;(function() {
  var trialExpiration = undefined
  var licenseExpiration = undefined
  var domains = undefined
  var expiration

  if (trialExpiration) expiration = new Date(trialExpiration).getTime()
  else if (licenseExpiration) expiration = new Date(licenseExpiration).getTime()

  if (expiration) {
    var now = new Date().getTime()

    if (expiration <= now) {
      if (trialExpiration) alert('This license has expired!')
      console.error('This license has expired!')
    } else if (trialExpiration) {
      var diffDays = Math.round((expiration - now) / (1000 * 60 * 60 * 24))

      if (diffDays < 3) {
        alert('This trial license expires in ' + diffDays + ' days!')
        console.log(
          'WARNING: This trial license expires in ' + diffDays + ' days!'
        )
      }
    }
  }

  if (domains && domains.length > 2) {
    var href = document.location.href
    var found = false

    for (var i = 0; i < domains.length; i++) {
      if (href.indexOf(domains[i]) > -1) {
        found = true
        break
      }
    }

    if (!found) {
      alert('ERROR: Not licensed for domain ' + href)
      console.error('ERROR: Not licensed for domain ' + href)
    }
  }
})()

const built = (function(_exports) {
  var __drawing_ =
    //-------------------------------------------------------------------------------------------
    // Copyright 2012-2017 by ChartIQ, Inc.
    // All rights reserved
    //-------------------------------------------------------------------------------------------
    function(_exports) {
      var CIQ = _exports.CIQ,
        timezoneJS = _exports.timezoneJS

      /**
       * Base class for Drawing Tools. Use ciqInheritsFrom() to build a subclass for custom drawing tools.
       * The name of the subclass should be CIQ.Drawing.yourname. Whenever CIQ.ChartEngine.vectorType==yourname, then
       * your drawing tool will be the one that is enabled when the user begins a drawing. Capitalization of yourname
       * must be an exact match otherwise the kernel will not be able to find your drawing tool.
       *
       * Each of the CIQ.Drawing prototype functions may be overridden. To create a functioning drawing tool
       * you must override the functions below that create alerts.
       *
       * Drawing clicks are always delivered in *adjusted price*. That is, if a stock has experienced splits then
       * the drawing will not display correctly on an unadjusted price chart unless this is considered during the rendering
       * process. Follow the templates to assure correct rendering under both circumstances.
       *
       * If no color is specified when building a drawing then color will be set to "auto" and the chart will automatically display
       * white or black depending on the background.
       *
       * **Permanent drawings:**<br>
       * To make a drawing permanent set its `permanent` property to `true` once created.
       * <br>Example: <br>
       * ```drawingObject.permanent=true;```
       *
       * See {@tutorial Using and Customizing Drawing Tools} for more details.
       *
       * @name  CIQ.Drawing
       * @constructor
       */
      CIQ.Drawing = function() {
        this.chartsOnly = false // Set this to true to restrict drawing to panels containing charts (as opposed to studies)
        this.penDown = false // Set to true when in the midst of creating the object
      }

      /**
       * Since not all drawings have the same configuration parameters,
       * this is a helper function intended to return the relevant drawing parameters and default settings for the requested drawing type.
       *
       * For example,  you can use the returning object as your template for creating the proper UI tool box for that particular drawing.
       * Will you need a line width UI element, a fill color?, etc. Or you can use it to determine what values you should be setting if enabling
       * a particular drawing type programatically with specific properties.
       * @param {CIQ.ChartEngine} stx Chart object
       * @param {string} drawingName Name of drawing, e.g. "ray', "segment"
       * @returns {object} Map of parameters used in the drawing type, with their current values
       * @memberOf CIQ.Drawing
       * @since 3.0.0
       */
      CIQ.Drawing.getDrawingParameters = function(stx, drawingName) {
        var drawing
        try {
          drawing = new CIQ.Drawing[drawingName]()
        } catch (e) {}
        if (!drawing) return null
        drawing.stx = stx
        drawing.copyConfig()
        var result = {}
        var confs = drawing.configs
        for (var c = 0; c < confs.length; c++) {
          result[confs[c]] = drawing[confs[c]]
        }
        return result
      }

      /**
       * Instance function used to copy the relevant drawing parameters into itself.
       * It just calls the static function.
       * @memberOf CIQ.Drawing
       * @since 3.0.0
       */
      CIQ.Drawing.prototype.copyConfig = function() {
        CIQ.Drawing.copyConfig(this)
      }
      /**
       * Static function used to copy the relevant drawing parameters into the drawing instance.
       * Use this when overriding the Instance function, to perform basic copy before performing custom operations.
       * @param {CIQ.Drawing} drawingInstance to copy into
       * @memberOf CIQ.Drawing
       * @since 3.0.0
       */
      CIQ.Drawing.copyConfig = function(drawingInstance) {
        var configs = drawingInstance.configs
        for (var c = 0; c < configs.length; c++) {
          var conf = configs[c]
          var cvp = drawingInstance.stx.currentVectorParameters
          if (conf == 'color') {
            drawingInstance.color = cvp.currentColor
          } else if (conf == 'parameters') {
            drawingInstance.parameters = cvp.fibonacci
          } else if (conf == 'font') {
            drawingInstance.font = CIQ.clone(cvp.annotation.font)
          } else {
            drawingInstance[conf] = cvp[conf]
          }
        }
      }

      /**
       * Set to true when need to hold mouse down to draw; set to false for click on/off draw
       * @memberOf CIQ.Drawing
       * @example
       * CIQ.Drawing.prototype.dragToDraw=true;
       */
      CIQ.Drawing.prototype.dragToDraw = false

      /**
       * Is called to tell a drawing to abort itself. It should clean up any rendered objects such as DOM elements or toggle states. It
       * does not need to clean up anything that it drew on the canvas.
       * @param  {boolean} forceClear Indicates that the user explicitly has deleted the drawing (advanced usage)
       * @memberOf CIQ.Drawing
       */
      CIQ.Drawing.prototype.abort = function(forceClear) {}

      /**
       * Should call this.stx.setMeasure() with the measurements of the drawing if supported
       * @memberOf CIQ.Drawing
       */
      CIQ.Drawing.prototype.measure = function() {}

      /**
       * Initializes the drawing
       * @param  {CIQ.ChartEngine} stx   The chart object
       * @param  {CIQ.ChartEngine.Panel} panel The panel reference
       * @memberOf CIQ.Drawing
       */
      CIQ.Drawing.prototype.construct = function(stx, panel) {
        this.stx = stx
        this.panelName = panel.name
      }

      /**
       * Called to render the drawing
       * @memberOf CIQ.Drawing
       */
      CIQ.Drawing.prototype.render = function(context) {
        alert('must implement render function!')
      }

      /**
       * Called when a user clicks while drawing.
       * @param  {object} context               The canvas context
       * @param  {number} tick                  The tick in the dataSet
       * @param  {number} value - The value (price) of the click
       * @return {boolean}                       Return true if the drawing is complete. Otherwise the kernel will continue accepting clicks.
       * @memberOf CIQ.Drawing
       */
      CIQ.Drawing.prototype.click = function(context, tick, value) {
        alert('must implement click function!')
      }

      /**
       * Called when the user moves while creating a drawing.
       * @memberOf CIQ.Drawing
       */
      CIQ.Drawing.prototype.move = function(context, tick, value) {
        alert('must implement move function!')
      }

      /**
       * Called when the user attempts to reposition a drawing. The repositioner is the object provided by {@link CIQ.Drawing.intersected}
       * and can be used to determine which aspect of the drawing is being repositioned. For instance, this object may indicate
       * which point on the drawing was selected by the user. It might also contain the original coordinates of the point or anything else
       * that is useful to render the drawing.
       * @param  {object} context      The canvas context
       * @param  {object} repositioner The repositioner object
       * @param  {number} tick         Current tick in the dataSet for the mouse cursor
       * @param  {number} value        Current value in the datSet for the mouse cursor
       * @memberOf CIQ.Drawing
       */
      CIQ.Drawing.prototype.reposition = function(
        context,
        repositioner,
        tick,
        value
      ) {}
      /**
       * Called to determine whether the drawing is intersected by either the tick/value (pointer location) or box (small box surrounding the pointer).
       * For line based drawings, box should be checked. For area drawings (rectangles, circles) the point should be checked
       * @param  {number} tick               The tick in the dataSet representing the cursor point
       * @param  {number} value              The value (price) representing the cursor point
       * @param  {object} box				   x0,y0,x1,y1 representing an area around the cursor
       * @return {object}                    An object that contains information about the intersection.
       *                                     This object is passed back to {@link CIQ.Drawing.reposition} when repositioning the drawing.
       *                                     Return false or null if not intersected. Simply returning true will highlight the drawing.
       * @memberOf CIQ.Drawing
       */
      CIQ.Drawing.prototype.intersected = function(tick, value, box) {
        alert('must implement intersected function!')
      }

      /**
       * Reconstruct this drawing type from a serialization object
       * @memberOf CIQ.Drawing
       */
      CIQ.Drawing.prototype.reconstruct = function(stx, obj) {
        alert('must implement reconstruct function!')
      }

      /**
       * Serialize a drawing into an object.
       * @memberOf CIQ.Drawing
       */
      CIQ.Drawing.prototype.serialize = function() {
        alert('must implement serialize function!')
      }

      /**
       * Called whenever periodicity changes so that drawings can adjust their rendering.
       * @memberOf CIQ.Drawing
       */
      CIQ.Drawing.prototype.adjust = function() {
        alert('must implement adjust function!')
      }

      /**
       * Returns the highlighted state. Set this.highlighted to the highlight state.
       * For simple drawings the highlighted state is just true or false. For complex drawings
       * with pivot points for instance, the highlighted state may have more than two states.
       * Whenever the highlighted state changes a draw() event will be triggered.
       * @param {Boolean} highlighted True to highlight the drawing, false to unhighlight
       * @memberOf CIQ.Drawing.BaseTwoPoint
       */
      CIQ.Drawing.prototype.highlight = function(highlighted) {
        if (highlighted && !this.highlighted) {
          this.highlighted = highlighted
        } else if (!highlighted && this.highlighted) {
          this.highlighted = highlighted
        }
        return this.highlighted
      }

      CIQ.Drawing.prototype.littleCircleRadius = function() {
        var radius = 6 //Math.max(12, this.layout.candleWidth)/2;
        return radius
      }

      CIQ.Drawing.prototype.littleCircle = function(ctx, x, y, fill) {
        var strokeColor = this.stx.defaultColor
        var fillColor = CIQ.chooseForegroundColor(strokeColor)
        ctx.beginPath()
        ctx.lineWidth = 1
        ctx.arc(x, y, this.littleCircleRadius(), 0, 2 * Math.PI, false)
        if (fill) ctx.fillStyle = strokeColor
        else ctx.fillStyle = fillColor
        ctx.strokeStyle = strokeColor
        ctx.fill()
        ctx.stroke()
        ctx.closePath()
      }

      CIQ.Drawing.prototype.rotator = function(ctx, x, y, on) {
        var circleSize = this.littleCircleRadius()
        var strokeColor = this.stx.defaultColor
        ctx.beginPath()
        ctx.lineWidth = 2
        if (!on) ctx.globalAlpha = 0.5
        var radius = 4 + circleSize
        ctx.arc(x, y, radius, 0, (3 * Math.PI) / 2, false)
        ctx.moveTo(x + 2 + radius, y + 2)
        ctx.lineTo(x + radius, y)
        ctx.lineTo(x - 2 + radius, y + 2)
        ctx.moveTo(x - 2, y + 2 - radius)
        ctx.lineTo(x, y - radius)
        ctx.lineTo(x - 2, y - 2 - radius)
        ctx.strokeStyle = strokeColor
        ctx.stroke()
        ctx.closePath()
        ctx.globalAlpha = 1
      }

      CIQ.Drawing.prototype.mover = function(ctx, x, y, on) {
        var circleSize = this.littleCircleRadius()
        var strokeColor = this.stx.defaultColor
        var length = 5
        var start = circleSize + 1
        ctx.save()
        ctx.lineWidth = 2
        ctx.strokeStyle = strokeColor
        ctx.translate(x, y)
        if (!on) ctx.globalAlpha = 0.5
        for (var i = 0; i < 4; i++) {
          ctx.rotate(Math.PI / 2)
          ctx.beginPath()
          ctx.moveTo(0, start)
          ctx.lineTo(0, start + length)
          ctx.moveTo(-2, start + length - 2)
          ctx.lineTo(0, start + length)
          ctx.lineTo(2, start + length - 2)
          ctx.closePath()
          ctx.stroke()
        }
        ctx.globalAlpha = 1
        ctx.restore()
      }

      CIQ.Drawing.prototype.resizer = function(ctx, x, y, on) {
        var circleSize = this.littleCircleRadius()
        var strokeColor = this.stx.defaultColor
        var length = 5 * Math.sqrt(2)
        var start = circleSize + 1
        ctx.save()
        ctx.lineWidth = 2
        ctx.strokeStyle = strokeColor
        ctx.translate(x, y)
        ctx.rotate(((-(x * y) / Math.abs(x * y)) * Math.PI) / 4)
        if (!on) ctx.globalAlpha = 0.5
        for (var i = 0; i < 2; i++) {
          ctx.rotate(Math.PI)
          ctx.beginPath()
          ctx.moveTo(0, start)
          ctx.lineTo(0, start + length)
          ctx.moveTo(-2, start + length - 2)
          ctx.lineTo(0, start + length)
          ctx.lineTo(2, start + length - 2)
          ctx.closePath()
          ctx.stroke()
        }
        ctx.globalAlpha = 1
        ctx.restore()
      }

      /**
       * Returns true if the tick and value are inside the box
       * @param  {number} tick  The tick
       * @param  {number} value The value
       * @param  {object} box   The box
       * @return {boolean}       True if the tick and value are within the box
       * @memberOf CIQ.Drawing
       */
      CIQ.Drawing.prototype.pointIntersection = function(tick, value, box) {
        var panel = this.stx.panels[this.panelName]
        if (!panel) return false
        if (
          tick >= box.x0 &&
          tick <= box.x1 &&
          value >= box.y1 &&
          value <= box.y0
        )
          return true
        return false
      }

      /**
       * Sets the internal properties of the drawing points where x is a tick or a date and y is a value.
       * @param  {number} point    index to point to be converted (0,1)
       * @param  {number|string} x    index of bar in dataSet (tick) or date of tick (string form)
       * @param  {number} y    price
       * @param  {CIQ.Chart} [chart] Optional chart object
       * @memberOf CIQ.Drawing.BaseTwoPoint
       * @since 04-2015
       */
      CIQ.Drawing.prototype.setPoint = function(point, x, y, chart) {
        var tick = null
        var date = null
        if (typeof x == 'number') tick = x
        else if (x.length >= 8) date = x
        else tick = Number(x)

        if (y || y === 0) this['v' + point] = y
        var d
        if (tick !== null) {
          d = this.stx.dateFromTick(tick, chart, true)
          this['tzo' + point] = d.getTimezoneOffset()
          this['d' + point] = CIQ.yyyymmddhhmmssmmm(d)
          this['p' + point] = [tick, y]
        } else if (date !== null) {
          d = CIQ.strToDateTime(date)
          if (!this['tzo' + point] && this['tzo' + point] !== 0)
            this['tzo' + point] = d.getTimezoneOffset()
          this['d' + point] = date
          var adj = this['tzo' + point] - d.getTimezoneOffset()
          d.setMinutes(d.getMinutes() + adj)
          var forward = false
          // if no match, we advance on intro-day when there is a no time portion
          // except for free form which already handles time placement internally
          if (
            this.name != 'freeform' &&
            !CIQ.ChartEngine.isDailyInterval(this.stx.layout.interval) &&
            !d.getHours() &&
            !d.getMinutes() &&
            !d.getSeconds() &&
            !d.getMilliseconds()
          )
            forward = true

          this['p' + point] = [
            this.stx.tickFromDate(
              CIQ.yyyymmddhhmmssmmm(d),
              chart,
              null,
              forward
            ),
            y,
          ]
        }
      }

      /**
       * Compute the proper color to use when rendering lines in the drawing.
       * Will use the color but if set to auto or transparent, will use the container's defaultColor.
       * If drawing is highlighted will use the highlight color as defined in stx_highlight_vector style.
       * @param {string} color Color string to check and use as a basis for setting.  If not supplied, uses this.color.
       * @return {string} Color to use for the line drawing
       * @memberOf CIQ.Drawing
       * @since 4.0.0
       * @example
       * 		var trendLineColor=this.setLineColor();
       *		this.stx.plotLine(x0, x1, y0, y1, trendLineColor, "segment", context, panel, parameters);
       */
      CIQ.Drawing.prototype.setLineColor = function(color) {
        if (!color) color = this.color
        var lineColor = color
        if (lineColor == 'auto' || CIQ.isTransparent(lineColor))
          lineColor = this.stx.defaultColor
        if (this.highlighted) {
          lineColor = this.stx.getCanvasColor('stx_highlight_vector')
        }
        return lineColor
      }

      /**
       * Base class for drawings that require two mouse clicks. Override as required.
       * @constructor
       * @name  CIQ.Drawing.BaseTwoPoint
       */
      CIQ.Drawing.BaseTwoPoint = function() {
        this.p0 = null
        this.p1 = null
        this.color = ''
      }

      CIQ.Drawing.BaseTwoPoint.ciqInheritsFrom(CIQ.Drawing)

      CIQ.Drawing.BaseTwoPoint.prototype.configs = []

      /**
       * Intersection is based on a hypothetical box that follows a user's mouse or finger around
       * An intersection occurs when either the box crosses over the drawing.The type should be "segment", "ray" or "line" depending on whether
       * the drawing extends infinitely in any or both directions. radius determines the size of the box in pixels and is
       * determined by the kernel depending on the user interface (mouse, touch, etc)
       * @memberOf CIQ.Drawing.BaseTwoPoint
       */

      CIQ.Drawing.BaseTwoPoint.prototype.lineIntersection = function(
        tick,
        value,
        box,
        type
      ) {
        var p0 = this.p0,
          p1 = this.p1,
          layout = this.stx.layout
        return (
          p0 &&
          p1 &&
          CIQ.boxIntersects(
            box.x0,
            box.y0,
            box.x1,
            box.y1,
            p0[0],
            p0[1],
            p1[0],
            p1[1],
            type,
            layout.semiLog || layout.chartScale == 'log'
          )
        )
      }

      /**
       * Determine whether the tick/value lie within the theoretical box outlined by this drawing's two points
       * @memberOf CIQ.Drawing.BaseTwoPoint
       */
      CIQ.Drawing.BaseTwoPoint.prototype.boxIntersection = function(
        tick,
        value
      ) {
        if (!this.p0 || !this.p1) return false
        if (
          tick > Math.max(this.p0[0], this.p1[0]) ||
          tick < Math.min(this.p0[0], this.p1[0])
        )
          return false
        if (
          value > Math.max(this.p0[1], this.p1[1]) ||
          value < Math.min(this.p0[1], this.p1[1])
        )
          return false
        return true
      }

      /**
       * Any two-point drawing that results in a drawing that is less than 10 pixels
       * can safely be assumed to be an accidental click. Such drawings are so small
       * that they are difficult to highlight and delete, so we won't allow them.
       *
       * <b>Note:</b> it is very important to use pixelFromValueAdjusted() rather than pixelFromPrice(). This will
       * ensure that saved drawings always render correctly when a chart is adjusted or transformed for display
       * @memberOf CIQ.Drawing.BaseTwoPoint
       */
      CIQ.Drawing.BaseTwoPoint.prototype.accidentalClick = function(
        tick,
        value
      ) {
        var panel = this.stx.panels[this.panelName]
        var x0 = this.stx.pixelFromTick(this.p0[0], panel.chart)
        var x1 = this.stx.pixelFromTick(tick, panel.chart)
        var y0 = this.stx.pixelFromValueAdjusted(panel, this.p0[0], this.p0[1])
        var y1 = this.stx.pixelFromValueAdjusted(panel, tick, value)
        var h = Math.abs(x1 - x0)
        var v = Math.abs(y1 - y0)
        var length = Math.sqrt(h * h + v * v)
        if (length < 10) {
          this.penDown = false
          if (this.dragToDraw) this.stx.undo()
          return true
        }
      }

      /**
       * Value will be the actual underlying, unadjusted value for the drawing. Any adjustments or transformations
       * are reversed out by the kernel. Internally, drawings should store their raw data (date and value) so that
       * they can be rendered on charts with different layouts, axis, etc
       * @memberOf CIQ.Drawing.BaseTwoPoint
       */
      CIQ.Drawing.BaseTwoPoint.prototype.click = function(
        context,
        tick,
        value
      ) {
        this.copyConfig()
        var panel = this.stx.panels[this.panelName]
        if (!this.penDown) {
          this.setPoint(0, tick, value, panel.chart)
          this.penDown = true
          return false
        }
        if (this.accidentalClick(tick, value)) return this.dragToDraw

        this.setPoint(1, tick, value, panel.chart)
        this.penDown = false
        return true // kernel will call render after this
      }

      /**
       * Default adjust function for BaseTwoPoint drawings
       * @memberOf CIQ.Drawing.BaseTwoPoint
       */
      CIQ.Drawing.BaseTwoPoint.prototype.adjust = function() {
        // If the drawing's panel doesn't exist then we'll check to see
        // whether the panel has been added. If not then there's no way to adjust
        var panel = this.stx.panels[this.panelName]
        if (!panel) return
        this.setPoint(0, this.d0, this.v0, panel.chart)
        this.setPoint(1, this.d1, this.v1, panel.chart)
      }

      /**
       * Default move function for BaseTwoPoint drawings
       * @memberOf CIQ.Drawing.BaseTwoPoint
       */
      CIQ.Drawing.BaseTwoPoint.prototype.move = function(context, tick, value) {
        if (!this.penDown) return

        this.copyConfig()
        this.p1 = [tick, value]
        this.render(context)
      }

      /**
       * Default measure function for BaseTwoPoint drawings
       * @memberOf CIQ.Drawing.BaseTwoPoint
       */
      CIQ.Drawing.BaseTwoPoint.prototype.measure = function() {
        if (this.p0 && this.p1) {
          this.stx.setMeasure(
            this.p0[1],
            this.p1[1],
            this.p0[0],
            this.p1[0],
            true,
            this.name
          )
        }
      }

      CIQ.Drawing.BaseTwoPoint.prototype.reposition = function(
        context,
        repositioner,
        tick,
        value
      ) {
        if (!repositioner) return
        var panel = this.stx.panels[this.panelName]
        var tickDiff = repositioner.tick - tick
        var valueDiff = repositioner.value - value
        if (repositioner.action == 'move') {
          this.setPoint(
            0,
            repositioner.p0[0] - tickDiff,
            repositioner.p0[1] - valueDiff,
            panel.chart
          )
          this.setPoint(
            1,
            repositioner.p1[0] - tickDiff,
            repositioner.p1[1] - valueDiff,
            panel.chart
          )
          this.render(context)
        } else if (repositioner.action == 'drag') {
          this[repositioner.point] = [tick, value]
          this.setPoint(0, this.p0[0], this.p0[1], panel.chart)
          this.setPoint(1, this.p1[0], this.p1[1], panel.chart)
          this.render(context)
        }
      }
      /**
       * Annotation drawing tool. An annotation is a simple text tool. It uses the class stx_annotation
       * to determine the font style and color for the annotation. Class stx_annotation_highlight_bg is used to
       * determine the background color when highlighted.
       *
       * The controls controls.annotationSave and controls.annotationCancel are used to create HTMLElements for
       * saving and canceling the annotation while editing. A textarea is created dynamically. The annotation tool
       * attempts to draw the annotations at the same size and position as the textarea so that the effect is wysiwig.
       * @constructor
       * @name  CIQ.Drawing.annotation
       * @see {@link CIQ.Drawing.BaseTwoPoint}
       */
      CIQ.Drawing.annotation = function() {
        this.name = 'annotation'
        this.arr = []
        this.w = 0
        this.h = 0
        this.padding = 4
        this.text = ''
        this.ta = null
        this.fontSize = 0
        this.font = {}
      }
      CIQ.Drawing.annotation.ciqInheritsFrom(CIQ.Drawing.BaseTwoPoint)

      CIQ.Drawing.annotation.prototype.getFontString = function() {
        this.fontDef = {
          style: null,
          weight: null,
          size: '12px',
          family: null,
        }
        var css = this.stx.canvasStyle('stx_annotation')
        if (css) {
          if (css.fontStyle) this.fontDef.style = css.fontStyle
          if (css.fontWeight) this.fontDef.weight = css.fontWeight
          if (css.fontSize) this.fontDef.size = css.fontSize
          if (css.fontFamily) this.fontDef.family = css.fontFamily
        }
        if (this.font.style) this.fontDef.style = this.font.style
        if (this.font.weight) this.fontDef.weight = this.font.weight
        if (this.font.size) this.fontDef.size = this.font.size
        if (this.font.family) this.fontDef.family = this.font.family
        this.fontString = ''
        var first = true
        for (var n in this.fontDef) {
          if (this.fontDef[n]) {
            if (!first) {
              this.fontString += ' '
            } else {
              first = false
            }
            this.fontString += this.fontDef[n]
          }
        }
      }

      CIQ.Drawing.annotation.prototype.configs = ['color', 'font']

      CIQ.Drawing.annotation.prototype.measure = function() {}

      CIQ.Drawing.annotation.prototype.render = function(context) {
        var panel = this.stx.panels[this.panelName]
        if (!panel) return
        var x0 = this.stx.pixelFromTick(this.p0[0], panel.chart)
        var y0 = this.stx.pixelFromValueAdjusted(panel, this.p0[0], this.p0[1])

        context.font = this.fontString
        context.textBaseline = 'top'
        var x = x0
        var y = y0
        var w = this.w
        var h = this.h

        var color = this.setLineColor()
        if (this.stem) {
          var sx0, sx1, sy0, sy1
          if (this.stem.d) {
            // absolute positioning of stem
            sx0 = this.stx.pixelFromTick(this.stem.t) // bottom of stem
            sy0 = this.stx.pixelFromValueAdjusted(
              panel,
              this.stem.t,
              this.stem.v
            )
            sx1 = x + w / 2 // center of text
            sy1 = y + h / 2
          } else if (this.stem.x) {
            // stem with relative offset positioning
            sx0 = x
            sy0 = y
            x += this.stem.x
            y += this.stem.y
            sx1 = x + w / 2
            sy1 = y + h / 2
          }

          context.beginPath()
          if (this.borderColor) context.strokeStyle = this.borderColor
          else context.strokeStyle = color
          context.moveTo(sx0, sy0)
          context.lineTo(sx1, sy1)
          context.stroke()
        }
        if (this.highlighted) {
          this.stx.canvasColor('stx_annotation_highlight_bg', context)
          context.fillRect(x, y, w, h)
        } else {
          if (this.fillColor) {
            context.fillStyle = this.fillColor
            context.fillRect(x, y, w, h)
          } else if (this.stem) {
            // If there's a stem then use the container color otherwise the stem will show through
            context.fillStyle = this.stx.containerColor
            context.fillRect(x, y, w, h)
          }
        }
        if (this.borderColor) {
          context.beginPath()
          context.strokeStyle = this.borderColor
          context.rect(x, y, w, h)
          context.stroke()
        }
        //this.stx.canvasFont("stx_annotation");
        if (this.highlighted) {
          this.stx.canvasColor('stx_annotation_highlight', context)
        } else {
          context.fillStyle = color
        }
        y += this.padding
        for (var i = 0; i < this.arr.length; i++) {
          context.fillText(this.arr[i], x + this.padding, y)
          y += this.fontSize
        }
        context.textBaseline = 'alphabetic'
      }

      CIQ.Drawing.annotation.prototype.onChange = function(e) {
        //no operation. Override if you want to capture the change.
      }

      CIQ.Drawing.annotation.prototype.edit = function(context) {
        var panel = this.stx.panels[this.panelName]
        if (!panel) return
        // When mouse events are attached to the container then any dom objects on top
        // of the container will intercept those events. In particular, the textarea for
        // annotations gets in the way, so here we capture the mouseup that fires on the textarea
        // and pass it along to the kernel if necessary
        function handleTAMouseUp(stx) {
          return function(e) {
            if (stx.manageTouchAndMouse && CIQ.ChartEngine.drawingLine) {
              stx.mouseup(e)
            }
          }
        }

        function cancelAnnotation(self) {
          return function(e) {
            self.stx.editingAnnotation = false
            self.stx.undo()
            self.stx.cancelTouchSingleClick = true
          }
        }
        function saveAnnotation(self) {
          return function(e) {
            if (self.ta.value === '') return
            self.stx.editingAnnotation = false
            self.text = self.ta.value
            self.adjust()

            self.stx.addDrawing(self)
            self.stx.changeOccurred('vector')
            self.stx.undo()
            self.stx.cancelTouchSingleClick = true
          }
        }

        function resizeAnnotation(self) {
          return function(e) {
            if (e) {
              var key = window.event ? event.keyCode : e.keyCode
              switch (key) {
                case 27:
                  self.stx.undo()
                  return
              }
            }
            var stx = self.stx
            var ta = self.ta
            var save = stx.controls.annotationSave
            var cancel = stx.controls.annotationCancel
            var arr = ta.value.split('\n')
            var w = 0
            //stx.canvasFont("stx_annotation");
            stx.chart.context.font = self.fontString
            for (var i = 0; i < arr.length; i++) {
              var m = stx.chart.context.measureText(arr[i]).width
              if (m > w) w = m
            }
            var h = (arr.length + 1) * (self.fontSize + 3)
            if (w < 50) w = 50
            ta.style.width = w + 30 + 'px' // Leave room for scroll bar
            ta.style.height = h + 'px'
            var y = parseInt(CIQ.stripPX(ta.style.top), 10)
            var x = CIQ.stripPX(ta.style.left)
            w = ta.clientWidth
            h = ta.clientHeight
            if (x + w + 100 < self.stx.chart.canvasWidth) {
              save.style.top = y + 'px'
              cancel.style.top = y + 'px'
              save.style.left = x + w + 10 + 'px'
              cancel.style.left = x + w + 60 + 'px'
            } else if (y + h + 30 < self.stx.chart.canvasHeight) {
              save.style.top = y + h + 10 + 'px'
              cancel.style.top = y + h + 10 + 'px'
              save.style.left = x + 'px'
              cancel.style.left = x + 50 + 'px'
            } else {
              save.style.top = y - 35 + 'px'
              cancel.style.top = y - 35 + 'px'
              save.style.left = x + 'px'
              cancel.style.left = x + 50 + 'px'
            }
          }
        }

        this.stx.editingAnnotation = true
        this.stx.undisplayCrosshairs()
        this.stx.openDialog = 'annotation'
        if (!this.ta) {
          this.ta = document.createElement('TEXTAREA')
          this.ta.className = 'stx_annotation'
          this.ta.onkeyup = resizeAnnotation(this)
          this.ta.onmouseup = handleTAMouseUp(this.stx)
          this.ta.setAttribute('wrap', 'hard')
          if (CIQ.isIOS7or8) this.ta.setAttribute('placeholder', 'Enter Text')
          this.stx.chart.container.appendChild(this.ta)
          this.ta.style.position = 'absolute'
          this.ta.style.width = '100px'
          this.ta.style.height = '20px'
          if (CIQ.ipad || CIQ.iphone) {
            this.ta.ontouchstart = function(e) {
              e.stopPropagation()
            }
            /*var ta=this.ta;
				CIQ.safeClickTouch(this.ta, function(e){
					if(document.activeElement===ta){
							window.focus();
							CIQ.focus(ta, true);
					}
				});*/
          }
        }
        var self = this
        this.ta.oninput = function(e) {
          self.onChange(e)
        }
        this.ta.style.font = this.fontString
        if (this.color) {
          if (this.color == 'transparent' || this.color == 'auto') {
            var styles = getComputedStyle(this.ta)
            if (styles && CIQ.isTransparent(styles.backgroundColor)) {
              this.ta.style.color = this.stx.defaultColor
            } else {
              this.ta.style.color = '#000' // text area always has white background
            }
          } else {
            this.ta.style.color = this.color
          }
        }
        var x0 = this.stx.pixelFromTick(this.p0[0], panel.chart)
        var y0 = this.stx.pixelFromValueAdjusted(panel, this.p0[0], this.p0[1])
        //if the right edge of the ta is off of the screen, scootch it to the left.
        this.ta.style.left =
          x0 + 140 < this.stx.chart.canvasRight
            ? x0 + 'px'
            : this.stx.chart.canvasRight - 200 + 'px'
        //if user clicks within 60 px of bottom of the chart,scootch it up.
        this.ta.style.top =
          y0 + 60 < this.stx.chart.canvasHeight ? y0 + 'px' : y0 - 60 + 'px'
        if (this.name == 'callout') {
          this.ta.style.left =
            x0 - (!isNaN(this.w) ? this.w / 2 : this.defaultWidth) + 'px'
          this.ta.style.top =
            y0 - (!isNaN(this.h) ? this.h / 2 : this.defaultHeight) + 'px'
        }

        this.stx.controls.annotationSave.style.display = 'inline-block'
        this.stx.controls.annotationCancel.style.display = 'inline-block'
        CIQ.safeClickTouch(
          this.stx.controls.annotationSave,
          saveAnnotation(this)
        )
        CIQ.safeClickTouch(
          this.stx.controls.annotationCancel,
          cancelAnnotation(this)
        )
        resizeAnnotation(this)()

        /*var timeout=0;
		if(CIQ.ipad) timeout=400;
		if(!CIQ.isIOS7or8){
			CIQ.focus(this.ta,timeout);
		}*/
        this.ta.focus()

        if (CIQ.isAndroid && !CIQ.is_chrome) {
          // Android soft keyboard will cover up the lower half of the browser so if our
          // annotation is in that area we temporarily scroll the chart container upwards
          // The style.bottom of the chart container is reset in abort()
          this.priorBottom = this.stx.chart.container.style.bottom
          var keyboardHeight = 400 // hard coded. We could get this by measuring the change in innerHeight but timing is awkward because the keyboard scrolls
          var screenLocation = this.stx.resolveY(y0) + 100 // figure 100 pixels of height for text
          if (screenLocation > CIQ.pageHeight() - keyboardHeight) {
            var pixelsFromBottomOfScreen = CIQ.pageHeight() - screenLocation
            var scrolledBottom = keyboardHeight - pixelsFromBottomOfScreen
            this.stx.chart.container.style.bottom = scrolledBottom + 'px'
          }
        }
      }

      CIQ.Drawing.annotation.prototype.click = function(context, tick, value) {
        //don't allow user to add annotation on the axis.
        if (this.stx.overXAxis || this.stx.overYAxis) return
        var panel = this.stx.panels[this.panelName]
        this.copyConfig()
        //this.getFontString();
        this.setPoint(0, tick, value, panel.chart)
        this.adjust()

        this.edit(context)
        return false
      }

      CIQ.Drawing.annotation.prototype.reposition = function(
        context,
        repositioner,
        tick,
        value
      ) {
        if (!repositioner) return
        var panel = this.stx.panels[this.panelName]
        var tickDiff = repositioner.tick - tick
        var valueDiff = repositioner.value - value
        this.setPoint(
          0,
          repositioner.p0[0] - tickDiff,
          repositioner.p0[1] - valueDiff,
          panel.chart
        )
        this.render(context)
      }

      CIQ.Drawing.annotation.prototype.intersected = function(
        tick,
        value,
        box
      ) {
        var panel = this.stx.panels[this.panelName]
        if (!this.p0) return null // in case invalid drawing (such as from panel that no longer exists)
        var x0 = this.stx.pixelFromTick(this.p0[0], panel.chart)
        var y0 = this.stx.pixelFromValueAdjusted(panel, this.p0[0], this.p0[1])
        var x1 = x0 + this.w
        var y1 = y0 + this.h
        if (this.stem && this.stem.x) {
          x0 += this.stem.x
          x1 += this.stem.x
          y0 += this.stem.y
          y1 += this.stem.y
        }
        var x = this.stx.pixelFromTick(tick, panel.chart)
        var y = this.stx.pixelFromValueAdjusted(panel, tick, value)

        if (x >= x0 && x <= x1 && y >= y0 && y <= y1) {
          this.highlighted = true
          return {
            p0: CIQ.clone(this.p0),
            tick: tick,
            value: value,
          }
        }
        return false
        //return this.boxIntersection(tick, value);
      }

      CIQ.Drawing.annotation.prototype.abort = function() {
        this.stx.controls.annotationSave.style.display = 'none'
        this.stx.controls.annotationCancel.style.display = 'none'
        if (this.ta) this.stx.chart.container.removeChild(this.ta)
        this.ta = null
        this.stx.openDialog = ''
        this.stx.showCrosshairs()
        //document.body.style.cursor="crosshair"; //Was interfering with undisplayCrosshairs().
        this.stx.editingAnnotation = false
        CIQ.clearCanvas(this.stx.chart.tempCanvas, this.stx)
        if (CIQ.isAndroid && !CIQ.is_chrome) {
          this.stx.chart.container.style.bottom = this.priorBottom
        }
        CIQ.fixScreen()
      }

      /**
       * Reconstruct an annotation
       * @param  {CIQ.ChartEngine} stx The chart object
       * @param  {object}[obj] A drawing descriptor
       * @param {string} [obj.col] The text color for the annotation
       * @param {string} [obj.pnl] The panel name
       * @param {string} [obj.d0] String form date or date time
       * @param {number} [obj.v0] The value at which to position the annotation
       * @param {string} [obj.text] The annotation text (escaped using encodeURIComponent())
       * @param {number} [obj.tzo0] Offset of UTC from d0 in minutes
       * @param {string} [obj.bc] Border color
       * @param {string} [obj.bg] Background color
       * @param {string} [obj.lw] Line width
       * @param {string} [obj.ptrn] Line pattern
       * @param {object} [obj.fnt] Font
       * @param {object} [obj.fnt.st] Font style
       * @param {object} [obj.fnt.sz] Font size
       * @param {object} [obj.fnt.wt] Font weight
       * @param {object} [obj.fnt.fl] Font family
       * @memberOf CIQ.Drawing.annotation
       */
      CIQ.Drawing.annotation.prototype.reconstruct = function(stx, obj) {
        this.stx = stx
        this.color = obj.col
        this.panelName = obj.pnl
        this.d0 = obj.d0
        this.tzo0 = obj.tzo0
        this.v0 = obj.v0
        this.text = stx.escapeOnSerialize
          ? decodeURIComponent(obj.text)
          : obj.text
        this.stem = obj.stem
        this.borderColor = obj.bc
        this.fillColor = obj.bg
        this.lineWidth = obj.lw
        this.pattern = obj.ptrn
        this.font = CIQ.replaceFields(obj.fnt, {
          st: 'style',
          sz: 'size',
          wt: 'weight',
          fl: 'family',
        })
        if (!this.font) this.font = {}
        this.adjust()
      }

      CIQ.Drawing.annotation.prototype.serialize = function() {
        var obj = {
          name: this.name,
          pnl: this.panelName,
          col: this.color,
          d0: this.d0,
          tzo0: this.tzo0,
          v0: this.v0,
          text: this.stx.escapeOnSerialize
            ? encodeURIComponent(this.text)
            : this.text,
        }
        if (this.font) {
          var fnt = CIQ.removeNullValues(
            CIQ.replaceFields(this.font, {
              style: 'st',
              size: 'sz',
              weight: 'wt',
              family: 'fl',
            })
          )
          if (!CIQ.isEmpty(fnt)) obj.fnt = fnt
        }
        if (this.stem) {
          obj.stem = {
            d: this.stem.d,
            v: this.stem.v,
            x: this.stem.x,
            y: this.stem.y,
          }
        }
        if (this.borderColor) obj.bc = this.borderColor
        if (this.fillColor) obj.bg = this.fillColor
        if (this.lineWidth) obj.lw = this.lineWidth
        if (this.pattern) obj.ptrn = this.pattern

        return obj
      }

      CIQ.Drawing.annotation.prototype.renderText = function() {
        this.getFontString()
        var panel = this.stx.panels[this.panelName]
        if (!panel) return
        this.arr = this.text.split('\n')
        var w = 0
        this.stx.chart.context.font = this.fontString
        //this.stx.canvasFont("stx_annotation");
        for (var i = 0; i < this.arr.length; i++) {
          var m = this.stx.chart.context.measureText(this.arr[i]).width
          if (m > w) w = m
        }
        if (w === 0) w = 2 * this.defaultWidth
        //this.fontSize=this.stx.getCanvasFontSize("stx_annotation");
        this.fontSize = CIQ.stripPX(this.fontDef.size)
        var h = this.arr.length * this.fontSize
        if (CIQ.touchDevice) h += 5
        this.w = w + this.padding * 2
        this.h = h + this.padding * 2
        var x1 = this.stx.pixelFromTick(this.p0[0], panel.chart) + w
        var y1 =
          this.stx.pixelFromValueAdjusted(panel, this.p0[0], this.p0[1]) + h
        this.p1 = [
          this.stx.tickFromPixel(x1, panel.chart),
          this.stx.valueFromPixel(y1, panel),
        ]
        if (this.stem && this.stem.d) {
          this.stem.t = this.stx.tickFromDate(this.stem.d, panel.chart)
        }
      }

      CIQ.Drawing.annotation.prototype.adjust = function() {
        var panel = this.stx.panels[this.panelName]
        if (!panel) return
        this.setPoint(0, this.d0, this.v0, panel.chart)
        this.renderText()
      }

      /**
       * segment is an implementation of a {@link CIQ.Drawing.BaseTwoPoint} drawing.
       * @name CIQ.Drawing.segment
       * @constructor
       */
      CIQ.Drawing.segment = function() {
        this.name = 'segment'
      }

      CIQ.Drawing.segment.ciqInheritsFrom(CIQ.Drawing.BaseTwoPoint)

      CIQ.Drawing.segment.prototype.render = function(context) {
        var panel = this.stx.panels[this.panelName]
        if (!panel) return
        var x0 = this.stx.pixelFromTick(this.p0[0], panel.chart)
        var x1 = this.stx.pixelFromTick(this.p1[0], panel.chart)
        var y0 = this.stx.pixelFromValueAdjusted(panel, this.p0[0], this.p0[1])
        var y1 = this.stx.pixelFromValueAdjusted(panel, this.p1[0], this.p1[1])

        var width = this.lineWidth
        var color = this.setLineColor()

        var parameters = {
          pattern: this.pattern,
          lineWidth: width,
        }
        this.stx.plotLine(
          x0,
          x1,
          y0,
          y1,
          color,
          this.name,
          context,
          panel,
          parameters
        )

        if (this.axisLabel && !this.highlighted) {
          if (this.name == 'horizontal') {
            this.stx.endClip()
            var txt = this.p0[1]
            if (panel.chart.transformFunc)
              txt = panel.chart.transformFunc(this.stx, panel.chart, txt)
            if (panel.yAxis.priceFormatter)
              txt = panel.yAxis.priceFormatter(this.stx, panel, txt)
            else txt = this.stx.formatYAxisPrice(txt, panel)
            this.stx.createYAxisLabel(panel, txt, y0, color)
            this.stx.startClip(panel.name)
          } else if (
            this.name == 'vertical' &&
            this.p0[0] >= 0 &&
            !CIQ.ChartEngine.hideDates()
          ) {
            // don't try to compute dates from before dataSet
            var dt, newDT
            dt = this.stx.dateFromTick(this.p0[0], panel.chart, true)
            if (!CIQ.ChartEngine.isDailyInterval(this.stx.layout.interval)) {
              var milli = dt.getSeconds() * 1000 + dt.getMilliseconds()
              if (this.stx.dataZone) {
                // this creates a date in the right quote feed date
                newDT = new timezoneJS.Date(
                  dt.getFullYear(),
                  dt.getMonth(),
                  dt.getDate(),
                  dt.getHours(),
                  dt.getMinutes(),
                  this.stx.dataZone
                )
                dt = new Date(newDT.getTime() + milli)
              }
              if (this.stx.displayZone) {
                // this converts from the quote feed timezone to the chart specified time zone
                newDT = new timezoneJS.Date(dt.getTime(), this.stx.displayZone)
                dt = new Date(
                  newDT.getFullYear(),
                  newDT.getMonth(),
                  newDT.getDate(),
                  newDT.getHours(),
                  newDT.getMinutes()
                )
                dt = new Date(dt.getTime() + milli)
              }
            } else {
              dt.setHours(0, 0, 0, 0)
            }
            var myDate = CIQ.mmddhhmm(CIQ.yyyymmddhhmm(dt))

            if (panel.chart.xAxis.formatter) {
              myDate = panel.chart.xAxis.formatter(dt)
            } else if (this.stx.internationalizer) {
              var str
              if (dt.getHours() !== 0 || dt.getMinutes() !== 0) {
                str = this.stx.internationalizer.monthDay.format(dt)
                str += ' ' + this.stx.internationalizer.hourMinute.format(dt)
              } else {
                str = this.stx.internationalizer.yearMonthDay.format(dt)
              }
              myDate = str
            }

            this.stx.endClip()
            this.stx.createXAxisLabel(panel, myDate, x0, color, null, true)
            this.stx.startClip(panel.name)
          }
        }
        if (
          this.highlighted &&
          this.name != 'horizontal' &&
          this.name != 'vertical'
        ) {
          var p0Fill = this.highlighted == 'p0' ? true : false
          var p1Fill = this.highlighted == 'p1' ? true : false
          this.littleCircle(context, x0, y0, p0Fill)
          this.littleCircle(context, x1, y1, p1Fill)
        }
      }

      CIQ.Drawing.segment.prototype.abort = function() {
        this.stx.setMeasure(null, null, null, null, false)
      }

      CIQ.Drawing.segment.prototype.intersected = function(tick, value, box) {
        if (!this.p0 || !this.p1) return null // in case invalid drawing (such as from panel that no longer exists)
        if (
          this.name != 'horizontal' &&
          this.name != 'vertical' &&
          this.name != 'gartley'
        ) {
          if (this.pointIntersection(this.p0[0], this.p0[1], box)) {
            this.highlighted = 'p0'
            return {
              action: 'drag',
              point: 'p0',
            }
          } else if (this.pointIntersection(this.p1[0], this.p1[1], box)) {
            this.highlighted = 'p1'
            return {
              action: 'drag',
              point: 'p1',
            }
          }
        }
        var isIntersected = this.lineIntersection(tick, value, box, this.name)
        if (isIntersected) {
          this.highlighted = true
          // This object will be used for repositioning
          return {
            action: 'move',
            p0: CIQ.clone(this.p0),
            p1: CIQ.clone(this.p1),
            tick: tick, // save original tick
            value: value, // save original value
          }
        }
        return null
      }

      CIQ.Drawing.segment.prototype.configs = ['color', 'lineWidth', 'pattern']

      CIQ.Drawing.segment.prototype.copyConfig = function() {
        CIQ.Drawing.copyConfig(this)
        if (this.pattern == 'none') this.pattern = 'solid'
      }

      /**
       * Reconstruct a segment
       * @memberOf CIQ.Drawing.segment
       * @param  {CIQ.ChartEngine} stx The chart object
       * @param  {object} [obj] A drawing descriptor
       * @param {string} [obj.col] The line color
       * @param {string} [obj.pnl] The panel name
       * @param {string} [obj.ptrn] Optional pattern for line "solid","dotted","dashed". Defaults to solid.
       * @param {number} [obj.lw] Optional line width. Defaults to 1.
       * @param {number} [obj.v0] Value (price) for the first point
       * @param {number} [obj.v1] Value (price) for the second point
       * @param {number} [obj.d0] Date (string form) for the first point
       * @param {number} [obj.d1] Date (string form) for the second point
       * @param {number} [obj.tzo0] Offset of UTC from d0 in minutes
       * @param {number} [obj.tzo1] Offset of UTC from d1 in minutes
       */
      CIQ.Drawing.segment.prototype.reconstruct = function(stx, obj) {
        this.stx = stx
        this.color = obj.col
        this.panelName = obj.pnl
        this.pattern = obj.ptrn
        this.lineWidth = obj.lw
        this.d0 = obj.d0
        this.d1 = obj.d1
        this.tzo0 = obj.tzo0
        this.tzo1 = obj.tzo1
        this.v0 = obj.v0
        this.v1 = obj.v1
        this.adjust()
      }

      CIQ.Drawing.segment.prototype.serialize = function() {
        return {
          name: this.name,
          pnl: this.panelName,
          col: this.color,
          ptrn: this.pattern,
          lw: this.lineWidth,
          d0: this.d0,
          d1: this.d1,
          tzo0: this.tzo0,
          tzo1: this.tzo1,
          v0: this.v0,
          v1: this.v1,
        }
      }

      /**
       * Continuous line drawing tool. Creates a series of connected line segments, each one completed with a user click.
       *
       * It inherits its properties from {@link CIQ.Drawing.segment}.
       * @constructor
       * @name  CIQ.Drawing.continuous
       */
      CIQ.Drawing.continuous = function() {
        this.name = 'continuous'
        this.dragToDraw = false
        this.maxSegments = null
      }

      CIQ.Drawing.continuous.ciqInheritsFrom(CIQ.Drawing.segment)

      CIQ.Drawing.continuous.prototype.click = function(context, tick, value) {
        var panel = this.stx.panels[this.panelName]
        if (!panel) return
        this.copyConfig()
        if (!this.penDown) {
          this.setPoint(0, tick, value, panel.chart)
          this.penDown = true
          return false
        }
        if (this.accidentalClick(tick, value)) {
          this.stx.undo() //abort
          return true
        }

        this.setPoint(1, tick, value, panel.chart)

        // render a segment
        var Segment = CIQ.Drawing.segment
        var segment = new Segment()
        var obj = this.serialize(this.stx)
        segment.reconstruct(this.stx, obj)
        this.stx.addDrawing(segment)
        this.stx.changeOccurred('vector')
        this.stx.draw()
        this.segment++

        if (this.maxSegments && this.segment > this.maxSegments) return true
        this.setPoint(0, tick, value, panel.chart) // reset initial point for next segment, copy by value
        return false
      }

      /**
       * Line drawing tool. A line is a vector defined by two points that is infinite in both directions.
       *
       * It inherits its properties from {@link CIQ.Drawing.segment}.
       * @constructor
       * @name  CIQ.Drawing.line
       */
      CIQ.Drawing.line = function() {
        this.name = 'line'
      }

      CIQ.Drawing.line.prototype.dragToDraw = false

      CIQ.Drawing.line.ciqInheritsFrom(CIQ.Drawing.segment)

      CIQ.Drawing.line.prototype.calculateOuterSet = function(panel) {
        if (
          this.p0[0] == this.p1[0] ||
          this.p0[1] == this.p1[1] ||
          CIQ.ChartEngine.isDailyInterval(this.stx.layout.interval)
        ) {
          return
        }

        var vector = {
          x0: this.p0[0],
          y0: this.p0[1],
          x1: this.p1[0],
          y1: this.p1[1],
        }
        if (vector.x0 > vector.x1) {
          vector = {
            x0: this.p1[0],
            y0: this.p1[1],
            x1: this.p0[0],
            y1: this.p0[1],
          }
        }

        var earlier = vector.x0 - 1000
        var later = vector.x1 + 1000

        this.v0B = CIQ.yIntersection(vector, earlier)
        this.v1B = CIQ.yIntersection(vector, later)
        this.d0B = this.stx.dateFromTick(earlier, panel.chart)
        this.d1B = this.stx.dateFromTick(later, panel.chart)
      }

      CIQ.Drawing.line.prototype.click = function(context, tick, value) {
        var panel = this.stx.panels[this.panelName]
        if (!panel) return
        this.copyConfig()
        if (!this.penDown) {
          this.setPoint(0, tick, value, panel.chart)
          this.penDown = true
          return false
        }
        // if the user accidentally double clicks in rapid fashion
        if (this.accidentalClick(tick, value)) return this.dragToDraw
        this.setPoint(1, tick, value, panel.chart)
        this.calculateOuterSet(panel)
        this.penDown = false
        return true // kernel will call render after this
      }

      /**
       * Reconstruct a line
       * @param  {CIQ.ChartEngine} stx The chart object
       * @param  {object} [obj] A drawing descriptor
       * @param {string} [obj.col] The line color
       * @param {string} [obj.pnl] The panel name
       * @param {string} [obj.ptrn] Optional pattern for line "solid","dotted","dashed". Defaults to solid.
       * @param {number} [obj.lw] Optional line width. Defaults to 1.
       * @param {number} [obj.v0] Value (price) for the first point
       * @param {number} [obj.v1] Value (price) for the second point
       * @param {number} [obj.d0] Date (string form) for the first point
       * @param {number} [obj.d1] Date (string form) for the second point
       * @param {number} [obj.v0B] Computed outer Value (price) for the first point if original drawing was on intraday but now displaying on daily
       * @param {number} [obj.v1B] Computed outer Value (price) for the second point if original drawing was on intraday but now displaying on daily
       * @param {number} [obj.d0B] Computed outer Date (string form) for the first point if original drawing was on intraday but now displaying on daily
       * @param {number} [obj.d1B] Computed outer Date (string form) for the second point if original drawing was on intraday but now displaying on daily
       * @param {number} [obj.tzo0] Offset of UTC from d0 in minutes
       * @param {number} [obj.tzo1] Offset of UTC from d1 in minutes
       * @memberOf CIQ.Drawing.line
       */
      CIQ.Drawing.line.prototype.reconstruct = function(stx, obj) {
        this.stx = stx
        this.color = obj.col
        this.panelName = obj.pnl
        this.pattern = obj.ptrn
        this.lineWidth = obj.lw
        this.v0 = obj.v0
        this.v1 = obj.v1
        this.d0 = obj.d0
        this.d1 = obj.d1
        this.tzo0 = obj.tzo0
        this.tzo1 = obj.tzo1
        if (obj.d0B) {
          this.d0B = obj.d0B
          this.d1B = obj.d1B
          this.v0B = obj.v0B
          this.v1B = obj.v1B
        }
        this.adjust()
      }

      CIQ.Drawing.line.prototype.serialize = function() {
        var obj = {
          name: this.name,
          pnl: this.panelName,
          col: this.color,
          ptrn: this.pattern,
          lw: this.lineWidth,
          d0: this.d0,
          d1: this.d1,
          tzo0: this.tzo0,
          tzo1: this.tzo1,
          v0: this.v0,
          v1: this.v1,
        }
        if (this.d0B) {
          obj.d0B = this.d0B
          obj.d1B = this.d1B
          obj.v0B = this.v0B
          obj.v1B = this.v1B
        }
        return obj
      }

      CIQ.Drawing.line.prototype.adjust = function() {
        var panel = this.stx.panels[this.panelName]
        if (!panel) return
        this.setPoint(0, this.d0, this.v0, panel.chart)
        this.setPoint(1, this.d1, this.v1, panel.chart)
        // Use outer set if original drawing was on intraday but now displaying on daily
        if (
          CIQ.ChartEngine.isDailyInterval(this.stx.layout.interval) &&
          this.d0B
        ) {
          this.setPoint(0, this.d0B, this.v0B, panel.chart)
          this.setPoint(1, this.d1B, this.v1B, panel.chart)
        }
      }

      /**
       * Ray drawing tool. A ray is defined by two points. It travels infinitely past the second point.
       *
       * It inherits its properties from {@link CIQ.Drawing.line}.
       * @constructor
       * @name  CIQ.Drawing.ray
       */
      CIQ.Drawing.ray = function() {
        this.name = 'ray'
      }

      CIQ.Drawing.ray.ciqInheritsFrom(CIQ.Drawing.line)

      CIQ.Drawing.ray.prototype.calculateOuterSet = function(panel) {
        if (
          this.p0[0] == this.p1[0] ||
          this.p0[1] == this.p1[1] ||
          CIQ.ChartEngine.isDailyInterval(this.stx.layout.interval)
        ) {
          return
        }

        var vector = {
          x0: this.p0[0],
          y0: this.p0[1],
          x1: this.p1[0],
          y1: this.p1[1],
        }

        var endOfRay = vector.x1 + 1000
        if (vector.x0 > vector.x1) {
          endOfRay = vector.x1 - 1000
        }

        this.v0B = this.v0
        this.v1B = CIQ.yIntersection(vector, endOfRay)
        this.d0B = this.d0
        this.d1B = this.stx.dateFromTick(endOfRay, panel.chart)
      }

      CIQ.Drawing.ray.prototype.adjust = function() {
        var panel = this.stx.panels[this.panelName]
        if (!panel) return
        this.setPoint(0, this.d0, this.v0, panel.chart)
        this.setPoint(1, this.d1, this.v1, panel.chart)
        // Use outer set if original drawing was on intraday but now displaying on daily
        if (
          CIQ.ChartEngine.isDailyInterval(this.stx.layout.interval) &&
          this.d0B
        ) {
          this.setPoint(1, this.d1B, this.v1B, panel.chart)
        }
      }

      /**
       * Horizontal line drawing tool. The horizontal line extends infinitely in both directions.
       *
       * It inherits its properties from {@link CIQ.Drawing.segment}
       * @constructor
       * @name  CIQ.Drawing.horizontal
       */
      CIQ.Drawing.horizontal = function() {
        this.name = 'horizontal'
      }

      CIQ.Drawing.horizontal.prototype.dragToDraw = false

      CIQ.Drawing.horizontal.ciqInheritsFrom(CIQ.Drawing.segment)
      CIQ.Drawing.horizontal.prototype.measure = function() {}

      CIQ.Drawing.horizontal.prototype.click = function(context, tick, value) {
        var panel = this.stx.panels[this.panelName]
        if (!panel) return
        this.copyConfig()
        this.setPoint(0, tick, value, panel.chart)
        return true // kernel will call render after this
      }

      /**
       * Reconstruct a horizontal
       * @param  {CIQ.ChartEngine} stx The chart object
       * @param  {object} [obj] A drawing descriptor
       * @param {string} [obj.col] The line color
       * @param {string} [obj.pnl] The panel name
       * @param {string} [obj.ptrn] Optional pattern for line "solid","dotted","dashed". Defaults to solid.
       * @param {number} [obj.lw] Optional line width. Defaults to 1.
       * @param {number} [obj.v0] Value (price) for the first point
       * @param {number} [obj.d0] Date (string form) for the first point
       * @param {boolean} [obj.al] True to include an axis label
       * @param {number} [obj.tzo0] Offset of UTC from d0 in minutes
       * @memberOf CIQ.Drawing.horizontal
       */
      CIQ.Drawing.horizontal.prototype.reconstruct = function(stx, obj) {
        this.stx = stx
        this.color = obj.col
        this.panelName = obj.pnl
        this.pattern = obj.ptrn
        this.lineWidth = obj.lw
        this.v0 = obj.v0
        this.d0 = obj.d0
        this.tzo0 = obj.tzo0
        this.axisLabel = obj.al
        this.adjust()
      }

      CIQ.Drawing.horizontal.prototype.serialize = function() {
        var obj = {
          name: this.name,
          pnl: this.panelName,
          col: this.color,
          ptrn: this.pattern,
          lw: this.lineWidth,
          v0: this.v0,
          d0: this.d0,
          tzo0: this.tzo0,
          al: this.axisLabel,
        }

        return obj
      }

      CIQ.Drawing.horizontal.prototype.adjust = function() {
        var panel = this.stx.panels[this.panelName]
        if (!panel) return
        this.setPoint(0, this.d0, this.v0, panel.chart)
        this.p1 = [this.p0[0] + 100, this.p0[1]]
      }

      CIQ.Drawing.horizontal.prototype.configs = [
        'color',
        'lineWidth',
        'pattern',
        'axisLabel',
      ]

      CIQ.Drawing.horizontal.prototype.copyConfig = function() {
        CIQ.Drawing.copyConfig(this)
        if (this.pattern == 'none') this.pattern = 'solid'
      }

      /**
       * Vertical line drawing tool. The vertical line extends infinitely in both directions.
       *
       * It inherits its properties from {@link CIQ.Drawing.horizontal}.
       * @constructor
       * @name  CIQ.Drawing.vertical
       */
      CIQ.Drawing.vertical = function() {
        this.name = 'vertical'
      }

      CIQ.Drawing.vertical.ciqInheritsFrom(CIQ.Drawing.horizontal)
      CIQ.Drawing.vertical.prototype.measure = function() {}

      CIQ.Drawing.vertical.prototype.adjust = function() {
        var panel = this.stx.panels[this.panelName]
        if (!panel) return
        this.setPoint(0, this.d0, this.v0, panel.chart)
        this.p1 = [this.p0[0], this.p0[1] + 1]
      }

      /**
       * Measure tool.
       * It inherits its properties from {@link CIQ.Drawing.segment}.
       * @constructor
       * @name  CIQ.Drawing.measure
       */
      CIQ.Drawing.measure = function() {
        this.name = 'measure'
      }

      CIQ.Drawing.measure.ciqInheritsFrom(CIQ.Drawing.segment)

      CIQ.Drawing.measure.prototype.click = function(context, tick, value) {
        this.copyConfig()
        if (!this.penDown) {
          this.p0 = [tick, value]
          this.penDown = true

          return false
        }
        this.stx.undo()
        this.penDown = false
        return true
      }

      /**
       * rectangle is an implementation of a {@link CIQ.Drawing.BaseTwoPoint} drawing
       * @constructor
       * @name  CIQ.Drawing.rectangle
       */
      CIQ.Drawing.rectangle = function() {
        this.name = 'rectangle'
      }

      CIQ.Drawing.rectangle.ciqInheritsFrom(CIQ.Drawing.BaseTwoPoint)

      CIQ.Drawing.rectangle.prototype.render = function(context) {
        var panel = this.stx.panels[this.panelName]
        if (!panel) return
        var x0 = this.stx.pixelFromTick(this.p0[0], panel.chart)
        var x1 = this.stx.pixelFromTick(this.p1[0], panel.chart)
        var y0 = this.stx.pixelFromValueAdjusted(panel, this.p0[0], this.p0[1])
        var y1 = this.stx.pixelFromValueAdjusted(panel, this.p1[0], this.p1[1])

        var x = Math.round(Math.min(x0, x1)) + 0.5
        var y = Math.min(y0, y1)
        var width = Math.max(x0, x1) - x
        var height = Math.max(y0, y1) - y
        var edgeColor = this.color
        if (this.highlighted) {
          edgeColor = this.stx.getCanvasColor('stx_highlight_vector')
        }

        var fillColor = this.fillColor
        if (fillColor && !CIQ.isTransparent(fillColor) && fillColor != 'auto') {
          context.beginPath()
          context.rect(x, y, width, height)
          context.fillStyle = fillColor
          context.globalAlpha = 0.2
          context.fill()
          context.closePath()
          context.globalAlpha = 1
        }

        var parameters = {
          pattern: this.pattern,
          lineWidth: this.lineWidth,
        }
        if (this.highlighted && parameters.pattern == 'none') {
          parameters.pattern = 'solid'
          if (parameters.lineWidth == 0.1) parameters.lineWidth = 1
        }

        // We extend the vertical lines by .5 to account for displacement of the horizontal lines
        // HTML5 Canvas exists *between* pixels, not on pixels, so draw on .5 to get crisp lines
        this.stx.plotLine(
          x0,
          x1,
          y0,
          y0,
          edgeColor,
          'segment',
          context,
          panel,
          parameters
        )
        this.stx.plotLine(
          x1,
          x1,
          y0 - 0.5,
          y1 + 0.5,
          edgeColor,
          'segment',
          context,
          panel,
          parameters
        )
        this.stx.plotLine(
          x1,
          x0,
          y1,
          y1,
          edgeColor,
          'segment',
          context,
          panel,
          parameters
        )
        this.stx.plotLine(
          x0,
          x0,
          y1 + 0.5,
          y0 - 0.5,
          edgeColor,
          'segment',
          context,
          panel,
          parameters
        )
        if (this.highlighted) {
          var p0Fill = this.highlighted == 'p0' ? true : false
          var p1Fill = this.highlighted == 'p1' ? true : false
          this.littleCircle(context, x0, y0, p0Fill)
          this.littleCircle(context, x1, y1, p1Fill)
        }
      }

      CIQ.Drawing.rectangle.prototype.intersected = function(tick, value, box) {
        if (!this.p0 || !this.p1) return null // in case invalid drawing (such as from panel that no longer exists)
        if (this.pointIntersection(this.p0[0], this.p0[1], box)) {
          this.highlighted = 'p0'
          return {
            action: 'drag',
            point: 'p0',
          }
        } else if (this.pointIntersection(this.p1[0], this.p1[1], box)) {
          this.highlighted = 'p1'
          return {
            action: 'drag',
            point: 'p1',
          }
        }
        if (this.boxIntersection(tick, value)) {
          this.highlighted = true
          return {
            action: 'move',
            p0: CIQ.clone(this.p0),
            p1: CIQ.clone(this.p1),
            tick: tick,
            value: value,
          }
        }
        return null
      }

      CIQ.Drawing.rectangle.prototype.configs = [
        'color',
        'fillColor',
        'lineWidth',
        'pattern',
      ]

      /**
       * Reconstruct an rectangle
       * @param  {CIQ.ChartEngine} stx The chart object
       * @param  {object} [obj] A drawing descriptor
       * @param {string} [obj.col] The border color
       * @param {string} [obj.fc] The fill color
       * @param {string} [obj.pnl] The panel name
       * @param {string} [obj.ptrn] Optional pattern for line "solid","dotted","dashed". Defaults to solid.
       * @param {number} [obj.lw] Optional line width. Defaults to 1.
       * @param {number} [obj.v0] Value (price) for the first point
       * @param {number} [obj.v1] Value (price) for the second point
       * @param {number} [obj.d0] Date (string form) for the first point
       * @param {number} [obj.d1] Date (string form) for the second point
       * @param {number} [obj.tzo0] Offset of UTC from d0 in minutes
       * @param {number} [obj.tzo1] Offset of UTC from d1 in minutes
       * @memberOf CIQ.Drawing.rectangle
       */
      CIQ.Drawing.rectangle.prototype.reconstruct = function(stx, obj) {
        this.stx = stx
        this.color = obj.col
        this.fillColor = obj.fc
        this.panelName = obj.pnl
        this.pattern = obj.ptrn
        this.lineWidth = obj.lw
        this.d0 = obj.d0
        this.d1 = obj.d1
        this.tzo0 = obj.tzo0
        this.tzo1 = obj.tzo1
        this.v0 = obj.v0
        this.v1 = obj.v1
        this.adjust()
      }

      CIQ.Drawing.rectangle.prototype.serialize = function() {
        return {
          name: this.name,
          pnl: this.panelName,
          col: this.color,
          fc: this.fillColor,
          ptrn: this.pattern,
          lw: this.lineWidth,
          d0: this.d0,
          d1: this.d1,
          tzo0: this.tzo0,
          tzo1: this.tzo1,
          v0: this.v0,
          v1: this.v1,
        }
      }

      /**
       * Ellipse drawing tool.
       *
       * It inherits its properties from {@link CIQ.Drawing.BaseTwoPoint}.
       * @constructor
       * @name  CIQ.Drawing.ellipse
       */
      CIQ.Drawing.ellipse = function() {
        this.name = 'ellipse'
      }

      CIQ.Drawing.ellipse.ciqInheritsFrom(CIQ.Drawing.BaseTwoPoint)

      CIQ.Drawing.ellipse.prototype.render = function(context) {
        var panel = this.stx.panels[this.panelName]
        if (!panel) return
        var x0 = this.stx.pixelFromTick(this.p0[0], panel.chart)
        var x1 = this.stx.pixelFromTick(this.p1[0], panel.chart)
        var y0 = this.stx.pixelFromValueAdjusted(panel, this.p0[0], this.p0[1])
        var y1 = this.stx.pixelFromValueAdjusted(panel, this.p1[0], this.p1[1])

        var left = x0 - (x1 - x0)
        var right = x1
        var middle = y0
        var bottom = y1
        var top = y0 - (y1 - y0)
        var weight = (bottom - top) / 6
        var lineWidth = this.lineWidth
        if (!lineWidth) lineWidth = 1.1
        var edgeColor = this.color
        if (edgeColor == 'auto' || CIQ.isTransparent(edgeColor))
          edgeColor = this.stx.defaultColor
        if (this.highlighted) {
          edgeColor = this.stx.getCanvasColor('stx_highlight_vector')
          if (lineWidth == 0.1) lineWidth = 1.1
        }

        var fillColor = this.fillColor

        context.beginPath()
        context.moveTo(left, middle)
        context.bezierCurveTo(
          left,
          bottom + weight,
          right,
          bottom + weight,
          right,
          middle
        )
        context.bezierCurveTo(
          right,
          top - weight,
          left,
          top - weight,
          left,
          middle
        )

        if (fillColor && !CIQ.isTransparent(fillColor) && fillColor != 'auto') {
          context.fillStyle = fillColor
          context.globalAlpha = 0.2
          context.fill()
          context.globalAlpha = 1
        }

        if (edgeColor && this.pattern != 'none') {
          context.strokeStyle = edgeColor
          context.lineWidth = lineWidth
          if (context.setLineDash) {
            context.setLineDash(
              CIQ.borderPatternToArray(lineWidth, this.pattern)
            )
            context.lineDashOffset = 0 //start point in array
          }
          context.stroke()
        }
        context.closePath()
        if (this.highlighted) {
          var p1Fill = this.highlighted == 'p1' ? true : false
          this.littleCircle(context, x1, y1, p1Fill)
        }
      }

      CIQ.Drawing.ellipse.prototype.intersected = function(tick, value, box) {
        if (!this.p0 || !this.p1) return null // in case invalid drawing (such as from panel that no longer exists)
        if (this.pointIntersection(this.p1[0], this.p1[1], box)) {
          this.highlighted = 'p1'
          return {
            action: 'drag',
            point: 'p1',
          }
        }
        var left = this.p0[0] - (this.p1[0] - this.p0[0])
        var right = this.p1[0]
        var bottom = this.p1[1]
        var top = this.p0[1] - (this.p1[1] - this.p0[1])

        if (tick > Math.max(left, right) || tick < Math.min(left, right))
          return false
        if (value > Math.max(top, bottom) || value < Math.min(top, bottom))
          return false
        this.highlighted = true
        return {
          action: 'move',
          p0: CIQ.clone(this.p0),
          p1: CIQ.clone(this.p1),
          tick: tick,
          value: value,
        }
      }

      CIQ.Drawing.ellipse.prototype.configs = [
        'color',
        'fillColor',
        'lineWidth',
        'pattern',
      ]

      /**
       * Reconstruct an ellipse
       * @param  {CIQ.ChartEngine} stx The chart object
       * @param  {object} [obj] A drawing descriptor
       * @param {string} [obj.col] The border color
       * @param {string} [obj.fc] The fill color
       * @param {string} [obj.pnl] The panel name
       * @param {string} [obj.ptrn] Optional pattern for line "solid","dotted","dashed". Defaults to solid.
       * @param {number} [obj.lw] Optional line width. Defaults to 1.
       * @param {number} [obj.v0] Value (price) for the center point
       * @param {number} [obj.v1] Value (price) for the outside point
       * @param {number} [obj.d0] Date (string form) for the center point
       * @param {number} [obj.d1] Date (string form) for the outside point
       * @param {number} [obj.tzo0] Offset of UTC from d0 in minutes
       * @param {number} [obj.tzo1] Offset of UTC from d1 in minutes
       * @memberOf CIQ.Drawing.ellipse
       */
      CIQ.Drawing.ellipse.prototype.reconstruct = function(stx, obj) {
        this.stx = stx
        this.color = obj.col
        this.fillColor = obj.fc
        this.panelName = obj.pnl
        this.pattern = obj.ptrn
        this.lineWidth = obj.lw
        this.d0 = obj.d0
        this.d1 = obj.d1
        this.tzo0 = obj.tzo0
        this.tzo1 = obj.tzo1
        this.v0 = obj.v0
        this.v1 = obj.v1
        this.adjust()
      }

      CIQ.Drawing.ellipse.prototype.serialize = function() {
        return {
          name: this.name,
          pnl: this.panelName,
          col: this.color,
          fc: this.fillColor,
          ptrn: this.pattern,
          lw: this.lineWidth,
          d0: this.d0,
          d1: this.d1,
          tzo0: this.tzo0,
          tzo1: this.tzo1,
          v0: this.v0,
          v1: this.v1,
        }
      }

      /**
       * Fibonacci drawing tool.
       *
       * It inherits its properties from {@link CIQ.Drawing.BaseTwoPoint}
       * @constructor
       * @name  CIQ.Drawing.fibonacci
       */
      CIQ.Drawing.fibonacci = function() {
        this.name = 'fibonacci'
        this.configurator = 'fibonacci'
      }

      CIQ.Drawing.fibonacci.ciqInheritsFrom(CIQ.Drawing.BaseTwoPoint)

      CIQ.Drawing.fibonacci.mapping = {
        trend: 't',
        color: 'c',
        parameters: 'p',
        pattern: 'pt',
        opacity: 'o',
        lineWidth: 'lw',
        level: 'l',
        extendLeft: 'e',
        printLevels: 'pl',
        printValues: 'pv',
        timezone: 'tz',
      }

      CIQ.Drawing.fibonacci.prototype.configs = [
        'color',
        'fillColor',
        'lineWidth',
        'pattern',
        'parameters',
      ]

      /*
       * Calculate the outer points of the fib series, which are used to detect highlighting
       */
      CIQ.Drawing.fibonacci.prototype.setOuter = function() {
        this.outer = {
          p0: CIQ.clone(this.p0),
          p1: CIQ.clone(this.p1),
        }
        var y0 = this.p0[1]
        var y1 = this.p1[1]
        var x0 = this.p0[0]
        var x1 = this.p1[0]

        var min = 0
        var max = 1
        for (var i = 0; i < this.parameters.fibs.length; i++) {
          var fib = this.parameters.fibs[i]
          if ((fib.level >= min && fib.level <= max) || !fib.display) continue
          var val = y1 - (y1 - y0) * fib.level
          var x = CIQ.xIntersection({ x0: x0, x1: x1, y0: y0, y1: y1 }, val)
          if (fib.level < min) {
            min = fib.level
            this.outer.p1[1] = val
            this.outer.p1[0] = x
          } else if (fib.level > max) {
            max = fib.level
            this.outer.p0[1] = val
            this.outer.p0[0] = x
          }
        }
      }

      CIQ.Drawing.fibonacci.prototype.click = function(context, tick, value) {
        var panel = this.stx.panels[this.panelName]
        if (!panel) return
        this.copyConfig()
        if (!this.penDown) {
          this.setPoint(0, tick, value, panel.chart)
          this.penDown = true
          return false
        }
        if (this.accidentalClick(tick, value)) return this.dragToDraw

        this.setPoint(1, tick, value, panel.chart)
        this.setOuter()
        this.parameters = CIQ.clone(this.parameters) // separate from the global object
        this.penDown = false

        return true // kernel will call render after this
      }

      CIQ.Drawing.fibonacci.prototype.render = function(context) {
        var panel = this.stx.panels[this.panelName]
        if (!panel) return
        var yAxis = panel.yAxis
        if (!this.p1) return
        var max = Math.max(this.p0[1], this.p1[1])
        var min = Math.min(this.p0[1], this.p1[1])
        var dist = max - min
        var x0 = this.stx.pixelFromTick(this.p0[0], panel.chart)
        var x1 = this.stx.pixelFromTick(this.p1[0], panel.chart)
        var y0 = this.stx.pixelFromValueAdjusted(panel, this.p0[0], this.p0[1])
        var y1 = this.stx.pixelFromValueAdjusted(panel, this.p1[0], this.p1[1])
        var top = Math.min(y1, y0)
        var bottom = Math.max(y1, y0)
        var height = bottom - top
        var isUpTrend = (y1 - y0) / (x1 - x0) > 0

        //old drawings missing parameters.trend
        var trend = {
          color: 'auto',
          parameters: { pattern: 'solid', opacity: 0.25, lineWidth: 1 },
        }
        if (!this.parameters.trend) this.parameters.trend = trend
        var trendLineColor = this.setLineColor(this.parameters.trend.color)
        context.textBaseline = 'middle'
        this.stx.canvasFont('stx_yaxis', context) // match font from y axis so it looks cohesive
        var w = context.measureText('161.8%').width + 10 // give it extra space so it does not overlap with the price labels.
        var minX = Number.MAX_VALUE,
          minY = Number.MAX_VALUE,
          maxX = Number.MAX_VALUE * -1,
          maxY = Number.MAX_VALUE * -1
        var txtColor = this.color
        if (txtColor == 'auto' || CIQ.isTransparent(txtColor))
          txtColor = this.stx.defaultColor
        for (var i = 0; i < this.parameters.fibs.length; i++) {
          context.textAlign = 'left'
          context.fillStyle = txtColor
          var fib = this.parameters.fibs[i]
          if (!fib.display) continue
          var y = this.stx.pixelFromValueAdjusted(
            panel,
            this.p0[0],
            y1 < y0 ? max - dist * fib.level : min + dist * fib.level
          )
          var x = CIQ.xIntersection({ x0: x0, x1: x1, y0: y0, y1: y1 }, y)
          var nearX = this.parameters.extendLeft ? 0 : x
          var farX = this.stx.chart.left + this.stx.chart.width
          if (this.parameters.printLevels) {
            var txt = Math.round(fib.level * 1000) / 10 + '%'
            farX -= w
            if (this.parameters.printValues) {
              context.fillStyle = txtColor // the price labels screw up the color and font size...so reset before rendering the text
              this.stx.canvasFont('stx_yaxis', context) // use the same context as the y axis so they match.
            }
            if (farX < nearX) context.textAlign = 'right'
            context.fillText(txt, farX, y)
            if (farX < nearX) farX += 5
            else farX -= 5
          }
          if (this.parameters.printValues) {
            if (x < this.stx.chart.width) {
              // just use the actual price that segment will render on regardless of 'isUpTrend' since the values must match the prices on the y axis, and can not be reversed.
              var price = this.stx.transformedPriceFromPixel(y, panel)
              if (yAxis.priceFormatter) {
                price = yAxis.priceFormatter(this.stx, panel, price)
              } else {
                price = this.stx.formatYAxisPrice(price, panel)
              }
              if (context == this.stx.chart.context) this.stx.endClip()
              this.stx.createYAxisLabel(
                panel,
                price,
                y,
                txtColor,
                null,
                context
              )
              if (context == this.stx.chart.context)
                this.stx.startClip(panel.name)
            }
          }
          var fibColor = fib.color
          if (fibColor == 'auto' || CIQ.isTransparent(fibColor))
            fibColor = this.color
          if (fibColor == 'auto' || CIQ.isTransparent(fibColor))
            fibColor = this.stx.defaultColor
          var fillColor = fib.color
          if (fillColor == 'auto' || CIQ.isTransparent(fillColor))
            fillColor = this.fillColor
          if (fillColor == 'auto' || CIQ.isTransparent(fillColor))
            fillColor = this.stx.defaultColor
          context.fillStyle = fillColor
          this.stx.plotLine(
            nearX,
            farX,
            y,
            y,
            fibColor,
            'segment',
            context,
            panel,
            fib.parameters
          )
          context.globalAlpha = 0.05
          context.beginPath()
          context.moveTo(farX, y)
          context.lineTo(nearX, y)
          if (nearX) context.lineTo(x1, y1)
          else context.lineTo(nearX, y1)
          context.lineTo(farX, y1)
          if (typeof fillColor != 'undefined') context.fill() // so legacy fibs continue to have no fill color.
          context.globalAlpha = 1
          if (y < minY) {
            minX = x
            minY = y
          }
          if (y > maxY) {
            maxX = x
            maxY = y
          }
        }
        // ensure we at least draw trend line from zero to 100
        for (var level in { 0: 0, 1: 1 }) {
          var yy = isUpTrend ? bottom - height * level : top + height * level
          yy = Math.round(yy)
          if (yy < minY) {
            minX = CIQ.xIntersection({ x0: x0, x1: x1, y0: y0, y1: y1 }, yy)
            minY = yy
          }
          if (yy > maxY) {
            maxX = CIQ.xIntersection({ x0: x0, x1: x1, y0: y0, y1: y1 }, yy)
            maxY = yy
          }
        }
        this.stx.plotLine(
          minX,
          maxX,
          minY,
          maxY,
          trendLineColor,
          'segment',
          context,
          panel,
          this.parameters.trend.parameters
        )
        if (this.highlighted) {
          var p0Fill = this.highlighted == 'p0' ? true : false
          var p1Fill = this.highlighted == 'p1' ? true : false
          this.littleCircle(context, x0, y0, p0Fill)
          this.littleCircle(context, x1, y1, p1Fill)
        }
      }

      CIQ.Drawing.fibonacci.prototype.reposition = function(
        context,
        repositioner,
        tick,
        value
      ) {
        if (!repositioner) return
        CIQ.Drawing.BaseTwoPoint.prototype.reposition.apply(this, arguments)
        this.adjust()
      }

      CIQ.Drawing.fibonacci.prototype.intersected = function(tick, value, box) {
        //TODO, find some efficient way to allow an intersection across the entire trend line, not just between the two clicked points
        var p0 = this.p0,
          p1 = this.p1,
          outer = this.outer,
          layout = this.stx.layout
        if (!p0 || !p1) return null // in case invalid drawing (such as from panel that no longer exists)
        var intersects = CIQ.boxIntersects(
          box.x0,
          box.y0,
          box.x1,
          box.y1,
          outer.p0[0],
          outer.p0[1],
          outer.p1[0],
          outer.p1[1],
          'segment',
          layout.semiLog || layout.chartScale == 'log'
        )
        if (intersects) {
          if (this.pointIntersection(p0[0], p0[1], box)) {
            this.highlighted = 'p0'
            return {
              action: 'drag',
              point: 'p0',
            }
          } else if (this.pointIntersection(p1[0], p1[1], box)) {
            this.highlighted = 'p1'
            return {
              action: 'drag',
              point: 'p1',
            }
          }
          // This object will be used for repositioning
          this.highlighted = true
          return {
            action: 'move',
            p0: CIQ.clone(p0),
            p1: CIQ.clone(p1),
            tick: tick, // save original tick
            value: value, // save original value
          }
        }
        return null
      }

      /**
       * Reconstruct a fibonacci
       * @param  {CIQ.ChartEngine} stx The chart object
       * @param  {object} [obj] A drawing descriptor
       * @param {string} [obj.col] The border color
       * @param {string} [obj.fc] The fill color
       * @param {string} [obj.pnl] The panel name
       * @param {number} [obj.v0] Value (price) for the first point
       * @param {number} [obj.v1] Value (price) for the second point
       * @param {number} [obj.d0] Date (string form) for the first point
       * @param {number} [obj.d1] Date (string form) for the second point
       * @param {number} [obj.tzo0] Offset of UTC from d0 in minutes
       * @param {number} [obj.tzo1] Offset of UTC from d1 in minutes
       * @param {object} [obj.parameters] Configuration parameters
       * @param {object} [obj.parameters.trend] Describes the trend line
       * @param {string} [obj.parameters.trend.color] The color for the trend line (Defaults to "auto")
       * @param {object} [obj.parameters.trend.parameters] Line description object (pattern, opacity, lineWidth)
       * @param {array} [obj.parameters.fibs] A fib description object for each fib (level, color, parameters)
       * @param {boolean} [obj.parameters.extendLeft] True to extend the fib lines to the left of the screen. Defaults to false.
       * @param {boolean} [obj.parameters.printLevels] True (default) to print text for each percentage level
       * @param {boolean} [obj.parameters.printValues] True to print text for each price level
       * @memberOf CIQ.Drawing.fibonacci
       */
      CIQ.Drawing.fibonacci.prototype.reconstruct = function(stx, obj) {
        obj = CIQ.replaceFields(
          obj,
          CIQ.reverseObject(CIQ.Drawing.fibonacci.mapping)
        )
        this.stx = stx
        this.parameters = obj.parameters
        if (!this.parameters)
          this.parameters = CIQ.clone(
            this.stx.currentVectorParameters.fibonacci
          ) // For legacy fibs that didn't include parameters
        this.color = obj.col
        this.fillColor = obj.fc
        this.panelName = obj.pnl
        this.d0 = obj.d0
        this.d1 = obj.d1
        this.tzo0 = obj.tzo0
        this.tzo1 = obj.tzo1
        this.v0 = obj.v0
        this.v1 = obj.v1
        this.adjust()
      }

      CIQ.Drawing.fibonacci.prototype.adjust = function() {
        var panel = this.stx.panels[this.panelName]
        if (!panel) return
        this.setPoint(0, this.d0, this.v0, panel.chart)
        this.setPoint(1, this.d1, this.v1, panel.chart)
        this.setOuter()
      }

      CIQ.Drawing.fibonacci.prototype.serialize = function() {
        var obj = {
          name: this.name,
          parameters: this.parameters,
          pnl: this.panelName,
          col: this.color,
          fc: this.fillColor,
          d0: this.d0,
          d1: this.d1,
          tzo0: this.tzo0,
          tzo1: this.tzo1,
          v0: this.v0,
          v1: this.v1,
        }
        return CIQ.replaceFields(obj, CIQ.Drawing.fibonacci.mapping)
      }

      /**
       * Retracement drawing tool.
       *
       * It inherits its properties from {@link CIQ.Drawing.fibonacci}
       * @constructor
       * @name  CIQ.Drawing.retracement
       */
      CIQ.Drawing.retracement = function() {
        this.name = 'retracement'
      }

      CIQ.Drawing.retracement.ciqInheritsFrom(CIQ.Drawing.fibonacci)

      /**
       * Function to determine which drawing tools are available.
       * @param  {object} excludeList Exclusion list of tools in object form ( e.g. {"vertical":true,"annotation":true})
       * @returns {object} Map of tool names and types
       * @memberof CIQ.Drawing
       * @since 3.0.0
       */
      CIQ.Drawing.getDrawingToolList = function(excludeList) {
        var map = {}
        var excludedDrawings = {
          ciqInheritsFrom: true,
          stxInheritsFrom: true,
          copyConfig: true,
          getDrawingParameters: true,
          getDrawingToolList: true,
          BaseTwoPoint: true,
          shape: true,
        }
        CIQ.extend(excludedDrawings, excludeList)
        for (var drawing in CIQ.Drawing) {
          if (!excludedDrawings[drawing])
            map[new CIQ.Drawing[drawing]().name] = drawing
        }
        return map
      }

      return _exports
    }

  var __i18n_ =
    //-------------------------------------------------------------------------------------------
    // Copyright 2012-2017 by ChartIQ, Inc.
    // All rights reserved
    //-------------------------------------------------------------------------------------------
    function(_exports) {
      var CIQ = _exports.CIQ,
        $$ = _exports.$$

      /**
       * Namespace for Internationalization API.
       * See {@tutorial Localization} for more details.
       * @namespace
       * @name CIQ.I18N
       */

      CIQ.I18N = function() {}

      // Hack code to make a multi line string easy cut & paste from a spreadsheet
      CIQ.I18N.hereDoc = function(f) {
        return f
          .toString()
          .replace(/^[^/]+\/\*!?/, '')
          .replace(/\*\/[^/]+$/, '')
      }

      /**
       * Must be set to the desired language. Defaults to english "en"
       * @memberOf CIQ.I18N
       * @type {string}
       */
      CIQ.I18N.language = 'en'

      /**
       * Sets the languages that that don't support shortening
       * Translation will print entire month from locale for these languages
       * @memberOf CIQ.I18N
       * @type {Object}
       */
      CIQ.I18N.longMonths = { zh: true }

      /**
       * Maintains the list of locales used by {@link CIQ.I18N.localize} to decide if the up/down colors should be reversed and can be updated as outlined on the example.
       *
       * Defaults to : {"zh":true,"ja":true};
       * @type {Object}
       * @memberOf CIQ.I18N
       * @since 4.0.0
       * @example
       * CIQ.I18N.reverseColorsByLocale={
       * 		"zh":true,
       * 		"ja":true,
       * 		"fr":true,
       * 		"de":true,
       * 		"hu":true,
       * 		"it":true,
       * 		"pt":true
       * };
       */
      CIQ.I18N.reverseColorsByLocale = { zh: true, ja: true }

      /** Returns a word list containing unique words. Each word references an array of DOM
       *  nodes that contain that word. This can then be used for translation.
       *  Text nodes and placeholders which are found in the document tree will be wrapped by this function
       *  within a <translate> tag for easy translation back and forth.
       * @param  {HTMLElement} [root] root for the TreeWalker.  If omitted, document.body assumed.
       * @return {object}      A word list containing unique words.
       *  @memberOf CIQ.I18N
       */
      CIQ.I18N.findAllTextNodes = function(root) {
        if (!root) root = document.body
        // Get all the words from the placeholders
        // We'll create text nodes for them and stash them in a hidden div so we can access them in the future
        if (root == document.body) {
          if (!$$('stashedTextNodes')) {
            var stashedTextNodes = document.createElement('div')
            stashedTextNodes.id = 'stashedTextNodes'
            stashedTextNodes.style.display = 'none'
            root.appendChild(stashedTextNodes)

            var fields = document.querySelectorAll(
              'input,textarea,.editable_content'
            )
            for (var f = 0; f < fields.length; f++) {
              var placeHolder = fields[f].getAttribute('placeholder')
              if (placeHolder) {
                var wrapper = stashedTextNodes.appendChild(
                  document.createElement('translate')
                )
                wrapper.setAttribute('original', placeHolder)
                wrapper.placeholderFor = fields[f]
                wrapper.appendChild(document.createTextNode(placeHolder))
              }
            }
          }
        }

        var walker = document.createTreeWalker(
          root,
          NodeFilter.SHOW_TEXT,
          null,
          false
        )

        var node = walker.nextNode()
        var ws = new RegExp('^\\s*$')
        var line = new RegExp('\n|\t|\f', 'g')
        var wordList = {}
        var dontTranslate = {
          SCRIPT: true,
          STYLE: true,
          TEXTAREA: true,
        }

        while (node) {
          var key = node.nodeValue
          if (!ws.test(key)) {
            var parentNode = node.parentNode
            var parentTag = parentNode.tagName
            if (!dontTranslate[parentTag]) {
              if (parentTag != 'TRANSLATE') {
                var wrapper2 = parentNode.insertBefore(
                  document.createElement('translate'),
                  node
                )
                wrapper2.setAttribute('original', key) //must do getAttribute so it will clone
                wrapper2.appendChild(node)
              } else {
                key = parentNode.getAttribute('original')
              }
              if (line.test(key)) key = key.replace(line, '') // strips out new lines in text
              if (!wordList[key]) wordList[key] = []
              wordList[key].push(node)
            }
          }
          node = walker.nextNode()
        }
        if (root == document.body) {
          // For missing word list collation only:
          // Get all the words from the study library that are used to populate the study dialogs.
          // These will have an empty array since they aren't associated with any nodes
          var studyLibrary = CIQ.Studies ? CIQ.Studies.studyLibrary : null
          if (studyLibrary) {
            for (var study in studyLibrary) {
              if (wordList[study] === null) wordList[study] = []
              var s = studyLibrary[study]
              if (s.inputs) {
                for (var input in s.inputs) {
                  if (!wordList[input]) wordList[input] = []
                }
              }
              if (s.outputs) {
                for (var output in s.outputs) {
                  if (!wordList[output]) wordList[output] = []
                }
              }
            }
          }
        }
        return wordList
      }

      /**
       * CIQ.I18N.missingWordList will scan the UI by walking all the text elements. It will determine which
       * text elements have not been translated for the given language and return those as a JSON object.
       * @param {string} [language] The language to search for missing words. Defaults to whatever language CIQ.I18N.language has set.
       * @return {object} Words that are undefined with values set to empty strings
       * @memberOf CIQ.I18N
       * @since 4.0.0 Iterates over the studyLibrary entry name, inputs, & outputs
       */
      CIQ.I18N.missingWordList = function(language) {
        if (!language) language = CIQ.I18N.language
        var wordsInUI = CIQ.I18N.findAllTextNodes()
        var missingWords = {}
        var languageWordList = CIQ.I18N.wordLists[language]
        if (!languageWordList) languageWordList = {}

        var addIfMissing = function(x) {
          if (typeof languageWordList[x] == 'undefined') {
            missingWords[x] = ''
          }
        }

        for (var word in wordsInUI) {
          addIfMissing(word)
        }

        if (!(CIQ.Studies && CIQ.Studies.studyLibrary)) {
          return missingWords
        }

        var study
        var value

        for (var id in CIQ.Studies.studyLibrary) {
          study = CIQ.Studies.studyLibrary[id]

          addIfMissing(study.name)

          for (var input in study.inputs) {
            addIfMissing(input)
            value = study.inputs[input]

            switch (Object.prototype.toString.call(value)) {
              case '[object String]':
                addIfMissing(value)
                break
              case '[object Array]':
                for (var i = 0; i < value.length; ++i) {
                  addIfMissing(value[i])
                }
                break
            }
          }

          for (var output in study.outputs) {
            addIfMissing(output)
          }
        }

        // studyOverZones input fields
        addIfMissing('Show Zones')
        addIfMissing('OverBought')
        addIfMissing('OverSold')

        return missingWords
      }

      /**
       * A convenient function for creating a human readable JSON object suitable for delivery to a translator.
       * @param {string} [language] language. Defaults to CIQ.I18N.language.
       * @return {string} String of missing words.
       * @memberOf CIQ.I18N
       */
      CIQ.I18N.printableMissingWordList = function(language) {
        var missingWords = JSON.stringify(CIQ.I18N.missingWordList(language))
        missingWords = missingWords.replace(/","/g, '",\n"')
        return missingWords
      }

      /**
       * Passes through the UI (DOM elements) and translates all of the text for the given language.
       *
       * It is important to note that if you are dynamically creating UI content and adding it to the DOM after you have set the language,
       * you must either call this function again after the new content is added,
       * or ensure your code explicitly translates the new content using {@link CIQ.translatableTextNode} or {@link CIQ.ChartEngine#translateIf}.
       *
       * @param {string} [language] language. Defaults to CIQ.I18N.language.
       * @param {HTMLElement} [root] root for the TreeWalker to prevent the entire page from being translated.  If omitted, document.body assumed.
       * @memberOf CIQ.I18N
       * @since 4.0.0 Language code for Portuguese is "pt" (formerly "pu"; maintained for backwards compatibility)
       */
      CIQ.I18N.translateUI = function(language, root) {
        if (language == 'pu') language = 'pt' // backward compatibility.
        if (!CIQ.I18N.wordLists) return
        if (!language) language = CIQ.I18N.language
        var wordsInUI = CIQ.I18N.findAllTextNodes(root)
        var languageWordList = CIQ.I18N.wordLists[language]
        if (!languageWordList) return

        for (var word in wordsInUI) {
          var translation = CIQ.I18N.translateSections(word, languageWordList)
          var nodes = wordsInUI[word]
          for (var i = 0; i < nodes.length; i++) {
            var node = nodes[i],
              parentNode = node.parentNode,
              originalText = parentNode.getAttribute('original')
            // Two scenarios where we don't want to use translation, when undefined or word is not in the translation files
            if (translation === ',' || !translation) translation = originalText
            var elemWithPlaceholder = parentNode.placeholderFor
            if (elemWithPlaceholder) {
              elemWithPlaceholder.placeholder = translation
            } else {
              node.data = translation
            }
          }
        }
      }

      /**
       * Translates an individual word for a given language. Set stxx.translationCallback to this function
       * in order to automatically translate all textual elements on the chart itself.
       * @param {string} word The word to translate
       * @param {string} [language] language. Defaults to CIQ.I18N.language.
       * @return {string} Translation of the given word, or the word itself if no translation was found.
       * @memberOf CIQ.I18N
       */
      CIQ.I18N.translate = function(word, language) {
        if (!language) language = CIQ.I18N.language
        if (!CIQ.I18N.wordLists) {
          console.log(
            'Must include translations.js in order to use CIQ.I18N.translate()'
          )
          return word
        }
        var languageWordList = CIQ.I18N.wordLists[language]
        var translation = null
        if (languageWordList)
          translation =
            CIQ.I18N.translateSections(word, languageWordList) || word
        // Lastly check and see if the translation is blank in the CSV source (no translation for given language) which is parsed as ',' and if so fall back to English default
        return translation === ',' ? word : translation
      }

      /**
       * Translates a phrase which may have untranslatable parts (like a study id).
       * The translatable pieces are delimited left and right with a non-printable character Zero-Width-Non_Joiner.
       * @param {string} word The word to translate
       * @param {object} [languageWordList] Map of words and translations in the desired language
       * @return {string} Translation of the given phrase
       * @memberOf CIQ.I18N
       * @since 4.0.0
       */
      CIQ.I18N.translateSections = function(word, languageWordList) {
        // Test here for word phrases, delimited by the zero-width-non-breaking character
        // we'll split the text into pieces, filtering out the parentheses and commas to generate phrases
        var zwnb = '\u200c' // https://en.wikipedia.org/wiki/Zero-width_non-joiner
        if (typeof word == 'string' && word.indexOf(zwnb) != -1) {
          word = word.replace(/([(),])/g, zwnb + '$1' + zwnb)
          var sections = word.split(zwnb)
          sections.forEach(function(val, i, arr) {
            var padding = val.match(/^(\s*).*\S(\s*)$/)
            var translation = languageWordList[val.trim()]
            if (translation) {
              if (padding) translation = padding[1] + translation + padding[2]
              arr[i] = translation
            }
          })
          return sections.join('')
        }
        return languageWordList[word]
      }

      /**
	 * Converts a 'CSV formatted' string of translations into the required JSON format and set to {@link CIQ.I18N.wordLists}
	 * You can output {@link CIQ.I18N.wordLists} to the console and paste back in if desired.
	 * @param {string} [csv] Translation spreadsheet in csv format **as a single long string**.
	 * Make sure there are no leading tabs, trailing commas or spaces.
	 * Assumes that the header row of the CSV is the language codes and that the first column is the key language (English).
	 * Assumes non-quoted words, data is comma delimited and lines separated by '\n'. Default is CIQ.I18N.csv
	 * @memberOf CIQ.I18N
	 * @example
var csv="en,ar,fr,de,hu,it,pt,ru,es,zh,ja\nChart,الرسم البياني,Graphique,Darstellung,Diagram,Grafico,Gráfico,График,Gráfica,图表,チャート\nChart Style,أسلوب الرسم البياني,Style de graphique,Darstellungsstil,Diagram stílusa,Stile grafico,Estilo do gráfico,Тип графика,Estilo de gráfica,图表类型,チャート形式\nCandle,الشموع,Bougie,Kerze,Gyertya,Candela,Vela,Свеча,Vela,蜡烛,ローソク足\nShape,شكل,Forme,Form,Alak,Forma,Forma,Форма,Forma,形状,パターン";
CIQ.I18N.convertCSV(csv);
	 */
      CIQ.I18N.convertCSV = function(csv) {
        var curly = new RegExp('[\u201C\u201D]|[\u2018\u2019]', 'g')
        var quotation = new RegExp('^("+)|("(?="))', 'g')
        var wordLists = CIQ.I18N.wordLists
        if (!csv) csv = CIQ.I18N.csv
        var lines = csv.split('\n')
        var headerRow = lines[0]
        var languages = headerRow.split(',')
        for (var j = 0; j < languages.length; j++) {
          var lang = languages[j]
          if (!wordLists[lang]) {
            wordLists[lang] = {}
          }
        }
        for (var i = 1; i < lines.length; i++) {
          var words =
            lines[i].match(/(".*?"|[^",]+)(?=\s*,|\s*$)|(,(?=,))/g) || []
          var key = words[0]
          if (quotation.test(key)) key = key.replace(quotation, '')
          if (curly.test(key)) key = key.replace(curly, '"')
          for (var k = 1; k < words.length; k++) {
            var word = words[k]
            if (quotation.test(word)) word = word.replace(quotation, '')
            wordLists[languages[k]][key] = word
          }
        }
      }

      /**
       * Convenience function to set up translation services for a chart and its surrounding GUI.
       * It automatically sets CIQ.I18N.language, loads all translations and translates the chart.
       *
       * Uses/sets (in execution order):
       *  - {@link CIQ.I18N.convertCSV}
       *  - {@link CIQ.I18N.language}
       *  - {@link CIQ.I18N.translateUI}
       *  - {@link CIQ.I18N.translate}
       *
       * Feel free to create your own convenience function if required to explicitly set CIQ.I18N.wordLists instead of using the CIQ.I18N.hereDoc copy-paste spreadsheet in `translations.js`.
       *
       * It is important to note that if you are dynamically creating UI content and adding it to the DOM after you have set the language,
       * you must either call {@link CIQ.I18N.translateUI} after the new content is added,
       * or ensure your code explicitly translates the new content using {@link CIQ.translatableTextNode} or {@link CIQ.ChartEngine#translateIf}.
       *
       * @param {CIQ.ChartEngine} stx A chart object
       * @param {string} language  A language in your CSV file. For instance 'en' from CIQ.I18N.csv
       * @param {string} [translationCallback]  Function to perform Canvas Built-in word translations . Default is CIQ.I18N.translate
       * @param {string} [csv] Translation spreadsheet in csv format **as a single long string**. Make sure no leading tabs, trailing commas or spaces. Default is CIQ.I18N.csv. See {@link CIQ.I18N.convertCSV} for format sample
       * @param {HTMLElement} [root] root for the TreeWalker to prevent the entire page from being translated.  If omitted, document.body assumed.
       * @memberOf CIQ.I18N
       * @since 04-2015
       * <br>&bull; 3.0.0 'root' parameter added.
       * <br>&bull; 4.0.0 Language code for Portuguese is "pt" (formerly "pu"; maintained for backwards compatibility)
       */
      CIQ.I18N.setLanguage = function(
        stx,
        language,
        translationCallback,
        csv,
        root
      ) {
        if (language == 'pu') language = 'pt' // backward compatibility.
        CIQ.I18N.convertCSV(csv)
        CIQ.I18N.language = language
        CIQ.I18N.translateUI(language, root)
        if (!translationCallback) translationCallback = CIQ.I18N.translate
        stx.translationCallback = translationCallback
      }

      /**
	 * This method will set the chart locale using Intl natively or for unsupported browsers dynamically loads the locale using JSONP.
	 * Once the locale is loaded then the chart widget itself is updated for that locale. Use this function when a user can select a locale dynamically so as to avoid
	 * having to include specific locale entries as `script` tags.
	 * The optional callback will be called when the locale has been set.
	 * The Intl library includes JSONP for each locale. A zip of these locales can be requested and should be placed in the locale-data directory of your server.
	 *
	 * Localization formatting is done by {@link CIQ.ChartEngine#setLocale} and can be overwritten as outlined on the example.
	 * @param {CIQ.ChartEngine} stx A chart object
	 * @param {string} locale A valid locale, for instance en-IN
	 * @param {Function} [cb] Callback when locale has been loaded. This function will be passed an error message if it cannot be loaded.
	 * @param {string} [url] url for where to fetch the jsonp data. Defaults to "locale-data/jsonp"
	 * @param {number} [maxDecimals] maximum number of decimal places to allow on number conversions. Defaults to 5. See {@link CIQ.ChartEngine#setLocale} for more details.
	 * @since 3.0.0 maxDecimals was added to the signature
	 * @memberOf CIQ.I18N
	 * @example
	 * CIQ.I18N.setLocale(stxx, "zh");	// set localization services -- before any UI or chart initialization is done
	 * // override time formatting to enable 12 hour clock (hour12:true)
	 * stxx.internationalizer.hourMinute=new Intl.DateTimeFormat(this.locale, {hour:"numeric", minute:"numeric", hour12:true});
	 * stxx.internationalizer.hourMinuteSecond=new Intl.DateTimeFormat(this.locale, {hour:"numeric", minute:"numeric", second:"numeric", hour12:true});

	 */
      CIQ.I18N.setLocale = function(stx, locale, cb, url, maxDecimals) {
        if (!Intl.__addLocaleData) {
          // Intl built into browser
          stx.setLocale(locale, maxDecimals)
          if (cb) cb(null)
          return
        }
        url = typeof url == 'undefined' ? 'locale-data/jsonp' : url
        var localeFileURL = url + '/' + locale + '.js'
        var script = document.createElement('SCRIPT')
        script.async = true
        script.src = localeFileURL
        var s = document.getElementsByTagName('script')[0]
        s.parentNode.insertBefore(script, s.nextSibling)
        script.onload = function() {
          stx.setLocale(locale, maxDecimals)
          if (cb) cb(null)
        }
        script.onerror = function() {
          if (cb) cb('cannot load script')
        }
      }

      /**
       * Extract the name of the month from the locale. We do this by creating a
       * localized date for the first date of each month. Then we extract the alphabetic characters.
       * MonthLetters then becomes the first letter of the month. Note that in the current Intl.js locale, chinese and
       * japanese months are implemented as 1月 through 12月 which causes this algorithm to fail. Hopefully real months
       * will be available when Intl becomes a browser standard, otherwise this method or the locale will need to
       * be modified for those or other special cases. The arrays are stored in stx.monthAbv and stx.monthLetters which
       * will then override the global arrays CIQ.monthAbv and CIQ.monthLetters.
       * @param  {CIQ.ChartEngine} stx       Chart object
       * @param  {object} formatter An Intl compatible date formatter
       * @param  {string} locale    A valid Intl locale, such as en-IN
       * @memberOf CIQ.I18N
       */
      CIQ.I18N.createMonthArrays = function(stx, formatter, locale) {
        stx.monthAbv = []
        stx.monthLetters = []
        var dt = new Date()
        var shortenMonth = true
        if (CIQ.I18N.longMonths && CIQ.I18N.longMonths[locale])
          shortenMonth = false
        for (var i = 0; i < 12; i++) {
          dt.setDate(1)
          dt.setMonth(i)
          var str = formatter.format(dt)
          if (shortenMonth) {
            var month = ''
            for (var j = 0; j < str.length; j++) {
              var c = str.charAt(j)
              var cc = c.charCodeAt(0)
              if (cc < 65) continue
              month += c
            }
            stx.monthAbv[i] = month
            stx.monthLetters[i] = month[0]
          } else {
            stx.monthAbv[i] = str
            stx.monthLetters[i] = str
          }
        }
      }

      /**
	 * A convenience function that sets locale and language at once and checks to see if candle colors should be reversed.
 	 * Each of these grouped functions are called with default arguments. If you require custom parameters you will need to call each separately.
 	 *
 	 * {@link CIQ.I18N.reverseColorsByLocale}  is used to determine if the colors should be reversed.
 	 *
 	 * It is important to note that if you are dynamically creating UI content and adding it to the DOM after you have set the language,
	 * you must either call {@link CIQ.I18N.translateUI} after the new content is added,
	 * or ensure your code explicitly translates the new content using {@link CIQ.translatableTextNode} or {@link CIQ.ChartEngine#translateIf}.
 	 *
 	 * Functions are called in the following order:
 	 * - {@link CIQ.I18N.setLocale}
	 * - {@link CIQ.I18N.setLanguage}
	 * - {@link CIQ.I18N.reverseCandles} - Called only if colors need to be reversed.
 	 *
	 * @param {CIQ.ChartEngine} stx Chart object
	 * @param  {string} locale    A valid Intl locale, such as en-IN
	 * @memberOf CIQ.I18N
	 * @since 4.0.0
	 * @example
	 * CIQ.I18N.localize(stxx, "zh");	// set translation and localization services -- before any UI or chart initialization is done
	 * // override time formatting to enable 12 hour clock (hour12:true)
	 * stxx.internationalizer.hourMinute=new Intl.DateTimeFormat(this.locale, {hour:"numeric", minute:"numeric", hour12:true});
	 * stxx.internationalizer.hourMinuteSecond=new Intl.DateTimeFormat(this.locale, {hour:"numeric", minute:"numeric", second:"numeric", hour12:true});

	 */
      CIQ.I18N.localize = function(stx, locale) {
        var prevLocale = stx.locale // checks to see if we're switching from a locale with reversed candles
        var reverseLocale = this.reverseColorsByLocale[locale]
        var reversePrevLocale = this.reverseColorsByLocale[prevLocale]
        this.setLocale(stx, locale)
        this.setLanguage(stx, locale)
        if (reverseLocale && reversePrevLocale) return
        if (reverseLocale || reversePrevLocale) this.reverseCandles(stx)
      }

      /**
       * Some locales prefer candle colors reversed. This will reverse candle colors without changing CSS.
       * @param {CIQ.ChartEngine} stx Chart object
       * @memberOf CIQ.I18N
       * @since 4.0.0
       */
      CIQ.I18N.reverseCandles = function(stx) {
        var styles = stx.styles
        var candleDown = stx.cloneStyle(styles.stx_candle_down)
        var candleUp = stx.cloneStyle(styles.stx_candle_up)
        styles.stx_candle_up = candleDown
        styles.stx_candle_down = candleUp
      }

      return _exports
    }

  var __markers_ =
    //-------------------------------------------------------------------------------------------
    // Copyright 2012-2017 by ChartIQ, Inc.
    // All rights reserved
    //-------------------------------------------------------------------------------------------
    function(_exports) {
      var CIQ = _exports.CIQ

      /**
       * The markerHelper is a private object that we use for placeholder values, primarily as a performance aid
       * @private
       * @memberOf CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.makeMarkerHelper = function() {
        this.markerHelper = {
          chartMap: {},
          classMap: {},
        }
      }

      /**
       * Adds a marker to the chart
       * @private
       * @memberOf CIQ.ChartEngine
       * @param {CIQ.Marker} marker The marker to add
       */
      CIQ.ChartEngine.prototype.addToHolder = function(marker) {
        var panel = this.panels[marker.params.panelName]
        if (!panel) return

        // Switcheroo. If a NodeCreator is passed in, then we change the marker
        // to reference the actual DOM node and then we add stxNodeCreator to the
        // marker so that we can reference it if need be
        if (CIQ.derivedFrom(marker.params.node, CIQ.Marker.NodeCreator)) {
          marker.stxNodeCreator = marker.params.node
          marker.node = marker.stxNodeCreator.node
        } else {
          marker.node = marker.params.node
        }

        if (!this.markerHelper) this.makeMarkerHelper()

        if (marker.params.chartContainer) {
          this.container.appendChild(marker.node)
        } else if (marker.params.includeAxis) {
          panel.holder.appendChild(marker.node)
        } else {
          panel.subholder.appendChild(marker.node)
        }

        var label = marker.params.label
        if (!this.markers[label]) this.markers[label] = []
        this.markers[label].push(marker)

        marker.chart = panel.chart

        // Put it in the map of charts
        if (!this.markerHelper.chartMap[marker.chart.name]) {
          this.markerHelper.chartMap[marker.chart.name] = {
            dataSetLength: 0,
            markers: [],
          }
        }
        this.markerHelper.chartMap[marker.chart.name].markers.push(marker)

        // Put it in the map of placement functions
        if (!marker.className) {
          console.log('Marker objects must have a member className')
        }
        var classMap = this.markerHelper.classMap[marker.className]
        if (!classMap)
          classMap = this.markerHelper.classMap[marker.className] = {}
        if (!classMap[marker.params.panelName])
          classMap[marker.params.panelName] = []
        classMap[marker.params.panelName].push(marker)

        this.setMarkerTick(marker)
      }

      /**
       * Gets an array of markers
       * @private
       * @param {string} type The type of comparison "panelName","label","all"
       * @param {string} comparison The value to compare to
       * @return {array} The marker array
       */
      CIQ.ChartEngine.prototype.getMarkerArray = function(type, comparison) {
        var arr = []
        for (var label in this.markers) {
          for (var i = 0; i < this.markers[label].length; i++) {
            var marker = this.markers[label][i]
            if (type == 'panelName') {
              if (marker.params.panelName == comparison) arr.push(marker)
            } else if (type == 'label') {
              if (label == comparison) arr.push(marker)
            } else if (type == 'all') {
              arr.push(marker)
            }
          }
        }
        return arr
      }
      /**
       * Removes the marker from the chart
       * @private
       * @param  {CIQ.Marker} marker The marker to remove
       * @memberOf CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.removeFromHolder = function(marker) {
        var panel = this.panels[marker.params.panelName]
        if (panel) {
          if (marker.node.parentNode == panel.holder)
            panel.holder.removeChild(marker.node)
          else if (marker.node.parentNode == panel.subholder)
            panel.subholder.removeChild(marker.node)
          else if (marker.node.parentNode == this.container)
            this.container.removeChild(marker.node)
        }
        // Remove from label map
        var labels = this.markers[marker.params.label]
        if (!labels) return
        var i
        for (i = 0; i < labels.length; i++) {
          if (labels[i] === marker) {
            labels.splice(i, 1)
            break
          }
        }

        // remove from chart map
        var chartMap = this.markerHelper.chartMap[marker.chart.name]
        if (chartMap) {
          for (i = 0; i < chartMap.markers.length; i++) {
            if (chartMap.markers[i] === marker) {
              chartMap.markers.splice(i, 1)
              break
            }
          }
        }

        // remove from class map
        var classMap = this.markerHelper.classMap[marker.className]
        if (classMap) {
          var panelArray = classMap[marker.params.panelName]
          if (panelArray) {
            for (i = 0; i < panelArray.length; i++) {
              if (panelArray[i] === marker) {
                panelArray.splice(i, 1)
                break
              }
            }
          }
        }
      }

      /**
       * Moves the markers from one panel to another
       * Useful when renaming panels
       * @param  {string} fromPanelName The panel to move markers from
       * @param  {string} toPanelName The panel to move markers to
       * @memberOf CIQ.ChartEngine
       * @since 2016-07-16
       */
      CIQ.ChartEngine.prototype.moveMarkers = function(
        fromPanelName,
        toPanelName
      ) {
        var arr = this.getMarkerArray('panelName', fromPanelName)
        for (var i = 0; i < arr.length; i++) {
          arr[i].params.panelName = toPanelName
        }
        for (var className in this.markerHelper.classMap) {
          var tmp = this.markerHelper.classMap[className][fromPanelName]
          if (tmp) {
            this.markerHelper.classMap[className][toPanelName] = tmp
            delete this.markerHelper.classMap[className][fromPanelName]
          }
        }
      }

      /**
       * Establishes the tick value for any markers that have a "date" specified. It tries to be efficient, not recalculating
       * unless the size of the dataSet for a chart has actually changed
       * @private
       * @memberOf CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.establishMarkerTicks = function() {
        if (!this.markerHelper) this.makeMarkerHelper()
        var chartMap = this.markerHelper.chartMap
        for (var chart in chartMap) {
          var chartEntry = chartMap[chart]
          if (chartEntry.dataSetLength == this.charts[chart].dataSet.length)
            continue
          for (var i = 0; i < chartEntry.markers.length; i++) {
            this.setMarkerTick(chartEntry.markers[i])
          }
        }
      }

      /**
       * Figures out the position of a future marker but only if it is displayed on the screen.
       * @param  {CIQ.Marker} marker The marker to check
       * @memberOf CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.futureTickIfDisplayed = function(marker) {
        var chart = marker.chart
        if (chart.dataSet.length < 1) return
        var xaxisDT = chart.xaxis[chart.xaxis.length - 1].DT

        xaxisDT = new Date(xaxisDT.getTime() - this.timeZoneOffset * 60000)
        if (marker.params.x > xaxisDT) return // not displayed on screen yet

        // It should be displayed on the screen now so find the exact tick
        var futureTicksOnScreen = chart.maxTicks - chart.dataSegment.length
        var ticksToSearch = chart.dataSet.length + futureTicksOnScreen
        var pms, qms
        var dt = new Date(+chart.dataSet[chart.dataSet.length - 1].DT)

        var iter = this.standardMarketIterator(dt, null, chart)

        var dms = marker.params.x.getTime()
        for (var j = chart.dataSet.length; j < ticksToSearch; j++) {
          pms = dt.getTime()
          dt = iter.next()
          qms = dt.getTime()
          // If the event lands on that day, or if the event landed between bars
          if (qms == dms) {
            marker.tick = j
            return
          } else if (qms > dms && pms < dms) {
            marker.tick = Math.max(j - 1, 0)
            return
          }
        }
      }

      /**
       * Establishes the tick value for the specified marker. We do this to avoid calculating the date every time we want
       * to place the marker. Converting date to tick is a very expensive operation!
       * @param {CIQ.Marker} marker The marker for which to establish the tick
       * @private
       * @memberOf CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.setMarkerTick = function(marker) {
        var chart = marker.chart
        if (marker.params.xPositioner == 'master' && marker.params.x) {
          marker.tick = Math.floor(marker.params.x / this.layout.periodicity)
          return
        } else if (marker.params.xPositioner == 'date' && marker.params.x) {
          var pms, qms
          // TODO, use binary search for finding date
          var dms = marker.params.x.getTime()
          for (var i = 0; i < chart.dataSet.length; i++) {
            var quotes = chart.dataSet[i]
            qms = quotes.DT.getTime()
            pms = qms
            if (i > 0) pms = chart.dataSet[i - 1].DT.getTime()
            // If the event lands on that day, or if the event landed between bars
            if (qms == dms) {
              marker.tick = i
              return
            } else if (qms > dms && pms < dms) {
              marker.tick = Math.max(i - 1, 0)
              return
            } else if (dms < qms) {
              marker.tick = null
              // marker date is in distant past, shortcircuit the logic for performance.
              return
            }
          }
          if (chart.dataSet.length < 1) return
          var dt = new Date(+chart.dataSet[i - 1].DT)
          if (dt.getTime() < dms) marker.params.future = true
          marker.tick = null // reset in case we had figured it out with an earlier dataset
        }
      }

      /**
       * <span class="injection">INJECTABLE</span>
       * @memberOf CIQ.ChartEngine.AdvancedInjectable#
       * @alias positionMarkers
       */
      CIQ.ChartEngine.prototype.positionMarkers = function() {
        var self = this
        if (!self.markerHelper) return

        function draw() {
          if (self.runPrepend('positionMarkers', arguments)) return
          self.markerTimeout = null
          for (var className in self.markerHelper.classMap) {
            for (var panelName in self.markerHelper.classMap[className]) {
              var arr = self.markerHelper.classMap[className][panelName]
              var panel = self.panels[panelName]
              if (arr.length) {
                var params = {
                  stx: self,
                  arr: arr,
                  panel: panel,
                }
                params.firstTick =
                  panel.chart.dataSet.length - panel.chart.scroll
                params.lastTick =
                  params.firstTick + panel.chart.dataSegment.length

                var fn = arr[0].constructor.placementFunction // Some magic, this gets the static member "placementFunction" of the class (not the instance)
                if (fn) {
                  fn(params)
                } else {
                  self.defaultMarkerPlacement(params)
                }
              }
            }
          }
          self.runAppend('positionMarkers', arguments)
        }

        if (this.markerDelay || this.markerDelay === 0) {
          if (!this.markerTimeout)
            this.markerTimeout = setTimeout(draw, this.markerDelay)
        } else {
          draw()
        }
      }

      /**
       * A marker is a DOM object that is managed by the chart. Makers are placed in "holders" which are
       * DIV elements whose placement and size corresponds with a panel on the chart.
       * A holder exists for each panel.
       * Markers are placed by date, tick or bar to control their position on the x-axis.
       * They are placed by value (price) to control their position on the y-axis.
       * Markers will be repositioned when the user scrolls or zooms the chart.
       *
       * The default placement function for any markers is {@link CIQ.ChartEngine#defaultMarkerPlacement}, but custom placement functions can be created as needed.
       *
       * If markers must be part of an exported image generated using the {@link CIQ.Share} plug-in, you need to draw them on the actual canvas instead using [Canvas Markers](tutorial-Popular%20API%20Injections.html#marker).
       *
       * See {@tutorial Markers} tutorials for additional implementation instructions.
       *
       * @name CIQ.Marker
       * @param {Object} params Parameters that describe the marker
       * @param {CIQ.ChartEngine} params.stx The chart to attach the marker
       * @param {*} params.x A valid date, date string, tick or bar (depending on selected xPositioner) to select a candle to attach to.
       * @param {Number} params.y A valid value for positioning on the y-axis (depending on selected yPositioner, if missing the marker will be set "above_candle" as long as a valid candle is selected by `params.x`)
       * @param {HTMLElement} [params.node] The HTML element. This should be detached from the DOM! If none passed then a blank div will be created.
       * @param {string} params.panelName="chart" The name of the panel to attach the holder. Defaults to the main chart panel.
       * @param {string} [params.xPositioner="date"] Determines the x position.
       * Values are:
       * - "date" (`params.x` must be set to a JavaScript date)
       * - "master" (`params.x` must be set to a masterData position)
       * - "bar" (`params.x` must be set to a dataSegment position)
       * - "none" (use CSS positioning, `params.x` will not be used)
       * @param {string} [params.yPositioner="value"] Determines the y position.
       * Values are:
       * - "value" (`params.y` must be set to an exact y axis value.  If `params.y` is omitted, the y position will default to above_candle)
       * - "above_candle" (right above the candle or line. If more than one on same position, they will align upwards from the first. `params.y` will not be used)
       * - "under_candle" (right under the candle or line. If more than one on same position, they will align downwards from the first. `params.y` will not be used)
       * - "on_candle" (in the center or the candle or line - covering it. If more than one on same position, they will align downwards from the first. `params.y` will not be used)
       * - "top" (on top of the chart, right under the margin. If more than one on same position, they will align downwards from the first. `params.y` will not be used)
       * - "bottom" ( on the bottom of the chart, right over the margin. If more than one on same position, they will align upwards from the first. `params.y` will not be used)
       * - "none" (use CSS positioning. `params.y` will not be used)
       * @param {boolean} [params.permanent=false] Stays on the chart even when chart is re-initialized (symbol change, newChart(), initializeChart())
       * @param {string} [params.label="generic"] A label for the marker. Multiple markers can be assigned the same label. This allows them to be deleted in one fell swoop.
       * @param {boolean} [params.includeAxis=false] If true then the marker can display on the x or y axis. Otherwise it will be cropped at the axis edges.
       * @param {Boolean} [params.chartContainer] If true then the marker will be put directly in the chart container as opposed to in a holder. When placing
       * markers directly in the chart container, the z-index setting for the marker should be set vis a vis the z-index of the holders in order to place
       * the markers below or above those inside the holders.
       * @constructor
       * @since
       * <br> 15-07-01 Class added
       * <br> 05-2016-10 It now takes the following `params.yPositioner` values: "value", "above_candle", "under_candle","on_candle","top","bottom"
       * @version ChartIQ Advanced Package
       * @example
       * new CIQ.Marker({
       * 	stx: stxx,
       * 	xPositioner: "date",
       *  yPositioner: "value",
       * 	x: someDate,
       * 	label: "events",
       * 	node: newNode
       * });
       */
      CIQ.Marker = function(params) {
        this.params = {
          xPositioner: 'date',
          yPositioner: 'value',
          panelName: 'chart',
          permanent: false,
          label: 'generic',
          includeAxis: false,
        }
        CIQ.extend(this.params, params)
        if (!this.params.node) {
          this.params.node = document.createElement('DIV')
        }
        if (!this.params.stx) {
          console.log('Marker created without specifying stx')
          return
        }
        if (!this.className) this.className = 'CIQ.Marker'
        this.params.stx.addToHolder(this)
      }

      /**
       * Removes the marker from the chart object
       * @memberOf CIQ.Marker
       * @since  15-07-01
       */
      CIQ.Marker.prototype.remove = function() {
        this.params.stx.removeFromHolder(this)
      }

      /**
       * Normally the chart will take care of positioning the marker automatically but you can
       * force a marker to render itself by calling this method. This will cause the marker to
       * call it's placement function. You might want to do this for instance if your marker morphs
       * or changes position outside of the animation loop.
       */
      CIQ.Marker.prototype.render = function() {
        var arr = [this]
        var params = {
          stx: this.params.stx,
          arr: arr,
          panel: this.params.stx.panels[this.params.panelName],
          showClass: this.showClass,
        }
        this.constructor.placementFunction(params)
      }

      /**
       * Removes all markers with the specified label from the chart object
       * @param  {CIQ.ChartEngine} stx   The chart object
       * @param  {string} label The label
       * @memberOf CIQ.Marker
       * @since  15-07-01
       */
      CIQ.Marker.removeByLabel = function(stx, label) {
        var arr = stx.getMarkerArray('label', label)
        for (var i = 0; i < arr.length; i++) stx.removeFromHolder(arr[i])
      }

      /**
       *
       * Content positioner for any markers using the 'stx-marker-expand' class,
       * this will consider the marker node's loction within its container and determine where to
       * place the content, be it to the left or right/top or bottom of the marker node (so it is all showing)
       * @memberOf CIQ.Marker
       * @param {HTMLElement} node The HTML element representing the marker which has content
       * @since 5.1.2
       */
      CIQ.Marker.positionContentVerticalAndHorizontal = function(node) {
        var content_node = node.querySelectorAll('.stx-marker-expand')[0]
        if (content_node) {
          var offsetWidth = content_node.offsetWidth,
            offsetHeight = content_node.offsetHeight
          if (!offsetWidth || !offsetHeight) return

          var nodeStyle = content_node.style
          nodeStyle.left = nodeStyle.right = '' // reset content to right of node
          nodeStyle.bottom = nodeStyle.top = '' // reset content to bottom of node

          var contentLeft = getComputedStyle(content_node).left
          var contentBottom = getComputedStyle(content_node).bottom
          var contentHeight = getComputedStyle(content_node).height

          var leftPxOfContent = node.offsetLeft + parseInt(contentLeft, 10)
          var bottomContentInt = parseInt(contentBottom, 10)
          var heightInt = parseInt(contentHeight, 10)
          var topPxOfContent = node.offsetTop + bottomContentInt - heightInt

          var offsetMaxWidth = node.parentNode.offsetWidth
          var offsetMaxHeight = node.parentNode.offsetHeight

          //switch content to left of node if node is off the left of the chart or content will not fit to the right of the node
          if (leftPxOfContent + offsetWidth > offsetMaxWidth) {
            nodeStyle.right = contentLeft
            nodeStyle.left = 'auto'
          }

          if (node.offsetTop - heightInt < offsetMaxHeight) {
            //node not off the top of the chart
            //switch content to the bottom of the node if node is off the top of the chart
            if (node.offsetTop - node.offsetHeight < 0) {
              nodeStyle.top = contentBottom
              nodeStyle.bottom = 'auto'
            } else if (topPxOfContent + offsetHeight > offsetMaxHeight) {
              //switch content to top of node if node is off the top of the chart
              nodeStyle.top = 'auto'
              //Since the "middle" placement has a bottom content of 30px, if we want to move above the marker
              //we have to make this number larger than the default (otherwise it'll be back in the middle)
              nodeStyle.bottom = bottomContentInt * 3 + 'px'
            }
          }
        }
      }

      /**
       * The above_candle and below_candle y-positioner will usually use the high and low to place the marker.
       * However, some chart renderings will draw the extent of the bar either inside or outside the high/low range.
       * For those chart types, this function will return the actual high/low to be used by the marker placement function.
       * This is only valid when {@link CIQ.Renderer#highLowBars} is true.
       * Currently this function will handle p&f and histogram chart types.
       * For any other chart type, define "markerHigh" and "markerLow" for each bar in the dataSet/dataSegment
       * and these will be honored and returned.
       * Note: This function may be used with any markerPlacement function to give the lowest and highest point of the bar.
       *
       * @memberOf CIQ.ChartEngine
       * @param {Object} quote The bar's data.  This can come from the chart.dataSet
       * @return {Object}        The high and low for the marker
       * @since 3.0.0
       */
      CIQ.ChartEngine.prototype.getBarBounds = function(quote) {
        var type = this.layout.chartType,
          aggregation = this.layout.aggregationType
        var bounds
        if (aggregation == 'pandf')
          bounds = {
            high: Math.max(quote.pfOpen, quote.pfClose),
            low: Math.min(quote.pfOpen, quote.pfClose),
          }
        else bounds = { high: quote.High, low: quote.Low }
        if (quote.markerHigh) bounds.high = markerHigh
        if (quote.markerLow) bounds.low = markerLow
        return bounds
      }

      /**
       * Placement functions are responsible for positioning markers in their holder according to each marker's settings.
       * They are called directly form the draw() function in the animation loop.
       * Each Marker placement handler must have a corresponding `placementFunction` or this method will be used.
       *
       * `firstTick` and `lastTick` can be used as a hint as to whether to display a marker or not.
       *
       * See {@link CIQ.Marker} and {@tutorial Markers} for more details
       * @memberOf CIQ.ChartEngine
       * @param {Object} params The parameters
       * @param {Array} params.arr The array of markers
       * @param {Object} params.panel The panel to display
       * @param {Number} params.firstTick The first tick displayed on the screen
       * @param {Number} params.lastTick The last tick displayed on the screen
       * @since
       * <br> 2015-09-01 On prior versions you must define your own default function. Example: CIQ.ChartEngine.prototype.defaultMarkerPlacement = yourPlacementFunction;
       */
      CIQ.ChartEngine.prototype.defaultMarkerPlacement = function(params) {
        var panel = params.panel
        var yAxis = params.yAxis ? params.yAxis : params.panel.yAxis
        var chart = panel.chart
        var stx = params.stx

        var showsHighs =
          stx.chart.highLowBars || stx.highLowBars[stx.layout.chartType]
        var plotField = chart.defaultPlotField
        if (!plotField || showsHighs) plotField = 'Close'

        var placementMap = {}

        for (var i = 0; i < params.arr.length; i++) {
          var marker = params.arr[i],
            mparams = marker.params
          var node = marker.node
          // Getting clientWidth and clientHeight is a very expensive operation
          // so we'll cache the results. Don't use this function if your markers change
          // shape or size dynamically!
          if (!marker.clientWidth) marker.clientWidth = node.clientWidth
          if (!marker.clientHeight) marker.clientHeight = node.clientHeight
          var quote = null

          // X axis positioning logic

          var xPositioner = mparams.xPositioner,
            yPositioner = mparams.yPositioner,
            tick = marker.tick,
            dataSet = chart.dataSet,
            clientWidth = marker.clientWidth
          if (xPositioner != 'none') {
            if (xPositioner == 'bar' && mparams.x) {
              if (mparams.x < chart.xaxis.length) {
                var xaxis = chart.xaxis[mparams.x]
                if (xaxis) quote = xaxis.data
              }
              node.style.left =
                Math.round(
                  stx.pixelFromBar(mparams.x, chart) - clientWidth / 2
                ) +
                1 +
                'px'
            } else {
              // This is a section of code to hide markers if they are off screen, and also to figure out
              // the position of markers "just in time"
              // the tick is conditionally pre-set by CIQ.ChartEngine.prototype.setMarkerTick depending on marker.params.xPositioner
              if (!tick && tick !== 0) {
                // if tick is not defined then hide, probably in distant past
                if (mparams.future && chart.scroll < chart.maxTicks) {
                  // In future
                  stx.futureTickIfDisplayed(marker) // Just in time check for tick
                  tick = marker.tick //copy new tick from prior function
                  if (!tick && tick !== 0) {
                    node.style.left = '-1000px'
                    continue
                  }
                } else {
                  node.style.left = '-1000px'
                  continue
                }
              }
              if (tick < dataSet.length) quote = dataSet[tick]
              marker.leftpx = Math.round(
                stx.pixelFromTick(tick, chart) - chart.left - clientWidth / 2
              )
              marker.rightEdge = marker.leftpx + clientWidth
              if (tick < params.firstTick && marker.rightEdge < chart.left - 50)
                continue // off screen, no need to reposition the marker (accounting 50px for any visual effects)
              node.style.left = marker.leftpx + 'px'
            }
            if (!quote) quote = dataSet[dataSet.length - 1] // Future ticks based off the value of the current quote
          } else if (yPositioner.indexOf('candle') > -1) {
            // candle positioning, find the quote
            left = getComputedStyle(node).left
            if (left) {
              var bar = stx.barFromPixel(parseInt(left, 10), chart)
              if (bar >= 0) {
                quote = chart.xaxis[bar].data
                if (!quote) quote = dataSet[dataSet.length - 1] // Future ticks based off the value of the current quote
              }
            }
          }

          // Y axis positioning logic
          var y = mparams.y,
            clientHeight = node.clientHeight,
            val
          if (yPositioner != 'none') {
            var height = mparams.chartContainer
              ? stx.height
              : panel.yAxis.bottom
            var bottom = 0,
              bottomAdjust = 0
            if (typeof placementMap[node.style.left] == 'undefined') {
              placementMap[node.style.left] = 0
            }
            bottomAdjust = placementMap[node.style.left]
            placementMap[node.style.left] += clientHeight

            if (yPositioner == 'value' && y) {
              bottom =
                Math.round(
                  height -
                    stx.pixelFromPrice(y, panel, yAxis) -
                    clientHeight / 2
                ) + 'px'
            } else if (yPositioner == 'under_candle' && quote) {
              val = quote[plotField]
              if (showsHighs) val = stx.getBarBounds(quote).low
              bottom =
                Math.round(
                  height -
                    stx.pixelFromPrice(val, panel, yAxis) -
                    clientHeight -
                    bottomAdjust
                ) + 'px'
            } else if (yPositioner == 'on_candle' && quote) {
              val = quote[plotField]
              if (showsHighs) val = (quote.Low + quote.High) / 2
              bottom =
                Math.round(
                  height -
                    stx.pixelFromPrice(val, panel, yAxis) -
                    clientHeight / 2 -
                    bottomAdjust
                ) + 'px'
            } else if (yPositioner == 'top') {
              bottom = Math.round(height - clientHeight - bottomAdjust) + 'px'
            } else if (yPositioner == 'bottom') {
              bottom = Math.round(bottomAdjust) + 'px'
            } else if (quote) {
              //above_candle
              val = quote[plotField]
              if (showsHighs) val = stx.getBarBounds(quote).high
              bottom =
                Math.round(
                  height - stx.pixelFromPrice(val, panel, yAxis) + bottomAdjust
                ) + 'px'
            }
            if (node.style.bottom != bottom) node.style.bottom = bottom
          }
          CIQ.Marker.positionContentVerticalAndHorizontal(node)
        }
      }

      /**
       * Base class to create an empty marker node that can then be styled. Used by {@link CIQ.Marker.Simple}
       * See {@tutorial Markers} tutorials for additional implementation instructions.
       * @name CIQ.Marker.NodeCreator
       * @constructor
       */
      CIQ.Marker.NodeCreator = function() {}

      CIQ.Marker.NodeCreator.toNode = function() {
        return this.node
      }

      /**
       * Constructor for basic built-in markers.
       * See {@tutorial Markers} tutorials for additional implementation instructions.
       * @name CIQ.Marker.Simple
       * @constructor
       * @param {Object} params Parameters to describe the marker
       * @param {string} params.type The marker type "circle", "square", "callout"
       * @param {string} params.headline The headline text to display
       * @param {string} [params.category] The category "news", "earningsUp", "earningsDown", "dividend", "filing", "split"
       * @param {string} [params.story] The story to display when hovered
       */
      CIQ.Marker.Simple = function(params) {
        var node = (this.node = document.createElement('div'))
        node.className = 'stx-marker'
        CIQ.appendClassName(node, params.type)
        if (params.category) CIQ.appendClassName(node, params.category)
        var visual = CIQ.newChild(node, 'div', 'stx-visual')
        CIQ.newChild(node, 'div', 'stx-stem')

        var expand
        if (params.type == 'callout') {
          var content = CIQ.newChild(visual, 'div', 'stx-marker-content')
          CIQ.newChild(content, 'h4', null, params.headline)
          expand = CIQ.newChild(content, 'div', 'stx-marker-expand')
          CIQ.newChild(expand, 'p', null, params.story)
        } else {
          expand = CIQ.newChild(node, 'div', 'stx-marker-expand')
          CIQ.newChild(expand, 'h4', null, params.headline)
          CIQ.newChild(expand, 'p', null, params.story)
          CIQ.safeClickTouch(expand, function(e) {
            CIQ.toggleClassName(node, 'highlight')
          })
        }
        function cb() {
          CIQ.Marker.positionContentVerticalAndHorizontal(node)
        }
        CIQ.safeClickTouch(visual, function(e) {
          CIQ.toggleClassName(node, 'highlight')
          setTimeout(cb, 10)
        })
      }

      CIQ.Marker.Simple.ciqInheritsFrom(CIQ.Marker.NodeCreator, false)

      return _exports
    }

  var __quoteFeed_ =
    //-------------------------------------------------------------------------------------------
    // Copyright 2012-2017 by ChartIQ, Inc.
    // All rights reserved
    //-------------------------------------------------------------------------------------------
    function(_exports) {
      var CIQ = _exports.CIQ

      /**
       * See tutorial [Data Integration : Quotefeeds]{@tutorial DataIntegrationQuoteFeeds} for a complete overview and
       * step by step source code for implementing a quotefeed
       *
       * Interface for classes that implement a quotefeed. You define a quotefeed object and attach it to
       * the chart using {@link CIQ.ChartEngine#attachQuoteFeed}. Each member "fetch..." method is optional. The chart
       * will call your member method if it exists, and will skip if it does not.
       *
       * Also see {@link CIQ.ChartEngine#dontRoll} if your feed aggregates weekly and monthly bars and you do not wish the chart to roll them form daily bars.
       *
       * @name quotefeed
       * @namespace
       * @property {number} maxTicks The maximum number of ticks a quoteFeed should request at a single time. This value will be overridden if the {@link CIQ.ChartEngine.Driver} has a behavior.maximumTicks set.
       */
      function quotefeed() {}

      /**
	 * Each of your quotefeed's "fetch..."" methods must call this callback to return data results to the chart.
	 *
	 * @callback quotefeed~dataCallback
	 * @param response
	 * @param {string} [response.error]			An error message, if one occurred.
	 * @param {array} [response.quotes]			An array of Quotes in required JSON format.
	 * @param {boolean} [response.moreAvailable]	Set this to false if you know that no older data is available (to stop pagination requests).
	 * @param {object} [response.attribution]		This object will be assigned to `stx.chart.attribution`. Your UI can use this to display attribution messages. See example.
	 *
	 * @example <caption>Returning quotes in the dataCallback object</caption>
	 * cb({quotes:[--array of quote elements here--]});
	 *
	 * @example <caption>Returning an error in the dataCallback object</caption>
	 * cb({error:"Your error message here"});
	 *
	 * @example <caption>Setting attribution through the dataCallback object</caption>
	 *
	 * // Set up a callback to be called whenever fetchInitialData is called
	 *  stxx.attachQuoteFeed(yourQuoteFeed, {callback: showAttribution});
	 *
	 * // after very data call, the attribution function will be called and you can then use it to display any message regarding the quote feed
		function showAttribution(params){
			var message=params.stx.chart.attribution.message;
			// add your code here to display the message on your screen.
		}
	 *
	 * // In your quotefeed's fetchInitialData method, set the attribution object
	 * cb({quotes:[--array of quote elements here--], attribution:{message:"Data is delayed by 15 minutes"}});
	 */

      /**
       * See [Data Integration : Quotefeeds]{@tutorial DataIntegrationQuoteFeeds}
       *
       * The charting engine calls this quotefeed function whenever the chart is wiped clean and created again with new data.
       * This typically occurs when {@link CIQ.ChartEngine#newChart} is called but can also occur from other methods such as {@link CIQ.ChartEngine#setPeriodicity}
       * or {@link CIQ.ChartEngine#importLayout}.
       *
       * @param {string} symbol The ticker symbol of the data being fetched
       * @param {Date} suggestedStartDate A suggested starting date for the fetched data (based on how much can be displayed)
       * @param {Date} suggestedEndDate A suggested starting date for the fetched data (based on how much can be displayed)
       * @param {object} params						-Provides additional information on the data requested by the chart.
       * @param {Boolean}	params.series 				-If true then the request is for series/comparison data (i.e. not the the main symbol)
       * @param {CIQ.ChartEngine} params.stx 			-The chart object requesting data
       * @param {string} [params.symbolObject] 		-The symbol to fetch in object format; if a symbolObject is initialized ( see {@link CIQ.ChartEngine#newChart}, {@link CIQ.ChartEngine#addSeries}, {@link CIQ.Comparison.add} )
       * @param {number} params.period 				-The timeframe each returned object represents. For example, if using interval "minute", a period of 30 means your feed must return ticks (objects) with dates 30 minutes apart; where each tick represents the aggregated activity for that 30 minute period. **Note that this will not always be the same as the period set in {@link CIQ.ChartEngine#setPeriodicity}, since it represents the aggregation of the raw data to be returned by the feed server, rather than the final data to be displayed.**
       * @param {string} params.interval 				-The type of data your feed will need to provide. Allowable values: "millisecond,"second","minute","day","week","month". (This is **not** how much data you want the chart to show on the screen; for that you can use {@link CIQ.ChartEngine#setRange} or {@link CIQ.ChartEngine#setSpan})
       * @param {Boolean} [params.fetchMaximumBars]	-If set to true, the chart requires as much historical data as is available from the feed (params.ticks may also be set to 20,000 to set a safety max), regardless of start date. This is needed for some chart types since they aggregate data (kagi,renko, or linebreak, for example). Developers implementing fetch, should override params.tick and use a smaller number if their feed can't support that much data being sent back. The engine will then make multiple smaller calls to get enough data to fill the screen.
       * @param {number} params.ticks 				-The suggested number of data points to return. This is calculated as twice the number of bars displayed on the chart. This can be used as an alternative to suggestedStartDate.
       * @param {number} [params.timeout=10000]		-This may be used to set the timeout in msec of the remote server request.
       * @param  {quotefeed~dataCallback} cb			-Call this function with the results (or error) of your data request.
       * @since 4.1.2 Added timeout parameter.
       * @memberOf quotefeed
       */
      quotefeed.fetchInitialData = function(
        symbol,
        suggestedStartDate,
        suggestedEndDate,
        params,
        cb
      ) {}

      /**
       * See [Data Integration : Quotefeeds]{@tutorial DataIntegrationQuoteFeeds}
       *
       * The charting engine calls this quotefeed function periodically (poll) to request updated data.
       * The polling frequency is determined by the `refreshInterval` that you provided when you called {@link CIQ.ChartEngine#attachQuoteFeed}.
       *
       * @param {string} symbol The ticker symbol of the data being fetched
       * @param {Date} startDate The starting date for the fetched data (based on how much can be displayed)
       * @param {object} params						-Provides additional information on the data requested by the chart.
       * @param {Boolean}	params.series 				-If true then the request is for series/comparison data (i.e. not the main symbol)
       * @param {CIQ.ChartEngine} params.stx 			-The chart object requesting data
       * @param {string} [params.symbolObject] 		-The symbol to fetch in object format; if a symbolObject is initialized ( see {@link CIQ.ChartEngine#newChart}, {@link CIQ.ChartEngine#addSeries}, {@link CIQ.Comparison.add} )
       * @param {number} params.period 				-The timeframe each returned object represents. For example, if using interval "minute", a period of 30 means your feed must return ticks (objects) with dates 30 minutes apart; where each tick represents the aggregated activity for that 30 minute period. **Note that this will not always be the same as the period set in {@link CIQ.ChartEngine#setPeriodicity}, since it represents the aggregation of the raw data to be returned by the feed server, rather than the final data to be displayed.**
       * @param {string} params.interval 				-The type of data your feed will need to provide. Allowable values: "millisecond,"second","minute","day","week","month". (This is **not** how much data you want the chart to show on the screen; for that you can use {@link CIQ.ChartEngine#setRange} or {@link CIQ.ChartEngine#setSpan})
       * @param {number} [params.timeout=10000]		-This may be used to set the timeout in msec of the remote server request.
       * @param  {quotefeed~dataCallback} cb			-Call this function with the results (or error) of your data request.
       * @since 4.1.2 Added timeout parameter.
       * @memberOf quotefeed
       */
      quotefeed.fetchUpdateData = function(symbol, startDate, params, cb) {}

      /**
       * See [Data Integration : Quotefeeds]{@tutorial DataIntegrationQuoteFeeds}
       *
       * The charting engine calls this quotefeed function whenever the chart requires older data.
       * Usually this is because a user has scrolled or zoomed past the end of the data.
       * *Note: This method may be called during initial load if your fetchInitialData didn't provide enough data to fill the visible chart.*
       *
       * @param {string} symbol The ticker symbol of the data being fetched
       * @param {Date} suggestedStartDate A suggested starting data for the fetched data (based on how much can be displayed)
       * @param {Date} endDate The date of the last data point currently available in the chart. You should return data from this point and then backward in time.
       * @param {object} params						-Provides additional information on the data requested by the chart.
       * @param {CIQ.ChartEngine} params.stx 			-The chart object requesting data
       * @param {string} [params.symbolObject] 		-The symbol to fetch in object format; if a symbolObject is initialized ( see {@link CIQ.ChartEngine#newChart}, {@link CIQ.ChartEngine#addSeries}, {@link CIQ.Comparison.add} )
       * @param {number} params.period 				-The timeframe each returned object represents. For example, if using interval "minute", a period of 30 means your feed must return ticks (objects) with dates 30 minutes apart; where each tick represents the aggregated activity for that 30 minute period. **Note that this will not always be the same as the period set in {@link CIQ.ChartEngine#setPeriodicity}, since it represents the aggregation of the raw data to be returned by the feed server, rather than the final data to be displayed.**
       * @param {string} params.interval 				-The type of data your feed will need to provide. Allowable values: "millisecond,"second","minute","day","week","month". (This is **not** how much data you want the chart to show on the screen; for that you can use {@link CIQ.ChartEngine#setRange} or {@link CIQ.ChartEngine#setSpan})
       * @param {Boolean} [params.fetchMaximumBars]	-If set to true, the chart requires as much historical data as is available from the feed (params.ticks may also be set to 20,000 to set a safety max), regardless of start date. This is needed for some chart types since they aggregate data (kagi,renko, or linebreak, for example). Developers implementing fetch, should override params.tick and use a smaller number if their feed can't support that much data being sent back. The engine will then make multiple smaller calls to get enough data to fill the screen.
       * @param {number} params.ticks 				-The suggested number of data points to return. This is calculated as twice the number of bars displayed on the chart. This can be used as an alternative to suggestedStartDate.
       * @param {number} [params.timeout=10000]		-This may be used to set the timeout in msec of the remote server request.
       * @param  {quotefeed~dataCallback} cb			-Call this function with the results (or error) of your data request.
       * @since 4.1.2 Added timeout parameter.
       * @memberOf quotefeed
       */
      quotefeed.fetchPaginationData = function(
        symbol,
        suggestedStartDate,
        endDate,
        params,
        cb
      ) {}

      /**
       * See [Data Integration : Advanced]{@tutorial DataIntegrationAdvanced}
       *
       * Although not a core quotefeed function, the charting engine calls this optional function each time the chart encounters a new symbol or a particular periodicity for that symbol.
       * This could happen when a user changes periodcity, changes a symbol, adds a comparison symbol, or a new study is added that requires an underlying symbol.
       *
       * Use this along with unsubscribe() to keep track of symbols on the chart.
       * Use cases include: maintaining legends, lists of securities, or adding/removing subscriptions to streaming connections.
       *
       * If using a push stream, subscribe and then have the push streamer push updates using {@link CIQ.ChartEngine#updateChartData}.
       *
       * @param {object} params						-Provides additional information on the data requested by the chart.
       * @param {CIQ.ChartEngine} params.stx 			-The chart object requesting data
       * @param {string} params.symbol 				-The symbol being added
       * @param {string} params.symbolObject 			-The symbol being added in object form
       * @param {number} params.period 				-The timeframe each returned object represents. For example, if using interval "minute", a period of 30 means your feed must return ticks (objects) with dates 30 minutes apart; where each tick represents the aggregated activity for that 30 minute period. **Note that this will not always be the same as the period set in {@link CIQ.ChartEngine#setPeriodicity}, since it represents the aggregation of the raw data to be returned by the feed server, rather than the final data to be displayed.**
       * @param {string} params.interval 				-The type of data your feed will need to provide. Allowable values: "millisecond,"second","minute","day","week","month". (This is **not** how much data you want the chart to show on the screen; for that you can use {@link CIQ.ChartEngine#setRange} or {@link CIQ.ChartEngine#setSpan})
       * @memberOf quotefeed
       * @since 4.0.0 Changes to periodicity (period/interval) will now also cause subscribe calls
       */
      quotefeed.subscribe = function(params) {}

      /**
       * See [Data Integration : Advanced]{@tutorial DataIntegrationAdvanced}
       *
       * Although not a core quotefeed function, the charting engine calls this optional function each time the chart no longer requires a symbol or a particular periodicity for that symbol.
       *
       * @param {object} params						-Provides additional information on the data requested by the chart.
       * @param {CIQ.ChartEngine} params.stx 			-The chart object requesting data
       * @param {string} params.symbol				-The symbol being removed
       * @param {string} params.symbolObject 			-The symbol being removed in object form
       * @param {number} params.period 				-The timeframe each returned object represents. For example, if using interval "minute", a period of 30 means your feed must return ticks (objects) with dates 30 minutes apart; where each tick represents the aggregated activity for that 30 minute period. **Note that this will not always be the same as the period set in {@link CIQ.ChartEngine#setPeriodicity}, since it represents the aggregation of the raw data to be returned by the feed server, rather than the final data to be displayed.**
       * @param {string} params.interval 				-The type of data your feed will need to provide. Allowable values: "millisecond,"second","minute","day","week","month". (This is **not** how much data you want the chart to show on the screen; for that you can use {@link CIQ.ChartEngine#setRange} or {@link CIQ.ChartEngine#setSpan})
       * @memberOf quotefeed
       * @since 4.0.0 Changes to periodicity (period/interval) will now also cause unsubscribe calls
       */
      quotefeed.unsubscribe = function(params) {}

      /**
       * See tutorial [Data Integration : Quotefeeds]{@tutorial DataIntegrationQuoteFeeds} for a complete overview and
       * step by step source code for implementing a quotefeed
       *
       * @namespace
       * @name CIQ.QuoteFeed
       * @deprecated
       */
      CIQ.QuoteFeed = function() {}

      /**
       * @private
       * @param {object} params
       * @param {function} cb Callback
       * @deprecated
       */
      CIQ.QuoteFeed.prototype.fetch = function(params, cb) {
        if (!this.v2QuoteFeed) {
          console.log(
            'You must implement CIQ.QuoteFeed.[yourfeedname].prototype.fetch()'
          )
        }
      }

      /**
       * Whenever an error occurs the params and dataCallback from fetch will be automatically passed to this method by the quote engine.
       * Use this to alert the user if desired.
       * Override this with your own alerting mechanisms.
       * @param  {object} params The params originally passed into fetch()
       * @param {object} dataCallback The data returned to fetch
       * @memberOf CIQ.QuoteFeed
       * @example
       * 	CIQ.MyQuoteFeed.prototype.announceError=function(params, dataCallback){
       *		if(params.startDate){
       *			// Perhaps some sort of "disconnected" message on screen
       *		}else if(params.endDate){
       *			// Perhaps something indicating the end of the chart
       *		}else{
       *			CIQ.alert("Error fetching quote:" + dataCallback.error);	// Probably a not found error?
       *		}
       *	};
       *	@private
       *	@deprecated
       */
      CIQ.QuoteFeed.prototype.announceError = function(params, dataCallback) {
        if (params.suppressErrors || dataCallback.suppressAlert) return
        if (params.startDate) {
          // Perhaps some sort of "disconnected" message on screen
        } else if (params.endDate) {
          // Perhaps something indicating the end of the chart
        } else if (dataCallback.error) {
          CIQ.alert('Error fetching quote:' + dataCallback.error)
        } else {
          //CIQ.alert("Error fetching quote:" + params.symbol);	// Probably a not found error?
        }
      }

      /**
       * Fetches multiple quotes asynchronously, possibly from various data sources. This method is used to update a chart with multiple symbols
       * such as a comparison chart.
       * @param  {array}   arr Array of stock symbols
       * @param  {Function} cb  Function to callback when quotes are fetched. Will be passed an array of results. Each result is an object {dataCallback, params}.
       * @memberOf CIQ.QuoteFeed
       * @private
       */
      CIQ.QuoteFeed.prototype.multiFetch = function(arr, cb) {
        if (arr.length === 0) cb([])

        var tracker = {
          counter: 0,
          finished: arr.length,
          results: [],
        }

        function handleResponse(params, tracker, cb) {
          return function(dataCallback) {
            tracker.results.push({ dataCallback: dataCallback, params: params })
            tracker.counter++
            if (tracker.counter >= tracker.finished) {
              var results = tracker.results
              tracker.results = []
              cb(results)
            }
          }
        }
        for (var i = 0; i < arr.length; i++) {
          var params = arr[i]
          if (params.stx.isEquationChart(params.symbol)) {
            //equation chart
            CIQ.fetchEquationChart(params, handleResponse(params, tracker, cb))
          } else {
            CIQ.ChartEngine.Driver.fetchData(
              CIQ.QuoteFeed.SERIES,
              this,
              params,
              handleResponse(params, tracker, cb)
            )
          }
        }
      }

      /**
       * QuoteFeed for managing streaming data
       * @constructor
       * @private
       */
      CIQ.QuoteFeed.Subscriptions = function() {
        this.subscriptions = []
      }

      CIQ.QuoteFeed.Subscriptions.ciqInheritsFrom(CIQ.QuoteFeed)

      /**
       * Used by the QuoteFeed Driver to create subscribe and unsubscribe calls as needed.
       *
       * @param {CIQ.ChartEngine} stx engine instance
       * @since 4.0.0 Changes to periodicity (period/interval) will cause subscribe/unsubscribe calls
       */
      CIQ.QuoteFeed.Subscriptions.prototype.checkSubscriptions = function(stx) {
        var sub, need
        var chartNeeds = stx.getSymbols()

        // reset subscription match status
        for (var s = 0; s < this.subscriptions.length; s++) {
          this.subscriptions[s].match = false
        }

        for (var i = 0; i < chartNeeds.length; i++) {
          // Convert kernel periodicity/interval/timeUnit to feed format
          need = chartNeeds[i]
          var interval = need.interval
          // If we're rolling our own months or weeks then we should ask for days from the quote feed
          if ((interval == 'month' || interval == 'week') && !stx.dontRoll) {
            interval = 'day'
          }

          need.interval = interval
          need.period = 1
          need.match = false

          if (!isNaN(need.interval)) {
            // normalize numeric intervals into "minute" form
            need.period = need.interval
            need.interval = need.timeUnit
            if (!need.interval) need.interval = 'minute'
          }
          delete need.periodicity // to avoid confusion
          delete need.timeUnit // to avoid confusion
          delete need.setSpan // to avoid confusion

          for (s = 0; s < this.subscriptions.length; s++) {
            sub = this.subscriptions[s]
            if (
              sub.symbol == need.symbol &&
              sub.period == need.period &&
              sub.interval == need.interval
            ) {
              need.match = true
              sub.match = true
              break
            } else if (sub.symbol != need.symbol) {
              if (need.reason != 'period') need.reason = 'symbol'
              sub.reason = 'symbol'
            } else {
              need.reason = 'period'
              sub.reason = 'period'
            }
          }
        }
        //console.log(this.subscriptions);
        //console.log(chartNeeds);

        var self = this
        // unsubscribe to any symbols no longer matched, and remove them from subscriptions
        this.subscriptions = this.subscriptions.filter(function(c) {
          if (!c.match) {
            if (!c.stx) c.stx = stx
            self.unsubscribe(c)
          }
          return c.match
        })

        chartNeeds.forEach(function(c) {
          if (!c.match) {
            if (!c.stx) c.stx = stx
            if (!c.reason) c.reason = 'initialize'
            self.subscribe(c)
            self.subscriptions.push(c)
          }
        })
      }

      /**
       * Calls fetchFromSource and checks for subscription updates when successful.
       *
       * @param {Object} params
       * @param {Function} cb
       */
      CIQ.QuoteFeed.Subscriptions.prototype.fetch = function(params, cb) {
        var self = this
        this.fetchFromSource(params, function(results) {
          if (!results.error) {
            self.checkSubscriptions(params.stx)
          }
          cb(results)
        })
      }

      /**
       * Implement this method. Start your streaming here.
       *
       * @param {Object} params
       */
      CIQ.QuoteFeed.Subscriptions.prototype.subscribe = function(params) {
        console.log('subscribe', params)
      }

      /**
       * Implement this method. End your streaming here.
       *
       * @param {Object} params
       */
      CIQ.QuoteFeed.Subscriptions.prototype.unsubscribe = function(params) {
        console.log('unsubscribe', params)
      }

      /**
       * The charting engine will call this method whenever it needs data from your feed.
       * Override this with your implementation to fetch data from your server.
       * Uses same parameters and format as {@link CIQ.QuoteFeed#fetch}.
       * @param {object} params
       * @param {function} cb Callback
       * @memberOf CIQ.QuoteFeed.Subscriptions
       * @private
       * @deprecated
       */
      CIQ.QuoteFeed.Subscriptions.prototype.fetchFromSource = function(
        params,
        cb
      ) {
        console.log('Please provide implementation of fetchFromSource')
      }

      /**
       * Return true if your quote feed should make an immediate refresh after initial load. For instance if your
       * initial load is EOD and then you need to immediately load a real-time bar
       * @param  {object} params The same parameters that are passed to fetch()
       * @return {boolean}       Return true if a refresh is required immediately
       * @memberOf CIQ.QuoteFeed
       * @private
       */
      CIQ.QuoteFeed.prototype.requiresImmediateRefresh = function(params) {
        return false
      }

      /**
       * Attaches a quote feed to the charting engine. This causes the chart to pull data from the quotefeed as needed.
       * @param  {object} [quoteFeed] your quoteFeed object.
       * @param  {object} [behavior] Optional behavior object to initialize quotefeed
       * @param {number} [behavior.refreshInterval] If non null, then sets the frequency for fetchUpdates (if null or zero then fetchUpdate will not be called)
       * @param {number} [behavior.bufferSize] Set to the minimum number of undisplayed historical ticks always buffered in the masterData. Useful to prevent temporary gaps on studies while paginating. This forces fetch requests to be triggered ahead of reaching the left-most corner of the chart (default) if the number of already loaded bars is less than the required buffer size. This parameter can be reset at any time by manipulating 'stxx.quoteDriver.behavior.bufferSize'; it will then become active on the very next loading check.
       * @param {Function} [behavior.callback] Optional callback after any fetch to enhance functionality. It will be called with the params object used with the fetch call.
       * @param {number} [behavior.noLoadMore] If true, then the chart will not attempt to load any more data after the initial load.
       * @param {boolean} [behavior.loadMoreReplace] If true, then when paginating, the driver will replace the masterData instead of prepending. Set this if your feed can only provide a full data set of varying historical lengths.
       * @param {string} [behavior.adjustmentMethod] Set to override the quotefeed's default dividend/split adjustment method.  The value will depend on the particular quotefeed implementation.
       * @param {number} [behavior.maximumTicks=20000] Limiter on maximum number of ticks to request from a quoteFeed. Setting a value in the quoteDriver's behavior will override an individual quoteFeed's maximumTicks value.
       * @memberOf CIQ.ChartEngine
       *
       * @example <caption>Attach a quotefeed and have the driver call fetchUpdateData once per second</caption>
       * stxx.attachQuoteFeed(yourQuotefeed, {refreshInterval: 1});
       * @since
       * <br>&bull; 2016-12-01 added
       * <br>&bull; 5.0.0 behavior.bufferSize is now available.
       * <br>&bull; 5.1.1 added maximumTicks to behavior
       */
      CIQ.ChartEngine.prototype.attachQuoteFeed = function(
        quoteFeed,
        behavior
      ) {
        if (!behavior) behavior = {}
        if (this.quoteDriver) {
          this.quoteDriver.die()
        }
        // Legacy QuoteFeeds
        if (
          typeof quoteFeed.fetchInitialData !== 'function' &&
          typeof quoteFeed.fetchUpdateData !== 'function' &&
          typeof quoteFeed.fetchPaginationData !== 'function'
        ) {
          this.quoteDriver = new CIQ.ChartEngine.Driver(
            this,
            quoteFeed,
            behavior
          )
          return
        }

        // New "duck typed" v2 quotefeed
        if (
          typeof quoteFeed.fetchPaginationData !== 'function' &&
          typeof quoteFeed.fetchUpdateData !== 'function'
        ) {
          behavior.noLoadMore = true
        }
        quoteFeed.v2QuoteFeed = true // store flag in quotefeed to single new version of quotefeed
        ;['multiFetch', 'announceError', 'requiresImmediateRefresh'].forEach(
          function(prop) {
            if (!quoteFeed[prop])
              quoteFeed[prop] = CIQ.QuoteFeed.prototype[prop] // no inheritance so add function
          }
        )
        if (typeof quoteFeed.subscribe === 'function') {
          // if subscription quotefeed
          quoteFeed.checkSubscriptions =
            CIQ.QuoteFeed.Subscriptions.prototype.checkSubscriptions // no inheritance so add checkSubscriptions function
          quoteFeed.subscriptions = []
        }
        this.quoteDriver = new CIQ.ChartEngine.Driver(this, quoteFeed, behavior)
      }

      /**
       * ** Deprecated. ** Use {@link CIQ.ChartEngine#attachQuoteFeed} instead
       * Attaches a quote feed to the charting engine. This causes the chart to pull data from the quotefeed as needed.
       *
       * @param  {object} [quoteFeed] your quoteFeed object.
       * @param  {object} [behavior] Optional behavior object to initialize quotefeed
       * @param {number} [behavior.refreshInterval] If non null, then sets the frequency for fetchUpdates (if null or zero then fetchUpdate will not be called)
       * @param {Function} [behavior.callback] Optional callback after any fetch to enhance functionality. It will be called with the params object used with the fetch call.
       * @param {number} [behavior.noLoadMore] If true, then the chart will not attempt to load any more data after the initial load.
       * @param {boolean} [behavior.loadMoreReplace] If true, then when paginating, the driver will replace the masterData instead of prepending. Set this if your feed can only provide a full data set of varying historical lengths.
       * @memberOf CIQ.ChartEngine
       *
       * @example <caption>Attach a quotefeed and have the driver call fetchUpdateData once per second</caption>
       * stxx.attachEngineQuoteFeed(yourQuotefeed, {refreshInterval: 1});
       * @since 2016-12-01
       * @deprecated
       *
       */
      CIQ.ChartEngine.prototype.attachEngineQuoteFeed = function(
        quoteFeed,
        behavior
      ) {
        console.log(
          'CIQ.ChartEngine.attachEngineQuoteFeed is now Deprecated. Use CIQ.ChartEngine.attachQuoteFeed instead'
        )
        this.attachQuoteFeed(quoteFeed, behavior)
      }

      /**
       * LEGACY INTERFACE
       * Attaches an additional {@link CIQ.QuoteFeed}. fetch() will be called on this quote feed after
       * every fetch on the primary quote feed. This allows additional content to be loaded (for instance a
       * custom study that fetches pre-computed data). See {@link CIQ.ChartEngine#detachTagAlongQuoteFeed}
       *
       * The data from a tagAlong will be added to the masterData in an object under the label name.
       *
       * @param  {object} feed Feed descriptor
       * @param {CIQ.QuoteFeed} feed.quoteFeed The quote feed object
       * @param {Object} [feed.behavior] Optional behavior object. This will behave like the primary behavior object except that the refreshInterval will not be respected.
       * @param {string} feed.label Multiple copies of the same physical QuoteFeed can be used with independent labels. If multiple copies are
       * attached with the same label then a count will be kept to prevent early detachment.
       * @memberOf CIQ.ChartEngine
       * @since  04-2015
       * @deprecated
       * @private
       */
      CIQ.ChartEngine.prototype.attachTagAlongQuoteFeed = function(feed) {
        if (!feed.label) {
          console.log(
            'Attempt to attachTagAlongQuoteFeed without assigning a label'
          )
          return
        }
        this.quoteDriver.attachTagAlongQuoteFeed(feed)
      }

      /**
       * LEGACY INTERFACE
       * See {@link CIQ.ChartEngine#attachTagAlongQuoteFeed}
       * @param {object} feed
       * @memberOf CIQ.ChartEngine
       * @since  04-2015
       * @deprecated
       * @private
       */
      CIQ.ChartEngine.prototype.detachTagAlongQuoteFeed = function(feed) {
        if (!feed.label) {
          console.log(
            'Attempt to detachTagAlongQuoteFeed without assigning a label'
          )
          return
        }
        this.quoteDriver.detachTagAlongQuoteFeed(feed)
      }

      /**
       * Drives the Chart's relationship with the quotefeed object provided to the chart
       * @param {CIQ.ChartEngine} stx A chart engine instance
       * @param {object} quoteFeed
       * @param {object} behavior
       * @param {number} [behavior.refreshInterval] Defines how frequently in seconds the chart looks for an update
       * @param {number} [behavior.buffer] A value of ticks that acts as a buffer before pagination
       * @param {number} [behavior.maximumTicks=20000] Limiter on maximum number of ticks to request from a quoteFeed. Setting a value in the quoteDriver's behavior will override an individual quoteFeed's maximumTicks value.
       * @property {boolean} loadingNewChart=false READ ONLY boolean telling when a new chart is loading
       * @property {boolean} updatingChart=false READ ONLY boolean telling when a chart is updating
       * @property {?number} intervalTimer=null intervalTimer a set interval which can be cleared to stop the update loop
       * @constructor
       * @name  CIQ.ChartEngine.Driver
       * @since 5.1.1 added maximumTicks to behavior
       */
      CIQ.ChartEngine.Driver = function(stx, quoteFeed, behavior) {
        this.tagalongs = {}
        this.stx = stx
        this.quoteFeed = quoteFeed
        if (!behavior.maximumTicks)
          behavior.maximumTicks = quoteFeed.maxTicks
            ? quoteFeed.maxTicks
            : 20000 // Historically this is the safest limit of ticks to fetch for response time
        this.behavior = behavior
        this.loadingNewChart = false // This gets set to true when loading a new chart in order to prevent refreshes while waiting for data back from the server
        this.intervalTimer = null // This is the window.setInterval which can be cleared to stop the updating loop
        this.updatingChart = false // This gets set when the chart is being refreshed
        this.updateChartLoop()
      }

      CIQ.ChartEngine.Driver.prototype.die = function() {
        if (this.intervalTimer) {
          window.clearInterval(this.intervalTimer)
          this.intervalTimer = -1 // this means it was stopped by the die function and should not be started again in the event of an async call back from the fetch coming back after it was killed.
        }
      }

      /**
       * Call this whenever the kernel knows that the symbols being used have changed
       * @private
       */
      CIQ.ChartEngine.Driver.prototype.updateSubscriptions = function() {
        if (this.quoteFeed.checkSubscriptions)
          this.quoteFeed.checkSubscriptions(this.stx)
      }

      CIQ.ChartEngine.Driver.prototype.attachTagAlongQuoteFeed = function(
        feed
      ) {
        if (!feed.label) return
        if (!this.tagalongs[feed.label]) {
          this.tagalongs[feed.label] = {
            label: feed.label,
            quoteFeed: feed.quoteFeed,
            behavior: feed.behavior ? feed.behavior : {},
            count: 0,
          }
        }
        this.tagalongs[feed.label].count++
      }

      CIQ.ChartEngine.Driver.prototype.detachTagAlongQuoteFeed = function(
        feed
      ) {
        if (!feed.label) return
        var tagalong = this.tagalongs[feed.label]
        tagalong.count--
        if (!tagalong.count) this.tagalongs[feed.label] = null
      }

      CIQ.ChartEngine.Driver.prototype.loadDependents = function(params, cb) {
        var field
        var syms = {}
        var stx = params.stx
        var chart = params.chart
        var seriesList = chart.series
        var masterData = stx.masterData
        var series, symbolObject

        function getStartDate(symbol) {
          for (var c = masterData.length - 1; c >= 0; c--) {
            if (masterData[c] && typeof masterData[c][symbol] != 'undefined') {
              return CIQ.strToDateTime(masterData[c].Date)
            }
          }
          return params.startDate
        }

        // Create a master list of all symbols we need from our various dependencies: series and studySymbols
        var allSymbols = []
        var isUpdate = params.originalState.update
        for (field in seriesList) {
          series = seriesList[field]
          if (!isUpdate && series.moreAvailable === false) continue // skip series that no longer have historical data.
          var sp = series.parameters
          symbolObject = sp.symbolObject
          if (!symbolObject.symbol) continue // skip series that are really just fields already loaded, like "High".
          if (sp.loadData === false) continue // skip series that do not load data
          if (sp.data && !sp.data.useDefaultQuoteFeed) continue // legacy
          var isUnique = true
          for (var j = 0; j < allSymbols.length; j++) {
            if (CIQ.symbolEqual(allSymbols[j], symbolObject)) isUnique = false
          }
          if (isUnique) allSymbols.push(symbolObject)
        }

        var arr = []
        for (var k = 0; k < allSymbols.length; k++) {
          symbolObject = allSymbols[k]
          var seriesParam = CIQ.shallowClone(params.originalState)
          seriesParam.symbol = symbolObject.symbol
          seriesParam.symbolObject = symbolObject
          series = seriesList[field]
          if (seriesParam.update) {
            seriesParam.startDate = getStartDate(field)
          } else {
            if (!seriesParam.startDate) seriesParam.startDate = params.startDate
            // for comparisons, you must fetch enough data on the new Comparison to match the beginning of the masterData until the current tick.
            // The current tick may be newer than master data last tick, so set the end Date to right now.
            if (!seriesParam.endDate)
              seriesParam.endDate = stx.convertToDataZone(new Date())
            seriesParam.ticks = params.ticks
          }
          arr.push(seriesParam)
        }
        if (!arr.length) {
          // we need this because in updateChart we don't create and let the dependents do it.
          stx.createDataSet(null, null, {
            appending: params.originalState.update,
          })
          if (!params.nodraw) stx.draw()
          if (cb) cb(null)
          return
        }

        function MFclosure(isUpdate) {
          return function(results) {
            var earliestDate = null
            for (var i = 0; i < results.length; i++) {
              var result = results[i]
              var error = result.dataCallback.error
              if (!error && error !== 0) {
                var symbolObject = result.params.symbolObject
                var dataCallback = result.dataCallback,
                  quotes = dataCallback.quotes,
                  moreAvailable = dataCallback.moreAvailable
                var arr = stx.getSeries({ symbolObject: symbolObject })
                var parameters = {}
                for (var j = 0; j < arr.length; j++) {
                  series = arr[j]
                  if (!isUpdate) {
                    // only reset the moreAvailable on pagination or initial fetch, never on updates.
                    series.moreAvailable =
                      moreAvailable === false
                        ? false
                        : moreAvailable ||
                          quotes.length > (result.params.endDate ? 1 : 0)
                  }
                  parameters = series.parameters
                }
                CIQ.addMemberToMasterdata({
                  stx: stx,
                  label: symbolObject.symbol,
                  data: quotes,
                  fieldForLabel: parameters.field,
                  fillGaps: parameters.fillGaps,
                  createObject: true,
                })
                if (
                  quotes &&
                  quotes.length &&
                  (!earliestDate || earliestDate > quotes[0].DT)
                )
                  earliestDate = quotes[0].DT
              }
            }
            stx.createDataSet(null, null, {
              appending: params.originalState.update,
              appendToDate: earliestDate,
            })
            if (!params.nodraw) stx.draw()
            if (cb) cb(null)
          }
        }

        this.quoteFeed.multiFetch(arr, MFclosure(isUpdate))
      }

      CIQ.ChartEngine.Driver.prototype.executeTagAlongs = function(params) {
        var count = {
          count: CIQ.objLength(this.taglongs),
        }
        var self = this
        function closure(qparams, tagalong, count) {
          return function(dataCallback) {
            count.count--
            if (!dataCallback.error) {
              var fields = qparams.fields
              if (!fields) fields = null
              CIQ.addMemberToMasterdata(
                self.stx,
                tagalong.label,
                dataCallback.quotes,
                fields
              )
            }

            if (count.count == -1) {
              self.stx.createDataSet(null, null, {
                appending: qparams.originalState.update,
              })
              self.stx.draw()
            }
          }
        }
        for (var label in this.tagalongs) {
          var tagalong = this.tagalongs[label]

          // behavior + params
          var qparams = CIQ.shallowClone(tagalong.behavior)
          CIQ.extend(qparams, params, true)

          CIQ.ChartEngine.Driver.fetchData(
            null,
            tagalong.quoteFeed,
            qparams,
            closure(qparams, tagalong, count)
          ) // only legacy quotefeed supported with tagalong
        }
      }

      /**
       * Updates the chart as part of the chart loop
       * @memberOf CIQ.ChartEngine.Driver
       * @private
       */
      CIQ.ChartEngine.Driver.prototype.updateChart = function() {
        if (this.updatingChart) return
        if (this.loadingNewChart) return
        var howManyToGet = CIQ.objLength(this.stx.charts)
        var howManyReturned = 0

        var interval = this.stx.layout.interval
        var timeUnit = this.stx.layout.timeUnit

        function closure(self, params, symbol) {
          if (self.behavior.prefetchAction)
            self.behavior.prefetchAction('updateChart')
          return function(dataCallback) {
            howManyReturned++
            var stx = self.stx,
              chart = params.chart,
              masterData = chart.masterData
            if (
              symbol == chart.symbol &&
              interval == stx.layout.interval &&
              timeUnit == stx.layout.timeUnit
            ) {
              // Make sure user hasn't changed symbol while we were waiting on a response
              if (!dataCallback.error) {
                var quotes = dataCallback.quotes
                stx.doCleanupDates(dataCallback.quotes, interval)
                var lastBarAdded = false
                if (!params.missingBarsCreated) {
                  if (
                    masterData &&
                    masterData.length &&
                    quotes &&
                    quotes.length > 0
                  ) {
                    var lastRecord = masterData[masterData.length - 1]
                    var firstQuote = quotes[0]
                    if (
                      (firstQuote.DT && lastRecord.DT < firstQuote.DT) ||
                      (firstQuote.Date && lastRecord.Date < firstQuote.Date)
                    ) {
                      quotes.unshift(lastRecord) //add previous bar so we can close gaps
                      lastBarAdded = true //there is no overlap; possible gap
                    }
                  }
                  dataCallback.quotes = quotes = stx.doCleanupGaps(
                    quotes,
                    chart
                  )
                  if (lastBarAdded) quotes.shift()
                }
                stx.updateChartData(quotes, chart, { noCreateDataSet: true })
                chart.attribution = dataCallback.attribution
              } else {
                self.quoteFeed.announceError(params.originalState, dataCallback)
              }
            } else {
              //console.log("orphaned update",params);
              return
            }
            if (howManyReturned == howManyToGet) {
              self.updatingChart = false
            }
            self.executeTagAlongs(params)
            if (self.behavior.callback) {
              self.behavior.callback(params)
            }
            self.loadDependents(params) // createDataSet(),draw() will be handled in here
          }
        }

        //TODO, change this to multi-fetch?
        for (var chartName in this.stx.charts) {
          var chart = this.stx.charts[chartName]
          if (!chart.symbol) continue
          // Removed below line.  It's possible IPO has no quotes from newChart but a BATS update will return data.
          //if(!chart.masterData /*|| !chart.masterData.length*/) continue;	 // sometimes there is no data but it is not an error, and we want to let the refresh try again. If don't go in here, self.updatingChart will never be set to true and we will never refresh.
          var params = this.makeParams(chart.symbol, chart.symbolObject, chart)
          if (chart.masterData && chart.masterData.length)
            params.startDate = chart.masterData[chart.masterData.length - 1].DT // if there is no data, then let the fetch treat an in initial load without start or end dates.
          params.update = true
          params.originalState = CIQ.shallowClone(params)
          this.updatingChart = true
          var closureCB = closure(this, params, chart.symbol)
          if (this.stx.isEquationChart(params.symbol)) {
            //equation chart
            CIQ.fetchEquationChart(params, closureCB)
          } else {
            CIQ.ChartEngine.Driver.fetchData(
              CIQ.QuoteFeed.UPDATE,
              this.quoteFeed,
              params,
              closureCB
            )
          }
        }
      }

      CIQ.ChartEngine.Driver.prototype.updateChartLoop = function(newInterval) {
        if (this.intervalTimer == -1) return // the driver was killed. This was probably an async call from a feed response sent before it was killed.
        if (this.intervalTimer) window.clearInterval(this.intervalTimer) // stop the timer
        if (this.behavior.noUpdate) return
        function closure(self) {
          return function() {
            if (self.behavior.noUpdate) return
            self.updateChart()
          }
        }
        if (!newInterval && newInterval !== 0)
          newInterval = this.behavior.refreshInterval
        if (newInterval)
          this.intervalTimer = window.setInterval(
            closure(this),
            newInterval * 1000
          )
      }

      /**
       * Convenience function to change the refresh interval that was set during attachQuoteFeed.
       * @param  {number} newInterval The new refresh interval in seconds
       * @memberOf CIQ.ChartEngine.Driver
       * @since 07/01/2015
       */
      CIQ.ChartEngine.Driver.prototype.resetRefreshInterval = function(
        newInterval
      ) {
        this.behavior.refreshInterval = newInterval // set to your new interval
        this.updateChartLoop() // restart the timer in the new interval
      }

      /**
       * Loads all available data
       * @param {CIQ.ChartEngine.Chart} [chart] The chart to adjust. If left undefined, adjust the main symbol chart.
       * @param {function} cb The callback function. Will be called with the error returned by the quotefeed, if any.
       * @memberOf CIQ.ChartEngine.Driver
       * @since 07/01/2015
       */
      CIQ.ChartEngine.Driver.prototype.loadAll = function(chart, cb) {
        var self = this
        var count = 0
        function closure() {
          return function(response) {
            if (response) {
              // error
              cb(response)
            } else if (!chart.moreAvailable) {
              // no more data
              cb(null)
            } else if (chart.loadingMore) {
              // something else is loading past data, abort this
              cb(null)
            } else if (++count > 20) {
              // we'll allow up to 20 fetches
              cb('error, moreAvailable not implemented correctly in QuoteFeed')
            } else {
              // get some more
              self.checkLoadMore(chart, true, true, closure())
            }
          }
        }
        closure()()
      }

      /**
       * If the quote feed has indicated there is more data available it will create and execute a fetch() call,
       * load the data into the masterData array, and create a new dataSet. Called internally as needed to keep the chart data up to date.
       * Finally it will re-draw the chart to display the new data
       *
       * @param  {CIQ.ChartEngine.Chart} [chart] The chart to adjust. Otherwise adjusts the main symbol chart.
       * @param {boolean} forceLoadMore set to true to force a fetch() call.
       * @param {boolean} fetchMaximumBars	set to true to request the maximum amount of data available from the feed.
       * @param {function} cb The callback function. Will be called with the error returned by the quotefeed, if any.
       * @param {boolean} nodraw
       * @memberOf CIQ.ChartEngine.Driver
       * @private
       */
      CIQ.ChartEngine.Driver.prototype.checkLoadMore = function(
        chart,
        forceLoadMore,
        fetchMaximumBars,
        cb,
        nodraw
      ) {
        if (chart.loadingMore) {
          chart.initialScroll = chart.scroll
          if (cb) cb(null)
          return
        }
        var params
        function finish(err) {
          chart.loadingMore = false
          if (cb) cb(err)
        }
        var stx = this.stx
        if (!chart.moreAvailable) {
          //If there is no more data for master, check to see if the compares have more data.
          if (
            (chart.dataSet.length > 0 &&
              chart.scroll >= chart.dataSet.length) ||
            forceLoadMore
          ) {
            //check to see if we can load data from the series
            for (var key in chart.series) {
              if (chart.series[key].moreAvailable !== false) {
                params = this.makeParams(
                  chart.symbol,
                  chart.symbolObject,
                  chart
                )
                //Take the first date from master data and use that as the end date
                if (chart.masterData && chart.masterData.length) {
                  params.endDate = chart.masterData[0].DT
                } else {
                  params.endDate = stx.convertToDataZone(new Date())
                }
                params.originalState = CIQ.shallowClone(params)
                params.nodraw = nodraw
                chart.loadingMore = true
                this.loadDependents(params, finish)
                return
              }
            }
          }
          if (cb) cb(null)
          return
        }
        var interval = stx.layout.interval
        var timeUnit = stx.layout.timeUnit
        function closure(self, params) {
          if (self.behavior.prefetchAction)
            self.behavior.prefetchAction('checkLoadMore')
          return function(dataCallback) {
            var stx = self.stx,
              chart = params.chart
            if (
              params.symbol == chart.symbol &&
              interval == stx.layout.interval &&
              timeUnit == stx.layout.timeUnit
            ) {
              // Make sure user hasn't changed symbol while we were waiting on a response
              if (!params.loadMore) params.chart.loadingMore = false
              if (!dataCallback.error) {
                if (!dataCallback.quotes) dataCallback.quotes = []
                stx.doCleanupDates(dataCallback.quotes, interval)
                if (dataCallback.quotes.length) {
                  // remove possible dup with master data's first record
                  var lastQuote =
                    dataCallback.quotes[dataCallback.quotes.length - 1]
                  if (!lastQuote.DT && lastQuote.Date)
                    lastQuote.DT = CIQ.strToDateTime(lastQuote.Date)
                  if (lastQuote.DT && +lastQuote.DT == +chart.masterData[0].DT)
                    dataCallback.quotes.pop()
                }
                if (!params.missingBarsCreated) {
                  dataCallback.quotes.push(chart.masterData[0]) //add bar for end date so we can close gaps
                  dataCallback.quotes = stx.doCleanupGaps(
                    dataCallback.quotes,
                    chart
                  )
                  dataCallback.quotes.pop() //remove end date bar
                }
                // set moreAvailable before we call draw or we can create an infinite loop if the feed servers runs out of data in the middle of a draw

                // if dataCallback.moreAvailable is set to either true or false, set chart.moreAvailable to that value
                // if dataCallback.moreAvailable is not set at all (null or undefined), then set chart.moreAvailable to dataCallback.quotes.length!==0
                if (dataCallback.moreAvailable) chart.moreAvailable = true
                else if (
                  dataCallback.moreAvailable === false ||
                  !dataCallback.quotes.length
                )
                  chart.moreAvailable = false
                // Can't be more available if we got nothing back
                else chart.moreAvailable = true
                self.tickMultiplier = dataCallback.quotes.length
                  ? 2
                  : self.tickMultiplier * 2

                chart.loadingMore = false // this has to be set before draw() because a new pagination fetch might occur with its own loadMoreFlag setting
                if (params.loadMoreReplace) {
                  stx.setMasterData(dataCallback.quotes, chart)
                } else {
                  CIQ.addMemberToMasterdata({
                    stx: stx,
                    chart: chart,
                    data: dataCallback.quotes,
                    fields: ['*'],
                  })
                }
                stx.createDataSet()
                if (!nodraw) stx.draw()
                //params.endDate=chart.masterData[0].DT;
                self.executeTagAlongs(params)
                if (self.behavior.callback) {
                  self.behavior.callback(params)
                }
                self.loadDependents(params, cb)
              } else {
                self.quoteFeed.announceError(params.originalState, dataCallback)
                params.chart.loadingMore = false
                if (cb) cb(dataCallback.error)
              }
            } else {
              //console.log("orphaned loadMore",params);
              return
            }
          }
        }
        function getEndDate() {
          for (var c = 0; c < chart.masterData.length; c++) {
            if (
              chart.masterData[c] &&
              typeof chart.masterData[c][chart.defaultPlotField] != 'undefined'
            ) {
              return chart.masterData[c].DT
            }
          }
          return chart.masterData[0].DT
        }
        var fetching = false
        if (!this.behavior.noLoadMore) {
          if (
            !stx.maxDataSetSize ||
            chart.dataSet.length < stx.maxDataSetSize
          ) {
            var loadedData =
              chart.dataSet.length - (this.behavior.bufferSize || 0)
            if (loadedData < 0) loadedData = 0
            if (chart.scroll >= loadedData || forceLoadMore) {
              chart.initialScroll = chart.scroll
              chart.loadingMore = true
              params = this.makeParams(chart.symbol, chart.symbolObject, chart)
              if (chart.masterData && chart.masterData.length)
                params.endDate = getEndDate()
              else params.endDate = stx.convertToDataZone(new Date())
              params.originalState = CIQ.shallowClone(params)
              params.nodraw = nodraw
              if (stx.fetchMaximumBars[stx.layout.aggregationType])
                fetchMaximumBars = true
              if (fetchMaximumBars) {
                params.fetchMaximumBars = true
                if (
                  !stx.maxMasterDataSize ||
                  this.behavior.maximumTicks < stx.maxMasterDataSize
                )
                  params.ticks = this.behavior.maximumTicks
                else params.ticks = stx.maxMasterDataSize
              }
              var closureCB = closure(this, params)
              if (stx.isEquationChart(params.symbol)) {
                //equation chart
                CIQ.fetchEquationChart(params, closureCB)
              } else {
                CIQ.ChartEngine.Driver.fetchData(
                  CIQ.QuoteFeed.PAGINATION,
                  this.quoteFeed,
                  params,
                  closureCB
                )
              }
              fetching = true
            }
          }
        }
        if (!fetching && cb) cb(null)
      }

      /**
       * Returns how many bars should be fetched. If we're fetching a series then it's simply the number
       * of bars already in the chart. Otherwise it's twice the number of bars to fetch to fill up the screen.
       * If we're rolling our own months or weeks from daily ticks it will return the number of daily ticks to fetch.
       *
       * @param  {object} params Parameters
       * @param  {object} params.stx	  The chart object
       * @return {number}		   Number of bars to fetch
       * @memberOf CIQ.ChartEngine.Driver
       * @private
       */
      CIQ.ChartEngine.Driver.prototype.barsToFetch = function(params) {
        if (params.isSeries) return params.stx.masterData.length
        var interval = this.stx.layout.interval
        var p = params.stx.layout.periodicity
        // Rough calculation, this will account for 24x7 securities
        // If we're rolling our own months or weeks then adjust to daily bars
        if ((interval == 'month' || interval == 'week') && !this.stx.dontRoll) {
          p *= interval == 'week' ? 7 : 30
        }
        var bars = params.stx.chart.maxTicks * p
        return bars * this.tickMultiplier
      }

      /**
       * Calcluates the suggestedStartDate for a query to a quoteFeed. Will either do a quick estimation if fetchMaximimBars is true for effiency or use a market iterator to find the exact start date.
       * This should only be called after the correct ticks have been determined.
       * @param {object} params
       * @param {object} iterator
       * @param {number} ticks
       * @return {Date} suggestedStartDate
       * @memberof CIQ.ChartEngine.Driver
       * @since 5.1.1
       */
      CIQ.ChartEngine.Driver.determineStartDate = function(
        params,
        iterator,
        ticks
      ) {
        var interval = params.interval,
          period = params.stx.layout.periodicity,
          multiplier = CIQ.Market.Symbology.isForexSymbol ? 1.3 : 4
        if (interval === 'millisecond' || interval === 'second')
          interval = CIQ.SECOND * period * multiplier
        else if (interval === 'minute')
          interval = CIQ.MINUTE * period * multiplier
        else interval = CIQ.DAY * multiplier
        var startDate
        if (params.fetchMaximumBars) {
          startDate = new Date(Date.now() - ticks * interval) // by default this will be a date around 50 years ago, a safe starting estimate
        } else {
          startDate = params.startDate
            ? params.startDate
            : iterator.previous(ticks)
        }
        return startDate
      }

      CIQ.ChartEngine.Driver.prototype.makeParams = function(
        symbol,
        symbolObject,
        chart
      ) {
        var interval = this.stx.layout.interval
        var ticks = this.barsToFetch({ stx: this.stx })
        // If we're rolling our own months or weeks then we should ask for days from the quote feed
        if ((interval == 'month' || interval == 'week') && !this.stx.dontRoll) {
          interval = 'day'
        }
        var params = CIQ.shallowClone(this.behavior)

        CIQ.extend(
          params,
          {
            stx: this.stx,
            symbol: symbol,
            symbolObject: symbolObject,
            chart: chart,
            interval: interval,
            extended: this.stx.layout.extended,
            period: 1,
            feed: 'delayed',
            ticks: ticks,
          },
          true
        )

        if (!params.symbolObject) params.symbolObject = { symbol: symbol }

        if (!isNaN(params.interval)) {
          // normalize numeric intervals into "minute", "second" or "millisecond" form as required by fetch()
          params.period = parseInt(params.interval, 10) // in case it was a string, which is allowed in setPeriodicity.
          params.interval = this.stx.layout.timeUnit
          if (!params.interval) params.interval = 'minute'
        }
        return params
      }

      CIQ.ChartEngine.Driver.prototype.newChart = function(params, cb) {
        var stx = this.stx
        var symbol = params.symbol
        var interval = stx.layout.interval
        var timeUnit = stx.layout.timeUnit
        var chart = params.chart
        chart.moreAvailable = null
        chart.attribution = null
        this.tickMultiplier = 2 // used to determine params.ticks
        var qparams = this.makeParams(symbol, params.symbolObject, chart)
        CIQ.extend(qparams, params, true)
        // Some aggregation types potentially require a lot of data. We set the flag "fetchMaximumBars"
        // but also take a guess and say 20,000 bars should cover most situations
        if (
          stx.fetchMaximumBars[stx.layout.aggregationType] ||
          params.fetchMaximumBars
        ) {
          if (
            !stx.maxMasterDataSize ||
            this.behavior.maximumTicks < stx.maxMasterDataSize
          )
            qparams.ticks = this.behavior.maximumTicks
          else qparams.ticks = stx.maxMasterDataSize
          qparams.fetchMaximumBars = true
        }

        function closure(self, qparams) {
          if (self.behavior.prefetchAction)
            self.behavior.prefetchAction('newChart')
          return function(dataCallback) {
            var chart = qparams.chart,
              quotes = dataCallback.quotes
            if (
              symbol == chart.symbol &&
              interval == stx.layout.interval &&
              timeUnit == stx.layout.timeUnit
            ) {
              // Make sure user hasn't changed symbol while we were waiting on a response
              if (!dataCallback.error) {
                stx.doCleanupDates(quotes, interval)
                if (!qparams.missingBarsCreated)
                  quotes = stx.doCleanupGaps(quotes, chart)
                stx.setMasterData(quotes, chart)
                // Note, quotes.length==0 will not set moreAvailable to false, just in case the stock is thinly traded
                // We'll rely on checkLoadMore to make the definitive decision
                if (!quotes) chart.moreAvailable = false
                else
                  chart.moreAvailable =
                    dataCallback.moreAvailable === false ? false : true

                chart.attribution = dataCallback.attribution
                if (params.initializeChart) stx.initializeChart()
                stx.createDataSet()
                if (!qparams.nodraw) stx.home() // by default the white space is maintained now, so no need to include the {maintainWhitespace:true} parameter
              } else {
                self.quoteFeed.announceError(
                  qparams.originalState,
                  dataCallback
                )
              }
            } else {
              //console.log("orphaned request", qparams);
              if (cb) cb('orphaned')
              return
            }

            // new data means that all series could potentially have historical data. So reset them all.
            for (var key in chart.series) chart.series[key].moreAvailable = null

            self.loadingNewChart = false
            // We've now responded to the newChart() callback. Please note that dependents are now being loaded in parallel!
            var masterData = chart.masterData
            if (masterData && masterData.length) {
              qparams.startDate = masterData[0].DT
              qparams.endDate = masterData[masterData.length - 1].DT
            }
            self.executeTagAlongs(qparams)
            if (self.behavior.callback) {
              self.behavior.callback(qparams)
            }
            self.loadDependents(qparams, function() {
              if (cb) cb(dataCallback.error)
              self.stx.dispatch('newChart', {
                stx: self.stx,
                symbol: self.stx.chart.symbol,
                symbolObject: self.stx.chart.symbolObject,
                moreAvailable: self.stx.chart.moreAvailable,
                quoteDriver: self,
              })

              self.resetRefreshInterval(self.behavior.refreshInterval)
            })
          }
        }
        this.loadingNewChart = true
        this.updatingChart = false

        qparams.originalState = CIQ.shallowClone(qparams)
        var closureCB = closure(this, qparams)
        if (this.stx.isEquationChart(qparams.symbol)) {
          //equation chart
          CIQ.fetchEquationChart(qparams, closureCB)
        } else {
          CIQ.ChartEngine.Driver.fetchData(
            CIQ.QuoteFeed.INITIAL,
            this.quoteFeed,
            qparams,
            closureCB
          )
        }
      }

      ///////////////////////////////////////////////////////////////////////////////////////////////////
      ///////////////////////////////////////////////////////////////////////////////////////////////////
      // Below code supports new quotefeed architecture
      ///////////////////////////////////////////////////////////////////////////////////////////////////
      ///////////////////////////////////////////////////////////////////////////////////////////////////

      //Quotefeed constants defining fetchData's context parameter
      CIQ.QuoteFeed.INITIAL = 1
      CIQ.QuoteFeed.UPDATE = 2
      CIQ.QuoteFeed.PAGINATION = 3
      CIQ.QuoteFeed.SERIES = 4

      // ALL quotefeed-fetch calls (old and new versions) go through this function
      CIQ.ChartEngine.Driver.fetchData = function(
        context,
        quoteFeed,
        params,
        cb
      ) {
        if (quoteFeed.v2QuoteFeed) {
          // if new version of quotefeed
          if (typeof quoteFeed.subscribe !== 'function') {
            // if no subscribe function defined then this is a typical quotefeed
            CIQ.ChartEngine.Driver.fetchDataInContext(
              context,
              quoteFeed,
              params,
              cb
            )
          } else {
            // else this is a "subscription" quotefeed
            CIQ.ChartEngine.Driver.fetchDataInContext(
              context,
              quoteFeed,
              params,
              function(results) {
                if (!results.error) {
                  quoteFeed.checkSubscriptions(params.stx)
                }
                cb(results)
              }
            )
          }
        } else {
          // old version of quotefeed
          quoteFeed.fetch(params, cb)
        }
      }

      // if not a "subscription" quotefeed, then this function is always called for new quotefeed -- here the user's quotefeed is invoked;
      // functions not defined in quotefeed are skipped over
      CIQ.ChartEngine.Driver.fetchDataInContext = function(
        context,
        quoteFeed,
        params,
        cb
      ) {
        var iterator_parms, iterator, suggestedStartDate, suggestedEndDate
        // When dealing with a series, we need to look at the original params in order to figure out
        // what type of request we really need to make
        if (context === CIQ.QuoteFeed.SERIES) {
          params.series = true
          context = CIQ.QuoteFeed.INITIAL
          if (params.endDate && !params.startDate)
            context = CIQ.QuoteFeed.PAGINATION
          else if (params.startDate && !params.endDate)
            context = CIQ.QuoteFeed.UPDATE
        }
        switch (context) {
          case CIQ.QuoteFeed.UPDATE:
            var startDate
            if (params.startDate) {
              startDate = params.startDate
            } else {
              startDate = new Date() // occurs if initial fetch returned no data
              startDate.setHours(0, 0, 0, 0)
            }
            if (typeof quoteFeed.fetchUpdateData === 'function') {
              quoteFeed.fetchUpdateData(params.symbol, startDate, params, cb)
            }
            break
          case CIQ.QuoteFeed.INITIAL:
            suggestedEndDate = new Date()
            suggestedEndDate.setMilliseconds(0)
            iterator_parms = {
              begin: suggestedEndDate,
              interval: params.interval == 'tick' ? 1 : params.interval,
              periodicity:
                params.interval == 'tick'
                  ? params.stx.chart.xAxis.futureTicksInterval
                  : params.period,
              inZone: params.stx.dataZone,
              outZone: params.stx.dataZone,
            }
            iterator = params.stx.chart.market.newIterator(iterator_parms)
            suggestedStartDate = CIQ.ChartEngine.Driver.determineStartDate(
              params,
              iterator,
              params.ticks
            )
            suggestedEndDate = params.endDate
              ? params.endDate
              : suggestedEndDate

            if (typeof quoteFeed.fetchInitialData === 'function') {
              quoteFeed.fetchInitialData(
                params.symbol,
                suggestedStartDate,
                suggestedEndDate,
                params,
                cb
              )
            }
            break
          case CIQ.QuoteFeed.PAGINATION:
            iterator_parms = {
              begin: params.endDate,
              interval: params.interval == 'tick' ? 1 : params.interval,
              periodicity:
                params.interval == 'tick'
                  ? params.stx.chart.xAxis.futureTicksInterval
                  : params.period,
              inZone: params.stx.dataZone,
              outZone: params.stx.dataZone,
            }
            iterator = params.stx.chart.market.newIterator(iterator_parms)
            var ticks = Math.min(
              params.ticks,
              params.stx.quoteDriver.behavior.maximumTicks
            )
            suggestedStartDate = CIQ.ChartEngine.Driver.determineStartDate(
              params,
              iterator,
              ticks
            )
            if (typeof quoteFeed.fetchPaginationData === 'function') {
              if (
                params.stx.maxMasterDataSize &&
                params.stx.maxMasterDataSize <= params.stx.masterData.length
              )
                return
              quoteFeed.fetchPaginationData(
                params.symbol,
                suggestedStartDate,
                params.endDate,
                params,
                cb
              )
            }
            break
          default:
            console.error('Illegal fetchData constant')
        }
      }

      return _exports
    }

  var __span_ =
    //-------------------------------------------------------------------------------------------
    // Copyright 2012-2017 by ChartIQ, Inc.
    // All rights reserved
    //-------------------------------------------------------------------------------------------
    function(_exports) {
      var CIQ = _exports.CIQ
      /**
	 * Sets a chart to the requested date range.
	 *
	 * When a quotefeed is attached to the chart (ver 04-2015 and up), and not enough data is available in masterData to render the requested range, setRange will request more from the feed.
	 * Also, if no periodicity (params.periodicity) is supplied in the parameters, **it may	 override the current periodicity** and automatically choose the best periodicity to use for the requested range using the {@link CIQ.ChartEngine#dynamicRangePeriodicityMap} when {@link CIQ.ChartEngine#autoPickCandleWidth} is enabled,
	 * or the use of the {@link CIQ.ChartEngine#staticRangePeriodicityMap} object when {@link CIQ.ChartEngine#autoPickCandleWidth} is **NOT** enabled.
	 * So depending on your UI, **you may need to use the callback to refresh the periodicity displayed on your menu**.
	 *
	 * Therefore, if you choose to let setRange set the periodicity, you should **not** call setPeriodicity before or after calling this method.
	 *
	 * **Note:** if the chart is in `tick` periodicity, the periodicity will be automatically selected even if one was provided because in `tick` periodicity we have no way to know how many ticks to get to fulfill the requested range.
	 *
	 * If there is no quotefeed attached (or using a version prior to 04-2015), then setRange will use whatever data is available in the masterData. So you must ensure you have preloaded enough to display the requested range.
	 *
	 * This function must be called after newChart() creates a datSet.
	 *
	 * ** Layout preservation and the range **
	 * <br>The selected range will be recorded in the chart {@link CIQ.ChartEngine#layout} when it is requested through {@link CIQ.ChartEngine#newChart}, or when you call setRange directly.
	 * <br>It is then used in {@link CIQ.ChartEngine#importLayout} and {@link CIQ.ChartEngine#newChart} to reset that range, until a new range is selected.
	 *
	 * @param {object} params  Parameters for the request
	 * @param {Date} [params.dtLeft] Date to set left side of chart. If no left date is specified then the right edge will be flushed, and the same interval and period will be kept causing the chart to simply scroll to the right date indicated.<BR> **Must be in the exact same time-zone as the `masterdata`.** See {@link CIQ.ChartEngine#setTimeZone} and {@link CIQ.ChartEngine#convertToDataZone} for more details.
	 * @param {Date} [params.dtRight] Date to set right side of chart. Defaults to right now. <BR> **Must be in the exact same time-zone as the `masterdata`.** See {@link CIQ.ChartEngine#setTimeZone} and {@link CIQ.ChartEngine#convertToDataZone} for more details.
	 * @param {number} [params.padding] Whitespace padding in pixels to apply to right side of chart after sizing for date range. If not present then 0 will be used.
	 * @param {CIQ.ChartEngine.Chart} [params.chart] Which chart, defaults to "chart"
	 * @param {boolean} [params.goIntoFuture] If true then the right side of the chart will be set into the future if dtRight is greater than last tick. See {@link CIQ.ChartEngine#staticRange} if you wish to make this your default behavior.
	 * @param {boolean} [params.goIntoPast] If true then the left side of the chart will be set into the past if dtLeft is less than first tick. See {@link CIQ.ChartEngine#staticRange} if you wish to make this your default behavior.
	 * @param {object} [params.periodicity] Override a specific periodicity combination to use with the range. Only available if a quoteFeed is attached to the chart. Note: if the chart is in tick periodicity, the periodicity will be automatically selected even if one was provided because in tick periodicity we have no way to know how many ticks to get to fulfill the requested range. If used, all 3 elements of this object must be set.
	 * @param {Number} params.periodicity.period Period as used by {@link CIQ.ChartEngine#setPeriodicity}
	 * @param {string} params.periodicity.interval An interval as used by {@link CIQ.ChartEngine#setPeriodicity}
	 * @param {string} params.periodicity.timeUnit A timeUnit as used by {@link CIQ.ChartEngine#setPeriodicity}
	 * @param {Number} params.pixelsPerBar] Optionally override this value so that the auto-periodicity selected chooses different sized candles.
	 * @param {boolean} params.dontSaveRangeToLayout If true then the range won't be saved to the layout.
	 * @param {Function} [cb] Callback method. Will be called with the error retuned by the quotefeed, if any.
	 * @memberOf CIQ.ChartEngine
	 * @since
	 * <br>&bull; 04-2015 params.rangePeriodicityMap and params.periodicity added as well as automatic integration with {@link CIQ.QuoteFeed}
	 * <br>&bull; 2016-05-10 params.rangePeriodicityMap deprecated in favor of new automatic algorithm
	 * <br>&bull; m-2016-12-01 restored logic to reference a periodicity map. Similar to previous `params.rangePeriodicityMap` . See {@link CIQ.ChartEngine#staticRangePeriodicityMap} for details
	 * <br>&bull; m-2016-12-01 modified automatic periodicity algorithm. See {@link CIQ.ChartEngine#dynamicRangePeriodicityMap} and {@link CIQ.ChartEngine#autoPickCandleWidth} for details
	 * <br>&bull; 4.0.0 now uses {@link CIQ.ChartEngine#needDifferentData} to determine if new data should be fetched.
	 * <br>&bull; 4.0.0 No longer defaulting padding to current value of preferences.whiteSpace
	 * <br>&bull; 5.1.0 params.dontSaveRangeToLayout added
	 * <br>&bull; 5.1.0 The selected range will be recorded in the chart {@link CIQ.ChartEngine#layout} when it is requested through {@link CIQ.ChartEngine#newChart}, or when you call setRange directly.
	 * @example
	 * // this will display all of the available data in the current chart periodicity
	    stxx.setRange({
	        dtLeft: stxx.chart.dataSet[0].DT,
	        dtRight: stxx.chart.dataSet[stxx.chart.dataSet.length - 1].DT,
	        periodicity:{period:stxx.layout.periodicity,interval:stxx.layout.interval,timeUnit:stxx.layout.timeUnit}
	    });
	 */
      CIQ.ChartEngine.prototype.setRange = function(params, cb) {
        if (CIQ.isEmpty(params)) {
          // Handle legacy argument list implementation
          params = {
            dtLeft: arguments[0],
            dtRight: arguments[1],
            padding: arguments[2],
            chart: arguments[3],
          }
          cb = arguments[4]
        }
        if (this.staticRange) {
          params.goIntoPast = params.goIntoFuture = true
        }

        if (!params.chart) params.chart = this.chart
        if (typeof params.padding == 'undefined') {
          // if no whitespace sent in, maintain existing ( different than sending 0 which will set to no whitespace )
          params.padding = 0
        }
        var dontChangePeriodicity = false
        var chart = params.chart
        var lt =
          typeof params.dtLeft === 'string'
            ? new Date(params.dtLeft)
            : params.dtLeft // just in case a string date is passed in
        var rt = this.convertToDataZone(new Date())
        if (params.dtRight)
          rt =
            typeof params.dtRight === 'string'
              ? new Date(params.dtRight)
              : params.dtRight
        if (!lt) {
          // If no left date then we want to just flush the right edge, and keep the same interval,period
          var iter = this.standardMarketIterator(rt, null, chart)
          lt = iter.previous(chart.maxTicks)
          if (!params.periodicity) dontChangePeriodicity = true
        }
        chart.inflectionPoint = lt //  this is where consolidation originates in either direction

        var self = this
        function showTheRange(err) {
          if (typeof err == 'undefined') err = null

          var l = 0,
            r = 0
          var todaysDate = new Date()
          var base = params.base
          var periodicity = params.periodicity
          var layout = self.layout

          if (
            params.goIntoFuture &&
            (!chart.masterData.length ||
              lt > chart.masterData[chart.masterData.length - 1].DT)
          ) {
            // we're displaying entirely in the future, fill gap
            var leftmost = chart.masterData.length
              ? chart.masterData.pop()
              : { DT: lt }
            var gapData = self.doCleanupGaps([leftmost, { DT: rt }], chart, {
              cleanupGaps: 'gap',
            })
            self.setMasterData(chart.masterData.concat(gapData))
            self.createDataSet(null, null, { appending: true })
          }
          var dataSet = chart.dataSet
          var dsLength = dataSet.length

          if (!dataSet || dsLength === 0) {
            if (cb) cb(err)
            return
          }

          // range is day and interval is day
          if (
            base === 'day' &&
            (periodicity && periodicity.interval === 'day')
          ) {
            var multiplier = params.multiplier
            // left bar is how many days the range is, or beginning of dataset
            var leftBar = dsLength < multiplier ? 0 : dsLength - multiplier
            l = leftBar
            r = dsLength - 1
          }
          // if intraday range and last day in dataSet doesn't equal current day then show previous day's data
          else if (
            base === 'today' &&
            dataSet[dsLength - 1].DT.getDate() != todaysDate.getDate()
          ) {
            var leftDT = new Date(dataSet[dsLength - 1].DT.getTime())
            var rightDT = new Date(leftDT.getTime())

            for (var d = dsLength - 1; d >= 0; d--) {
              if (dataSet[d] && dataSet[d].DT.getDate() != leftDT.getDate()) {
                leftDT = new Date(+dataSet[d + 1].DT)
                break
              }
            }
            if (rightDT.getTime() == leftDT.getTime()) {
              leftDT = new Date(+dataSet[0].DT)
            }

            l = self.tickFromDate(leftDT, chart, null, true)
            r = self.tickFromDate(rightDT, chart)
          } else {
            if (lt.getTime() >= dataSet[0].DT.getTime() || params.goIntoPast) {
              l = self.tickFromDate(lt, chart, null, true)
            } else {
              l = 0
            }
            if (
              rt.getTime() <= dataSet[dsLength - 1].DT.getTime() ||
              params.goIntoFuture
            ) {
              r = self.tickFromDate(rt, chart)
            } else {
              r = dsLength - 1
            }
          }
          var ticks = r - l + 1

          if (ticks < 1) {
            if (cb) cb(err)
            return
          }

          var leftMargin = self.getLabelOffsetInPixels(
            self,
            chart,
            layout.chartType
          )
          var padding = Math.max(leftMargin, params.padding)
          if (r < dsLength - 1) padding = 0
          //var barsHaveWidth=self.mainSeriesRenderer && self.mainSeriesRenderer.barsHaveWidth;
          var newCandleWidth = (chart.width - padding) / ticks //*(barsHaveWidth?1:(1-1/(2*ticks)));  // deduct 1/2 the proposed candlewidth for the micropixel offset for line type charts
          self.setCandleWidth(newCandleWidth, chart)
          chart.scroll = ticks - (r - dsLength) - 1
          self.micropixels = 1 // this is done to allow crosshairs over first tick when candles are small
          // line-type charts go center-to-center in the data point space, so we end up with 1/2 a candle empty on the left and the right..
          //if(!barsHaveWidth) self.micropixels+=newCandleWidth/2; // line charts display to middle of candle
          for (var p in self.panels)
            self.calculateYAxisMargins(self.panels[p].yAxis)

          // only save the range for direct calls to setRange
          if (!params.dontSaveRangeToLayout) {
            delete params.chart // having the chart in there causes an issue with cloning
            delete layout.setSpan // range and setSpan are mutually exclusive
            layout.range = params // save the range in the layout to be able to restore
          } else {
            // setRange called from setSpan, remove range from layout
            delete layout.range
          }

          self.draw()
          self.changeOccurred('layout')
          if (cb) cb(err)
        }

        var loadMoreCount = 0 // safety valve to eliminate infinite loop
        function loadTheRange(err) {
          if (err && loadMoreCount === 0) {
            // change the periodicity, scroll and candle width back to original chart values
            // if our initial fetch from the quotedriver failed.
            chart.scroll = previousScroll
            self.setCandleWidth(previousCandleWidth)
            self.layout.interval = previousInterval
            self.layout.periodicity = previousPeriodicity
            self.layout.timeUnit = previousTimeUnit
            if (cb) cb(err)
            return
          }
          loadMoreCount++
          if (loadMoreCount > 10) {
            console.log(
              'CIQ.ChartEngine.setRange(): Too many loads (10) from server. Stopping. Check periodicity logic.'
            )
            showTheRange()
            return
          }
          if (
            chart.moreAvailable &&
            chart.masterData[0] &&
            chart.masterData[0].DT > lt
          ) {
            self.quoteDriver.checkLoadMore(
              chart,
              true,
              false,
              function(err) {
                if (!err) loadTheRange()
                else showTheRange(err) // if there was an error on a subsequent fetch, then show as much as we were able to get.
              },
              true
            )
          } else {
            showTheRange()
          }
        }

        function estimateMaxTicks(
          rtMS,
          ltMS,
          interval,
          period,
          timeUnit,
          dontRoll
        ) {
          // how many ticks do we need at the requested periodicity to fill the screen
          var ticks = 0
          var ms = rtMS - ltMS
          if (CIQ.ChartEngine.isDailyInterval(interval)) {
            if (interval == 'month') {
              ticks = ms / CIQ.MONTH / period
            } else if (interval == 'week') {
              ticks = ms / CIQ.WEEK / period
            } else {
              ticks = ms / CIQ.DAY / period
            }
          } else {
            if (!isNaN(interval)) {
              if (timeUnit == 'millisecond') ticks = ms / (period * interval)
              else if (timeUnit == 'second')
                ticks = ms / CIQ.SECOND / (period * interval)
              else ticks = ms / CIQ.MINUTE / (period * interval)
            }
          }
          return Math.round(ticks) // rough estimation...
        }

        if (this.quoteDriver) {
          var intervalToUse, periodToUse, timeUnitToUse
          if (dontChangePeriodicity) {
            intervalToUse = this.layout.interval
            timeUnitToUse = this.layout.timeUnit
            periodToUse = this.layout.periodicity
          } else if (params.periodicity) {
            // If the caller specifies the periodicity then we use that
            var internalPeriodicity = CIQ.cleanPeriodicity(
              params.periodicity.period,
              params.periodicity.interval,
              params.periodicity.timeUnit
            )
            intervalToUse = internalPeriodicity.interval
            timeUnitToUse = internalPeriodicity.timeUnit
            periodToUse = internalPeriodicity.period
          } else {
            // Set the periodicity according to the staticRangePeriodicityMap
            // This will check the milliseconds of each range and choose the proper width
            var rangeInMS = rt.getTime() - lt.getTime()
            if (!this.autoPickCandleWidth.turnOn) {
              var periodicityMap = this.staticRangePeriodicityMap

              var entryToUse = null
              // Cycle through the periodicity map looking for the closest fit
              for (var i = 0; i < periodicityMap.length; i++) {
                var mapEntry = periodicityMap[i]

                if (rangeInMS / mapEntry.rangeInMS < 1.001) {
                  // inexact due to quote updates
                  entryToUse = mapEntry
                  break
                }
              }
              intervalToUse = entryToUse.interval
              periodToUse = entryToUse.periodicity
              timeUnitToUse = entryToUse.timeUnit
            } else {
              // Calculate the best periodicity dynamically according to the intervals
              // set in dynamicRangePeriodicityMap
              var pixelsPerBar = 0

              // use candlewidth set in the chart
              if (this.autoPickCandleWidth.candleWidth) {
                pixelsPerBar = this.autoPickCandleWidth.candleWidth
              }
              // else choose candlewidth according to chart type
              else {
                pixelsPerBar = this.barsHaveWidth[this.layout.chartType] ? 5 : 2
              }

              var numBars = chart.width / pixelsPerBar

              var possibleIntervals = this.dynamicRangePeriodicityMap

              // default
              intervalToUse = possibleIntervals[0].interval
              periodToUse = 1

              var numBarsLastInterval
              for (var j = 0; j < possibleIntervals.length; j++) {
                var numBarsThisInterval =
                  rangeInMS / possibleIntervals[j].rangeInMS
                if (numBarsThisInterval < numBars) {
                  if (possibleIntervals[j - 1]) {
                    intervalToUse = possibleIntervals[j - 1].interval
                    timeUnitToUse = possibleIntervals[j - 1].timeUnit
                    periodToUse = Math.ceil(numBarsLastInterval / numBars)
                  } else {
                    intervalToUse = possibleIntervals[j].interval
                    timeUnitToUse = possibleIntervals[j].timeUnit
                    periodToUse = 1
                  }
                  break
                }
                numBarsLastInterval = numBarsThisInterval
              }
            }
          }

          // maintain the previous values just in case an error is thrown when getting new data
          var previousScroll = this.chart.scroll
          var previousCandleWidth = this.layout.candleWidth
          var previousInterval = this.layout.interval
          var previousPeriodicity = this.layout.periodicity
          var previousTimeUnit = this.layout.timeUnit

          // to prevent multiple fetches trying to get enough ticks for the selected range;
          // maxticks,scroll and  candleWidth are used in CIQ.ChartEngine.Driver.barsToFetch and checkLoadMore() to deduce the number of ticks to fill the screen.
          // So we need to set it here to prevent us from using the pre-setRange  values which are not going to be right.
          // these are estimated, for the fetch, but will be properly recalculated by showTheRange();
          this.chart.scroll = this.chart.maxTicks = estimateMaxTicks(
            rt.getTime(),
            lt.getTime(),
            intervalToUse,
            periodToUse,
            timeUnitToUse,
            this.dontRoll
          )
          this.layout.candleWidth = this.chart.width / this.chart.maxTicks

          // logic to determine whether we have the right interval for what is needed
          var needDifferentData = this.needDifferentData({
            period: periodToUse,
            interval: intervalToUse,
            timeUnit: timeUnitToUse,
          })

          // if we need data from before what we have, fetch new data
          if (
            this.chart.masterData &&
            this.chart.masterData.length &&
            this.chart.masterData[0].DT > lt
          )
            needDifferentData = true

          if (
            !this.chart.masterData ||
            !this.chart.masterData.length ||
            needDifferentData ||
            params.forceLoad
          ) {
            this.layout.interval = intervalToUse
            this.layout.periodicity = periodToUse
            this.layout.timeUnit = timeUnitToUse
            if (!this.layout.timeUnit) {
              if (CIQ.ChartEngine.isDailyInterval(this.layout.interval))
                this.layout.timeUnit = null
              else if (this.layout.interval == 'second')
                this.layout.timeUnit = 'second'
              // backward compatibility with heatmap
              else if (this.layout.interval != 'tick')
                this.layout.timeUnit = 'minute'
            }
            var qparams = {
              symbol: chart.symbol,
              symbolObject: chart.symbolObject,
              chart: chart,
              nodraw: true,
            }
            if (this.layout.interval == 'tick') {
              // for 'tick' periodcity we have to request a specific range instead of # of ticks,
              //since we can never be sure how many ticks will be in a particular range.
              qparams.startDate = lt
              qparams.endDate = rt
            }

            if (!this.displayInitialized) qparams.initializeChart = true //TODO, this is confusing to developers. They think it means newChart()
            qparams.startDate = new Date(2 * lt - rt)
            qparams.startDate.setHours(0, 0, 0, 0)
            this.quoteDriver.newChart(qparams, loadTheRange)
          } else {
            if (
              this.layout.interval != intervalToUse ||
              this.layout.periodicity != periodToUse ||
              this.layout.timeUnit != timeUnitToUse ||
              !this.chart.dataSegment ||
              !this.chart.dataSegment[0] ||
              this.chart.dataSegment[0].DT != chart.inflectionPoint
            ) {
              this.layout.interval = intervalToUse
              this.layout.periodicity = periodToUse
              this.layout.timeUnit = timeUnitToUse
              this.createDataSet()
            }
            loadTheRange()
          }
        } else {
          showTheRange()
        }
      }

      /**
       * Sets the chart to display the requested time span.
       *
       * setSpan makes use of {@link CIQ.ChartEngine#setRange} by converting the span requested into a date range.
       * All parameters in setSpan will be sent into setRange (except if 'all' is requested), so you can pre-load things like `params.periodicity` in setSpan for setRange to use.
       *
       * Example:
       * <pre>
       * stxx.setSpan ({
       *   multiplier: 5,
       *   base: "day",
       *   padding: 30,
       *   // pre load a parameter for setRange
       *   periodicity:{
       *   	period:1,
       *   	interval:5,
       *   	timeUnit:'minute'
       *   }
       * });
       * </pre>
       *
       * Just keep in mind that if passing `periodicity.interval` and `periodicity.period` to be used in {@link CIQ.ChartEngine#setRange} , then **DO NOT** set `maintainPeriodicity`. Otherwise, the requested periodicity will be ignored.
       *
       * If a quotefeed is attached to the chart (ver 04-2015 and up), setSpan will attempt to gather more data from the feed (IF NEEDED) to fulfill the requested range AND **may override the periodicity** to provide the most optimal chart display.
       * So depending on your UI, **you may need to use the callback to refresh the periodicity displayed on your menu**.
       * Please see {@link CIQ.ChartEngine#setRange}	 and {@link CIQ.ChartEngine#displayAll} for complete details on how the periodicity is calculated.
       * <br>If there is no quotefeed attached (or using a version prior to 04-2015), then setStan will use whatever data is available in the masterData. So you must ensure you have preloaded enough to display the requested range.
       *
       * Calling {@link CIQ.ChartEngine#setPeriodicity} immediately after setting a span may cause all of the data to be re-fetched at a different periodicity than the one used by the requested span. Once you have set your initial periodicity for the chart, there is no need to manually change it when setting a new span unless you are using the `params.maintainPeriodicity` flag; in which case you want to call `setPeriodicity` **before** you set the span, so the setSpan call will use the pre-set periodicity.
       * <br>Setting a span to `params.multiplier:7` `params.base:'days'` or `params.multiplier:1` `params.base:'week'`, for example, is really the same thing; same span of time. If what you are trying to do is tell the chart how you want the raw data to be fetched, that is done with {@link CIQ.ChartEngine#setPeriodicity} or by letting setSpan figure it out as described above.
       * <br>Remember that by default, weekly and monthly data is calculated using daily raw ticks. If your feed returns data already rolled up in monthly or weekly ticks, you can override this behavior by setting `stxx.dontRoll` to `true` ( see {@link CIQ.ChartEngine#dontRoll}  and the {@tutorial Periodicity} tutorial)
       *
       * This function must be called **after** newChart() completes and creates a dataSet, or together with newChart() by setting the proper parameter values.
       * If calling separately right after newChart(), be sure to call it in the newChart() callback!.
       * See example in this section and {@link CIQ.ChartEngine#newChart} for more details and compatibility with your current version.
       *
       * **Note: ** versions prior to '2015-05-01' must use the legacy arguments : setSpan(multiplier, base, padding, char,useMarketTZ,cb), and related example in this section.
       *
       * ** Layout preservation and the span **
       * <br>If `maintainPeriodicity` is not set, the selected span will be recorded in the chart {@link CIQ.ChartEngine#layout} when it is requested through {@link CIQ.ChartEngine#newChart}, or when you call setSpan directly.
       * <br>It is then used in {@link CIQ.ChartEngine#importLayout} and {@link CIQ.ChartEngine#newChart} to reset that span, until a new periodicity is selected.
       *
       * @param {object} params Parameter for the function
       * @param {number} params.multiplier   Number of base units to show. To show 3 weeks of data, for example, set this to 3 and `params.base` to 'week'.
       * @param {string} params.base The base span to show. "minute","hour","day","week","month","year","all", "ytd" or "today".
       * <br>This span will be combined with the multiplier. Example 2 days, 4 months.
       * <br>** These spans are market hours sensitive **, so if you ask for 1 hour, for example, at the time the markets are close,
       * the span will find the last time the markets where open for the active symbol, and include the last market hour in the span.
       * It will also exclude days when the market is closed.
       * <br>&bull; If 'all' data is requested, {@link CIQ.ChartEngine#displayAll} is called first to ensure all quotefeed data for that particular instrument is loaded. Note that 'all' will display the data in `monthly` periodicity unless otherwise specified. Please note that "all" will attempt to load all of the data the quotefeed has available for that symbol. Use this span with caution.
       * <br>&bull; If 'today' is requested, the chart will display the current market day but extend the chart all the way to market close (as per market hours set in the active market definition - see {@link CIQ.Market})
       * <br>&bull; If 1 'day' is requested --on market days--,the chart will start from same time on the previous market day, wich may be over a weekend. Example from 3:30 PM Friday to 3:30 PM Monday, if the market is closed Saturday and Sunday.
       * <br>&bull; If 1 'day' is requested --on weekends and holidays-- or if 2 or more days are requested, the chart will will always start from market open of prior days.
       * @param {boolean} [params.maintainPeriodicity] If set to true, it will maintain the current periodicity for the chart instead of trying to select the most optimal periodicity for the selected range. See {@link CIQ.ChartEngine#setRange} for details.
       * <br>**Note:** if the chart is in `tick` periodicity, the periodicity will be automatically selected even if it was requested to be maintained because in `tick` periodicity we have no way to know how many ticks to get to fulfill the requested range.
       * @param {number} [params.padding] Whitespace padding in pixels to apply to right side of chart after sizing for date range. If not set will default whitespace to 0.
       * @param {boolean} [params.forceLoad] Forces a complete load (used by newChart)
       * @param {CIQ.ChartEngine.Chart} [params.chart] Which chart, defaults to "chart"
       * @param {Function} cb Optional callback
       * @memberOf CIQ.ChartEngine
       * @example
       * // this displays 5 days. It can be called anywhere including buttons on the UI
       *	stxx.setSpan ({
       *		multiplier: 5,
       *		base: "day",
       *		padding: 30
       *	});
       * @example
       * // using embedded span requirements on a newChart() call.
       * stxx.newChart(
       *      {symbol:newSymbol,other:'stuff'},
       *      null,
       *      null,
       *      callbackFunction(),
       *      {
       *           span:{base:'day',multiplier:2},
       *      }
       * );
       * @example
       * // Calling setSpan in the newChart() callback to ensure synchronicity.
       * stxx.newChart(
       *      {symbol:newSymbol,other:'stuff'},
       *      null,
       *      null,
       *      function(){
       *		 	stxx.setSpan ({
       *				multiplier: 5,
       *				base: "day",
       *				padding: 30
       *			});
       *      }
       * );
       * @since
       * <br>&bull; 04-2015: added "all", "today", "ytd" and automatic integration with {@link CIQ.QuoteFeed}
       * <br>&bull; 15-07-01: params.period changed to params.multiplier for clarity
       * <br>&bull; 15-07-01: params.interval changed to params.base for clarity
       * <br>&bull; 05-2016-10: saves the set span in stxx.layout to be restored with the layout between sessions
       * <br>&bull; 4.0.3 saves all parameters of the requested span in stxx.layout to be restored with the layout between sessions. Previously only `multiplier` and `base` were saved.
       * <br>&bull; 5.0.0 when 1 'day' is requested data displayed will differ if current day is market day or the market is closed to ensure the span will have enough data.
       */
      CIQ.ChartEngine.prototype.setSpan = function(params, cb) {
        var period = arguments[0]
        var interval = arguments[1]
        var padding = arguments[2]
        var chart = arguments[3]

        if (typeof params == 'object') {
          period = params.period
            ? params.period
            : params.multiplier
            ? params.multiplier
            : 1
          interval = params.interval
            ? params.interval
            : params.base
            ? params.base
            : params.span
            ? params.span
            : params.period
          padding = params.padding
          chart = params.chart
        } else {
          params = {
            period: period,
            interval: interval,
            padding: padding,
            chart: chart,
          }
          cb = arguments[5]
        }
        // Do not force padding to 0 on setSpan
        //if(!params.padding) params.padding=0;

        if (!chart) chart = this.chart

        interval = interval.toLowerCase()
        if (interval == 'all') {
          this.displayAll(params, cb)
          return
        }
        var iterInterval = interval
        var iterPeriod = 1
        if (interval == 'today') {
          iterInterval = 'day'
        } else if (interval == 'year') {
          iterInterval = 'month'
          iterPeriod = 12
        }

        var parms_copy = CIQ.shallowClone(params)

        var iter_parms = {
          begin: new Date(),
          interval: iterInterval,
          period: iterPeriod,
          //'inZone': this.dataZone, default to browser timezone since we are just setting 'begin' in new Date()
          outZone: this.dataZone,
        }
        var iter
        if (interval !== 'ytd') iter = chart.market.newIterator(iter_parms)
        var leftDT = this.convertToDataZone(new Date())

        function zeroDT(dt) {
          dt.setHours(0)
          dt.setMinutes(0)
          dt.setSeconds(0)
          dt.setMilliseconds(0)
          return dt
        }
        if (interval === 'ytd') {
          leftDT = zeroDT(leftDT)
          leftDT.setMonth(0)
          leftDT.setDate(1)
        } else if (interval === 'today') {
          // forward and then back will land us on the most current valid market day
          iter.next()
          leftDT = iter.previous()
          if (leftDT > iter_parms.begin) leftDT = iter.previous() // from market close until midnight
        } else if (interval === 'month') {
          leftDT = zeroDT(new Date())
          leftDT.setMonth(leftDT.getMonth() - period)
        } else if (interval === 'year') {
          leftDT = zeroDT(new Date())
          leftDT.setFullYear(leftDT.getFullYear() - period)
        } else if (interval === 'week') {
          leftDT = zeroDT(new Date())
          leftDT.setDate(leftDT.getDate() - period * 7)
        } else if (
          interval === 'day' &&
          period == 1 &&
          this.chart.market.isMarketDay()
        ) {
          // Special case, 1 "day" --on market days-- will start from same time on previous market day
          // 1 day in weekends and holidays or 2 or more days will always start from market open of prior days (next else)
          var h = leftDT.getHours()
          var m = leftDT.getMinutes()
          var s = leftDT.getSeconds()
          var mm = leftDT.getMilliseconds()
          leftDT = iter.previous()
          leftDT.setHours(h)
          leftDT.setMinutes(m)
          leftDT.setSeconds(s)
          leftDT.setMilliseconds(mm)
        } else {
          if (period == 1) period++
          leftDT = iter.previous(period - 1)
        }
        parms_copy.dtLeft = leftDT
        if (interval === 'today') {
          parms_copy.goIntoFuture = true
          parms_copy.dtRight = new Date(+leftDT)
          parms_copy.dtRight.setDate(leftDT.getDate() + 1)
          parms_copy.dtRight = chart.market._convertFromMarketTZ(
            parms_copy.dtRight,
            this.dataZone
          )

          parms_copy.dtLeft.setHours(iter.market.zopen_hour)
          parms_copy.dtLeft.setMinutes(iter.market.zopen_minute)
          parms_copy.dtLeft.setSeconds(0)
          parms_copy.dtLeft = chart.market._convertFromMarketTZ(
            parms_copy.dtLeft,
            this.dataZone
          )
        }
        if (parms_copy.maintainPeriodicity) {
          parms_copy.periodicity = {}
          parms_copy.periodicity.interval = this.layout.interval
          parms_copy.periodicity.period = this.layout.periodicity
        }
        chart.spanLock = false // unlock left edge
        parms_copy.dontSaveRangeToLayout = true // don't do certain things in setRange when being called from setSpan
        var self = this
        this.setRange(parms_copy, function(err) {
          self.layout.setSpan = params
          self.changeOccurred('layout')

          if (interval == 'today') {
            chart.spanLock = true // lock left edge of screen, in callback after we have fetched!
          }
          if (cb) cb(err)
        })
      }

      //@private
      // Foobarred function.  Does not handle today or all properly.  Assumes daily data.  Not called from anywhere.
      CIQ.ChartEngine.prototype.getSpanCandleWidth = function(span) {
        if (!span || !span.base || !span.multiplier) return
        var num = parseFloat(span.multiplier)
        var base = span.base
        var now = new Date()
        var prev = new Date()
        if (base == 'year') {
          prev.setFullYear(prev.getFullYear() - num)
        } else if (base == 'month') {
          prev.setMonth(prev.getMonth() - num)
        } else if (base == 'day') {
          prev.setDate(prev.getDate() - num)
        } else if (base == 'week') {
          prev.setDate(prev.getDate() - 7 * num)
        } else if (base == 'YTD') {
          prev.setMonth(0)
          prev.setDate(1)
        }
        var diff = (now.getTime() - prev.getTime()) / 1000 / 60 / 60 / 24
        diff = (diff * 5) / 7
        var candleWidth = this.chart.width / diff
        return candleWidth
      }

      /**
       * Sets a chart to display all data for a security.
       *
       * If no feed is attached, it will simply display all the data loaded in the present periodicity.
       * <br>If the chart is driven by a QuoteFeed and no periodicity is requested, it will default to 'monthly'.
       * It will then call QuoteDriver.loadAll() which makes multiple queries to ensure all data available from the quote feed is loaded.
       * Once all the data is loaded, the chart will be set to cover that range using {@link CIQ.ChartEngine#setRange}
       * @param {object} [params] Optional parameters in same format as {@link CIQ.ChartEngine#setSpan}.
       * @param {Function} [cb] Callback, is called when chart is displayed.
       * @since  04-2015
       * @memberOf CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.displayAll = function(params, cb) {
        var chart = this.chart
        if (params && params.chart) chart = params.chart
        var self = this
        function displayTheResults() {
          if (!chart.masterData || !chart.masterData.length) return
          var p = CIQ.clone(params)
          p.dtLeft = chart.masterData[0].DT
          p.dtRight = chart.masterData[chart.masterData.length - 1].DT
          if (params.maintainPeriodicity) {
            p.periodicity = {}
            p.periodicity.interval = self.layout.interval
            p.periodicity.period = self.layout.periodicity
          } else if (params.periodicity) {
            p.periodicity = params.periodicity
          }
          self.setRange(p, function(err) {
            if (!params.maintainPeriodicity) {
              self.layout.setSpan = {
                base: params.base,
                multiplier: params.multiplier,
              }
              self.changeOccurred('layout')
            }
            for (var p in self.panels)
              self.calculateYAxisMargins(self.panels[p].yAxis)
            self.draw()
            if (cb) cb(err)
          })
        }
        function loadAllTheData() {
          self.quoteDriver.loadAll(chart, displayTheResults)
        }

        // Case 1: no quoteFeed so display what we have
        if (!this.quoteDriver) {
          displayTheResults()
          return
        }

        var periodicity = params.maintainPeriodicity
          ? {
              periodicity: this.layout.periodicity,
              interval: this.layout.interval,
            }
          : { periodicity: 1, interval: 'month' }
        periodicity = params.periodicity ? params.periodicity : periodicity
        if (periodicity.period) periodicity.periodicity = periodicity.period // setSpan,setRange unfortunately use period instead of periodicity

        var needDifferentData = this.needDifferentData(periodicity)

        this.layout.periodicity = periodicity.periodicity
        this.layout.interval = periodicity.interval
        this.layout.timeUnit = periodicity.timeUnit

        // Case 2: new symbol or new periodicity
        if (params.forceLoad || needDifferentData) {
          this.quoteDriver.newChart(
            {
              noDraw: true,
              symbol: this.chart.symbol,
              symbolObject: this.chart.symbolObject,
              chart: this.chart,
              initializeChart: true,
              fetchMaximumBars: true,
            },
            loadAllTheData
          )
        } else {
          // Case 3, the right interval is set but we don't have all the data
          if (chart.moreAvailable) {
            loadAllTheData()
          } else {
            // Case 4, the right interval is set and we have all the data
            this.createDataSet() // Just in case the interval changed from month to day or vice versa
            displayTheResults()
          }
        }
      }

      return _exports
    }

  var __studies_ =
    //-------------------------------------------------------------------------------------------
    // Copyright 2012-2017 by ChartIQ, Inc.
    // All rights reserved
    //-------------------------------------------------------------------------------------------
    function(_exports) {
      //
      // Type definitions
      //

      /**
       * @typedef {object} minMax
       * @property {number} min The minimum data point
       * @property {number} max The maximum data point
       */

      /**
       * @typedef {object} studyDescriptor
       * @property {string} name The study's id
       * @property {object} inputs Keys for each possible study input with descriptors for the set and default values
       * @property {number} min The minimum data point
       * @property {number} max The maximum data point
       * @property {object} outputs Keys for each possible study output option
       * @property {string} panel ID of the panel element the study is attached to
       * @property {parameters} parameters Keys for each of the study's possible plot parameters
       * @property {string} type The study type
       */

      //
      // (end definitions)
      //

      var CIQ = _exports.CIQ

      /**
       * Namespace for functionality related to studies (aka indicators)
       * @namespace
       * @name  CIQ.Studies
       */
      CIQ.Studies = function() {}

      /**
       * Constants for when no inputs or outputs specified in studies.
       * Values can be changed but do not change keys.
       * @memberOf CIQ.Studies
       */
      CIQ.Studies.DEFAULT_INPUTS = { Period: 14 }
      CIQ.Studies.DEFAULT_OUTPUTS = { Result: 'auto' }

      /**
       * Array of study outputs which should be considered valid fields in the study dialog "Field" dropdown".
       * This is autopopulated from {@link CIQ.Studies.displayStudies}.
       * @type {Array}
       * @memberOf CIQ.Studies
       */
      CIQ.Studies.actualOutputs = []

      /**
       * Maps the names of studies to the panel that they are drawn on. For instance, a moving average may be drawn on an RSI panel
       * @type {Object}
       * @memberOf CIQ.Studies
       */
      CIQ.Studies.studyPanelMap = {}

      CIQ.Studies.colorPickerDiv = null

      /**
       * A study descriptor contains all of the information necessary to handle a study. READ ONLY.
       *
       * Do not try to manually create your own study descriptor, but rather always use the one returned by {@link CIQ.Studies.addStudy}
       *
       * @param {string} name       The name of the study. This should be unique to the chart. For instance if there are two RSI panels then they should be of different periods and named accordingly. Usually this is determined automatically by the library.
       * @param {string} type       The type of study, which can be used as a look up in the StudyLibrary
       * @param {string} panel      The name of the panel that contains the study
       * @param {object} inputs     Names and values of input fields
       * @param {object} outputs    Names and values (colors) of outputs
       * @param {object} parameters Additional parameters that are unique to the particular study
       * @memberOf CIQ.Studies
       */
      CIQ.Studies.StudyDescriptor = function(
        name,
        type,
        panel,
        inputs,
        outputs,
        parameters
      ) {
        this.name = name
        this.type = type
        this.panel = panel
        this.inputs = inputs
        this.outputs = outputs
        this.parameters = parameters // Optional parameters, i.e. zones
        this.outputMap = {} // Maps dataSet label to outputs label "RSI (14)" : "RSI", for the purpose of figuring color
        this.min = null
        this.max = null
        this.startFrom = 0
        var libraryEntry = CIQ.Studies.studyLibrary[type]
        if (!libraryEntry) {
          libraryEntry = {}
          if (
            panel == 'chart' ||
            (!panel && parameters && parameters.chartName == 'chart')
          )
            this.overlay = true
        }
        if (typeof libraryEntry.inputs == 'undefined')
          libraryEntry.inputs = CIQ.clone(CIQ.Studies.DEFAULT_INPUTS)
        if (typeof libraryEntry.outputs == 'undefined')
          libraryEntry.outputs = CIQ.clone(CIQ.Studies.DEFAULT_OUTPUTS)

        this.study = libraryEntry
        this.libraryEntry = libraryEntry // deprecated, backwards compatibility
      }

      /**
       * Automatically generates a unique name for the study instance. If a translation callback has been associated with the chart
       * object then the name of the study will be translated.
       * @param  {CIQ.ChartEngine} stx A chart engine instance
       * @param  {string} studyName Type of study
       * @param  {object} inputs The inputs for this study instance
       * @param {string} [replaceID] If it matches then return the same id
       * @param {string} [customName] If this is supplied, use it to form the full study name. Otherwise `studyName` will be used. <br>ie: if custom name is 'SAMPLE', the unique name returned would resemble "SAMPLE(paam1,param2,param3,...)-X".
       * @return {string} A unique name for the study
       * @memberOf CIQ.Studies
       * @since 5.1.1 added customName argument, if supplied, use it to form the full study name. Otherwise `studyName` will be used.
       */
      CIQ.Studies.generateID = function(
        stx,
        studyName,
        inputs,
        replaceID,
        customName
      ) {
        var libraryEntry = CIQ.Studies.studyLibrary[studyName]
        if (libraryEntry) {
          // only one instance can exist at a time if custom removal or no inputs, so return study name
          if (libraryEntry.customRemoval || CIQ.isEmpty(inputs))
            return customName || studyName
        }
        //Translation piece with either be default study name or customName if supplied
        var translationPiece = '\u200c' + (customName || studyName) + '\u200c'
        var id = translationPiece + ' ('
        var first = false
        for (var field in inputs) {
          if (field == 'id' || field == 'display') continue //skip these!
          if (field == 'Shading') continue //this does not merit being in the studyname
          var val = inputs[field]
          if (val == 'field') continue // skip default, usually means "Close"
          val = val.toString()
          if (CIQ.Studies.prettify[val] !== undefined)
            val = CIQ.Studies.prettify[val]
          if (!first) {
            first = true
          } else {
            if (val) id += ','
          }
          id += val
        }
        id += ')'

        //this tests if replaceID is just a warted version of id, int that case keep the old id
        if (replaceID && replaceID.indexOf(id) === 0) return replaceID

        // If the id already exists then we'll wart it by adding -N
        if (stx.layout.studies && stx.layout.studies[id]) {
          for (var i = 2; i < 50; i++) {
            var warted = id + '-' + i
            if (!stx.layout.studies[warted]) {
              id = warted
              break
            }
          }
        }
        return id
      }

      /**
       * Generates an object that can be used to create a dialog for creating or modifying a study.
       * The object will then contain arrays for inputs, outputs and parameters. Each
       * input will describe a form field that should be generated. Each output will describe a color
       * swatch that should be generated. The results of the dialog would then be passed to {@link CIQ.Studies.addStudy}.
       * The libraryEntry (required), which is the object that defines the prototype for a study, may contain attributes which are used
       * to help construct the input fields of the study dialog.  See documentation of {@link CIQ.Studies.studyLibrary}.
       * @param {object} params Object containing the following:
       * @param  {CIQ.Studies.StudyDescriptor} params.name Name of study to add
       * @param  {CIQ.Studies.StudyDescriptor} params.sd A study descriptor when modifying an existing study
       * @param  {CIQ.CIQ.ChartEngine} params.stx A chart object
       * @param  {Object} [params.inputs] Existing input parameters for the study (if modifying)
       * @param  {Object} [params.outputs] Existing output parameters for the study (if modifying)
       * @param  {Object} [params.parameters] Existing additional parameters for the study (if modifying)
       * @name  CIQ.Studies.DialogHelper
       * @constructor
       * @example
       * var helper=new CIQ.Studies.DialogHelper({sd:sd,stx:stx});
       * console.log(helper.inputs);
       * console.log(helper.outputs);
       * console.log(helper.parameters);
       */
      CIQ.Studies.DialogHelper = function(params) {
        var stx = (this.stx = params.stx)
        var sd = (this.sd = params.sd)
        this.name = sd ? sd.type : params.name
        this.inputs = []
        this.outputs = []
        this.parameters = []
        var libraryEntry = (this.libraryEntry = sd
          ? sd.study
          : CIQ.Studies.studyLibrary[params.name])
        if (typeof libraryEntry.inputs == 'undefined')
          libraryEntry.inputs = CIQ.clone(CIQ.Studies.DEFAULT_INPUTS)
        if (typeof libraryEntry.outputs == 'undefined')
          libraryEntry.outputs = CIQ.clone(CIQ.Studies.DEFAULT_OUTPUTS)
        var panel =
          sd && stx.panels[sd.panel]
            ? stx.panels[sd.panel]
            : { chart: stx.chart }
        var chart = panel.chart

        this.title = stx.translateIf(libraryEntry.name)

        this.attributes = libraryEntry.attributes
        if (!this.attributes) this.attributes = {}

        /*
		This code loops through the acceptable inputs for the study in question. The format of the input default in the studyLibrary determines what type of input
		is required. For instance a number requires an input field. A string will produce a select box, of moving averages for instance if the string is "ma".
		If the string is "field" then a select box of acceptable fields is displayed. Likewise, an array will show up as a select box.
		 */
        for (var i in libraryEntry.inputs) {
          var input = {}
          this.inputs.push(input)
          input.name = i
          input.heading = stx.translateIf(i)
          var acceptedData = libraryEntry.inputs[i]
          if (
            sd &&
            sd.inputs &&
            typeof sd.inputs[i] != 'undefined' &&
            sd.inputs[i] !== null
          )
            input.value = sd.inputs[i]
          else input.value = libraryEntry.inputs[i]

          input.defaultInput = libraryEntry.inputs[i]
          if (!this.attributes[i])
            this.attributes[i] = CIQ.Studies.inputAttributeDefaultGenerator(
              input.defaultInput
            )

          if (acceptedData.constructor == Number) {
            input.type = 'number'
          } else if (acceptedData.constructor == String) {
            var isMA = CIQ.Studies.movingAverageHelper(stx, input.defaultInput)
            if (isMA) {
              input.type = 'select'
              input.defaultInput = isMA
              var converted = CIQ.Studies.movingAverageHelper(stx, input.value)
              if (!converted) converted = input.value
              input.value = converted
              input.options = CIQ.Studies.movingAverageHelper(stx, 'options')
            } else if (acceptedData == 'field') {
              input.type = 'select'
              input.options = {}
              nextField: for (var field in chart.dataSet[
                chart.dataSet.length - 1
              ]) {
                if (
                  [
                    'Open',
                    'High',
                    'Low',
                    'Close',
                    'Adj_Close',
                    'hl/2',
                    'hlc/3',
                    'hlcc/4',
                    'ohlc/4',
                    chart.defaultPlotField,
                  ].indexOf(field) == -1
                ) {
                  // field not an actual output but rather is just an intermediate value, so skip
                  if (CIQ.Studies.actualOutputs.indexOf(field) == -1) continue
                  // can't modify study basing it on its own output data, which is changing due to the same modify (infinite loop)
                  // can't modify study A basing it on another study B which uses study A data, this causes infinite loop as well
                  if (params.sd) {
                    for (var out in params.sd.outputMap) {
                      // here we make sure that the output, and not a warted version of it, is in the field before skipping it.
                      if (
                        field.indexOf(out) != -1 &&
                        field.indexOf(out + '-') == -1
                      )
                        continue nextField
                    }
                  }
                }
                input.options[field] = stx.translateIf(field)
              }
              if (input.value == 'field') {
                input.value = 'Close'
              }
              if (input.defaultInput == 'field') {
                input.defaultInput = 'Close'
              }
            } else {
              input.type = 'text'
            }
          } else if (acceptedData.constructor == Boolean) {
            input.type = 'checkbox'
            if (
              input.value === true ||
              input.value == 'true' ||
              input.value == 'on'
            )
              input.value = true
          } else if (acceptedData.constructor == Array) {
            input.type = 'select'
            input.options = {}
            for (var ii = 0; ii < acceptedData.length; ii++) {
              input.options[acceptedData[ii]] = stx.translateIf(
                acceptedData[ii]
              )
            }
            if (input.value.constructor == Array) {
              input.value = input.value[0]
            }
            input.defaultInput = acceptedData[0]
          }
        }

        /*
		Outputs are much simpler than inputs. Outputs are simply a list of available outputs and the selected color for that output. So here
		we print a line item in the dialog for each output and attach a color picker to it. The color picker is obtained from the Context.
		 */

        for (i in libraryEntry.outputs) {
          var output = {
            name: i,
            heading: stx.translateIf(i),
          }
          this.outputs.push(output)

          output.color = output.defaultOutput = libraryEntry.outputs[i]
          if (sd && sd.outputs && sd.outputs[i]) output.color = sd.outputs[i]
          if (output.color == 'auto') output.color = stx.defaultColor
        }

        /* And now the parameters */

        if (
          libraryEntry.parameters &&
          libraryEntry.parameters.template == 'studyOverZones'
        ) {
          var init = libraryEntry.parameters.init
          if (init) {
            var obj
            obj = {
              name: 'studyOverZones',
              heading: stx.translateIf('Show Zones'),
              defaultValue: init.studyOverZonesEnabled,
              value: init.studyOverZonesEnabled,
            }
            var parameters = sd ? sd.parameters : null
            if (
              parameters &&
              (parameters.studyOverZonesEnabled ||
                parameters.studyOverZonesEnabled === false)
            ) {
              obj.value = parameters.studyOverZonesEnabled
            }
            this.parameters.push(obj)

            obj = {
              name: 'studyOverBought',
              heading: stx.translateIf('OverBought'),
              defaultValue: init.studyOverBoughtValue,
              value: init.studyOverBoughtValue,
              defaultColor: init.studyOverBoughtColor,
              color: init.studyOverBoughtColor,
            }
            if (parameters && parameters.studyOverBoughtValue)
              obj.value = parameters.studyOverBoughtValue
            if (parameters && parameters.studyOverBoughtColor)
              obj.color = parameters.studyOverBoughtColor
            if (obj.color == 'auto') obj.color = stx.defaultColor
            this.parameters.push(obj)

            obj = {
              name: 'studyOverSold',
              heading: stx.translateIf('OverSold'),
              defaultValue: init.studyOverSoldValue,
              value: init.studyOverSoldValue,
              defaultColor: init.studyOverSoldColor,
              color: init.studyOverSoldColor,
            }
            if (parameters && parameters.studyOverSoldValue)
              obj.value = parameters.studyOverSoldValue
            if (parameters && parameters.studyOverSoldColor)
              obj.color = parameters.studyOverSoldColor
            if (obj.color == 'auto') obj.color = stx.defaultColor
            this.parameters.push(obj)

            if (!this.attributes.studyOverBoughtValue)
              this.attributes.studyOverBoughtValue = {}
            if (!this.attributes.studyOverSoldValue)
              this.attributes.studyOverSoldValue = {}
          }
        }
      }

      /**
       * Update (or add) the study attached to the DialogHelper.
       * @param  {Object} updates If updating, it should contain an object with updates to the `inputs`, `outputs` and `parameters` object used in {@link CIQ.Studies.addStudy}.  A new study ID will be created using the default format or parameters.replaceID, if provided.
       * @memberOf CIQ.Studies.DialogHelper
       * @example
       * var helper=new CIQ.Studies.DialogHelper({sd:sd, stx:stx});
       * helper.updateStudy({inputs:{Period:60}});
       */
      CIQ.Studies.DialogHelper.prototype.updateStudy = function(updates) {
        var newParams = {}
        var sd = this.sd
        var libraryEntry = this.libraryEntry
        if (!libraryEntry) libraryEntry = {}
        if (!sd) sd = libraryEntry
        newParams.inputs = CIQ.shallowClone(sd.inputs)
        newParams.outputs = CIQ.clone(sd.outputs)
        newParams.parameters = CIQ.shallowClone(sd.parameters)
        CIQ.extend(newParams, updates)
        if (!newParams.parameters) newParams.parameters = {}
        if (newParams.inputs && newParams.inputs.id) {
          this.sd = CIQ.Studies.replaceStudy(
            this.stx,
            newParams.inputs.id,
            this.name,
            newParams.inputs,
            newParams.outputs,
            newParams.parameters,
            null,
            sd.study
          )
        } else {
          this.sd = CIQ.Studies.addStudy(
            this.stx,
            this.name,
            newParams.inputs,
            newParams.outputs,
            newParams.parameters,
            null,
            sd.study
          )
        }
      }

      /**
       * Prepares a study descriptor for use by assigning default calculation or display functions if required and configuring the outputMap
       * which is used internally to determine the color for each output. This method also places any overlays into the stx.overlays array for
       * future reference. Finally it is responsible for rebuilding any derived studies when replacing an underlying study.
       * @private
       * @param  {CIQ.ChartEngine} stx A chart object
       * @param  {object} study The study library entry
       * @param  {studyDescriptor} sd The study descriptor being prepared
       * @param  {object} [parameters] Object containing any of the following options:
       * @param  {boolean} [parameters.replaceID] Remove any overlays that relies on the old panel ID name
       * @memberOf CIQ.Studies
       */
      CIQ.Studies.prepareStudy = function(stx, study, sd, parameters) {
        if (typeof study.calculateFN == 'undefined') study.useRawValues = true
        //if(typeof(study.seriesFN)=="undefined") study.seriesFN=CIQ.Studies.displaySeriesAsLine;

        if (parameters && parameters.replaceID) {
          // Remove any overlays that relied on the old panel ID name, for instance a moving average on RSI(14) is no
          CIQ.Studies.rejiggerDerivedStudies(
            stx,
            parameters.replaceID,
            sd.inputs.id,
            sd.panel
          )
          delete parameters.replaceID
        }

        // Unless overridden by the calculation function we assume the convention that the dataSet entries
        // will begin with the output name such as "RSI rsi (14)"
        if (CIQ.isEmpty(sd.outputMap)) {
          for (var i in sd.outputs) {
            if (study.useRawValues) {
              sd.outputMap[i] = i
            } else {
              sd.outputMap[i + ' ' + sd.name] = i
            }
          }
        }
        if (sd.overlay || sd.underlay) {
          stx.overlays[sd.name] = sd
        }
        if (study.feed) {
          stx.attachTagAlongQuoteFeed(study.feed)
        } else if (!stx.currentlyImporting) {
          // silent mode while importing
          if (sd.chart.dataSet) stx.createDataSet()
          stx.draw()
        }
      }

      /**
       * Fixes any derived studies that were based off of a study that has just changed.
       * For instance a moving average on another overlay, or a moving average on an RSI.
       * The panel name needs to change and the input "Field".
       * @param  {CIQ.ChartEngine} stx       The stx instance
       * @param  {string} replaceID The old ID for the underlying study e.g. RSI (14)
       * @param  {string} newID     The new ID for the underlying study
       * @param  {string} panelID     The panel name of the underlying study
       */
      CIQ.Studies.rejiggerDerivedStudies = function(
        stx,
        replaceID,
        newID,
        panelID
      ) {
        var studies = stx.layout.studies,
          overlays = stx.overlays
        for (var s in studies) {
          var st = studies[s]
          var inputs = st.inputs
          var derivedID = inputs.id
          if (
            inputs.id.indexOf(replaceID) != -1 &&
            inputs.id.indexOf(replaceID + '-') == -1
          ) {
            //check if exact field (and not warted one) exists in input
            var newDerivedID = inputs.id.replace(replaceID, newID) // The new ID, naively accomplished with string replace
            var stNeedsReplacement = false
            var fieldInputs = CIQ.Studies.getFieldInputs(st)
            for (var f = 0; f < fieldInputs.length; f++) {
              if (inputs[fieldInputs[f]].indexOf(replaceID) != -1) {
                // Yuck, we should implement actual parent
                var oldName = st.name
                inputs[fieldInputs[f]] = inputs[fieldInputs[f]].replace(
                  replaceID,
                  newID
                ) // Adjust the field name, tricky because the field name is "output (id)" and we don't really know the outputs
                inputs.id = inputs.id.replace(replaceID, newID)
                inputs.display = inputs.display.replace(replaceID, newID)
                st.name = st.name.replace(replaceID, newID)
                st.outputMap = {}
                for (var i in st.outputs) {
                  if (st.study.useRawValues) {
                    st.outputMap[i] = i
                  } else {
                    st.outputMap[i + ' ' + st.name] = i
                  }
                }
                stNeedsReplacement = true
              }
            }
            if (stNeedsReplacement)
              CIQ.Studies.replaceStudy(
                stx,
                derivedID,
                st.type,
                st.inputs,
                st.outputs,
                st.parameters
              )
          }
        }
      }

      /**
       * Removes any series that the study is referencing
       * @param {object} sd 			Study descriptor
       * @param {CIQ.ChartEngine} stx The chart engine
       * @memberOf CIQ.Studies
       * @since 3.0.0
       * @since  3.0.7 changed "name" argument to take a study descriptor
       * @since  3.0.7 added required stx argument
       */
      CIQ.Studies.removeStudySymbols = function(sd, stx) {
        if (sd.series)
          stx.deleteSeries(sd.series, null, { action: 'remove-study' })
        //stx.draw();
      }

      /**
       * Replaces an existing study with new inputs, outputs and parameters. When using this method
       * a study's position in the stack will remain the same. Derived (child) studies will shift to
       * use the new study as well
       * @param {CIQ.ChartEngine} stx        The chart object
       * @param {string} id 		The id of the current study. If set, then the old study will be replaced
       * @param {string} type       The name of the study (out of the studyLibrary)
       * @param {object} [inputs]     Inputs for the study instance. Default is those defined in the studyLibrary.
       * @param {object} [outputs]    Outputs for the study instance. Default is those defined in the studyLibrary.
       * @param {object} [parameters] additional custom parameters for this study if supported or required by that study
       * @param {string} [panelName] Optionally specify the panel. If not specified then an attempt will be made to locate a panel based on the input id or otherwise created if required.
       * @param {object} [study] Optionally supply a study definition, overriding what may be found in the study library
       * @return {object} A study descriptor which can be used to remove or modify the study.
       * @since 3.0.0 added study argument
       * @memberOf CIQ.Studies
       */
      CIQ.Studies.replaceStudy = function(
        stx,
        id,
        type,
        inputs,
        outputs,
        parameters,
        panelName,
        study
      ) {
        if (!parameters) parameters = {}
        if (id) parameters.replaceID = id
        if (inputs.id == inputs.display) delete inputs.display
        delete inputs.id
        var sd = stx.layout.studies[parameters.replaceID]
        CIQ.Studies.removeStudySymbols(sd, stx)
        if (stx.quoteDriver) stx.quoteDriver.updateSubscriptions()
        return CIQ.Studies.addStudy(
          stx,
          type,
          inputs,
          outputs,
          parameters,
          panelName,
          study
        )
      }

      /**
       * Adds or replace a study on the chart. A layout change event is triggered when this occurs.
       * <P>Example: <iframe width="800" height="500" scrolling="no" seamless="seamless" align="top" style="float:top" src="http://jsfiddle.net/chartiq/5y4a0kry/embedded/result,js,html,css/" allowfullscreen="allowfullscreen" frameborder="1"></iframe>
       *
       * Optionally you can assign the edit callback to a function that can handle initialization of a dialog box for editing studies.
       * If the callback is not assigned a function, the edit study buttons/functionality will not appear.
       * The 'Study Edit' feature is standard functionality in the advanced package.
       *
       * Prior to version 2015-07-01, all edit functionality was handled by `stx.editCallback` and was limited to panel studies.
       * Starting on version 2015-07-01, edit functionality is handled by `stxx.callbacks.studyPanelEdit` and `stxx.callbacks.studyOverlayEdit`; and it is available on both panel studies and overly studies.
       * See Examples for exact function parameters and return value requirements.
       * Please note that these callbacks must be set **before** you call importLayout. Otherwise your imported studies will not have an edit capability.
       *
       * @param {CIQ.ChartEngine} stx        The chart object
       * @param {string} type       The name of the study (object key on the {@link CIQ.Studies.studyLibrary})
       * @param {object} [inputs]     Inputs for the study instance. Default is those defined in the studyLibrary. Note that if you specify this object, it will be combined with (override) the library defaults. To bypass a library default, set that field to null.
       * @param {string} [inputs.id] The id of the current study. If set, then the old study will be replaced
       * @param {string} [inputs.display] The display name of the current study. If not set, a name generated by {@link CIQ.Studies.prettyDisplay} will be used. Note that if the study descriptor defines a `display` name, the study descriptor name will allays override this parameter.
       * @param {object} [outputs]    Outputs for the study instance. Default is those defined in the studyLibrary. Values specified here will override those in the studyLibrary.
       * @param {object} [parameters] Additional custom parameters for this study if supported or required by that study. Default is those defined in the {@link CIQ.Studies.studyLibrary}.
       * @param {object} [parameters.replaceID] If `inputs.id` is specified, this value can be used to set the new ID for the modified study( will display as the study name on the study panel). If omitted the existing ID will be preserved.
       * @param {object} [parameters.display] If this is supplied, use it to form the full study name. Otherwise `studyName` will be used. <br>ie: if custom name is 'SAMPLE', the unique name returned would resemble "SAMPLE(paam1,param2,param3,...)-X".
       * @param {string} [panelName] Optionally specify the panel. The relationship between studies and their panels is kept in {@link CIQ.Studies.studyPanelMap}. If not specified then an attempt will be made to locate a panel based on the input id or otherwise created if required.
       * @param {object} [study] Optionally supply a study definition, overriding what may be found in the study library
       * @return {object} A study descriptor which can be used to remove or modify the study.
       * @since
       * <br>&bull; 3.0.0 added study argument
       * <br>&bull; 5.1.1 `parameters.display` added. If this is supplied, use it to form the full study name.
       * @memberOf CIQ.Studies
       * @example
       * CIQ.Studies.addStudy(stxx, "vol undr", {}, {"Up Volume":"#8cc176","Down Volume":"#b82c0c"});
       * @example
       * // this is an example of  the expected stxx.editCallback function for version prior to version 2015-07-01
       * stxx.editCallback=function(stx, sd){
       *	// your code here
       *	return $$("studyDialog"); // This is a reference to the actual HTML dialog container that can be filled by studyDialog.
       * };
       * @example
       * var params={stx:stx,sd:sd,inputs:inputs,outputs:outputs, parameters:parameters};
       * stxx.callbacks.studyPanelEdit=function(params){
       *		// your code here
       * };
       * @example
       * var params={stx:stx,sd:sd,inputs:inputs,outputs:outputs, parameters:parameters};
       * stxx.callbacks.studyOverlayEdit=function(params){
       *		// your code here
       * };
       */
      CIQ.Studies.addStudy = function(
        stx,
        type,
        inputs,
        outputs,
        parameters,
        panelName,
        study
      ) {
        var libraryEntry = study ? study : CIQ.Studies.studyLibrary[type]

        if (!parameters) parameters = {}
        if (libraryEntry) {
          if (libraryEntry.inputs) {
            // Default to the library inputs
            var libraryInputs = CIQ.shallowClone(libraryEntry.inputs)
            for (var i in libraryInputs) {
              // But set any arrays to the default (the first item in the array)
              if (libraryInputs[i] instanceof Array)
                libraryInputs[i] = libraryInputs[i][0]
            }
            // Now override the library inputs with anything the user passed in
            inputs = CIQ.extend(libraryInputs, inputs)
          }
          if (libraryEntry.outputs) {
            outputs = CIQ.extend(CIQ.clone(libraryEntry.outputs), outputs)
          }
          var libraryParameters = libraryEntry.parameters
          if (libraryParameters && libraryParameters.init) {
            parameters = CIQ.extend(
              CIQ.shallowClone(libraryParameters.init),
              parameters
            )
          }

          if (libraryParameters && !parameters.display) {
            parameters.display = libraryParameters.display
          }
        }

        if (!inputs) inputs = CIQ.clone(CIQ.Studies.DEFAULT_INPUTS)
        if (!outputs) outputs = CIQ.clone(CIQ.Studies.DEFAULT_OUTPUTS)
        if (!parameters.chartName) parameters.chartName = 'chart'

        if (inputs.Period < 1) inputs.Period = 1 // periods can't be less than one candle. This is a general safety check. Each study should have a check or add input validation.

        if (!inputs.id) {
          inputs.id = CIQ.Studies.generateID(
            stx,
            type,
            inputs,
            parameters.replaceID,
            parameters.display
          )
        }
        var sd = null
        if (libraryEntry && libraryEntry.initializeFN) {
          sd = libraryEntry.initializeFN(
            stx,
            type,
            inputs,
            outputs,
            parameters,
            panelName,
            study
          )
        } else {
          sd = CIQ.Studies.initializeFN(
            stx,
            type,
            inputs,
            outputs,
            parameters,
            panelName,
            study
          )
        }
        if (!sd) {
          console.log(
            'CIQ.Studies.addStudy: initializeFN() returned null for ' + type
          )
          return
        }
        study = sd.study
        sd.chart = stx.charts[parameters.chartName]
        if (!stx.layout.studies) stx.layout.studies = {}
        // removed following line because it causes modified studies to be re-added out of sequence causing issues if there are dependencies
        // so instead of deleting and adding to the end of the array, we just replace the data with the new sd
        //delete stx.layout.studies[sd.inputs.id]; // for good measure, in case of orphaned studies
        stx.layout.studies[sd.inputs.id] = sd
        sd.type = type
        sd.permanent = study.permanent
        sd.customLegend = study.customLegend
        var panel = stx.panels[sd.panel]
        CIQ.Studies.prepareStudy(stx, study, sd, parameters)
        //if(!stx.currentlyImporting) CIQ.Studies.checkSymbolChanged(stx, sd, "add-study");
        if (stx.quoteDriver) stx.quoteDriver.updateSubscriptions()
        stx.changeOccurred('layout')
        var hasEditCallback = false
        var isPanelStudy = !(sd.overlay || sd.underlay)

        if (isPanelStudy && study.horizontalCrosshairFieldFN) {
          panel.horizontalCrosshairField = study.horizontalCrosshairFieldFN(
            stx,
            sd
          )
        }

        if (stx.editCallback) {
          hasEditCallback = true
        } else if (isPanelStudy) {
          if (
            stx.callbacks.studyPanelEdit ||
            (stx.callbackListeners.studyPanelEdit &&
              stx.callbackListeners.studyPanelEdit.length)
          )
            hasEditCallback = true
        } else {
          if (
            stx.callbacks.studyOverlayEdit ||
            (stx.callbackListeners.studyOverlayEdit &&
              stx.callbackListeners.studyOverlayEdit.length)
          )
            hasEditCallback = true
        }

        if (hasEditCallback) {
          parameters.editMode = true
          var hasInput = false
          for (var input in sd.inputs) {
            if (input == 'id') continue
            if (input == 'display') continue
            hasInput = true
            break
          }
          if (!hasInput) {
            for (var output in sd.outputs) {
              hasInput = true
              break
            }
          }
          if (hasInput) {
            var editFunction
            if (typeof sd.study.edit != 'undefined') {
              if (sd.study.edit) {
                editFunction = (function(stx, sd, inputs, outputs) {
                  return function() {
                    CIQ.clearCanvas(stx.chart.tempCanvas, stx) // clear any drawing in progress
                    sd.study.edit(sd, {
                      stx: stx,
                      inputs: inputs,
                      outputs: outputs,
                      parameters: parameters,
                    })
                  }
                })(stx, sd, inputs, outputs, parameters)
                stx.setPanelEdit(panel, editFunction)
                sd.editFunction = editFunction
              }
            } else if (!isPanelStudy && stx.callbacks.studyOverlayEdit) {
              editFunction = (function(stx, sd, inputs, outputs, parameters) {
                return function(forceEdit) {
                  CIQ.clearCanvas(stx.chart.tempCanvas, stx) // clear any drawing in progress
                  stx.dispatch('studyOverlayEdit', {
                    stx: stx,
                    sd: sd,
                    inputs: inputs,
                    outputs: outputs,
                    parameters: parameters,
                    forceEdit: forceEdit,
                  })
                }
              })(stx, sd, inputs, outputs, parameters)
              sd.editFunction = editFunction
            } else {
              if (stx.editCallback) {
                // deprecated legacy support
                editFunction = (function(stx, sd, inputs, outputs) {
                  return function() {
                    var dialogDiv = stx.editCallback(stx, sd)
                    CIQ.clearCanvas(stx.chart.tempCanvas, stx) // clear any drawing in progress
                    CIQ.Studies.studyDialog(stx, type, dialogDiv, {
                      inputs: inputs,
                      outputs: outputs,
                      parameters: parameters,
                    })
                  }
                })(stx, sd, inputs, outputs, parameters)
                if (panel.name != 'chart') {
                  stx.setPanelEdit(panel, editFunction)
                }
              } else {
                editFunction = (function(stx, sd, inputs, outputs, parameters) {
                  return function() {
                    CIQ.clearCanvas(stx.chart.tempCanvas, stx) // clear any drawing in progress
                    stx.dispatch('studyPanelEdit', {
                      stx: stx,
                      sd: sd,
                      inputs: inputs,
                      outputs: outputs,
                      parameters: parameters,
                    })
                  }
                })(stx, sd, inputs, outputs, parameters)
                if (panel.name != 'chart') {
                  stx.setPanelEdit(panel, editFunction)
                  sd.editFunction = editFunction
                }
              }
            }
          }
        }
        return sd
      }

      /** @deprecated **/
      CIQ.Studies.quickAddStudy = CIQ.Studies.addStudy

      /**
       * Removes a study from the chart (and panel if applicable)
       * @param  {CIQ.ChartEngine} stx A chart object
       * @param  {studyDescriptor} sd  A study descriptor returned from {@link CIQ.Studies.addStudy}
       * @memberOf CIQ.Studies
       */
      CIQ.Studies.removeStudy = function(stx, sd) {
        if (sd.overlay || sd.underlay) {
          stx.removeOverlay(sd.name)
          stx.draw()
        } else {
          var panel = stx.panels[sd.panel]
          if (panel) stx.panelClose(panel)
        }
      }

      /**
       * <span class="animation">Animation Loop</span>
       * This method displays all of the studies for a chart. It is called from within the chart draw() loop.
       * @param  {CIQ.ChartEngine} stx The charting object
       * @param {CIQ.ChartEngine.Chart} chart Which chart to display studies for
       * @param {Boolean} [underlays=false] If set to true then underlays only will be displayed, otherwise underlays will be skipped
       * @memberOf CIQ.Studies
       */
      CIQ.Studies.displayStudies = function(stx, chart, underlays) {
        var s = stx.layout.studies
        if (!s) return
        if (underlays) CIQ.Studies.actualOutputs = []
        var permanentPanel = {} // local map of permanent panels
        permanentPanel[chart.name] = true // no X on chart panel
        for (var n in s) {
          var sd = s[n]
          var study = sd.study
          if (!study) continue
          if (underlays) {
            if (!sd.underlay && !study.underlay) continue
          } else {
            if (sd.underlay || study.underlay) continue
          }
          var panel = stx.panels[sd.panel]
          if (panel) {
            if (panel.chart != chart) continue
            if (sd.study.range != 'bypass') panel.min = null // force determineminmax to calculate values, except if we are bypassing the automatic range setting
            //TODO: get rid of orphaned overlay study?
            if (panel.hidden) continue
            if (!permanentPanel[panel.name]) {
              var permanent = sd.permanent
              if (panel.closeX) {
                panel.closeX.style.display = permanent ? 'none' : ''
              } else {
                panel.close.style.display = permanent ? 'none' : ''
              }
              permanentPanel[panel.name] = permanent
            }
          } else {
            //orphaned panel study, kill it
            delete s[n]
            continue
          }

          var quotes = sd.chart.dataSegment // Find the appropriate data to drive this study

          for (var i in sd.outputMap) {
            CIQ.Studies.actualOutputs.push(i)
          }

          // change the panel if it's an overlay and the underlying field has changed
          var fieldInputs = CIQ.Studies.getFieldInputs(sd)
          for (var f = 0; f < fieldInputs.length; f++) {
            if (
              sd.panel == sd.parameters.chartName &&
              sd.inputs[fieldInputs[f]]
            ) {
              var mapEntry =
                CIQ.Studies.studyPanelMap[sd.inputs[fieldInputs[f]]]
              if (mapEntry) {
                sd.panel = mapEntry.panel
                break
              }
            }
          }
          if (typeof study.seriesFN == 'undefined') {
            // null means don't display, undefined means display by default as a series
            CIQ.Studies.displaySeriesAsLine(stx, sd, quotes)
            if (panel) CIQ.Studies.displayError(stx, sd)
          } else {
            if (study.seriesFN) {
              if (panel) {
                study.seriesFN(stx, sd, quotes)
                CIQ.Studies.displayError(stx, sd)
              }
            }
          }
        }
      }

      /**
       * This method displays a watermark on a panel for a study with sd.error set.
       * The sd.error property can be set to true, which will display the default message "Not enough data to compute XXX"
       * or it can be set to a custom string which will be displayed as supplied.
       * @param  {CIQ.ChartEngine} stx The charting object
       * @param  {studyDescriptor} sd     The study descriptor
       * @param  {Object} [params]	additional options to customize the watermark
       * @param  {string} [params.panel]	name of the panel on which to display the error, defaults to sd.panel
       * @param  {string} [params.h]	watermark horizontal position
       * @param  {string} [params.v]	watermark vertical position
       * @memberOf CIQ.Studies
       * @since
       * <br>&bull; 3.0.0
       * <br>&bull; 4.0.0 Displays one error per panel, added params argument
       */
      CIQ.Studies.displayError = function(stx, sd, params) {
        var panel = params && params.panel ? params.panel : sd.panel,
          state = stx.panels[panel].state

        if (
          state.studyError ||
          !sd.error ||
          (typeof practiceMode !== 'undefined' && practiceMode)
        )
          return

        params = params || { h: 'center', v: 'bottom' }

        params.text = state.studyError =
          sd.error === true
            ? stx.translateIf('Not enough data to compute ') +
              stx.translateIf(sd.study.name)
            : stx.translateIf(sd.error)

        stx.watermark(panel, params)
      }

      /**
       * Convenience function for determining the min and max for a given data point
       * @param {CIQ.ChartEngine} stx The chart
       * @param {string} name The field to evaluate
       * @param {array} quotes The array of quotes to evaluate (typically dataSet, scrubbed or dataSegment)
       * @memberOf CIQ.Studies
       * @return {minMax} Object containing the min and max data point values
       */
      CIQ.Studies.calculateMinMaxForDataPoint = function(stx, name, quotes) {
        var min = Number.MAX_VALUE
        var max = Number.MAX_VALUE * -1
        for (var i = 0; i < quotes.length; i++) {
          var m = quotes[i][name]
          if (m === null || typeof m == 'undefined') continue
          if (isNaN(m)) continue
          min = Math.min(m, min)
          max = Math.max(m, max)
        }
        return { min: min, max: max }
      }

      /**
       * Method to determine the minimum and maximum points in a study panel. The studyLibrary is checked for the type of range. If the range
       * is dynamic then the output values for the study are checked for minimum and maximum values. If a histogram is being printed then
       * the values for the histogram (represented by sd.name+"_hist") are also checked. This method does not draw the yAxis but it does compute
       * the high, low and shadow that the yAxis utilizes when drawn.
       * @param  {CIQ.ChartEngine} stx    The chart object
       * @param  {studyDescriptor} sd     The study descriptor
       * @param  {array} quotes The set of quotes to evaluate
       * @memberOf CIQ.Studies
       */
      CIQ.Studies.determineMinMax = function(stx, sd, quotes) {
        var panel = stx.panels[sd.panel]
        if (!panel) return
        function setMinMaxFor(quote, field) {
          if (!quote) return
          var value = quote[field]
          if (value === null || typeof value == 'undefined' || isNaN(value))
            return
          panel.min = Math.min(value, panel.min)
          panel.max = Math.max(value, panel.max)
        }
        if (!panel.min && panel.min !== 0) {
          var study = sd.study
          if (!sd.min && sd.min !== 0) {
            if (study.range == '0 to 100') {
              panel.min = 0
              panel.max = 100
            } else if (study.range == '-1 to 1') {
              panel.min = -1
              panel.max = 1
            } else if (study.range != 'bypass') {
              panel.min = Number.MAX_VALUE
              panel.max = Number.MAX_VALUE * -1
              var h, j, n
              for (var i = 0; i < quotes.length; i++) {
                var quote = quotes[i]
                if (!quote) continue
                for (j in sd.outputMap) {
                  setMinMaxFor(quote, j)
                }
                for (h = 0; h <= 2; h++) {
                  n = sd.name + '_hist' + (h ? h : '')
                  setMinMaxFor(quote, n)
                }
              }
              if (panel.min == Number.MAX_VALUE || panel.min == panel.max) {
                //found under 2 data points - look off edge of chart
                for (j in sd.outputMap) {
                  setMinMaxFor(stx.getPreviousBar(panel.chart, j, 0), j)
                  setMinMaxFor(
                    stx.getNextBar(panel.chart, j, quotes.length - 1),
                    j
                  )
                }
                for (h = 0; h <= 2; h++) {
                  n = sd.name + '_hist' + (h ? h : '')
                  setMinMaxFor(stx.getPreviousBar(panel.chart, n, 0), n)
                  setMinMaxFor(
                    stx.getNextBar(panel.chart, n, quotes.length - 1),
                    n
                  )
                }
              }
            }
            if (study.range == '0 to max') {
              panel.min = Math.min(0, panel.min)
            }
          } else {
            panel.min = sd.min
            panel.max = sd.max
          }
        }
        // use the panel high/low values if they were set previously, like by a renderer
        if (
          (panel.highValue || panel.highValue === 0) &&
          panel.highValue > panel.max
        )
          panel.max = panel.highValue
        if (
          (panel.lowValue || panel.lowValue === 0) &&
          panel.lowValue < panel.min
        )
          panel.min = panel.lowValue
        // If a developer hard codes the max or min for yAxis then that supercedes everything
        var yAxis = panel.yAxis
        if (yAxis.max || yAxis.max === 0) panel.max = yAxis.max
        if (yAxis.min || yAxis.min === 0) panel.min = yAxis.min
        if (panel.max == panel.min) {
          // All the same values, force a straight line
          panel.max = panel.max * 2
          panel.min = 0
        }
        panel.shadow = panel.max - panel.min
        if (panel.max > 0 && panel.min < 0)
          panel.shadow = panel.max + panel.min * -1
        yAxis.high = panel.max
        yAxis.low = panel.min
        yAxis.shadow = yAxis.high - yAxis.low
      }

      /**
       * Creates the yAxis for a study panel. Utilizes CIQ.ChartEngine.createYAxis internally. This method is not re-entrant. panel.axisDrawn will be set
       * to true in order to prevent the yAxis from being drawn multiple times if there are multiple studies on a panel. The first study on the panel
       * will therefore determine the minimum and maximum bounds of the panel. If the library entry defines a yAxisFN function then it will be used
       * to render the yaxis instead of CIQ.ChartEngine.createYAxis. If zones are enabled then CIQ.ChartEngine.createYAxis again will not be the renderer.
       * @param  {CIQ.ChartEngine} stx    The chart object
       * @param  {studyDescriptor} sd     The study descriptor
       * @param  {array} quotes The set of quotes (representing dataSegment)
       * @param  {CIQ.ChartEngine.Panel} panel  A reference to the panel
       * @memberOf CIQ.Studies
       */
      CIQ.Studies.createYAxis = function(stx, sd, quotes, panel) {
        if (!panel.axisDrawn) {
          panel.height = panel.bottom - panel.top
          CIQ.Studies.determineMinMax(stx, sd, quotes)
          // panel.yAxis.displayGridLines=false;	// Moved to initializeFN
          var parameters
          var study = sd.study
          if (study.yaxis || study.yAxisFN) {
            parameters = { noDraw: true }
            stx.createYAxis(panel, parameters)
            stx.drawYAxis(panel, parameters)
            if (study.yaxis) study.yaxis(stx, sd) // backward compatibility
            if (study.yAxisFN) study.yAxisFN(stx, sd) // Use yAxisFN for forward compatibility
          } else {
            // If zones are enabled then we don't want to draw the yAxis
            parameters = {
              noDraw: sd.parameters && sd.parameters.studyOverZonesEnabled,
            }
            if (study.range == '0 to 100') parameters.range = [0, 100]
            else if (study.range == '-1 to 1') parameters.range = [-1, 1]
            if (study.yAxis && study.yAxis.ground) parameters.ground = true

            stx.createYAxis(panel, parameters)
            stx.drawYAxis(panel, parameters)
          }
          if (!sd.error) {
            if (study.centerline) {
              CIQ.Studies.drawHorizontal(stx, sd, quotes, study.centerline)
            } else if (panel.min < 0 && panel.max > 0) {
              CIQ.Studies.drawHorizontal(stx, sd, quotes, 0)
            }
          }
          panel.axisDrawn = true
        }
      }

      /**
       * Displays a single or group of series as lines in the study panel.
       * One series per output field declared in the study library will be displayed.
       * It expects the 'quotes' array to have data fields for each series with keys in the outputMap format: 'output name from study library'+ " " + sd.name.
       * Y-axis will be rendered if studyOverZones are not set and panel is not “hidden”.
       * studyOverZones will be displayed and Peaks & Valleys will be filled if corresponding thresholds are set in the study library as follows:
       *
       * <code>init:{studyOverZonesEnabled:true, studyOverBoughtValue:70, studyOverBoughtColor:"auto", studyOverSoldValue:30, studyOverSoldColor:"auto"}</code>
       *
       * For most custom studies this function will do the work for you.
       * @param  {CIQ.ChartEngine} stx    The chart object
       * @param  {studyDescriptor} sd     The study descriptor
       * @param  {array} quotes The set of quotes (dataSegment)
       * @memberOf CIQ.Studies
       */
      CIQ.Studies.displaySeriesAsLine = function(stx, sd, quotes) {
        if (!quotes.length) return
        var panel = stx.panels[sd.panel]
        if (!panel) return
        if (panel.hidden) return
        if (panel.name != sd.chart.name && !sd.underlay) {
          CIQ.Studies.createYAxis(stx, sd, quotes, panel)
        }
        CIQ.Studies.drawZones(stx, sd, quotes)

        for (var i in sd.outputMap) {
          CIQ.Studies.studyPanelMap[i] = sd
          CIQ.Studies.displayIndividualSeriesAsLine(stx, sd, panel, i, quotes)
        }
      }

      /**
	 * Displays a single or group of series as histogram in the study panel.
	 * It expects the 'quotes' array to have data fields for each series with keys in the outputMap format: 'output name from study library'+ " " + sd.name.
	 *
	 * It takes into account the following study input fields (see {@link CIQ.ChartEngine#drawHistogram} for details ) :
	 * - sd.inputs.HistogramType ("overlaid", "clustered", "stacked") - Default "overlaid"
	 * - sd.inputs.HeightPercentage - Default ".25"
	 * - sd.inputs.WidthFactor - Default ".5"
	 * @param  {CIQ.ChartEngine} stx    The chart object
	 * @param  {studyDescriptor} sd     The study descriptor
	 * @param  {array} quotes The set of quotes (dataSegment)
	 * @memberOf CIQ.Studies
	 * @example
	 *
		// this adds a study panel that will display the High and Low values from the masterData as a stacked histogram study
		CIQ.Studies.studyLibrary["Plot High Low"]={
		 	"seriesFN": CIQ.Studies.displaySeriesAsHistogram,
		 	inputs:{"HistogramType":"stacked"},
		    outputs:{"High":"blue","Low":"red"}
		};
		CIQ.Studies.addStudy(stxx, "Plot High Low");
	 */
      CIQ.Studies.displaySeriesAsHistogram = function(stx, sd, quotes) {
        if (!quotes.length) return
        var panel = stx.panels[sd.panel]
        if (!panel) return
        if (panel.hidden) return

        var seriesParam = []
        for (var i in sd.outputMap) {
          var output = sd.outputs[sd.outputMap[i]]
          var series = {
            field: i,
            fill_color_up: output,
            border_color_up: output,
            fill_color_down: output,
            border_color_down: output,
          }
          seriesParam.push(series)
        }

        var inputs = sd.inputs
        var params = {
          name: sd.name,
          type: inputs.HistogramType ? inputs.HistogramType : 'overlaid',
          panel: sd.panel,
          heightPercentage: inputs.HeightPercentage
            ? inputs.HeightPercentage
            : 0.25,
          widthFactor: inputs.WidthFactor ? inputs.WidthFactor : 0.5,
        }

        if (
          !sd.study ||
          !sd.study.parameters ||
          !sd.study.parameters.excludeYAxis
        ) {
          CIQ.Studies.createYAxis(
            stx,
            sd,
            sd.chart.dataSegment,
            stx.panels[sd.panel]
          )
        }
        stx.drawHistogram(params, seriesParam)
      }

      /**
       * Displays multiple data-points as series on a panel. This is the default display function for an indicator and will
       * work for 90% of custom indicators.
       * It also inserts the study results into the studyPanelMap to be selected as the basis for another study.
       * @param  {CIQ.ChartEngine} stx    The chart object
       * @param  {studyDescriptor} sd     The study descriptor
       * @param  {CIQ.ChartEngine.Panel} panel  A reference to the study panel
       * @param  {string} name   The name of this study instance (should match field from 'quotes' needed to render this line)
       * @param  {array} quotes The array of quotes (dataSegment)
       * @memberOf CIQ.Studies
       */
      CIQ.Studies.displayIndividualSeriesAsLine = function(
        stx,
        sd,
        panel,
        name,
        quotes
      ) {
        if (!panel.height) panel.height = panel.bottom - panel.top

        var context = stx.chart.context
        var output = sd.outputs[sd.outputMap[name]]
        if (!output) return

        // save the original context settings
        stx.chart.context.save()

        // backwards compatibility if the output is just a color string
        if (typeof output === 'string') {
          output = {
            color: output,
            width: 1,
          }
        }

        var lineWidth = output.width || 1
        context.lineWidth = sd.highlight ? lineWidth + 2 : lineWidth

        var color = output.color
        if (color == 'auto') color = stx.defaultColor // This is calculated and set by the kernel before draw operation.
        context.strokeStyle = color

        var pattern = output.pattern

        context.setLineDash(
          CIQ.borderPatternToArray(context.lineWidth, pattern)
        )
        context.lineDashOffset = 0

        var labelDecimalPlaces = 0
        var study = sd.study,
          yAxis = panel.yAxis
        if (yAxis.shadow < 1000) labelDecimalPlaces = 2
        if (yAxis.shadow < 5) labelDecimalPlaces = 4
        if (sd.overlay || sd.underlay) labelDecimalPlaces = null // will end up using the same as the chart itself
        if (yAxis.decimalPlaces || yAxis.decimalPlaces === 0)
          labelDecimalPlaces = yAxis.decimalPlaces
        var label = null
        if (sd.parameters) label = sd.parameters.label
        var libParams = study.parameters
        if (!libParams) libParams = {}
        var step = sd.series
          ? sd.series.parameters.type
            ? sd.series.parameters.type == 'step'
            : libParams.plotType == 'step'
          : false

        // backwards compatibility
        if (libParams.noLabels) label = false
        if (!sd.noSlopes && sd.noSlopes !== false)
          sd.noSlopes = libParams.noSlopes
        if (!sd.extendToEnd && sd.extendToEnd !== false)
          sd.extendToEnd = libParams.extendToEnd
        var showLabel = label || (stx.preferences.labels && label !== false)

        var gaplines = sd.gaplines
        var symbol = sd.inputs.Symbol
        var colorFunction = gaplines
          ? stx.getGapColorFunction(symbol, name, output, gaplines)
          : null
        stx.plotDataSegmentAsLine(
          name,
          panel,
          {
            skipTransform: stx.panels[sd.panel].name != sd.chart.name,
            label: showLabel,
            labelDecimalPlaces: labelDecimalPlaces,
            noSlopes: sd.noSlopes,
            step: step,
            extendToEndOfDataSet: sd.extendToEnd,
            gaps: gaplines,
          },
          colorFunction
        )

        if (study.appendDisplaySeriesAsLine)
          study.appendDisplaySeriesAsLine(stx, sd, quotes, name, panel)

        // restore the original context settings
        stx.chart.context.restore()
      }

      /**
       * Draws a horizontal line on the study.
       * @param  {CIQ.ChartEngine} stx    The chart object
       * @param  {studyDescriptor} sd     The study descriptor
       * @param  {array} quotes The array of quotes (unused)
       * @param  {number} price  The price (value) to draw the horizontal line
       * @memberOf CIQ.Studies
       */
      CIQ.Studies.drawHorizontal = function(stx, sd, quotes, price) {
        var panel = stx.panels[sd.panel]
        if (!panel) return

        var y = stx.pixelFromPrice(price, panel)
        if (y > panel.top && y < panel.yAxis.bottom)
          stx.plotLine(
            panel.left,
            panel.right,
            y,
            y,
            '#DDDDDD',
            'segment',
            stx.chart.context,
            false,
            {}
          )
      }

      /**
       * A sample of a custom display function. This function creates the yAxis, draws **a single** histogram and then plots the series.
       * Note that to differentiate between a regular series and the histogram series there is a convention to use sd.name+"_hist" for histogram values on a study</b> See {@link CIQ.Studies.createHistogram} for details</p>
       * @param  {CIQ.ChartEngine} stx      The chart object
       * @param  {studyDescriptor} sd       The study descriptor
       * @param  {array} quotes   The quotes (dataSegment)
       * @memberOf CIQ.Studies
       */
      CIQ.Studies.displayHistogramWithSeries = function(stx, sd, quotes) {
        var panel = stx.panels[sd.panel]
        CIQ.Studies.createYAxis(stx, sd, quotes, panel)
        CIQ.Studies.createHistogram(stx, sd, quotes, false, 0.4)
        CIQ.Studies.displaySeriesAsLine(stx, sd, quotes)
      }

      /**
       * Plots over/under zones for indicators that support them, and when the user selects them. This method will draw its own
       * yAxis which will not have a scale, but merely the over under points.
       * Shading will be performed between the zone lines and the study plot.
       * @param  {CIQ.ChartEngine} stx      The chart object
       * @param  {studyDescriptor} sd       The study descriptor
       * @param  {array} quotes   The quotes (dataSegment)
       * @memberOf CIQ.Studies
       */
      CIQ.Studies.drawZones = function(stx, sd, quotes) {
        if (!sd.parameters || !sd.parameters.studyOverZonesEnabled) return

        var low = parseFloat(sd.parameters.studyOverSoldValue)
        var high = parseFloat(sd.parameters.studyOverBoughtValue)
        var lowColor = sd.parameters.studyOverSoldColor
        var highColor = sd.parameters.studyOverBoughtColor
        var output = sd.zoneOutput
        if (!output) output = 'Result'
        var zoneColor = CIQ.Studies.determineColor(sd.outputs[output])
        if (!zoneColor || zoneColor == 'auto' || CIQ.isTransparent(zoneColor))
          zoneColor = stx.defaultColor
        if (!lowColor) lowColor = zoneColor
        if (!lowColor || lowColor == 'auto' || CIQ.isTransparent(lowColor))
          lowColor = stx.defaultColor
        if (!highColor) highColor = zoneColor
        if (!highColor || highColor == 'auto' || CIQ.isTransparent(highColor))
          highColor = stx.defaultColor
        var panel = stx.panels[sd.panel]
        var drawBorders = panel.yAxis.displayBorder
        if (stx.axisBorders === false) drawBorders = false
        if (stx.axisBorders === true) drawBorders = true
        var borderEdge = Math.round(panel.right) + 0.5
        var w = drawBorders ? borderEdge - 0.5 : panel.right
        var tickWidth = drawBorders ? 3 : 0 // pixel width of tick off edge of border

        var ctx = stx.chart.context
        var color = ctx.fillStyle

        stx.chart.context.globalAlpha = 0.2

        stx.startClip(panel.name, true)
        var yAxis = panel.yAxis
        var yAxisPlotter = (yAxis.yAxisPlotter = new CIQ.Plotter())
        yAxisPlotter.newSeries(
          'border',
          'stroke',
          stx.canvasStyle('stx_grid_border')
        )

        ctx.beginPath()
        var ph = Math.round(stx.pixelFromPrice(high, panel)) + 0.5
        ctx.strokeStyle = highColor
        ctx.moveTo(panel.left, ph)
        ctx.lineTo(w, ph)
        ctx.stroke()
        ctx.closePath()

        stx.chart.context.beginPath()
        var pl = Math.round(stx.pixelFromPrice(low, panel)) + 0.5
        ctx.strokeStyle = lowColor
        ctx.moveTo(panel.left, pl)
        ctx.lineTo(w, pl)
        ctx.stroke()
        ctx.closePath()

        if (drawBorders) {
          yAxisPlotter.moveTo('border', borderEdge - 0.5, ph)
          yAxisPlotter.lineTo('border', borderEdge + tickWidth, ph)
          yAxisPlotter.moveTo('border', borderEdge - 0.5, pl)
          yAxisPlotter.lineTo('border', borderEdge + tickWidth, pl)
        }

        ctx.fillStyle = color

        var params = {
          skipTransform: stx.panels[sd.panel].name != sd.chart.name,
          panelName: sd.panel,
          band: output + ' ' + sd.name,
        }
        CIQ.preparePeakValleyFill(
          stx,
          CIQ.extend(params, {
            threshold: high,
            direction: 1,
            color: highColor,
          })
        )
        CIQ.preparePeakValleyFill(
          stx,
          CIQ.extend(params, { threshold: low, direction: -1, color: lowColor })
        )

        ctx.globalAlpha = 1

        if (!sd.study || !sd.study.yaxis) {
          if (drawBorders) {
            var b = Math.round(yAxis.bottom) + 0.5
            yAxisPlotter.moveTo('border', borderEdge, yAxis.top)
            yAxisPlotter.lineTo('border', borderEdge, b)
            yAxisPlotter.draw(stx.chart.context, 'border')
          }

          // Draw the y-axis with high/low
          stx.canvasFont('stx_yaxis')
          stx.canvasColor('stx_yaxis')
          var textX = yAxis.left + tickWidth + 3
          ctx.fillText(high, textX, ph)
          ctx.fillText(low, textX, pl)
          panel.axisDrawn = true
        }
        stx.endClip()
        ctx.globalAlpha = 1
      }

      /**
       * Draws a histogram on the study.
       * Initial bar color is defined in stx-chart.css under '.stx_histogram'. If using the default UI, refer to provided css files under '.stx_histogram' and '.ciq-night .stx_histogram' style sections.
       * If sd.outputs["Decreasing Bar"] and sd.outputs["Increasing Bar"] are present, their corresponding colors will be used instead.
       * <p><b>Note the convention to use sd.name+"_hist" for histogram values on a study</b></p>
       *
       * @param  {CIQ.ChartEngine} stx      The chart object
       * @param  {studyDescriptor} sd       The study descriptor
       * @param  {array} quotes   The quotes (dataSegment)
       * @param  {boolean} centered If true then the histogram will be physically centered on the yAxis, otherwise it will be centered at the zero value on the yAxis
       * @param  {number} [opacity=1] Optionally set the opacity
       * @memberOf CIQ.Studies
       */

      CIQ.Studies.createHistogram = function(
        stx,
        sd,
        quotes,
        centered,
        opacity
      ) {
        var panel = stx.panels[sd.panel]
        stx.startClip(panel.name)

        var myWidth = stx.layout.candleWidth - 2
        if (myWidth < 2) myWidth = 1

        var y = stx.pixelFromPrice(0, panel)
        if (panel.min > 0) y = stx.pixelFromPrice(panel.min, panel) // Don't draw below the bottom of the chart. If zero isn't on the chart then make it behave like a bar graph.
        if (centered) {
          y = Math.floor(panel.top + panel.height / 2)
        }

        var context = stx.chart.context
        var field = sd.name + '_hist'
        if (!sd.outputs['Decreasing Bar'] && !sd.outputs['Negative Bar'])
          stx.canvasColor('stx_histogram')
        else context.globalAlpha = opacity ? opacity : 1
        var y0 = null,
          y1 = null
        var outputs = sd.outputs
        for (var i = 0; i < quotes.length; i++) {
          var quote = quotes[i]
          if (!quote) continue
          if (quote.candleWidth)
            myWidth = Math.floor(Math.max(1, quote.candleWidth - 2))
          var x0 = Math.floor(stx.pixelFromBar(i, panel.chart) - myWidth / 2)
          var x1 = Math.floor(myWidth)
          if (y0 === null) {
            var tick = stx.tickFromPixel(x0, panel.chart) - 1
            if (tick < 0) y0 = y1
            else
              y0 = stx.pixelFromPrice(stx.chart.dataSet[tick][field], panel) - y
          } else {
            y0 = y1
          }
          y1 = stx.pixelFromPrice(quote[field], panel) - y

          var decreasingBarColor = CIQ.Studies.determineColor(
            outputs['Decreasing Bar']
          )
          var increasingBarColor = CIQ.Studies.determineColor(
            outputs['Increasing Bar']
          )
          var positiveBarColor = CIQ.Studies.determineColor(
            outputs['Positive Bar']
          )
          var negativeBarColor = CIQ.Studies.determineColor(
            outputs['Negative Bar']
          )

          if (decreasingBarColor && y1 > y0)
            context.fillStyle = decreasingBarColor
          else if (increasingBarColor && y1 < y0)
            context.fillStyle = increasingBarColor
          else if (positiveBarColor && y1 < 0)
            context.fillStyle = positiveBarColor
          else if (negativeBarColor && y1 > 0)
            context.fillStyle = negativeBarColor
          context.fillRect(x0, y, x1, Math.floor(y1))
        }

        context.globalAlpha = 1
        stx.endClip()
      }

      /**
       * Convenience function for creating a volume style chart that supports multiple colors
       * of volume bars. If borderMap (border colors) is passed in then the chart will display in a format where bars are flush against
       * one another so that there is no white space between bars. If however a borderMap is not specified then white space will be left
       * between the bars.
       * @param  {CIQ.ChartEngine} stx      The chart object
       * @param  {studyDescriptor} sd       The study descriptor
       * @param  {object} colorMap Map of colors to arrays. Each array should contain entries for each dataSegment bar mapped to that color.
       * It should contain null values for any bar that shouldn't be drawn
       * @param {object} borderMap Map of border colors for each color. If null then no borders will be drawn.
       * @example
       * var colorMap={};
       * colorMap["#FF0000"]=[56,123,null,null,45];
       * colorMap["#00FF00"]=[null,null,12,13,null];
       *
       * var borderMap={
       *    "#FF0000": "#FFFFFF",
       *    "#00FF00": "#FFFFDD"
       * };
       * CIQ.Studies.volumeChart(stx, sd, colorMap, borderMap);
       * @memberOf CIQ.Studies
       */
      CIQ.Studies.volumeChart = function(stx, sd, colorMap, borderMap) {
        // Determine min max
        var maximum = Number.MAX_VALUE * -1
        var color, value
        for (color in colorMap) {
          for (var c = 0; c < colorMap[color].length; c++) {
            value = colorMap[color][c]
            if (!value) continue
            if (value > maximum) maximum = value
          }
        }

        // determine calculation ratios
        var panel = stx.panels[sd.panel]
        var b = Math.floor(panel.yAxis.bottom) + 0.5
        var t = Math.floor(panel.yAxis.top) + 0.5
        var h = b - t
        var candleWidth = stx.layout.candleWidth
        var borderColor = null
        if (!sd.parameters || !sd.parameters.displayBorder) borderMap = null
        var offset = 0
        if (!borderMap) offset = (candleWidth - stx.chart.tmpWidth) / 2
        var context = stx.chart.context
        context.lineWidth = 1
        stx.startClip(sd.panel)
        for (color in colorMap) {
          if (borderMap) borderColor = borderMap[color]
          context.fillStyle = color
          if (borderColor) context.strokeStyle = borderColor
          context.beginPath()
          var prevTop = b + 0.5
          var farLeft = Math.floor(stx.pixelFromBar(0, panel.chart))
          var prevRight
          for (var i = 0; i < colorMap[color].length; i++) {
            if (
              stx.chart.dataSegment[i] &&
              stx.chart.dataSegment[i].candleWidth
            ) {
              candleWidth = stx.chart.dataSegment[i].candleWidth
              if (!borderMap) offset = candleWidth / 4
            } else {
              candleWidth = stx.layout.candleWidth
              if (!borderMap) offset = (candleWidth - stx.chart.tmpWidth) / 2
            }
            if (i === 0) {
              farLeft -= candleWidth / 2
              prevRight = farLeft
            }
            value = colorMap[color][i]
            if (!value) {
              prevTop = b
              prevRight += candleWidth
              //if(borderMap) prevRight-=0.5;
              continue
            }
            var y = value * (h / maximum)
            var top = Math.min(Math.floor(b - h + (h - y)) + 0.5, b)
            var x0, x1
            x0 = Math.floor(prevRight + offset)
            x1 = Math.floor(prevRight + candleWidth - offset)
            x0 = Math.max(x0, farLeft)

            context.moveTo(x0, b)
            context.lineTo(x1, b)
            context.lineTo(x1, top)
            context.lineTo(x0, top)
            if (borderMap) {
              if (prevTop > top || i === 0) context.lineTo(x0, prevTop) // draw down to the top of the previous bar, so that we don't overlap strokes
            } else {
              context.lineTo(x0, b)
            }
            prevTop = top
            prevRight += candleWidth
            //if(borderMap) prevRight-=0.5;
          }
          context.fill()
          context.strokeStyle = borderColor
          if (borderMap && stx.layout.candleWidth >= 2) context.stroke()
          context.closePath()
        }
        stx.endClip()
      }

      /**
       * Used to reduce certain common fields to abbreviated form for display in study panel labels
       * @type {Object}
       * @memberOf CIQ.Studies
       */
      CIQ.Studies.prettify = {
        Close: 'C',
        Open: 'O',
        High: 'H',
        Low: 'L',
        simple: 'ma',
        exponential: 'ema',
        'time series': 'tsma',
        triangular: 'tma',
        variable: 'vma',
        VIDYA: 'vdma',
        weighted: 'wma',
        'welles wilder': 'smma',
        true: 'y',
        false: 'n',
      }

      CIQ.Studies.prettyRE = /^.*\((.*?)\).*$/

      /**
       * Convert a study ID into a displayable format
       * @param  {string} id The ID
       * @return {string}    A pretty (shortened) ID
       * @memberOf CIQ.Studies
       */
      CIQ.Studies.prettyDisplay = function(id) {
        var match = CIQ.Studies.prettyRE.exec(id)
        if (!match) return id
        var guts = match[1]
        if (guts) {
          for (var i in CIQ.Studies.prettify) {
            guts = guts.replace(i, CIQ.Studies.prettify[i])
          }
          id = id.replace(match[1], guts)
        }
        return id
      }

      /**
       * Returns an array of input field names which are used  to specify the field for the study.
       * In most cases, this field is called "Field", but it does not have to be, nor does there need to be only one.
       *
       * @param  {studyDescriptor} sd       The study descriptor
       * @return {array}           Input fields used to specify the field
       * @since 3.0.0
       * @memberOf CIQ.Studies
       */
      CIQ.Studies.getFieldInputs = function(sd) {
        var res = []
        var defaultInputs = sd.study.inputs
        for (var input in defaultInputs) {
          if (defaultInputs[input] == 'field') res.push(input)
        }
        return res
      }

      /**
       * The default initialize function for a study. It creates the study descriptor. It creates the panel if one is required.
       *
       * @param  {CIQ.ChartEngine} stx        The chart object
       * @param  {string} type       The type of study (from studyLibrary)
       * @param  {object} inputs     The inputs for the study instance
       * @param  {object} outputs    The outputs for the study instance
       * @param  {object} [parameters] Optional parameters if required or supported by this study
       * @param {string} [panelName] Optional panel. If not provided then the panel will be determined dynamically.
       * @param {object} [study]	Optionally supply a study definition to use in lieu of the study library entry
       * @return {object}            The newly initialized study descriptor
       * @since 3.0.0 added study argument
       * @memberOf CIQ.Studies
       */
      CIQ.Studies.initializeFN = function(
        stx,
        type,
        inputs,
        outputs,
        parameters,
        panelName,
        study
      ) {
        function determinePanelForOverlay(inputs, parameters, panels) {
          var panel = null
          var fieldInputs = CIQ.Studies.getFieldInputs(sd)
          var highLowBars =
            stx.chart.highLowBars || stx.highLowBars[stx.layout.chartType]
          for (var f = 0; f < fieldInputs.length; f++) {
            var st = CIQ.Studies.studyPanelMap[inputs[fieldInputs[f]]]
            if (st) {
              panel = st.panel
              break
            }
            if (
              inputs[fieldInputs[f]] == 'Volume' &&
              (stx.chart.defaultPlotField != 'Volume' || highLowBars)
            ) {
              if (panels.vchart) panel = 'vchart'
              else panel = 'volume'
            }
          }
          if (!panel) panel = parameters.chartName // If a panel isn't specified then this is an overlay on the chart itself
          return panel
        }
        if (!inputs)
          inputs = {
            id: type,
          }
        if (!parameters) parameters = {}
        if (!inputs.display) inputs.display = inputs.id
        var sd = new CIQ.Studies.StudyDescriptor(
          inputs.id,
          type,
          inputs.id,
          inputs,
          outputs,
          parameters
        )
        if (inputs.Period) sd.days = Math.max(1, parseInt(sd.inputs.Period, 10)) // you can't have fractional or non-positive day periods
        if (study) {
          if (!study.inputs) study.inputs = sd.study.inputs
          if (!study.outputs) study.outputs = sd.study.outputs
          sd.study = study
        } else study = sd.study
        if (study.display) inputs.display = study.display // override what is displayed in the label
        if (!panelName) panelName = inputs.id
        var isOverlay = sd.overlay || study.overlay || inputs.Overlay
        var isUnderlay = sd.underlay || study.underlay || inputs.Underlay
        if (isUnderlay) sd.underlay = true
        if (isOverlay) sd.overlay = true

        var oldStudy = parameters.replaceID
          ? stx.layout.studies[parameters.replaceID]
          : null
        if (
          oldStudy &&
          (stx.panelExists(parameters.replaceID) || isOverlay || isUnderlay)
        ) {
          if (isOverlay || isUnderlay) {
            sd.panel = determinePanelForOverlay(inputs, parameters, stx.panels)
            //if(oldStudy && sd.panel==parameters.chartName && !inputs.Overlay && !inputs.Underlay) sd.panel=oldStudy.panel;
            if (parameters.replaceID != sd.inputs.id) {
              // delete the old study if using a different id (not modifying the same study )
              delete stx.layout.studies[parameters.replaceID]
              delete stx.overlays[parameters.replaceID]
              CIQ.deleteRHS(CIQ.Studies.studyPanelMap, oldStudy)
              if (stx.panelExists(parameters.replaceID))
                stx.panelClose(stx.panels[parameters.replaceID]) // This can happen if oldStudy was a panel
            }
          } else {
            sd.panel = panelName
            var newPanels = {}
            for (var p in stx.panels) {
              if (p == parameters.replaceID) {
                // swap the name/id of the old panel
                var tmp = stx.panels[p]
                tmp.name = panelName
                tmp.display = inputs.display
                newPanels[panelName] = tmp
                if (parameters.replaceID != panelName) {
                  //delete stx.panels[parameters.replaceID];
                  CIQ.deleteRHS(CIQ.Studies.studyPanelMap, oldStudy)
                }
                if (stx.moveMarkers)
                  stx.moveMarkers(parameters.replaceID, panelName)
              } else {
                newPanels[p] = stx.panels[p]
              }
            }
            stx.panels = newPanels
            // we want to preserve the order so we keep it unless the ID changed. Otherwise it will attempt to draw the depending study before the base study
            if (parameters.replaceID != sd.inputs.id)
              delete stx.layout.studies[parameters.replaceID] // delete the old study if using a different id (not modifying the same)
          }
        } else if (stx.panelExists(panelName)) {
          sd.panel = panelName
          if (!sd.underlay && sd.panel == stx.chart.name) sd.overlay = true //set to overlay if the panel name is "chart"
        } else if (!isOverlay && !isUnderlay) {
          var panelHeight = study.panelHeight ? study.panelHeight : null
          stx.createPanel(
            inputs.display,
            inputs.id,
            panelHeight,
            parameters.chartName
          )
          if (!study.yAxis) {
            stx.panels[inputs.id].yAxis.displayGridLines =
              stx.displayGridLinesInStudies
          }
          if (oldStudy && parameters.replaceID != sd.inputs.id) {
            // This can happen if oldStudy was an overlay
            CIQ.Studies.removeStudy(stx, oldStudy)
          }
        } else {
          sd.panel = determinePanelForOverlay(inputs, parameters, stx.panels)
        }
        var panel = stx.panels[sd.panel]
        if (panel && panel.chart.name != panel.name) {
          var syAxis = study ? study.yAxis : null
          var sparameters = study ? study.parameters : null
          if (syAxis) {
            CIQ.extend(panel.yAxis, syAxis)
            if (syAxis.ground) panel.yAxis.initialMarginBottom = 0
            if (
              syAxis.ground ||
              syAxis.initialMarginTop ||
              syAxis.initialMarginTop === 0 ||
              syAxis.initialMarginBottom ||
              syAxis.initialMarginBottom === 0
            ) {
              stx.calculateYAxisMargins(panel.yAxis)
            }
          } else if (
            sparameters &&
            (sparameters.zoom || sparameters.zoom === 0)
          ) {
            // LEGACY, instead add a yAxis to the study
            panel.yAxis.zoom = sparameters.zoom // Optionally set the default zoom in the "parameters" in the study library
          } else {
            panel.yAxis.zoom = 10 // Default to slight zoom when adding study panels so that studies are not up on the edge
          }
        }

        return sd
      }

      /**
       * Plots over/under zones for indicators that support them, and when the user selects them. This method will draw its own
       * yAxis which will not have a scale, but merely the over under points.
       * @private
       * @param {CIQ.ChartEngine} stx A chart engine instance
       * @param {studyDescriptor} sd Descriptor of the study to plot for
       * @param {array} quotes Array of quotes
       * @deprecated use CIQ.Studies.drawZones instead
       * @memberOf CIQ.Studies
       */
      CIQ.Studies.overZones = function(stx, sd, quotes) {
        if (!quotes.length) return
        var panel = stx.panels[sd.panel]
        if (!panel) return
        if (panel.hidden) return
        CIQ.Studies.displaySeriesAsLine(stx, sd, quotes)
        var parameters = sd.parameters
        if (parameters && parameters.studyOverZonesEnabled) {
          var ctx = stx.chart.context
          var overBought = parseFloat(parameters.studyOverBoughtValue),
            overSold = parseFloat(parameters.studyOverSoldValue)
          var ypx = panel.height / panel.shadow
          var overBoughtY = panel.bottom - ypx * overBought
          var overSoldY = panel.bottom - ypx * overSold
          var params = {
            lineWidth: 1,
          }
          ctx.globalAlpha = 0.2
          stx.plotLine(
            panel.left,
            panel.right - 5,
            overBoughtY,
            overBoughtY,
            parameters.studyOverBoughtColor,
            'segment',
            ctx,
            false,
            params
          )
          ctx.globalAlpha = 0.2
          stx.plotLine(
            panel.left,
            panel.right - 5,
            overSoldY,
            overSoldY,
            parameters.studyOverSoldColor,
            'segment',
            ctx,
            false,
            params
          )

          if (!sd.study || !sd.study.yaxis) {
            // Draw the y-axis with overbought/oversold
            var fontHeight = stx.getCanvasFontSize('stx_yaxis')
            stx.canvasFont('stx_yaxis')
            stx.canvasColor('stx_yaxis')
            ctx.fillText(
              overBought,
              panel.yAxis.left,
              overBoughtY + fontHeight / 2
            )
            ctx.fillText(overSold, panel.yAxis.left, overSoldY + fontHeight / 2)
            panel.axisDrawn = true
          }
        }
      }

      /**
       * A sample display function for an overlay. An overlay displays in the chart area.
       *
       * Also note the use of clipping to ensure that the overlay doesn't print outside of the panel
       *
       * Finally note that when color=="auto" you can use stx.defaultColor which will automatically adjust based on the background color. This
       * is the default for studies that use the color picker for user selection of output colors.
       * @param {CIQ.ChartEngine} stx A chart engine instance
       * @param {studyDescriptor} sd
       * @param {array} quotes Array of quotes
       * @memberOf CIQ.Studies
       */
      CIQ.Studies.displayPSAR2 = function(stx, sd, quotes) {
        var panel = stx.panels[sd.panel]
        var isChart = panel.name == panel.chart.name
        stx.startClip(panel.name)
        var ctx = stx.chart.context
        var squareWave = sd.inputs['Plot Type'] == 'squarewave'
        for (var output in sd.outputs) {
          var field = output + ' ' + sd.name
          ctx.beginPath()
          var candleWidth = stx.layout.candleWidth
          var pointWidth = Math.max(3, Math.floor(stx.chart.tmpWidth / 2))
          for (var x = 0; x < quotes.length; x++) {
            var quote = quotes[x]
            if (!quote || (!quote[field] && quote[field] !== 0)) continue
            if (quote.candleWidth) candleWidth = quote.candleWidth
            if (isChart && quote.transform) quote = quote.transform
            var x0 = stx.pixelFromBar(x, panel.chart)
            if (squareWave) x0 -= candleWidth / 2
            var y0 = stx.pixelFromTransformedValue(quote[field], panel)
            if (
              x === 0 ||
              !quotes[x - 1] ||
              (!quotes[x - 1][field] && quotes[x - 1][field] !== 0)
            ) {
              ctx.moveTo(x0, y0)
            }
            if (squareWave) {
              ctx.lineTo(x0, y0)
              ctx.lineTo(x0 + candleWidth, y0)
              if (quotes[x + 1]) {
                var quote_1 = quotes[x + 1]
                if (isChart && quote_1.transform) quote_1 = quote_1.transform
                if (!quote_1[field] && quote_1[field] !== 0) {
                  ctx.lineTo(
                    x0 + candleWidth,
                    stx.pixelFromTransformedValue(
                      quote_1[sd.referenceOutput + ' ' + sd.name],
                      stx.panels[sd.panel]
                    )
                  )
                }
              }
            } else {
              ctx.moveTo(x0 - pointWidth / 2, y0)
              ctx.lineTo(x0 + pointWidth / 2, y0)
            }
          }
          ctx.lineWidth = 1
          if (sd.highlight) ctx.lineWidth = 3
          var color = CIQ.Studies.determineColor(sd.outputs[output])
          if (color == 'auto') color = stx.defaultColor // This is calculated and set by the kernel before draw operation.
          ctx.strokeStyle = color
          ctx.stroke()
          ctx.closePath()
          ctx.lineWidth = 1
        }
        stx.endClip()
      }

      /**
       * A sample of a custom initialization function. It is rare that one would be required. In this case we simply customize the input display
       * but otherwise call the default.
       * @param {CIQ.ChartEngine} stx A chart engine instance
       * @param {*} type Type to pass to initialization function
       * @param {object} inputs Study inputs
       * @param {object} outputs Study ouptuts
       * @return {*} Initialization callback's data
       * @memberOf CIQ.Studies
       */
      CIQ.Studies.initializeStochastics = function(stx, type, inputs, outputs) {
        inputs.display = stx.translateIf('Stoch') + ' (' + inputs.Period + ')'
        return CIQ.Studies.initializeFN.apply(null, arguments)
      }

      /**
       * A simple calculation function. Volume is already obtained, so all that is done here is setting colors.
       * @param {CIQ.ChartEngine} stx A chart engine instance
       * @param {studyDescriptor} sd Study to calculate volume for
       * @memberOf CIQ.Studies
       */
      CIQ.Studies.calculateVolume = function(stx, sd) {
        var outputs = sd.outputs
        var colorUp = CIQ.Studies.determineColor(outputs['Up Volume'])
        var colorDown = CIQ.Studies.determineColor(outputs['Down Volume'])
        if (sd.name == 'vchart' || sd.name == 'volume') {
          stx.setStyle('stx_volume_up', 'color', colorUp)
          stx.setStyle('stx_volume_down', 'color', colorDown)
        } else {
          if (!stx || !stx.chart.dataSet) return
          var layout = stx.layout
          var remove = sd.parameters.removeStudy
          var previous = layout.volumeUnderlay
          layout.volumeUnderlay = !remove
          if (previous != layout.volumeUnderlay) stx.changeOccurred('layout')
          if (remove) {
            CIQ.Studies.removeStudy(stx, sd)
          } else {
            stx.setStyle('stx_volume_underlay_up', 'color', colorUp)
            stx.setStyle('stx_volume_underlay_down', 'color', colorDown)
            // use css for border so it can be configured.
            //if(colorUp) stx.setStyle("stx_volume_underlay_up", "border-left-color", colorUp);
            //if(colorDown) stx.setStyle("stx_volume_underlay_down", "border-left-color", colorDown);
          }
        }
      }

      /**
       * Moving Average convenience function
       * @param  {string}   type    The type of moving average, e.g. simple, exponential, triangular, etc
       * @param  {number}   periods Moving average period
       * @param  {string}   field   The field in the data array to perform the moving average on
       * @param  {number}   offset  Periods to offset the result by
       * @param  {string}   name    String to prefix to the name of the output.  Full name of output would be name + " " + sd.name, for instance "Signal MACD"
       * @param  {CIQ.ChartEngine} stx     Chart object
       * @param  {object}   sd      Study Descriptor
       * @param  {string}   subField      Subfield within field to perform moving average on, if applicable.  For example, IBM.Close: field:"IBM", subField:"Close"
       * @memberOf CIQ.Studies
       * @since 04-2015
       */
      CIQ.Studies.MA = function(
        type,
        periods,
        field,
        offset,
        name,
        stx,
        sd,
        subField
      ) {
        var ma = new CIQ.Studies.StudyDescriptor(
          name + ' ' + sd.name,
          'ma',
          sd.panel
        )
        ma.chart = sd.chart
        ma.days = parseInt(periods, 10)
        ma.startFrom = sd.startFrom
        ma.subField = subField
        ma.inputs = {}
        if (type) ma.inputs.Type = type
        if (field) ma.inputs.Field = field
        if (offset) ma.inputs.Offset = parseInt(offset, 10)
        CIQ.Studies.calculateMovingAverage(stx, ma)
      }

      // Moving average data; add to it if adding moving average functionality
      CIQ.Studies.movingAverage = {
        //conversions: mapping of study type to moving average type name
        conversions: {
          ma: 'simple',
          sma: 'simple',
          ema: 'exponential',
          tsma: 'time series',
          tma: 'triangular',
          vma: 'variable',
          vdma: 'vidya',
          wma: 'weighted',
          smma: 'welles wilder',
        },
        //translations: mapping of moving average type name to display name
        translations: {
          simple: 'Simple',
          exponential: 'Exponential',
          'time series': 'Time Series',
          triangular: 'Triangular',
          variable: 'Variable',
          vidya: 'VIDYA',
          weighted: 'Weighted',
          'welles wilder': 'Welles Wilder',
        },
        //typeMap: mapping of both study type and type name to calculation function suffix
        //i.e., calculateMovingAverageXXX
        typeMap: {
          ema: 'Exponential',
          exponential: 'Exponential',
          tsma: 'TimeSeries',
          'time series': 'TimeSeries',
          tma: 'Triangular',
          triangular: 'Triangular',
          vma: 'Variable',
          variable: 'Variable',
          vdma: 'Variable',
          vidya: 'Variable',
          wma: 'Weighted',
          weighted: 'Weighted',
          smma: 'Exponential',
          'welles wilder': 'Exponential',
        },
      }
      /**
       * Does conversions for valid moving average types
       * @param  {CIQ.ChartEngine} stx The chart object
       * @param  {string} input String to test if a moving average type or "options" to return the list of ma options.
       * @return {Object} The name of the moving average or a list of options
       * @memberOf CIQ.Studies
       */
      CIQ.Studies.movingAverageHelper = function(stx, input) {
        if (input == 'options') {
          var translations = {}
          for (var t in CIQ.Studies.movingAverage.translations) {
            translations[t] = stx.translateIf(
              CIQ.Studies.movingAverage.translations[t]
            )
          }
          return translations
        }
        return CIQ.Studies.movingAverage.conversions[input]
      }

      /**
	 * Creates a volume underlay for the chart.
	 * The underlay height is a % of the chart height as determined by the `HeightPercentage` study parameter.
	 * Each bar width will be determined by `widthFactor` study parameter.
	 * @param {CIQ.ChartEngine} stx A chart engine instance
	 * @param {studyDescriptor} sd A study descriptor
	 * @param {array} quotes Array of quotes
	 * @memberOf CIQ.Studies
	 * @deprecated use {@link CIQ.Studies.createVolumeChart}
	 * @example
	 *  // default study library entry with required parameters
		"vol undr": {
			"name": "Volume Underlay",
			"underlay": true,
		    "seriesFN": CIQ.Studies.createVolumeChart,
		    "calculateFN": CIQ.Studies.calculateVolume,
		    "inputs": {},
		    "outputs": {"Up Volume":"#8cc176","Down Volume":"#b82c0c"},
			"customRemoval": true,
			"removeFN": function(stx, sd){
					stx.layout.volumeUnderlay=false;
					stx.changeOccurred("layout");
				},
		    "parameters": {
		    	"init":{heightPercentage: 0.25},
		    	"widthFactor":1
			}
		}
	 */
      CIQ.Studies.volUnderlay = function(stx, sd, quotes) {
        CIQ.Studies.createVolumeChart(stx, sd, quotes)
      }

      /**
	 *
	 * Creates a volume chart.
	 * If no volume is available on the screen then the panel will be watermarked "Volume Not Available" (translated if a translate function is attached to the kernel object).
	 * Each bar width will be determined by `widthFactor` study parameter.
	 * @param {CIQ.ChartEngine} stx A chart engine instance
	 * @param {studyDescriptor} sd A study descriptor
	 * @param {array} quotes Array of quotes
	 * @memberOf CIQ.Studies
	 * @example
	 *  // default study library entry with required parameters
		"volume": {
			"name": "Volume Chart",
		    "range": "0 to max",
		    "yAxis": {"ground":true, "initialMarginTop":0},
		    "seriesFN": CIQ.Studies.createVolumeChart,
		    "calculateFN": CIQ.Studies.calculateVolume,
		    "inputs": {},
		    "outputs": {"Up Volume":"#8cc176","Down Volume":"#b82c0c"},
		    "parameters": {
		    	"zoom": 0,
		    	"widthFactor":1
		    }
		}
	 */
      CIQ.Studies.createVolumeChart = function(stx, sd, quotes) {
        var panel = sd.panel,
          inputs = sd.inputs,
          underlay = sd.underlay,
          overlay = sd.overlay
        var inMainChart = underlay || overlay
        var style = inMainChart ? 'stx_volume_underlay' : 'stx_volume'
        var seriesParam = [
          {
            field: 'Volume',
            fill_color_up: stx.canvasStyle(style + '_up').color,
            border_color_up: stx.canvasStyle(style + '_up').borderLeftColor,
            opacity_up: stx.canvasStyle(style + '_up').opacity,
            fill_color_down: stx.canvasStyle(style + '_down').color,
            border_color_down: stx.canvasStyle(style + '_down').borderLeftColor,
            opacity_down: stx.canvasStyle(style + '_down').opacity,
          },
        ]

        var seriesParam0 = seriesParam[0]
        // Major backward compatibility hack. If the border color is the same as our standard color
        // then most likely the customer is missing border: #000000 style on stx_volume_up and stx_volume_down
        if (
          !inMainChart &&
          seriesParam0.border_color_down === 'rgb(184, 44, 12)'
        ) {
          seriesParam0.border_color_down = '#000000'
          seriesParam0.border_color_up = '#000000'
        }

        var params = {
          name: 'Volume',
          panel: panel,
          heightPercentage: inMainChart ? 0.25 : null,
          widthFactor: 1,
          bindToYAxis: !inMainChart,
        }
        CIQ.extend(params, sd.study.parameters)
        CIQ.extend(params, sd.parameters)

        if (stx.colorByCandleDirection) {
          seriesParam0.color_function = function(quote) {
            var O = quote.Open,
              C = quote.Close
            //if((!O && O!==0) || (!C && C!==0) || O===C) return stx.defaultColor;

            return {
              fill_color:
                O > C
                  ? seriesParam0.fill_color_down
                  : seriesParam0.fill_color_up,
              border_color:
                O > C
                  ? seriesParam0.border_color_down
                  : seriesParam0.border_color_up,
              opacity:
                O > C ? seriesParam0.opacity_down : seriesParam0.opacity_up,
            }
          }
        }

        if (!inMainChart) {
          sd.outputMap.Volume = 'transparent'
          CIQ.Studies.createYAxis(
            stx,
            sd,
            sd.chart.dataSegment,
            stx.panels[panel]
          )
        }
        if (inputs.HeightPercentage)
          params.heightPercentage = inputs.HeightPercentage // backward compatibility
        stx.drawHistogram(params, seriesParam)
      }

      /**
       * A sample study calculation function. Note how sd.chart.scrubbed is used instead of dataSet. Also note the naming convention
       * for the outputs.
       * @param {CIQ.ChartEngine} stx A chart engine instance
       * @param {studyDescriptor} sd A study descriptor
       * @memberOf CIQ.Studies
       */
      CIQ.Studies.calculateRSI = function(stx, sd) {
        var quotes = sd.chart.scrubbed
        function computeRSI(avgGain, avgLoss) {
          if (avgLoss === 0) return 100
          var rs = avgGain / avgLoss
          return 100 - 100 / (1 + rs)
        }
        if (quotes.length < sd.days + 1) {
          sd.error = true
          return
        }
        for (var i = sd.startFrom; i < quotes.length; i++) {
          if (!i) continue
          var quote = quotes[i]
          var quote1 = quotes[i - 1]
          var change = quote.Close - quote1.Close
          var num = Math.min(i, sd.days)

          var avgGain = quote1['_avgG ' + sd.name]
          if (!avgGain) avgGain = 0
          avgGain -= avgGain / num

          var avgLoss = quote1['_avgL ' + sd.name]
          if (!avgLoss) avgLoss = 0
          avgLoss -= avgLoss / num

          if (change > 0) {
            avgGain += change / num
          } else {
            avgLoss -= change / num
          }
          if (i >= sd.days)
            quote['RSI ' + sd.name] = computeRSI(avgGain, avgLoss)
          //intermediates
          quote['_avgG ' + sd.name] = avgGain
          quote['_avgL ' + sd.name] = avgLoss
        }
        sd.zoneOutput = 'RSI'
      }

      /**
       * Calculate function for MACD study
       * @param  {CIQ.ChartEngine} stx Chart object
       * @param  {studyDescriptor} sd  Study Descriptor
       * @memberOf CIQ.Studies
       */
      CIQ.Studies.calculateMACD = function(stx, sd) {
        var quotes = sd.chart.scrubbed
        var inputs = sd.inputs,
          name = sd.name
        if (!sd.macd1Days) sd.macd1Days = parseFloat(inputs['Fast MA Period'])
        if (!sd.macd2Days) sd.macd2Days = parseFloat(inputs['Slow MA Period'])
        if (!sd.signalDays) sd.signalDays = parseFloat(inputs['Signal Period'])
        if (!sd.days)
          sd.days = Math.max(sd.macd1Days, sd.macd2Days, sd.signalDays)
        if (quotes.length < sd.days + 1) {
          sd.error = true
          return
        }

        var field = sd.inputs.Field
        if (!field || field == 'field') field = 'Close'

        var maType = inputs['Moving Average Type']
        if (!maType) maType = 'exponential'

        CIQ.Studies.MA(maType, sd.macd1Days, field, 0, '_MACD1', stx, sd)
        CIQ.Studies.MA(maType, sd.macd2Days, field, 0, '_MACD2', stx, sd)

        var i,
          quote,
          start = Math.max(sd.startFrom, sd.days - 1)
        for (i = start; i < quotes.length; i++) {
          quote = quotes[i]
          quote['MACD ' + name] =
            quote['_MACD1 ' + name] - quote['_MACD2 ' + name]
        }
        var sigMaType = inputs['Signal MA Type']
        if (!sigMaType) sigMaType = 'exponential'
        CIQ.Studies.MA(
          sigMaType,
          sd.signalDays,
          'MACD ' + name,
          0,
          'Signal',
          stx,
          sd
        )

        var histogram = name + '_hist'
        for (i = start; i < quotes.length; i++) {
          quote = quotes[i]
          var signal = quote['Signal ' + name]
          if (!signal && signal !== 0) continue // don't create histogram before the signal line is valid
          quote[histogram] = quote['MACD ' + name] - quote['Signal ' + name]
        }
      }

      /**
       * Calculate function for standard deviation.
       * @param  {CIQ.ChartEngine} stx Chart object
       * @param  {studyDescriptor} sd  Study Descriptor
       * @memberOf CIQ.Studies
       */
      CIQ.Studies.calculateStandardDeviation = function(stx, sd) {
        var quotes = sd.chart.scrubbed
        if (quotes.length < sd.days + 1) {
          sd.error = true
          return
        }
        var field = sd.inputs.Field
        if (!field || field == 'field') field = 'Close'
        var type = sd.inputs['Moving Average Type']
        if (!type) type = sd.inputs.Type
        CIQ.Studies.MA(type, sd.days, field, sd.inputs.Offset, '_MA', stx, sd)

        var acc1 = 0
        var acc2 = 0
        var ma = 0
        var mult = Number(sd.inputs['Standard Deviations'])
        if (mult < 0) mult = 2
        var name = sd.name
        for (var p in sd.outputs) {
          name = p + ' ' + name
        }
        var i, val, its
        for (
          i = sd.startFrom - 1, its = 0;
          i >= 0 && its < sd.days;
          i--, its++
        ) {
          val = quotes[i][field]
          if (isNaN(val)) val = 0
          acc1 += Math.pow(val, 2)
          acc2 += val
        }
        for (i = sd.startFrom; i < quotes.length; i++) {
          var quote = quotes[i]
          val = quote[field]
          if (isNaN(val)) val = 0
          acc1 += Math.pow(val, 2)
          acc2 += val
          if (i < sd.days - 1) continue
          if (i >= sd.days) {
            var val2 = quotes[i - sd.days][field]
            if (isNaN(val2)) val2 = 0
            acc1 -= Math.pow(val2, 2)
            acc2 -= val2
          }
          ma = quote['_MA ' + sd.name]
          quote[name] =
            Math.sqrt(
              (acc1 + sd.days * Math.pow(ma, 2) - 2 * ma * acc2) / sd.days
            ) * mult
        }
      }

      /**
       * Calculate function for moving averages. sd.inputs["Type"] can be used to request a specific type of moving average.
       * @param {CIQ.ChartEngine} stx A chart engine instance
       * @param {studyDescriptor} sd A study descriptor
       * @return {undefined}
       * @memberOf CIQ.Studies
       */
      CIQ.Studies.calculateMovingAverage = function(stx, sd) {
        if (!sd.chart.scrubbed) return
        var type = sd.inputs.Type
        if (type == 'ma' || !type) type = 'simple' // handle when the default inputs are passed in
        var typeMap = CIQ.Studies.movingAverage.typeMap
        if (type in typeMap) {
          return CIQ.Studies['calculateMovingAverage' + typeMap[type]](stx, sd)
        } else if (type !== 'simple') {
          return
        }
        var quotes = sd.chart.scrubbed
        var acc = 0
        var vals = []
        var name = sd.name
        for (var p in sd.outputs) {
          name = p + ' ' + name
        }
        var field = sd.inputs.Field
        if (!field || field == 'field') field = 'Close' // Handle when the default inputs are passed in
        var offset = parseInt(sd.inputs.Offset, 10)
        if (isNaN(offset)) offset = 0
        var i,
          val,
          start = sd.startFrom
        // backload the past data into the array
        var offsetBack = offset
        for (i = sd.startFrom - 1; i >= 0; i--) {
          val = quotes[i][field]
          if (!val && val !== 0) continue
          if (offsetBack > 0) {
            offsetBack--
            start = i
            continue
          }
          if (vals.length == sd.days - 1) break
          acc += val
          vals.unshift(val)
        }
        if (vals.length < sd.days - 1) {
          vals = []
          start = 0 // not enough records to continue where left off
        }
        for (i = start; i < quotes.length; i++) {
          var quote = quotes[i]
          val = quote[field]
          if (val && typeof val == 'object') {
            var subField = sd.subField || 'Close'
            val = val[subField]
          }
          var notOverflowing = i + offset >= 0 && i + offset < quotes.length
          var offsetQuote = notOverflowing ? quotes[i + offset] : null
          if (!val && val !== 0) {
            if (offsetQuote) offsetQuote[name] = null
            continue
          }
          acc += val
          vals.push(val)
          if (vals.length > sd.days) acc -= vals.shift()
          if (offsetQuote)
            offsetQuote[name] = vals.length == sd.days ? acc / sd.days : null
        }
      }

      /**
       * Calculate function for exponential moving average
       * @param  {CIQ.ChartEngine} stx Chart object
       * @param  {studyDescriptor} sd  Study Descriptor
       * @memberOf CIQ.Studies
       */
      CIQ.Studies.calculateMovingAverageExponential = function(stx, sd) {
        var type = sd.inputs.Type
        var quotes = sd.chart.scrubbed
        var acc = 0
        var ma = 0
        var ii = 0
        var multiplier = 2 / (sd.days + 1)
        if (type == 'welles wilder') multiplier = 1 / sd.days

        var emaPreviousDay = null
        var name = sd.name
        for (var p in sd.outputs) {
          name = p + ' ' + name
        }

        var field = sd.inputs.Field
        if (!field || field == 'field') field = 'Close' // Handle when the default inputs are passed in
        var offset = parseInt(sd.inputs.Offset, 10)
        if (isNaN(offset)) offset = 0
        var i, val
        var start = sd.startFrom
        // find emaPreviousDay
        var offsetBack = offset
        for (i = sd.startFrom - 1; i >= 0; i--) {
          val = quotes[i][name]
          if (!val && val !== 0) continue
          if (emaPreviousDay === null) emaPreviousDay = val
          ii = sd.days
          if (offsetBack <= 0) break
          offsetBack--
          start = i
        }
        if (emaPreviousDay === null) {
          emaPreviousDay = start = 0
        }
        for (i = start; i < quotes.length; i++) {
          var quote = quotes[i]
          val = quote[field]
          var notOverflowing = i + offset >= 0 && i + offset < quotes.length
          var offsetQuote = notOverflowing ? quotes[i + offset] : null
          if (!val && val !== 0) {
            if (offsetQuote) offsetQuote[name] = null
            continue
          }
          if (ii == sd.days - 1) {
            acc += val
            ma = acc / sd.days
            if (offsetQuote) offsetQuote[name] = ma
          } else if (ii < sd.days - 1) {
            acc += val
            ma = acc / (ii + 1)
            if (offsetQuote) offsetQuote[name] = null
          } else if (ii === 0) {
            acc += val
            ma = acc
            if (offsetQuote) offsetQuote[name] = null
          } else if (emaPreviousDay || emaPreviousDay === 0) {
            ma = (val - emaPreviousDay) * multiplier + emaPreviousDay
            if (offsetQuote) offsetQuote[name] = ma
          }
          emaPreviousDay = ma
          ii++
        }
      }

      /**
       * Calculate function for variable moving average and VI Dynamic MA (VIDYA)
       * @param  {CIQ.ChartEngine} stx Chart object
       * @param  {studyDescriptor} sd  Study Descriptor
       * @memberOf CIQ.Studies
       */
      CIQ.Studies.calculateMovingAverageVariable = function(stx, sd) {
        var type = sd.inputs.Type
        var quotes = sd.chart.scrubbed
        var alpha = 2 / (sd.days + 1)

        var vmaPreviousDay = null
        var name = sd.name
        for (var p in sd.outputs) {
          name = p + ' ' + name
        }

        var field = sd.inputs.Field
        if (!field || field == 'field') field = 'Close' // Handle when the default inputs are passed in

        if (type == 'vidya') {
          sd.std = new CIQ.Studies.StudyDescriptor(sd.name, 'sdev', sd.panel)
          sd.std.chart = sd.chart
          sd.std.days = 5
          sd.std.startFrom = sd.startFrom
          sd.std.inputs = { Field: field, 'Standard Deviations': 1, Type: 'ma' }
          sd.std.outputs = { _STD: null }
          CIQ.Studies.calculateStandardDeviation(stx, sd.std)

          CIQ.Studies.MA('ma', 20, '_STD ' + sd.name, 0, '_MASTD', stx, sd)
        } else {
          sd.cmo = new CIQ.Studies.StudyDescriptor(sd.name, 'cmo', sd.panel)
          sd.cmo.chart = sd.chart
          sd.cmo.days = 9
          sd.cmo.startFrom = sd.startFrom
          sd.cmo.outputs = { _CMO: null }
          CIQ.Studies.calculateChandeMomentum(stx, sd.cmo)
        }

        var offset = parseInt(sd.inputs.Offset, 10)
        if (isNaN(offset)) offset = 0

        var i, val
        var start = sd.startFrom
        // find vmaPreviousDay
        var offsetBack = offset
        for (i = sd.startFrom - 1; i >= 0; i--) {
          val = quotes[i][name]
          if (!val && val !== 0) continue
          if (vmaPreviousDay === null) vmaPreviousDay = val
          if (offsetBack <= 0) break
          offsetBack--
          start = i
        }
        if (vmaPreviousDay === null) {
          vmaPreviousDay = start = 0
        }

        for (i = start; i < quotes.length; i++) {
          var quote = quotes[i]
          val = quote[field]
          var notOverflowing = i + offset >= 0 && i + offset < quotes.length
          var offsetQuote = notOverflowing ? quotes[i + offset] : null
          if (!val && val !== 0) {
            if (offsetQuote) offsetQuote[name] = null
            continue
          }
          var vi
          if (type == 'vidya') {
            if (!quote['_MASTD ' + sd.name] && quote['_MASTD ' + sd.name] !== 0)
              continue
            else vi = quote['_STD ' + sd.name] / quote['_MASTD ' + sd.name]
          } else {
            if (!quote['_CMO ' + sd.name] && quote['_CMO ' + sd.name] !== 0)
              continue
            else vi = Math.abs(quote['_CMO ' + sd.name]) / 100
          }
          var vma = alpha * vi * val + (1 - alpha * vi) * vmaPreviousDay
          vmaPreviousDay = vma
          if (i < sd.days) vma = null
          if (offsetQuote) offsetQuote[name] = vma
        }
      }

      /**
       * Calculate function for time series moving average
       * @param  {CIQ.ChartEngine} stx Chart object
       * @param  {studyDescriptor} sd  Study Descriptor
       * @memberOf CIQ.Studies
       */
      CIQ.Studies.calculateMovingAverageTimeSeries = function(stx, sd) {
        sd.ma = new CIQ.Studies.StudyDescriptor(sd.name, 'ma', sd.panel)
        sd.ma.chart = sd.chart
        sd.ma.days = sd.days
        sd.ma.startFrom = sd.startFrom
        sd.ma.inputs = sd.inputs
        CIQ.Studies.calculateLinearRegressionIndicator(stx, sd.ma)

        var name = sd.name
        for (var p in sd.outputs) {
          name = p + ' ' + name
        }
        var offset = parseInt(sd.inputs.Offset, 10)
        if (isNaN(offset)) offset = 0
        var quotes = sd.chart.scrubbed
        // find start
        var offsetBack = offset
        for (var i = sd.startFrom - 1; i >= 0; i--) {
          var val = quotes[i][name]
          if (!val && val !== 0) continue
          if (offsetBack > 0) {
            offsetBack--
            continue
          }
          break
        }
        for (i++; i < quotes.length; i++) {
          var quote = quotes[i]
          if (i + offset >= 0 && i + offset < quotes.length)
            quotes[i + offset][name] = quote['Forecast ' + sd.name]
        }
      }

      /**
       * Calculate function for triangular moving average
       * @param  {CIQ.ChartEngine} stx Chart object
       * @param  {studyDescriptor} sd  Study Descriptor
       * @memberOf CIQ.Studies
       */
      CIQ.Studies.calculateMovingAverageTriangular = function(stx, sd) {
        var quotes = sd.chart.scrubbed

        var field = sd.inputs.Field
        if (!field || field == 'field') field = 'Close' // Handle when the default inputs are passed in
        var days = Math.ceil(sd.days / 2)
        CIQ.Studies.MA('simple', days, sd.inputs.Field, 0, 'TRI1', stx, sd)
        if (sd.days % 2 === 0) days++
        CIQ.Studies.MA('simple', days, 'TRI1 ' + sd.name, 0, 'TRI2', stx, sd)

        var name = sd.name
        for (var p in sd.outputs) {
          name = p + ' ' + name
        }
        var offset = parseInt(sd.inputs.Offset, 10)
        if (isNaN(offset)) offset = 0

        // find start
        var offsetBack = offset
        for (var i = sd.startFrom - 1; i >= 0; i--) {
          var val = quotes[i][name]
          if (!val && val !== 0) continue
          if (offsetBack > 0) {
            offsetBack--
            continue
          }
          break
        }
        for (i++; i < quotes.length; i++) {
          if (i + offset >= 0 && i + offset < quotes.length)
            quotes[i + offset][name] = quotes[i]['TRI2 ' + sd.name]
        }
        return
      }

      /**
       * Calculate function for weighted moving average
       * @param  {CIQ.ChartEngine} stx Chart object
       * @param  {studyDescriptor} sd  Study Descriptor
       */
      CIQ.Studies.calculateMovingAverageWeighted = function(stx, sd) {
        var quotes = sd.chart.scrubbed

        var accAdd = 0
        var accSubtract = 0
        var field = sd.inputs.Field
        if (!field || field == 'field') field = 'Close' // Handle when the default inputs are passed in
        var divisor = (sd.days * (sd.days + 1)) / 2

        var name = sd.name
        for (var p in sd.outputs) {
          name = p + ' ' + name
        }
        var offset = parseInt(sd.inputs.Offset, 10)
        if (isNaN(offset)) offset = 0
        var i, val
        var vals = []
        var start = sd.startFrom
        // backload the past data into the array
        var offsetBack = offset
        for (i = sd.startFrom - 1; i >= 0; i--) {
          val = quotes[i][field]
          if (!val && val !== 0) continue
          if (offsetBack > 0) {
            offsetBack--
            start = i
            continue
          }
          if (vals.length == sd.days - 1) break
          vals.unshift(val)
        }
        if (vals.length < sd.days - 1) {
          vals = []
          start = 0 // not enough records to continue where left off
        }
        for (i = 0; i < vals.length; i++) {
          accAdd += (i + 1) * vals[i]
          accSubtract += vals[i]
        }
        for (i = start; i < quotes.length; i++) {
          var quote = quotes[i]
          val = quote[field]
          var notOverflowing = i + offset >= 0 && i + offset < quotes.length
          var offsetQuote = notOverflowing ? quotes[i + offset] : null
          if (!val && val !== 0) {
            if (offsetQuote) offsetQuote[name] = null
            continue
          }
          vals.push(val)
          if (vals.length > sd.days) {
            accAdd -= accSubtract
            accSubtract -= vals.shift()
          }
          accAdd += vals.length * val
          accSubtract += val

          if (i < sd.days - 1) {
            if (offsetQuote) offsetQuote[name] = null
          } else {
            if (offsetQuote) offsetQuote[name] = accAdd / divisor
          }
        }
      }

      /**
       * Calculate function for klinger
       * @param  {CIQ.ChartEngine} stx Chart object
       * @param  {studyDescriptor} sd  Study Descriptor
       * @memberOf CIQ.Studies
       */

      CIQ.Studies.calculateKlinger = function(stx, sd) {
        var quotes = sd.chart.scrubbed
        var shortCycle = Number(sd.inputs['Short Cycle'])
        var longCycle = Number(sd.inputs['Long Cycle'])
        if (quotes.length < Math.max(shortCycle, longCycle) + 1) {
          sd.error = true
          return
        }

        var field = sd.name + '_hist',
          klinger = 'Klinger ' + sd.name,
          klingerSignal = 'KlingerSignal ' + sd.name,
          signedVolume = '_SV ' + sd.name,
          shortEMA = '_EMA-S ' + sd.name,
          longEMA = '_EMA-L ' + sd.name,
          i
        for (i = Math.max(1, sd.startFrom); i < quotes.length; i++) {
          var sv = quotes[i].Volume
          if (quotes[i]['hlc/3'] < quotes[i - 1]['hlc/3']) sv *= -1
          quotes[i][signedVolume] = sv
        }

        CIQ.Studies.MA(
          'exponential',
          shortCycle,
          signedVolume,
          0,
          '_EMA-S',
          stx,
          sd
        )
        CIQ.Studies.MA(
          'exponential',
          longCycle,
          signedVolume,
          0,
          '_EMA-L',
          stx,
          sd
        )

        for (i = Math.max(longCycle, sd.startFrom); i < quotes.length; i++) {
          quotes[i][klinger] = quotes[i][shortEMA] - quotes[i][longEMA]
        }

        CIQ.Studies.MA(
          'exponential',
          Number(sd.inputs['Signal Periods']),
          klinger,
          0,
          'KlingerSignal',
          stx,
          sd
        )

        for (i = sd.startFrom; i < quotes.length; i++) {
          quotes[i][field] = quotes[i][klinger] - quotes[i][klingerSignal]
        }
      }

      /**
       * Calculate function for stochastics
       * @param  {CIQ.ChartEngine} stx Chart object
       * @param  {studyDescriptor} sd  Study Descriptor
       * @memberOf CIQ.Studies
       */
      CIQ.Studies.calculateStochastics = function(stx, sd) {
        if (!sd.smooth) sd.smooth = sd.inputs.Smooth
        var field = sd.inputs.Field
        if (!field || field == 'field') field = 'Close'

        var fastPeriod = sd.inputs['%K Periods']
        if (!fastPeriod) fastPeriod = sd.days

        var quotes = sd.chart.scrubbed
        if (quotes.length < Math.max(fastPeriod, sd.days) + 1) {
          sd.error = true
          return
        }

        var smoothingPeriod = sd.inputs['%K Smoothing Periods']
        if (smoothingPeriod) sd.smooth = true
        else if (sd.smooth) smoothingPeriod = 3

        var slowPeriod = sd.inputs['%D Periods']
        if (!slowPeriod) slowPeriod = 3

        function computeStochastics(position, field, days) {
          var beg = position - days + 1
          var high = Number.MAX_VALUE * -1,
            low = Number.MAX_VALUE
          for (var i = beg; i <= position; i++) {
            low = Math.min(low, quotes[i].Low)
            high = Math.max(high, quotes[i].High)
          }
          var k =
            high == low
              ? 0
              : ((quotes[position][field] - low) / (high - low)) * 100
          return k
        }

        sd.outputMap = {}
        sd.outputMap['%K ' + sd.name] = 'Fast'
        sd.outputMap['%D ' + sd.name] = 'Slow'

        for (
          var i = Math.max(fastPeriod, sd.startFrom);
          i < quotes.length;
          i++
        ) {
          quotes[i][sd.name] = computeStochastics(i, field, fastPeriod)
        }

        CIQ.Studies.MA(
          'simple',
          sd.smooth ? smoothingPeriod : 1,
          sd.name,
          0,
          '%K',
          stx,
          sd
        )
        CIQ.Studies.MA('simple', slowPeriod, '%K ' + sd.name, 0, '%D', stx, sd)
      }

      CIQ.Studies.calculateStudyATR = function(stx, sd) {
        var quotes = sd.chart.scrubbed
        var period = sd.days
        if (quotes.length < period + 1) {
          sd.error = true
          return
        }
        var total = 0
        var name = sd.name
        for (var i = Math.max(sd.startFrom, 1); i < quotes.length; i++) {
          var prices = quotes[i]
          var pd = quotes[i - 1]
          var trueRange = prices.trueRange
          if (pd['Sum True Range ' + name]) total = pd['Sum True Range ' + name]
          total += trueRange
          if (i > period) total -= quotes[i - period]['True Range ' + name]
          prices['True Range ' + name] = trueRange
          prices['Sum True Range ' + name] = total
          if (i == period) prices['ATR ' + name] = total / period
          else if (i > period)
            prices['ATR ' + name] =
              (pd['ATR ' + name] * (period - 1) + trueRange) / period
        }
      }

      CIQ.Studies.calculatePSAR = function(stx, sd) {
        var quotes = sd.chart.scrubbed

        var af = 0
        var ep = null
        var lasttrend = false
        var SAR = 0
        var step = parseFloat(sd.inputs['Minimum AF'])
        var maxStep = parseFloat(sd.inputs['Maximum AF'])

        function doReset() {
          af = 0
          ep = null
          lasttrend = !lasttrend
        }
        if (sd.startFrom > 0) {
          SAR = quotes[sd.startFrom - 1]['Result ' + sd.name]
          var state = quotes[sd.startFrom - 1]['_state ' + sd.name]
          if (state && state.length == 3) {
            af = state[0]
            ep = state[1]
            lasttrend = state[2]
          }
        }
        for (var i = sd.startFrom - 1; i < quotes.length - 1; i++) {
          if (i < 0) continue
          var priorSAR = SAR
          if (lasttrend) {
            if (!ep || ep < quotes[i].High) {
              ep = quotes[i].High
              af = Math.min(af + step, maxStep)
            }
            SAR = priorSAR + af * (ep - priorSAR)
            var lowestPrior2Lows = Math.min(
              quotes[Math.max(1, i) - 1].Low,
              quotes[i].Low
            )
            if (SAR > quotes[i + 1].Low) {
              SAR = ep
              doReset()
            } else if (SAR > lowestPrior2Lows) {
              SAR = lowestPrior2Lows
            }
          } else {
            if (!ep || ep > quotes[i].Low) {
              ep = quotes[i].Low
              af = Math.min(af + step, maxStep)
            }
            SAR = priorSAR + af * (ep - priorSAR)
            var highestPrior2Highs = Math.max(
              quotes[Math.max(1, i) - 1].High,
              quotes[i].High
            )
            if (SAR < quotes[i + 1].High) {
              SAR = ep
              doReset()
            } else if (SAR < highestPrior2Highs) {
              SAR = highestPrior2Highs
            }
          }
          quotes[i + 1]['Result ' + sd.name] = SAR
          quotes[i + 1]['_state ' + sd.name] = [af, ep, lasttrend]
        }
      }

      CIQ.Studies.calculateTRIX = function(stx, sd) {
        var quotes = sd.chart.scrubbed
        if (quotes.length < sd.days + 1) {
          sd.error = true
          return
        }
        var name = sd.name
        var fields = ['Close', '_MA1 ' + name, '_MA2 ' + name, '_MA3 ' + name]
        for (var e = 0; e < fields.length - 1; e++) {
          CIQ.Studies.MA(
            'exponential',
            sd.days,
            fields[e],
            0,
            '_MA' + (e + 1).toString(),
            stx,
            sd
          )
        }

        var ma3 = fields[3]
        for (var i = Math.max(1, sd.startFrom); i < quotes.length; i++) {
          var q0 = quotes[i - 1][ma3]
          if (!q0) continue
          quotes[i]['Result ' + name] = 100 * (quotes[i][ma3] / q0 - 1)
        }
      }

      CIQ.Studies.calculateIntradayMomentum = function(stx, sd) {
        var quotes = sd.chart.scrubbed
        var period = sd.days
        if (quotes.length < period + 1) {
          sd.error = true
          return
        }

        var totalUp = 0
        var totalDown = 0
        if (sd.startFrom > 1) {
          totalUp = quotes[sd.startFrom - 1]['_totUp ' + sd.name]
          totalDown = quotes[sd.startFrom - 1]['_totDn ' + sd.name]
        }
        for (var i = sd.startFrom; i < quotes.length; i++) {
          var diff = quotes[i].Close - quotes[i].Open
          if (diff > 0) totalUp += diff
          else totalDown -= diff
          if (i >= period) {
            var pDiff = quotes[i - period].Close - quotes[i - period].Open
            if (pDiff > 0) totalUp -= pDiff
            else totalDown += pDiff
          }
          quotes[i]['Result ' + sd.name] =
            (100 * totalUp) / (totalUp + totalDown)
          quotes[i]['_totUp ' + sd.name] = totalUp
          quotes[i]['_totDn ' + sd.name] = totalDown
        }
      }

      CIQ.Studies.calculateQStick = function(stx, sd) {
        var quotes = sd.chart.scrubbed
        if (quotes.length < sd.days + 1) {
          sd.error = true
          return
        }
        for (var i = sd.startFrom; i < quotes.length; i++) {
          quotes[i]['_Close-Open ' + sd.name] = quotes[i].Close - quotes[i].Open
        }
        CIQ.Studies.MA(
          sd.inputs['Moving Average Type'],
          sd.days,
          '_Close-Open ' + sd.name,
          0,
          'Result',
          stx,
          sd
        )
      }

      CIQ.Studies.calculateSchaff = function(stx, sd) {
        var quotes = sd.chart.scrubbed
        var period = sd.days
        var shortCycle = Number(sd.inputs['Short Cycle'])
        var longCycle = Number(sd.inputs['Long Cycle'])
        if (quotes.length < Math.max(period, shortCycle, longCycle) + 1) {
          sd.error = true
          return
        }
        var field = sd.inputs.Field
        if (!field || field == 'field') field = 'Close'
        var factor = 0.5

        CIQ.Studies.MA(
          sd.inputs['Moving Average Type'],
          shortCycle,
          field,
          0,
          '_MACD1',
          stx,
          sd
        )
        CIQ.Studies.MA(
          sd.inputs['Moving Average Type'],
          longCycle,
          field,
          0,
          '_MACD2',
          stx,
          sd
        )

        function getLLVHHV(p, x, n) {
          var l = null,
            h = null
          for (var j = x - p + 1; j <= x; j++) {
            var d = quotes[j][n + ' ' + sd.name]
            if (!d) continue
            l = l === null ? d : Math.min(l, d)
            h = h === null ? d : Math.max(h, d)
          }
          return [l, h]
        }
        var f1 = 0,
          f2 = 0
        for (var i = sd.startFrom; i < quotes.length; i++) {
          var quote = quotes[i]
          quote['Result ' + sd.name] = f2

          if (i < longCycle - 1) continue
          quote['_MACD ' + sd.name] =
            quote['_MACD1 ' + sd.name] - quote['_MACD2 ' + sd.name]

          if (i < longCycle + (period - 1)) continue
          var lh = getLLVHHV(period, i, '_MACD')
          f1 =
            lh[1] > lh[0]
              ? (100 * (quote['_MACD ' + sd.name] - lh[0])) / (lh[1] - lh[0])
              : f1
          quote['_PF ' + sd.name] = quotes[i - 1]['_PF ' + sd.name]
            ? quotes[i - 1]['_PF ' + sd.name] +
              factor * (f1 - quotes[i - 1]['_PF ' + sd.name])
            : f1

          if (i < longCycle + 2 * (period - 1)) continue
          lh = getLLVHHV(period, i, '_PF')
          f2 =
            lh[1] > lh[0]
              ? (100 * (quote['_PF ' + sd.name] - lh[0])) / (lh[1] - lh[0])
              : f2
          quote['Result ' + sd.name] = quotes[i - 1]['Result ' + sd.name]
            ? quotes[i - 1]['Result ' + sd.name] +
              factor * (f2 - quotes[i - 1]['Result ' + sd.name])
            : f2
        }
      }

      CIQ.Studies.calculateStochMomentum = function(stx, sd) {
        var pKPeriods = Number(sd.inputs['%K Periods'])
        var pKSmoothPeriods = Number(sd.inputs['%K Smoothing Periods'])
        var pK2SmoothPeriods = Number(sd.inputs['%K Double Smoothing Periods'])
        var pDPeriods = Number(sd.inputs['%D Periods'])

        var quotes = sd.chart.scrubbed
        if (
          quotes.length < pKPeriods + pKSmoothPeriods + pK2SmoothPeriods - 1 ||
          quotes.length < pDPeriods
        ) {
          sd.error = true
          return
        }

        function getLLVHHV(p, x) {
          var l = null,
            h = null
          for (var j = x - p + 1; j <= x; j++) {
            l = l === null ? quotes[j].Low : Math.min(l, quotes[j].Low)
            h = h === null ? quotes[j].High : Math.max(h, quotes[j].High)
          }
          return [l, h]
        }

        var i
        for (
          i = Math.max(pKPeriods, sd.startFrom) - 1;
          i < quotes.length;
          i++
        ) {
          var quote = quotes[i]
          var lh = getLLVHHV(pKPeriods, i)
          quote['_H ' + sd.name] = quote.Close - (lh[0] + lh[1]) / 2
          quote['_DHL ' + sd.name] = lh[1] - lh[0]
        }

        CIQ.Studies.MA(
          'exponential',
          pKSmoothPeriods,
          '_H ' + sd.name,
          0,
          '_HS1',
          stx,
          sd
        )
        CIQ.Studies.MA(
          'exponential',
          pK2SmoothPeriods,
          '_HS1 ' + sd.name,
          0,
          '_HS2',
          stx,
          sd
        )
        CIQ.Studies.MA(
          'exponential',
          pKSmoothPeriods,
          '_DHL ' + sd.name,
          0,
          '_DHL1',
          stx,
          sd
        )
        CIQ.Studies.MA(
          'exponential',
          pK2SmoothPeriods,
          '_DHL1 ' + sd.name,
          0,
          '_DHL2',
          stx,
          sd
        )

        for (i = pKPeriods - 1; i < quotes.length; i++) {
          quotes[i]['%K ' + sd.name] =
            (quotes[i]['_HS2 ' + sd.name] /
              (0.5 * quotes[i]['_DHL2 ' + sd.name])) *
            100
        }

        CIQ.Studies.MA(
          sd.inputs['%D Moving Average Type'],
          pDPeriods,
          '%K ' + sd.name,
          0,
          '%D',
          stx,
          sd
        )

        sd.zoneOutput = '%K'
      }

      CIQ.Studies.calculateEhlerFisher = function(stx, sd) {
        var quotes = sd.chart.scrubbed
        if (quotes.length < sd.days + 1) {
          sd.error = true
          return
        }

        function getLLVHHV(p, x) {
          var l = Number.MAX_VALUE,
            h = Number.MAX_VALUE * -1
          for (var j = x - p + 1; j <= x; j++) {
            var d = (quotes[j].High + quotes[j].Low) / 2
            l = Math.min(l, d)
            h = Math.max(h, d)
          }
          return [l, h]
        }

        var n = 0
        if (sd.startFrom > 1) n = quotes[sd.startFrom - 1]['_n ' + sd.name]
        for (var i = sd.startFrom; i < quotes.length; i++) {
          var quote = quotes[i]
          if (i < sd.days - 1) {
            quote['EF ' + sd.name] = quote['EF Trigger ' + sd.name] = n
            continue
          }
          var lh = getLLVHHV(sd.days, i)
          n =
            0.33 *
              2 *
              (((quotes[i].High + quotes[i].Low) / 2 - lh[0]) /
                Math.max(0.000001, lh[1] - lh[0]) -
                0.5) +
            0.67 * n
          if (n > 0) n = Math.min(n, 0.9999)
          else if (n < 0) n = Math.max(n, -0.9999)
          var previous = i ? quotes[i - 1]['EF ' + sd.name] : 0
          quote['EF ' + sd.name] =
            0.5 * Math.log((1 + n) / (1 - n)) + 0.5 * previous
          quote['EF Trigger ' + sd.name] = previous
          quote['_n ' + sd.name] = n
        }
      }

      CIQ.Studies.calculatePrettyGoodOscillator = function(stx, sd) {
        var quotes = sd.chart.scrubbed
        if (quotes.length < sd.days + 1) {
          sd.error = true
          return
        }

        CIQ.Studies.MA('exponential', sd.days, 'trueRange', 0, '_EMA', stx, sd)
        CIQ.Studies.MA('simple', sd.days, 'Close', 0, '_SMA', stx, sd)

        for (var i = Math.max(1, sd.startFrom); i < quotes.length; i++) {
          if (!quotes[i]['_SMA ' + sd.name] || !quotes[i]['_EMA ' + sd.name])
            continue
          quotes[i]['Result ' + sd.name] =
            (quotes[i].Close - quotes[i]['_SMA ' + sd.name]) /
            quotes[i]['_EMA ' + sd.name]
        }
      }

      CIQ.Studies.calculateUltimateOscillator = function(stx, sd) {
        var quotes = sd.chart.scrubbed
        var cycle = [
          sd.inputs['Cycle 1'],
          sd.inputs['Cycle 2'],
          sd.inputs['Cycle 3'],
        ]
        var start = Math.max(cycle[0], cycle[1], cycle[2])
        if (quotes.length < start + 1) {
          sd.error = true
          return
        }
        var c01 = cycle[0] * cycle[1]
        var c02 = cycle[0] * cycle[2]
        var c12 = cycle[1] * cycle[2]
        var accbp = [0, 0, 0]
        var acctr = [0, 0, 0]
        if (sd.startFrom) {
          if (quotes[sd.startFrom - 1]['_accbp ' + sd.name])
            accbp = quotes[sd.startFrom - 1]['_accbp ' + sd.name].slice()
          if (quotes[sd.startFrom - 1]['_acctr ' + sd.name])
            acctr = quotes[sd.startFrom - 1]['_acctr ' + sd.name].slice()
        }
        for (var i = Math.max(1, sd.startFrom); i < quotes.length; i++) {
          var minLC = Math.min(quotes[i].Low, quotes[i - 1].Close)
          var bp = quotes[i].Close - minLC
          var tr = Math.max(quotes[i].High, quotes[i - 1].Close) - minLC
          for (var x = 0; x < cycle.length; x++) {
            accbp[x] += bp
            acctr[x] += tr
            if (i > cycle[x]) {
              var p_minLC = Math.min(
                quotes[i - cycle[x]].Low,
                quotes[i - cycle[x] - 1].Close
              )
              var p_bp = quotes[i - cycle[x]].Close - p_minLC
              var p_tr =
                Math.max(
                  quotes[i - cycle[x]].High,
                  quotes[i - cycle[x] - 1].Close
                ) - p_minLC
              accbp[x] -= p_bp
              acctr[x] -= p_tr
            }
          }
          quotes[i]['_accbp ' + sd.name] = accbp.slice()
          quotes[i]['_acctr ' + sd.name] = acctr.slice()
          if (i < start) continue
          var numerator =
            (c12 * accbp[0]) / acctr[0] +
            (c02 * accbp[1]) / acctr[1] +
            (c01 * accbp[2]) / acctr[2]
          var denominator = c12 + c02 + c01
          quotes[i]['Result ' + sd.name] = (100 * numerator) / denominator
        }
      }

      CIQ.Studies.calculatePriceVolumeTrend = function(stx, sd) {
        var field = sd.inputs.Field
        if (!field || field == 'field') field = 'Close'

        var quotes = sd.chart.scrubbed
        var total = 0
        if (sd.startFrom > 1) {
          total = quotes[sd.startFrom - 1]['Result ' + sd.name]
        }
        for (var i = Math.max(1, sd.startFrom); i < quotes.length; i++) {
          if (!quotes[i][field]) continue
          if (!quotes[i - 1][field]) continue

          total +=
            (quotes[i].Volume * (quotes[i][field] - quotes[i - 1][field])) /
            quotes[i - 1][field]
          quotes[i]['Result ' + sd.name] = total
        }
      }

      CIQ.Studies.calculateOnBalanceVolume = function(stx, sd) {
        var field = sd.inputs.Field
        if (!field || field == 'field') field = 'Close'
        var minTick = sd.inputs['Min Tick Value']
        var obv = false
        if (!minTick && minTick !== 0) {
          obv = true
          minTick = 0
        }
        var quotes = sd.chart.scrubbed,
          direction = 0
        var quote, quote1
        for (var i = sd.startFrom; i < quotes.length; i++) {
          quote = quotes[i]
          if (!i || !quote[field]) continue
          if (quotes[i - 1][field]) quote1 = quotes[i - 1]
          if (!quote1) continue

          if (quote[field] - quote1[field] > minTick) direction = 1
          else if (quote1[field] - quote[field] > minTick) direction = -1
          else if (obv) direction = 0

          var total = quote1['Result ' + sd.name]
          if (!total) total = 0
          total += quote.Volume * direction
          quote['Result ' + sd.name] = total
        }
      }

      CIQ.Studies.calculateVolumeIndex = function(stx, sd) {
        var field = sd.inputs.Field
        if (!field || field == 'field') field = 'Close'
        var quotes = sd.chart.scrubbed
        if (quotes.length < sd.days + 1) {
          sd.error = true
          return
        }
        var total = 100
        if (sd.startFrom > 1)
          total = quotes[sd.startFrom - 1]['Index ' + sd.name]
        for (var i = Math.max(1, sd.startFrom); i < quotes.length; i++) {
          if (!quotes[i][field]) continue
          if (!quotes[i - 1][field]) continue
          if (
            (sd.type == 'Pos Vol' && quotes[i].Volume > quotes[i - 1].Volume) ||
            (sd.type == 'Neg Vol' && quotes[i].Volume < quotes[i - 1].Volume)
          ) {
            total *= quotes[i][field] / quotes[i - 1][field]
          }
          quotes[i]['Index ' + sd.name] = total
        }
        CIQ.Studies.MA(
          sd.inputs['Moving Average Type'],
          sd.days,
          'Index ' + sd.name,
          0,
          'MA',
          stx,
          sd
        )
      }

      CIQ.Studies.calculateHistoricalVolatility = function(stx, sd) {
        function intFactor(days) {
          if (isNaN(days)) days = 365
          if (stx.layout.interval == 'day') return days
          else if (stx.layout.interval == 'week') return 52
          else if (stx.layout.interval == 'month') return 12
          return days
        }
        var quotes = sd.chart.scrubbed
        if (quotes.length < sd.days + 1) {
          sd.error = true
          return
        }
        var field = sd.inputs.Field
        if (!field || field == 'field') field = 'Close'
        var mult = sd.inputs['Standard Deviations']
        if (mult < 0) mult = 1
        var annualizingFactor =
          100 * Math.sqrt(intFactor(sd.inputs['Days Per Year'])) * mult

        var arr = []
        var accum = 0
        if (sd.startFrom > 1) {
          accum = quotes[sd.startFrom - 1]['_state ' + sd.name][0]
          arr = quotes[sd.startFrom - 1]['_state ' + sd.name][1].slice()
        }
        for (var i = Math.max(1, sd.startFrom); i < quotes.length; i++) {
          var denom = quotes[i - 1][field]
          if (denom) {
            var ln = Math.log(quotes[i][field] / denom)
            arr.push(ln)
            accum += ln
            if (i >= sd.days) {
              var d2 = 0
              accum /= sd.days
              for (var j = 0; j < arr.length; j++) {
                d2 += Math.pow(arr[j] - accum, 2)
              }
              accum *= sd.days
              accum -= arr.shift()
              quotes[i]['Result ' + sd.name] =
                Math.sqrt(d2 / sd.days) * annualizingFactor
            }
          }
          quotes[i]['_state ' + sd.name] = [accum, arr.slice()]
        }
      }

      CIQ.Studies.calculateSwingIndex = function(stx, sd) {
        var T = sd.inputs['Limit Move Value']
        if (T === null || isNaN(T)) T = 99999
        var quotes = sd.chart.scrubbed
        var total = 0
        if (sd.startFrom > 1)
          total = quotes[sd.startFrom - 1]['Result ' + sd.name]
        for (var i = Math.max(1, sd.startFrom); i < quotes.length; i++) {
          var A = Math.abs(quotes[i].High - quotes[i - 1].Close)
          var B = Math.abs(quotes[i].Low - quotes[i - 1].Close)
          var C = Math.abs(quotes[i].High - quotes[i].Low)
          var D = Math.abs(quotes[i - 1].Close - quotes[i - 1].Open)
          var K = Math.max(A, B)
          var M = Math.max(C, K)
          var R = M + 0.25 * D
          if (M == A) R -= 0.5 * B
          else if (M == B) R -= 0.5 * A

          var swing =
            ((50 *
              (quotes[i].Close -
                quotes[i - 1].Close +
                0.5 * (quotes[i].Close - quotes[i].Open) +
                0.25 * (quotes[i - 1].Close - quotes[i - 1].Open))) /
              R) *
            (K / T)
          if (R === 0 || T === 0) swing = 0

          if (sd.type == 'Swing') total = 0
          total += swing
          quotes[i]['Result ' + sd.name] = total
        }
      }

      CIQ.Studies.calculateADX = function(stx, sd) {
        CIQ.Studies.calculateStudyATR(stx, sd)

        var quotes = sd.chart.scrubbed
        var period = sd.days
        var smoothing = parseInt(sd.inputs['Smoothing Period'], 10)
        if (!smoothing && smoothing !== 0) smoothing = period

        if (quotes.length < sd.days + 1) {
          sd.error = true
          return
        }

        var smoothTR = 0
        var smoothPlusDM = 0
        var smoothMinusDM = 0
        var runningDX = 0
        var quote
        for (var i = Math.max(1, sd.startFrom); i < quotes.length; i++) {
          quote = quotes[i]
          var plusDM = Math.max(0, quote.High - quotes[i - 1].High)
          var minusDM = Math.max(0, quotes[i - 1].Low - quote.Low)
          if (plusDM > minusDM) minusDM = 0
          else if (minusDM > plusDM) plusDM = 0
          else plusDM = minusDM = 0

          if (i <= period) {
            smoothPlusDM += plusDM
            smoothMinusDM += minusDM
            smoothTR += quote['True Range ' + sd.name]
          } else {
            smoothPlusDM =
              (quotes[i - 1]['_sm+DM ' + sd.name] * (period - 1)) / period +
              plusDM
            smoothMinusDM =
              (quotes[i - 1]['_sm-DM ' + sd.name] * (period - 1)) / period +
              minusDM
            smoothTR =
              (quotes[i - 1]['_smTR ' + sd.name] * (period - 1)) / period +
              quote['True Range ' + sd.name]
          }
          quote['_sm+DM ' + sd.name] = smoothPlusDM
          quote['_sm-DM ' + sd.name] = smoothMinusDM
          quote['_smTR ' + sd.name] = smoothTR

          if (i < period) continue

          var plusDI = (100 * smoothPlusDM) / smoothTR
          var minusDI = (100 * smoothMinusDM) / smoothTR
          var DX = (100 * Math.abs(plusDI - minusDI)) / (plusDI + minusDI)

          quote['+DI ' + sd.name] = plusDI
          quote['-DI ' + sd.name] = minusDI
          if (sd.inputs.Series !== false && smoothing) {
            if (i < period + smoothing - 1) {
              if (i == sd.startFrom) {
                for (var j = period; j < sd.startFrom; j++) {
                  runningDX +=
                    (100 *
                      Math.abs(
                        quotes[j]['+DI ' + sd.name] -
                          quotes[j]['-DI ' + sd.name]
                      )) /
                    (quotes[j]['+DI ' + sd.name] + quotes[j]['-DI ' + sd.name])
                }
              }
              runningDX += DX
            } else if (i == period + smoothing - 1) {
              quote['ADX ' + sd.name] = runningDX / smoothing
            } else {
              quote['ADX ' + sd.name] =
                (quotes[i - 1]['ADX ' + sd.name] * (smoothing - 1) + DX) /
                smoothing
            }
          }
          if (sd.inputs.Histogram) {
            var histogram = sd.name + '_hist'
            if (!quote['+DI ' + sd.name] && quote['+DI ' + sd.name] !== 0)
              continue
            if (!quote['-DI ' + sd.name] && quote['-DI ' + sd.name] !== 0)
              continue
            quote[histogram] = quote['+DI ' + sd.name] - quote['-DI ' + sd.name]
            if (sd.inputs.Series === false) {
              //delete these so yAxis computes max/min correctly
              quote['+DI ' + sd.name] = null
              quote['-DI ' + sd.name] = null
            }
          }
        }
      }

      CIQ.Studies.calculateRandomWalk = function(stx, sd) {
        var quotes = sd.chart.scrubbed
        if (quotes.length < sd.days + 1) {
          sd.error = true
          return
        }

        for (var i = Math.max(2, sd.startFrom); i < quotes.length; i++) {
          var ttr = 0
          var high = quotes[i].High
          var low = quotes[i].Low
          var maxHigh = 0
          var maxLow = 0
          for (var j = 1; j <= sd.days; j++) {
            if (i <= j) {
              maxHigh = maxLow = 0
              break
            }
            ttr += quotes[i - j].trueRange
            var denom = (ttr / j) * Math.sqrt(j)
            if (denom) {
              // skip if denominator is 0 --
              var cH = (high - quotes[i - j].Low) / denom
              var cL = (quotes[i - j].High - low) / denom
              maxHigh = Math.max(maxHigh, cH)
              maxLow = Math.max(maxLow, cL)
            }
          }
          quotes[i]['Random Walk High ' + sd.name] = maxHigh
          quotes[i]['Random Walk Low ' + sd.name] = maxLow
        }
      }

      CIQ.Studies.calculateRateOfChange = function(stx, sd) {
        var quotes = sd.chart.scrubbed
        if (quotes.length < sd.days + 1) {
          sd.error = true
          return
        }
        var field = sd.inputs.Field
        if (sd.type == 'Vol ROC') field = 'Volume'
        else if (!field || field == 'field') field = 'Close'
        var name = sd.name
        for (var p in sd.outputs) {
          name = p + ' ' + name
        }

        var offset = sd.inputs['Center Line']
        if (!offset) offset = 0
        else offset = parseInt(offset, 10)

        for (var i = Math.max(sd.startFrom, sd.days); i < quotes.length; i++) {
          if (sd.type == 'Momentum')
            quotes[i][name] =
              quotes[i][field] - quotes[i - sd.days][field] + offset
          else {
            var denom = quotes[i - sd.days][field]
            if (denom) {
              // skip if denominator is 0 --
              quotes[i][name] = 100 * (quotes[i][field] / denom - 1) + offset
            }
          }
        }
      }

      CIQ.Studies.calculateTypicalPrice = function(stx, sd) {
        var quotes = sd.chart.scrubbed
        var period = sd.days
        if (quotes.length < period + 1) {
          if (!sd.overlay) sd.error = true
          return
        }
        var name = sd.name
        for (var p in sd.outputs) {
          name = p + ' ' + name
        }
        var field = 'hlc/3'
        if (sd.type == 'Med Price') field = 'hl/2'
        else if (sd.type == 'Weighted Close') field = 'hlcc/4'

        var total = 0
        if (sd.startFrom <= period) sd.startFrom = 0
        for (var i = sd.startFrom; i < quotes.length; i++) {
          if (i && quotes[i - 1][name]) total = quotes[i - 1][name] * period
          total += quotes[i][field]
          if (i >= period) {
            total -= quotes[i - period][field]
            quotes[i][name] = total / period
          }
        }
      }

      CIQ.Studies.calculateElderRay = function(stx, sd) {
        var quotes = sd.chart.scrubbed
        if (quotes.length < sd.days) {
          sd.error = true
          return
        }
        CIQ.Studies.MA('exponential', sd.days, 'Close', 0, '_EMA', stx, sd)

        for (
          var i = Math.max(sd.startFrom, sd.days - 1);
          i < quotes.length;
          i++
        ) {
          quotes[i][sd.name + '_hist1'] =
            quotes[i].High - quotes[i]['_EMA ' + sd.name]
          quotes[i][sd.name + '_hist2'] =
            quotes[i].Low - quotes[i]['_EMA ' + sd.name]
        }
      }

      CIQ.Studies.calculateElderForce = function(stx, sd) {
        var quotes = sd.chart.scrubbed
        if (quotes.length < sd.days) {
          sd.error = true
          return
        }
        for (var i = Math.max(1, sd.startFrom); i < quotes.length; i++) {
          quotes[i]['_EF1 ' + sd.name] =
            quotes[i].Volume * (quotes[i].Close - quotes[i - 1].Close)
        }
        CIQ.Studies.MA(
          'exponential',
          sd.days,
          '_EF1 ' + sd.name,
          0,
          'Result',
          stx,
          sd
        )
      }

      CIQ.Studies.calculateCenterOfGravity = function(stx, sd) {
        var quotes = sd.chart.scrubbed
        if (quotes.length < sd.days) {
          sd.error = true
          return
        }
        var field = sd.inputs.Field
        if (!field || field == 'field') field = 'Close'
        for (
          var i = Math.max(sd.startFrom, sd.days - 1);
          i < quotes.length;
          i++
        ) {
          var num = 0,
            den = 0
          for (var j = 0; j < sd.days; j++) {
            num -= (j + 1) * quotes[i - j][field]
            den += quotes[i - j][field]
          }
          if (den) quotes[i]['Result ' + sd.name] = num / den
        }
      }

      CIQ.Studies.calculateEaseOfMovement = function(stx, sd) {
        var quotes = sd.chart.scrubbed
        if (quotes.length < sd.days) {
          sd.error = true
          return
        }
        for (var i = Math.max(1, sd.startFrom); i < quotes.length; i++) {
          var avgCurrent = (quotes[i].High + quotes[i].Low) / 2
          var avgPrior = (quotes[i - 1].High + quotes[i - 1].Low) / 2
          var dm = avgCurrent - avgPrior
          var br =
            quotes[i].Volume / 100000000 / (quotes[i].High - quotes[i].Low)
          var result = dm / br
          if (!isFinite(result)) quotes[i]['_EOM1 ' + sd.name] = NaN
          //With NaN, the study plotter will plot from the previous point
          //directly to the next point after the current tick. Infinity was making the
          //study not plot in the panel at all while the data point was in dataSegement.
          else quotes[i]['_EOM1 ' + sd.name] = result
        }
        CIQ.Studies.MA(
          sd.inputs['Moving Average Type'],
          sd.days,
          '_EOM1 ' + sd.name,
          0,
          'Result',
          stx,
          sd
        )
      }

      CIQ.Studies.calculateChaikinVolatility = function(stx, sd) {
        var quotes = sd.chart.scrubbed
        if (quotes.length < sd.days) {
          sd.error = true
          return
        }
        var i
        for (i = sd.startFrom; i < quotes.length; i++) {
          quotes[i]['_High-Low ' + sd.name] = quotes[i].High - quotes[i].Low
        }
        CIQ.Studies.MA(
          sd.inputs['Moving Average Type'],
          sd.days,
          '_High-Low ' + sd.name,
          0,
          '_MA',
          stx,
          sd
        )

        var roc = sd.inputs['Rate Of Change']
        if (!roc) roc = sd.days
        for (i = Math.max(sd.startFrom, roc); i < quotes.length; i++) {
          if (!quotes[i - roc]['_MA ' + sd.name]) continue
          quotes[i]['Result ' + sd.name] =
            100 *
            (quotes[i]['_MA ' + sd.name] / quotes[i - roc]['_MA ' + sd.name] -
              1)
        }
      }

      CIQ.Studies.calculateChaikinMoneyFlow = function(stx, sd) {
        var quotes = sd.chart.scrubbed
        if (quotes.length < sd.days) {
          sd.error = true
          return
        }
        var sumMoneyFlow = 0,
          sumVolume = 0
        var startQuote = quotes[sd.startFrom - 1]
        if (startQuote) {
          if (startQuote['_sumMF ' + sd.name])
            sumMoneyFlow = startQuote['_sumMF ' + sd.name]
          if (startQuote['_sumV ' + sd.name])
            sumVolume = startQuote['_sumV ' + sd.name]
        }
        for (var i = sd.startFrom; i < quotes.length; i++) {
          if (quotes[i].High == quotes[i].Low) quotes[i]['_MFV ' + sd.name] = 0
          else
            quotes[i]['_MFV ' + sd.name] =
              (quotes[i].Volume *
                (2 * quotes[i].Close - quotes[i].High - quotes[i].Low)) /
              (quotes[i].High - quotes[i].Low)
          sumMoneyFlow += quotes[i]['_MFV ' + sd.name]
          sumVolume += quotes[i].Volume
          if (i > sd.days - 1) {
            sumMoneyFlow -= quotes[i - sd.days]['_MFV ' + sd.name]
            sumVolume -= quotes[i - sd.days].Volume
            if (sumVolume)
              quotes[i]['Result ' + sd.name] = sumMoneyFlow / sumVolume
          }
          quotes[i]['_sumMF ' + sd.name] = sumMoneyFlow
          quotes[i]['_sumV ' + sd.name] = sumVolume
        }
      }

      CIQ.Studies.calculateTwiggsMoneyFlow = function(stx, sd) {
        var quotes = sd.chart.scrubbed
        if (quotes.length < sd.days) {
          sd.error = true
          return
        }
        var sumMoneyFlow = 0,
          sumVolume = 0
        var startQuote = quotes[sd.startFrom - 1]
        if (startQuote) {
          if (startQuote['_sumMF ' + sd.name])
            sumMoneyFlow = startQuote['_sumMF ' + sd.name]
          if (startQuote['_sumV ' + sd.name])
            sumVolume = startQuote['_sumV ' + sd.name]
        }
        for (var i = Math.max(1, sd.startFrom); i < quotes.length; i++) {
          var trh = Math.max(quotes[i - 1].Close, quotes[i].High)
          var trl = Math.min(quotes[i - 1].Close, quotes[i].Low)
          quotes[i]['_MFV ' + sd.name] =
            (quotes[i].Volume * (2 * quotes[i].Close - trh - trl)) /
            (trh - trl === 0 ? 999999 : trh - trl)
          if (i > sd.days - 1) {
            sumMoneyFlow *= (sd.days - 1) / sd.days
            sumVolume *= (sd.days - 1) / sd.days
          }
          sumMoneyFlow += quotes[i]['_MFV ' + sd.name]
          sumVolume += quotes[i].Volume
          if (i > sd.days - 1) {
            if (sumVolume)
              quotes[i]['Result ' + sd.name] =
                sumMoneyFlow / (sumVolume > 0 ? sumVolume : 999999)
          }
          quotes[i]['_sumMF ' + sd.name] = sumMoneyFlow
          quotes[i]['_sumV ' + sd.name] = sumVolume
        }
      }

      CIQ.Studies.calculateMassIndex = function(stx, sd) {
        var quotes = sd.chart.scrubbed
        if (quotes.length < Math.max(9, sd.days + 1)) {
          sd.error = true
          return
        }
        for (var i = sd.startFrom; i < quotes.length; i++) {
          quotes[i]['_High-Low ' + sd.name] = quotes[i].High - quotes[i].Low
        }

        CIQ.Studies.MA(
          'exponential',
          9,
          '_High-Low ' + sd.name,
          0,
          '_EMA',
          stx,
          sd
        )
        CIQ.Studies.MA('exponential', 9, '_EMA ' + sd.name, 0, '_EMA2', stx, sd)

        var total = 0
        if (
          quotes[sd.startFrom - 1] &&
          quotes[sd.startFrom - 1]['_total ' + sd.name]
        )
          total = quotes[sd.startFrom - 1]['_total ' + sd.name]
        for (var j = Math.max(17, sd.startFrom); j < quotes.length; j++) {
          total += quotes[j]['_EMA ' + sd.name] / quotes[j]['_EMA2 ' + sd.name]
          if (j >= 17 + sd.days - 1) {
            quotes[j]['Result ' + sd.name] = total
            total -=
              quotes[j - sd.days + 1]['_EMA ' + sd.name] /
              quotes[j - sd.days + 1]['_EMA2 ' + sd.name]
          }
          quotes[j]['_total ' + sd.name] = total
        }
      }

      CIQ.Studies.calculateMoneyFlowIndex = function(stx, sd) {
        var quotes = sd.chart.scrubbed
        if (quotes.length < sd.days + 1) {
          sd.error = true
          return
        }
        var cumPosMF = 0,
          cumNegMF = 0
        var startQuote = quotes[sd.startFrom - 1]
        var rawMFLbl = '_rawMF ' + sd.name
        var cumMFLbl = '_cumMF ' + sd.name
        var resultLbl = 'Result ' + sd.name
        if (startQuote && startQuote[cumMFLbl]) {
          cumPosMF = startQuote[cumMFLbl][0]
          cumNegMF = startQuote[cumMFLbl][1]
        }
        for (var i = sd.startFrom; i < quotes.length; i++) {
          var typPrice = quotes[i]['hlc/3']
          if (i > 0) {
            var lastTypPrice = quotes[i - 1]['hlc/3']
            var rawMoneyFlow = typPrice * quotes[i].Volume
            if (typPrice > lastTypPrice) {
              cumPosMF += rawMoneyFlow
            } else if (typPrice < lastTypPrice) {
              rawMoneyFlow *= -1
              cumNegMF -= rawMoneyFlow
            } else {
              rawMoneyFlow = 0
            }
            if (i > sd.days) {
              var old = quotes[i - sd.days][rawMFLbl]
              if (old > 0) cumPosMF -= old
              else cumNegMF += old
              if (cumNegMF === 0) quotes[i][resultLbl] = 100
              else quotes[i][resultLbl] = 100 - 100 / (1 + cumPosMF / cumNegMF)
            }
            quotes[i][rawMFLbl] = rawMoneyFlow
            quotes[i][cumMFLbl] = [cumPosMF, cumNegMF]
          }
        }
      }

      CIQ.Studies.calculateChandeMomentum = function(stx, sd) {
        var name = sd.name
        for (var p in sd.outputs) {
          name = p + ' ' + name
        }
        var quotes = sd.chart.scrubbed
        if (quotes.length < sd.days + 1) {
          sd.error = true
          return
        }

        var sumMomentum = 0,
          absSumMomentum = 0
        var history = []
        for (var i = sd.startFrom - sd.days + 1; i < quotes.length; i++) {
          if (i < 1) continue
          var diff = quotes[i].Close - quotes[i - 1].Close
          history.push(diff)
          sumMomentum += diff
          absSumMomentum += Math.abs(diff)
          if (history.length == sd.days) {
            quotes[i][name] = (100 * sumMomentum) / absSumMomentum
            var old = history.shift()
            sumMomentum -= old
            absSumMomentum -= Math.abs(old)
          }
        }
      }

      CIQ.Studies.calculateChandeForecast = function(stx, sd) {
        var quotes = sd.chart.scrubbed
        if (quotes.length < sd.days + 1) {
          sd.error = true
          return
        }
        var field = sd.inputs.Field
        if (!field || field == 'field') field = 'Close'
        CIQ.Studies.MA('time series', sd.days, field, 0, 'MA', stx, sd)
        for (var i = Math.max(1, sd.startFrom); i < quotes.length; i++) {
          quotes[i]['Result ' + sd.name] =
            100 * (1 - quotes[i]['MA ' + sd.name] / quotes[i][field])
        }
      }

      CIQ.Studies.calculateDetrendedPrice = function(stx, sd) {
        var quotes = sd.chart.scrubbed
        if (quotes.length < sd.days + 1) {
          sd.error = true
          return
        }
        var field = sd.inputs.Field
        if (!field || field == 'field') field = 'Close'
        CIQ.Studies.MA(
          sd.inputs['Moving Average Type'],
          sd.days,
          field,
          0,
          'MA',
          stx,
          sd
        )

        for (
          var i = Math.max(sd.startFrom, Math.floor(sd.days / 2 + 1));
          i < quotes.length;
          i++
        ) {
          quotes[i]['Result ' + sd.name] =
            quotes[i - Math.floor(sd.days / 2 + 1)][field] -
            quotes[i]['MA ' + sd.name]
        }
      }

      CIQ.Studies.calculateAroon = function(stx, sd) {
        var quotes = sd.chart.scrubbed
        if (quotes.length < sd.days + 1) {
          sd.error = true
          return
        }
        var daysSinceHigh = 0,
          daysSinceLow = 0
        var xDayHigh = null,
          xDayLow = null
        if (sd.startFrom > 0) {
          var state = quotes[sd.startFrom - 1]['_state ' + sd.name]
          if (state) {
            daysSinceHigh = state[0]
            daysSinceLow = state[1]
            xDayHigh = state[2]
            xDayLow = state[3]
          }
        }
        var j
        for (var i = sd.startFrom; i < quotes.length; i++) {
          if (xDayHigh === null) xDayHigh = quotes[i].High
          if (xDayLow === null) xDayLow = quotes[i].Low
          xDayHigh = Math.max(xDayHigh, quotes[i].High)
          if (xDayHigh == quotes[i].High) {
            daysSinceHigh = 0
          } else {
            daysSinceHigh++
            if (daysSinceHigh > sd.days) {
              xDayHigh = quotes[i].High
              daysSinceHigh = 0
              for (j = 1; j <= sd.days; j++) {
                xDayHigh = Math.max(xDayHigh, quotes[i - j].High)
                if (xDayHigh == quotes[i - j].High) {
                  daysSinceHigh = j
                }
              }
            }
          }
          xDayLow = Math.min(xDayLow, quotes[i].Low)
          if (xDayLow == quotes[i].Low) {
            daysSinceLow = 0
          } else {
            daysSinceLow++
            if (daysSinceLow > sd.days) {
              xDayLow = quotes[i].Low
              daysSinceLow = 0
              for (j = 1; j <= sd.days; j++) {
                xDayLow = Math.min(xDayLow, quotes[i - j].Low)
                if (xDayLow == quotes[i - j].Low) {
                  daysSinceLow = j
                }
              }
            }
          }
          quotes[i]['Aroon Up ' + sd.name] = 100 * (1 - daysSinceHigh / sd.days)
          quotes[i]['Aroon Down ' + sd.name] =
            100 * (1 - daysSinceLow / sd.days)
          quotes[i]['Aroon Oscillator ' + sd.name] =
            quotes[i]['Aroon Up ' + sd.name] -
            quotes[i]['Aroon Down ' + sd.name]
          quotes[i]['_state ' + sd.name] = [
            daysSinceHigh,
            daysSinceLow,
            xDayHigh,
            xDayLow,
          ]
        }
      }

      CIQ.Studies.calculatePrimeNumber = function(stx, sd) {
        var primes = []
        function isPrime(x) {
          if (x <= 0) return false
          else if (x != Math.floor(x)) return false
          //assume x is an int
          else if (primes[x] === true || primes[x] === false) return primes[x]
          var q = parseInt(Math.sqrt(x), 10)
          for (var i = 2; i <= q; i++) {
            if (x % i === 0) {
              primes[x] = false
              return false
            }
          }
          primes[x] = true
          return true
        }
        var quotes = sd.chart.scrubbed
        for (var i = sd.startFrom; i < quotes.length; i++) {
          var quote = quotes[i]
          if (!quote) continue

          var high = quote.High
          //high=Math.ceil(high);
          for (var h = 0; high > 0 && high <= 10; h++) high *= 10
          if (isPrime(high)) high += 2
          high = Math.ceil(high)
          if (high % 2 === 0) high++
          while (!isPrime(high)) high += 2
          high /= Math.pow(10, h)

          var low = quote.Low
          //low=Math.floor(low);
          for (var l = 0; low > 0 && low <= 10; l++) low *= 10
          if (isPrime(low)) low -= 2
          low = Math.floor(low)
          if (low % 2 === 0) low--
          if (low > 0) {
            while (!isPrime(low)) low -= 2
            low /= Math.pow(10, l)
          }

          if (sd.type == 'Prime Number Bands') {
            quote['Prime Bands Top ' + sd.name] = high
            quote['Prime Bands Bottom ' + sd.name] = Math.max(0, low)
          } else {
            var value = 0
            var tolerance =
              (sd.inputs['Tolerance Percentage'] * (high - low)) / 100
            var skew = high + low - 2 * quote.Close
            if (skew < tolerance) value = 1
            else if (skew > tolerance) value = -1
            if (value) quote['Result ' + sd.name] = value
          }
        }
      }

      CIQ.Studies.calculateVerticalHorizontalFilter = function(stx, sd) {
        var quotes = sd.chart.scrubbed
        if (quotes.length < sd.days + 1) {
          sd.error = true
          return
        }
        sd.mhml = new CIQ.Studies.StudyDescriptor(sd.name, sd.type, sd.panel)
        sd.mhml.chart = sd.chart
        sd.mhml.days = sd.days
        sd.mhml.startFrom = sd.startFrom
        sd.mhml.inputs = {}
        sd.mhml.outputs = { _MHML: null }
        CIQ.Studies.calculateMaxHighMinLow(stx, sd.mhml)
        var sumChanges = 0
        var changes = []
        for (
          var i = Math.max(1, sd.startFrom - sd.days);
          i < quotes.length;
          i++
        ) {
          var change = Math.abs(quotes[i].Close - quotes[i - 1].Close)
          changes.push(change)
          sumChanges += change
          if (changes.length == sd.days) {
            quotes[i]['Result ' + sd.name] =
              quotes[i]['_MHML ' + sd.name] / sumChanges
            sumChanges -= changes.shift()
          }
        }
      }

      CIQ.Studies.calculatePriceOscillator = function(stx, sd) {
        var quotes = sd.chart.scrubbed
        var short = Number(sd.inputs['Short Cycle'])
        var long = Number(sd.inputs['Long Cycle'])
        if (quotes.length < Math.max(short, long) + 1) {
          sd.error = true
          return
        }
        var field = sd.inputs.Field
        var maType = sd.inputs['Moving Average Type']
        if (!maType) maType = 'simple'
        if (!field || field == 'field') {
          if (sd.parameters.isVolume) {
            field = 'Volume'
            maType = 'exponential'
          } else field = 'Close'
        }
        var pts = sd.inputs['Points Or Percent']
        if (!pts) pts = 'Percent'

        CIQ.Studies.MA(maType, short, field, 0, '_Short MA', stx, sd)
        CIQ.Studies.MA(maType, long, field, 0, '_Long MA', stx, sd)

        for (var i = Math.max(long, sd.startFrom); i < quotes.length; i++) {
          var quote = quotes[i]
          if (!quote) continue
          if (pts == 'Points')
            quote['Result ' + sd.name] =
              quote['_Short MA ' + sd.name] - quote['_Long MA ' + sd.name]
          else
            quote['Result ' + sd.name] =
              100 *
              (quote['_Short MA ' + sd.name] / quote['_Long MA ' + sd.name] - 1)
          if (sd.outputs['Increasing Bar'])
            quote[sd.name + '_hist'] = quote['Result ' + sd.name]
        }
      }

      CIQ.Studies.calculateKeltner = function(stx, sd) {
        CIQ.Studies.MA(
          sd.inputs['Moving Average Type'],
          sd.days,
          'Close',
          0,
          'MA',
          stx,
          sd
        )
        CIQ.Studies.calculateStudyATR(stx, sd)
        CIQ.Studies.calculateGenericEnvelope(
          stx,
          sd,
          sd.inputs.Shift,
          'MA ' + sd.name,
          'ATR ' + sd.name
        )
      }

      CIQ.Studies.calculateCoppock = function(stx, sd) {
        var quotes = sd.chart.scrubbed
        var field = sd.inputs.Field
        if (!field || field == 'field') field = 'Close'

        var longDays = parseInt(sd.inputs['Long RoC'], 10)
        if (!longDays) longDays = 14
        var shortDays = parseInt(sd.inputs['Short RoC'], 10)
        if (!shortDays) shortDays = 11
        var period = sd.days
        if (!period) period = 10
        if (longDays < shortDays) return

        if (quotes.length < Math.max(shortDays, longDays, period) + 1) {
          sd.error = true
          return
        }
        for (var i = Math.max(sd.startFrom, longDays); i < quotes.length; i++) {
          var denom1 = quotes[i - shortDays][field]
          var denom2 = quotes[i - longDays][field]
          if (denom1 && denom2) {
            // skip if denominator is 0 --
            quotes[i]['_Sum ' + sd.name] =
              100 * (quotes[i][field] / denom1 + quotes[i][field] / denom2 - 2)
          }
        }

        CIQ.Studies.MA(
          'weighted',
          period,
          '_Sum ' + sd.name,
          0,
          'Result',
          stx,
          sd
        )
      }

      CIQ.Studies.calculateLinearRegressionIndicator = function(stx, sd) {
        var quotes = sd.chart.scrubbed
        if (quotes.length < sd.days + 1) {
          sd.error = true
          return
        }
        var field = sd.inputs.Field
        if (!field || field == 'field') field = 'Close'

        var sumWeights = (sd.days * (sd.days + 1)) / 2
        var squaredSumWeights = Math.pow(sumWeights, 2)
        var sumWeightsSquared = (sumWeights * (2 * sd.days + 1)) / 3

        var sumCloses = 0
        var sumWeightedCloses = 0
        var sumClosesSquared = 0
        if (sd.startFrom) {
          var sums = quotes[sd.startFrom - 1]['_sums ' + sd.name]
          if (sums) {
            sumWeightedCloses = sums[0]
            sumCloses = sums[1]
            sumClosesSquared = sums[2]
          }
        }
        for (var i = sd.startFrom; i < quotes.length; i++) {
          if (!quotes[i][field] && quotes[i][field] !== 0) continue
          sumWeightedCloses += sd.days * quotes[i][field] - sumCloses
          sumCloses += quotes[i][field]
          sumClosesSquared += Math.pow(quotes[i][field], 2)
          if (i < sd.days - 1) continue
          else if (i > sd.days - 1) {
            if (!quotes[i - sd.days][field] && quotes[i - sd.days][field] !== 0)
              continue
            sumCloses -= quotes[i - sd.days][field]
            sumClosesSquared -= Math.pow(quotes[i - sd.days][field], 2)
          }
          var b =
            (sd.days * sumWeightedCloses - sumWeights * sumCloses) /
            (sd.days * sumWeightsSquared - squaredSumWeights)
          quotes[i]['Slope ' + sd.name] = b
          var a = (sumCloses - b * sumWeights) / sd.days
          quotes[i]['Intercept ' + sd.name] = a
          quotes[i]['Forecast ' + sd.name] = a + b * sd.days
          var c =
            (sd.days * sumWeightsSquared - squaredSumWeights) /
            (sd.days * sumClosesSquared - Math.pow(sumCloses, 2))
          quotes[i]['RSquared ' + sd.name] = b * b * c
          quotes[i]['_sums ' + sd.name] = [
            sumWeightedCloses,
            sumCloses,
            sumClosesSquared,
          ]
        }
      }

      CIQ.Studies.calculateBollinger = function(stx, sd) {
        var field = sd.inputs.Field
        if (!field || field == 'field') field = 'Close'

        CIQ.Studies.MA(
          sd.inputs['Moving Average Type'],
          sd.days,
          field,
          0,
          '_MA',
          stx,
          sd
        )

        sd.std = new CIQ.Studies.StudyDescriptor(sd.name, 'STD Dev', sd.panel)
        sd.std.chart = sd.chart
        sd.std.startFrom = sd.startFrom
        sd.std.days = sd.days
        sd.std.inputs = {
          Field: field,
          'Standard Deviations': 1,
          Type: sd.inputs['Moving Average Type'],
        }
        sd.std.outputs = { '_STD Dev': null }
        CIQ.Studies.calculateStandardDeviation(stx, sd.std)

        CIQ.Studies.calculateGenericEnvelope(
          stx,
          sd,
          sd.inputs['Standard Deviations'],
          '_MA ' + sd.name,
          '_STD Dev ' + sd.name
        )
        if (sd.type == 'Boll %b') sd.zoneOutput = '%b'
      }

      CIQ.Studies.calculateMAEnvelope = function(stx, sd) {
        var field = sd.inputs.Field
        if (!field || field == 'field') field = 'Close'
        CIQ.Studies.MA(
          sd.inputs['Moving Average Type'],
          sd.days,
          field,
          0,
          'MA',
          stx,
          sd
        )
        var shiftType = sd.inputs['Shift Type']
        var shift = sd.inputs.Shift
        if (!shiftType) {
          //legacy
          shiftType = 'percent'
          shift = sd.inputs['Shift Percentage']
        }
        if (shiftType == 'percent') {
          CIQ.Studies.calculateGenericEnvelope(
            stx,
            sd,
            shift / 100,
            'MA ' + sd.name
          )
        } else if (shiftType == 'points') {
          CIQ.Studies.calculateGenericEnvelope(
            stx,
            sd,
            null,
            'MA ' + sd.name,
            null,
            Number(shift)
          )
        }
      }

      /**
       * Calculate function for preparing data to be used by displayChannel().
       * Inserts the following fields in the dataSet:
       * <code>
       * quote[sd.type + " Top " + sd.name]=quote[centerIndex]+totalShift;<br>
       * quote[sd.type + " Bottom " + sd.name]=quote[centerIndex]-totalShift;<br>
       * quote[sd.type + " Median " + sd.name]=quote[centerIndex];<br>
       * quote["Bandwidth " + sd.name]=200*totalShift/quote[centerIndex];<br>
       * quote["%b " + sd.name]=50*((quote.Close-quote[centerIndex])/totalShift+1);<br>
       * </code>
       * Example: 'Prime Bands' + ' Top ' +  'Prime Number Bands (true)'.
       * @param  {CIQ.ChartEngine} stx Chart object
       * @param  {studyDescriptor} sd  Study Descriptor
       * @param  {object} percentShift Used to calculate totalShift. Defaults to 0 (zero)
       * @param  {object} [centerIndex=Close]  Quote element to use for center series (Open, Close, High, Low). Defaults to "Close"
       * @param  {object} [offsetIndex=centerIndex]  Quote element to use for calculating totalShift (percentShift*quote[offsetIndex]+pointShift;)
       * @param  {object} pointShift   Used to calculate totalShift.Defaults to 0 (zero)
       * @memberOf CIQ.Studies
       */
      CIQ.Studies.calculateGenericEnvelope = function(
        stx,
        sd,
        percentShift,
        centerIndex,
        offsetIndex,
        pointShift
      ) {
        if (!percentShift) percentShift = 0
        if (!pointShift) pointShift = 0
        if (!centerIndex) centerIndex = 'Close'
        if (!offsetIndex) offsetIndex = centerIndex
        var quotes = sd.chart.scrubbed
        for (var i = sd.startFrom; quotes && i < quotes.length; i++) {
          var quote = quotes[i]
          if (!quote) continue
          if (!quote[centerIndex]) continue
          var totalShift = percentShift * quote[offsetIndex] + pointShift
          quote[sd.type + ' Top ' + sd.name] = quote[centerIndex] + totalShift
          quote[sd.type + ' Bottom ' + sd.name] =
            quote[centerIndex] - totalShift
          quote[sd.type + ' Median ' + sd.name] = quote[centerIndex]
          quote['Bandwidth ' + sd.name] =
            (200 * totalShift) / quote[centerIndex]
          quote['%b ' + sd.name] =
            50 * ((quote.Close - quote[centerIndex]) / totalShift + 1)
        }
      }

      CIQ.Studies.calculateMaxHighMinLow = function(stx, sd) {
        var quotes = sd.chart.scrubbed
        var highPeriod = sd.days,
          lowPeriod = sd.days
        if (sd.inputs['High Period']) highPeriod = sd.inputs['High Period']
        if (sd.inputs['Low Period']) lowPeriod = sd.inputs['Low Period']
        if (quotes.length < Math.max(highPeriod, lowPeriod) + 1) {
          sd.error = true
          return
        }

        var low = Number.MAX_VALUE,
          high = Number.MAX_VALUE * -1
        var j
        if (sd.startFrom > 1) {
          for (j = 1; j < highPeriod; j++) {
            high = Math.max(high, quotes[sd.startFrom - j].High)
          }
          for (j = 1; j < lowPeriod; j++) {
            low = Math.min(low, quotes[sd.startFrom - j].Low)
          }
        }
        for (var i = Math.max(0, sd.startFrom - 1); i < quotes.length; i++) {
          high = Math.max(high, quotes[i].High)
          low = Math.min(low, quotes[i].Low)
          if (i >= highPeriod) {
            if (quotes[i - highPeriod].High == high) {
              high = quotes[i].High
              for (j = 1; j < highPeriod; j++) {
                high = Math.max(high, quotes[i - j].High)
              }
            }
          }
          if (i >= lowPeriod) {
            if (quotes[i - lowPeriod].Low == low) {
              low = quotes[i].Low
              for (j = 1; j < lowPeriod; j++) {
                low = Math.min(low, quotes[i - j].Low)
              }
            }
          }
          var result = 0
          if (sd.type == 'HHV') {
            result = high
          } else if (sd.type == 'LLV') {
            result = low
          } else if (sd.type == 'Donchian Width') {
            result = high - low
          } else if (sd.type == 'GAPO' || sd.type == 'Gopala') {
            result = Math.log(high - low) / Math.log(lowPeriod)
          } else if (sd.type == 'VT HZ Filter') {
            result = high - low
            quotes[i]['_MHML ' + sd.name] = result
            continue
          } else if (sd.type == 'Williams %R') {
            result = (-100 * (high - quotes[i].Close)) / (high - low)
            quotes[i]['Result ' + sd.name] = result
            continue
          }
          if (i == quotes.length - 1) break

          if (sd.type == 'Donchian Channel') {
            quotes[i + 1]['Donchian High ' + sd.name] = high
            quotes[i + 1]['Donchian Low ' + sd.name] = low
            quotes[i + 1]['Donchian Median ' + sd.name] = (high + low) / 2
          } else {
            //width
            quotes[i + 1]['Result ' + sd.name] = result
          }
        }
      }

      CIQ.Studies.calculateAccumulationDistribution = function(stx, sd) {
        var quotes = sd.chart.scrubbed
        for (var i = sd.startFrom; i < quotes.length; i++) {
          if (!i) continue
          var quote = quotes[i]
          var quote1 = quotes[i - 1]
          var todayAD = 0
          if (quote.Close > quote1.Close) {
            todayAD = quote.Close - Math.min(quote.Low, quote1.Close)
          } else if (quote.Close < quote1.Close) {
            todayAD = quote.Close - Math.max(quote.High, quote1.Close)
          }
          if (sd.inputs['Use Volume']) todayAD *= quote.Volume

          var total = quote1['Result ' + sd.name]
          if (!total) total = 0
          total += todayAD
          quote['Result ' + sd.name] = total
        }
      }

      CIQ.Studies.calculateCCI = function(stx, sd) {
        var quotes = sd.chart.scrubbed
        if (quotes.length < sd.days + 1) {
          sd.error = true
          return
        }

        CIQ.Studies.MA('simple', sd.days, 'hlc/3', 0, 'MA', stx, sd)

        for (
          var i = Math.max(sd.startFrom, sd.days - 1);
          i < quotes.length;
          i++
        ) {
          var quote = quotes[i]
          if (!quote) continue
          var md = 0
          for (var j = 0; j < sd.days; j++) {
            md += Math.abs(quotes[i - j]['hlc/3'] - quote['MA ' + sd.name])
          }
          md /= sd.days
          if (Math.abs(md) < 0.00000001) quote['Result ' + sd.name] = 0
          else
            quote['Result ' + sd.name] =
              (quote['hlc/3'] - quote['MA ' + sd.name]) / (0.015 * md)
        }
      }

      CIQ.Studies.calculateFractalChaos = function(stx, sd) {
        var quotes = sd.chart.scrubbed

        var fractalHigh = 0
        var fractalLow = 0
        var test = 0
        if (sd.startFrom && sd.type == 'Fractal Chaos Bands') {
          fractalHigh = quotes[sd.startFrom - 1]['Fractal High ' + sd.name]
          fractalLow = quotes[sd.startFrom - 1]['Fractal Low ' + sd.name]
        }
        for (var i = Math.max(4, sd.startFrom); i < quotes.length; i++) {
          quotes[i]['Result ' + sd.name] = 0
          var j
          test = 0
          for (j = 0; j <= i; j++) {
            if (!quotes[i - j]) break
            if (quotes[i - j].High > quotes[i - 2].High) break
            if (j < 2 && quotes[i - j].High == quotes[i - 2].High) break
            if (quotes[i - j].High < quotes[i - 2].High) test++
            if (test == 4) {
              fractalHigh = quotes[i - 2].High
              break
            }
          }
          if (sd.type == 'Fractal Chaos Bands') {
            quotes[i]['Fractal High ' + sd.name] =
              fractalHigh > 0 ? fractalHigh : null
          } else if (test == 4) {
            //oscillator
            quotes[i]['Result ' + sd.name] = 1
          }
          test = 0
          for (j = 0; j <= i; j++) {
            if (!quotes[i - j]) break
            if (quotes[i - j].Low < quotes[i - 2].Low) break
            if (j < 2 && quotes[i - j].Low == quotes[i - 2].Low) break
            if (quotes[i - j].Low > quotes[i - 2].Low) test++
            if (test == 4) {
              fractalLow = quotes[i - 2].Low
              break
            }
          }
          if (sd.type == 'Fractal Chaos Bands') {
            quotes[i]['Fractal Low ' + sd.name] =
              fractalLow > 0 ? fractalLow : null
          } else if (test == 4) {
            //oscillator
            quotes[i]['Result ' + sd.name] = -1
          }
        }
      }

      CIQ.Studies.displayPrettyGoodOscillator = function(stx, sd, quotes) {
        CIQ.Studies.displaySeriesAsLine(stx, sd, quotes)

        var low = -3
        var high = 3

        var panel = stx.panels[sd.panel]
        var color = stx.chart.context.strokeStyle

        stx.chart.context.globalAlpha = 0.2
        stx.chart.context.strokeStyle = sd.outputs.Result

        stx.chart.context.beginPath()
        var ph = stx.pixelFromPrice(high, panel)
        stx.chart.context.moveTo(0, ph)
        stx.chart.context.lineTo(stx.chart.width, ph)

        var pl = stx.pixelFromPrice(low, panel)
        stx.chart.context.moveTo(0, pl)
        stx.chart.context.lineTo(stx.chart.width, pl)
        stx.chart.context.stroke()
        stx.chart.context.closePath()

        var params = {
          skipTransform: stx.panels[sd.panel].name != sd.chart.name,
          panelName: sd.panel,
          band: 'Result ' + sd.name,
          threshold: high,
          direction: 1,
          color: sd.outputs.Result,
        }
        CIQ.preparePeakValleyFill(stx, params)
        CIQ.preparePeakValleyFill(
          stx,
          CIQ.extend(params, { threshold: low, direction: -1 })
        )

        stx.chart.context.strokeStyle = color
        stx.chart.context.globalAlpha = 1
      }

      CIQ.Studies.displayRAVI = function(stx, sd, quotes) {
        var i
        CIQ.Studies.determineMinMax(stx, sd, quotes)
        var panel = stx.panels[sd.panel]
        panel.yAxis.low = panel.min = Math.min(0, panel.min)
        panel.yAxis.high = panel.max = Math.max(0, panel.max)
        CIQ.Studies.displaySeriesAsLine(stx, sd, quotes)

        var y = stx.pixelFromPrice(0, panel)

        var myWidth = stx.layout.candleWidth - 2
        if (myWidth < 2) myWidth = 1

        var upColor = CIQ.Studies.determineColor(sd.outputs['Increasing Bar'])
        var downColor = CIQ.Studies.determineColor(sd.outputs['Decreasing Bar'])
        stx.canvasColor('stx_histogram')
        stx.chart.context.globalAlpha = 1
        stx.startClip(sd.panel)
        for (i = 0; i < quotes.length; i++) {
          var quote = quotes[i]
          if (!quote || !quotes[i - 1]) continue
          var overBought = 0,
            overSold = 0
          if (sd.parameters && sd.parameters.studyOverZonesEnabled) {
            overBought = parseFloat(sd.parameters.studyOverBoughtValue)
            overSold = parseFloat(sd.parameters.studyOverSoldValue)
          }
          if (i === 0) stx.chart.context.fillStyle = '#CCCCCC'
          else if (
            quote[sd.name + '_hist'] > overBought &&
            quotes[i - 1][sd.name + '_hist'] < quote[sd.name + '_hist']
          )
            stx.chart.context.fillStyle = upColor
          else if (
            quote[sd.name + '_hist'] < overSold &&
            quotes[i - 1][sd.name + '_hist'] > quote[sd.name + '_hist']
          )
            stx.chart.context.fillStyle = downColor
          else stx.chart.context.fillStyle = '#CCCCCC'
          if (quote.candleWidth)
            myWidth = Math.floor(Math.max(1, quote.candleWidth - 2))
          stx.chart.context.fillRect(
            Math.floor(stx.pixelFromBar(i, panel.chart) - myWidth / 2),
            Math.floor(y),
            Math.floor(myWidth),
            Math.floor(stx.pixelFromPrice(quote[sd.name + '_hist'], panel) - y)
          )
        }
        stx.endClip()
      }

      CIQ.Studies.displayElderForce = function(stx, sd, quotes) {
        CIQ.Studies.displaySeriesAsLine(stx, sd, quotes)
        var params = {
          skipTransform: stx.panels[sd.panel].name != sd.chart.name,
          panelName: sd.panel,
          band: 'Result ' + sd.name,
          threshold: 0,
          color: sd.outputs.Result,
        }
        params.direction = 1
        CIQ.preparePeakValleyFill(stx, params)
        params.direction = -1
        CIQ.preparePeakValleyFill(stx, params)
      }

      CIQ.Studies.displayElderRay = function(stx, sd, quotes) {
        CIQ.Studies.determineMinMax(stx, sd, quotes)
        var panel = stx.panels[sd.panel]
        panel.yAxis.low = panel.min = Math.min(0, panel.min)
        panel.yAxis.high = panel.max = Math.max(0, panel.max)
        CIQ.Studies.displaySeriesAsLine(stx, sd, quotes)

        var y = stx.pixelFromPrice(0, panel)

        var myWidth = stx.layout.candleWidth - 2
        if (myWidth < 2) myWidth = 1
        function drawBar(i, reduction, output, hist) {
          stx.chart.context.fillStyle = CIQ.Studies.determineColor(
            sd.outputs[output]
          )
          stx.chart.context.fillRect(
            Math.floor(
              stx.pixelFromBar(i, panel.chart) -
                myWidth / 2 +
                myWidth * reduction
            ),
            Math.floor(y),
            Math.floor(myWidth * (1 - 2 * reduction)),
            Math.floor(stx.pixelFromPrice(quote[sd.name + hist], panel) - y)
          )
        }

        stx.canvasColor('stx_histogram')
        var fillStyle = stx.chart.context.fillStyle
        stx.chart.context.globalAlpha = 1
        stx.startClip(sd.panel)
        for (var i = 0; i < quotes.length; i++) {
          var quote = quotes[i]
          if (!quote) continue
          if (quote.candleWidth)
            myWidth = Math.floor(Math.max(1, quote.candleWidth - 2))
          if (quote[sd.name + '_hist1'] > 0)
            drawBar(i, 0, 'Elder Bull Power', '_hist1')
          if (quote[sd.name + '_hist2'] < 0)
            drawBar(i, 0, 'Elder Bear Power', '_hist2')
          if (quote[sd.name + '_hist1'] < 0)
            drawBar(i, 0.1, 'Elder Bull Power', '_hist1')
          if (quote[sd.name + '_hist2'] > 0)
            drawBar(i, 0.1, 'Elder Bear Power', '_hist2')
        }
        stx.endClip()
        stx.chart.context.fillStyle = fillStyle
      }

      CIQ.Studies.displayADX = function(stx, sd, quotes) {
        CIQ.Studies.createYAxis(stx, sd, quotes, stx.panels[sd.panel])
        if (sd.inputs.Series && sd.inputs.Shading) {
          var topBand = '+DI ' + sd.name,
            bottomBand = '-DI ' + sd.name
          var topColor = CIQ.Studies.determineColor(
              sd.outputs[sd.outputMap[topBand]]
            ),
            bottomColor = CIQ.Studies.determineColor(
              sd.outputs[sd.outputMap[bottomBand]]
            )
          var parameters = {
            topBand: topBand,
            bottomBand: bottomBand,
            topColor: topColor,
            bottomColor: bottomColor,
            skipTransform: stx.panels[sd.panel].name != sd.chart.name,
          }
          CIQ.fillIntersecting(stx, sd.panel, parameters)
        }
        var opacity = sd.inputs.Series ? 0.4 : 1
        if (sd.inputs.Histogram)
          CIQ.Studies.createHistogram(stx, sd, quotes, false, opacity)
        if (sd.inputs.Series !== false)
          CIQ.Studies.displaySeriesAsLine(stx, sd, quotes)
        else if (!sd.inputs.Series && !sd.inputs.Histogram)
          stx.watermark(
            sd.panel,
            'center',
            'bottom',
            stx.translateIf('Nothing to display')
          )
      }

      CIQ.Studies.displayMassIndex = function(stx, sd, quotes) {
        CIQ.Studies.displaySeriesAsLine(stx, sd, quotes)

        var bulge = sd.inputs['Bulge Threshold']

        var panel = stx.panels[sd.panel]
        var color = stx.chart.context.strokeStyle

        stx.chart.context.globalAlpha = 0.2
        stx.chart.context.strokeStyle = sd.outputs.Result

        stx.chart.context.beginPath()
        var p = stx.pixelFromPrice(bulge, panel)
        stx.chart.context.moveTo(0, p)
        stx.chart.context.lineTo(stx.chart.width, p)
        stx.chart.context.stroke()
        stx.chart.context.closePath()

        CIQ.preparePeakValleyFill(stx, {
          skipTransform: stx.panels[sd.panel].name != sd.chart.name,
          panelName: sd.panel,
          band: 'Result ' + sd.name,
          threshold: bulge,
          direction: 1,
          color: sd.outputs.Result,
        })

        stx.chart.context.strokeStyle = color
        stx.chart.context.globalAlpha = 1
      }

      /**
	 * Rendering function for displaying a Channel study output composed of top, middle and bottom lines.
	 *
	 * Requires study library input of <code>"Channel Fill":true</code> to determine if the area within the channel is to be shaded.
	 * Shading will be done using the "xxxxx Channel" or "xxxxx Median" color defined in the outputs parameter of the study library.
	 *
	 * Requires study library outputs to have fields in the format of :
	 * - 'xxxxx Top' or 'xxxxx High' for the top band,
	 * - 'xxxxx Bottom' or 'xxxxx Low' for the bottom band and
	 * - 'xxxxx Median' or 'xxxxx Channel' for the middle line.
	 *
	 * It expects 'quotes' to have fields for each series in the channel with keys in the following format:
	 * - study-output-name ( from study library) + " " + sd.name.
	 * - Example: 'Prime Bands Top'+ ' ' +  'Prime Number Bands (true)'. Which equals : 'Prime Bands Top Prime Number Bands (true)'
	 *
	 * @param  {CIQ.ChartEngine} stx Chart object
	 * @param  {studyDescriptor} sd  Study Descriptor
	 * @param {array} quotes The array of quotes needed to render the channel
	 * @memberOf CIQ.Studies
	 * @example
	 * "inputs": {"Period":5, "Shift": 3, "Field":"field", "Channel Fill":true}
	 * "outputs": {"Prime Bands Top":"red", "Prime Bands Bottom":"auto", "Prime Bands Channel":"rgb(184,44,11)"}
	 * @example
	 * // full definition example including opacity
		"Bollinger Bands": {
			"name": "Bollinger Bands",
			"overlay": true,
			"calculateFN": CIQ.Studies.calculateBollinger,
			"seriesFN": CIQ.Studies.displayChannel,
			"inputs": {"Field":"field", "Period":20, "Standard Deviations": 2, "Moving Average Type":"ma", "Channel Fill": true},
			"outputs": {"Bollinger Bands Top":"auto", "Bollinger Bands Median":"auto", "Bollinger Bands Bottom":"auto"},
			"attributes": {
				"Standard Deviations":{min:0.1,step:0.1}
			},
			"parameters": {
				"init":{opacity: 0.2}
			}
		}
	 * @since 4.1.0 now also uses sd.parameters.opacity if one defined.
	 * @since 4.1.0 now shading is rendered under the channel lines instead of over.
	 */
      CIQ.Studies.displayChannel = function(stx, sd, quotes) {
        if (sd.inputs['Channel Fill']) {
          var parameters = { panelName: sd.panel }
          for (var p in sd.outputs) {
            var lastWord = p.split(' ').pop()
            if (lastWord == 'Top' || lastWord == 'High') {
              parameters.topBand = p + ' ' + sd.name
            } else if (lastWord == 'Bottom' || lastWord == 'Low') {
              parameters.bottomBand = p + ' ' + sd.name
            } else if (lastWord == 'Median' || lastWord == 'Channel') {
              parameters.color = CIQ.Studies.determineColor(sd.outputs[p])
            }
          }
          if (sd.parameters && sd.parameters.opacity) {
            parameters.opacity = sd.parameters.opacity
          }
          parameters.skipTransform = stx.panels[sd.panel].name != sd.chart.name
          CIQ.prepareChannelFill(stx, parameters)
        }
        CIQ.Studies.displaySeriesAsLine(stx, sd, quotes)
      }

      CIQ.Studies.inputAttributeDefaultGenerator = function(value) {
        if (!value && value !== 0) return {}
        if (value.constructor == Number) {
          if (Math.floor(value) == value) {
            // Integer
            if (value > 0) return { min: 1, step: 1 } // positive
            return { step: 1 } // full range
          }
          // Decimal
          if (value > 0) return { min: 0, step: 0.01 } // positive
          return { step: 0.01 } // full range
        }
        return {}
      }

      /**
       * Function to determine which studies are available.
       * @param  {object} excludeList Exclusion list of studies in object form ( e.g. {"rsi":true,"macd":true})
       * @returns {object} Map of avaialbe entries from {@link CIQ.Studies.studyLibrary}.
       * @memberof CIQ.Studies
       * @since 3.0.0
       */
      CIQ.Studies.getStudyList = function(excludeList) {
        var map = {}
        var excludedStudies = {
          Directional: true,
          Gopala: true,
          vchart: true,
        }
        CIQ.extend(excludedStudies, excludeList)
        for (var libraryEntry in CIQ.Studies.studyLibrary) {
          if (!excludedStudies[libraryEntry])
            map[CIQ.Studies.studyLibrary[libraryEntry].name] = libraryEntry
        }
        return map
      }

      /**
       * A helper function that will find the color value in the output.
       * @param {String/Object} output Color string value or object that has the color value
       * @return {String}	Color value
       * @since 4.0.0
       */
      CIQ.Studies.determineColor = function(output) {
        if (!output) {
          return null
        } else if (typeof output === 'object') {
          return output.color
        }

        return output
      }

      /**
	 * The studyLibrary defines all of the available studies. This is used to drive the dialog boxes and creation of the studies. When you
	 * create a custom study you should add it to the studyLibrary.
	 *
	 * You can also alter study defaults by overriding the different elements on each definition.
	 * For example, if you wanted to change the default colors for the volume underlay,
	 * you would add the following code in your files; making sure your files are loaded **after** the library js files -- not before:
	 * ```
	 * CIQ.Studies.studyLibrary["vol undr"].outputs= {"Up Volume":"blue","Down Volume":"yellow"};
	 * ```
	 * See {@tutorial Using and Customizing Studies} for complete details
	 * @type {Object}
	 * @memberOf CIQ.Studies
	 * @example
	 * "RAVI": {
			"name": "RAVI",
			"seriesFN": CIQ.Studies.displayRAVI,
			"calculateFN": CIQ.Studies.calculatePriceOscillator,
			"inputs": {"Field":"field", "Short Cycle":7, "Long Cycle":65},
			"outputs": {"Increasing Bar":"#00DD00", "Decreasing Bar":"#FF0000"},
			"parameters": {
				template:"studyOverZones",
				init:{studyOverZonesEnabled:true, studyOverBoughtValue:3, studyOverBoughtColor:"auto", studyOverSoldValue:-3, studyOverSoldColor:"auto"}
			},
			"attributes":{
				"studyOverBoughtValue":{"min":0,"step":"0.1"},
				"studyOverSoldValue":{"max":0,"step":"0.1"}
			}
		},
	 */
      CIQ.Studies.studyLibrary = {
        rsi: {
          name: 'RSI',
          inputs: { Period: 14 },
          calculateFN: CIQ.Studies.calculateRSI,
          range: '0 to 100',
          outputs: { RSI: 'auto' },
          parameters: {
            template: 'studyOverZones',
            init: {
              studyOverZonesEnabled: true,
              studyOverBoughtValue: 80,
              studyOverBoughtColor: 'auto',
              studyOverSoldValue: 20,
              studyOverSoldColor: 'auto',
            },
          },
        },
        ma: {
          name: 'Moving Average',
          overlay: true,
          range: 'bypass',
          calculateFN: CIQ.Studies.calculateMovingAverage,
          inputs: {
            Period: 50,
            Field: 'field',
            Type: 'ma',
            Offset: 0,
            Underlay: false,
          },
          outputs: { MA: '#FF0000' },
        },
        macd: {
          name: 'MACD',
          calculateFN: CIQ.Studies.calculateMACD,
          seriesFN: CIQ.Studies.displayHistogramWithSeries,
          inputs: {
            'Fast MA Period': 12,
            'Slow MA Period': 26,
            'Signal Period': 9,
          },
          outputs: {
            MACD: 'auto',
            Signal: '#FF0000',
            'Increasing Bar': '#00DD00',
            'Decreasing Bar': '#FF0000',
          },
        },
        stochastics: {
          name: 'Stochastics',
          range: '0 to 100',
          initializeFN: CIQ.Studies.initializeStochastics,
          calculateFN: CIQ.Studies.calculateStochastics,
          inputs: { Period: 14, Smooth: true },
          outputs: { Fast: 'auto', Slow: '#FF0000' },
          parameters: {
            template: 'studyOverZones',
            init: {
              studyOverZonesEnabled: true,
              studyOverBoughtValue: 80,
              studyOverBoughtColor: 'auto',
              studyOverSoldValue: 20,
              studyOverSoldColor: 'auto',
            },
          },
        },
        Aroon: {
          name: 'Aroon',
          range: '0 to 100',
          calculateFN: CIQ.Studies.calculateAroon,
          outputs: { 'Aroon Up': '#00DD00', 'Aroon Down': '#FF0000' },
        },
        'Aroon Osc': {
          name: 'Aroon Oscillator',
          calculateFN: CIQ.Studies.calculateAroon,
          outputs: { 'Aroon Oscillator': 'auto' },
        },
        'Lin R2': {
          name: 'Linear Reg R2',
          calculateFN: CIQ.Studies.calculateLinearRegressionIndicator,
          inputs: { Period: 14, Field: 'field' },
          outputs: { RSquared: 'auto' },
        },
        'Lin Fcst': {
          name: 'Linear Reg Forecast',
          overlay: true,
          calculateFN: CIQ.Studies.calculateLinearRegressionIndicator,
          inputs: { Period: 14, Field: 'field' },
          outputs: { Forecast: 'auto' },
        },
        'Lin Incpt': {
          name: 'Linear Reg Intercept',
          overlay: true,
          calculateFN: CIQ.Studies.calculateLinearRegressionIndicator,
          inputs: { Period: 14, Field: 'field' },
          outputs: { Intercept: 'auto' },
        },
        'Time Fcst': {
          name: 'Time Series Forecast',
          overlay: true,
          calculateFN: CIQ.Studies.calculateLinearRegressionIndicator,
          inputs: { Period: 14, Field: 'field' },
          outputs: { Forecast: 'auto' },
        },
        'VT HZ Filter': {
          name: 'Vertical Horizontal Filter',
          calculateFN: CIQ.Studies.calculateVerticalHorizontalFilter,
          inputs: { Period: 28 },
        },
        TRIX: {
          name: 'TRIX',
          calculateFN: CIQ.Studies.calculateTRIX,
        },
        'STD Dev': {
          name: 'Standard Deviation',
          calculateFN: CIQ.Studies.calculateStandardDeviation,
          inputs: {
            Period: 14,
            Field: 'field',
            'Standard Deviations': 2,
            'Moving Average Type': 'ma',
          },
          attributes: {
            'Standard Deviations': { min: 0.1, step: 0.1 },
          },
        },
        'Trade Vol': {
          name: 'Trade Volume Index',
          calculateFN: CIQ.Studies.calculateOnBalanceVolume,
          inputs: { 'Min Tick Value': 0.5 },
        },
        Swing: {
          name: 'Swing Index',
          calculateFN: CIQ.Studies.calculateSwingIndex,
          inputs: { 'Limit Move Value': 0.5 },
        },
        'Acc Swing': {
          name: 'Accumulative Swing Index',
          calculateFN: CIQ.Studies.calculateSwingIndex,
          inputs: { 'Limit Move Value': 0.5 },
        },
        'Price ROC': {
          name: 'Price Rate of Change',
          calculateFN: CIQ.Studies.calculateRateOfChange,
          inputs: { Field: 'field', Period: 14 },
        },
        'Vol ROC': {
          name: 'Volume Rate of Change',
          calculateFN: CIQ.Studies.calculateRateOfChange,
        },
        Momentum: {
          name: 'Momentum Indicator',
          calculateFN: CIQ.Studies.calculateRateOfChange,
          inputs: { Period: 14 },
          centerline: 0,
        },
        'Price Vol': {
          name: 'Price Volume Trend',
          calculateFN: CIQ.Studies.calculatePriceVolumeTrend,
          inputs: { Field: 'field' },
        },
        'Pos Vol': {
          name: 'Positive Volume Index',
          calculateFN: CIQ.Studies.calculateVolumeIndex,
          inputs: { Field: 'field', 'Moving Average Type': 'ma', Period: 255 },
          outputs: { Index: 'auto', MA: '#FF0000' },
        },
        'Neg Vol': {
          name: 'Negative Volume Index',
          calculateFN: CIQ.Studies.calculateVolumeIndex,
          inputs: { Field: 'field', 'Moving Average Type': 'ma', Period: 255 },
          outputs: { Index: 'auto', MA: '#FF0000' },
        },
        'On Bal Vol': {
          name: 'On Balance Volume',
          calculateFN: CIQ.Studies.calculateOnBalanceVolume,
          inputs: {},
        },
        'Stch Mtm': {
          name: 'Stochastic Momentum Index',
          calculateFN: CIQ.Studies.calculateStochMomentum,
          inputs: {
            '%K Periods': 10,
            '%K Smoothing Periods': 3,
            '%K Double Smoothing Periods': 3,
            '%D Periods': 10,
            '%D Moving Average Type': 'ema',
          },
          outputs: { '%K': 'auto', '%D': '#FF0000' },
          parameters: {
            template: 'studyOverZones',
            init: {
              studyOverZonesEnabled: true,
              studyOverBoughtValue: 40,
              studyOverBoughtColor: 'auto',
              studyOverSoldValue: -40,
              studyOverSoldColor: 'auto',
            },
          },
        },
        'Hist Vol': {
          name: 'Historical Volatility',
          calculateFN: CIQ.Studies.calculateHistoricalVolatility,
          inputs: {
            Field: 'field',
            Period: 10,
            'Days Per Year': [252, 365],
            'Standard Deviations': 1,
          },
          attributes: {
            'Standard Deviations': { min: 0.1, step: 0.1 },
          },
        },
        'Pretty Good': {
          name: 'Pretty Good Oscillator',
          seriesFN: CIQ.Studies.displayPrettyGoodOscillator,
          calculateFN: CIQ.Studies.calculatePrettyGoodOscillator,
        },
        Ultimate: {
          name: 'Ultimate Oscillator',
          calculateFN: CIQ.Studies.calculateUltimateOscillator,
          inputs: { 'Cycle 1': 7, 'Cycle 2': 14, 'Cycle 3': 28 },
          parameters: {
            template: 'studyOverZones',
            init: {
              studyOverZonesEnabled: true,
              studyOverBoughtValue: 70,
              studyOverBoughtColor: 'auto',
              studyOverSoldValue: 30,
              studyOverSoldColor: 'auto',
            },
          },
        },
        'Vol Osc': {
          name: 'Volume Oscillator',
          calculateFN: CIQ.Studies.calculatePriceOscillator,
          inputs: {
            'Short Cycle': 12,
            'Long Cycle': 26,
            'Points Or Percent': ['Points', 'Percent'],
          },
          parameters: {
            init: { isVolume: true },
          },
        },
        Twiggs: {
          name: 'Twiggs Money Flow',
          calculateFN: CIQ.Studies.calculateTwiggsMoneyFlow,
          inputs: { Period: 21 },
        },
        'Chaikin MF': {
          name: 'Chaikin Money Flow',
          calculateFN: CIQ.Studies.calculateChaikinMoneyFlow,
          inputs: { Period: 20 },
        },
        'Chaikin Vol': {
          name: 'Chaikin Volatility',
          calculateFN: CIQ.Studies.calculateChaikinVolatility,
          inputs: {
            Period: 14,
            'Rate Of Change': 2,
            'Moving Average Type': 'ma',
          },
        },
        'Price Osc': {
          name: 'Price Oscillator',
          calculateFN: CIQ.Studies.calculatePriceOscillator,
          inputs: {
            Field: 'field',
            'Long Cycle': 26,
            'Short Cycle': 12,
            'Moving Average Type': 'ema',
            'Points Or Percent': ['Points', 'Percent'],
          },
        },
        EOM: {
          name: 'Ease of Movement',
          calculateFN: CIQ.Studies.calculateEaseOfMovement,
          inputs: { Period: 14, 'Moving Average Type': 'ma' },
        },
        CCI: {
          name: 'Commodity Channel Index',
          calculateFN: CIQ.Studies.calculateCCI,
          inputs: { Period: 20 },
          parameters: {
            template: 'studyOverZones',
            init: {
              studyOverZonesEnabled: true,
              studyOverBoughtValue: 100,
              studyOverBoughtColor: 'auto',
              studyOverSoldValue: -100,
              studyOverSoldColor: 'auto',
            },
          },
          attributes: {
            Period: { min: 2 },
          },
        },
        Detrended: {
          name: 'Detrended Price Oscillator',
          calculateFN: CIQ.Studies.calculateDetrendedPrice,
          inputs: { Field: 'field', Period: 14, 'Moving Average Type': 'ma' },
        },
        'True Range': {
          name: 'True Range',
          calculateFN: CIQ.Studies.calculateStudyATR,
          inputs: {},
          outputs: { 'True Range': 'auto' },
        },
        ATR: {
          name: 'Average True Range',
          calculateFN: CIQ.Studies.calculateStudyATR,
          outputs: { ATR: 'auto' },
        },
        'Ehler Fisher': {
          name: 'Ehler Fisher Transform',
          calculateFN: CIQ.Studies.calculateEhlerFisher,
          inputs: { Period: 10 },
          outputs: { EF: 'auto', 'EF Trigger': '#FF0000' },
        },
        Schaff: {
          name: 'Schaff Trend Cycle',
          range: '0 to 100',
          calculateFN: CIQ.Studies.calculateSchaff,
          inputs: {
            Field: 'field',
            Period: 10,
            'Short Cycle': 23,
            'Long Cycle': 50,
            'Moving Average Type': 'ema',
          },
          parameters: {
            template: 'studyOverZones',
            init: {
              studyOverZonesEnabled: true,
              studyOverBoughtValue: 75,
              studyOverBoughtColor: 'auto',
              studyOverSoldValue: 25,
              studyOverSoldColor: 'auto',
            },
          },
        },
        QStick: {
          name: 'QStick',
          calculateFN: CIQ.Studies.calculateQStick,
          inputs: { Period: 8, 'Moving Average Type': 'ma' },
        },
        Coppock: {
          name: 'Coppock Curve',
          calculateFN: CIQ.Studies.calculateCoppock,
          inputs: {
            Field: 'field',
            'Short RoC': 11,
            'Long RoC': 14,
            Period: 10,
          },
        },
        'Chande Mtm': {
          name: 'Chande Momentum Oscillator',
          calculateFN: CIQ.Studies.calculateChandeMomentum,
          inputs: { Period: 9 },
          parameters: {
            template: 'studyOverZones',
            init: {
              studyOverZonesEnabled: true,
              studyOverBoughtValue: 50,
              studyOverBoughtColor: 'auto',
              studyOverSoldValue: -50,
              studyOverSoldColor: 'auto',
            },
          },
        },
        'Chande Fcst': {
          name: 'Chande Forecast Oscillator',
          calculateFN: CIQ.Studies.calculateChandeForecast,
          inputs: { Field: 'field', Period: 14 },
        },
        'Intraday Mtm': {
          name: 'Intraday Momentum Index',
          calculateFN: CIQ.Studies.calculateIntradayMomentum,
          inputs: { Period: 20 },
          parameters: {
            template: 'studyOverZones',
            init: {
              studyOverZonesEnabled: true,
              studyOverBoughtValue: 70,
              studyOverBoughtColor: 'auto',
              studyOverSoldValue: 30,
              studyOverSoldColor: 'auto',
            },
          },
        },
        RAVI: {
          name: 'RAVI',
          seriesFN: CIQ.Studies.displayRAVI,
          calculateFN: CIQ.Studies.calculatePriceOscillator,
          inputs: {
            Field: 'field',
            'Moving Average Type': 'vdma',
            'Short Cycle': 7,
            'Long Cycle': 65,
          },
          outputs: { 'Increasing Bar': '#00DD00', 'Decreasing Bar': '#FF0000' },
          parameters: {
            template: 'studyOverZones',
            init: {
              studyOverZonesEnabled: true,
              studyOverBoughtValue: 3,
              studyOverBoughtColor: 'auto',
              studyOverSoldValue: -3,
              studyOverSoldColor: 'auto',
            },
          },
          attributes: {
            studyOverBoughtValue: { min: 0, step: '0.1' },
            studyOverSoldValue: { max: 0, step: '0.1' },
          },
        },
        'Random Walk': {
          name: 'Random Walk Index',
          calculateFN: CIQ.Studies.calculateRandomWalk,
          outputs: {
            'Random Walk High': '#FF0000',
            'Random Walk Low': '#0000FF',
          },
        },
        ADX: {
          name: 'ADX/DMS',
          calculateFN: CIQ.Studies.calculateADX,
          seriesFN: CIQ.Studies.displayADX,
          inputs: {
            Period: 14,
            'Smoothing Period': 14,
            Series: true,
            Shading: false,
            Histogram: false,
          },
          outputs: {
            '+DI': '#00FF00',
            '-DI': '#FF0000',
            ADX: 'auto',
            'Positive Bar': '#00DD00',
            'Negative Bar': '#FF0000',
          },
        },
        'High Low': {
          name: 'High Low Bands',
          overlay: true,
          seriesFN: CIQ.Studies.displayChannel,
          calculateFN: function(stx, sd) {
            sd.inputs['Moving Average Type'] = 'triangular'
            CIQ.Studies.calculateMAEnvelope(stx, sd)
          },
          inputs: {
            Field: 'field',
            Period: 10,
            'Shift Percentage': 5,
            'Channel Fill': true,
          },
          outputs: {
            'High Low Top': 'auto',
            'High Low Median': 'auto',
            'High Low Bottom': 'auto',
          },
          attributes: {
            'Shift Percentage': { min: 0.1, step: 0.1 },
          },
        },
        'High-Low': {
          name: 'High Minus Low',
          calculateFN: function(stx, sd) {
            var quotes = sd.chart.scrubbed
            for (var i = sd.startFrom; i < quotes.length; i++) {
              quotes[i]['Result ' + sd.name] = quotes[i].High - quotes[i].Low
            }
          },
          inputs: {},
        },
        'Med Price': {
          name: 'Median Price',
          calculateFN: CIQ.Studies.calculateTypicalPrice,
          inputs: { Period: 14, Overlay: false },
        },
        'MA Env': {
          name: 'Moving Average Envelope',
          overlay: true,
          seriesFN: CIQ.Studies.displayChannel,
          calculateFN: CIQ.Studies.calculateMAEnvelope,
          inputs: {
            Field: 'field',
            Period: 50,
            'Shift Type': ['percent', 'points'],
            Shift: 5,
            'Moving Average Type': 'ma',
            'Channel Fill': true,
          },
          outputs: {
            'MA Env Top': 'auto',
            'MA Env Median': 'auto',
            'MA Env Bottom': 'auto',
          },
          attributes: {
            Shift: { min: 0.1, step: 0.1 },
          },
        },
        'Fractal Chaos Bands': {
          name: 'Fractal Chaos Bands',
          overlay: true,
          calculateFN: CIQ.Studies.calculateFractalChaos,
          seriesFN: CIQ.Studies.displayChannel,
          inputs: { 'Channel Fill': true },
          outputs: {
            'Fractal High': 'auto',
            'Fractal Low': 'auto',
            'Fractal Channel': 'auto',
          },
        },
        'Fractal Chaos': {
          name: 'Fractal Chaos Oscillator',
          range: '-1 to 1',
          calculateFN: CIQ.Studies.calculateFractalChaos,
          inputs: {},
          centerline: 20, //so centerline is "off the chart" and not visible
        },
        GAPO: {
          name: 'Gopalakrishnan Range Index',
          calculateFN: CIQ.Studies.calculateMaxHighMinLow,
        },
        'Prime Number Bands': {
          name: 'Prime Number Bands',
          overlay: true,
          calculateFN: CIQ.Studies.calculatePrimeNumber,
          seriesFN: CIQ.Studies.displayChannel,
          inputs: { 'Channel Fill': true },
          outputs: {
            'Prime Bands Top': 'auto',
            'Prime Bands Bottom': 'auto',
            'Prime Bands Channel': 'auto',
          },
        },
        'Prime Number': {
          name: 'Prime Number Oscillator',
          range: '-1 to 1',
          calculateFN: CIQ.Studies.calculatePrimeNumber,
          inputs: { 'Tolerance Percentage': 5 },
          attributes: {
            'Tolerance Percentage': { min: 0.1, step: 0.1 },
          },
        },
        'Bollinger Bands': {
          name: 'Bollinger Bands',
          overlay: true,
          calculateFN: CIQ.Studies.calculateBollinger,
          seriesFN: CIQ.Studies.displayChannel,
          inputs: {
            Field: 'field',
            Period: 20,
            'Standard Deviations': 2,
            'Moving Average Type': 'ma',
            'Channel Fill': true,
          },
          outputs: {
            'Bollinger Bands Top': 'auto',
            'Bollinger Bands Median': 'auto',
            'Bollinger Bands Bottom': 'auto',
          },
          attributes: {
            'Standard Deviations': { min: 0.1, step: 0.1 },
          },
        },
        'Donchian Channel': {
          name: 'Donchian Channel',
          overlay: true,
          calculateFN: CIQ.Studies.calculateMaxHighMinLow,
          seriesFN: CIQ.Studies.displayChannel,
          inputs: { 'High Period': 20, 'Low Period': 20, 'Channel Fill': true },
          outputs: {
            'Donchian High': 'auto',
            'Donchian Median': 'auto',
            'Donchian Low': 'auto',
          },
        },
        HHV: {
          name: 'Highest High Value',
          calculateFN: CIQ.Studies.calculateMaxHighMinLow,
          inputs: { Period: 14 },
        },
        LLV: {
          name: 'Lowest Low Value',
          calculateFN: CIQ.Studies.calculateMaxHighMinLow,
          inputs: { Period: 14 },
        },
        'Mass Idx': {
          name: 'Mass Index',
          seriesFN: CIQ.Studies.displayMassIndex,
          calculateFN: CIQ.Studies.calculateMassIndex,
          inputs: { Period: 25, 'Bulge Threshold': 27 },
          attributes: {
            'Bulge Threshold': { min: 20, max: 35, step: 0.1 },
          },
        },
        Keltner: {
          name: 'Keltner Channel',
          overlay: true,
          seriesFN: CIQ.Studies.displayChannel,
          calculateFN: CIQ.Studies.calculateKeltner,
          inputs: {
            Period: 50,
            Shift: 5,
            'Moving Average Type': 'ema',
            'Channel Fill': true,
          },
          outputs: {
            'Keltner Top': 'auto',
            'Keltner Median': 'auto',
            'Keltner Bottom': 'auto',
          },
          attributes: {
            Shift: { min: 0.1, step: 0.1 },
          },
        },
        PSAR: {
          name: 'Parabolic SAR',
          overlay: true,
          calculateFN: CIQ.Studies.calculatePSAR,
          seriesFN: CIQ.Studies.displayPSAR2,
          inputs: { 'Minimum AF': 0.02, 'Maximum AF': 0.2 },
        },
        Klinger: {
          name: 'Klinger Volume Oscillator',
          seriesFN: CIQ.Studies.displayHistogramWithSeries,
          calculateFN: CIQ.Studies.calculateKlinger,
          inputs: { 'Signal Periods': 13, 'Short Cycle': 34, 'Long Cycle': 55 },
          outputs: {
            Klinger: 'auto',
            KlingerSignal: '#FF0000',
            'Increasing Bar': '#00DD00',
            'Decreasing Bar': '#FF0000',
          },
        },
        'Elder Ray': {
          name: 'Elder Ray Index',
          seriesFN: CIQ.Studies.displayElderRay,
          calculateFN: CIQ.Studies.calculateElderRay,
          inputs: { Period: 13 },
          outputs: {
            'Elder Bull Power': '#00DD00',
            'Elder Bear Power': '#FF0000',
          },
        },
        'Elder Force': {
          name: 'Elder Force Index',
          calculateFN: CIQ.Studies.calculateElderForce,
          seriesFN: CIQ.Studies.displayElderForce,
          inputs: { Period: 13 },
        },
        'LR Slope': {
          name: 'Linear Reg Slope',
          calculateFN: CIQ.Studies.calculateLinearRegressionIndicator,
          inputs: { Period: 14, Field: 'field' },
          outputs: { Slope: 'auto' },
        },
        COG: {
          name: 'Center Of Gravity',
          calculateFN: CIQ.Studies.calculateCenterOfGravity,
          inputs: { Period: 10, Field: 'field' },
        },
        'Typical Price': {
          name: 'Typical Price',
          calculateFN: CIQ.Studies.calculateTypicalPrice,
          inputs: { Period: 14, Overlay: false },
        },
        'Weighted Close': {
          name: 'Weighted Close',
          calculateFN: CIQ.Studies.calculateTypicalPrice,
          inputs: { Period: 14, Overlay: false },
        },
        'M Flow': {
          name: 'Money Flow Index',
          range: '0 to 100',
          calculateFN: CIQ.Studies.calculateMoneyFlowIndex,
          inputs: { Period: 14 },
          parameters: {
            template: 'studyOverZones',
            init: {
              studyOverZonesEnabled: true,
              studyOverBoughtValue: 80,
              studyOverBoughtColor: 'auto',
              studyOverSoldValue: 20,
              studyOverSoldColor: 'auto',
            },
          },
        },
        'Williams %R': {
          name: 'Williams %R',
          calculateFN: CIQ.Studies.calculateMaxHighMinLow,
          inputs: { Period: 14 },
          parameters: {
            template: 'studyOverZones',
            init: {
              studyOverZonesEnabled: true,
              studyOverBoughtValue: -20,
              studyOverBoughtColor: 'auto',
              studyOverSoldValue: -80,
              studyOverSoldColor: 'auto',
            },
          },
        },
        'W Acc Dist': {
          name: 'Accumulation/Distribution',
          calculateFN: CIQ.Studies.calculateAccumulationDistribution,
          inputs: { 'Use Volume': false },
        },
        volume: {
          name: 'Volume Chart',
          range: '0 to max',
          yAxis: { ground: true, initialMarginTop: 0 },
          seriesFN: CIQ.Studies.createVolumeChart,
          calculateFN: CIQ.Studies.calculateVolume,
          inputs: {},
          outputs: { 'Up Volume': '#8cc176', 'Down Volume': '#b82c0c' },
          parameters: {
            zoom: 0,
            widthFactor: 1,
          },
        },
        'vol undr': {
          name: 'Volume Underlay',
          underlay: true,
          seriesFN: CIQ.Studies.createVolumeChart,
          calculateFN: CIQ.Studies.calculateVolume,
          inputs: {},
          outputs: { 'Up Volume': '#8cc176', 'Down Volume': '#b82c0c' },
          customRemoval: true,
          removeFN: function(stx, sd) {
            stx.layout.volumeUnderlay = false
            stx.changeOccurred('layout')
          },
          parameters: {
            init: { heightPercentage: 0.25 },
            widthFactor: 1,
          },
        },
      }

      return _exports
    }

  var __drawingAdvanced_ =
    //-------------------------------------------------------------------------------------------
    // Copyright 2012-2017 by ChartIQ, Inc.
    // All rights reserved
    //-------------------------------------------------------------------------------------------
    function(_exports) {
      var CIQ = _exports.CIQ,
        timezoneJS = _exports.timezoneJS

      /**
       * Channel drawing tool. Creates a channel within 2 parallel line segments.
       *
       * It inherits its properties from {@link CIQ.Drawing.segment}.
       * @constructor
       * @name  CIQ.Drawing.channel
       * @version ChartIQ Advanced Package
       */
      CIQ.Drawing.channel = function() {
        this.name = 'channel'
        this.dragToDraw = false
        this.p2 = null
      }

      CIQ.Drawing.channel.ciqInheritsFrom(CIQ.Drawing.segment)

      CIQ.Drawing.channel.prototype.configs = [
        'color',
        'fillColor',
        'lineWidth',
        'pattern',
      ]

      CIQ.Drawing.channel.prototype.move = function(context, tick, value) {
        if (!this.penDown) return

        this.copyConfig()
        if (this.p2 === null) this.p1 = [tick, value]
        else {
          var y =
            value -
            ((this.p1[1] - this.p0[1]) / (this.p1[0] - this.p0[0])) *
              (tick - this.p1[0])
          this.p2 = [this.p1[0], y]
        }
        this.render(context)
      }

      CIQ.Drawing.channel.prototype.click = function(context, tick, value) {
        var panel = this.stx.panels[this.panelName]
        if (!panel) return
        this.copyConfig()
        if (!this.penDown) {
          this.setPoint(0, tick, value, panel.chart)
          this.penDown = true
          return false
        }
        if (this.accidentalClick(tick, value)) {
          this.stx.undo() //abort
          return true
        }

        if (this.p2 !== null) {
          this.setPoint(2, this.p2[0], this.p2[1], panel.chart)
          return true
        }
        this.setPoint(1, tick, value, panel.chart)
        if (this.p0[0] == this.p1[0]) {
          // don't allow vertical line
          this.p1 = null
          return false
        }
        this.p2 = [this.p1[0], this.p1[1]]
        return false
      }

      CIQ.Drawing.channel.prototype.boxIntersection = function(tick, value) {
        if (!this.p0 || !this.p1 || !this.p2) return false
        if (
          tick > Math.max(this.p0[0], this.p1[0]) ||
          tick < Math.min(this.p0[0], this.p1[0])
        )
          return false

        // http://stackoverflow.com/questions/1560492/how-to-tell-whether-a-point-is-to-the-right-or-left-side-of-a-line
        var s1 =
          (this.p1[0] - this.p0[0]) * (value - this.p0[1]) -
          (this.p1[1] - this.p0[1]) * (tick - this.p0[0])
        var s2 =
          (this.p2[0] - this.p0[0]) *
            (value - (this.p0[1] + this.p2[1] - this.p1[1])) -
          (this.p1[1] - this.p0[1]) * (tick - this.p0[0])
        return s1 * s2 < 0
      }

      CIQ.Drawing.channel.prototype.intersected = function(tick, value, box) {
        if (!this.p0 || !this.p1 || !this.p2) return null // in case invalid drawing (such as from panel that no longer exists)
        if (this.pointIntersection(this.p0[0], this.p0[1], box)) {
          this.highlighted = 'p0'
          return {
            action: 'drag',
            point: 'p0',
          }
        } else if (this.pointIntersection(this.p1[0], this.p1[1], box)) {
          this.highlighted = 'p1'
          return {
            action: 'drag',
            point: 'p1',
          }
        } else if (this.pointIntersection(this.p2[0], this.p2[1], box)) {
          this.highlighted = 'p2'
          return {
            action: 'drag',
            point: 'p2',
          }
        }
        if (this.boxIntersection(tick, value)) {
          this.highlighted = true
          // This object will be used for repositioning
          return {
            action: 'move',
            p0: CIQ.clone(this.p0),
            p1: CIQ.clone(this.p1),
            p2: CIQ.clone(this.p2),
            tick: tick, // save original tick
            value: value, // save original value
          }
        }
        return null
      }

      CIQ.Drawing.channel.prototype.render = function(context) {
        var panel = this.stx.panels[this.panelName]
        if (!panel) return
        var x0 = this.stx.pixelFromTick(this.p0[0], panel.chart)
        var x1 = this.stx.pixelFromTick(this.p1[0], panel.chart)
        var y0 = this.stx.pixelFromValueAdjusted(panel, this.p0[0], this.p0[1])
        var y1 = this.stx.pixelFromValueAdjusted(panel, this.p1[0], this.p1[1])
        var y = null
        if (this.p2) {
          y = this.stx.pixelFromValueAdjusted(panel, this.p2[0], this.p2[1])
        }

        var width = this.lineWidth
        var color = this.setLineColor()

        var fillColor = this.fillColor
        if (
          this.p2 &&
          fillColor &&
          !CIQ.isTransparent(fillColor) &&
          fillColor != 'auto'
        ) {
          context.beginPath()
          context.moveTo(x0, y0)
          context.lineTo(x1, y1)
          context.lineTo(x1, y)
          context.lineTo(x0, y0 + (y - y1))
          context.closePath()
          context.globalAlpha = 0.2
          context.fillStyle = fillColor
          context.fill()
          context.globalAlpha = 1
        }

        var parameters = {
          pattern: this.pattern,
          lineWidth: width,
        }
        this.stx.plotLine(
          x0,
          x1,
          y0,
          y1,
          color,
          'segment',
          context,
          panel,
          parameters
        )
        if (this.p2)
          this.stx.plotLine(
            x0,
            x1,
            y0 + (y - y1),
            y,
            color,
            'segment',
            context,
            panel,
            parameters
          )

        if (this.highlighted) {
          var p0Fill = this.highlighted == 'p0' ? true : false
          var p1Fill = this.highlighted == 'p1' ? true : false
          var p2Fill = this.highlighted == 'p2' ? true : false
          this.littleCircle(context, x0, y0, p0Fill)
          this.littleCircle(context, x1, y1, p1Fill)
          this.littleCircle(context, x1, y, p2Fill)
        }
      }

      CIQ.Drawing.channel.prototype.reposition = function(
        context,
        repositioner,
        tick,
        value
      ) {
        if (!repositioner) return
        var panel = this.stx.panels[this.panelName]
        var tickDiff = repositioner.tick - tick
        var valueDiff = repositioner.value - value
        if (repositioner.action == 'move') {
          this.setPoint(
            0,
            repositioner.p0[0] - tickDiff,
            repositioner.p0[1] - valueDiff,
            panel.chart
          )
          this.setPoint(
            1,
            repositioner.p1[0] - tickDiff,
            repositioner.p1[1] - valueDiff,
            panel.chart
          )
          this.setPoint(
            2,
            repositioner.p2[0] - tickDiff,
            repositioner.p2[1] - valueDiff,
            panel.chart
          )
          this.render(context)
        } else if (repositioner.action == 'drag') {
          this[repositioner.point] = [tick, value]
          this.setPoint(0, this.p0[0], this.p0[1], panel.chart)
          this.setPoint(1, this.p1[0], this.p1[1], panel.chart)
          this.setPoint(2, this.p2[0], this.p2[1], panel.chart)
          this.render(context)
        }
      }

      CIQ.Drawing.channel.prototype.adjust = function() {
        var panel = this.stx.panels[this.panelName]
        if (!panel) return
        this.setPoint(0, this.d0, this.v0, panel.chart)
        this.setPoint(1, this.d1, this.v1, panel.chart)
        this.setPoint(2, this.d1, this.v2, panel.chart) //not an error, should be d1 here
      }

      /**
       * Reconstruct a channel
       * @memberOf CIQ.Drawing.channel
       * @param  {CIQ.ChartEngine} stx The chart object
       * @param  {object} [obj] A drawing descriptor
       * @param {string} [obj.col] The line color
       * @param {string} [obj.fc] The fill color
       * @param {string} [obj.pnl] The panel name
       * @param {string} [obj.ptrn] Optional pattern for line "solid","dotted","dashed". Defaults to solid.
       * @param {number} [obj.lw] Optional line width. Defaults to 1.
       * @param {number} [obj.v0] Value (price) for the first point
       * @param {number} [obj.v1] Value (price) for the second point
       * @param {number} [obj.v2] Value (price) for the second point of the opposing parallel channel line
       * @param {number} [obj.d0] Date (string form) for the first point
       * @param {number} [obj.d1] Date (string form) for the second point
       * @param {number} [obj.tzo0] Offset of UTC from d0 in minutes
       * @param {number} [obj.tzo1] Offset of UTC from d1 in minutes
       */
      CIQ.Drawing.channel.prototype.reconstruct = function(stx, obj) {
        this.stx = stx
        this.color = obj.col
        this.fillColor = obj.fc
        this.panelName = obj.pnl
        this.pattern = obj.ptrn
        this.lineWidth = obj.lw
        this.d0 = obj.d0
        this.d1 = obj.d1
        this.tzo0 = obj.tzo0
        this.tzo1 = obj.tzo1
        this.v0 = obj.v0
        this.v1 = obj.v1
        this.v2 = obj.v2
        this.adjust()
      }

      CIQ.Drawing.channel.prototype.serialize = function() {
        return {
          name: this.name,
          pnl: this.panelName,
          col: this.color,
          fc: this.fillColor,
          ptrn: this.pattern,
          lw: this.lineWidth,
          d0: this.d0,
          d1: this.d1,
          tzo0: this.tzo0,
          tzo1: this.tzo1,
          v0: this.v0,
          v1: this.v1,
          v2: this.v2,
        }
      }

      /**
       * Andrews' Pitchfork drawing tool. A Pitchfork is defined by three parallel rays.  The center ray is equidistant from the two outer rays.
       *
       * It inherits its properties from {@link CIQ.Drawing.channel}.
       * @constructor
       * @name  CIQ.Drawing.pitchfork
       * @version ChartIQ Advanced Package
       */
      CIQ.Drawing.pitchfork = function() {
        this.name = 'pitchfork'
        this.dragToDraw = false
        this.p2 = null
      }

      CIQ.Drawing.pitchfork.ciqInheritsFrom(CIQ.Drawing.channel)

      CIQ.Drawing.pitchfork.prototype.configs = [
        'color',
        'lineWidth',
        'pattern',
      ]

      CIQ.Drawing.pitchfork.prototype.move = function(context, tick, value) {
        if (!this.penDown) return

        this.copyConfig()
        if (this.p2 === null) this.p1 = [tick, value]
        else this.p2 = [tick, value]
        this.render(context)
      }

      CIQ.Drawing.pitchfork.prototype.lineIntersection = function(
        tick,
        value,
        box,
        type
      ) {
        var p0 = this.p0,
          p1 = this.p1,
          p2 = this.p2,
          layout = this.stx.layout
        return (
          p0 &&
          p1 &&
          p2 &&
          CIQ.boxIntersects(
            box.x0,
            box.y0,
            box.x1,
            box.y1,
            p0[0],
            p0[1],
            (p1[0] + p2[0]) / 2,
            (p1[1] + p2[1]) / 2,
            type,
            layout.semiLog || layout.chartScale == 'log'
          )
        )
      }

      CIQ.Drawing.pitchfork.prototype.intersected = function(tick, value, box) {
        if (!this.p0 || !this.p1 || !this.p2) return null // in case invalid drawing (such as from panel that no longer exists)
        if (this.pointIntersection(this.p0[0], this.p0[1], box)) {
          this.highlighted = 'p0'
          return {
            action: 'drag',
            point: 'p0',
          }
        } else if (this.pointIntersection(this.p1[0], this.p1[1], box)) {
          this.highlighted = 'p1'
          return {
            action: 'drag',
            point: 'p1',
          }
        } else if (this.pointIntersection(this.p2[0], this.p2[1], box)) {
          this.highlighted = 'p2'
          return {
            action: 'drag',
            point: 'p2',
          }
        }
        var isIntersected = this.lineIntersection(tick, value, box, 'ray')
        if (isIntersected) {
          this.highlighted = true
          // This object will be used for repositioning
          return {
            action: 'move',
            p0: CIQ.clone(this.p0),
            p1: CIQ.clone(this.p1),
            p2: CIQ.clone(this.p2),
            tick: tick, // save original tick
            value: value, // save original value
          }
        }
        return null
      }

      CIQ.Drawing.pitchfork.prototype.render = function(context) {
        var panel = this.stx.panels[this.panelName]
        if (!panel) return
        var p2 = this.p2
        if (!p2) p2 = this.p1
        var x0 = this.stx.pixelFromTick(this.p0[0], panel.chart)
        var x1 = this.stx.pixelFromTick(this.p1[0], panel.chart)
        var x2 = this.stx.pixelFromTick(p2[0], panel.chart)
        var y0 = this.stx.pixelFromValueAdjusted(panel, this.p0[0], this.p0[1])
        var y1 = this.stx.pixelFromValueAdjusted(panel, this.p1[0], this.p1[1])
        var y2 = this.stx.pixelFromValueAdjusted(panel, p2[0], p2[1])

        var width = this.lineWidth
        var color = this.setLineColor()

        var parameters = {
          pattern: this.pattern,
          lineWidth: width,
        }
        var z = 50
        var yp = 2 * y0 - y1 - y2
        var denom = 2 * x0 - x1 - x2
        if (denom < 0) z *= -1
        yp = (z * yp) / denom
        this.stx.plotLine(
          x0,
          (x1 + x2) / 2,
          y0,
          (y1 + y2) / 2,
          color,
          'ray',
          context,
          panel,
          parameters
        )
        this.stx.plotLine(
          x1,
          x2,
          y1,
          y2,
          color,
          'segment',
          context,
          panel,
          parameters
        )
        if (!(x1 == x2 && y1 == y2)) {
          this.stx.plotLine(
            x1,
            x1 - z,
            y1,
            y1 - yp,
            color,
            'ray',
            context,
            panel,
            parameters
          )
          this.stx.plotLine(
            x2,
            x2 - z,
            y2,
            y2 - yp,
            color,
            'ray',
            context,
            panel,
            parameters
          )
        }
        if (this.highlighted) {
          var p0Fill = this.highlighted == 'p0' ? true : false
          var p1Fill = this.highlighted == 'p1' ? true : false
          var p2Fill = this.highlighted == 'p2' ? true : false
          this.littleCircle(context, x0, y0, p0Fill)
          this.littleCircle(context, x1, y1, p1Fill)
          this.littleCircle(context, x2, y2, p2Fill)
        }
      }

      CIQ.Drawing.pitchfork.prototype.adjust = function() {
        var panel = this.stx.panels[this.panelName]
        if (!panel) return
        this.setPoint(0, this.d0, this.v0, panel.chart)
        this.setPoint(1, this.d1, this.v1, panel.chart)
        this.setPoint(2, this.d2, this.v2, panel.chart)
      }

      /**
       * Reconstruct a pitchfork
       * @memberOf CIQ.Drawing.pitchfork
       * @param  {CIQ.ChartEngine} stx The chart object
       * @param  {object} [obj] A drawing descriptor
       * @param {string} [obj.col] The line color
       * @param {string} [obj.pnl] The panel name
       * @param {string} [obj.ptrn] Optional pattern for line "solid","dotted","dashed". Defaults to solid.
       * @param {number} [obj.lw] Optional line width. Defaults to 1.
       * @param {number} [obj.v0] Value (price) for the first point
       * @param {number} [obj.v1] Value (price) for the second point
       * @param {number} [obj.v2] Value (price) for the third point
       * @param {number} [obj.d0] Date (string form) for the first point
       * @param {number} [obj.d1] Date (string form) for the second point
       * @param {number} [obj.d2] Date (string form) for the third point
       * @param {number} [obj.tzo0] Offset of UTC from d0 in minutes
       * @param {number} [obj.tzo1] Offset of UTC from d1 in minutes
       * @param {number} [obj.tzo2] Offset of UTC from d2 in minutes
       */
      CIQ.Drawing.pitchfork.prototype.reconstruct = function(stx, obj) {
        this.stx = stx
        this.color = obj.col
        this.panelName = obj.pnl
        this.pattern = obj.ptrn
        this.lineWidth = obj.lw
        this.d0 = obj.d0
        this.d1 = obj.d1
        this.d2 = obj.d2
        this.tzo0 = obj.tzo0
        this.tzo1 = obj.tzo1
        this.tzo2 = obj.tzo2
        this.v0 = obj.v0
        this.v1 = obj.v1
        this.v2 = obj.v2
        this.adjust()
      }

      CIQ.Drawing.pitchfork.prototype.serialize = function() {
        return {
          name: this.name,
          pnl: this.panelName,
          col: this.color,
          ptrn: this.pattern,
          lw: this.lineWidth,
          d0: this.d0,
          d1: this.d1,
          d2: this.d2,
          tzo0: this.tzo0,
          tzo1: this.tzo1,
          tzo2: this.tzo2,
          v0: this.v0,
          v1: this.v1,
          v2: this.v2,
        }
      }

      /**
       * Gartley drawing tool. Creates a series of four connected line segments, each one completed with a user click.
       * Will adhere to Gartley requirements vis-a-vis fibonacci levels etc..
       *
       * It inherits its properties from {@link CIQ.Drawing.continuous}.
       * @constructor
       * @name  CIQ.Drawing.gartley
       * @version ChartIQ Advanced Package
       * @since 04-2015-15
       */
      CIQ.Drawing.gartley = function() {
        this.name = 'gartley'
        this.dragToDraw = false
        this.maxSegments = 4
        this.shape = null
        this.points = []
      }

      CIQ.Drawing.gartley.ciqInheritsFrom(CIQ.Drawing.continuous)

      CIQ.Drawing.gartley.prototype.check = function(first, second) {
        if (!second) return true
        if (first[0] >= second[0] || first[1] == second[1]) return false
        if (this.segment == 1) {
          if (first[1] < second[1]) this.shape = 'M'
          else this.shape = 'W'
        } else if (this.segment == 2) {
          if (this.shape == 'M' && first[1] < second[1]) return false
          else if (this.shape == 'W' && first[1] > second[1]) return false
          else if (
            (second[1] - first[1]) / (this.points[0][1] - first[1]) <
            0.618
          )
            return false
          else if (
            (second[1] - first[1]) / (this.points[0][1] - first[1]) >=
            0.786
          )
            return false
        } else if (this.segment == 3) {
          if (this.shape == 'M' && first[1] > second[1]) return false
          else if (this.shape == 'W' && first[1] < second[1]) return false
          else if (
            (second[1] - first[1]) / (this.points[1][1] - first[1]) <
            0.618
          )
            return false
          else if (
            (second[1] - first[1]) / (this.points[1][1] - first[1]) >=
            0.786
          )
            return false
        } else if (this.segment == 4) {
          if (
            this.shape == 'M' &&
            (first[1] < second[1] || second[1] < this.points[0][1])
          )
            return false
          else if (
            this.shape == 'W' &&
            (first[1] > second[1] || second[1] > this.points[0][1])
          )
            return false
          else if (
            (this.points[1][1] - second[1]) /
              (this.points[1][1] - this.points[2][1]) <
            1.27
          )
            return false
          else if (
            (this.points[1][1] - second[1]) /
              (this.points[1][1] - this.points[2][1]) >=
            1.618
          )
            return false
        }
        return true
      }

      CIQ.Drawing.gartley.prototype.click = function(context, tick, value) {
        var panel = this.stx.panels[this.panelName]
        if (!panel) return
        this.copyConfig()
        if (!this.penDown) {
          this.setPoint(0, tick, value, panel.chart)
          this.pts = []
          this.penDown = true
          this.segment = 1
          return false
        }
        if (this.accidentalClick(tick, value)) {
          this.penDown = true
          return false
        }
        if (this.check(this.p0, this.p1)) {
          if (this.segment == 1) this.points.push(this.p0)
          this.points.push(this.p1)
          this.drawDropZones = true
          this.setPoint(1, tick, value, panel.chart)
          this.segment++

          if (this.segment > this.maxSegments) {
            this.setPoint(0, this.points[0][0], this.points[0][1], panel.chart)
            return true
          }
          this.pts.push(this.d1, this.tzo1, this.v1)
          this.setPoint(0, tick, value, panel.chart) // reset initial point for next segment, copy by value
        }
        return false
      }

      CIQ.Drawing.gartley.prototype.render = function(context) {
        var panel = this.stx.panels[this.panelName]
        if (!panel) return
        var x0 = this.stx.pixelFromTick(this.p0[0], panel.chart)
        var x1 = this.stx.pixelFromTick(this.p1[0], panel.chart)
        var y0 = this.stx.pixelFromValueAdjusted(panel, this.p0[0], this.p0[1])
        var y1 = this.stx.pixelFromValueAdjusted(panel, this.p1[0], this.p1[1])

        if (this.segment == 2) {
          this.drawDropZone(
            context,
            0.618 * this.points[0][1] + 0.382 * this.p0[1],
            0.786 * this.points[0][1] + 0.214 * this.p0[1],
            this.p0[0]
          )
        } else if (this.segment == 3) {
          this.drawDropZone(
            context,
            0.618 * this.points[1][1] + 0.382 * this.p0[1],
            0.786 * this.points[1][1] + 0.214 * this.p0[1],
            this.p0[0]
          )
        } else if (this.segment == 4) {
          var bound = 1.618 * this.points[2][1] - 0.618 * this.points[1][1]
          if (this.shape == 'M') bound = Math.max(bound, this.points[0][1])
          else bound = Math.min(bound, this.points[0][1])
          this.drawDropZone(
            context,
            bound,
            1.27 * this.points[2][1] - 0.27 * this.points[1][1],
            this.p0[0]
          )
        }

        var width = this.lineWidth
        var color = this.setLineColor()

        var parameters = {
          pattern: this.pattern,
          lineWidth: width,
        }
        if (this.segment <= this.maxSegments)
          this.stx.plotLine(
            x0,
            x1,
            y0,
            y1,
            color,
            this.name,
            context,
            panel,
            parameters
          )

        var fillColor = this.fillColor
        var coords = []
        if (this.points.length) {
          context.beginPath()
          for (var fp = 1; fp < this.points.length && fp <= 4; fp++) {
            var xx0 = this.stx.pixelFromTick(
              this.points[fp - 1][0],
              panel.chart
            )
            var xx1 = this.stx.pixelFromTick(this.points[fp][0], panel.chart)
            var yy0 = this.stx.pixelFromValueAdjusted(
              panel,
              this.points[fp - 1][0],
              this.points[fp - 1][1]
            )
            var yy1 = this.stx.pixelFromValueAdjusted(
              panel,
              this.points[fp][0],
              this.points[fp][1]
            )
            if (fp == 1) coords.push(xx0, yy0)
            coords.push(xx1, yy1)
            this.stx.plotLine(
              xx0,
              xx1,
              yy0,
              yy1,
              color,
              this.name,
              context,
              panel,
              parameters
            )
          }
          if (this.points.length == 2 || this.points.length == 4) {
            coords.push(x1, y1)
          }
          if (this.points[2]) {
            coords.push(
              this.stx.pixelFromTick(this.points[2][0], panel.chart),
              this.stx.pixelFromValueAdjusted(
                panel,
                this.points[2][0],
                this.points[2][1]
              )
            )
          }
          if (
            fillColor &&
            fillColor != 'auto' &&
            !CIQ.isTransparent(fillColor)
          ) {
            for (var c = 0; c < coords.length; c += 2) {
              if (c === 0) context.moveTo(coords[0], coords[1])
              context.lineTo(coords[c], coords[c + 1])
            }
            context.fillStyle = fillColor
            context.globalAlpha = 0.2
            context.closePath()
            context.fill()
            context.globalAlpha = 1
          }
        }

        /*if(this.highlighted){
			var p0Fill=this.highlighted=="p0"?true:false;
			var p1Fill=this.highlighted=="p1"?true:false;
			this.littleCircle(context, x0, y0, p0Fill);
			this.littleCircle(context, x1, y1, p1Fill);
		}*/
      }

      CIQ.Drawing.gartley.prototype.lineIntersection = function(
        tick,
        value,
        box,
        type
      ) {
        var points = this.points,
          layout = this.stx.layout
        if (points.length != this.maxSegments + 1) return false
        for (var pt = 0; pt < points.length - 1; pt++) {
          if (
            CIQ.boxIntersects(
              box.x0,
              box.y0,
              box.x1,
              box.y1,
              points[pt][0],
              points[pt][1],
              points[pt + 1][0],
              points[pt + 1][1],
              'segment',
              layout.semiLog || layout.chartScale == 'log'
            )
          )
            return true
        }
        return false
      }

      CIQ.Drawing.gartley.prototype.boxIntersection = function(tick, value) {
        if (!this.p0 || !this.p1) return false
        if (
          tick > Math.max(this.p0[0], this.p1[0]) ||
          tick < Math.min(this.p0[0], this.p1[0])
        )
          return false
        var lowPoint = Math.min(this.p0[1], this.p1[1])
        var highPoint = Math.max(this.p0[1], this.p1[1])
        for (var pt = 0; pt < this.points.length; pt++) {
          lowPoint = Math.min(lowPoint, this.points[pt][1])
          highPoint = Math.max(highPoint, this.points[pt][1])
        }
        if (value > highPoint || value < lowPoint) return false
        return true
      }

      CIQ.Drawing.gartley.prototype.reposition = function(
        context,
        repositioner,
        tick,
        value
      ) {
        if (!repositioner) return
        var panel = this.stx.panels[this.panelName]
        var tickDiff = repositioner.tick - tick
        repositioner.tick = tick
        var valueDiff = repositioner.value - value
        repositioner.value = value
        if (repositioner.action == 'move') {
          this.pts = []
          for (var pt = 0; pt < this.points.length; pt++) {
            this.points[pt][0] -= tickDiff
            this.points[pt][1] -= valueDiff
            this.setPoint(
              1,
              this.points[pt][0],
              this.points[pt][1],
              panel.chart
            )
            if (pt && pt < this.points.length - 1)
              this.pts.push(this.d1, this.tzo1, this.v1)
            this.points[pt] = this.p1
          }
          this.setPoint(0, this.points[0][0], this.points[0][1], panel.chart)
          this.render(context)
          /*}else if(repositioner.action=="drag"){
			this[repositioner.point]=[tick, value];
			this.setPoint(0, this.p0[0], this.p0[1], panel.chart);
			this.setPoint(1, this.p1[0], this.p1[1], panel.chart);
			this.render(context);*/
        }
      }

      CIQ.Drawing.gartley.prototype.configs = [
        'color',
        'fillColor',
        'lineWidth',
        'pattern',
      ]

      CIQ.Drawing.gartley.prototype.drawDropZone = function(
        context,
        hBound1,
        hBound2,
        leftBound
      ) {
        var panel = this.stx.panels[this.panelName]
        if (!panel) return
        var y0 = this.stx.pixelFromPrice(hBound1, panel)
        var y1 = this.stx.pixelFromPrice(hBound2, panel) - y0
        var x0 = this.stx.pixelFromTick(leftBound, panel.chart)
        var x1 = this.stx.chart.width - x0
        context.fillStyle = '#008000'
        context.globalAlpha = 0.2
        context.fillRect(x0, y0, x1, y1)
        context.globalAlpha = 1
      }

      CIQ.Drawing.gartley.prototype.adjust = function() {
        // If the drawing's panel doesn't exist then we'll check to see
        // whether the panel has been added. If not then there's no way to adjust
        var panel = this.stx.panels[this.panelName]
        if (!panel) return
        this.reconstructPoints()

        this.setPoint(0, this.d0, this.v0, panel.chart)
        this.points.unshift(this.p0)

        this.setPoint(1, this.d1, this.v1, panel.chart)
        this.points.push(this.p1)
      }

      CIQ.Drawing.gartley.prototype.reconstructPoints = function() {
        var panel = this.stx.panels[this.panelName]
        if (!panel) return
        this.points = []
        for (var a = 0; a < this.pts.length; a += 3) {
          var d = CIQ.strToDateTime(this.pts[a])
          d.setMinutes(
            d.getMinutes() + Number(this.pts[a + 1]) - d.getTimezoneOffset()
          )
          this.points.push([
            this.stx.tickFromDate(CIQ.yyyymmddhhmmssmmm(d), panel.chart),
            this.pts[a + 2],
          ])
        }
      }

      /**
       * Reconstruct a gartley
       * @memberOf CIQ.Drawing.gartley
       * @param  {CIQ.ChartEngine} stx The chart object
       * @param  {object} [obj] A drawing descriptor
       * @param {string} [obj.col] The line color
       * @param {string} [obj.fc] The fill color
       * @param {string} [obj.pnl] The panel name
       * @param {string} [obj.ptrn] Optional pattern for line "solid","dotted","dashed". Defaults to solid.
       * @param {number} [obj.lw] Optional line width. Defaults to 1.
       * @param {number} [obj.v0] Value (price) for the first point
       * @param {number} [obj.v1] Value (price) for the last point
       * @param {number} [obj.d0] Date (string form) for the first point
       * @param {number} [obj.d1] Date (string form) for the last point
       * @param {number} [obj.tzo0] Offset of UTC from d0 in minutes
       * @param {number} [obj.tzo1] Offset of UTC from d1 in minutes
       * @param {number} [obj.pts] a serialized list of dates,offsets,values for the 3 intermediate points of the gartley (should be 9 items in list)
       */
      CIQ.Drawing.gartley.prototype.reconstruct = function(stx, obj) {
        this.stx = stx
        this.color = obj.col
        this.fillColor = obj.fc
        this.panelName = obj.pnl
        this.pattern = obj.ptrn
        this.lineWidth = obj.lw
        this.d0 = obj.d0
        this.d1 = obj.d1
        this.tzo0 = obj.tzo0
        this.tzo1 = obj.tzo1
        this.v0 = obj.v0
        this.v1 = obj.v1
        this.pts = obj.pts.split(',')
        this.adjust()
      }

      CIQ.Drawing.gartley.prototype.serialize = function() {
        return {
          name: this.name,
          pnl: this.panelName,
          col: this.color,
          fc: this.fillColor,
          ptrn: this.pattern,
          lw: this.lineWidth,
          d0: this.d0,
          d1: this.d1,
          tzo0: this.tzo0,
          tzo1: this.tzo1,
          v0: this.v0,
          v1: this.v1,
          pts: this.pts.join(','),
        }
      }

      /**
       * Freeform drawing tool. Set splineTension to a value from 0 to 1 (default .3). This is a dragToDraw function
       * and automatically disables the crosshairs while enabled.
       *
       * It inherits its properties from {@link CIQ.Drawing.segment}.
       * @constructor
       * @name  CIQ.Drawing.freeform
       * @version ChartIQ Advanced Package
       */
      CIQ.Drawing.freeform = function() {
        this.name = 'freeform'
        this.splineTension = 0.3 //set to -1 to not use splines at all
        this.dragToDraw = true
      }

      CIQ.Drawing.freeform.ciqInheritsFrom(CIQ.Drawing.segment)

      CIQ.Drawing.freeform.prototype.measure = function() {}

      CIQ.Drawing.freeform.prototype.intersected = function(tick, value, box) {
        if (tick > this.hiX || tick < this.lowX) return null
        if (value > this.hiY || value < this.lowY) return null
        this.highlighted = true
        // This object will be used for repositioning
        return {
          action: 'move',
          p0: CIQ.clone(this.p0),
          tick: tick, // save original tick
          value: value, // save original value
        }
      }

      CIQ.Drawing.freeform.prototype.reposition = function(
        context,
        repositioner,
        tick,
        value
      ) {
        if (!repositioner) return
        var panel = this.stx.panels[this.panelName]
        var tickDiff = repositioner.tick - tick
        var valueDiff = repositioner.value - value
        if (repositioner.action == 'move') {
          this.setPoint(
            0,
            repositioner.p0[0] - tickDiff,
            repositioner.p0[1] - valueDiff,
            panel.chart
          )
          this.adjust()
          this.render(context)
        }
      }

      CIQ.Drawing.freeform.prototype.click = function(context, tick, value) {
        var panel = this.stx.panels[this.panelName]
        if (!panel) return

        if (this.penDown === false) {
          this.copyConfig()
          this.startX = Math.round(
            this.stx.resolveX(this.stx.pixelFromTick(tick, panel.chart))
          )
          this.startY = Math.round(
            this.stx.resolveY(
              this.stx.pixelFromValueAdjusted(panel, tick, value)
            )
          )
          var d = this.stx.dateFromTick(tick, panel.chart, true)
          this.d0 = CIQ.yyyymmddhhmmssmmm(d)
          this.tzo0 = d.getTimezoneOffset()
          this.v0 = value
          this.p0 = [
            CIQ.ChartEngine.crosshairX - this.startX,
            CIQ.ChartEngine.crosshairY - this.startY,
          ]
          this.nodes = [this.p0[0], this.p0[1]]
          this.pNodes = [this.p0]
          this.candleWidth = this.stx.layout.candleWidth
          this.multiplier = panel.yAxis.multiplier
          this.interval = this.stx.layout.interval
          this.periodicity = this.stx.layout.periodicity
          this.tempSplineTension = this.splineTension
          this.splineTension = -1
          document.body.style.cursor = 'pointer'
          this.penDown = true
          return false
        }
        this.penDown = false
        this.splineTension = this.tempSplineTension
        document.body.style.cursor = 'auto'
        //this.adjust(); //moved to drawingClick - Gus
        return true
      }

      CIQ.Drawing.freeform.prototype.move = function(context, tick, value) {
        if (!this.penDown) return

        var panel = this.stx.panels[this.panelName]
        var d1 = this.stx.dateFromTick(tick, panel.chart, true)
        this.d1 = CIQ.yyyymmddhhmmssmmm(d1)
        this.tzo1 = d1.getTimezoneOffset()
        this.v1 = value
        this.p1 = [
          CIQ.ChartEngine.crosshairX - this.startX,
          CIQ.ChartEngine.crosshairY - this.startY,
        ]

        if (this.pNodes.length > 2) {
          if (
            this.p1[0] == this.pNodes[this.pNodes.length - 2][0] &&
            this.p1[0] == this.pNodes[this.pNodes.length - 1][0]
          ) {
            this.pNodes.length--
            this.nodes.length -= 2
          } else if (
            this.p1[1] == this.pNodes[this.pNodes.length - 2][1] &&
            this.p1[1] == this.pNodes[this.pNodes.length - 1][1]
          ) {
            this.pNodes.length--
            this.nodes.length -= 2
          }
        }

        this.nodes.push(this.p1[0], this.p1[1])
        this.pNodes.push(this.p1)

        this.render(context)
        return false
      }

      //TODO: make more exact, and relocate this to somewhere useful
      CIQ.Drawing.freeform.prototype.intervalRatio = function(
        oldInterval,
        newInterval,
        oldPeriodicity,
        newPeriodicity,
        startDate,
        symbol
      ) {
        //approximating functions
        function weeksInMonth(startDate, symbol) {
          return 5
        }
        function daysInWeek(startDate, symbol) {
          return 5
        }
        function daysInMonth(startDate, symbol) {
          return 30
        }
        function minPerDay(startDate, symbol) {
          if (CIQ.Market.Symbology.isForexSymbol(symbol)) return 1440
          return 390
        }
        //1,3,5,10,15,30,"day","week","month"
        var returnValue = 0
        if (oldInterval == newInterval) returnValue = 1
        else if (!isNaN(oldInterval) && !isNaN(newInterval))
          returnValue = oldInterval / newInterval
        //two intraday intervals
        else if (isNaN(oldInterval)) {
          //was daily
          if (oldInterval == 'month') {
            if (newInterval == 'week')
              returnValue = weeksInMonth(startDate, symbol)
            else if (newInterval == 'day')
              returnValue = daysInMonth(startDate, symbol)
            else if (!isNaN(newInterval))
              returnValue =
                (daysInMonth(startDate, symbol) *
                  minPerDay(startDate, symbol)) /
                newInterval
          } else if (oldInterval == 'week') {
            if (newInterval == 'month')
              returnValue = 1 / weeksInMonth(startDate, symbol)
            if (newInterval == 'day')
              returnValue = daysInWeek(startDate, symbol)
            else if (!isNaN(newInterval))
              returnValue =
                (daysInWeek(startDate, symbol) * minPerDay(startDate, symbol)) /
                newInterval
          } else if (oldInterval == 'day') {
            if (newInterval == 'week')
              returnValue = 1 / daysInWeek(startDate, symbol)
            else if (newInterval == 'month')
              returnValue = 1 / daysInMonth(startDate, symbol)
            else if (!isNaN(newInterval))
              returnValue = minPerDay(startDate, symbol) / newInterval
          }
        } else if (!isNaN(oldInterval)) {
          //switching from intraday to daily
          if (newInterval == 'month')
            returnValue =
              oldInterval /
              (daysInMonth(startDate, symbol) * minPerDay(startDate, symbol))
          else if (newInterval == 'week')
            returnValue =
              oldInterval /
              (daysInWeek(startDate, symbol) * minPerDay(startDate, symbol))
          else if (newInterval == 'day')
            returnValue = oldInterval / minPerDay(startDate, symbol)
        }
        returnValue *= oldPeriodicity / newPeriodicity
        return returnValue
      }

      CIQ.Drawing.freeform.prototype.render = function(context) {
        var panel = this.stx.panels[this.panelName]
        if (!panel) return

        var intvl = this.intervalRatio(
          this.interval,
          this.stx.layout.interval,
          this.periodicity,
          this.stx.layout.periodicity,
          this.d0,
          panel.chart.symbol
        )
        if (intvl === 0) return

        var cwr = this.stx.layout.candleWidth / this.candleWidth
        var mlt = panel.yAxis.multiplier / this.multiplier
        this.setPoint(0, this.d0, this.v0, panel.chart)
        var spx = this.stx.pixelFromTick(this.p0[0], panel.chart)
        var spy = this.stx.pixelFromValueAdjusted(panel, this.p0[0], this.p0[1])
        var arrPoints = []

        var width = this.lineWidth
        var color = this.setLineColor()

        var parameters = {
          pattern: this.pattern,
          lineWidth: width,
        }

        for (var n = 0; n < this.pNodes.length; n++) {
          var x0 = intvl * cwr * this.pNodes[n][0] + spx
          var y0 = mlt * this.pNodes[n][1] + spy
          arrPoints.push(x0, y0)
        }

        if (!arrPoints.length) return
        if (this.splineTension < 0) {
          this.stx.connectTheDots(
            arrPoints,
            color,
            this.name,
            context,
            panel,
            parameters
          )
        } else {
          this.stx.plotSpline(
            arrPoints,
            this.splineTension,
            color,
            this.name,
            context,
            true,
            parameters
          )
        }
      }

      CIQ.Drawing.freeform.prototype.adjust = function() {
        // If the drawing's panel doesn't exist then we'll check to see
        // whether the panel has been added. If not then there's no way to adjust
        var panel = this.stx.panels[this.panelName]
        if (!panel) return

        var p0 = [this.nodes[0], this.nodes[1]]
        this.pNodes = [p0]
        this.lowX = this.nodes[0]
        this.hiX = this.nodes[0]
        this.lowY = this.nodes[1]
        this.hiY = this.nodes[1]

        for (var n = 2; n < this.nodes.length; n += 2) {
          var p1 = [this.nodes[n], this.nodes[n + 1]]
          this.pNodes.push(p1)
          this.lowX = Math.min(this.lowX, p1[0])
          this.hiX = Math.max(this.hiX, p1[0])
          this.lowY = Math.max(this.lowY, p1[1]) //reversed because price axis goes bottom to top
          this.hiY = Math.min(this.hiY, p1[1])
        }

        var intvl = this.intervalRatio(
          this.interval,
          this.stx.layout.interval,
          this.periodicity,
          this.stx.layout.periodicity,
          this.d0,
          panel.chart.symbol
        )
        if (intvl === 0) return

        var cwr = this.stx.layout.candleWidth / this.candleWidth
        var mlt = panel.yAxis.multiplier / this.multiplier
        this.setPoint(0, this.d0, this.v0, panel.chart)
        var spx = this.stx.pixelFromTick(this.p0[0], panel.chart)
        var spy = this.stx.pixelFromValueAdjusted(panel, this.p0[0], this.p0[1])

        this.lowX = this.stx.tickFromPixel(
          Math.floor(intvl * cwr * this.lowX) + spx,
          panel.chart
        )
        this.hiX = this.stx.tickFromPixel(
          Math.ceil(intvl * cwr * this.hiX) + spx,
          panel.chart
        )
        this.lowY = this.stx.valueFromPixel(
          Math.floor(mlt * this.lowY) + spy,
          panel
        )
        this.hiY = this.stx.valueFromPixel(
          Math.ceil(mlt * this.hiY) + spy,
          panel
        )
      }

      CIQ.Drawing.freeform.prototype.serialize = function() {
        return {
          name: this.name,
          pnl: this.panelName,
          col: this.color,
          ptrn: this.pattern,
          lw: this.lineWidth,
          cw: Number(this.candleWidth.toFixed(4)),
          mlt: Number(this.multiplier.toFixed(4)),
          d0: this.d0,
          tzo0: this.tzo0,
          v0: this.v0,
          inter: this.interval,
          pd: this.periodicity,
          nodes: this.nodes,
        }
      }

      /**
       * Reconstruct a freeform drawing. It is not recommended to do this programatically.
       * @param  {CIQ.ChartEngine} stx The chart object
       * @param  {object} [obj] A drawing descriptor
       * @param {string} [obj.col] The line color
       * @param {string} [obj.pnl] The panel name
       * @param {string} [obj.ptrn] Optional pattern for line "solid","dotted","dashed". Defaults to solid.
       * @param {number} [obj.lw] Optional line width. Defaults to 1.
       * @param {number} [obj.cw] Candle width from original drawing
       * @param {number} [obj.mlt] Y-axis multiplier from original drawing
       * @param {number} [obj.v0] Value (price) for the first point
       * @param {number} [obj.d0] Date (string form) for the first point
       * @param {number} [obj.int] Interval from original drawing
       * @param {number} [obj.pd] Periodicity from original drawing
       * @param {number} [obj.tzo0] Offset of UTC from d0 in minutes
       * @param {array} [obj.nodes] An array of nodes in form [x0a,x0b,y0a,y0b, x1a, x1b, y1a, y1b, ....]
       * @memberOf CIQ.Drawing.freeform
       */
      CIQ.Drawing.freeform.prototype.reconstruct = function(stx, obj) {
        this.stx = stx
        this.color = obj.col
        this.panelName = obj.pnl
        this.pattern = obj.ptrn
        this.lineWidth = obj.lw
        this.candleWidth = obj.cw
        this.multiplier = obj.mlt
        this.d0 = obj.d0
        this.tzo0 = obj.tzo0
        this.v0 = obj.v0
        this.interval = obj.inter
        this.periodicity = obj.pd
        this.nodes = obj.nodes
        this.adjust()
      }

      /**
       * Callout drawing tool.  This is like an annotation except it draws a stem and offers a background color and line style.
       *
       * @constructor
       * @name  CIQ.Drawing.callout
       * @since 2015-11-1
       * @version ChartIQ Advanced Package
       * @see {@link CIQ.Drawing.annotation}
       */
      CIQ.Drawing.callout = function() {
        this.name = 'callout'
        this.arr = []
        this.w = 0
        this.h = 0
        this.padding = 4
        this.text = ''
        this.ta = null
        this.fontSize = 0
        this.font = {}
        this.stemEntry = ''
        this.defaultWidth = 50
        this.defaultHeight = 10
        //this.dragToDraw=true;
      }

      CIQ.Drawing.callout.ciqInheritsFrom(CIQ.Drawing.annotation)

      CIQ.Drawing.callout.prototype.configs = [
        'color',
        'fillColor',
        'lineWidth',
        'pattern',
        'font',
      ]

      CIQ.Drawing.callout.prototype.copyConfig = function() {
        CIQ.Drawing.copyConfig(this)
        this.borderColor = this.color
      }

      CIQ.Drawing.callout.prototype.move = function(context, tick, value) {
        if (!this.penDown) return

        this.copyConfig()
        this.p0 = [tick, value]
        this.render(context)
      }

      CIQ.Drawing.callout.prototype.onChange = function(e) {
        var panel = this.stx.panels[this.panelName]
        if (!panel) return
        var textarea = e.target
        this.w = textarea.clientWidth
        this.h = textarea.clientHeight
        //textarea.style.left=(this.stx.pixelFromTick(this.p0[0])-this.w/2) + "px";
        //textarea.style.top=(this.stx.pixelFromPrice(this.p0[1],panel)-this.h/2) + "px";
        var context = this.context || this.stx.chart.tempCanvas.context
        CIQ.clearCanvas(context.canvas, this.stx)
        this.render(context)
        this.edit(context)
      }

      CIQ.Drawing.callout.prototype.render = function(context) {
        this.context = context // remember last context
        var panel = this.stx.panels[this.panelName]
        if (!panel) return
        var x0 = this.stx.pixelFromTick(this.p0[0], panel.chart)
        var y0 = this.stx.pixelFromValueAdjusted(panel, this.p0[0], this.p0[1])
        if (isNaN(y0)) return

        context.font = this.fontString
        context.textBaseline = 'top'
        var x = x0
        var y = y0
        var w = this.w / 2
        var h = this.h / 2
        if (this.penDown) {
          w = this.defaultWidth
          h = this.defaultHeight
          if (!h) h = this.fontSize
        }
        var lineWidth = this.lineWidth
        if (!lineWidth) lineWidth = 1.1
        var color = this.color
        if (color == 'auto' || CIQ.isTransparent(color))
          color = this.stx.defaultColor
        var borderColor = this.borderColor
        if (borderColor == 'auto' || CIQ.isTransparent(borderColor))
          borderColor = this.stx.defaultColor
        if (this.highlighted)
          borderColor = this.stx.getCanvasColor('stx_highlight_vector')
        var sx0, sx1, sy0, sy1
        var r = Math.min(Math.min(w, h) / 2, 8)
        if (this.stem) {
          if (this.stem.t) {
            // absolute positioning of stem
            sx0 = this.stx.pixelFromTick(this.stem.t) // bottom of stem
            sy0 = this.stx.pixelFromValueAdjusted(
              panel,
              this.stem.t,
              this.stem.v
            )
          } else if (this.stem.x) {
            // stem with relative offset positioning
            sx0 = x
            sy0 = y
            x += this.stem.x
            y += this.stem.y
          }

          var state = ''
          if (sx0 >= x + w) {
            sx1 = x + w
            state = 'r'
          } // right of text
          else if (sx0 > x - w && sx0 < x + w) {
            sx1 = x
            state = 'c'
          } // center of text
          else if (sx0 <= x - w) {
            sx1 = x - w
            state = 'l'
          } // left of text

          if (sy0 >= y + h) {
            sy1 = y + h
            state += 'b'
          } // bottom of text
          else if (sy0 > y - h && sy0 < y + h) {
            sy1 = y
            state += 'm'
          } // middle of text
          else if (sy0 <= y - h) {
            sy1 = y - h
            state += 't'
          } // top of text

          this.stemEntry = state

          if (state != 'cm') {
            // make sure stem does not originate underneath the annotation
            sx0 = Math.round(sx0)
            sx1 = Math.round(sx1)
            sy0 = Math.round(sy0)
            sy1 = Math.round(sy1)
          }
        }
        if (this.highlighted) {
          this.stx.canvasColor('stx_annotation_highlight_bg', context)
        } else {
          if (this.fillColor) {
            context.fillStyle = this.fillColor
            context.globalAlpha = 0.4
          } else if (this.stem) {
            // If there's a stem then use the container color otherwise the stem will show through
            context.fillStyle = this.stx.containerColor
          }
        }
        context.strokeStyle = borderColor
        if (context.setLineDash) {
          context.setLineDash(CIQ.borderPatternToArray(lineWidth, this.pattern))
          context.lineDashOffset = 0 //start point in array
        }

        if (borderColor) {
          context.beginPath()
          context.lineWidth = lineWidth
          context.moveTo(x + w - r, y - h)
          if (this.stemEntry != 'rt') {
            context.quadraticCurveTo(x + w, y - h, x + w, y - h + r) //top right
          } else {
            context.lineTo(sx0, sy0)
            context.lineTo(x + w, y - h + r)
          }
          context.lineTo(x + w, y - r / 2)
          if (this.stemEntry == 'rm') context.lineTo(sx0, sy0)
          context.lineTo(x + w, y + r / 2)
          context.lineTo(x + w, y + h - r)
          if (this.stemEntry != 'rb') {
            context.quadraticCurveTo(x + w, y + h, x + w - r, y + h) //bottom right
          } else {
            context.lineTo(sx0, sy0)
            context.lineTo(x + w - r, y + h)
          }
          context.lineTo(x + r / 2, y + h)
          if (this.stemEntry == 'cb') context.lineTo(sx0, sy0)
          context.lineTo(x - r / 2, y + h)
          context.lineTo(x - w + r, y + h)
          if (this.stemEntry != 'lb') {
            context.quadraticCurveTo(x - w, y + h, x - w, y + h - r) //bottom left
          } else {
            context.lineTo(sx0, sy0)
            context.lineTo(x - w, y + h - r)
          }
          context.lineTo(x - w, y + r / 2)
          if (this.stemEntry == 'lm') context.lineTo(sx0, sy0)
          context.lineTo(x - w, y - r / 2)
          context.lineTo(x - w, y - h + r)
          if (this.stemEntry != 'lt') {
            context.quadraticCurveTo(x - w, y - h, x - w + r, y - h) //top left
          } else {
            context.lineTo(sx0, sy0)
            context.lineTo(x - w + r, y - h)
          }
          context.lineTo(x - r / 2, y - h)
          if (this.stemEntry == 'ct') context.lineTo(sx0, sy0)
          context.lineTo(x + r / 2, y - h)
          context.lineTo(x + w - r, y - h)
          context.fill()
          context.globalAlpha = 1
          context.stroke()
        }
        if (this.highlighted) {
          this.stx.canvasColor('stx_annotation_highlight', context)
        } else {
          context.fillStyle = color
        }
        y += this.padding
        for (var i = 0; i < this.arr.length; i++) {
          context.fillText(this.arr[i], x - w + this.padding, y - h)
          y += this.fontSize
        }
        context.textBaseline = 'alphabetic'

        if (this.highlighted) {
          var p0Fill = this.highlighted == 'p0' ? true : false
          this.littleCircle(context, sx0, sy0, p0Fill)
        }
        /*if(this.penDown){
			context.globalAlpha=0.2;
			context.fillText("[Your text here]", x-w+this.padding, y-h);
			context.globalAlpha=1;
		}*/
      }

      CIQ.Drawing.callout.prototype.click = function(context, tick, value) {
        //don't allow user to add callout on the axis.
        if (this.stx.overXAxis || this.stx.overYAxis) return
        var panel = this.stx.panels[this.panelName]
        this.copyConfig()
        //this.getFontString();
        this.setPoint(0, tick, value, panel.chart)
        if (!this.penDown) {
          this.stem = {
            d: this.d0,
            v: this.v0,
          }
          this.penDown = true
          this.adjust()
          return false
        }
        this.adjust()
        this.edit(context)
        this.penDown = false
        return false
      }

      CIQ.Drawing.callout.prototype.reposition = function(
        context,
        repositioner,
        tick,
        value
      ) {
        if (!repositioner) return
        var panel = this.stx.panels[this.panelName]
        var tickDiff = repositioner.tick - tick
        var valueDiff = repositioner.value - value
        if (repositioner.stem) {
          if (repositioner.action == 'drag') {
            this.stem = {
              d: this.stx.dateFromTick(tick, panel.chart, true),
              v: value,
            }
          } else if (repositioner.action == 'move') {
            this.setPoint(
              0,
              repositioner.p0[0] - tickDiff,
              repositioner.p0[1] - valueDiff,
              panel.chart
            )
            this.stem = {
              d: this.stx.dateFromTick(
                this.stx.tickFromDate(repositioner.stem.d, panel.chart) -
                  tickDiff
              ),
              v: repositioner.stem.v - valueDiff,
            }
          }
          this.adjust()
        } else {
          this.setPoint(
            0,
            repositioner.p0[0] - tickDiff,
            repositioner.p0[1] - valueDiff,
            panel.chart
          )
        }
        this.render(context)
      }

      CIQ.Drawing.callout.prototype.lineIntersection = function(
        tick,
        value,
        box,
        type
      ) {
        var panel = this.stx.panels[this.panelName]
        var stem = this.stem,
          p0 = this.p0,
          layout = this.stx.layout
        if (!p0 || !stem || !panel) return false
        var stemTick = stem.t || this.stx.tickFromDate(stem.d, panel.chart)
        return CIQ.boxIntersects(
          box.x0,
          box.y0,
          box.x1,
          box.y1,
          p0[0],
          p0[1],
          stemTick,
          stem.v,
          type,
          panel.yAxis.semiLog
        )
      }

      CIQ.Drawing.callout.prototype.intersected = function(tick, value, box) {
        var panel = this.stx.panels[this.panelName]
        if (!this.p0) return null // in case invalid drawing (such as from panel that no longer exists)
        if (this.pointIntersection(this.stem.t, this.stem.v, box)) {
          this.highlighted = 'p0'
          return {
            action: 'drag',
            stem: true,
          }
        }
        var x0 = this.stx.pixelFromTick(this.p0[0], panel.chart) - this.w / 2
        var y0 =
          this.stx.pixelFromValueAdjusted(panel, this.p0[0], this.p0[1]) -
          this.h / 2
        var x1 = x0 + this.w
        var y1 = y0 + this.h
        if (this.stem && this.stem.x) {
          x0 += this.stem.x
          x1 += this.stem.x
          y0 += this.stem.y
          y1 += this.stem.y
        }
        var x = this.stx.pixelFromTick(tick, panel.chart)
        var y = this.stx.pixelFromValueAdjusted(panel, tick, value)
        if (x >= x0 && x <= x1 && y >= y0 && y <= y1) {
          this.highlighted = true
          return {
            p0: CIQ.clone(this.p0),
            tick: tick,
            value: value,
          }
        }
        var isIntersected = this.lineIntersection(tick, value, box, 'segment')
        if (isIntersected) {
          this.highlighted = true
          // This object will be used for repositioning
          return {
            action: 'move',
            stem: CIQ.clone(this.stem),
            p0: CIQ.clone(this.p0),
            tick: tick, // save original tick
            value: value, // save original value
          }
        }
        return null
      }

      /**
       * Fibonacci Arc drawing tool.
       *
       * It inherits its properties from {@link CIQ.Drawing.fibonacci}
       * @constructor
       * @name  CIQ.Drawing.fibarc
       * @since 2015-11-1
       * @version ChartIQ Advanced Package
       */
      CIQ.Drawing.fibarc = function() {
        this.name = 'fibarc'
        //this.dragToDraw=true;
      }

      CIQ.Drawing.fibarc.ciqInheritsFrom(CIQ.Drawing.fibonacci)

      CIQ.Drawing.fibarc.prototype.setOuter = function() {
        this.outer = {
          p0: CIQ.clone(this.p0),
          p1: CIQ.clone(this.p1),
        }
        var y0 = this.p0[1]
        var y1 = this.p1[1]
        var x0 = this.p0[0]
        var x1 = this.p1[0]

        var val = (y0 - y1) * 2 + y1
        var x = CIQ.xIntersection({ x0: x0, x1: x1, y0: y0, y1: y1 }, val)
        this.outer.p0[1] = val
        this.outer.p0[0] = x
      }

      CIQ.Drawing.fibarc.prototype.render = function(context) {
        var panel = this.stx.panels[this.panelName]
        if (!panel) return
        var yAxis = panel.yAxis
        if (!this.p1) return
        var x0 = this.stx.pixelFromTick(this.p0[0], panel.chart)
        var x1 = this.stx.pixelFromTick(this.p1[0], panel.chart)
        var y0 = this.stx.pixelFromValueAdjusted(panel, this.p0[0], this.p0[1])
        var y1 = this.stx.pixelFromValueAdjusted(panel, this.p1[0], this.p1[1])
        var isUpTrend = y1 < y0
        var factor = Math.abs((y1 - y0) / (x1 - x0))

        var trendLineColor = this.setLineColor(this.parameters.trend.color)
        context.textBaseline = 'middle'
        this.stx.canvasFont('stx_yaxis', context) // match font from y axis so it looks cohesive
        var txtColor = this.color
        if (txtColor == 'auto' || CIQ.isTransparent(txtColor))
          txtColor = this.stx.defaultColor
        for (var i = 0; i < this.parameters.fibs.length; i++) {
          context.fillStyle = txtColor
          var fib = this.parameters.fibs[i]
          if (fib.level < 0 || !fib.display) continue
          var radius =
            Math.abs(this.p1[1] - this.p0[1]) * Math.sqrt(2) * fib.level
          var value = this.p1[1] + radius * (isUpTrend ? -1 : 1)
          var y = this.stx.pixelFromValueAdjusted(panel, this.p0[0], value)
          var x = CIQ.xIntersection({ x0: x0, x1: x1, y0: y0, y1: y1 }, y)
          if (this.parameters.printLevels) {
            context.textAlign = 'center'
            var txt = Math.round(fib.level * 1000) / 10 + '%'
            if (this.parameters.printValues) {
              context.fillStyle = txtColor // the price labels screw up the color and font size...so  reset before rendering the text
              this.stx.canvasFont('stx_yaxis', context) // use the same context as the y axis so they match.
            }
            context.fillText(txt, x1, Math.round(y - 5))
          }
          context.textAlign = 'left'
          if (this.parameters.printValues) {
            if (x < this.stx.chart.width) {
              // just use the actual price that segment will render on regardless of 'isUpTrend' since the values must match the prices on the y axis, and can not be reversed.
              var price = value
              if (yAxis.priceFormatter) {
                price = yAxis.priceFormatter(this.stx, panel, price)
              } else {
                price = this.stx.formatYAxisPrice(price, panel)
              }
              if (context == this.stx.chart.context) this.stx.endClip()
              this.stx.createYAxisLabel(
                panel,
                price,
                y,
                txtColor,
                null,
                context
              )
              if (context == this.stx.chart.context)
                this.stx.startClip(panel.name)
            }
          }
          var fibColor = fib.color
          if (fibColor == 'auto' || CIQ.isTransparent(fibColor))
            fibColor = this.color
          if (fibColor == 'auto' || CIQ.isTransparent(fibColor))
            fibColor = this.stx.defaultColor
          context.strokeStyle = fibColor
          var fillColor = fib.color
          if (fillColor == 'auto' || CIQ.isTransparent(fillColor))
            fillColor = this.fillColor
          if (fillColor == 'auto' || CIQ.isTransparent(fillColor))
            fillColor = this.stx.defaultColor
          context.fillStyle = fillColor
          context.globalAlpha = fib.parameters.opacity
          context.lineWidth = fib.parameters.lineWidth
          if (context.setLineDash) {
            context.setLineDash(
              CIQ.borderPatternToArray(
                context.lineWidth,
                fib.parameters.pattern
              )
            )
            context.lineDashOffset = 0 //start point in array
          }
          context.save()
          context.beginPath()
          context.scale(1 / factor, 1)
          context.arc(x1 * factor, y1, Math.abs(y - y1), 0, Math.PI, !isUpTrend)
          context.stroke()
          context.globalAlpha = 0.05
          context.fill()
          context.restore()
          if (context.setLineDash) context.setLineDash([])
          context.globalAlpha = 1
        }
        context.textAlign = 'left'
        // ensure we at least draw trend line from zero to 100
        this.stx.plotLine(
          x1,
          2 * x0 - x1,
          y1,
          2 * y0 - y1,
          trendLineColor,
          'segment',
          context,
          panel,
          this.parameters.trend.parameters
        )
        if (this.highlighted) {
          var p0Fill = this.highlighted == 'p0' ? true : false
          var p1Fill = this.highlighted == 'p1' ? true : false
          this.littleCircle(context, x0, y0, p0Fill)
          this.littleCircle(context, x1, y1, p1Fill)
        }
      }

      /**
       * Fibonacci Fan drawing tool.
       *
       * It inherits its properties from {@link CIQ.Drawing.fibonacci}
       * @constructor
       * @name  CIQ.Drawing.fibfan
       * @since 2015-11-1
       * @version ChartIQ Advanced Package
       */
      CIQ.Drawing.fibfan = function() {
        this.name = 'fibfan'
        //this.dragToDraw=true;
      }

      CIQ.Drawing.fibfan.ciqInheritsFrom(CIQ.Drawing.fibonacci)

      CIQ.Drawing.fibfan.prototype.setOuter = function() {
        this.outer = {
          p0: CIQ.clone(this.p0),
          p1: CIQ.clone(this.p1),
        }
        var y0 = this.p0[1]
        var y1 = this.p1[1]
        var x0 = this.p0[0]
        var x1 = this.p1[0]

        var min = 0
        for (var i = 0; i < this.parameters.fibs.length; i++) {
          var fib = this.parameters.fibs[i]
          if (fib.level >= min || !fib.display) continue
          var val = (y0 - y1) * fib.level + y1
          var x = CIQ.xIntersection({ x0: x0, x1: x1, y0: y0, y1: y1 }, val)
          min = fib.level
          this.outer.p1[1] = val
          this.outer.p1[0] = x
        }
      }

      CIQ.Drawing.fibfan.prototype.render = function(context) {
        var panel = this.stx.panels[this.panelName]
        if (!panel) return
        var yAxis = panel.yAxis
        if (!this.p1) return
        var x0 = this.stx.pixelFromTick(this.p0[0], panel.chart)
        var x1 = this.stx.pixelFromTick(this.p1[0], panel.chart)
        var y0 = this.stx.pixelFromValueAdjusted(panel, this.p0[0], this.p0[1])
        var y1 = this.stx.pixelFromValueAdjusted(panel, this.p1[0], this.p1[1])
        var top = Math.min(y1, y0)
        var bottom = Math.max(y1, y0)
        var height = bottom - top
        var isUpTrend = (y1 - y0) / (x1 - x0) > 0

        var trendLineColor = this.setLineColor(this.parameters.trend.color)

        context.textBaseline = 'middle'
        this.stx.canvasFont('stx_yaxis', context) // match font from y axis so it looks cohesive
        var w = context.measureText('161.8%').width + 10 // give it extra space so it does not overlap with the price labels.
        var /*minX=Number.MAX_VALUE,*/ minY = Number.MAX_VALUE,
          /*maxX=Number.MAX_VALUE*-1,*/ maxY = Number.MAX_VALUE * -1
        var txtColor = this.color
        if (txtColor == 'auto' || CIQ.isTransparent(txtColor))
          txtColor = this.stx.defaultColor
        for (var i = 0; i < this.parameters.fibs.length; i++) {
          context.fillStyle = txtColor
          var fib = this.parameters.fibs[i]
          if (!fib.display) continue
          //var y=(y0-y1)*fib.level+y1;
          var y = this.stx.pixelFromValueAdjusted(
            panel,
            this.p0[0],
            (this.p0[1] - this.p1[1]) * fib.level + this.p1[1]
          )
          var x = CIQ.xIntersection({ x0: x1, x1: x1, y0: y0, y1: y1 }, y)
          var farX = this.stx.chart.left
          if (x1 > x0) farX += this.stx.chart.width
          var farY = ((farX - x0) * (y - y0)) / (x - x0) + y0
          if (x0 > farX - (this.parameters.printLevels ? w + 5 : 0) && x1 > x0)
            continue
          else if (
            x0 < farX + (this.parameters.printLevels ? w + 5 : 0) &&
            x1 < x0
          )
            continue
          if (this.parameters.printLevels) {
            var txt = Math.round(fib.level * 1000) / 10 + '%'
            if (x1 > x0) {
              farX -= w
              context.textAlign = 'left'
            } else {
              farX += w
              context.textAlign = 'right'
            }
            if (this.parameters.printValues) {
              context.fillStyle = txtColor // the price labels screw up the color and font size...so reset before rendering the text
              this.stx.canvasFont('stx_yaxis', context) // use the same context as the y axis so they match.
            }
            farY = ((farX - x0) * (y - y0)) / (x - x0) + y0
            context.fillText(txt, farX, farY)
            if (x1 > x0) farX -= 5
            else farX += 5
          }
          context.textAlign = 'left'
          if (this.parameters.printValues) {
            if (x < this.stx.chart.width) {
              // just use the actual price that segment will render on regardless of 'isUpTrend' since the values must match the prices on the y axis, and can not be reversed.
              var price = this.stx.transformedPriceFromPixel(y, panel)
              if (yAxis.priceFormatter) {
                price = yAxis.priceFormatter(this.stx, panel, price)
              } else {
                price = this.stx.formatYAxisPrice(price, panel)
              }
              if (context == this.stx.chart.context) this.stx.endClip()
              this.stx.createYAxisLabel(
                panel,
                price,
                y,
                txtColor,
                null,
                context
              )
              if (context == this.stx.chart.context)
                this.stx.startClip(panel.name)
            }
          }
          var fibColor = fib.color
          if (fibColor == 'auto' || CIQ.isTransparent(fibColor))
            fibColor = this.color
          if (fibColor == 'auto' || CIQ.isTransparent(fibColor))
            fibColor = this.stx.defaultColor
          var fillColor = fib.color
          if (fillColor == 'auto' || CIQ.isTransparent(fillColor))
            fillColor = this.fillColor
          if (fillColor == 'auto' || CIQ.isTransparent(fillColor))
            fillColor = this.stx.defaultColor
          context.fillStyle = fillColor
          if (this.parameters.printLevels)
            farY = ((farX - x0) * (y - y0)) / (x - x0) + y0
          this.stx.plotLine(
            x0,
            farX,
            y0,
            farY,
            fib.level || !this.highlighted ? fibColor : trendLineColor,
            'segment',
            context,
            panel,
            fib.parameters
          )
          context.globalAlpha = 0.05
          context.beginPath()
          context.moveTo(farX, farY)
          context.lineTo(x0, y0)
          context.lineTo(farX, y0)
          context.fill()
          context.globalAlpha = 1
          if (y < minY) {
            //minX=x;
            minY = y
          }
          if (y > maxY) {
            //maxX=x;
            maxY = y
          }
        }
        // ensure we at least draw trend line from zero to 100
        for (var level in { 0: 0, 1: 1 }) {
          var yy = isUpTrend ? bottom - height * level : top + height * level
          yy = Math.round(yy)
          if (yy < minY) {
            //minX=CIQ.xIntersection({x0:x1,x1:x1,y0:y0,y1:y1}, yy);
            minY = yy
          }
          if (yy > maxY) {
            //maxX=CIQ.xIntersection({x0:x1,x1:x1,y0:y0,y1:y1}, yy);
            maxY = yy
          }
        }
        //this.stx.plotLine(minX, maxX, minY, maxY, trendLineColor, "segment", context, panel, this.parameters.trend.parameters);
        if (this.highlighted) {
          var p0Fill = this.highlighted == 'p0' ? true : false
          var p1Fill = this.highlighted == 'p1' ? true : false
          this.littleCircle(context, x0, y0, p0Fill)
          this.littleCircle(context, x1, y1, p1Fill)
        }
      }

      /**
       * Fibonacci Time Zone drawing tool.
       *
       * It inherits its properties from {@link CIQ.Drawing.fibonacci}
       * @constructor
       * @name  CIQ.Drawing.fibtimezone
       * @since 2015-11-1
       * @version ChartIQ Advanced Package
       */
      CIQ.Drawing.fibtimezone = function() {
        this.name = 'fibtimezone'
        //this.dragToDraw=true;
      }

      CIQ.Drawing.fibtimezone.ciqInheritsFrom(CIQ.Drawing.fibonacci)

      CIQ.Drawing.fibtimezone.prototype.render = function(context) {
        var panel = this.stx.panels[this.panelName]
        if (!panel) return
        if (!this.p1) return
        var x0 = this.stx.pixelFromTick(this.p0[0], panel.chart)
        var x1 = this.stx.pixelFromTick(this.p1[0], panel.chart)
        var y0 = this.stx.pixelFromValueAdjusted(panel, this.p0[0], this.p0[1])
        var y1 = this.stx.pixelFromValueAdjusted(panel, this.p1[0], this.p1[1])
        var fibs = [1, 0]

        var trendLineColor = this.setLineColor(this.parameters.trend.color)

        context.textBaseline = 'middle'
        this.stx.canvasFont('stx_yaxis', context) // match font from y axis so it looks cohesive
        var h = 20 // give it extra space so it does not overlap with the date labels.
        var mult = this.p1[0] - this.p0[0]
        var txtColor = this.color
        if (txtColor == 'auto' || CIQ.isTransparent(txtColor))
          txtColor = this.stx.defaultColor
        context.textAlign = 'center'

        var x = x0
        var farY = this.stx.chart.panel.yAxis.height
        var txt = 0
        var fibColor = this.parameters.timezone.color
        if (fibColor == 'auto' || CIQ.isTransparent(fibColor))
          fibColor = this.color
        if (fibColor == 'auto' || CIQ.isTransparent(fibColor))
          fibColor = this.stx.defaultColor
        var fillColor = this.parameters.timezone.color
        if (fillColor == 'auto' || CIQ.isTransparent(fillColor))
          fillColor = this.fillColor
        if (fillColor == 'auto' || CIQ.isTransparent(fillColor))
          fillColor = this.stx.defaultColor

        if (this.parameters.printLevels) farY -= h - 7

        do {
          x = this.stx.pixelFromTick(this.p0[0] + txt * mult, panel.chart)
          //if(x<this.stx.chart.left || x>this.stx.chart.left+this.stx.chart.width) break;
          if (x0 < x1 && x > this.stx.chart.left + this.stx.chart.width) break
          else if (x0 > x1 && x < this.stx.chart.left) break
          if (this.parameters.printLevels) {
            context.fillStyle = txtColor
            context.fillText(x1 > x0 ? txt : txt * -1, x, farY + 7)
          }
          context.fillStyle = fillColor
          this.stx.plotLine(
            x,
            x,
            0,
            farY,
            this.highlighted ? trendLineColor : fibColor,
            'segment',
            context,
            panel,
            this.parameters.timezone.parameters
          )
          context.globalAlpha = 0.05
          context.beginPath()
          context.moveTo(x0, 0)
          context.lineTo(x, 0)
          context.lineTo(x, farY)
          context.lineTo(x0, farY)
          context.fill()
          context.globalAlpha = 1
          txt = fibs[0] + fibs[1]
          fibs.unshift(txt)
        } while (mult)
        context.textAlign = 'left'
        this.stx.plotLine(
          x0,
          x1,
          y0,
          y1,
          trendLineColor,
          'segment',
          context,
          panel,
          this.parameters.trend.parameters
        )
        if (this.highlighted) {
          var p0Fill = this.highlighted == 'p0' ? true : false
          var p1Fill = this.highlighted == 'p1' ? true : false
          this.littleCircle(context, x0, y0, p0Fill)
          this.littleCircle(context, x1, y1, p1Fill)
        }
      }

      CIQ.Drawing.fibtimezone.prototype.intersected = function(
        tick,
        value,
        box
      ) {
        var p0 = this.p0,
          p1 = this.p1,
          layout = this.stx.layout
        if (!p0 || !p1) return null // in case invalid drawing (such as from panel that no longer exists)
        if (this.pointIntersection(p0[0], p0[1], box)) {
          this.highlighted = 'p0'
          return {
            action: 'drag',
            point: 'p0',
          }
        } else if (this.pointIntersection(p1[0], p1[1], box)) {
          this.highlighted = 'p1'
          return {
            action: 'drag',
            point: 'p1',
          }
        }
        // Check for over the trend line or the 0 vertical line
        var boxIntersects = CIQ.boxIntersects(
          box.x0,
          box.y0,
          box.x1,
          box.y1,
          p0[0],
          p0[1],
          p1[0],
          p1[1],
          'segment',
          layout.semiLog || layout.chartScale == 'log'
        )
        if (boxIntersects || (box.x0 <= p0[0] && box.x1 >= p0[0])) {
          this.highlighted = true
          return {
            action: 'move',
            p0: CIQ.clone(p0),
            p1: CIQ.clone(p1),
            tick: tick, // save original tick
            value: value, // save original value
          }
        }
        return null
      }

      /**
       * shape is a default implementation of a {@link CIQ.Drawing.BaseTwoPoint} drawing
       * which places a "shape" on the canvas.  It can be rotated and/or stretched.
       * It is meant to be overridden with specific shape designs, such as arrows....
       * @constructor
       * @name  CIQ.Drawing.shape
       * @since 2015-11-1
       * @version ChartIQ Advanced Package
       */
      CIQ.Drawing.shape = function() {
        this.name = 'shape'
        this.radians = 0
        this.a = 0
        this.rotating = false
        this.textMeasure = false
        this.configurator = 'shape' //forces all derived classes to default to shape drawing tools
        this.dimension = [0, 0]
        this.points = []
      }

      CIQ.Drawing.shape.ciqInheritsFrom(CIQ.Drawing.BaseTwoPoint)

      CIQ.Drawing.shape.prototype.measure = function() {}

      CIQ.Drawing.shape.prototype.render = function(context) {
        if (!this.points.length) return
        var panel = this.stx.panels[this.panelName]
        if (!panel) return
        var x0 = this.stx.pixelFromTick(this.p0[0], panel.chart)
        var y0 = this.stx.pixelFromValueAdjusted(panel, this.p0[0], this.p0[1])
        if (this.p1) {
          var x1 = this.stx.pixelFromTick(this.p1[0], panel.chart)
          var y1 = this.stx.pixelFromValueAdjusted(
            panel,
            this.p1[0],
            this.p1[1]
          )

          context.globalAlpha = 0.5
          context.fillStyle = '#000000'
          if (this.rotating) {
            this.radians = Math.atan((y1 - y0) / (x1 - x0))
            if (x1 < x0) this.radians += Math.PI
            else if (y1 < y0) this.radians += 2 * Math.PI
            this.a =
              parseInt(((this.radians * 36) / Math.PI).toFixed(0), 10) * 5
            this.a %= 360
            this.radians = (this.a * Math.PI) / 180
            if (this.textMeasure)
              context.fillText(this.a + '\u00b0', x1 + 10, y1 + 10)
          } else if (this.penDown) {
            this.sx = Math.max(
              1,
              parseFloat(
                Math.abs((2 * (x1 - x0)) / this.dimension[0]).toFixed(1)
              )
            )
            if (x1 < x0) this.sx *= -1
            this.sy = Math.max(
              1,
              parseFloat(
                Math.abs((2 * (y1 - y0)) / this.dimension[1]).toFixed(1)
              )
            )
            if (y1 < y0) this.sy *= -1
            if (this.textMeasure)
              context.fillText(
                this.sx + 'x,' + this.sy + 'x',
                x1 + this.sx + 5,
                y1 + this.sy + 5
              )
          }
          context.globalAlpha = 1
        }

        var lineWidth = this.lineWidth
        if (!lineWidth) lineWidth = 1.1

        var parameters = {
          pattern: this.pattern,
          lineWidth: lineWidth,
        }
        if (this.highlighted && parameters.pattern == 'none') {
          parameters.pattern = 'solid'
          if (parameters.lineWidth == 0.1) parameters.lineWidth = 1
        }
        var edgeColor = this.color
        if (edgeColor == 'auto' || CIQ.isTransparent(edgeColor))
          edgeColor = this.stx.defaultColor
        if (this.highlighted) {
          edgeColor = this.stx.getCanvasColor('stx_highlight_vector')
          if (lineWidth == 0.1) lineWidth = 1.1
        }
        var fillColor = this.fillColor
        lineWidth /=
          (Math.abs(this.sx * this.sy) * 2) /
          (Math.abs(this.sx) + Math.abs(this.sy))

        context.save()
        context.translate(x0, y0)
        context.rotate(this.radians)
        context.scale(this.sx, this.sy)

        var subshape, point
        for (subshape = 0; subshape < this.points.length; subshape++) {
          context.beginPath()
          for (point = 0; point < this.points[subshape].length; point++) {
            var x, y, cx1, cx2, cy1, cy2
            if (this.points[subshape][point] == 'M') {
              //move
              x = this.points[subshape][++point] - (this.dimension[0] - 1) / 2
              y = this.points[subshape][++point] - (this.dimension[1] - 1) / 2
              context.moveTo(x, y)
            } else if (this.points[subshape][point] == 'L') {
              //line
              x = this.points[subshape][++point] - (this.dimension[0] - 1) / 2
              y = this.points[subshape][++point] - (this.dimension[1] - 1) / 2
              context.lineTo(x, y)
            } else if (this.points[subshape][point] == 'Q') {
              //quadratic
              cx1 = this.points[subshape][++point] - (this.dimension[0] - 1) / 2
              cy1 = this.points[subshape][++point] - (this.dimension[1] - 1) / 2
              x = this.points[subshape][++point] - (this.dimension[0] - 1) / 2
              y = this.points[subshape][++point] - (this.dimension[1] - 1) / 2
              context.quadraticCurveTo(cx1, cy1, x, y)
            } else if (this.points[subshape][point] == 'B') {
              //bezier
              cx1 = this.points[subshape][++point] - (this.dimension[0] - 1) / 2
              cy1 = this.points[subshape][++point] - (this.dimension[1] - 1) / 2
              cx2 = this.points[subshape][++point] - (this.dimension[0] - 1) / 2
              cy2 = this.points[subshape][++point] - (this.dimension[1] - 1) / 2
              x = this.points[subshape][++point] - (this.dimension[0] - 1) / 2
              y = this.points[subshape][++point] - (this.dimension[1] - 1) / 2
              context.bezierCurveTo(cx1, cy1, cx2, cy2, x, y)
            }
          }
          context.closePath()

          if (
            fillColor &&
            !CIQ.isTransparent(fillColor) &&
            fillColor != 'auto'
          ) {
            //context.globalAlpha=0.4;
            context.fillStyle = fillColor
            context.fill()
            //context.globalAlpha=1;
          }
          if (edgeColor && this.pattern != 'none') {
            context.strokeStyle = edgeColor
            context.lineWidth = lineWidth
            if (context.setLineDash) {
              context.setLineDash(
                CIQ.borderPatternToArray(lineWidth, this.pattern)
              )
              context.lineDashOffset = 0 //start point in array
            }
            context.stroke()
          }
        }

        //context.strokeRect(-(this.dimension[0]-1)/2,-(this.dimension[1]-1)/2,this.dimension[0]-1,this.dimension[1]-1);

        context.restore()
        context.save()
        context.translate(x0, y0)
        context.rotate(this.radians)

        if (this.highlighted) {
          var p0Fill = this.highlighted == 'p0' ? true : false
          var p1Fill = this.highlighted == 'p1' ? true : false
          var p2Fill = this.highlighted == 'p2' ? true : false
          this.littleCircle(context, 0, 0, p0Fill)
          this.mover(context, 0, 0, p0Fill)
          this.littleCircle(
            context,
            (this.sx * this.dimension[0]) / 2,
            (this.sy * this.dimension[1]) / 2,
            p1Fill
          )
          this.resizer(
            context,
            (this.sx * this.dimension[0]) / 2,
            (this.sy * this.dimension[1]) / 2,
            p1Fill
          )
          this.littleCircle(
            context,
            (this.sx * this.dimension[0]) / 2,
            0,
            p2Fill
          )
          this.rotator(context, (this.sx * this.dimension[0]) / 2, 0, p2Fill)
          context.globalAlpha = 0.5
          context.fillStyle = '#000000'
          if (this.textMeasure) {
            context.fillText(
              this.sx + 'x,' + this.sy + 'x',
              (this.sx * this.dimension[0]) / 2 + 12,
              (this.sy * this.dimension[1]) / 2 + 5
            )
            context.fillText(
              this.a + '\u00b0',
              (this.sx * this.dimension[0]) / 2 + 12,
              5
            )
          }
          context.globalAlpha = 1
        } else if (this.penDown) {
          if (this.rotating) {
            this.rotator(context, (this.sx * this.dimension[0]) / 2, 0, true)
          } else {
            this.resizer(
              context,
              (this.sx * this.dimension[0]) / 2,
              (this.sy * this.dimension[1]) / 2,
              true
            )
          }
        }
        context.restore()
      }

      CIQ.Drawing.shape.prototype.reposition = function(
        context,
        repositioner,
        tick,
        value
      ) {
        if (!repositioner) return
        var panel = this.stx.panels[this.panelName]
        if (repositioner.action == 'move') {
          var tickDiff = repositioner.tick - tick
          var valueDiff = repositioner.value - value
          this.setPoint(
            0,
            repositioner.p0[0] - tickDiff,
            repositioner.p0[1] - valueDiff,
            panel.chart
          )
          this.render(context)
        } else {
          var x0 = this.stx.pixelFromTick(this.p0[0], panel.chart)
          var y0 = this.stx.pixelFromValueAdjusted(
            panel,
            this.p0[0],
            this.p0[1]
          )
          var x1 = this.stx.pixelFromTick(tick, panel.chart)
          var y1 = this.stx.pixelFromValueAdjusted(panel, tick, value)
          if (repositioner.action == 'scale') {
            this[repositioner.point] = [tick, value]
            this.sx = parseFloat(
              (
                ((x1 - x0) * Math.cos(this.radians) +
                  (y1 - y0) * Math.sin(this.radians)) /
                (this.dimension[0] / 2)
              ).toFixed(1)
            )
            if (Math.abs(this.sx) < 1) this.sx /= Math.abs(this.sy)
            this.sy = parseFloat(
              (
                ((y1 - y0) * Math.cos(this.radians) -
                  (x1 - x0) * Math.sin(this.radians)) /
                (this.dimension[1] / 2)
              ).toFixed(1)
            )
            if (Math.abs(this.sy) < 1) this.sy /= Math.abs(this.sy)
            this.render(context)
          } else if (repositioner.action == 'rotate') {
            this[repositioner.point] = [tick, value]
            this.radians = Math.atan((y1 - y0) / (x1 - x0))
            if (x1 < x0) this.radians += Math.PI
            else if (y1 < y0) this.radians += 2 * Math.PI
            this.a =
              parseInt(((this.radians * 36) / Math.PI).toFixed(0), 10) * 5
            if (this.sx < 0) this.a = this.a + 180
            this.a %= 360
            this.radians = (this.a * Math.PI) / 180
            this.render(context)
          }
        }
      }

      CIQ.Drawing.shape.prototype.intersected = function(tick, value, box) {
        if (!this.p0) return null // in case invalid drawing (such as from panel that no longer exists)
        if (
          this.stx.repositioningDrawing == this &&
          this.stx.repositioningDrawing.repositioner
        )
          return this.stx.repositioningDrawing.repositioner

        var panel = this.stx.panels[this.panelName]
        var x0 = this.stx.pixelFromTick(this.p0[0], panel.chart)
        var y0 = this.stx.pixelFromValueAdjusted(panel, this.p0[0], this.p0[1])
        var x1 = this.stx.pixelFromTick(tick, panel.chart)
        var y1 = this.stx.pixelFromValueAdjusted(panel, tick, value)

        x1 -= x0
        y1 -= y0
        var y1t = y1,
          x1t = x1
        x1 = Math.cos(this.radians) * x1t + Math.sin(this.radians) * y1t
        y1 = Math.cos(this.radians) * y1t - Math.sin(this.radians) * x1t
        x1 /= this.sx
        y1 /= this.sy
        var circleR2 = Math.pow(
          CIQ.touchDevice ? 25 : 5 + this.littleCircleRadius(),
          2
        )
        var scaledCircleR2 = Math.abs(circleR2 / (this.sx * this.sy))
        var overShape =
          Math.pow(this.dimension[0] / 2, 2) +
            Math.pow(this.dimension[1] / 2, 2) >
          Math.pow(x1, 2) + Math.pow(y1, 2)
        var moveProximity =
          (circleR2 - (Math.pow(x1 * this.sx, 2) + Math.pow(y1 * this.sy, 2))) /
          Math.abs(this.sx * this.sy)
        var scaleProximity =
          scaledCircleR2 -
          (Math.pow(x1 - this.dimension[0] / 2, 2) +
            Math.pow(y1 - this.dimension[1] / 2, 2))
        var rotateProximity =
          scaledCircleR2 -
          (Math.pow(x1 - this.dimension[0] / 2, 2) + Math.pow(y1, 2))
        //console.log("s:"+scaleProximity+" r:"+rotateProximity+" m:"+moveProximity);
        if (
          scaleProximity > 0 &&
          scaleProximity >= rotateProximity &&
          scaleProximity >= moveProximity
        ) {
          this.highlighted = 'p1'
          return {
            action: 'scale',
          }
        } else if (
          rotateProximity > 0 &&
          rotateProximity >= scaleProximity &&
          rotateProximity >= moveProximity
        ) {
          this.highlighted = 'p2'
          return {
            action: 'rotate',
          }
        } else if (
          moveProximity > 0 &&
          moveProximity >= scaleProximity &&
          moveProximity >= rotateProximity
        ) {
          this.highlighted = 'p0'
          return {
            action: 'move',
            p0: CIQ.clone(this.p0),
            tick: tick,
            value: value,
          }
        } else if (overShape) {
          this.highlighted = true
          return {}
        }
        return null
      }

      CIQ.Drawing.shape.prototype.configs = [
        'color',
        'fillColor',
        'lineWidth',
        'pattern',
      ]

      CIQ.Drawing.shape.prototype.littleCircleRadius = function() {
        return 3
      }

      CIQ.Drawing.shape.prototype.click = function(context, tick, value) {
        if (!this.points.length) return false
        this.copyConfig()
        var panel = this.stx.panels[this.panelName]
        if (!this.penDown) {
          this.setPoint(0, tick, value, panel.chart)
          this.penDown = true
          return false
        }
        //if(this.accidentalClick(tick, value)) return this.dragToDraw;

        this.setPoint(1, tick, value, panel.chart)

        if (this.rotating) {
          this.penDown = false
          this.rotating = false
          return true // kernel will call render after this
        }
        this.rotating = true
        return false
      }

      CIQ.Drawing.shape.prototype.adjust = function() {
        var panel = this.stx.panels[this.panelName]
        if (!panel) return
        this.setPoint(0, this.d0, this.v0, panel.chart)
        this.radians = (Math.round(this.a / 5) * Math.PI) / 36
      }

      /**
       * Reconstruct a shape
       * @param  {CIQ.ChartEngine} stx The chart object
       * @param  {object} [obj] A drawing descriptor
       * @param {string} [obj.col] The border color
       * @param {string} [obj.fc] The fill color
       * @param {string} [obj.pnl] The panel name
       * @param {string} [obj.ptrn] Optional pattern for line "solid","dotted","dashed". Defaults to solid.
       * @param {number} [obj.lw] Optional line width. Defaults to 1.
       * @param {number} [obj.v0] Value (price) for the center point
       * @param {number} [obj.d0] Date (string form) for the center point
       * @param {number} [obj.tzo0] Offset of UTC from d0 in minutes
       * @param {number} [obj.a] Angle of the rotation in degrees
       * @param {number} [obj.sx] Horizontal scale factor
       * @param {number} [obj.sy] Vertical scale factor
       * @memberOf CIQ.Drawing.shape
       */
      CIQ.Drawing.shape.prototype.reconstruct = function(stx, obj) {
        this.stx = stx
        this.color = obj.col
        this.fillColor = obj.fc
        this.panelName = obj.pnl
        this.pattern = obj.ptrn
        this.lineWidth = obj.lw
        this.d0 = obj.d0
        this.v0 = obj.v0
        this.tzo0 = obj.tzo0
        this.a = obj.a
        this.sx = obj.sx
        this.sy = obj.sy
        this.adjust()
      }

      CIQ.Drawing.shape.prototype.serialize = function() {
        return {
          name: this.name,
          pnl: this.panelName,
          col: this.color,
          fc: this.fillColor,
          ptrn: this.pattern,
          lw: this.lineWidth,
          d0: this.d0,
          v0: this.v0,
          tzo0: this.tzo0,
          a: this.a,
          sx: this.sx,
          sy: this.sy,
        }
      }

      /* Drawing specific shapes
       *
       * this.dimension: overall dimension of shape as designed, as a pair [dx,dy] where dx is length and dy is width, in pixels
       * this.points: array of arrays.  Each array represents a closed loop subshape.
       * 	within each array is a series of values representing coordinates.
       * 	For example, ["M",0,0,"L",1,1,"L",2,1,"Q",3,3,4,1,"B",5,5,0,0,3,3]
       * 	The array will be parsed by the render function:
       * 		"M" - move to the xy coordinates represented by the next 2 array elements
       * 		"L" - draw line to xy coordinates represented by the next 2 array elements
       * 		"Q" - draw quadratic curve where next 2 elements are the control point and following 2 elements are the end coordinates
       * 		"B" - draw bezier curve where next 2 elements are first control point, next 2 elements are second control point, and next 2 elements are the end coordinates
       * See sample shapes below.
       *
       */

      CIQ.Drawing.xcross = function() {
        this.name = 'xcross'
        this.dimension = [7, 7]
        this.points = [
          [
            'M',
            1,
            0,
            'L',
            3,
            2,
            'L',
            5,
            0,
            'L',
            6,
            1,
            'L',
            4,
            3,
            'L',
            6,
            5,
            'L',
            5,
            6,
            'L',
            3,
            4,
            'L',
            1,
            6,
            'L',
            0,
            5,
            'L',
            2,
            3,
            'L',
            0,
            1,
            'L',
            1,
            0,
          ],
        ]
      }
      CIQ.Drawing.xcross.ciqInheritsFrom(CIQ.Drawing.shape)

      CIQ.Drawing.arrow = function() {
        this.name = 'arrow'
        this.dimension = [11, 11]
        this.points = [
          [
            'M',
            3,
            0,
            'L',
            7,
            0,
            'L',
            7,
            5,
            'L',
            10,
            5,
            'L',
            5,
            10,
            'L',
            0,
            5,
            'L',
            3,
            5,
            'L',
            3,
            0,
          ],
        ]
      }
      CIQ.Drawing.arrow.ciqInheritsFrom(CIQ.Drawing.shape)

      CIQ.Drawing.check = function() {
        this.name = 'check'
        this.dimension = [8, 9]
        this.points = [
          [
            'M',
            1,
            5,
            'L',
            0,
            6,
            'L',
            2,
            8,
            'L',
            7,
            1,
            'L',
            6,
            0,
            'L',
            2,
            6,
            'L',
            1,
            5,
          ],
        ]
      }
      CIQ.Drawing.check.ciqInheritsFrom(CIQ.Drawing.shape)

      CIQ.Drawing.star = function() {
        this.name = 'star'
        this.dimension = [12, 12]
        this.points = [
          [
            'M',
            0,
            4,
            'L',
            4,
            4,
            'L',
            5.5,
            0,
            'L',
            7,
            4,
            'L',
            11,
            4,
            'L',
            8,
            7,
            'L',
            9,
            11,
            'L',
            5.5,
            9,
            'L',
            2,
            11,
            'L',
            3,
            7,
            'L',
            0,
            4,
          ],
        ]
      }
      CIQ.Drawing.star.ciqInheritsFrom(CIQ.Drawing.shape)

      CIQ.Drawing.heart = function() {
        this.name = 'heart'
        this.dimension = [23, 20]
        this.points = [
          [
            'M',
            11,
            3,
            'B',
            11,
            2.4,
            10,
            0,
            6,
            0,
            'B',
            0,
            0,
            0,
            7.5,
            0,
            7.5,
            'B',
            0,
            11,
            4,
            15.4,
            11,
            19,
            'B',
            18,
            15.4,
            22,
            11,
            22,
            7.5,
            'B',
            22,
            7.5,
            22,
            0,
            16,
            0,
            'B',
            13,
            0,
            11,
            2.4,
            11,
            3,
          ],
        ]
      }
      CIQ.Drawing.heart.ciqInheritsFrom(CIQ.Drawing.shape)

      CIQ.Drawing.focusarrow = function() {
        this.name = 'focusarrow'
        this.dimension = [7, 5]
        this.points = [
          ['M', 0, 0, 'L', 2, 2, 'L', 0, 4, 'L', 0, 0],
          ['M', 6, 0, 'L', 4, 2, 'L', 6, 4, 'L', 6, 0],
        ]
      }
      CIQ.Drawing.focusarrow.ciqInheritsFrom(CIQ.Drawing.shape)

      /**
       * Crossline drawing tool.
       *
       * It inherits its properties from {@link CIQ.Drawing.horizontal}
       * @constructor
       * @name  CIQ.Drawing.crossline
       * @since 2016-09-19
       * @version ChartIQ Advanced Package
       */
      CIQ.Drawing.crossline = function() {
        this.name = 'crossline'
      }
      CIQ.Drawing.crossline.ciqInheritsFrom(CIQ.Drawing.horizontal)
      CIQ.extend(CIQ.Drawing.crossline.prototype, {
        measure: function() {},
        accidentalClick: function(tick, value) {
          return false
        },
        adjust: function() {
          var panel = this.stx.panels[this.panelName]
          if (!panel) return
          this.setPoint(0, this.d0, this.v0, panel.chart)
          this.p1 = CIQ.clone(this.p0)
        },
        intersected: function(tick, value, box) {
          if (!this.p0 || !this.p1) return null
          this.p1[0] += 1
          var isIntersected = this.lineIntersection(
            tick,
            value,
            box,
            'horizontal'
          )
          this.p1 = CIQ.clone(this.p0)
          if (!isIntersected) {
            this.p1[1] += 1
            isIntersected = this.lineIntersection(tick, value, box, 'vertical')
            this.p1 = CIQ.clone(this.p0)
            if (!isIntersected) return null
          }
          this.highlighted = true
          // This object will be used for repositioning
          return {
            action: 'move',
            p0: CIQ.clone(this.p0),
            p1: CIQ.clone(this.p1),
            tick: tick, // save original tick
            value: value, // save original value
          }
        },
        render: function(context) {
          var panel = this.stx.panels[this.panelName]
          if (!panel) return
          var x0 = this.stx.pixelFromTick(this.p0[0], panel.chart)
          var y0 = this.stx.pixelFromValueAdjusted(
            panel,
            this.p0[0],
            this.p0[1]
          )

          var color = this.setLineColor()

          var parameters = {
            pattern: this.pattern,
            lineWidth: this.lineWidth,
          }
          this.stx.plotLine(
            x0,
            x0 + 100,
            y0,
            y0,
            color,
            'horizontal',
            context,
            panel,
            parameters
          )
          this.stx.plotLine(
            x0,
            x0,
            y0,
            y0 + 100,
            color,
            'vertical',
            context,
            panel,
            parameters
          )

          if (this.axisLabel && !this.highlighted) {
            this.stx.endClip()
            var txt = this.p0[1]
            if (panel.chart.transformFunc)
              txt = panel.chart.transformFunc(this.stx, panel.chart, txt)
            if (panel.yAxis.priceFormatter)
              txt = panel.yAxis.priceFormatter(this.stx, panel, txt)
            else txt = this.stx.formatYAxisPrice(txt, panel)
            this.stx.createYAxisLabel(panel, txt, y0, color)
            this.stx.startClip(panel.name)
            if (this.p0[0] >= 0 && !CIQ.ChartEngine.hideDates()) {
              // don't try to compute dates from before dataSet
              var dt, newDT
              /* set d0 to the right timezone */
              dt = this.stx.dateFromTick(this.p0[0], panel.chart, true)
              if (!CIQ.ChartEngine.isDailyInterval(this.stx.layout.interval)) {
                var milli = dt.getSeconds() * 1000 + dt.getMilliseconds()
                if (this.stx.dataZone) {
                  // this creates a date in the right quote feed date
                  newDT = new timezoneJS.Date(
                    dt.getFullYear(),
                    dt.getMonth(),
                    dt.getDate(),
                    dt.getHours(),
                    dt.getMinutes(),
                    this.stx.dataZone
                  )
                  dt = new Date(newDT.getTime() + milli)
                }
                if (this.stx.displayZone) {
                  // this converts from the quote feed timezone to the chart specified time zone
                  newDT = new timezoneJS.Date(
                    dt.getTime(),
                    this.stx.displayZone
                  )
                  dt = new Date(
                    newDT.getFullYear(),
                    newDT.getMonth(),
                    newDT.getDate(),
                    newDT.getHours(),
                    newDT.getMinutes()
                  )
                  dt = new Date(dt.getTime() + milli)
                }
              } else {
                dt.setHours(0, 0, 0, 0)
              }
              var myDate = CIQ.mmddhhmm(CIQ.yyyymmddhhmm(dt))
              /***********/
              if (panel.chart.xAxis.formatter) {
                myDate = panel.chart.xAxis.formatter(dt)
              } else if (this.stx.internationalizer) {
                var str
                if (dt.getHours() !== 0 || dt.getMinutes() !== 0) {
                  str = this.stx.internationalizer.monthDay.format(dt)
                  str += ' ' + this.stx.internationalizer.hourMinute.format(dt)
                } else {
                  str = this.stx.internationalizer.yearMonthDay.format(dt)
                }
                myDate = str
              }
              this.stx.endClip()
              this.stx.createXAxisLabel(panel, myDate, x0, color, null, true)
              this.stx.startClip(panel.name)
            }
          }
        },
      })

      /**
       * Speed Resistance Arc drawing tool.
       *
       * It inherits its properties from {@link CIQ.Drawing.segment}
       * @constructor
       * @name  CIQ.Drawing.speedarc
       * @since 2016-09-19
       * @version ChartIQ Advanced Package
       */
      CIQ.Drawing.speedarc = function() {
        this.name = 'speedarc'
        this.printLevels = true
      }
      CIQ.Drawing.speedarc.ciqInheritsFrom(CIQ.Drawing.segment)
      CIQ.extend(CIQ.Drawing.speedarc.prototype, {
        defaultOpacity: 0.25,
        configs: ['color', 'fillColor', 'lineWidth', 'pattern'],
        lineIntersection: function(tick, value, box, type) {
          var p0 = this.p0,
            p1 = this.p1,
            layout = this.stx.layout
          return (
            p0 &&
            p1 &&
            CIQ.boxIntersects(
              box.x0,
              box.y0,
              box.x1,
              box.y1,
              p0[0],
              p0[1],
              p1[0],
              p1[1],
              'segment',
              layout.semiLog || layout.chartScale == 'log'
            )
          )
        },
        copyConfig: function() {
          this.color = this.stx.currentVectorParameters.currentColor
          this.fillColor = this.stx.currentVectorParameters.fillColor
          this.lineWidth = this.stx.currentVectorParameters.lineWidth
          this.pattern = this.stx.currentVectorParameters.pattern
        },
        render: function(context) {
          var panel = this.stx.panels[this.panelName]
          if (!panel) return
          if (!this.p1) return
          var x0 = this.stx.pixelFromTick(this.p0[0], panel.chart)
          var x1 = this.stx.pixelFromTick(this.p1[0], panel.chart)
          var y0 = this.stx.pixelFromValueAdjusted(
            panel,
            this.p0[0],
            this.p0[1]
          )
          var y1 = this.stx.pixelFromValueAdjusted(
            panel,
            this.p1[0],
            this.p1[1]
          )
          var isUpTrend = y1 < y0
          var factor = Math.abs((y1 - y0) / (x1 - x0))

          var color = this.color
          if (color == 'auto' || CIQ.isTransparent(color))
            color = this.stx.defaultColor
          context.strokeStyle = color
          var fillColor = this.fillColor
          if (fillColor == 'auto' || CIQ.isTransparent(fillColor))
            fillColor = this.stx.defaultColor
          context.fillStyle = fillColor
          if (context.setLineDash) {
            context.setLineDash(
              CIQ.borderPatternToArray(this.lineWidth, this.pattern)
            )
            context.lineDashOffset = 0 //start point in array
          }
          this.stx.canvasFont('stx_yaxis', context)
          for (var i = 1; i < 3; i++) {
            var radius =
              (Math.abs(this.p1[1] - this.p0[1]) * Math.sqrt(2) * i) / 3
            var value = this.p1[1] + radius * (isUpTrend ? -1 : 1)
            var y = this.stx.pixelFromValueAdjusted(panel, this.p0[0], value)

            context.save()
            context.beginPath()
            context.scale(1 / factor, 1)
            context.arc(
              x1 * factor,
              y1,
              Math.abs(y - y1),
              0,
              Math.PI,
              !isUpTrend
            )
            context.globalAlpha = this.defaultOpacity
            context.stroke()
            context.globalAlpha = 0.1
            context.fill()
            context.restore()
            context.globalAlpha = 1
            if (this.printLevels) {
              context.fillStyle = color
              context.textAlign = 'center'
              var txt = i + '/3'
              context.fillText(txt, x1, Math.round(y - 5))
              context.fillStyle = fillColor
            }
          }
          context.textAlign = 'left'
          var trendLineColor = this.setLineColor()
          var parameters = {
            pattern: this.pattern,
            lineWidth: this.lineWidth,
            opacity: this.defaultOpacity,
          }
          this.stx.plotLine(
            x0,
            x1,
            y0,
            y1,
            trendLineColor,
            'segment',
            context,
            panel,
            parameters
          )
          if (context.setLineDash) context.setLineDash([])
          if (this.highlighted) {
            var p0Fill = this.highlighted == 'p0' ? true : false
            var p1Fill = this.highlighted == 'p1' ? true : false
            this.littleCircle(context, x0, y0, p0Fill)
            this.littleCircle(context, x1, y1, p1Fill)
          }
        },
        reconstruct: function(stx, obj) {
          this.stx = stx
          this.color = obj.col
          this.fillColor = obj.fc
          this.panelName = obj.pnl
          this.pattern = obj.ptrn
          this.lineWidth = obj.lw
          this.d0 = obj.d0
          this.d1 = obj.d1
          this.tzo0 = obj.tzo0
          this.tzo1 = obj.tzo1
          this.v0 = obj.v0
          this.v1 = obj.v1
          this.adjust()
        },
        serialize: function() {
          return {
            name: this.name,
            pnl: this.panelName,
            col: this.color,
            fc: this.fillColor,
            ptrn: this.pattern,
            lw: this.lineWidth,
            d0: this.d0,
            d1: this.d1,
            tzo0: this.tzo0,
            tzo1: this.tzo1,
            v0: this.v0,
            v1: this.v1,
          }
        },
      })

      /**
       * Speed Resistance Lines drawing tool.
       *
       * It inherits its properties from {@link CIQ.Drawing.speedarc}
       * @constructor
       * @name  CIQ.Drawing.speedline
       * @since 2016-09-19
       * @version ChartIQ Advanced Package
       */
      CIQ.Drawing.speedline = function() {
        this.name = 'speedline'
        this.printLevels = true
      }
      CIQ.Drawing.speedline.ciqInheritsFrom(CIQ.Drawing.speedarc)
      CIQ.extend(CIQ.Drawing.speedline.prototype, {
        render: function(context) {
          var panel = this.stx.panels[this.panelName]
          if (!panel) return
          if (!this.p1) return
          var x0 = this.stx.pixelFromTick(this.p0[0], panel.chart)
          var x1 = this.stx.pixelFromTick(this.p1[0], panel.chart)
          var y0 = this.stx.pixelFromValueAdjusted(
            panel,
            this.p0[0],
            this.p0[1]
          )
          var y1 = this.stx.pixelFromValueAdjusted(
            panel,
            this.p1[0],
            this.p1[1]
          )
          this.stx.canvasFont('stx_yaxis', context) // match font from y axis so it looks cohesive
          var trendLineColor = this.setLineColor()
          var color = this.color
          if (color == 'auto' || CIQ.isTransparent(color))
            color = this.stx.defaultColor
          context.strokeStyle = color
          var fillColor = this.fillColor
          if (fillColor == 'auto' || CIQ.isTransparent(fillColor))
            fillColor = this.stx.defaultColor
          context.fillStyle = fillColor
          var parameters = {
            pattern: this.pattern,
            lineWidth: this.lineWidth,
            opacity: this.defaultOpacity,
          }
          var farX0, farY0
          var levels = ['1', '2/3', '1/3', '3/2', '3']
          var levelValues = [1, 2 / 3, 1 / 3, 3 / 2, 3]
          var grids = []
          for (var i = 0; i < levelValues.length; i++) {
            var level = levelValues[i]
            if (level > 1 && !this.extension) continue
            var y = this.stx.pixelFromValueAdjusted(
              panel,
              this.p0[0],
              this.p0[1] - (this.p0[1] - this.p1[1]) * level
            )
            var x
            if (level > 1) {
              x = CIQ.xIntersection({ x0: x0, x1: x1, y0: y0, y1: y }, y1)
              grids.push(x)
            } else {
              x = CIQ.xIntersection({ x0: x1, x1: x1, y0: y0, y1: y1 }, y)
              grids.push(y)
            }
            //var x=x0+(x1-x0)/level;
            //var y=y0-level*(y0-y1);
            var farX = level > 1 ? x : x1
            var farY = level > 1 ? y1 : y
            if (!this.confineToGrid) {
              farX = this.stx.chart.left
              if (x1 > x0) farX += this.stx.chart.width
              farY = ((farX - x0) * (y - y0)) / (x1 - x0) + y0
            }
            if (this.printLevels) {
              if (level != 1 || this.extension) {
                context.fillStyle = color
                var perturbX = 0,
                  perturbY = 0
                if (y0 > y1) {
                  perturbY = -5
                  context.textBaseline = 'bottom'
                } else {
                  perturbY = 5
                  context.textBaseline = 'top'
                }
                if (x0 > x1) {
                  perturbX = 5
                  context.textAlign = 'right'
                } else {
                  perturbX = -5
                  context.textAlign = 'left'
                }
                if (level > 1)
                  context.fillText(
                    levels[i],
                    x + (this.confineToGrid ? 0 : perturbX),
                    y1
                  )
                else
                  context.fillText(
                    levels[i],
                    x1,
                    y + (this.confineToGrid ? 0 : perturbY)
                  )
                context.fillStyle = fillColor
              }
            }
            this.stx.plotLine(
              x0,
              farX,
              y0,
              farY,
              i || !this.highlighted ? color : trendLineColor,
              'segment',
              context,
              panel,
              parameters
            )
            if (level == 1) {
              farX0 = farX
              farY0 = farY
            }
            context.globalAlpha = 0.1
            context.beginPath()
            context.moveTo(farX, farY)
            context.lineTo(x0, y0)
            context.lineTo(farX0, farY0)
            context.fill()
            context.globalAlpha = 1
          }
          context.textAlign = 'left'
          context.textBaseline = 'middle'
          if (this.confineToGrid) {
            context.globalAlpha = 0.3
            context.beginPath()
            context.moveTo(x0, y0)
            context.lineTo(x0, y1)
            context.lineTo(x1, y1)
            context.lineTo(x1, y0)
            context.lineTo(x0, y0)
            context.moveTo(x0, grids[1])
            context.lineTo(x1, grids[1])
            context.moveTo(x0, grids[2])
            context.lineTo(x1, grids[2])
            if (this.extension) {
              context.moveTo(grids[3], y0)
              context.lineTo(grids[3], y1)
              context.moveTo(grids[4], y0)
              context.lineTo(grids[4], y1)
            }
            context.stroke()
            context.globalAlpha = 1
          }
          if (this.highlighted) {
            var p0Fill = this.highlighted == 'p0' ? true : false
            var p1Fill = this.highlighted == 'p1' ? true : false
            this.littleCircle(context, x0, y0, p0Fill)
            this.littleCircle(context, x1, y1, p1Fill)
          }
        },
      })

      /**
       * Gann Fan drawing tool.
       *
       * It inherits its properties from {@link CIQ.Drawing.speedarc}
       * @constructor
       * @name  CIQ.Drawing.gannfan
       * @since 2016-09-19
       * @version ChartIQ Advanced Package
       */
      CIQ.Drawing.gannfan = function() {
        this.name = 'gannfan'
        this.printLevels = true
      }
      CIQ.Drawing.gannfan.ciqInheritsFrom(CIQ.Drawing.speedarc)
      CIQ.extend(CIQ.Drawing.gannfan.prototype, {
        render: function(context) {
          var panel = this.stx.panels[this.panelName]
          if (!panel) return
          if (!this.p1) return
          var x0 = this.stx.pixelFromTick(this.p0[0], panel.chart)
          var x1 = this.stx.pixelFromTick(this.p1[0], panel.chart)
          var y0 = this.stx.pixelFromValueAdjusted(
            panel,
            this.p0[0],
            this.p0[1]
          )
          var y1 = this.stx.pixelFromValueAdjusted(
            panel,
            this.p1[0],
            this.p1[1]
          )
          this.stx.canvasFont('stx_yaxis', context) // match font from y axis so it looks cohesive
          var trendLineColor = this.setLineColor()
          var color = this.color
          if (color == 'auto' || CIQ.isTransparent(color))
            color = this.stx.defaultColor
          context.strokeStyle = color
          var fillColor = this.fillColor
          if (fillColor == 'auto' || CIQ.isTransparent(fillColor))
            fillColor = this.stx.defaultColor
          context.fillStyle = fillColor
          var parameters = {
            pattern: this.pattern,
            lineWidth: this.lineWidth,
            opacity: this.defaultOpacity,
          }
          var farX0, farY0
          var levels = [1, 2, 3, 4, 8, 1 / 2, 1 / 3, 1 / 4, 1 / 8]
          for (var i = 0; i < levels.length; i++) {
            var level = levels[i]
            var x = x0 + (x1 - x0) / level
            var y = y0 - level * (y0 - y1)
            var farX = this.stx.chart.left
            if (x1 > x0) farX += this.stx.chart.width
            var farY = ((farX - x0) * (y - y0)) / (x1 - x0) + y0
            if (this.printLevels) {
              context.fillStyle = color
              var perturbX = 0,
                perturbY = 0
              if (y0 > y1) {
                perturbY = 5
                context.textBaseline = 'top'
              } else {
                perturbY = -5
                context.textBaseline = 'botttom'
              }
              if (x0 > x1) {
                perturbX = 5
                context.textAlign = 'left'
              } else {
                perturbX = -5
                context.textAlign = 'right'
              }
              if (level > 1) context.fillText(level + 'x1', x + perturbX, y1)
              else context.fillText('1x' + 1 / level, x1, y + perturbY)
              context.fillStyle = fillColor
            }
            this.stx.plotLine(
              x0,
              farX,
              y0,
              farY,
              i || !this.highlighted ? color : trendLineColor,
              'segment',
              context,
              panel,
              parameters
            )
            if (level == 1) {
              farX0 = farX
              farY0 = farY
            }
            context.globalAlpha = 0.1
            context.beginPath()
            context.moveTo(farX, farY)
            context.lineTo(x0, y0)
            context.lineTo(farX0, farY0)
            context.fill()
            context.globalAlpha = 1
          }
          context.textAlign = 'left'
          context.textBaseline = 'middle'
          if (this.highlighted) {
            var p0Fill = this.highlighted == 'p0' ? true : false
            var p1Fill = this.highlighted == 'p1' ? true : false
            this.littleCircle(context, x0, y0, p0Fill)
            this.littleCircle(context, x1, y1, p1Fill)
          }
        },
      })

      /**
       * Time Cycle drawing tool.
       *
       * It inherits its properties from {@link CIQ.Drawing.speedarc}
       * @constructor
       * @name  CIQ.Drawing.timecycle
       * @since 2016-09-19
       * @version ChartIQ Advanced Package
       */
      CIQ.Drawing.timecycle = function() {
        this.name = 'timecycle'
        this.printLevels = true
      }
      CIQ.Drawing.timecycle.ciqInheritsFrom(CIQ.Drawing.speedarc)
      CIQ.extend(CIQ.Drawing.timecycle.prototype, {
        intersected: function(tick, value, box) {
          var p0 = this.p0,
            p1 = this.p1,
            layout = this.stx.layout
          if (!p0 || !p1) return null // in case invalid drawing (such as from panel that no longer exists)
          if (this.pointIntersection(p0[0], p0[1], box)) {
            this.highlighted = 'p0'
            return {
              action: 'drag',
              point: 'p0',
            }
          } else if (this.pointIntersection(p1[0], p1[1], box)) {
            this.highlighted = 'p1'
            return {
              action: 'drag',
              point: 'p1',
            }
          }
          // Check for over the trend line or the 0 vertical line
          var boxIntersects = CIQ.boxIntersects(
            box.x0,
            box.y0,
            box.x1,
            box.y1,
            p0[0],
            p0[1],
            p1[0],
            p1[1],
            'segment',
            layout.semiLog || layout.chartScale == 'log'
          )
          if (boxIntersects || (box.x0 <= this.p0[0] && box.x1 >= p0[0])) {
            this.highlighted = true
            return {
              action: 'move',
              p0: CIQ.clone(p0),
              p1: CIQ.clone(p1),
              tick: tick, // save original tick
              value: value, // save original value
            }
          }
          return null
        },
        render: function(context) {
          var panel = this.stx.panels[this.panelName]
          if (!panel) return
          if (!this.p1) return
          var x0 = this.stx.pixelFromTick(this.p0[0], panel.chart)
          var x1 = this.stx.pixelFromTick(this.p1[0], panel.chart)
          var y0 = this.stx.pixelFromValueAdjusted(
            panel,
            this.p0[0],
            this.p0[1]
          )
          var y1 = this.stx.pixelFromValueAdjusted(
            panel,
            this.p1[0],
            this.p1[1]
          )
          var count = 0

          var trendLineColor = this.setLineColor()
          context.textBaseline = 'middle'
          this.stx.canvasFont('stx_yaxis', context) // match font from y axis so it looks cohesive
          var h = 20 // give it extra space so it does not overlap with the date labels.
          var mult = this.p1[0] - this.p0[0]
          context.textAlign = 'center'

          var x = x0
          var farY = this.stx.chart.panel.yAxis.height
          var color = this.color
          if (color == 'auto' || CIQ.isTransparent(color))
            color = this.stx.defaultColor
          var fillColor = this.fillColor
          if (fillColor == 'auto' || CIQ.isTransparent(fillColor))
            fillColor = this.stx.defaultColor

          if (this.printLevels) farY -= h - 7

          var parameters = {
            pattern: this.pattern,
            lineWidth: this.lineWidth,
            opacity: this.defaultOpacity,
          }

          var x_s = []
          context.save()
          context.fillStyle = fillColor
          context.globalAlpha = 0.05
          //context.globalCompositeOperation="destination-over";
          do {
            x = this.stx.pixelFromTick(this.p0[0] + count * mult, panel.chart)
            count++
            if (x0 < x1 && x > this.stx.chart.left + this.stx.chart.width) break
            else if (x0 > x1 && x < this.stx.chart.left) break
            else if (
              x < this.stx.chart.left ||
              x > this.stx.chart.left + this.stx.chart.width
            )
              continue

            context.beginPath()
            context.moveTo(x0, 0)
            context.lineTo(x, 0)
            context.lineTo(x, farY)
            context.lineTo(x0, farY)
            context.fill()
            x_s.push({ c: count, x: x })
          } while (mult)
          context.globalAlpha = 1
          var slack = 0
          for (var pt = 0; pt < x_s.length; pt++) {
            this.stx.plotLine(
              x_s[pt].x,
              x_s[pt].x,
              0,
              farY,
              this.highlighted ? trendLineColor : color,
              'segment',
              context,
              panel,
              parameters
            )
            if (this.printLevels) {
              context.fillStyle = color
              var m = this.stx.chart.context.measureText(x_s[pt].c).width + 3
              if (m < this.stx.layout.candleWidth + slack) {
                context.fillText(x_s[pt].c, x_s[pt].x, farY + 7)
                slack = 0
              } else {
                slack += this.stx.layout.candleWidth
              }
            }
          }
          context.restore()
          context.textAlign = 'left'
          this.stx.plotLine(
            x0,
            x1,
            y0,
            y1,
            trendLineColor,
            'segment',
            context,
            panel,
            parameters
          )
          if (this.highlighted) {
            var p0Fill = this.highlighted == 'p0' ? true : false
            var p1Fill = this.highlighted == 'p1' ? true : false
            this.littleCircle(context, x0, y0, p0Fill)
            this.littleCircle(context, x1, y1, p1Fill)
          }
        },
      })

      /**
       * Regression Line drawing tool.
       *
       * It inherits its properties from {@link CIQ.Drawing.segment}
       * @constructor
       * @name  CIQ.Drawing.regression
       * @since 2016-09-19
       * @version ChartIQ Advanced Package
       */
      CIQ.Drawing.regression = function() {
        this.name = 'regression'
      }
      CIQ.Drawing.regression.ciqInheritsFrom(CIQ.Drawing.segment)
      CIQ.extend(CIQ.Drawing.regression.prototype, {
        click: function(context, tick, value) {
          if (tick < 0) return
          this.copyConfig()
          var panel = this.stx.panels[this.panelName]
          if (!this.penDown) {
            this.setPoint(0, tick, value, panel.chart)
            this.penDown = true
            return false
          }
          if (this.accidentalClick(tick, value)) return this.dragToDraw

          this.setPoint(1, tick, value, panel.chart)
          this.penDown = false
          return true // kernel will call render after this
        },
        lineIntersection: function(tick, value, box, type) {
          var p0 = this.p0,
            p1 = this.p1,
            layout = this.stx.layout
          return (
            p0 &&
            p1 &&
            CIQ.boxIntersects(
              box.x0,
              box.y0,
              box.x1,
              box.y1,
              p0[0],
              p0[1],
              p1[0],
              p1[1],
              'segment',
              layout.semiLog || layout.chartScale == 'log'
            )
          )
        },
        render: function(context) {
          var panel = this.stx.panels[this.panelName]
          if (!panel) return
          if (!this.p1) return
          if (this.p0[0] < 0 || this.p1[0] < 0) return
          var x0 = this.stx.pixelFromTick(this.p0[0], panel.chart)
          var x1 = this.stx.pixelFromTick(this.p1[0], panel.chart)
          if (x0 < this.stx.chart.left && x1 < this.stx.chart.left) return
          if (x0 > this.stx.chart.right && x1 > this.stx.chart.right) return

          var prices = []
          var sumCloses = 0
          var sumWeightedCloses = 0
          //var sumClosesSquared=0;
          var rawTicks = 0
          for (
            var i = Math.min(this.p1[0], this.p0[0]);
            i <= Math.max(this.p1[0], this.p0[0]);
            i++
          ) {
            if (this.stx.chart.dataSet[i]) {
              var price = this.stx.chart.dataSet[i].Close
              if (price || price === 0) {
                prices.push(price)
              }
            }
            rawTicks++
          }
          for (i = 0; i < prices.length; i++) {
            sumWeightedCloses += prices.length * prices[i] - sumCloses
            sumCloses += prices[i]
            //sumClosesSquared+=Math.pow(prices[i],2);
          }
          var ticks = prices.length
          var sumWeights = (ticks * (ticks + 1)) / 2
          var squaredSumWeights = Math.pow(sumWeights, 2)
          var sumWeightsSquared = (sumWeights * (2 * ticks + 1)) / 3
          var slope =
            (ticks * sumWeightedCloses - sumWeights * sumCloses) /
            (ticks * sumWeightsSquared - squaredSumWeights)
          var intercept = (sumCloses - slope * sumWeights) / ticks
          var y0, y1
          if (this.p0[0] < this.p1[0]) {
            y0 = this.stx.pixelFromValueAdjusted(panel, this.p0[0], intercept)
            y1 = this.stx.pixelFromValueAdjusted(
              panel,
              this.p1[0],
              slope * rawTicks + intercept
            )
          } else {
            y0 = this.stx.pixelFromValueAdjusted(
              panel,
              this.p0[0],
              slope * rawTicks + intercept
            )
            y1 = this.stx.pixelFromValueAdjusted(panel, this.p1[0], intercept)
          }

          var trendLineColor = this.setLineColor()

          var parameters = {
            pattern: this.pattern,
            lineWidth: this.lineWidth,
          }
          this.stx.plotLine(
            x0,
            x1,
            y0,
            y1,
            trendLineColor,
            'segment',
            context,
            panel,
            parameters
          )
          this.stx.plotLine(
            x0,
            x0,
            y0 - 20,
            y0 + 20,
            trendLineColor,
            'segment',
            context,
            panel,
            parameters
          )
          this.stx.plotLine(
            x1,
            x1,
            y1 - 20,
            y1 + 20,
            trendLineColor,
            'segment',
            context,
            panel,
            parameters
          )

          if (!this.highlighted) {
            //move points
            if (this.p0[0] < this.p1[0]) {
              this.setPoint(0, this.p0[0], intercept, panel.chart)
              this.setPoint(
                1,
                this.p1[0],
                slope * rawTicks + intercept,
                panel.chart
              )
            } else {
              this.setPoint(
                0,
                this.p0[0],
                slope * rawTicks + intercept,
                panel.chart
              )
              this.setPoint(1, this.p1[0], intercept, panel.chart)
            }
          } else {
            var p0Fill = this.highlighted == 'p0' ? true : false
            var p1Fill = this.highlighted == 'p1' ? true : false
            this.littleCircle(context, x0, y0, p0Fill)
            this.littleCircle(context, x1, y1, p1Fill)
          }
        },
      })

      /**
       * trendline is an implementation of a {@link CIQ.Drawing.segment} drawing.
       *
       * Extends {@link CIQ.Drawing.segment} and automatically renders a {@link CIQ.Drawing.callout}
       * containing trend information.
       * @constructor
       * @name CIQ.Drawing.trendline
       * @since 5.1.2
       * @version ChartIQ Advanced Package
       */
      CIQ.Drawing.trendline = function() {
        this.name = 'trendline'
      }

      CIQ.Drawing.trendline.ciqInheritsFrom(CIQ.Drawing.segment)

      // allow configuration of font for trendline info in callout, which is then assigned later
      CIQ.Drawing.trendline.prototype.configs = [
        'color',
        'fillColor',
        'lineWidth',
        'pattern',
        'font',
      ]

      CIQ.Drawing.trendline.prototype.measure = function() {
        // empty function since the text will now display in a callout
      }

      CIQ.Drawing.trendline.prototype.reconstruct = function(stx, obj) {
        // reconstruct segment as usual, then add callout as property
        CIQ.Drawing.segment.prototype.reconstruct.call(this, stx, obj)
        this.callout = new CIQ.Drawing.callout()
        this.callout.reconstruct(stx, obj.callout)
      }

      CIQ.Drawing.trendline.prototype.serialize = function() {
        // serialize segment as usual, then add callout as property
        var obj = CIQ.Drawing.segment.prototype.serialize.call(this)
        obj.callout = this.callout.serialize()
        return obj
      }

      CIQ.Drawing.trendline.prototype.render = function(context) {
        var panel = this.stx.panels[this.panelName]
        if (!panel) return

        // render segment as usual
        CIQ.Drawing.segment.prototype.render.call(this, context)

        // only create and initialize callout once
        if (!this.callout) {
          this.callout = new CIQ.Drawing.callout()
          var obj = CIQ.Drawing.segment.prototype.serialize.call(this)
          this.callout.reconstruct(this.stx, obj)
        }

        // always render the callout perpendicular above / below the segment / trendline
        this.callout.p0 = CIQ.clone(this.p0)

        // extract segment coordinates
        var x0 = this.stx.pixelFromTick(this.p0[0], panel.chart)
        var x1 = this.stx.pixelFromTick(this.p1[0], panel.chart)
        var y0 = this.stx.pixelFromValueAdjusted(panel, this.p0[0], this.p0[1])
        var y1 = this.stx.pixelFromValueAdjusted(panel, this.p1[0], this.p1[1])

        // return if we are off the screen axes else insanity ensues
        if (!isFinite(y0) || !isFinite(y1)) return

        // calculate midpoint (for stem of callout)
        var xmid = (x0 + x1) / 2
        var ymid = (y0 + y1) / 2

        // determine length of segment and multiplier / direction of normal vector to give fixed length depending on stem location
        this.fontSize = CIQ.stripPX((this.font && this.font.size) || 13)
        var stemDist =
          this.callout.w * 1.2 + (this.callout.stemEntry[0] == 'c' ? 0 : 50)
        var segmentDist = Math.sqrt(Math.pow(x1 - x0, 2) + Math.pow(y1 - y0, 2))
        var scalar =
          (stemDist / (segmentDist || stemDist)) *
          (this.p1[1] < this.p0[1] ? 1 : -1)

        // normal vector (see e.g. http://mathworld.wolfram.com/NormalVector.html)
        var nX = -(y1 - ymid) * scalar + xmid
        var nY = (x1 - xmid) * scalar + ymid

        // assign callout coordinates
        this.callout.p0[0] = this.stx.tickFromPixel(nX, panel.chart)
        this.callout.p0[1] = this.stx.priceFromPixel(nY, panel)
        this.callout.v0 = this.callout.p0[1]
        this.callout.p1 = CIQ.clone(this.p0)

        // assign callout properties
        this.callout.stx = this.stx
        this.callout.fillColor = this.fillColor || this.callout.fillColor
        this.callout.borderColor = this.color
        this.callout.font = this.font || this.callout.font
        this.callout.noHandles = true

        // calculate trend and assign to callout text; only show percent if not Inf
        var deltaV = this.p1[1] - this.p0[1]
        this.callout.text =
          '' +
          Number(deltaV).toFixed(2) +
          (this.p0[1] === 0
            ? ''
            : ' (' + Number((100 * deltaV) / this.p0[1]).toFixed(2) + '%) ') +
          '' +
          Math.abs(this.p1[0] - this.p0[0]) +
          ' Bars'

        // calculate stem as midpoint of segment
        var midtickIdx = Math.floor((this.p0[0] + this.p1[0]) / 2),
          midV
        if (
          Math.abs(this.p0[0] - this.p1[0]) > 1 &&
          Math.abs(this.p0[0] - this.p1[0]) < 20
        ) {
          // because of math.floor, we may be grabbing a bar off of center,
          // so calculate price based on slope of trendline
          var midtickXpixel = this.stx.pixelFromTick(midtickIdx, panel.chart)
          var midtickYpixel =
            y0 + ((y1 - y0) / (x1 - x0)) * (midtickXpixel - x0)
          midV = this.stx.priceFromPixel(midtickYpixel, panel) || ymid
        } else {
          midV = this.stx.priceFromPixel(ymid, panel)
        }

        this.callout.stem = {
          t: midtickIdx,
          v: midV,
        }

        // render callout and text
        this.callout.renderText()
        this.callout.render(context)

        // paint the handle circles based on highlighting
        if (this.highlighted) {
          var p0Fill = this.highlighted == 'p0' ? true : false
          var p1Fill = this.highlighted == 'p1' ? true : false
          this.littleCircle(context, x0, y0, p0Fill)
          this.littleCircle(context, x1, y1, p1Fill)
        }
      }

      CIQ.Drawing.trendline.prototype.lineIntersection = function(
        tick,
        value,
        box,
        type
      ) {
        // override type as segment to preserve lineIntersection functionality
        return CIQ.Drawing.BaseTwoPoint.prototype.lineIntersection.call(
          this,
          tick,
          value,
          box,
          'segment'
        )
      }

      CIQ.Drawing.trendline.prototype.intersected = function(tick, value, box) {
        // in case invalid drawing (such as from panel that no longer exists)
        if (!this.p0 || !this.p1) return null

        // call and store intersection methods on both callout and segment
        var calloutIntersected = this.callout.intersected(tick, value, box)
        var segmentIntersected = CIQ.Drawing.segment.prototype.intersected.call(
          this,
          tick,
          value,
          box
        )

        // synchronize highlighting
        this.callout.highlighted = !!(calloutIntersected || segmentIntersected)
        //this.highlighted = segmentIntersected || calloutIntersected;

        if (segmentIntersected) {
          // If segment is highlighted, return as usual;
          return segmentIntersected
        } else if (calloutIntersected) {
          // Otherwise, if callout is highlighted, move segment (callout will follow / rerender)
          return {
            action: 'move',
            p0: CIQ.clone(this.p0),
            p1: CIQ.clone(this.p1),
            tick: tick, // save original tick
            value: value, // save original value
          }
        }

        // neither are intersected
        return null
      }

      /**
	/**
	 * Average Line drawing tool.
	 *
	 * It inherits its properties from {@link CIQ.Drawing.regression}
	 * @constructor
	 * @name  CIQ.Drawing.average
	 * @since 4.0.0
	 * @version ChartIQ Advanced Package
	 */
      CIQ.Drawing.average = function() {
        this.name = 'average'
      }
      CIQ.Drawing.average.ciqInheritsFrom(CIQ.Drawing.regression)
      CIQ.extend(CIQ.Drawing.average.prototype, {
        configs: ['color', 'lineWidth', 'pattern', 'axisLabel'],
        measure: function() {},
        render: function(context) {
          var panel = this.stx.panels[this.panelName]
          if (!panel) return
          if (!this.p1) return
          if (this.p0[0] < 0 || this.p1[0] < 0) return
          var x0 = this.stx.pixelFromTick(this.p0[0], panel.chart)
          var x1 = this.stx.pixelFromTick(this.p1[0], panel.chart)
          if (x0 < this.stx.chart.left && x1 < this.stx.chart.left) return
          if (x0 > this.stx.chart.right && x1 > this.stx.chart.right) return

          var sumCloses = 0
          var rawTicks = 0
          var validTicks = 0
          for (
            var i = Math.min(this.p1[0], this.p0[0]);
            i <= Math.max(this.p1[0], this.p0[0]);
            i++
          ) {
            if (this.stx.chart.dataSet[i]) {
              var price = this.stx.chart.dataSet[i].Close
              if (price || price === 0) {
                validTicks++
                sumCloses += price
              }
            }
            rawTicks++
          }
          var y0, y1
          if (!validTicks) return
          var average = sumCloses / validTicks
          y = this.stx.pixelFromValueAdjusted(panel, this.p0[0], average)

          var trendLineColor = this.setLineColor()

          var parameters = {
            pattern: this.pattern,
            lineWidth: this.lineWidth,
          }
          this.stx.plotLine(
            x0,
            x1,
            y,
            y,
            trendLineColor,
            'segment',
            context,
            panel,
            parameters
          )
          this.stx.plotLine(
            x0,
            x0,
            y - 20,
            y + 20,
            trendLineColor,
            'segment',
            context,
            panel,
            parameters
          )
          this.stx.plotLine(
            x1,
            x1,
            y - 20,
            y + 20,
            trendLineColor,
            'segment',
            context,
            panel,
            parameters
          )

          if (this.axisLabel && !this.highlighted && !this.penDown) {
            if (
              (x0 >= panel.chart.left && x0 <= panel.chart.right) ||
              (x1 >= panel.chart.left && x1 <= panel.chart.right)
            ) {
              this.stx.endClip()
              var txt = average
              if (panel.chart.transformFunc)
                txt = panel.chart.transformFunc(this.stx, panel.chart, txt)
              if (panel.yAxis.priceFormatter)
                txt = panel.yAxis.priceFormatter(this.stx, panel, txt)
              else txt = this.stx.formatYAxisPrice(txt, panel)
              this.stx.createYAxisLabel(panel, txt, y, trendLineColor)
              this.stx.startClip(panel.name)
            }
          }

          if (!this.highlighted) {
            //move points
            this.setPoint(0, this.p0[0], average)
            this.setPoint(1, this.p1[0], average)
          } else {
            var p0Fill = this.highlighted == 'p0' ? true : false
            var p1Fill = this.highlighted == 'p1' ? true : false
            this.littleCircle(context, x0, y, p0Fill)
            this.littleCircle(context, x1, y, p1Fill)
          }
        },
        reconstruct: function(stx, obj) {
          this.stx = stx
          this.color = obj.col
          this.panelName = obj.pnl
          this.pattern = obj.ptrn
          this.lineWidth = obj.lw
          this.d0 = obj.d0
          this.d1 = obj.d1
          this.tzo0 = obj.tzo0
          this.tzo1 = obj.tzo1
          this.v0 = obj.v0
          this.v1 = obj.v1
          this.axisLabel = obj.al
          this.adjust()
        },
        serialize: function() {
          var obj = {
            name: this.name,
            pnl: this.panelName,
            col: this.color,
            ptrn: this.pattern,
            lw: this.lineWidth,
            d0: this.d0,
            d1: this.d1,
            tzo0: this.tzo0,
            tzo1: this.tzo1,
            v0: this.v0,
            v1: this.v1,
            al: this.axisLabel,
          }
          return obj
        },
      })

      /**
       * Quadrant Lines drawing tool.
       *
       * It inherits its properties from {@link CIQ.Drawing.speedarc}
       * @constructor
       * @name  CIQ.Drawing.quadrant
       * @since 2016-09-19
       * @version ChartIQ Advanced Package
       */
      CIQ.Drawing.quadrant = function() {
        this.name = 'quadrant'
      }
      CIQ.Drawing.quadrant.ciqInheritsFrom(CIQ.Drawing.speedarc)
      CIQ.extend(CIQ.Drawing.quadrant.prototype, {
        render: function(context) {
          var panel = this.stx.panels[this.panelName]
          if (!panel) return
          if (!this.p1) return
          var x0 = this.stx.pixelFromTick(this.p0[0], panel.chart)
          var x1 = this.stx.pixelFromTick(this.p1[0], panel.chart)

          var highest = null,
            lowest = null
          for (
            var i = Math.min(this.p1[0], this.p0[0]);
            i <= Math.max(this.p1[0], this.p0[0]);
            i++
          ) {
            if (this.stx.chart.dataSet[i]) {
              var price = this.stx.chart.dataSet[i].Close
              if (price || price === 0) {
                if (highest === null || price > highest) highest = price
                if (lowest === null || price < lowest) lowest = price
              }
            }
          }
          var avg = (highest + lowest) / 2
          var y0 = this.stx.pixelFromValueAdjusted(panel, this.p0[0], highest)
          var y25 = this.stx.pixelFromValueAdjusted(
            panel,
            this.p0[0],
            (highest + avg) / 2
          )
          var y33 = this.stx.pixelFromValueAdjusted(
            panel,
            this.p0[0],
            (2 * highest + lowest) / 3
          )
          var y50 = this.stx.pixelFromValueAdjusted(panel, this.p0[0], avg)
          var y66 = this.stx.pixelFromValueAdjusted(
            panel,
            this.p0[0],
            (highest + 2 * lowest) / 3
          )
          var y75 = this.stx.pixelFromValueAdjusted(
            panel,
            this.p0[0],
            (lowest + avg) / 2
          )
          var y100 = this.stx.pixelFromValueAdjusted(panel, this.p0[0], lowest)

          var trendLineColor = this.setLineColor()

          var fillColor = this.fillColor
          if (fillColor == 'auto' || CIQ.isTransparent(fillColor))
            fillColor = this.stx.defaultColor
          context.fillStyle = fillColor

          var parameters = {
            pattern: this.pattern,
            lineWidth: this.lineWidth,
          }
          this.stx.plotLine(
            x0,
            x1,
            y0,
            y0,
            trendLineColor,
            'segment',
            context,
            panel,
            parameters
          )
          this.stx.plotLine(
            x0,
            x1,
            y100,
            y100,
            trendLineColor,
            'segment',
            context,
            panel,
            parameters
          )
          if (this.name == 'quadrant') {
            this.stx.plotLine(
              x0,
              x1,
              y25,
              y25,
              trendLineColor,
              'segment',
              context,
              panel,
              parameters
            )
            this.stx.plotLine(
              x0,
              x1,
              y75,
              y75,
              trendLineColor,
              'segment',
              context,
              panel,
              parameters
            )
          } else if (this.name == 'tirone') {
            this.stx.plotLine(
              x0,
              x1,
              y33,
              y33,
              trendLineColor,
              'segment',
              context,
              panel,
              parameters
            )
            this.stx.plotLine(
              x0,
              x1,
              y66,
              y66,
              trendLineColor,
              'segment',
              context,
              panel,
              parameters
            )
          }
          this.stx.plotLine(
            x0,
            x0,
            y0,
            y100,
            trendLineColor,
            'segment',
            context,
            panel,
            parameters
          )
          this.stx.plotLine(
            x1,
            x1,
            y0,
            y100,
            trendLineColor,
            'segment',
            context,
            panel,
            parameters
          )
          this.stx.plotLine(
            x0,
            x1,
            y50,
            y50,
            trendLineColor,
            'segment',
            context,
            panel,
            CIQ.extend(parameters, { opacity: this.name == 'tirone' ? 0.2 : 1 })
          )

          context.globalAlpha = 0.1
          context.beginPath()
          context.fillRect(x0, y0, x1 - x0, y100 - y0)
          if (this.name == 'quadrant') {
            context.fillRect(x0, y25, x1 - x0, y75 - y25)
          } else if (this.name == 'tirone') {
            context.fillRect(x0, y33, x1 - x0, y66 - y33)
          }
          context.globalAlpha = 1

          if (!this.highlighted) {
            //move points
            this.setPoint(0, this.p0[0], avg, panel.chart)
            this.setPoint(1, this.p1[0], avg, panel.chart)
          } else {
            var p0Fill = this.highlighted == 'p0' ? true : false
            var p1Fill = this.highlighted == 'p1' ? true : false
            this.littleCircle(context, x0, y50, p0Fill)
            this.littleCircle(context, x1, y50, p1Fill)
          }
        },
      })

      /**
       * Tirone Levels drawing tool.
       *
       * It inherits its properties from {@link CIQ.Drawing.quadrant}
       * @constructor
       * @name  CIQ.Drawing.tirone
       * @since 2016-09-19
       * @version ChartIQ Advanced Package
       */
      CIQ.Drawing.tirone = function() {
        this.name = 'tirone'
      }
      CIQ.Drawing.tirone.ciqInheritsFrom(CIQ.Drawing.quadrant)

      return _exports
    }

  var __equations_ =
    //-------------------------------------------------------------------------------------------
    // Copyright 2012-2017 by ChartIQ, Inc.
    // All rights reserved
    //-------------------------------------------------------------------------------------------
    function(_exports) {
      var CIQ = _exports.CIQ

      /* jshint ignore:start */
      /* eslint-disable */
      //JavaScript Expression Evaluator: https://silentmatt.com/javascript-expression-evaluator/
      /*!
	 Based on ndef.parser, by Raphael Graf(r@undefined.ch)
	 http://www.undefined.ch/mparser/index.html
	 Ported to JavaScript and modified by Matthew Crumley (email@matthewcrumley.com, http://silentmatt.com/)
	 You are free to use and modify this code in anyway you find useful. Please leave this comment in the code
	 to acknowledge its original source. If you feel like it, I enjoy hearing about projects that use my code,
	 but don't feel like you have to let me know or ask permission.
	*/

      var Parser = function() {
        function object(o) {
          function F() {}
          F.prototype = o
          return new F()
        }

        var TNUMBER = 0
        var TOP1 = 1
        var TOP2 = 2
        var TVAR = 3
        var TFUNCALL = 4

        function Token(type_, index_, prio_, number_) {
          this.type_ = type_
          this.index_ = index_ || 0
          this.prio_ = prio_ || 0
          this.number_ = number_ !== undefined && number_ !== null ? number_ : 0
          this.toString = function() {
            switch (this.type_) {
              case TNUMBER:
                return this.number_
              case TOP1:
              case TOP2:
              case TVAR:
                return this.index_
              case TFUNCALL:
                return 'CALL'
              default:
                return 'Invalid Token'
            }
          }
        }

        function Expression(tokens, ops1, ops2, functions) {
          this.tokens = tokens
          this.ops1 = ops1
          this.ops2 = ops2
          this.functions = functions
        }

        // Based on http://www.json.org/json2.js
        var cx = /[\u0000\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,
          escapable = /[\\\'\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,
          meta = {
            // table of character substitutions
            '\b': '\\b',
            '\t': '\\t',
            '\n': '\\n',
            '\f': '\\f',
            '\r': '\\r',
            "'": "\\'",
            '\\': '\\\\',
          }

        function escapeValue(v) {
          if (typeof v === 'string') {
            escapable.lastIndex = 0
            return escapable.test(v)
              ? "'" +
                  v.replace(escapable, function(a) {
                    var c = meta[a]
                    return typeof c === 'string'
                      ? c
                      : '\\u' +
                          ('0000' + a.charCodeAt(0).toString(16)).slice(-4)
                  }) +
                  "'"
              : "'" + v + "'"
          }
          return v
        }

        Expression.prototype = {
          simplify: function(values) {
            values = values || {}
            var nstack = []
            var newexpression = []
            var n1
            var n2
            var f
            var L = this.tokens.length
            var item
            var i = 0
            for (i = 0; i < L; i++) {
              item = this.tokens[i]
              var type_ = item.type_
              if (type_ === TNUMBER) {
                nstack.push(item)
              } else if (type_ === TVAR && item.index_ in values) {
                item = new Token(TNUMBER, 0, 0, values[item.index_])
                nstack.push(item)
              } else if (type_ === TOP2 && nstack.length > 1) {
                n2 = nstack.pop()
                n1 = nstack.pop()
                f = this.ops2[item.index_]
                item = new Token(TNUMBER, 0, 0, f(n1.number_, n2.number_))
                nstack.push(item)
              } else if (type_ === TOP1 && nstack.length > 0) {
                n1 = nstack.pop()
                f = this.ops1[item.index_]
                item = new Token(TNUMBER, 0, 0, f(n1.number_))
                nstack.push(item)
              } else {
                while (nstack.length > 0) {
                  newexpression.push(nstack.shift())
                }
                newexpression.push(item)
              }
            }
            while (nstack.length > 0) {
              newexpression.push(nstack.shift())
            }

            return new Expression(
              newexpression,
              object(this.ops1),
              object(this.ops2),
              object(this.functions)
            )
          },

          substitute: function(variable, expr) {
            if (!(expr instanceof Expression)) {
              expr = new Parser().parse(String(expr))
            }
            var newexpression = []
            var L = this.tokens.length
            var item
            var i = 0
            for (i = 0; i < L; i++) {
              item = this.tokens[i]
              var type_ = item.type_
              if (type_ === TVAR && item.index_ === variable) {
                for (var j = 0; j < expr.tokens.length; j++) {
                  var expritem = expr.tokens[j]
                  var replitem = new Token(
                    expritem.type_,
                    expritem.index_,
                    expritem.prio_,
                    expritem.number_
                  )
                  newexpression.push(replitem)
                }
              } else {
                newexpression.push(item)
              }
            }

            var ret = new Expression(
              newexpression,
              object(this.ops1),
              object(this.ops2),
              object(this.functions)
            )
            return ret
          },

          evaluate: function(values) {
            values = values || {}
            var nstack = []
            var n1
            var n2
            var f
            var L = this.tokens.length
            var item
            var i = 0
            for (i = 0; i < L; i++) {
              item = this.tokens[i]
              var type_ = item.type_
              if (type_ === TNUMBER) {
                nstack.push(item.number_)
              } else if (type_ === TOP2) {
                n2 = nstack.pop()
                n1 = nstack.pop()
                f = this.ops2[item.index_]
                nstack.push(f(n1, n2))
              } else if (type_ === TVAR) {
                if (item.index_ in values) {
                  nstack.push(values[item.index_])
                } else if (item.index_ in this.functions) {
                  nstack.push(this.functions[item.index_])
                } else {
                  throw new Error('undefined variable: ' + item.index_)
                }
              } else if (type_ === TOP1) {
                n1 = nstack.pop()
                f = this.ops1[item.index_]
                nstack.push(f(n1))
              } else if (type_ === TFUNCALL) {
                n1 = nstack.pop()
                f = nstack.pop()
                if (f.apply && f.call) {
                  if (Object.prototype.toString.call(n1) == '[object Array]') {
                    nstack.push(f.apply(undefined, n1))
                  } else {
                    nstack.push(f.call(undefined, n1))
                  }
                } else {
                  throw new Error(f + ' is not a function')
                }
              } else {
                throw new Error('invalid Expression')
              }
            }
            if (nstack.length > 1) {
              throw new Error('invalid Expression (parity)')
            }
            return nstack[0]
          },

          toString: function(toJS) {
            var nstack = []
            var n1
            var n2
            var f
            var L = this.tokens.length
            var item
            var i = 0
            for (i = 0; i < L; i++) {
              item = this.tokens[i]
              var type_ = item.type_
              if (type_ === TNUMBER) {
                nstack.push(escapeValue(item.number_))
              } else if (type_ === TOP2) {
                n2 = nstack.pop()
                n1 = nstack.pop()
                f = item.index_
                if (toJS && f == '^') {
                  nstack.push('Math.pow(' + n1 + ',' + n2 + ')')
                } else {
                  nstack.push('(' + n1 + f + n2 + ')')
                }
              } else if (type_ === TVAR) {
                nstack.push(item.index_)
              } else if (type_ === TOP1) {
                n1 = nstack.pop()
                f = item.index_
                if (f === '-') {
                  nstack.push('(' + f + n1 + ')')
                } else {
                  nstack.push(f + '(' + n1 + ')')
                }
              } else if (type_ === TFUNCALL) {
                n1 = nstack.pop()
                f = nstack.pop()
                nstack.push(f + '(' + n1 + ')')
              } else {
                throw new Error('invalid Expression')
              }
            }
            if (nstack.length > 1) {
              throw new Error('invalid Expression (parity)')
            }
            return nstack[0]
          },

          variables: function() {
            var L = this.tokens.length
            var vars = []
            for (var i = 0; i < L; i++) {
              var item = this.tokens[i]
              if (item.type_ === TVAR && vars.indexOf(item.index_) == -1) {
                vars.push(item.index_)
              }
            }

            return vars
          } /*,

			toJSFunction: function (param, variables) {
				var f = new Function(param, "with(Parser.values) { return " + this.simplify(variables).toString(true) + "; }");
				return f;
			}*/,
        }

        function add(a, b) {
          return Number(a) + Number(b)
        }
        function sub(a, b) {
          return a - b
        }
        function mul(a, b) {
          return a * b
        }
        function div(a, b) {
          return a / b
        }
        function mod(a, b) {
          return a % b
        }
        function concat(a, b) {
          return '' + a + b
        }
        function equal(a, b) {
          return a == b
        }
        function notEqual(a, b) {
          return a != b
        }
        function greaterThan(a, b) {
          return a > b
        }
        function lessThan(a, b) {
          return a < b
        }
        function greaterThanEqual(a, b) {
          return a >= b
        }
        function lessThanEqual(a, b) {
          return a <= b
        }
        function andOperator(a, b) {
          return Boolean(a && b)
        }
        function orOperator(a, b) {
          return Boolean(a || b)
        }
        function sinh(a) {
          return Math.sinh ? Math.sinh(a) : (Math.exp(a) - Math.exp(-a)) / 2
        }
        function cosh(a) {
          return Math.cosh ? Math.cosh(a) : (Math.exp(a) + Math.exp(-a)) / 2
        }
        function tanh(a) {
          if (Math.tanh) return Math.tanh(a)
          if (a === Infinity) return 1
          if (a === -Infinity) return -1
          return (Math.exp(a) - Math.exp(-a)) / (Math.exp(a) + Math.exp(-a))
        }
        function asinh(a) {
          if (Math.asinh) return Math.asinh(a)
          if (a === -Infinity) return a
          return Math.log(a + Math.sqrt(a * a + 1))
        }
        function acosh(a) {
          return Math.acosh ? Math.acosh(a) : Math.log(a + Math.sqrt(a * a - 1))
        }
        function atanh(a) {
          return Math.atanh ? Math.atanh(a) : Math.log((1 + a) / (1 - a)) / 2
        }
        function log10(a) {
          return Math.log(a) * Math.LOG10E
        }
        function neg(a) {
          return -a
        }
        function trunc(a) {
          if (Math.trunc) return Math.trunc(a)
          else return a < 0 ? Math.ceil(a) : Math.floor(a)
        }
        function random(a) {
          return Math.random() * (a || 1)
        }
        function fac(a) {
          //a!
          a = Math.floor(a)
          var b = a
          while (a > 1) {
            b = b * --a
          }
          return b
        }

        function hypot() {
          if (Math.hypot) return Math.hypot.apply(this, arguments)
          var y = 0
          var length = arguments.length
          for (var i = 0; i < length; i++) {
            if (arguments[i] === Infinity || arguments[i] === -Infinity) {
              return Infinity
            }
            y += arguments[i] * arguments[i]
          }
          return Math.sqrt(y)
        }

        function condition(cond, yep, nope) {
          return cond ? yep : nope
        }

        function append(a, b) {
          if (Object.prototype.toString.call(a) != '[object Array]') {
            return [a, b]
          }
          a = a.slice()
          a.push(b)
          return a
        }

        function Parser() {
          this.success = false
          this.errormsg = ''
          this.expression = ''

          this.pos = 0

          this.tokennumber = 0
          this.tokenprio = 0
          this.tokenindex = 0
          this.tmpprio = 0

          this.ops1 = {
            sin: Math.sin,
            cos: Math.cos,
            tan: Math.tan,
            asin: Math.asin,
            acos: Math.acos,
            atan: Math.atan,
            sinh: sinh,
            cosh: cosh,
            tanh: tanh,
            asinh: asinh,
            acosh: acosh,
            atanh: atanh,
            sqrt: Math.sqrt,
            log: Math.log,
            lg: log10,
            log10: log10,
            abs: Math.abs,
            ceil: Math.ceil,
            floor: Math.floor,
            round: Math.round,
            trunc: trunc,
            '-': neg,
            exp: Math.exp,
          }

          this.ops2 = {
            '+': add,
            '-': sub,
            '*': mul,
            '/': div,
            '%': mod,
            '^': Math.pow,
            ',': append,
            '||': concat,
            '==': equal,
            '!=': notEqual,
            '>': greaterThan,
            '<': lessThan,
            '>=': greaterThanEqual,
            '<=': lessThanEqual,
            and: andOperator,
            or: orOperator,
          }

          this.functions = {
            random: random,
            fac: fac,
            min: Math.min,
            max: Math.max,
            hypot: hypot,
            pyt: hypot, // backward compat
            pow: Math.pow,
            atan2: Math.atan2,
            if: condition,
          }

          this.consts = {
            E: Math.E,
            PI: Math.PI,
          }
        }

        Parser.parse = function(expr) {
          return new Parser().parse(expr)
        }

        Parser.evaluate = function(expr, variables) {
          return Parser.parse(expr).evaluate(variables)
        }

        Parser.Expression = Expression

        Parser.values = {
          sin: Math.sin,
          cos: Math.cos,
          tan: Math.tan,
          asin: Math.asin,
          acos: Math.acos,
          atan: Math.atan,
          sinh: sinh,
          cosh: cosh,
          tanh: tanh,
          asinh: asinh,
          acosh: acosh,
          atanh: atanh,
          sqrt: Math.sqrt,
          log: Math.log,
          lg: log10,
          log10: log10,
          abs: Math.abs,
          ceil: Math.ceil,
          floor: Math.floor,
          round: Math.round,
          trunc: trunc,
          random: random,
          fac: fac,
          exp: Math.exp,
          min: Math.min,
          max: Math.max,
          hypot: hypot,
          pyt: hypot, // backward compat
          pow: Math.pow,
          atan2: Math.atan2,
          if: condition,
          E: Math.E,
          PI: Math.PI,
        }

        var PRIMARY = 1 << 0
        var OPERATOR = 1 << 1
        var FUNCTION = 1 << 2
        var LPAREN = 1 << 3
        var RPAREN = 1 << 4
        var COMMA = 1 << 5
        var SIGN = 1 << 6
        var CALL = 1 << 7
        var NULLARY_CALL = 1 << 8

        Parser.prototype = {
          parse: function(expr) {
            this.errormsg = ''
            this.success = true
            var operstack = []
            var tokenstack = []
            this.tmpprio = 0
            var expected = PRIMARY | LPAREN | FUNCTION | SIGN
            var noperators = 0
            this.expression = expr
            this.pos = 0

            while (this.pos < this.expression.length) {
              var token
              if (this.isOperator()) {
                if (this.isSign() && expected & SIGN) {
                  if (this.isNegativeSign()) {
                    this.tokenprio = 2
                    this.tokenindex = '-'
                    noperators++
                    this.addfunc(tokenstack, operstack, TOP1)
                  }
                  expected = PRIMARY | LPAREN | FUNCTION | SIGN
                } else if (this.isComment()) {
                } else {
                  if ((expected & OPERATOR) === 0) {
                    this.error_parsing(this.pos, 'unexpected operator')
                  }
                  noperators += 2
                  this.addfunc(tokenstack, operstack, TOP2)
                  expected = PRIMARY | LPAREN | FUNCTION | SIGN
                }
              } else if (this.isNumber()) {
                if ((expected & PRIMARY) === 0) {
                  this.error_parsing(this.pos, 'unexpected number')
                }
                token = new Token(TNUMBER, 0, 0, this.tokennumber)
                tokenstack.push(token)

                expected = OPERATOR | RPAREN | COMMA
              } else if (this.isString()) {
                if ((expected & PRIMARY) === 0) {
                  this.error_parsing(this.pos, 'unexpected string')
                }
                token = new Token(TNUMBER, 0, 0, this.tokennumber)
                tokenstack.push(token)

                expected = OPERATOR | RPAREN | COMMA
              } else if (this.isLeftParenth()) {
                if ((expected & LPAREN) === 0) {
                  this.error_parsing(this.pos, 'unexpected "("')
                }

                if (expected & CALL) {
                  noperators += 2
                  this.tokenprio = -2
                  this.tokenindex = -1
                  this.addfunc(tokenstack, operstack, TFUNCALL)
                }

                expected = PRIMARY | LPAREN | FUNCTION | SIGN | NULLARY_CALL
              } else if (this.isRightParenth()) {
                if (expected & NULLARY_CALL) {
                  token = new Token(TNUMBER, 0, 0, [])
                  tokenstack.push(token)
                } else if ((expected & RPAREN) === 0) {
                  this.error_parsing(this.pos, 'unexpected ")"')
                }

                expected = OPERATOR | RPAREN | COMMA | LPAREN | CALL
              } else if (this.isComma()) {
                if ((expected & COMMA) === 0) {
                  this.error_parsing(this.pos, 'unexpected ","')
                }
                this.addfunc(tokenstack, operstack, TOP2)
                noperators += 2
                expected = PRIMARY | LPAREN | FUNCTION | SIGN
              } else if (this.isConst()) {
                if ((expected & PRIMARY) === 0) {
                  this.error_parsing(this.pos, 'unexpected constant')
                }
                var consttoken = new Token(TNUMBER, 0, 0, this.tokennumber)
                tokenstack.push(consttoken)
                expected = OPERATOR | RPAREN | COMMA
              } else if (this.isOp2()) {
                if ((expected & FUNCTION) === 0) {
                  this.error_parsing(this.pos, 'unexpected function')
                }
                this.addfunc(tokenstack, operstack, TOP2)
                noperators += 2
                expected = LPAREN
              } else if (this.isOp1()) {
                if ((expected & FUNCTION) === 0) {
                  this.error_parsing(this.pos, 'unexpected function')
                }
                this.addfunc(tokenstack, operstack, TOP1)
                noperators++
                expected = LPAREN
              } else if (this.isVar()) {
                if ((expected & PRIMARY) === 0) {
                  this.error_parsing(this.pos, 'unexpected variable')
                }
                var vartoken = new Token(TVAR, this.tokenindex, 0, 0)
                tokenstack.push(vartoken)

                expected = OPERATOR | RPAREN | COMMA | LPAREN | CALL
              } else if (this.isWhite()) {
              } else {
                if (this.errormsg === '') {
                  this.error_parsing(this.pos, 'unknown character')
                } else {
                  this.error_parsing(this.pos, this.errormsg)
                }
              }
            }
            if (this.tmpprio < 0 || this.tmpprio >= 10) {
              this.error_parsing(this.pos, 'unmatched "()"')
            }
            while (operstack.length > 0) {
              var tmp = operstack.pop()
              tokenstack.push(tmp)
            }
            if (noperators + 1 !== tokenstack.length) {
              //print(noperators + 1);
              //print(tokenstack);
              this.error_parsing(this.pos, 'parity')
            }

            return new Expression(
              tokenstack,
              object(this.ops1),
              object(this.ops2),
              object(this.functions)
            )
          },

          evaluate: function(expr, variables) {
            return this.parse(expr).evaluate(variables)
          },

          error_parsing: function(column, msg) {
            this.success = false
            this.errormsg = 'parse error [column ' + column + ']: ' + msg
            this.column = column
            throw new Error(this.errormsg)
          },

          //\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\

          addfunc: function(tokenstack, operstack, type_) {
            var operator = new Token(
              type_,
              this.tokenindex,
              this.tokenprio + this.tmpprio,
              0
            )
            while (operstack.length > 0) {
              if (operator.prio_ <= operstack[operstack.length - 1].prio_) {
                tokenstack.push(operstack.pop())
              } else {
                break
              }
            }
            operstack.push(operator)
          },

          isNumber: function() {
            var r = false
            var str = ''
            while (this.pos < this.expression.length) {
              var code = this.expression.charCodeAt(this.pos)
              if ((code >= 48 && code <= 57) || code === 46) {
                str += this.expression.charAt(this.pos)
                this.pos++
                this.tokennumber = parseFloat(str)
                r = true
              } else {
                break
              }
            }
            return r
          },

          // Ported from the yajjl JSON parser at http://code.google.com/p/yajjl/
          unescape: function(v, pos) {
            var buffer = []
            var escaping = false

            for (var i = 0; i < v.length; i++) {
              var c = v.charAt(i)

              if (escaping) {
                switch (c) {
                  case "'":
                    buffer.push("'")
                    break
                  case '\\':
                    buffer.push('\\')
                    break
                  case '/':
                    buffer.push('/')
                    break
                  case 'b':
                    buffer.push('\b')
                    break
                  case 'f':
                    buffer.push('\f')
                    break
                  case 'n':
                    buffer.push('\n')
                    break
                  case 'r':
                    buffer.push('\r')
                    break
                  case 't':
                    buffer.push('\t')
                    break
                  case 'u':
                    // interpret the following 4 characters as the hex of the unicode code point
                    var codePoint = parseInt(v.substring(i + 1, i + 5), 16)
                    buffer.push(String.fromCharCode(codePoint))
                    i += 4
                    break
                  default:
                    throw this.error_parsing(
                      pos + i,
                      "Illegal escape sequence: '\\" + c + "'"
                    )
                }
                escaping = false
              } else {
                if (c == '\\') {
                  escaping = true
                } else {
                  buffer.push(c)
                }
              }
            }

            return buffer.join('')
          },

          isString: function() {
            var r = false
            var str = ''
            var startpos = this.pos
            if (
              this.pos < this.expression.length &&
              this.expression.charAt(this.pos) == "'"
            ) {
              this.pos++
              while (this.pos < this.expression.length) {
                var code = this.expression.charAt(this.pos)
                if (code != "'" || str.slice(-1) == '\\') {
                  str += this.expression.charAt(this.pos)
                  this.pos++
                } else {
                  this.pos++
                  this.tokennumber = this.unescape(str, startpos)
                  r = true
                  break
                }
              }
            }
            return r
          },

          isConst: function() {
            var str
            for (var i in this.consts) {
              if (true) {
                var L = i.length
                str = this.expression.substr(this.pos, L)
                if (i === str) {
                  this.tokennumber = this.consts[i]
                  this.pos += L
                  return true
                }
              }
            }
            return false
          },

          isOperator: function() {
            var code = this.expression.charCodeAt(this.pos)
            if (code === 43) {
              // +
              this.tokenprio = 2
              this.tokenindex = '+'
            } else if (code === 45) {
              // -
              this.tokenprio = 2
              this.tokenindex = '-'
            } else if (code === 62) {
              // >
              if (this.expression.charCodeAt(this.pos + 1) === 61) {
                this.pos++
                this.tokenprio = 1
                this.tokenindex = '>='
              } else {
                this.tokenprio = 1
                this.tokenindex = '>'
              }
            } else if (code === 60) {
              // <
              if (this.expression.charCodeAt(this.pos + 1) === 61) {
                this.pos++
                this.tokenprio = 1
                this.tokenindex = '<='
              } else {
                this.tokenprio = 1
                this.tokenindex = '<'
              }
            } else if (code === 124) {
              // |
              if (this.expression.charCodeAt(this.pos + 1) === 124) {
                this.pos++
                this.tokenprio = 1
                this.tokenindex = '||'
              } else {
                return false
              }
            } else if (code === 61) {
              // =
              if (this.expression.charCodeAt(this.pos + 1) === 61) {
                this.pos++
                this.tokenprio = 1
                this.tokenindex = '=='
              } else {
                return false
              }
            } else if (code === 33) {
              // !
              if (this.expression.charCodeAt(this.pos + 1) === 61) {
                this.pos++
                this.tokenprio = 1
                this.tokenindex = '!='
              } else {
                return false
              }
            } else if (code === 97) {
              // a
              if (
                this.expression.charCodeAt(this.pos + 1) === 110 &&
                this.expression.charCodeAt(this.pos + 2) === 100
              ) {
                // n && d
                this.pos++
                this.pos++
                this.tokenprio = 0
                this.tokenindex = 'and'
              } else {
                return false
              }
            } else if (code === 111) {
              // o
              if (this.expression.charCodeAt(this.pos + 1) === 114) {
                // r
                this.pos++
                this.tokenprio = 0
                this.tokenindex = 'or'
              } else {
                return false
              }
            } else if (code === 42 || code === 8729 || code === 8226) {
              // * or ∙ or •
              this.tokenprio = 3
              this.tokenindex = '*'
            } else if (code === 47) {
              // /
              this.tokenprio = 4
              this.tokenindex = '/'
            } else if (code === 37) {
              // %
              this.tokenprio = 4
              this.tokenindex = '%'
            } else if (code === 94) {
              // ^
              this.tokenprio = 5
              this.tokenindex = '^'
            } else {
              return false
            }
            this.pos++
            return true
          },

          isSign: function() {
            var code = this.expression.charCodeAt(this.pos - 1)
            if (code === 45 || code === 43) {
              // -
              return true
            }
            return false
          },

          isPositiveSign: function() {
            var code = this.expression.charCodeAt(this.pos - 1)
            if (code === 43) {
              // +
              return true
            }
            return false
          },

          isNegativeSign: function() {
            var code = this.expression.charCodeAt(this.pos - 1)
            if (code === 45) {
              // -
              return true
            }
            return false
          },

          isLeftParenth: function() {
            var code = this.expression.charCodeAt(this.pos)
            if (code === 40) {
              // (
              this.pos++
              this.tmpprio += 10
              return true
            }
            return false
          },

          isRightParenth: function() {
            var code = this.expression.charCodeAt(this.pos)
            if (code === 41) {
              // )
              this.pos++
              this.tmpprio -= 10
              return true
            }
            return false
          },

          isComma: function() {
            var code = this.expression.charCodeAt(this.pos)
            if (code === 44) {
              // ,
              this.pos++
              this.tokenprio = -1
              this.tokenindex = ','
              return true
            }
            return false
          },

          isWhite: function() {
            var code = this.expression.charCodeAt(this.pos)
            if (code === 32 || code === 9 || code === 10 || code === 13) {
              this.pos++
              return true
            }
            return false
          },

          isOp1: function() {
            var str = ''
            for (var i = this.pos; i < this.expression.length; i++) {
              var c = this.expression.charAt(i)
              if (c.toUpperCase() === c.toLowerCase()) {
                if (i === this.pos || (c != '_' && (c < '0' || c > '9'))) {
                  break
                }
              }
              str += c
            }
            if (str.length > 0 && str in this.ops1) {
              this.tokenindex = str
              this.tokenprio = 5
              this.pos += str.length
              return true
            }
            return false
          },

          isOp2: function() {
            var str = ''
            for (var i = this.pos; i < this.expression.length; i++) {
              var c = this.expression.charAt(i)
              if (c.toUpperCase() === c.toLowerCase()) {
                if (i === this.pos || (c != '_' && (c < '0' || c > '9'))) {
                  break
                }
              }
              str += c
            }
            if (str.length > 0 && str in this.ops2) {
              this.tokenindex = str
              this.tokenprio = 5
              this.pos += str.length
              return true
            }
            return false
          },

          isVar: function() {
            var str = ''
            for (var i = this.pos; i < this.expression.length; i++) {
              var c = this.expression.charAt(i)
              if (c.toUpperCase() === c.toLowerCase()) {
                if (i === this.pos || (c != '_' && (c < '0' || c > '9'))) {
                  break
                }
              }
              str += c
            }
            if (str.length > 0) {
              this.tokenindex = str
              this.tokenprio = 4
              this.pos += str.length
              return true
            }
            return false
          },

          isComment: function() {
            var code = this.expression.charCodeAt(this.pos - 1)
            if (code === 47 && this.expression.charCodeAt(this.pos) === 42) {
              this.pos = this.expression.indexOf('*/', this.pos) + 2
              if (this.pos === 1) {
                this.pos = this.expression.length
              }
              return true
            }
            return false
          },
        }
        return Parser
      }
      /* eslint-enable */
      /* jshint ignore:end */

      /**
       * Extracts symbols from an equation.  An equation can consist of symbols and the following operators: +-/*%()
       * PEMDAS order is followed.  Additionally, symbols can be enclosed in brackets [] to treat them as literal non-parseables.
       * @param {string} equation The equation to parse (e.g. IBM+GE)
       * @return  {object} Parsed equation, {equation: [formatted equation], symbols: [array of symbols found in the equation]}
       * @memberOf CIQ
       * @version ChartIQ Advanced Package
       */
      CIQ.formatEquation = function(equation) {
        var eq = ''
        var syms = []
        var thisSym = ''
        var lockSymbol = false
        for (var j = 1; j < equation.length; j++) {
          var c = equation[j].toUpperCase()
          if (c == '[' && !lockSymbol) {
            lockSymbol = true
          } else if (c == ']' && lockSymbol) {
            lockSymbol = false
            if (thisSym !== '') {
              syms.push(thisSym)
              eq += '[' + thisSym + ']'
            }
            thisSym = ''
          } else if (lockSymbol) {
            thisSym += c
          } else if (
            c == '+' ||
            c == '-' ||
            c == '*' ||
            c == '/' ||
            c == ':' ||
            c == '%' ||
            c == '(' ||
            c == ')'
          ) {
            if (thisSym !== '' && isNaN(thisSym)) {
              syms.push(thisSym)
              eq += '[' + thisSym + ']'
            } else {
              eq += thisSym
            }
            if (c == ':') c = '/'
            eq += c
            thisSym = ''
          } else if (c != ' ') {
            thisSym += c
          }
        }
        if (thisSym !== '' && isNaN(thisSym)) {
          syms.push(thisSym)
          eq += '[' + thisSym + ']'
        } else {
          eq += thisSym
        }
        return { equation: eq, symbols: syms }
      }

      /**
       * Extracts symbols from an equation and fetches the quotes for them.
       * @param {object} params Parameters used for the fetch
       * @param  {function} cb Callback function once all quotes are fetched
       * @memberOf CIQ
       * @version ChartIQ Advanced Package
       */
      CIQ.fetchEquationChart = function(params, cb) {
        var formEq = CIQ.formatEquation(params.symbol)
        var syms = formEq.symbols
        var arr = []
        // jump through hoops with stx so that CIQ.clone doesn't choke on it
        var stx = params.stx
        params.stx = null
        for (var i = 0; i < syms.length; i++) {
          var newParams = CIQ.shallowClone(params)
          newParams.stx = stx
          newParams.symbol = syms[i]
          arr.push(newParams)
        }
        params.stx = stx
        // multi fetch the symbols we need
        stx.quoteDriver.quoteFeed.multiFetch(arr, function(results) {
          var map = {}
          params.loadMoreReplace = true
          var attribution = { charge: 0 }
          // error on any symbol then error out. Otherwise construct map.
          for (var i = 0; i < results.length; i++) {
            var result = results[i]
            if (result.dataCallback.error) {
              cb({ error: result.dataCallback.error })
              return
            }
            map[result.params.symbol] = result.dataCallback.quotes
            params.loadMoreReplace =
              params.loadMoreReplace && result.params.loadMoreReplace
            params.moreToLoad =
              params.moreToLoad || result.dataCallback.moreAvailable
            if (result.dataCallback.attribution.charge)
              attribution.charge += result.dataCallback.attribution.charge
          }
          // compute the result and then pass to the response
          if (arr.length || !(params.loadMore || params.update)) {
            try {
              var equQuotes = CIQ.computeEquationChart(formEq.equation, map)
              cb({
                quotes: equQuotes,
                moreAvailable: params.moreToLoad,
                attribution: attribution,
              })
            } catch (e) {
              var error = { error: 'Invalid equation: ' + formEq.equation }
              if (e.name && e.name == 'NoException') error.suppressAlert = true
              cb(error)
            }
          }
        })
      }

      /**
       * Computes an equation that may contain symbols and simple arithmetic operators.
       * Parentheses can be used to separate portions of the equation.
       * PEMDAS priority is observed.
       * Symbols can be optionally contained within brackets.
       * Valid examples: 3*IBM, 4+(IBM*2), (IBM-GM)/2
       * If the equation cannot be resolved an exception is thrown.
       * @param {string} equation The equation to compute.
       * @param  {Object} map An map of symbols to data
       * @return {Array}     A consolidated array of equation results
       * @memberOf CIQ
       * @version ChartIQ Advanced Package
       */
      CIQ.computeEquationChart = function(equation, map) {
        equation = equation.replace(/[:]/, '/').toUpperCase()
        var count = 0
        for (var sym in map) {
          var r = new RegExp(
            '\\[' +
              sym
                .replace(/\[/g, '\\[')
                .replace(/\]/g, '\\]')
                .replace(/\$/g, '\\$')
                .replace(/\^/g, '\\^')
                .replace(/[+\-*/%()]/g, '\\$&') +
              '\\]',
            'g'
          )
          equation = equation.replace(r, 'symbol' + count)
          count++
        }
        var expr = Parser().parse(equation)
        var newArray = []
        var iters = {}
        var numSyms = 0,
          c
        var firstIter = null
        var priceRelative = false
        var arrMap = []
        for (sym in map) {
          var elem = { sym: sym, map: map[sym] }
          if (map[sym]) arrMap.unshift(elem)
          else arrMap.push(elem)
        }
        // Need an array - cannot guarantee order of map!
        for (var el = 0; el < arrMap.length; el++) {
          var _ = arrMap[el]
          iters[_.sym] = { i: 0, s: _.sym }
          if (_.map) {
            numSyms++
            c = _.map[0]
          } else if (numSyms == 1) {
            priceRelative = _.sym
          }
          if (!c.DT) c.DT = CIQ.strToDateTime(c.Date)
          iters[_.sym].d = c.DT
          if (!firstIter) firstIter = iters[_.sym]
        }
        var constant = numSyms === 0
        var computeHighLow = numSyms == 1 && equation.indexOf('%') == -1
        function incrementIterator(iterator) {
          iterator.i++
          if (map[iterator.s]) {
            if (iterator.i >= map[iterator.s].length) return 0
            c = map[iterator.s][iterator.i]
          }
          if (!c.DT) c.DT = CIQ.strToDateTime(c.Date)
          iterator.d = c.DT
          return 1
        }
        function isAllAligned() {
          var laggard = null
          var temp = null
          for (var iter in iters) {
            if (!temp) temp = iters[iter]
            else if (iters[iter].d.getTime() < temp.d.getTime()) {
              laggard = temp = iters[iter]
            } else if (iters[iter].d.getTime() > temp.d.getTime()) {
              laggard = temp
            }
          }
          if (laggard) {
            if (!incrementIterator(laggard)) return 0
            return -1
          }
          return 1
        }
        whileLoop: while (true) {
          var aligned = isAllAligned()
          if (!aligned) break
          if (aligned == 1) {
            var m
            if (priceRelative) {
              var prElem = map[firstIter.s][firstIter.i][priceRelative]
              if (prElem && (prElem.Close || prElem.Close === 0))
                prElem = prElem.Close
              var close = expr.evaluate({
                symbol0: map[firstIter.s][firstIter.i].Close,
                symbol1: prElem,
              })
              close = Number(close.toFixed(8)) //Math.round(close*10000)/10000;
              m = { DT: firstIter.d, Close: close, Adj_Close: close }
              m[firstIter.s] = map[firstIter.s][firstIter.i].Close
              if (!isNaN(close) && close != Infinity) newArray.push(m)
            } else if (constant) {
              var res = expr.evaluate({})
              CIQ.alert(equation + '=' + res)
              throw { name: 'NoException', message: '' }
            } else {
              count = 0
              var evaluators = {
                Adj_Close: {},
                Close: {},
                Open: {},
                High: {},
                Low: {},
                Volume: {},
              }
              for (sym in map) {
                for (var e in evaluators) {
                  evaluators[e]['symbol' + count] = map[sym][iters[sym].i][e]
                }
                count++
              }
              m = { DT: firstIter.d }
              /*
					variation 1 (Stockcharts.com):
					m.Close/=c.Close;
					m.High/=c.Close;
					m.Low/=c.Close;
					m.Open/=c.Close;

					variation 2 (eSignal):
					m.Close/=c.Close;
					m.High/=c.High;
					m.Low/=c.Low;
					m.Open/=c.Open;
					m.High=Math.max(m.High,Math.max(m.Open,m.Close));
					m.Low=Math.min(m.Low,Math.min(m.Open,m.Close));
					*/

              m.Adj_Close = expr.evaluate(evaluators.Adj_Close)
              m.Close = expr.evaluate(evaluators.Close)
              m.Open = expr.evaluate(evaluators.Open)
              m.Volume = expr.evaluate(evaluators.Volume)
              if (isNaN(m.Volume)) m.Volume = 0

              if (computeHighLow) {
                m.High = expr.evaluate(evaluators.High)
                m.Low = expr.evaluate(evaluators.Low)
              } else {
                m.High = Math.max(m.Open, m.Close)
                m.Low = Math.min(m.Open, m.Close)
              }
              if (!isNaN(m.Close) && m.Close != Infinity) newArray.push(m)

              if (!isNaN(m.High)) m.High = Number(m.High.toFixed(8)) //Math.round(m.High*10000)/10000;
              if (!isNaN(m.Low)) m.Low = Number(m.Low.toFixed(8)) //Math.round(m.Low*10000)/10000;
              if (!isNaN(m.Open)) m.Open = Number(m.Open.toFixed(8)) //Math.round(m.Open*10000)/10000;
              if (!isNaN(m.Close)) m.Close = Number(m.Close.toFixed(8)) //Math.round(m.Close*10000)/10000;
              if (!isNaN(m.Adj_Close))
                m.Adj_Close = Number(m.Adj_Close.toFixed(8))
              //Math.round(m.Adj_Close*10000)/10000;
              else m.Adj_Close = m.Close

              // Terry, 4-28-17, we were adding the individual components of an equation chart to the masterData but this complicated
              // the process of cleaning up the masterData when a series was removed. Since equation charts are handled totally out-of-band
              // it isn't necessary to store the individual component data. If we want to get efficient, and re-use components without loading
              // them from the quotefeed, then we would adapt equation charts to use series. This could get complicated though
              // since an equation series would then depend on other series. So for now we'll leave as is.
              /*count=0;
					for(sym in map){
						m[sym]=evaluators.Close["symbol"+count];
						count++;
					}*/
            }
            for (sym in map) {
              if (!incrementIterator(iters[sym])) break whileLoop
            }
          }
        }
        return newArray
      }

      return _exports
    }

  var __renderersAdvanced_ =
    //-------------------------------------------------------------------------------------------
    // Copyright 2012-2017 by ChartIQ, Inc.
    // All rights reserved
    //-------------------------------------------------------------------------------------------
    function(_exports) {
      var CIQ = _exports.CIQ

      /**
       * Creates a Shading renderer
       * This is just like Lines renderer except it will allow shading between lines.
       * Note: by default the renderer will display lines as underlays. As such, they will appear below the chart ticks and any other studies or drawings.
       *
       * See {@link CIQ.Renderer#construct} for parameters required by all renderers
       * @param {Object} config Config for renderer
       * @param  {object} [config.params] Parameters to control the renderer itself
       * @param  {number} [config.params.width] Width of the rendered line
       * @constructor
       * @name  CIQ.Renderer.Shading
       * @version ChartIQ Advanced Package
       */
      CIQ.Renderer.Shading = function(config) {
        this.construct(config)
        this.beenSetup = false
        this.errTimeout = null
        this.params.useChartLegend = false
        this.shading = []
        if (this.params.type == 'rangechannel') this.highLowBars = true
      }
      CIQ.Renderer.Shading.ciqInheritsFrom(CIQ.Renderer.Lines, false)

      /**
       * Returns a new Shading renderer if the featureList calls for it
       * FeatureList should contain "rangechannel" (draws high and low plots and shades between)
       * Called by {@link CIQ.Renderer.produce} to create a renderer for the main series
       * @param {array} featureList List of rendering terms requested by the user, parsed from the chartType
       * @param {object} [config.params] Parameters used for the series to be created, used to create the renderer
       * @return {CIQ.Renderer.Shading} A new instance of the Shading renderer, if the featureList matches
       * @memberof CIQ.Renderer.Shading
       * @since 5.1.0
       */
      CIQ.Renderer.Shading.requestNew = function(featureList, params) {
        var type = null
        for (var pt = 0; pt < featureList.length; pt++) {
          var pType = featureList[pt]
          if (pType == 'rangechannel') type = 'rangechannel'
        }
        if (type === null) return null

        return new CIQ.Renderer.Shading({
          params: CIQ.extend(params, { type: type }),
        })
      }

      /**
       * Sets the shading scheme of the renderer
       * @param  {array} scheme single object or array of objects denoting shading
       * @param  {string} [scheme.primary] left series for comparison; if omitted, use chart.dataSegment[i].Close
       * @param  {string} [scheme.secondary] right series for comparison; if omitted, use first series in the seriesMap
       * @param  {string} [scheme.color] color in hex, rgb, rgba, etc to shade between primary and secondary
       * @param  {string} [scheme.greater] color in hex, rgb, rgba, etc to shade between primary and secondary if primary is greater in price than secondary
       * @param  {string} [scheme.lesser] color in hex, rgb, rgba, etc to shade between primary and secondary if primary is lesser in price than secondary
       * Note: if scheme.greater or scheme.lesser are omitted, scheme.color is used.
       * At a bare minimum, scheme.color is required.  It is not required if scheme.greater and scheme.lesser are supplied.
       * If scheme.primary is omitted, the shading will only occur if the series share the same axis as the chart.dataSegment[i].Close.
       * If shading cannot occur for any reason, series lines will still be drawn.
       * @memberOf CIQ.Renderer.Shading
       * @example
       * renderer.setShading([
       * 	{primary:'ibm', secondary:'ge', greater:'green', lesser:'red'}, // switches shading based on crossover of values
       * 	{primary:'t', secondary:'intc', color:'blue'}, // color always blue between them regardless of which is higher or lower
       * 	{secondary:'t', color:'yellow'}, // compares masterData with the named series
       * 	{color:'yellow'} // automatically shades between master and the first series
       * ]);
       * @version ChartIQ Advanced Package
       */
      CIQ.Renderer.Shading.prototype.setShading = function(scheme) {
        if (scheme.constructor != Array) {
          scheme = [scheme]
        }
        this.shading = scheme
      }

      CIQ.Renderer.Shading.prototype.draw = function() {
        var stx = this.stx,
          chart = stx.panels[this.params.panel].chart
        if (this.params.type == 'rangechannel') {
          if (this.beenSetup) {
            if (this.seriesParams.length > 2)
              this.removeSeries(this.seriesParams[2].id)
          } else {
            this.beenSetup = true
            this.params.display = this.seriesParams[0].display
            this.params.yAxis = this.seriesParams[0].yAxis
            var shadeColor = this.seriesParams[0].color || 'auto'
            var symbol = this.seriesParams[0].symbol,
              prefix = ''
            if (symbol) prefix = symbol + '.'
            this.removeAllSeries(true)
            var name = this.params.name
            stx.addSeries(null, {
              symbol: symbol,
              loadData: !!symbol,
              field: 'High',
              renderer: 'Shading',
              name: name,
              style: 'stx_line_up',
              display: this.params.display,
            })
            stx.addSeries(null, {
              symbol: symbol,
              loadData: !!symbol,
              field: 'Low',
              renderer: 'Shading',
              name: name,
              style: 'stx_line_down',
              display: this.params.display,
            })
            this.setShading({
              primary: this.seriesParams[0].id,
              secondary: this.seriesParams[1].id,
              color: shadeColor,
            })
          }
        }
        if (!this.shading) {
          if (!this.errTimeout) {
            console.log(
              'Warning: no shading scheme set.  Use myRenderer.setShading(scheme) to set.'
            )
            var self = this
            this.errTimeout = setTimeout(function() {
              self.errTimeout = null
            }, 10000)
          }
        }
        var seriesMap = {}
        var s
        for (s = 0; s < this.seriesParams.length; s++) {
          var defaultParams = {}
          if (chart.series[this.seriesParams[s].id]) {
            // make sure the series is still there.
            defaultParams = CIQ.clone(
              chart.series[this.seriesParams[s].id].parameters
            )
          }
          seriesMap[this.seriesParams[s].id] = {
            parameters: CIQ.extend(
              CIQ.extend(defaultParams, this.params),
              this.seriesParams[s]
            ),
            yValueCache: this.caches[this.seriesParams[s].id],
          }
        }
        stx.drawSeries(chart, seriesMap, this.params.yAxis, this)

        if (chart.legend && this.params.type == 'rangechannel') {
          if (!chart.legend.colorMap) chart.legend.colorMap = {}
          var display = this.params.display
          var colors = [
            stx.getCanvasColor('stx_line_up'),
            stx.getCanvasColor('stx_line_down'),
          ]
          chart.legend.colorMap[display] = {
            color: colors,
            display: display,
            isBase: this == stx.mainSeriesRenderer,
          } // add in the optional display text to send into the legendRenderer function
        }

        for (s in seriesMap) {
          this.caches[s] = seriesMap[s].yValueCache
        }

        function joinFields(series) {
          var map = seriesMap[series]
          if (map) {
            var fld = map.parameters.field
            var subFld = map.parameters.subField
            return fld + (subFld ? '.' + subFld : '')
          }
          return series
        }

        for (s = 0; s < this.shading.length; s++) {
          var scheme = this.shading[s]
          var color = scheme.color
          if (scheme.color == 'auto') color = stx.defaultColor
          if (!scheme.primary) scheme.primary = 'Close'
          if (!scheme.secondary) scheme.secondary = this.seriesParams[0].field

          if (!scheme.secondary || !color) continue
          else if (!seriesMap[scheme.primary] && scheme.primary != 'Close')
            continue
          else if (!seriesMap[scheme.secondary]) continue
          else if (
            scheme.primary == 'Close' &&
            this.params.yAxis != chart.yAxis
          )
            continue //don't allow shading across axes

          var topFields = joinFields(scheme.primary).split('.')
          var bottomFields = joinFields(scheme.secondary).split('.')
          var parameters = {
            topBand: topFields[0],
            topSubBand: topFields[1],
            topColor: scheme.greater || color,
            topAxis: this.params.yAxis,
            bottomBand: bottomFields[0],
            bottomSubBand: bottomFields[1],
            bottomColor: scheme.lesser || color,
            bottomAxis: scheme.primary == 'Close' ? null : this.params.yAxis,
            tension: this.params.tension || chart.tension,
            opacity: 0.1,
          }
          CIQ.fillIntersecting(stx, this.params.panel, parameters)
        }
      }

      /**
	 * Creates a multi-part histogram renderer where bars can be stacked one on top of the other, clustered next to each other, or overlaid over each other.
	 *
	 * See {@link CIQ.Renderer#construct} for parameters required by all renderers
	 * @param {Object} config Config for renderer
	 * @param  {object} [config.params] Parameters to control the renderer itself
	 * @param  {boolean} [config.params.defaultBorders] Whether to draw a border for each bar as a whole.  Can be overridden by a border set for a series.  Default: false.
	 * @param  {number} [config.params.widthFactor] Width of each bar as a percentage of the candleWidth. Valid values are 0.00-1.00. Default: .8
	 * @param  {number} [config.params.heightPercentage] The amount of vertical space to use, valid values are 0.00-1.00. Default: .7
	 * @param  {boolean} [config.params.bindToYAxis] Set to true to bind the rendering to the y-axis and to draw it. Automatically set if params.yAxis is present.
	 * @param  {string} [config.params.subtype="overlaid"] Subtype of rendering "stacked", "clustered", "overlaid"
	 * @constructor
	 * @name  CIQ.Renderer.Histogram
	 * 	@example
		// configure the histogram display
		var params={
			name:				"Sentiment Data",
			type:				"histogram",
			subtype:			"stacked",
			heightPercentage:	.7,	 // how high to go. 1 = 100%
			opacity:			.7,  // only needed if supporting IE8, otherwise can use rgba values in histMap instead
			widthFactor:		.8	 // to control space between bars. 1 = no space in between
		};

	 	//legend creation callback (optional)
		function histogramLegend(colors){
	        stxx.chart.legendRenderer(stxx,{legendColorMap:colors, coordinates:{x:260, y:stxx.panels["chart"].yAxis.top+30}, noBase:true});
	    }

		// set the renderer
		var histRenderer=stxx.setSeriesRenderer(new CIQ.Renderer.Histogram({params: params, callback: histogramLegend}));

		// add data and attach.
		stxx.addSeries("^NIOALL", {display:"Symbol 1"}, function() {histRenderer.attachSeries("^NIOALL","#6B9CF7").ready();});
		stxx.addSeries("^NIOAFN", {display:"Symbol 2"}, function() {histRenderer.attachSeries("^NIOAFN","#95B7F6").ready();});
		stxx.addSeries("^NIOAMD", {display:"Symbol 3"}, function() {histRenderer.attachSeries("^NIOAMD","#B9D0F5").ready();});
	 *
	 * @example
		// this is an example on how completely remove a renderer and all associated data.
		// This should only be necessary if you are also removing the chart itself

		// Remove all series from the renderer including series data from the masterData
  		renderer.removeAllSeries(true);

  		// detach the series renderer from the chart.
  		stxx.removeSeriesRenderer(renderer);

  		// delete the renderer itself.
  		delete renderer;

	 * @version ChartIQ Advanced Package
	 */
      CIQ.Renderer.Histogram = function(config) {
        this.construct(config)
        this.params.type = 'histogram'
        this.params.highlightable = false
        this.barsHaveWidth = this.standaloneBars = true
      }

      CIQ.Renderer.Histogram.ciqInheritsFrom(CIQ.Renderer, false)
      CIQ.Renderer.Histogram.prototype.performCalculations = function(
        prevMinMax
      ) {
        if (this.params.yAxis) {
          var panel = this.stx.panels[this.params.panel]
          var fields = []
          for (var i = 0; i < this.seriesParams.length; i++) {
            fields.push(this.seriesParams[i].field)
          }
          var minMax = this.stx.determineMinMax(
            this.stx.chart.dataSegment,
            fields,
            this.params.subtype == 'stacked',
            true
          )
          if (prevMinMax && prevMinMax.length) {
            minMax[0] = Math.min(prevMinMax[0], minMax[0])
            minMax[1] = Math.max(prevMinMax[1], minMax[1])
          }
          this.stx.calculateYAxisRange(panel, this.params.yAxis, 0, minMax[1])
          var heightPercentage = this.params.heightPercentage
            ? this.params.heightPercentage
            : 1
          this.params.yAxis.high = minMax[1] / heightPercentage
          this.params.yAxis.min = 0 // So that zoom doesn't pull negative numbers in
          this.params.bindToYAxis = true
        }
      }

      CIQ.Renderer.Histogram.prototype.draw = function() {
        this.stx.drawHistogram(CIQ.clone(this.params), this.seriesParams)
      }

      /**
       * Creates a Heatmap renderer
       * See {@link CIQ.Renderer#construct} for parameters required by all renderers
       * @param {Object} config Config for renderer
       * @param  {object} [config.params] Parameters to control the renderer itself
       * @param  {number} [config.params.widthFactor] Width of each bar as a percentage of the candleWidth. Valid values are 0.00-1.00. Default: 1
       * @param  {number} [config.params.height] The amount of vertical space to use, in price units. For example, 2=>2 unit increments on yaxis.
       * @constructor
       * @name  CIQ.Renderer.Heatmap
       * @version ChartIQ Advanced Package
       */
      CIQ.Renderer.Heatmap = function(config) {
        this.construct(config)
        this.params.type = 'heatmap'
        this.params.highlightable = false
        this.barsHaveWidth = this.standaloneBars = true
      }

      CIQ.Renderer.Heatmap.ciqInheritsFrom(CIQ.Renderer, false)
      CIQ.Renderer.Heatmap.prototype.performCalculations = function(
        prevMinMax
      ) {
        var panel = this.stx.panels[this.params.panel]
        var yAxis = this.params.yAxis ? this.params.yAxis : panel.yAxis
        var fields = []
        for (var i = 0; i < this.seriesParams.length; i++) {
          fields.push(this.seriesParams[i].field)
        }
        var minMax = this.stx.determineMinMax(
          this.stx.chart.dataSegment,
          fields,
          false,
          true
        )
        if (prevMinMax && prevMinMax.length) {
          minMax[0] = Math.min(prevMinMax[0], minMax[0])
          minMax[1] = Math.max(prevMinMax[1], minMax[1])
        }
        if (this.params.yAxis) {
          this.stx.calculateYAxisRange(panel, yAxis, minMax[0], minMax[1])
        } else if (this.params.panel == this.stx.chart.panel.name) {
          this.stx.chart.lowValue = Math.min(this.stx.chart.lowValue, minMax[0])
          this.stx.chart.highValue = Math.max(
            this.stx.chart.highValue,
            minMax[1]
          )
        } else {
          this.stx.calculateYAxisRange(panel, yAxis, minMax[0], minMax[1])
          panel.lowValue = panel.yAxis.low
          panel.highValue = panel.yAxis.high
        }
      }

      CIQ.Renderer.Heatmap.prototype.draw = function() {
        this.stx.drawHeatmap(CIQ.clone(this.params), this.seriesParams)
      }

      /**
       * Creates a Scatter plot renderer
       * See {@link CIQ.Renderer#construct} for parameters required by all renderers
       * @param {Object} config Config for renderer
       * @param  {object} [config.params] Parameters to control the renderer itself
       * @constructor
       * @name  CIQ.Renderer.Scatter
       * @version ChartIQ Advanced Package
       */
      CIQ.Renderer.Scatter = function(config) {
        this.construct(config)
        this.standaloneBars = this.barsHaveWidth = true
      }

      CIQ.Renderer.Scatter.ciqInheritsFrom(CIQ.Renderer.Lines, false)

      /**
       * Returns a new Scatter renderer if the featureList calls for it
       * FeatureList should contain "scatter"
       * Called by {@link CIQ.Renderer.produce} to create a renderer for the main series
       * @param {array} featureList List of rendering terms requested by the user, parsed from the chartType
       * @param {object} [config.params] Parameters used for the series to be created, used to create the renderer
       * @return {CIQ.Renderer.Scatter} A new instance of the Scatter renderer, if the featureList matches
       * @memberof CIQ.Renderer.Scatter
       * @since 5.1.0
       */
      CIQ.Renderer.Scatter.requestNew = function(featureList, params) {
        var type = null
        for (var pt = 0; pt < featureList.length; pt++) {
          var pType = featureList[pt]
          if (pType == 'scatterplot') type = 'scatter'
        }
        if (type === null) return null

        return new CIQ.Renderer.Scatter({
          params: CIQ.extend(params, { type: type }),
        })
      }

      CIQ.Renderer.Scatter.prototype.drawIndividualSeries = function(
        chart,
        parameters
      ) {
        panel = this.stx.panels[parameters.panel] || chart.panel
        var rc = { colors: [] }
        if (this.stx.scatter) rc = this.stx.scatter(panel, parameters)
        else console.warn('Error, Scatter renderer requires customChart.js')
        return rc
      }

      return _exports
    }

  var __share_ =
    //-------------------------------------------------------------------------------------------
    // Copyright 2012-2017 by ChartIQ, Inc.
    // All rights reserved
    //-------------------------------------------------------------------------------------------
    function(_exports) {
      var CIQ = _exports.CIQ
      var h2canvas

      /**
       * Manages chart sharing and uploading.
       * @constructor
       * @name CIQ.Share
       */
      CIQ.Share = function() {}
      _exports.STXSocial = CIQ.Share

      /**
       * Creates a png image or canvas of the current chart and everything inside the container associated with the chart when it was instantiated; including HTML.
       * Elements outside the chart container will **NOT** be included.
       *
       * It will dynamically try to load `js/thirdparty/html2canvas.js` if not already loaded.
       *
       * This function is asynchronous and requires a callback function. The callback will be passed
       * a data object or canvas which can be sent to a server or converted to an image.
       *
       * By default this method will rely on HTML2Canvas to create an image which will rely on Promises. If your browser does not implement Promises, be sure to include a polyfill to ensure HTML2Canvas works properly.
       *
       * ** This method does not always work with React or Safari **
       *
       * **Canvases can only be exported if all the contents including CSS images come from the same domain,
       * or all images have cross origin set properly and come from a server that supports CORS; which may or may not be possible with CSS images.**
       *
       * **Note when using the charts from `file:///` :**
       * If your application will use this functionality in a `file:///` environment, make sure to include `html2canvas` statically instead of allowing this method to load it dynamically.
       * <br>Example:
       * <br>`<script src="js/thirdparty/html2canvas.js"></script>`
       *
       *
       * @param {CIQ.ChartEngine} stx   Chart object
       * @param {object} params
       * @param {number} params.width
       * @param {number} params.height
       * @param {string} params.background
       * @param {bolean} params.data If true returns the image data, otherwise, it returns the canvas
       * @param {Array} params.hide Array of strings; array of the CSS selectors of the DOM elements to hide, before creating a PNG
       * @param {Function} cb  Callback when image is available fc(error,data) where data is the serialized image object or canvas
       * @name CIQ.Share.FullChart2PNG
       * @since 4.0.0 Addition of `params.hide`
       * @version ChartIQ Advanced Package plug-in
       * @private
       */

      CIQ.Share.FullChart2PNG = function(stx, params, cb) {
        if (!stx || !stx.chart) return
        //If we haven't loaded html2canvas, load it
        if (typeof html2canvas === 'undefined')
          return loadHTML2Canvas(function() {
            return createHTML2Canvas(stx, params, cb)
          })
        h2canvas = html2canvas
        createHTML2Canvas(stx, params, cb)
      }

      function createHTML2Canvas(stx, params, cb) {
        if (!params) params = {}
        var recordsTurnedOff = [],
          ciqNoShare = 'ciq-no-share',
          body = document.querySelector('body')

        if (params.hide && params.hide instanceof Array) {
          var customHide = params.hide.join(', ')
          var hideItems = document.querySelectorAll(customHide)
          for (var idx = 0; idx < hideItems.length; idx++) {
            CIQ.appendClassName(hideItems[idx], ciqNoShare)
          }
        }
        // Combining ".sharing" and ".ciq-no-share" to display:none for selected elements
        CIQ.appendClassName(body, 'sharing')

        h2canvas(stx.chart.container, {
          allowTaint: false,
          logging: false,
          width: params.width ? params.width : null,
          height: params.height ? params.height : null,
          background: params.background ? params.background : null,
          useCORS: true,
        }).then(function(canvas) {
          if (cb) {
            CIQ.unappendClassName(body, 'sharing')
            //return the full canvas if the data param is not true
            if (!params.data) {
              return cb(null, canvas)
            }
            return cb(null, canvas.toDataURL('image/png'))
          }
        })
      }

      //Load HTML2Canvas dynamically. If html2canvas.js is already loaded (statically, webpacked or with require.js) then this will be skipped.
      // HTML2Canvas is rather heavy which is why we provide the option to load dynamically. It isn't really necessary to load this until
      // a user actually shares a chart.
      function loadHTML2Canvas(cb) {
        //Make sure HTML2Canvas is not already loaded
        if (typeof html2canvas === 'undefined') {
          //If we have require, use it
          if (typeof requirejs !== 'undefined') {
            try {
              return requirejs(['html2canvas'], function(h2) {
                h2canvas = h2
                return cb()
              })
            } catch (exception) {
              console.warn(
                'Require loading has failed, attempting to load html2canvas manually.'
              )
            }
          }

          // if no require then load directly
          CIQ.loadScript(getMyRoot() + '/html2canvas.js', function() {
            h2canvas = html2canvas
            return cb()
          })
        } else {
          h2canvas = html2canvas
          return cb()
        }
      }

      //Get the location of this file. Unbundled, this would be share.js. Bundled, this would be chartiq.js. When unbundled
      //we need to walk back up out of advanced. When bundled we don't need a root because thirdparty should be a relative
      //path.
      //Set CIQ.Share.html2canvasLocation to completely override this logic.
      function getMyRoot() {
        if (CIQ.Share.html2canvasLocation) return CIQ.Share.html2canvasLocation
        var sc = document.getElementsByTagName('script')
        for (var idx = 0; idx < sc.length; idx++) {
          var s = sc[idx]
          if (s.src && s.src.indexOf('share.js') > -1) {
            return s.src.replace(/advanced\/share\.js/, '') + 'thirdparty/'
          }
        }
        return 'js/thirdparty/'
      }

      /**
       * Creates a png image of the current chart and everything inside the container associated with the chart when it was instantiated; including HTML.
       * Elements outside the chart container will **NOT** be included.
       *
       * If widthPX and heightPX are passed in then the image will be scaled to the requested dimensions.
       *
       * It will dynamically try to load `js/thirdparty/html2canvas.js` if not already loaded.
       *
       * This function is asynchronous and requires a callback function.
       * The callback will be passed a data object or canvas which can be sent to a server or converted to an image.
       *
       * Important Notes:
       * - ** This method will rely on Promises. If your browser does not implement Promises, be sure to include a polyfill.**
       *
       * - ** This method does not always work with React or Safari **
       *
       * - **Canvases can only be exported if all the contents including CSS images come from the same domain,
       * or all images have cross origin set properly and come from a server that supports CORS; which may or may not be possible with CSS images.**
       *
       * - **When using the charts from `file:///` :**
       * If your application will use this functionality in a `file:///` environment, make sure to include `html2canvas` statically instead of allowing this method to load it dynamically.
       * <br>Example:
       * <br>`<script src="js/thirdparty/html2canvas.js"></script>`
       *
       * @param  {object}   stx           Chart object
       * @param	 {object}		[parameters] 	Optional parameters to describe the image.
       * @param  {number}   [parameters.widthPX]       Width of image to create. If passed then params.heightPX  will adjust to maintain ratio.
       * @param  {number}   [parameters.heightPX]      Height of image to create. If passed then params.widthPX will adjust to maintain ratio.
       * @param  {string}   [parameters.imageType]   Specifies the file format your image will be output in. The dfault is PNG and the format must be suported by your browswer.
       * @param {Array} 	[parameters.hide] Array of strings; array of the CSS selectors of the DOM elements to hide, before creating a PNG
       * @param  {Function} cb            Callback when image is available fc(data) where data is the serialized image object
       * @memberOf CIQ.Share
       * @since
       * <br>&bull; 3.0.0 Function signature changed to take parameters.
       * <br>&bull; 4.0.0 Addition of `parameters.hide`
       * @version ChartIQ Advanced Package plug-in
       */
      //imageType is in it's location so developers don't need to change their current code.
      CIQ.Share.createImage = function(stx, params, cb) {
        var args = [].slice.call(arguments)
        cb = args.pop()
        if (params === null || typeof params != 'object')
          params = { widthPX: args[1], heightPX: args[2], imageType: args[3] }
        var widthPX = params.widthPX
        var heightPX = params.heightPX
        var imageType = params.imageType

        // Set background for any part of canvas that is currently transparent NO LONGER NECESSARY????
        // CIQ.fillTransparentCanvas(stx.chart.context, stx.containerColor, stx.chart.canvas.width, stx.chart.canvas.height);

        // We use style height/width instead of the canvas width/height when the backing store is 2x on retina screens
        var renderedHeight = stx.chart.canvas.height
        var renderedWidth = stx.chart.canvas.width
        if (stx.chart.canvas.style.height) {
          renderedHeight = CIQ.stripPX(stx.chart.canvas.style.height)
          renderedWidth = CIQ.stripPX(stx.chart.canvas.style.width)
        }
        if (widthPX && heightPX) {
          renderedHeight = heightPX
          renderedWidth = widthPX
        } else if (heightPX) {
          renderedWidth =
            stx.chart.canvas.width * (renderedHeight / stx.chart.canvas.height)
        } else if (widthPX) {
          renderedWidth = widthPX
          renderedHeight =
            stx.chart.canvas.height * (widthPX / stx.chart.canvas.width)
        }
        //var totalHeight=renderedHeight;
        var imageResult = imageType ? 'image/' + imageType : 'image/png'
        // Render the canvas as an image
        var shareImage = document.createElement('img')
        shareImage.onload = function() {
          // Print the image on a new canvas of appropriate size
          CIQ.Share.FullChart2PNG(
            stx,
            {
              image: this,
              width: renderedWidth,
              height: renderedHeight,
              hide: params.hide,
            },
            function(err, canvas) {
              try {
                cb(canvas.toDataURL(imageResult)) // return the data
              } catch (e) {
                console.warn(
                  "Safari devices do not handle CORS enabled images. Using the charts' canvas as a fallback."
                )
                cb(shareImage.src)
              }
            }
          )
        }
        shareImage.src = stx.chart.canvas.toDataURL(imageResult)
      }

      /**
	 * Uploads an image to a server. The callback will take two parameters. The first parameter is an error
	 * condition (server status), or null if there is no error. The second parameter (if no error) will contain
	 * the response from the server.
	 * 'payload' is an optional object that contains meta-data for the server. If payload exists then the image will be added as a member of the payload object, otherwise an object will be created
	 * 'dataImage' should be a data representation of an image created by the call canvas.toDataURL such as is returned by CIQ.Share.createImage
	 * If you are getting a status of zero back then you are probably encountering a cross-domain ajax issue. Check your access-control-allow-origin header on the server side

	 * @param  {string}   dataImage Serialized data for image
	 * @param  {string}   url       URL to send the image
	 * @param  {object}   [payload]   Any additional data to send to the server should be sent as an object.
	 * @param  {Function} cb        Callback when image is uploaded
	 * @memberOf CIQ.Share
	 * @version ChartIQ Advanced Package plug-in
	 */
      CIQ.Share.uploadImage = function(dataImage, url, payload, cb) {
        if (!payload) payload = {}
        payload.image = dataImage
        var valid = CIQ.postAjax(url, JSON.stringify(payload), function(
          status,
          response
        ) {
          if (status != 200) {
            cb(status, null)
            return
          }
          cb(null, response)
        })
        if (!valid) cb(0, null)
      }

      /**
	 * Convenience function that serves as a wrapper for createImage and uploadImage.
	 * It will create an image using the default parameters. If you wish to customize the image you must use {@link CIQ.Share.createImage} separately and then call {@link CIQ.Share.uploadImage}.
	 * (example python code available in our {@tutorial Chart Sharing} tutorial.
	 * @param {object}	stx Chart Object
	 * @param {object}  [override] Optional parameters that overwrite the default hosting location from https://share.chartiq.com to a custom location.
	 * @param {object}	[override.host]
	 * @param {object}	[override.path]
	 * @param {function}	cb Callback when the image is uploaded.
	 * @memberof CIQ.Share
	 * @since 2015-11-01
	 * @example
	 *  // here is the exact code this convenience function is using
		CIQ.Share.createImage(stx, {}, function(imgData){
			var id=CIQ.uniqueID();
			var host="https://share.chartiq.com";
			var url= host + "/upload/" + id;
			if(override){
				if(override.host) host=override.host;
				if(override.path) url=host+override.path+"/"+id;
			}
			var startOffset=stx.getStartDateOffset();
			var metaData={
				"layout": stx.exportLayout(),
				"drawings": stx.exportDrawings(),
				"xOffset": startOffset,
				"startDate": stx.chart.dataSegment[startOffset].Date,
				"endDate": stx.chart.dataSegment[stx.chart.dataSegment.length-1].Date,
				"id": id,
				"symbol": stx.chart.symbol
			};
			var payload={"id": id, "image": imgData, "config": metaData};
			CIQ.Share.uploadImage(imgData, url, payload, function(err, response){
				if(err!==null){
					CIQ.alert("error sharing chart: ",err);
				}else{
					cb(host+response);
				}
			});
			// end sample code to upload image to a server
		});
	 *
	 */
      CIQ.Share.shareChart = function(stx, override, cb) {
        CIQ.Share.createImage(stx, {}, function(imgData) {
          var id = CIQ.uniqueID()
          var host = 'https://share.chartiq.com'
          var url = host + '/upload/' + id
          if (override) {
            if (override.host) host = override.host
            if (override.path) url = host + override.path + '/' + id
          }
          var startOffset = stx.getStartDateOffset()
          var metaData = {
            layout: stx.exportLayout(),
            drawings: stx.exportDrawings(),
            xOffset: startOffset,
            startDate: stx.chart.dataSegment[startOffset].Date,
            endDate:
              stx.chart.dataSegment[stx.chart.dataSegment.length - 1].Date,
            id: id,
            symbol: stx.chart.symbol,
          }
          var payload = { id: id, image: imgData, config: metaData }
          CIQ.Share.uploadImage(imgData, url, payload, function(err, response) {
            if (err !== null) {
              CIQ.alert('error sharing chart: ', err)
            } else {
              cb(host + response)
            }
          })
          // end sample code to upload image to a server
        })
      }

      return _exports
    }

  var __studiesAdvanced_ =
    //-------------------------------------------------------------------------------------------
    // Copyright 2012-2017 by ChartIQ, Inc.
    // All rights reserved
    //-------------------------------------------------------------------------------------------
    function(_exports) {
      var CIQ = _exports.CIQ

      /**
       * Calculate "val lines" study. This study does all calculations on the {studyDescriptor.chart.dataSegment}.
       *
       * @param {CIQ.ChartEngine} stx A chart engine instance
       * @param {studyDescriptor} sd A study descriptor
       * @param {Object[]} quotes the dataSegment
       * @memberof CIQ.Studies
       */
      CIQ.Studies.calculateValuationLines = function(stx, sd, quotes) {
        var field = sd.inputs.Field == 'field' ? 'Close' : sd.inputs.Field
        var averageType = sd.inputs['Average Type']
        var displayAvg = sd.inputs['Display Average']
        var displayS1 = sd.inputs['Display 1 Standard Deviation (1\u03C3)']
        var displayS2 = sd.inputs['Display 2 Standard Deviation (2\u03C3)']
        var displayS3 = sd.inputs['Display 3 Standard Deviation (3\u03C3)']
        var values = []

        for (var i = 0; i < quotes.length; ++i) {
          if (quotes[i]) values.push(quotes[i][field])
        }

        var average = (function(nums, type) {
          var len = nums.length
          var numerator = 0,
            denominator = 0,
            i = 0

          switch (type) {
            case 'mean':
              denominator = len
              for (; i < len; ++i) {
                numerator += nums[i]
              }
              break
            case 'harmonic':
              numerator = len
              for (; i < len; ++i) {
                denominator += 1 / nums[i]
              }
              break
            case 'median':
              var middle = Math.floor(len / 2)
              var sorted = nums.slice().sort(function(a, b) {
                if (a > b) return 1
                if (a < b) return -1
                return 0
              })

              if (len % 1 === 0) {
                numerator = sorted[middle] + sorted[middle - 1]
                denominator = 2
              } else {
                numerator = sorted[middle]
                denominator = 1
              }
              break
          }

          return numerator / denominator
        })(values, averageType)

        // logic skips the calculation if none of the stddev lines are displaying
        var stddev =
          !(displayS1 || displayS2 || displayS3) ||
          (function(nums, baseline) {
            var len = nums.length
            var numerator = 0

            for (var i = 0; i < len; ++i) {
              numerator += Math.pow(nums[i] - baseline, 2)
            }

            return Math.sqrt(numerator / len)
          })(values, average)

        sd.data = {
          Average: displayAvg ? [average] : null,
          '1 Standard Deviation (1\u03C3)': displayS1
            ? [average + stddev, average - stddev]
            : null,
          '2 Standard Deviation (2\u03C3)': displayS2
            ? [average + stddev * 2, average - stddev * 2]
            : null,
          '3 Standard Deviation (3\u03C3)': displayS3
            ? [average + stddev * 3, average - stddev * 3]
            : null,
        }
      }

      /**
       * Display "val lines" study.
       *
       * It is possible to change how the lines appear with CSS styling.
       * ** Example: **
       * .ciq-valuation-average-line {
       *   border-style: solid;
       *   border-width: 1.2px;
       *   opacity: 0.95;
       * }
       * .ciq-valuation-deviation-line {
       *   border-style: dotted;
       *   border-width: 1px;
       *   opacity: 0.80;
       * }
       *
       * These values are used to create the params argument for {CIQ.ChartEngine#plotLine}.
       *  - "border-style" -> "pattern"
       *  - "border-width" -> "lineWidth"
       *  - "opacity" -> "opacity"
       *
       * Average line defaults to {pattern: 'solid', lineWidth: 1, opacity: 1}
       * Deviation lines default to {pattern: 'dashed', lineWidth: 1, opacity: 1}
       *
       * Suggested that whitespace be set from about 60 to 90 pixels so that the labels are
       * clearly visible in the home position.
       *
       * @example
       * var stxx = new CIQ.ChartEngine({container: $('.chart-container')[0], preferences: {whitespace: 60.5}});
       *
       * Alternatively, you can use yAxis labels by setting the labels parameter to "yaxis" in the studyLibrary entry.
       *
       * @example
       * CIQ.Studies.studyLibrary['val lines'].parameters = {labels: 'yaxis'};
       *
       * @param {CIQ.ChartEngine} stx The chart object
       * @param {studyDescriptor} sd The study descriptor
       * @memberOf CIQ.Studies
       */
      CIQ.Studies.displayValuationLines = function(stx, sd) {
        var panel = stx.panels[sd.panel]
        var context = sd.chart.context
        var data = sd.data
        var labels = sd.parameters.labels
        var averageType = sd.inputs['Average Type']
        var averageLabels = { mean: 'AVG', median: 'MED', harmonic: 'HAVG' }
        var averageStyle = stx.canvasStyle('ciq-valuation-average-line')
        var deviationStyle = stx.canvasStyle('ciq-valuation-deviation-line')
        var textPadding = 3 // padding top, right, and bottom
        var textHeight = stx.getCanvasFontSize('stx_yaxis') + textPadding * 2
        var isAvg, color, value, i, price, y, text, textWidth, plotLineParams

        for (var key in data) {
          if (!data[key]) continue

          isAvg = key == 'Average'
          color = CIQ.Studies.determineColor(sd.outputs[key])
          value = data[key]

          for (i = 0; i < value.length; ++i) {
            price = value[i]
            y = stx.pixelFromTransformedValue(price, panel)

            if (y <= panel.top || y >= panel.yAxis.bottom) continue

            plotLineParams = isAvg
              ? {
                  pattern:
                    averageStyle.borderStyle != 'none'
                      ? averageStyle.borderStyle || 'solid'
                      : 'solid',
                  lineWidth: parseFloat(averageStyle.borderWidth) || 1,
                  opacity: parseFloat(averageStyle.opacity) || 1,
                }
              : {
                  pattern:
                    deviationStyle.borderStyle != 'none'
                      ? deviationStyle.borderStyle || 'dashed'
                      : 'dashed',
                  lineWidth: parseFloat(deviationStyle.borderWidth) || 1,
                  opacity: parseFloat(deviationStyle.opacity) || 1,
                }

            stx.plotLine(
              panel.left,
              panel.right,
              y,
              y,
              color,
              'line',
              context,
              panel,
              plotLineParams
            )

            if (labels === 'yaxis') {
              stx.createYAxisLabel(
                panel,
                stx.formatYAxisPrice(price, panel),
                y,
                color,
                null,
                context
              )
              continue
            }

            // additional Y padding to prevent line from overlapping text
            y += Math.floor(plotLineParams.lineWidth / 2)

            if (y + textHeight >= panel.yAxis.bottom) continue

            text =
              (isAvg
                ? averageLabels[averageType] + ': '
                : key[0] + '\u03C3: ') + stx.formatYAxisPrice(price, panel)
            textWidth = context.measureText(text).width

            context.strokeText(
              text,
              panel.right - textWidth - textPadding,
              y + textHeight / 2 + 0.5
            )
          }
        }
      }

      /**
       * Calculate function for correlation coefficient
       * @param  {CIQ.ChartEngine} stx Chart object
       * @param  {object} sd  Study Descriptor
       * @memberOf CIQ.Studies
       * @version ChartIQ Advanced Package
       */
      CIQ.Studies.calculateCorrelationCoefficient = function(stx, sd) {
        var quotes = sd.chart.scrubbed
        var period = sd.days
        if (quotes.length < period + 1) {
          sd.error = true
          return
        }
        //var base=stx.chart.symbol;
        sd.compare = sd.inputs['Compare To']
        if (!sd.compare) {
          sd.compare = []
          sd.outputs = {}
          sd.outputMap = {}
          for (var s in stx.chart.series) {
            var series = stx.chart.series[s]
            if (series.parameters.color) {
              sd.compare.push(series.display)
              sd.outputs['Result ' + series.display] = series.parameters.color
              sd.outputMap['Result ' + series.display + ' ' + sd.name] =
                'Result ' + series.display
            }
          }
        }
        if (!sd.compare.length) {
          sd.error =
            'Correlation Coefficient requires at least one comparison symbol'
          return
        }
        for (var sym = 0; sym < sd.compare.length; sym++) {
          var sB = 0
          var sC = 0
          var sB2 = 0
          var sC2 = 0
          var sBC = 0
          var thisCompare = sd.compare[sym]
          var iters = 0
          for (var i = sd.startFrom - period; i < quotes.length; i++) {
            //last tick has no compare data
            if (!quotes[i]) continue
            var comparisonQuote = quotes[i][thisCompare]
            if (comparisonQuote && typeof comparisonQuote == 'object')
              comparisonQuote = comparisonQuote.Close
            if (!comparisonQuote && comparisonQuote !== 0) {
              if (
                i > 0 &&
                quotes[i - 1] &&
                quotes[i - 1]['_temps ' + sd.name].c
              )
                comparisonQuote = quotes[i - 1]['_temps ' + sd.name].c
              else comparisonQuote = 0
            }
            if (comparisonQuote && typeof comparisonQuote == 'object')
              comparisonQuote = comparisonQuote.Close
            quotes[i]['_temps ' + sd.name] = {}
            sB += quotes[i]['_temps ' + sd.name].b = quotes[i].Close
            sC += quotes[i]['_temps ' + sd.name].c = comparisonQuote
            sB2 += quotes[i]['_temps ' + sd.name].b2 = Math.pow(
              quotes[i].Close,
              2
            )
            sC2 += quotes[i]['_temps ' + sd.name].c2 = Math.pow(
              comparisonQuote,
              2
            )
            sBC += quotes[i]['_temps ' + sd.name].bc =
              quotes[i].Close * comparisonQuote
            if (iters >= period) {
              sB -= quotes[i - period]['_temps ' + sd.name].b
              sC -= quotes[i - period]['_temps ' + sd.name].c
              sB2 -= quotes[i - period]['_temps ' + sd.name].b2
              sC2 -= quotes[i - period]['_temps ' + sd.name].c2
              sBC -= quotes[i - period]['_temps ' + sd.name].bc

              var vb = sB2 / period - Math.pow(sB / period, 2)
              var vc = sC2 / period - Math.pow(sC / period, 2)
              var cv = sBC / period - (sB * sC) / Math.pow(period, 2)
              var cc = cv / Math.sqrt(vb * vc)
              quotes[i]['Result ' + thisCompare + ' ' + sd.name] = cc
            }
            iters++
          }
        }
      }

      CIQ.Studies.prettify = CIQ.extend(
        {
          '2-exponential': 'dema',
          '3-exponential': 'tema',
          hull: 'hma',
        },
        CIQ.Studies.prettify
      )

      CIQ.extend(CIQ.Studies.movingAverage, {
        conversions: {
          hma: 'hull',
          dema: '2-exponential',
          tema: '3-exponential',
        },
        translations: {
          hull: 'Hull',
          '2-exponential': 'Double Exponential',
          '3-exponential': 'Triple Exponential',
        },
        typeMap: {
          hma: 'Hull',
          hull: 'Hull',
          dema: 'DoubleExponential',
          '2-exponential': 'DoubleExponential',
          tema: 'TripleExponential',
          '3-exponential': 'TripleExponential',
        },
      })

      CIQ.Studies.calculateMovingAverageHull = function(stx, sd) {
        var quotes = sd.chart.scrubbed

        var field = sd.inputs.Field
        if (!field || field == 'field') field = 'Close' // Handle when the default inputs are passed in

        CIQ.Studies.MA('wma', sd.days, field, 0, '_WMA1', stx, sd)
        CIQ.Studies.MA(
          'wma',
          Math.ceil(sd.days / 2),
          field,
          0,
          '_WMA2',
          stx,
          sd
        )

        var i, val
        for (i = sd.startFrom - 1; i >= 0; i--) {
          val = quotes[i][field]
          if (val || val === 0) break
        }
        for (i++; i < quotes.length; i++) {
          var quote = quotes[i]
          quote['_MMA ' + sd.name] =
            2 * quote['_WMA2 ' + sd.name] - quote['_WMA1 ' + sd.name]
        }

        var offset = parseInt(sd.inputs.Offset, 10)
        if (isNaN(offset)) offset = 0

        var hmaDays = Math.floor(Math.sqrt(sd.days))
        CIQ.Studies.MA(
          'wma',
          hmaDays,
          '_MMA ' + sd.name,
          offset,
          '_HMA',
          stx,
          sd
        )

        var name = sd.name
        for (var p in sd.outputs) {
          name = p + ' ' + name
        }
        for (
          i = Math.max(sd.days + hmaDays - 1, sd.startFrom);
          i < quotes.length;
          i++
        ) {
          quotes[i][name] = quotes[i]['_HMA ' + sd.name]
        }
      }

      CIQ.Studies.calculateMovingAverageDoubleExponential = function(stx, sd) {
        var quotes = sd.chart.scrubbed

        var field = sd.inputs.Field
        if (!field || field == 'field') field = 'Close' // Handle when the default inputs are passed in

        CIQ.Studies.MA('ema', sd.days, field, 0, '_EMA1', stx, sd)
        CIQ.Studies.MA('ema', sd.days, '_EMA1 ' + sd.name, 0, '_EMA2', stx, sd)

        var offset = parseInt(sd.inputs.Offset, 10)
        if (isNaN(offset)) offset = 0
        var i, val
        var offsetBack = offset
        for (i = sd.startFrom - 1; i >= 0; i--) {
          val = quotes[i][field]
          if (!val && val !== 0) continue
          if (offsetBack > 0) {
            offsetBack--
            continue
          }
          break
        }
        var name = sd.name
        for (var p in sd.outputs) {
          name = p + ' ' + name
        }
        for (i++; i < quotes.length; i++) {
          if (i < 2 * (sd.days - 1)) continue
          var quote = quotes[i]
          if (quotes[i + offset])
            quotes[i + offset][name] =
              2 * quote['_EMA1 ' + sd.name] - quote['_EMA2 ' + sd.name]
        }
      }

      CIQ.Studies.calculateMovingAverageTripleExponential = function(stx, sd) {
        var quotes = sd.chart.scrubbed

        var field = sd.inputs.Field
        if (!field || field == 'field') field = 'Close' // Handle when the default inputs are passed in

        CIQ.Studies.MA('ema', sd.days, field, 0, '_EMA1', stx, sd)
        CIQ.Studies.MA('ema', sd.days, '_EMA1 ' + sd.name, 0, '_EMA2', stx, sd)
        CIQ.Studies.MA('ema', sd.days, '_EMA2 ' + sd.name, 0, '_EMA3', stx, sd)

        var offset = parseInt(sd.inputs.Offset, 10)
        if (isNaN(offset)) offset = 0
        var i, val
        var offsetBack = offset
        for (i = sd.startFrom - 1; i >= 0; i--) {
          val = quotes[i][field]
          if (!val && val !== 0) continue
          if (offsetBack > 0) {
            offsetBack--
            continue
          }
          break
        }
        var name = sd.name
        for (var p in sd.outputs) {
          name = p + ' ' + name
        }
        for (i++; i < quotes.length; i++) {
          if (i < 3 * (sd.days - 1)) continue
          var quote = quotes[i]
          if (quotes[i + offset])
            quotes[i + offset][name] =
              3 * quote['_EMA1 ' + sd.name] -
              3 * quote['_EMA2 ' + sd.name] +
              quote['_EMA3 ' + sd.name]
        }
      }

      CIQ.Studies.calculateATRBands = function(stx, sd) {
        CIQ.Studies.calculateStudyATR(stx, sd)
        var field = sd.inputs.Field
        if (!field || field == 'field') field = 'Close'
        CIQ.Studies.calculateGenericEnvelope(
          stx,
          sd,
          sd.inputs.Shift,
          field,
          'ATR ' + sd.name
        )
      }

      CIQ.Studies.calculateSTARCBands = function(stx, sd) {
        CIQ.Studies.calculateStudyATR(stx, sd)
        CIQ.Studies.MA(
          'simple',
          sd.inputs['MA Period'],
          'Close',
          0,
          '_MA',
          stx,
          sd
        )
        CIQ.Studies.calculateGenericEnvelope(
          stx,
          sd,
          sd.inputs.Multiplier,
          '_MA ' + sd.name,
          'ATR ' + sd.name
        )
      }

      CIQ.Studies.calculateATRStops = function(stx, sd) {
        var quotes = sd.chart.scrubbed
        if (!quotes) return
        CIQ.Studies.calculateStudyATR(stx, sd)
        var useHighLow = sd.inputs.HighLow
        for (
          var i = Math.max(sd.startFrom - 1, 1);
          i < quotes.length - 1;
          i++
        ) {
          var prices = quotes[i]
          var pd = quotes[i - 1]
          var prev = prices['Buy Stops ' + sd.name]
          if (!prev) prev = prices['Sell Stops ' + sd.name]
          if (!prev) prev = 0
          if (!prices || !pd) continue
          var base = prices.Close
          var result = base
          var offset = prices['ATR ' + sd.name] * sd.inputs.Multiplier
          if (prices.Close > prev && pd.Close > prev) {
            if (useHighLow) base = prices.High
            result = Math.max(prev, base - offset)
          } else if (prices.Close <= prev && pd.Close <= prev) {
            if (useHighLow) base = prices.Low
            result = Math.min(prev, base + offset)
          } else if (prices.Close > prev) {
            if (useHighLow) base = prices.High
            result = base - offset
          } else if (prices.Close <= prev) {
            if (useHighLow) base = prices.Low
            result = base + offset
          }
          if (base <= result) {
            quotes[i + 1]['Buy Stops ' + sd.name] = result
            delete quotes[i + 1]['Sell Stops ' + sd.name]
          } else if (base > result) {
            quotes[i + 1]['Sell Stops ' + sd.name] = result
            delete quotes[i + 1]['Buy Stops ' + sd.name]
          }
          quotes[i + 1]['All Stops ' + sd.name] = result
          sd.referenceOutput = 'All Stops' //so PSAR2 can draw a square wave
        }
      }

      CIQ.Studies.calculateAwesomeOscillator = function(stx, sd) {
        var quotes = sd.chart.scrubbed
        if (quotes.length < 33) {
          sd.error = true
          return
        }

        CIQ.Studies.MA('simple', 5, 'hl/2', 0, '_MA5', stx, sd)
        CIQ.Studies.MA('simple', 34, 'hl/2', 0, '_MA34', stx, sd)

        for (var i = Math.max(sd.startFrom, 33); i < quotes.length; i++) {
          if (!quotes[i]) continue
          quotes[i][sd.name + '_hist'] =
            quotes[i]['_MA5 ' + sd.name] - quotes[i]['_MA34 ' + sd.name]
        }
      }

      CIQ.Studies.calculateRelativeVolatility = function(stx, sd) {
        sd.days = Number(sd.inputs['Smoothing Period'])
        var smoothing = Number(sd.inputs['STD Period'])
        var quotes = sd.chart.scrubbed
        if (quotes.length < sd.days + smoothing) {
          sd.error = true
          return
        }
        var field = sd.inputs.Field
        if (!field || field == 'field') field = 'Close'
        function computeRVI(avgGain, avgLoss) {
          if (avgGain + avgLoss === 0) return 100
          return (100 * avgGain) / (avgGain + avgLoss)
        }
        sd.std = new CIQ.Studies.StudyDescriptor(sd.name, 'sdev', sd.panel)
        sd.std.chart = sd.chart
        sd.std.days = smoothing
        sd.std.startFrom = sd.startFrom
        sd.std.inputs = { Field: field, 'Standard Deviations': 1, Type: 'ma' }
        sd.std.outputs = { STD: null }
        CIQ.Studies.calculateStandardDeviation(stx, sd.std)

        var avgGain = 0
        var avgLoss = 0
        if (sd.startFrom > 1) {
          avgGain = quotes[sd.startFrom - 1]['_avgG ' + sd.name]
          avgLoss = quotes[sd.startFrom - 1]['_avgL ' + sd.name]
        }
        for (var i = Math.max(sd.startFrom, sd.days); i < quotes.length; i++) {
          var quote = quotes[i]
          if (quote[field] > quotes[i - 1][field]) {
            avgGain =
              (avgGain * (sd.days - 1) + quote['STD ' + sd.name]) / sd.days
            avgLoss = (avgLoss * (sd.days - 1)) / sd.days
          } else {
            avgLoss =
              (avgLoss * (sd.days - 1) + quote['STD ' + sd.name]) / sd.days
            avgGain = (avgGain * (sd.days - 1)) / sd.days
          }
          quote['Rel Vol ' + sd.name] = computeRVI(avgGain, avgLoss)
          quote['_avgG ' + sd.name] = avgGain
          quote['_avgL ' + sd.name] = avgLoss
        }
        sd.zoneOutput = 'Rel Vol'
      }

      CIQ.Studies.calculatePMO = function(stx, sd) {
        var periods = {
          Smooth: Number(sd.inputs['Smoothing Period']) - 1,
          Double: Number(sd.inputs['Double Smoothing Period']) - 1,
          Signal: Number(sd.inputs['Signal Period']),
        }
        var quotes = sd.chart.scrubbed
        if (quotes.length < periods.Smooth + periods.Double) {
          sd.error = true
          return
        }
        var field = sd.inputs.Field
        if (!field || field == 'field') field = 'Close'
        var i
        for (i = sd.startFrom; i < quotes.length; i++) {
          if (!quotes[i]) continue
          if (!quotes[i - 1]) continue
          var denom = quotes[i - 1][field]
          if (denom) {
            quotes[i]['_ROCx10 ' + sd.name] =
              1000 * (quotes[i][field] / denom - 1)
          }
        }
        CIQ.Studies.MA(
          'exponential',
          periods.Smooth,
          '_ROCx10 ' + sd.name,
          0,
          '_EMAx10',
          stx,
          sd
        )
        CIQ.Studies.MA(
          'exponential',
          periods.Double,
          '_EMAx10 ' + sd.name,
          0,
          'PMO',
          stx,
          sd
        )
        CIQ.Studies.MA(
          'exponential',
          periods.Signal,
          'PMO ' + sd.name,
          0,
          'PMOSignal',
          stx,
          sd
        )
        sd.zoneOutput = 'PMO'
      }

      CIQ.Studies.calculateElderImpulse = function(stx, sd) {
        var quotes = sd.chart.scrubbed
        var bull = sd.outputs.Bullish
        var bear = sd.outputs.Bearish
        var neutral = sd.outputs.Neutral

        CIQ.Studies.MA('exponential', 13, 'Close', 0, '_MA', stx, sd)
        sd.macd = new CIQ.Studies.StudyDescriptor(
          '_' + sd.name,
          'macd',
          sd.panel
        )
        sd.macd.chart = sd.chart
        sd.macd.days = sd.days
        sd.macd.startFrom = sd.startFrom
        sd.macd.inputs = {
          'Fast MA Period': 12,
          'Slow MA Period': 26,
          'Signal Period': 9,
        }
        sd.macd.outputs = { _MACD: null, _Signal: null }
        CIQ.Studies.calculateMACD(stx, sd.macd)

        var color
        for (var i = sd.startFrom; i < quotes.length; i++) {
          if (i === 0) color = neutral
          else if (
            quotes[i]['_MA ' + sd.name] > quotes[i - 1]['_MA ' + sd.name] &&
            quotes[i]['_' + sd.name + '_hist'] >
              quotes[i - 1]['_' + sd.name + '_hist']
          )
            color = bull
          else if (
            quotes[i]['_MA ' + sd.name] < quotes[i - 1]['_MA ' + sd.name] &&
            quotes[i]['_' + sd.name + '_hist'] <
              quotes[i - 1]['_' + sd.name + '_hist']
          )
            color = bear
          else color = neutral
          quotes[i]['Result ' + sd.name] = color
          //if(i) quotes[i-1][sd.name+"_hist"]=null;
        }
      }

      CIQ.Studies.calculatePivotPoints = function(stx, sd) {
        var quotes = sd.chart.scrubbed
        var period = 'day'
        if (stx.layout.interval == 'day') period = 'month'
        else if (CIQ.ChartEngine.isDailyInterval(stx.layout.interval))
          period = 'year'
        else if (
          stx.layout.interval == 'second' ||
          stx.layout.interval == 'millisecond' ||
          stx.layout.timeUnit == 'second' ||
          stx.layout.timeUnit == 'millisecond'
        )
          period = '15min'
        else {
          var interval = stx.layout.periodicity
          if (stx.layout.interval != 'minute') {
            interval *= stx.layout.interval
          }
          if (interval >= 30) period = 'week'
        }

        var isForex = CIQ.Market.Symbology.isForexSymbol(stx.chart.symbol)
        var isMetal = CIQ.Market.Symbology.isForexMetal(stx.chart.symbol)
        var marketOffset = null

        function getMarketOffset(localQuoteDate) {
          var marketZone = 'America/New_York'
          if (!isForex) {
            if (stx.chart.market) {
              marketZone = stx.chart.market.market_tz
            } else {
              //get the exchange from the symbol (whatever is after the period)
              var foreignExchange =
                CIQ.Market.Symbology.isForeignSymbol(stx.chart.symbol) &&
                stx.chart.symbol.split('.').pop()
              if (CIQ && CIQ.realTimeDataSource) {
                marketZone = new CIQ.QuoteFeed[CIQ.realTimeDataSource]()
                  .exchangeZones[foreignExchange]
              } else {
                marketZone =
                  CIQ.QuoteFeed.Xignite.Utility.timeZone[foreignExchange]
              }
            }
          }
          var dt = new Date(
            localQuoteDate.getTime() +
              localQuoteDate.getTimezoneOffset() * 60000
          )
          if (!marketZone || marketZone.indexOf('UTC') == -1)
            dt = CIQ.convertTimeZone(dt, 'UTC', marketZone)

          return (
            new Date(
              dt.getFullYear(),
              dt.getMonth(),
              dt.getDate(),
              dt.getHours(),
              dt.getMinutes(),
              dt.getSeconds(),
              dt.getMilliseconds()
            ).getTime() - localQuoteDate.getTime()
          )
        }
        var pointers = {
          pivotPoint: NaN,
          high: 0,
          low: 0,
          prevHigh: 0,
          prevLow: 0,
          hlSpread: 0,
        }
        if (sd.startFrom > 1) {
          pointers = CIQ.clone(quotes[sd.startFrom - 1]['_pointers ' + sd.name])
        }
        function resetPivots() {
          pointers.pivotPoint =
            (pointers.high + pointers.low + quotes[i - 1].Close) / 3
          pointers.prevHigh = pointers.high
          pointers.prevLow = pointers.low
          pointers.hlSpread = pointers.high - pointers.low
          pointers.high = pointers.low = 0
        }
        for (var i = Math.max(1, sd.startFrom); i < quotes.length; i++) {
          if (!quotes[i - 1]) continue
          pointers.high = Math.max(pointers.high, quotes[i - 1].High)
          pointers.low = Math.min(
            pointers.low > 0 ? pointers.low : quotes[i - 1].Low,
            quotes[i - 1].Low
          )
          if (sd.inputs.Continuous) resetPivots()
          else if (
            period == 'year' &&
            quotes[i].DT.getYear() != quotes[i - 1].DT.getYear()
          ) {
            //new yearly period
            resetPivots()
          } else if (
            period == 'month' &&
            quotes[i].DT.getMonth() != quotes[i - 1].DT.getMonth()
          ) {
            //new monthly period
            resetPivots()
          } else if (
            period == 'week' &&
            quotes[i].DT.getDay() < quotes[i - 1].DT.getDay()
          ) {
            //new weekly period
            resetPivots()
          } else if (period == 'day') {
            if (marketOffset === null) {
              //possible new daily period
              marketOffset = getMarketOffset(quotes[i].DT)
              if (isForex) {
                //Forex beginning of day is 17:00 NY Time, so add 7 hours of msecs (6 for metals) to make it fall on a date boundary
                if (isMetal) marketOffset += 6 * 60 * 60 * 1000
                else marketOffset += 7 * 60 * 60 * 1000
              }
            }
            var newDate = new Date(
              new Date(+quotes[i].DT).setMilliseconds(
                quotes[i].DT.getMilliseconds() + marketOffset
              )
            )
            var oldDate = new Date(
              new Date(+quotes[i - 1].DT).setMilliseconds(
                quotes[i - 1].DT.getMilliseconds() + marketOffset
              )
            )
            if (
              oldDate.getDate() != newDate.getDate() &&
              newDate.getDay() !== 0 &&
              newDate.getDay() != 6
            ) {
              //new daily period
              marketOffset = null
              resetPivots()
            }
          } else if (
            period == '15min' &&
            (quotes[i].DT.getHours() != quotes[i - 1].DT.getHours() ||
              Math.floor(quotes[i].DT.getMinutes() / 15) !=
                Math.floor(quotes[i - 1].DT.getMinutes() / 15))
          ) {
            //new 15 minute period
            resetPivots()
          }
          quotes[i]['Pivot ' + sd.name] = pointers.pivotPoint
          if (sd.inputs.Type.toLowerCase() == 'fibonacci') {
            quotes[i]['Resistance 1 ' + sd.name] =
              pointers.pivotPoint + 0.382 * pointers.hlSpread
            quotes[i]['Resistance 2 ' + sd.name] =
              pointers.pivotPoint + 0.618 * pointers.hlSpread
            quotes[i]['Resistance 3 ' + sd.name] =
              pointers.pivotPoint + pointers.hlSpread
            quotes[i]['Support 1 ' + sd.name] =
              pointers.pivotPoint - 0.382 * pointers.hlSpread
            quotes[i]['Support 2 ' + sd.name] =
              pointers.pivotPoint - 0.618 * pointers.hlSpread
            quotes[i]['Support 3 ' + sd.name] =
              pointers.pivotPoint - pointers.hlSpread
          } else {
            quotes[i]['Resistance 1 ' + sd.name] =
              2 * pointers.pivotPoint - pointers.prevLow
            quotes[i]['Resistance 2 ' + sd.name] =
              pointers.pivotPoint + pointers.hlSpread
            quotes[i]['Resistance 3 ' + sd.name] =
              pointers.pivotPoint + 2 * pointers.hlSpread
            quotes[i]['Support 1 ' + sd.name] =
              2 * pointers.pivotPoint - pointers.prevHigh
            quotes[i]['Support 2 ' + sd.name] =
              pointers.pivotPoint - pointers.hlSpread
            quotes[i]['Support 3 ' + sd.name] =
              pointers.pivotPoint - 2 * pointers.hlSpread
          }
          quotes[i]['_pointers ' + sd.name] = CIQ.clone(pointers)
        }
      }

      CIQ.Studies.calculateVWAP = function(stx, sd) {
        var quotes = sd.chart.scrubbed
        if (CIQ.ChartEngine.isDailyInterval(stx.layout.interval)) {
          sd.error = 'VWAP is Intraday Only'
          return
        }
        var isForex = CIQ.Market.Symbology.isForexSymbol(stx.chart.symbol)
        var isMetal = CIQ.Market.Symbology.isForexMetal(stx.chart.symbol)
        var marketOffset = null
        var volume = 0
        var volume_price = 0
        var hasThereBeenVolume = false
        function getMarketOffset(localQuoteDate) {
          var marketZone = 'America/New_York'
          if (!isForex) {
            if (stx.chart.market) {
              marketZone = stx.chart.market.market_tz
            } else {
              //get the exchange from the symbol (whatever is after the period)
              var foreignExchange =
                CIQ.Market.Symbology.isForeignSymbol(stx.chart.symbol) &&
                stx.chart.symbol.split('.').pop()
              if (CIQ && CIQ.realTimeDataSource) {
                marketZone = new CIQ.QuoteFeed[CIQ.realTimeDataSource]()
                  .exchangeZones[foreignExchange]
              } else {
                marketZone =
                  CIQ.QuoteFeed.Xignite.Utility.timeZone[foreignExchange]
              }
            }
          }
          var dt = new Date(
            localQuoteDate.getTime() +
              localQuoteDate.getTimezoneOffset() * 60000
          )
          if (!marketZone || marketZone.indexOf('UTC') == -1)
            dt = CIQ.convertTimeZone(dt, 'UTC', marketZone)

          return (
            new Date(
              dt.getFullYear(),
              dt.getMonth(),
              dt.getDate(),
              dt.getHours(),
              dt.getMinutes(),
              dt.getSeconds(),
              dt.getMilliseconds()
            ).getTime() - localQuoteDate.getTime()
          )
        }
        if (sd.startFrom > 1) {
          volume = quotes[sd.startFrom - 1]['_V ' + sd.name]
          volume_price = quotes[sd.startFrom - 1]['_VxP ' + sd.name]
        }
        for (var i = sd.startFrom; i < quotes.length; i++) {
          if (marketOffset === null) {
            //possible new daily period
            marketOffset = getMarketOffset(quotes[i].DT)
            if (isForex) {
              //Forex beginning of day is 17:00 NY Time, so add 7 hours of msecs (6 for metals) to make it fall on a date boundary
              if (isMetal) marketOffset += 6 * 60 * 60 * 1000
              else marketOffset += 7 * 60 * 60 * 1000
            }
          }
          if (quotes[i - 1] && quotes[i - 1].DT) {
            var newDate = new Date(
              new Date(+quotes[i].DT).setMilliseconds(
                quotes[i].DT.getMilliseconds() + marketOffset
              )
            )
            var oldDate = new Date(
              new Date(+quotes[i - 1].DT).setMilliseconds(
                quotes[i - 1].DT.getMilliseconds() + marketOffset
              )
            )
            if (
              oldDate.getDate() != newDate.getDate() &&
              newDate.getDay() !== 0 &&
              newDate.getDay() != 6
            ) {
              //new daily period
              marketOffset = null
              volume = volume_price = 0
            }
          }
          var typicalPrice = quotes[i]['hlc/3']
          volume += quotes[i].Volume
          volume_price += quotes[i].Volume * typicalPrice
          if (!volume) continue
          quotes[i]['VWAP ' + sd.name] = volume_price / volume
          quotes[i]['_V ' + sd.name] = volume
          quotes[i]['_VxP ' + sd.name] = volume_price
          hasThereBeenVolume = true
        }
        if (!hasThereBeenVolume) {
          sd.error = 'VWAP Requires Volume'
        }
      }

      CIQ.Studies.calculateMFI = function(stx, sd) {
        var quotes = sd.chart.scrubbed
        var hist,
          high = 0
        var factor = sd.inputs['Scale Factor']
        if (!factor) factor = sd.study.inputs['Scale Factor']
        var scale = Math.pow(10, Number(factor))
        if (sd.startFrom > 1)
          high = quotes[sd.startFrom - 1]['_high ' + sd.name]
        var i
        for (i = sd.startFrom; i < quotes.length; i++) {
          if (!quotes[i]) continue
          if (quotes[i].Volume) {
            quotes[i][sd.name + '_hist'] = hist =
              (scale * (quotes[i].High - quotes[i].Low)) / quotes[i].Volume
            quotes[i]['_high ' + sd.name] = high = Math.max(high, hist)
          }
        }
      }

      CIQ.Studies.calculateAlligator = function(stx, sd) {
        var periods = {
          J: Number(sd.inputs['Jaw Period']),
          T: Number(sd.inputs['Teeth Period']),
          L: Number(sd.inputs['Lips Period']),
        }
        var quotes = sd.chart.scrubbed
        if (quotes.length < Math.max(periods.J, periods.T, periods.L) + 1) {
          sd.error = true
          return
        }

        CIQ.Studies.MA(
          'welles wilder',
          periods.J,
          'hl/2',
          sd.inputs['Jaw Offset'],
          'Jaw',
          stx,
          sd
        )
        CIQ.Studies.MA(
          'welles wilder',
          periods.T,
          'hl/2',
          sd.inputs['Teeth Offset'],
          'Teeth',
          stx,
          sd
        )
        CIQ.Studies.MA(
          'welles wilder',
          periods.L,
          'hl/2',
          sd.inputs['Lips Offset'],
          'Lips',
          stx,
          sd
        )

        for (var i = sd.startFrom; i < quotes.length; i++) {
          if (!quotes[i]) continue
          if (sd.type == 'Gator') {
            quotes[i][sd.name + '_hist1'] = Math.abs(
              quotes[i]['Jaw ' + sd.name] - quotes[i]['Teeth ' + sd.name]
            )
            quotes[i][sd.name + '_hist2'] = -Math.abs(
              quotes[i]['Teeth ' + sd.name] - quotes[i]['Lips ' + sd.name]
            )
          }
          if (sd.inputs['Show Fractals']) {
            if (
              !quotes[i - 2] ||
              !quotes[i - 1] ||
              !quotes[i] ||
              !quotes[i + 1] ||
              !quotes[i + 2]
            )
              continue
            if (
              quotes[i - 2].High &&
              quotes[i - 1].High &&
              quotes[i].High &&
              quotes[i + 1].High &&
              quotes[i + 2].High
            ) {
              if (
                quotes[i].High > quotes[i - 1].High &&
                quotes[i].High > quotes[i - 2].High &&
                quotes[i].High > quotes[i + 1].High &&
                quotes[i].High > quotes[i + 2].High
              ) {
                quotes[i]['Fractal High ' + sd.name] = 1
              }
            }
            if (
              quotes[i - 2].Low &&
              quotes[i - 1].Low &&
              quotes[i].Low &&
              quotes[i + 1].Low &&
              quotes[i + 2].Low
            ) {
              if (
                quotes[i].Low < quotes[i - 1].Low &&
                quotes[i].Low < quotes[i - 2].Low &&
                quotes[i].Low < quotes[i + 1].Low &&
                quotes[i].Low < quotes[i + 2].Low
              ) {
                quotes[i]['Fractal Low ' + sd.name] = 1
              }
            }
          }
        }
      }

      CIQ.Studies.calculateRelativeVigor = function(stx, sd) {
        var quotes = sd.chart.scrubbed
        if (quotes.length < sd.days + 1) {
          sd.error = true
          return
        }
        var i
        for (i = sd.startFrom; i < quotes.length; i++) {
          quotes[i]['_Change ' + sd.name] = quotes[i].Close - quotes[i].Open
          quotes[i]['_Range ' + sd.name] = quotes[i].High - quotes[i].Low
        }

        CIQ.Studies.MA(
          'triangular',
          4,
          '_Change ' + sd.name,
          0,
          '_Numer',
          stx,
          sd
        )
        CIQ.Studies.MA(
          'triangular',
          4,
          '_Range ' + sd.name,
          0,
          '_Denom',
          stx,
          sd
        )

        var nums = []
        var dens = []
        for (i = Math.max(sd.startFrom - sd.days, 0); i < quotes.length; i++) {
          nums.push(quotes[i]['_Numer ' + sd.name])
          dens.push(quotes[i]['_Denom ' + sd.name])
          if (nums.length > sd.days) {
            nums.shift()
            dens.shift()
          }
          var sumNum = 0
          var sumDen = 0
          var it
          for (it = 0; it < nums.length; it++) {
            sumNum += nums[it]
          }
          for (it = 0; it < dens.length; it++) {
            sumDen += dens[it]
          }
          if (sumDen === 0) sumDen = 0.00000001
          if (i < sd.startFrom) continue
          quotes[i]['Rel Vig ' + sd.name] = sumNum / sumDen
        }

        CIQ.Studies.MA(
          'triangular',
          4,
          'Rel Vig ' + sd.name,
          0,
          'RelVigSignal',
          stx,
          sd
        )

        for (i = sd.startFrom; i < quotes.length; i++) {
          quotes[i][sd.name + '_hist'] =
            quotes[i]['Rel Vig ' + sd.name] -
            quotes[i]['RelVigSignal ' + sd.name]
        }
      }

      CIQ.Studies.calculateUlcerIndex = function(stx, sd) {
        var quotes = sd.chart.scrubbed
        if (quotes.length < 2 * sd.days - 1) {
          sd.error = true
          return
        }
        var field = sd.inputs.Field
        if (!field || field == 'field') field = 'Close'

        function getHV(p, x, f) {
          var h = null
          for (var j = x - p + 1; j <= x; j++) {
            if (j < 0) continue
            h = h === null ? quotes[j][f] : Math.max(h, quotes[j][f])
          }
          return h
        }
        var i
        for (i = Math.max(sd.startFrom, sd.days - 1); i < quotes.length; i++) {
          quotes[i]['_PD2 ' + sd.name] = Math.pow(
            100 * (quotes[i][field] / getHV(sd.days, i, field) - 1),
            2
          )
        }
        CIQ.Studies.MA('simple', sd.days, '_PD2 ' + sd.name, 0, '_MA', stx, sd)
        for (
          i = Math.max(sd.startFrom, 2 * (sd.days - 1));
          i < quotes.length;
          i++
        ) {
          quotes[i]['Result ' + sd.name] = Math.sqrt(
            quotes[i]['_MA ' + sd.name]
          )
        }
      }

      CIQ.Studies.calculateChoppiness = function(stx, sd) {
        CIQ.Studies.calculateStudyATR(stx, sd)

        var quotes = sd.chart.scrubbed
        if (quotes.length < sd.days + 1) {
          sd.error = true
          return
        }

        function getLLVHHV(p, x) {
          var h = Number.MAX_VALUE * -1,
            l = Number.MAX_VALUE
          for (var j = x - p + 1; j <= x; j++) {
            if (j < 0) continue
            h = Math.max(h, quotes[j].High)
            l = Math.min(l, quotes[j].Low)
          }
          return [l, h]
        }
        for (var i = Math.max(sd.startFrom, sd.days); i < quotes.length; i++) {
          if (!quotes[i]) continue
          var lh = getLLVHHV(sd.days, i)
          if (quotes[i]['Sum True Range ' + sd.name]) {
            quotes[i]['Result ' + sd.name] =
              (100 *
                Math.log(
                  quotes[i]['Sum True Range ' + sd.name] /
                    Math.max(0.000001, lh[1] - lh[0])
                )) /
              Math.log(sd.days)
          } else {
            quotes[i]['Result ' + sd.name] = 0
          }
        }
      }

      CIQ.Studies.calculateDisparity = function(stx, sd) {
        var quotes = sd.chart.scrubbed
        if (quotes.length < sd.days + 1) {
          sd.error = true
          return
        }
        var field = sd.inputs.Field
        if (!field || field == 'field') field = 'Close'

        CIQ.Studies.MA(
          sd.inputs['Moving Average Type'],
          sd.days,
          field,
          0,
          '_MA',
          stx,
          sd
        )
        for (
          var i = Math.max(sd.startFrom, sd.days - 1);
          i < quotes.length;
          i++
        ) {
          if (!quotes[i]) continue
          quotes[i]['Result ' + sd.name] =
            100 * (quotes[i][field] / quotes[i]['_MA ' + sd.name] - 1)
        }
      }

      CIQ.Studies.calculateRainbow = function(stx, sd) {
        var quotes = sd.chart.scrubbed
        if (quotes.length < sd.days + 1) {
          sd.error = true
          return
        }
        var field = sd.inputs.Field
        if (!field || field == 'field') field = 'Close'

        function getLLVHHV(p, x) {
          var h = Number.MAX_VALUE * -1,
            l = Number.MAX_VALUE
          for (var j = x - p + 1; j <= x; j++) {
            if (j < 0) continue
            h = Math.max(h, quotes[j].Close)
            l = Math.min(l, quotes[j].Close)
          }
          return [l, h]
        }

        var f = field
        for (var j = 1; j <= 10; j++) {
          CIQ.Studies.MA('simple', sd.days, f, 0, 'SMA' + j, stx, sd)
          f = 'SMA' + j + ' ' + sd.name
        }

        for (var i = Math.max(sd.startFrom, 10); i < quotes.length; i++) {
          if (!quotes[i]) continue
          var accum = 0,
            max = Number.MAX_VALUE * -1,
            min = Number.MAX_VALUE
          for (j = 1; j <= 10; j++) {
            var q = quotes[i]['SMA' + j + ' ' + sd.name]
            accum += q
            max = Math.max(max, q)
            min = Math.min(min, q)
          }
          if (sd.name.indexOf('Osc') > -1) {
            var lh = getLLVHHV(sd.inputs['HHV/LLV Lookback'], i)
            quotes[i][sd.name + '_hist'] =
              (100 * (quotes[i][field] - accum / 10)) /
              Math.max(0.000001, lh[1] - lh[0])
            quotes[i]['Over ' + sd.name] =
              (100 * (max - min)) / Math.max(0.000001, lh[1] - lh[0])
            quotes[i]['Under ' + sd.name] = -quotes[i]['Over ' + sd.name]
            quotes[i]['Zero ' + sd.name] = 0
          }
        }
      }

      CIQ.Studies.calculateKST = function(stx, sd) {
        var quotes = sd.chart.scrubbed
        var field = sd.inputs.Field
        if (!field || field == 'field') field = 'Close'
        var roc = {},
          smp = {}
        roc[1] = Number(sd.inputs['Lightest Rate of Change Period'])
        roc[2] = Number(sd.inputs['Light Rate of Change Period'])
        roc[3] = Number(sd.inputs['Heavy Rate of Change Period'])
        roc[4] = Number(sd.inputs['Heaviest Rate of Change Period'])
        smp[1] = Number(sd.inputs['Lightest SMA Period'])
        smp[2] = Number(sd.inputs['Light SMA Period'])
        smp[3] = Number(sd.inputs['Heavy SMA Period'])
        smp[4] = Number(sd.inputs['Heaviest SMA Period'])
        var sp = Number(sd.inputs['Signal Period'])
        var i, j
        for (i = sd.startFrom; i < quotes.length; i++) {
          if (!quotes[i]) continue
          for (j = 1; j <= 4; j++) {
            if (i >= roc[j] && quotes[i - roc[j]] && quotes[i - roc[j]][field])
              quotes[i]['_ROC' + j + ' ' + sd.name] =
                100 * (quotes[i][field] / quotes[i - roc[j]][field] - 1)
          }
        }
        for (j = 1; j <= 4; j++) {
          CIQ.Studies.MA(
            'simple',
            smp[j],
            '_ROC' + j + ' ' + sd.name,
            0,
            '_SMA' + j,
            stx,
            sd
          )
        }
        for (i = sd.startFrom; i < quotes.length; i++) {
          quotes[i]['KST ' + sd.name] = 0
          for (j = 1; j <= 4; j++)
            quotes[i]['KST ' + sd.name] +=
              j * quotes[i]['_SMA' + j + ' ' + sd.name]
        }
        CIQ.Studies.MA('simple', sp, 'KST ' + sd.name, 0, 'KSTSignal', stx, sd)
      }

      CIQ.Studies.calculateSpecialK = function(stx, sd) {
        var quotes = sd.chart.scrubbed
        var field = sd.inputs.Field
        if (!field || field == 'field') field = 'Close'
        var span = sd.inputs.Interval
        if (!span) span = 'daily'
        var roc = {
          daily: [10, 15, 20, 30, 50, 65, 75, 100, 195, 265, 390, 530],
          weekly: [4, 5, 6, 8, 10, 13, 15, 20, 39, 52, 78, 104],
        }
        var map = {
          daily: [10, 10, 10, 15, 50, 65, 75, 100, 130, 130, 130, 195],
          weekly: [4, 5, 6, 8, 10, 13, 15, 20, 26, 26, 26, 39],
        }
        var i, j
        for (i = sd.startFrom; i < quotes.length; i++) {
          if (!quotes[i]) continue
          for (j = 0; j < roc[span].length; j++) {
            if (
              i >= roc[span][j] &&
              quotes[i - roc[span][j]] &&
              quotes[i - roc[span][j]][field]
            )
              quotes[i]['_ROC' + j + ' ' + sd.name] =
                100 * (quotes[i][field] / quotes[i - roc[span][j]][field] - 1)
          }
        }
        for (j = 0; j < map[span].length; j++) {
          CIQ.Studies.MA(
            span == 'daily' ? 'simple' : 'exponential',
            map[span][j],
            '_ROC' + j + ' ' + sd.name,
            0,
            '_MA' + j,
            stx,
            sd
          )
        }
        for (i = sd.startFrom; i < quotes.length; i++) {
          quotes[i]['Result ' + sd.name] = 0
          for (j = 0; j < map[span].length; j++) {
            quotes[i]['Result ' + sd.name] +=
              ((j % 4) + 1) * quotes[i]['_MA' + j + ' ' + sd.name]
          }
        }
      }

      CIQ.Studies.calculateDarvas = function(stx, sd) {
        var quotes = sd.chart.scrubbed
        var allTimeHigh = 0
        var allTimeHighPeriods = parseInt(sd.inputs['ATH Lookback Period'], 10)
        if (sd.inputs['Volume Spike']) {
          CIQ.Studies.MA(
            'simple',
            allTimeHighPeriods,
            'Volume',
            0,
            'ADV',
            stx,
            sd
          )
        }
        var spikePercentage = parseFloat(sd.inputs['Volume % of Avg']) / 100
        var boxState = 'none'
        var boxData = {}
        var ghost = null
        var buy = null,
          sell = null
        var offset = parseFloat(sd.inputs['Level Offset'])
        var debug = false
        if (debug) console.log('*****************')
        var i
        var lbl = {} //labels
        ;['Darvas', 'Ghost', 'Profit', 'Loss', 'ATH', 'ADV', 'Spike'].forEach(
          function(v) {
            lbl[v] = v + ' ' + sd.name
          }
        )
        for (i = sd.startFrom - 1; i > 0; i--) {
          var q = quotes[i]
          if (q[lbl.Darvas] || q[lbl.Ghost]) {
            for (var l in lbl) q[l] = null
          } else {
            allTimeHigh = q[lbl.ATH] || 0
            buy = q[lbl.Profit]
            sell = q[lbl.Loss]
            break
          }
        }
        for (i; i < quotes.length; i++) {
          var quote = quotes[i]
          if (!quote) continue

          if (
            parseFloat(sd.inputs['Price Minimum']) <= quotes[allTimeHigh].Close
          ) {
            if (ghost && (!ghost.End || i == ghost.End + 1)) {
              if (quotes[i - 1].Close > boxData.High) {
                boxData = {
                  State: 1,
                  High: 2 * boxData.High - boxData.Low,
                  Low: boxData.High,
                  Start: i,
                  End: 2 * boxData.End - boxData.Start + 1,
                }
              } else {
                ghost = null
                //boxData={State:1,High:boxData.High,Low:boxData.Low,Start:i,End:2*boxData.End-boxData.Start+1};
              }
              if (ghost) {
                quote[lbl.Ghost] = CIQ.clone(boxData)
                if (debug) console.log('Ghost begin:' + quote.DT)
                boxData.State = 0
                if (quotes[boxData.End]) {
                  quotes[boxData.End][lbl.Ghost] = CIQ.clone(boxData)
                  if (debug) console.log('Ghost end:' + quotes[boxData.End].DT)
                }
                ghost = { Start: boxData.Start, End: boxData.End }
                buy = boxData.High + offset
                if (!sell || sell < boxData.Low - offset) {
                  sell = boxData.Low - offset
                }
              }
            }

            quote[lbl.Profit] = buy
            quote[lbl.Loss] = sell
            if (quote.Close >= buy) buy = null
            else if (sd.inputs['Exit Field'] == 'high/low' && quote.High >= buy)
              buy = null

            if (boxState == 'none') {
              if (i == allTimeHigh + 3) {
                if (
                  !quotes[allTimeHigh + 2][lbl.Darvas] &&
                  !quotes[allTimeHigh + 1][lbl.Darvas] &&
                  !quotes[allTimeHigh][lbl.Darvas] &&
                  quotes[allTimeHigh].High > quote.High
                ) {
                  boxState = 'high'
                  //if(sell) buy=Math.max(buy,quotes[allTimeHigh].High+offset);
                }
              }
            }

            if (boxState == 'high') {
              if (quote.High > quotes[allTimeHigh].High) {
                boxState = 'none'
              } else if (
                quotes[i - 3].Low < quotes[i - 2].Low &&
                quotes[i - 3].Low < quotes[i - 1].Low &&
                quotes[i - 3].Low < quote.Low
              ) {
                boxData = {
                  State: 1,
                  High: quotes[allTimeHigh].High,
                  Low: quotes[i - 3].Low,
                  Start: allTimeHigh,
                }
                quotes[allTimeHigh][lbl.Darvas] = CIQ.clone(boxData)
                boxState = 'darvas'
                if (debug) console.log('Darvas begin:' + quotes[allTimeHigh].DT)
                if (debug) console.log('Darvas established:' + quote.DT)
                if (ghost) {
                  if (ghost.End > i && quotes[ghost.Start]) {
                    quote[lbl.Ghost] = CIQ.clone(quotes[ghost.Start][lbl.Ghost])
                    quote[lbl.Ghost].End = i
                    if (quotes[ghost.End]) {
                      delete quotes[ghost.End][lbl.Ghost]
                      if (debug)
                        console.log('Ghost End removed:' + quotes[ghost.End].DT)
                    }
                  }
                  quote[lbl.Ghost].State = 0
                  quotes[ghost.Start][lbl.Ghost].End = i
                  if (debug) console.log('Ghost end:' + quote.DT)
                  ghost = null
                }
                buy = boxData.High + offset
                if (!sell || sell < boxData.Low - offset) {
                  sell = boxData.Low - offset
                }
              }
            }

            if (boxState == 'darvas') {
              if (quote.Close > boxData.High) ghost = {}
              else if (
                sd.inputs['Exit Field'] == 'high/low' &&
                quote.High > boxData.High
              )
                ghost = {}
              else if (quote.Close < boxData.Low) boxState = 'none'
              else if (
                sd.inputs['Exit Field'] == 'high/low' &&
                quote.Low < boxData.Low
              )
                boxState = 'none'
              if (ghost) boxState = 'none'
              else if (boxState == 'none') {
                buy = null
                sell = null
              }
              if (!sd.inputs['Ghost Boxes']) ghost = null
              if (boxState == 'none') {
                for (var d = boxData.Start + 1; d < i; d++) {
                  quotes[d][lbl.Darvas] = CIQ.clone(boxData)
                }
                boxData.State = 0
                boxData.End = i
                quote[lbl.Darvas] = CIQ.clone(boxData)
                if (debug) console.log('Darvas end:' + quote.DT)
                quote[lbl.ATH] = allTimeHigh
                continue
              }
            }

            if (sell) {
              if (
                quote.Close < boxData.Low ||
                (sd.inputs['Exit Field'] == 'high/low' &&
                  quote.Low < boxData.Low)
              ) {
                if (boxState == 'darvas') boxState = 'none'
                if (
                  quote.Close < sell ||
                  (sd.inputs['Exit Field'] == 'high/low' && quote.Low < sell)
                ) {
                  buy = null
                  sell = null
                }
                if (ghost) {
                  if (ghost.End > i && quotes[ghost.Start]) {
                    quote[lbl.Ghost] = CIQ.clone(quotes[ghost.Start][lbl.Ghost])
                    quote[lbl.Ghost].End = i
                    if (quotes[ghost.End]) {
                      delete quotes[ghost.End][lbl.Ghost]
                      if (debug)
                        console.log('Ghost End removed:' + quotes[ghost.End].DT)
                    }
                  }
                  quote[lbl.Ghost].State = 0
                  quotes[ghost.Start][lbl.Ghost].End = i
                  if (debug) console.log('Ghost end:' + quote.DT)
                  ghost = null
                }
              }
            }
          }

          if (quote.High >= quotes[allTimeHigh].High) {
            allTimeHigh = i
            if (debug) console.log('All Time High:' + quote.DT)
          }

          if (
            i < 3 ||
            (quote.High >= quotes[i - 1].High &&
              quote.High >= quotes[i - 2].High &&
              quote.High >= quotes[i - 3].High)
          ) {
            if (i - allTimeHigh >= allTimeHighPeriods) {
              allTimeHigh = i
              for (var j = 0; j < allTimeHighPeriods; j++) {
                if (i - j < 0) break
                if (quotes[i - j].High > quotes[allTimeHigh].High) {
                  allTimeHigh = i - j
                }
              }
              if (debug) console.log('All Time High:' + quote.DT)
            }
          }

          if (
            sd.inputs['Volume Spike'] &&
            i > allTimeHighPeriods &&
            i == allTimeHigh
          ) {
            if (quote[lbl.ADV] * spikePercentage < quote.Volume) {
              quote[lbl.Spike] = 1
              if (debug) console.log('Volume Spike:' + quote.DT)
            }
          }
          quote[lbl.ATH] = allTimeHigh
        }
      }

      CIQ.Studies.calculateSupertrend = function(stx, sd) {
        var quotes = sd.chart.scrubbed
        if (quotes.length < sd.days + 1) {
          sd.error = true
          return
        }
        CIQ.Studies.calculateStudyATR(stx, sd)
        for (var i = sd.startFrom; i < quotes.length; i++) {
          var quote = quotes[i]
          if (!quote) continue
          var median = (quote.High + quote.Low) / 2
          var factoredATR = sd.inputs.Multiplier * quote['ATR ' + sd.name]
          var uptrend = median - factoredATR
          var downtrend = median + factoredATR
          if (i) {
            if (
              quotes[i - 1] &&
              quotes[i - 1].Close &&
              quotes[i - 1].Close > quotes[i - 1]['_Uptrend ' + sd.name] &&
              quotes[i - 1]['_Uptrend ' + sd.name] > uptrend
            )
              uptrend = quotes[i - 1]['_Uptrend ' + sd.name]
            if (
              quotes[i - 1] &&
              quotes[i - 1].Close &&
              quotes[i - 1].Close < quotes[i - 1]['_Downtrend ' + sd.name] &&
              quotes[i - 1]['_Downtrend ' + sd.name] < downtrend
            )
              downtrend = quotes[i - 1]['_Downtrend ' + sd.name]
          }
          quote['_Direction ' + sd.name] = 1
          if (i) {
            quote['_Direction ' + sd.name] =
              quotes[i - 1]['_Direction ' + sd.name]
            if (quote.Close > quotes[i - 1]['_Downtrend ' + sd.name])
              quote['_Direction ' + sd.name] = 1
            else if (quote.Close < quotes[i - 1]['_Uptrend ' + sd.name])
              quote['_Direction ' + sd.name] = -1
          }
          quote['_Uptrend ' + sd.name] = uptrend
          quote['_Downtrend ' + sd.name] = downtrend
          quote['Trend ' + sd.name] =
            quote['_Direction ' + sd.name] > 0 ? uptrend : downtrend
          if (!i) continue
        }
        sd.outputMap = {}
        sd.outputMap['Trend ' + sd.name] = 'Trend'
      }

      /**
       * Ensures that symbols required by a study are loaded by the quotefeed.
       * @param  {CIQ.ChartEngine} stx  The chart engine
       * @param  {object} sd   The study descriptor
       * @param  {array} syms An array of symbols required by the study
       * @param {object} [params] Optional parameters. These are sent to addSeries. See {@link CIQ.ChartEngine#addSeries}.
       * @since  3.0.7 This was a previously private function.
       */
      CIQ.Studies.fetchAdditionalInstruments = function(stx, sd, syms, params) {
        if (!stx.quoteDriver) {
          console.log(
            'CIQ.Studies.fetchAdditionalInstruments: No quotefeed to fetch symbol'
          )
          return
        }
        // sd.chart may not be initialized, so we find it the hard way
        var chart = stx.panels[sd.panel].chart

        // We'll remember which symbols we have set so that we can delete them later
        sd.symbols = syms

        var i, symbol, symbolObject
        // Add entries for the symbols we need. If those symbols already exist, add the study name as a dependency
        function addSeriesCB() {
          stx.createDataSet()
          stx.draw()
        }
        for (i = 0; i < syms.length; i++) {
          symbol = symbolObject = syms[i]
          if (typeof symbolObject == 'object') {
            symbol = symbolObject.symbol
          } else {
            symbolObject = { symbol: symbol }
          }
          var parameters = {
            symbol: symbol,
            symbolObject: symbolObject,
            bucket: 'study',
            studyName: sd.name,
            chartName: chart.name,
            action: 'add-study',
          }
          CIQ.extend(parameters, params)
          sd.series = stx.addSeries(null, parameters, addSeriesCB)
        }
      }

      /**
       * Initializes data for Price Relative Study by fetching the comparing symbol.
       *
       * @param {CIQ.ChartEngine} stx    The chart object
       * @param {string} type Study type
       * @param {object} inputs Study inputs
       * @param {object} outputs Study outputs
       * @param {object} parameters Study parameters
       * @param {string} panel ID of the study's panel element
       * @return {studyDescriptor} Study descriptor object
       * @memberOf CIQ.Studies
       * @version ChartIQ Advanced Package
       * @since 09-2016-19
       */
      CIQ.Studies.initPriceRelative = function(
        stx,
        type,
        inputs,
        outputs,
        parameters,
        panel
      ) {
        var sd = CIQ.Studies.initializeFN(
          stx,
          type,
          inputs,
          outputs,
          parameters,
          panel
        )
        var syms = [sd.inputs['Comparison Symbol'].toUpperCase()]

        CIQ.Studies.fetchAdditionalInstruments(stx, sd, syms)
        return sd
      }

      /**
       * Calculates data for Price Relative Study
       *
       * @param  {CIQ.ChartEngine} stx    The chart object
       * @param  {object} sd    The study descriptor object
       * @memberOf CIQ.Studies
       * @version ChartIQ Advanced Package
       */
      CIQ.Studies.calculatePriceRelative = function(stx, sd) {
        var quotes = sd.chart.scrubbed
        var cSym = sd.inputs['Comparison Symbol'].toUpperCase()
        if (!cSym) cSym = sd.study.inputs['Comparison Symbol']

        var map = {}
        var mainSymbol = stx.chart.symbol.replace(/=/, '')
        mainSymbol = mainSymbol.replace(/[+\-*\\%]/g, '')
        map[mainSymbol] = quotes.slice(sd.startFrom)
        if (!map[mainSymbol].length) return
        if (mainSymbol != cSym) map[cSym] = null
        var results = CIQ.computeEquationChart(
          '[' + mainSymbol + ']/[' + cSym + ']',
          map
        )
        var rIter = 0
        for (
          var i = sd.startFrom;
          i < quotes.length && rIter < results.length;
          i++
        ) {
          while (
            rIter < results.length &&
            quotes[i].DT.getTime() > results[rIter].DT.getTime()
          )
            rIter++
          if (quotes[i].DT.getTime() < results[rIter].DT.getTime()) continue
          quotes[i]['Result ' + sd.name] = results[rIter].Close
          rIter++
        }
      }

      CIQ.Studies.calculatePerformance = function(stx, sd) {
        var quotes = sd.chart.scrubbed
        var cSym = sd.inputs['Comparison Symbol'].toUpperCase()
        if (!cSym) cSym = sd.study.inputs['Comparison Symbol']
        if (!sd.days) sd.days = sd.study.inputs.Period
        if (quotes.length < sd.days + 1) {
          sd.error = true
          return
        }

        CIQ.Studies.MA('ma', sd.days, 'Close', 0, '_MA Base', stx, sd)
        CIQ.Studies.MA('ma', sd.days, cSym, 0, '_MA Comp', stx, sd)
        for (var i = sd.startFrom; i < quotes.length; i++) {
          var cSymQ = quotes[i][cSym]
          if (cSymQ && (cSymQ.Close || cSymQ.Close === 0)) cSymQ = cSymQ.Close
          quotes[i]['Result ' + sd.name] =
            (quotes[i].Close / cSymQ) *
            (quotes[i]['_MA Comp ' + sd.name] /
              quotes[i]['_MA Base ' + sd.name])
        }
      }

      CIQ.Studies.calculateBeta = function(stx, sd) {
        var quotes = sd.chart.scrubbed
        var cSym = sd.inputs['Comparison Symbol'].toUpperCase()
        if (!cSym) cSym = sd.study.inputs['Comparison Symbol']
        if (!sd.days) sd.days = sd.study.inputs.Period
        if (quotes.length < sd.days + 1) {
          sd.error = true
          return
        }

        for (var i = Math.max(sd.startFrom, 1); i < quotes.length; i++) {
          quotes[i]['_BaseChange ' + sd.name] =
            quotes[i].Close / quotes[i - 1].Close - 1
          var cSymQ = quotes[i][cSym]
          if (cSymQ && (cSymQ.Close || cSymQ.Close === 0)) cSymQ = cSymQ.Close
          var cSymQ1 = quotes[i - 1][cSym]
          if (cSymQ1 && (cSymQ1.Close || cSymQ1.Close === 0))
            cSymQ1 = cSymQ1.Close
          quotes[i]['_CompChange ' + sd.name] = cSymQ / cSymQ1 - 1
        }
        CIQ.Studies.MA(
          'ma',
          sd.days,
          '_BaseChange ' + sd.name,
          0,
          '_MA Base',
          stx,
          sd
        )
        CIQ.Studies.MA(
          'ma',
          sd.days,
          '_CompChange ' + sd.name,
          0,
          '_MA Comp',
          stx,
          sd
        )
        for (i = Math.max(sd.startFrom, sd.days); i < quotes.length; i++) {
          quotes[i]['_COVARn ' + sd.name] =
            (quotes[i]['_BaseChange ' + sd.name] -
              quotes[i]['_MA Base ' + sd.name]) *
            (quotes[i]['_CompChange ' + sd.name] -
              quotes[i]['_MA Comp ' + sd.name])
          quotes[i]['_VARn ' + sd.name] = Math.pow(
            quotes[i]['_CompChange ' + sd.name] -
              quotes[i]['_MA Comp ' + sd.name],
            2
          )
        }
        CIQ.Studies.MA(
          'ma',
          sd.days,
          '_COVARn ' + sd.name,
          0,
          '_COVAR',
          stx,
          sd
        )
        CIQ.Studies.MA('ma', sd.days, '_VARn ' + sd.name, 0, '_VAR', stx, sd)
        for (
          i = Math.max(sd.startFrom, sd.days * 2 - 1);
          i < quotes.length;
          i++
        ) {
          quotes[i]['Result ' + sd.name] =
            quotes[i]['_COVAR ' + sd.name] / quotes[i]['_VAR ' + sd.name]
        }
      }

      CIQ.Studies.calculateVortex = function(stx, sd) {
        var quotes = sd.chart.scrubbed
        var period = sd.days
        if (quotes.length < period + 1) {
          sd.error = true
          return
        }
        var total = { tr: 0, vmPlus: 0, vmMinus: 0 }
        if (sd.startFrom > 1) {
          total = CIQ.clone(quotes[sd.startFrom - 1]['_totals ' + sd.name])
        }
        for (var i = Math.max(sd.startFrom, 1); i < quotes.length; i++) {
          var prices = quotes[i]
          var pd = quotes[i - 1]
          var vmPlus = Math.abs(prices.High - pd.Low)
          var vmMinus = Math.abs(prices.Low - pd.High)
          var trueRange =
            Math.max(prices.High, pd.Close) - Math.min(prices.Low, pd.Close)
          total.tr += trueRange
          total.vmPlus += vmPlus
          total.vmMinus += vmMinus
          if (i > period) {
            total.tr -= quotes[i - period]['_True Range ' + sd.name]
            total.vmPlus -= quotes[i - period]['_VMPlus ' + sd.name]
            total.vmMinus -= quotes[i - period]['_VMMinus ' + sd.name]
          }
          prices['_True Range ' + sd.name] = trueRange
          prices['_VMPlus ' + sd.name] = vmPlus
          prices['_VMMinus ' + sd.name] = vmMinus
          if (i >= period) {
            prices['+VI ' + sd.name] = total.vmPlus / total.tr
            prices['-VI ' + sd.name] = total.vmMinus / total.tr
          }
          prices['_totals ' + sd.name] = CIQ.clone(total)
        }
      }

      CIQ.Studies.calculateBalanceOfPower = function(stx, sd) {
        var quotes = sd.chart.scrubbed
        if (quotes.length < sd.days + 1) {
          sd.error = true
          return
        }
        for (var i = sd.startFrom; i < quotes.length; i++) {
          var quote = quotes[i]
          quote['_Ratio ' + sd.name] = quote.Close - quote.Open
          if (quote['_Ratio ' + sd.name] !== 0)
            // avoid division by zero
            quote['_Ratio ' + sd.name] /= quote.High - quote.Low
        }
        CIQ.Studies.MA(
          sd.inputs['Moving Average Type'],
          sd.days,
          '_Ratio ' + sd.name,
          0,
          'Result',
          stx,
          sd
        )
      }

      CIQ.Studies.calculateTrendIntensity = function(stx, sd) {
        var quotes = sd.chart.scrubbed
        if (quotes.length < sd.days + 1) {
          sd.error = true
          return
        }
        var field = sd.inputs.Field
        if (!field || field == 'field') field = 'Close'

        function computeTII(gain, loss) {
          if (Math.abs(loss) < 0.00000001) return 100
          return 100 - 100 / (1 + gain / loss)
        }
        CIQ.Studies.MA('ma', sd.days, field, 0, '_SMA', stx, sd)
        var gain = 0,
          loss = 0,
          i,
          change,
          queue = [],
          maxLength = Math.ceil(sd.days / 2)
        for (
          i = Math.max(0, sd.startFrom - maxLength);
          i < quotes.length;
          i++
        ) {
          if (
            !quotes[i]['_SMA ' + sd.name] &&
            quotes[i]['_SMA ' + sd.name] !== 0
          )
            continue
          change = quotes[i][field] - quotes[i]['_SMA ' + sd.name]
          if (change < 0) loss += change * -1
          else gain += change
          queue.push(change)
          if (queue.length > maxLength) {
            change = queue.shift()
            if (change < 0) loss -= change * -1
            else gain -= change
          }
          if (i < sd.startFrom) continue
          quotes[i]['TII ' + sd.name] = computeTII(gain, loss)
        }
        CIQ.Studies.MA(
          'ema',
          sd.inputs['Signal Period'],
          'TII ' + sd.name,
          0,
          'Signal',
          stx,
          sd
        )
        sd.zoneOutput = 'TII'
      }

      // Note: this study expects createDataSet to be called when changing the chart type!
      CIQ.Studies.calculateZigZag = function(stx, sd) {
        var quotes = sd.chart.scrubbed
        if (!quotes || !quotes.length) return
        var highLowChart = sd.highLowChart
        function fillBetweenPoints(start, end) {
          for (var i = start + 1; i < end; i++) {
            quotes[i]['ShadowResult ' + sd.name] =
              ((quotes[end]['Result ' + sd.name] -
                quotes[start]['Result ' + sd.name]) *
                (i - start)) /
                (end - start) +
              quotes[start]['Result ' + sd.name]
            delete quotes[i]['Result ' + sd.name]
          }
        }
        var ll = null,
          hh = null
        var distance = sd.inputs['Distance(%)']
        var direction = 0
        var bar = 0
        var previousBar = 0
        var zig = null,
          zag = null
        var start = 0
        for (var b = Math.min(quotes.length - 1, sd.startFrom); b >= 0; b--) {
          start = b
          if (quotes[b]['_state ' + sd.name]) {
            var state = quotes[b]['_state ' + sd.name]
            //[ll,hh,direction,bar,previousBar,zig,zag]
            ll = state[0]
            hh = state[1]
            direction = state[2]
            bar = state[3]
            previousBar = state[4]
            zig = state[5]
            zag = state[6]
            break
          }
        }
        for (var i = start; i < quotes.length; i++) {
          var thisHigh = quotes[i][highLowChart ? 'High' : 'Close']
          var thisLow = quotes[i][highLowChart ? 'Low' : 'Close']
          if (hh === null || hh < thisHigh) {
            hh = thisHigh
            if (direction < 0) ll = thisLow
            zig = (1 - distance / 100) * hh
            if (direction > -1) {
              if (zag !== null && hh > zag) {
                quotes[bar]['Result ' + sd.name] =
                  quotes[bar][highLowChart ? 'Low' : 'Close']
                fillBetweenPoints(previousBar, bar)
                direction = -1
                ll = thisLow
                previousBar = bar
                bar = i
                continue
              }
            } else {
              bar = i
            }
          }
          if (ll === null || ll > thisLow) {
            ll = thisLow
            if (direction > 0) hh = thisHigh
            zag = (1 + distance / 100) * ll
            if (direction < 1) {
              if (zig !== null && ll < zig) {
                quotes[bar]['Result ' + sd.name] =
                  quotes[bar][highLowChart ? 'High' : 'Close']
                fillBetweenPoints(previousBar, bar)
                direction = 1
                hh = thisHigh
                previousBar = bar
                bar = i
                continue
              }
            } else {
              bar = i
            }
          }
        }
        quotes[bar]['Result ' + sd.name] =
          quotes[bar][
            highLowChart ? (direction == 1 ? 'Low' : 'High') : 'Close'
          ]
        quotes[bar]['_state ' + sd.name] = [
          ll,
          hh,
          direction,
          bar,
          previousBar,
          zig,
          zag,
        ]
        fillBetweenPoints(previousBar, bar)
        quotes[quotes.length - 1]['Result ' + sd.name] =
          quotes[quotes.length - 1][
            highLowChart ? (direction == 1 ? 'High' : 'Low') : 'Close'
          ]
        fillBetweenPoints(bar, quotes.length - 1)
      }

      CIQ.Studies.calculatePsychologicalLine = function(stx, sd) {
        var quotes = sd.chart.scrubbed
        if (quotes.length < sd.days + 1) {
          sd.error = true
          return
        }
        var array = []
        var increment = 100 / sd.days
        var accum = 0
        for (
          var i = Math.max(sd.startFrom - sd.days, 1);
          i < quotes.length;
          i++
        ) {
          var up = Number(quotes[i].Close > quotes[i - 1].Close)
          if (up) accum += increment
          array.push(up)
          if (array.length > sd.days) accum -= array.shift() * increment
          if (i < sd.startFrom) continue
          quotes[i]['Result ' + sd.name] = accum
        }
      }

      CIQ.Studies.calculateMADev = function(stx, sd) {
        var quotes = sd.chart.scrubbed
        if (quotes.length < sd.days + 1) {
          sd.error = true
          return
        }
        var field = sd.inputs.Field
        if (!field || field == 'field') field = 'Close'
        var pts = sd.inputs['Points Or Percent']
        if (!pts) pts = 'Points'
        var maType = sd.inputs['Moving Average Type']
        if (!maType) maType = 'exponential'
        CIQ.Studies.MA(maType, sd.days, field, 0, '_MA', stx, sd)
        var histogram = sd.name + '_hist'
        for (
          var i = Math.max(sd.startFrom, sd.days - 1);
          i < quotes.length;
          i++
        ) {
          var quote = quotes[i]
          if (pts == 'Points')
            quote[histogram] = quote[field] - quote['_MA ' + sd.name]
          else
            quote[histogram] =
              100 * (quote[field] / quote['_MA ' + sd.name] - 1)
        }
      }

      CIQ.Studies.calculateShinohara = function(stx, sd) {
        var quotes = sd.chart.scrubbed
        if (quotes.length < sd.days + 1) {
          sd.error = true
          return
        }
        var accums = {
          weakNum: 0,
          weakDen: 0,
          strongNum: 0,
          strongDen: 0,
        }
        if (sd.startFrom > 1) {
          accums = CIQ.clone(quotes[sd.startFrom - 1]['_accums ' + sd.name])
        }
        for (var i = sd.startFrom; i < quotes.length; i++) {
          accums.weakNum += quotes[i].High - quotes[i].Close
          accums.weakDen += quotes[i].Close - quotes[i].Low
          if (i > 0) {
            accums.strongNum += quotes[i].High - quotes[i - 1].Close
            accums.strongDen += quotes[i - 1].Close - quotes[i].Low
          }
          if (i >= sd.days) {
            accums.weakNum -=
              quotes[i - sd.days].High - quotes[i - sd.days].Close
            accums.weakDen -=
              quotes[i - sd.days].Close - quotes[i - sd.days].Low
            quotes[i]['Weak Ratio ' + sd.name] =
              (100 * accums.weakNum) / accums.weakDen
            if (i > sd.days) {
              accums.strongNum -=
                quotes[i - sd.days].High - quotes[i - sd.days - 1].Close
              accums.strongDen -=
                quotes[i - sd.days - 1].Close - quotes[i - sd.days].Low
              quotes[i]['Strong Ratio ' + sd.name] =
                (100 * accums.strongNum) / accums.strongDen
            }
          }
          quotes[i]['_accums ' + sd.name] = CIQ.clone(accums)
        }
      }

      CIQ.Studies.calculateIchimoku = function(stx, sd) {
        var quotes = sd.chart.scrubbed
        var periods = {
          Base: Number(sd.inputs['Base Line Period']),
          Conv: Number(sd.inputs['Conversion Line Period']),
          LeadB: Number(sd.inputs['Leading Span B Period']),
          Lag: Number(sd.inputs['Lagging Span Period']),
        }

        function getLLVHHV(p, x) {
          var l = Number.MAX_VALUE,
            h = Number.MAX_VALUE * -1
          for (var j = x - p + 1; j <= x; j++) {
            if (j < 0) continue
            l = Math.min(l, quotes[j].Low)
            h = Math.max(h, quotes[j].High)
          }
          return [l, h]
        }

        var i, hl
        for (i = sd.startFrom; i < quotes.length; i++) {
          if (!quotes[i]) continue

          hl = getLLVHHV(periods.Conv, i)
          quotes[i]['Conversion Line ' + sd.name] = (hl[1] + hl[0]) / 2

          hl = getLLVHHV(periods.Base, i)
          quotes[i]['Base Line ' + sd.name] = (hl[1] + hl[0]) / 2

          if (i < periods.Lag) continue
          quotes[i - periods.Lag]['Lagging Span ' + sd.name] = quotes[i].Close
        }
        sd.futureA = []
        sd.futureB = []
        for (
          i = Math.max(0, sd.startFrom - periods.Base);
          i < quotes.length;
          i++
        ) {
          hl = getLLVHHV(periods.LeadB, i)
          var lsa =
            (quotes[i]['Conversion Line ' + sd.name] +
              quotes[i]['Base Line ' + sd.name]) /
            2
          var lsb = (hl[1] + hl[0]) / 2
          if (quotes[i + periods.Base]) {
            quotes[i + periods.Base]['Leading Span A ' + sd.name] = lsa
            quotes[i + periods.Base]['Leading Span B ' + sd.name] = lsb
          } else {
            sd.futureA.push(lsa)
            sd.futureB.push(lsb)
          }
        }
      }

      CIQ.Studies.displayIchimoku = function(stx, sd, quotes) {
        var topBand = 'Leading Span A ' + sd.name,
          bottomBand = 'Leading Span B ' + sd.name
        var topColor = CIQ.Studies.determineColor(
          sd.outputs[sd.outputMap[topBand]]
        )
        var bottomColor = CIQ.Studies.determineColor(
          sd.outputs[sd.outputMap[bottomBand]]
        )
        var parameters = {
          topBand: topBand,
          bottomBand: bottomBand,
          topColor: topColor,
          bottomColor: bottomColor,
          skipTransform: stx.panels[sd.panel].name != sd.chart.name,
        }
        CIQ.fillIntersecting(stx, sd.panel, parameters)

        function fillFutureCloud(points, isUp) {
          var fParams = {
            color:
              isUp === false ? bottomColor : isUp ? topColor : 'transparent',
            opacity: 0.3,
            panelName: sd.panel,
          }
          CIQ.fillArea(stx, points, fParams)
          stx.endClip()
        }

        var panel = stx.panels[sd.panel]
        var xInit = stx.pixelFromBar(quotes.length - 1, panel.chart)
        var ayInit = stx.pixelFromPrice(
          quotes[quotes.length - 1][topBand],
          panel
        )
        var byInit = stx.pixelFromPrice(
          quotes[quotes.length - 1][bottomBand],
          panel
        )
        var cloud = [[xInit, byInit], [xInit, ayInit]],
          isUpCloud = null

        var futureA = sd.futureA,
          futureB = sd.futureB
        if (sd.chart.dataSegment.length >= sd.chart.scroll) {
          for (var i = 0; futureA && i < futureA.length - 1; i++) {
            if (
              futureA[i] === null ||
              isNaN(futureA[i]) ||
              futureB[i] === null ||
              isNaN(futureB[i])
            )
              continue
            var x1 = stx.pixelFromBar(quotes.length + i, panel.chart)
            var x2 = stx.pixelFromBar(quotes.length + i + 1, panel.chart)
            var ay1 = stx.pixelFromPrice(futureA[i], panel)
            var ay2 = stx.pixelFromPrice(futureA[i + 1], panel)
            var by1 = stx.pixelFromPrice(futureB[i], panel)
            var by2 = stx.pixelFromPrice(futureB[i + 1], panel)
            cloud.push([x1, ay1])
            cloud.unshift([x1, by1])
            isUpCloud = ay1 < by1
            if ((isUpCloud && ay2 > by2) || (!isUpCloud && ay2 < by2)) {
              var interX = CIQ.intersectLineLineX(
                x1,
                x2,
                ay1,
                ay2,
                x1,
                x2,
                by1,
                by2
              )
              var interY = CIQ.intersectLineLineY(
                x1,
                x2,
                ay1,
                ay2,
                x1,
                x2,
                by1,
                by2
              )
              cloud.push([interX, interY])
              fillFutureCloud(cloud, isUpCloud)
              cloud = [[interX, interY]]
              isUpCloud = null
            }
          }
          if (cloud.length > 2) fillFutureCloud(cloud, isUpCloud)
        }
        CIQ.Studies.displaySeriesAsLine(stx, sd, quotes)
      }

      CIQ.Studies.displayDarvas = function(stx, sd, quotes) {
        var levelsColor = sd.outputs.Levels
        if (
          !levelsColor ||
          levelsColor == 'auto' ||
          CIQ.isTransparent(levelsColor)
        )
          levelsColor = stx.defaultColor
        var darvasColor = sd.outputs.Darvas
        if (
          !darvasColor ||
          darvasColor == 'auto' ||
          CIQ.isTransparent(darvasColor)
        )
          darvasColor = stx.defaultColor
        var ghostColor = sd.outputs.Ghost
        if (
          !ghostColor ||
          ghostColor == 'auto' ||
          CIQ.isTransparent(ghostColor)
        )
          ghostColor = stx.defaultColor

        var panel = stx.panels[sd.panel]
        var i, q
        var slyh1, slyl1
        var myWidth = stx.layout.candleWidth - 2
        if (myWidth < 2) myWidth = 1
        stx.startClip(sd.panel)
        if (sd.inputs['Stop Levels']) {
          if (stx.chart.context.setLineDash) {
            stx.chart.context.setLineDash([2, 2])
          }
          stx.chart.context.lineWidth = 2
          stx.chart.context.strokeStyle = levelsColor
          /*  Don't display the take profit levels
			stx.chart.context.beginPath();
			for(i=0;i<quotes.length;i++){
				q=quotes[i];
				q1=quotes[i-1];
				if(!q) continue;
				slyh1=q["Profit "+sd.name]?Math.floor(stx.pixelFromPrice(q["Profit "+sd.name], panel)):null;
				var slyh0=q1 && q1["Profit "+sd.name]?Math.floor(stx.pixelFromPrice(q1["Profit "+sd.name], panel)):null;
				if(slyh1){
					if(q.candleWidth) myWidth=Math.floor(Math.max(1,q.candleWidth));
					var slxh1=Math.floor(stx.pixelFromBar(i, panel.chart)+myWidth/2);
					var slxh0=Math.floor(stx.pixelFromBar(i, panel.chart)-myWidth/2);
					if(slyh0) stx.chart.context.lineTo(slxh0,slyh1);
					else if(i===0) stx.chart.context.moveTo(stx.chart.left,slyh1);
					else stx.chart.context.moveTo(slxh0,slyh1);
					stx.chart.context.lineTo(slxh1,slyh1);
				}
			}
			stx.chart.context.stroke();
			*/
          stx.chart.context.beginPath()
          for (i = 0; i < quotes.length; i++) {
            q = quotes[i]
            var q1 = quotes[i - 1]
            if (!q) continue
            slyl1 = q['Loss ' + sd.name]
              ? Math.floor(stx.pixelFromPrice(q['Loss ' + sd.name], panel))
              : null
            var slyl0 =
              q1 && q1['Loss ' + sd.name]
                ? Math.floor(stx.pixelFromPrice(q1['Loss ' + sd.name], panel))
                : null
            if (slyl1) {
              if (q.candleWidth)
                myWidth = Math.floor(Math.max(1, q.candleWidth))
              var slxl1 = Math.floor(
                stx.pixelFromBar(i, panel.chart) + myWidth / 2
              )
              var slxl0 = Math.floor(
                stx.pixelFromBar(i, panel.chart) - myWidth / 2
              )
              if (slyl0 && slyl0 >= slyl1)
                stx.chart.context.lineTo(slxl0, slyl1)
              else if (i === 0) stx.chart.context.moveTo(stx.chart.left, slyl1)
              else stx.chart.context.moveTo(slxl0, slyl1)
              stx.chart.context.lineTo(slxl1, slyl1)
            }
          }
          stx.chart.context.stroke()
          if (stx.chart.context.setLineDash) {
            stx.chart.context.setLineDash([])
          }
          stx.chart.context.lineWidth = 1
        }
        var dx = -10,
          dy,
          dw = 0,
          dh,
          gx = -10,
          gy,
          gw = 0,
          gh
        var inDarvas = false,
          inGhost = false
        var signalWidth = stx.chart.context.measureText('\u25B2').width / 2
        for (i = 0; i < quotes.length; i++) {
          if (!quotes[i]) continue
          if (quotes[i]['Spike ' + sd.name]) {
            stx.chart.context.fillStyle = darvasColor
            stx.chart.context.textBaseline = 'bottom'
            var y = stx.pixelFromPrice(quotes[i].High, stx.chart.panel)
            stx.chart.context.fillText(
              '\u25BC',
              stx.pixelFromBar(i) - signalWidth,
              y - 5
            ) // down arrow
          }

          if (quotes[i].candleWidth)
            myWidth = Math.floor(Math.max(1, quotes[i].candleWidth))
          if (quotes[i]['Darvas ' + sd.name]) {
            q = quotes[i]['Darvas ' + sd.name]
            if (q.State == 1 && !inDarvas) {
              dx = Math.floor(stx.pixelFromBar(i, panel.chart) - myWidth / 2)
              dy = Math.floor(stx.pixelFromPrice(q.High, panel))
              dh = Math.floor(stx.pixelFromPrice(q.Low, panel)) - dy
              inDarvas = true
            } else if (q.State === 0) {
              dw =
                Math.floor(stx.pixelFromBar(i, panel.chart) + myWidth / 2) - dx
              dy = Math.floor(stx.pixelFromPrice(q.High, panel))
              dh = Math.floor(stx.pixelFromPrice(q.Low, panel)) - dy
              stx.chart.context.strokeStyle = darvasColor
              stx.chart.context.fillStyle = darvasColor
              if (!sd.inputs['Stop Levels']) {
                stx.chart.context.strokeRect(dx, dy, dw, dh)
                stx.chart.context.globalAlpha = 0.2
              } else {
                stx.chart.context.globalAlpha = 0.3
              }
              stx.chart.context.fillRect(dx, dy, dw, dh)
              stx.chart.context.globalAlpha = 1
              inDarvas = false
            }
          }
          if (quotes[i]['Ghost ' + sd.name] && sd.inputs['Ghost Boxes']) {
            q = quotes[i]['Ghost ' + sd.name]
            if (q.State == 1 && !inGhost) {
              gx = Math.floor(stx.pixelFromBar(i, panel.chart) - myWidth / 2)
              gy = Math.floor(stx.pixelFromPrice(q.High, panel))
              gw = Math.floor(
                (q.End - q.Start + 1) * stx.layout.candleWidth + myWidth / 2
              )
              gh = Math.floor(stx.pixelFromPrice(q.Low, panel)) - gy
              inGhost = true
            } else if (q.State === 0) {
              if (q.Start == q.End)
                gx = Math.floor(stx.pixelFromBar(i, panel.chart) - myWidth / 2)
              gw =
                Math.floor(stx.pixelFromBar(i, panel.chart) + myWidth / 2) - gx
              gy = Math.floor(stx.pixelFromPrice(q.High, panel))
              gh = Math.floor(stx.pixelFromPrice(q.Low, panel)) - gy
              stx.chart.context.strokeStyle = ghostColor
              stx.chart.context.fillStyle = ghostColor
              if (!sd.inputs['Stop Levels']) {
                stx.chart.context.strokeRect(gx, gy, gw, gh)
                stx.chart.context.globalAlpha = 0.2
              } else {
                stx.chart.context.globalAlpha = 0.3
              }
              stx.chart.context.fillRect(gx, gy, gw, gh)
              stx.chart.context.globalAlpha = 1
              inGhost = false
            }
          }
        }
        if (inDarvas) {
          dw = Math.floor(stx.pixelFromBar(i, panel.chart) + myWidth / 2) - dx
          stx.chart.context.strokeStyle = darvasColor
          stx.chart.context.fillStyle = darvasColor
          if (!sd.inputs['Stop Levels']) {
            stx.chart.context.beginPath()
            stx.chart.context.moveTo(dx + 2 * dw, dy)
            stx.chart.context.lineTo(dx, dy)
            stx.chart.context.lineTo(dx, dy + dh)
            stx.chart.context.lineTo(dx + 2 * dw, dy + dh)
            stx.chart.context.stroke()
            stx.chart.context.globalAlpha = 0.2
          } else {
            stx.chart.context.globalAlpha = 0.3
          }
          stx.chart.context.fillRect(dx, dy, 2 * dw, dh)
          stx.chart.context.globalAlpha = 1
        }
        if (inGhost) {
          stx.chart.context.strokeStyle = ghostColor
          stx.chart.context.fillStyle = ghostColor
          if (!sd.inputs['Stop Levels']) {
            stx.chart.context.strokeRect(gx, gy, gw, gh)
            stx.chart.context.globalAlpha = 0.2
          } else {
            stx.chart.context.globalAlpha = 0.3
          }
          stx.chart.context.fillRect(gx, gy, gw, gh)
          stx.chart.context.globalAlpha = 1
        }
        if (inDarvas || inGhost) {
          if (sd.inputs['Stop Levels']) {
            if (stx.chart.context.setLineDash) {
              stx.chart.context.setLineDash([2, 2])
            }
            stx.chart.context.lineWidth = 2
            stx.chart.context.strokeStyle = levelsColor
            var x = Math.floor(
              stx.pixelFromBar(i - 1, panel.chart) + myWidth / 2
            )
            if (slyh1) {
              stx.chart.context.beginPath()
              stx.chart.context.moveTo(x, slyh1)
              stx.chart.context.lineTo(inDarvas ? dx + 2 * dw : gx + gw, slyh1)
              stx.chart.context.stroke()
            }
            if (slyl1) {
              stx.chart.context.beginPath()
              stx.chart.context.moveTo(x, slyl1)
              stx.chart.context.lineTo(inDarvas ? dx + 2 * dw : gx + gw, slyl1)
              stx.chart.context.stroke()
            }
            if (stx.chart.context.setLineDash) {
              stx.chart.context.setLineDash([])
            }
            stx.chart.context.lineWidth = 1
          }
          inDarvas = false
          inGhost = false
        }
        stx.endClip()
      }

      CIQ.Studies.displaySupertrend = function(stx, sd, quotes) {
        var panel = stx.panels[sd.panel]
        function colorFunction(stx, quote, mode) {
          if (quote && quote['_Direction ' + sd.name] < 0)
            return sd.outputs.Downtrend
          return sd.outputs.Uptrend
        }
        var params = { skipProjections: true, label: stx.preferences.labels }
        var context = stx.chart.context
        context.strokeStyle = colorFunction(stx, quotes[quotes.length - 1])
        context.lineWidth = 2
        if (sd.highlight) context.lineWidth = 3
        var trendName = 'Trend ' + sd.name
        for (var x = 0; panel.chart.transformFunc && x < quotes.length; x++) {
          var q = quotes[x]
          if (q && q.transform) {
            q.transform[trendName] = panel.chart.transformFunc(
              stx,
              panel.chart,
              q[trendName]
            )
          }
        }
        stx.plotDataSegmentAsLine(trendName, panel, params, colorFunction)
        context.lineWidth = 1

        stx.startClip(sd.panel)
        var signalWidth = stx.chart.context.measureText('\u25B2').width / 2
        var i
        for (i = 0; i < quotes.length; i++) {
          if (!quotes[i] || !quotes[i - 1]) continue
          if (
            quotes[i - 1]['_Direction ' + sd.name] >
            quotes[i]['_Direction ' + sd.name]
          ) {
            stx.chart.context.fillStyle = sd.outputs.Downtrend
            stx.chart.context.textBaseline = 'bottom'
            var yh = stx.pixelFromPrice(quotes[i].High, stx.chart.panel)
            for (var d = 5; d <= 45; d += 10)
              stx.chart.context.fillText(
                '\u25BC',
                stx.pixelFromBar(i) - signalWidth,
                yh - d
              ) // down arrow
          } else if (
            quotes[i - 1]['_Direction ' + sd.name] <
            quotes[i]['_Direction ' + sd.name]
          ) {
            stx.chart.context.fillStyle = sd.outputs.Uptrend
            stx.chart.context.textBaseline = 'top'
            var yl = stx.pixelFromPrice(quotes[i].Low, stx.chart.panel)
            for (var u = 5; u <= 45; u += 10)
              stx.chart.context.fillText(
                '\u25B2',
                stx.pixelFromBar(i) - signalWidth,
                yl + u
              ) // up arrow
          }
        }
        stx.endClip()
      }

      CIQ.Studies.displayVsComparisonSymbol = function(stx, sd, quotes) {
        var symbol = sd.inputs['Comparison Symbol'].toUpperCase()
        if (!stx.getSeries({ symbol: symbol, chart: sd.chart }).length) {
          stx.watermark(
            sd.panel,
            'center',
            'bottom',
            stx.translateIf(sd.study.name + ' Not Available')
          )
          return
        }
        var params = {
          skipTransform: stx.panels[sd.panel].name != sd.chart.name,
          panelName: sd.panel,
          band: 'Result ' + sd.name,
          threshold: sd.study.centerline,
        }
        for (var c = quotes.length - 1; c >= 0; c--) {
          if (quotes[c] && quotes[c][symbol]) {
            CIQ.Studies.displaySeriesAsLine(stx, sd, quotes)
            if (sd.study.centerline || sd.study.centerline === 0) {
              if (sd.outputs.Gain)
                CIQ.preparePeakValleyFill(
                  stx,
                  CIQ.extend(params, { direction: 1, color: sd.outputs.Gain })
                )
              if (sd.outputs.Loss)
                CIQ.preparePeakValleyFill(
                  stx,
                  CIQ.extend(params, { direction: -1, color: sd.outputs.Loss })
                )
            }
            return
          }
        }
      }

      CIQ.Studies.displayMFI = function(stx, sd, quotes) {
        var panel = stx.panels[sd.panel]
        panel.yAxis.min = 0
        //CIQ.Studies.determineMinMax(stx, sd, quotes);
        CIQ.Studies.displaySeriesAsLine(stx, sd, quotes)

        var y = panel.yAxis.bottom

        var myWidth = stx.layout.candleWidth - 2
        if (myWidth < 2) myWidth = 1

        var green = sd.outputs.Green
        var fade = sd.outputs.Fade
        var fake = sd.outputs.Fake
        var squat = sd.outputs.Squat
        stx.canvasColor('stx_histogram')
        stx.chart.context.globalAlpha = 1
        stx.chart.context.fillStyle = '#CCCCCC'
        stx.startClip(sd.panel)
        for (var i = 0; i < quotes.length; i++) {
          var quote = quotes[i]
          if (!quote || !quotes[i - 1]) continue
          if (i === 0);
          else if (
            quotes[i - 1][sd.name + '_hist'] < quote[sd.name + '_hist']
          ) {
            if (quotes[i - 1].Volume < quote.Volume)
              stx.chart.context.fillStyle = green
            else if (quotes[i - 1].Volume > quote.Volume)
              stx.chart.context.fillStyle = fake
          } else if (
            quotes[i - 1][sd.name + '_hist'] > quote[sd.name + '_hist']
          ) {
            if (quotes[i - 1].Volume < quote.Volume)
              stx.chart.context.fillStyle = squat
            else if (quotes[i - 1].Volume > quote.Volume)
              stx.chart.context.fillStyle = fade
          }
          if (quote.candleWidth)
            myWidth = Math.floor(Math.max(1, quote.candleWidth - 2))
          stx.chart.context.fillRect(
            Math.floor(stx.pixelFromBar(i, panel.chart) - myWidth / 2),
            Math.floor(y),
            Math.floor(myWidth),
            Math.floor(stx.pixelFromPrice(quote[sd.name + '_hist'], panel) - y)
          )
        }
        stx.endClip()
      }

      CIQ.Studies.displayAwesomeOscillator = function(stx, sd, quotes) {
        CIQ.Studies.determineMinMax(stx, sd, quotes)
        var panel = stx.panels[sd.panel]
        panel.yAxis.low = panel.min = Math.min(0, panel.min)
        panel.yAxis.high = panel.max = Math.max(0, panel.max)
        CIQ.Studies.displaySeriesAsLine(stx, sd, quotes)

        var y = stx.pixelFromPrice(0, panel)

        var myWidth = stx.layout.candleWidth - 2
        if (myWidth < 2) myWidth = 1

        var upColor = CIQ.Studies.determineColor(sd.outputs['Increasing Bar'])
        var downColor = CIQ.Studies.determineColor(sd.outputs['Decreasing Bar'])
        stx.canvasColor('stx_histogram')
        stx.chart.context.globalAlpha = 1
        stx.chart.context.fillStyle = '#CCCCCC'
        stx.startClip(sd.panel)
        for (var i = 0; i < quotes.length; i++) {
          var quote = quotes[i]
          if (!quote || !quotes[i - 1]) continue
          if (i === 0);
          else if (quotes[i - 1][sd.name + '_hist'] < quote[sd.name + '_hist'])
            stx.chart.context.fillStyle = upColor
          else if (quotes[i - 1][sd.name + '_hist'] > quote[sd.name + '_hist'])
            stx.chart.context.fillStyle = downColor
          if (quote.candleWidth)
            myWidth = Math.floor(Math.max(1, quote.candleWidth - 2))
          stx.chart.context.fillRect(
            Math.floor(stx.pixelFromBar(i, panel.chart) - myWidth / 2),
            Math.floor(y),
            Math.floor(myWidth),
            Math.floor(stx.pixelFromPrice(quote[sd.name + '_hist'], panel) - y)
          )
        }
        stx.endClip()
      }

      CIQ.Studies.displayGator = function(stx, sd, quotes) {
        CIQ.Studies.determineMinMax(stx, sd, quotes)
        var panel = stx.panels[sd.panel]
        panel.yAxis.low = panel.min = Math.min(0, panel.min)
        panel.yAxis.high = panel.max = Math.max(0, panel.max)
        CIQ.Studies.displaySeriesAsLine(stx, sd, quotes)

        var y = stx.pixelFromPrice(0, panel)

        var myWidth = stx.layout.candleWidth - 2
        if (myWidth < 2) myWidth = 1

        var upColor = CIQ.Studies.determineColor(sd.outputs['Increasing Bar'])
        var downColor = CIQ.Studies.determineColor(sd.outputs['Decreasing Bar'])
        stx.canvasColor('stx_histogram')
        stx.chart.context.globalAlpha = 1
        stx.chart.context.fillStyle = '#CCCCCC'
        stx.startClip(sd.panel)
        for (var i = 1; i < quotes.length; i++) {
          var quote = quotes[i]
          if (!quote || !quotes[i - 1]) continue
          for (var j = 1; j <= 2; j++) {
            if (
              Math.abs(quotes[i - 1][sd.name + '_hist' + j]) <
              Math.abs(quote[sd.name + '_hist' + j])
            )
              stx.chart.context.fillStyle = upColor
            else if (
              Math.abs(quotes[i - 1][sd.name + '_hist' + j]) >
              Math.abs(quote[sd.name + '_hist' + j])
            )
              stx.chart.context.fillStyle = downColor
            if (quote.candleWidth)
              myWidth = Math.floor(Math.max(1, quote.candleWidth - 2))
            stx.chart.context.fillRect(
              Math.floor(stx.pixelFromBar(i, panel.chart) - myWidth / 2),
              Math.floor(y),
              Math.floor(myWidth),
              Math.floor(
                stx.pixelFromPrice(quote[sd.name + '_hist' + j], panel) - y
              )
            )
          }
        }
        stx.endClip()
      }

      CIQ.Studies.initElderImpulse = function(
        stx,
        type,
        inputs,
        outputs,
        parameters,
        panel
      ) {
        var sd = CIQ.Studies.initializeFN(
          stx,
          type,
          inputs,
          outputs,
          parameters,
          panel
        )
        stx.chart.customChart = {
          chartType: 'colored_bar',
          colorFunction: function(stx, quote, mode) {
            return quote['Result ' + sd.name]
          },
        }
        stx.setMainSeriesRenderer()
        return sd
      }

      CIQ.Studies.displayPivotPoints = function(stx, sd, quotes) {
        sd.noSlopes = !sd.inputs.Continuous
        CIQ.Studies.displaySeriesAsLine(stx, sd, quotes)
        if (sd.inputs.Shading) {
          var params = {
            noSlopes: sd.noSlopes,
            opacity: sd.parameters.opacity ? sd.parameters.opacity : 0.2,
            skipTransform: stx.panels[sd.panel].name != sd.chart.name,
          }
          CIQ.prepareChannelFill(
            stx,
            CIQ.extend(
              {
                panelName: sd.panel,
                topBand: 'Resistance 3 ' + sd.name,
                bottomBand: 'Resistance 2 ' + sd.name,
                color: CIQ.Studies.determineColor(sd.outputs['Resistance 3']),
              },
              params
            )
          )
          CIQ.prepareChannelFill(
            stx,
            CIQ.extend(
              {
                panelName: sd.panel,
                topBand: 'Resistance 2 ' + sd.name,
                bottomBand: 'Resistance 1 ' + sd.name,
                color: CIQ.Studies.determineColor(sd.outputs['Resistance 2']),
              },
              params
            )
          )
          CIQ.prepareChannelFill(
            stx,
            CIQ.extend(
              {
                panelName: sd.panel,
                topBand: 'Resistance 1 ' + sd.name,
                bottomBand: 'Pivot ' + sd.name,
                color: CIQ.Studies.determineColor(sd.outputs['Resistance 1']),
              },
              params
            )
          )
          CIQ.prepareChannelFill(
            stx,
            CIQ.extend(
              {
                panelName: sd.panel,
                topBand: 'Support 1 ' + sd.name,
                bottomBand: 'Pivot ' + sd.name,
                color: CIQ.Studies.determineColor(sd.outputs['Support 1']),
              },
              params
            )
          )
          CIQ.prepareChannelFill(
            stx,
            CIQ.extend(
              {
                panelName: sd.panel,
                topBand: 'Support 2 ' + sd.name,
                bottomBand: 'Support 1 ' + sd.name,
                color: CIQ.Studies.determineColor(sd.outputs['Support 2']),
              },
              params
            )
          )
          CIQ.prepareChannelFill(
            stx,
            CIQ.extend(
              {
                panelName: sd.panel,
                topBand: 'Support 3 ' + sd.name,
                bottomBand: 'Support 2 ' + sd.name,
                color: CIQ.Studies.determineColor(sd.outputs['Support 3']),
              },
              params
            )
          )
        }
      }

      CIQ.Studies.displayAlligator = function(stx, sd, quotes) {
        function drawFractal(highLow, index) {
          //stx.canvasFont("???");
          var y
          if (highLow == 'high') {
            stx.chart.context.fillStyle = stx.defaultColor
            stx.chart.context.textBaseline = 'bottom'
            y = stx.pixelFromPrice(quotes[index].High, stx.chart.panel)
            stx.chart.context.fillText(
              '\u25B2',
              stx.pixelFromBar(i, stx.chart) -
                stx.chart.context.measureText('\u25B2').width / 2 +
                1,
              y - 5
            ) // up arrow
          } else if (highLow == 'low') {
            stx.chart.context.fillStyle = stx.defaultColor
            stx.chart.context.textBaseline = 'top'
            y = stx.pixelFromPrice(quotes[index].Low, stx.chart.panel)
            stx.chart.context.fillText(
              '\u25BC',
              stx.pixelFromBar(i, stx.chart) -
                stx.chart.context.measureText('\u25BC').width / 2 +
                1,
              y + 5
            ) // down arrow
          }
        }
        var panel = stx.panels[sd.panel]
        CIQ.Studies.displayIndividualSeriesAsLine(
          stx,
          sd,
          panel,
          'Jaw ' + sd.name,
          quotes
        )
        CIQ.Studies.displayIndividualSeriesAsLine(
          stx,
          sd,
          panel,
          'Lips ' + sd.name,
          quotes
        )
        CIQ.Studies.displayIndividualSeriesAsLine(
          stx,
          sd,
          panel,
          'Teeth ' + sd.name,
          quotes
        )
        if (sd.inputs['Show Fractals']) {
          stx.startClip(sd.panel)
          for (var i = 2; i < quotes.length - 2; i++) {
            if (quotes[i]) {
              if (quotes[i]['Fractal High ' + sd.name]) drawFractal('high', i)
              if (quotes[i]['Fractal Low ' + sd.name]) drawFractal('low', i)
            }
          }
          stx.endClip()
        }
      }

      CIQ.Studies.displayRainbowMA = function(stx, sd, quotes) {
        var panel = stx.panels[sd.panel]
        //just need to display in reverse order from outputMap
        for (var i = 10; i > 0; i--) {
          CIQ.Studies.displayIndividualSeriesAsLine(
            stx,
            sd,
            panel,
            'SMA' + i + ' ' + sd.name,
            quotes
          )
        }
      }

      CIQ.Studies.displayRainbowOsc = function(stx, sd, quotes) {
        //CIQ.Studies.determineMinMax(stx, sd, quotes);
        var panel = stx.panels[sd.panel]
        panel.min = -100
        panel.max = 100
        panel.yAxis.low = panel.min = Math.min(0, panel.min)
        panel.yAxis.high = panel.max = Math.max(0, panel.max)
        CIQ.Studies.displaySeriesAsLine(stx, sd, quotes)
        stx.startClip(sd.panel)
        var y = stx.pixelFromPrice(0, panel)
        stx.plotDataSegmentAsLine('Zero ' + sd.name, panel, {
          noDraw: true,
          skipTransform: true,
          label: false,
        })

        var upColor = CIQ.Studies.determineColor(sd.outputs['Positive Bar'])
        stx.chart.context.strokeStyle = upColor
        stx.plotDataSegmentAsLine('Over ' + sd.name, panel, {
          skipTransform: true,
          label: false,
        })

        var skipTransform = stx.panels[sd.panel].name != sd.chart.name
        var upgradient = stx.chart.context.createLinearGradient(
          0,
          y,
          0,
          panel.yAxis.top
        )
        upgradient.addColorStop(0, stx.containerColor)
        upgradient.addColorStop(1, upColor)
        CIQ.prepareChannelFill(stx, {
          skipTransform: skipTransform,
          color: upgradient,
          opacity: 1,
          panelName: sd.name,
          topBand: 'Over ' + sd.name,
          bottomBand: 'Zero ' + sd.name,
        })

        var downColor = CIQ.Studies.determineColor(sd.outputs['Negative Bar'])
        stx.chart.context.strokeStyle = downColor
        stx.plotDataSegmentAsLine('Under ' + sd.name, panel, {
          skipTransform: true,
          label: false,
        })

        var dngradient = stx.chart.context.createLinearGradient(
          0,
          y,
          0,
          panel.yAxis.bottom
        )
        dngradient.addColorStop(0, stx.containerColor)
        dngradient.addColorStop(1, downColor)
        CIQ.prepareChannelFill(stx, {
          skipTransform: skipTransform,
          color: dngradient,
          opacity: 1,
          panelName: sd.name,
          topBand: 'Zero ' + sd.name,
          bottomBand: 'Under ' + sd.name,
        })

        var myWidth = stx.layout.candleWidth - 2
        if (myWidth < 2) myWidth = 1

        stx.canvasColor('stx_histogram')
        stx.chart.context.globalAlpha = 1
        stx.chart.context.fillStyle = '#CCCCCC'
        for (var i = 0; i < quotes.length; i++) {
          var quote = quotes[i]
          if (!quote) continue
          if (quote[sd.name + '_hist'] > 0)
            stx.chart.context.fillStyle = upColor
          else if (quote[sd.name + '_hist'] < 0)
            stx.chart.context.fillStyle = downColor
          if (quote.candleWidth)
            myWidth = Math.floor(Math.max(1, quote.candleWidth - 2))
          stx.chart.context.fillRect(
            Math.floor(stx.pixelFromBar(i, panel.chart) - myWidth / 2),
            Math.floor(y),
            Math.floor(myWidth),
            Math.floor(stx.pixelFromPrice(quote[sd.name + '_hist'], panel) - y)
          )
        }
        stx.endClip()
      }

      CIQ.Studies.displayZigZag = function(stx, sd, quotes) {
        var highLowBars =
          stx.chart.highLowBars || stx.highLowBars[stx.layout.chartType]
        if (sd.highLowChart != highLowBars) {
          sd.highLowChart = highLowBars
          sd.startFrom = 0
          sd.study.calculateFN(stx, sd)
        }
        var chart = stx.chart
        for (var i = 0; i < quotes.length; i++) {
          if (quotes[i] && quotes[i]['_shadowCopy ' + sd.name]) {
            delete quotes[i]['Result ' + sd.name]
            if (quotes[i].transform)
              delete quotes[i].transform['Result ' + sd.name]
            delete quotes[i]['_shadowCopy ' + sd.name]
          }
        }
        var q0 = quotes[0],
          ql = quotes[quotes.length - 1]
        if (q0 && !q0['Result ' + sd.name] && q0['ShadowResult ' + sd.name]) {
          q0['Result ' + sd.name] = q0['ShadowResult ' + sd.name]
          if (q0.transform)
            q0.transform['Result ' + sd.name] = chart.transformFunc(
              stx,
              chart,
              q0['ShadowResult ' + sd.name]
            )
          q0['_shadowCopy ' + sd.name] = 1
        }
        if (ql && !ql['Result ' + sd.name] && ql['ShadowResult ' + sd.name]) {
          ql['Result ' + sd.name] = ql['ShadowResult ' + sd.name]
          if (ql.transform)
            ql.transform['Result ' + sd.name] = chart.transformFunc(
              stx,
              chart,
              ql['ShadowResult ' + sd.name]
            )
          ql['_shadowCopy ' + sd.name] = 1
        }
        CIQ.Studies.displaySeriesAsLine(stx, sd, quotes)
      }

      /**
       * Creates a volume profile underlay for the chart. The underlay is always 25% of the width of the chart.
       * The color is determined by the 'sd.outputs["Bars Color"]' parameter and opacity and border colors can be controlled with the class stx_volume_profile
       */

      CIQ.Studies.displayVolumeProfile = function(stx, sd, quotes) {
        if (!stx || !stx.chart.dataSet) return

        var chart = stx.chart

        var numberBars = sd.parameters.numberOfBars
        var widthPercentage = sd.parameters.widthPercentage
        var displayBorder = sd.parameters.displayBorder
        var displayVolume = sd.parameters.displayVolume
        //set defaults
        if (!numberBars || numberBars < 0) numberBars = 30
        numberBars = Math.ceil(numberBars)
        if (!widthPercentage || widthPercentage < 0) widthPercentage = 0.25
        if (displayBorder !== false) displayBorder = true
        if (displayVolume !== true) displayVolume = false
        //decide how many bars
        var interval = (chart.highValue - chart.lowValue) / numberBars
        if (interval === 0) return
        var priceVolArry = []

        // set the boundaries for the bars -- add .1 to the loop to account for possible rounding errors.
        for (var j = chart.lowValue; j < chart.highValue + 0.1; j += interval) {
          priceVolArry.push([j, 0])
        }

        if (priceVolArry.length < 2) {
          // need at least 2 price data points to draw boxes
          stx.watermark(
            'chart',
            'center',
            'top',
            stx.translateIf('Not enough data to render the Volume Profile')
          )
          return
        }

        var volumeMax = 0 // this is the maximum volume after we group them by the bars we will draw
        for (var i = 0; i < quotes.length; i++) {
          var prices = quotes[i]
          if (!prices) continue
          var volume = prices.Volume
          if (sd.panel == chart.name && prices.transform)
            prices = prices.transform

          var bottomRange = priceVolArry[0][0]
          var topRange = 0
          for (var x = 1; x < priceVolArry.length; x++) {
            topRange = priceVolArry[x][0]
            if (
              (prices.Low >= bottomRange && prices.Low <= topRange) ||
              (prices.Low < bottomRange && prices.High > topRange) ||
              (prices.High >= bottomRange && prices.High <= topRange)
            ) {
              priceVolArry[x][1] += volume
              if (priceVolArry[x][1] > volumeMax) volumeMax = priceVolArry[x][1]
            }
            bottomRange = topRange
          }
        }
        if (volumeMax === 0) {
          stx.watermark(
            'chart',
            'center',
            'top',
            stx.translateIf('Not enough data to render the Volume Profile')
          )
          return
        }

        stx.setStyle(
          'stx_volume_profile',
          'color',
          CIQ.Studies.determineColor(sd.outputs['Bars Color'])
        )
        var context = chart.context
        var fontstyle = 'stx-float-date'
        stx.canvasFont(fontstyle, context)
        var txtHeight = stx.getCanvasFontSize(fontstyle)
        var panel = chart.panel
        var chartBottom = panel.yAxis.bottom
        var barBottom = Math.round(chart.width) - 0.5 //bottom x coordinate for the bar  -- remember bars are sideways so the bottom is on the x axis
        var barMaxHeight = chart.width * widthPercentage // pixels for highest bar
        var borderColor = stx.canvasStyle('stx_volume_profile').borderColor
        var bordersOn =
          !CIQ.isTransparent(
            stx.canvasStyle('stx_volume_profile').borderColor
          ) && displayBorder

        var self = stx

        function drawBars(volumeProfileClass, borders) {
          if (!borders) barBottom -= 2
          self.canvasColor(volumeProfileClass)
          if (CIQ.isIE8) context.globalAlpha = 0.5
          context.beginPath()
          var bottomRange = priceVolArry[0][0]
          var prevTop = barBottom
          for (var i = 1; i < priceVolArry.length; i++) {
            if (priceVolArry[i][1]) {
              var barTop =
                Math.round(
                  barBottom - (priceVolArry[i][1] * barMaxHeight) / volumeMax
                ) - 0.5
              var bottomRangePixel =
                Math.round(self.pixelFromTransformedValue(bottomRange, panel)) +
                0.5
              var topRangePixel =
                Math.round(
                  self.pixelFromTransformedValue(priceVolArry[i][0], panel)
                ) + 0.5

              if (!borders) {
                bottomRangePixel -= 0.5
                topRangePixel += 0.5
                barTop += 0.5
              }

              if (bottomRangePixel > chartBottom) bottomRangePixel = chartBottom
              if (topRangePixel < chartBottom) {
                context.moveTo(barBottom, bottomRangePixel)
                context.lineTo(barBottom, topRangePixel)
                context.lineTo(barTop, topRangePixel)
                context.lineTo(barTop, bottomRangePixel)
                if (borders) {
                  if (prevTop > barTop || i == 1)
                    context.lineTo(prevTop, bottomRangePixel) // draw down to the top of the previous bar, so that we don't overlap strokes
                } else {
                  context.lineTo(barBottom, bottomRangePixel)
                  if (displayVolume) {
                    //write the volume on the bar **/
                    var txt = CIQ.condenseInt(priceVolArry[i][1])
                    var barHeight = bottomRangePixel - topRangePixel
                    if (txtHeight <= barHeight - 2) {
                      var width
                      try {
                        width = context.measureText(txt).width
                      } catch (e) {
                        width = 0
                      } // Firefox doesn't like this in hidden iframe
                      context.textBaseline = 'top'
                      var tmpcolor = context.fillStyle
                      context.fillStyle = borderColor
                      context.fillText(
                        txt,
                        barTop - width - 3,
                        topRangePixel + (barHeight / 2 - txtHeight / 2)
                      )
                      context.fillStyle = tmpcolor
                    }
                  }
                }
              }
              prevTop = barTop
            } else {
              prevTop = barBottom // there will be a missing bar here so the border needs to once again go to the end
            }
            bottomRange = priceVolArry[i][0]
          }
          if (!borders) context.fill()
          context.strokeStyle = borderColor
          if (borders) context.stroke()
          context.closePath()
        }

        drawBars('stx_volume_profile', false)
        if (bordersOn) {
          drawBars('stx_volume_profile', true)
        }

        context.globalAlpha = 1
      }

      CIQ.Studies.studyLibrary = CIQ.extend(CIQ.Studies.studyLibrary, {
        'val lines': {
          name: 'Valuation Lines',
          calculateFN: function() {},
          seriesFN: function(stx, sd, quotes) {
            CIQ.Studies.calculateValuationLines(stx, sd, quotes)
            CIQ.Studies.displayValuationLines(stx, sd)
          },
          overlay: true,
          inputs: {
            Field: 'field',
            'Average Type': ['mean', 'median', 'harmonic'],
            'Display Average': true,
            'Display 1 Standard Deviation (1\u03C3)': false,
            'Display 2 Standard Deviation (2\u03C3)': false,
            'Display 3 Standard Deviation (3\u03C3)': false,
            // doing underlay causes the labels to underlay was well. Enable this if we switch to YAxis labels.
            //"Underlay": false
          },
          outputs: {
            Average: '#00afed',
            '1 Standard Deviation (1\u03C3)': '#e1e1e1',
            '2 Standard Deviation (2\u03C3)': '#85c99e',
            '3 Standard Deviation (3\u03C3)': '#fff69e',
          },
        },
        correl: {
          name: 'Correlation Coefficient',
          range: '-1 to 1',
          calculateFN: CIQ.Studies.calculateCorrelationCoefficient,
          outputs: {},
        },
        PMO: {
          name: 'Price Momentum Oscillator',
          calculateFN: CIQ.Studies.calculatePMO,
          inputs: {
            Field: 'field',
            'Smoothing Period': 35,
            'Double Smoothing Period': 20,
            'Signal Period': 10,
          },
          outputs: { PMO: 'auto', PMOSignal: '#FF0000' },
          parameters: {
            template: 'studyOverZones',
            init: {
              studyOverZonesEnabled: true,
              studyOverBoughtValue: 2.5,
              studyOverBoughtColor: 'auto',
              studyOverSoldValue: -2.5,
              studyOverSoldColor: 'auto',
            },
          },
          attributes: {
            studyOverBoughtValue: { min: 0, step: '0.05' },
            studyOverSoldValue: { max: 0, step: '0.05' },
          },
        },
        'Rel Vol': {
          name: 'Relative Volatility',
          range: '0 to 100',
          calculateFN: CIQ.Studies.calculateRelativeVolatility,
          inputs: { Field: 'field', 'STD Period': 10, 'Smoothing Period': 14 },
          outputs: { 'Rel Vol': 'auto' },
          centerline: 50,
          parameters: {
            template: 'studyOverZones',
            init: {
              studyOverZonesEnabled: true,
              studyOverBoughtValue: 70,
              studyOverBoughtColor: 'auto',
              studyOverSoldValue: 30,
              studyOverSoldColor: 'auto',
            },
          },
        },
        Awesome: {
          name: 'Awesome Oscillator',
          seriesFN: CIQ.Studies.displayAwesomeOscillator,
          calculateFN: CIQ.Studies.calculateAwesomeOscillator,
          inputs: {},
          outputs: { 'Increasing Bar': '#00DD00', 'Decreasing Bar': '#FF0000' },
        },
        'W MFI': {
          name: 'Market Facilitation Index',
          seriesFN: CIQ.Studies.displayMFI,
          calculateFN: CIQ.Studies.calculateMFI,
          yAxis: { ground: true },
          range: '0 to max',
          inputs: { 'Scale Factor': 6 },
          outputs: {
            Green: '#8bc176',
            Fade: '#ab611f',
            Fake: '#5f7cb8',
            Squat: '#ffd0cf',
          },
        },
        'ATR Bands': {
          name: 'ATR Bands',
          overlay: true,
          seriesFN: CIQ.Studies.displayChannel,
          calculateFN: CIQ.Studies.calculateATRBands,
          inputs: { Period: 5, Shift: 3, Field: 'field', 'Channel Fill': true },
          outputs: {
            'ATR Bands Top': 'auto',
            'ATR Bands Bottom': 'auto',
            'ATR Bands Channel': 'auto',
          },
          attributes: {
            Shift: { min: 0.1, step: 0.1 },
          },
        },
        'STARC Bands': {
          name: 'STARC Bands',
          overlay: true,
          seriesFN: CIQ.Studies.displayChannel,
          calculateFN: CIQ.Studies.calculateSTARCBands,
          inputs: {
            Period: 15,
            'MA Period': 5,
            Multiplier: 1.3,
            'Channel Fill': true,
          },
          outputs: {
            'STARC Bands Top': 'auto',
            'STARC Bands Median': 'auto',
            'STARC Bands Bottom': 'auto',
          },
          attributes: {
            Multiplier: { min: 0.1, step: 0.1 },
          },
        },
        'ATR Trailing Stop': {
          name: 'ATR Trailing Stops',
          overlay: true,
          seriesFN: CIQ.Studies.displayPSAR2,
          calculateFN: CIQ.Studies.calculateATRStops,
          inputs: {
            Multiplier: 3,
            Period: 21,
            'Plot Type': ['points', 'squarewave'],
            HighLow: false,
          },
          outputs: { 'Buy Stops': '#FF0000', 'Sell Stops': '#00FF00' },
          attributes: {
            Multiplier: { min: 0.1, step: 0.1 },
          },
        },
        'Boll %b': {
          name: 'Bollinger %b',
          calculateFN: CIQ.Studies.calculateBollinger,
          inputs: {
            Field: 'field',
            Period: 20,
            'Standard Deviations': 2,
            'Moving Average Type': 'ma',
          },
          outputs: { '%b': 'auto' },
          parameters: {
            template: 'studyOverZones',
            init: {
              studyOverZonesEnabled: true,
              studyOverBoughtValue: 100,
              studyOverBoughtColor: 'auto',
              studyOverSoldValue: 0,
              studyOverSoldColor: 'auto',
            },
          },
          attributes: {
            'Standard Deviations': { min: 0.1, step: 0.1 },
          },
        },
        'Boll BW': {
          name: 'Bollinger Bandwidth',
          calculateFN: CIQ.Studies.calculateBollinger,
          inputs: {
            Field: 'field',
            Period: 20,
            'Standard Deviations': 2,
            'Moving Average Type': 'ma',
          },
          outputs: { Bandwidth: 'auto' },
          attributes: {
            'Standard Deviations': { min: 0.1, step: 0.1 },
          },
        },
        'Donchian Width': {
          name: 'Donchian Width',
          calculateFN: CIQ.Studies.calculateMaxHighMinLow,
          inputs: { 'High Period': 20, 'Low Period': 20 },
        },
        'Rel Vig': {
          name: 'Relative Vigor Index',
          seriesFN: CIQ.Studies.displayHistogramWithSeries,
          calculateFN: CIQ.Studies.calculateRelativeVigor,
          inputs: { Period: 10 },
          outputs: {
            'Rel Vig': 'auto',
            RelVigSignal: '#FF0000',
            'Increasing Bar': '#00DD00',
            'Decreasing Bar': '#FF0000',
          },
        },
        'Elder Impulse': {
          name: 'Elder Impulse System',
          calculateFN: CIQ.Studies.calculateElderImpulse,
          initializeFN: CIQ.Studies.initElderImpulse,
          seriesFN: null,
          customRemoval: true,
          underlay: true,
          inputs: {},
          outputs: {
            Bullish: '#8BC176',
            Bearish: '#DD3E39',
            Neutral: '#5F7CB8',
          },
          removeFN: function(stx, sd) {
            stx.chart.customChart = null
            stx.setMainSeriesRenderer()
          },
        },
        'Pivot Points': {
          name: 'Pivot Points',
          overlay: true,
          seriesFN: CIQ.Studies.displayPivotPoints,
          calculateFN: CIQ.Studies.calculatePivotPoints,
          inputs: {
            Type: ['standard', 'fibonacci'],
            Continuous: false,
            Shading: false,
          },
          outputs: {
            Pivot: 'auto',
            'Resistance 1': 'rgb(184,44,11)',
            'Support 1': 'rgb(105,145,88)',
            'Resistance 2': 'rgb(227,100,96)',
            'Support 2': 'rgb(179,217,135)',
            'Resistance 3': 'rgb(255,208,207)',
            'Support 3': 'rgb(211,232,174)',
          },
          parameters: {
            init: { opacity: 0.2 },
          },
        },
        VWAP: {
          name: 'VWAP',
          overlay: true,
          calculateFN: CIQ.Studies.calculateVWAP,
          inputs: {},
          outputs: { VWAP: '#FF0000' },
        },
        Alligator: {
          name: 'Alligator',
          overlay: true,
          seriesFN: CIQ.Studies.displayAlligator,
          calculateFN: CIQ.Studies.calculateAlligator,
          inputs: {
            'Jaw Period': 13,
            'Jaw Offset': 8,
            'Teeth Period': 8,
            'Teeth Offset': 5,
            'Lips Period': 5,
            'Lips Offset': 3,
            'Show Fractals': false,
          },
          outputs: { Jaw: '#0000FF', Teeth: '#FF0000', Lips: '#00DD00' },
        },
        Gator: {
          name: 'Gator Oscillator',
          seriesFN: CIQ.Studies.displayGator,
          calculateFN: CIQ.Studies.calculateAlligator,
          inputs: {
            'Jaw Period': 13,
            'Jaw Offset': 8,
            'Teeth Period': 8,
            'Teeth Offset': 5,
            'Lips Period': 5,
            'Lips Offset': 3,
          },
          outputs: { 'Increasing Bar': '#00DD00', 'Decreasing Bar': '#FF0000' },
          centerline: 0,
        },
        'Ichimoku Clouds': {
          name: 'Ichimoku Clouds',
          overlay: true,
          range: 'bypass',
          calculateFN: CIQ.Studies.calculateIchimoku,
          seriesFN: CIQ.Studies.displayIchimoku,
          inputs: {
            'Conversion Line Period': 9,
            'Base Line Period': 26,
            'Leading Span B Period': 52,
            'Lagging Span Period': 26,
          },
          outputs: {
            'Conversion Line': '#0000FF',
            'Base Line': '#FF0000',
            'Leading Span A': '#00FF00',
            'Leading Span B': '#FF0000',
            'Lagging Span': '#808000',
          },
        },
        'P Rel': {
          name: 'Price Relative',
          initializeFN: CIQ.Studies.initPriceRelative,
          seriesFN: CIQ.Studies.displayVsComparisonSymbol,
          calculateFN: CIQ.Studies.calculatePriceRelative,
          inputs: { 'Comparison Symbol': 'SPY' },
          deferUpdate: true,
        },
        'Perf Idx': {
          name: 'Performance Index',
          centerline: 1,
          initializeFN: CIQ.Studies.initPriceRelative,
          seriesFN: CIQ.Studies.displayVsComparisonSymbol,
          calculateFN: CIQ.Studies.calculatePerformance,
          inputs: { Period: 120, 'Comparison Symbol': 'SPY' },
          outputs: { Result: 'auto', Gain: '#00DD00', Loss: '#FF0000' },
          deferUpdate: true,
        },
        Beta: {
          name: 'Beta',
          centerline: 1,
          initializeFN: CIQ.Studies.initPriceRelative,
          seriesFN: CIQ.Studies.displayVsComparisonSymbol,
          calculateFN: CIQ.Studies.calculateBeta,
          inputs: { Period: 20, 'Comparison Symbol': 'SPY' },
          deferUpdate: true,
        },
        Ulcer: {
          name: 'Ulcer Index',
          calculateFN: CIQ.Studies.calculateUlcerIndex,
          inputs: { Field: 'field', Period: 14 },
        },
        'Bal Pwr': {
          name: 'Balance of Power',
          range: '-1 to 1',
          calculateFN: CIQ.Studies.calculateBalanceOfPower,
          inputs: { Period: 14, 'Moving Average Type': 'ma' },
        },
        'Trend Int': {
          name: 'Trend Intensity Index',
          calculateFN: CIQ.Studies.calculateTrendIntensity,
          range: '0 to 100',
          inputs: { Field: 'field', Period: 14, 'Signal Period': 9 },
          outputs: { TII: 'auto', Signal: '#FF0000' },
          parameters: {
            template: 'studyOverZones',
            init: {
              studyOverZonesEnabled: true,
              studyOverBoughtValue: 80,
              studyOverBoughtColor: 'auto',
              studyOverSoldValue: 20,
              studyOverSoldColor: 'auto',
            },
          },
        },
        Choppiness: {
          name: 'Choppiness Index',
          calculateFN: CIQ.Studies.calculateChoppiness,
          centerline: 50,
          parameters: {
            template: 'studyOverZones',
            init: {
              studyOverZonesEnabled: true,
              studyOverBoughtValue: 61.8,
              studyOverBoughtColor: 'auto',
              studyOverSoldValue: 38.2,
              studyOverSoldColor: 'auto',
            },
          },
          attributes: {
            studyOverBoughtValue: { min: 50, step: '0.1' },
            studyOverSoldValue: { max: 50, step: '0.1' },
          },
        },
        Disparity: {
          name: 'Disparity Index',
          calculateFN: CIQ.Studies.calculateDisparity,
          inputs: { Field: 'field', Period: 14, 'Moving Average Type': 'ma' },
        },
        'Rainbow MA': {
          name: 'Rainbow Moving Average',
          overlay: true,
          calculateFN: CIQ.Studies.calculateRainbow,
          seriesFN: CIQ.Studies.displayRainbowMA,
          inputs: { Field: 'field', Period: 2, Underlay: false },
          outputs: {
            SMA1: '#FF0000',
            SMA2: '#FF7F00',
            SMA3: '#FFFF00',
            SMA4: '#7FFF00',
            SMA5: '#00FF7F',
            SMA6: '#00FFFF',
            SMA7: '#007FFF',
            SMA8: '#0000FF',
            SMA9: '#7F00FF',
            SMA10: '#FF00FF',
          },
        },
        'Rainbow Osc': {
          name: 'Rainbow Oscillator',
          calculateFN: CIQ.Studies.calculateRainbow,
          seriesFN: CIQ.Studies.displayRainbowOsc,
          inputs: { Field: 'field', Period: 2, 'HHV/LLV Lookback': 10 },
          outputs: { 'Positive Bar': '#00DD00', 'Negative Bar': '#FF0000' },
        },
        'Pring KST': {
          name: "Pring's Know Sure Thing",
          calculateFN: CIQ.Studies.calculateKST,
          inputs: {
            Field: 'field',
            'Lightest Rate of Change Period': 10,
            'Lightest SMA Period': 10,
            'Light Rate of Change Period': 15,
            'Light SMA Period': 10,
            'Heavy Rate of Change Period': 20,
            'Heavy SMA Period': 10,
            'Heaviest Rate of Change Period': 30,
            'Heaviest SMA Period': 15,
            'Signal Period': 9,
          },
          outputs: { KST: '#00DD00', KSTSignal: '#FF0000' },
        },
        'Pring Sp-K': {
          name: "Pring's Special K",
          calculateFN: CIQ.Studies.calculateSpecialK,
          inputs: { Field: 'field', Interval: ['daily', 'weekly'] },
        },
        Darvas: {
          name: 'Darvas Box',
          underlay: true,
          calculateFN: CIQ.Studies.calculateDarvas,
          seriesFN: CIQ.Studies.displayDarvas,
          inputs: {
            'ATH Lookback Period': 100,
            'Exit Field': ['close', 'high/low'],
            'Ghost Boxes': true,
            'Stop Levels': false,
            'Level Offset': 0.01,
            'Price Minimum': 5,
            'Volume Spike': false,
            'Volume % of Avg': 400,
          },
          outputs: { Darvas: '#5F7CB8', Ghost: '#699158', Levels: 'auto' },
          customRemoval: true,
          attributes: {
            'Price Minimum': { min: 0.01, step: 0.01 },
          },
        },
        Supertrend: {
          name: 'Supertrend',
          overlay: true,
          seriesFN: CIQ.Studies.displaySupertrend,
          calculateFN: CIQ.Studies.calculateSupertrend,
          inputs: { Period: 7, Multiplier: 3 },
          outputs: { Uptrend: '#8cc176', Downtrend: '#b82c0c' },
          attributes: {
            Multiplier: { min: 0.1, step: 0.1 },
          },
        },
        'vol profile': {
          name: 'Volume Profile',
          overlay: true,
          seriesFN: CIQ.Studies.displayVolumeProfile,
          calculateFN: null,
          inputs: {},
          outputs: { 'Bars Color': '#b64a96' },
          customRemoval: true,
          parameters: {
            init: {
              displayBorder: true,
              displayVolume: false,
              numberOfBars: 30,
              widthPercentage: 0.25,
            },
          },
        },
        Vortex: {
          name: 'Vortex Indicator',
          calculateFN: CIQ.Studies.calculateVortex,
          centerline: 1,
          outputs: { '+VI': '#00FF00', '-VI': '#FF0000' },
          parameters: {
            template: 'studyOverZones',
            init: {
              studyOverZonesEnabled: true,
              studyOverBoughtValue: 1.1,
              studyOverBoughtColor: 'auto',
              studyOverSoldValue: 0.9,
              studyOverSoldColor: 'auto',
            },
          },
          attributes: {
            studyOverBoughtValue: { min: 1, step: '0.01' },
            studyOverSoldValue: { max: 1, step: '0.01' },
          },
        },
        ZigZag: {
          name: 'ZigZag',
          overlay: true,
          seriesFN: CIQ.Studies.displayZigZag,
          calculateFN: CIQ.Studies.calculateZigZag,
          inputs: { 'Distance(%)': 10 },
          parameters: {
            init: { label: false },
          },
          customRemoval: true,
          attributes: {
            'Distance(%)': { min: 0.1, step: 0.1 },
          },
        },
        PSY: {
          name: 'Psychological Line',
          range: '0 to 100',
          calculateFN: CIQ.Studies.calculatePsychologicalLine,
          inputs: { Period: 20 },
        },
        'MA Dev': {
          name: 'Moving Average Deviation',
          calculateFN: CIQ.Studies.calculateMADev,
          seriesFN: CIQ.Studies.displayHistogramWithSeries,
          inputs: {
            Field: 'field',
            Period: 12,
            'Moving Average Type': 'ma',
            'Points Or Percent': ['Points', 'Percent'],
          },
          outputs: { 'Increasing Bar': '#00DD00', 'Decreasing Bar': '#FF0000' },
        },
        Shinohara: {
          name: 'Shinohara Intensity Ratio',
          calculateFN: CIQ.Studies.calculateShinohara,
          inputs: { Period: 26 },
          outputs: { 'Strong Ratio': '#E99B54', 'Weak Ratio': '#5F7CB8' },
        },
      })

      return _exports
    }

  var __core_ =
    //-------------------------------------------------------------------------------------------
    // Copyright 2012-2017 by ChartIQ, Inc.
    // All rights reserved
    //-------------------------------------------------------------------------------------------
    function(_exports, utility) {
      if (!_exports.SplinePlotter) _exports.SplinePlotter = {}

      var CIQ = _exports.CIQ,
        $$$ = _exports.$$$,
        splinePlotter = _exports.SplinePlotter

      /*
       * Default implementation of plotSplinePrimitive.  Load splines.js to get real splining.
       */
      var plotSplinePrimitive = function(
        points,
        tension,
        context,
        colorPatternChanges
      ) {
        if (!window.splineWarning)
          console.log(
            'Warning: Cannot find implementation of splining.  Try loading splines.js'
          )
        window.splineWarning = 1
        var colorPatternIndex = 0
        context.moveTo(points[0], points[1])
        for (var i = 2; i < points.length; i += 2) {
          if (
            colorPatternChanges &&
            colorPatternIndex < colorPatternChanges.length
          ) {
            var colorPatternChange = colorPatternChanges[colorPatternIndex]
            if (
              colorPatternChange.coord[0] == points[i - 2] &&
              colorPatternChange.coord[1] == points[i - 1]
            ) {
              context.stroke()
              context.strokeStyle = colorPatternChange.color
              context.setLineDash(colorPatternChange.pattern)
              context.lineDashOffset = 0
              context.lineWidth = colorPatternChange.width
              context.beginPath()
              context.moveTo(points[i - 2], points[i - 1]) //reset back to last point
              colorPatternIndex++
            }
          }
          context.lineTo(points[i], points[i + 1])
        }
      }
      // If splines.js has not been included then set it with our default no-op implementation
      if (!_exports.SplinePlotter.plotSpline)
        _exports.SplinePlotter.plotSpline = plotSplinePrimitive

      /**
       * Gets the current time in Eastern Time Zone. This can be used as a convenience for determining open and closing times of US markets.
       * @return {date} JavaScript Date representing the time in Eastern Time Zone
       * @memberof CIQ
       */
      CIQ.getETDateTime = function() {
        var d = new Date()
        return CIQ.convertTimeZone(
          new Date(d.getTime() + d.getTimezoneOffset() * 60000),
          'UTC',
          'America/New_York'
        )
      }

      /**
       * Converts a JavaScript date from Eastern Time Zone to the browser's local time zone. Daylight Savings Time is hard coded. @see CIQ.getETDateTime
       * @param  {date} est JavaScript Date object representing a date/time in eastern time zone
       * @return {date}     JavaScript Date object converted to browser's local time zone
       * @memberof CIQ
       */
      CIQ.fromET = function(est) {
        var d = new Date()
        //var localTime = d.getTime();
        //var localOffset = d.getTimezoneOffset() * 60000;
        //var utc = localTime + localOffset;
        var offset = 4
        if (
          d.getMonth() < 2 ||
          (d.getMonth() == 2 && d.getDate() < 11) ||
          (d.getMonth() > 10 || (d.getMonth() == 10 && d.getDate() >= 4))
        )
          offset = 5
        var localTime = est.getTime() + 3600000 * offset
        var nd = new Date(localTime)
        return nd
      }

      /**
       * Converts a future month to the month index or vice versa.  Month indexes begin with 1 for January
       * @param  {char} x 	The value to convert.  If numeric, will convert to Future month letter.  If Alpha, will convert to month index.
       * @return {char} 		Converted value
       * @memberof CIQ
       */
      CIQ.convertFutureMonth = function(x) {
        var y = x.toString()
        if (y.length <= 0 || y.length > 2) return ''
        switch (y) {
          case '1':
            return 'F'
          case '2':
            return 'G'
          case '3':
            return 'H'
          case '4':
            return 'J'
          case '5':
            return 'K'
          case '6':
            return 'M'
          case '7':
            return 'N'
          case '8':
            return 'Q'
          case '9':
            return 'U'
          case '10':
            return 'V'
          case '11':
            return 'X'
          case '12':
            return 'Z'
          case 'F':
            return '1'
          case 'G':
            return '2'
          case 'H':
            return '3'
          case 'J':
            return '4'
          case 'K':
            return '5'
          case 'M':
            return '6'
          case 'N':
            return '7'
          case 'Q':
            return '8'
          case 'U':
            return '9'
          case 'V':
            return '10'
          case 'X':
            return '11'
          case 'Z':
            return '12'
        }
        return y
      }

      /**
       * Prints out a number in US Dollar monetary representation
       * @param  {number} val      The amount
       * @param  {number} [decimals=2] Optional number of decimal places.
       * @param  {string} [currency] Optional currency designation.  If omitted, will use $.
       * @return {string}          US Dollar monetary representation
       * // Returns $100.00
       * CIQ.money(100, 2);
       * @memberof CIQ
       */
      CIQ.money = function(val, decimals, currency) {
        if (!currency) currency = '$'
        if (currency.length == 3) currency += ' '
        if (!decimals && decimals !== 0) decimals = 2
        return (
          currency +
          CIQ.commas((Math.round(val * 10000) / 10000).toFixed(decimals))
        )
      }

      /**
       * Converts a currency code from ISO to char
       * @param  {string} code      The string to convert, e.g. USD
       * @return {string}          The converted string, e.g. $
       * @memberof CIQ
       */
      CIQ.convertCurrencyCode = function(code) {
        var codes = {
          JPY: '¥',
          USD: '$',
          AUD: 'A$',
          BRL: 'R$',
          CAD: 'CA$',
          CNY: 'CN¥',
          CZK: 'Kč',
          DKK: 'kr',
          EUR: '€',
          GBP: '£',
          HKD: 'HK$',
          HUF: 'Ft',
          ILS: '₪',
          INR: '₹',
          KRW: '₩',
          MXN: 'MX$',
          NOK: 'kr',
          NZD: 'NZ$',
          PLN: 'zł',
          RUB: 'руб',
          SAR: '﷼',
          SEK: 'kr',
          SGD: 'S$',
          THB: '฿',
          TRY: '₺',
          TWD: 'NT$',
          VND: '₫',
          XAF: 'FCFA',
          XCD: 'EC$',
          XOF: 'CFA',
          XPF: 'CFPF',
          ZAR: 'R',
        }
        var rt = codes[code]
        if (rt) return rt
        return code
      }

      /**
       * Returns a string representation of a number with commas in thousands, millions or billions places. Note that this function does
       * not handle values with more than 3 decimal places!!!
       * @param  {number} val The value
       * @return {string}     The result with commas
       * @example
       * // Returns 1,000,000
       * CIQ.commas(1000000);
       * @memberof CIQ
       */
      CIQ.commas = function(val) {
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }

      /**
       * User friendly alerts. The charting engine always uses this instead of alert() for warning or error messages. This
       * method can be overriden as required by your user interface.
       * @param  {string} text Alert message
       * @example
       * // Override with a friendlier alert mechanism!
       * CIQ.alert=function(text){
       * 	doSomethingElse(text);
       * }
       * @memberof CIQ
       */
      CIQ.alert = function(text) {
        alert(text)
      }

      /**
       * Returns true if a point, in absolute screen position, is within an element
       * @param  {object} node A valid DOM element to check whether the point overlaps
       * @param  {number} x    Absolute screen X position of point
       * @param  {number} y    Absolute screen Y position of pointer
       * @return {boolean}      True if the point lies inside of the DOM element
       * @memberof CIQ
       */
      CIQ.withinElement = function(node, x, y) {
        var rect = node.getBoundingClientRect()
        if (x <= rect.left) return false
        if (y <= rect.top) return false
        if (x >= rect.left + node.offsetWidth) return false
        if (y >= rect.top + node.offsetHeight) return false
        return true
      }

      /**
       * Sets a member or style for a DOM element only if it isn't already set.
       * This is more efficient than blindly updating the DOM.
       * @param  {HTMLElement} node  Node to update
       * @param  {string} member The DOM member to update
       * @param  {string} value The value to set
       * @memberOf  CIQ
       * @since  4.0.0
       */
      CIQ.efficientDOMUpdate = function(node, member, value) {
        if (node[member] !== value) node[member] = value
      }

      /**
       * Used in conjunction, safeMouseOut and safeMouseOver ensure just a single event when the mouse moves
       * in or out of an element. This is important because simple mouseout events will fire when the mouse
       * crosses boundaries *within* an element. Note that this function will do nothing on a touch device where
       * mouseout is not a valid operation.
       * @param  {object} node A valid DOM element
       * @param  {function} fc   Function to call when the mouse has moved out
       * @memberof CIQ
       */
      CIQ.safeMouseOut = function(node, fc) {
        function closure(node, fc) {
          return function(e) {
            if (typeof e.pageX == 'undefined') {
              e.pageX = e.clientX
              e.pageY = e.clientY
            }
            if (CIQ.withinElement(node, e.pageX, e.pageY)) {
              return
            }
            node.stxMouseOver = false
            fc(e)
          }
        }
        node.addEventListener('mouseout', closure(node, fc))
      }

      /**
       * This method is guaranteed to only be called once when a user mouses over an object. @see CIQ#safeMouseOut
       * @param  {object} node A valid DOM element
       * @param  {function} fc   Function to call when mouse moves over the object
       * @memberof CIQ
       */
      CIQ.safeMouseOver = function(node, fc) {
        function closure(node, fc) {
          return function(e) {
            if (typeof e.pageX == 'undefined') {
              e.pageX = e.clientX
              e.pageY = e.clientY
            }
            if (CIQ.withinElement(node, e.pageX, e.pageY)) {
              if (node.stxMouseOver) return
              node.stxMouseOver = true
              fc(e)
            }
          }
        }
        node.addEventListener('mouseover', closure(node, fc))
      }

      /**
       * Converts an object to emit "stxtap" events. This uses {@link CIQ#safeClickTouch}. You should use addEventListener("tap") to receive the events.
       * @param {HTMLElement} div The element to convert
       * @param {object} [params] Optional parameters to pass to {@link CIQ#safeClickTouch}
       * @param {boolean} [params.stopPropagation=false] If set to true then propagation will be stopped
       * @memberOf  CIQ
       * @since  04-2015
       */
      CIQ.installTapEvent = function(div, params) {
        var fc = function(e) {
          var ev = document.createEvent('Event')
          ev.initEvent('stxtap', true, true)
          if (typeof e.pageX == 'undefined') {
            e.pageX = e.clientX
            e.pageY = e.clientY
          }
          ev.pageX = e.pageX
          ev.pageY = e.pageY
          e.target.dispatchEvent(ev)
          if (params && params.stopPropagation) e.stopPropagation()
        }
        CIQ.safeClickTouch(div, fc, params)
      }
      /**
       * Use this instead of onclick or ontouch events. This function will automatically use the quickest available
       * but also protect against being called twice.
       * By default any previous safeClickTouch listeners will be cleared (to allow re-use of the element).
       * @param {object} div The DOM element to attach an event
       * @param {Function} fc The function to call when the object is pressed
       * @param {object} params Parameters to drive behavior.
       * @param {object} [params.safety] An optional object, generated from a CIQ.safeDrag association to prevent the click from being triggered when a drag operation is released
       * @param {boolean} [params.allowMultiple=false] If set then multiple click events can be associated with the node
       * @param {boolean} [params.preventUnderlayClick=true] By default prevents an underlaying element from being "clicked" on a touch device 400ms after the overlay was tapped. Set to false for input fields, or any div containing input fields (body)
       * @param {boolean} [params.absorbDownEvent=true] Ensures that a mousedown, pointerdown, touchstart event doesn't get passed to the parent.
       * @memberof CIQ
       * @since 11/01/2015 Removed timers in favor of a new algorithm. This algorithm allows only the first event to fire from a UI interaction to execute the fc function.
       */
      CIQ.safeClickTouch = function(div, fc, params) {
        if (!params) params = {}
        var movementWatcher = {}

        if (!params.allowMultiple) CIQ.clearSafeClickTouches(div)
        if (params.preventUnderlayClick !== false)
          params.preventUnderlayClick = true
        if (params.absorbDownEvent !== false) params.absorbDownEvent = true
        params.allowAnotherDevice = 0
        params.registeredClick = false
        function closure(which, params, movementWatcher) {
          return function(e) {
            if (!CIQ.safeClickTouchEvent) {
              if (!movementWatcher.t) {
                return // is this up/end event related to a down/start event?
              }
              var timeSincePressed = movementWatcher.t
              movementWatcher.t = null
              if (timeSincePressed + 1000 < new Date().getTime()) return //allow no more than 1 second for click
            }
            if (params.safety && params.safety.recentlyDragged) return
            if (!e) e = event
            if ((e.which && e.which >= 2) || (e.button && e.button >= 2)) return // ignore right clicks
            if (params.preventUnderlayClick) {
              // underlay click happens when you tap on a mobile device but a second mouse event registers
              // 300 ms later on another clickable object that was beneath the menu. By default we stop this
              // secondary event using preventDefault. However, we don't want to do this if we clicked inside
              // an input tag, because that would prevent the soft keyboard from coming up. Note that modern
              // touch operating systems don't have the 300ms delay issue so this code can be eliminated once
              // older operating systems are safely retired.
              if (e.target.tagName !== 'INPUT') e.preventDefault()
            } else {
              // prevent touch and mouse from being clicked when we can't use preventDefault
              if (
                params.lastType != which &&
                Date.now() < params.allowAnotherDevice
              )
                return
              params.lastType = which
              params.allowAnotherDevice = Date.now() + 1000 // 1 Second then not a coat tail mouse click
            }
            fc(e)
          }
        }
        function isClick(movementWatcher, down) {
          return function(e) {
            var x = e.clientX ? e.clientX : e.pageX
            var y = e.clientY ? e.clientY : e.pageY
            if (down) {
              movementWatcher.t = new Date().getTime()
              movementWatcher.x = x
              movementWatcher.y = y
            } else if (movementWatcher.x) {
              //allow no more than 4 pixel distance movement
              if (
                Math.pow(movementWatcher.x - x, 2) +
                  Math.pow(movementWatcher.y - y, 2) >
                16
              ) {
                movementWatcher.t = null
              }
            }
          }
        }
        var safeClickTouchEvents = div.safeClickTouchEvents
        if (!safeClickTouchEvents)
          safeClickTouchEvents = div.safeClickTouchEvents = []
        var fc1 = closure('mouseup', params, movementWatcher)
        var fc2 = closure('touchend', params, movementWatcher)
        var fc3 = closure('pointerup', params, movementWatcher)
        var f = function(e) {
          e.stopPropagation()
        }
        var eventHolder = {}
        if (CIQ.safeClickTouchEvent) {
          // global override for which event to use, for instance if you want to force use of "click" or "tap"
          var fc4 = closure(CIQ.safeClickTouchEvent, params)
          div.addEventListener(CIQ.safeClickTouchEvent, fc4)
          eventHolder[CIQ.safeClickTouchEvent] = fc4
          safeClickTouchEvents.push(eventHolder)
        } else if ('onpointerup' in document) {
          // Internet Explorer can always use pointerup safely
          div.addEventListener('pointerdown', isClick(movementWatcher, true))
          div.addEventListener('pointermove', isClick(movementWatcher))
          div.addEventListener('pointerup', fc3)
          eventHolder.pointerup = fc3
          if (params.absorbDownEvent) {
            div.addEventListener('pointerdown', f)
            eventHolder.pointerdown = f
          }
          safeClickTouchEvents.push(eventHolder)
        } else {
          // all in one computers can support both of these under Chrome/FF!
          div.addEventListener('mousedown', isClick(movementWatcher, true))
          div.addEventListener('mousemove', isClick(movementWatcher))
          div.addEventListener('touchstart', isClick(movementWatcher, true))
          div.addEventListener('touchmove', isClick(movementWatcher))
          div.addEventListener('mouseup', fc1)
          div.addEventListener('touchend', fc2)
          eventHolder.mouseup = fc1
          eventHolder.touchend = fc2
          if (params.absorbDownEvent) {
            div.addEventListener('mousedown', f)
            eventHolder.mousedown = f
            div.addEventListener('touchstart', f)
            eventHolder.touchstart = f
          }
          safeClickTouchEvents.push(eventHolder)
        }
      }

      /**
       * Clears all safeClickTouch events from a DOM element.
       * @param  {object} div The DOM element to clear events
       * @memberof CIQ
       */
      CIQ.clearSafeClickTouches = function(div) {
        var safeClickTouchEvents = div.safeClickTouchEvents
        if (!safeClickTouchEvents) return
        for (var i = 0; i < safeClickTouchEvents.length; i++) {
          var fc = safeClickTouchEvents[i]
          for (var e in fc) {
            var f = fc[e]
            div.removeEventListener(e, f)
          }
        }
        div.safeClickTouchEvents = null
      }

      /**
       * Safe function to handle dragging of objects on the screen. This method is cross-device aware and can handle mouse or touch drags.
       * This method does not actually move the objects but provides callbacks that explain when drag operations
       * begin and cease, and what movements are made during the drag. Callbacks should be used to move the actual objects
       * (if it is desired to move objects during a drag operation). For convenience, displacementX and displacementY are added to callback events
       * to indicate the distance from the original starting point of the drag.
       * A "safety" object is returned which can optionally be passed into CIQ.safeClickTouch to prevent errant click events
       * from being triggered when a user lets go of a drag
       * @param  {object} div    The draggable DOM element
       * @param  {function} [fcDown] Callback function when a drag operation begins. Receives an event object.
       * @param  {function} [fcMove] Callback function when a drag move occurs. Receives an event object.
       * @param  {function} [fcUp]   Callback function when the drag operation ends. Receives an event object.
       * @return {object}        Safety object which can be passed to CIQ.safeClickTouch
       * @memberof CIQ
       */
      CIQ.safeDrag = function(div, fcDown, fcMove, fcUp) {
        var resetMS = 100 // To avoid multiple down events only one can occur per 100ms
        var registeredClick = false
        var startX = 0,
          startY = 0
        var safety = {
          recentlyDragged: false,
        }
        function closure(moveEvent) {
          var fmap = {
            mousedown: { move: 'mousemove', up: 'mouseup' },
            pointerdown: { move: 'pointermove', up: 'pointerup' },
            touchstart: { move: 'touchmove', up: 'touchend' },
          }
          function pageX(e) {
            if (e.touches) {
              if (e.touches.length >= 1) {
                return e.touches[0].pageX
              } else if (e.changedTouches && e.changedTouches.length >= 1) {
                return e.changedTouches[0].pageX
              }
            }
            if (typeof e.pageX == 'undefined') {
              return e.clientX
            }
            return e.pageX
          }
          function pageY(e) {
            if (e.touches) {
              if (e.touches.length >= 1) {
                return e.touches[0].pageY
              } else if (e.changedTouches && e.changedTouches.length >= 1) {
                return e.changedTouches[0].pageY
              }
            }
            if (typeof e.pageY == 'undefined') {
              return e.clientY
            }
            return e.pageY
          }
          return function(e) {
            if (registeredClick) return
            registeredClick = true
            CIQ.ChartEngine.ignoreTouch = true
            var moveFC = function(e) {
              if (e && e.preventDefault) e.preventDefault()
              safety.recentlyDragged = true
              e.displacementX = pageX(e) - startX
              e.displacementY = pageY(e) - startY
              fcMove(e) // Call the move event
            }
            if (fcMove)
              document.body.addEventListener(fmap[moveEvent].move, moveFC)
            document.body.addEventListener(fmap[moveEvent].up, function(e) {
              // Create an up listener on the body
              CIQ.ChartEngine.ignoreTouch = false
              if (fcMove)
                document.body.removeEventListener(fmap[moveEvent].move, moveFC) // Remove the move listener since our move is now complete
              document.body.removeEventListener(
                fmap[moveEvent].up,
                arguments.callee
              ) // Remove the up listener since our move is now complete
              e.displacementX = pageX(e) - startX
              e.displacementY = pageY(e) - startY
              if (fcUp) fcUp(e) // Call the up event
              setTimeout(
                (function(safety) {
                  return function() {
                    safety.recentlyDragged = false
                  }
                })(safety),
                50
              ) // Prevent errant clicks from touch letting go
            })
            setTimeout(function() {
              registeredClick = false
            }, resetMS)
            startX = pageX(e)
            startY = pageY(e)
            if (fcDown) fcDown(e)
          }
        }
        div.addEventListener('mousedown', closure('mousedown'))
        div.addEventListener('pointerdown', closure('pointerdown'))
        div.addEventListener('touchstart', closure('touchstart'))
        return safety
      }

      if (CIQ.isSurface) {
        CIQ.gesture = new MSGesture()
        CIQ.gesture.target = document.body
        CIQ.gesturePointerId = null
      }

      /**
       * Captures enter key events. Also clears the input box on escape key.
       * @param {object} node The DOM element to attach the event to. Should be a text input box.
       * @param {Function} cb Callback function when enter key is pressed.
       * @memberof CIQ
       */

      CIQ.inputKeyEvents = function(node, cb) {
        node.addEventListener(
          'keyup',
          function(e) {
            var key = window.event ? event.keyCode : e.keyCode
            switch (key) {
              case 13:
                cb()
                break
              case 27:
                node.value = ''
                break
              default:
                break
            }
          },
          false
        )
      }

      /**
       * Fixes screen scroll. This can occur when the keyboard opens on an ipad or iphone.
       * @memberof CIQ
       */
      CIQ.fixScreen = function() {
        window.scrollTo(0, 0)
      }

      /**
       * Sets the position of the cursor within a textarea box. This is used for instance to position the cursor at the
       * end of the text that is in a textarea.
       * @param {object} ctrl A valid textarea DOM element
       * @param {number} pos  The position in the text area to position
       * @memberof CIQ
       */
      CIQ.setCaretPosition = function(ctrl, pos) {
        ctrl.style.zIndex = 5000
        if (ctrl.setSelectionRange) {
          CIQ.focus(ctrl)
          try {
            ctrl.setSelectionRange(pos, pos)
          } catch (e) {}
        } else if (ctrl.createTextRange) {
          var range = ctrl.createTextRange()
          range.collapse(true)
          range.moveEnd('character', pos)
          range.moveStart('character', pos)
          range.select()
        }
      }

      /**
       * Sets the value of an input box only if it is not active. This prevents an input box from changing underneath
       * a user, which can be extremely frustrating on touch devices.
       * @param {HTMLElement} el    The input element
       * @param {string} value The value to set
       * @memberOf  CIQ
       */
      CIQ.setValueIfNotActive = function(el, value) {
        if (document.activeElement == el) return
        el.value = value
      }

      /**
       * Closes the keyboard on a touch device by blurring any active input elements.
       * @param {HTMLElement} newFocus optional element to change focus to
       * @memberof CIQ
       */
      CIQ.hideKeyboard = function(newFocus) {
        var element = document.activeElement
        if (element.tagName == 'INPUT' || element.tagName == 'TEXTAREA') {
          element.blur()
          window.focus()
          if (newFocus) {
            if (newFocus === document.body || document.body.contains(newFocus))
              newFocus.focus()
          }
        }
      }

      /**
       * Determines whether a line intersects a box. This is used within the charting engine to determine whether the cursor
       * has intersected a drawing.
       * @param  {number} bx1
       * @param  {number} by1
       * @param  {number} bx2
       * @param  {number} by2
       * @param  {number} x0
       * @param  {number} y0
       * @param  {number} x1
       * @param  {number} y1
       * @param  {string} vtype - Either "segment", "ray" or "line"
       * @param  {boolean} isLog - True if the chart is in log scale and linear values are passed in
       * @return {boolean}       Returns true if the line intersects the box
       * @memberof CIQ
       * @since 4.0.0 `isLog` parameter added
       */
      CIQ.boxIntersects = function(
        bx1,
        by1,
        bx2,
        by2,
        x0,
        y0,
        x1,
        y1,
        vtype,
        isLog
      ) {
        //Adapted from http://stackoverflow.com/questions/99353/how-to-test-if-a-line-segment-intersects-an-axis-aligned-rectange-in-2d

        // Find min and max X for the segment
        var minX = x0
        var maxX = x1

        if (x0 > x1) {
          minX = x1
          maxX = x0
        }

        // Find the intersection of the segment's and rectangle's x-projections
        if (maxX > bx2) maxX = bx2
        if (minX < bx1) minX = bx1

        if (vtype == 'segment' && minX > maxX) return false // If their projections do not intersect return false

        if (isLog) {
          y0 = CIQ.log10(y0)
          y1 = CIQ.log10(y1)
          by1 = CIQ.log10(by1)
          by2 = CIQ.log10(by2)
        }

        // Find corresponding min and max Y for min and max X we found before
        var minY = y0
        var maxY = y1

        var dx = x1 - x0

        if (Math.abs(dx) > 0.0000001) {
          var a = (y1 - y0) / dx
          var b = y0 - a * x0
          minY = a * minX + b
          maxY = a * maxX + b
        }

        if (minY > maxY) {
          var tmp = maxY
          maxY = minY
          minY = tmp
        }

        // Find the intersection of the segment's and rectangle's y-projections
        if (maxY > by1) maxY = by1
        if (minY < by2) minY = by2

        if (vtype == 'segment') {
          return minY <= maxY // If their projections do not intersect return false
        }

        // Now see if all box corners land on the same side of the line
        function cornerCheck(x, y) {
          return (y0 - y1) * x + (x1 - x0) * y + (x0 * y1 - x1 * y0)
        }
        var map = {
          a: cornerCheck(bx1, by1),
          b: cornerCheck(bx1, by2),
          c: cornerCheck(bx2, by1),
          d: cornerCheck(bx2, by2),
        }
        if (map.a > 0 && map.b > 0 && map.c > 0 && map.d > 0) return false
        if (map.a < 0 && map.b < 0 && map.c < 0 && map.d < 0) return false

        return true
      }

      /**
       * Determines whether two lines intersect
       * @param  {number} x1
       * @param  {number} x2
       * @param  {number} y1
       * @param  {number} y2
       * @param  {number} x3
       * @param  {number} x4
       * @param  {number} y3
       * @param  {number} y4
       * @param  {string} type - Either "segment", "ray" or "line"
       * @return {boolean}      Returns true if the two lines intersect
       * @memberof CIQ
       */
      CIQ.linesIntersect = function(x1, x2, y1, y2, x3, x4, y3, y4, type) {
        var denom = (y4 - y3) * (x2 - x1) - (x4 - x3) * (y2 - y1)
        var numera = (x4 - x3) * (y1 - y3) - (y4 - y3) * (x1 - x3)
        var numerb = (x2 - x1) * (y1 - y3) - (y2 - y1) * (x1 - x3)
        //var EPS = .000001;

        if (denom === 0) {
          if (numera === 0 && numerb === 0) return true // coincident
          return false // parallel
        }

        var mua = numera / denom
        var mub = numerb / denom
        if (type == 'segment') {
          if (mua >= 0 && mua <= 1 && mub >= 0 && mub <= 1) return true
        } else if (
          type == 'line' ||
          type == 'horizontal' ||
          type == 'vertical'
        ) {
          if (mua >= 0 && mua <= 1) return true
        } else if (type == 'ray') {
          if (mua >= 0 && mua <= 1 && mub >= 0) return true
        }
        return false
      }

      /**
       * Determines the Y value at which point X intersects a line (vector)
       * @param  {object} vector - Object of type {x0,x1,y0,y1}
       * @param  {number} x      - X value
       * @return {number}        - Y intersection point
       * @memberof CIQ
       */
      CIQ.yIntersection = function(vector, x) {
        var x1 = vector.x0,
          x2 = vector.x1,
          x3 = x,
          x4 = x
        var y1 = vector.y0,
          y2 = vector.y1,
          y3 = 0,
          y4 = 10000
        var denom = (y4 - y3) * (x2 - x1) - (x4 - x3) * (y2 - y1)
        var numera = (x4 - x3) * (y1 - y3) - (y4 - y3) * (x1 - x3)
        //var numerb = (x2-x1) * (y1-y3) - (y2-y1) * (x1-x3);
        //var EPS = .000001;

        var mua = numera / denom
        if (denom === 0) {
          if (numera === 0) mua = 1
          else return null
        }

        var y = y1 + mua * (y2 - y1)
        return y
      }

      /**
       * Determines the X value at which point Y intersects a line (vector)
       * @param  {object} vector - Object of type {x0,x1,y0,y1}
       * @param  {number} y      - Y value
       * @return {number}        - X intersection point
       * @memberof CIQ
       */
      CIQ.xIntersection = function(vector, y) {
        var x1 = vector.x0,
          x2 = vector.x1,
          x3 = 0,
          x4 = 10000
        var y1 = vector.y0,
          y2 = vector.y1,
          y3 = y,
          y4 = y
        var denom = (y4 - y3) * (x2 - x1) - (x4 - x3) * (y2 - y1)
        var numera = (x4 - x3) * (y1 - y3) - (y4 - y3) * (x1 - x3)
        //var numerb = (x2-x1) * (y1-y3) - (y2-y1) * (x1-x3);
        //var EPS = .000001;

        var mua = numera / denom
        if (denom === 0) {
          if (numera === 0) mua = 1
          else return null
        }

        var x = x1 + mua * (x2 - x1)
        return x
      }

      /**
       * Get the X intersection point between two lines
       * @memberof CIQ
       */
      CIQ.intersectLineLineX = function(
        ax1,
        ax2,
        ay1,
        ay2,
        bx1,
        bx2,
        by1,
        by2
      ) {
        var ua_t = (bx2 - bx1) * (ay1 - by1) - (by2 - by1) * (ax1 - bx1)
        var u_b = (by2 - by1) * (ax2 - ax1) - (bx2 - bx1) * (ay2 - ay1)

        var ua = ua_t / u_b

        return ax1 + ua * (ax2 - ax1)
      }

      /**
       * Get the Y intersection point between two lines
       * @memberof CIQ
       */
      CIQ.intersectLineLineY = function(
        ax1,
        ax2,
        ay1,
        ay2,
        bx1,
        bx2,
        by1,
        by2
      ) {
        var ua_t = (bx2 - bx1) * (ay1 - by1) - (by2 - by1) * (ax1 - bx1)
        var u_b = (by2 - by1) * (ax2 - ax1) - (bx2 - bx1) * (ay2 - ay1)

        var ua = ua_t / u_b

        return ay1 + ua * (ay2 - ay1)
      }

      /**
       * Set once after user is alerted that private browsing is enabled
       * @memberof CIQ
       * @type boolean
       */
      CIQ.privateBrowsingAlert = false

      // Some browsers don't support localStorage, worse won't let you polyfill (JDK7 webview). So we will create
      // this so that we can add a polyfill.
      CIQ.localStorage = typeof localStorage !== 'undefined' ? localStorage : {}

      /**
       * Convenience function for storing a name value pair in local storage. This will detect if private browsing is enabled
       * because localStorage is inoperable under private browsing
       * @param  {string} name  Name to store
       * @param  {string} value Value to store
       * @memberof CIQ
       */
      CIQ.localStorageSetItem = function(name, value) {
        try {
          CIQ.localStorage.setItem(name, value)
        } catch (e) {
          if (!CIQ.privateBrowsingAlert) {
            CIQ.alert(
              'No storage space available.  Possible causes include browser being in Private Browsing mode, or maximum storage space has been reached.'
            )
            CIQ.privateBrowsingAlert = true
          }
        }
      }

      /**
       * Dynamically load UI elements from an external HTML file. This is accomplished by rendering raw HTML in an iframe
       * and then cloning all of the newly created DOM elements into our main document. The iframe is then removed.
       *
       * The title of the iframe is checked. External content should *not* have a title. By convention, 404 or 500 errors
       * have a title and so we use this to determine whether the iframe contains valid content or not.
       *
       * @param  {string}   url The external url to fetch new UI content
       * @param  {Function} cb  A callback function to call when the new UI is available
       * @memberof CIQ
       */
      CIQ.loadUI = function(url, cb) {
        var i = document.createElement('iframe')
        var onload = function() {
          var iframeDocument = null

          try {
            iframeDocument = i.contentDocument || i.contentWindow.document
          } catch (error) {
            return cb(error)
          }

          if (iframeDocument && !iframeDocument.title) {
            var html = iframeDocument.body.innerHTML
            var div = document.createElement('div')

            document.body.removeChild(i)
            CIQ.innerHTML(div, html)

            for (var j = 0; j < div.children.length; j++) {
              var ch = div.children[j].cloneNode(true)
              document.body.appendChild(ch)
            }

            cb(null)
          } else {
            cb(new Error('iFrame not found or document has a title'))
          }
        }

        i.src = url + '?' + CIQ.uniqueID()
        i.hidden = true
        i.addEventListener('load', onload, false)
        document.body.appendChild(i)
      }

      /**
       * Loads JavaScript dynamically. This method keeps a static memory of scripts that have been loaded
       * to prevent them from being loaded twice. The callback function however is always called, even if
       * the script has already been loaded.
       * @param  {string}   scriptName The url of the script to load
       * @param  {Function} cb         Callback function to call when the script is loaded
       * @memberof CIQ
       */
      CIQ.loadScript = function(scriptName, cb) {
        if (!CIQ.loadedScripts) CIQ.loadedScripts = {}
        if (CIQ.loadedScripts[scriptName]) {
          if (cb) cb()
          return
        }
        var script = document.createElement('SCRIPT')
        script.async = true
        script.onload = function() {
          CIQ.loadedScripts[scriptName] = true
          if (cb) cb()
        }
        if (typeof isIE8 != 'undefined') {
          script.onreadystatechange = function() {
            if (script.readyState == 'loaded') {
              CIQ.loadedScripts[scriptName] = true
              if (cb) {
                setTimeout(cb, 0)
              }
            }
          }
        }
        var uniqueName = scriptName
        // Use the epoch to create a unique query string, which will force the browser to reload
        if (uniqueName.indexOf('?') == -1) {
          uniqueName = uniqueName + '?' + Date.now()
        } else {
          uniqueName = uniqueName + '&' + Date.now()
        }
        script.src = uniqueName
        var s = document.getElementsByTagName('script')[0]
        s.parentNode.insertBefore(script, s.nextSibling)
      }

      /**
       * Loads a stylesheet.
       * @param  {string}   stylesheet Name of stylesheet file.
       * @param  {Function} cb     Function to call when the stylesheet is fully loaded
       * @since 2016-03-11
       * @memberof CIQ
       */
      CIQ.loadStylesheet = function(widget, cb) {
        var lnk = document.createElement('link')
        lnk.rel = 'stylesheet'
        lnk.type = 'text/css'
        lnk.media = 'screen'
        lnk.href = widget + '?' + Date.now()
        lnk.onload = function() {
          if (this.loaded) return //undocumented IE Edge bug, css files load twice.  This to prevent double-triggering of onload, which may load html file twice.
          this.loaded = true
          if (cb) cb()
        }
        var links = document.getElementsByTagName('link')
        var lastLink = links[links.length - 1]
        lastLink.parentNode.insertBefore(lnk, lastLink.nextSibling)
      }

      /**
       * Loads a feature function widget. Feature function widgets consist of a css file, a JS file and an HTML file. This can
       * be used to dynamically load content and functionality.
       * @param  {string}   widget Name of widget. The js, css and html files should be this name.
       * @param  {Function} cb     Function to call when the widget is fully loaded
       * @memberof CIQ
       */
      CIQ.loadWidget = function(widget, cb) {
        CIQ.loadStylesheet(widget + '.css', function() {
          CIQ.loadUI(widget + '.html', function(err) {
            if (err) cb(err)
            else CIQ.loadScript(widget + '.js', cb)
          })
        })
      }

      /**
       * Sets the transparent parts of the canvas to the specified background color. Used to ensure a background when turning charts into images
       * because normally the background is the background of the DIV container and not the canvas itself.
       * @param  {object} context An HTML canvas context
       * @param  {string} color   The color to set the background. Any valid HTML canvas color.
       * @param  {number} width   Width to apply color (Could be less than size of canvas)
       * @param  {number} height  Height to apply color (Could be less than size of canvas if applying branding for instance)
       * @memberof CIQ
       */
      CIQ.fillTransparentCanvas = function(context, color, width, height) {
        var compositeOperation = context.globalCompositeOperation
        context.globalCompositeOperation = 'destination-over'
        context.fillStyle = color
        context.fillRect(0, 0, width, height)
        context.globalCompositeOperation = compositeOperation
      }

      /**
       * Draws a ticked rectangle on the canvas. For use in the y-axis label.
       * @param  {object}  ctx    A valid HTML Canvas Context
       * @param  {number}  x      Left position of drawing on canvas
       * @param  {number}  y      Top position of drawing on canvas
       * @param  {number}  width  Width of rectangle
       * @param  {number}  height Height of rectangle
       * @param  {number}  radius Radius of rounding
       * @param  {boolean} [fill]   Whether to fill the background
       * @param  {boolean} [stroke] Whether to fill the outline
       * @memberof CIQ
       * @since 3.0.0 - function signature changed: This function now takes a params object instead of 8 different parameters
       */

      CIQ.tickedRect = function(params) {
        CIQ.rect(params)
        var tickY = Math.round(params.top + params.height / 2) + 0.5
        params.ctx.beginPath()
        params.ctx.moveTo(params.x - 2, tickY)
        params.ctx.lineTo(params.x, tickY)
        params.ctx.stroke()
        params.ctx.closePath()
      }

      /**
       * Draws a rounded rectangle on the canvas.
       * @param  {object} params
       * @param  {object} params.ctx    A valid HTML Canvas Context
       * @param  {number} params.x      Left position of drawing on canvas
       * @param  {number} params.top      Top position of drawing on canvas
       * @param  {number} params.width  Width of rectangle
       * @param  {number} params.height Height of rectangle
       * @param  {number} params.radius Radius of rounding
       * @param  {boolean} [params.fill]   Whether to fill the background
       * @param  {number}  [params.txt]    Text for the label
       * @param  {number}  [params.y]      Y position of drawing on canvas
       * @param  {object}  [params.margin]     Margin around the text
       * @param  {object}  [params.margin.left]     Left margin of text
       * @param  {object}  [params.margin.top]     Top margin of text
       * @param  {number}  [params.backgroundColor]  background color. This is the background color of the rectangle
       * @param  {number}  [params.color] Text color
       * @param {string} [edge] "flush","arrow"
       * @memberof CIQ
       * @since 3.0.0  - function signature changed: This function now takes a params object and the drawing type instead of 8 different parameters.
       * Also, this function will draw the label if `params.txt` is present, otherwise just the floating label outline will be drawn
       */
      CIQ.roundRect = function(params, edge) {
        if (arguments.length === 9) {
          params = {
            ctx: arguments[0],
            x: arguments[1],
            top: arguments[2],
            width: arguments[3],
            height: arguments[4],
            radius: arguments[5],
            fill: arguments[6],
            stroke: arguments[7],
            edge: arguments[8],
          }
        }
        var stroke = params.stroke
        var x = params.x
        var y = params.top
        var width = params.width
        var height = params.height
        var radius = params.radius
        var fill = params.fill
        var ctx = params.ctx
        if (typeof stroke == 'undefined') {
          stroke = true
        }
        if (typeof radius === 'undefined') {
          radius = 5
          if (width < 0) radius = -5
        }
        var yradius = width < 0 ? radius * -1 : radius
        if (radius && !edge) x = x - 1 // Just a smidge more

        var xr = x + radius,
          xw = x + width,
          yr = y + yradius,
          yh = y + height
        var xwr = xw - radius,
          yhr = yh - yradius
        ctx.beginPath()
        ctx.moveTo(xr, y)
        ctx.lineTo(xwr, y)

        ctx.quadraticCurveTo(xw, y, xw, yr)
        ctx.lineTo(xw, yhr)
        ctx.quadraticCurveTo(xw, yh, xwr, yh)
        ctx.lineTo(xr, yh)

        if (edge == 'flush') {
          ctx.lineTo(x, yh)
          ctx.lineTo(x, y)
        } else if (edge == 'arrow') {
          ctx.quadraticCurveTo(x, yh, x - radius, yhr)
          var multiplier = width < 0 ? 1 : -1
          ctx.lineTo(x + (height / 2) * multiplier, y + height / 2) // right arrow tip
          ctx.lineTo(x - radius, yr)
          ctx.quadraticCurveTo(x, y, xr, y)
        } else {
          ctx.quadraticCurveTo(x, yh, x, yhr)
          ctx.lineTo(x, yr)
          ctx.quadraticCurveTo(x, y, xr, y)
        }
        ctx.closePath()
        if (params.backgroundColor) ctx.fillStyle = params.backgroundColor

        if (stroke) {
          ctx.stroke()
        }
        if (fill) {
          ctx.fill()
        }
        if (params.txt) CIQ.createLabel(params)
      }
      /**
       * Creates  a text label on the canvas.
       * @param  {object}  params
       * @param  {object}  params.ctx      A valid HTML Canvas Context
       * @param  {number}  params.x      Left position of drawing on canvas
       * @param  {number}  params.txt    Text for the lavel
       * @param  {number}  params.y      Y position of drawing on canvas
       * @param  {object}  params.margin     Margin around the text
       * @param  {object}  params.margin.left     Left margin of text
       * @param  {object}  params.margin.top     Top margin of text
       * @param  {number}  params.backgroundColor  background color. This is used to find the text color if there is no color specified
       * @param  {number}  params.color Text color
       * @memberof CIQ
       * @since 3.0.0 -  New Function
       */

      CIQ.createLabel = function(params) {
        params.ctx.textBaseline = 'middle'
        params.ctx.fillStyle = params.color
          ? params.color
          : CIQ.chooseForegroundColor(params.backgroundColor)
        if (params.ctx.fillStyle === params.backgroundColor) {
          // Best effort to pick a foreground color that isn't the same as the background!
          if (params.backgroundColor.toUpperCase() == '#FFFFFF')
            params.ctx.fillStyle = '#000000'
          else params.ctx.fillStyle = '#FFFFFF'
        }
        params.ctx.fillText(
          params.txt,
          params.x + params.margin.left,
          params.y + params.margin.top
        )
        params.ctx.textAlign = 'left'
      }

      /**
       * Draws a rounded rectangle with an arrowhead on the screen.
       * @param  {object}  ctx    A valid HTML Canvas Context
       * @param  {number}  x      Left position of drawing on canvas
       * @param  {number}  y      Top position of drawing on canvas
       * @param  {number}  width  Width of rectangle
       * @param  {number}  height Height of rectangle
       * @param  {number}  radius Radius of rounding
       * @param  {boolean} [fill]   Whether to fill the background
       * @param  {boolean} [stroke] Whether to fill the outline
       * @memberof CIQ
       * @since 3.0.0 - function signature changed: This function now takes a params object instead of 8 different parameters
       */
      CIQ.roundRectArrow = function(params) {
        CIQ.roundRect(params, 'arrow')
      }

      /**
       * Draws a rectangle on the canvas with just the right side curved corners
       * see {@link CIQ.roundRect}
       * @memberof CIQ
       * @since 3.0.0 - function signature changed: This function now takes a params object instead of 8 different parameters
       */
      CIQ.semiRoundRect = function(params) {
        CIQ.roundRect(params, 'flush')
      }

      /**
       * Draws a rectangle on the canvas
       * see {@link CIQ.roundRect}
       * @memberof CIQ
       * @since 3.0.0 - function signature changed: This function now takes a params object instead of 8 different parameters
       */
      CIQ.rect = function(params) {
        params.radius = 0
        CIQ.roundRect(params)
      }

      /**
       * No operation will be performed. As a result there will be no label drawn around the value.
       * see {@link CIQ.roundRect}
       * @memberof CIQ
       * @since 3.0.0 - function signature changed: This function now takes a params object instead of 8 different parameters
       */
      CIQ.noop = function(params) {
        CIQ.createLabel(params)
      }

      /**
       * Turns a portion of raw text into multi-line text that fits in a given width. This is used for autoformatting of annotations
       * @param  {object} ctx    A valid HTML Canvas Context
       * @param  {string} phrase The text
       * @param  {number} l      The width in pixels to fit the text within on the canvas
       * @return {array}        An array of individual lines that should fit within the specified width
       * @memberof CIQ
       */
      CIQ.getLines = function(ctx, phrase, l) {
        var wa = phrase.split(' '),
          phraseArray = [],
          lastPhrase = '',
          measure = 0
        var fw = false
        for (var i = 0; i < wa.length; i++) {
          var w = wa[i]
          measure = ctx.measureText(lastPhrase + w).width
          if (measure < l) {
            if (fw) lastPhrase += ' '
            fw = true
            lastPhrase += w
          } else {
            phraseArray.push(lastPhrase)
            lastPhrase = w
          }
          if (i === wa.length - 1) {
            phraseArray.push(lastPhrase)
            break
          }
        }
        return phraseArray
      }

      /**
       * Creates a string with a periodicity that is easy to read given a chart
       * @param  {CIQ.ChartEngine} stx A chart object
       * @return {string}     A periodicity value that can be displayed to an end user
       * @memberof CIQ
       */
      CIQ.readablePeriodicity = function(stx) {
        var displayPeriodicity = stx.layout.periodicity
        var displayInterval = stx.layout.interval
        if (typeof stx.layout.interval == 'number' && stx.layout.timeUnit) {
          displayPeriodicity = stx.layout.interval * stx.layout.periodicity
          displayInterval = stx.layout.timeUnit
        } else if (
          typeof stx.layout.interval == 'number' &&
          !stx.layout.timeUnit
        ) {
          displayPeriodicity = stx.layout.interval * stx.layout.periodicity
          displayInterval = 'minute'
        }
        if (displayPeriodicity % 60 === 0 && displayInterval == 'minute') {
          displayPeriodicity /= 60
          displayInterval = 'hour'
        }
        return (
          displayPeriodicity +
          ' ' +
          stx.translateIf(displayInterval.capitalize())
        )
      }

      /**
       * Creates a document node which facilitates translation to other languages, if stx.translationCallback callback function is set.
       * If there is no translationCallback, a standard text node is returned.
       * @param  {CIQ.ChartEngine} stx The chart object
       * @param  {string} english The word to translate
       * @param {string} [language] Optional language. Defaults to CIQ.I18N.language.
       * @return {HTMLElement}	A node in the following form if translationCallback exists:
       * 					<language original="english">translation</language>
       * 							If it does not exist, a text node is returned.
       * @memberof CIQ
       */
      CIQ.translatableTextNode = function(stx, english, language) {
        if (stx.translationCallback) {
          var translationNode = document.createElement('translate')
          translationNode.setAttribute('original', english)
          translationNode.innerHTML = stx.translationCallback(english, language)
          return translationNode
        }
        return document.createTextNode(english)
      }

      /**
       * <span class="animation">Animation Loop</span>
       * Clears the canvas. Uses the fastest known method except on the legacy Android browser which had many problems!
       * @param  {object} canvas A valid HTML canvas object
       * @param  {object} [stx]    A chart object, only necessary for old Android browsers on problematic devices
       * @memberof CIQ
       */
      CIQ.clearCanvas = function(canvas, stx) {
        canvas.isDirty = false
        var ctx = canvas.context
        ctx.clearRect(0, 0, canvas.width, canvas.height)
        if (CIQ.isAndroid && !CIQ.is_chrome) {
          // Android browser last remaining
          // one to need this clearing method
          if (CIQ.ChartEngine.useOldAndroidClear && stx) {
            ctx.fillStyle = stx.containerColor
            ctx.fillRect(0, 0, canvas.width, canvas.height)
            ctx.clearRect(0, 0, canvas.width, canvas.height)
          }
          var w = canvas.width
          canvas.width = 1
          canvas.width = w
        }
      }

      CIQ.monthLetters = [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D',
      ]
      CIQ.monthAbv = [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec',
      ]

      /* Enumerated types for time units */
      CIQ.MILLISECOND = 1
      CIQ.SECOND = 1000
      CIQ.MINUTE = 60 * CIQ.SECOND
      CIQ.HOUR = 60 * CIQ.MINUTE
      CIQ.DAY = 24 * CIQ.HOUR
      CIQ.WEEK = 7 * CIQ.DAY
      CIQ.MONTH = 31 * CIQ.DAY
      CIQ.YEAR = 366 * CIQ.DAY
      CIQ.DECADE = 10 * CIQ.YEAR - 7 * CIQ.DAY

      /**
       * Convenience function for creating a displayable month name using CIQ.monthLetters and CIQ.monthAbv.
       * Please note that those arrays may not be utilized if the library is used in conjunction with Internationalization.
       * This method is used primarily to create the x-axis of a chart
       * @param  {number} i              The numerical month (0-11)
       * @param  {boolean} displayLetters - True if just the first letter should be displayed (such as a tight display)
       * @param  {object} [stx]            The chart object, only necessary if Internationalization is in use
       * @return {string}                String representation of the month
       * @memberof CIQ
       */
      CIQ.monthAsDisplay = function(i, displayLetters, stx) {
        if (displayLetters) {
          if (stx && stx.monthLetters) return stx.monthLetters[i]
          return CIQ.monthLetters[i]
        }
        if (stx && stx.monthAbv) return stx.monthAbv[i]
        return CIQ.monthAbv[i]
      }

      /**
       * Displays a time in readable form. If Internationalization is in use then the time will be in 24 hour Intl numeric format
       * @param  {date} dt  JavaScript Date object
       * @param  {object} [stx] Optional chart object if Internationalization is in use
       * @param {number} [precision] Optional precision to use. If `null` then `hh:mm`. `CIQ.SECOND` then `hh:mm:ss`. If `CIQ.MILLISECOND` then `hh:mm:ss.mmmmm`
       * @return {string}     Human friendly time, usually hh:mm
       * @memberof CIQ
       */
      CIQ.timeAsDisplay = function(dt, stx, precision) {
        var internationalizer = stx ? stx.internationalizer : null
        if (internationalizer) {
          if (precision == CIQ.SECOND)
            return internationalizer.hourMinuteSecond.format(dt)
          else if (precision == CIQ.MILLISECOND)
            return (
              internationalizer.hourMinuteSecond.format(dt) +
              '.' +
              dt.getMilliseconds()
            )
          return internationalizer.hourMinute.format(dt)
        }
        var min = dt.getMinutes()
        if (min < 10) min = '0' + min
        var str = dt.getHours() + ':' + min
        var sec = ''
        if (precision <= CIQ.SECOND) {
          sec = dt.getSeconds()
          if (sec < 10) sec = '0' + sec
          str += ':' + sec
        }
        if (precision == CIQ.MILLISECOND) {
          var msec = dt.getMilliseconds()
          if (msec < 10) msec = '00' + msec
          else if (msec < 100) msec = '0' + msec
          str += '.' + msec
        }
        return str
      }

      /**
       * Displays a date according to the chart settings. It will format the date according to the folllowing order:
       * 1. xAxis formatter
       * 2. Internationalization
       * 3. default
       * 		a. Daily: mm-dd-yyyy
       * 		b. Intraday: mm/dd hh:mm[:ss[:ms]]
       * @param  {CIQ.ChartEngine} stx	  The charting object
       * @param  {CIQ.ChartEngine.Chart} chart	The specific chart
       * @param  {date} dt 	JavaScript date
       * @return {string}		Formatted date
       * @memberof CIQ
       * @since 4.0.0
       */
      CIQ.displayableDate = function(stx, chart, dt) {
        function twoPlaces(val) {
          if (val < 10) return '0' + val
          return val
        }
        var displayableDate = ''
        var interval = stx.layout.interval
        var isDaily = CIQ.ChartEngine.isDailyInterval(interval)
        if (chart.xAxis.formatter) {
          displayableDate = chart.xAxis.formatter(dt)
        } else if (stx.internationalizer) {
          displayableDate = stx.internationalizer.monthDay.format(dt)
          if (!isDaily)
            displayableDate += ' ' + stx.internationalizer.hourMinute.format(dt)
          else {
            if (interval == 'month')
              displayableDate = stx.internationalizer.yearMonth.format(dt)
            else displayableDate = stx.internationalizer.yearMonthDay.format(dt)
          }
        } else {
          var m = twoPlaces(dt.getMonth() + 1)
          var d = twoPlaces(dt.getDate())
          var h = twoPlaces(dt.getHours())
          var mn = twoPlaces(dt.getMinutes())
          if (isDaily) {
            displayableDate = interval == 'month' ? m + '-' : m + '-' + d + '-'
            displayableDate += dt.getFullYear()
          } else {
            displayableDate = m + '/' + d + ' ' + h + ':' + mn
            var isSecond =
              (chart.xAxis.activeTimeUnit &&
                chart.xAxis.activeTimeUnit <= CIQ.SECOND) ||
              stx.layout.timeUnit == 'second'
            var isMS =
              (chart.xAxis.activeTimeUnit &&
                chart.xAxis.activeTimeUnit <= CIQ.MILLISECOND) ||
              stx.layout.timeUnit == 'millisecond'
            if (isSecond || isMS) {
              var sec = twoPlaces(dt.getSeconds())
              displayableDate += ':' + sec

              if (isMS) {
                var mil = twoPlaces(dt.getMilliseconds())
                if (mil < 100) mil = '0' + mil
                displayableDate += ':' + mil
              }
            }
          }
        }
        return displayableDate
      }

      /**
       * Given a numeric price that may be a float with rounding errors, this will trim off the trailing zeroes
       * @param  {number} price The price
       * @return {number}       The price trimmed of trailing zeroes
       * @memberof CIQ
       */
      CIQ.fixPrice = function(price) {
        if (!price && price !== 0) return null
        var p = price.toFixed(10)
        for (var i = p.length - 1; i > 1; i--) {
          if (p.charAt(i) != '0') break
        }
        p = p.substring(0, i + 1)
        return parseFloat(p)
      }

      /**
       * Condenses a number into abbreviated form by adding "k","m","b" or "t".
       * This method is used in the y-axis for example with volume studies.
       * @param  {number} txt - A numerical value
       * @return {string}     Condensed version of the number if over 999, otherwise returnes `txt` untouched
       * @example
       * // This will return 12m
       * condentInt(12000000);
       * @memberof CIQ
       * @since 4.0.0 now returns `txt` untouched if under 1000. Previously was removing all decimal places.
       */
      CIQ.condenseInt = function(txt) {
        if (txt === null || typeof txt == 'undefined') return ''
        if (txt === Infinity || txt === -Infinity) return 'n/a'
        if (txt > 0) {
          if (txt > 1000000000000)
            txt = Math.round(txt / 100000000000) / 10 + 't'
          else if (txt > 100000000000) txt = Math.round(txt / 1000000000) + 'b'
          //100b
          else if (txt > 10000000000)
            txt = (Math.round(txt / 100000000) / 10).toFixed(1) + 'b'
          //10.1b
          else if (txt > 1000000000)
            txt = (Math.round(txt / 10000000) / 100).toFixed(2) + 'b'
          //1.11b
          else if (txt > 100000000) txt = Math.round(txt / 1000000) + 'm'
          //100m
          else if (txt > 10000000)
            txt = (Math.round(txt / 100000) / 10).toFixed(1) + 'm'
          //10.1m
          else if (txt > 1000000)
            txt = (Math.round(txt / 10000) / 100).toFixed(2) + 'm'
          //1.11m
          else if (txt > 100000) txt = Math.round(txt / 1000) + 'k'
          //100k
          else if (txt > 10000)
            txt = (Math.round(txt / 100) / 10).toFixed(1) + 'k'
          //10.1k
          else if (txt > 1000)
            txt = (Math.round(txt / 10) / 100).toFixed(2) + 'k'
          //1.11k
          else txt = txt.toString()
        } else {
          if (txt < -1000000000000)
            txt = Math.round(txt / 100000000000) / 10 + 't'
          else if (txt < -1000000000)
            txt = Math.round(txt / 100000000) / 10 + 'b'
          else if (txt < -1000000) txt = Math.round(txt / 100000) / 10 + 'm'
          else if (txt < -1000) txt = Math.round(txt / 100) / 10 + 'k'
          else txt = txt.toString()
        }
        return txt
      }

      /**
       * Determines how many decimal places the security trades. This is a callback from CIQ.ChartEngine.calculateTradingDecimalPlaces and you
       * can override this with your own functionality. The default algorithm is to check the most recent 50 quotes and find the maximum number
       * of decimal places that the stock has traded. This will work for most securities but if your market data feed has rounding errors
       * or bad data then you may want to supplement this algorithm that checks the maximum value by security type.
       * @param {object} params Parameters
       * @param  {CIQ.ChartEngine} params.stx    The chart object
       * @param {CIQ.ChartEngine.Chart} params.chart The chart in question
       * @param  {object} params.symbol The symbol object. If you create charts with just stock symbol then symbolObject.symbol will contain that symbol
       * @return {number}        The number of decimal places
       * @memberof CIQ
       */
      CIQ.calculateTradingDecimalPlaces = function(params) {
        var chart = params.chart
        var decimalPlaces = 2
        var quotesToCheck = 50 // Check up to 50 recent quotes
        var masterData = chart.masterData
        if (masterData && masterData.length > quotesToCheck) {
          // exclude the current quote by setting i=2 in case animation is enabled. Animation uses very large decimals to allow for smooth movements.
          for (var i = 2; i < quotesToCheck; i++) {
            var position = masterData.length - i
            if (position < 0) break
            var quotes = masterData[position]
            if (quotes.Close && typeof quotes.Close == 'number') {
              var cs = quotes.Close.toString()
              var point = cs.indexOf('.')
              if (point != -1) {
                var dp = cs.length - point - 1
                if (dp > decimalPlaces) {
                  decimalPlaces = dp
                }
              }
            }
          }
        }
        var maxDecimalPlaces = chart.yAxis.maxDecimalPlaces
        if (decimalPlaces > maxDecimalPlaces) decimalPlaces = maxDecimalPlaces
        return decimalPlaces
      }

      /**
       * Fills an area on the chart, usually created by a study.
       * @param  {CIQ.ChartEngine} stx    The chart object
       * @param  {array} points  The set of points, this is an array of chart coordinates in array form
       * 							e.g. [[x1,y1],[x2,y2]].  The points should be arranged to form a loop;
       * 							the loop need not be closed.
       * @param  {object} params  parameters
       * @param  {string} [params.color]  color to fill the area
       * @param  {number} [params.opacity] opacity of fill, 0 to 1.  Defaults to 0.1
       * @param  {number} [params.tension] Tension for splining. Requires "js/thirdparty/splines.js"
       * @param  {string} [params.panelName] optional Name of panel to draw on.  If omitted or invalid, area may fill over top or bottom of plot area
       * @since
       * <br>&bull; 01-2015-20 `params.panelName` added
       * <br>&bull; 4.0.0 Combined arguments into params, added tension
       * @memberof CIQ
       */
      CIQ.fillArea = function(stx, points, params) {
        if (!points.length) return
        var ctx = stx.chart.context
        var globalAlpha = ctx.globalAlpha
        var color = arguments[2],
          opacity = arguments[3],
          panelName = arguments[4],
          tension = 0
        if (params && typeof params == 'object') {
          color = params.color
          opacity = params.opacity
          tension = params.tension
          panelName = params.panelName
        }
        if (!opacity && opacity !== 0) opacity = 0.2
        if (color == 'auto') color = stx.defaultColor
        ctx.globalAlpha = opacity
        if (color) ctx.fillStyle = color

        var b = Number.MAX_VALUE
        var t = b * -1
        var panel = stx.panels[panelName]
        if (panel) {
          t = panel.yAxis.top
          b = panel.yAxis.bottom
          ctx.save()
          ctx.beginPath()
          ctx.rect(panel.left, t, panel.width, b - t)
          ctx.clip()
        }
        ctx.beginPath()
        var i
        if (tension) {
          var flatPoints = []
          for (i = 0; i < points.length - 2; i++) {
            flatPoints.push(points[i][0], points[i][1])
          }
          splinePlotter.plotSpline(flatPoints, tension, ctx)
          for (i = points.length - 2; i < points.length; i++) {
            ctx.lineTo(Math.round(points[i][0]), Math.round(points[i][1]))
            // Chrome 58/59 issue with gradient fills.  Less severe if we round these last 2 points.
          }
        } else {
          ctx.moveTo(points[0][0], points[0][1])
          for (i = 1; i < points.length; i++) {
            ctx.lineTo(points[i][0], points[i][1])
          }
        }
        ctx.closePath()
        ctx.fill()
        if (panel) ctx.restore()

        ctx.globalAlpha = globalAlpha
      }

      /**
       * Fills an area on the chart delimited by non intersecting top and bottom bands (channel), usually created by a study.
       * @param {CIQ.ChartEngine} stx The chart object
       * @param {object} parameters The configuration parameters
       * @param {string} parameters.panelName The name of the panel
       * @param {boolean} parameters.noSlopes If set then chart will fill rectangles with no transition lines between levels
       * @param {string} parameters.topBand The name of the quote field to use as the top band
       * @param {string} parameters.bottomBand The name of the quote field to use as the bottom band
       * @param {number} parameters.opacity The color opacity/transparency as a decimal number (1= full opacity / no transparency)
       * @param {string} parameters.color The fill color
       * @memberof CIQ
       * @since 4.1.2 Removed quotes argument; function always uses dataSegment.
       * @example
       * CIQ.prepareChannelFill(stx,{"color":dngradient,"opacity":1,"panelName":sd.name,"topBand":"Zero "+sd.name,"bottomBand":"Under "+sd.name});
       */
      CIQ.prepareChannelFill = function(stx, parameters) {
        if (!parameters || parameters instanceof Array)
          parameters = arguments[2] // backwards compatibility for when quotes was the second argument
        var panel = stx.panels[parameters.panelName],
          chart = stx.chart,
          strokeStyle = chart.context.strokeStyle
        var saveParams = { noDraw: parameters.noDraw }
        var chParams = CIQ.ensureDefaults(parameters, {
          noDraw: true,
          yAxis: panel.yAxis,
        })
        var rcTop = stx.plotDataSegmentAsLine(
          parameters.topBand,
          panel,
          chParams
        )
        var rcBottom = stx.plotDataSegmentAsLine(
          parameters.bottomBand,
          panel,
          chParams
        )
        parameters.noDraw = saveParams.noDraw
        parameters.gaps = saveParams.gaps
        var points = []
        for (var t = 0; t < rcTop.points.length; t += 2) {
          points.push([rcTop.points[t], rcTop.points[t + 1]])
        }
        for (var b = rcBottom.points.length - 1; b >= 0; b -= 2) {
          points.push([rcBottom.points[b - 1], rcBottom.points[b]])
        }
        CIQ.fillArea(stx, points, parameters)
        return
      }

      /**
       * Fills an area on the chart delimited by a series line closed off by a horizontal threshold line, usually created by a study.
       * @param {CIQ.ChartEngine} stx The chart object
       * @param {object} parameters The configuration parameters
       * @param {string} [parameters.panelName] The name of the panel
       * @param {string} [parameters.band] The name of the quote field to use as the series line
       * @param {number} [parameters.threshold] The price where the horizontal line hits yaxis/series to enclose the fill area.  If not set will look to parameters.reverse to determine if threshold is the lowest or highest value of the plot.
       * @param {boolean} [parameters.reverse] Valid only if parameters.threshold is not set.  If this parameter is set to true, threshold will be highest value of plot.  Otherwise, threshold will be lowest value of plot.
       * @param {number} [parameters.direction] 1 to fill from the threshold upwards or -1 to fill from the threshold downwards
       * @param {object} [parameters.edgeHighlight] Set to either a color or a Styles object as returned from {@link CIQ.ChartEngine#canvasStyle} to draw the threshold line.
       * @param {object} [parameters.edgeParameters] The parameters to draw the threshold line as required by {@link CIQ.ChartEngine#plotLine}
       * @param {object} [parameters.gaps] Gap object as set by See {@link CIQ.ChartEngine#setGapLines}.
       * @param {number} [parameters.opacity] The color opacity/transparency as a decimal number (1= full opacity / no transparency).  Default is 0.3.
       * @param {boolean} [parameters.step] True for a step chart
       * @param {number} [parameters.tension] Tension for splining. Requires "js/thirdparty/splines.js"
       * @param {string} [parameters.color] The fill color
       * @memberof CIQ
       * @since
       * <br>&bull; 4.0.0 Added `parameters.reverse`, made `parameters.threshold` optional in case filling to top or bottom of panel
       * <br>&bull; 4.1.2 Removed quotes argument; function always uses dataSegment.
       * @example
       * if(sd.outputs.Gain) CIQ.preparePeakValleyFill(stx,{panelName:sd.panel, band:"Result " + sd.name, threshold:sd.study.centerline, direction:1, color:sd.outputs.Gain});
       * if(sd.outputs.Loss) CIQ.preparePeakValleyFill(stx,{panelName:sd.panel, band:"Result " + sd.name, threshold:sd.study.centerline, direction:-1, color:sd.outputs.Loss});
       */
      CIQ.preparePeakValleyFill = function(stx, parameters) {
        if (!parameters || parameters instanceof Array)
          parameters = arguments[2] // backwards compatibility for when quotes was the second argument
        var panel = stx.panels[parameters.panelName],
          yAxis = panel.yAxis,
          chart = stx.chart,
          context = chart.context,
          strokeStyle = context.strokeStyle
        var saveParams = { noDraw: parameters.noDraw }
        var rc = stx.plotDataSegmentAsLine(
          parameters.band,
          panel,
          CIQ.ensureDefaults(parameters, { noDraw: true })
        )
        parameters.noDraw = saveParams.noDraw
        var threshold = parameters.threshold,
          direction = parameters.direction,
          reverse = parameters.reverse,
          gaps = parameters.gaps
        if (parameters.yAxis) yAxis = parameters.yAxis
        var yMax = -Number.MAX_VALUE,
          yMin = Number.MAX_VALUE,
          yThresh = reverse ? yMax : yMin
        if (threshold || threshold === 0)
          yThresh = stx.pixelFromPrice(threshold, panel, yAxis) //where threshold hits yaxis

        var points = [],
          length = rc.points.length
        for (var i = 0; i < length; i += 2) {
          var x = rc.points[i],
            y = rc.points[i + 1],
            x1,
            y1
          if (isNaN(y)) continue
          var limit =
            (y > yThresh && direction > 0) || (y < yThresh && direction < 0)
          if (!limit) {
            points.push([x, y])
            yMax = Math.max(y, yMax)
            yMin = Math.min(y, yMin)
          }
          if (i < length - 3) {
            x1 = rc.points[i + 2]
            y1 = rc.points[i + 3]
            if (
              (y < yThresh && y1 > yThresh) ||
              (y > yThresh && y1 < yThresh)
            ) {
              x += ((yThresh - y) * (x1 - x)) / (y1 - y)
              points.push([x, yThresh])
            }
          }
        }
        length = points.length
        if (!length) return

        var edgeParameters = parameters.edgeParameters,
          edgeHighlight = parameters.edgeHighlight
        if (edgeHighlight) {
          if (edgeParameters.lineWidth > 100) edgeParameters.lineWidth = 1 // trap case where no width is specified in the css
          for (var p = 0; p < length - 1; p++) {
            var point0 = points[p],
              point1 = points[p + 1]
            if (point0[1] == yThresh && point1[1] == yThresh) continue // here we avoid drawing a horizontal line along the threshold
            if (point0[0] == point1[0] && stx.layout.candleWidth >= 1) {
              // here we try to avoid drawing a vertical line to the threshold (like a gap boundary)
              if (
                point0[1] == yThresh &&
                points[p - 1] &&
                points[p - 1][1] == yThresh
              )
                continue
              if (
                point1[1] == yThresh &&
                points[p + 2] &&
                points[p + 2][1] == yThresh
              )
                continue
            }
            stx.plotLine(
              point0[0],
              point1[0],
              point0[1],
              point1[1],
              parameters.edgeHighlight,
              'segment',
              chart.context,
              true,
              edgeParameters
            )
          }
        }
        if (!threshold && threshold !== 0) {
          yThresh = reverse
            ? Math.min(yMin, yAxis.top)
            : Math.max(yMax, yAxis.bottom)
        }
        points.push([points[length - 1][0], yThresh], [points[0][0], yThresh])

        var opacity = parameters.opacity
        if (!opacity && opacity !== 0) parameters.opacity = 0.3
        CIQ.fillArea(stx, points, parameters)
        // Now fill in the mountain area under the gap, if required
        if (
          gaps &&
          gaps.color &&
          gaps.fillMountain &&
          !parameters.tension &&
          !CIQ.isTransparent(gaps.color) &&
          !CIQ.isTransparent(
            parameters.color
          ) /*need this last check for baseline_mountain to render properly*/
        ) {
          context.save()
          if (context.fillStyle instanceof CanvasGradient) {
            var gradient = context.createLinearGradient(
              0,
              direction === 1 ? panel.top : panel.bottom,
              0,
              yThresh
            )
            gradient.addColorStop(
              0,
              CIQ.hexToRgba(CIQ.colorToHex(gaps.color), 60)
            )
            gradient.addColorStop(
              1,
              CIQ.hexToRgba(CIQ.colorToHex(gaps.color), 10)
            )
            context.fillStyle = gradient
          } else {
            context.fillStyle = gaps.color
          }
          var poly = []
          var myParams = {
            opacity: parameters.opacity,
            panelName: parameters.panelName,
          }
          for (i = 0; i < rc.gapAreas.length; i++) {
            var datum = rc.gapAreas[i]
            var start = datum.start
            var end = datum.end
            var thresh = datum.threshold
            if (start) {
              poly = [[start[0], start[1]], [start[0], thresh]]
            } else {
              poly.push(
                [end[0], thresh],
                [end[0], parameters.step ? poly[0][1] : end[1]]
              )
            }
            if (poly.length == 4) {
              CIQ.fillArea(stx, poly, myParams)
              if (parameters.step) {
                stx.plotLine(
                  poly[0][0],
                  poly[3][0],
                  poly[0][1],
                  poly[0][1],
                  gaps,
                  'segment',
                  context,
                  true,
                  gaps
                )
                stx.plotLine(
                  poly[3][0],
                  poly[3][0],
                  poly[0][1],
                  poly[3][1],
                  gaps,
                  'segment',
                  context,
                  true,
                  gaps
                )
              } else {
                stx.plotLine(
                  poly[0][0],
                  poly[3][0],
                  poly[0][1],
                  poly[3][1],
                  gaps,
                  'segment',
                  context,
                  true,
                  gaps
                )
              }
            }
          }
          context.restore()
        }
        parameters.opacity = opacity
      }

      /**
	 * Fills an area on the chart delimited by intersecting bands.
	 *
	 * Bands can be anchored by different y-axis as determined by the `parameters.topAxis` and `parameters.bottomAxis` parameters.
	 * @param {CIQ.ChartEngine} stx The chart object
	 * @param {string} panelName The name of the panel
	 * @param {object} parameters The configuration parameters
	 * @param {string} parameters.topBand The name of the quote field to use as the top band
	 * @param {string} parameters.bottomBand The name of the quote field to use as the bottom band
	 * @param {string} parameters.topSubBand Optional name of the field within the top band to use, for example when plotting a series
	 * @param {string} parameters.bottomSubBand Optional name of the field within the bottom band to use, for example when plotting a series
	 * @param {string} parameters.topColor The color of the top band, used to fill in a cloud whose top edge is the topBand
	 * @param {string} parameters.bottomColor The color the bottom band, used to fill in a cloud whose top edge is the bottomBand
	 * @param {number} [parameters.tension] Tension for splining. Requires "js/thirdparty/splines.js"
	 * @param {CIQ.ChartEngine.YAxis} parameters.topAxis The y-axis for the top band (will use default axis if not specified)
	 * @param {CIQ.ChartEngine.YAxis} parameters.bottomAxis The y-axis for the bottom band (will use default axis if not specified)
	 * @param {boolean} parameters.skipTransform If true then any transformations (such as comparison charting) will not be applied
		 * @param {number} parameters.opacity The color opacity/transparency as a decimal number (1= full opacity / no transparency).  Default is 0.3.
	 * @memberof CIQ
	 * @since
	 * <br>&bull; 4.0.0 Changed `sd` argument to `panelName` argument, added `parameters.topColor`, `parameters.bottomColor`, `parameters.opacity` and `parameters.skipTransform`, removed `parameters.fillFuture`
	 * <br>&bull; 4.1.2 Removed quotes argument; function always uses dataSegment.
	 * @example
		var parameters={
			topBand: "Leading Span A " + sd.name,
			bottomBand: "Leading Span B " + sd.name,
			topColor: "green",
			bottomColor: "red"
		};
		CIQ.fillIntersecting(stx, sd.panel, parameters)
	 */
      CIQ.fillIntersecting = function(stx, panelName, parameters) {
        if (!parameters || parameters instanceof Array)
          parameters = arguments[3] // backwards compatibility for when quotes was the second argument
        var topBand = parameters.topBand,
          bottomBand = parameters.bottomBand
        var topSubBand = parameters.topSubBand,
          bottomSubBand = parameters.bottomSubBand
        var topColor = parameters.topColor,
          bottomColor = parameters.bottomColor
        var panel = panelName
        if (panel.panel) {
          // backwards compatibility, where this argument is really a studyDescriptor
          if (panel.outputs && panel.outputMap) {
            if (!topColor) topColor = panel.outputs[panel.outputMap[topBand]]
            if (!bottomColor)
              bottomColor = panel.outputs[panel.outputMap[bottomBand]]
          }
          panel = panel.panel
        }
        panel = stx.panels[panel]

        //make a copy of what's there now
        var context = stx.chart.context
        var sctx = stx.scratchContext
        if (!sctx) {
          var scratchCanvas = context.canvas.cloneNode(true)
          sctx = stx.scratchContext = scratchCanvas.getContext('2d')
          sctx.canvas = scratchCanvas
        }
        sctx.canvas.height = context.canvas.height
        sctx.canvas.width = context.canvas.width
        sctx.drawImage(context.canvas, 0, 0)
        context.clearRect(0, 0, context.canvas.width, context.canvas.height)

        //then fill the intersections
        var alpha = 0.3
        if (parameters.opacity) alpha = parameters.opacity
        context.save()
        context.globalCompositeOperation = 'xor'

        var params = {
          band: topBand,
          subField: topSubBand,
          color: topColor,
          opacity: 1,
          panelName: panel.name,
          yAxis: parameters.topAxis,
          skipTransform: parameters.skipTransform,
          tension: parameters.tension,
        }
        CIQ.preparePeakValleyFill(stx, params)

        CIQ.extend(params, {
          band: bottomBand,
          subField: bottomSubBand,
          color: bottomColor,
          yAxis: parameters.bottomAxis,
        })
        CIQ.preparePeakValleyFill(stx, params)

        //now redraw with correct alpha
        context.globalAlpha = alpha
        context.globalCompositeOperation = 'copy'
        context.scale(
          1 / stx.adjustedDisplayPixelRatio,
          1 / stx.adjustedDisplayPixelRatio
        )
        context.drawImage(context.canvas, 0, 0)

        //finally, restore what we copied, but _under_ the intersected fills we just made
        context.globalAlpha = 1
        context.globalCompositeOperation = 'destination-over'
        context.drawImage(stx.scratchContext.canvas, 0, 0)

        context.restore()
      }

      /**
       * Draws an item in the legend and returns the position for the next item
       * @param {CIQ.ChartEngine} stx The chart object
       * @param  {array} xy    An X,Y tuple (from chart.legend)
       * @param  {string} label The text to print in the item
       * @param  {string} color The color for the background of the item
       * @return {array}       A tuple containing the X,Y position for the next the item
       * @memberof CIQ
       */
      CIQ.drawLegendItem = function(stx, xy, label, color, opacity) {
        if (!opacity) opacity = 1
        var x = xy[0],
          y = xy[1],
          w = 10,
          h = 10
        var context = stx.chart.context
        context.globalAlpha = opacity
        context.fillStyle = color
        context.fillRect(x, y, w, h)
        context.globalAlpha = 1
        x += w + 2 // 2 px spacing between box and text
        context.fillStyle = stx.defaultColor
        context.fillText(label, x, y)
        x += context.measureText(label).width + 6 // 6 px spacing between labels
        return [x, y]
      }

      /**
       * Draws a legend for the series that are displayed on the chart.
       * @param {CIQ.ChartEngine} stx The chart object to draw
       * @param  {object} params parameters for drawing the legend
       * @param  {CIQ.ChartEngine.Chart} [params.chart] The chart object
       * @param  {object} [params.legendColorMap] A map of series names to colors and display symbols ( example  IBM:{color:'red', display:'Int B M'} )
       * @param  {object} [params.coordinates] Coordinates upon which to draw the items, in pixels relative to top left of panel ( example  {x:50, y:0} ).  If null, uses chart.legend
       * @param  {boolean} [params.noBase] Set to true to not draw the base (the chart symbol's color) in the legend
       * @memberof CIQ
       */
      CIQ.drawLegend = function(stx, params) {
        var coordinates = params.coordinates
        var context = stx.chart.context
        context.textBaseline = 'top'
        var rememberFont = context.font
        stx.canvasFont('stx-legend', context)

        if (!coordinates) coordinates = params.chart.legend
        var xy = [coordinates.x, coordinates.y]
        var lineColor = stx.defaultColor

        for (var i = 0; i < 2; i++) {
          // loop twice, first for the base then again for the series
          for (var field in params.legendColorMap) {
            var legendItem = params.legendColorMap[field]
            if (legendItem.isBase && (i || params.noBase)) continue
            if (!legendItem.isBase && !i) continue
            var c
            if (legendItem.color instanceof Array) {
              var colors = legendItem.color
              for (c = colors.length - 1; c >= 0; c--) {
                if (CIQ.isTransparent(colors[c])) colors.splice(c, 1)
              }
              if (colors.length > 1) {
                var grd = context.createLinearGradient(
                  xy[0],
                  xy[1],
                  xy[0] + 10,
                  xy[1]
                )
                for (c = 0; c < colors.length; c++) {
                  grd.addColorStop(c / (colors.length - 1), colors[c])
                }
                lineColor = grd
              } else if (colors.length > 0) {
                lineColor = colors[0]
              } else {
                lineColor = stx.getCanvasColor('stx_line_chart')
              }
            } else {
              lineColor = null
            }
            if (lineColor) {
              var display = field
              if (legendItem.display) {
                display = legendItem.display
              }
              if (!display) {
                if (params.chart.symbolDisplay) {
                  display = params.chart.symbolDisplay
                } else {
                  display = params.chart.symbol
                }
              }
              xy = CIQ.drawLegendItem(
                stx,
                xy,
                display,
                lineColor,
                legendItem.opacity
              )
            }
          }
        }
        context.font = rememberFont
      }

      /**
       * This method will return an tuple [min,max] that contains the minimum
       * and maximum values in the series where values are series[field]
       * @param {array} series The series
       * @param {string} field The name of the series to look at
       * @param {string} subField The name of the field within the series to look at
       * @param {boolean} highLow True when comparing max High/min Low vs a specific field
       * @return {array} Tuple containing min and max values in the series
       * @memberof CIQ
       * @since 5.1.0 added subField, highLow arguments
       */
      CIQ.minMax = function(series, field, subField, highLow) {
        var min = Number.MAX_VALUE
        var max = Number.MAX_VALUE * -1
        if (!subField) subField = 'Close'
        var highField = highLow ? 'High' : subField
        var lowField = highLow ? 'Low' : subField
        for (var i = 0; i < series.length; i++) {
          var entry = series[i]
          if (!entry) continue
          var fVal = entry[field]
          if (!fVal && fVal !== 0) continue
          var sfVal = fVal
          if (typeof fVal === 'object') sfVal = fVal[highField]
          if (!isNaN(sfVal) && (sfVal || sfVal === 0)) {
            max = Math.max(max, sfVal)
          }
          if (typeof fVal === 'object') sfVal = fVal[lowField]
          if (!isNaN(sfVal) && (sfVal || sfVal === 0)) {
            min = Math.min(min, sfVal)
          }
        }
        return [min, max]
      }

      /**
       * Returns true if two symbols match. Symbols can be strings or symbolObjects. By default, the "symbol" member is compared, and then
       * a "source" member if one exists.
       * If the objects have an "equals()" function member then that will be used for comparison.
       * You can override this with your own method if you have other requirements.
       * @param  {object} left  Symbol object
       * @param  {object} right Symbol object
       * @return {boolean}       true if the same
       * @memberOf  CIQ
       */
      CIQ.symbolEqual = function(left, right) {
        if (!left || !right) return false
        if (typeof left != 'object') left = { symbol: left }
        if (typeof right != 'object') right = { symbol: right }
        if (typeof left.equals == 'function') {
          return left.equals(right)
        }
        var l = left.symbol
        var r = right.symbol
        if (l) l = l.toUpperCase()
        if (r) r = r.toUpperCase()
        if (l != r) return false
        if (left.source != right.source) return false
        return true
      }

      /**
       * Convenience function to iterate through the charts masterData and add a data member.
       * Generally used for additional comparison or study symbols.
       * Can be used with any array of data objects which contains at least the 'DT' (date in javascript format) and 'Close' ( close/last price ) elements of an [OHLC object](index.html#data-format).
       * @param {object} params Parameters object
       * @param {CIQ.ChartEngine} [params.stx]       	A chart object
       * @param {array} [params.data]		 			The data to add (which should align or closely align with the chart data by date)
       * @param {array} [params.fields] 				The fields from the incoming data objects to extract and add as the new members in each masterData object. One new member will be added per field using the exact same name as in the incoming data. Example: (for each filed name in the array) masterData[mIterator][fieldN]=data[dIterator][fieldN]. Takes precedence over `createObject`, `label` and `fieldForLabel` parameters.  Use fields=["*"] to copy all fields in the data object.
       * @param {string} [params.label]     			The name of the new member to add into each masterData object. Example: masterData[mIterator][label]=data[dIterator]["Close"]. Required unless "fields" is specified.
       * @param {boolean} [params.createObject] 		If true, then each complete incoming data object will be assigned to the new label member in each masterData object. Example: masterData[mIterator][label]=data[dIterator]. This behavior is mutually exclusive with `fields`.
       * @param {string} [params.fieldForLabel="Close"] 	If set, this will be the field from each incoming data object that will be copied into the new label member in each masterData object. If not set, "Close" or "Value" is used, whichever exists; and if neither exists, it will attempt to copy over a filed matching the `label` name. Example: masterData[mIterator][label]=data[dIterator][fieldForLabel]. This behavior is mutually exclusive with `fields` and `createObject`.
       * @param {boolean} [params.fillGaps]			If true then gaps in data will be filled by carrying forward the value of from the previous bar.
       * @param {CIQ.ChartEngine.Chart} [params.chart]   The chart to update
       * @memberof CIQ
       * @example
       * //data element format if neither fields, fieldForLabel or createObject are used
       * {DT:epoch,Date:strDate,Value:value}
       * {DT:epoch,Date:strDate,Close:value }
       * //data element format if fields is used
       * {DT:epoch,Date:strDate,Field1:value,Field2:value,Field3:value,Field4:value}
       * //data element format if createObject is used
       * {DT:epoch,Date:strDate,AnyOtherData:otherData,MoreData:otherData,...}
       * @since
       * <br>&bull; 04-2015 added
       * <br>&bull; 15-07-01 fieldForLabel argument
       * <br>&bull; 3.0.0 all data sent in will be forced into the chart. Dates are no longer required to be exact matches (minutes, hours, seconds, milliseconds) in order to show up in comparisons.
       * <br>&bull; 4.0.0 Arguments are now parameterized. Backward compatibility with old signature.
       * <br>&bull; 4.0.0 Added ability to specify copying of all fields by setting params.fields=["*"]
       */
      CIQ.addMemberToMasterdata = function(params) {
        if (params.constructor === CIQ.ChartEngine) {
          params = {
            stx: arguments[0],
            label: arguments[1],
            data: arguments[2],
            fields: arguments[3],
            createObject: arguments[4],
            fieldForLabel: arguments[5],
          }
        }
        var stx = params.stx
        var label = params.label
        var data = params.data
        var fields = params.fields
        var createObject = params.createObject
        var fieldForLabel = params.fieldForLabel

        if (data && data.constructor == Object) data = [data] // When developer mistakenly sends an object instead of an array of objects
        if (!data || !data.length) return
        stx.doCleanupDates(data, stx.layout.interval)

        var chart = params.chart ? params.chart : stx.chart
        var mIterator = 0,
          cIterator = 0,
          masterData = chart.masterData,
          layout = stx.layout,
          m,
          c
        if (!masterData) {
          masterData = []
        }

        var defaultPlotField =
          stx.chart && stx.chart.defaultPlotField
            ? stx.chart.defaultPlotField
            : null
        var isLineType =
          !stx.chart.highLowBars && !stx.highLowBars[stx.layout.chartType]

        // inject data from c into m
        function injectData(m, c) {
          if (fields && fields.length) {
            // Case 1, copy the [several] specified fields from new object to masterData object
            if (fields[0] == '*') {
              // copy all fields
              CIQ.extend(m, c)
            } else {
              for (var i = 0; i < fields.length; i++) {
                m[fields[i]] = c[fields[i]]
              }
            }
          } else if (createObject) {
            // Case 2, the new object will become a child object of the masterData object
            m[label] = c
          } else if (fieldForLabel) {
            // Case 3, copy the data from one label (fieldForLabel) to another (label)
            m[label] = c[fieldForLabel]
          } else if (
            isLineType &&
            defaultPlotField &&
            c[defaultPlotField] !== undefined
          ) {
            // If a default field on the chart has been provided, then use that if it's in the new object
            m[label] = c[defaultPlotField]
          } else if (layout.adj && c.Adj_Close !== undefined) {
            // If Adjusted close is in the new object, use that
            m[label] = c.Adj_Close
          } else if (c.Close !== undefined) {
            // If Close is in the new object use that
            m[label] = c.Close
          } else if (c.Value !== undefined) {
            // If "Value" is in the new object use that
            m[label] = c.Value
          } else {
            // Default to copying the same label from the old to the new object.
            m[label] = c[label]
          }
        }

        // insert/update up to masterData last bar
        while (
          data &&
          mIterator < masterData.length &&
          cIterator < data.length
        ) {
          c = data[cIterator]
          m = masterData[mIterator]
          if (!c.DT || typeof c.DT == 'undefined')
            c.DT = CIQ.strToDateTime(c.Date)
          else {
            if (typeof c.DT == 'number') c.DT = new Date(c.DT) //in case they sent in an epoch
            if (!c.Date || c.Date.length != 17)
              c.Date = CIQ.yyyymmddhhmmssmmm(c.DT)
          }

          if (+c.DT == +m.DT) {
            injectData(m, c)
            cIterator++
            mIterator++
            continue
          }

          if (c.DT < m.DT) {
            masterData.splice(mIterator, 0, { DT: c.DT, Date: c.Date })
            continue
          } else mIterator++
        }

        // insert after master data last bar
        if (mIterator >= masterData.length) {
          while (data && cIterator < data.length) {
            c = data[cIterator]
            if (!c.DT || typeof c.DT == 'undefined')
              c.DT = CIQ.strToDateTime(c.Date)
            else {
              if (typeof c.DT == 'number') c.DT = new Date(c.DT) //in case they sent in an epoch
              if (!c.Date || c.Date.length != 17)
                c.Date = CIQ.yyyymmddhhmmssmmm(c.DT)
            }
            m = {
              DT: c.DT,
              Date: c.Date,
            }
            injectData(m, c)
            masterData.push(m)
            cIterator++
          }
        }
        if (params.fillGaps && masterData.length) {
          var lastQuote = masterData[0]
          // carry forward series
          for (var i = 1; i < masterData.length; i++) {
            var quote = masterData[i]
            if (fields) {
              for (var j = 0; j < fields.length; j++) {
                var field = fields[j]
                if (
                  typeof quote[field] == 'undefined' &&
                  typeof lastQuote[field] != 'undefined'
                )
                  quote[field] = lastQuote[field]
              }
            } else {
              if (
                typeof quote[label] == 'undefined' &&
                typeof lastQuote[label] != 'undefined'
              )
                quote[label] = lastQuote[label]
            }
            lastQuote = quote
          }
        }
        if (chart.series[label]) chart.series[label].lastQuote = m[label]
        stx.setMasterData(masterData, chart)
      }

      /**
       * Generates an object that can be used programatically to load new themes or to create a theme dialog to manage chart themes.
       * The initial values contain the existing values in the current chart.
       * Simply have your dialog modify these values and then call the method {@link CIQ.ThemeHelper#update}
       *
       * Note that the chart has many granular customizations beyond what this theme helper produces.
       * These can be manipulated in the CSS.
       * This helper simplifies and consolidates into a manageable set.
       *
       * @param {object} params Parameters
       * @param {CIQ.ChartEngine} params.stx A chart object
       * @constructor
       * @name  CIQ.ThemeHelper
       * @example
       * var helper=new CIQ.ThemeHelper({stx:stx});
       * console.log(helper.settings);
       * helper.settings.chart["Grid Lines"].color="rgba(255,0,0,.5)";
       * helper.update();
       */
      CIQ.ThemeHelper = function(params) {
        this.params = params
        var stx = params.stx
        var backgroundColor = '#FFFFFF'
        if (stx.chart.container) {
          backgroundColor = getComputedStyle(stx.chart.container)
            .backgroundColor
          if (CIQ.isTransparent(backgroundColor))
            backgroundColor = stx.containerColor
        }
        this.settings.chart.Background.color = CIQ.hexToRgba(backgroundColor)
        this.settings.chart['Grid Lines'].color = CIQ.hexToRgba(
          stx.canvasStyle('stx_grid').color
        )
        this.settings.chart['Grid Dividers'].color = CIQ.hexToRgba(
          stx.canvasStyle('stx_grid_dark').color
        )
        this.settings.chart['Axis Text'].color = CIQ.hexToRgba(
          stx.canvasStyle('stx_xaxis').color
        )

        this.settings.chartTypes['Candle/Bar'].up.color = CIQ.hexToRgba(
          stx.canvasStyle('stx_candle_up').color
        )

        this.settings.chartTypes['Candle/Bar'].down.color = CIQ.hexToRgba(
          stx.canvasStyle('stx_candle_down').color
        )
        this.settings.chartTypes['Candle/Bar'].up.wick = CIQ.hexToRgba(
          stx.canvasStyle('stx_candle_shadow_up').color
        )
        this.settings.chartTypes['Candle/Bar'].down.wick = CIQ.hexToRgba(
          stx.canvasStyle('stx_candle_shadow_down').color
        )
        this.settings.chartTypes['Candle/Bar'].even.wick = CIQ.hexToRgba(
          stx.canvasStyle('stx_candle_shadow_even').color
        )
        this.settings.chartTypes['Candle/Bar'].up.border = CIQ.hexToRgba(
          stx.canvasStyle('stx_candle_up').borderLeftColor
        )
        this.settings.chartTypes['Candle/Bar'].down.border = CIQ.hexToRgba(
          stx.canvasStyle('stx_candle_down').borderLeftColor
        )
        if (CIQ.isTransparent(stx.canvasStyle('stx_candle_up').borderLeftColor))
          this.settings.chartTypes['Candle/Bar'].up.border = null
        if (
          CIQ.isTransparent(stx.canvasStyle('stx_candle_down').borderLeftColor)
        )
          this.settings.chartTypes['Candle/Bar'].down.border = null

        this.settings.chartTypes.Line.color = CIQ.hexToRgba(
          stx.canvasStyle('stx_line_chart').color
        )

        this.settings.chartTypes.Mountain.color = CIQ.hexToRgba(
          stx.canvasStyle('stx_mountain_chart').backgroundColor
        )
      }

      /**
	 * Current theme settings. These are the settings that are ready to be loaded, or currently loaded.
	 * Modify as needed.
	 * To load these settings call {@link CIQ.ThemeHelper#update}
	 * @example
	 * //Default settings object structure
	 * 	"chart":{
			"Background":{
				"color":color1
			},
			"Grid Lines":{
				"color":color2
			},
			"Grid Dividers":{
				"color":color3
			},
			"Axis Text":{
				"color":color4
			}
		},
		"chartTypes":{
			"Candle/Bar":{
				"up":{
					"color":color5,
					"wick":color6,
					"border":color7
				},
				"down":{
					"color":color8,
					"wick":color9,
					"border":color10
				},
				"even":{
					"color":null,
					"wick":null,
					"border":null
				}
			},
			"Line":{
				"color":color11
			},
			"Mountain":{
				"color":color12
			}
		}
	 * @memberof CIQ.ThemeHelper
	 * @type object
	 */
      CIQ.ThemeHelper.prototype.settings = {
        chart: {
          Background: {
            color: null,
          },
          'Grid Lines': {
            color: null,
          },
          'Grid Dividers': {
            color: null,
          },
          'Axis Text': {
            color: null,
          },
        },
        chartTypes: {
          'Candle/Bar': {
            up: {
              color: null,
              wick: null,
              border: null,
            },
            down: {
              color: null,
              wick: null,
              border: null,
            },
            even: {
              color: null,
              wick: null,
              border: null,
            },
          },
          Line: {
            color: null,
          },
          Mountain: {
            color: null,
          },
        },
      }

      /**
	 * Call this method to activate the chart theme with values set in {@link CIQ.ThemeHelper#settings}
	 * @memberof CIQ.ThemeHelper
	 * @param {CIQ.ChartEngine} [stx] Optional chart engine to apply the changes to.
	 * @since  4.1.0 Added optional chart engine parameter.
	 * @example
	 * var helper=new CIQ.ThemeHelper({stx:stx});
	 * console.log(helper.settings);
	 * helper.settings=NewSettings;
	 * helper.update();

	 */
      CIQ.ThemeHelper.prototype.update = function(stx) {
        if (!stx) stx = this.params.stx
        var classMapping = {
          stx_candle_up: {
            stx_candle_up: true,
            stx_bar_up: true,
            stx_hollow_candle_up: true,
            stx_line_up: true,
            stx_baseline_up: true,
          },
          stx_candle_down: {
            stx_candle_down: true,
            stx_bar_down: true,
            stx_hollow_candle_down: true,
            stx_line_down: true,
            stx_baseline_down: true,
          },
          stx_shadow_up: { stx_candle_shadow_up: true },
          stx_shadow_down: { stx_candle_shadow_down: true },
          stx_shadow_even: { stx_candle_shadow_even: true },
          stx_line_chart: { stx_bar_chart: true, stx_line_chart: true },
          stx_grid: { stx_grid: true },
          stx_grid_dark: { stx_grid_dark: true },
          stx_xaxis: {
            stx_xaxis_dark: true,
            stx_xaxis: true,
            stx_yaxis: true,
            stx_yaxis_dark: true,
            stx_grid_border: true,
          },
          stx_mountain_chart: { stx_mountain_chart: true },
          stx_market_session: { stx_market_session: true },
        }

        stx.chart.container.style.backgroundColor = this.settings.chart.Background.color

        function setStyle(style, field, value) {
          var styles = classMapping[style]
          for (var s in styles) {
            stx.setStyle(s, field, value)
          }
        }

        setStyle('stx_grid', 'color', this.settings.chart['Grid Lines'].color)
        setStyle(
          'stx_grid_dark',
          'color',
          this.settings.chart['Grid Dividers'].color
        )
        setStyle('stx_xaxis', 'color', this.settings.chart['Axis Text'].color)

        var candleBar = this.settings.chartTypes['Candle/Bar']
        // backwards compatibility with pre-5.0.3 saved themes
        if (!candleBar.even) {
          candleBar.even = {
            color: null,
            wick: CIQ.hexToRgba(
              stx.canvasStyle('stx_candle_shadow_even').color
            ),
            border: null,
          }
        }
        setStyle('stx_candle_up', 'color', candleBar.up.color)
        setStyle('stx_candle_down', 'color', candleBar.down.color)
        setStyle('stx_shadow_up', 'color', candleBar.up.wick)
        setStyle('stx_shadow_down', 'color', candleBar.down.wick)
        setStyle('stx_shadow_even', 'color', candleBar.even.wick)

        // Only apply borders to candle, not the other types
        stx.setStyle('stx_candle_up', 'borderLeftColor', candleBar.up.border)
        stx.setStyle(
          'stx_candle_down',
          'borderLeftColor',
          candleBar.down.border
        )

        setStyle('stx_line_chart', 'color', this.settings.chartTypes.Line.color)

        stx.setStyle(
          'stx_mountain_chart',
          'borderTopColor',
          this.settings.chartTypes.Mountain.color
        )
        stx.setStyle(
          'stx_mountain_chart',
          'backgroundColor',
          CIQ.hexToRgba(this.settings.chartTypes.Mountain.color, 0.8)
        )
        stx.setStyle(
          'stx_mountain_chart',
          'color',
          CIQ.hexToRgba(this.settings.chartTypes.Mountain.color, 0.1)
        )
        stx.draw()
      }

      /**
       * Base class for interacting with a name value store.
       * This base class saves to local storage but you can override your own for remote storage,
       * as long as you maintain the same function signatures and call back requirements.
       *
       * See {@link CIQ.UI.ViewsMenu} for implementatin example.
       *
       * @constructor
       * @name  CIQ.NameValueStore
       */
      CIQ.NameValueStore = function() {}

      CIQ.NameValueStore.prototype.toJSONIfNecessary = function(obj) {
        if (obj.constructor == String) return obj
        try {
          var s = JSON.stringify(obj)
          return s
        } catch (e) {
          console.log('Cannot convert to JSON: ' + obj)
          return null
        }
      }

      CIQ.NameValueStore.prototype.fromJSONIfNecessary = function(obj) {
        try {
          var s = JSON.parse(obj)
          return s
        } catch (e) {
          return obj
        }
      }

      /**
       * Get a value from the name value store
       * @param  {string}   field The field to fetch
       * @param  {Function} cb    Callback. First field is error or null. Second field is the result.
       * @memberof CIQ.NameValueStore
       * @example
       * nameValueStore.get("myfield", function(err,data){
       *    if(!err){
       *        // do something with data
       *        if(cb) cb(errorCode, yourViewObject);
       *    }
       * });
       */
      CIQ.NameValueStore.prototype.get = function(field, cb) {
        var value = CIQ.localStorage.getItem(field)
        if (cb) cb(null, this.fromJSONIfNecessary(value))
      }

      /**
       * Set a value to the name value store
       * @param  {string}   field The field to fetch
       * @param  {string}   value The value to store
       * @param  {Function} cb    Callback
       * @memberof CIQ.NameValueStore
       * @example
       * nameValueStore.set("myfield", "myValue", function(){
       *        // do something after data has been saved
       *        if(cb) cb(errorCode);
       *    }
       * });
       */
      CIQ.NameValueStore.prototype.set = function(field, value, cb) {
        CIQ.localStorageSetItem(field, this.toJSONIfNecessary(value))
        if (cb) cb(null)
      }

      /**
       * Remove a field from the name value store
       * @param  {string}   field The field to remove
       * @param  {Function} cb    Callback
       * @memberof CIQ.NameValueStore
       * @example
       * nameValueStore.remove("myfield", function(){
       *        // do something after data has been removed
       *        if(cb) cb(errorCode);
       *    }
       * });
       */
      CIQ.NameValueStore.prototype.remove = function(field, cb) {
        CIQ.localStorage.removeItem(field)
        if (cb) cb(null)
      }

      /**
       * The Plotter is a device for managing complex drawing operations on the canvas. The HTML 5 canvas performs better when drawing
       * operations of the same color are batched (reducing the number of calls to the GPU). The plotter allows a developer to store those
       * operations in a normal control flow, and then have the Plotter deliver the primitives to the canvas. The plotter can also be used
       * as a caching mechanism for performing the same operations repeatedly. The y-axis of the chart uses this mechanism to boost performance.
       * @constructor
       * @name  CIQ.Plotter
       */
      CIQ.Plotter = function() {
        this.seriesArray = []
        this.seriesMap = {}
      }

      CIQ.Plotter.prototype = {
        /**
         * Define a series to plot. A series is a specific color and referenced by name
         * @param {string} name         Name of series
         * @param {boolean} strokeOrFill If true then a stroke operation, otherwise a fill operation
         * @param {string} color        A valid canvas color
         * @param {number} [opacity=1]      A valid opacity from 0-1
         * @param {number} [width=1]      A valid lineWidth from 1
         * @param {string} [pattern=solid]      A valid pattern (solid, dotted, dashed)
         * @memberof CIQ.Plotter
         * @since 4.0.0 added parameter pattern
         */
        Series: function(name, strokeOrFill, color, opacity, width, pattern) {
          this.name = name
          this.strokeOrFill = strokeOrFill
          this.color = color
          this.moves = []
          this.text = []
          if (!opacity || opacity > 1 || opacity < 0) opacity = 1
          this.opacity = opacity
          if (!width || width > 25 || width < 1) width = 1
          this.width = width
          this.pattern = CIQ.borderPatternToArray(width, pattern)
        },
        /**
         * Create a series. This supports either a text color or CIQ.ChartEngine.Style object
         * @see  CIQ.Plotter.Series
         * @memberof CIQ.Plotter
         */
        newSeries: function(name, strokeOrFill, colorOrStyle, opacity, width) {
          var series
          if (colorOrStyle.constructor == String)
            series = new this.Series(
              name,
              strokeOrFill,
              colorOrStyle,
              opacity,
              width
            )
          else
            series = new this.Series(
              name,
              strokeOrFill,
              colorOrStyle.color,
              colorOrStyle.opacity,
              width,
              colorOrStyle.borderTopStyle
            )
          this.seriesArray.push(series)
          this.seriesMap[name] = series
        },
        /**
         * Clear out any moves or text stored in the plotter for series "name"
         * @memberof CIQ.Plotter
         * @param {string} name Name of series to reset.  If omitted, will reset all series in plotter.
         * @since 3.0.0
         */
        reset: function(name) {
          for (var s in this.seriesMap) {
            if (name && name != s) continue
            var series = this.seriesMap[s]
            if (series) {
              series.moves = []
              series.text = []
            }
          }
        },
        /**
         * @memberof CIQ.Plotter
         */
        moveTo: function(name, x, y) {
          var series = this.seriesMap[name]
          series.moves.push({ action: 'moveTo', x: x, y: y })
        },
        /**
         * @memberof CIQ.Plotter
         */
        lineTo: function(name, x, y) {
          var series = this.seriesMap[name],
            pattern = series.pattern
          series.moves.push({ action: 'lineTo', x: x, y: y, pattern: pattern })
        },
        /**
         * @memberof CIQ.Plotter
         */
        dashedLineTo: function(name, x, y, pattern) {
          var series = this.seriesMap[name]
          series.moves.push({ action: 'lineTo', x: x, y: y, pattern: pattern })
        },
        /**
         * @memberof CIQ.Plotter
         */
        quadraticCurveTo: function(name, cx0, cy0, x, y) {
          var series = this.seriesMap[name],
            pattern = series.pattern
          series.moves.push({
            action: 'quadraticCurveTo',
            x0: cx0,
            y0: cy0,
            x: x,
            y: y,
            pattern: pattern,
          })
        },
        /**
         * @memberof CIQ.Plotter
         * @since 4.0.0
         */
        bezierCurveTo: function(name, cx0, cy0, cx1, cy1, x, y) {
          var series = this.seriesMap[name],
            pattern = series.pattern
          series.moves.push({
            action: 'bezierCurveTo',
            x0: cx0,
            y0: cy0,
            x1: cx1,
            y1: cy1,
            x: x,
            y: y,
            pattern: pattern,
          })
        },
        /**
         * Add text to be rendered with the drawing. Primarily used when the Plotter is used for caching since there is no
         * performance benefit from batching text operations to the GPU. If specifying a bounding box, textBaseline="middle" is assumed
         * @param {string} name Name of series
         * @param {string} text The raw text to render
         * @param {number} x    X position on canvas for text
         * @param {number} y    Y position on canvas for text
         * @param {string} [backgroundColor] Optional, will put a box underneath the text
         * @param {number} [width] Optional width of bounding box
         * @param {number} [height] Optional height of bounding box
         * @memberof CIQ.Plotter
         */
        addText: function(name, text, x, y, backgroundColor, width, height) {
          var series = this.seriesMap[name]
          series.text.push({ text: text, x: x, y: y, bg: backgroundColor })
        },
        /**
         * Renders the text objects. This is done after drawing primitives for each series.
         * @private
         * @memberof CIQ.Plotter
         */
        drawText: function(context, series) {
          for (var i = 0; i < series.text.length; i++) {
            var textObj = series.text[i]
            if (textObj.bg) {
              var w = textObj.width
                ? textObj.width
                : context.measureText(textObj.text).width
              var h = textObj.height ? textObj.height : 12
              var prev = context.fillStyle
              context.fillStyle = textObj.bg
              if (context.textAlign == 'right') {
                context.fillRect(textObj.x, textObj.y + h / 2, -w, -h)
              } else {
                context.fillRect(textObj.x, textObj.y + h / 2, w, h)
              }
              context.fillStyle = prev
            }
            context.fillText(textObj.text, textObj.x, textObj.y)
          }
        },
        /**
         * Render the plotter. All of the stored operations are sent to the canvas. This operation stores and restores
         * global canvas parameters such as fillStyle, strokeStyle and globalAlpha.
         * @param  {object} context A valid HTML canvas context
         * @param  {string} [name]    Optionally render only a specific series. If null or not provided then all series will be rendered.
         * @memberof CIQ.Plotter
         */
        draw: function(context, name) {
          var prevWidth = context.lineWidth
          var prevFillStyle = context.fillStyle
          var prevStrokeStyle = context.strokeStyle
          var prevGlobalAlpha = context.globalAlpha
          for (var i = 0; i < this.seriesArray.length; i++) {
            var series = this.seriesArray[i]
            if (name && series.name != name) continue
            context.beginPath()
            context.lineWidth = series.width
            context.globalAlpha = series.opacity
            context.fillStyle = series.color
            context.strokeStyle = series.color
            context.save()
            for (var j = 0; j < series.moves.length; j++) {
              var move = series.moves[j]
              if (move.pattern) {
                context.setLineDash(move.pattern)
                context.lineDashOffset = 0
              } else context.setLineDash([])
              if (move.action == 'quadraticCurveTo') {
                context[move.action](move.x0, move.y0, move.x, move.y)
              } else if (move.action == 'bezierCurveTo') {
                context[move.action](
                  move.x0,
                  move.y0,
                  move.x1,
                  move.y1,
                  move.x,
                  move.y
                )
              } else {
                context[move.action](move.x, move.y)
              }
            }
            if (series.strokeOrFill == 'fill') {
              context.fill()
            } else {
              context.stroke()
            }
            context.closePath()
            context.restore()
            this.drawText(context, series)
            context.lineWidth = 1
          }
          context.lineWidth = prevWidth
          context.fillStyle = prevFillStyle
          context.strokeStyle = prevStrokeStyle
          context.globalAlpha = prevGlobalAlpha
        },
      }

      /**
       * A simple device to make ease functions easy to use. Requests a cubic function that takes the form function (t, b, c, d)
       * 		t = current time
       * 		b = starting value
       * 		c = change in value
       * 		d = duration
       * @param {function} fc        The cubic function
       * @param {number} ms         Milliseconds to perform the function
       * @param {map} [startValues] Name value pairs of starting values (or pass in a single value)
       * @param {map} [endValues]   Name value pairs of ending values (or pass in a single value)
       * @name  CIQ.EaseMachine
       * @constructor
       * @example
       * var e=new CIQ.EaseMachine(Math.easeInOutCubic, 200);
       * e.run(function(v){console.log(v)}, 100, 110);
       */
      CIQ.EaseMachine = function(fc, ms, startValues, endValues) {
        this.fc = fc
        this.ms = ms
        if (startValues || startValues === 0) {
          this.reset(startValues, endValues)
        }
      }

      /**
       * Resets the EaseMachine with a new set of values
       * @param {map} [startValues] Name value pairs of starting values (or pass in a single value). If null then the currentValues will become the startValues (allowing for resetting or reversing of direction)
       * @param {map} endValues   Name value pairs of ending values (or pass in a single value)
       * @memberof CIQ.EaseMachine
       */
      CIQ.EaseMachine.prototype.reset = function(startValues, endValues) {
        if (!startValues && startValues !== 0) startValues = this.currentValues
        this.hasCompleted = false
        this.running = false
        this.okayToRun = true
        this.useNameValuePairs = typeof endValues == 'object'
        this.startTime = Date.now()
        if (this.useNameValuePairs) {
          this.startValues = startValues
          this.endValues = endValues
        } else {
          this.startValues = { default: startValues }
          this.endValues = { default: endValues }
        }
        this.changeValues = {}
        this.currentValues = {}
        for (var n in this.startValues) {
          this.changeValues[n] = this.endValues[n] - this.startValues[n]
        }
      }

      /**
       * Returns the next set of values, or individual value
       * @return {map} Name value pairs of current values or current value
       * @memberof CIQ.EaseMachine
       */
      CIQ.EaseMachine.prototype.next = function() {
        var now = Date.now()
        if (now >= this.startTime + this.ms) {
          now = this.startTime + this.ms
          this.hasCompleted = true
          this.running = false
        }
        this.currentValues = {}
        for (var n in this.changeValues) {
          this.currentValues[n] = this.fc(
            now - this.startTime,
            this.startValues[n],
            this.changeValues[n],
            this.ms
          )
        }
        if (!this.useNameValuePairs) return this.currentValues['default']
        return this.currentValues
      }

      /**
       * This will be false while the ease machine is completing
       * @type {boolean}
       * @memberof CIQ.EaseMachine
       */
      CIQ.EaseMachine.prototype.hasCompleted = true

      /**
       * Runs the ease machine in a loop until completion by calling next() from within a requestAnimationFrame.
       * @param {function} fc Function callback, will receive the results of {@link CIQ.EaseMachine#next}
       * @param {map} [startValues] Name value pairs of starting values (or pass in a single value)
       * @param {map} [endValues]   Name value pairs of ending values (or pass in a single value)
       * @param {boolean} [delayFirstRun=false] Normally, the first pass of the run will happen immediately. Pass true if you want to wait for the next animation frame before beginning.
       * @memberof CIQ.EaseMachine
       */
      CIQ.EaseMachine.prototype.run = function(
        fc,
        startValues,
        endValues,
        delayFirstRun
      ) {
        if (this.afid) cancelAnimationFrame(this.afid)
        if (startValues || startValues === 0) {
          this.reset(startValues, endValues)
        } else if (endValues || endValues === 0) {
          this.reset(this.currentValues, endValues)
        }
        var self = this
        function go() {
          self.afid = null
          if (!self.okayToRun) return
          var result = self.next()
          fc(result)
          if (self.hasCompleted) return
          self.afid = requestAnimationFrame(go)
        }
        this.running = true
        if (delayFirstRun) this.afid = requestAnimationFrame(go)
        else go()
      }

      /**
       * Stops the ease machine from running mid-animation. Returns the current state.
       * @return {map} Name value pairs of current values or current value
       * @memberof CIQ.EaseMachine
       */
      CIQ.EaseMachine.prototype.stop = function() {
        if (this.afid) cancelAnimationFrame(this.afid)
        this.afid = null
        this.okayToRun = false
        this.running = false
        if (typeof this.useNameValuePairs == 'undefined') return {}
        if (!this.useNameValuePairs) return this.currentValues['default']
        return this.currentValues
      }

      /**
       * Base class for Renderers.
       * A renderer is used to draw a complex visualization based on one or more "series" of data.
       * This is a reusable object. Once defined and attached to a chart, it shouldn’t have to be recreated every time a symbol changed.
       * The series inside the renderers may change with a new symbol, but the linked renderer itself remains the vehicle for adding series.
       *
       * To create a renderer use {@link CIQ.ChartEngine#setSeriesRenderer}
       *
       * @name  CIQ.Renderer
       * @constructor
       */
      CIQ.Renderer = function() {}

      /**
       * Factory for renderer.  Will request a renderer from each renderer subclass until it is given one.
       * @param  {string} chartType Chart type name (usually from layout.chartType)
       * @param  {object} [params] Parameters to pass to the renderer constructor
       * @memberof CIQ.Renderer
       * @since 5.1.0
       * @private
       */
      CIQ.Renderer.produce = function(chartType, params) {
        var renderer = null
        if (chartType) {
          for (var r in CIQ.Renderer) {
            var rendererType = CIQ.Renderer[r]
            // Note: chartType has often been a combination of attributes connected with an underscore,
            // e.g. colored_bar, baseline_mountain.  So we split this legacy name to get the attributes.
            if (rendererType.requestNew)
              renderer = rendererType.requestNew(chartType.split('_'), params)
            if (renderer) return renderer
          }
        }
        params.type = 'line'
        return new CIQ.Renderer.Lines({ params: params })
      }

      CIQ.Renderer.colorFunctions = {}
      /**
       * Registers a colorFunction for use with a renderer.
       * It is necessary to register a color function if you want the function to be tied back to an imported renderer.
       * @param  {string} name The name of the registered function
       * @param  {function} fc The function to register
       * @memberof CIQ.Renderer
       */
      CIQ.Renderer.registerColorFunction = function(name, funct) {
        CIQ.Renderer.colorFunctions[name] = funct
      }

      /**
       * Unregisters a colorFunction for use with a renderer.
       * @param  {string} name The name of the registered function
       * @memberof CIQ.Renderer
       */
      CIQ.Renderer.unregisterColorFunction = function(name) {
        delete CIQ.Renderer.colorFunctions[name]
      }

      /**
       * If your renderer manages a yAxis then the necessary calculations (high and low) should be made here
       * @memberof CIQ.Renderer
       */
      CIQ.Renderer.prototype.performCalculations = function() {}

      /**
       * Perform drawing operations here.
       * @memberof CIQ.Renderer
       */
      CIQ.Renderer.prototype.draw = function() {}

      /**
       * Draws one series from the renderer
       * Called by {@link CIQ.ChartEngine#drawSeries}
       * @param  {CIQ.ChartEngine.Chart} chart The chart object to draw the renderers upon
       * @param {object} [parameters] Parameters used to draw the series, depends on the renderer type
       * @param {string} [parameters.panel] Name of panel to draw the series upon
       * @memberof CIQ.Renderer
       * @since 5.1.0
       */
      CIQ.Renderer.prototype.drawIndividualSeries = function(
        chart,
        parameters
      ) {}

      /**
	 * Default constructor for a renderer. Override this if desired.
	 * @param  {object} config Configuration for the renderer
	 * @param  {function} [config.callback] Callback function to perform activity post-drawing, for example, creating a legend. It will be called with a 'colors' argument, which will be an array of objects containing the colors used to draw the rendering. ( Example: cb(colors); ). See example for format.
	 * @param  {string} [config.id] Handle to access the rendering in the future.  If not provided, one will be generated.
	 * @param  {object} [config.params] Parameters to control the renderer itself
	 * @param  {string} [config.params.name] Name of the renderer. Default: 'Data'.  This is used when displaying error message on screen
	 * @param  {string} [config.params.panel] The name of the panel to put the rendering on, defaults to "chart"
	 * @param  {boolean} [config.params.overChart=true] If set to false, will draw the rendering behind the main chart rather than over it. By default rendering will be as overlay on the main chart.
	 * @param  {boolean} [config.params.yAxis] Optional Y-axis object to use for the series.
	 * @param  {number} [config.params.opacity] Opacity of the rendering as a whole.  Can be overridden by an opacity set for a series.  Valid values are 0.0-1.0. Default: 1
	 * @memberof CIQ.Renderer
	 * @example
		stxx.addSeries("NOK", {display:"NOK",width:4});
		stxx.addSeries("SNE", {display:"Sony",width:4});

		var axis=new CIQ.ChartEngine.YAxis();
		axis.position="left";
		axis.textStyle="#FFBE00";

		var renderer=stxx.setSeriesRenderer(new CIQ.Renderer.Lines({params:{name:"lines", type:"mountain", yAxis:axis}}));

		renderer.removeAllSeries()
			.attachSeries("NOK", "#FFBE00")
			.attachSeries("SNE", "#FF9300")
			.ready();

	 */
      CIQ.Renderer.prototype.construct = function(config) {
        if (!config) config = {}
        var params = config.params ? config.params : {}
        if (!params.name) params.name = CIQ.uniqueID()
        if (!params.heightPercentage) params.heightPercentage = 0.7
        if (!params.opacity) params.opacity = 1
        if (params.highlightable !== false) params.highlightable = true
        if (!params.panel) params.panel = 'chart'
        this.cb = config.callback
        this.params = params
        this.seriesParams = []
        this.caches = {}
        this.colors = {}
      }

      /**
	 * Attach a series to the renderer.
	 * This assumes that the series data *is already in the dataSet* and simply connects it to the renderer with the specified parameters.
	 * See {@link CIQ.ChartEngine#addSeries} for details on how to create a series.
	 *
	 * Any parameters defined when attaching a series, such as colors, will supersede any defined when a series was created. This allows you to attach the same series to multiple renderers, each rendering displaying the same series data in a different color, for example.
	 *
	 * @param  {string} id      The name of the series.
	 * @param  {object} parameters Settings to control color and opacity of <B>each</B> series in the group. See {@link CIQ.ChartEngine#addSeries} for implementation examples. <P>Argument format can be:<ul><li> a `string` containing the color</li><li> or a more granular `object` having the following members:</li></ul>
	 * @param  {string} [parameters.field] The name of the field. Name of the field in the dataSet to use for the series.  If omitted, defaults to id
	 * @param  {string} [parameters.fill_color_up] Color to use to fill the part when the Close is higher than the previous (or null to not draw)
	 * @param  {string} [parameters.border_color_up] Color to use to draw the border when the Close is higher than the previous (or null to not draw)
	 * @param  {number} [parameters.opacity_up] Opacity to use to fill the part when the Close is higher than the previous (0.0-1.0). Default: .4
	 * @param  {string} [parameters.fill_color_down] Color to use to fill the part when the Close is lower than the previous (or null to not draw)
	 * @param  {string} [parameters.border_color_down] Color to use to draw the border when the Close is lower than the previous (or null to not draw)
	 * @param  {number} [parameters.opacity_down] Opacity to use to fill the part when the Close is lower than the previous (0.0-1.0) default: .4
	 * @param  {string} [parameters.color] Color to use to fill the series in the absence of specific up/down color.
	 * @param  {string} [parameters.fillStyle] Color to use to fill the mountain chart.
	 * @param  {string} [parameters.baseColor] Color to use at the bottom of the mountain chart, will create a gradient with bgColor
	 * @param  {string} [parameters.bgColor] Color to use at the top of the mountain chart, will create a gradient if baseColor is specified.  Otherwise, will fill the mountain solid with this color unless fillStyle is specified
	 * @param  {boolean} [parameters.permanent] Whether the attached series can be removed by the user (lines and bars only). By default the series will not be permanent. This flag (including the default) will supersede the permanent flag of the actual series. As such, a series will not be permanent unless you set this flag to 'true', even if the series being attached was flaged set as permanent when defined. This gives the renderer most control over the rendering process.
	 * @return {CIQ.Renderer}            Returns a copy of this for chaining
	 * @since 5.1.0 added fillStyle, baseColor, bgColor parameters
	 * @memberof CIQ.Renderer
	 * @example
		stxx.addSeries("NOK", {display:"NOK",width:4});

		var axis=new CIQ.ChartEngine.YAxis();
		axis.position="left";
		axis.textStyle="#FFBE00";

		var renderer=stxx.setSeriesRenderer(new CIQ.Renderer.Lines({params:{name:"lines", type:"mountain", yAxis:axis}}));

		renderer.removeAllSeries()
			.attachSeries("NOK", "#FFBE00")
			.attachSeries("SNE", "#FF9300")
			.ready();

	 */
      CIQ.Renderer.prototype.attachSeries = function(id, parameters) {
        var stx = this.stx
        if (!stx) return this
        var series = this.stx.chart.series[id]
        if (!series) series = { parameters: {} }
        var rParams = this.params,
          sParams = series.parameters
        var sp = {
          id: id,
          chartType: rParams.type,
          display: series.parameters.display,
          border_color_up: rParams.defaultBorders ? 'auto' : null,
          fill_color_up: series.parameters.color,
          opacity_up: rParams.opacity,
          border_color_down: rParams.defaultBorders ? 'auto' : null,
          fill_color_down: series.parameters.color,
          opacity_down: rParams.opacity,
          color: series.parameters.color,
          symbol: series.parameters.symbol,
          symbolObject: CIQ.clone(series.parameters.symbolObject),
        }
        if (typeof parameters == 'string') {
          sp.color = sp.fill_color_down = sp.fill_color_up = parameters
        } else if (typeof parameters == 'object') {
          for (var p in parameters) sp[p] = parameters[p]
          var c = sp.color,
            bc = sp.border_color
          if (c) {
            if (!sp.fill_color_up) sp.fill_color_up = c
            if (!sp.fill_color_down) sp.fill_color_down = c
            if (!sp.fill_color_even) sp.fill_color_even = c
          }
          if (bc) {
            if (!sp.border_color_up) sp.border_color_up = bc
            if (!sp.border_color_down) sp.border_color_down = bc
            if (!sp.border_color_even) sp.border_color_even = bc
          }
        }
        if (sp.symbol && sp.field != sp.symbol) {
          sp.subField = sp.field
          sp.field = sp.symbol
        }
        if (!sp.symbol && !sp.field && !this.highLowBars) sp.field = 'Close'
        if (!sp.id) sp.id = CIQ.uniqueID()
        this.removeSeries(id, true).seriesParams.push(sp)

        if (sp.fill_color_up != sp.fill_color_down) {
          this.colors[id + ' up'] = {
            color: sp.fill_color_up,
            opacity: sp.opacity_up,
            display: sp.display ? sp.display + ' up' : id + ' up',
          }
          this.colors[id + ' dn'] = {
            color: sp.fill_color_down,
            opacity: sp.opacity_down,
            display: sp.display ? sp.display + ' down' : id + ' down',
          }
        } else {
          this.colors[id] = {
            color: sp.fill_color_up,
            opacity: sp.opacity_up,
            display: sp.display ? sp.display : id,
          }
        }
        if (rParams.yAxis) {
          rParams.yAxis = stx.addYAxis(stx.panels[rParams.panel], rParams.yAxis)
          rParams.yAxis.needsInitialPadding = true
        }
        return this
      }

      /**
       * Removes a series from the renderer. The yAxis and actual series data will also be removed if no longer used by any other renderers.
       * When the last series is removed from the renderer, the chart it is attached to will remove the renderer.
       * @param  {string} id          The field name of the series.
       * @param  {boolean} [preserveSeries=false] Set to true to keep the series data in the CIQ.ChartEngine object.
       * @return {CIQ.Renderer}                A copy of this for chaining
       * @memberof CIQ.Renderer
       * @since
       * <br>&bull; 2015-07-01 'preserveSeries' is now available
       * <br>&bull; 3.0.0 series is now removed even if series parameter 'permanent' is set to true. The permanent parameter only prevents right click user interaction and not programatically requested removals.
       * <br>&bull; 4.0.0 series data is now totally removed from masterData if no longer used by any other renderers.
       */
      CIQ.Renderer.prototype.removeSeries = function(id, preserveSeries) {
        for (var sp = 0; sp < this.seriesParams.length; sp++) {
          if (this.seriesParams[sp].id == id) {
            this.seriesParams.splice(sp, 1)
            break
          }
        }
        delete this.colors[id + ' up']
        delete this.colors[id + ' dn']
        delete this.colors[id]

        if (!preserveSeries) {
          //if(!this.stx.chart.series[id] || !this.stx.chart.series[id].parameters.permanent){
          var seriesInUse = false
          for (var plot in this.stx.chart.seriesRenderers) {
            var myPlot = this.stx.chart.seriesRenderers[plot]
            for (var s = 0; s < myPlot.seriesParams.length; s++) {
              if (myPlot.seriesParams[s].id == id) {
                seriesInUse = true
                break
              }
            }
            if (seriesInUse) break
          }
          if (!seriesInUse) {
            this.stx.deleteSeries(id, this.stx.chart)
          }
          //}
        }
        this.stx.deleteYAxisIfUnused(
          this.stx.panels[this.params.panel],
          this.params.yAxis
        )
        return this
      }

      /**
       * Removes all series from the renderer and the yAxis from the panel if it is not being used by any current renderers.
       * @param {boolean} [eraseData=false] Set to true to erase the actual series data in the CIQ.ChartEngine otherwise it will be retained
       * @return {CIQ.Renderer} A copy of this for chaining
       * @memberof CIQ.Renderer
       */
      CIQ.Renderer.prototype.removeAllSeries = function(eraseData) {
        if (eraseData) {
          var arr = []
          // Compile a list of all of the fields
          for (var sp = 0; sp < this.seriesParams.length; sp++) {
            arr.push(this.seriesParams[sp].id)
          }
          for (var i = 0; i < arr.length; i++) {
            this.removeSeries(arr[i])
          }
        }
        this.seriesParams = []
        this.colors = {}
        this.stx.deleteYAxisIfUnused(
          this.stx.panels[this.params.panel],
          this.params.yAxis
        )
        return this
      }

      /**
       * Call this to immediately render the visualization, at the end of a chain of commands.
       * @return {CIQ.Renderer} A copy of this for chaining
       * @memberof CIQ.Renderer
       */
      CIQ.Renderer.prototype.ready = function() {
        this.stx.createDataSet()
        this.stx.draw()
        return this
      }

      /**
	 * Creates a Lines renderer
	 *
	 * Note: by default the renderer will display lines as underlays. As such, they will appear below any other studies or drawings.
	 *
	 * The Lines renderer is used to create the following drawing types: line, mountain, baseline, wave, step chart, and colored versions of these
	 *
	 * See {@link CIQ.Renderer#construct} for parameters required by all renderers
	 * @param {object} config Config for renderer
	 * @param  {object} [config.params] Parameters to control the renderer itself
	 * @param  {number} [config.params.width] Width of the rendered line
	 * @param  {string} [config.params.type="line"] Type of rendering "line", "mountain"
	 * @param  {boolean} [config.params.useChartLegend=false] Set to true to use the built in canvas legend renderer. See {@link CIQ.ChartEngine.Chart#legendRenderer};
	 * @param  {boolean} [config.params.highlightable=true] Set to false to prevent selection of series via hover
	 * @param  {string} [config.params.style] Optional style name to use in lieu of defaults for the type
	 * @param  {boolean} [config.params.step] Specifies a step chart
	 * @param  {boolean} [config.params.baseline] Specifies a baseline chart
	 * @param  {boolean} [config.params.colored] Specifies the use of a colorFunction to dictate color of the segment
	 * @param  {boolean} [config.params.vertex] Specifies drawing a dot on every vertex
	 * @param  {boolean} [config.params.vertex_color] Specifies a color for the vertices.  If omitted, will use defaultColor.
	 * @param  {string} [config.params.colorFunction] Optional override string (or function) used to determine color of bar.  May be an actual function or a string name of the registered function (see {@link CIQ.Renderer.registerColorFunction})
	 * @constructor
	 * @name  CIQ.Renderer.Lines
	 * @since
	 * <br>&bull; 4.0.0 - New `config.params.useChartLegend` added
	 * <br>&bull; 5.1.0 removed subtype parameter, this will be determined internally from config.params.step=true
	 * <br>&bull; 5.1.0 added highlightable, overChart, step, baseline, vertex, style, colored, and colorFunction parameters
	 *
	 * @example
		// create series for the renderer
		stxx.addSeries("NOK", {display:"NOK",width:4});
		stxx.addSeries("SNE", {display:"Sony",width:4});

		// create the y axis to assign to the renderer
		var axis=new CIQ.ChartEngine.YAxis();
		axis.position="left";
		axis.textStyle="#FFBE00";

		// create a renderer and associate it to the chart
		var renderer=stxx.setSeriesRenderer(new CIQ.Renderer.Lines({params:{name:"lines", type:"mountain", yAxis:axis}}));

		// remove all series form the renderer (not always needed) , attach new series, and render.
		renderer.removeAllSeries()
			.attachSeries("NOK", "#FFBE00")
			.attachSeries("SNE", "#FF9300")
			.ready();

	 *
	 * @example
		// This is an example on how completely remove a renderer and all associated data.
		// This should only be necessary if you are also removing the chart itself.

		// remove all series from the renderer including series data from the masterData
  		renderer.removeAllSeries(true);

  		// detach the series renderer from the chart.
  		stxx.removeSeriesRenderer(renderer);

  		// delete the renderer itself.
  		renderer=null;
	 *
	 * @example
	 	// Colored step baseline mountain with vertices
		var renderer=stxx.setSeriesRenderer(new CIQ.Renderer.Lines({params:{name:"lines", type:"mountain", baseline:true, step:true, colored:true, vertex:true, yAxis:axis}}));
	 *
	 */
      CIQ.Renderer.Lines = function(config) {
        this.construct(config)
        var params = this.params
        if (!params.type) params.type = 'line'
        if (!params.style) {
          switch (params.type) {
            case 'mountain':
              if (params.baseline) params.style = 'stx_baseline_delta_mountain'
              else if (params.colored)
                params.style = 'stx_colored_mountain_chart'
              else params.style = 'stx_mountain_chart'
              break
            default:
              params.style = 'stx_line_chart'
          }
        }
        this.supportsAnimation = true
        if (params.type == 'wave') {
          // wave charts don't support these options and no gap support either.
          params.step = params.vertex = params.baseline = params.colored = false
          this.highLowBars = this.barsHaveWidth = true
          this.supportsAnimation = false
        } else if (params.type == 'step') {
          params.step = true
        }
      }
      CIQ.Renderer.Lines.ciqInheritsFrom(CIQ.Renderer, false)

      /**
       * Returns a new Lines renderer if the featureList calls for it
       * FeatureList should contain whatever features requested; valid features:
       * 	line, mountain, baseline (delta), step, vertex, colored, wave
       * Anything else is an invalid feature and will cause function to return null
       * Called by {@link CIQ.Renderer.produce} to create a renderer for the main series
       * @param {array} featureList List of rendering terms requested by the user, parsed from the chartType
       * @param {object} [config.params] Parameters used for the series to be created, used to create the renderer
       * @return {CIQ.Renderer.Lines} A new instance of the Lines renderer, if the featureList matches
       * @memberof CIQ.Renderer.Lines
       * @since 5.1.0
       */
      CIQ.Renderer.Lines.requestNew = function(featureList, params) {
        var type = null,
          isStep = false,
          isColored = false,
          isBaseline = false,
          isVertex = false
        for (var pt = 0; pt < featureList.length; pt++) {
          var pType = featureList[pt]
          switch (pType) {
            case 'line':
            case 'mountain':
            case 'wave':
              type = pType
              break
            case 'baseline':
              isBaseline = true
              break
            case 'colored':
              isColored = true
              break
            case 'step':
              isStep = true
              break
            case 'vertex':
              isVertex = true
              break
            case 'delta':
              break
            default:
              return null // invalid chart type for this renderer
          }
        }
        if (type === null && !isBaseline && !isStep) return null

        return new CIQ.Renderer.Lines({
          params: CIQ.extend(params, {
            type: type,
            step: isStep,
            colored: isColored,
            baseline: isBaseline,
            vertex: isVertex,
          }),
        })
      }

      CIQ.Renderer.Lines.prototype.performCalculations = function(prevMinMax) {
        var yAxis = this.params.yAxis,
          stx = this.stx
        if (yAxis) {
          var panel = stx.panels[this.params.panel]
          var fields = []
          for (var i = 0; i < this.seriesParams.length; i++) {
            var field = this.seriesParams[i].field,
              subField = this.seriesParams[i].subField || 'Close'
            fields.push(field)
            if (field == 'Close') fields.push('iqPrevClose')
            else
              fields = fields.concat(
                CIQ.createObjectChainNames(field, [subField, 'iqPrevClose'])
              )
          }
          var minMax = stx.determineMinMax(
            stx.chart.dataSegment,
            fields,
            false,
            true
          )
          if (prevMinMax && prevMinMax.length) {
            minMax[0] = Math.min(prevMinMax[0], minMax[0])
            minMax[1] = Math.max(prevMinMax[1], minMax[1])
          }
          stx.calculateYAxisRange(panel, yAxis, minMax[0], minMax[1])
          if (yAxis.needsInitialPadding) {
            stx.calculateYAxisMargins(yAxis)
            yAxis.needsInitialPadding = false
          }
        }
      }

      CIQ.Renderer.Lines.prototype.draw = function() {
        var stx = this.stx,
          panel = this.stx.panels[this.params.panel],
          chart = panel.chart
        var seriesMap = {}
        var s,
          seriesParams = this.seriesParams
        var colorFunction = this.params.colorFunction
        function defaultColorFunction(param) {
          var stxLineUpColor =
            param.fill_color_up || stx.getCanvasColor('stx_line_up')
          var stxLineDownColor =
            param.fill_color_down || stx.getCanvasColor('stx_line_down')
          var stxLineColor = param.color || stx.getCanvasColor('stx_line_chart')
          return function(stx, quote, mode) {
            if (!quote.iqPrevClose && quote.iqPrevClose !== 0)
              return stxLineColor
            if (quote.Close > quote.iqPrevClose) return stxLineUpColor
            if (quote.Close < quote.iqPrevClose) return stxLineDownColor
            return stxLineColor
          }
        }
        if (this.params.vertex && !stx.scatter) {
          console.warn('Error, vertex option requires customChart.js')
          this.params.vertex = false
        }
        for (s = 0; s < seriesParams.length; s++) {
          var sParam = seriesParams[s]
          if (this.params.colored) {
            var parts = ['_color_up', '_color_down', '_color']
            for (var i = 0; i < parts.length; i++) {
              //if(!sParam["fill"+parts[i]]){
              var b = sParam['border' + parts[i]]
              if (b && b != 'auto') sParam['fill' + parts[i]] = b
              //}
            }
            if (!colorFunction) colorFunction = defaultColorFunction(sParam)
            this.params.colorFunction = colorFunction
          }
          var defaultParams = {}
          if (chart.series[sParam.id]) {
            // make sure the series is still there.
            defaultParams = CIQ.clone(chart.series[sParam.id].parameters)
          }
          seriesMap[sParam.id] = {
            parameters: CIQ.extend(
              CIQ.extend(defaultParams, this.params),
              sParam
            ),
            yValueCache: this.caches[sParam.id],
          }
          if (
            this == stx.mainSeriesRenderer &&
            chart.customChart &&
            chart.customChart.colorFunction
          ) {
            seriesMap[sParam.id].parameters.colorFunction =
              chart.customChart.colorFunction
          }
        }
        stx.drawSeries(chart, seriesMap, this.params.yAxis, this)
        for (s in seriesMap) {
          this.caches[s] = seriesMap[s].yValueCache
        }
      }

      CIQ.Renderer.Lines.prototype.drawIndividualSeries = function(
        chart,
        parameters
      ) {
        if (parameters.invalid) return
        var stx = this.stx,
          context = chart.context,
          rc = null
        var colorFunction = parameters.colorFunction,
          panel = stx.panels[parameters.panel] || chart.panel
        if (typeof colorFunction == 'string') {
          colorFunction = CIQ.Renderer.colorFunctions[colorFunction]
          if (!colorFunction) return
        }

        if (parameters.vertex) {
          context.save()
          context.lineJoin = 'bevel'
        }
        if (parameters.type == 'wave') {
          rc = stx.drawWaveChart(panel, parameters)
        } else if (parameters.baseline) {
          rc = stx.drawBaselineChart(panel, parameters)
        } else if (parameters.type == 'mountain') {
          parameters.returnObject = true
          rc = stx.drawMountainChart(panel, parameters, colorFunction)
        } else {
          parameters.returnObject = true
          rc = stx.drawLineChart(
            panel,
            parameters.style,
            colorFunction,
            parameters
          )
        }
        if (parameters.vertex) {
          stx.scatter(panel, {
            yAxis: parameters.yAxis,
            field: parameters.field,
            subField: parameters.subField,
            symbol: parameters.symbol,
            color: parameters.vertex_color,
            overlayScaling: parameters.overlayScaling,
          })
          context.restore()
        }
        return rc
      }

      /**
	 * Creates an OHLC renderer
	 *
	 * Note: by default the renderer will display bars as underlays. As such, they will appear below any other studies or drawings.
	 *
	 * The OHLC renderer is a base class for creating the following drawing types: bar, hlc, candle, histogram and their variants; and colored versions of these
	 *
	 * See {@link CIQ.Renderer#construct} for parameters required by all renderers
	 * @param {object} config Config for renderer
	 * @param  {object} [config.params] Parameters to control the renderer itself
	 * @param  {string} [config.params.type] Type of rendering "bar", "candle". Not needed if `params.histogram` is set)
	 * @param  {boolean} [config.params.useChartLegend=false] Set to true to use the built in canvas legend renderer. See {@link CIQ.ChartEngine.Chart#legendRenderer};
	 * @param  {string} [config.params.style] Optional style name to use in lieu of defaults for the type
	 * @param  {boolean} [config.params.colored] For bar or hlc, specifies using a condition or colorFunction to determine color
	 * @param  {boolean} [config.params.hollow] Specifies candles should be hollow candles
	 * @param  {boolean} [config.params.volume] Specifies candles should be volume candles
	 * @param  {boolean} [config.params.histogram] Specifies histogram chart (if set, `params.type` is not required). These are basic histograms that allow just one bar per tick; not to be confused with stackable histograms which require the more advanced {@link CIQ.Renderer.Histogram}
	 * @param  {boolean} [config.params.hlc] Specifies bar chart, with just hlc data; no open tick
	 * @param  {boolean} [config.params.gradient=true] Specifies histogram bars are to be drawn with a gradient; set to false to draw with solid colors
	 * @param  {string} [config.params.colorBasis="close"] For bar/hlc charts, will compute color based on whether current close is higher or lower than previous close.  Set to "open" to compute this off the open rather than yesterday's close.
	 * @param  {function} [config.params.colorFunction] Optional override function (or string) used to determine color of bar.  May be an actual function or a string name of the registered function (see {@link CIQ.Renderer.registerColorFunction})
	 * @constructor
	 * @name  CIQ.Renderer.OHLC
	 * @since 5.1.0
	 * @example
	 	// Colored hlc chart
		var renderer=stxx.setSeriesRenderer(new CIQ.Renderer.OHLC({params:{name:"bars", type:"bar", hlc:true, colored:true}}));
	 *
	 */

      CIQ.Renderer.OHLC = function(config) {
        this.construct(config)
        var params = this.params
        if (!params.type) params.type = 'candle'
        this.highLowBars = this.barsHaveWidth = this.standaloneBars = true
        if (params.histogram) {
          params.type = 'candle'
          this.highLowBars = false
          params.volume = params.hollow = false
        }
        if (params.type == 'bar')
          params.volume = params.hollow = params.histogram = false
        if (params.type == 'candle') params.hlc = params.colored = false
        if (params.volume) params.hollow = true
      }
      CIQ.Renderer.OHLC.ciqInheritsFrom(CIQ.Renderer, false)

      /**
       * Returns a new OHLC renderer if the featureList calls for it
       * FeatureList should contain whatever features requested; valid features:
       * 	bar, hlc, candle, colored, histogram, hollow, volume
       * Anything else is an invalid feature and will cause function to return null
       * Called by {@link CIQ.Renderer.produce} to create a renderer for the main series
       * @param {array} featureList List of rendering terms requested by the user, parsed from the chartType
       * @param {object} [config.params] Parameters used for the series to be created, used to create the renderer
       * @return {CIQ.Renderer.OHLC} A new instance of the OHLC renderer, if the featureList matches
       * @memberof CIQ.Renderer.OHLC
       * @since 5.1.0
       */
      CIQ.Renderer.OHLC.requestNew = function(featureList, params) {
        var type = null,
          isHlc = false,
          isColored = false,
          isHollow = false,
          isVolume = false,
          histogram = false
        for (var pt = 0; pt < featureList.length; pt++) {
          var pType = featureList[pt]
          switch (pType) {
            case 'bar':
            case 'candle':
              type = pType
              break
            case 'volume':
              isVolume = true
              break
            case 'hollow':
              isHollow = true
              break
            case 'colored':
              isColored = true
              break
            case 'histogram':
              histogram = true
              type = 'candle'
              break
            case 'hlc':
              isHlc = true
              type = 'bar'
              break
            default:
              return null // invalid chartType for this renderer
          }
        }
        if (type === null) return null

        return new CIQ.Renderer.OHLC({
          params: CIQ.extend(params, {
            type: type,
            hlc: isHlc,
            colored: isColored,
            hollow: isHollow,
            volume: isVolume,
            histogram: histogram,
          }),
        })
      }

      CIQ.Renderer.OHLC.prototype.performCalculations = function(prevMinMax) {
        var yAxis = this.params.yAxis,
          stx = this.stx
        if (yAxis) {
          var panel = stx.panels[this.params.panel]
          var fields = []
          for (var i = 0; i < this.seriesParams.length; i++) {
            var field = this.seriesParams[i].field
            fields = fields.concat(
              CIQ.createObjectChainNames(field, [
                'Close',
                'High',
                'Low',
                'Open',
                'iqPrevClose',
              ])
            )
          }
          var minMax = stx.determineMinMax(
            stx.chart.dataSegment,
            fields,
            false,
            true
          )
          if (prevMinMax && prevMinMax.length) {
            minMax[0] = Math.min(prevMinMax[0], minMax[0])
            minMax[1] = Math.max(prevMinMax[1], minMax[1])
          }
          stx.calculateYAxisRange(panel, yAxis, minMax[0], minMax[1])
          if (yAxis.needsInitialPadding) {
            stx.calculateYAxisMargins(yAxis)
            yAxis.needsInitialPadding = false
          }
        }
      }

      CIQ.Renderer.OHLC.prototype.draw = function() {
        var stx = this.stx,
          panel = this.stx.panels[this.params.panel],
          chart = panel.chart
        var seriesMap = {}
        var s,
          seriesParams = this.seriesParams
        for (s = 0; s < seriesParams.length; s++) {
          var sParam = seriesParams[s]

          var defaultParams = {}
          if (chart.series[sParam.id]) {
            // make sure the series is still there.
            defaultParams = CIQ.clone(chart.series[sParam.id].parameters)
          }
          seriesMap[sParam.id] = {
            parameters: CIQ.extend(
              CIQ.extend(defaultParams, this.params),
              sParam
            ),
            //yValueCache: this.caches[sParam.id]
          }
          if (
            this == stx.mainSeriesRenderer &&
            chart.customChart &&
            chart.customChart.colorFunction
          ) {
            seriesMap[sParam.id].parameters.colorFunction =
              chart.customChart.colorFunction
          }
        }
        stx.drawSeries(chart, seriesMap, this.params.yAxis, this)
        for (s in seriesMap) {
          if (seriesMap[s].yValueCache)
            this.caches[s] = seriesMap[s].yValueCache
        }
      }

      CIQ.Renderer.OHLC.prototype.getColor = function(
        stx,
        panel,
        style,
        isBorder,
        isGradient,
        overrideColor
      ) {
        var color = overrideColor || style.color
        if (isBorder) {
          color =
            overrideColor || style.borderLeftColor || style['border-left-color']
          if (!color) return null
        }
        if (!isGradient) return color
        var top = stx.pixelFromTransformedValue(panel.chart.highValue, panel)
        if (isNaN(top)) top = 0 // 32 bit IE doesn't like large numbers
        var backgroundColor = style.backgroundColor
        if (color && !CIQ.isTransparent(color)) {
          var gradient = stx.chart.context.createLinearGradient(
            0,
            top,
            0,
            2 * panel.yAxis.bottom - top
          )
          gradient.addColorStop(0, color)
          gradient.addColorStop(1, backgroundColor)
          return gradient
        }
        return backgroundColor
      }

      CIQ.Renderer.OHLC.prototype.drawIndividualSeries = function(
        chart,
        parameters
      ) {
        if (parameters.invalid) return
        var stx = this.stx,
          context = chart.context
        var colorFunction = parameters.colorFunction,
          panel = stx.panels[parameters.panel] || chart.panel
        if (typeof colorFunction == 'string') {
          colorFunction = CIQ.Renderer.colorFunctions[colorFunction]
          if (!colorFunction) return
        }
        var noBorders =
          stx.layout.candleWidth - chart.tmpWidth <= 2 && chart.tmpWidth <= 3
        var CLOSEUP = 1 // today's close greater than yesterday's close
        var CLOSEDOWN = 2 // today's close less than yesterday's close
        var CLOSEEVEN = 4 // today's close the same as yesterday's close
        var CANDLEUP = 8 // today's close greater than today's open
        var CANDLEDOWN = 16 // today's close less than today's open
        var CANDLEEVEN = 32 // today's close equal to today's open
        if (!chart.state.chartType) chart.state.chartType = {}
        var pass = (chart.state.chartType.pass = {})
        var colorUseOpen = stx.colorByCandleDirection
        if (parameters.colorBasis)
          colorUseOpen = parameters.colorBasis == 'open'
        var isHistogram = parameters.histogram,
          type = parameters.type,
          hollow = parameters.hollow
        var noWicks = stx.noWicksOnCandles[type]
        stx.startClip(panel.name)
        var colors = null,
          rc = { colors: [], cache: [] },
          caches = []
        if (colorFunction) {
          var drawingParams = {
            isHistogram: isHistogram,
            field: parameters.field,
            yAxis: parameters.yAxis,
            volume: parameters.volume,
            overlayScaling: parameters.overlayScaling,
            highlight: parameters.highlight,
          }
          if (!isHistogram && type == 'bar') {
            drawingParams.type = parameters.hlc ? 'hlc' : 'bar'
            rc = stx.drawBarChart(
              panel,
              'stx_bar_chart',
              colorFunction,
              drawingParams
            )
          } else {
            if (type == 'candle' && !noWicks)
              stx.drawShadows(panel, colorFunction, drawingParams)
            rc = stx.drawCandles(panel, colorFunction, drawingParams) //all bars
            drawingParams.isOutline = true
            if (hollow || !noBorders)
              stx.drawCandles(panel, colorFunction, drawingParams) //all bar borders, if candlewidth is too small then don't draw the borders
          }
        } else {
          var isGradient = isHistogram && parameters.gradient !== false
          var chartParts = [
            {
              type: 'histogram',
              drawType: 'histogram',
              style: 'stx_histogram_up',
              condition: CANDLEUP,
              fill: 'fill_color_up',
              border: 'border_color_up',
              useColorInMap: true,
              useBorderStyleProp: true,
            },
            {
              type: 'histogram',
              drawType: 'histogram',
              style: 'stx_histogram_down',
              condition: CANDLEDOWN,
              fill: 'fill_color_down',
              border: 'border_color_down',
              useColorInMap: true,
              useBorderStyleProp: true,
            },
            {
              type: 'histogram',
              drawType: 'histogram',
              style: 'stx_histogram_even',
              condition: CANDLEEVEN,
              fill: 'fill_color_even',
              border: 'border_color_even',
              skipIfPass: true,
              useColorInMap: true,
              useBorderStyleProp: true,
            },
            {
              type: 'bar',
              drawType: 'bar',
              style: parameters.style || 'stx_bar_chart',
              useColorInMap: true,
            },
            {
              type: 'bar',
              drawType: 'bar',
              style: 'stx_bar_up',
              condition: colorUseOpen ? CANDLEUP : CLOSEUP,
              border: 'border_color_up',
              useColorInMap: true,
            },
            {
              type: 'bar',
              drawType: 'bar',
              style: 'stx_bar_down',
              condition: colorUseOpen ? CANDLEDOWN : CLOSEDOWN,
              border: 'border_color_down',
              useColorInMap: true,
            },
            {
              type: 'bar',
              drawType: 'bar',
              style: 'stx_bar_even',
              condition: colorUseOpen ? CANDLEEVEN : CLOSEEVEN,
              border: 'border_color_even',
              skipIfPass: true,
              useColorInMap: true,
            },
            {
              type: 'candle',
              drawType: 'shadow',
              style: 'stx_candle_shadow',
              border: 'border_color_up',
            },
            {
              type: 'candle',
              drawType: 'shadow',
              style: 'stx_candle_shadow_up',
              condition: CANDLEUP,
              border: 'border_color_up',
            },
            {
              type: 'candle',
              drawType: 'shadow',
              style: 'stx_candle_shadow_down',
              condition: CANDLEDOWN,
              border: 'border_color_down',
            },
            {
              type: 'candle',
              drawType: 'shadow',
              style: 'stx_candle_shadow_even',
              condition: CANDLEEVEN,
              border: 'border_color_even',
              skipIfPass: true,
            },
            {
              type: 'candle',
              drawType: 'candle',
              style: 'stx_candle_up',
              condition: CANDLEUP,
              fill: 'fill_color_up',
              border: 'border_color_up',
              useColorInMap: true,
              useBorderStyleProp: true,
            },
            {
              type: 'candle',
              drawType: 'candle',
              style: 'stx_candle_down',
              condition: CANDLEDOWN,
              fill: 'fill_color_down',
              border: 'border_color_down',
              useColorInMap: true,
              useBorderStyleProp: true,
            },
            {
              type: 'hollow',
              drawType: 'shadow',
              style: 'stx_hollow_candle_up',
              condition: CLOSEUP,
              border: 'border_color_up',
            },
            {
              type: 'hollow',
              drawType: 'shadow',
              style: 'stx_hollow_candle_down',
              condition: CLOSEDOWN,
              border: 'border_color_down',
            },
            {
              type: 'hollow',
              drawType: 'shadow',
              style: 'stx_hollow_candle_even',
              condition: CLOSEEVEN,
              border: 'border_color_even',
              skipIfPass: true,
            },
            {
              type: 'hollow',
              drawType: 'candle',
              style: 'stx_hollow_candle_up',
              condition: CLOSEUP | CANDLEDOWN,
              fill: 'fill_color_up',
              border: 'border_color_up',
              useColorInMap: true,
            },
            {
              type: 'hollow',
              drawType: 'candle',
              style: 'stx_hollow_candle_down',
              condition: CLOSEDOWN | CANDLEDOWN,
              fill: 'fill_color_down',
              border: 'border_color_down',
              useColorInMap: true,
            },
            {
              type: 'hollow',
              drawType: 'candle',
              style: 'stx_hollow_candle_even',
              condition: CLOSEEVEN | CANDLEDOWN,
              fill: 'fill_color_even',
              border: 'border_color_even',
              skipIfPass: true,
              useColorInMap: true,
            },
            {
              type: 'hollow',
              drawType: 'candle',
              style: 'stx_hollow_candle_up',
              condition: CLOSEUP | CANDLEUP,
              fill: 'fill_color_up',
              border: 'border_color_up',
            },
            {
              type: 'hollow',
              drawType: 'candle',
              style: 'stx_hollow_candle_down',
              condition: CLOSEDOWN | CANDLEUP,
              fill: 'fill_color_down',
              border: 'border_color_down',
            },
            {
              type: 'hollow',
              drawType: 'candle',
              style: 'stx_hollow_candle_even',
              condition: CLOSEEVEN | CANDLEUP,
              fill: 'fill_color_even',
              border: 'border_color_even',
            },
          ]
          for (var i = 0; i < chartParts.length; i++) {
            var chartPart = chartParts[i]
            if (chartPart.skipIfPass && !pass.even) continue
            else if (isHistogram) {
              if (chartPart.type != 'histogram') continue
            } else if (type == 'bar') {
              if (chartPart.type != 'bar') continue
              else if (parameters.colored && !chartPart.condition) continue
              else if (!parameters.colored && chartPart.condition) continue
            } else if (hollow) {
              if (chartPart.type != 'hollow') continue
              else if (chartPart.drawType == 'shadow' && noWicks) continue
            } else if (type == 'candle') {
              if (chartPart.type != 'candle') continue
              else if (chartPart.drawType == 'shadow') {
                if (noWicks) continue
                var coloredShadowUp =
                  parameters.border_color_up ||
                  stx.getCanvasColor('stx_candle_shadow_up')
                var coloredShadowDown =
                  parameters.border_color_down ||
                  stx.getCanvasColor('stx_candle_shadow_down')
                var coloredShadowEven =
                  parameters.border_color_even ||
                  stx.getCanvasColor('stx_candle_shadow_even')
                if (
                  !CIQ.colorsEqual(coloredShadowUp, coloredShadowDown) ||
                  !CIQ.colorsEqual(coloredShadowUp, coloredShadowEven) ||
                  !CIQ.colorsEqual(coloredShadowUp, stx.defaultColor)
                ) {
                  if (!chartPart.condition) continue
                } else if (chartPart.condition) continue
              }
            } else continue

            var styleArray = stx.canvasStyle(chartPart.style)
            var legendColor = this.getColor(
              stx,
              panel,
              styleArray,
              false,
              false,
              parameters[chartPart.fill]
            )
            var fillColor = this.getColor(
              stx,
              panel,
              styleArray,
              false,
              isGradient,
              parameters[chartPart.fill]
            )
            var borderColor = this.getColor(
              stx,
              panel,
              styleArray,
              chartPart.useBorderStyleProp && !noBorders,
              isGradient,
              parameters[chartPart.border]
            )
            if (chartPart.drawType == 'candle') {
              if (chartPart.type == 'hollow') {
                // Solid candles get no border unless the border color is different than the fill color
                if (
                  !CIQ.isTransparent(fillColor) &&
                  CIQ.colorsEqual(borderColor, fillColor)
                )
                  borderColor = chartPart.useColorInMap
                    ? 'transparent'
                    : fillColor
                if (!chartPart.useColorInMap) fillColor = stx.containerColor
              } else if (chartPart.type == 'candle') {
                // Check to see if the candles are too small for borders
                if (noBorders) {
                  if (CIQ.isTransparent(fillColor)) fillColor = borderColor
                  // transparent candle, draw it with the border color
                  else borderColor = fillColor // non-transparent candle, set the border to the fill color
                }
              }
            }
            caches.push(
              stx.drawBarTypeChartInner({
                fillColor: fillColor,
                borderColor: borderColor,
                condition: chartPart.condition,
                style: chartPart.style,
                type: parameters.hlc ? 'hlc' : chartPart.drawType,
                panel: panel,
                field: parameters.field,
                yAxis: parameters.yAxis,
                volume: parameters.volume,
                overlayScaling: parameters.overlayScaling,
                highlight: parameters.highlight,
              })
            )
            if (!colors) colors = {}
            if (chartPart.useColorInMap) colors[legendColor] = 1
          }
        }
        stx.endClip()
        for (var c in colors) {
          if (!parameters.hollow || !CIQ.equals(c, stx.containerColor)) {
            rc.colors.push(c)
          }
        }
        for (c = 0; c < caches.length; c++) {
          for (var x = 0; x < caches[c].cache.length; x++) {
            var v = caches[c].cache[x]
            if (v || v === 0) rc.cache[x] = v
          }
        }
        return rc
      }

      /**
	 * Creates a Bars renderer
	 *
	 * Note: by default the renderer will display bars as underlays. As such, they will appear below any other studies or drawings.
	 *
	 * The Bars renderer is used to create the following drawing types: bar, colored bar.
	 *
	 * See {@link CIQ.Renderer#construct} for parameters required by all renderers
	 * @param {object} config Config for renderer
	 * @param  {object} [config.params] Parameters to control the renderer itself
	 * @param  {boolean} [config.params.useChartLegend=false] Set to true to use the built in canvas legend renderer. See {@link CIQ.ChartEngine.Chart#legendRenderer};
	 * @param  {string} [config.params.style] Optional style name to use in lieu of defaults for the type
	 * @param  {boolean} [config.params.colored] For bar or hlc, specifies using a condition or colorFunction to determine color
	 * @param  {string} [config.params.colorBasis="close"] Will compute color based on whether current close is higher or lower than previous close.  Set to "open" to compute this off the open rather than yesterday's close.
	 * @param  {function} [config.params.colorFunction] Optional override function (or string) used to determine color of bar.  May be an actual function or a string name of the registered function (see {@link CIQ.Renderer.registerColorFunction})
	 * @constructor
	 * @name  CIQ.Renderer.Bars
	 * @since 5.1.1, creates only Bar type charts
	 * @example
	 	// Colored bar chart
		var renderer=stxx.setSeriesRenderer(new CIQ.Renderer.Bars({params:{name:"bars", type:"bar", colored:true}}));
	 *
	 */

      CIQ.Renderer.Bars = function(config) {
        this.construct(config)
        var params = this.params
        params.type = 'bar'
        this.highLowBars = this.barsHaveWidth = this.standaloneBars = true
        params.hlc = params.volume = params.hollow = params.histogram = false
      }
      CIQ.Renderer.Bars.ciqInheritsFrom(CIQ.Renderer.OHLC, false)

      /**
	 * Creates a HLC renderer
	 *
	 * Note: by default the renderer will display bars as underlays. As such, they will appear below any other studies or drawings.
	 *
	 * The HLC renderer is used to create the following drawing types: hlc, colored hlc.
	 *
	 * See {@link CIQ.Renderer#construct} for parameters required by all renderers
	 * @param {object} config Config for renderer
	 * @param  {object} [config.params] Parameters to control the renderer itself
	 * @param  {boolean} [config.params.useChartLegend=false] Set to true to use the built in canvas legend renderer. See {@link CIQ.ChartEngine.Chart#legendRenderer};
	 * @param  {string} [config.params.style] Optional style name to use in lieu of defaults for the type
	 * @param  {boolean} [config.params.colored] For bar or hlc, specifies using a condition or colorFunction to determine color
	 * @param  {string} [config.params.colorBasis="close"] Will compute color based on whether current close is higher or lower than previous close.  Set to "open" to compute this off the open rather than yesterday's close.
	 * @param  {function} [config.params.colorFunction] Optional override function (or string) used to determine color of bar.  May be an actual function or a string name of the registered function (see {@link CIQ.Renderer.registerColorFunction})
	 * @constructor
	 * @name  CIQ.Renderer.HLC
	 * @since 5.1.1
	 * @example
	 	// Colored hlc chart
		var renderer=stxx.setSeriesRenderer(new CIQ.Renderer.HLC({params:{name:"hlc", colored:true}}));
	 *
	 */

      CIQ.Renderer.HLC = function(config) {
        this.construct(config)
        var params = this.params
        params.type = 'bar'
        params.hlc = true
        this.highLowBars = this.barsHaveWidth = this.standaloneBars = true
        params.volume = params.hollow = params.histogram = false
      }
      CIQ.Renderer.HLC.ciqInheritsFrom(CIQ.Renderer.Bars, false)

      /**
	 * Creates a Candles renderer, a derivation of the Bars renderer
	 *
	 * Note: by default the renderer will display candles as underlays. As such, they will appear below any other studies or drawings.
	 *
	 * The Candles renderer is used to create the following drawing types: candle, hollow candle, volume candle
	 *
	 * See {@link CIQ.Renderer#construct} for parameters required by all renderers
	 * @param {object} config Config for renderer
	 * @param  {object} [config.params] Parameters to control the renderer itself
	 * @param  {boolean} [config.params.useChartLegend=false] Set to true to use the built in canvas legend renderer. See {@link CIQ.ChartEngine.Chart#legendRenderer};
	 * @param  {string} [config.params.style] Optional style name to use in lieu of defaults for the type
	 * @param  {boolean} [config.params.hollow] Specifies candles should be hollow candles
	 * @param  {boolean} [config.params.volume] Specifies candles should be volume candles
	 * @param  {function} [config.params.colorFunction] Optional override function (or string) used to determine color of candle.  May be an actual function or a string name of the registered function (see {@link CIQ.Renderer.registerColorFunction})
	 * @constructor
	 * @name  CIQ.Renderer.Candles
	 * @since 5.1.1
	 * @example
	 	// Hollow candle chart
		var renderer=stxx.setSeriesRenderer(new Candles({params:{name:"candles", hollow:true}}));
	 *
	 */
      CIQ.Renderer.Candles = function(config) {
        this.construct(config)
        var params = this.params
        params.type = 'candle'
        this.highLowBars = this.barsHaveWidth = this.standaloneBars = true
        params.hlc = params.colored = params.histogram = false
        if (params.volume) params.hollow = true
      }
      CIQ.Renderer.Candles.ciqInheritsFrom(CIQ.Renderer.OHLC, false)

      /**
	 * Creates a SimpleHistogram renderer
	 *
	 * Note: by default the renderer will display histogram as underlays. As such, they will appear below any other studies or drawings.
	 *
	 * The SimpleHistogram renderer is used to create a histogram with the top of each bar representing the value of the field.
	 * It is a much simpler form of histogram than that produced by the Histogram renderer (advanced package).
	 *
	 * See {@link CIQ.Renderer#construct} for parameters required by all renderers
	 * @param {object} config Config for renderer
	 * @param  {object} [config.params] Parameters to control the renderer itself
	 * @param  {boolean} [config.params.useChartLegend=false] Set to true to use the built in canvas legend renderer. See {@link CIQ.ChartEngine.Chart#legendRenderer};
	 * @param  {string} [config.params.style] Optional style name to use in lieu of defaults for the type
	 * @param  {boolean} [config.params.gradient=true] Specifies histogram bars are to be drawn with a gradient; set to false to draw with solid colors
	 * @param  {function} [config.params.colorFunction] Optional override function (or string) used to determine color of bar.  May be an actual function or a string name of the registered function (see {@link CIQ.Renderer.registerColorFunction})
	 * @constructor
	 * @name  CIQ.Renderer.SimpleHistogram
	 * @since 5.1.1
	 * @example
	 	// SimpleHistogram under the main chart plot
		var renderer=stxx.setSeriesRenderer(new CIQ.Renderer.SimpleHistogram({params:{name:"histogram", overChart:false}}));
	 *
	 */

      CIQ.Renderer.SimpleHistogram = function(config) {
        this.construct(config)
        var params = this.params
        params.type = 'candle'
        params.histogram = true
        this.barsHaveWidth = this.standaloneBars = true
        this.highLowBars = false
        params.hlc = params.colored = params.hollow = params.volume = false
      }
      CIQ.Renderer.SimpleHistogram.ciqInheritsFrom(CIQ.Renderer.Candles, false)

      return _exports
    }

  var __engine_ =
    //-------------------------------------------------------------------------------------------
    // Copyright 2012-2017 by ChartIQ, Inc.
    // All rights reserved
    //-------------------------------------------------------------------------------------------
    function(_exports, market) {
      var CIQ = _exports.CIQ,
        $$ = _exports.$$,
        $$$ = _exports.$$$,
        splinePlotter = _exports.SplinePlotter,
        timezoneJS = _exports.timezoneJS

      /**
       * Previously `STXChart`.
       * This is the constructor that creates a chart engine, instantiates its basic chart object and links it to its DOM container.
       * Before any chart operations can be performed, this constructor must be called.
       *
       * Multiple CIQ.ChartEngine (stx) objects can exist on an HTML document.
       *
       * Once instantiated, the chart engine will never need to be constructed again, unless it is [destroyed]{@link CIQ.ChartEngine#destroy}.
       * To load or change symbols on the chart, simply call {@link {@link CIQ.ChartEngine#newChart}.
       *
       * @constructor
       * @param {object} config Configuration object. Any field or object within the config parameter will be preset or added to the CIQ.ChartEngine object itself.
       * Generally you will want to at least include {container: <your div element>}.
       * @name  CIQ.ChartEngine
       * @example
       * // declare a chart
       * var stxx=new CIQ.ChartEngine({container: $$("chartContainer")});
       * // override defaults after a chart object is declared (this can be done at any time. If the chart has already been rendered, you will need to call `stx.draw();` to immediately see your changes )
       * stxx.yaxisLabelStyle="roundRectArrow";
       * stxx.layout.chartType="bar";
       * @example
       * // declare a chart and preset defaults
       * var stxx=new CIQ.ChartEngine({container: $$("chartContainer"),layout:{"chartType": "candle","candleWidth": 16}});
       * @since
       * <br>&bull; 15-07-01 deprecated CIQ.ChartEngine#underlayPercentage
       * <br>&bull; m-2016-12-01 deprecated renamed `CIQ.ChartEngine` from `STXChart`
       */
      CIQ.ChartEngine = function(config) {
        if (!config)
          config = {
            container: null,
          }
        if (config.constructor == HTMLDivElement) {
          // legacy versions accepted the chart container as the first parameters rather than a config object
          var newConfig = {
            container: config,
          }
          config = newConfig
        }
        /**
         * READ ONLY. A map of marker objects, sorted by label.
         * @type object
         * @alias markers
         * @memberof CIQ.ChartEngine.prototype
         */
        this.markers = {}
        /**
         * READ ONLY. An array of currently enabled panels
         * @type object
         * @alias panels
         * @memberof CIQ.ChartEngine.prototype
         */
        this.panels = {}
        /**
         * READ ONLY. An array of currently enabled overlay studies
         * @type object
         * @alias overlays
         * @memberof CIQ.ChartEngine.prototype
         */
        this.overlays = {}
        /**
         * READ ONLY. The charts on the screen. Will contain at least one item, "chart"
         * @type object
         * @alias charts
         * @memberof CIQ.ChartEngine.prototype
         */
        this.charts = {}
        /**
         * READ ONLY. Array of event listeners. These listeners will be killed when {@link CIQ.ChartEngine#destroy} is called.
         * @type array
         * @alias eventListeners
         * @memberof CIQ.ChartEngine.prototype
         */
        this.eventListeners = []

        /**
         * Animations. These can be overridden with customized EaseMachines
         * To disable an animation replace with an EaseMchine with one ms as the second parameter.
         * @type {object}
         * @alias animations
         * @memberof CIQ.ChartEngine.prototype
         * @example
         * stxx.animations.zoom=new CIQ.EaseMachine(Math.easeOutCubic,1);
         */
        this.animations = {
          zoom: new CIQ.EaseMachine(Math.easeOutCubic, 400),
        }
        /**
         * Specify a callback by assigning a function to the event. Once the event triggers the callback will be executed.
         *
         * ** Note: All callbacks have been deprecated in favor of {@link CIQ.ChartEngine#addEventListener}**
         *
         * @type object
         * @alias callbacks
         * @memberof CIQ.ChartEngine#
         * @example
         * // using event listener
         * stxx.addEventListener("callbackNameHere", function(callBackParametersHere){
         * 	alert('triggered!');
         * });
         * @example
         * // using callback function
         * stxx.callbacks.callbackNameHere=function(callBackPatamerersHere){
         * 	alert('triggered!');
         * };
         * @deprecated 4.0.0
         */
        this.callbacks = {
          /**
           * Called when a user right clicks on an overlay study. If `forceEdit==true` then a user has clicked
           * on an edit button (cog wheel) so pull up an edit dialog. Otherwise they have simply right clicked so
           * give them a context menu.
           *
           * ***Please note that this callback must be set *before* you call {@link CIQ.ChartEngine#importLayout}.
           * Otherwise your imported studies will not have an edit capability***
           *
           * Format:<br>
           * studyOverlayEdit({stx:stx,sd:sd,inputs:inputs,outputs:outputs, parameters:parameters, forceEdit: forceEdit});
           *
           * The following CSS entry must also be present to enable the `Right click to Manage` text on the mouse-over context menu (div id="mSticky" generated by {@link CIQ.ChartEngine.htmlControls}):
           * ```
           * .rightclick_study #mouseManageText {
           * display: inline; }
           * ```
           * See {@link CIQ.Studies.addStudy} for more details.
           *
           * @type function
           * @alias callbacks[`studyOverlayEdit`]
           * @memberof! CIQ.ChartEngine#
           */
          studyOverlayEdit: null,
          /**
           * Called when a user clicks the edit button on a study panel.
           *
           * ***Please note that this callback should be set *before* you call {@link CIQ.ChartEngine#importLayout}.
           * Otherwise your imported studies will not have an edit capability***
           *
           * Format:<br>
           * studyPanelEdit({stx:stx,sd:sd,inputs:inputs,outputs:outputs, parameters:parameters});
           *
           * See {@link CIQ.Studies.addStudy} for more details.
           *
           * @type function
           * @alias callbacks[`studyPanelEdit`]
           * @memberof! CIQ.ChartEngine#
           */
          studyPanelEdit: null,
          /**
           * Called when a user clicks or taps on the chart. Not called if a drawing tool is active!
           *
           * Format:<br>
           * callback({stx:CIQ.ChartEngine, panel:CIQ.ChartEngine.Panel, x:this.cx, y:this.cy})
           * @type function
           * @alias callbacks[`tap`]
           * @memberof! CIQ.ChartEngine#
           * @example
           * // using event listener
           * stxx.addEventListener("tap", function(tapObject){
           * 	alert('tap event at x: ' + tapObject.x + ' y: '+ tapObject.y);
           * });
           * @example
           * // using callback
           * // this example  uses barFromPixel() to get the actual bar from the pixel location
           * stxx.callbacks.tap= function(tapObject){
           *	var msg= 'tap event at x: ' + tapObject.x + ' y: '+ tapObject.y;
           *	var bar=this.barFromPixel(this.cx);
           *  if(this.chart.dataSegment[bar]) {
           * 	  msg+=' Date:' + this.chart.dataSegment[bar].DT;
           * 	  msg+=' Close:' + this.chart.dataSegment[bar].Close;
           *  }
           *  alert (msg);
           * };
           */
          tap: null,
          /**
           * Called when a user clicks or right clicks on the chart. Not called if the user right clicks on a drawing or study
           * when [stxx.bypassRightClick]{@link CIQ.ChartEngine#bypassRightClick}=true
           *
           * Format:<br>
           * callback({stx:CIQ.ChartEngine, panel:CIQ.ChartEngine.Panel, x:this.cx, y:this.cy})
           * @type function
           * @alias callbacks[`rightClick`]
           * @memberof! CIQ.ChartEngine#
           * @example
           * // using event listener
           * stxx.addEventListener("rightClick", function(rcObject){
           * 	alert('right click event at x: ' + rcObject.x + ' y: '+ rcObject.y);
           * });
           * @since  09-2016-19
           */
          rightClick: null,
          /**
           * Called when a user "long holds" on the chart. By default this is set to 1000 milliseconds.
           * Optionally change the value of stxx.longHoldTime to a different setting, or set to zero to disable.
           *
           * Format:<br>
           * callback({stx:CIQ.ChartEngine, panel:CIQ.ChartEngine.Panel, x:this.cx, y:this.cy})
           * @type function
           * @alias callbacks[`longhold`]
           * @memberof! CIQ.ChartEngine#
           * @example
           * // using event listener
           * stxx.longHoldTime=... // Optionally override default value of 1000ms
           * stxx.addEventListener("longhold", function(lhObject){
           * 	alert('longhold event at x: ' + lhObject.x + ' y: '+ lhObject.y);
           * });
           * @example
           * // using callback function
           * stxx.longHoldTime=... // Optionally override default value of 1000ms
           * stxx.callbacks.longhold=function(lhObject){
           * 	alert('longhold event at x: ' + lhObject.x + ' y: '+ lhObject.y);
           * });
           * @memberof! CIQ.ChartEngine#
           * @since 2016-06-22
           */
          longhold: null,
          /**
           * Called when a user moves on the chart. Not called if a drawing tool is active, panel resizing, etc
           * grab is true if a mouse user has the mouse button down while moving. For touch users it is true
           * if they do not have the crosshair tool enabled.
           *
           * Format:<br>
           * callback({stx:CIQ.ChartEngine, panel:CIQ.ChartEngine.Panel, x:this.cx, y:this.cy, grab:boolean})
           * @type function
           * @alias callbacks[`move`]
           * @memberof! CIQ.ChartEngine#
           */
          move: null,

          /**
           * Called when the layout changes
           *
           * Format:<br>
           * callback({stx:CIQ.ChartEngine, chart:CIQ.ChartEngine.Chart, symbol: String, symbolObject:Object, layout: Object})
           * @type function
           * @alias callbacks[`layout`]
           * @memberof! CIQ.ChartEngine#
           */
          layout: null,
          /**
           * Called when a drawing is added or deleted (all the drawings are returned, not just the new one)
           *
           * Format:<br>
           * callback({stx:CIQ.ChartEngine, symbol: String, symbolObject:Object, drawings: Object})
           * @type function
           * @alias callbacks[`drawing`]
           * @memberof! CIQ.ChartEngine#
           */
          drawing: null,
          /**
           * Called when preferences are changed
           * calback({stx:CIQ.ChartEngine})
           * @type function
           * @alias callbacks[`preferences`]
           * @memberof! CIQ.ChartEngine#
           */
          preferences: null,
          /**
           * Called when a theme is changed
           *
           * Format:<br>
           * callback({stx:CIQ.ChartEngine})
           * @type function
           * @alias callbacks[`theme`]
           * @memberof! CIQ.ChartEngine#
           */
          theme: null,
          /**
           * Called when the symbol is changed (when newChart is called), added (addSeries, addStudy) or removed (removeSeries, removeStudy). Note
           * that this is not called if the symbol change occurs during an importLayout
           *
           * Format:<br>
           * callback({stx:CIQ.ChartEngine, symbol: String, symbolObject:Object, action:["master"|"add-series"|"remove-series"})
           * @type function
           * @alias callbacks[`symbolChange`]
           * @memberof! CIQ.ChartEngine#
           * @since 06-2016-21
           */
          symbolChange: null,
          /**
           * Called when the symbol is first imported into the layout.
           *
           * Format:<br>
           * callback({stx:CIQ.ChartEngine, symbol: String, symbolObject:Object, action:"master"})
           * @type function
           * @alias callbacks[`symbolImport`]
           * @memberof! CIQ.ChartEngine#
           * @since 4.0.0
           */
          symbolImport: null,
          /**
           * Called to determine how many decimal places the stock trades in. This is used for head's up display
           * and also for the current price pointer label.
           *
           * Format:<br>
           * callback({stx:CIQ.ChartEngine, chart:CIQ.ChartEngine.Chart, symbol: String, symbolObject:Object})
           * @type function
           * @alias callbacks[`calculateTradingDecimalPlaces`]
           * @memberof! CIQ.ChartEngine#
           */
          calculateTradingDecimalPlaces: CIQ.calculateTradingDecimalPlaces,
        }
        /**
         * Holds the HTML control elements managed by the chart. Usually this will be a copy of the default [htmlControls]{@link CIQ.ChartEngine#htmlControls}.
         * These are not the GUI elements around the chart, but rather the HTML elements that the library will directly interact with on the canvas
         * for things like panel resizing, study edit controls, zooming controls, etc. See {@link CIQ.ChartEngine#htmlControls} for more details.
         * @type object
         * @alias controls
         * @memberof CIQ.ChartEngine.prototype
         */
        this.controls = {} // contains the HTML controls for the chart (zoom, home, etc)
        this.goneVertical = false // Used internally for pinching algorithm
        /**
         * READ ONLY.. Toggles to true when the screen is being pinched
         * @type boolean
         * @default
         * @alias pinchingScreen
         * @memberof CIQ.ChartEngine.prototype
         */
        this.pinchingScreen = false
        /**
         * READ ONLY.. Toggles to true when the screen is being panned
         * @type boolean
         * @default
         * @alias grabbingScreen
         * @memberof CIQ.ChartEngine.prototype
         */
        this.grabbingScreen = false
        this.grabStartX = 0 // Used internally for panning
        this.grabStartY = 0 // "
        this.grabStartScrollX = 0 // "
        this.grabStartScrollY = 0 // "
        this.swipe = {} // "
        /**
         * Number of pixels the mouse needs to move in vertical direction to "unlock" vertical panning/scrolling.
         * Setting to a number larger than the pixels on the canvas will also disable vertical scrolling
         * @type number
         * @default
         * @alias yTolerance
         * @memberof CIQ.ChartEngine.prototype
         * @example
         * //This will disable the tolerance, so panning will immediately follow the user actions without maintaining a locked vertical location when panning left or right.
         * var stxx=new CIQ.ChartEngine({container:$$$(".chartContainer"), layout:{"candleWidth": 16, "crosshair":true}});
         * stxx.yTolerance=0;
         */
        this.yTolerance = 100

        /**
         * Number of bars to always keep on the left of the screen when the user pans forward in time (moves chart from right to left).
         * If this is set to less than 1 then it will be possible to have a blank chart.
         * See {@link CIQ.ChartEngine.Chart#allowScrollPast} for instructions on how to prevent users from scrolling past the oldest bar on the chart.
         * @type number
         * @default
         * @alias minimumLeftBars
         * @memberof CIQ.ChartEngine.prototype
         * @since 05-2016-10
         */
        this.minimumLeftBars = 1
        this.grabStartCandleWidth = 0 // Used internally for zooming
        this.grabStartZoom = 0 // "
        this.grabOverrideClick = false // "
        this.grabMode = '' // Used internally. Set to either pan, zoom-x or zoom-y when grabbing screen
        this.vectorsShowing = false // Used internally to ensure that vectors aren't drawn more than once
        this.mouseMode = true // Used internally. For Windows8 devices this is set to true or false depending on whether the last touch was a mouse click or touch event. To support all-in-one computers
        /**
         * Set to true to reverse direction of mousewheel for zooming
         * @type boolean
         * @default
         * @alias reverseMouseWheel
         * @memberof CIQ.ChartEngine.prototype
         */
        this.reverseMouseWheel = false
        /**
         * Set to false to turn off mousewheel acceleration
         * @type boolean
         * @default
         * @alias mouseWheelAcceleration
         * @since 2015-11-1
         * @memberof CIQ.ChartEngine.prototype
         */
        this.mouseWheelAcceleration = true
        /**
         * Minimum candleWidth (in pixels) allowed when zooming out. This will determine the maximum number of ticks to display on the chart.
         * Anything smaller than **0.5 pixels** may cause performance issues when zooming out.
         * @type number
         * @default
         * @alias minimumCandleWidth
         * @memberof CIQ.ChartEngine.prototype
         */
        this.minimumCandleWidth = 1
        /**
         * Minimum number of ticks to display when zooming in.
         * @type number
         * @default
         * @alias minimumZoomTicks
         * @memberof CIQ.ChartEngine.prototype
         * @since 07-2016-16.6
         */
        this.minimumZoomTicks = 9
        /**
         * Set to false to disable any user zooming on the chart
         * @type boolean
         * @default
         * @alias allowZoom
         * @memberof CIQ.ChartEngine.prototype
         * @since 04-2015
         * @example
         * var stxx=new CIQ.ChartEngine({container:$$$(".chartContainer"), allowZoom:false, layout:{"candleWidth": 16, "crosshair":true}});
         */
        this.allowZoom = true
        /**
         * Set to false to disable any user scrolling of the chart
         * @type boolean
         * @default
         * @alias allowScroll
         * @memberof CIQ.ChartEngine.prototype
         * @since 04-2015
         * @example
         * var stxx=new CIQ.ChartEngine({container:$$$(".chartContainer"), allowScroll:false, layout:{"candleWidth": 16, "crosshair":true}});
         */
        this.allowScroll = true
        /**
         * Set to false to disable 2 finger side swipe motion for scrolling
         * @type boolean
         * @default
         * @alias allowSideswipe
         * @memberof CIQ.ChartEngine.prototype
         * @since 2015-12-08
         */
        this.allowSideswipe = true
        /**
         * If set to true then a three finger movement will increment periodicity.
         * @type boolean
         * @default
         * @alias allowThreeFingerTouch
         * @memberof CIQ.ChartEngine.prototype
         */
        this.allowThreeFingerTouch = false
        /**
         * Set to `true` to bypass right clicks on **all** overlay types.
         * Or define independent settings for series, studies, and drawings by using an object instead.
         * Also see <a href="CIQ.ChartEngine.html#callbacks%5B%60rightClick%60%5D">CIQ.ChartEngine#callbacks.rightClick</a>
         * @type object
         * @default
         * @alias bypassRightClick
         * @memberof CIQ.ChartEngine.prototype
         * @since 2016-07-16
         * Since 5.1.0: An object containing booleans to separate series, studies, and drawings.
         * @example
         * this.bypassRightClick={
         *	series: false,
         *	study: false,
         *	drawing: false
         * };
         */
        this.bypassRightClick = {
          series: false,
          study: false,
          drawing: false,
        }

        this.anyHighlighted = false // READ ONLY. Toggles to true if any drawing or overlay is highlighted for deletion
        this.accessoryTimer = null // Used internally to control drawing performance
        this.lastAccessoryUpdate = new Date().getTime() // "
        this.displayCrosshairs = true // READ ONLY. Use doDisplayCrosshairs() or undisplayCrosshairs()
        this.hrPanel = null // READ ONLY. Current panel that mouse is hovering over
        this.editingAnnotation = false // READ ONLY. True if an annotation is open for editing
        this.openDialog = '' // Set this to non-blank to disable chart touch and mouse events use CIQ.ChartEngine.prototype.modalBegin() and CIQ.ChartEngine.prototype.modalEnd

        /**
         * Set these to false to not display the up and down arrows in the panel management component. See {@link CIQ.ChartEngine#controls} for alternate methods and more details.
         * @type boolean
         * @default
         * @alias displayIconsUpDown
         * @memberof CIQ.ChartEngine.prototype
         * @example
         * stxx.displayIconsUpDown=false;
         */
        this.displayIconsUpDown = true
        /**
         * Set these to false to not display this panel management component. See {@link CIQ.ChartEngine#controls} for alternate methods and more details.
         * @type boolean
         * @default
         * @alias displayIconsSolo
         * @memberof CIQ.ChartEngine.prototype
         * @example
         * stxx.displayIconsSolo=false;
         */
        this.displayIconsSolo = true
        /**
         * Set these to false to not display this panel management component. See {@link CIQ.ChartEngine#controls} for alternate methods and more details.
         * @type boolean
         * @default
         * @alias displayIconsClose
         * @memberof CIQ.ChartEngine.prototype
         * @since 3.0.7
         * @example
         * stxx.displayIconsClose=false;
         */
        this.displayIconsClose = true
        /**
         * Set these to false to not display this panel management component. See {@link CIQ.ChartEngine#controls} for alternate methods and more details.
         * @type boolean
         * @default
         * @alias displayPanelResize
         * @memberof CIQ.ChartEngine.prototype
         * @example
         * stxx.displayPanelResize=false;
         */
        this.displayPanelResize = true
        /**
         * Set this to true to hide even the chart panel when soloing a non-chart panel.  Normally chart panels are not hidden when soloing.
         * @type boolean
         * @default
         * @alias soloPanelToFullScreen
         * @memberof CIQ.ChartEngine.prototype
         * @since 3.0.7
         * @example
         * stxx.soloPanelToFullScreen=true;
         */
        this.soloPanelToFullScreen = false
        /**
         * Only reposition markers this many milliseconds. Set to zero or null for no visible delay. (lower numbers are more CPU intensive).
         * See {@tutorial Markers} for more details on adding markers to your charts
         * @type number
         * @default
         * @alias markerDelay
         * @memberof CIQ.ChartEngine.prototype
         * @example
         * stxx.markerDelay=25;
         */
        this.markerDelay = 0
        /**
         * When set to true, the backing store for the canvas is used.
         * This results in crisper display but with a noticeable performance penalty in some browsers.
         * The default is true.
         * If improved performance is necessary, set the variable as shown in the example.
         * The example allows mobile devices (android/ipad/iphone) to continue using the backing store while being bypassed in others (desktop browsers).
         *
         * @type boolean
         * @default
         * @alias useBackingStore
         * @memberof CIQ.ChartEngine.prototype
         * @since 3.0.0
         * @example
         * stxx.useBackingStore=CIQ.isMobile;
         */
        this.useBackingStore = true

        /**
         * On touch devices, when set to true, the backing store will be turned off while a user is panning or zooming the chart. This increases performance during the operation by reducing
         * resolution. Resolution is restored once the user lifts their finger. Generally, you'll want to enable this dynamically when you know that a particular device has poor canvas performance.
         * This defaults to true but can be disabled by setting to false.
         * @type boolean
         * @default
         * @alias disableBackingStoreDuringTouch
         * @memberOf  CIQ.ChartEngine.prototype
         * @since  4.0.0
         */
        this.disableBackingStoreDuringTouch = CIQ.isMobile
        /**
         * If true when the chart initially is rendered, then the CIQ.ChartEngine object will register to listen and manage touch and mouse browser events within then canvas by attaching them to the container div.
         *
         * Set to false to restrict all events registration and optionally turn into a static chart.
         * Users will not be able to zoom or scroll.
         * See {@tutorial Creating Static Charts} for more details on creating static charts.
         *
         * It is possible to re-enable the events after the chart has been rendered, but you must call stx.initializeChart(); stx.draw(); to register the events once again.
         * @type boolean
         * @default
         * @alias manageTouchAndMouse
         * @memberof CIQ.ChartEngine.prototype
         * @example
         * // if enabling events after the chart was already rendered, you must reinitialize to re register the browser events.
         * stxx.manageTouchAndMouse = true;
         * stxx.initializeChart();
         * stxx.draw();
         */
        this.manageTouchAndMouse = true
        /**
         * Primarily intended for mobile devices, if set to false it will allow up/down swiping to pass trough the chart container so the main page can manage it.
         * This allows a user swiping up and down to swipe trough the chart instead of having the chart capture the event and prevent the page from continue moving.
         * It therefore produces a more natural up/down swiping motion throughout the page.
         * @type boolean
         * @default
         * @alias captureTouchEvents
         * @memberof CIQ.ChartEngine.prototype
         * @since 12-2015-08
         */
        this.captureTouchEvents = true
        /**
         * If set to false it will allow up/down mouseWheel / touchPad swiping to pass trough the chart container so the main page can manage it.
         * This allows a user swiping up and down to swipe trough the chart instead of having the chart capture the event and prevent the page from continue moving.
         * It therefore produces a more natural up/down sliding of the page.
         * @type boolean
         * @default
         * @alias captureMouseWheelEvents
         * @memberof CIQ.ChartEngine.prototype
         * @since m-2016-12-01.4
         */
        this.captureMouseWheelEvents = true
        this.touches = [] // Used internally for touch
        this.changedTouched = [] // Used internally for touch
        /**
         * The value (price) representing the crosshair cursor point
         * @type number
         * @alias crosshairTick
         * @memberof CIQ.ChartEngine.prototype
         */
        this.crosshairTick = null
        /**
         * READ ONLY.. The value (price) representing the crosshair cursor point
         * @type number
         * @alias crosshairValue
         * @memberof CIQ.ChartEngine.prototype
         */
        this.crosshairValue = null
        /**
         * Set to either "roundRectArrow", "semiRoundRect", "roundRect","tickedRect","rect","noop"
         * @type string
         * @default
         * @alias yaxisLabelStyle
         * @memberof CIQ.ChartEngine.prototype
         * @example
         * var stxx=new CIQ.ChartEngine({container: $$("chartContainer")});
         * stxx.yaxisLabelStyle="roundRectArrow";
         */
        this.yaxisLabelStyle = 'roundRectArrow'
        /**
         * Set to false if you don't want the axis borders drawn. This will override individual settings on yaxis and xaxis.
         * @type boolean
         * @default
         * @alias axisBorders
         * @memberof CIQ.ChartEngine.prototype
         */
        this.axisBorders = null

        this.pt = {
          x1: -1,
          x2: -1,
          y1: -1,
          y2: -1,
        }
        this.moveA = -1 // Used internally for touch
        this.moveB = -1 // "
        this.touchStartTime = -1 // "
        this.gestureStartDistance = -1 // "
        this.grabStartPeriodicity = 1 // "
        this.grabEndPeriodicity = -1 // "
        this.scrollEvent = null // "
        this.cmd = false // "
        this.ctrl = false // "
        this.shift = false // "
        this.userPointerDown = false //represents either mouse button or finger on touch device
        /**
		     * Set to true based on a key stroke, button press, etc, when you want to enable the ability to clone a highlighted drawing.
		     * Reset to false when you want the cloning to end.
		     * For example, you can set to true when the `control` key is pressed and disable when it is released.
		     * @type number
		     * @default
		     * @alias cloneDrawing
		     * @memberof CIQ.ChartEngine.prototype
		     * @since 07-2016-16.7
		     * @example
		     *
				document.onkeyup=keyup;
				document.onkeydown=keydown;

				// disable cloning if the ctl key is released
				function keyup(e){
					var key = (window.event) ? event.keyCode : e.keyCode;
					if (key == 18 ) stxx.cloneDrawing=false;
				}

				// enable cloning if the ctl key is pressed
				function keydown(e){
					var key = (window.event) ? event.keyCode : e.keyCode;
					if (key == 18 ) stxx.cloneDrawing=true;
				}
		     */
        this.cloneDrawing = false
        /**
         * Set to true to have drawings highlight only the last applied drawing if more than one is intersected at a time.
         * @type boolean
         * @default
         * @since 5.0.0
         * @alias singleDrawingHighlight
         * @memberof CIQ.ChartEngine.prototype
         */
        this.singleDrawingHighlight = true
        /**
         * X axis offset for touch devices so that finger isn't blocking crosshair
         * @type number
         * @default
         * @alias crosshairXOffset
         * @memberof CIQ.ChartEngine.prototype
         */
        this.crosshairXOffset = -40
        /**
         * Y axis Offset for touch devices so that finger isn't blocking crosshair
         * @type number
         * @default
         * @alias crosshairYOffset
         * @memberof CIQ.ChartEngine.prototype
         */
        this.crosshairYOffset = -40
        /**
         * READ ONLY. This gets set to true when the chart display has been initialized.
         * @type boolean
         * @default
         * @alias displayInitialized
         * @memberof CIQ.ChartEngine.prototype
         */
        this.displayInitialized = false
        /**
         * READ ONLY. Mouse pointer X pixel location in reference to the chart canvas. where cx=0 and cy=0 is the upper left corner of the chart.
         * @type number
         * @alias cx
         * @memberof CIQ.ChartEngine.prototype
         */
        this.cx = null
        /**
         * READ ONLY. Mouse pointer Y pixel location in reference to the chart canvas. where cx=0 and cy=0 is the upper left corner of the chart.
         * @type number
         * @alias cy
         * @memberof CIQ.ChartEngine.prototype
         */
        this.cy = null

        /**
         * When set to true, line and mountain charts are extended slightly in order to reduce whitespace at the right edge of the chart
         * @type boolean
         * @default
         * @alias extendLastTick
         * @memberof CIQ.ChartEngine.prototype
         * @since 05-2016-10 The line will be extended to the end of the chart (full candle width) instead of the candle border, even when using yaxisLabelStyle "roundRectArrow"
         */
        this.extendLastTick = false

        this.clicks = {
          s1MS: -1,
          e1MS: -1,
          s2MS: -1,
          e2MS: -1,
        }

        this.cancelTouchSingleClick = false // Set this to true whenever a screen item is touched so as to avoid a chart touch event
        /**
         * Contains the current chart layout.
         *
         * Layout parameters can be directly **pre-set** on a chart at the time the engine is instantiated.<br>
         * The following is an example for setting some of the available layout parameters:
         * ```
         * var stxx=new CIQ.ChartEngine({container: $$("chartContainer"),layout:{"crosshair":true,"interval":"day","periodicity":1,"chartType": "candle","candleWidth": 16}});
         * ```
         * These parameters will then be activated when [newChart()]{@link CIQ.ChartEngine#newChart} is called to render the chart.<br>
         * Once a chart is rendered, most of these parameters become READ ONLY,and must be modified using their corresponding methods, as indicated in the documentation, to ensure chart integrity.
         *
         * See [importLayout]{@link CIQ.ChartEngine#importLayout} and [exportLayout]{@link CIQ.ChartEngine#exportLayout} for methods to serialize a layout and restore previously saved settings.
         *
         * @type object
         * @alias layout
         * @memberof CIQ.ChartEngine#
         */
        this.layout = {
          /**
           * READ ONLY. Chart interval.
           *
           * Note that internal periodicity format will differ from API parameters used in {@link CIQ.ChartEngine#setPeriodicity}
           *
           * Available options are:
           *  - [number] representing minutes
           *  - "day"
           *  - "week"
           *  - "month"
           *
           * See the [Periodicity and Quote feed]{@tutorial Periodicity} tutorial.
           * @type string
           * @default
           * @alias layout[`interval`]
           * @memberof! CIQ.ChartEngine#
           */
          interval: 'day',
          /**
           * READ ONLY. Number of periods per interval/timeUnit
           *
           * See the [Periodicity and Quote feed]{@tutorial Periodicity} tutorial.
           * @type number
           * @default
           * @alias layout[`periodicity`]
           * @memberof! CIQ.ChartEngine#
           */
          periodicity: 1,
          /**
				 * READ ONLY. Time unit for the interval.
				 *
				 * Note that internal periodicity format will differ from API parameters used in {@link CIQ.ChartEngine#setPeriodicity}
				 *
			     * See the [Periodicity and Quote feed]{@tutorial Periodicity} tutorial.

				 * Available options are:
				 *  - "millisecond"
				 *  - "second"
				 *  - "minute"
				 *  - null for "day", "week", "month" periodicity
				 * @type string
				 * @default
				 * @memberof! CIQ.ChartEngine#
				 */
          timeUnit: null,
          /**
           * READ ONLY. Candle Width In pixels ( see {@tutorial Managing Chart Zoom and Range} )
           * @type number
           * @default
           * @alias layout[`candleWidth`]
           * @memberof! CIQ.ChartEngine#
           */
          candleWidth: 8,
          volumeUnderlay: false,
          /**
           * Whether adjusted or nominal prices are being displayed.
           * If true then the chart will look for "Adj_Close" in the masterData as an alternative to "Close".
           * @type boolean
           * @default
           * @alias layout[`adj`]
           * @memberof! CIQ.ChartEngine#
           * @instance
           */
          adj: true,
          /**
           * READ ONLY. Whether crosshairs are being displayed.
           *
           * Use {@link CIQ.ChartEngine.showCrosshairs} to enable or disable crosshairs.
           *
           * @type boolean
           * @default
           * @alias layout[`crosshair`]
           * @memberof! CIQ.ChartEngine#
           * @instance
           */
          crosshair: false,
          /**
           * READ ONLY. The primary chart type.
           *
           * Available options are:
           *  - "none"
           *  - "line"
           *  - "step"
           *  - "mountain"
           *  - "baseline_delta"
           *  - "candle"
           *  - "bar"
           *  - "hlc"
           *  - "hlc_box" **Requires "js/extras/hlcbox.js"**
           *  - "hlc_shaded_box" **Requires "js/extras/hlcbox.js"**
           *  - "wave"
           *  - "scatterplot"
           *  - "histogram"
           *  - "rangechannel"
           *
           * Variations of these types are available by prepending terms to the options as follows:
           *  - "step_" - add to mountain, baseline_delta  e.g. step_mountain, baseline_delta_step
           *  - "vertex_" - add to line, step, mountain, baseline_delta
           *  - "hollow_" - add to candle
           *  - "volume_" - add to candle
           *  - "colored_" - add to line, mountain, step, bar, hlc
           *  - "mountain_" - add to baseline_delta
           *
           * Other options are available provided a renderer is created with a `requestNew` function which will support the option, see {@link CIQ.Renderer.Lines#requestNew} and {@link CIQ.Renderer.OHLC#requestNew}
           *
           * Use {@link CIQ.ChartEngine#setChartType} to set this value.
           *
           * See {@tutorial Chart Styles and Types} for more details.
           *
           * @type string
           * @default
           * @alias layout[`chartType`]
           * @memberof! CIQ.ChartEngine#
           * @since
           * <br>&bull; 05-2016-10.1 "baseline_delta_mountain" and  "colored_mountain" are now available
           * <br>&bull; 3.0.0 "histogram" and  "step" are now available
           * <br>&bull; 3.0.7 "hlc" now available
           * <br>&bull; 4.0.0 "colored_step", "colored_hlc" is now available
           * <br>&bull; 5.1.0 More chart types available using combinations of terms
           */
          chartType: 'candle',
          /**
           * Flag for extended hours time-frames.
           *
           * The chart includes the 'extended' parameter in the `params` object sent into the `fetch()` call.
           * Your quote feed must be able to provide extended hours data when requested (`extended:true`) for any extended hours functionality to work.
           *
           * See {@link CIQ.ExtendedHours} and {@link CIQ.Market} for more details on how extended hours are set and used.
           * @type boolean
           * @default
           * @alias layout[`extended`]
           * @memberof! CIQ.ChartEngine#
           */
          extended: false,
          /**
           * Tracks the extended market sessions to display on the chart.
           *
           * Once set, call newChart() to enable the corresponding time-frames in the x axis and load the data for these sessions.
           * Session names must match the session names declared in {@link CIQ.Market}.
           *
           * See {@link CIQ.ExtendedHours} and {@link CIQ.Market} for more details on how extended hours are set and used.
           * @type object
           * @default
           * @alias layout[`marketSessions`]
           * @memberof! CIQ.ChartEngine#
           * @example
           * marketSessions = {
           *      "session1": true,
           *      "session2": true,
           *      "session3": false,
           *      "pre": true,
           *      "post": true
           * }
           * @since  06-2016-02
           */
          marketSessions: {}, //use defaults
          /**
           * READ ONLY. Active aggregation for the chart.
           *
           * See {@link CIQ.ChartEngine#setAggregationType}
           * @type string
           * @default
           * @alias layout[`aggregationType`]
           * @memberof! CIQ.ChartEngine#
           */
          aggregationType: 'ohlc',
          /**
           * READ ONLY. Active scale for the chart.
           *
           * See {@link CIQ.ChartEngine#setChartScale}
           *
           * **Replaces CIQ.ChartEngine.layout.semiLog**
           *
           * @type string
           * @default
           * @alias layout[`chartScale`]
           * @memberof! CIQ.ChartEngine#
           */
          chartScale: 'linear',
          studies: {},
          panels: {},
          setSpan: {},
        }
        /**
		     * Contains the chart preferences.
		     *
		     * Preferences parameters, unless otherwise indicated, can be set at any time and only require a [draw()]{@link CIQ.ChartEngine#draw} call to activate.
		     *
		     * See [importPreferences]{@link CIQ.ChartEngine#importPreferences} and [exportPreferences]{@link CIQ.ChartEngine#exportPreferences} for methods to serialize and restore previously saved preferences.

		     * @type object
		     * @alias preferences
		     * @memberof CIQ.ChartEngine#
		     */
        this.preferences = {
          /**
           * Pixel radius for the invisible intersection box around the cursor used to determine if it has intersected with an element to be highlighted.
           * Used on items removed with a right click such as series and drawings.
           *
           * Only applicable if the user has **not** tapped on the screen to set the location of the cross-hair.
           *
           * @type number
           * @default
           * @alias preferences[`highlightsRadius`]
           * @memberof! CIQ.ChartEngine#
           * @since 3.0.0
           */
          highlightsRadius: 10,
          /**
           * Pixel radius for the invisible intersection box around the cursor used to determine if it has intersected with an element to be highlighted.
           * Used on items removed with a right click such as series and drawings.
           *
           * ** Only applicable if the user has tapped on the screen to set the location of the cross-hair. **
           *
           * @type number
           * @default
           * @alias preferences[`highlightsTapRadius`]
           * @memberof! CIQ.ChartEngine#
           * @since 3.0.0
           */
          highlightsTapRadius: 30,
          /**
           * Draw a horizontal line at the current price.
           * Only drawn if the most recent tick is visible.
           *
           * See {@link CIQ.ChartEngine.AdvancedInjectable#drawCurrentHR}
           *
           * @type boolean
           * @default
           * @alias preferences[`currentPriceLine`]
           * @memberof! CIQ.ChartEngine#
           * @since 05-2016-10
           */
          currentPriceLine: false,
          /**
           * Magnetize the crosshairs to datapoints during drawing operations to improve placement accuracy. See {@link CIQ.ChartEngine.AdvancedInjectable#magnetize} for more details
           * @type boolean
           * @default
           * @alias preferences[`magnet`]
           * @memberof! CIQ.ChartEngine#
           */
          magnet: false,
          /**
           * Locks the crosshair Y value to the value of the field name specified
           * for the tick under the cursor on the primary chart.
           *
           * For studies create a horizontalCrosshairFieldFN function that will be called by
           * CIQ.Studies.addStudy. The function must return the field name in the dataSet to
           * reference. The function will not be called when the study is set to overly or
           * underlay the chart's panel.
           *
           * @example
           * // Have the crosshair lock to the "Close" field of the tick under the cursor
           * stxx.preferences.horizontalCrosshairField = "Close";
           *
           * @example
           * // Have the crosshair lock to the "ATR ATR (14)" field for a ATR study with a period of 14
           * CIQ.Studies.studyLibrary["ATR"].horizontalCrosshairFieldFN = function(stx, sd) {
           * 	// returns the field name, which should be created by the study's "calculateFN"
           * 	return "ATR " + sd.name;
           * };
           *
           * @type string
           * @default
           * @alias preferences[`horizontalCrosshairField`]
           * @memberof! CIQ.ChartEngine#
           * @since 04-2016-08
           */
          horizontalCrosshairField: null,
          /**
			     * Set to true to display labels on y-axis for line based studies using {@link CIQ.Studies.displayIndividualSeriesAsLine} or {@link CIQ.Studies.displaySeriesAsLine} (this is overridden by the particular y-axis setting of {@link CIQ.ChartEngine.YAxis#drawPriceLabels}).
			     * This flag is checked inside these 2 functions to decide if a label should be set, as such if you do not wish to have a label on a particular study line, you can set this flag to `false`, before calling the function, and then back to `true`.
			     * @type boolean
			     * @default
			     * @alias preferences[`labels`]
			     * @memberof! CIQ.ChartEngine#
			     * @example
					//do not display the price labels for this study
					stxx.preferences.labels=false;
					CIQ.Studies.displaySeriesAsLine(stx, sd, quotes);

					//restore price labels to default value
					stxx.preferences.labels=true;
			     */
          labels: true,
          /**
           * Stores preferred language for the chart.
           *
           * It can be individually restored using {@link CIQ.I18N.setLanguage} and activated by {@link CIQ.I18N.translateUI}
           * @type {string}
           * @alias preferences[`language`]
           * @memberof! CIQ.ChartEngine#
           * @since 4.0.0
           */
          language: null,
          /**
           * Stores the preferred timezone for the display of the x axis labels.
           *
           * It is automatically set and can be individually restored by {@link CIQ.ChartEngine#setTimeZone}.
           * @type {string}
           * @alias preferences[`timezone`]
           * @memberof! CIQ.ChartEngine#
           * @since 4.0.0
           */
          timeZone: null,
          /**
           * Initial whitespace on right of the screen in pixels.
           * @type number
           * @default
           * @alias preferences[`whitespace`]
           * @memberof! CIQ.ChartEngine#
           * @example
           * // override the default value at declaration time
           * var stxx=new CIQ.ChartEngine({container:$$$(".chartContainer"), preferences:{"whitespace": 20}});
           */
          whitespace: 50,
          /**
           * zoom-in speed for mousewheel and zoom button.
           *
           * Range: **0 -.99999**. The closer to 1 the slower the zoom.
           * @type number
           * @default
           * @alias preferences[`zoomInSpeed`]
           * @memberof! CIQ.ChartEngine#
           * @example
           * stxx.preferences.zoomInSpeed=.98;
           * @example
           * var stxx=new CIQ.ChartEngine({container:$$$(".chartContainer"), preferences:{"zoomInSpeed": .98}});
           * @since 07/01/2015
           */
          zoomInSpeed: null,
          /**
           * zoom-out speed for mousewheel and zoom button.
           *
           * Range: **1-2**. The closer to 1 the slower the zoom.
           * @type number
           * @default
           * @alias preferences[`zoomOutSpeed`]
           * @memberof! CIQ.ChartEngine#
           * @example
           * stxx.preferences.zoomOutSpeed=1;
           * @example
           * var stxx=new CIQ.ChartEngine({container:$$$(".chartContainer"), preferences:{"zoomOutSpeed": 1}});
           * @since 07/01/2015
           */
          zoomOutSpeed: null,
          /**
           * If set to 'true', the mouse wheel zooming is centered by the mouse position.
           *
           * @type boolean
           * @default
           * @alias preferences[`zoomAtCurrentMousePosition`]
           * @memberof! CIQ.ChartEngine#
           * @since 4.0.0
           */
          zoomAtCurrentMousePosition: false,
        }
        /**
         * Used to control the behavior and throttling of real time updates in [updateChartData()]{@link CIQ.ChartEngine#updateChartData} to prevent overloading the chart engine
         * @type object
         * @alias streamParameters
         * @memberof CIQ.ChartEngine#
         */
        this.streamParameters = {
          count: 0,
          /**
           * ms to wait before allowing update to occur (if this condition is met, the update will occur and all pending ticks will be loaded - exclusive of maxTicks)
           * @type number
           * @default
           * @alias streamParameters[`maxWait`]
           * @memberof! CIQ.ChartEngine#
           */
          maxWait: 1000,
          /**
           * ticks to wait before allowing update to occur (if this condition is met, the update will occur and all pending ticks will be loaded - exclusive of maxWait)
           * @type number
           * @default
           * @alias streamParameters[`maxTicks`]
           * @memberof! CIQ.ChartEngine#
           */
          maxTicks: 100,
          timeout: -1,
          /**
           * If true then {@link CIQ.ChartEngine#doCleanupGaps} is called so long as {@link CIQ.ChartEngine#cleanupGaps} is also set. This will ensure gaps will be filled in the master data from the last tick in the chart to the date of the trade. **Only applicable when using streamTrade()**.<BR> Reminder: `tick` does not fill any gaps as it is not a predictable interval.
           * @type boolean
           * @default
           * @alias streamParameters[`fillGaps`]
           * @memberof! CIQ.ChartEngine#
           * @since 2016-03-11
           * @deprecated See deprecation of {@link CIQ.ChartEngine#streamTrade}. Use {@link CIQ.ChartEngine#updateChartData} instead.
           */
          fillGaps: true,
        }
        /**
         * This is the callback function used to translate languages.
         * Should return a translated phrase given the English phrase. See separate translation file for list of phrases.
         *
         * Expected format :
         *
         * 		var translatedWord = fc(english);
         *
         * Defaults to {@link CIQ.I18N.translate}
         * @type {function}
         * @alias translationCallback
         * @memberof CIQ.ChartEngine.prototype
         */
        this.translationCallback = null
        this.locale = null // set by setLocale()
        /**
         * READ ONLY. Timezone of the masterData, set by {@link CIQ.ChartEngine#setTimeZone}.
         * @type {string}
         * @alias dataZone
         * @memberof CIQ.ChartEngine.prototype
         */
        this.dataZone = null
        /**
         * READ ONLY. Timezone to display on the chart, set by {@link CIQ.ChartEngine#setTimeZone}.
         * @type {string}
         * @alias displayZone
         * @memberof CIQ.ChartEngine.prototype
         */
        this.displayZone = null
        this.timeZoneOffset = 0 // use setTimeZone() to compute this value
        /**
         * This is the callback function used to react to {@link CIQ.ChartEngine#changeOccurred}.
         *
         * This function has been deprecated.
         * Please use {@link CIQ.ChartEngine#addEventListener} instead.
         *
         * Use this for storing chart configurations or drawings real time as users make changes.
         *
         * Expected format :
         *
         * 		fc(stxChart, eventType);
         *
         * Currently implemented values for  "eventType" are "layout" and "vector".
         *
         * You can create any additional event types and trigger them by calling 'CIQ.ChartEngine.changeOccurred(eventType)'
         *
         * **Note** only one changeCallback function can be registered per chart object. As such, you must program it to handle any and all possible events triggered by {@link CIQ.ChartEngine#changeOccurred}.
         * @type {function}
         * @alias changeCallback
         * @memberof CIQ.ChartEngine.prototype
         * @deprecated
         * @since 4.0.0 - Deprecated
         * @example
         * stxx.changeCallback=function(stxx, eventType){
         *		if(eventType=="layout") saveLayout();
         *		if(eventType=="vector") saveDrawing();
         * }
         */
        this.changeCallback = null
        this.masterData = null // Contains the historical quotes for the current chart
        /**
         * Register this function to transform the data set before a createDataSet() event; such as change in periodicity.
         * You can also explicitly call  <code>stxx.createDataSet(); stxx.draw();</code> to trigger this function.
         *
         * Expected Format :
         *
         * 		fc(stxChart, dataSet);
         *
         * @type {function}
         * @alias transformDataSetPre
         * @memberof CIQ.ChartEngine.prototype
         * @example
         * stxx.transformDataSetPre=function(stxx, dataSet){
         *		for(var i=0;i < dataSet.length;i++){
         *			// do something to the dataset here
         *		}
         * }
         */
        this.transformDataSetPre = null
        /**
         * Register this function to transform the data set after a createDataSet() event; such as change in periodicity.
         * You can also explicitly call  <code>stxx.createDataSet(); stxx.draw();</code> to trigger this function.
         *
         * Expected Format :
         *
         * 		fc(stxChart, dataSet, min low price in the dataset, max high price in the dataset);
         *
         * @type {function}
         * @alias transformDataSetPost
         * @memberof CIQ.ChartEngine.prototype
         * @example
         * stxx.transformDataSetPost=function(self, dataSet, min, max){
         *		for(var i=0;i < dataSet.length;i++){
         *			// do something to the dataset here
         *		}
         * }
         */
        this.transformDataSetPost = null
        /**
         * Register this function if you need [setMasterData()]{@link CIQ.ChartEngine#setMasterData} to transform each quote returned by your data feed into a properly formatted OHLC object before loading it into the chart.
         * {@link CIQ.ChartEngine#setMasterData} is called by {@link CIQ.ChartEngine#newChart}.
         *
         * This is a useful function if your data is not properly formated as required by the charting library.
         * Instead of having to iterate through your data to re-format it, and once again within setMasterData() to load it,
         * you can use the transform function to format it as it is being loaded, and thus preventing the dual looping.
         *
         * Expected Format :
         *
         * 		var formattedOHLCObject = fc(quote);
         *
         * @type {function}
         * @alias transformMasterDataQuote
         * @memberof CIQ.ChartEngine.prototype
         * @example
         * stxx.transformMasterDataQuote=function(quote){
         * 	var formattedOHLCObject = {
         * 		DT:new Date(quote.DT.valueOf()),
         * 		Open:parseFloat(quote.Open),
         * 		Close:parseFloat(quote.Close),
         * 		High:parseFloat(quote.High),
         * 		Low:parseFloat(quote.Low),
         * 		Volume:parseInt(quote.Volume,10)
         * 	};
         *
         * 	return formattedOHLCObject;
         * };
         */
        this.transformMasterDataQuote = null
        /**
         * This is the callback function used by {@link CIQ.ChartEngine#setPeriodicity} when no quotefeed has been attached to the chart.
         * Called if the masterData does not have the interval requested.
         *
         * Do not initialize if you are using a quotefeed ( {@link CIQ.QuoteFeed } )
         *
         * @type {function}
         * @alias dataCallback
         * @memberof CIQ.ChartEngine.prototype
         * @example
         * stxx.dataCallback=function(){
         *		// put code here to get the new data in the correct periodicity.
         *		// use layout.interval and layout.periodicity to determine what you need.
         *		// finally call stxx.newChart(symbol,data) to load the data and render the chart.
         * }
         */
        this.dataCallback = null
        /**
         * Set this to `true` if your server returns data in  week or monthly ticks, and doesn't require rolling computation from daily.
         *
         * If set to `false`:
         * - 'weekly' bars will be aligned to the first open market day of the week according to the active [market definitions]{@link CIQ.Market} (Weeks start Sunday).
         * - 'monthly' bar will be aligned to the first market day or the month according to the active [market definitions]{@link CIQ.Market}.
         *
         * @type boolean
         * @default
         * @alias dontRoll
         * @memberof CIQ.ChartEngine.prototype
         */
        this.dontRoll = false
        /**
         * Set to true to allow an equation to be entered into the symbol input.  For example, =2*IBM-GM
         * NOTE: the equation needs to be preceded by an equals sign (=) in order for it to be parsed as an equation.
         * See {@link CIQ.formatEquation} and {@link CIQ.computeEquationChart} for more details on allowed syntax.
         * @type boolean
         * @default
         * @alias allowEquations
         * @memberof CIQ.ChartEngine.prototype
         */
        this.allowEquations = true
        /**
         * Stores a list of active drawing object on the chart. Serialized renditions of drawings can be added using {@link CIQ.ChartEngine#createDrawing} and removed using {@link CIQ.ChartEngine#removeDrawing}
         * @type array
         * @default
         * @alias drawingObjects
         * @memberof CIQ.ChartEngine.prototype
         */
        this.drawingObjects = []
        this.undoStamps = []
        /**
         * If set, {@link CIQ.ChartEngine#doCleanupGaps} will be automatically called **when using a quoteFeed**
         * on intra-day or daily interval charts to create missing data points during market hours/days for stocks that may have missing bars.
         *
         * If you are pushing data into the chart, you can still manually clean up your data as outlined in the example section.
         *
         * <br>`carry` will cause the closing price to be carried forward, resulting in dashes on a candle/bar chart or continuous line on a line or mountain chart.
         * <br>`gap` will cause physical breaks to occur on the chart in the gapped position.
         *
         * **Note:** the clean up process leverages the current periodicity and the active market definition, if any.
         * So you must first set those to ensure proper clean up.
         * If no market definition is enabled, the clean up will assume gaps need to be added during the entire 24 hours period, every day.
         * See "{@link CIQ.Market}" for details on how to properly configure the library to your market hours requirements.
         * <br>No gaps will be cleaned for `tick` since by nature it is no a predictable interval.
         *
         * **Important information to prevent inaccurate 'gapping'**
         * The cleanup process leverages the current market iterator which traverses along the timeline on the exact minute/second/millisecond mark for intro-day data.
         * As such, you must ensure your time stamps match this requirement.
         * If your data does not comply, you must round your timestamps before sending the data into the chart.
         * <br>For example, if in minute periodicity, seconds and milliseconds should not be present or be set to zero.
         *
         * @type string
         * @default
         * @alias cleanupGaps
         * @memberof CIQ.ChartEngine.prototype
         * @example  <caption>Manually set and call the gaps cleaner function when pushing data into the chart</caption>
         * var stxx=new CIQ.ChartEngine({container:$$$(".chartContainer")});
         * stxx.setMarketFactory(CIQ.Market.Symbology.factory);
         * stxx.cleanupGaps='gap';
         * stxx.setPeriodicity({period:1, interval:5, timeUnit:"minute"});
         * var cleanedData= stxx.doCleanupGaps(missingPointsData);
         * stxx.newChart("SPY", cleanedData);
         *
         * @example  <caption>If using a quoteFeed, just set the parameter will automatically call {@link CIQ.ChartEngine#doCleanupGaps} </caption>
         * var stxx=new CIQ.ChartEngine({container:$$$(".chartContainer")});
         * stxx.attachQuoteFeed(yourFeed,{refreshInterval:1});
         * stxx.setMarketFactory(CIQ.Market.Symbology.factory);
         * stxx.cleanupGaps='carry';
         * stxx.setPeriodicity({period:1, interval:5, timeUnit:"minute"});
         * stxx.newChart("SPY");
         *
         * @since
         * <br>&bull; 15-07-01 gaps are automatically cleaned up unless this flag is set to false
         * <br>&bull; 2015-11-1, gaps are not automatically cleaned unless this flag is set to true
         * <br>&bull; m-2016-12-01.4 "carry" and "gap" values now supported. Setting to non-false will default to "carry" for backward compatibility with prior versions.
         */
        this.cleanupGaps = false
        /**
         * When set to true, the requested range will be visually preserved even if the data required to fill the left and/or right side of the x axis if not present.
         * This behavior is similar to setting `goIntoPast` and `goIntoFuture` when calling [setRange]{@link CIQ.ChartEngine#setRange}/[setSpan]{@link CIQ.ChartEngine#setSpan} explicitly, but will persist between symbol changes or when a layout is imported.
         * @type boolean
         * @default
         * @alias staticRange
         * @memberof CIQ.ChartEngine.prototype
         * @since 5.1.2
         */
        this.staticRange = false
        /**
         * Set a maximum size for the dataSet to prevent it from growing excessively large.
         * Older data will be sliced off of the end (historical) of the dataSet array as new bars arrive.
         * Set to 0 to let it grow forever.
         * @type number
         * @default
         * @alias maxDataSetSize
         * @memberof CIQ.ChartEngine.prototype
         */
        this.maxDataSetSize = 20000
        /**
         * Set a maximum size for masterData to prevent it from growing excessively large.
         * Older data will be sliced off of the end of masterData array as new bars arrive.
         * By default (set to 0) masterData is unlimited and will grow forever.
         * Note: when rolling up data due to periodicity, you should anticipate large enough masterData to accomodate the desired chart length.
         *
         * @type {number}
         * @default false
         * @alias maxMasterDataSize
         * @memberof CIQ.ChartEngine.prototype
         * @since 3.0.0
         */
        this.maxMasterDataSize = 0
        /**
         * Set to zero to avoid resize checking loop. See {@link CIQ.ChartEngine#setResizeTimer} for more details
         * @type number
         * @default
         * @alias resizeDetectMS
         * @memberof CIQ.ChartEngine.prototype
         */
        this.resizeDetectMS = 1000
        /**
         * Set to true to display the xAxis below all panels and extend the vertical grid lines accordingly.
         * By default, the x axis will be rendered right under the main panel and the grid lines will not extend to secondary (study) panels under it.
         * @type boolean
         * @default
         * @alias xAxisAsFooter
         * @memberof CIQ.ChartEngine.prototype
         * @since
         * <br>&bull; 05-2016-10
         * <br>&bull; 4.1.0 now defaults to true
         */
        this.xAxisAsFooter = true
        /**
         * Sets the x axis height in pixels.
         * @type boolean
         * @default
         * @alias xaxisHeight
         * @memberof CIQ.ChartEngine.prototype
         * @since 4.1.0 Now defaults to 30 px
         */
        this.xaxisHeight = 30
        /**
         * Set to true to display horizontal grid lines on studies.
         * This parameter is only used when a custom y axis is ** not** defined for the study.
         * @type boolean
         * @default
         * @alias displayGridLinesInStudies
         * @memberof 	CIQ.ChartEngine.prototype
         * @since 3.0.0
         */
        this.displayGridLinesInStudies = false
        /**
         * When true serialize methods may escape their values with encodeURIComponent.
         * @type boolean
         * @default
         * @alias escapeOnSerialize
         * @memberof CIQ.ChartEngine.prototype
         * @since 4.1.0
         */
        this.escapeOnSerialize = true
        /**
         * Holds {@link CIQ.ChartEngine.Chart} object
         * @type object
         * @default
         * @alias chart
         * @memberof 	CIQ.ChartEngine.prototype
         */
        this.chart = new CIQ.ChartEngine.Chart()
        this.chart.name = 'chart'
        this.chart.canvas = null // Contains the HTML5 canvas with the chart and drawings
        this.chart.tempCanvas = null // lays on top of the canvas and is used when creating drawings
        this.chart.container = config.container
        this.chart.market = new CIQ.Market() //create a default market, always open
        /**
         * Adjust to increase or decrease the default width of candles
         * @type boolean
         * @default
         * @alias candleWidthPercent
         * @memberof CIQ.ChartEngine.prototype
         */
        this.candleWidthPercent = 0.65
        /**
         * Color a colored bar or a volume bar based on difference between open and close, rather than difference between previous close and close.
         * @type boolean
         * @default
         * @alias colorByCandleDirection
         * @memberof CIQ.ChartEngine.prototype
         * @since 4.0.0
         */
        this.colorByCandleDirection = false
        /**
         * chart types which do not draw wicks on candles
         * @type object
         * @default
         * @alias noWicksOnCandles
         * @memberof CIQ.ChartEngine.prototype
         */
        this.noWicksOnCandles = { renko: true, linebreak: true }
        /**
         * chart types which require fetching as many bars as possible (since they aggregate data)
         * @type object
         * @default
         * @alias fetchMaximumBars
         * @memberof CIQ.ChartEngine.prototype
         */
        this.fetchMaximumBars = {
          rangebars: true,
          kagi: true,
          renko: true,
          linebreak: true,
          pandf: true,
        }
        /**
         * READ ONLY. Access the renderer controlling the main series.
         * @type CIQ.Renderer
         * @default
         * @alias mainSeriesRenderer
         * @memberof CIQ.ChartEngine
         */
        this.mainSeriesRenderer = null
        /**
         * Chart types which plot more than one data field (OHLC charts).
         * Putting a chart type here will disable the use of {@link CIQ.ChartEngine.Chart#defaultPlotField}.
         * @type object
         * @default
         * @alias highLowBars
         * @deprecated, access property in chart instead (stxx.chart.highLowBars)
         * @memberof CIQ.ChartEngine.prototype
         * @since 4.0.0
         */
        this.highLowBars = {
          bar: true,
          colored_bar: true,
          candle: true,
          hollow_candle: true,
          volume_candle: true,
          hlc: true,
          colored_hlc: true,
          hlc_box: true,
          hlc_shaded_box: true,
          wave: true,
          rangechannel: true,
          none: true,
        }
        /**
         * Chart types whose bars represent a stand-alone entity as opposed to a vertex in a line-type chart.
         * This is important when the engine tries to render the data points right off the chart; in a stand-alone bar,
         * the points right off the chart need not be considered.
         * @type object
         * @default
         * @alias standaloneBars
         * @deprecated, access property in chart instead (stxx.chart.standaloneBars)
         * @memberof CIQ.ChartEngine.prototype
         * @since 4.0.0
         */
        this.standaloneBars = {
          bar: true,
          colored_bar: true,
          candle: true,
          hollow_candle: true,
          volume_candle: true,
          hlc: true,
          colored_hlc: true,
          hlc_box: true,
          hlc_shaded_box: true,
          histogram: true,
          scatterplot: true,
        }
        /**
         * Chart types whose bars have width, as opposed to a line-type chart whose "bars" are just a point on the chart.
         * This is useful when the engine adjusts the chart for smooth scrolling and homing.
         * @type object
         * @default
         * @alias barsHaveWidth
         * @deprecated, access property in chart instead (stxx.chart.barsHaveWidth)
         * @memberof CIQ.ChartEngine.prototype
         * @since 4.0.0
         */
        this.barsHaveWidth = {
          bar: true,
          colored_bar: true,
          candle: true,
          hollow_candle: true,
          volume_candle: true,
          hlc: true,
          colored_hlc: true,
          hlc_box: true,
          hlc_shaded_box: true,
          histogram: true,
          scatterplot: true,
          wave: true,
        }
        /**
		     * Allow the candle width to be determined dynamically when using {@link CIQ.ChartEngine#setRange}.
		     * This will require a valid {@link CIQ.ChartEngine#dynamicRangePeriodicityMap}
		     * @type object
		     * @default
		     * @alias autoPickCandleWidth
		     * @memberof CIQ.ChartEngine.prototype
		     * @example
				autoPickCandleWidth:{
					turnOn: true,
					candleWidth: 5
				}
		     * @since m-2016-12-01
		     */
        this.autoPickCandleWidth = {
          /**
           * Turn to 'true' if you want the periodicity to be determined dynamically when using {@link CIQ.ChartEngine#setRange}.
           * This will require a valid {@link CIQ.ChartEngine#dynamicRangePeriodicityMap}
           * @type boolean
           * @default
           * @alias autoPickCandleWidth[`turnOn`]
           * @memberof! CIQ.ChartEngine#
           */
          turnOn: false,

          /**
           * Set if you want to set a specific candle width when using {@link CIQ.ChartEngine#setRange}.
           * This will require a valid {@link CIQ.ChartEngine#dynamicRangePeriodicityMap}.
           * Set to '0' if you want the candle width to be determined according to chart type
           * @type number
           * @default
           * @alias autoPickCandleWidth[`candleWidth`]
           * @memberof! CIQ.ChartEngine#
           */
          candleWidth: 5,
        }

        /**
		     * Map of default values to be used to statically set periodicity (candle width) upon range selection when using {@link CIQ.ChartEngine#setRange}
		     *
		     * **Default Value:**
		     * ```
				[
					{
						rangeInMS : CIQ.WEEK,	// Any range less than a week, load 5 minute bars
						periodicity : 1,
						interval : 5,
						timeUnit : 'minute'
					},
					{
						rangeInMS : CIQ.MONTH,	// Any range less than a month, load 30 minute bars
						periodicity : 1,
						interval : 30,
						timeUnit : 'minute'
					},
					{
						rangeInMS : CIQ.YEAR,	// Any range less than a year, load day bars
						periodicity : 1,
						interval : "day"
					},
					{
						rangeInMS : CIQ.DECADE,	// Any range less than 10 years, load weekly bars
						periodicity : 1,
						interval : "week"
					},
					{
						rangeInMS : CIQ.DECADE * 10,	// Any range less than a century, load monthly bars
						periodicity : 1,
						interval : "month"
					},
					{
						rangeInMS : Number.MAX_VALUE,	// Anything greater than a century, load yearly bars
						periodicity : 12,
						interval : "month"
					}
				]
		     * ```
		     * @type array
		     * @alias staticRangePeriodicityMap
		     * @memberof CIQ.ChartEngine.prototype
		     * @since m-2016-12-01
		     */
        this.staticRangePeriodicityMap = [
          {
            rangeInMS: CIQ.WEEK, // Any range less than a week, load 5 minute bars
            periodicity: 1,
            interval: 5,
            timeUnit: 'minute',
          },
          {
            rangeInMS: CIQ.MONTH, // Any range less than a month, load 30 minute bars
            periodicity: 1,
            interval: 30,
            timeUnit: 'minute',
          },
          {
            rangeInMS: CIQ.YEAR, // Any range less than a year, load day bars
            periodicity: 1,
            interval: 'day',
          },
          {
            rangeInMS: CIQ.DECADE, // Any range less than 10 years, load weekly bars
            periodicity: 1,
            interval: 'week',
          },
          {
            rangeInMS: CIQ.DECADE * 10, // Any range less than a century, load monthly bars
            periodicity: 1,
            interval: 'month',
          },
          {
            rangeInMS: Number.MAX_VALUE, // Anything greater than a century, load yearly bars
            periodicity: 12,
            interval: 'month',
          },
        ]

        /**
		     * Map of multiples to be used to dynamically determine periodicity (candle width) upon range selection when using {@link CIQ.ChartEngine#setRange}
		     * Used when {@link CIQ.ChartEngine#autoPickCandleWidth} is enabled
		     *
		     * **Default Value:**
		     * ```
				[
					{
						interval : 1,
						rangeInMS : CIQ.MINUTE
					},
					{
						interval : 5,
						rangeInMS : CIQ.MINUTE * 5
					},
					{
						interval : 30,
						rangeInMS : CIQ.MINUTE * 30
					},
					{
						interval : 60,
						rangeInMS : CIQ.MINUTE * 60
					},
					{
						interval : "day",
						rangeInMS : CIQ.DAY
					},
					{
						interval : "month",
						rangeInMS : CIQ.MONTH
					},
					{
						interval : "year",
						rangeInMS : CIQ.YEAR
					}
				]
		     * ```

		     * @type array
		     * @alias dynamicRangePeriodicityMap
		     * @memberof CIQ.ChartEngine.prototype
		     * @since 11-2016-29
		     */
        this.dynamicRangePeriodicityMap = [
          {
            interval: 1,
            timeUnit: 'minute',
            rangeInMS: CIQ.MINUTE,
          },
          {
            interval: 5,
            timeUnit: 'minute',
            rangeInMS: CIQ.MINUTE * 5,
          },
          {
            interval: 30,
            timeUnit: 'minute',
            rangeInMS: CIQ.MINUTE * 30,
          },
          {
            interval: 60,
            timeUnit: 'minute',
            rangeInMS: CIQ.MINUTE * 60,
          },
          {
            interval: 'day',
            rangeInMS: CIQ.DAY,
          },
          {
            interval: 'month',
            rangeInMS: CIQ.MONTH,
          },
          {
            interval: 'year',
            rangeInMS: CIQ.YEAR,
          },
        ]

        this.charts.chart = this.chart
        this.styles = {} // Contains CSS styles used internally to render canvas elements
        this.currentVectorParameters = CIQ.clone(
          CIQ.ChartEngine.currentVectorParameters
        ) // contains the current drawing parameters for this chart
        CIQ.extend(this, config)

        if (config.container) {
          this.registerHTMLElements()
          // Initialize the very basic dimensions of chart so that it is operational immediately
          this.chart.width =
            this.chart.container.clientWidth - this.chart.yAxis.width
          this.setCandleWidth(this.layout.candleWidth, this.chart)
          this.chart.canvasHeight = this.chart.container.clientHeight

          // This prevents mousewheel events from inadvertently triggering page scroll in Firefox and IE
          if (CIQ.useOldWheelLogic && !CIQ.FireFoxWheelWorkaround) {
            var wheelListener
            if (CIQ.isIE) {
              wheelListener = function(e) {
                if (CIQ.ChartEngine.insideChart) {
                  e.preventDefault()
                  // IE won't propagate the event so we need to manually figure out if we're inside the chart
                  for (
                    var i = 0;
                    i < CIQ.ChartEngine.registeredContainers.length;
                    i++
                  ) {
                    var stx = CIQ.ChartEngine.registeredContainers[i].stx
                    if (
                      CIQ.ChartEngine.crosshairX >= stx.left &&
                      CIQ.ChartEngine.crosshairX <= stx.right &&
                      CIQ.ChartEngine.crosshairY >= stx.top &&
                      CIQ.ChartEngine.crosshairY <= stx.bottom
                    ) {
                      stx.mouseWheel(e, 'onmousewheel')
                    }
                  }
                }
              }
            } else {
              wheelListener = function(e) {
                if (CIQ.ChartEngine.insideChart) e.preventDefault()
              }
            }
            this.addDomEventListener(document.body, 'wheel', wheelListener)
            CIQ.FireFoxWheelWorkaround = true
          }
        }
        this.construct()
      }

      /**
       * READ ONLY. Toggles to true when a drawing is initiated
       * @type boolean
       * @default
       * @alias drawingLine
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.drawingLine = false
      /**
       * READ ONLY. Toggles to true when a panel is being resized
       * @type boolean
       * @default
       * @alias resizingPanel
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.resizingPanel = null
      CIQ.ChartEngine.vectorType = '' // @deprecated The type of drawing currently enabled "segment", "line", "ray", etc. See sample.html menu
      /**
       * READ ONLY. Current X screen coordinate of the crosshair.
       * @type number
       * @default
       * @alias crosshairX
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.crosshairX = 0
      /**
       * READ ONLY. Current Y screen coordinate of the crosshair.
       * @type number
       * @default
       * @alias crosshairY
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.crosshairY = 0
      /**
       * READ ONLY. Toggles to true whenever the mouse cursor is within the chart (canvas)
       * @type boolean
       * @default
       * @alias insideChart
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.insideChart = false
      /**
       * READ ONLY. Toggles to true if the mouse cursor is over the X Axis.
       * @type boolean
       * @default
       * @alias overXAxis
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.overXAxis = false
      /**
       * READ ONLY. Toggles to true if the mouse cursor is over the Y Axis.
       * @type boolean
       * @default
       * @alias overYAxis
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.overYAxis = false
      CIQ.ChartEngine.currentColor = 'auto' // @deprecated Currently selected color for drawing tools. This may be changed by developing a menu with a color picker.
      CIQ.ChartEngine.drawingTools = {}
      /**
       * [Browser animation API](https://developer.mozilla.org/en-US/docs/Web/API/window/requestAnimationFrame) is on by default.
       * @type boolean
       * @default
       * @alias useAnimation
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.useAnimation = true
      /**
       * This setting limits the maximum number of bars to be drawn on an iOS device to help address performance limitations on that OS.
       * @type number
       * @default
       * @alias ipadMaxTicks
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.ipadMaxTicks = 1500
      CIQ.ChartEngine.enableCaching = false
      /**
       * Set to true to true to bypass all touch event handling.
       * @type number
       * @default
       * @alias ignoreTouch
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.ignoreTouch = false
      CIQ.ChartEngine.useOldAndroidClear = true // Turn this off to boost native android browser performance, but at risk of "double candle" display errors on some devices
      /**
       * Each CIQ.ChartEngine object will clone a copy of this object template and use it to store the settings for the active drawing tool.
       * The default settings can be changed by overriding these defaults on your own files.
       * See {@tutorial Custom Drawing Toolbar} for details on how to use this template to replace the standard drawing toolbar.
       * <br>This object can be extended to support additional drawing tools (for instance note the extensive customization capabilities for fibonacci)
       * @type {object}
       * @alias currentVectorParameters
       * @memberof! CIQ.ChartEngine#
       */
      CIQ.ChartEngine.currentVectorParameters = {
        /**
         *  Drawing to activate.
         * <br>See 'Classes' in {@link CIQ.Drawing} for available drawings.
         * Use {@link CIQ.ChartEngine#changeVectorType} to activate.
         * @type string
         * @alias currentVectorParameters[`vectorType`]
         * @memberof! CIQ.ChartEngine#
         */
        vectorType: null,
        /**
         *  Line pattern.
         * <br><B>Valid values for pattern: solid, dotted, dashed, none</B>
         * <br>Not all parameters/values are valid on all drawings. See the specific `recontruct` method for your desired drawing for more details(Example: {@link CIQ.Drawing.horizontal#reconstruct})
         * @type string
         * @default
         * @alias currentVectorParameters[`pattern`]
         * @memberof! CIQ.ChartEngine
         */
        pattern: 'solid',
        /**
         *  Line width
         * <br>Not all parameters/values are valid on all drawings. See the specific `recontruct` method for your desired drawing for more details(Example: {@link CIQ.Drawing.horizontal#reconstruct})
         * @type number
         * @default
         * @alias currentVectorParameters[`lineWidth`]
         * @memberof! CIQ.ChartEngine#
         */
        lineWidth: 1,
        /**
         *  Fill color.
         * <br>Not all parameters/values are valid on all drawings. See the specific `recontruct` method for your desired drawing for more details(Example: {@link CIQ.Drawing.horizontal#reconstruct})
         * @type string
         * @default
         * @alias currentVectorParameters[`fillColor`]
         * @memberof! CIQ.ChartEngine#
         */
        fillColor: '#7DA6F5',
        /**
         * Line color.
         * <br>Not all parameters/values are valid on all drawings. See the specific `recontruct` method for your desired drawing for more details(Example: {@link CIQ.Drawing.horizontal#reconstruct})
         * @type string
         * @default
         * @alias currentVectorParameters[`currentColor`]
         * @memberof! CIQ.ChartEngine#
         */
        currentColor: 'auto',
        /**
         * Axis Label.
         * Set to 'true' to display a label on the x axis.
         * <br>Not all parameters/values are valid on all drawings. See the specific `recontruct` method for your desired drawing for more details(Example: {@link CIQ.Drawing.horizontal#reconstruct})
         * @type string
         * @default
         * @alias currentVectorParameters[`axisLabel`]
         * @memberof! CIQ.ChartEngine#
         */
        axisLabel: true,
        /**
			 * Fibonacci settings.
			 * See {@link CIQ.Drawing.fibonacci#reconstruct} `parameters` object for valid options
		     * @type object
		     * @alias currentVectorParameters[`fibonacci`]
		     * @memberof! CIQ.ChartEngine#
		     * @example
				fibonacci:{
					trend:{color:"auto", parameters:{pattern:"solid", opacity:0.25, lineWidth:1}},
					fibs:[
						  {level:-0.786, color:"auto", parameters:{pattern:"solid", opacity:0.25, lineWidth:1}},
					      {level:-0.618, color:"auto", parameters:{pattern:"solid", opacity:0.25, lineWidth:1}, display: true},
					      {level:-0.382, color:"auto", parameters:{pattern:"solid", opacity:0.25, lineWidth:1}, display: true},
					      {level:0, color:"auto", parameters:{pattern:"solid", lineWidth:1}, display: true},
					      {level:0.382, color:"auto", parameters:{pattern:"solid", opacity:0.25, lineWidth:1}, display: true},
					      {level:0.618, color:"auto", parameters:{pattern:"solid", opacity:0.25, lineWidth:1}, display: true},
					      {level:0.786, color:"auto", parameters:{pattern:"solid", opacity:0.25, lineWidth:1}},
					      {level:0.5, color:"auto", parameters:{pattern:"solid", opacity:0.25, lineWidth:1}, display: true},
					      {level:1, color:"auto", parameters:{pattern:"solid", lineWidth:1}, display: true},
					      {level:1.382, color:"auto", parameters:{pattern:"solid", opacity:0.25, lineWidth:1}, display: true},
					      {level:1.618, color:"auto", parameters:{pattern:"solid", opacity:0.25, lineWidth:1}, display: true}
					      ],
					extendLeft: false,
					printLevels: true,
					printValues: false,
					timezone:{color:"auto", parameters:{pattern:"solid", opacity:0.25, lineWidth:1}}
				}
			 * @since 3.0.9 '0.786' and '-0.786' levels added
		     */
        fibonacci: {
          trend: {
            color: 'auto',
            parameters: { pattern: 'solid', opacity: 0.25, lineWidth: 1 },
          },
          fibs: [
            {
              level: -0.786,
              color: 'auto',
              parameters: { pattern: 'solid', opacity: 0.25, lineWidth: 1 },
            },
            {
              level: -0.618,
              color: 'auto',
              parameters: { pattern: 'solid', opacity: 0.25, lineWidth: 1 },
              display: true,
            },
            {
              level: -0.5,
              color: 'auto',
              parameters: { pattern: 'solid', opacity: 0.25, lineWidth: 1 },
            },
            {
              level: -0.382,
              color: 'auto',
              parameters: { pattern: 'solid', opacity: 0.25, lineWidth: 1 },
              display: true,
            },
            {
              level: -0.236,
              color: 'auto',
              parameters: { pattern: 'solid', opacity: 0.25, lineWidth: 1 },
            },
            {
              level: 0,
              color: 'auto',
              parameters: { pattern: 'solid', lineWidth: 1 },
              display: true,
            },
            {
              level: 0.236,
              color: 'auto',
              parameters: { pattern: 'solid', opacity: 0.25, lineWidth: 1 },
            },
            {
              level: 0.382,
              color: 'auto',
              parameters: { pattern: 'solid', opacity: 0.25, lineWidth: 1 },
              display: true,
            },
            {
              level: 0.5,
              color: 'auto',
              parameters: { pattern: 'solid', opacity: 0.25, lineWidth: 1 },
              display: true,
            },
            {
              level: 0.618,
              color: 'auto',
              parameters: { pattern: 'solid', opacity: 0.25, lineWidth: 1 },
              display: true,
            },
            {
              level: 0.786,
              color: 'auto',
              parameters: { pattern: 'solid', opacity: 0.25, lineWidth: 1 },
            },
            {
              level: 1,
              color: 'auto',
              parameters: { pattern: 'solid', lineWidth: 1 },
              display: true,
            },
            {
              level: 1.382,
              color: 'auto',
              parameters: { pattern: 'solid', opacity: 0.25, lineWidth: 1 },
              display: true,
            },
            {
              level: 1.618,
              color: 'auto',
              parameters: { pattern: 'solid', opacity: 0.25, lineWidth: 1 },
              display: true,
            },
            {
              level: 2.618,
              color: 'auto',
              parameters: { pattern: 'solid', opacity: 0.25, lineWidth: 1 },
            },
            {
              level: 4.236,
              color: 'auto',
              parameters: { pattern: 'solid', opacity: 0.25, lineWidth: 1 },
            },
          ],
          extendLeft: false,
          printLevels: true,
          printValues: false,
          timezone: {
            color: 'auto',
            parameters: { pattern: 'solid', opacity: 0.25, lineWidth: 1 },
          },
        },
        /**
			 * Annotation settings.
		     * @type object
		     * @alias currentVectorParameters[`annotation`]
		     * @memberof! CIQ.ChartEngine#
		     * @example
				annotation:{
					font:{
						style:null,
						size:null,	// override .stx_annotation default
						weight:null, // override .stx_annotation default
						family:null // override .stx_annotation default
					}
				}
		     */
        annotation: {
          font: {
            style: null,
            size: null, // override .stx_annotation default
            weight: null, // override .stx_annotation default
            family: null, // override .stx_annotation default
          },
        },
      }

      CIQ.ChartEngine.defaultDisplayTimeZone = null // If set, then new CIQ.ChartEngine objects will pull their display timezone from this

      /**
       * Defines an object used for rendering a chart and is automatically created by the {@link CIQ.ChartEngine}.
       * Chart objects contain the data and config for each chart but they don't actually exist on the screen until a panel is attached.
       * A chart object is attached to both the main chart panel and any related study panels so they can share the same chart data.
       *
       * Example: stxx.panels['chart'].chart
       *
       * Example: stxx.chart (convenience shortcut for accessing the main chart object - same as above)
       *
       * Example stxx.panels['Aroon (14)'].chart
       *
       * @constructor
       * @name  CIQ.ChartEngine.Chart
       */
      CIQ.ChartEngine.Chart = function() {
        this.xAxis = new CIQ.ChartEngine.XAxis()
        this.yAxis = new CIQ.ChartEngine.YAxis()
        this.symbolObject = { symbol: null }
        this.series = {}
        this.seriesRenderers = {}
        this.xaxis = []
        this.state = {}
        this.defaultChartStyleConfig = {}
        this.baseline = CIQ.clone(this.baseline) // copy from prototype
      }

      /**
       * Defines an object used for rendering the Y-axis on a panel.
       * Each panel object will automatically include a YAxis object, which can be adjusted immediately after declaring your `new CIQ.ChartEngine();`
       * Any adjustments to the Y-axis members after it has been rendered and will require a draw() call to apply the changes ( initializeChart() may be required as well depending on the setting being changed).
       *
       * See {@tutorial Gridlines and axis labels}, {@link CIQ.ChartEngine.AdvancedInjectable#createYAxis} and {@link CIQ.ChartEngine.AdvancedInjectable#drawYAxis} for additional customization instructions.
       *
       * Example: stxx.panels['chart'].yAxis
       *
       * Example: stxx.chart.yAxis (convenience shortcut for accessing the main panel object - same as above)
       *
       * Example: stxx.panels['Aroon (14)'].yAxis
       *
       * @constructor
       * @name  CIQ.ChartEngine.YAxis
       * @param {object} init Object containing custom values for Y-axis members
       * @example
       * // here is an example on how to override the default top and bottom margins after the initial axis has already been rendered
       * stxx.newChart(symbol, yourData, null, function () {    // call new chart to render your data
       *    	// callback - your code to be executed after the chart is loaded
       * 		stxx.chart.yAxis.initialMarginTop=50;
       * 		stxx.chart.yAxis.initialMarginBottom=50;
       * 		stxx.calculateYAxisMargins(stxx.chart.panel.yAxis); // must recalculate the margins after they are changed.
       * 		stxx.draw();
       * });
       * @example
       * // here is an example on how to override the default top and bottom margins before the initial axis has been rendered
       * var stxx=new CIQ.ChartEngine({container:$$$(".chartContainer"), layout:{"candleWidth": 16, "crosshair":true}});
       * stxx.setPeriodicity({period:1, interval:1, timeUnit:"minute"}); 			// set your default periodicity to match your data. In this case one minute.
       * stx.chart.yAxis.initialMarginTop=50;		// set default margins so they do not bump on to the legend
       * stx.chart.yAxis.initialMarginBottom=50;
       * stx.newChart("SPY", yourData);
       * @example
       * // here is an example on how to turn off the last price label (main chart panel) before the initial axis has already been rendered
       * var stxx=new CIQ.ChartEngine({container:$$$(".chartContainer"), layout:{"candleWidth": 16, "crosshair":true}});
       * stxx.chart.panel.yAxis.drawCurrentPriceLabel=false;
       *
       * @since 5.1.0 created a name member which is used to determine if the yAxis is the same as another.
       */
      CIQ.ChartEngine.YAxis = function(init) {
        this.name = CIQ.uniqueID()
        for (var field in init) this[field] = init[field]
      }

      /**
       * Defines an object used for rendering the X-axis on the chart, which can be adjusted immediately after declaring your `new CIQ.ChartEngine();`
       * The CIQ.ChartEngine.XAxis object is created by and part of the {@link CIQ.ChartEngine.Chart} object and is used on the main chart pannel only.
       * There is only one x axis per chart container.
       *
       * Colors and fonts for the x axis can be controlled by manipulating the CSS.
       * You can override the `stx_xaxis` class to change the font or colors.
       *
       * For full customization instructions see:
       * - {@tutorial Custom X-axis}
       * - {@link CIQ.ChartEngine.AdvancedInjectable#createXAxis}
       * - {@link CIQ.ChartEngine#createTickXAxisWithDates}
       *
       * Example: stxx.chart.xAxis
       *
       * @constructor
       * @name  CIQ.ChartEngine.XAxis
       * @param {object} init Object containing custom values for X-axis members
       * @example
       * var stxx=new CIQ.ChartEngine({container:$$$(".chartContainer"), layout:{"candleWidth": 16, "crosshair":true}});
       * stxx.chart.xAxis.formatter=formatFunction;
       */
      CIQ.ChartEngine.XAxis = function(init) {
        for (var field in init) this[field] = init[field]
      }

      /**
		 * Defines a Panel object.
		 * Every chart or study is rendered in a panel.
		 *
		 * Example: stxx.panels['chart']
		 *
		 * Example: stxx.panels['Aroon (14)']

		 * @param {string} name The name of the panel.
		 * @param {CIQ.ChartEngine.YAxis} [yAxis] Pass an optional {@link CIQ.ChartEngine.YAxis} object
		 * @constructor
		 * @name  CIQ.ChartEngine.Panel
		 */
      CIQ.ChartEngine.Panel = function(name, yAxis) {
        if (yAxis) this.yAxis = yAxis
        else this.yAxis = new CIQ.ChartEngine.YAxis()
        this.name = name
        this.state = {} // drawing state of the panel, can be studies, drawings, or any panel-scoped object
      }

      CIQ.ChartEngine.YAxis.prototype = {
        high: null, // High value on y axis (read only)
        low: null, // Low value on y axis (read only)
        shadow: null, // high - low (read only)
        logHigh: null, // High log value on y axis (read only)
        logLow: null, // Low log value on y axis (read only)
        logShadow: null, // logHigh - logLow (read only)
        multiplier: null, // Computed automatically. Divide pixel by this to get the price (then add to low). Or multiply price by this to get the pixel (then add to top)
        bottom: null, // calculated automatically (panel.bottom-yAxis.bottomOffset)
        top: null, // calculated automatically (panel.top+yAxis.topOffset;)
        height: null, // bottom - top
        left: null, // calculated left position on canvas to begin drawing.
        width: null, // calculated width of y axis
      }

      /**
       * Controls maximum decimal places to ever display on a floating price label.
       * Leave null and the chart will compute based on the number of decimal places in the actual data.
       * See {@link CIQ.ChartEngine.YAxis#decimalPlaces} for controlling decimal places on the axis itself.
       * Also see See {@link CIQ.ChartEngine.YAxis#width} as you may also need to increase the width of the y axis to fit the additional decimals.
       * @type number
       * @default
       * @memberof CIQ.ChartEngine.YAxis
       */
      CIQ.ChartEngine.YAxis.prototype.maxDecimalPlaces = 5

      /**
       * Optionally hard set the high (top value) of the yAxis (for instance when plotting 0 - 100% charts)
       * @type number
       * @default
       * @memberof CIQ.ChartEngine.YAxis
       */
      CIQ.ChartEngine.YAxis.prototype.max = null

      /**
       * Optionally hard set the low (bottom value) of the yAxis (for instance when plotting 0 - 100% charts)
       * @type number
       * @default
       * @memberof CIQ.ChartEngine.YAxis
       */
      CIQ.ChartEngine.YAxis.prototype.min = null

      /**
       * Set to the required  decimal places from 0 to 10, or leave null and the chart will choose automatically.
       * - **Note 1:**  this only affects the number of decimal places for the prices on the axis itself and not on the price on the floating label.
       * - **Note 2:**  study panel axis will be condenses if over 999 by the use of {@link condenseInt}.
       *
       * See {@link CIQ.ChartEngine.YAxis#maxDecimalPlaces} for controlling decimal places on floating labels.<br>
       * See {@link CIQ.ChartEngine.YAxis#width} as you may also need to increase the width of the y axis to fit the additional decimals.
       *
       * @type number
       * @default
       * @memberof CIQ.ChartEngine.YAxis
       */
      CIQ.ChartEngine.YAxis.prototype.decimalPlaces = null

      /**
       * ideal size between y-axis values in pixels. Leave null to automatically calculate.
       * See {@tutorial Gridlines and  axis labels} for additional details.
       * @type number
       * @default
       * @memberof CIQ.ChartEngine.YAxis
       */
      CIQ.ChartEngine.YAxis.prototype.idealTickSizePixels = null

      /**
       * Set to specify that the y-axis vertical grid be drawn with specific intervals between ticks.
       * This amount will be overridden if it will result  in y axis crowding.
       * In which chase, multiples of the original interval will be used.
       * For example, if `.25` is selected, and that will cause labels to be on top of or too close to each other, `.50` may be used.
       * Crowding is prevented by allowing for a minimum of space equating the y-axis font height between labels.
       *
       * **This parameter is also used in the 'Trade From Chart' (TFC) module**. If set, it will force the widget to skip certain price values and instead 'snap' to your desired intervals. This will guarantee that an order is only placed at the allowed price intervals for the security in question.
       *
       * **Note that this parameter will be ignored if {@link CIQ.ChartEngine.YAxis#pretty} is set to `true`. If you require specific price intervals, please set {@link CIQ.ChartEngine.YAxis#pretty} to 'false' before setting `minimumPriceTick` **
       *
       * Visual Reference:<br>
       * ![yAxis.minimumPriceTick](yAxis.minimumPriceTick.png "yAxis.minimumPriceTick")
       *
       * @type number
       * @default
       * @memberof CIQ.ChartEngine.YAxis
       * @example
       * // Declare a CIQ.ChartEngine object. This is the main object for drawing charts
       * var stxx=new CIQ.ChartEngine({container:$$$(".chartContainer"), layout:{"candleWidth": 16, "crosshair":true}});
       * // set interval between ticks
       * stxx.chart.yAxis.minimumPriceTick=.50;
       */
      CIQ.ChartEngine.YAxis.prototype.minimumPriceTick = null

      /**
		 * Set to specify that the y-axis vertical grid be drawn with fractional intervals.
		 * This is checked in {@link CIQ.ChartEngine.AdvancedInjectable#drawYAxis} and if it is not null,
		 * and there is no existing yAxis.priceFormatter, one is created to specially format the y-axis ticks.
		 *
		 * To disable the formatting you must reset both the yAxis.priceFormatter and this fractional object to 'null'.
		 * <br>Example:
		 * ```
		 * stxx.chart.yAxis.priceFormatter=stxx.chart.yAxis.fractional=null;
     	 * ```
		 *
		 * @type object
		 * @default
		 * @memberof CIQ.ChartEngine.YAxis
		 * @example
		 * // Declare a CIQ.ChartEngine object. This is the main object for drawing charts
		 * var stxx=new CIQ.ChartEngine({container:$$$(".chartContainer"), layout:{"candleWidth": 16, "crosshair":true}});
		 * // set axis to display in 1/32nds; for example, 100 5/32 will display as 100'05.  If there is a price midway between
		 * // two ticks (for example, 11/64), a plus (+) will follow the price; for example 100 11/64 will display as 100'11+.
		 * stxx.chart.yAxis.fractional={
				formatter: "'",				// This is the character used to separate he whole number portion from the numerator (' default)
				resolution: 1/32			// Set to smallest increment for the quoted amounts
			}
		 */
      CIQ.ChartEngine.YAxis.prototype.fractional = null

      /**
       * set to true to draw a line left of the y-axis and tick marks
       * @type boolean
       * @default
       * @memberof CIQ.ChartEngine.YAxis
       */
      CIQ.ChartEngine.YAxis.prototype.displayBorder = true

      /**
       * set to false to hide grid lines. See {@tutorial Gridlines and  axis labels} for additional details.
       * @type boolean
       * @default
       * @memberof CIQ.ChartEngine.YAxis
       */
      CIQ.ChartEngine.YAxis.prototype.displayGridLines = true

      /**
       * set to true to hide the yaxis
       * @type boolean
       * @default
       * @memberof CIQ.ChartEngine.YAxis
       */
      CIQ.ChartEngine.YAxis.prototype.noDraw = null

      /**
       * set to false to hide the current price label <b>in the main panel's y-axis</b>.
       *
       * See {@link CIQ.ChartEngine.AdvancedInjectable#drawCurrentHR}
       *
       * Visual Reference:<br>
       * ![yAxis.drawCurrentPriceLabel](drawCurrentPriceLabel.png "yAxis.drawCurrentPriceLabel")
       * @type boolean
       * @default
       * @memberof CIQ.ChartEngine.YAxis
       * @since  04-2015
       */
      CIQ.ChartEngine.YAxis.prototype.drawCurrentPriceLabel = true

      /**
       * set to false to hide the series price labels <b>in the main panel's y-axis</b>.
       *
       * @type boolean
       * @default
       * @memberof CIQ.ChartEngine.YAxis
       * @since  3.0.0
       */
      CIQ.ChartEngine.YAxis.prototype.drawSeriesPriceLabels = true

      /**
       * Set to false to hide **all** price labels on the particular y axis.
       * <br>See {@link CIQ.ChartEngine.YAxis#drawCurrentPriceLabel} to disable just the current price label on the main chart panel.
       * <br>See [CIQ.ChartEngine.preferences.labels]{@link CIQ.ChartEngine#preferences}  to disable just the last value label on studies.
       * @type boolean
       * @default
       * @memberof CIQ.ChartEngine.YAxis
       * @since  04-2015
       */
      CIQ.ChartEngine.YAxis.prototype.drawPriceLabels = true

      /**
       * When `true`, will attempt to create grid lines that approximate a `golden ratio` between x and y axis by basing grid on {@link CIQ.ChartEngine.YAxis#idealTickSizePixels}.
       * This creates an "airy" modern looking chart.
       * If set to false, each axis will be adjusted separately and may create long and narrow rectangular greeds depending on date or price range.
       * @type boolean
       * @default
       * @memberof CIQ.ChartEngine.YAxis
       * @since
       * <br>&bull; 04-2015
       * <br>&bull; 4.0.0 Now defaults to true.
       */
      CIQ.ChartEngine.YAxis.prototype.goldenRatioYAxis = true

      /**
       * Set to either "roundRectArrow", "semiRoundRect", "roundRect","tickedRect","rect","noop".
       * It will default to {@link CIQ.ChartEngine.yaxisLabelStyle}
       * This could be set independently on each panel if desired.
       * @type string
       * @default
       * @memberof CIQ.ChartEngine.YAxis
       * @since  04-2015
       * @example
       * var stxx=new CIQ.ChartEngine({container:$$$(".chartContainer"), layout:{"candleWidth": 16, "crosshair":true}});
       * stxx.chart.yAxis.yaxisLabelStyle="rect"
       */
      CIQ.ChartEngine.YAxis.prototype.yaxisLabelStyle = null

      /**
       * Set to true to right justify the yaxis (use with CIQ.ChartEngine.yaxisPaddingRight)
       * @type boolean
       * @default
       * @memberof CIQ.ChartEngine.YAxis
       * @since  15-07-01
       */
      CIQ.ChartEngine.YAxis.prototype.justifyRight = null

      /**
       * Set to true to put a rectangle behind the yaxis text (use with CIQ.ChartEngine.yaxisPaddingRight)
       * @type boolean
       * @default
       * @memberof CIQ.ChartEngine.YAxis
       * @since  15-07-01
       */
      CIQ.ChartEngine.YAxis.prototype.textBackground = false

      /**
       * Optional function used to override default formatting of Y-axis values, including the floating HUD value of the crosshair.
       *
       * Expected format :
       *
       * 		function(stx, panel, price, decimalPlaces)
       *
       * Parameters:
       *
       * 		stx           - {@link CIQ.ChartEngine}       - The chart object
       *		panel         - {@link CIQ.ChartEngine.Panel} - The panel
       *		price         - number                - The price to format
       *		decimalPlaces - number                - Optional - Number of decimal places to use
       *													(may not always be present)
       *
       * Returns:
       *
       *		text - Formated text label for the price
       *
       * @type function
       * @example
       * stxx.chart.panel.yAxis.priceFormatter=function(stx, panel, price, decimalPlaces){
       * 	var convertedPrice;
       * 	  // add our logic here to convert 'price' to 'convertedPrice'
       *    return convertedPrice; // string
       * }
       * @default
       * @memberof CIQ.ChartEngine.YAxis
       */
      CIQ.ChartEngine.YAxis.prototype.priceFormatter = null

      /**
       * Sets the y-axis bottom on any panel.
       * Rendering will start this number of pixels above the panel's bottom.
       * Note that {@link CIQ.ChartEngine#adjustPanelPositions} and {@link CIQ.ChartEngine#draw} will need to be called to immediately activate this setting after the axis has already been drawn.
       *
       * Visual Reference:<br>
       * ![yAxis.width](yAxis.bottomOffset.png "yAxis.bottomOffset")
       * ![yAxis.width](yAxis.bottomTopOffset.png "yAxis.bottomTopOffset")
       * @type number
       * @default
       * @memberof CIQ.ChartEngine.YAxis
       * @example
       * // The list of current panels can be found in "stxx.panels".
       * stxx.panels[panelName].yAxis.bottomOffset=20;
       * stxx.panels[panelName].yAxis.topOffset=60;
       * stxx.adjustPanelPositions();	// !!!! must recalculate the margins after they are changed. !!!!
       * stxx.draw();
       */
      CIQ.ChartEngine.YAxis.prototype.bottomOffset = 0

      /**
       * Sets y-axis top on Study panels.
       * Rendering will start this number of pixels below the panel's top.
       * Note that {@link CIQ.ChartEngine#adjustPanelPositions} and {@link CIQ.ChartEngine#draw} will need to be called to immediately activate this setting after the axis has already been drawn.
       *
       * Visual Reference:<br>
       * ![yAxis.width](yAxis.bottomTopOffset.png "yAxis.bottomTopOffset")
       * @type number
       * @default
       * @memberof CIQ.ChartEngine.YAxis
       * @example
       * // The list of current panels can be found in "stxx.panels".
       * stxx.panels[panelName].yAxis.bottomOffset=20;
       * stxx.panels[panelName].yAxis.topOffset=60;
       * stxx.adjustPanelPositions();	// !!!! must recalculate the margins after they are changed. !!!!
       * stxx.draw();
       */
      CIQ.ChartEngine.YAxis.prototype.topOffset = 0

      /**
       * Set this to automatically compress and offset the y-axis so that this many pixels of white space is above the display.
       * Note that {@link CIQ.ChartEngine#calculateYAxisMargins} and {@link CIQ.ChartEngine#draw} will need to be called to immediately activate this setting after the axis has already been drawn.
       *
       * Visual Reference:<br>
       * ![yAxis.width](yAxis.initialMarginTop.png "yAxis.initialMarginTop")
       * @type number
       * @default
       * @memberof CIQ.ChartEngine.YAxis
       * @example
       * // Here is an example on how to override the default top and bottom margins **before** the initial axis has been rendered
       * var stxx=new CIQ.ChartEngine({container:$$$(".chartContainer"), layout:{"candleWidth": 16, "crosshair":true}});
       * stxx.setPeriodicity({period:1, interval:1, timeUnit:"minute"});				// set your default periodicity to match your data. In this case one minute.
       * stxx.chart.yAxis.initialMarginTop=50;		// set default margins so they do not bump on to the legend
       * stxx.chart.yAxis.initialMarginBottom=50;
       * stxx.newChart("SPY", yourData);
       * @example
       * // Here is an example on how to override the default top and bottom margins **after** the initial axis has already been rendered
       * stxx.newChart(symbol, yourData, null, function () {    // call new chart to render your data
       *    	// callback - your code to be executed after the chart is loaded
       * 		stxx.chart.yAxis.initialMarginTop=50;
       * 		stxx.chart.yAxis.initialMarginBottom=50;
       * 		stxx.calculateYAxisMargins(stxx.chart.panel.yAxis); // !!!! must recalculate the margins after they are changed. !!!!
       * 		stxx.draw();
       * });
       * @example
       * // Here is an example on how to override the default top and bottom margins for a specifc panel**after** the initial axis has already been rendered
       * // The list of current panels can be found in "stxx.panels".
       * stxx.panels[panelName].yAxis.initialMarginTop=100;
       * stxx.panels[panelName].yAxis.initialMarginBottom=100;
       * stxx.calculateYAxisMargins(stxx.panels[panelName].panel.yAxis); // !!!! must recalculate the margins after they are changed. !!!!
       * stxx.draw();
       */
      CIQ.ChartEngine.YAxis.prototype.initialMarginTop = 10

      /**
       * set this to automatically compress and offset the y-axis to that this many pixels of white space is below the display
       * Note that {@link CIQ.ChartEngine#calculateYAxisMargins} and {@link CIQ.ChartEngine#draw} will need to be called to immediately activate this setting after the axis has already been drawn.
       *
       * Visual Reference:<br>
       * ![yAxis.width](yAxis.initialMarginTop.png "yAxis.initialMarginTop")
       * @type number
       * @default
       * @memberof CIQ.ChartEngine.YAxis
       * @example
       * // here is an example on how to override the default top and bottom margins **before** the initial axis has been rendered
       * var stxx=new CIQ.ChartEngine({container:$$$(".chartContainer"), layout:{"candleWidth": 16, "crosshair":true}});
       * stxx.setPeriodicity({period:1, interval:1, timeUnit:"minute"});				// set your default periodicity to match your data. In this case one minute.
       * stxx.chart.yAxis.initialMarginTop=50;		// set default margins so they do not bump on to the legend
       * stxx.chart.yAxis.initialMarginBottom=50;
       * stxx.newChart("SPY", yourData);
       * @example
       * // here is an example on how to override the default top and bottom margins **after** the initial axis has already been rendered
       * stxx.newChart(symbol, yourData, null, function () {    // call new chart to render your data
       *    	// callback - your code to be executed after the chart is loaded
       * 		stxx.chart.yAxis.initialMarginTop=50;
       * 		stxx.chart.yAxis.initialMarginBottom=50;
       * 		stxx.calculateYAxisMargins(stxx.chart.panel.yAxis); // !!!! must recalculate the margins after they are changed. !!!!
       * 		stxx.draw();
       * });
       *
       *
       */
      CIQ.ChartEngine.YAxis.prototype.initialMarginBottom = 10

      /**
       * Set this to the number of pixels to zoomed in or out, positive or negative.
       * This is defined as the number of pixels to add or subtract from both top and bottom of panel for calculations.
       *
       * Please note that the zoom level will be reset as determined by {@link CIQ.ChartEngine.YAxis#initialMarginTop} and
       * {@link CIQ.ChartEngine.YAxis#initialMarginBottom} when a {@link CIQ.ChartEngine#newChart} is rendered, the {@link CIQ.ChartEngine#home} button is pressed, or when {@link CIQ.ChartEngine.AdvancedInjectable#touchDoubleClick} is activated on a touch device.
       *
       * @type number
       * @default
       * @memberof CIQ.ChartEngine.YAxis
       */
      CIQ.ChartEngine.YAxis.prototype.zoom = 0

      /**
       * set this to the number of pixels to offset the y-axis, positive or negative.
       * @type number
       * @default
       * @memberof CIQ.ChartEngine.YAxis
       */
      CIQ.ChartEngine.YAxis.prototype.scroll = 0

      /**
       * The width in pixels.
       *
       * Visual Reference:<br>
       * ![yAxis.width](yAxis.width.png "yAxis.width")
       * @type number
       * @default
       * @memberof CIQ.ChartEngine.YAxis
       */
      CIQ.ChartEngine.YAxis.prototype.width = 50

      /**
       * Override the default stx_yaxis style for text by setting this to the desired CSS style. This would typically be used to set a secondary axis to a particular color.
       * @type string
       * @default
       * @memberof CIQ.ChartEngine.YAxis
       * @since  15-07-01
       */
      CIQ.ChartEngine.YAxis.prototype.textStyle = null

      /**
       * Set to "left" for the yaxis to draw on the left side of the screen. The main chart axis will default to "right". The main
       * access for any study panel will follow the main chart axis as long as this is set to null. Note that this only applies to chart panels.
       * @type string
       * @default
       * @memberof CIQ.ChartEngine.YAxis
       * @example
       * // set the main y axis for the chart on the left.
       * stxx.chart.yAxis.position = 'left';
       * @since  15-07-01
       */
      CIQ.ChartEngine.YAxis.prototype.position = null

      /**
       * Default setting for the array that determines how many decimal places to print based on the size of the shadow (the difference between chart high and chart low).
       * The array consists of tuples in descending order. If the shadow is less than n1 then n2 decimal places will be printed.
       * See {@link CIQ.ChartEngine.YAxis#shadowBreaks}
       * @type array
       * @memberof CIQ.ChartEngine.YAxis
       * @since  2015-11-1
       * @default
       */
      CIQ.ChartEngine.YAxis.defaultShadowBreaks = [[1000, 2], [1, 4]]

      /**
       * Alternative setting (for small charts)  array that determines how many decimal places to print based on the size of the shadow (the difference between chart high and chart low).
       * The array consists of tuples in descending order. If the shadow is less than n1 then n2 decimal places will be printed.
       * See {@link CIQ.ChartEngine.YAxis#shadowBreaks}
       * @type array
       * @memberof CIQ.ChartEngine.YAxis
       * @since  2015-11-1
       * @default
       */
      CIQ.ChartEngine.YAxis.smallChartShadowBreaks = [[10, 2], [1, 4]]

      /**
       * If true then uses the "pretty" algorithm instead of the "best fit" algorithm. The pretty algorithm
       * uses the values specified in {@link CIQ.ChartEngine.YAxis#increments} to set axis label locations.
       *
       * **Note that this algorithm will override the {@link CIQ.ChartEngine.YAxis#minimumPriceTick}. If you require specific price intervals, please set this parameter to 'false' before setting `minimumPriceTick` **
       *
       * @memberof CIQ.ChartEngine.YAxis
       * @since 2015-11-1
       * @type boolean
       * @default
       */
      CIQ.ChartEngine.YAxis.prototype.pretty = true

      /**
       * Values used by the {@link CIQ.ChartEngine.YAxis#pretty} algorithm to set axis label locations.
       * @memberof CIQ.ChartEngine.YAxis
       * @since 2015-11-1
       * @type array
       * @default
       */
      CIQ.ChartEngine.YAxis.prototype.increments = [1, 2.5, 5]

      /**
       * If true then uses an additional step in the "pretty" algorithm for the log
       * scale. This allows the algorithm to lower the grid to fill large visual gaps.
       * The "increments" are not fully respected by this approach.
       *
       * Only applicable when using *both* pretty mode and semiLog.
       * @memberof CIQ.ChartEngine.YAxis
       * @since 2016-03-11
       * @type boolean
       * @default
       */
      CIQ.ChartEngine.YAxis.prototype.prettySemiLog = true

      /**
       * An array that determines how many decimal places to print based on the size of the shadow (the difference between chart high and chart low).
       * The array consists of tuples in descending order. If the shadow is less than n1 then n2 decimal places will be printed.
       * See {@link CIQ.ChartEngine.YAxis.defaultShadowBreaks} and {@link CIQ.ChartEngine.YAxis.smallChartShadowBreaks} for default settings.
       * @type array
       * @memberof CIQ.ChartEngine.YAxis
       * @since  2015-11-1
       */
      CIQ.ChartEngine.YAxis.prototype.shadowBreaks =
        CIQ.ChartEngine.YAxis.defaultShadowBreaks

      CIQ.ChartEngine.Panel.prototype = {
        name: null, // Name of panel
        display: null, // Display text of panel
        chart: null, // The chart from which this panel derives its data
        yAxis: null, // Y axis object for this panel, this is the same object as chart.yAxis on chart panels
        shareChartXAxis: null, // Set to false to indicate panel does not share x axis with its chart
        top: null, // Y location of top of chart
        bottom: null, // Y location of bottom of chart
        height: null, // height of chart in pixels
        percent: null, // percent of overall window this panel takes up
      }

      CIQ.ChartEngine.XAxis.prototype = {
        /**
         * Optional function to format dates on x-axis.
         * If defined, will be used to completely control x-axis formatting, including the floating HUD date of the crosshair.
         *
         * This function **should not** be used to alter the timezone of the displayed date/time. For time zone conversions use {@link CIQ.ChartEngine#setTimeZone}
         *
         * **Expected format:**
         *
         * - `function(labelDate, gridType, timeUnit, timeUnitMultiplier);`
         *
         * **Parameters:**
         * <table>
         * <tr><th>Name</th><th>Type</th><th>Description</th></tr>
         * <tr><td>labelDate</td><td>Date</td><td>javaScript date to format</td></tr>
         * <tr><td>gridType</td><td>String</td><td>"boundary" or "line" for the axis labels<br>absent for the floating crosshair label</td></tr>
         * <tr><td>timeUnit</td><td>Enumerated type</td><td>CIQ.MILLISECOND <br>CIQ.SECOND <br>CIQ.MINUTE <br>CIQ.HOUR <br>CIQ.DAY <br>CIQ.MONTH <br>CIQ.YEAR <br>CIQ.DECADE <br>absent for the floating crosshair label</td></tr>
         * <tr><td>timeUnitMultiplier</td><td>Number</td><td>how many timeUnits <br>absent for the floating crosshair label</td></tr>
         * </table>
         *
         * **Returns:**
         * - Formatted text label for the particular date passed in
         *
         * @type function
         * @memberof CIQ.ChartEngine.XAxis#
         * @example
         * stxx.chart.xAxis.formatter = function(labelDate, gridType, timeUnit, timeUnitMultiplier){
         * 		// your code here to format your string
         * 		// Example: always return HH:MM regardless of gridType,
         * 		// even if gridType is a 'boundary' that normally would display a date in intro-day periodicity
         * 		// or a month in daily periodicity
         *
         * 		var stringDate = labelDate.getHours() + ':' + labelDate.getMinutes();
         * 		return stringDate;
         * }
         * @since 3.0.0 Using x axis formatter now is available for year and month boundaries.
         */
        formatter: null,
        /**
         * If true, the user selected (default browser if none selected) timezone will be used on the x axis.
         * If not set to true, the data timezone will be used even if a user timezone was set.
         * @type boolean
         * @default
         * @memberof CIQ.ChartEngine.XAxis#
         */
        adjustTimeZone: true,
        /**
         * Ideal space between x-axis labels in pixels.
         * If null then the chart will attempt a tick size and time unit in proportion to the chart.
         * Please note that if `stxx.chart.yAxis.goldenRatioYAxis` is set to `true`, this setting will also affect the spacing between y-axis labels.
         * Please note that this setting will be overwritten at rendering time if too small to prevent labels from covering each other.
         * Not applicable if {@link CIQ.ChartEngine.XAxis#timeUnit} is manually set.
         * See {@tutorial Custom X-axis} for additional details.
         * @type number
         * @default
         * @memberof CIQ.ChartEngine.XAxis#
         */
        idealTickSizePixels: null,
        /**
         * Overrides default used in {@link CIQ.ChartEngine#createTickXAxisWithDates}
         * <br>Allowable values:
         * - CIQ.MILLISECOND,
         * - CIQ.SECOND
         * - CIQ.MINUTE
         * - CIQ.HOUR
         * - CIQ.DAY
         * - CIQ.WEEK
         * - CIQ.MONTH
         * - CIQ.YEAR
         * - CIQ.DECADE
         *
         * Visual Reference for sample code below (draw a label every 5 seconds using 1 second periodicity ) :<br>
         * ![xAxis.timeUnit](xAxis.timeUnit.png "xAxis.timeUnit")
         * @type number
         * @default
         * @memberof CIQ.ChartEngine.XAxis#
         * @example
         * // The following will cause the default implementation of createTickXAxisWithDates to print labels in seconds every 5 seconds.
         * // masterData is in 1 second intervals for this particular example.
         * stxx.chart.xAxis.timeUnit = CIQ.SECOND;
         * stxx.chart.xAxis.timeUnitMultiplier = 5;
         */
        timeUnit: null,
        /**
         * Overrides default used in {@link CIQ.ChartEngine#createTickXAxisWithDates}
         * @type number
         * @default
         * @memberof CIQ.ChartEngine.XAxis#
         * @example
         * // The following will cause the default implementation of createTickXAxisWithDates to print labels in seconds every 5 seconds.
         * // masterData is in 1 second intervals for this particular example.
         * stxx.chart.xAxis.timeUnit = CIQ.SECOND;
         * stxx.chart.xAxis.timeUnitMultiplier = 5;
         */
        timeUnitMultiplier: null,
        /**
         * Set to true to draw a line above the x-axis.
         * @type boolean
         * @default
         * @memberof CIQ.ChartEngine.XAxis#
         */
        displayBorder: true,
        /**
         * Set to false to suppress grid lines
         * @type boolean
         * @default
         * @memberof CIQ.ChartEngine.XAxis#
         */
        displayGridLines: true,
        /**
         * Set to false to suppress entire axis
         * @type boolean
         * @default
         * @memberof CIQ.ChartEngine.XAxis#
         * @since 3.0.0
         */
        noDraw: null,
        /**
         * Minimum size for label. This ensures adequate padding so that labels don't collide with one another.
         * Please note that this setting is used during the rendering process, not during the label spacing calculation process and will be overwritten if too small to prevent labels from covering each other.
         * To modify at what interval labels will be placed, please see {@tutorial Custom X-axis} for more details
         * @type number
         * @default
         * @memberof CIQ.ChartEngine.XAxis#
         */
        minimumLabelWidth: 50,
        /**
         * Set to false to hide axis markings in the future.
         * @type boolean
         * @default
         * @memberof CIQ.ChartEngine.XAxis#
         */
        futureTicks: true,
        /**
         * Set to the number of minutes ticks will move by when iterating in "tick" interval.
         * <P>
         * Since 'tick' is not a time based display, there is no way to predict what the time between ticks will be.
         * Ticks can come a second later, a minute later or even more depending on how active a particular instrument may be.
         * As such, if iterating through the market day in 'tick' periodicity, the library uses a pre-defined number of minutes to move around.
         * This will be primarily used when deciding where to put x axis labels when going into the future in 'tick' mode.
         *
         * @type number
         * @default
         * @memberof CIQ.ChartEngine.XAxis#
         * @example
         * //You can override this behavior as follows:
         * var stxx=new CIQ.ChartEngine({container:$$$(".chartContainer"), layout:{"candleWidth": 16, "crosshair":true}});
         * stxx.chart.xAxis.futureTicksInterval=1; // to set to 1 minute, for example
         * @since 3.0.0 default changed from 10 to 1.
         */
        futureTicksInterval: 1,
      }

      CIQ.ChartEngine.Chart.prototype = {
        /**
         * The current symbol for the chart
         * @type string
         * @memberof CIQ.ChartEngine.Chart#
         */
        symbol: null,
        /**
         * The current symbolObject for the chart. Generally this is simply `{symbol: symbol}`.
         * This is initialized by {@link CIQ.ChartEngine#newChart}.
         * @type {object}
         * @memberof CIQ.ChartEngine.Chart#
         */
        symbolObject: { symbol: null },
        /**
         * Set this to presnet an alternate name for the symbol on the chart label and comparison legend.
         * You can set  `stxx.chart.symbolDisplay='yourName'; ` right before calling `newChart()`.
         * Alternatively, a good place to set it is in your fetch() function, if using {@link CIQ.QuoteFeed}. See example.
         * @type string
         * @default
         * @memberof CIQ.ChartEngine.Chart#
         * @example
         * // on your fetch initial load add the following
         * params.stx.chart.symbolDisplay='yourName for '+params.symbol;
         */
        symbolDisplay: null,
        /**
         * Contains information about the series that are associated with the chart.
         * Series are additional data sets, such as used for comparison charts.
         * Note that a series may have a different y-axis calculation than the price chart.
         * See the "parameters" section of {@link CIQ.ChartEngine#addSeries} for details
         * @type {object}
         * @memberof CIQ.ChartEngine.Chart#
         */
        series: {},
        /**
         * Contains "renderers" that are used to create the visualizations for series.
         * @type {object}
         * @memberof CIQ.ChartEngine.Chart#
         */
        seriesRenderers: {},
        /**
         * Current number of ticks scrolled in from the end of the chart.
         * Setting to zero would theoretically cause the chart to be scrolled completely to the left showing an empty canvas.
         * Setting to 10 would display the last 10 candles on the chart.
         * Setting to `maxTicks` would display a full screen on the chart (assuming enough data is available).
         * @type number
         * @default
         * @memberof CIQ.ChartEngine.Chart#
         */
        scroll: 0,
        standStill: 0, // Used internally
        /**
         * Will contain the maximum number of bars that can be displayed on the chart.
         * This number is auto-computed by the ChartEngine when the user zooms or the size of the chart changes.
         * Since charts can pan slightly off the edge of the screen, this number is width/candleWidth + 2 in order allow partial candles to be displayed on both edges.
         * @type number
         * @memberof CIQ.ChartEngine.Chart#
         */
        maxTicks: 0, // Horizontal number of chart ticks that currently fit in the canvas, based on candlewidth and spacing. This is generally one greater than the actual size of the canvas due to candle clipping.
        /**
         * Set to a value between 0 and 1 to soften the curves on a line or mountain chart.
         *
         * This only affects the primary chart series. For setting tension on additional series see {@link CIQ.ChartEngine#addSeries}
         * @type number
         * @memberof CIQ.ChartEngine.Chart#
         */
        tension: null,
        /**
         * The master data for this chart. This data is never modified by the chart engine itself and should not be altered directly. Use {@link CIQ.ChartEngine#setMasterData} , {@link CIQ.ChartEngine#updateChartData} to manipulate this object. See the [Data Integration]{@tutorial DataIntegrationOverview} tutorial for details.
         * @type array
         * @memberof CIQ.ChartEngine.Chart#
         */
        masterData: null,
        /**
         * Contains the current complete data set created by {@link CIQ.ChartEngine#createDataSet}, adjusted for periodicity and with calculated studies. See the [Data Integration]{@tutorial DataIntegrationOverview} tutorial for details.
         * @type array
         * @memberof CIQ.ChartEngine.Chart#
         */
        dataSet: null,
        /**
         * Contains a copy of the dataSet, scrubbed for null entries (gap dates).
         * This is used by studies to avoid gaps being interpreted as "zero" values and throwing off calculations.
         * @type array
         * @memberof CIQ.ChartEngine.Chart#
         */
        scrubbed: null,
        /**
         * Contains the segment of the data set that is displayed on the screen (view-window). See the [Data Integration]{@tutorial DataIntegrationOverview} tutorial for details.
         * @type array
         * @memberof CIQ.ChartEngine.Chart#
         */
        dataSegment: null,
        /**
         * Contains data pertaining to variable width candles, used to determine location of bars on the screen
         * @type array
         * @memberof CIQ.ChartEngine.Chart#
         */
        segmentImage: null,
        /**
         * Parameters used to control the baseline in baseline_delta charts
         * @type object
         * @alias baseline
         * @inner
         * @memberof! CIQ.ChartEngine.Chart#
         */
        baseline: {
          /**
           * includeInDataSegment - If set to true, forces a line chart (usually a baseline chart) to begin inside the chart,
           *                        whereas normally the first point in a line chart is off the left edge of the screen.
           * @type boolean
           * @default
           * @inner
           * @alias baseline[`includeInDataSegment`]
           * @memberof! CIQ.ChartEngine.Chart#
           */
          includeInDataSegment: false,
          /**
           * defaultLevel - If set to a value, overrides the default behavior of baseline chart
           *                which is to set baseline to leftmost point visible on the chart.
           * @type number
           * @default
           * @inner
           * @alias baseline[`defaultLevel`]
           * @memberof! CIQ.ChartEngine.Chart#
           */
          defaultLevel: null,
          /**
           * userLevel - Value of the user-set baseline level.  To prevent user from adjusting the baseline,
           *             set this property to false.
           * @type boolean|number
           * @default
           * @alias baseline[`userLevel`]
           * @memberof! CIQ.ChartEngine.Chart#
           */
          userLevel: null,
          /**
           * actualLevel - This is computed automatically.  Do not set.
           * @type number
           * @default
           * @alias baseline[`actualLevel`]
           * @memberof! CIQ.ChartEngine.Chart#
           */
          actualLevel: null,
        },
        /**
         * Contains the {@CIQ.ChartEngine.XAxis} object for the chart.
         * @type CIQ.ChartEngine.XAxis
         * @memberof CIQ.ChartEngine.Chart#
         */
        xAxis: null, // x Axis for the chart
        /**
         * Contains data entries for the full xaxis, including entries for "future" bars that are displayed on the chart.
         * floatDate and headsUp use these values for display to the user.
         * It is a superset of dataSegment.
         * @type {array}
         * @memberof CIQ.ChartEngine.Chart#
         */
        xaxis: [],
        /**
         * Determines at which zoom level interior axis points are displayed. Value in pixels.
         * @type number
         * @default
         * @memberof CIQ.ChartEngine.Chart#
         */
        xaxisFactor: 30,
        /**
         * Maximum number of decimal places in data set. Computed automatically by calculateTradingDecimalPlaces
         * @type number
         * @memberof CIQ.ChartEngine.Chart#
         */
        decimalPlaces: 2,
        /**
         * Flag for determining whether yAxes will automatically determine a width based on the text length of quotes in a dataSet.
         * Works on all axis attached to a chart.
         * @type boolean
         * @memberof CIQ.ChartEngine.Chart#
         * @since 5.1.1
         */
        dynamicYAxis: false,
        /**
         * Represents the longest length in pixels that the text label of a quote will be.
         * Used to dynamically determine the width of yAxis on resize.
         * @type number
         * @memberof CIQ.ChartEngine.Chart#
         * @private
         */
        quoteTextLength: 0,
        roundit: 100, // Computed automatically to round y-axis display
        /**
         * Function used to render the Legend when multiple series are being displayed on the main chart panel.
         * Update your prototype or a specific chart instance, if you want to use a different rendering method for legend.
         * See {@link CIQ.drawLegend} for details and function signature.
         * <P>
         * Defaults to {@link CIQ.drawLegend}
         * @type function
         * @default
         * @memberof CIQ.ChartEngine.Chart#
         * @example stxx.chart.legendRenderer = yourFunction; // must follow the function signature of {@link CIQ.drawLegend};
         * @since 07/01/2015
         */
        legendRenderer: CIQ.drawLegend,
        /**
         * This structure is used to temporarily override the layout.chartType.  It can also be used to override the coloring function used when drawing
         * bars, candles, etc.
         *
         * Expected format :
         *
         * 		customChart={chartType:myChartType, colorFunction: myColorFunction}
         *
         * 		myChartType is any valid chartType
         * 		myColorFunction needs to support the following parameters: stx, quote, mode
         * 		Example: myColorFunction(stx,quote,mode)
         *
         * 		Parameters:
         *
         *		{@link CIQ.ChartEngine} stx	- A chart object
         *		{object} quote	- A properly formatted OHLC object.
         *		{string} mode	- Applicable on 'candle', 'hollow_candle' and 'volume_candle' charts only. Allowed values: "shadow", "outline", and "solid".
         *							`shadow`- indicates the function is asking for the candle wick color
         *							`outline` indicates the function is asking for the candle border color
         *							`solid` indicates the function is asking for the candle fill color
         *										(Inside of candle. Not applicable on 'hollow_candle' or 'volume_candle')
         *
         * 		Returns:
         *
         *		{string|object} Color to use for the bar, candle or line segment component. Set to null to skip bar or line segment.
         *		For colored line charts a color/pattern combination can be returned in an object of the follwing format: `{pattern:[3,3],color:"red"}`
         *
         * You may omit either of the properties to default to existing settings.
         * Note: After setting the chartType property, it is necessary to call stx.setMainSeriesRenderer() to change the chart rendering.
         *
         * To restore the original chart settings, set this object to null (and call setMainSeriesRenderer() if necessary)
         *
         * See {@tutorial Chart Styles and Types} for more details.
         * @type object
         * @default
         * @alias customChart
         * @memberof! CIQ.ChartEngine.Chart#
         * @example
         * stxx.chart.customChart={colorFunction: function(stx, quote, mode){
         *		if(mode=="shadow" || mode=="outline") return "black";  //draw black wicks and borders
         *		else{
         *			if(quote.Close>100) return "green";
         * 			else if(quote.DT.getHours()<12) return "yellow";
         *			else return "orange";
         *		}
         *		return null;
         *	  }
         * 	};
         */
        customChart: null,
        /**
         * How much padding to leave for the right y-axis. Default is enough for the axis. Set to zero to overlap y-axis onto chart.
         * @type number
         * @default
         * @memberof CIQ.ChartEngine.Chart#
         * @since 07/01/2015
         */
        yaxisPaddingRight: null,
        /**
         * How much padding to leave for the left y-axis. Default is enough for the axis. Set to zero to overlap y-axis onto chart.
         * @type number
         * @default
         * @memberof CIQ.ChartEngine.Chart#
         * @since 07/01/2015
         */
        yaxisPaddingLeft: null,
        tickCache: {}, // private
        /**
         * If set to false, the chart will be anchored on left side preventing white space to be created past the oldest tick.
         * If both {@link CIQ.ChartEngine.Chart#allowScrollPast} and {@link CIQ.ChartEngine.Chart#allowScrollFuture} are set to false, allowScrollFuture will take precedence if the candle is manually set to create space, but automated zoom operations ({@link CIQ.ChartEngine#zoomOut}) will maintain both scroll restrictions.
         *
         * The amount of white space allowed on the right will be limited by {@link CIQ.ChartEngine#minimumLeftBars}
         * @type boolean
         * @default
         * @memberof CIQ.ChartEngine.Chart#
         */
        allowScrollPast: true,
        /**
         * If set to false, the chart will be anchored on right side preventing white space to be created beyond the newest tick.
         * If both {@link CIQ.ChartEngine.Chart#allowScrollPast} and {@link CIQ.ChartEngine.Chart#allowScrollFuture} are set to false, allowScrollFuture will take precedence if the candle is manually set to create space, but automated zoom operations ({@link CIQ.ChartEngine#zoomOut}) will maintain both scroll restrictions.
         * @type boolean
         * @default
         * @memberof CIQ.ChartEngine.Chart#
         */
        allowScrollFuture: true,
        /**
         * Set to true to temporarily hide drawings
         * @type boolean
         * @default
         * @memberof CIQ.ChartEngine.Chart#
         */
        hideDrawings: false,
        /**
         * For line and mountain type charts set this to a value other than "Close" to have those chart types plot a different field.
         *
         * @type {string}
         * @default
         * @memberof CIQ.ChartEngine.Chart#
         * @since 3.0.0
         */
        defaultPlotField: 'Close',
        /**
         * For chart types which have configuration settings (such as the aggregate charts renko, kagi, etc) contains those default settings.
         * This object holds the settings for the current chart type only.
         * @type {object}
         * @default
         * @memberof CIQ.ChartEngine.Chart#
         * @since 3.0.0
         */
        defaultChartStyleConfig: {},
        /**
         * Set this to true to turn off auto-scrolling when fresh data comes in. By default, the chart will scroll backward
         * whenever a new bar comes in, so as to maintain the chart's forward position on the screen. If lockScroll is
         * true then fresh bars with advance the chart forward (and eventually off the right edge of the screen)
         *
         * Note that setSpan({base:"today"}) will set an internal variable that accomplishes the same thing. This is a unique case.
         * @type {boolean}
         * @default
         * @memberof CIQ.ChartEngine.Chart#
         * @since 05-2016-10
         */
        lockScroll: false,
        /**
         * Set this to true to include the chart overlay/study values in the calculation to determine the high and low values for the chart.
         * This may cause the chart to shrink vertically to ensure all study/overlay data is in view.
         * Setting it to false, will maintain the current candle's height, but some of the study/overlay data may be out of the display range.
         * @type {boolean}
         * @default
         * @memberof CIQ.ChartEngine.Chart#
         * @since
         * <br>&bull; 2016-12-01.4.13
         * <br>&bull; 3.0.10 switched default to true
         */
        includeOverlaysInMinMax: true,
        /**
         * READ ONLY. Gap filling style for the chart (line/mountain chart types only).
         * Set by using {@link CIQ.ChartEngine#setGapLines}.
         * @type {object}
         * @default
         * @memberof CIQ.ChartEngine.Chart#
         * @since 4.0.0
         */
        gaplines: null,
        /**
         * READ ONLY. Style for the main series renderer.
         * Set by using {@link CIQ.ChartEngine#setLineStyle}.
         * @type {object}
         * @default
         * @memberof CIQ.ChartEngine.Chart#
         * @since 4.0.0
         */
        lineStyle: null,
        /**
         * When candleWidth<1, setting to true will create approximation of a line chart to improve rendering performance.
         *
         * Must allow for smaller candle sizes by lowering {@link CIQ.ChartEngine#minimumCandleWidth}
         * and allow for larger dataset by increasing {@link CIQ.ChartEngine#maxDataSetSize} or setting it to 0.
         * @type {boolean}
         * @default
         * @memberof CIQ.ChartEngine.Chart#
         * @since 4.1.0
         */
        lineApproximation: true,
        /**
         * Whether chart's main renderer's bars plot more than one data field (OHLC charts).
         * When this is true, will disable the use of {@link CIQ.ChartEngine.Chart#defaultPlotField}.
         * @type boolean
         * @default
         * @memberof CIQ.ChartEngine.Chart#
         * @since 5.1.0
         */
        highLowBars: false,
        /**
         * Whether chart's main renderer's bars represent a stand-alone entity as opposed to a vertex in a line-type chart.
         * This is important when the engine tries to render the data points right off the chart; in a stand-alone bar,
         * the points right off the chart need not be considered.
         * @type boolean
         * @default
         * @memberof CIQ.ChartEngine.Chart#
         * @since 5.1.0
         */
        standaloneBars: false,
        /**
         * Whether chart's main renderer's bars have width, as opposed to a line-type chart whose "bars" are just a point on the chart.
         * This is useful when the engine adjusts the chart for smooth scrolling and homing.
         * @type boolean
         * @default
         * @memberof CIQ.ChartEngine.Chart#
         * @since 5.1.0
         */
        barsHaveWidth: false,
      }

      /**
       * Given a browser time it will return the date in dataZone time. See {@link CIQ.ChartEngine#setTimeZone} for more details.
       * If no dataZone is set, it will return the original date passed in.
       * @param {date} browserDate Date in browser time - as in 'new Date();'
       * @return {date} Date converted to dataZone
       * @memberof CIQ.ChartEngine
       * @since 07-2016-16.6
       */
      CIQ.ChartEngine.prototype.convertToDataZone = function(browserDate) {
        if (this.dataZone) {
          // convert the current time to the dataZone
          var tzNow = CIQ.convertTimeZone(browserDate, null, this.dataZone)
          // remember the the masterData is in local time but really representing the dataZone time.
          // now build a browser timezone time using the dataZone time so it will match the offset of the existing data in masterData.
          browserDate = new Date(
            tzNow.getFullYear(),
            tzNow.getMonth(),
            tzNow.getDate(),
            tzNow.getHours(),
            tzNow.getMinutes(),
            tzNow.getSeconds(),
            tzNow.getMilliseconds()
          )
        }
        return browserDate
      }

      /**
       * Returns true if the interval is based off of a daily interval ("day","week" or "month")
       * @param  {string}  interval The interval
       * @return {boolean}          True if it's a daily interval
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.isDailyInterval = function(interval) {
        if (interval == 'day') return true
        if (interval == 'week') return true
        if (interval == 'month') return true
        return false
      }

      /**
       * Returns true if the chart needs new data to conform with the new periodicity.
       * @param {object} newPeriodicity			newPeriodicity. See {@link CIQ.ChartEngine#setPeriodicity}
       * @param {number} newPeriodicity.period 	`period` as required by {@link CIQ.ChartEngine#setPeriodicity}
       * @param {string} newPeriodicity.interval 	`interval` as required by {@link CIQ.ChartEngine#setPeriodicity}
       * @param {string} newPeriodicity.timeUnit 	`timeUnit` as required by {@link CIQ.ChartEngine#setPeriodicity}
       * @return {boolean} True if the cart needs data in a new periodicity
       * @memberof CIQ.ChartEngine
       * @since 4.0.0
       */
      CIQ.ChartEngine.prototype.needDifferentData = function(newPeriodicity) {
        var layout = this.layout
        var isDaily = CIQ.ChartEngine.isDailyInterval(newPeriodicity.interval),
          wasDaily = CIQ.ChartEngine.isDailyInterval(layout.interval)
        var getDifferentData = false

        if (this.dontRoll || !wasDaily) {
          // we are not rolling so monthly and weekly are not the same as daily or any of the intraday... so simply check for different interval.
          if (layout.interval != newPeriodicity.interval)
            getDifferentData = true
        } else {
          //we are rolling weeekly and monthly and wasn't intraday mode...so check to see if we an still use daily data for the new periodicity
          if (isDaily != wasDaily) getDifferentData = true
        }

        // safety check to deal with defaults.
        if (!isDaily && !newPeriodicity.timeUnit)
          newPeriodicity.timeUnit = 'minute'
        if (!wasDaily && !layout.timeUnit) layout.timeUnit = 'minute'

        if (newPeriodicity.timeUnit != layout.timeUnit) getDifferentData = true // !!! Do not change to !==

        return getDifferentData
      }

      /**
       * Returns true if the chartType displays OHL data.
       * @param  {string} chartType The chart type (layout.chartType)
       * @return {boolean} True if the chart type only displays close values
       * @memberof CIQ.ChartEngine
       * @since 05-2016-10.1 "baseline_delta_mountain" and  "colored_mountain" are also available
       * @deprecated
       */
      CIQ.ChartEngine.chartShowsHighs = function(chartType) {
        console.warn(
          'CIQ.ChartEngine.chartShowsHighs() has been deprecated. Please check one of the appropriate renderer properties instead: stxx.chart.highLowBars, stxx.chart.standaloneBars, or stxx.chart.barsHaveWidth.'
        )
        if (
          {
            line: 1,
            colored_line: 1,
            mountain: 1,
            colored_mountain: 1,
            baseline_delta: 1,
            baseline_delta_mountain: 1,
            histogram: 1,
            scatterplot: 1,
            step: 1,
            colored_step: 1,
          }[chartType] == 1
        )
          return false
        return true
      }

      /**
       * This method does nothing. It is just a known location to put a break point for debugging the kernel.
       * @private
       */
      CIQ.ChartEngine.prototype.debug = function() {}

      /**
       * Measures frames per second. Use this from the console.
       * @param {number} [seconds = 5] Polling interval length
       * @param {function} cb Callback to invoke when done polling
       * @private
       */
      CIQ.ChartEngine.prototype.fps = function(seconds, cb) {
        seconds = seconds || 5
        var start = new Date().getTime()
        var frames = 0
        var self = this
        console.log('Running fps() for ' + seconds + ' seconds')

        function render() {
          var duration = (new Date().getTime() - start) / 1000
          if (duration > seconds) {
            var fps = frames / duration
            console.log('FPS=' + fps)
            if (cb) cb(fps)
            return
          }
          self.draw()
          frames++
          if (CIQ.ChartEngine.useAnimation) {
            requestAnimationFrame(render)
          } else {
            setTimeout(render, 0)
          }
        }
        render()
      }

      _exports.STXChart = CIQ.ChartEngine // backward compatibility

      /**
       * @deprecated
       * @memberOf  CIQ.ChartEngine
       */
      CIQ.ChartEngine.DrawingDescriptor = {
        name: '',
        render: null, /// function(vector, color, context, highlight (boolean), temporary (boolean), stx)
        intersected: null, /// function(vector, x, y) returns whether coordinates intersect the object
        click: null, /// function(vector, clickNumber) called when mouse click or tap. Return true to end drawing. False to accept more clicks.
        abort: null, /// called when user has aborted drawing action (esc key for instance)
      }

      /**
       * The following is a list of ADVANCED injectable methods.
       *
       * **These methods should not be normally called by your code, but rather injections should be used to modify their behavior within the library Kernel.**
       *
       * The "Injection API" provides prepend and append functionality to any built-in method.
       * Essentially what this means is that a developer can write code that will be run either before (prepend) or after (append) any internal {@link CIQ.ChartEngine} function (such as draw() or mouseMove()).
       * This gives developers the ability to supplement, override or ignore any of the built in functionality.
       *
       * Note that you may prepend or append multiple functions. Each injected function is stacked "outward" (daisy-chained) from the core function.
       *
       * _prepend >> prepend >> prepend >> function << append << append << append_
       *
       * You may prepend/append either to CIQ.ChartEngine.prototype or directly to a CIQ.ChartEngine instance.
       *
       * See the {@tutorial Using the Injection API} and [Customization Basics](tutorial-Customization%20Basics.html#injections) tutorials for additional guidance and examples.
       * @namespace CIQ.ChartEngine.AdvancedInjectable
       * @example
       * CIQ.ChartEngine.prototype.append("method_name_goes_here", function(){
       * 	// do something here
       * });
       * @example
       * CIQ.ChartEngine.prototype.prepend("method_name_goes_here", function(){
       * 	// do something here
       * 	// return true; // if you want to exit the method after your injection
       * 	// return false; // if you want the standard code to follow the prepend
       * });
       */

      /**
       * Prepends custom developer functionality to an internal chart member. See [“Injection API"]{@tutorial Using the Injection API}.
       * @param  {string} o Signature of member
       * @param  {function} n Callback function, will be called with "apply"
       * @memberof CIQ.ChartEngine
       * @since
       * <br>&bull; 04-2015 You can append either to an {@link CIQ.ChartEngine} instance, or to the prototype. The first will affect only a single
       * chart while the latter will affect any chart (if you have multiple on the screen).
       * <br>&bull; 15-07-01 function returns a descriptor which can be passed in to [removeInjection()]{@link CIQ.ChartEngine#removeInjection} to remove it later on.
       * @return {object} Injection descriptor which can be passed in to {@link CIQ.ChartEngine#removeInjection} to remove it later on.
       */
      CIQ.ChartEngine.prototype.prepend = function(o, n) {
        var m = 'prepend' + o
        var prepends
        if (this instanceof CIQ.ChartEngine) {
          prepends = this.hasOwnProperty(m) ? this[m] : []
          this[m] = [n].concat(prepends)
        } else {
          prepends = CIQ.ChartEngine.prototype[m] || []
          CIQ.ChartEngine.prototype[m] = [n].concat(prepends)
        }
        return { method: m, func: n }
      }

      /**
       * Appends custom developer functionality to an internal chart member. See [“Injection API"]{@tutorial Using the Injection API}.
       * @param  {string} o Signature of member
       * @param  {function} n Callback function, will be called with "apply"
       * @memberof CIQ.ChartEngine
       * @since
       * <br>&bull; 04-2015 You can append either to an {@link CIQ.ChartEngine} instance, or to the prototype. The first will affect only a single
       * chart while the latter will affect any chart (if you have multiple on the screen)
       * <br>&bull; 15-07-01 function returns a descriptor which can be passed in to [removeInjection()]{@link CIQ.ChartEngine#removeInjection} to remove it later on.
       * @return {object} Injection descriptor which can be passed in to {@link CIQ.ChartEngine#removeInjection} to remove it later on.
       */
      CIQ.ChartEngine.prototype.append = function(o, n) {
        var m = 'append' + o
        var appends
        if (this instanceof CIQ.ChartEngine) {
          appends = this.hasOwnProperty(m) ? this[m] : []
          this[m] = appends.concat(n)
        } else {
          appends = CIQ.ChartEngine.prototype[m] || []
          CIQ.ChartEngine.prototype[m] = appends.concat(n)
        }
        return { method: m, func: n }
      }

      /**
       * Removes a specific injection.  One can remove either an instance injection or a prototype injection, depending on how the function is called.
       * @param  {object} id The injection descriptor returned from {@link CIQ.ChartEngine#prepend} or {@link CIQ.ChartEngine#append}
       * @since 07/01/2015
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.removeInjection = function(id) {
        var method = id.method
        var i
        if (this instanceof CIQ.ChartEngine) {
          if (!this[method]) return
          for (i = 0; i < this[method].length; i++) {
            if (this[method][i] == id.func) {
              this[method].splice(i, 1)
              return
            }
          }
        } else {
          if (!CIQ.ChartEngine.prototype[method]) return
          for (i = 0; i < CIQ.ChartEngine.prototype[method].length; i++) {
            if (CIQ.ChartEngine.prototype[method][i] == id.func) {
              CIQ.ChartEngine.prototype[method].splice(i, 1)
              return
            }
          }
        }
      }
      /**
       * Removes custom developer functionality from an internal chart member. Will remove any and all appends or prepends.
       * @param  {string} o Signature of member
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.remove = function(o) {
        if (this instanceof CIQ.ChartEngine) {
          delete this['append' + o]
          delete this['prepend' + o]
        } else {
          delete CIQ.ChartEngine.prototype['append' + o]
          delete CIQ.ChartEngine.prototype['prepend' + o]
        }
      }

      CIQ.ChartEngine.registeredContainers = [] // This will contain an array of all of the CIQ container objects
      // Note that if you are dynamically destroying containers in the DOM you should delete them from this array when you do so

      /**
       * This code prevents the browser context menu from popping up when right-clicking on a drawing or overlay
       * @param {object} [e=event] Event
       * @return {boolean}
       * @memberOf  CIQ.ChartEngine
       * @deprecated Use CIQ.ScrollManager.attachRightClick
       */
      CIQ.ChartEngine.handleContextMenu = function(e) {
        if (!e) e = event
        for (var i = 0; i < CIQ.ChartEngine.registeredContainers.length; i++) {
          var stx = CIQ.ChartEngine.registeredContainers[i].stx
          if (stx) {
            if (stx.anyHighlighted) {
              if (e.preventDefault) e.preventDefault()
              return false
            }
          }
        }
      }

      CIQ.ChartEngine.prototype.positionMarkers = function() {}

      /**
       * Placeholder for plugin data sets. This array will register each plug in object, complete with their functions.
       * See our Plug-in {@tutorial Markers} tutorial for complete details and examples on registering and implementing a plug-in.
       *
       * If defined, Plug-in instances will be called by their corresponding native functions for the following:
       * - consolidate ( called by {@link CIQ.ChartEngine#consolidatedQuote})
       * - drawUnder (called by draw before rendering underlays)
       * - drawOver (called by draw after rendering overlays)
       * - {@link CIQ.ChartEngine#setMasterData}
       * - {@link CIQ.ChartEngine#updateChartData}
       * - {@link CIQ.ChartEngine#initializeChart}
       * - {@link CIQ.ChartEngine#createDataSet}
       * @type array
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.plugins = {}

      /*
       * remove the items from chart and into stx
       */

      /**
       * Defines raw html for the chart controls. These can be overridden by manually placing HTML elements in the chart container
       * with the same ID. To completely disable a chart control, programmatically set controls[controlID]=null where controlID is the control to disable.
       * You can also set any of these components to null in the stx object before creating a chart as outlined in the included examples.
       * Note that only some controls can be disabled.
       * @example
       * var stxx=new CIQ.ChartEngine({container:$$("chartContainer"), controls: {chartControls:null}});
       * @example
       * // before calling newChart()
       * stxx.controls["chartControls"]=null;
       * @type {object}
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.htmlControls = {
        /**
         * controlID for the Annotation Save button (class="stx-btn stx_annotation_save").
         * @alias htmlControls[`annotationSave`]
         * @memberof CIQ.ChartEngine#htmlControls
         */
        annotationSave:
          '<span class="stx-btn stx_annotation_save" style="display: none;">save</span>',
        /**
         * controlID for the Annotation Cancel button (class="stx-btn stx_annotation_cancel").
         * @alias htmlControls[`annotationCancel`]
         * @memberof CIQ.ChartEngine#htmlControls
         */
        annotationCancel:
          '<span class="stx-btn stx_annotation_cancel" style="display: none; margin-left:10px;">cancel</span>',
        /**
         * controlID for the Trash Can button / Series delete panel (id="mSticky"). Also see {@link CIQ.ChartEngine#displaySticky}
         * @alias htmlControls[`mSticky`]
         * @memberof CIQ.ChartEngine#htmlControls
         * @example
         * // disable the tool tip that appears when hovering over an overlay ( drawing, line study, etc.)
         * stxx.controls["mSticky"]=null;
         */
        mSticky:
          '<div id="mSticky"> <span id="mStickyInterior"></span> <span id="mStickyRightClick" class=""><span class="overlayEdit stx-btn" style="display:none"><span>&nbsp;</span></span> <span id="overlayTrashCan" class="stx-btn" style="display:none"><span>&nbsp;</span></span> <span id="mouseDeleteInstructions"><span>(</span><span id="mouseDeleteText">right-click to delete</span><span id="mouseManageText">right-click to manage</span><span>)</span></span></span></div>',
        /**
         * controlID for the Horizontal Crosshair line (class="stx_crosshair stx_crosshair_x").
         * @alias htmlControls[`crossX`]
         * @memberof CIQ.ChartEngine#htmlControls
         */
        crossX:
          '<div class="stx_crosshair stx_crosshair_x" style="display: none;"></div>',
        /**
         * controlID for the Vertical Crosshair line (class="stx_crosshair stx_crosshair_y").
         * @alias htmlControls[`crossY`]
         * @memberof CIQ.ChartEngine#htmlControls
         */
        crossY:
          '<div class="stx_crosshair stx_crosshair_y" style="display: none;"></div>',
        /**
         * controlID for the zoom-in and zoom-out buttons (class="stx_chart_controls").
         * @alias htmlControls[`chartControls`]
         * @memberof CIQ.ChartEngine#htmlControls
         */
        chartControls:
          '<div class="stx_chart_controls" style="display: none; bottom: 22px;"><div id="chartSize"><span id="zoomOut" class="stx-zoom-out"></span><span id="zoomIn" class="stx-zoom-in"></span></div></div>',
        /**
         * controlID for the home button (class="stx_jump_today home").
         * The button goes away if you are showing the most current data. See example to manually turn it off.
         * You can call `stxx.home();` programatically.	 See {@link CIQ.ChartEngine#home} for more details
         * @alias htmlControls[`home`]
         * @memberof CIQ.ChartEngine#htmlControls
         * @example
         * // disable the home button
         * var stxx=new CIQ.ChartEngine({container:$$$(".chartContainer"), layout:{"candleWidth": 16, "crosshair":true}});
         * stxx.controls["home"]=null;
         */
        home:
          '<div id="home" class="stx_jump_today home" style="display:none"><span></span></div>',
        /**
         * controlID for div which floats along the X axis with the crosshair date (class="stx-float-date").
         * @alias htmlControls[`floatDate`]
         * @memberof CIQ.ChartEngine#htmlControls
         */
        floatDate:
          '<div class="stx-float-date" style="visibility: hidden;"></div>',
        /**
         * controlID for div which controls the handle to resize panels (class="stx-ico-handle").
         * @alias htmlControls[`handleTemplate`]
         * @memberof CIQ.ChartEngine#htmlControls
         * @example
         * // example to hide the handle and prevent resizing of panels
         * .stx-ico-handle {
         *		display: none;
         * }
         */
        handleTemplate:
          '<div class="stx-ico-handle" style="display: none;"><span></span></div> ',
        /**
         * controlID for the div which hosts the panel title (symbol name, study name ) and the study control icons on the on the upper left hand corner of each panel (class="stx-panel-control")
         * This control can not be disabled, but can be manipulated using the corresponding CSS style classes.
         * On the main chart panel, `stx-chart-panel` is added to the class definition ( in addition to `stx-panel-title` which just controls the tile) so you can manipulate the entire chart controls section, separately from the rest of the study panel controls.
         *
         * @example
         * // example to hide the chart symbol title
         * .stx-panel-control.stx-chart-panel .stx-panel-title{
         * 		display:none;
         * }
         *
         * // for backwards compatibility, this is still supported:
         * .chart-title{
         *		display	: none;
         *	}
         *
         * @example
         * // example to hide all panels titles
         * .stx-panel-control .stx-panel-title{
         * 		display:none;
         * }
         *
         * @alias htmlControls[`iconsTemplate`]
         * @memberof CIQ.ChartEngine#htmlControls
         */
        iconsTemplate:
          '<div class="stx-panel-control"><div class="stx-panel-title"></div><div class="stx-btn-panel"><span class="stx-ico-up"></span></div><div class="stx-btn-panel"><span class="stx-ico-focus"></span></div><div class="stx-btn-panel"><span class="stx-ico-down"></span></div><div class="stx-btn-panel"><span class="stx-ico-edit"></span></div><div class="stx-btn-panel"><span class="stx-ico-close"></span></div></div>',
        /**
         * controlID for grabber which sits to right of baseline so it can be moved.
         * @alias htmlControls[`baselineHandle`]
         * @memberof CIQ.ChartEngine#htmlControls
         */
        baselineHandle:
          '<div class="stx-baseline-handle" style="display: none;"></div>',
      }

      /**
       * Registers the Chart controls and attaches event handlers to the zoom and home controls.
       * @private
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.registerHTMLElements = function() {
        var c = this.chart.container
        for (var control in CIQ.ChartEngine.htmlControls) {
          if (
            typeof this.chart[control] == 'undefined' &&
            typeof this.controls[control] == 'undefined'
          ) {
            if (!this.allowZoom && control == 'chartControls') continue
            var el = $$$('#' + control, c)
            if (el) {
              this.chart[control] = el
              this.controls[control] = el
            } else {
              var rawHTML = CIQ.ChartEngine.htmlControls[control]
              var div = document.createElement('DIV')
              div.innerHTML = rawHTML
              el = div.firstChild
              c.appendChild(el)
              this.chart[control] = el
              this.controls[control] = el
              el.id = control
            }
          }
        }
        if (this.controls.chartControls) {
          var zoomIn = $$$('#zoomIn', this.controls.chartControls)
          var zoomOut = $$$('#zoomOut', this.controls.chartControls)

          CIQ.safeClickTouch(
            zoomIn,
            (function(self) {
              return function(e) {
                self.zoomIn(e)
                e.stopPropagation()
              }
            })(this)
          )
          CIQ.safeClickTouch(
            zoomOut,
            (function(self) {
              return function(e) {
                self.zoomOut(e)
                e.stopPropagation()
              }
            })(this)
          )
          if (!CIQ.touchDevice) {
            this.makeModal(zoomIn)
            this.makeModal(zoomOut)
          }
        }
        if (this.controls.home) {
          CIQ.safeClickTouch(
            this.controls.home,
            (function(self) {
              return function(e) {
                self.home({ animate: true })
                e.stopPropagation()
              }
            })(this)
          )
          if (!CIQ.touchDevice) {
            this.makeModal(this.controls.home)
          }
        }
      }

      /**
       * Convience function to attach a model on mouse events
       * @param {HTMLElement} Element to attach the modal to
       * @private
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.makeModal = function(element) {
        var self = this
        element.onmouseover = function(event) {
          self.modalBegin()
        }
        element.onmouseout = function(event) {
          self.modalEnd()
        }
      }
      /**
       * Clones a style from a style object (obtained from getComputedStyle). Any styles are converted to camel case. This method automatically
       * converts from browsers that store styles as numeric arrays rather than as property objects.
       * @param  {object} styleObject A style object derived from getComputedStyle
       * @return {object}	A new style object that will match properties
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.cloneStyle = function(styleObject) {
        var rc = {}
        var nativeCamelSupport = false
        function capitalize(g) {
          return g[1].toUpperCase()
        }
        for (var i in styleObject) {
          var v = styleObject[i]
          // do *not* check styleObject["backgroundAttachment"]. Android browsers return bogus results.
          // instead we iterate through the object
          if (i == 'backgroundAttachment') nativeCamelSupport = true

          // modern browsers contain both camel and hyphenated. We can avoid the camelCase conversion
          // logic to save a little bit of startup time
          if (nativeCamelSupport) {
            if (v && v.constructor == String && isNaN(i)) {
              rc[i] = v
            }
          } else if (!isNaN(i)) {
            // old android browsers fall into here
            var x = styleObject.getPropertyValue(v)
            if (x) {
              //var vcc=v.replace(CIQ.camelCaseRegExp, function (g) { return g[1].toUpperCase(); })
              // much more efficient camel case conversion algorithm
              v = v.split('-')
              var ii = 0,
                jj = v.length
              var vcc = v[0]
              while (++ii < jj) {
                vcc += v[ii].charAt(0).toUpperCase() + v[ii].slice(1)
              }
              rc[vcc] = x
            }
          } else {
            // old internet explorer falls into here
            var icc = i.replace(CIQ.camelCaseRegExp, capitalize)
            rc[icc] = v
          }
        }
        return rc
      }

      /**
       * Returns an object containing the class style given a css class name (used by plotLine() for instance). A caching mechanism is used
       * for performance. If styles are changed dynamically then use CIQ.ChartEngine.prototype.clearStyles to reset.
       * @param  {string} className The CSS class name to get the styles
       * @return {object}			  An object containing each style, in camel case.
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.canvasStyle = function(className) {
        var s = this.styles[className]
        if (!s) {
          var div = document.createElement('div') // Create a dummy div
          div.className = className
          this.container.appendChild(div)
          var styles = getComputedStyle(div)
          s = this.styles[className] = this.cloneStyle(styles)
          this.container.removeChild(div)
          if (!styles) {
            // css not initialized, possibly hidden iframe in firefox
            this.styles[className] = null
          }
        }
        return s
      }

      /**
       * Detects if a string is a valid CSS color and if so returns that string. Otherwise it
       * returns a style object, assuming that the string is a classname.
       * @param  {string} str Either a color or a className
       * @return {object}		Either the color or a class object
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.colorOrStyle = function(str) {
        if (str.indexOf('#') != -1) return str
        if (str.indexOf('(') != -1) return str // rgb() or rgba()
        if (str == 'transparent') return str
        return this.canvasStyle(str)
      }

      /**
		Call this to remove all of the loaded canvas styles, for instance after loading a new css file
		@memberof CIQ.ChartEngine
	*/
      CIQ.ChartEngine.prototype.clearStyles = function() {
        this.styles = {}
      }

      /**
       * Convenience method to set a style on the chart
       * @param  {string} obj The object whose style you wish to change (stx_grid, stx_xaxis, etc)
       * @param  {string} attribute The style name of the object you wish to change. It will accept hyphenated or camel case formats.
       * @param  {string} value The value to assign to the attribute
       * @example
       * stx.setStyle("stx_candle_up","borderLeftColor","green");
       * stx.setStyle("stx_candle_down","borderLeftColor","red");
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.setStyle = function(obj, attribute, value) {
        if (!this.styles[obj]) {
          this.canvasStyle(obj)
        }
        if (!this.styles[obj]) this.styles[obj] = {}
        this.styles[obj][CIQ.makeCamelCase(attribute)] = value
      }

      /**
       * Sets canvas font context given a css class name. Supports fontStyle, fontWeight, fontSize and fontFamily.
       * @param  {string} className The name of the CSS class to pull font from
       * @param  {external:CanvasRenderingContext2D} ctx		 An HTML Context
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.canvasFont = function(className, ctx) {
        if (!ctx) ctx = this.chart.context
        var style = this.canvasStyle(className)
        if (!style) return

        var result =
          style.fontStyle +
          ' ' +
          style.fontWeight +
          ' ' +
          style.fontSize +
          ' ' +
          style.fontFamily
        if (result.indexOf('undefined') == -1) {
          ctx.font = result
        } else {
          this.styles[className] = null
          console.log('bad css style for class ' + className)
        }
      }

      /**
       * Sets color and globalAlpha (opacity) for the canvas given a css class name. Call this before drawing on the canvas.
       * @param  {string} className A CSS style. Supports "color" and "opacity"
       * @param  {external:CanvasRenderingContext2D} [ctx]	   An HTML Context
       * @example
       * stxx.canvasColor("myStyle");
       * // draw a line using canvas primitives, will be color defined in .myStyle
       * @memberof CIQ.ChartEngine
       * @since 4.0.0 Allow color:"transparent" to pass through and not use defaultColor.  Instead, use defaultColor if there is no style.color.
       */
      CIQ.ChartEngine.prototype.canvasColor = function(className, ctx) {
        if (!ctx) ctx = this.chart.context
        var style = this.canvasStyle(className)
        if (!style) return
        var color = style.color
        if (!color) color = this.defaultColor
        ctx.globalAlpha = 1
        ctx.fillStyle = color
        ctx.strokeStyle = color
        var opacity = style.opacity
        if (typeof opacity != 'undefined') ctx.globalAlpha = opacity
      }

      /**
       * Returns the font size defined by the requested class name. Defaults to 12 if undefined. Use this to determine vertical heights so that lettering isn't clipped.
       * @param  {string} className Class name
       * @return {number}			  The font size (px is stripped)
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.getCanvasFontSize = function(className) {
        var s = this.canvasStyle(className)
        var fs = s.fontSize
        if (!fs) fs = '12'
        return parseInt(CIQ.stripPX(fs), 10)
      }

      /**
       * Returns the canvas color specified in the class name
       * @param  {string} className The class name
       * @return {string}			  The color specified (May be undefined if none specified)
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.getCanvasColor = function(className) {
        var s = this.canvasStyle(className)
        return s.color
      }

      /**
       * Override this function to hide the date which floats along the X axis when crosshairs are enabled. Return `true` to hide the date or `false` to display.
       * @memberof CIQ.ChartEngine
       * @deprecated
       */
      CIQ.ChartEngine.hideDates = function() {
        return false
      }

      /**
       * Runs the prepend injections. A prepend function that returns true will short circuit any proceeding prepend functions, and the core functionality.
       * @private
       * @param  {string} o	 The function name
       * @param  {arguments} args The arguments to the function
       * @param  {object} self The this object
       * @return {boolean}	  Returns true if any prepend function returns true.
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.runPrepend = function(o, args, self) {
        var n = 'prepend' + o
        var prepends = this.hasOwnProperty(n) ? this[n] : []
        prepends = prepends.concat(CIQ.ChartEngine.prototype[n] || [])
        if (!prepends.length) return false
        if (!self) self = this
        for (var i = 0; i < prepends.length; i++) {
          var rv = prepends[i].apply(self, args)
          if (rv) return rv
        }
        return false
      }

      /**
       * Runs the append injections. An append function that returns true will short circuit any proceeding append functions (but not the core functionality since that has already ocurred).
       * @private
       * @param  {string} o	 The function name
       * @param  {arguments} args The arguments to the function
       * @param  {object} self The this object
       * @return {boolean}	  Returns true if any append function returns true.
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.runAppend = function(o, args, self) {
        var n = 'append' + o
        var appends = this.hasOwnProperty(n) ? this[n] : []
        appends = appends.concat(CIQ.ChartEngine.prototype[n] || [])
        if (!appends.length) return false
        if (!self) self = this
        for (var i = 0; i < appends.length; i++) {
          var rv = appends[i].apply(self, args)
          if (rv) return rv
        }
        return false
      }

      /**
       * Registers a drawing tool. This is typically done using lazy eval.
       * @private
       * @param  {string} name Name of drawing tool
       * @param  {function} func Constructor for drawing tool
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.registerDrawingTool = function(name, func) {
        CIQ.ChartEngine.drawingTools[name] = func
      }

      /**
       * @memberOf  CIQ.ChartEngine
       * @deprecated
       */

      CIQ.ChartEngine.prototype.createBlock = function(
        left,
        width,
        top,
        height,
        className,
        context
      ) {
        if (!context) context = this.chart.context
        if (typeof height == 'undefined') {
          return
        }
        this.canvasColor(className, context)
        context.fillRect(left, top, width, height)
        context.globalAlpha = 1
      }

      /**
       * This is called whenever a change to layout, drawings or theme occurs. But can be used to trigger any event. If {@link CIQ.ChartEngine#changeCallback} has a function registered, then
       * that function will be called with the type of change. The change itself is not passed in. The layout or drawings can be inspected to find the change but
       * typically the entire set of drawings or entire layout is desired and it is mostly just necessary to know that they have changed so that they
       * can be saved.
       * @param  {string} change Type of change that occurred. Any string that {@link CIQ.ChartEngine#changeCallback} has been programmed to handle is valid.
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.changeOccurred = function(change) {
        if (this.currentlyImporting) return // changes actually occurring because of an import, not user activity
        if (this.changeCallback) {
          console.warn(
            'CIQ.ChartEngine.changeCallback has been deprecated. Please use addEventListener()'
          )
          this.changeCallback(this, change)
        }
        var obj = {
          stx: this,
          symbol: this.chart.symbol,
          symbolObject: this.chart.symbolObject,
          layout: this.layout,
          drawings: this.drawingObjects,
        }
        if (change == 'layout') {
          this.dispatch('layout', obj)
        } else if (change == 'vector') {
          this.dispatch('drawing', obj)
        } else if (change == 'theme') {
          this.dispatch('theme', obj)
        } else if (change == 'preferences') {
          this.dispatch('preferences', obj)
        }
      }

      /**
       * Sets the base chart type for the primary symbol.
       * @param {string} chartType The chart type. See <a href="CIQ.ChartEngine.html#layout%5B%60chartType%60%5D">CIQ.ChartEngine.layout.chartType</a> for valid options.
       *
       * See {@tutorial Chart Styles and Types} for more details.
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.setChartType = function(chartType) {
        var layout = this.layout,
          chart = this.chart
        if (layout.aggregationType != 'ohlc') {
          layout.aggregationType = 'ohlc'
          if (chart.canvas) this.createDataSet()
        }
        layout.chartType = chartType
        this.setMainSeriesRenderer(true)
        chart.defaultChartStyleConfig = { type: chartType }
        if (this.displayInitialized) this.draw()
        this.changeOccurred('layout')
      }

      /**
       * Sets the base aggregation type to "rangebars" "ohlc" "kagi" "pandf" "heikinashi" "linebreak" "renko".
       * See the [Chart types](tutorial-Chart Styles and Types.html#OverridingDefaults) tutorial for details on how to override aggregation type defaults.
       * @param {string} aggregationType The chart type
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.setAggregationType = function(aggregationType) {
        this.layout.chartType = 'candle'
        var chart = this.chart
        if (chart.baseline.userLevel !== false) {
          chart.baseline.userLevel = chart.baseline.defaultLevel
          chart.panel.yAxis.scroll = CIQ.ChartEngine.YAxis.prototype.scroll
        }
        this.layout.aggregationType = aggregationType
        this.setMainSeriesRenderer()
        if (chart.canvas) {
          this.createDataSet()
          this.draw()
        }
        this.changeOccurred('layout')
      }

      /**
       * Sets the chart scale.
       * @param {string} chartScale "log", "linear", "percent", "relative".
       *  - Setting to "percent" or "relative" will call {@link CIQ.ChartEngine#setComparison} even of no comparisons are present; which sets `stxx.chart.isComparison=true`.
       *    - To check if scale is in percentage mode use `stxx.chart.isComparison` instead of using the {@link CIQ.ChartEngine#chartScale} value.
       *  - See {@link CIQ.Comparison.initialPrice} for details on how to set basis for "relative" scale.
       * @memberof CIQ.ChartEngine
       * @since 4.1.0 added "percent"
       * @since 5.1.0 added "relative"
       */
      CIQ.ChartEngine.prototype.setChartScale = function(chartScale) {
        var chart = this.chart
        var needsTransform = {
          percent: true,
          relative: true,
        }
        if (!chartScale) chartScale = 'linear'
        if (needsTransform[chartScale]) {
          this.setComparison(chartScale, chart, CIQ.Comparison.initialPrice)
        } else if (needsTransform[this.layout.chartScale]) {
          var comparing = false
          for (var s in chart.series) {
            if (chart.series[s].parameters.isComparison) comparing = true
          }
          if (!comparing) this.setComparison(false, chart)
        }
        this.layout.chartScale = chartScale
        if (chart.canvas) this.draw()
        this.changeOccurred('layout')
      }

      /**
       * Sets the charts to adjusted values rather than standard values. Adjusted values are calculated outside of the chart engine (and may be splits, dividends or both).
       * When charts are using adjusted values, a computed ratio for each tick is used for price to pixel calculations which keeps drawings accurate
       * @param {boolean} data True to use adjusted values (Adj_Close), false to use Close values
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.setAdjusted = function(data) {
        this.layout.adj = data
        if (this.chart.canvas) {
          this.createDataSet()
          this.draw()
        }
        this.changeOccurred('layout')
      }

      /**
       * Turns on or off the volume underlay indicator
       * @param {boolean} data True to turn on the underlay
       * @memberof CIQ.ChartEngine
       * @deprecated
       */
      CIQ.ChartEngine.prototype.setVolumeUnderlay = function(data) {
        this.layout.volumeUnderlay = data
        if (this.chart.canvas) this.draw()
        this.changeOccurred('layout')
      }

      /**
       * Exports all of the drawings on the chart(s) so that they can be saved to an external database and later reconstructed.
       *
       * Note: This function has been renamed {@link CIQ.ChartEngine#exportDrawings}.
       *
       * @see {@link CIQ.ChartEngine#exportDrawings}
       * @see {@link CIQ.ChartEngine#importDrawings}
       * @return {array} An array of objects representing each drawing
       * @memberof CIQ.ChartEngine
       * @deprecated since 3.0.0
       */
      CIQ.ChartEngine.prototype.serializeDrawings = function() {
        console.warn(
          'CIQ.ChartEngine.serializeDrawings() has been deprecated. Please use exportDrawings()'
        )
        return this.exportDrawings()
      }

      /**
       * Exports all of the drawings on the chart(s) so that they can be saved to an external database and later imported with {@link CIQ.ChartEngine#importDrawings}.
       * @see {@link CIQ.ChartEngine#importDrawings}
       * @return {array} An array of objects representing each drawing
       * @memberof CIQ.ChartEngine
       * @since 3.0.0 Replaces serializeDrawings
       */
      CIQ.ChartEngine.prototype.exportDrawings = function() {
        var arr = []
        for (var i = 0; i < this.drawingObjects.length; i++) {
          arr.push(this.drawingObjects[i].serialize())
        }
        return arr
      }

      /**
       * Causes all drawings to delete themselves. External access should be made through @see CIQ.ChartEngine.prototype.clearDrawings
       * @private
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.abortDrawings = function() {
        for (var i = 0; i < this.drawingObjects.length; i++) {
          this.drawingObjects[i].abort(true)
        }
        this.drawingObjects = []
      }

      /**
       * Imports drawings from an array originally created by {@link CIQ.ChartEngine#serializeDrawings}.
       *
       * Note: This function and serializeDrawings have been renamed {@link CIQ.ChartEngine#importDrawings} and {@link CIQ.ChartEngine#exportDrawings} respectively.
       *
       * To immediately render the reconstructed drawings, you must call `draw()`.
       * See {@tutorial Using and Customizing Drawing Tools} for more details.
       * @see {@link CIQ.ChartEngine#exportDrawings}
       * @see {@link CIQ.ChartEngine#importDrawings}
       * @param  {array} arr An array of serialized drawings
       * @memberof CIQ.ChartEngine
       * @deprecated since 4.0.0
       */
      CIQ.ChartEngine.prototype.reconstructDrawings = function(arr) {
        console.warn(
          'CIQ.ChartEngine.reconstructDrawings() has been deprecated. Please use importDrawings()'
        )
        this.importDrawings(arr)
      }

      /**
       * Imports drawings from an array originally created by {@link CIQ.ChartEngine#exportDrawings}.
       * To immediately render the reconstructed drawings, you must call `draw()`.
       * See {@tutorial Using and Customizing Drawing Tools} for more details.
       *
       * **Important:**
       * Calling this function in a way that will cause it to run simultaneously with [importLayout]{@link CIQ.ChartEngine#importLayout}
       * will damage the results on the layout load. To prevent this, use the {@link CIQ.ChartEngine#importLayout} or {@link CIQ.ChartEngine#newChart} callbacks.
       *
       * @see {@link CIQ.ChartEngine#exportDrawings}
       * @param  {array} arr An array of serialized drawings
       * @memberof CIQ.ChartEngine
       * @since 4.0.0 Replaces reconstructDrawings
       * @example
       * // programatically add a rectangle
       * stxx.importDrawings([{"name":"rectangle","pnl":"chart","col":"transparent","fc":"#7DA6F5","ptrn":"solid","lw":1.1,"d0":"20151216030000000","d1":"20151216081000000","tzo0":300,"tzo1":300,"v0":152.5508906882591,"v1":143.3385829959514}]);
       * // programatically add a vertical line
       * stxx.importDrawings([{"name":"vertical","pnl":"chart","col":"transparent","ptrn":"solid","lw":1.1,"v0":147.45987854251013,"d0":"20151216023000000","tzo0":300,"al":true}]);
       * // now render the reconstructed drawings
       * stxx.draw();
       */
      CIQ.ChartEngine.prototype.importDrawings = function(arr) {
        if (!CIQ.Drawing) return
        for (var i = 0; i < arr.length; i++) {
          var rep = arr[i]
          if (rep.name == 'fibonacci') rep.name = 'retracement'
          var Factory = CIQ.ChartEngine.drawingTools[rep.name]
          if (!Factory) {
            if (CIQ.Drawing[rep.name]) {
              Factory = CIQ.Drawing[rep.name]
              CIQ.ChartEngine.registerDrawingTool(rep.name, Factory)
            }
          }
          if (Factory) {
            var drawing = new Factory()
            drawing.reconstruct(this, rep)
            this.drawingObjects.push(drawing)
          }
        }
      }

      /**
       * Clears all the drawings on the chart. (Do not call abortDrawings directly).
       * @param {boolean} cantUndo Set to true to make this an "non-undoable" operation
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.clearDrawings = function(cantUndo) {
        var before = CIQ.shallowClone(this.drawingObjects)
        this.abortDrawings()
        if (cantUndo) {
          this.undoStamps = []
        } else {
          this.undoStamp(before, CIQ.shallowClone(this.drawingObjects))
        }
        this.changeOccurred('vector')
        //this.createDataSet();
        //this.deleteHighlighted(); // this will remove any stickies and also call draw()
        // deleteHighlighted was doing too much, so next we call 'just' what we need.
        this.cancelTouchSingleClick = true
        CIQ.clearCanvas(this.chart.tempCanvas, this)
        this.draw()
        if (this.controls.mSticky) {
          this.controls.mSticky.style.display = 'none'
          this.controls.mSticky.children[0].innerHTML = ''
        }
      }

      /**
       * Creates a new drawing of the specified type with the specified parameters. See {@tutorial Using and Customizing Drawing Tools} for more details.
       * @param  {string} type	   Drawing name
       * @param  {object} parameters Parameters that describe the drawing
       * @return {CIQ.Drawing}			A drawing object
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.createDrawing = function(type, parameters) {
        if (!CIQ.Drawing) return
        var drawing = new CIQ.Drawing[type]()
        drawing.reconstruct(this, parameters)
        //set default configs if not provided
        var config = new CIQ.Drawing[type]()
        config.stx = this
        config.copyConfig()
        for (var prop in config) {
          drawing[prop] = drawing[prop] || config[prop]
        }
        this.drawingObjects.push(drawing)
        this.draw()
        return drawing
      }

      /**
       * Removes the drawing. Drawing object should be one returned from {@link CIQ.ChartEngine#createDrawing}. See {@tutorial Using and Customizing Drawing Tools} for more details.
       * @param  {object} drawing Drawing object
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.removeDrawing = function(drawing) {
        for (var i = 0; i < this.drawingObjects.length; i++) {
          if (this.drawingObjects[i] == drawing) {
            this.drawingObjects.splice(i, 1)
            this.changeOccurred('vector')
            this.draw()
            return
          }
        }
      }

      /**
       * Returns a date (in yyyymmddhhmm form) given a tick (location in the dataSet).
       * If the tick lies outside of the dataSet then the date will be arrived at algorithmically by calculating into the past or future.
       * @param  {number} tick  Location in the dataSet
       * @param  {CIQ.ChartEngine.Chart} [chart] An optional chart object
       * @param  {boolean} [nativeDate] True to return as date object otherwise returns in yyyymmddhhmm form
       * @return {string}		  The date form dictated by native param
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.dateFromTick = function(
        tick,
        chart,
        nativeDate
      ) {
        if (!chart) chart = this.chart
        var data_len = chart.dataSet.length
        var dt
        var iter
        var result
        var addedTempDate = false

        // if empty chart then add current date so this function supports initializing an empty chart in quotefeed
        if (data_len === 0) {
          chart.dataSet[0] = {}
          chart.dataSet[0].DT = new Date()
          data_len = chart.dataSet.length
          addedTempDate = true
        }

        if (tick < 0) {
          iter = this.standardMarketIterator(chart.dataSet[0].DT)
          dt = iter.previous(Math.abs(tick))
        } else if (tick >= data_len) {
          iter = this.standardMarketIterator(chart.dataSet[data_len - 1].DT)
          dt = iter.next(tick - (data_len - 1))
        } else {
          dt = chart.dataSet[tick].DT
        }

        if (nativeDate) {
          result = new Date(dt.getTime())
        } else {
          result = CIQ.yyyymmddhhmm(dt)
        }

        if (addedTempDate) {
          delete chart.dataSet[0].DT
        }
        return result
      }

      /**
       * Calculates and sets the value of zoom and scroll for y-axis based on yAxis.initialMarginTop and yAxis.initialMarginBottom.
       * This method will automatically translate those into starting scroll and zoom factors.
       * If the combined initial values are greater than the y-axis height, then both zoom and scroll will be rest to 0;
       * @param {CIQ.ChartEngine.YAxis} yAxis The yAxis to reset
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.calculateYAxisMargins = function(yAxis) {
        yAxis.zoom = yAxis.initialMarginTop + yAxis.initialMarginBottom
        yAxis.scroll = (yAxis.initialMarginTop - yAxis.initialMarginBottom) / 2
        if (yAxis.zoom > yAxis.height) {
          //console.log('calculateYAxisMargins adjusted zoom and scroll to 0. zoom',yAxis.zoom,'  |  height=',yAxis.height);
          yAxis.zoom = 0 // If the zoom is greater than the height then we'll have an upside down y-axis
          yAxis.scroll = 0
        }
      }

      /**
       * Returns the minimum spacing required between the latest tick on the chart and the price label.
       * @param  {CIQ.ChartEngine} stx	  The charting object
       * @param  {CIQ.ChartEngine.Chart} chart	The specific chart
       * @param  {string} chartType	The chart rendering type (candle, line, etc)
       * @returns  {number} pixels to offset
       * @memberof CIQ.ChartEngine
       * @since 4.0.0
       * @since 5.1.0 removed stx param
       */
      CIQ.ChartEngine.prototype.getLabelOffsetInPixels = function(
        chart,
        chartType
      ) {
        var isLineType =
          (!this.mainSeriesRenderer ||
            !this.mainSeriesRenderer.standaloneBars) &&
          !this.standaloneBars[chartType]
        if (
          this.yaxisLabelStyle == 'roundRectArrow' &&
          !(isLineType && this.extendLastTick && chart.yaxisPaddingRight !== 0)
        ) {
          // Special case when we have a pointy arrow we want the current tick to be right
          // at the arrow point, not buried underneath it
          // unless the developer set the flags to extend the line/mountain to the very edge of the chart.
          // or unless the y-axis is overlaying the chart
          var margin = 3 // should be the same from createYAxisLabel
          var height = this.getCanvasFontSize('stx_yaxis') + margin * 2
          return height * 0.66
        }
        return 0
      }

      /**
       * Returns the chart to the home position, where the most recent tick is on the right side of the screen.
       *
       * By default the home() behavior is to maintain the white space currently on the right side of the chart.
       * To align the chart to the right edge instead, set the white space to 0  by calling: `stxx.home({whitespace:0});` or `stxx.home({maintainWhitespace:false});`
       *
       * @param {object} params Object containing the following keys:
       * @param {boolean} [params.animate = false] Set to true to animate a smooth scroll to the home position.
       * @param {boolean} [params.maintainWhitespace = true] Set to `true` to maintain the currently visible white space on the right of the chart, or to `false` to align to the right edge.
       * @param {number} [params.whitespace = 0] Override to force a specific amount of whitespace on the right of the chart.
       *		This will take precedence over `params.maintainWhitespace`
       * @param {CIQ.ChartEngine.Chart} [params.chart] Optionally which chart to scroll home
       * @memberof CIQ.ChartEngine
       * @example
       * stxx.home({maintainWhitespace:false});
       */
      CIQ.ChartEngine.prototype.home = function(params) {
        this.swipe.amplitude = 0
        this.grabbingScreen = false //in case they were grabbing the screen and let go on top of the home button.
        var layout = this.layout
        if (CIQ.ChartEngine.insideChart)
          CIQ.unappendClassName(this.container, 'stx-drag-chart') //in case they were grabbing the screen and let go on top of the home button.
        if (typeof params != 'object') {
          // backward compatibility
          params = {
            maintainWhitespace: params,
          }
        }

        function resetPanelZooms(stx) {
          for (var p in stx.panels) {
            var yAxes = stx.panels[p].yaxisLHS.concat(stx.panels[p].yaxisRHS)
            for (var a = 0; a < yAxes.length; a++)
              stx.calculateYAxisMargins(yAxes[a])
          }
        }
        function scrollToCallback(self, chart, exactScroll) {
          return function() {
            resetPanelZooms(self)
            chart.scroll = exactScroll
            self.draw()
          }
        }
        if (typeof params.maintainWhitespace == 'undefined')
          params.maintainWhitespace = true // maintain the whitespace unless set to false

        this.cancelTouchSingleClick = true
        if (!this.chart.dataSet || !this.chart.dataSet.length) {
          // to clear out anything that may have been on the screen. Otherwise we still show stale data.
          this.draw()
          return
        }
        this.micropixels = 0
        var barsDisplayedOnScreen = Math.floor(
          this.chart.width / layout.candleWidth
        )
        for (var chartName in this.charts) {
          var chart = this.charts[chartName]
          if (params.chart && params.chart != chart) continue

          var whitespace = 0
          if (params.maintainWhitespace && this.preferences.whitespace >= 0)
            whitespace = this.preferences.whitespace
          if (params.whitespace || params.whitespace === 0)
            whitespace = params.whitespace
          var leftMargin = this.getLabelOffsetInPixels(chart, layout.chartType)
          if (leftMargin > whitespace) whitespace = leftMargin

          var exactScroll = Math.min(
            barsDisplayedOnScreen,
            chart.dataSet.length
          ) // the scroll must be the number of bars you want to see.
          if (this.chart.allowScrollPast) exactScroll = barsDisplayedOnScreen // If whitespace allowed on left of screen
          this.micropixels =
            this.chart.width - exactScroll * layout.candleWidth - whitespace
          this.preferences.whitespace = whitespace
          while (this.micropixels > layout.candleWidth) {
            // If micropixels is larger than a candle then scroll back further
            exactScroll++
            this.micropixels -= layout.candleWidth
          }
          while (this.micropixels < 0) {
            exactScroll--
            this.micropixels += layout.candleWidth
          }
          this.micropixels -= layout.candleWidth
          exactScroll++
          if (
            (!this.mainSeriesRenderer ||
              !this.mainSeriesRenderer.standaloneBars) &&
            !this.standaloneBars[layout.chartType]
          )
            this.micropixels += layout.candleWidth / 2 // bar charts display at beginning of candle

          if (params.animate) {
            var self = this
            this.scrollTo(
              chart,
              exactScroll,
              scrollToCallback(self, chart, exactScroll)
            )
          } else {
            chart.scroll = exactScroll
            resetPanelZooms(this)
          }
        }
        this.draw()
      }

      /**
       * Whether the chart is scrolled to a home position.
       *
       * @returns {boolean} true when the scroll position shows the last tick of the dataSet
       * @memberof CIQ.ChartEngine
       * @since 2016-06-21
       */
      CIQ.ChartEngine.prototype.isHome = function() {
        var chart = this.chart,
          dataSet = chart.dataSet,
          animating = chart.animatingHorizontalScroll
        return (
          this.pixelFromTick(dataSet.length - (animating ? 2 : 1), chart) <
          chart.width + chart.panel.left
        )
        //return ((this.chart.scroll-1)*this.layout.candleWidth)+this.micropixels<=this.chart.width+1;
      }

      /**
       * Returns the tick (position in dataSet) given the requested date. The date does not need to match exactly.
       * If the date lies between ticks then the earlier will be returned by default.
       * @param  {string} dt	  Date in string format
       * @param  {CIQ.ChartEngine.Chart} [chart] Optional chart object
       * @param  {number} [adj] Optional timezone adjustment in minutes to apply to date before getting tick
       * @param  {boolean} [forward] Optional switch to return the next tick as opposed to the previous, in case an exact match is not found
       * @return {number}		  The tick location
       * @todo  Use native dates instead of string form dates.
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.tickFromDate = function(
        dt,
        chart,
        adj,
        forward
      ) {
        if (!chart) chart = this.chart
        if (!chart.dataSet || !chart.dataSet.length) return 0
        if (!adj) adj = 0

        if (!chart) {
          chart = this.chart
        }
        var target = dt.constructor == Date ? dt : CIQ.strToDateTime(dt)

        // This line is used by drawings which are saved with a gmt offset.
        if (!CIQ.ChartEngine.isDailyInterval(this.layout.interval))
          target.setMinutes(target.getMinutes() + adj)

        var ms = target.getTime()
        var total = chart.tickCache[ms]
        if (total || total === 0) {
          return total
        }

        var firstDate = chart.dataSet[0].DT
        var lastDate = chart.dataSet[chart.dataSet.length - 1].DT
        if (target >= firstDate && target <= lastDate) {
          for (var i = 0; i < chart.dataSet.length; i++) {
            var d = chart.dataSet[i].DT
            if (d.getTime() == target.getTime()) {
              chart.tickCache[ms] = i
              return i
            }
            if (d > target) {
              chart.tickCache[ms] = forward ? i : i - 1
              return chart.tickCache[ms]
            }
          }
        }

        var intoThePast = target < firstDate // start at beginning of chart and work backward into the past, or end of chart and into the future
        var start = intoThePast ? firstDate : lastDate
        var iter = this.standardMarketIterator(start)
        var ticks = iter.futureTick({ end: target })
        total = intoThePast ? ticks * -1 : chart.dataSet.length - 1 + ticks
        if (forward && intoThePast) total++
        if (!forward && !intoThePast) total--
        chart.tickCache[ms] = total
        return total
      }

      /**
       * This is the object stored in CIQ.ChartEngine.chart.xaxis which contains information regarding an x-axis tick.
       * See {@link CIQ.ChartEngine.AdvancedInjectable#createXAxis} for more detail.
       * @constructor
       * @param {number} hz Horizontal position of center of label in pixels
       * @param {string} grid Either "line" or "boundary" depending on whether the label should be a date/time boundary or just a grid line
       * @param {string} text The text to display in the label
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.XAxisLabel = function(hz, grid, text) {
        this.hz = hz
        this.grid = grid
        this.text = text
      }

      /**
       * <span class="injection">INJECTABLE</span>
       * <span class="animation">Animation Loop</span>
       * Call this method to create the X axis (date axis). Uses {@link CIQ.ChartEngine#createTickXAxisWithDates}.
       *
       * Use css styles `stx_xaxis` to control colors and fonts for the dates. <br>
       * Use css styles `stx_xaxis_dark` to control **color only** for the divider dates. <br>
       * Use css styles `stx_grid_border`, `stx_grid` and `stx_grid_dark` to control the grid line colors. <br>
       * The dark styles are used for dividers; when the grid changes to a major point such as the start of a new day on an intraday chart, or a new month on a daily chart.
       *
       * See {@tutorial Custom X-axis} and {@tutorial CSS Overview} for additional details.
       *
       * @param  {CIQ.ChartEngine.Chart} chart	The chart to create an x-axis for
       * @return {CIQ.ChartEngine.XAxisLabel[]}			axisRepresentation that can be passed in to {@link CIQ.ChartEngine#drawXAxis}
       * @memberof CIQ.ChartEngine.AdvancedInjectable#
       * @alias createXAxis
       *
       */
      CIQ.ChartEngine.prototype.createXAxis = function(chart) {
        //TODO caching of xaxis probably in this function.
        if (chart.dataSegment.length <= 0) return null
        if (CIQ.ChartEngine.hideDates()) return null
        var arguments$ = [chart]
        var axisRepresentation = this.runPrepend('createXAxis', arguments$)
        if (axisRepresentation) return axisRepresentation
        axisRepresentation = this.createTickXAxisWithDates(chart)
        this.headsUpHR()
        this.runAppend('createXAxis', arguments$)
        return axisRepresentation
      }

      /**
       * Change the yAxis.top and yAxis.bottom to create drawing space
       * for the xAxis.
       *
       * @param {CIQ.ChartEngine.Panel} panel	Panel to adjust, used to check location
       * @param {CIQ.ChartEngine.YAxis} yAxis	yAxis to adjust
       * @private
       */
      CIQ.ChartEngine.prototype.adjustYAxisHeightOffset = function(
        panel,
        yAxis
      ) {
        var topOffset = yAxis.topOffset,
          bottomOffset = yAxis.bottomOffset
        //If the sum of bottomOffset and topOffset is larger than the panel height reset them
        if (topOffset + bottomOffset > panel.height) {
          console.log(
            'The sum of yAxis.topOffset and yAxis.bottomOffset cannot be greater than the panel height. Both values will be reset to 0.'
          )
          yAxis.bottomOffset = 0
          yAxis.topOffset = 0
        }

        if (!this.xaxisHeight && this.xaxisHeight !== 0) {
          this.xaxisHeight = this.getCanvasFontSize('stx_xaxis') + 4
          if (this.chart.xAxis.displayBorder || this.axisBorders)
            this.xaxisHeight += 3
        }
        var panelHasTheAxis =
          (this.xAxisAsFooter &&
            panel.bottom > this.chart.canvasHeight - this.xaxisHeight) ||
          (!this.xAxisAsFooter && panel == this.chart.panel)
        if (panelHasTheAxis) bottomOffset += this.xaxisHeight

        yAxis.top = panel.top + topOffset
        yAxis.bottom = panel.bottom - bottomOffset
      }

      /**
       * <span class="injection">INJECTABLE</span>
       * <span class="animation">Animation Loop</span>
       *
       * Draws the grid for the y-axis.
       * @param  {CIQ.ChartEngine.Panel} panel The panel for the y-axis
       * @memberof CIQ.ChartEngine.AdvancedInjectable#
       * @alias plotYAxisGrid
       */
      CIQ.ChartEngine.prototype.plotYAxisGrid = function(panel) {
        if (this.runPrepend('plotYAxisGrid', arguments)) return
        var context = this.chart.context
        if (panel.yAxis.yAxisPlotter) {
          panel.yAxis.yAxisPlotter.draw(context, 'grid')
        }
        this.runAppend('plotYAxisGrid', arguments)
      }

      /**
       * <span class="injection">INJECTABLE</span>
       * <span class="animation">Animation Loop</span>
       *
       * Plots the text on the y-axis.
       * @param  {CIQ.ChartEngine.Panel} panel The panel for the y-axis
       * @memberof CIQ.ChartEngine.AdvancedInjectable#
       * @alias plotYAxisText
       */
      CIQ.ChartEngine.prototype.plotYAxisText = function(panel) {
        if (this.runPrepend('plotYAxisText', arguments)) return
        var arr = panel.yaxisLHS.concat(panel.yaxisRHS)
        for (var i = 0; i < arr.length; i++) {
          var yAxis = arr[i]
          if (!yAxis.yAxisPlotter) continue
          if (yAxis.noDraw) continue
          this.canvasFont('stx_yaxis')
          this.canvasColor('stx_yaxis')
          var context = this.chart.context
          context.textBaseline = 'middle'
          if (yAxis.justifyRight) context.textAlign = 'right'
          else context.textAlign = 'left'
          yAxis.yAxisPlotter.draw(context, 'text')
          context.textBaseline = 'alphabetic'
          context.textAlign = 'left'
        }
        this.runAppend('plotYAxisText', arguments)
      }

      /**
	 * Formats prices for the Y-axis.
	 *
	 * Intelligently computes the decimal places based on the size of the y-axis ticks.

	 * If the panel is a study panel, then prices will be condensed by {@link CIQ.condenseInt} if equal or over 1000.
	 * This can be overridden by manually setting {@link CIQ.ChartEngine.YAxis#decimalPlaces}.

	 * You can call this method to ensure that any prices that you are using outside of the chart are formatted the same as the prices on the y-axis.
	 * @param  {number} price The price to be formatted
	 * @param  {CIQ.ChartEngine.Panel} panel The panel for the y-axis.
	 * @param {number} [requestedDecimalPlaces] Optionally specify the number of decimal places, otherwise it will be determined by the yaxis setting, or if not set, determined automatically
	 * @param {CIQ.ChartEngine.YAxis} [yAxis] Optional yAxis
	 * @return {number}		  The formatted price
	 * @memberof CIQ.ChartEngine
	 * @since 4.0.0 condenseInt will be called only if equal or over 1000 rather than 100.
	 */
      CIQ.ChartEngine.prototype.formatYAxisPrice = function(
        price,
        panel,
        requestedDecimalPlaces,
        yAxis
      ) {
        if (price === null || typeof price == 'undefined' || isNaN(price))
          return ''
        var yax = yAxis ? yAxis : panel.yAxis
        var decimalPlaces = requestedDecimalPlaces
        if (!decimalPlaces && decimalPlaces !== 0)
          decimalPlaces = yax.printDecimalPlaces
        if (!decimalPlaces && decimalPlaces !== 0) {
          if (yax.priceTick < 0.01) decimalPlaces = 4
          else if (yax.priceTick < 0.1) decimalPlaces = 2
          else if (yax.priceTick < 1) decimalPlaces = 1
          else decimalPlaces = 0
        }
        if (panel.name != panel.chart.name) {
          // Don't condense chart prices, but do condense study prices
          if (yax.priceTick >= 1000) {
            // k or m for thousands or millions
            return CIQ.condenseInt(price)
          }
        }

        var internationalizer = this.internationalizer
        if (internationalizer) {
          var l = internationalizer.priceFormatters.length
          if (decimalPlaces >= l) decimalPlaces = l - 1
          price = internationalizer.priceFormatters[decimalPlaces].format(price)
        } else {
          price = price.toFixed(decimalPlaces)
          // the above may be a problem at some point for datasets with very small shadows because the rounding skews the real number.
          // We should truncate the decimal places instead of rounding to preserve the accuracy,
          // but for now the above seems to work fine so we will leave it alone.
          // And also the amount of rounding being done here actually "corrects" some of differences introduced elsewhere in the yAxis price calculations. ugg!
          // Use the flowing code when ready to show truncated vs. rounded values
          //price = price.toString();
          //if(price.indexOf(".") > 0){
          //	price = price.slice(0, (price.indexOf("."))+decimalPlaces+1)
          //};
        }
        return price
      }

      /**
       * Pads out the decimal places given only a price. It will not truncate, but will
       * add zeroes. Prices under 2 will be padded to 4 decimal places. Prices over 1000
       * will not be padded. All other prices will be padded to 2 decimal places.
       * @param  {number} price A price
       * @param  {number} [determinant] The optional value to determine the decimal places. For
       * instance, if you want to determine the number of decimals for today's change based on the actual price
       * @return {string}       A price padded for decimal places
       * @memberOf  CIQ.ChartEngine
       * @since 2016-07-16
       */
      CIQ.ChartEngine.prototype.padOutPrice = function(price, determinant) {
        if (price !== 0 && (!price || typeof price != 'number')) return ''
        if (!determinant && determinant !== 0) determinant = price
        var str = '' + determinant
        var decimalPlaces = str.substring(str.indexOf('.')).length - 1
        if (determinant >= 1000) decimalPlaces = Math.max(decimalPlaces, 0)
        else if (determinant < 2) decimalPlaces = Math.max(decimalPlaces, 4)
        else decimalPlaces = Math.max(decimalPlaces, 2)

        var internationalizer = this.internationalizer
        if (internationalizer) {
          var l = internationalizer.priceFormatters.length
          if (decimalPlaces >= l) decimalPlaces = l - 1
          price = internationalizer.priceFormatters[decimalPlaces].format(price)
        } else {
          price = price.toFixed(decimalPlaces)
        }
        return price
      }

      /**
       * Formats a price according to the decimalPlaces specified in either the panel or chart.
       * It will then format to international standards if the internationalizer is set.
       * This method *does not* condense prices.
       * @param  {number} price The price to be formatted
       * @param  {CIQ.ChartEngine.Panel} panel The panel to use to determine the number of decimal places.
       * @return {number}		  The formatted price
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.formatPrice = function(price, panel) {
        if (price !== 0 && (!price || typeof price == 'undefined')) return ''
        if (!panel) panel = this.currentPanel
        if (!panel) panel = this.chart.panel
        if (!panel) return price
        var decimalPlaces = panel.decimalPlaces
        if (!decimalPlaces && decimalPlaces !== 0) {
          decimalPlaces = panel.chart.decimalPlaces
        }
        if (!decimalPlaces && decimalPlaces !== 0) {
          return price
        }
        var internationalizer = this.internationalizer
        if (internationalizer) {
          var l = internationalizer.priceFormatters.length
          if (decimalPlaces >= l) decimalPlaces = l - 1
          price = internationalizer.priceFormatters[decimalPlaces].format(price)
        } else {
          price = price.toFixed(decimalPlaces)
        }
        return price
      }

      /**
       * <span class="injection">INJECTABLE</span>
       * <span class="animation">Animation Loop</span>
       * Registers mouse events for the crosshair elements (to prevent them from picking up events)
       * @memberof CIQ.ChartEngine.AdvancedInjectable#
       * @alias createCrosshairs
       */
      CIQ.ChartEngine.prototype.createCrosshairs = function() {
        if (this.runPrepend('createCrosshairs', arguments)) return
        if (this.controls.crossX.onmousedown) return

        this.controls.crossY.onmousedown = function(e) {
          if (!e) e = event
          if (e.preventDefault) e.preventDefault()
          return false
        }
        this.controls.crossX.onmousedown = function(e) {
          if (!e) e = event
          if (e.preventDefault) e.preventDefault()
          return false
        }
        this.runAppend('createCrosshairs', arguments)
      }

      /**
       * This method determines the high and low values for the data set. It requires an array of fields to check. For instance
       * the array might contain ["Close","Series1","Series2"] which would return the max and min of all of those values for each
       * quote.
       *
       * @param  {array} quotes The array of quotes to evaluate for min and max (typically CIQ.ChartEngine.chart.dataSegment)
       * @param  {array} fields A list of fields to compare
       * @param {boolean} [sum] If true then compute maximum sum rather than the maximum single value
       * @param {boolean} [bypassTransform] If true then bypass any transformations
       * @param {number} [length] Optionally specify how much of the quotes to process
       * @return {array}		  A tuple, min and max values
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.determineMinMax = function(
        quotes,
        fields,
        sum,
        bypassTransform,
        length
      ) {
        var highValue = Number.MAX_VALUE * -1
        var lowValue = Number.MAX_VALUE
        var isTransform = false
        var l = quotes.length
        if (length) l = length
        //var leftmostQuoteExists, rightmostQuoteExists;   // Removing this logic fixes KB 5395, but it will include the offscreen coords in the y-axis range even if it's connected by a gap and the gap is not drawn

        for (var i = 0; i <= l + 1; i++) {
          var quote
          //if(i==l && lowValue!=Number.MAX_VALUE && lowValue!=highValue) break;  // no need to examine off-chart values
          // Here only the first field in the fields array is checked.  A different approach might be to check all the fields.
          if (fields.length) {
            if (i == l) {
              //if(leftmostQuoteExists) continue;  // no need to fetch bar to left of dataSegment
              quote = this.getPreviousBar(this.chart, fields[0], 0)
            } else if (i == l + 1) {
              //if(rightmostQuoteExists) continue;  // no need to fetch bar to right of dataSegment
              quote = this.getNextBar(this.chart, fields[0], l - 1)
            } else quote = quotes[i]
          }
          if (!quote) continue
          if (!bypassTransform) {
            if (quote.transform) {
              isTransform = true
              quote = quote.transform
            } else if (isTransform) continue //don't include points without transforms if we have been including points with transforms
          }
          var acc = 0
          for (var j = 0; j < fields.length; j++) {
            var tuple = CIQ.existsInObjectChain(quote, fields[j])
            if (!tuple) continue
            var f = tuple.obj[tuple.member]
            if (typeof f == 'number') f = [f]
            for (var v = 0; v < f.length; v++) {
              var val = f[v]
              if (val || val === 0) {
                if (sum) {
                  acc += val
                  if (acc > highValue) highValue = acc
                  if (acc < lowValue) lowValue = acc
                } else {
                  if (val > highValue) highValue = val
                  if (val < lowValue) lowValue = val
                }
                //if(i===0) leftmostQuoteExists=true;
                //if(i==l-1) rightmostQuoteExists=true;
              }
            }
          }
        }
        if (highValue == Number.MAX_VALUE * -1) highValue = 0
        if (lowValue == Number.MAX_VALUE) lowValue = 0
        return [lowValue, highValue]
      }

      /**
       * Here we calculate the range for the yaxis and set appropriate member variables.
       * @private
       * @param  {CIQ.ChartEngine.Panel} panel The panel containing the yaxis
       * @param  {CIQ.ChartEngine.YAxis} yAxis The yaxis to work on
       * @param {number} [low] The low value for the axis
       * @param {number} [high] The high value for the axis
       */
      CIQ.ChartEngine.prototype.calculateYAxisRange = function(
        panel,
        yAxis,
        low,
        high
      ) {
        if (low == Number.MAX_VALUE) {
          low = 0
          high = 0
        }
        var cheight = panel.height,
          newHigh = null,
          newLow = null
        this.adjustYAxisHeightOffset(panel, yAxis)
        yAxis.height = yAxis.bottom - yAxis.top
        // Ensure the user hasn't scrolled off the top or the bottom of the chart
        var verticalPad = Math.round(Math.abs(cheight / 5))
        if (cheight - Math.abs(yAxis.scroll) < verticalPad) {
          yAxis.scroll = (cheight - verticalPad) * (yAxis.scroll < 0 ? -1 : 1)
        }

        if (low || low === 0) {
          if (high - low === 0) {
            // A stock that has no movement, so we create some padding so that a straight line will appear
            var padding = Math.pow(
              10,
              -(low.toString() + '.').split('.')[1].length
            )
            if (padding == 1) padding = 100 // For whole number prices, widen the shadow
            newHigh = low + padding
            newLow = low - padding
          } else {
            if (
              (this.layout.semiLog || this.layout.chartScale == 'log') &&
              newHigh
            ) {
              // When in log scale, the yAxis high and low will be the log10 of the prices. The actual values are just for display, not for calculation.
              var logLow = Math.log(low) / Math.LN10
              var logHigh = Math.log(high) / Math.LN10
              newHigh = Math.pow(10, logHigh)
              newLow = Math.pow(10, logLow)
            } else {
              newHigh = high
              newLow = low
            }
          }
          yAxis.high = newHigh
          yAxis.low = newLow
        }
        if (yAxis.max || yAxis.max === 0) yAxis.high = yAxis.max
        if (yAxis.min || yAxis.min === 0) yAxis.low = yAxis.min
        yAxis.shadow = yAxis.high - yAxis.low
        if (
          panel.chart.name === panel.name &&
          panel.yAxis.name === yAxis.name
        ) {
          // For the main yaxis on the main chart only check for semilog
          var isLogScale =
            this.layout.semiLog || this.layout.chartScale == 'log'
          if (
            panel.chart.isComparison ||
            this.layout.aggregationType == 'pandf'
          )
            isLogScale = false
          if (yAxis.semiLog != isLogScale) {
            this.clearPixelCache()
            yAxis.semiLog = isLogScale
          }
        }
      }

      /**
       * <span class="injection">INJECTABLE</span>
       * <span class="animation">Animation Loop</span>
       *
       * This method creates and draws the Y Axis for the chart
       *
       * yAxis.high - The highest value on the y-axis
       * yAxis.low - The lowest value on the y-axis
       *
       * @param  {CIQ.ChartEngine.Chart} chart The chart to create y-axis
       * @memberof CIQ.ChartEngine.AdvancedInjectable#
       * @alias renderYAxis
       * @since  15-07-01
       */
      CIQ.ChartEngine.prototype.renderYAxis = function(chart) {
        if (this.runPrepend('renderYAxis', arguments)) return
        var panel = chart.panel
        var arr = panel.yaxisRHS.concat(panel.yaxisLHS)

        // Iterate through all the yaxis for the panel and set all the necessary calculations
        // For the primary yaxis (panel.yAxis) we will set the low and high values based on the range
        // of values in the chart itself
        var i
        for (i = 0; i < arr.length; i++) {
          var yAxis = arr[i]
          var low = null,
            high = null
          if (panel.yAxis.name === yAxis.name) {
            low = chart.lowValue
            high = chart.highValue
          }
          this.calculateYAxisRange(panel, yAxis, low, high)
        }

        var parameters = {}

        for (i = 0; i < arr.length; i++) {
          parameters.yAxis = arr[i]
          this.createYAxis(panel, parameters)
          this.drawYAxis(panel, parameters)
        }
        this.runAppend('renderYAxis', arguments)
      }
      /**
       * <span class="injection">INJECTABLE</span>
       * <span class="animation">Animation Loop</span>
       *
       * This method initializes display variables for the chart.
       * It is part of the animation loop and called with every draw() operation.
       * The high and low values for the displayed chart are calculated.
       * Those values are subsequently used by {@link CIQ.ChartEngine.AdvancedInjectable#createYAxis} which is called from within this method.
       * This method also calls {@link CIQ.ChartEngine#createCrosshairs}.
       *
       * chart.highValue - The highest value on the chart
       * chart.lowValue - The lowest value on the chart
       *
       * @param  {CIQ.ChartEngine.Chart} chart The chart to initialize
       * @memberof CIQ.ChartEngine.AdvancedInjectable#
       * @alias initializeDisplay
       */
      CIQ.ChartEngine.prototype.initializeDisplay = function(chart) {
        if (this.runPrepend('initializeDisplay', arguments)) return
        var fields = []
        var self = this
        function getSeriesOverlayFields(baseFields) {
          for (var id in chart.seriesRenderers) {
            var renderer = chart.seriesRenderers[id],
              params = renderer.params,
              panelName = params.panel,
              panel = self.panels[panelName]
            if (params.yAxis && panelName == chart.panel.name) continue //only include series using the main y axis
            for (var id2 = 0; id2 < renderer.seriesParams.length; id2++) {
              // Find any series that share the Y axis
              var seriesParams = renderer.seriesParams[id2]
              if (seriesParams.shareYAxis) {
                if (seriesParams.symbol) {
                  fields = fields.concat(
                    CIQ.createObjectChainNames(seriesParams.symbol, baseFields)
                  )
                } else if (seriesParams.field) {
                  fields.push(seriesParams.field)
                }
              }
            }
          }
          chart.panel = self.panels[chart.name]

          if (chart.includeOverlaysInMinMax) {
            for (var overlay in self.overlays) {
              var o = self.overlays[overlay]
              if (o.panel != chart.name) continue
              for (var entry in o.outputMap) {
                fields.push(entry)
              }
            }
          }
        }
        var minMax
        var length = null

        // We often have an extra tick hanging off the edge of the screen. We don't want this
        // tick to affect the high and low calculation though. That causes jumpiness when
        // zooming because the chart is alternately including and excluding that tick
        var ticksOnScreen = Math.floor(
          (chart.width - this.micropixels) / this.layout.candleWidth
        )
        if (chart.scroll > chart.maxTicks && chart.maxTicks > ticksOnScreen + 1)
          length = chart.dataSegment.length - 1

        if (
          (this.mainSeriesRenderer && !this.mainSeriesRenderer.highLowBars) ||
          !this.highLowBars[this.layout.chartType]
        ) {
          // line charts shouldn't take into account high and low values, just close
          var defaultField = this.chart.defaultPlotField || 'Close'
          /*if(!defaultField || defaultField=="Close") fields.push("Close", "iqPrevClose");
			else */ fields.push(
            defaultField
          )
          getSeriesOverlayFields(fields.slice())
          minMax = this.determineMinMax(
            chart.dataSegment,
            fields,
            null,
            !chart.transformFunc,
            length
          )
          var mainSeriesRenderer = this.mainSeriesRenderer || {}
          if (
            mainSeriesRenderer.params &&
            mainSeriesRenderer.params.baseline &&
            mainSeriesRenderer.params.type != 'mountain'
          ) {
            var base = chart.baseline.actualLevel
            if (base || base === 0) {
              if (chart.transformFunc)
                base = chart.transformFunc(this, chart, base)
              var diff = Math.max(base - minMax[0], minMax[1] - base)
              if (this.repositioningBaseline) {
                minMax = [chart.lowValue, chart.highValue]
              } else {
                minMax[0] = base - diff
                minMax[1] = base + diff
              }
            }
          }
        } else {
          fields.push('Close', 'Open', 'High', 'Low' /*, "iqPrevClose"*/)
          getSeriesOverlayFields(fields.slice())
          minMax = this.determineMinMax(
            chart.dataSegment,
            fields,
            null,
            !this.chart.transformFunc,
            length
          )
        }
        chart.lowValue = minMax[0]
        chart.highValue = minMax[1]
        var aggregation = chart.state.aggregation
        if (aggregation && aggregation.box) {
          // Make room for X and O rendering since half of it lies beyond the high/low
          chart.lowValue -= aggregation.box / 2
          chart.highValue += aggregation.box / 2
        }
        this.runAppend('initializeDisplay', arguments)
      }

      // @deprecated Use pixelFromBar
      CIQ.ChartEngine.prototype.computePosition = function(x, offset) {
        if (typeof offset == 'undefined') offset = 0
        var position = x * this.layout.candleWidth + offset + this.micropixels
        return position
      }

      // @deprecated
      CIQ.ChartEngine.prototype.computeColor = function(open, close) {
        if (open < close) return 'stx_candle_up'
        if (open > close) return 'stx_candle_down'
        return 'stx_candle_shadow'
      }

      // @deprecated
      CIQ.ChartEngine.prototype.computeLength = function(high, low) {
        var h = this.pixelFromPrice(high)
        var l = this.pixelFromPrice(low)
        return l - h
      }

      /**
       * Adds a series renderer to the chart, or updates it.	A series renderer manages a group of series which are rendered on the chart
       * in the same manner. For instance, several series which are part of the same stacked histogram.
       *
       * Example 1 <iframe width="100%" height="500" scrolling="no" seamless="seamless" align="top" style="float:top" src="http://jsfiddle.net/chartiq/b6pkzrad/embedded/result,js,html/" allowfullscreen="allowfullscreen" frameborder="1"></iframe>
       *
       * Example 2 <iframe width="100%" height="500" scrolling="no" seamless="seamless" align="top" style="float:top" src="http://jsfiddle.net/chartiq/rb423n71/embedded/result,js,html/" allowfullscreen="allowfullscreen" frameborder="1"></iframe>
       *
       * You must manage the persistency of a renderer, and remove individual series ({@link CIQ.Renderer#removeSeries} ) , remove all series ({@link CIQ.Renderer#removeAllSeries}) or even delete the renderer ({@link CIQ.ChartEngine#removeSeriesRenderer}) as needed by your application
       *
       * Note: once a renderer is set for a chart it will remain loaded with all its series definitions and y axis (if one used) even if a new symbol is loaded.
       * Calling setSeriesRenderer again with the same renderer name, will just return the previously created renderer.
       * **Be careful not to send a different yAxis object unless you have deleted the previous one by completely removing all of its associated series** (see {@link CIQ.Renderer#removeAllSeries}).
       * Failure to do this will cause multiple axis to be displayed, the original one becoming orphan.
       *
       * See {@link CIQ.Renderer}
       *
       * See {@link CIQ.ChartEngine#removeSeriesRenderer} for release functionality.
       *
       * See {@link CIQ.ChartEngine#addSeries} for additional implementation examples.
       *
       * @param {CIQ.Renderer} renderer The renderer
       * @returns {CIQ.Renderer} This seriesRenderer
       * @memberof CIQ.ChartEngine
       * @since 07/01/2015
       * @example
       *	// group the series together and select "line" as the rendering type to display the series.
       *	var mdataRenderer=stxx.setSeriesRenderer(new CIQ.Renderer.Lines({params:{name:"My Line Series", type:"line", width:4, callback:mdataLegend}}))
       *			.removeAllSeries()
       *			.attachSeries(symbol1,{color:"red",permanent:true})
       *			.attachSeries(symbol2,"blue")
       *			.attachSeries(symbol3,"yellow")
       *			.ready()
       */
      CIQ.ChartEngine.prototype.setSeriesRenderer = function(renderer) {
        var params = renderer.params
        if (this.chart.seriesRenderers[params.name])
          return this.chart.seriesRenderers[params.name] // renderer already created

        if (params.yAxis) {
          params.yAxis = this.addYAxis(this.panels[params.panel], params.yAxis)
        }
        renderer.stx = this

        this.chart.seriesRenderers[params.name] = renderer
        return renderer
      }

      /** Sets a renderer for the main chart.  This is done by parsing the layout.chartType and layout.aggregationType and creating the renderer which will support those settings.
       * @param {boolean} eraseData Set to true to erase any existing series data
       * @memberOf  CIQ.ChartEngine
       * @since 5.1.0
       */
      CIQ.ChartEngine.prototype.setMainSeriesRenderer = function(eraseData) {
        var chartType = this.layout.chartType,
          aggregationType = this.layout.aggregationType,
          custom = this.chart.customChart
        var r = this.mainSeriesRenderer
        if (r) {
          r.removeAllSeries(eraseData)
          this.removeSeriesRenderer(r)
          r = this.mainSeriesRenderer = null
        }
        var params = {
          panel: this.chart.panel.name,
          name: '_main_series',
          highlightable: false,
          useChartLegend: true,
        }
        if (custom && custom.chartType) chartType = custom.chartType
        if (chartType == 'none') return // no renderer and no default lines renderer
        if (aggregationType && aggregationType != 'ohlc')
          chartType = aggregationType
        var renderer = CIQ.Renderer.produce(chartType, params)
        if (renderer) {
          this.setSeriesRenderer(renderer).attachSeries(null, {
            display: this.chart.symbol,
          })
          this.mainSeriesRenderer = renderer
        }
        // Convenience access
        ;['highLowBars', 'standaloneBars', 'barsHaveWidth'].forEach(
          function(p) {
            this.chart[p] =
              this.mainSeriesRenderer && this.mainSeriesRenderer[p]
          }.bind(this)
        )
      }

      /**
       * Sets the market definition on the chart.
       * Once set, the definition will not change until it is explicitly set to something else by calling this method again.
       * If a dynamic model is desired, where a new definition is loaded as different instruments are activated, see {@link CIQ.ChartEngine#setMarketFactory}.
       * See {@link CIQ.Market} for market definition rules and examples.
       * This is only required if your chart will need to know the operating hours for the different exchanges.
       * If using a 24x7 chart, a market does not need to be set.
       * @param {object} marketDefinition A market definition as required by {@link CIQ.Market}
       * @param {CIQ.ChartEngine.Chart} chart An instance of {@link CIQ.ChartEngine.Chart}
       * @memberof CIQ.ChartEngine
       * @since 04-2016-08
       * @example
       * stxx.setMarket(marketDefinition);
       */
      CIQ.ChartEngine.prototype.setMarket = function(marketDefinition, chart) {
        if (!chart) chart = this.chart
        chart.market = new CIQ.Market(marketDefinition)
        for (var session in this.layout.marketSessions) {
          chart.market.disableSession(
            session,
            this.layout.marketSessions[session]
          )
        }
      }

      /**
       * Links the chart to a method that given a symbol object of form accepted by {@link CIQ.ChartEngine#newChart}, can return a complete market definition object.
       * Once linked, the market factory it will be used by the chart to ensure the market always matches the active instrument.
       * This is only required if your chart will need to know the operating hours for the different exchanges.
       * If using a 24x7 chart, a market factory does not need to be set.
       * @param {function} factory A function that takes a symbolObject and returns a market definition. See {@link CIQ.Market} for instruction on how to create a market definition. See {@link CIQ.Market.Symbology.factory} for working example of a factory function.
       * @memberof CIQ.ChartEngine
       * @since 04-2016-08
       * @example
       * // example of a market factory that returns a different market definition based on the symbol passed in
       * sampleFactory=function(symbolObject){
       *		var symbol=symbolObject.symbol;
       *		// isTypeX(symbol) is a function you would create to identify the market definition object that should be used.
       *		if( isType1(symbol) ) return type1DefinitionObject;
       *		if( isType2(symbol) ) return type2DefinitionObject;
       *		if( isType3(symbol) ) return type3DefinitionObject;
       *		return defaultDefinitionObject;
       * };
       *
       * @example
       * // link a market factory to the chart.
       * stxx.setMarketFactory(sampleFactory);
       */
      CIQ.ChartEngine.prototype.setMarketFactory = function(factory) {
        this.marketFactory = factory
      }

      /**
       * Detaches a series renderer from the chart and deletes its associated y-axis if no longer used by any other renderer.
       *
       * Note: the actual series and related data are not deleted with this command and can be attached or continue to be used with other renderers.
       *
       * Note: the actual renderer (created by using new `CIQ.Renderer.xxxxx`) is not deleted but simply detached from the chart. You can re-attach it again if needed.
       * To delete the renderer use `delete myRenderer`. See example in {@link CIQ.Renderer.Lines}
       *
       * @param  {object} renderer The actual renderer instance to be removed
       * @memberof CIQ.ChartEngine
       * @since 07/01/2015
       */
      CIQ.ChartEngine.prototype.removeSeriesRenderer = function(renderer) {
        for (var r in this.chart.seriesRenderers) {
          if (
            renderer.params.name === this.chart.seriesRenderers[r].params.name
          ) {
            var toDelete = this.chart.seriesRenderers[renderer.params.name]
            var yAxis = toDelete.params.yAxis
            var panel = this.panels[toDelete.params.panel]
            delete this.chart.seriesRenderers[renderer.params.name]
            this.deleteYAxisIfUnused(panel, yAxis)
            return
          }
        }
      }

      /**
       * Retrieves a series renderer from the chart
       * @param  {string} name Handle to access the renderer (params.name)
       * @return {object} the matching series renderer if found
       * @memberof CIQ.ChartEngine
       * @since 07/01/2015
       */
      CIQ.ChartEngine.prototype.getSeriesRenderer = function(name) {
        return this.chart.seriesRenderers[name]
      }

      /**
       * Initializes boundary clipping on the requested panel. Use this when you are drawing on the canvas and wish for the
       * drawing to be contained within the panel. You must call {@link CIQ.ChartEngine#endClip} when your drawing functions are complete.
       * @param  {string} [panelName] The name of the panel. Defaults to the chart itself.
       * @param {boolean} [allowYAxis=false] If true then the clipping region will include the y-axis. By default the clipping region ends at the y-axis.
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.startClip = function(panelName, allowYAxis) {
        if (!panelName) panelName = 'chart'
        var panel = this.panels[panelName]
        var yAxis = panel.yAxis
        this.chart.context.save()
        this.chart.context.beginPath()
        var left = panel.left
        var width = panel.width
        if (allowYAxis) {
          left = 0
          width = this.width
        } else if (panel.yaxisLHS && panel.yaxisLHS.length) {
          left++
          width--
        }
        this.chart.context.rect(left, yAxis.top, width, yAxis.height)
        this.chart.context.clip()
      }

      /**
       * Completes a bounded clipping operation. See {@link CIQ.ChartEngine#startClip}.
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.endClip = function() {
        this.chart.context.restore()
      }

      /**
       * Sets the line style for the main chart.  Works for Lines renderer only.
       * @param  {object} [obj]	Parameter object
       * @param {string} [obj.color] A color on the canvas palette to use for line plot. Alternatively, obj may be set to the color string directly if no other parameters are needed.  This is ignored for a mountain chart.
       * @param {array} [obj.pattern] Pattern to use as alternative to solid line for line plot, in array format, e.g. [1,2,3,2] or string format, e.g. "solid", "dashed", "dotted"
       * @param {number} [obj.width] Width of the line plot
       * @param  {object} [target=this.chart] Optional target to attach line style to.  Supported objects are CIQ.ChartEngine.Chart or CIQ.Studies.StudyDescriptor instances
       * @memberof CIQ.ChartEngine
       * @since 4.0.0
       * @example
       *   stxx.setLineStyle({color:"rgb(127,127,127)",pattern:"dashed",width:3});
       *   stxx.setLineStyle("blue");
       */
      CIQ.ChartEngine.prototype.setLineStyle = function(obj, target) {
        var res = {}
        if (obj && typeof obj == 'object') {
          res = obj
        } else {
          res.color = obj
        }
        if (!res.color && !res.pattern && !res.width) res = null
        if (!target) target = this.chart
        var width = 1
        if (res && res.width) width = res.width
        if (res && res.pattern)
          res.pattern = CIQ.borderPatternToArray(width, res.pattern)
        target.lineStyle = res
      }

      /**
       * Creates a gap filling style object for lines which can be used with any API call requiring a gap object.
       * The gap object, called `gaplines` will be attached to the `target` passed in, or will set the the primary chart's gap style if to target is provided.
       *
       * A gap is an area on a line type rendering ( mountain, baseline, step, etc) where the value for the plotted field is null, undefined, or missing.
       * @param  {object} [obj]	Parameter object
       * @param {string} [obj.color] A color on the canvas palette to use for gap plot. Alternatively, obj may be set to the color string directly if no other parameters are needed.
       * @param {array} [obj.pattern] Pattern to use as alternative to solid line for gap plot, in array format, e.g. [1,2,3,2].
       * @param {number} [obj.width] Line width for gap plot, in pixels
       * @param {boolean} [obj.fillMountain] Set to true to fill the gaps in a mountain chart with the gap color.  Otherwise the mountain chart is filled in with its default color.
       * @param  {object} [target=this.chart] Optional target to attach `gaplines` object to.  If none provided it defaults to CIQ.ChartEngine.Chart.
       * @memberof CIQ.ChartEngine
       * @since 4.0.0
       * @example
       *   // the following will set stxx.chart.gaplines
       *   stxx.setGapLines({color:"transparent",pattern:[1,2],width:3,fillMountain:true});
       *   stxx.setGapLines("blue");
       *
       *   // the following will set objectTarget.gaplines
       *   stxx.setGapLines({color:"transparent",pattern:[1,2],width:3,fillMountain:true,target:objectTarget});
       *
       */
      CIQ.ChartEngine.prototype.setGapLines = function(obj, target) {
        var res = {}
        if (obj && typeof obj == 'object') {
          res = obj
        } else {
          res.color = obj
        }
        if (!res.color && !res.pattern && !res.fillMountain) res = null
        if (!target) target = this.chart
        if (res && res.pattern)
          res.pattern = CIQ.borderPatternToArray(res.pattern)
        if (res && res.width <= 0) res.width = null
        target.gaplines = res
      }

      /**
       * Generates a function used to return the color and pattern of a line chart over a gap area.
       * A gap is an area where the value for the plotted field is null, undefined, or missing.
       *
       * See {@link CIQ.ChartEngine#setGapLines}.
       *
       * @param  {string} [symbol] Symbol of the series
       * @param  {string} [field]	Field to plot, usually Close
       * @param {object} [normal] Normal definition object containing color, pattern and width.  If only color is required, this may be set directly to the color string.
       * @param {string} [normal.color] A color on the canvas palette to use for normal, non-gap plot
       * @param {array} [normal.pattern] Pattern to use as alternative to solid line for normal, non-gap plot, in array format, e.g. [1,2,3,2]
       * @param {number} [normal.width] Line with for normal plot, in pixels
       * @param {object} [gaps] Gaps definition object containing color, pattern and width.  If only color is required, this may be set directly to the color string. If no gaps should be filled, leave out or set to false.
       * @param {string} [gaps.color] A color on the canvas palette to use for gap plot
       * @param {array} [gaps.pattern] Pattern to use as alternative to solid line for gap plot, in array format, e.g. [1,2,3,2]
       * @param {number} [gaps.width] Line with for gap plot, in pixels
       * @param {function} [colorFunction] Optional function to apply to plot to determine colors, for normal, non-gap portion
       * @return {function} A function for generating color and pattern for the entire chart.
       * @memberof CIQ.ChartEngine
       * @private
       * @since 5.1.0 changed signature, added width support
       */
      CIQ.ChartEngine.prototype.getGapColorFunction = function(
        symbol,
        field,
        normal,
        gaps,
        colorFunction
      ) {
        if (typeof normal != 'object') normal = { color: normal }
        return function(stx, quote, isGap) {
          var myColor = colorFunction
            ? colorFunction(stx, quote, isGap)
            : normal.color
          if (myColor.color) myColor = myColor.color // in case the colorFunction returns an object
          var q = quote[symbol]
          if (!q && q !== 0) q = quote[field]
          if (!isGap && (q || q === 0)) {
            return {
              color: myColor,
              pattern: normal.pattern,
              width: normal.width,
            }
          }
          if (!gaps) return null // no color is returned if no gaps are needed.
          if (typeof gaps != 'object') {
            if (typeof gaps == 'string') gaps = { color: gaps }
            else gaps = {}
          }
          return {
            color: gaps.color || myColor,
            pattern: gaps.pattern || normal.pattern,
            width: gaps.width || normal.width,
          }
        }
      }

      /**
	 * Draws a line chart.
	 *
	 * Uses CSS style `stx_line_chart` to control width and color of line charts, unless `params` are set.
	 *
	 * The default color function for the colored line chart uses the following CSS styles:
	 * - `stx_line_up`		- Color of the uptick portion of the line
	 * - `stx_line_down`	- Color of the downtick portion of the line
	 *
	 * @param  {CIQ.ChartEngine.Panel} panel The panel on which to draw the line chart
	 * @param  {string} style	The style selector which contains the styling for the bar (width and color)
	 * @param  {function} [colorFunction]	(optional) A function which accepts an CIQ.ChartEngine and quote as its arguments and returns the appropriate color for drawing that mode.
											Returning a null will skip that bar.  If not passed as an argument, will use a default color.
	 * @param  {object} [params]	(optional) Listing of parameters to use when plotting the line chart.
	 * @param {boolean} [params.skipTransform] If true then any transformations (such as comparison charting) will not be applied
	 * @param {boolean} [params.label] If true then the y-axis will be marked with the value of the right-hand intercept of the line
	 * @param {boolean} [params.noSlopes] If set then chart will draw horizontal bars with no vertical lines.
	 * @param {boolean} [params.step] If set then chart will resemble a step chart.  Horizontal lines will begin at the center of the bar.
	 * @param {number} [params.tension] Tension for splining. Requires "js/thirdparty/splines.js"
	 * @param {boolean} [params.highlight] If set then line will be twice as wide.
	 * @param {string} [params.color] The color for the line. Defaults to CSS style
	 * @param {string} [params.pattern] The pattern for the line ("solid","dashed","dotted"). Defaults to CSS style
	 * @param {number} [params.width] The width in pixels for the line. Defaults to CSS style
	 * @param {object} [params.gaps] Gap object as set by See {@link CIQ.ChartEngine#setGapLines}. If not set `chart.gaplines` will be used.
	 * @param {boolean} [params.labelDecimalPlaces] Optionally specify the number of decimal places to print on the label. If not set then it will match the y-axis.
	 * @return {object} Data generated by the plot, such as colors used if a colorFunction was passed, and the vertices of the line (points).
	 * @memberof CIQ.ChartEngine
	 * @since
	 * <br>&bull; 15-07-01 Changed signature from `chart` to `panel`
	 * <br>&bull; 3.0.0 added params argument
	 */
      CIQ.ChartEngine.prototype.drawLineChart = function(
        panel,
        style,
        colorFunction,
        params
      ) {
        var myColorFunction = colorFunction
        var chart = this.chart,
          context = chart.context,
          lineStyle = chart.lineStyle || {}
        var c = this.canvasStyle(style)
        if (!params) params = {}
        this.startClip(panel.name)
        var width = params.width || lineStyle.width || c.width
        if (width && parseInt(width, 10) <= 25) {
          context.lineWidth = Math.max(1, CIQ.stripPX(width))
        } else {
          context.lineWidth = 1
        }
        params.pattern = params.pattern || lineStyle.pattern || c.borderTopStyle
        params.pattern = CIQ.borderPatternToArray(
          context.lineWidth,
          params.pattern
        )
        this.canvasColor(style)
        var color = params.color || lineStyle.color
        if (color) context.strokeStyle = color
        params.skipProjections = true
        var field = params.field || chart.defaultPlotField // usually the series
        var plotField = params.subField || chart.defaultPlotField || 'Close' // usually the field within the series
        var gaps = params.gaps || chart.gaplines
        if (gaps)
          myColorFunction = this.getGapColorFunction(
            field,
            plotField,
            {
              color: context.strokeStyle,
              pattern: params.pattern,
              width: context.lineWidth,
            },
            gaps,
            colorFunction
          )
        if (panel.chart.tension) params.tension = panel.chart.tension
        var rc = this.plotDataSegmentAsLine(
          field,
          panel,
          params,
          myColorFunction
        )
        if (!rc.colors.length) rc.colors.push(context.strokeStyle)
        context.lineWidth = 1
        this.endClip()

        return params.returnObject ? rc : rc.colors
      }

      /**
       * Finds the previous element before dataSegment[bar] in the dataSet which has data for field
       * @param {CIQ.ChartEngine.Chart} chart An instance of {@link CIQ.ChartEngine.Chart}
       * @param {string} field The field to check for data
       * @param {number} bar The index into the dataSegment
       * @return {object} dataSet element which has data
       * @memberof CIQ.ChartEngine
       * @since 4.0.0
       */
      CIQ.ChartEngine.prototype.getPreviousBar = function(chart, field, bar) {
        return this.getNextBarInternal(chart, field, bar, -1)
      }

      /**
       * Finds the next element after dataSegment[bar] in the dataSet which has data for field
       * @param {CIQ.ChartEngine.Chart} chart An instance of {@link CIQ.ChartEngine.Chart}
       * @param {string} field The field to check for data
       * @param {number} bar The index into the dataSegment
       * @return {object} dataSet element which has data
       * @memberof CIQ.ChartEngine
       * @since 4.0.0
       */
      CIQ.ChartEngine.prototype.getNextBar = function(chart, field, bar) {
        return this.getNextBarInternal(chart, field, bar, 1)
      }

      /**
       * @param {CIQ.ChartEngine.Chart} chart An instance of {@link CIQ.ChartEngine.Chart}
       * @param {string} field The field to check for data
       * @param {number} bar The index into the dataSegment
       * @param {number} direction 1 or -1, for next or previous
       * @return {object} dataSet element which has data
       * @memberof CIQ.ChartEngine
       * @since 4.0.0
       * @private
       */
      CIQ.ChartEngine.prototype.getNextBarInternal = function(
        chart,
        field,
        bar,
        direction
      ) {
        var seg = chart.dataSegment && chart.dataSegment[bar]
        if (seg) {
          var tick = seg.tick
          while (tick > 0 && tick < chart.dataSet.length) {
            tick = tick + direction
            var ds = chart.dataSet[tick]
            if (ds) {
              var tuple = CIQ.existsInObjectChain(ds, field)
              if (tuple && tuple.obj[tuple.member]) return ds
            }
          }
        }
        return null
      }

      /**
       * Redraws the floating price label(s) for the crosshairs tool on the y axis using {@link CIQ.ChartEngine#createYAxisLabel} and sets the width of the y crosshair line to match pannel width.
       *
       * Label style: `stx-float-price` ( for price colors ) and `stx_crosshair_y` ( for cross hair line )
       *
       * @param  {CIQ.ChartEngine.Panel} panel	The panel on which to print the label(s)
       * @memberof CIQ.ChartEngine
       * @example
       * // controls primary default color scheme
       * .stx-float-price { color:#fff; background-color: yellow;}
       */

      CIQ.ChartEngine.prototype.updateFloatHRLabel = function(panel) {
        var arr = panel.yaxisLHS.concat(panel.yaxisRHS)
        var cy = this.crossYActualPos ? this.crossYActualPos : this.cy
        if (this.floatCanvas.isDirty) CIQ.clearCanvas(this.floatCanvas, this)
        if (this.controls.crossX.style.display == 'none') return
        if (this.controls.crossY) {
          var crosshairWidth = panel.width
          if (this.yaxisLabelStyle == 'roundRectArrow') crosshairWidth -= 7
          this.controls.crossY.style.left = panel.left + 'px'
          this.controls.crossY.style.width = crosshairWidth + 'px'
        }
        for (var i = 0; i < arr.length; i++) {
          var yAxis = arr[i]
          var price = this.transformedPriceFromPixel(cy, panel, yAxis)
          if (isNaN(price)) continue
          if ((panel.min || panel.min === 0) && price < panel.min) continue
          if ((panel.max || panel.max === 0) && price > panel.max) continue
          var labelDecimalPlaces = null
          if (yAxis !== panel.chart.yAxis) {
            // If a study panel, this logic allows the cursor to print more decimal places than the yaxis default for panels
            labelDecimalPlaces = 0
            if (yAxis.shadow < 1000) labelDecimalPlaces = 2
            if (yAxis.shadow < 5) labelDecimalPlaces = 4
            if (yAxis.decimalPlaces || yAxis.decimalPlaces === 0)
              labelDecimalPlaces = yAxis.decimalPlaces
          }
          if (yAxis.priceFormatter) {
            price = yAxis.priceFormatter(this, panel, price, labelDecimalPlaces)
          } else {
            price = this.formatYAxisPrice(
              price,
              panel,
              labelDecimalPlaces,
              yAxis
            )
          }

          var style = this.canvasStyle('stx-float-price')
          this.createYAxisLabel(
            panel,
            price,
            cy,
            style.backgroundColor,
            style.color,
            this.floatCanvas.context,
            yAxis
          )
          this.floatCanvas.isDirty = true
        }
      }

      /**
       * <span class="injection">INJECTABLE</span>
       * This method calls {@link CIQ.ChartEngine#updateFloatHRLabel} to draw the label that floats along the Y axis with the
       * current price for the crosshair.
       * It also fills the date in the "stxx.controls.floatDate" (Style: `stx-float-date`) div which floats along the X axis.
       * This is an appropriate place to inject an append method for drawing a head's up display if desired.
       *
       * You can override the {@link CIQ.ChartEngine#hideDates} method to decide if/when you want to hide the floating date.
       *
       * @memberof CIQ.ChartEngine.AdvancedInjectable#
       * @alias headsUpHR
       * @since 09-2016-19 only year and month will be displayed in monthly periodicity
       */
      CIQ.ChartEngine.prototype.headsUpHR = function() {
        if (this.runPrepend('headsUpHR', arguments)) return
        var panel = this.currentPanel
        if (!panel) return
        var chart = panel.chart

        this.updateFloatHRLabel(panel)
        var floatDate = this.controls.floatDate
        function setFloatDate(val) {
          CIQ.efficientDOMUpdate(floatDate, 'innerHTML', val)
        }

        if (floatDate && !CIQ.ChartEngine.hideDates()) {
          var bar = this.barFromPixel(this.cx)
          var prices = chart.xaxis[bar]
          if (prices && prices.DT) {
            setFloatDate(CIQ.displayableDate(this, chart, prices.DT))
          } else if (prices && prices.index) {
            setFloatDate(prices.index)
          } else {
            setFloatDate('') // there is no date to display
          }
        }

        this.runAppend('headsUpHR', arguments)
      }

      // TODO, deprecated
      CIQ.ChartEngine.prototype.setCrosshairColors = function() {}

      /**
       * <span class="injection">INJECTABLE</span>
       * Calculates the magnet point for the current mouse cursor location. This is the nearest OHLC point. A small white
       * circle is drawn on the temporary canvas to indicate this location for the end user. If the user initiates a drawing then
       * the end point of the drawing will be tied to the magnet point. This function is only entered if preferences.magnet is true and
       * a drawing type (CIQ.ChartEngine#currentVectorParameters.vectorType) has been enabled.
       * @memberof CIQ.ChartEngine.AdvancedInjectable#
       * @alias magnetize
       */
      CIQ.ChartEngine.prototype.magnetize = function() {
        this.magnetizedPrice = null
        if (this.runPrepend('magnetize', arguments)) return
        var drawingTool = this.currentVectorParameters.vectorType
        if (
          (drawingTool == 'annotation' || drawingTool == 'callout') &&
          CIQ.ChartEngine.drawingLine
        )
          return // Don't magnetize the end of an annotation
        if (drawingTool == 'projection') return
        if (drawingTool == 'freeform') return
        var panel = this.currentPanel
        if (panel.name == panel.chart.name) {
          // panel is chart type
          var chart = panel.chart
          var tick = this.tickFromPixel(
            CIQ.ChartEngine.crosshairX - this.left,
            chart
          )
          //if(this.layout.interval!="minute") tick/=this.layout.periodicity;
          if (tick > chart.dataSet.length) return // Don't magnetize in the future
          var prices = chart.dataSet[tick]
          if (!prices) return
          var price = this.valueFromPixel(this.cy, panel)
          this.magnetizedPrice = prices.Close
          var highLowBars =
            (this.mainSeriesRenderer && this.mainSeriesRenderer.highLowBars) ||
            this.highLowBars[this.layout.chartType]
          if (highLowBars) {
            var fields = ['Open', 'High', 'Low', 'Close']
            var closest = 1000000000
            for (var i = 0; i < fields.length; i++) {
              var fp = prices[fields[i]]
              if (Math.abs(price - fp) < closest) {
                closest = Math.abs(price - fp)
                this.magnetizedPrice = fp
              }
            }
          }
          var x = this.pixelFromTick(tick, chart)
          var y = this.pixelFromPrice(this.magnetizedPrice, this.currentPanel)
          var ctx = this.chart.tempCanvas.context
          ctx.beginPath()
          ctx.lineWidth = 1
          var radius = Math.max(this.layout.candleWidth, 12) / 3
          // Limit the radius size to 8 to prevent a large arc
          // when zooming in and increasing the candle width.
          ctx.arc(x, y, Math.min(radius, 8), 0, 2 * Math.PI, false)
          ctx.fillStyle = '#FFFFFF'
          ctx.strokeStyle = '#000000'
          ctx.fill()
          ctx.stroke()
          ctx.closePath()
          this.chart.tempCanvas.style.display = 'block'
        }
        this.runAppend('magnetize', arguments)
      }

      /**
       * <span class="injection">INJECTABLE</span>
       * Positions the crosshairs at the last known mouse/finger pointer position. This ensures
       * on touch devices that the crosshairs are at a known position. It is called by the DrawingToolbar.
       * @memberof CIQ.ChartEngine.AdvancedInjectable#
       * @alias positionCrosshairsAtPointer
       */
      CIQ.ChartEngine.prototype.positionCrosshairsAtPointer = function() {
        var currentPanel = this.currentPanel
        if (!currentPanel) return
        if (this.runPrepend('positionCrosshairsAtPointer', arguments)) return
        var chart = currentPanel.chart
        var rect = this.container.getBoundingClientRect()
        this.top = rect.top
        this.left = rect.left
        this.right = this.left + this.width
        this.bottom = this.top + this.height
        this.cy = this.crossYActualPos = this.backOutY(
          CIQ.ChartEngine.crosshairY
        )
        this.cx = this.backOutX(CIQ.ChartEngine.crosshairX)
        var crosshairTick = (this.crosshairTick = this.tickFromPixel(
          this.cx,
          chart
        ))
        var position = this.pixelFromTick(crosshairTick, chart) - 1
        this.controls.crossX.style.left = position + 'px'
        if (position >= currentPanel.right || position <= currentPanel.left) {
          this.undisplayCrosshairs()
          return
        }
        var chField =
          currentPanel.name == 'chart'
            ? this.preferences.horizontalCrosshairField
            : currentPanel.horizontalCrosshairField
        var dataSet = chart.dataSet
        if (
          chField &&
          dataSet &&
          crosshairTick < dataSet.length &&
          crosshairTick > -1
        ) {
          this.crossYActualPos = this.pixelFromPrice(
            dataSet[crosshairTick][chField],
            currentPanel
          )
        }
        this.controls.crossY.style.top = this.crossYActualPos + 'px'
        this.runAppend('positionCrosshairsAtPointer', arguments)
      }
      /**
       * <span class="injection">INJECTABLE</span>
       * This is an internal method that temporarily toggles whether the crosshairs are visible or not based on where the user's mouse pointer is located. When the user moves
       * the mouse out of the chart, or over a modal, then the crosshairs are made invisible. Crosshairs will only be shown of course if crosshair *state* is enabled. Crosshair
       * state is enabled with a call to the public method {@link CIQ.ChartEngine.showCrosshairs}. Crosshair state is also enabled automatically when a drawing tool is active.
       *
       * Do not call this method to change crosshair state (for instance when a user clicks on a crosshair icon).
       * Use {@link CIQ.ChartEngine.showCrosshairs} and {@link CIQ.ChartEngine#hideCrosshairs} for toggling state.
       *
       * This is the counter method to {@link CIQ.ChartEngine.AdvancedInjectable#undisplayCrosshairs} which is called, for instance, when the user mouses out of the chart or mouses
       * over a chart element.
       * @memberof CIQ.ChartEngine.AdvancedInjectable#
       * @alias doDisplayCrosshairs
       * @since 5.0.0 no longer allows the crosshair to be enabled if mouse pointer is outside the chart.
       */
      CIQ.ChartEngine.prototype.doDisplayCrosshairs = function() {
        if (this.runPrepend('doDisplayCrosshairs', arguments)) return
        if (this.displayInitialized) {
          var floatCanvas = this.floatCanvas
          var drawingTool = this.currentVectorParameters.vectorType
          if (!this.layout.crosshair && (drawingTool === '' || !drawingTool)) {
            this.undisplayCrosshairs()
          } else if (
            CIQ.Drawing &&
            CIQ.Drawing[drawingTool] &&
            new CIQ.Drawing[drawingTool]().dragToDraw
          ) {
            this.undisplayCrosshairs()
          } else if (
            this.overXAxis ||
            this.overYAxis ||
            (!CIQ.ChartEngine.insideChart && !this.grabbingScreen)
          ) {
            this.undisplayCrosshairs()
          } else if (this.openDialog !== '') {
            this.undisplayCrosshairs()
          } else {
            var controls = this.controls,
              crossX = controls.crossX,
              crossY = controls.crossY
            if (crossX.style.display !== '') {
              crossX.style.display = ''
              crossY.style.display = ''
              if (this.preferences.magnet && drawingTool) {
                CIQ.unappendClassName(this.container, 'stx-crosshair-on')
                this.chart.tempCanvas.style.display = 'block'
              } else {
                CIQ.appendClassName(this.container, 'stx-crosshair-on')
              }
            }
            if (controls.floatDate && !CIQ.ChartEngine.hideDates()) {
              controls.floatDate.style.visibility = ''
              if (this.currentPanel) this.updateFloatHRLabel(this.currentPanel)
            }
            if (floatCanvas) {
              floatCanvas.style.display = 'block'
            }
          }
        }
        this.runAppend('doDisplayCrosshairs', arguments)
      }

      /**
       * <span class="injection">INJECTABLE</span>
       *
       * This is called for instance when the user mouses out of the chart or over a chart control to temporarily make the crosshairs invisible. See also {@link CIQ.ChartEngine.AdvancedInjectable#doDisplayCrosshairs}.
       *
       * Use {@link CIQ.ChartEngine#hideCrosshairs} to toggle crosshair state (such as when a user presses a crosshair icon)
       *
       * @memberof CIQ.ChartEngine.AdvancedInjectable#
       * @alias undisplayCrosshairs
       */
      CIQ.ChartEngine.prototype.undisplayCrosshairs = function() {
        if (this.runPrepend('undisplayCrosshairs', arguments)) return
        var controls = this.controls,
          crossX = controls.crossX,
          crossY = controls.crossY
        if (crossX) {
          if (crossX.style.display != 'none') {
            crossX.style.display = 'none'
            crossY.style.display = 'none'
          }
        }
        if (this.displayInitialized && controls.floatDate) {
          controls.floatDate.style.visibility = 'hidden'
        }
        CIQ.unappendClassName(this.container, 'stx-crosshair-on')
        var floatCanvas = this.floatCanvas
        if (floatCanvas && floatCanvas.isDirty) {
          CIQ.clearCanvas(floatCanvas, this)
          if (floatCanvas.style.display != 'none')
            floatCanvas.style.display = 'none'
        }
        if (
          !this.activeDrawing &&
          !this.repositioningDrawing &&
          !this.editingAnnotation
        ) {
          var tempCanvas = this.chart.tempCanvas
          if (tempCanvas && tempCanvas.style.display != 'none')
            tempCanvas.style.display = 'none'
        }
        this.runAppend('undisplayCrosshairs', arguments)
      }

      /**
       * Sets the chart into a modal mode. Crosshairs are hidden and the chart will not respond to click or mouse events. Call this
       * for instance if you are enabling a dialog box and don't want errant mouse activity to affect the chart.
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.modalBegin = function() {
        this.openDialog = 'modal'
        this.undisplayCrosshairs()
      }

      /**
       * Ends modal mode. See {@link CIQ.ChartEngine#modalBegin}
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.modalEnd = function() {
        this.cancelTouchSingleClick = true
        this.openDialog = ''
        this.doDisplayCrosshairs()
      }

      /**
       * <span class="injection">INJECTABLE</span>
       * Updates the position of the stxx.controls.floatDate element ( Style: `stx-float-date` ) and calls {@link CIQ.ChartEngine.AdvancedInjectable#headsUpHR} to display the crosshairs labels on both x and y axis.
       * A timer is used to prevent this operation from being called more frequently than once every 100 milliseconds in order to
       * improve performance during scrolling.
       * @memberof CIQ.ChartEngine.AdvancedInjectable#
       * @alias updateChartAccessories
       */
      CIQ.ChartEngine.prototype.updateChartAccessories = function() {
        if (this.accessoryTimer !== null) clearTimeout(this.accessoryTimer)
        if (!CIQ.ChartEngine.drawingLine && CIQ.touchDevice) {
          if (new Date().getTime() - this.lastAccessoryUpdate < 100) {
            this.accessoryTimer = setTimeout(
              (function(stx) {
                return function() {
                  stx.updateChartAccessories()
                }
              })(this),
              10
            )
            return
          }
        }
        if (!this.chart.dataSet) return
        if (this.runPrepend('updateChartAccessories', arguments)) return
        this.positionCrosshairsAtPointer()
        this.accessoryTimer = null
        this.lastAccessoryUpdate = new Date().getTime()
        var floatDate = this.controls.floatDate
        if (floatDate) {
          var panel = this.currentPanel
          if (!panel) panel = this.chart.panel
          if (panel) {
            var chart = panel.chart
            var bottom =
              this.xAxisAsFooter === true
                ? 0
                : this.chart.canvasHeight - panel.chart.bottom
            var l =
              this.pixelFromTick(this.crosshairTick, chart) -
              floatDate.offsetWidth / 2 -
              0.5
            if (l < 0) l = 0
            CIQ.efficientDOMUpdate(floatDate.style, 'left', l + 'px')
            CIQ.efficientDOMUpdate(floatDate.style, 'bottom', bottom + 'px')
          }
        }
        this.headsUpHR()
        this.runAppend('updateChartAccessories', arguments)
      }

      /**
       * <span class="injection">INJECTABLE</span>
       * Handles mouse movement events. This method calls {@link CIQ.ChartEngine#mousemoveinner} which has the core logic
       * for dealing with panning and zooming. See also {@link CIQ.ChartEngine.AdvancedInjectable#touchmove} which is the equivalent method for touch events.
       * @param {Event} mouseEvent A mouse move event
       * @memberof CIQ.ChartEngine.AdvancedInjectable#
       * @alias mousemove
       */
      CIQ.ChartEngine.prototype.mousemove = function(mouseEvent) {
        var e = mouseEvent ? mouseEvent : event
        /* use e.client instead of e.page since we need the value to be relative to the viewport instead of the overall document size.
		if(!e.pageX){
			e.pageX=e.clientX + document.body.scrollLeft + document.documentElement.scrollLeft;
			e.pageY=e.clientY + document.body.scrollTop + document.documentElement.scrollTop;
		}
		*/
        CIQ.ChartEngine.crosshairX = e.clientX // These are used by the UI so make sure they are set even if no chart is set
        CIQ.ChartEngine.crosshairY = e.clientY
        if (this.runPrepend('mousemove', arguments)) return
        if (!this.displayInitialized) return // No chart displayed yet
        if (this.openDialog !== '') return // Don't show crosshairs when dialog is open
        this.mousemoveinner(e.clientX, e.clientY)
        this.runAppend('mousemove', arguments)
      }

      /**
       * Set a timer to check for chart resizing. Normally the chart is resized whenever the screen is resized
       * by capturing a screen resize event. However if charts are embedded in a windowing GUI then they may not
       * receive such events when windows are resized. Ideally, stxx.resizeChart() should be called whenever a window
       * is resized however if this is inconvenient then the resize timer can be enabled to cover all bases without too much effort.
       *
       * On initialization, CIQ.ChartEngine.resizeDetectMS is checked for the default resize checking interval. The default is 1,000 milliseconds.
       * To turn off resize checking simply set CIQ.ChartEngine.resizeDetectMS=0; when you declare your CIQ.ChartEngine object.
       * @param {number} ms Number of milliseconds to poll. Zero to stop checking.
       * @memberof CIQ.ChartEngine
       */

      CIQ.ChartEngine.prototype.setResizeTimer = function(ms) {
        this.resizeDetectMS = ms
        function closure(self) {
          return function() {
            if (!self.chart.canvas) return
            if (!CIQ.isAndroid) {
              if (
                self.chart.canvas.height !=
                  Math.floor(
                    self.devicePixelRatio * self.chart.container.clientHeight
                  ) ||
                self.chart.canvas.width !=
                  Math.floor(
                    self.devicePixelRatio * self.chart.container.clientWidth
                  )
              ) {
                self.resizeChart()
              }
            }
          }
        }
        if (ms) {
          if (this.resizeTimeout) window.clearInterval(this.resizeTimeout)
          this.resizeTimeout = window.setInterval(closure(this), ms)
        } else {
          if (this.resizeTimeout) window.clearInterval(this.resizeTimeout)
          this.resizeTimeout = null
        }
      }

      /**
       * Returns the yaxis that the crosshairs (mouse) is on top of
       * @param  {CIQ.ChartEngine.Panel} panel The panel
       * @param  {number} [x]		The X location. Defaults to CIQ.ChartEngine#cx
       * @return {CIQ.ChartEngine.YAxis}		  The yAxis that the crosshair is over
       * @memberOf  CIQ.ChartEngine
       * @since  15-07-01
       */
      CIQ.ChartEngine.prototype.whichYAxis = function(panel, x) {
        if (typeof x === 'undefined') x = this.cx
        if (panel) {
          var arr = panel.yaxisLHS.concat(panel.yaxisRHS)
          for (var i = 0; i < arr.length; i++) {
            var yAxis = arr[i]
            if (yAxis.left <= x && yAxis.left + yAxis.width >= x) return yAxis
          }
        }
        return this.chart.panel.yAxis
      }

      /**
       * Finds any objects that should be highlighted by the current crosshair position. All drawing objects have their highlight() method
       * called in order that they may draw themselves appropriately.
       * @param  {boolean} isTap If true then it indicates that the user tapped the screen on a touch device, and thus a wider radius is used to determine which objects might have been highlighted.
       * @param {boolean} clearOnly Set to true to clear highlights
       * @memberof CIQ.ChartEngine
       * @since 4.0.0 {@link CIQ.ChartEngine#displaySticky} is now called to display the 'series.symbol' if the 'series.display' is not present
       */
      CIQ.ChartEngine.prototype.findHighlights = function(isTap, clearOnly) {
        var radius = this.preferences.highlightsRadius //10;
        if (isTap) radius = this.preferences.highlightsTapRadius //30;
        var cy = this.cy
        var cx = this.cx
        this.anyHighlighted = false
        if (!this.currentPanel) return
        if (this.preferences.magnet && !this.activeDrawing) {
          CIQ.clearCanvas(this.chart.tempCanvas, this)
        }
        if (this.activeDrawing) clearOnly = true
        var somethingChanged = false
        var drawingToMeasure = null
        var stickyArgs = clearOnly ? null : ['', '', true, null, 'drawing']

        var chart = this.currentPanel.chart
        var box = {
          x0: this.tickFromPixel(cx - radius, chart),
          x1: this.tickFromPixel(cx + radius, chart),
          y0: this.valueFromPixel(cy - radius, this.currentPanel),
          y1: this.valueFromPixel(cy + radius, this.currentPanel),
        }
        if (this.repositioningDrawing && box.x1 - box.x0 < 2) {
          box.x1++
          box.x0--
        } else if (box.x1 == box.x0) {
          box.x0 -= 0.5
          box.x1 += 0.5
        }
        /* begin test code
		// show the box
		this.chart.canvas.context.strokeStyle="red";
		this.chart.canvas.context.strokeRect(this.pixelFromTick(box.x0,chart),cy-radius,this.pixelFromTick(box.x1,chart)-this.pixelFromTick(box.x0,chart),2*radius);
		this.chart.canvas.context.strokeStyle="blue";
		this.chart.canvas.context.strokeRect(cx-radius,cy-radius,2*radius,2*radius);
		  end test code */
        for (var i = this.drawingObjects.length - 1; i >= 0; i--) {
          var drawing = this.drawingObjects[i]
          if (drawing.permanent) continue
          if (!this.panels[drawing.panelName]) continue
          if (this.repositioningDrawing && this.repositioningDrawing != drawing)
            continue

          var prevHighlight = drawing.highlighted
          var highlightMe = drawing.panelName == this.currentPanel.name
          drawing.repositioner = drawing.intersected(
            this.crosshairTick,
            this.crosshairValue,
            box
          )
          highlightMe = highlightMe && drawing.repositioner

          if (!clearOnly && highlightMe) {
            if (prevHighlight) {
              drawingToMeasure = drawing
              if (this.anyHighlighted && this.singleDrawingHighlight)
                drawing.highlighted = false
            } else if (prevHighlight != drawing.highlight(true)) {
              if (!drawingToMeasure) drawingToMeasure = drawing
              if (this.anyHighlighted && this.singleDrawingHighlight)
                drawing.highlighted = false
              somethingChanged = true
            }
            this.anyHighlighted = true
          } else {
            if (prevHighlight != drawing.highlight(false)) {
              somethingChanged = true
            }
          }
        }

        var n, o, series
        for (n in this.overlays) {
          o = this.overlays[n]
          o.prev = o.highlight
          o.highlight = false
        }
        for (n in chart.seriesRenderers) {
          var r = chart.seriesRenderers[n]
          for (var j = 0; j < r.seriesParams.length; j++) {
            series = r.seriesParams[j]
            series.prev = series.highlight
            series.highlight = false
          }
        }

        // Function to detect if a "box" drawn around the cursor position is intersected by the overlay.
        // Up to two overlay segments may be tested:
        // The segment endpointed by the previous dataSet element containing that field and the current dataSet element behind the cursor,
        // and the current dataSet element behind the cursor and the next dataSet element containing that field.
        // In case there are gaps in the data, one of these segments may not exist.
        // This routine is designed to also handle comparison overlays which cause the dataSet to be transformed.
        // The argument "fullField" represents the series symbol and the subField, separated by a period (e.g. GOOG.High).
        // If there is no subField, a subField of Close is presumed.
        function isOverlayIntersecting(refBar, box, fullField, yAxis, cache) {
          var chart = this.chart,
            currentPanel = this.currentPanel
          if (!yAxis) yAxis = chart.yAxis
          var parts = fullField.split('-->')
          var field = parts[0]
          var subField = parts[1]
          if (!subField) subField = 'Close'
          function getVal(quote) {
            if (!quote) return null
            var theVal = quote[field]
            if (theVal && (theVal[subField] || theVal[subField] === 0)) {
              // TODO: allow OHLC range, right now need to hover over imaginary line connecting closes
              theVal = theVal[subField]
            }
            if (!chart.transformFunc || yAxis != chart.yAxis) return theVal
            else if (quote.transform && field in quote.transform) {
              theVal = quote.transform[field]
              if (theVal && (theVal[subField] || theVal[subField] === 0)) {
                // TODO: allow OHLC range, right now need to hover over imaginary line connecting closes
                theVal = theVal[subField]
              }
              return theVal
            }
            return chart.transformFunc(this, chart, theVal)
          }
          var quote = chart.dataSegment[bar],
            quotePrev,
            quoteNext
          var val,
            valPrev,
            valNext,
            tick = null,
            tickPrev = null,
            tickNext = null
          var usedCache = new Array(3)
          if (quote && cache) {
            val = cache[bar]
            tick = quote.tick
            if (val || val === 0) usedCache[0] = 1
            var ci
            for (ci = bar - 1; ci >= 0; ci--) {
              if (cache[ci] || cache[ci] === 0) {
                valPrev = cache[ci]
                tickPrev = tick - (bar - ci)
                usedCache[1] = 1
                break
              }
            }
            for (ci = bar + 1; ci < chart.dataSegment.length; ci++) {
              if (cache[ci] || cache[ci] === 0) {
                valNext = cache[ci]
                tickNext = tick - (bar - ci)
                usedCache[2] = 1
                break
              }
            }
          }
          if (tickPrev === null) {
            quotePrev = this.getPreviousBar.call(this, chart, fullField, bar)
            if (quotePrev) {
              tickPrev = quotePrev.tick
              valPrev = getVal(quotePrev)
            }
          }
          if (tickNext === null) {
            quoteNext = this.getNextBar.call(this, chart, fullField, bar) // Terry, getNextBar is failing when opening debugger. Not sure why.
            if (quoteNext) {
              tickNext = quoteNext.tick
              valNext = getVal(quoteNext)
            }
          }
          if (tickPrev === null && tickNext === null) return false

          if (!cache) {
            val = getVal(quote)
            valPrev = getVal(quotePrev)
            valNext = getVal(quoteNext)
            tick = quote.tick
            if (quotePrev) tickPrev = quotePrev.tick
            if (quoteNext) tickNext = quoteNext.tick
          }

          if (!valPrev && valPrev !== 0) {
            valPrev = 0
            tickPrev = 0
          }
          if (!valNext && valNext !== 0) {
            if (val || val === 0) {
              valNext = val
              usedCache[2] = usedCache[0]
            } else {
              valNext = valPrev
              usedCache[2] = usedCache[1]
            }
            tickNext = chart.dataSet.length - 1
          }
          if (!val && val !== 0) {
            val = valNext
            tick = tickNext
            usedCache[0] = usedCache[2]
            if (valPrev === 0 && tickPrev === 0) {
              valPrev = val
              tickPrev = tick
              usedCache[1] = usedCache[0]
            }
          }

          // The following code will get the pixel value of the price from either the renderer's series cache or the computation.
          // Then it will convert the pixel value back to the price value for the current panel's axis.
          // Using the cache is the only way to go for an overlay.  There is a shortcoming for the overlay though, in that
          // if valPrev or valNext were off the screen, they wouldn't be in the cache and so their y axis value would be inaccurate.
          //if(currentPanel.name==chart.name){  // does it matter what panel the overlay is on?
          var pftv = this.pixelFromTransformedValue.bind(this),
            vfp = this.valueFromPixel.bind(this)
          val = vfp(
            usedCache[0] ? val : pftv(val, currentPanel, yAxis),
            currentPanel
          )
          valPrev = vfp(
            usedCache[1] ? valPrev : pftv(valPrev, currentPanel, yAxis),
            currentPanel
          )
          valNext = vfp(
            usedCache[2] ? valNext : pftv(valNext, currentPanel, yAxis),
            currentPanel
          )
          //}
          if (
            CIQ.boxIntersects(
              box.x0,
              box.y0,
              box.x1,
              box.y1,
              tickPrev,
              valPrev,
              tick,
              val,
              'segment'
            ) ||
            CIQ.boxIntersects(
              box.x0,
              box.y0,
              box.x1,
              box.y1,
              tick,
              val,
              tickNext,
              valNext,
              'segment'
            )
          ) {
            return true
          }
          return false
        }

        if (!clearOnly) {
          var bar = this.barFromPixel(cx)
          if (bar >= 0 && bar < chart.dataSegment.length) {
            var y
            for (n in this.overlays) {
              o = this.overlays[n]
              if (o.panel != this.currentPanel.name) continue

              //custom highlight detection
              if (o.study.isHighlighted === false) continue
              else if (typeof o.study.isHighlighted == 'function') {
                if (o.study.isHighlighted(this, cx, cy)) {
                  o.highlight = true
                  this.anyHighlighted = true
                }
                continue
              }

              var quote = chart.dataSegment[bar]
              if (!quote) continue

              for (var out in o.outputMap) {
                if (
                  isOverlayIntersecting.call(
                    this,
                    bar,
                    box,
                    out,
                    this.panels[o.panel].yAxis
                  )
                ) {
                  o.highlight = true
                  this.anyHighlighted = true
                  break
                }
              }
              if (o.highlight) break // only allow one overlay to be highlighted at a time
            }
            for (n in chart.seriesRenderers) {
              var renderer = chart.seriesRenderers[n]
              var rendererPanel = renderer.params.panel
              if (!renderer.params.highlightable) continue
              if (rendererPanel != this.currentPanel.name) continue
              for (var m = 0; m < renderer.seriesParams.length; m++) {
                series = renderer.seriesParams[m]
                var fullField = series.field
                if (series.symbol && series.subField)
                  fullField += '-->' + series.subField
                var yAxis = renderer.params.yAxis
                if (!yAxis && rendererPanel)
                  yAxis = this.panels[rendererPanel].yAxis
                if (renderer.params.step && bar > 0) {
                  // In a step series we also need to check for intersection with
                  // the vertical bar (the step) that connects two points
                  if (!renderer.caches[series.id]) continue
                  y = renderer.caches[series.id][bar]
                  if (!y && y !== 0) continue
                  var py = renderer.caches[series.id][bar - 1]
                  if (
                    ((py || py === 0) &&
                      (cy + radius >= y && cy - radius <= py)) ||
                    (cy - radius <= y && cy + radius >= py)
                  ) {
                    series.highlight = true
                    this.anyHighlighted = true
                  }
                } else if (
                  isOverlayIntersecting.call(
                    this,
                    bar,
                    box,
                    fullField,
                    yAxis,
                    renderer.caches[series.id]
                  )
                ) {
                  series.highlight = true
                  this.anyHighlighted = true
                }
              }
            }
          }
        }
        for (n in this.overlays) {
          o = this.overlays[n]
          if (o.highlight) {
            this.anyHighlighted = true
            var display = o.inputs.display || o.name
            display = this.translateIf(display)
            stickyArgs = [display, null, null, o.permanent, 'study']
            drawingToMeasure = null
          }
          if (o.prev != o.highlight) somethingChanged = true
        }
        for (n in chart.seriesRenderers) {
          var r2 = chart.seriesRenderers[n]
          if (!r2.params.highlightable) continue //might not be necessary to check this here
          var bColor = r2.params.yAxis ? r2.params.yAxis.textStyle : null
          for (var m2 = 0; m2 < r2.seriesParams.length; m2++) {
            series = r2.seriesParams[m2]
            if (series.highlight) {
              this.anyHighlighted = true
              stickyArgs = [
                series.display ? series.display : series.symbol,
                series.color || bColor,
                false,
                series.permanent,
                'series',
              ]
              drawingToMeasure = null
            }
            if (series.prev != series.highlight) somethingChanged = true
          }
        }

        if (somethingChanged) {
          this.draw()
          this.displaySticky.apply(
            this,
            this.anyHighlighted ? stickyArgs : null
          )
          this.clearMeasure()
          if (drawingToMeasure) drawingToMeasure.measure()
        }

        if (!this.anyHighlighted) {
          this.setMeasure()
        }
      }

      /**
       * Positions a "sticky" (a tooltip element). It is positioned relative to the cursor but so that it is always available and never
       * accidentally tappable on a touch device.
       * @param  {HTMLElement} m The sticky
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.positionSticky = function(m) {
        var top = Math.max(this.cy - m.offsetHeight - 60, 0)
        var right = Math.min(
          this.chart.canvasWidth - (this.cx - 50),
          this.chart.canvasWidth - m.offsetWidth
        )
        m.style.top = top + 'px'
        m.style.right = right + 'px'
      }

      /**
       * Displays the "sticky" (tooltip element). The sticky should be in `CIQ.ChartEngine.controls.mSticky`. To disable stickies, set that element to null. See {@link CIQ.ChartEngine.htmlControls}
       * @param  {string} message			The message to display in the sticky
       * @param  {string} backgroundColor The background color to set the sticky (the foreground color will be picked automatically)
       * @param  {boolean} forceShow If true, will always show the sticky (as opposed to only on hover)
       * @param  {boolean} noDelete If true, will hide the delete instructions/button
       * @param  {string} type		 "study","drawing","series", or whatever is causing the sticky to be displayed.
       * @memberof CIQ.ChartEngine
       */

      CIQ.ChartEngine.prototype.displaySticky = function(
        message,
        backgroundColor,
        forceShow,
        noDelete,
        type
      ) {
        var m = this.controls.mSticky
        if (!m) return
        var mi = $$$('#mStickyInterior', m)
        if (!mi) return
        var overlayTrashCan = $$$('#overlayTrashCan', m)
        var overlayEdit = $$$('.overlayEdit', m)
        var mouseDeleteInstructions = $$$('#mouseDeleteInstructions', m)
        if (!forceShow && !message) {
          mi.innerHTML = ''
          m.style.display = 'none'
          if (CIQ.touchDevice) {
            if (overlayTrashCan) overlayTrashCan.style.display = 'none'
            if (overlayEdit) overlayEdit.style.display = 'none'
          } else if (!CIQ.touchDevice) {
            if (mouseDeleteInstructions)
              mouseDeleteInstructions.style.display = 'none'
          }
        } else {
          if (!message) message = ''
          if (forceShow && !message) {
            mi.style.backgroundColor = ''
            mi.style.color = ''
            mi.style.display = 'none'
          } else if (backgroundColor) {
            mi.style.backgroundColor = backgroundColor
            mi.style.color = CIQ.chooseForegroundColor(backgroundColor)
            mi.style.display = 'inline-block'
          } else {
            mi.style.backgroundColor = ''
            mi.style.color = ''
            mi.style.display = 'inline-block'
          }
          mi.innerHTML = message
          if (type)
            $$$('#mStickyRightClick', m).className = 'rightclick_' + type
          m.style.display = 'inline-block'
          this.positionSticky(m)
          if (
            noDelete ||
            this.bypassRightClick === true ||
            this.bypassRightClick[type]
          ) {
            this.controls.mSticky.style.display = 'none'
          } else if (CIQ.touchDevice) {
            if (overlayTrashCan) overlayTrashCan.style.display = 'inline-block'
            if (overlayEdit) overlayEdit.style.display = 'inline-block'
            if (mouseDeleteInstructions)
              mouseDeleteInstructions.style.display = 'none'
          } else {
            if (mouseDeleteInstructions)
              mouseDeleteInstructions.style.display = 'block'
          }
        }
      }

      /**
	 * <span class="injection">INJECTABLE</span>
	 * Sets the innerHTML value of the `mMeasure` HTML DOM Node to contain a measurement (price differential and bars/line distance), usually when a user hovers over a drawing.
	 * It is also used to display measurement as a drawing is being created or when using the 'Measure' tool.
	 *
	 * It also sets `this.controls.mSticky` with the measurement and displays it on `mSticky` on hover.
	 *
	 * Example: <B>23.83 (-12%) 11 Bars</B>
	 *
	 * It requires the UI to include the following div: ```<div class="currentMeasure"><span id="mMeasure" class="measureUnlit"></span></div>```
	 *
	 * It can be styled via CSS. See example.
	 *
	 * @param {number} price1 Beginning price of the drawing
	 * @param {number} price2 Ending price of the drawing
	 * @param {number} tick1  Beginning tick of the drawing
	 * @param {number} tick2  Ending tick of the drawing
	 * @param {boolean} hover  True to turn on the measurement, false to turn it off
	 * @param {string} name  Optional name of drawing, not used by default but passed into injection
	 * @memberof CIQ.ChartEngine
	 * @since 4.0.0 added name argument
	 * @example
	 * // Measuring tool styling CSS sample
		.currentMeasure {
			text-align: left;
			display: inline-block;
			margin: 4px 0 0 20px;
			height: 20px;
			line-height: 20px;
		}

		#mMeasure {
			display: inline-block;
			margin: 0 0 0 0;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
			width:140px;
		}

		// primary color scheme
		.measureUnlit {color:#666;}
		.measureLit {color:#000;}

		// dark color scheme
		.ciq-night .measureUnlit {color:#cbcccd;}
		.ciq-night .measureLit {color:#fff;}
		@example
		// This is an example of the framework to use for writing a prepend to further manipulate/display the measurements
		CIQ.ChartEngine.prototype.prepend("setMeasure",function(){

			var m=$$("mMeasure");

			if(!m) return; // cant show a measurement if the div is not present.

		 	// add your logic to manage the display of the measurements (price1, price2, tick1, tick2)
		 	//*****************************************
		 	var message = 'blah measurement';
		 	//*****************************************

			if(m.className!="measureLit") m.className="measureLit";
			m.innerHTML=message;

			if(this.activeDrawing) return;		// Don't show measurement Sticky when in the process of drawing

			m=this.controls.mSticky;
			if (m) {
				if(hover){
					m.style.display="inline-block";
					m.children[0].style.display="inline-block";
					if(price1){
						m.children[0].innerHTML=message;
					}
					this.positionSticky(m);
				}else{
					m.style.display="none";
					m.children[0].innerHTML="";
				}
			}

		 //return true; //if you don't want to continue into the regular function
		 //return false; //if you want to run through the standard function once you are done with your custom code.
		});
	 */
      CIQ.ChartEngine.prototype.setMeasure = function(
        price1,
        price2,
        tick1,
        tick2,
        hover
      ) {
        if (this.runPrepend('setMeasure', arguments)) return
        var m = $$('mMeasure')
        var message = ''
        if (!price1) {
          if (m && m.className != 'measureUnlit') m.className = 'measureUnlit'
          if (
            !this.anyHighlighted &&
            this.currentVectorParameters.vectorType === ''
          )
            this.clearMeasure()
        } else {
          var distance =
            Math.round(Math.abs(price1 - price2) * this.chart.roundit) /
            this.chart.roundit
          distance = distance.toFixed(this.chart.yAxis.printDecimalPlaces)
          if (this.internationalizer) {
            message += this.internationalizer.numbers.format(distance)
          } else {
            message += distance
          }
          var pct = (price2 - price1) / price1
          if (Math.abs(pct) > 0.1) {
            pct = Math.round(pct * 100)
          } else if (Math.abs(pct) > 0.01) {
            pct = Math.round(pct * 1000) / 10
          } else {
            pct = Math.round(pct * 10000) / 100
          }
          if (this.internationalizer) {
            pct = this.internationalizer.percent.format(pct / 100)
          } else {
            pct = pct + '%'
          }
          message += ' (' + pct + ')'
          var ticks = Math.abs(tick2 - tick1)
          ticks = Math.round(ticks) + 1
          var barsStr = this.translateIf('Bars')
          message += ' ' + ticks + ' ' + barsStr

          if (m) {
            if (m.className != 'measureLit') m.className = 'measureLit'
            m.innerHTML = message
          }
        }

        if (this.activeDrawing) return // Don't show measurement Sticky when in the process of drawing
        m = this.controls.mSticky
        if (m) {
          if (hover) {
            m.style.display = 'inline-block'
            m.children[0].style.display = 'inline-block'
            if (price1) {
              m.children[0].innerHTML = message
            }
            this.positionSticky(m)
          } else {
            m.style.display = 'none'
            m.children[0].innerHTML = ''
          }
        }
        this.runAppend('setMeasure', arguments)
      }

      /**
       * Clears the innerHTML value of the `mMeasure` HTML DOM Node.
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.clearMeasure = function() {
        var m = $$('mMeasure')
        if (m) {
          if (m.className != 'measureUnlit') m.className = 'measureUnlit'
          m.innerHTML = ''
        }
      }

      /**
       * Returns the X pixel give the location of a bar (dataSegment) on the chart.
       * @param  {number} bar The bar (position on the chart which is also the position in the dataSegment)
       * @param {CIQ.ChartEngine.Chart} [chart] Which chart to use. Defaults to this.chart.
       * @return {number}		The X pixel on the chart
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.pixelFromBar = function(bar, chart) {
        if (!chart) chart = this.chart
        var x = 0,
          segmentImage = this.chart.segmentImage
        if (segmentImage && segmentImage[bar] && segmentImage[bar].leftOffset) {
          x = segmentImage[bar].leftOffset
        } else {
          x = (bar + 0.5) * this.layout.candleWidth
        }
        x = chart.panel.left + Math.floor(x + this.micropixels) - 1
        return x
      }

      /**
       * Returns the position (array index) of the first **dataSegment** element encountered given the X pixel.
       * Do not reference this into dataSegment without checking bounds, because the return value may be negative or greater than the dataSegment array length.
       *
       * See {@link CIQ.ChartEngine#tickFromPixel} if you wish to locate the dataSet position.
       *
       * @param  {number} x An X pixel location on the chart
       * @param {CIQ.ChartEngine.Chart} [chart] Which chart to use. Defaults to this.chart.
       * @return {number}	  The bar that lies on the X pixel (may be negative/before or after the chart)
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.barFromPixel = function(x, chart) {
        if (!chart) chart = this.chart
        var segmentImage = this.chart.segmentImage,
          mp = this.micropixels,
          cw = this.layout.candleWidth
        if (segmentImage) {
          //binary search
          var pixel = x - chart.panel.left - mp,
            mult = 2,
            quote
          var length = segmentImage.length
          var bar = Math.round(length / mult)
          var leftOffset, halfCandleWidth
          var rightofLastTick =
            segmentImage[length - 1].leftOffset +
            segmentImage[length - 1].candleWidth / 2
          if (pixel > rightofLastTick) {
            //beyond the rightmost tick
            return (
              length +
              Math.floor((x - rightofLastTick - chart.panel.left - mp) / cw)
            )
          }
          for (var i = 1; i < length; i++) {
            mult *= 2
            quote = segmentImage[bar]
            if (!quote) break
            leftOffset = quote.leftOffset
            halfCandleWidth = quote.candleWidth / 2
            var left = leftOffset - halfCandleWidth
            var right = leftOffset + halfCandleWidth
            if (bar === 0 || (pixel >= left && pixel < right)) break
            else if (pixel < left) bar -= Math.max(1, Math.round(length / mult))
            else bar += Math.max(1, Math.round(length / mult))
            bar = Math.max(0, Math.min(length - 1, bar))
          }
          if (!segmentImage[bar]) {
            //sucks, we need to iterate through
            for (i = 0; i < length; i++) {
              quote = segmentImage[i]
              if (!quote) continue
              leftOffset = quote.leftOffset
              halfCandleWidth = quote.candleWidth / 2
              if (pixel < leftOffset - halfCandleWidth)
                return Math.max(0, i - 1)
              else if (pixel < leftOffset + halfCandleWidth) return i
              else if (pixel >= leftOffset + halfCandleWidth) return i + 1
            }
          }

          return bar
        }
        return Math.floor((x - chart.panel.left - mp) / cw)
      }

      /**
       * Returns the position (array index) of the first **dataSet** element encountered given the X pixel.
       *
       * See {@link CIQ.ChartEngine#barFromPixel} if you wish to locate the dataSegment position.
       *
       * @param  {number} x	  X pixel location
       * @param  {CIQ.ChartEngine.Chart} [chart] A chart object
       * @return {number}		  The tick (position in the dataSet)
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.tickFromPixel = function(x, chart) {
        if (!chart) chart = this.chart
        var tick = chart.dataSet.length - chart.scroll

        if (chart.segmentImage) {
          tick += this.barFromPixel(x, chart)
        } else {
          tick += Math.floor(
            (x - chart.panel.left - this.micropixels) / this.layout.candleWidth
          )
        }
        return tick
      }

      /**
       * Returns an X pixel for the given tick. The X pixel will be the center of the tick location.
       * Note that the pixel may be off of the visual canvas and that it might overlap the Y axis.
       * @param  {number} tick  The tick (position in the dataSet array)
       * @param  {CIQ.ChartEngine.Chart} [chart] A chart object
       * @return {number}		  The X position in pixels (may be negative or may be greater than dataSet.length)
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.pixelFromTick = function(tick, chart) {
        if (!chart) chart = this.chart
        var dataSegment = chart.dataSegment,
          dataSet = chart.dataSet,
          segmentImage = chart.segmentImage,
          mp = this.micropixels,
          length = dataSegment ? dataSegment.length : 0
        var panel = chart.panel,
          scroll = chart.scroll
        var bar = tick - dataSet.length + scroll,
          quote = length ? dataSegment[bar] : null

        if (segmentImage) quote = segmentImage[bar]
        if (quote && quote.leftOffset) {
          return panel.left + Math.floor(quote.leftOffset + mp) //in here for volume candle
        }
        //in here for other chart types, or volume candle if bar lies outside of the actual quote data
        var rightOffset = 0,
          dsTicks = 0
        quote = length ? dataSegment[length - 1] : null
        if (segmentImage) quote = segmentImage[length - 1]
        if (quote && quote.leftOffset) {
          //volume candle
          if (length < tick - dataSet.length + scroll) {
            //in the "whitespace" area on the right of the chart
            rightOffset = quote.leftOffset - quote.candleWidth / 2
            dsTicks = length
          }
        }
        return (
          rightOffset +
          panel.left +
          Math.floor(
            (tick - dsTicks - dataSet.length + scroll + 0.5) *
              this.layout.candleWidth +
              mp
          )
        )
      }

      /**
       * Returns the X pixel position for a given date. Warning: this can be an expensive operation if the date is not in the dataSet.
       * @param  {string} date  String form date
       * @param  {CIQ.ChartEngine.Chart} chart The chart to look in
       * @return {number}		  The pixel location for the date
       * @todo  Use Date object instead of string form date
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.pixelFromDate = function(date, chart) {
        return this.pixelFromTick(this.tickFromDate(date, chart), chart)
      }

      /**
       * A version of {@link CIQ.ChartEngine#priceFromPixel} that will return the y-axis value given a Y pixel
       * @param  {number} y	  The Y pixel location
       * @param  {CIQ.ChartEngine.Panel} [panel] The panel (defaults to the chart)
       * @param {CIQ.ChartEngine.YAxis} [yAxis] The yAxis to use
       * @return {number}		  The Y axis value
       * @memberof CIQ.ChartEngine
       * @since 4.0.0
       */
      CIQ.ChartEngine.prototype.transformedPriceFromPixel = function(
        y,
        panel,
        yAxis
      ) {
        if (!panel) panel = this.chart.panel
        var yax = yAxis ? yAxis : panel.yAxis
        y = yax.bottom - y
        if (!yax.multiplier) return null
        var price = yax.low + y / yax.multiplier
        /*var roundit=chart.roundit;
		if(panel.roundit) roundit=panel.roundit;
		price=Math.round(price*roundit)/roundit;*/
        if (yax.semiLog) {
          var logPrice = yax.logLow + (y * yax.logShadow) / yax.height
          price = Math.pow(10, logPrice)
        }

        return price
      }

      /**
       * Returns the actual value of the chart given a pixel regardless of any transformation such as a comparison chart.
       * @param  {number} y	  The Y pixel location
       * @param  {CIQ.ChartEngine.Panel} [panel] The panel to look. Defaults to the chart itself if not passed in.
       * @param {CIQ.ChartEngine.YAxis} [yAxis] The yAxis to use. Defaults to panel.yAxis.
       * @return {number}		  The Y location. This may be off of the visible canvas.
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.priceFromPixel = function(y, panel, yAxis) {
        if (!panel) panel = this.chart.panel
        var price = this.transformedPriceFromPixel(y, panel, yAxis)
        if (this.charts[panel.name] && panel.chart.untransformFunc)
          price = panel.chart.untransformFunc(this, panel.chart, price, yAxis)
        return price
      }

      /**
       * Returns the value (price) given a Y-axis pixel. The value is relative to the panel or the canvas.
       * @param  {number} y	  The y pixel position
       * @param  {CIQ.ChartEngine.Panel} [panel] A panel object. If passed then the value will be relative to that panel. If not passed then the value will be relative to the panel that is in the actual Y location.
       * @param  {CIQ.ChartEngine.YAxis} [yAxis] Which yAxis. Defaults to panel.yAxis.
       * @return {number}		  The value relative to the panel
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.valueFromPixel = function(y, panel, yAxis) {
        if (!panel) panel = this.whichPanel(y)
        if (!panel) {
          // If we're not in a current panel then we're off the screen, so choose the top or bottom panel
          // Ideally we never get in here because panel is passed in by the developer!
          if (y <= 0) {
            panel = this.panels[CIQ.first(this.panels)]
          } else {
            panel = this.panels[CIQ.last(this.panels)]
          }
        }
        return this.priceFromPixel(y, panel, yAxis)
      }

      /**
       * A version of {@link CIQ.ChartEngine#valueFromPixel} that will untransform a transformation such as a comparison chart.
       * @param  {number} y	  The y pixel location
       * @param  {CIQ.ChartEngine.Panel} panel A panel object. It is strongly recommended to pass the panel! (see {@link CIQ.ChartEngine#valueFromPixel})
       * @param {CIQ.ChartEngine.YAxis} [yAxis] The yaxis to use. Defaults to panel.yAxis.
       * @return {number}		  The price or value
       * @memberof CIQ.ChartEngine
       * @deprecated Use {@link CIQ.ChartEngine#valueFromPixel} instead
       */
      CIQ.ChartEngine.prototype.valueFromPixelUntransform = function(
        y,
        panel,
        yAxis
      ) {
        return this.valueFromPixel(y, panel, yAxis)
      }

      /**
       * A version of {@link CIQ.ChartEngine#pixelFromPrice} that will apply a transformation such as a comparison chart.
       * @param  {number} price	  The price or value
       * @param  {CIQ.ChartEngine.Panel} panel A panel object (see {@link CIQ.ChartEngine#pixelFromPrice})
       * @param {CIQ.ChartEngine.YAxis} [yAxis] The yaxis to use
       * @return {number}		  The y axis pixel location
       * @memberof CIQ.ChartEngine
       * @deprecated Use {@link CIQ.ChartEngine#pixelFromPrice} instead
       */
      CIQ.ChartEngine.prototype.pixelFromPriceTransform = function(
        price,
        panel,
        yAxis
      ) {
        return this.pixelFromPrice(price, panel, yAxis)
      }

      /**
       * A version of {@link CIQ.ChartEngine#pixelFromPrice} that will return the Y pixel from a given price (or value)
       * @param  {number} price The price
       * @param  {CIQ.ChartEngine.Panel} [panel] The panel (defaults to the chart)
       * @param {CIQ.ChartEngine.YAxis} [yAxis] The yAxis to use
       * @return {number}		  The Y pixel value
       * @memberof CIQ.ChartEngine
       * @since 4.0.0
       */
      CIQ.ChartEngine.prototype.pixelFromTransformedValue = function(
        price,
        panel,
        yAxis
      ) {
        if (!panel) panel = this.chart.panel
        var yax = yAxis ? yAxis : panel.yAxis
        var y = (yax.high - price) * yax.multiplier
        if (yax.semiLog) {
          var p = Math.max(price, 0)
          var logPrice = Math.log(p) / Math.LN10
          //if(price<=0) logPrice=0;
          var height = yax.height
          y = height - (height * (logPrice - yax.logLow)) / yax.logShadow
        }

        y += yax.top
        return y
      }

      /**
       * Returns the Y pixel from a transformation such as a comparison chart or from the actual value otherwise.
       * @param  {number} price	  The price or value
       * @param  {CIQ.ChartEngine.Panel} panel A panel object (see {@link CIQ.ChartEngine#pixelFromPrice})
       * @param {CIQ.ChartEngine.YAxis} [yAxis] The yaxis to use
       * @return {number}		  The y axis pixel location
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.pixelFromPrice = function(price, panel, yAxis) {
        if (!panel) panel = this.chart.panel
        if (this.charts[panel.name] && panel.chart.transformFunc)
          price = panel.chart.transformFunc(this, panel.chart, price, yAxis) // transform should move to panel
        return this.pixelFromTransformedValue(price, panel, yAxis)
      }

      /**
       * Returns the Y pixel location for the (split) unadjusted price rather than the displayed price.
       * This is important for drawing tools or any other device that requires the actual underlying price.
       *
       * @param  {CIQ.ChartEngine.Panel} panel The panel to get the value from
       * @param  {number} tick  The tick location (in the dataSet) to check for an adjusted value
       * @param  {number} value The value
       * @param {CIQ.ChartEngine.YAxis} [yAxis] The yaxis to use
       * @return {number}		  The pixel location
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.pixelFromValueAdjusted = function(
        panel,
        tick,
        value,
        yAxis
      ) {
        // If we're not showing unadjusted quotes, or if the panel isn't a chart then bypass
        if (this.layout.adj || !this.charts[panel.name])
          return this.pixelFromPrice(value, panel, yAxis)
        var a = Math.round(tick) // Not sure why we're rounding this. Possible legacy code.
        // Adjust if there's a ratio attached to the tick
        var ratio
        if (
          a > 0 &&
          a < panel.chart.dataSet.length &&
          (ratio = panel.chart.dataSet[a].ratio)
        ) {
          return this.pixelFromPrice(value * ratio, panel, yAxis)
        }
        // Otherwise pass through
        return this.pixelFromPrice(value, panel, yAxis)
      }

      /**
       * Returns the unadjusted value for a given value, if an adjustment (split) had been applied. This can return a value
       * relative to the original closing price.
       * @param  {CIQ.ChartEngine.Panel} panel The panel to check
       * @param  {number} tick  The location in the dataset
       * @param  {number} value The value to adjust
       * @return {number}		  The adjusted value
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.adjustIfNecessary = function(
        panel,
        tick,
        value
      ) {
        if (this.layout.adj) return value // Already adjusted prices
        if (!panel || !this.charts[panel.name]) return value
        var a = Math.round(tick)
        var ratio
        if (
          a > 0 &&
          a < panel.chart.dataSet.length &&
          (ratio = panel.chart.dataSet[a].ratio)
        ) {
          return value / ratio
        }
        return value
      }

      /**
       * Sets a transformation and untransformation function. Transforms can be used to transform the Y-Axis from absolute
       * to relative values. For instance, comparison charts use a transform that adjusts from price to percentage.
       * After this is called, chart.transformFunc and chart.untransformFunc will be set to those functions.
       * @param {CIQ.ChartEngine.Chart} chart			   The chart to transform
       * @param {function} transformFunction	 A transformation callback function which takes a number and returns the transformation of that number
       * @param {function} untransformFunction An untransformation callback function
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.setTransform = function(
        chart,
        transformFunction,
        untransformFunction
      ) {
        chart.transformFunc = transformFunction
        chart.untransformFunc = untransformFunction
      }

      /**
       * Removes a transformation/untransformation pair
       * @param  {CIQ.ChartEngine.Chart} chart The chart to remove transformations from
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.unsetTransform = function(chart) {
        delete chart.transformFunc
        delete chart.untransformFunc
        for (var i = 0; i < chart.dataSet.length; i++) {
          chart.dataSet[i].transform = null
        }
      }

      /**
       * <span class="injection">INJECTABLE</span>
       * Stops (aborts) the current drawing. See {@link CIQ.ChartEngine#undoLast} for an actual "undo" operation.
       * @memberof CIQ.ChartEngine.AdvancedInjectable#
       * @alias undo
       */
      CIQ.ChartEngine.prototype.undo = function() {
        if (this.runPrepend('undo', arguments)) return
        if (this.activeDrawing) {
          this.activeDrawing.abort()
          this.activateDrawing(null)
          CIQ.clearCanvas(this.chart.tempCanvas, this)
          this.draw()
          CIQ.swapClassName(
            this.controls.crossX,
            'stx_crosshair',
            'stx_crosshair_drawing'
          )
          CIQ.swapClassName(
            this.controls.crossY,
            'stx_crosshair',
            'stx_crosshair_drawing'
          )
          CIQ.ChartEngine.drawingLine = false
        }
        this.runAppend('undo', arguments)
      }

      /**
       * Creates an undo stamp for the chart's current drawing state and triggers a call to the {@link undoStampEventListener}.
       *
       * Every time a drawing is added or removed the {@link CIQ.ChartEngine#undoStamps} object is updated with a new entry containing the resulting set of drawings.
       * Using the corresponding {@link CIQ.ChartEngine#undoLast} method, you can revert back to the last state, one at a time.
       * You can also use the {@link undoStampEventListener} to create your own tracker to undo or redo drawings.
       * @memberof CIQ.ChartEngine
       * @param {array} before The chart's array of drawingObjects before being modified
       * @param {array} after The chart's array of drawingObjects after being modified
       */
      CIQ.ChartEngine.prototype.undoStamp = function(before, after) {
        this.undoStamps.push(before)
        this.dispatch('undoStamp', {
          before: before,
          after: after,
          stx: this,
        })
      }

      /**
       * Revers back to the previous drawing state change.
       * **Note: by design this method only manages drawings manually added during the current session and will not remove drawings restored from
       * a previous session. ** If you wish to remove all drawings use {@link CIQ.ChartEngine#clearDrawings}.
       *
       * You can also view and interact with all drawings by traversing through the {@link CIQ.ChartEngine#drawingObjects} array which includes **all** drawings displayed
       * on the chart, regardless of session. Removing a drawing from this list, will remove the drawing from the chart after a draw() operation is executed.
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.undoLast = function() {
        if (this.activeDrawing) {
          this.undo()
        } else {
          if (this.undoStamps.length) {
            this.drawingObjects = this.undoStamps.pop()
            this.changeOccurred('vector')
            this.draw()
          }
        }
      }

      /**
       * Programatically add a drawing
       * @param {object} drawing The drawing definition
       * @todo  Document drawing JSON format
       * @memberof CIQ.ChartEngine
       * @private
       */
      CIQ.ChartEngine.prototype.addDrawing = function(drawing) {
        var drawings = CIQ.shallowClone(this.drawingObjects)
        this.drawingObjects.push(drawing)
        this.undoStamp(drawings, CIQ.shallowClone(this.drawingObjects))
      }

      /**
       * Draws a series of connected lines on the canvas. The points are in a straight array for compactness. This is used
       * for instance in the freeform (doodle) drawing tool
       * @param  {array} points		  A series of points in the pattern x0,y0,x1,y1
       * @param  {string} color		   Either a color or a Styles object as returned from {@link CIQ.ChartEngine#canvasStyle}
       * @param  {string} type		   The type of line to draw ("segment","ray" or "line")
       * @param  {external:CanvasRenderingContext2D} [context]		The canvas context. Defaults to the standard context.
       * @param  {object} [confineToPanel] Panel the line should be drawn in, and not cross through. Or set to 'true' to confine to the main chart panel.
       * @param  {object} [parameters]	 Additional parameters to describe the line
       * @param {string} [parameters.pattern] The pattern for the line ("solid","dashed","dotted")
       * @param {number} [parameters.width] The width in pixels for the line
       * @param {number} [parameters.opacity] Optional opacity for the line
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.connectTheDots = function(
        points,
        color,
        type,
        context,
        confineToPanel,
        parameters
      ) {
        if (!parameters) parameters = {}
        if (parameters.pattern == 'none') return
        if (confineToPanel === true) confineToPanel = this.chart.panel
        if (context === null || typeof context == 'undefined')
          context = this.chart.context
        if (points.length < 4) return

        var edgeTop = 0
        var edgeBottom = this.chart.canvasHeight
        var edgeLeft = 0
        var edgeRight = this.chart.width

        if (confineToPanel) {
          edgeBottom = confineToPanel.yAxis.bottom
          edgeTop = confineToPanel.yAxis.top
        }

        context.lineWidth = 1.1 // Use 1.1 instead of 1 to get good anti-aliasing on Android Chrome
        if (typeof color == 'object') {
          context.strokeStyle = color.color
          if (color.opacity) context.globalAlpha = color.opacity
          else context.globalAlpha = 1
          context.lineWidth = parseInt(CIQ.stripPX(color.width), 10)
        } else {
          if (!color || color == 'auto' || CIQ.isTransparent(color)) {
            context.strokeStyle = this.defaultColor
          } else {
            context.strokeStyle = color
          }
        }
        if (parameters.opacity) context.globalAlpha = parameters.opacity
        if (parameters.lineWidth) context.lineWidth = parameters.lineWidth
        var pattern = CIQ.borderPatternToArray(
          context.lineWidth,
          parameters.pattern
        )
        context.beginPath()

        for (var i = 0; i < points.length - 2; i += 2) {
          var x0 = points[i]
          var y0 = points[i + 1]
          var x1 = points[i + 2]
          var y1 = points[i + 3]
          if (isNaN(x0) || isNaN(x1) || isNaN(y0) || isNaN(y1)) return

          var t0 = 0.0,
            t1 = 1.0
          var xdelta = x1 - x0
          var ydelta = y1 - y0
          var p, q, r

          for (var edge = 0; edge < 4; edge++) {
            if (edge === 0) {
              p = -xdelta
              q = -(edgeLeft - x0)
            }
            if (edge == 1) {
              p = xdelta
              q = edgeRight - x0
            }
            if (edge == 2) {
              p = -ydelta
              q = -(edgeTop - y0)
            }
            if (edge == 3) {
              p = ydelta
              q = edgeBottom - y0
            }
            r = q / p

            if ((y1 || y1 === 0) && p === 0 && q < 0) {
              return false // Don't draw line at all. (parallel horizontal line outside)
            }

            if (p < 0) {
              if (r > t1) return false
              // Don't draw line at all.
              else if (r > t0) t0 = r // Line is clipped!
            } else if (p > 0) {
              if (r < t0) return false
              // Don't draw line at all.
              else if (r < t1) t1 = r // Line is clipped!
            }
          }

          var x0clip = x0 + t0 * xdelta
          var y0clip = y0 + t0 * ydelta
          var x1clip = x0 + t1 * xdelta
          var y1clip = y0 + t1 * ydelta

          try {
            if (pattern && pattern.length) {
              context.dashedLineTo(x0clip, y0clip, x1clip, y1clip, pattern)
            } else {
              context.moveTo(x0clip, y0clip)
              context.lineTo(x1clip, y1clip)
            }
          } catch (e) {
            //alert(x0clip + ":" + y0clip + " " + x1clip + ":" + y1clip);
          }
        }
        context.stroke()
        context.closePath()
        context.globalAlpha = 1
        context.lineWidth = 1
      }

      // confineToPanel is not used because currently we are splining after the drawing is complete.
      // should that change we will need to implement it

      /**
       * Draws a series of points and splines (smooths the curve) those points.
       *
       * This is uses for drawings, not series.
       * @param  {array} points		  A series of points in the pattern x0,y0,x1,y1
       * @param {number} tension Spline tension (0-1). Set to negative to not spline. Requires "js/thirdparty/splines.js"
       * @param  {string} color		   Either a color or a Styles object as returned from {@link CIQ.ChartEngine#canvasStyle}
       * @param  {string} type		   The type of line to draw ("segment","ray" or "line")
       * @param  {external:CanvasRenderingContext2D} [context]		The canvas context. Defaults to the standard context.
       * @param  {string} [confineToPanel] Not currently implemented
       * @param  {object} [parameters]	 Additional parameters to describe the line
       * @param {string} [parameters.pattern] The pattern for the line ("solid","dashed","dotted")
       * @param {number} [parameters.width] The width in pixels for the line
       * @param {number} [parameters.opacity] Optional opacity for the line
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.plotSpline = function(
        points,
        tension,
        color,
        type,
        context,
        confineToPanel,
        parameters
      ) {
        if (!parameters) parameters = {}
        if (parameters.pattern == 'none') return
        if (confineToPanel === true) confineToPanel = this.chart.panel
        if (context === null || typeof context == 'undefined')
          context = this.chart.context

        context.save()

        context.lineWidth = 1.1 // Use 1.1 instead of 1 to get good anti-aliasing on Android Chrome
        if (typeof color == 'object') {
          context.strokeStyle = color.color
          if (color.opacity) context.globalAlpha = color.opacity
          else context.globalAlpha = 1
          context.lineWidth = parseInt(CIQ.stripPX(color.width), 10)
        } else {
          if (!color || color == 'auto' || CIQ.isTransparent(color)) {
            context.strokeStyle = this.defaultColor
          } else {
            context.strokeStyle = color
          }
        }
        if (parameters.opacity) context.globalAlpha = parameters.opacity
        if (parameters.lineWidth) context.lineWidth = parameters.lineWidth
        var pattern = CIQ.borderPatternToArray(
          context.lineWidth,
          parameters.pattern
        )
        if (parameters.pattern && context.setLineDash) {
          context.setLineDash(pattern)
          context.lineDashOffset = 0 //start point in array
        }

        //stxThirdParty
        context.beginPath()
        splinePlotter.plotSpline(points, tension, context)
        context.stroke()
        context.closePath()

        context.restore()
      }

      /**
       * Repositions a drawing onto the temporary canvas. Called when a user moves a drawing.
       * @param  {CIQ.Drawing} drawing The drawing to reposition
       * @param  {boolean} activating True when first activating "reposition", so the drawing simply gets re-rendered in the same spot but on the tempCanvas.
       * (Otherwise it would jump immediately to the location of the next click/touch).
       * @since  3.0.0
       * @since 5.0.0 Added activating parameter
       * @private
       */
      CIQ.ChartEngine.prototype.repositionDrawing = function(
        drawing,
        activating
      ) {
        var panel = this.panels[drawing.panelName]
        var value = this.adjustIfNecessary(
          panel,
          this.crosshairTick,
          this.valueFromPixel(this.backOutY(CIQ.ChartEngine.crosshairY), panel)
        )
        if (
          this.preferences.magnet &&
          this.magnetizedPrice &&
          panel.name == panel.chart.name
        ) {
          value = this.adjustIfNecessary(
            panel,
            this.crosshairTick,
            this.magnetizedPrice
          )
        }
        var tempCanvas = this.chart.tempCanvas
        CIQ.clearCanvas(tempCanvas, this)
        if (activating) {
          drawing.render(tempCanvas.context)
        } else {
          drawing.reposition(
            tempCanvas.context,
            drawing.repositioner,
            this.crosshairTick,
            value
          )
        }
        if (drawing.measure) drawing.measure()
      }

      /**
       * Activates or deactivates repositioning on a drawings.
       * @param  {CIQ.Drawing} drawing The drawing to activate. null to deactivate the current drawing.
       * @memberOf  CIQ.ChartEngine
       * @since  3.0.0
       */
      CIQ.ChartEngine.prototype.activateRepositioning = function(drawing) {
        var repositioningDrawing = (this.repositioningDrawing = drawing)
        if (drawing) {
          // Take the drawing off the main canvas and put it on the tempCanvas
          this.draw()
          this.repositionDrawing(drawing, true)
        }
        this.chart.tempCanvas.style.display = drawing ? 'block' : 'none'
      }

      /**
       * Activate a drawing. The user can then finish the drawing.
       *
       * Note: Some drawings labeled "chartOnly" can only be activated on the chart panel.
       * @param {string} drawingTool The tool to activate. Send null to deactivate.
       * @param {CIQ.ChartEngine.Panel} [panel] The panel where to activate the tool. Defaults to the chart panel.
       * @return {boolean} Returns true if the drawing was successfully activated. Returns false if unactivated or unsuccessful.
       * @memberof CIQ.ChartEngine
       * @since  3.0.0
       */
      CIQ.ChartEngine.prototype.activateDrawing = function(drawingTool, panel) {
        if (!drawingTool) {
          this.activeDrawing = null
          this.chart.tempCanvas.style.display = 'none'
          return false
        }
        if (!panel) panel = this.chart.panel
        var Factory = CIQ.ChartEngine.drawingTools[drawingTool]
        if (!Factory) {
          if (CIQ.Drawing[drawingTool]) {
            Factory = CIQ.Drawing[drawingTool]
            CIQ.ChartEngine.registerDrawingTool(drawingTool, Factory)
          }
        }
        if (Factory) {
          this.activeDrawing = new Factory()
          this.activeDrawing.construct(this, panel)
          if (!this.charts[panel.name]) {
            if (this.activeDrawing.chartsOnly) {
              this.activeDrawing = null
              return false
            }
          }
        }
        this.chart.tempCanvas.style.display = 'block'
        return true
      }

      /**
       * This is called to send a potential click event to an active drawing, if one is active.
       * @param  {CIQ.ChartEngine.Panel} panel The panel in which the click occurred
       * @param  {number} x	  The X pixel location of the click
       * @param  {number} y	  The y pixel location of the click
       * @return {boolean}	  Returns true if a drawing is active and received the click
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.drawingClick = function(panel, x, y) {
        if (!CIQ.Drawing) return
        if (!panel) return // can be true if panel was closed in the middle of a drawing
        if (this.openDialog !== '') return // don't register a drawing click if in modal mode
        if (!this.activeDrawing) {
          if (
            !this.activateDrawing(
              this.currentVectorParameters.vectorType,
              panel
            )
          )
            return
        }
        if (this.activeDrawing) {
          if (this.userPointerDown && !this.activeDrawing.dragToDraw) {
            if (!CIQ.ChartEngine.drawingLine) this.activateDrawing(null)
            return
          }

          var tick = this.tickFromPixel(x, panel.chart)
          var dpanel = this.panels[this.activeDrawing.panelName]
          var value = this.adjustIfNecessary(
            dpanel,
            tick,
            this.valueFromPixel(y, dpanel)
          )
          if (this.preferences.magnet && this.magnetizedPrice) {
            value = this.adjustIfNecessary(dpanel, tick, this.magnetizedPrice)
          }
          if (
            this.activeDrawing.click(this.chart.tempCanvas.context, tick, value)
          ) {
            if (this.activeDrawing) {
              // Just in case the drawing aborted itself, such as measure
              CIQ.ChartEngine.drawingLine = false
              CIQ.clearCanvas(this.chart.tempCanvas, this)
              this.addDrawing(this.activeDrawing) // Save drawing
              this.activateDrawing(null)
              this.adjustDrawings() //moved from individual drawing.click function to here --gus
              this.draw()
              this.changeOccurred('vector')
              CIQ.swapClassName(
                this.controls.crossX,
                'stx_crosshair',
                'stx_crosshair_drawing'
              )
              CIQ.swapClassName(
                this.controls.crossY,
                'stx_crosshair',
                'stx_crosshair_drawing'
              )
            }
          } else {
            this.changeOccurred('drawing')
            CIQ.ChartEngine.drawingLine = true
            CIQ.swapClassName(
              this.controls.crossX,
              'stx_crosshair_drawing',
              'stx_crosshair'
            )
            CIQ.swapClassName(
              this.controls.crossY,
              'stx_crosshair_drawing',
              'stx_crosshair'
            )
          }
          return true
        }
        return false
      }

      /**
       * Returns the panel for the given Y pixel. Used for instance to determine which panel the crosshairs are in.
       * @param  {number} y Y pixel location
       * @return {CIQ.ChartEngine.Panel}	  The panel containing the Y location. Null if the Y location is outside of all panels.
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.whichPanel = function(y) {
        for (var p in this.panels) {
          var panel = this.panels[p]
          if (panel.hidden) continue
          if (y > panel.top && y < panel.bottom) return panel
        }
        return null
      }

      /**
       * <span class="injection">INJECTABLE</span>
       * Called whenever the user lifts the mousebutton up. This may send a click to a drawing, or cease a drag operation.
       * @param  {Event} e A mouse event
       * @memberof CIQ.ChartEngine.AdvancedInjectable#
       * @alias mouseup
       */
      CIQ.ChartEngine.prototype.mouseup = function(e) {
        if (this.runPrepend('mouseup', arguments)) return
        this.swipe.end = true
        this.cancelLongHold = true
        if (this.repositioningDrawing) {
          // if we single click with a drawing tool enabled, then start another drawing instead of moving current one
          if (
            !this.currentVectorParameters.vectorType ||
            Date.now() - this.mouseTimer > 250
          ) {
            this.changeOccurred('vector')
            CIQ.clearCanvas(this.chart.tempCanvas, this)
            this.activateRepositioning(null)
            this.adjustDrawings() // added missing adjusts when repositioning a Drawing  --gus
            this.draw()
            return
          }
          this.activateRepositioning(null)
        }
        if (this.repositioningBaseline) {
          this.repositioningBaseline = null
          var mainSeriesRenderer = this.mainSeriesRenderer || {}
          if (
            mainSeriesRenderer.params &&
            mainSeriesRenderer.params.baseline &&
            mainSeriesRenderer.params.type != 'mountain'
          ) {
            //this is so the baseline does not pop back to the center
            this.chart.panel.yAxis.scroll =
              this.pixelFromPrice(
                this.chart.baseline.userLevel,
                this.chart.panel
              ) -
              (this.chart.panel.yAxis.top + this.chart.panel.yAxis.bottom) / 2
          }
          this.draw()
          return
        }
        var wasMouseDown = this.userPointerDown
        this.userPointerDown = false
        if (!this.displayInitialized) return // No chart displayed yet
        this.grabbingScreen = false
        if (this.openDialog !== '') {
          if (CIQ.ChartEngine.insideChart)
            CIQ.unappendClassName(this.container, 'stx-drag-chart') //in case they were grabbing the screen and let go on top of the button.
          return
        }
        if (this.grabOverrideClick) {
          this.swipeRelease()
          CIQ.unappendClassName(this.container, 'stx-drag-chart')
          this.grabOverrideClick = false
          this.doDisplayCrosshairs()
          this.updateChartAccessories()
          return
        }
        //if(!this.displayCrosshairs) return;
        if (CIQ.ChartEngine.insideChart)
          CIQ.unappendClassName(this.container, 'stx-drag-chart')
        if (CIQ.ChartEngine.resizingPanel) {
          this.releaseHandle({})
          //CIQ.clearCanvas(this.chart.tempCanvas, this);
          //this.resizePanels();
          //CIQ.ChartEngine.resizingPanel=null;
          return
        }
        if (!e) e = event //IE8
        if (
          (e.which && e.which >= 2) ||
          (e.button && e.button >= 2) ||
          e.ctrlKey
        ) {
          if (this.anyHighlighted && this.bypassRightClick !== true) {
            this.rightClickHighlighted()
            if (e.preventDefault && this.captureTouchEvents) e.preventDefault()
            e.stopPropagation()
            return false
          }
          this.dispatch('rightClick', {
            stx: this,
            panel: this.currentPanel,
            x: cx,
            y: cy,
          })
          return true
        }
        if (e.clientX < this.left || e.clientX > this.right) return
        if (e.clientY < this.top || e.clientY > this.bottom) return

        var cy = this.backOutY(e.clientY)
        var cx = this.backOutX(e.clientX)
        if (wasMouseDown && (!this.longHoldTookEffect || this.activeDrawing)) {
          //only completes drawing if you if don't leave chart and let go of mouse button
          this.drawingClick(this.currentPanel, cx, cy)
        }
        if (!this.activeDrawing && !this.longHoldTookEffect) {
          this.dispatch('tap', {
            stx: this,
            panel: this.currentPanel,
            x: cx,
            y: cy,
          })
        }

        this.runAppend('mouseup', arguments)
      }

      /**
       * Turns on the grabbing hand cursor. It does this by appending the class "stx-drag-chart" to the chart container.
       * If this is a problem then just eliminate this function from the prototype.
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.grabbingHand = function() {
        if (!this.allowScroll) return
        if (!this.grabbingScreen) return
        if (CIQ.touchDevice) return
        CIQ.appendClassName(this.container, 'stx-drag-chart')
      }

      /**
       * <span class="injection">INJECTABLE</span>
       * Called when the user presses the mouse button down. This will activate dragging operations once the user moves a few pixels
       * within {@link CIQ.ChartEngine#mousemoveinner}.
       * @param  {Event} e The mouse event
       * @memberof CIQ.ChartEngine.AdvancedInjectable#
       * @alias mousedown
       */
      CIQ.ChartEngine.prototype.mousedown = function(e) {
        if (this.runPrepend('mousedown', arguments)) return
        this.grabOverrideClick = false
        //if(this.openDialog!=="") return;
        if (!this.displayInitialized) return // No chart displayed yet
        if (!this.displayCrosshairs) return
        if (this.repositioningDrawing) return // if mouse went off screen this might happen
        if (this.editingAnnotation) return
        if (!e) e = event //IE8
        if ((e.which && e.which >= 2) || (e.button && e.button >= 2)) {
          // Added 9/19/13 to prevent mFinance bug where right click wouldn't eliminate drawing
          return
        }
        var rect = this.container.getBoundingClientRect()
        this.top = rect.top
        this.left = rect.left
        this.right = this.left + this.width
        this.bottom = this.top + this.height
        if (
          e.clientX >= this.left &&
          e.clientX <= this.right &&
          e.clientY >= this.top &&
          e.clientY <= this.bottom
        ) {
          CIQ.ChartEngine.insideChart = true
        } else {
          CIQ.ChartEngine.insideChart = false
          return
        }
        if (!this.currentPanel) return
        if (
          this.manageTouchAndMouse &&
          e &&
          e.preventDefault &&
          this.captureTouchEvents
        )
          e.preventDefault() // Added 9/19/13 to prevent IE from going into highlight mode when you mouseout of the container
        this.mouseTimer = Date.now()
        this.longHoldTookEffect = false
        this.hasDragged = false
        this.userPointerDown = true
        var chart = this.currentPanel.chart
        for (var i = 0; i < this.drawingObjects.length; i++) {
          var drawing = this.drawingObjects[i]
          if (drawing.highlighted) {
            if (this.cloneDrawing) {
              // clone a drawing if flag set
              var Factory = CIQ.ChartEngine.drawingTools[drawing.name]
              var clonedDrawing = new Factory()
              clonedDrawing.reconstruct(this, drawing.serialize())
              this.drawingObjects.push(clonedDrawing)
              this.activateRepositioning(clonedDrawing)
              clonedDrawing.repositioner = drawing.repositioner
              return
            }
            var drawingTool = this.currentVectorParameters.vectorType
            // do not allow repositioning if the drawing tool has dragToDraw (like the freeform)
            if (
              !CIQ.Drawing ||
              !drawingTool ||
              !CIQ.Drawing[drawingTool] ||
              !new CIQ.Drawing[drawingTool]().dragToDraw
            ) {
              this.activateRepositioning(drawing)
              return
            }
          }
        }
        var mainSeriesRenderer = this.mainSeriesRenderer || {}
        if (
          mainSeriesRenderer.params &&
          mainSeriesRenderer.params.baseline &&
          chart.baseline.userLevel !== false
        ) {
          var y0 = this.valueFromPixel(this.cy - 5, this.currentPanel)
          var y1 = this.valueFromPixel(this.cy + 5, this.currentPanel)
          var x0 =
            this.chart.right -
            parseInt(getComputedStyle(this.controls.baselineHandle).width, 10)
          if (
            chart.baseline.actualLevel < y0 &&
            chart.baseline.actualLevel > y1 &&
            this.cx > x0
          ) {
            this.repositioningBaseline = { lastDraw: Date.now() }
            return
          }
        }
        this.drawingClick(this.currentPanel, this.cx, this.cy)
        if (this.activeDrawing && this.activeDrawing.dragToDraw) return

        this.grabbingScreen = true
        chart.spanLock = false
        this.yToleranceBroken = false
        if (!e) e = event //IE8
        /* use e.client insead of e.page since we need the value to be relative to the viewport instead of the overall document size.
		if(!e.pageX){
			e.pageX=e.clientX + document.body.scrollLeft + document.documentElement.scrollLeft;
			e.pageY=e.clientY + document.body.scrollTop + document.documentElement.scrollTop;
		}
		*/
        this.grabStartX = e.clientX
        this.grabStartY = e.clientY
        this.grabStartMicropixels = this.micropixels
        this.grabStartScrollX = chart.scroll
        this.grabStartScrollY = this.currentPanel.yAxis.scroll
        this.grabStartCandleWidth = this.layout.candleWidth
        this.grabStartYAxis = this.whichYAxis(this.currentPanel)
        this.grabStartZoom = this.grabStartYAxis.zoom
        this.grabStartPanel = this.currentPanel

        setTimeout(
          (function(self) {
            return function() {
              self.grabbingHand()
            }
          })(this),
          100
        )
        this.swipeStart(chart)
        if (this.longHoldTime) this.startLongHoldTimer()
        this.runAppend('mousedown', arguments)
      }

      CIQ.ChartEngine.prototype.startLongHoldTimer = function() {
        var stx = this
        this.cancelLongHold = false
        if (this.longHoldTimeout) clearTimeout(this.longHoldTimeout)
        this.longHoldTimeout = setTimeout(function() {
          if (stx.cancelLongHold) return
          stx.dispatch('longhold', {
            stx: stx,
            panel: stx.currentPanel,
            x: stx.cx,
            y: stx.cy,
          })
          stx.longHoldTookEffect = true
        }, this.longHoldTime)
      }

      /**
       * Sets the current drawing tool as described by {@link CIQ.ChartEngine#currentVectorParameters} (segment, line, etc)
       * @param  {string} value The name of the drawing tool to enable
       * @memberof CIQ.ChartEngine
       * @example
       * // activates a drawing type described by currentVectorParameters
       * stxx.changeVectorType('rectangle');
       * // deactivates drawing mode
       * stxx.changeVectorType('');
       * // clears the drawings
       * stxx.clearDrawings()
       */
      CIQ.ChartEngine.prototype.changeVectorType = function(value) {
        this.currentVectorParameters.vectorType = value
        //if(value==""){  //need to always undo here to allow release of last drawing tool
        if (CIQ.ChartEngine.drawingLine) this.undo()
        //}
        this.setCrosshairColors()
        if (CIQ.ChartEngine.insideChart) this.doDisplayCrosshairs()
      }

      /**
       * Sets the current drawing parameter as described by {@link CIQ.ChartEngine#currentVectorParameters} (color, pattern, etc)
       * @param  {string} value The name of the drawing parameter to change (currentColor, fillColor, lineWidth, pattern, axisLabel, fontSize, fontStyle, fontWeight, fontFamily)
       * @param  {string} value The value of the parameter
       * @return  {boolean} True if property was assigned
       * @memberof CIQ.ChartEngine
       * @example
       * 		this.stx.changeVectorParameter("currentColor","yellow");  // or rgb/hex
       *		this.stx.changeVectorParameter("axisLabel",false);  // or "false"
       *		this.stx.changeVectorParameter("lineWidth",5);  // or "5"
       *		this.stx.changeVectorParameter("fontSize","12");  // or 12 or "12px"
       *		this.stx.changeVectorParameter("pattern","dotted");
       *
       * @since 3.0.0
       */
      CIQ.ChartEngine.prototype.changeVectorParameter = function(
        parameter,
        value
      ) {
        if (parameter == 'axisLabel')
          value = value.toString() === 'true' || Number(value)
        else if (parameter == 'lineWidth') value = Number(value)
        else if (parameter == 'fontSize') value = parseInt(value, 10) + 'px'
        var currentVectorParams = this.currentVectorParameters
        if (typeof currentVectorParams[parameter] !== 'undefined') {
          currentVectorParams[parameter] = value
          return true
        } else if (parameter.substr(0, 4) == 'font') {
          parameter = parameter.substr(4).toLowerCase()
          if (parameter == 'family' && value.toLowerCase() == 'default')
            value = null
          currentVectorParams = currentVectorParams.annotation.font
          if (typeof currentVectorParams[parameter] !== 'undefined') {
            currentVectorParams[parameter] = value
            return true
          }
        }
        return false
      }

      /**
       * <span class="injection">INJECTABLE</span>
       * This function is called when a highlighted study overly is right clicked. If the overlay has an edit function (as many studies do), it will be called. Otherwise it will remove the overlay
       * @param  {string} name The name (id) of the overlay
       * @param  {boolean} [forceEdit] If true then force edit menu
       * @memberof CIQ.ChartEngine.AdvancedInjectable#
       * @alias rightClickOverlay
       */
      CIQ.ChartEngine.prototype.rightClickOverlay = function(name, forceEdit) {
        if (this.runPrepend('rightClickOverlay', arguments)) return
        var sd = this.overlays[name]
        if (sd.editFunction) {
          sd.editFunction(forceEdit)
        } else {
          this.removeOverlay(name)
        }
        this.runAppend('rightClickOverlay', arguments)
      }

      /**
       * <span class="injection">INJECTABLE</span>
       * Removes an overlay (and the associated study)
       * @param  {string} name The name (id) of the overlay
       * @memberof CIQ.ChartEngine.AdvancedInjectable#
       * @alias removeOverlay
       */
      CIQ.ChartEngine.prototype.removeOverlay = function(name) {
        if (this.runPrepend('removeOverlay', arguments)) return
        var mySD = this.overlays[name]
        for (var o in this.overlays) {
          var sd = this.overlays[o]
          var fieldInputs = ['Field']
          if (CIQ.Studies) fieldInputs = CIQ.Studies.getFieldInputs(sd)
          for (var f = 0; f < fieldInputs.length; f++) {
            // Study sd is reliant on an output from the about-to-be-deleted overlay
            if (mySD.outputMap[sd.inputs[fieldInputs[f]]]) {
              // Yucky, we should move to explicit parent nodes
              this.removeOverlay(sd.name)
            }
          }
        }
        if (CIQ.Studies) {
          var study = this.layout.studies[name]
          CIQ.deleteRHS(CIQ.Studies.studyPanelMap, study)
          if (mySD) this.cleanupRemovedStudy(mySD)
        }
        delete this.overlays[name]

        if (!this.currentlyImporting) {
          // silent mode while importing
          this.displaySticky()
          this.createDataSet()
          this.changeOccurred('layout')
        }
        this.runAppend('removeOverlay', arguments)
      }

      /**
	 * <span class="injection">INJECTABLE</span>
	 * Adds a series to the chart.
	 *
	 * Series are plotted using [renderers]{@link CIQ.Renderer}. Renderers can plot lines, mountains, bars, candles, etc.
	 *
	 * This method can create its own renderer, if only basic behavior is required,
	 * or you can explicitly use `[setSeriesRenderer()]{@link CIQ.ChartEngine#setSeriesRenderer}` to group multiple series into a single renderer, for example,
	 * when drawing a stacked histogram, or group of lines sharing similar properties.
	 *
	 * Example 1 <iframe width="100%" height="500" scrolling="no" seamless="seamless" align="top" style="float:top" src="http://jsfiddle.net/chartiq/b6pkzrad/embedded/result,js,html/" allowfullscreen="allowfullscreen" frameborder="1"></iframe>
	 *
	 * Example 2 <iframe width="100%" height="500" scrolling="no" seamless="seamless" align="top" style="float:top" src="http://jsfiddle.net/chartiq/rb423n71/embedded/result,js,html/" allowfullscreen="allowfullscreen" frameborder="1"></iframe>
	 *
	 * **Important:** There are two ways to create a series:
	 *  - it can be added for immediate display.
	 *  - it can be added for later use; where only the data is immediately loaded, but the actual series will be awaiting to be linked to a renderer for display.
	 *
	 * Here are the details:
	 *
	 * -  If **`parameters.color` or `parameters.renderer` are included**, the series will automatically create a renderer and attached to it. This will cause it to be immediately displayed on the chart.
	 *
	 * Use this method if you don't need any of the advanced features available through [custom renderers]{@link CIQ.ChartEngine#setSeriesRenderer}.<br>
	 * In this case, there is no need to manually create a renderer and attach this seres to it,
	 * unless you want the same data to also be displayed differently by another renderer.<br>
	 * But remember that if you do so, it WILL render again using the new renderer settings.
	 * So never use `parameters.color` or `parameters.renderer` in `addSeries` if you intend to have the series managed by a custom renderer.
	 *
	 * The following is how the default renderer is defined if only `parameters.color` is included :
	 * ```
	 * stx.setSeriesRenderer(
	 * 		new CIQ.Renderer.Lines({
	 * 			params:{panel:obj.parameters.panel, type:"legacy", name:"_generic_series", overChart:true, useChartLegend:true},
	 * 		})
	 * );
	 * ```
	 *
	 * If you you include `parameters.renderer`, then that is the renderer that will be created.
	 *
	 * In this mode, the series `parameters` object will also accept any valid parameters for the [attachSeries]{@link CIQ.Renderer#attachSeries} and [setSeriesRenderer]{@link CIQ.ChartEngine#setSeriesRenderer} call.
	 * See {@link CIQ.Renderer#attachSeries} or the documentation for the renderer you want to use (e.g. {@link CIQ.Renderer.Lines}) for a list of all parameters.
	 *
	 * - If **`parameters.color` and `parameters.renderer` ARE NOT included**, the series will be set but not displayed, awaiting grouping and rendering done by the  [setSeriesRenderer()]{@link CIQ.ChartEngine#setSeriesRenderer} and [attachSeries()]{@link CIQ.Renderer#attachSeries} calls you will be explicitly adding.
	 *
	 * In this mode, be sure to set parameters in the separate [attachSeries]{@link CIQ.Renderer#attachSeries} and [setSeriesRenderer]{@link CIQ.ChartEngine#setSeriesRenderer} call, when present, rather than in the addSeries call.
	 *
	 * See the 'Examples' section for code illustrations of both methods.
	 *
	 * @param {string} [id] The name of the series. If not passed then a unique ID will be assigned. (parameters.symbol and parameters.symbolObject will default to using id if they are not set explicitly *and* id is supplied.)
	 * @param {object} [parameters] Optional parameters to describe the series
	 * @param {string} [parameters.renderer] Set to the desired [renderer]{@link CIQ.Renderer} type for the series. Will cause the series to immediately render.
	 * - If omitted, a default [Lines]{@link CIQ.Renderer.Lines} renderer will be used.
	 * - You can also include, any valid [attachSeries parameters]{@link CIQ.Renderer#attachSeries} and [renderer parameters]{@link CIQ.Renderer} to assist in the renderer creation.
	 * - Most common renderer parameters sent in addSeries are:
	 *  - `name` : Note that if you do not set a name for the renderer here, a unique ID will be assigned. <br>This has ramifications when importing a layout, as if you recreate the renderer on page load, it will receive a different name, which will not match the name imported from the storage.
	 *  - `type` : Each {@link CIQ.Renderer} will have a different set of values for this parameter. Please see the details for the particular renderer you are setting.
	 *  - `color` : Use this instead of setting the renderer parameter if all you want is to immediately display a line with the given color.
	 * - See examples section for implementation code.
	 * @param {string} [parameters.display] Set to the text to display on the legend. If not set, the id of the series will be used (usually symbol).  If id was not provided, will default to symbol.
	 * @param {string} [parameters.symbol] The symbol to fetch in string format. This will be sent into the fetch() function, if no data is provided.  If no symbol is provided, series will use the `id` as the symbol. If both `symbol` and `symbolObject` are set, `symbolObject` will be used.
	 * @param {object} [parameters.symbolObject] The symbol to fetch in object format. This will be sent into the fetch() function, if no data is provided. If no symbolObject is provided, series will use the `id` as the symbol. You can send anything you want in the symbol object, but you must always include at least a 'symbol' element. If both `symbol` and `symbolObject` are set, `symbolObject` will be used.
	 * @param {string} [parameters.field] Specify an alternative field to draw data from (other than the Close/Value). Must be present in your pushed data objects or returned from the quoteFeed.
	 * @param {boolean} [parameters.isComparison] If set to true, shareYAxis is automatically set to true to display relative values instead of the primary symbol's price labels. {@link CIQ.ChartEngine#setComparison} is also called and set to `true`. This is only applicable when using the primary Y axis, and should only be used with internal addSeries renderers.
	 * @param {boolean} [parameters.shareYAxis] Set to `true` so that the series shares the Y-axis and renders along actual values and print its corresponding current price label on the y axis. When set to `false` the series is superimposed on the chart maintaining the relative shape of the line but not on the actual y axes values and no current price will be displayed(used when rendering multiple series that do not share a common value range). Will automatically override to true if 'isComparison' is set. This is only applicable when using the primary Y axis.
	 * @param {number} [parameters.marginTop] Percentage (if less than 1) or pixels (if greater than 1) from top of panel to set the top margin for the series.<BR>**Note:** this parameter is to be used on **subsequent** series rendered on the same axis. To set margins for the first series, {@link CIQ.ChartEngine.YAxis#initialMarginTop} needs to be used.<BR>**Note:** not applicable if shareYAxis is set.
	 * @param {number} [parameters.marginBottom] Percentage (if less than 1) or pixels (if greater than 1) from the bottom of panel to set the bottom margin for the series.<BR>**Note:** this parameter is to be used on **subsequent** series rendered on the same axis. To set margins for the first series, {@link CIQ.ChartEngine.YAxis#initialMarginBottom} needs to be used.<BR>**Note:** not applicable if shareYAxis is set.
	 * @param {number} [parameters.width] Width of line
	 * @param {number} [parameters.minimum]	 Minimum value for the series. Overrides CIQ.minMax result.
	 * @param {number} [parameters.maximum]	 Maximum value for the series. Overrides CIQ.minMax result.
	 * @param {string} [parameters.color] Color to draw line. Will cause the line to immediately render an overlay. Only applicable for default/'Lines' renderer. See {@link CIQ.Renderer#attachSeries} for additional color options.
	 * @param {string} [parameters.baseColor] Color for the base of a mountain series. Defaults to `parameters.color`.
	 * @param {array|string} [parameters.pattern] Pattern to draw line, array elements are pixels on and off, or a string e.g. "solid", "dotted", "dashed"
	 * @param {boolean} [parameters.fillGaps] Will fill any missing **data** points in the series *relative to masterData*.
	 * 											<br>If true then gaps in data will be filled by carrying forward the value of from the previous bar.
	 *											<br>Note that this is independent of {CIQ.ChartEngine#cleanupGaps} which ensures (for all series and masterData) that a point exists for each valid market date.
	 * @param {object} [parameters.gaps] Defines how to **render** (style) gaps in the data (missing data points).  If undefined, and the series is a comparison, the gaps will be rendered transparent.
	 *                                   	Set to `true` to use the same color and pattern as the main line, or define a color-pattern object if different.
	 * @param {string} [parameters.gaps.color] Color to draw line where data points are missing
	 * @param {array|string} [parameters.gaps.pattern] Pattern to draw line where data points are missing, array elements are pixels on and off, or a string e.g. "solid", "dotted", "dashed"
	 * @param {string} [parameters.fillStyle] Fill style for mountain chart (if selected). For semi-opaque use rgba(R,G,B,.1).  If not provided a gradient is created with color and baseColor.
	 * @param {boolean} [parameters.permanent] Set to `true` to activate. Makes series unremoveable by a user **when attached to the default renderer**. If explicitly linked to a renderer, see {@link CIQ.Renderer#attachSeries} for details on how to prevent an attached series from being removed by a user.
	 * @param {object} [parameters.data] Data source for the series.
	 * <P>&bull; If this field is omitted, the library will connect to the QuoteFeed (if available) to fetch initial data ( unless `parameters.loadData` is set to `false`), and manage pagination and updates.
	 * <P>&bull; If data is sent in this field, it will be loaded into the masterData, but series will **not** be managed by the QuoteFeed (if available) for pagination or updates. This should contain an array of objects in {DT,Date,Value} format as outlined by the following properties:
	 * @param {date}   [parameters.data.DT] JavaScript date object or epoch representing data point (overrides Date parameter if present)
	 * @param {string} [parameters.data.Date] string date representing data point ( only used if DT parameter is not present)
	 * @param {number} [parameters.data.Value] value of the data point ( As an alternative, you can send `parameters.data.Close` since your quote feed may already be returning the data using this element name)
	 * @param {string} [parameters.panel] the panel name on which the series should display
	 * @param {string} [parameters.action="add-series"] Optionally override what action is sent in symbolChange events. Set to null to prevent a symbolChange event.
	 * @param {boolean} [parameters.loadData=true] Optionally include and set to false if you know the initial data is already in the masterData array or will be loaded by another method. The series will be added but no data requested. Note that if you remove this series, the data points linked to it will also be removed which may create issues if required by the chart. If that is the case, you will need to manually remove from the renderer linked to it instead of the underlying series itself.
	 * @param {boolean} [parameters.extendToEndOfDataSet] Set to true to plot any gap at the front of the chart.  Automatically done for step charts or if parameters.gaps are set (see {@link CIQ.ChartEngine#addSeries})
	 * @param {function} [cb] Callback function to be executed once the fetch returns data from the quoteFeed. It will be called with an error message if the fetch failed: `cb(err);`. Only applicable if no data is provided.
	 *
	 * @return {object} The series object
	 * @memberof CIQ.ChartEngine
	 *
	 * @example
	 * // add a series overlay for an existing data value without requesting initial data from the quoteFeed.
	 * // if `loadData:false` is excluded, the library will attempt to load data for symbol 'Close'; which is not what is intended.
	 * stxx.addSeries(
	 *		"Close",
	 *		{color:"purple", loadData:false}
	 * );
	 *
	 * @example
	 * // add a series overlay and display it as a dashed line.
	 * stxx.addSeries(
	 *		symbolGoesHere,
	 *		{color:"purple", pattern:[3,3]}
	 * );
	 *
	 * @example
	 * // add a series onto the main axis and then enable a study for using it.
	 * // In this case we are adding a Moving average for the series.
	 *
	 *	stxx.addSeries("ge", {color:"yellow", shareYAxis:true}, function(){
	 *		var inputs = {
	 *	        "Period": 20,
	 *	        "Field": "ge",
	 *	        "Type": "ma"
	 *	    };
	 *	    var outputs = {
	 *	        "MA": "red"
	 *	    };
	 *	    CIQ.Studies.addStudy(stxx, "ma", inputs, outputs);
	 *	});
	 *
	 * @example
	 * // add series using a symbolObject which includes the data source key.
	 * // This key will be sent into the fetch 'params' for use in your quoteFeed.
	 * var mySymbol={symbol:"GE", source:"realtimedb"};
	 * var mySymbol2={symbol:"GDP", source:"fundamentaldb"};
	 *
	 * stxx.addSeries(null, {color:"purple", symbolObject:mySymbol});
	 * stxx.addSeries(null, {color:"green", symbolObject:mySymbol2});
	 *
	 * @example
	 * // The engine is smart enough to use the series symbol, or "Close" if the symbol doesn't exist in the returned data from your quotefeed
	 * // but if you want to use any other field then you'll need to specify it like this.
	 * stxx.addSeries("GE", {color:"purple", field: "Open"});
	 *
	 * @example
	 * // add the comparison series with a color to immediately render using default renderer (as lines) and dashes for gaps fillers
	 * stxx.addSeries(symbol1, {display:"Description 1",isComparison:true,color:"purple", gaps:{pattern:[3,3]},width:4,permanent:true});
	 * stxx.addSeries(symbol2, {display:"Description 2",isComparison:true,color:"pink", gaps:{pattern:[3,3]},width:4});
	 * stxx.addSeries(symbol3, {display:"Description 3",isComparison:true,color:"brown", gaps:{pattern:[3,3]},width:4});
	 *
	 * @example
	 *	// add the series with only default parameters (no color).
	 *	// The series will not display on the chart after it is added,
	 *	// but the data will be available ready to be attached to a renderer.
	 *	stxx.addSeries(symbol1, {display:"Description 1"});
	 *	stxx.addSeries(symbol2, {display:"Description 2"});
	 *	stxx.addSeries(symbol3, {display:"Description 3"});
	 *
	 * @example
	 *	// add a series with a color to immediately render. It also calls callbackFunct after the data is returned from the fetch.
	 *	function callbackFunct(field){
	 *		 return function(err) {
	 *			alert(field);
	 *		}
	 *	}
	 *
	 *	stxx.addSeries(symbol1, {display:"Description",color:"brown"}, callbackFunct(symbol1));
	 *
	 * @example
	 * // add a stacked historam with 3 series usng an external renderer.
	 *
	 *	// note how the addSeries callback is used to ensure the data is present before the series  is displayed
	 *
	 * // configure the histogram display
	 * var params={
	 *	name:				"Sentiment Data",
	 *	type:				"histogram",
	 *	subtype:			"stacked",
	 *	heightPercentage:	.7,	 // how high to go. 1 = 100%
	 *	opacity:			.7,  // only needed if supporting IE8, otherwise can use rgba values in histMap instead
	 *	widthFactor:		.8	 // to control space between bars. 1 = no space in between
	 * };
	 *
	 * //legend creation callback
	 * function histogramLegend(colors){
	 * 	stxx.chart.legendRenderer(stxx,{legendColorMap:colors, coordinates:{x:260, y:stxx.panels["chart"].yAxis.top+30}, noBase:true});
	 * }
	 *
	 * var histRenderer=stxx.setSeriesRenderer(new CIQ.Renderer.Histogram({params: params, callback: histogramLegend}));
	 *
	 * stxx.addSeries("^NIOALL", {display:"Symbol 1"}, function() {histRenderer.attachSeries("^NIOALL","#6B9CF7").ready();});
	 * stxx.addSeries("^NIOAFN", {display:"Symbol 2"}, function() {histRenderer.attachSeries("^NIOAFN","#95B7F6").ready();});
	 * stxx.addSeries("^NIOAMD", {display:"Symbol 3"}, function() {histRenderer.attachSeries("^NIOAMD","#B9D0F5").ready();});
	 *
	 * @example
	 *	// add series and attach to a custom y-axis on the left.
	 *	// See this example working here : http://jsfiddle.net/chartiq/b6pkzrad
	 *
	 *	// note how the addSeries callback is used to ensure the data is present before the series  is displayed
	 *
	 *	//create the custom axis
	 *	var axis=new CIQ.ChartEngine.YAxis();
	 *	axis.position="left";
	 *	axis.textStyle="#FFBE00";
	 *	axis.decimalPlaces=0;			// no decimal places on the axis labels
	 *	axis.maxDecimalPlaces=0;		// no decimal places on the last price pointer
	 *
	 *	//create the renderer
	 *	renderer=stxx.setSeriesRenderer(new CIQ.Renderer.Lines({params:{name:"lines", type:"mountain", yAxis:axis}}));
	 *
	 *	// create your series and attach them to the chart when the data is loaded.
	 *	stxx.addSeries("NOK", {display:"NOK",width:4},function(){
	 *		renderer.attachSeries("NOK", "#FFBE00").ready();
	 *	});
	 *
	 *	stxx.addSeries("SNE", {display:"Sony",width:4},function(){
	 *		renderer.attachSeries("SNE", "#FF9300").ready();
	 *	});
	 *
	 * @example
	 * // add a series with a colored bar renderer; usng default colors
	 * stxx.addSeries("MSFT",{renderer:"Bars", type:"bar", colored:true, display:"Microsoft"});
	 *
	 * @example
	 * // add a series with a candle renderer; using custom colors
	 *stxx.addSeries("MSFT",{renderer:"Bars", type:"candle", fill_color_up:"magenta", border_color_up:"purple", fill_color_down:"lightgreen", border_color_down:"green", display:"Microsoft"});
	 *
	 *@example
	 * // add a series with Histrogram renderer; using default colors
	 * stxx.addSeries('ge', {renderer:"Histogram", color: 'red', display: 'General Electric'});
	 *
	 * // add a series with Lines renderer; using default colors
	 * stxx.addSeries('GE',{renderer:'Lines'});
	 *
	 * @example
	 * // add a series with tension to cause the lines to be curved instead of straight
	 * // 'tension' is a line renderer parameter.
	 * // the renderer:"Lines" parameter could theoretically be omitted since it is the default renderer.
	 * stxx.addSeries('GE',{renderer:"Lines", type:'mountain',color:'yellow',tension:0.3})
	 *
	 * @since
	 * <br>&bull; 04-2015 if `isComparison` is true shareYAxis is automatically set to true and setComparison(true) called. createDataSet() and draw() are automatically called to immediately render the series.
	 * <br>&bull; 15-07-01 if `color` is defined and chartStyle is not set then it is automatically set to "line".
	 * <br>&bull; 15-07-01 ability to use setSeriesRenderer().
	 * <br>&bull; 15-07-01 ability to automatically initialize using the quoteFeed.
	 * <br>&bull; 15-07-01 `parameters.quoteFeedCallbackRefresh` no longer used. Instead if `parameters.data.useDefaultQuoteFeed` is set to `true` the series will be initialized and refreshed using the default quote feed. ( Original documentation:  {boolean} [parameters.quoteFeedCallbackRefresh] Set to true if you want the series to use the attached quote feed (if any) to stay in sync with the main symbol as new data is fetched (only available in Advanced package). )
	 * <br>&bull; 2015-11-1 `parameters.symbolObject` is now available
	 * <br>&bull; 05-2016-10  `parameters.forceData` is now available.
	 * <br>&bull; 09-2016-19  `parameters.data.DT` can also take an epoch number.
	 * <br>&bull; 09-2016-19  `parameters.data.useDefaultQuoteFeed` no longer used. If no `parameters.data` is provided the quotefeed will be used.
	 * <br>&bull; 3.0.8  `parameters.forceData` no longer used, now all data sent in will be forced.
	 * <br>&bull; 3.0.8 parameters.loadData added.
	 * <br>&bull; 4.0.0 Added parameters.symbol (string equivalent of parameters.symboObject)
	 * <br>&bull; 4.0.0 Multiple series can now be added for the same underlying symbol. parameters.field or parameters.symbolObject can be used to accomplish this.
	 * <br>&bull; 4.0.0 Added `parameters.baseColor`.
	 * <br>&bull; 5.1.0 Series data now added to masterData as an object.  This allows storage of more than just one data point, facilitating OHLC series!
	 * <br>&bull; 5.1.0 addSeries will now create a renderer unless renderer, name and color parameters are all omitted
	 * <br>&bull; 5.1.0 Now also dispatches a "symbolChange" event when pushing data into the chart, rather than only when using a quote feed.
	 * <br>&bull; 5.1.1 Added `parameters.extendToEndOfDataSet`.
	 * <br>&bull; 5.1.1 `parameters.chartType`, originally used to draw "mountain" series, has been deprecated in favor of the more flexible 'renderer' parameter. It is being maintained for backwards compatibility

	 */
      CIQ.ChartEngine.prototype.addSeries = function(id, parameters, cb) {
        var injectionResult = this.runPrepend('addSeries', arguments)
        if (injectionResult) return injectionResult
        var display = id ? id : null // if id is passed then we default display to the same value (we can always override with parameters.display)
        var symbol = id
        if (!id) id = CIQ.uniqueID()
        var obj = {
          parameters: parameters ? CIQ.clone(parameters) : {},
          yValueCache: [],
          display: display,
          id: id,
        }
        parameters = obj.parameters
        if (parameters.symbol) symbol = parameters.symbol

        CIQ.ensureDefaults(parameters, {
          chartName: this.chart.name,
          symbolObject: { symbol: symbol },
          panel: this.chart.panel.name,
          action: 'add-series',
        })
        if ('display' in parameters) obj.display = parameters.display
        if (parameters.isComparison) parameters.shareYAxis = true
        var chart = this.charts[parameters.chartName]
        var symbolObject = parameters.symbolObject
        symbol = parameters.symbol = symbolObject.symbol
        if (!obj.display) obj.display = symbol || parameters.field // If after all this time, we still don't have a display, then resort to the reasonable alternative of using the symbol or field

        // backwards compatability for pre 4.0
        if (parameters.isComparison) {
          // if gaps parameters isn't defined the gaps will be rendered transparent
          if (parameters.gaps === undefined) parameters.gaps = 'transparent'
        }

        var existsAlready = this.getSeries({
          symbolObject: symbolObject,
          chart: chart,
          includeMaster: true,
        }).length

        chart.series[id] = obj
        var self = this

        function setUpRenderer(stx, obj) {
          var renderer = parameters.renderer || 'Lines'
          var name = parameters.name || CIQ.uniqueID()
          if (
            !parameters.renderer &&
            !parameters.name &&
            !parameters.color &&
            !parameters.chartType
          )
            return // if no renderer, name, color, nor chartType set, assume will be set later on manual call to attachSeries.
          var r = stx.getSeriesRenderer(name)
          if (!r) {
            var params = { name: name, overChart: true, useChartLegend: true }
            if (parameters.chartType) {
              params = CIQ.extend(
                { panel: parameters.panel, yAxis: parameters.yAxis },
                params
              )
              r = CIQ.Renderer.produce(parameters.chartType, params)
            } else {
              r = new CIQ.Renderer[renderer]({
                params: CIQ.extend(params, parameters),
              })
            }
            if (!r) return
            stx.setSeriesRenderer(r)
          }
          r.attachSeries(id, parameters)
          if (parameters.loadData !== false) r.ready()
        }

        function handleResponse(params) {
          return function(dataCallback) {
            if (!dataCallback.error) {
              CIQ.addMemberToMasterdata({
                stx: self,
                label: symbol,
                fieldForLabel: parameters.field,
                data: dataCallback.quotes,
                fillGaps: parameters.fillGaps,
                createObject: true,
              })
              setUpRenderer(self, obj)
            }
            if (parameters.action !== null && !existsAlready)
              self.dispatch(
                self.currentlyImporting ? 'symbolImport' : 'symbolChange',
                {
                  stx: self,
                  symbol: params.symbol,
                  symbolObject: params.symbolObject,
                  action: parameters.action,
                }
              )
            if (cb) cb.call(self, dataCallback.error, obj)
          }
        }

        if (parameters.isComparison) this.setComparison(true, chart)

        var masterData = chart.masterData
        if (!masterData) masterData = chart.masterData = this.masterData = []
        var masterLength = masterData.length

        if (
          parameters.data &&
          !parameters.data.useDefaultQuoteFeed /* legacy */
        ) {
          CIQ.addMemberToMasterdata({
            stx: this,
            label: symbol,
            fieldForLabel: parameters.field,
            data: parameters.data,
            fillGaps: parameters.fillGaps,
            createObject: true,
          })
          setUpRenderer(this, obj)
          if (parameters.action !== null && !existsAlready)
            self.dispatch(
              self.currentlyImporting ? 'symbolImport' : 'symbolChange',
              {
                stx: self,
                symbol: symbol,
                symbolObject: symbolObject,
                action: parameters.action,
              }
            )
          if (cb) cb.call(this, null, obj)
        } else if (existsAlready) {
          // This symbol is already in the series
          setUpRenderer(this, obj)
          if (cb) {
            setTimeout(function() {
              cb.call(self, null, obj)
            }, 0)
          }
        } else if (this.quoteDriver && parameters.loadData !== false) {
          // if we have a quote feed, go and fetch it.
          var driver = this.quoteDriver
          var fetchParams = driver.makeParams(symbol, symbolObject, chart)
          // for comparisons, you must fetch enough data on the new Comparison to match the beginning of the masterData until the current tick.
          // The current tick may be newer than master data last tick, so set the end Date to right now.
          // If the chart is empty, then don't send any dates and allow the fetch to do an initial load
          if (masterLength) {
            fetchParams.startDate = masterData[0].DT
            fetchParams.endDate = this.convertToDataZone(new Date())
          }
          if (fetchParams.stx.isEquationChart(fetchParams.symbol)) {
            //equation chart
            CIQ.fetchEquationChart(fetchParams, handleResponse(fetchParams))
          } else {
            CIQ.ChartEngine.Driver.fetchData(
              CIQ.QuoteFeed.SERIES,
              driver.quoteFeed,
              fetchParams,
              handleResponse(fetchParams)
            )
          }
        } else {
          // It might get in here if we depend on loadDependents to initialize the series, such as from importLayout
          setUpRenderer(this, obj)
          if (cb) cb.call(this, null, obj)
        }

        this.runAppend('addSeries', arguments)

        return obj
      }

      /**
       * Returns an array of series that match the given filters.
       *
       * If any series is an equation chart then the equation will be searched for the matching symbol.
       *
       * @param  {object} params Parameters
       * @param {string} [params.symbol] Filter for only series that contain this symbol
       * @param {string} [params.symbolObject] Filter for only series that contain this symbolObject
       * @param {boolean} [params.includeMaster] If true then the masterSymbol will be checked for a match too. A blank object will be returned. You should only use this if you're just using this to look for yes/no dependency on a symbol.
       * @param {CIQ.ChartEngine.Chart} [params.chart] Optional chart
       * @return {array}        Array of series descriptors
       * @memberOf  CIQ.ChartEngine
       * @since 4.0.0
       */
      CIQ.ChartEngine.prototype.getSeries = function(params) {
        var chart = params.chart ? params.chart : this.chart
        var series = chart.series
        var symbolObject = params.symbolObject
        if (!symbolObject) symbolObject = { symbol: params.symbol }
        var arr = []
        for (var id in series) {
          var sd = series[id]
          if (CIQ.symbolEqual(symbolObject, sd.parameters.symbolObject))
            arr.push(sd)
        }
        if (params.includeMaster) {
          if (CIQ.symbolEqual(symbolObject, chart.symbolObject)) arr.push({})
        }
        return arr
      }

      /**
       * Modify an existing series. Any passed parameters will extend the existing parameters.
       *
       * @param {string|Object} descriptor the series or series id which to modify
       * @param {Object} [parameters] use this to override any option to addSeries
       * @param {function} [cb] passed directly to addSeries
       * @memberof CIQ.ChartEngine
       * @since 5.1.1
       */
      CIQ.ChartEngine.prototype.modifySeries = function(
        descriptor,
        parameters,
        cb
      ) {
        if (this.runPrepend('modifySeries', arguments)) return

        var chart
        var series
        var id

        if (typeof descriptor === 'string') {
          chart =
            parameters && parameters.chartName
              ? this.charts[parameters.chartName]
              : this.chart
          id = descriptor
          series = chart.series[id]
        } else {
          series = descriptor
          id = series.id
        }
        if (!series) return

        CIQ.extend(series.parameters, parameters || {})

        series.parameters.action = 'modify-series'
        this.removeSeries(series)

        series = this.addSeries(id, series.parameters, cb)
        series.parameters.action = null

        this.runAppend('modifySeries', arguments)
      }

      CIQ.ChartEngine.prototype.isEquationChart = function(symbol) {
        if (!this.allowEquations || !CIQ.computeEquationChart) return false
        if (symbol && symbol[0] == '=') return true
        return false
      }

      /**
       * Returns all the valid data fields in masterData. A valid data field is one
       * that is in use by a series or one that is in use by the main chart
       * @param {CIQ.ChartEngine.Chart} [chart] The chart to look in
       * @return {array} An array of valid price fields
       * @private
       * @since 4.0.0
       */
      CIQ.ChartEngine.prototype.getDataFields = function(chart) {
        if (!chart) chart = this.chart
        var plotField = chart.defaultPlotField || 'Close'
        var fields = ['Open', 'High', 'Low']
        fields.push(plotField)
        for (var field in chart.series) {
          var parameters = chart.series[field].parameters
          fields.push(parameters.symbol)
        }
        return fields
      }
      /**
       * Cleans up the masterData after a series has been removed. This method will remove
       * the series field from the masterData, only if no other series are dependent on the field.
       * Once the field is removed, any empty/null masterData points will be removed. Finally,
       * doCleanGaps will be run again to set masterData back to it's original state. createDataSet
       * is not run from this method
       * @param  {object} symbolObject A symbol object
       * @param {CIQ.ChartEngine.Chart} chart The chart to clean
       * @private
       * @since 4.0.0
       */
      CIQ.ChartEngine.prototype.cleanMasterData = function(
        symbolObject,
        chart
      ) {
        var symbol = symbolObject.symbol
        var masterData = chart.masterData

        if (!masterData || !masterData.length) return

        var fields = this.getDataFields(chart)

        // Returns true is the quote doesn't have any valid data fields
        function empty(quote, fields) {
          for (var i = 0; i < fields.length; i++) {
            var val = quote[fields[i]]
            if (typeof val != 'undefined') return false
          }
          return true
        }
        // Clean out "zombie" masterData entries. These would be entries that no longer have
        // any valid data. This can happen whenever series have non-overlapping dates.
        var i = 0
        do {
          var quote = masterData[i]
          delete quote[symbol]
          if (empty.call(this, quote, fields)) {
            masterData.splice(i, 1)
            continue
          }
          i++
        } while (i < masterData.length)
        masterData = this.doCleanupGaps(masterData) // todo, remove once setMasterData cleans gaps
        this.setMasterData(masterData, chart)
      }

      /**
       * Removes series data from masterData and unregisters the series from `chart.series` without removing it from any associated renderers.
       * Also [resets comparisons]{@link CIQ.ChartEngine#setComparison} and updates the [quoteFeed subscriptions]{@lunk quotefeed.unsubscribe}.
       * **Not recommended to be called directly.**
       * Instead use {@link CIQ.ChartEngine#removeSeries} to remove a series from all associated renderers,
       * or {@link CIQ.Renderer#removeSeries} to remove a series from a specific renderer.
       * @param  {string|object} field The name of the series to remove -OR- the series object itself.
       * @param  {CIQ.ChartEngine.Chart} chart The chart to remove from
       * @param {object} [params] Optional parameters
       * @param {string} [params.action="remove-series"] Optional action to be dispatched with symbolChange event
       * @memberOf  CIQ.ChartEngine
       * @since
       * <br>&bull; 4.0.0 Now supports passing a series descriptor instead of a field
       * <br>&bull; 4.0.0 Series data is now totally removed from masterData if no longer used by any other renderers.
       * <br>&bull; 4.0.0 Empty renderers are now removed when series are removed
       */
      CIQ.ChartEngine.prototype.deleteSeries = function(field, chart, params) {
        if (this.runPrepend('deleteSeries', arguments)) return
        params = params ? params : {}
        var action = params.action ? params.action : 'remove-series'
        var toRemove
        if (typeof field === 'object') {
          toRemove = field.id
          chart = chart || this.charts[field.parameters.chartName]
        } else {
          toRemove = field
          chart = chart || this.chart
        }
        var theSeries = chart.series[toRemove]
        if (!theSeries) return // prevent js error if removing a series that doesn't exist
        var loadedData = theSeries.parameters.loadData
        var symbolObject = theSeries.parameters.symbolObject
        if (theSeries.parameters.action !== 'modify-series') {
          delete chart.series[toRemove]
        }

        // If no more dependencies, then remove the symbol from the actual masterData
        var dependencies = this.getSeries({
          symbolObject: symbolObject,
          includeMaster: true,
        })
        if (loadedData === false) dependencies.push(toRemove)
        if (!dependencies.length) this.cleanMasterData(symbolObject, chart)

        if (this.layout.chartScale != 'percent') {
          var comparing = false
          for (var s in chart.series) {
            if (chart.series[s].parameters.isComparison) comparing = true
          }
          if (!comparing) this.setComparison(false, chart)
        }
        this.createDataSet()
        if (!dependencies.length)
          this.dispatch(
            this.currentlyImporting ? 'symbolImport' : 'symbolChange',
            {
              stx: this,
              symbol: symbolObject.symbol,
              symbolObject: symbolObject,
              action: action,
            }
          )
        if (this.quoteDriver) this.quoteDriver.updateSubscriptions()
        this.runAppend('deleteSeries', arguments)
      }

      /**
       * Removes a series from all associated renderers in the chart, also removing the actual series data from masterData.
       * If the series was belonged to a renderer that has no other series attached to it, the renderer is removed.
       * See {@link CIQ.ChartEngine#deleteSeries} for more details.
       * <span class="injection">INJECTABLE</span>
       * @param  {string|object} field The name of the series to remove -OR- the series object itself.
       * @param  {CIQ.ChartEngine.Chart} [chart] The chart object from which to remove the series
       * @memberof CIQ.ChartEngine
       * @since
       * <br>&bull; 4.0.0 Now supports passing a series descriptor instead of a field
       * <br>&bull; 4.0.0 Series data is now totally removed from masterData if no longer used by any other renderers.
       * <br>&bull; 4.0.0 Empty renderers are now removed when series are removed
       */
      CIQ.ChartEngine.prototype.removeSeries = function(field, chart) {
        if (this.runPrepend('removeSeries', arguments)) return

        var toRemove
        var deleted = false

        if (typeof field === 'object') {
          toRemove = field.id
          chart = chart || this.charts[field.parameters.chartName]
        } else {
          toRemove = field
          chart = chart || this.chart
        }

        for (var r in chart.seriesRenderers) {
          var renderer = chart.seriesRenderers[r]
          for (var sp = renderer.seriesParams.length - 1; sp >= 0; sp--) {
            var series = renderer.seriesParams[sp]
            if (series.id === toRemove) {
              renderer.removeSeries(toRemove)
              if (renderer.seriesParams.length < 1)
                this.removeSeriesRenderer(renderer)
              deleted = true
            }
          }
        }
        if (!deleted) this.deleteSeries(toRemove, chart) // just in case the renderer didn't...
        this.draw()
        this.runAppend('removeSeries', arguments)
      }

      //@deprecated, use static version
      CIQ.ChartEngine.prototype.isDailyInterval = function(interval) {
        console.warn(
          'CIQ.ChartEngine.prototype.isDailyInterval has been deprecated. Use use static version insted'
        )
        return CIQ.ChartEngine.isDailyInterval(interval)
      }

      /**
       * <span class="injection">INJECTABLE</span>
       * Sets the data granularity (periodicity) and displays the resulting chart.
       *
       * If a quoteFeed has been attached to the chart (see {@link CIQ.ChartEngine#attachQuoteFeed} ) , it will be called to get the new data, otherwise this.dataCallback will
       * be called in an effort to fetch new data. See {@link CIQ.ChartEngine#dataCallback}. If neither one is set and new data is needed, the function will fail.
       *
       * This function can be called together with newChart() by setting the proper parameter values. See example in this section and {@link CIQ.ChartEngine#newChart} for more details and compatibility with your current version.
       *
       * The kernel is capable of deriving weekly and monthly charts by rolling-up daily data. Set {@link CIQ.ChartEngine#dontRoll} to true to bypass this
       * functionality if you have raw week and month data in the masterData.
       *
       * It is important to not that by default the weekly roll-ups start on Sunday unless a market definition exists to indicate Sunday is not a market day,
       * then they are shifted to the next market day which is Monday. Instructions to set a market for the chart can be found here: {@link CIQ.Market}
       *
       * **See {@link CIQ.ChartEngine#createDataSet} for additional details on the roll-up process including important notes on rolling-up data with gaps.**
       *
       * This function will not set how much data you want the chart to show on the screen; for that you can use {@link CIQ.ChartEngine#setRange} or {@link CIQ.ChartEngine#setSpan}.
       *
       * **Note on 'tick' timeUnit:**<BR>
       * When using 'tick', please note that this is not a time based display, as such, there is no way to predict what the time for the next tick will be.
       * It can come a second later, a minute later or even more depending on how active a particular instrument may be.
       * If using the future tick functionality ( {@link CIQ.ChartEngine.XAxis#futureTicks} ) when in 'tick' mode, the library uses a pre-defined number (  {@link CIQ.ChartEngine.XAxis#futureTicksInterval} )for deciding what time interval to use for future ticks.
       * See below example on how to override this default.
       *
       * @example
       * // each bar on the screen will represent 15 minutes (combining 15 1-minute bars from your server)
       * stxx.setPeriodicity({period:15, timeUnit:"minute"}, function(err){});
       *
       * @example
       * // each bar on the screen will represent 15 minutes (a single 15 minute bar from your server)
       * stxx.setPeriodicity({period:1, timeUnit:"minute", interval:15}, function(err){});
       *
       * @example
       * // each bar on the screen will represent 30 minutes formed by combining two 15-minute bars; each masterData element represening 15 minutes.
       * stxx.setPeriodicity({period:2, timeUnit:"minute", interval:15}, function(err){});
       *
       * @example
       * // each bar on the screen will represent 1 tick and no particular grouping will be done.
       * stxx.setPeriodicity({period:1, timeUnit:"tick"}, function(err){});
       *
       * @example
       * // each bar on the screen will represent 1 day. MasterData elements will represent one day each.
       * stxx.setPeriodicity({period:1, timeUnit:"day"}, function(err){});
       *
       * @example
       * // this sets the periodicity to 5 minute bars when newChart is called
       * stxx.newChart(
       * 		newSymbol,
       * 		null,
       * 		null,
       * 		finishedLoadingNewChart(
       * 			stxx.chart.symbol,
       * 			newSymbol
       * 		),
       * 		{
       * 			span:{base:'day', multiplier:2},		// this parameter will cause newChart to call setSpan with these parameters
       * 			periodicity:{period:1, timeUnit:"minute", interval:5}	// this parameter will cause newChart to call setPeriodicity with these parameters
       * 		}
       * );
       *
       * @example
       * //How to override stxx.chart.xAxis.futureTicksInterval when in 'tick' mode:
       * var stxx=new CIQ.ChartEngine({container:$$$(".chartContainer"), layout:{"candleWidth": 16, "crosshair":true}});
       * stxx.chart.xAxis.futureTicksInterval=1; // to set to 1 minute, for example
       *
       * @param {object} params periodicity arguments
       * @param {number} params.period The number of elements from masterData to roll-up together into one data point on the chart (candle,bar, etc). If set to 30 in a candle chart, for example, each candle will represent 30 raw elements of `interval/timeUnit` type.
       * @param {string} [params.timeUnit] Type of data requested. Valid values are "millisecond","second","minute","day","week", "month" or 'tick'. If not set, will default to "minute". ** "hour" is NOT a valid timeUnit. Use `timeUnit:"minute", interval:60` instead**
       * @param {string} [params.interval] Further qualifies pre-rolled details of intra-day `timeUnits` ("millisecond","second","minute") and will be converted to “1” if used with "day","week" or  "month" 'timeUnit'. Some feeds provide data that is already rolled up. For example, there may be a feed that provides 5 minute bars. To let the chart know you want that 5-minute bar from your feed instead of having the chart get individual 1 minute bars and roll them up, you would set the `interval` to '5' and `timeUnit` to 'minute'
       * @param {function} [cb] Optional callback after periodicity is changed. First parameter of callback will be null unless there was an error.
       * @memberof CIQ.ChartEngine
       * @since
       * <br>&bull; 3.0.0 replaces {@link CIQ.ChartEngine#setPeriodicityV2}.
       * <br>&bull; 4.0.0 now uses {@link CIQ.ChartEngine#needDifferentData} to determine if new data should be fetched.
       */
      CIQ.ChartEngine.prototype.setPeriodicity = function(params, cb) {
        if (this.runPrepend('setPeriodicity', arguments)) return

        var period,
          interval,
          timeUnit = null
        if (params && typeof params == 'object') {
          period = params.period
          interval = params.interval
          timeUnit = params.timeUnit
        } else {
          period = params
          interval = cb
          cb = arguments[arguments.length - 1]
          if (arguments.length > 3) timeUnit = arguments[2]
        }
        if (typeof cb !== 'function') cb = null

        var internalPeriodicity = CIQ.cleanPeriodicity(
          period,
          interval,
          timeUnit
        )
        period = internalPeriodicity.period
        interval = internalPeriodicity.interval
        timeUnit = internalPeriodicity.timeUnit

        var layout = this.layout,
          cw = layout.candleWidth
        var switchInterval = false

        layout.setSpan = {} // No longer in a span if we've set a specific periodicity
        layout.range = {} // No longer in a range if we've set a specific periodicity

        this.chart.inflectionPoint = null // reset where the consolidation occurs from
        var getDifferentData = false

        if (this.chart.symbol) {
          getDifferentData = this.needDifferentData({
            periodicity: period,
            interval: interval,
            timeUnit: timeUnit,
          })
        }

        layout.periodicity = period
        layout.interval = interval
        layout.timeUnit = timeUnit

        if (getDifferentData) {
          this.changeOccurred('layout')
          if (this.quoteDriver) {
            for (var c in this.charts) {
              if (this.charts[c].symbol) {
                if (this.displayInitialized)
                  this.quoteDriver.newChart(
                    {
                      symbol: this.charts[c].symbol,
                      symbolObject: this.charts[c].symbolObject,
                      chart: this.charts[c],
                    },
                    cb
                  )
                else
                  this.newChart(this.charts[c].symbol, null, this.charts[c], cb)
              }
            }
          } else if (this.dataCallback) {
            this.dataCallback()
            if (cb) cb(null)
          } else {
            console.log(
              'cannot change periodicity because neither dataCallback or quoteDriver are set'
            )
          }
          return
        }

        var chartName, chart
        for (chartName in this.charts) {
          chart = this.charts[chartName]
          var dataSegment = chart.dataSegment,
            dataSet = chart.dataSet,
            maxTicks = chart.maxTicks,
            scroll = chart.scroll
          var dataSegmentLength = dataSegment ? dataSegment.length : 0,
            dataSetLength = dataSet ? dataSet.length : 0
          var dt
          var pos = Math.round(chart.maxTicks / 2)
          this.setCandleWidth(cw, chart)
          var centerMe = true,
            rightAligned = false
          if (scroll <= maxTicks)
            // don't attempt to center the chart if we're scrolled into the future
            centerMe = false
          else if (dataSegment && !dataSegment[pos]) {
            // don't attempt to center the chart if we're scrolled into the past
            centerMe = false
            rightAligned = scroll - dataSetLength // We'll use this to keep the same amount of right alignment
          }

          if (centerMe && dataSegmentLength > 0) {
            if (
              maxTicks <
              (Math.round(this.chart.width / cw - 0.499) - 1) / 2
            ) {
              pos = dataSegmentLength - 1
            }
            if (pos >= dataSegmentLength) {
              dt = dataSegment[dataSegmentLength - 1].DT
              pos = dataSegmentLength - 1
            } else {
              dt = dataSegment[pos].DT
            }
          }

          this.createDataSet()

          if (centerMe) {
            // If we're scrolled somewhere into the middle of the chart then we will keep the chart centered as we increase or decrease periodicity
            if (dataSegmentLength > 0) {
              for (var i = dataSetLength - 1; i >= 0; i--) {
                var nd = dataSet[i].DT
                if (nd.getTime() < dt.getTime()) {
                  chart.scroll = dataSetLength - i + pos
                  break
                }
              }
            }
          } else if (!rightAligned) {
            var wsInTicks = Math.round(this.preferences.whitespace / cw)
            chart.scroll = maxTicks - wsInTicks - 1 // Maintain the same amount of left alignment
          } else {
            chart.scroll = dataSet.length + rightAligned // Maintain the same amount of right alignment
          }
        }

        if (this.displayInitialized) this.draw()
        this.changeOccurred('layout')

        if (this.quoteDriver) {
          for (chartName in this.charts) {
            chart = this.charts[chartName]
            if (chart.symbol && chart.moreAvailable) {
              this.quoteDriver.checkLoadMore(chart)
            }
          }
        }
        if (cb) cb(null)
        this.runAppend('setPeriodicity', arguments)
      }

      /**
       * <span class="injection">INJECTABLE</span>
       * **Legacy** function to set the periodicity and interval for the chart.
       *
       * **Replaced by {@link CIQ.ChartEngine#setPeriodicity}, but maintained for backwards comparibility. Uses same function signature.**
       *
       * @param {number} period The number of elements from masterData to roll-up together into one data point on the chart (one candle, for example). If set to 30 in a candle chart, for example, each candle will represent 30 raw elements of `interval` type.
       * @param {string} interval The type of data to base the `period` on. This can be a numeric value representing minutes, seconds or millisecond as inicated by `timeUnit`, "day","week", "month" or 'tick' for variable time x-axis. ** "hour" is NOT a valid interval.** (This is not how much data you want the chart to show on the screen; for that you can use {@link CIQ.ChartEngine#setRange} or {@link CIQ.ChartEngine#setSpan})
       * @param {string} [timeUnit] Optional time unit to further qualify the specified numeric interval. Valid values are "millisecond","second","minute",null. If not set, will default to "minute". ** only applicable and used on numeric intervals**
       * @param {function} [cb] Optional callback after periodicity is changed. First parameter of callback will be null unless there was an error.
       * @memberof CIQ.ChartEngine
       * @since
       * <br>&bull; 2015-11-1 `second` and `millisecond` periodicities are now supported by setting the `timeUnit` parameter.
       * <br>&bull; 3.0.0 Replaced by {@link CIQ.ChartEngine#setPeriodicity}, but maintained for backwards comparibility.
       */
      CIQ.ChartEngine.prototype.setPeriodicityV2 = function(
        period,
        interval,
        timeUnit,
        cb
      ) {
        if (typeof timeUnit === 'function') {
          cb = timeUnit // backward compatibility
          timeUnit = null
        }
        if (this.runPrepend('setPeriodicityV2', arguments)) return
        this.setPeriodicity(period, interval, timeUnit, cb)
        this.runAppend('setPeriodicityV2', arguments)
      }

      /**
       * <span class="injection">INJECTABLE</span>
       * <span class="animation">Animation Loop</span>
       * Draws the drawings (vectors). Each drawing is iterated and asked to draw itself. Drawings are automatically
       * clipped by their containing panel.
       * @memberof CIQ.ChartEngine.AdvancedInjectable#
       * @alias drawVectors
       */
      CIQ.ChartEngine.prototype.drawVectors = function() {
        if (this.vectorsShowing) return
        if (this.runPrepend('drawVectors', arguments)) return
        this.vectorsShowing = true
        if (!this.chart.hideDrawings) {
          var tmpPanels = {}
          // First find all the existing panels in the given set of drawings (excluding those that aren't displayed)
          var panelName, i
          for (i = 0; i < this.drawingObjects.length; i++) {
            var drawing = this.drawingObjects[i]
            if (this.repositioningDrawing === drawing) continue // don't display a drawing that is currently being repositioned because it will show on the tempCanvas
            panelName = drawing.panelName
            if (
              !this.panels[drawing.panelName] ||
              this.panels[drawing.panelName].hidden
            )
              continue // drawing from a panel that is not enabled
            if (!tmpPanels[panelName]) {
              tmpPanels[panelName] = []
            }
            tmpPanels[panelName].push(drawing)
          }
          // Now render all the drawings in those panels, clipping each panel
          for (panelName in tmpPanels) {
            this.startClip(panelName)
            var arr = tmpPanels[panelName]
            for (i = 0; i < arr.length; i++) {
              arr[i].render(this.chart.context)
            }
            this.endClip()
          }
        }
        this.runAppend('drawVectors', arguments)
      }

      // Constant bitmask for bar evaluation
      CIQ.ChartEngine.NONE = 0 // no evaluation (black bars)
      CIQ.ChartEngine.CLOSEUP = 1 // today's close greater than yesterday's close
      CIQ.ChartEngine.CLOSEDOWN = 2 // today's close less than yesterday's close
      CIQ.ChartEngine.CLOSEEVEN = 4 // today's close the same as yesterday's close
      CIQ.ChartEngine.CANDLEUP = 8 // today's close greater than today's open
      CIQ.ChartEngine.CANDLEDOWN = 16 // today's close less than today's open
      CIQ.ChartEngine.CANDLEEVEN = 32 // today's close equal to today's open

      /**
       * <span class="injection">INJECTABLE</span>
       * <span class="animation">Animation Loop</span>
       * Displays the chart by calling the main series renderer.
       *
       * The following styles are used for determining color and/or line width:
       *
       * - `kagi` :
       * `stx_kagi_up`, `stx_kagi_down`
       *
       * - `pandf` :
       * `stx_pandf_up`, `stx_pandf_down`
       *
       * - `line` and `step` :
       * `stx_line_chart`
       *
       * - `colored_mountain` :
       * `stx_colored_mountain_chart`,`stx_line_up`,`stx_line_down`
       *
       * - `colored_line` and `colored_step` :
       * `stx_line_chart`,`stx_line_up`,`stx_line_down`
       *
       * - `bar` and `hlc` :
       * `stx_bar_chart`
       *
       * - `colored_bar` and `colored_hlc` :
       * `stx_bar_chart`,`stx_bar_up`,`stx_bar_down`,`stx_bar_even`
       *
       * - `hollow_candle` and `volume_candle` :
       * `stx_hollow_candle_up`, `stx_hollow_candle_down`,`stx_hollow_candle_even`
       *
       * - `candle` :
       * `stx_candle_shadow_up`,`stx_candle_shadow_down`,`stx_candle_shadow`,`stx_candle_up`,`stx_candle_down`
       *
       * - `histogram` :
       * `stx_histogram_up`,`stx_histogram_down`,`stx_histogram_even`
       *
       * - `baseline_delta` :
       * `stx_baseline_up`,`stx_baseline_down`
       *
       * - `baseline_delta_mountain` :
       * `stx_baseline_delta_mountain`,`stx_baseline_up`,`stx_baseline_down`
       *
       * @param  {CIQ.ChartEngine.Chart} chart The chart to render
       * @memberof CIQ.ChartEngine.AdvancedInjectable#
       * @alias displayChart
       * @since 4.0.0 if no Open price is available, a candle will draw as a dash at the Close price.
       * @since 5.1.0 reduced to injections only for backwards compatibility, main chart is drawn with renderers now
       */
      CIQ.ChartEngine.prototype.displayChart = function(chart) {
        if (this.runPrepend('displayChart', arguments)) return
        this.rendererAction(chart, 'main')
        this.runAppend('displayChart', arguments)
      }

      /**
       * Calculates the ATR (Average True Range) for the dataSet
       * @private
       * @param  {CIQ.ChartEngine.Chart} chart The chart to calculate
       * @param  {number} period The number of periods
       * @param  {array} data The data to process, if omitted, uses chart.dataSet
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.calculateATR = function(chart, period, data) {
        if (!data) data = chart.dataSet
        var state = chart.state.calculations.atr
        if (!state) state = chart.state.calculations.atr = {}
        if (!period) period = 20
        var accum = []
        if (state.accum) accum = state.accum
        var q1
        for (var i = 0; i < data.length; i++) {
          var q = data[i]
          q1 = i ? data[i - 1] : state.q1
          if (!q1) continue

          var trueRange = Math.max(
            q.High - q.Low,
            Math.abs(q.High - q1.Close),
            Math.abs(q.Low - q1.Close)
          )
          if (accum.length < period) {
            if (accum.push(trueRange) == period) {
              var total = 0
              for (var j = 0; j < accum.length; j++) total += accum[j]
              q.atr = total / period
            }
          } else {
            q.atr = (q1.atr * (period - 1) + trueRange) / period
          }
          q.trueRange = trueRange
        }
        chart.state.calculations.atr = {
          accum: accum,
          q1: q1,
        }
      }

      /**
       * Calculates the Median Price for the dataSet.
       * @private
       * @param {CIQ.ChartEngine.Chart} chart The chart to update.
       * @param {array} data The data to process, if omitted, uses chart.dataSet
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.calculateMedianPrice = function(chart, data) {
        if (!data) data = chart.dataSet
        var d
        for (var i = 0; i < data.length; ++i) {
          d = data[i]
          d['hl/2'] = (d.High + d.Low) / 2
        }
      }

      /**
       * Calculates the Typical Price for the dataSet.
       * @private
       * @param {CIQ.ChartEngine.Chart} chart The chart to update.
       * @param {array} data The data to process, if omitted, uses chart.dataSet
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.calculateTypicalPrice = function(chart, data) {
        if (!data) data = chart.dataSet
        var d
        for (var i = 0; i < data.length; ++i) {
          d = data[i]
          d['hlc/3'] = (d.High + d.Low + d.Close) / 3
        }
      }

      /**
       * Calculates the Weighted Close for the dataSet.
       * @private
       * @param {CIQ.ChartEngine.Chart} chart The chart to update.
       * @param {array} data The data to process, if omitted, uses chart.dataSet
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.calculateWeightedClose = function(chart, data) {
        if (!data) data = chart.dataSet
        var d
        for (var i = 0; i < data.length; ++i) {
          d = data[i]
          d['hlcc/4'] = (d.High + d.Low + 2 * d.Close) / 4
        }
      }

      /**
       * Calculates the (Open + High + Low + Close) / 4 for the dataSet.
       * @private
       * @param {CIQ.ChartEngine.Chart} chart The chart to update.
       * @param {array} data The data to process, if omitted, uses chart.dataSet
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.calculateOHLC4 = function(chart, data) {
        if (!data) data = chart.dataSet
        var d
        for (var i = 0; i < data.length; ++i) {
          d = data[i]
          d['ohlc/4'] = (d.Open + d.High + d.Low + d.Close) / 4
        }
      }

      /**
       * Returns the current quote (the final element in the dataSet).
       * @return {object} The most recent quote
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.currentQuote = function() {
        if (!this.chart.dataSet) return null
        for (var i = this.chart.dataSet.length - 1; i >= 0; i--)
          if (this.chart.dataSet[i]) return this.chart.dataSet[i]
        return null
      }

      /**
       * <span class="injection">INJECTABLE</span>
       * <span class="animation">Animation Loop</span>
       * This method ensures that the chart is not scrolled off of either of the vertical edges.
       * See {@link CIQ.ChartEngine#minimumLeftBars}, {@link CIQ.ChartEngine.Chart#allowScrollPast}, and {@link CIQ.ChartEngine.Chart#allowScrollFuture} for adjustments to defaults.
       * @param  {CIQ.ChartEngine.Chart} theChart The chart to check
       * @memberof CIQ.ChartEngine.AdvancedInjectable#
       * @alias correctIfOffEdge
       */
      CIQ.ChartEngine.prototype.correctIfOffEdge = function(theChart) {
        if (this.runPrepend('correctIfOffEdge', arguments)) return
        for (var chartName in this.charts) {
          var chart = this.charts[chartName],
            dataSet = chart.dataSet,
            maxTicks = chart.maxTicks,
            layout = this.layout

          var minimumLeftBars = this.minimumLeftBars
          if (
            (!this.mainSeriesRenderer ||
              !this.mainSeriesRenderer.standaloneBars) &&
            !this.standaloneBars[layout.chartType]
          ) {
            //[Gus]
            //since lines display at the middle of the bar insted of the edge, we deduct one to allow for the 1/2 bar to still be considered or it will try to flush incorrectly.
            //this logic may need to change if we modify home() to use the same logic for micropixel as the manual drag.
            //drag sets one more scroll with a negative micropixel to offset the right edge, but home() uses the actual scroll with a positive micropixel.
            minimumLeftBars--
          }

          var leftPad = Math.min(minimumLeftBars, maxTicks) // in case the minimumLeftBars is larger than what we can display
          if (chart.allowScrollPast) {
            // allow scrolling from left to right, creating white space on either side
            var rightPad = maxTicks - leftPad
            if (leftPad > dataSet.length) {
              rightPad = maxTicks - dataSet.length
            }
            if (chart.scroll - rightPad >= dataSet.length) {
              chart.scroll = dataSet.length + rightPad - 1
              this.micropixels = 0
            }
            if (chart.scroll <= leftPad) {
              chart.scroll = leftPad
              this.micropixels = 0
            }
          } else {
            // earliest point in time is always anchored on left side of chart
            if (chart.scroll < leftPad) {
              chart.scroll = leftPad
            }
            if (chart.scroll > dataSet.length) {
              chart.scroll = dataSet.length
            }
          }
          if (chart.allowScrollFuture === false) {
            var whitespace = this.getLabelOffsetInPixels(
              chart,
              layout.chartType
            )
            var barsOnScreen =
              maxTicks - Math.round(whitespace / layout.candleWidth) - 1
            var scroll = this.micropixels < 0 ? chart.scroll - 1 : chart.scroll
            if (scroll < barsOnScreen) {
              chart.scroll = barsOnScreen
              this.micropixels = 0
            }
          }
        }
        this.runAppend('correctIfOffEdge', arguments)
      }

      /**
       * <span class="injection">INJECTABLE</span>
       * <span class="animation">Animation Loop</span>
       * Creates the dataSegment. The dataSegment is a copy of the portion of the dataSet that is observable in the
       * current chart. That is, the dataSegment is a "view" into the dataSet. chart.scroll and chart.maxTicks are the
       * primary drivers for this method.
       * @param  {CIQ.ChartEngine.Chart} [theChart] If passed then a data segment will be created just for that chart, otherwise all charts
       * @memberof CIQ.ChartEngine.AdvancedInjectable#
       * @alias createDataSegment
       */
      CIQ.ChartEngine.prototype.createDataSegment = function(theChart) {
        if (this.runPrepend('createDataSegment', arguments)) return
        var chart
        for (var chartName in this.charts) {
          chart = this.charts[chartName]
          if (theChart) chart = theChart

          if (chart.isComparison)
            CIQ.Comparison.createComparisonSegmentInner(this, chart)

          var dataSet = chart.dataSet,
            baseline = chart.baseline,
            scroll = chart.scroll,
            maxTicks = chart.maxTicks
          var layout = this.layout,
            cw = layout.candleWidth
          baseline.actualLevel = baseline.userLevel
            ? baseline.userLevel
            : baseline.defaultLevel
          /*
			chart.baseline.includeInDataSegment forces a line chart (usually a baseline chart) to begin inside the chart
			whereas normally the first point in a line chart is off the left edge of the screen.
			 */
          var dataSegmentStartsOneBack =
            baseline.includeInDataSegment &&
            (!this.mainSeriesRenderer ||
              !this.mainSeriesRenderer.standaloneBars) &&
            !this.standaloneBars[layout.chartType]
          var quote
          var dataSegment = (chart.dataSegment = [])
          var position = dataSet.length - 1 - scroll - 1 // One more to deal with -1 case
          var prevField = chart.defaultPlotField
          for (var i = -1; i < scroll && i < maxTicks; i++) {
            position++
            if (i == -1 && !dataSegmentStartsOneBack) continue
            if (position < dataSet.length && position >= 0) {
              quote = dataSet[position]
              quote.candleWidth = null
              dataSegment.push(quote)
              if (baseline.actualLevel === null && i >= 0) {
                if (prevField && prevField != 'Close') {
                  var q1 = dataSet[position - 1]
                  if (q1[prevField] || q1[prevField] === 0)
                    baseline.actualLevel = q1[prevField]
                } else {
                  if (quote.iqPrevClose || quote.iqPrevClose === 0)
                    baseline.actualLevel = quote.iqPrevClose
                }
              }
            } else if (position < 0) {
              dataSegment.push(null)
            }
          }
          chart.segmentImage = null
          var mainSeriesRenderer = this.mainSeriesRenderer || {}
          if (mainSeriesRenderer.params && mainSeriesRenderer.params.volume) {
            var totalVolume = 0
            var workingWidth =
              chart.width -
              (maxTicks - dataSegment.length - 1) * layout.candleWidth
            for (var v = 0; v < dataSegment.length; v++) {
              quote = dataSegment[v]
              if (quote) totalVolume += quote.Volume
            }
            var accumOffset = 0
            chart.segmentImage = []
            for (var w = 0; w < dataSegment.length; w++) {
              quote = dataSegment[w]
              chart.segmentImage[w] = {}
              var leftOffset = null
              if (quote) {
                if (quote.Volume) {
                  quote.candleWidth =
                    (workingWidth * quote.Volume) / totalVolume
                  leftOffset = accumOffset + quote.candleWidth / 2
                  accumOffset += quote.candleWidth
                } else {
                  quote.candleWidth = cw
                  leftOffset = accumOffset + cw / 2
                  accumOffset += cw
                }
                chart.segmentImage[w] = {
                  tick: quote.tick,
                  candleWidth: quote.candleWidth,
                  leftOffset: leftOffset,
                }
              } else {
                accumOffset += cw
              }
            }
          }
          if (theChart) break
        }
        if (chart && chart.isComparison) this.clearPixelCache()
        this.positionCrosshairsAtPointer()
        this.runAppend('createDataSegment', arguments)
      }

      /**
       * Returns the tick position of the leftmost position on the chart.
       * @return {number} The tick for the leftmost position
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.leftTick = function() {
        return this.chart.dataSet.length - this.chart.scroll
      }

      /**
       * Returns the offset from the left side of the screen for the first element
       * on the chart screen. Most times this will be zero except when a user has scrolled
       * past the end of the chart in which case it will be a positive number. This can be used
       * to recreate a saved chart.
       * @return {number} The offset from the left of the chart.
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.getStartDateOffset = function() {
        for (var ds = 0; ds < this.chart.dataSegment.length; ds++) {
          if (this.chart.dataSegment[ds]) {
            return ds
          }
        }
        return 0
      }

      /**
       * Scrolls the chart so that the leftmost tick is the requested date.
       * The date must be an exact match and data for that bar must already be loaded in the chart.
       * There is no effect if the date is not found an the engine will not attempt to fetch more data.
       * @param {date} dt The requested date
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.setStartDate = function(dt) {
        for (var i = 0; i < this.chart.dataSet.length; i++) {
          var bar = this.chart.dataSet[i]
          if (bar.DT.getTime() == dt.getTime()) {
            this.chart.scroll = this.chart.dataSet.length - i
            this.draw()
            return
          }
        }
      }

      //@private
      CIQ.ChartEngine.prototype.updateListeners = function(event) {
        for (var i in this.plugins) {
          var plugin = this.plugins[i]
          if (plugin.display && plugin.listener) plugin.listener(this, event)
        }
      }

      //@private
      CIQ.ChartEngine.prototype.clearPixelCache = function() {
        for (var x in this.panels) {
          var panel = this.panels[x]
          panel.cacheHigh = null
          panel.cacheLow = null
          panel.cacheLeft = 1000000
          panel.cacheRight = -1
        }
        for (var chartName in this.charts) {
          var chart = this.charts[chartName]
          if (!chart.dataSet) continue
          for (var i = 0; i < chart.dataSet.length; i++) {
            chart.dataSet[i].cache = {}
          }
        }
      }

      /**
       * Creates a label on the y-axis unless {@link CIQ.ChartEngine.YAxis#drawPriceLabels} is false.
       * This can be used for any panel and called multiple times to add multiple labels
       *
       * Style: stx_yaxis ( font only )
       *
       * @param  {CIQ.ChartEngine.Panel} panel			The panel on which to print the label
       * @param  {string} txt				The text for the label
       * @param  {number} y				The Y position on the canvas for the label. This method will ensure that it remains on the requested panel.
       * @param  {string} backgroundColor The background color for the label.
       * @param  {string} color			The foreground color for the label. If none provided then white is used, unless the background is white in which case black is used.
       * @param  {external:CanvasRenderingContext2D} [ctx]		 The canvas context to use, defaults to the chart
       * @param {CIQ.ChartEngine.YAxis} [yAxis] Optionally specifiy which yAxis if there are multiple for the panel
       * @memberof CIQ.ChartEngine
       * @since 3.0.0 - Moved text rendering to {@link CIQ.createLabel}
       */
      CIQ.ChartEngine.prototype.createYAxisLabel = function(
        panel,
        txt,
        y,
        backgroundColor,
        color,
        ctx,
        yAxis
      ) {
        if (panel.yAxis.drawPriceLabels === false || panel.yAxis.noDraw) return
        var yax = yAxis ? yAxis : panel.yAxis
        var context = ctx ? ctx : this.chart.context
        var margin = 3
        var height = this.getCanvasFontSize('stx_yaxis') + margin * 2
        this.canvasFont('stx_yaxis', context)
        var drawBorders = yax.displayBorder
        var tickWidth = this.drawBorders ? 3 : 0 // pixel width of tick off edge of border
        var width
        try {
          width = context.measureText(txt).width + tickWidth + margin * 2
        } catch (e) {
          width = yax.width
        } // Firefox doesn't like this in hidden iframe

        var x = yax.left - margin + 3
        var textx = x + margin + tickWidth
        var radius = 3
        var position =
          yax.position === null ? panel.chart.yAxis.position : yax.position
        if (position === 'left') {
          x = yax.left + yax.width + margin - 3
          width = width * -1
          textx = x
          radius = -3
          context.textAlign = 'right'
        }
        if (y + height / 2 > yax.bottom) y = yax.bottom - height / 2
        if (y - height / 2 < yax.top) y = yax.top + height / 2

        if (typeof CIQ[this.yaxisLabelStyle] == 'undefined') {
          this.yaxisLabelStyle = 'roundRectArrow' // in case of user error, set a default.
        }
        var yaxisLabelStyle = this.yaxisLabelStyle
        if (yax.yaxisLabelStyle) yaxisLabelStyle = yax.yaxisLabelStyle
        var params = {
          ctx: context,
          x: x,
          y: y,
          top: y - height / 2,
          width: width,
          height: height,
          radius: radius,
          backgroundColor: backgroundColor,
          fill: true,
          stroke: false,
          margin: { left: textx - x, top: 1 },
          txt: txt,
          color: color,
        }
        CIQ[yaxisLabelStyle](params)
      }

      /**
       * Creates a label on the x-axis. Generally used for drawing labels.
       *
       * Note: **This is not used for the floating crosshair date label wich is styled using `stx-float-date` ** See {@link CIQ.ChartEngine.AdvancedInjectable#updateChartAccessories} and {@link CIQ.ChartEngine.AdvancedInjectable#headsUpHR} for more details
       *
       * Label style: `stx-float-date` ( font only )
       *
       * @param  {CIQ.ChartEngine.Panel} panel			The panel on which to print the label
       * @param  {string} txt				The text for the label
       * @param  {number} x				The X position on the canvas for the label. This method will ensure that it remains on the requested panel.
       * @param  {string} backgroundColor The background color for the label.
       * @param  {string} color			The foreground color for the label. If none provided then white is used, unless the background is white in which case black is used.
       * @param  {boolean} pointed		True to put an arrow above the label
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.createXAxisLabel = function(
        panel,
        txt,
        x,
        backgroundColor,
        color,
        pointed
      ) {
        var context = this.chart.context
        var margin = 2
        var fontstyle = 'stx-float-date' //or stx_xaxis
        var height = this.getCanvasFontSize(fontstyle) + margin * 2
        this.canvasFont(fontstyle, context)
        var width
        try {
          width = context.measureText(txt).width + margin * 2
        } catch (e) {
          width = 0
        } // Firefox doesn't like this in hidden iframe
        var y = panel.top + panel.height - height //-margin;
        if (x + width / 2 < panel.left || x - width / 2 > panel.right) return //hopelessly out of bounds
        if (!pointed) {
          if (x + width / 2 > panel.right) x = panel.right - width / 2
          if (x - width / 2 < panel.left) x = panel.left + width / 2
        }
        context.fillStyle = backgroundColor
        CIQ.roundRect({
          ctx: context,
          x: x - width / 2,
          top: y,
          width: width,
          height: height,
          radius: 3,
          fill: true,
        })
        var arrowHeight = panel.bottom - panel.yAxis.bottom - height
        context.beginPath()
        if (pointed) {
          context.moveTo(x - arrowHeight, y)
          context.lineTo(x, y - arrowHeight - 1)
          context.lineTo(x + arrowHeight, y)
          context.closePath()
          context.fill()
        } else {
          context.moveTo(x, y)
          context.lineTo(x, y - arrowHeight)
          context.strokeStyle = backgroundColor
          context.stroke()
        }
        context.textBaseline = 'top'
        context.fillStyle = color
          ? color
          : CIQ.chooseForegroundColor(backgroundColor)
        if (context.fillStyle == backgroundColor) {
          // Best effort to pick a foreground color that isn't the same as the background!
          if (backgroundColor.toUpperCase() == '#FFFFFF')
            context.fillStyle = '#000000'
          else context.fillStyle = '#FFFFFF'
        }
        context.fillText(txt, x - width / 2 + margin, y + margin)
      }

      /**
       * <span class="injection">INJECTABLE</span>
       * <span class="animation">Animation Loop</span>
       * Draws a label for the last price <b>in the main chart panel's y-axis</b> using {@link CIQ.ChartEngine#createYAxisLabel}
       *
       * It will also draw a horizontal price line if {@link CIQ.ChartEngine#preferences.currentPriceLine} is true.
       *
       * It will not draw a line or a label if {@link CIQ.ChartEngine.YAxis#drawCurrentPriceLabel} is false for that particular axis.
       *
       * Label style: `stx_current_hr_down` and `stx_current_hr_up`
       *
       * @memberof CIQ.ChartEngine.AdvancedInjectable#
       * @alias drawCurrentHR
       */
      CIQ.ChartEngine.prototype.drawCurrentHR = function() {
        if (this.runPrepend('drawCurrentHR', arguments)) return
        var backgroundColor, color
        var mainSeriesRenderer = this.mainSeriesRenderer || {}
        var highLowBars =
          mainSeriesRenderer.highLowBars ||
          this.highLowBars[this.layout.chartType]
        for (var chartName in this.charts) {
          var chart = this.charts[chartName]
          var panel = chart.panel
          var yAxis = panel.yAxis
          if (panel.hidden) continue
          if (yAxis.drawCurrentPriceLabel === false || yAxis.noDraw) continue
          if (!mainSeriesRenderer.params) continue
          var whichSet = yAxis.whichSet
          if (!whichSet) whichSet = 'dataSet'
          var l = chart[whichSet].length,
            cw = this.layout.candleWidth
          if (whichSet == 'dataSegment') {
            //this crazy equation just to find the last bar displaying at least 50% on the screen
            while (l > (chart.width - this.micropixels + cw / 2 + 1) / cw) l--
          }
          if (l && chart[whichSet][l - 1]) {
            var field = chart.defaultPlotField
            if (!field || highLowBars) field = 'Close'
            var prevClose, currentClose
            do {
              prevClose = chart[whichSet][l - 1][field]
              currentClose = prevClose
              if (--l === 0) break
            } while (currentClose === null)
            if (whichSet == 'dataSet' && chart.currentQuote) {
              currentClose = chart.currentQuote[field]
            } else if (chart[whichSet].length >= 2) {
              var pquote = chart[whichSet][l - 2]
              if (pquote) prevClose = pquote[field]
            }
            if (currentClose < prevClose) {
              backgroundColor = this.canvasStyle('stx_current_hr_down')
                .backgroundColor
              color = this.canvasStyle('stx_current_hr_down').color
            } else {
              backgroundColor = this.canvasStyle('stx_current_hr_up')
                .backgroundColor
              color = this.canvasStyle('stx_current_hr_up').color
            }
            if (chart.transformFunc)
              currentClose = chart.transformFunc(this, chart, currentClose)
            var txt
            // If a chart panel, then always display at least the number of decimal places as calculated by masterData (panel.chart.decimalPlaces)
            // but if we are zoomed to high granularity then expand all the way out to the y-axis significant digits (panel.yAxis.printDecimalPlaces)
            var labelDecimalPlaces = Math.max(
              panel.yAxis.printDecimalPlaces,
              panel.chart.decimalPlaces
            )
            //	... and never display more decimal places than the symbol is supposed to be quoting at
            if (yAxis.maxDecimalPlaces || yAxis.maxDecimalPlaces === 0)
              labelDecimalPlaces = Math.min(
                labelDecimalPlaces,
                yAxis.maxDecimalPlaces
              )
            if (yAxis.priceFormatter) {
              txt = yAxis.priceFormatter(
                this,
                panel,
                currentClose,
                labelDecimalPlaces
              )
            } else {
              txt = this.formatYAxisPrice(
                currentClose,
                panel,
                labelDecimalPlaces
              )
            }

            var y = this.pixelFromTransformedValue(currentClose, panel)
            this.createYAxisLabel(panel, txt, y, backgroundColor, color)

            if (this.preferences.currentPriceLine === true && this.isHome()) {
              panel.chart.context.globalCompositeOperation = 'destination-over'
              this.plotLine(
                panel.left,
                panel.right,
                y,
                y,
                backgroundColor,
                'line',
                panel.chart.context,
                panel,
                {
                  pattern: 'dashed',
                  lineWidth: 1,
                  opacity: 0.8,
                }
              )
              panel.chart.context.globalCompositeOperation = 'source-over'
            }
          }
        }
        this.runAppend('drawCurrentHR', arguments)
      }

      /**
       * <span class="animation">Animation Loop</span>
       * Determines the default color for lines and studies drawn on the screen. This is black unless
       * the background color of the chart has a "value" greater than 65%.
       * The result is that this.defaultColor contains the default color.
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.getDefaultColor = function() {
        this.defaultColor = '#000000'
        var bgColor = null
        var div = this.chart.container
        while (!bgColor || CIQ.isTransparent(bgColor)) {
          var cStyle = getComputedStyle(div)
          if (!cStyle) return
          bgColor = cStyle.backgroundColor
          if (CIQ.isTransparent(bgColor)) bgColor = 'transparent'
          div = div.parentNode
          if (!div || !div.tagName) break
        }
        if (bgColor) {
          if (bgColor == 'transparent') bgColor = '#FFFFFF'
          this.containerColor = bgColor
          if (!CIQ.isTransparent(bgColor)) {
            var hsv = CIQ.hsv(bgColor)
            var v = hsv[2]
            if (v > 0.65) this.defaultColor = '#000000'
            else this.defaultColor = '#FFFFFF'
          } else {
            this.defaultColor = '#000000'
          }
        } else {
          this.containerColor = '#FFFFFF'
        }
      }

      /**
       * Charts may require asynchronous data to render. This creates a dilemma for any external
       * process that depends on a fully rendered chart (for instance a process to turn a chart into an image).
       * To solve this problem, external processes can register for a callback which will tell them when the chart
       * has been drawn. See {@link CIQ.ChartEngine.registerChartDrawnCallback}.
       *
       * To accommodate this requirement, studies, plugins or injections that render asynchronously should use startAsyncAction
       * and {@link CIQ.ChartEngine#completeAsyncAction} to inform the chart of their asynchronous activity.
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.startAsyncAction = function() {
        if (!this.pendingAsyncs) this.pendingAsyncs = []
        this.pendingAsyncs.push(true)
      }

      /**
       * Registers a callback for when the chart has been drawn
       * @param  {function} fc The function to call
       * @return {object} An object that can be passed in to {@link CIQ.ChartEngine#unregisterChartDrawnCallback}
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.registerChartDrawnCallback = function(fc) {
        if (!this.asyncCallbacks) this.asyncCallbacks = []
        this.asyncCallbacks.push(fc)
        return {
          fc: fc,
        }
      }

      /**
       * Removes a callback registration for when the chart has been drawn
       * @param  {object} fc An object from {@link CIQ.ChartEngine#registerDrawnCallback}
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.unregisterChartDrawnCallback = function(obj) {
        for (var i = 0; i < this.asyncCallbacks.length; i++) {
          if (this.asyncCallbacks[i] == obj.fc) {
            this.asyncCallbacks.splice(i, 1)
            return
          }
        }
      }

      /**
       * Makes the async callbacks only if no pending async activity
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.makeAsyncCallbacks = function() {
        if (!this.asyncCallbacks) return // no callbacks to make
        if (!this.pendingAsyncs || !this.pendingAsyncs.length) {
          // If no pending asyncs, or the array is empty (all have been fulfilled)
          for (var i = 0; i < this.asyncCallbacks.length; i++) {
            this.asyncCallbacks[i]()
          }
        }
      }
      /**
       * Studies or plugins that use asynchronous data should call this when their async activities are complete.
       * See {@link CIQ.ChartEngine#startAsyncAction}
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.completeAsyncAction = function() {
        this.pendingAsyncs.pop()
        this.makeAsyncCallbacks()
      }
      /**
       * <span class="injection">INJECTABLE</span>
       * <span class="animation">Animation Loop</span>
       * This is the main rendering function in the animation loop. It draws the chart including panels, axis, and drawings.
       * This method is called continually as a user pans or zooms the chart.
       * This would be a typical place to put an injection to add behavior to the chart after a drawing operation is complete.
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.draw = function() {
        this.debug()
        if (!this.chart.canvas) return
        if (!this.chart.dataSet) return
        if (!this.chart.canvasHeight) return
        //if(!this.useAnimation && new Date()-this.grossDragging<500) return;

        this.offset = (this.layout.candleWidth * this.candleWidthPercent) / 2
        CIQ.clearCanvas(this.chart.canvas, this)
        if (!this.masterData || !this.masterData.length) return
        if (this.runPrepend('draw', arguments)) return
        this.getDefaultColor() //TODO, don't call this in draw() but instead manually when background color is changed?
        this.vectorsShowing = false

        this.drawPanels()
        this.yAxisLabels = []
        var i, chart, chartName, plugin
        for (chartName in this.charts) {
          chart = this.charts[chartName]
          this.correctIfOffEdge()
          this.createDataSegment()
          var axisRepresentation = this.createXAxis(chart)
          this.initializeDisplay(chart)
          this.rendererAction(chart, 'calculate')
          this.renderYAxis(chart)
          this.drawXAxis(chart, axisRepresentation)

          /// Calculate tmpWidth which represents the amount of width that the candle takes, slightly less than candleWidth
          chart.tmpWidth = Math.floor(
            this.layout.candleWidth * this.candleWidthPercent
          ) // So we don't need to compute it a thousand times for every candle
          if (chart.tmpWidth % 2 === 0) {
            // assure that candles are always odd number of pixels wide
            chart.tmpWidth += 1
            if (chart.tmpWidth > this.layout.candleWidth)
              // If there isn't space then reduce further
              chart.tmpWidth -= 2
          }
          if (chart.tmpWidth < 0.5) chart.tmpWidth = 0.5

          for (i in this.plugins) {
            plugin = this.plugins[i]
            if (plugin.display) {
              if (plugin.drawUnder) plugin.drawUnder(this, chart)
            }
          }

          if (this.chart.legend) this.chart.legend.colorMap = null
          this.controls.baselineHandle.style.display = 'none'

          this.rendererAction(chart, 'yaxis')
          this.rendererAction(chart, 'underlay')
          if (CIQ.Studies) CIQ.Studies.displayStudies(this, chart, true)
          this.displayChart(chart)
          if (CIQ.Studies) CIQ.Studies.displayStudies(this, chart, false)
          this.rendererAction(chart, 'overlay')

          if (chart.legend && chart.legend.colorMap && chart.legendRenderer) {
            chart.legendRenderer(this, {
              chart: chart,
              legendColorMap: chart.legend.colorMap,
              coordinates: {
                x: chart.legend.x,
                y: chart.legend.y + chart.panel.yAxis.top,
              },
            })
          }
        }

        for (chartName in this.charts) {
          chart = this.charts[chartName]
          for (i in this.plugins) {
            plugin = this.plugins[i]
            if (plugin.display) {
              if (plugin.drawOver) plugin.drawOver(this, chart)
            }
          }
        }

        // Do this after all the drawing has taken place. That way the y-axis text sits on top of anything that
        // has been drawn underneath. For instance, if panel.yaxisCalculatedPaddingRight>0 and the y-axis sits on top of the chart
        for (var panel in this.panels) {
          if (!this.panels[panel].hidden) this.plotYAxisText(this.panels[panel])
        }
        for (var yLbl = 0; yLbl < this.yAxisLabels.length; yLbl++) {
          var labelParams = this.yAxisLabels[yLbl]
          if (
            labelParams.src == 'series' &&
            labelParams.args[6] &&
            labelParams.args[6].drawSeriesPriceLabels === false
          )
            continue
          this.createYAxisLabel.apply(this, labelParams.args)
        }
        this.createCrosshairs() //todo, move out of animation loop
        this.drawVectors()
        this.drawCurrentHR()
        this.displayInitialized = true
        if (this.controls.home) {
          this.controls.home.style.display = this.isHome() ? 'none' : 'block'
        }
        this.positionMarkers()
        for (chartName in this.charts) {
          chart = this.charts[chartName]
          if (this.quoteDriver) this.quoteDriver.checkLoadMore(chart)
        }
        this.runAppend('draw', arguments)
        this.makeAsyncCallbacks()
      }

      /**
       * This method adjusts the canvas for the current backing store. The backing store is used on "retina" style devices
       * to indicate the ratio of actual screen pixels to web pixels. The canvas is adjusted according to this ratio so that
       * pixels appear at the expected size and aren't fuzzy. Note that backing store is sometimes also employed by browsers
       * to effect changes in the size of the view.
       * @private
       * @param  {Canvas} canvas	An HTML5 canvas
       * @param  {external:CanvasRenderingContext2D} context An HTML5 canvas context
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.adjustBackingStore = function(canvas, context) {
        this.devicePixelRatio = window.devicePixelRatio || 1
        //note, let's ignore DPR<1, it is not consistently implemented on all browsers between retina and nonretina displays
        if (this.devicePixelRatio < 1.0) this.devicePixelRatio = 1.0
        var backingStoreRatio =
          context.webkitBackingStorePixelRatio ||
          context.mozBackingStorePixelRatio ||
          context.msBackingStorePixelRatio ||
          context.oBackingStorePixelRatio ||
          context.backingStorePixelRatio ||
          1

        var ratio = this.devicePixelRatio / backingStoreRatio

        if (!this.useBackingStore) {
          this.devicePixelRatio = this.adjustedDisplayPixelRatio = 1
          return
        }

        if (!CIQ.isAndroid || CIQ.is_chrome) {
          var oldWidth = canvas.width
          var oldHeight = canvas.height

          canvas.width = oldWidth * ratio
          canvas.height = oldHeight * ratio

          canvas.style.width = oldWidth + 'px'
          canvas.style.height = oldHeight + 'px'

          context.scale(ratio, ratio)
          this.adjustedDisplayPixelRatio = ratio
          this.backing = {
            ratio: ratio,
            width: canvas.width,
            height: canvas.height,
            styleWidth: oldWidth,
            styleHeight: oldHeight,
          }
        }
      }

      CIQ.ChartEngine.prototype.reconstituteBackingStore = function() {
        if (!this.useBackingStore) return
        var canvas = this.chart.canvas
        if (canvas.width == this.backing.width) return

        canvas.width = this.backing.width
        canvas.height = this.backing.height

        canvas.context.scale(this.backing.ratio, this.backing.ratio)
        this.adjustedDisplayPixelRatio = this.backing.ratio
        this.draw()
      }

      CIQ.ChartEngine.prototype.disableBackingStore = function() {
        if (!this.useBackingStore) return
        var canvas = this.chart.canvas
        if (canvas.width == this.backing.styleWidth) return

        canvas.width = this.backing.styleWidth
        canvas.height = this.backing.styleHeight

        canvas.context.scale(1, 1)
        this.adjustedDisplayPixelRatio = 1
        this.draw()
      }

      /**
       * This method resizes the canvas to the dimensions of the containing div. This is called primarily
       * by {@link CIQ.ChartEngine#resizeChart} and also when the chart is initialized (via newChart).
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.resizeCanvas = function() {
        if (!this.chart.panel) this.chart.panel = this.panels.chart
        var canvas = this.chart.canvas
        var context = this.chart.context
        if (canvas && context) {
          this.floatCanvas.height = this.chart.tempCanvas.height = canvas.height = this.chart.container.clientHeight
          this.floatCanvas.width = this.chart.tempCanvas.width = canvas.width = this.chart.container.clientWidth
          this.adjustBackingStore(canvas, context)
          this.adjustBackingStore(
            this.chart.tempCanvas,
            this.chart.tempCanvas.context
          )
          this.adjustBackingStore(this.floatCanvas, this.floatCanvas.context)
        }
        var rect = this.container.getBoundingClientRect()
        this.top = rect.top
        this.left = rect.left
        this.canvasWidth = this.chart.canvasWidth = this.chart.container.clientWidth
        this.right = this.left + this.canvasWidth
        this.height = this.chart.container.clientHeight
        this.width = this.right - this.left
        if (this.width === 0 && !this.container.dimensionlessCanvas) {
          console.log(
            'warning: zero width chart. Check CSS for chart container.'
          )
        }
        this.bottom = this.top + this.height
        this.calculateYAxisPositions()
        this.chart.canvasRight = this.right
        this.chart.canvasHeight = this.height
        var candleWidth = this.layout.candleWidth
        if (typeof candleWidth == 'undefined') candleWidth = 8
        for (var chartName in this.charts) {
          var chart = this.charts[chartName]

          this.setCandleWidth(candleWidth, chart)
          if (chart.scroll < chart.width / candleWidth) {
            chart.scroll = Math.floor(chart.width / candleWidth)
            var wsInTicks = Math.round(
              this.preferences.whitespace / this.layout.candleWidth
            )
            chart.scroll -= wsInTicks
          }

          var idealNumberOfTicks = 10
          var appxLabelWidth
          try {
            appxLabelWidth = context.measureText('10:00').width * 2
          } catch (e) {
            appxLabelWidth = 100
          }
          while (idealNumberOfTicks > 1) {
            if (this.chart.width / appxLabelWidth > idealNumberOfTicks) break
            idealNumberOfTicks /= 1.5
          }
          chart.xAxis.autoComputedTickSizePixels = Math.round(
            this.chart.width / idealNumberOfTicks
          )
          if (chart.xAxis.autoComputedTickSizePixels < 1)
            chart.xAxis.autoComputedTickSizePixels = 1
        }
      }

      /**
	 * Sets the candleWidth for the chart. The candleWidth represents the number of horizontal pixels from the start
	 * of one bar or candle to the start of the next. This also applies to line charts. It is effectively, the horizontal zoom.
	 * The candleWidth can be read from layout.candleWidth.
	 *
	 * **Note**: if calling `setCandleWidth()` before `newChart()`, with a value less than `minimumCandleWidth`, `newChart()` will reset the candle size to the default candle size (8 pixels).
	 *
	 * @param {number} newCandleWidth The new candle width. If less than or equal to 0, it will be reset to 8
	 * @param {CIQ.ChartEngine.Chart} [chart]	Which chart to set the candleWidth. Defaults to the default chart.
	 * @memberof CIQ.ChartEngine
	 * @example
	 * stxx.setCandleWidth(10);
	 * stxx.home();	// home() is preferred over draw() in this case to ensure the chart is properly aligned to the right most edge.

	 */
      CIQ.ChartEngine.prototype.setCandleWidth = function(
        newCandleWidth,
        chart
      ) {
        if (!chart) chart = this.chart
        if (newCandleWidth < this.minimumCandleWidth)
          newCandleWidth = this.minimumCandleWidth
        this.layout.candleWidth = newCandleWidth
        //chart.maxTicks=Math.ceil(this.chart.width/newCandleWidth+0.5); // we add half of a candle back in because lines and mountains only draw to the middle of the bar
        chart.maxTicks = Math.round(chart.width / newCandleWidth) + 1
      }

      /**
       * Resizes the chart and adjusts the panels. The chart is resized to the size of the container div by calling
       * {@link CIQ.ChartEngine#resizeCanvas}. This method is called automatically if a screen resize event occcurs. The charting
       * engine also attempts to detect size changes whenever the mouse is moved. Ideally, if you know the chart is being
       * resized, perhaps because of a dynamic change to the layout of your screen, you should call this method manually.
       * @param {boolean} [maintainScroll=true] By default the scroll position will remain pegged on the right side of the chart. Set this to false to override.
       * @memberof CIQ.ChartEngine
       * @since  2015-11-1 resizeChart now automatically retains scroll position
       * @since  09-2016-19 resizeChart now also manages the resizing of the crosshairs.
       */
      CIQ.ChartEngine.prototype.resizeChart = function(maintainScroll) {
        if (this.runPrepend('resizeChart', arguments)) return
        if (maintainScroll !== false) maintainScroll = true
        if (maintainScroll) this.preAdjustScroll()
        var previousHeight = this.chart.canvasHeight
        this.resizeCanvas()
        if (maintainScroll) this.postAdjustScroll()
        if (this.displayInitialized) {
          this.adjustPanelPositions()
          this.draw()
          // This second case occurs if a chart was initialized hidden but now
          // has suddenly been revealed. displayInitialized hadn't been set yet
          // because draw() has never been completed
        } else if (this.chart.canvasHeight !== 0 && previousHeight === 0) {
          this.adjustPanelPositions()
          this.draw()
        }

        //redraw the crosshairs to adjust to the new size of the screen.
        this.doDisplayCrosshairs()
        this.updateChartAccessories()

        this.runAppend('resizeChart', arguments)
      }

      /**
	 * Renders a chart for a particular instrument from the data passed in or fetches new data from the attached {@link CIQ.QuoteFeed}.
	 * This is the method that should be called every time a new chart needs to be drawn for a different instrument and
	 * there is no need to destroy the chart to change the data on it. Simply call this method again.
	 *
	 * Note that before using this method you must first instantiate the chart and assign it to a DOM container using [`stxx=new CIQ.ChartEngine({container: $$("chartContainer")});`]{@link CIQ.ChartEngine}
	 *
	 * @param  {string|object}			symbol			The symbol or equation for the new chart - a symbol string, equation or an object representing the symbol can be used.
	 * 													<br>After the new chart is initialized, it will contain both a symbol string (stxx.chart.symbol) and a symbol object (stxx.chart.symbolObject).
	 * 													<br>You can send anything you want in the symbol object, but you must always include at least a 'symbol' element. Both these variables will be available for use wherever the {@link CIQ.ChartEngine.Chart} object is present. For example, if using the [fetch()]{@link CIQ.QuoteFeed#fetch} method for gathering data, params.stx.chart.symbolObject will contain your symbol object.
	 * 													<br>To allow equations to be used on a chart, the {@link CIQ.ChartEngine#allowEquations} parameter must be set to `true` and the equation needs to be preceded by an equals sign (=) in order for it to be parsed as an equation.
	 * 													<br>See {@link CIQ.formatEquation} and {@link CIQ.computeEquationChart} for more details on allowed equations syntax.
	 * @param  {array}					[masterData]	An array of [properly formated OHLC objects](index.html#data-format) to create a chart. Each element should at a minimum contain a "Close" field (capitalized).
	 *													If the charting engine has been configured to use a QuoteFeed (@link CIQ.ChartEngine#attachQuoteFeed)
	 *													then masterData does not need to be passed in. The quote feed will be queried instead.
	 * @param  {CIQ.ChartEngine.Chart}	chart]			Which chart to create. Defaults to the default chart.
	 * @param {function}				[cb]			Optional callback when newChart is loaded. See {@tutorial Adding additional content on chart} for a tutorial on how to use this callback function.
	 * @param {object} 					[params] 		Parameters to dictate initial rendering behavior
	 * @param {Object} 					[params.range]	Default range to be used upon initial rendering. If both `range` and `span` parameters are passed in, range takes precedence. If periodicity is not set, the range will be displayed at the most optimal periodicity. See {@link CIQ.ChartEngine#setRange} for complete list of parameters this object will accept.
	 * @param {object} 					[params.span]	Default span to display upon initial rendering. If both `range` and `span` parameters are passed in, range takes precedence. If periodicity is not set, the span will be displayed at the most optimal periodicity. See {@link CIQ.ChartEngine#setSpan} for complete list of parameters this object will accept.
	 * @param {object} 					[params.periodicity]	Default periodicity to be used upon initial rendering. See {@link CIQ.ChartEngine#setPeriodicity} for complete list of parameters this object will accept.
	 * @param {boolean} 				[params.stretchToFillScreen] Increase the candleWidth to fill the left-side gap created by a small dataSet. Respects {@link CIQ.ChartEngine#preferences.whitespace}. Ignored when params `span` or `range` are used.
	 * @memberof CIQ.ChartEngine
	 * @example
	 	// using a symbol object and embedded span and periodicity requirements
	 	stxx.newChart(
		 	{symbol:newSymbol,other:'stuff'},
		 	null,
		 	null,
		 	callbackFunction(stxx.chart.symbol, newSymbol),
		 	{
		 		span:{base:'day',multiplier:2},
		 		periodicity:{period:1,interval:5,timeUnit:'minute'},
		 		stretchToFillScreen:true
		 	}
	 	);
	 * @example
	 	// using a symbol string
	 	stxx.newChart(
		 	"IBM",
		 	null,
		 	null,
		 	callbackFunction(stxx.chart.symbol, newSymbol)
	 	);
	 *
	 * @example
	 	// using an equation string
	 	stxx.newChart(
		 	"=2*IBM-GM",
		 	null,
		 	null,
		 	callbackFunction(stxx.chart.symbol, newSymbol)
	 	);
	 *
	 * @since
	 * <br> 2015-11-1 newChart is capable of setting periodicity and span via `params` settings
	 * <br> 04-2016-08 `params.stretchToFillScreen` is available
	 * <br> 5.1.0 newChart is capable of setting range via `params` settings
	 */
      CIQ.ChartEngine.prototype.newChart = function(
        symbol,
        masterData,
        chart,
        cb,
        params
      ) {
        //if (!symbol) return; // can't build a chart without a symbol
        if (!chart) chart = this.chart
        if (!params) params = {}

        var layout = this.layout,
          periodicity = params.periodicity
        if (periodicity) {
          var internalPeriodicity = CIQ.cleanPeriodicity(
            periodicity.period ? periodicity.period : periodicity.periodicity,
            periodicity.interval,
            periodicity.timeUnit
          )
          layout.interval = internalPeriodicity.interval
          layout.periodicity = internalPeriodicity.period
          layout.timeUnit = internalPeriodicity.timeUnit
        }

        var prevSymbol = chart.symbol
        var prevSymbolObject = CIQ.clone(chart.symbolObject)
        var prevMarket = chart.market
        var prevDataSet = chart.dataSet
        var prevMoreAvailable = chart.moreAvailable
        chart.dataSet = []
        chart.moreAvailable = null
        if (!symbol) {
          chart.symbol = null
          chart.symbolObject = { symbol: null }
        } else if (typeof symbol == 'object') {
          // an object was sent in, so initialize the string from the object
          chart.symbol = symbol.symbol
          chart.symbolObject = symbol
        } else {
          // a string was sent in so initialize the object from the string
          chart.symbol = symbol
          chart.symbolObject.symbol = symbol
        }

        chart.inflectionPoint = null // reset where the consolidation occurs from

        if (this.marketFactory) {
          var marketDef = this.marketFactory(chart.symbolObject)
          this.setMarket(marketDef, chart)
        }

        this.setMainSeriesRenderer(true)

        var setSpan = params.span
        var range = params.range
        // no range or span passed into params, check layout
        if (!range && !setSpan && layout) {
          setSpan = !layout.range ? layout.setSpan : {}
          range = layout.range || {}
        }
        // both passed into params, range takes precedence
        else if (range && setSpan) {
          setSpan = {}
        }

        var self = this
        if (!masterData && this.quoteDriver) {
          var callback = function(err) {
            if (err && err != 'orphaned') {
              // orphaned means that another newChart request came in, overriding this one
              chart.symbol = prevSymbol // revert the symbol back to what it was if there is an error
              chart.symbolObject = prevSymbolObject // revert the symbol object back to what it was if there is an error
              chart.market = prevMarket
              chart.dataSet = prevDataSet
              chart.moreAvailable = prevMoreAvailable
            }
            self.dispatch(
              self.currentlyImporting ? 'symbolImport' : 'symbolChange',
              {
                stx: self,
                symbol: self.chart.symbol,
                symbolObject: self.chart.symbolObject,
                action: 'master',
              }
            )
            if (cb) cb.call(self, err)
          }

          if (range && Object.keys(range).length) {
            // check for empty object
            delete params.span // range and span are mutually exclusive
            delete layout.setSpan
            this.chart.masterData = null
            this.displayInitialized = false
            if (range.base == 'all')
              this.displayAll({
                base: 'all',
                multiplier: 1,
                periodicity: periodicity,
                forceLoad: true,
                maintainPeriodicity: true,
              })
            // more efficient call
            else {
              // if there's a periodicity passed into newChart, use it
              if (periodicity) {
                range.periodicity = periodicity
              }
              this.setRange(range, callback)
            }
          } else if (setSpan && setSpan.base) {
            setSpan.multiplier = setSpan.multiplier || 1
            // force a new chart to be initialized and new data fetched before calling setSpan to conform with the expectations and purpose of newChart,
            // and not use existing data and symbol names.
            this.chart.masterData = null
            this.displayInitialized = false
            // periodicity will be kept if sent as a parameter.
            if (periodicity) setSpan.maintainPeriodicity = true
            //setSpan.symbol=chart.symbol; // why are we sending a symbol to set span???
            setSpan.forceLoad = true
            this.setSpan(setSpan, callback)
          } else {
            this.quoteDriver.newChart(
              {
                symbol: chart.symbol,
                symbolObject: chart.symbolObject,
                chart: chart,
                initializeChart: true,
              },
              function(err) {
                if (!err) {
                  self.adjustPanelPositions() // to ensure holders are adjusted for current yaxis height
                  self.quoteDriver.updateSubscriptions()
                  if (params.stretchToFillScreen) {
                    self.fillScreen()
                  }
                }
                callback.apply(self, arguments)
              }
            )
          }
        } else {
          if (!masterData) {
            console.log(
              'Warning: No masterData specified and no QuoteFeed configured'
            )
          }
          if (!chart.symbol) chart.symbol = '' // if we are ready to draw but the symbol is missing, it will crash
          this.doCleanupDates(masterData, layout.interval)
          this.setMasterData(masterData, chart)
          this.createDataSet()
          this.initializeChart()

          if (range && Object.keys(range).length) {
            this.setRange(range)
          } else if (setSpan && setSpan.multiplier && setSpan.base) {
            this.setSpan({
              maintainPeriodicity: true,
              multiplier: setSpan.multiplier,
              base: setSpan.base,
            })
          } else if (params.stretchToFillScreen) {
            this.fillScreen()
          } else if (masterData && masterData.length) {
            this.draw()
          } else {
            this.clear()
          }
          this.adjustPanelPositions() // to ensure holders are adjusted for current yaxis height
          self.dispatch(
            self.currentlyImporting ? 'symbolImport' : 'symbolChange',
            {
              stx: self,
              symbol: self.chart.symbol,
              symbolObject: self.chart.symbolObject,
              action: 'master',
            }
          )
          if (cb) cb.call(self)
        }
      }

      CIQ.ChartEngine.prototype.clear = function() {
        this.displayInitialized = false

        for (var id in this.layout.studies) {
          var sd = this.layout.studies[id]
          CIQ.Studies.removeStudy(this, sd)
        }

        this.controls.chartControls.style.display = 'none'

        this.panels.chart.title.innerHTML = ''
        this.panels.chart.title.appendChild(
          document.createTextNode(this.panels.chart.display)
        )
      }

      /**
       * Adjusts the candleWidth to eliminate left-side gaps on the chart if not enough bars are loaded.
       * @memberof CIQ.ChartEngine
       * @since 4.0.0 this function in now public
       */
      CIQ.ChartEngine.prototype.fillScreen = function() {
        var chart = this.chart
        var candleWidth = this.layout.candleWidth
        var chartWidth = chart.width - this.preferences.whitespace
        var count = chart.dataSet.length

        if (count * candleWidth >= chartWidth) {
          this.draw()
          return
        }

        // line-type charts go center-to-center in the data point space, so we end up which 1/2 a candle empty on the left and the right..
        //so if we remove a candle from the calculations, we go edge to edge.
        if (
          (!this.mainSeriesRenderer ||
            !this.mainSeriesRenderer.standaloneBars) &&
          !this.standaloneBars[this.layout.chartType]
        )
          count--

        var newCandleWidth = chartWidth / count
        this.setCandleWidth(newCandleWidth, chart)
        this.home({ maintainWhitespace: true })
      }

      /**
       * Sets the master data for the chart. A dataSet is derived from the master data by {@link CIQ.ChartEngine#createDataSet}.
       *
       * If a [marketFactory]{@link CIQ.ChartEngine#setMarketFactory} has been linked to the chart, this method will also update the market on the chart to match the newly loaded instrument.
       * When no factory is present, the chart assumes that the market will never change and will continue to use market initially set using {@link CIQ.ChartEngine#setMarket}.
       * If none set, then the chart will operate in 24x7 mode.
       *
       * This method also calculates the number of decimal places for the security by checking the maximum number
       * in the data. This is stored in chart.decimalPlaces.
       *
       * @param	{array}				masterData		An array of quotes. Each quote should at a minimum contain a "Close" field (capitalized) and a Date field which is a string form of the date.
       *												This method will set DT to be a JavaScript Date object derived from the string form.
       * @param	{CIQ.ChartEngine.Chart}	[chart]			The chart to put the masterData. Defaults to the default chart.
       * @memberof CIQ.ChartEngine
       * @since 2016-03-11 - you can now define {@link CIQ.ChartEngine#transformMasterDataQuote} to format each masterData element before inserting it into the chart.
       */
      CIQ.ChartEngine.prototype.setMasterData = function(masterData, chart) {
        if (!chart) chart = this.chart
        if (this.marketFactory) {
          var marketDef = this.marketFactory(chart.symbolObject)
          this.setMarket(marketDef, chart)
        }

        chart.masterData = masterData
        if (chart.name == 'chart') this.masterData = masterData
        //chart.decimalPlaces=2;
        var i
        for (i = 0; masterData && i < masterData.length; i++) {
          if (this.transformMasterDataQuote)
            masterData[i] = this.transformMasterDataQuote(masterData[i])
          var quotes = masterData[i]
          if (quotes.DT) {
            if (Object.prototype.toString.call(quotes.DT) != '[object Date]')
              quotes.DT = new Date(quotes.DT) // if already a date object; nothing to do
            if (!quotes.Date || quotes.Date.length != 17)
              quotes.Date = CIQ.yyyymmddhhmmssmmm(quotes.DT)
          } else if (quotes.Date) quotes.DT = CIQ.strToDateTime(quotes.Date)
          else
            console.log(
              'setMasterData : Missing DT and Date on masterData object'
            )
          if (quotes.Volume && typeof quotes.Volume !== 'number')
            quotes.Volume = parseInt(quotes.Volume, 10)
          //if(typeof quotes.Close != 'number' && !quotes.Close && quotes.Close!==null){
          //	console.log ('setMasterData : Close is missing or not a number. Use parseFloat() if your data server provides strings. MasterData Index= ' + i +' Value = ' + quotes.Close);
          //}
        }
        chart.decimalPlaces = this.callbacks.calculateTradingDecimalPlaces({
          stx: this,
          chart: chart,
          symbol: chart.symbolObject.symbol,
          symbolObject: chart.symbolObject,
        })

        if (!CIQ.ChartEngine.isDailyInterval(this.layout.interval))
          this.setDisplayDates(masterData)
        this.chart.roundit = Math.pow(10, chart.decimalPlaces)
        for (i in this.plugins) {
          var plugin = this.plugins[i]
          if (plugin.display) {
            if (plugin.setMasterData) plugin.setMasterData(this, chart)
          }
        }
      }

      /**
       * Sets the master data for the chart, creates the data set, and renders the chart.
       *
       * @param	{string}			symbol			Ticker symbol for the chart.
       * @param	{array}				masterData		An array of quotes. Each quote should at a minimum contain a "Close" field (capitalized) and a Date field which is a string form of the date.
       *												This method will set DT to be a JavaScript Date object derived from the string form.
       * @param	{CIQ.ChartEngine.Chart}	[chart]			The chart to put the masterData. Defaults to the default chart.
       * @memberof CIQ.ChartEngine
       * @since 3.0.0
       */
      CIQ.ChartEngine.prototype.setMasterDataRender = function(
        symbol,
        masterData,
        chart
      ) {
        if (!chart) chart = this.chart
        if (!chart.symbol) chart.symbol = ''
        this.setMasterData(masterData, chart)
        if (masterData && masterData.length) chart.symbol = symbol
        this.createDataSet()
        this.initializeChart()
        this.draw()
        if (!masterData || !masterData.length) {
          chart.symbol = null
          this.clear()
        }
        this.adjustPanelPositions()
      }

      /**
       * Returns an array of all symbols currently required to be loaded by the quoteFeed.
       * The returned array contains an object for each symbol containing:
       * symbol, symbolObject, interval, periodicity
       * @param {object} params Control parameters
       * @param {boolean} [params.include-parameters] Set to true to put the series parameters in the return object
       * @param {boolean} [params.exclude-studies] Set to true to not include study symbols
       *
       * @return {array} The array of symbol objects required
       * @memberof CIQ.ChartEngine
       * @since  2016-03-11
       */
      CIQ.ChartEngine.prototype.getSymbols = function(params) {
        if (!params) params = {}
        var a = [],
          obj,
          layout = this.layout,
          symbol,
          symbolObject
        function makeObj(symbol, symbolObject, layout) {
          return {
            symbol: symbol,
            symbolObject: symbolObject,
            periodicity: layout.periodicity,
            interval: layout.interval,
            timeUnit: layout.timeUnit,
            setSpan: layout.setSpan,
          }
        }
        for (var chartName in this.charts) {
          var chart = this.charts[chartName]
          if (chart.symbolObject && chart.symbolObject.symbol)
            a.push(makeObj(chart.symbol, chart.symbolObject, layout))
          for (var field in chart.series) {
            var series = chart.series[field],
              parameters = series.parameters
            if (parameters.data && !parameters.data.useDefaultQuoteFeed)
              continue // legacy
            symbolObject = parameters.symbolObject
            symbol = parameters.symbol
            obj = makeObj(symbol, symbolObject, layout)
            obj.id = field
            if (params['include-parameters']) obj.parameters = parameters
            if (params['exclude-studies'] && parameters.bucket == 'study')
              continue
            a.push(obj)
          }
        }
        for (var s = a.length - 1; s >= 0; s--) {
          symbol = a[s].symbol
          if (this.isEquationChart(symbol)) {
            var res = CIQ.formatEquation(symbol)
            if (res) {
              for (var sym = 0; sym < res.symbols.length; sym++) {
                obj = makeObj(res.symbols[sym], a[s].symbolObject, a[s])
                a.push(obj)
              }
              a.splice(s, 1)
            }
          }
        }
        return a
      }

      /**
       * Sets the displayDate for the data element in masterData. The displayDate is the timezone adjusted date.
       * @param {object} quote The quote element to check
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.setDisplayDate = function(quote) {
        var dt = quote.DT
        var milli = dt.getSeconds() * 1000 + dt.getMilliseconds()
        var newDT
        if (this.dataZone) {
          newDT = new timezoneJS.Date(
            dt.getFullYear(),
            dt.getMonth(),
            dt.getDate(),
            dt.getHours(),
            dt.getMinutes(),
            this.dataZone
          )
          dt = new Date(newDT.getTime() + milli)
        }
        if (this.displayZone) {
          newDT = new timezoneJS.Date(dt.getTime(), this.displayZone)
          dt = new Date(
            newDT.getFullYear(),
            newDT.getMonth(),
            newDT.getDate(),
            newDT.getHours(),
            newDT.getMinutes()
          )
          dt = new Date(dt.getTime() + milli)
        }
        quote.displayDate = dt
      }

      /**
       * Calls {@link CIQ.ChartEngine#setDisplayDate} for each element in masterData
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.setDisplayDates = function(masterData) {
        if (!masterData) return
        for (var i = 0; i < masterData.length; i++) {
          var quote = masterData[i]
          if (quote.DT) this.setDisplayDate(quote)
        }
      }

      /**
       * Streams "last sale" prices into the chart.
       *
       *
       * >**This function has been deprecated in favor of {@link CIQ.ChartEngine#updateChartData}.
       * This also means that {@link CIQ.ChartEngine#streamParameters.fillGaps} is deprecated.
       * Developers should instead call {@link CIQ.ChartEngine#updateChartData} with `params.fillGaps=true` or rely on cleanupGaps as default behavior.**
       *
       * >`streamTrade` to `updateChartData` migration examples:
       *
       * >Note that updateChartData follows the 'OHLC' format.
       * So `V`olume (upper case) is used rather than `v`olume (lower case).
       * Similarly `L`ast (upper case) is used rather than `l`ast (lower case).
       *
       * >Example 1: streaming a secondary series:
       *
       * >`streamTrade({"last":102.05}, null, "IBM");`
       * <br>Translates to : <br>
       * `updateChartData({"Last":102.05}, null, {fillGaps: true, secondarySeries: "IBM"});`
       *
       * >Example 2: streaming a primary series:
       *
       * >`streamTrade({"last":102.05, "volume":100});`
       * <br>Translates to : <br>
       * `updateChartData({"Last": 102.05,"Volume":100}, null, {fillGaps: true});`
       *
       * This method is designed to append ticks to the master data while maintaining the existing periodicity, appending to the last tick or creating new ticks as needed.
       * It will also fill in gaps if there are missing bars in a particular interval.
       * If a trade has a date older than the beginning of the next bar, the last bar will be updated even if the trade belongs to a prior bar; this could happen if a trade is sent in after hours at a time when the market is closed, or if it is received out of order.
       * When in 'tick' interval, each trade will be added to a new bar and no aggregation to previous bars will be done.
       * If the optional timestamp [now] is sent in, and it is older than the next period to be rendered, the last tick on the dataset will be updated instead of creating a new tick.
       *
       * ** It is crucial that you ensure the date/time of the trade is in line with your `masterData` and `dataZone` ** See `now` parameter for more details.
       *
       * This method leverages {@link CIQ.ChartEngine#updateChartData} for the actual data insertion into masterData. Please see  {@link CIQ.ChartEngine#updateChartData} for additional details and performance throttle settings.
       *
       * See the [Streaming]{@tutorial DataIntegrationStreaming} tutorial for more the details.
       *
       * **Note: ** versions prior to 15-07-01 must use the legacy arguments : streamTrade(price, volume, now, symbol)
       *
       * @param  {object}		data			Price & Volume Data, may include any or all of the following:
       * @param  {number}		data.last 		Last sale price
       * @param  {number}		[data.volume] 	Trade volume
       * @param  {number}		[data.bid] 		Bid price
       * @param  {number}		[data.ask] 		Offer/Ask price
       * @param  {date}		[now]			Date of trade. It must be a java script date [new Date().getTime()]. **If omitted, defaults to "right now" in the set `dataZone`** (see {@link CIQ.ChartEngine#setTimeZone}); or if no `dataZone` is set, it will default to the browser's timezone (not recommended for international client-base since different users will see different times). It is important to note that this value must be in the same timezone as the rest of the masterData already sent into the charting engine to prevent tick gaps or overlaps.
       * @param  {string}		[symbol]		trade symbol for series streaming ONLY. Leave out or set to `null` when streaming the primary chart symbol.
       * @param {object} 		[params] 		Params to be passed to {@link CIQ.ChartEngine#updateChartData}
       * @memberof CIQ.ChartEngine
       * @example
       * // streaming last sale for the primary chart symbol
       * stxx.streamTrade({"last":102.05, "volume":100});
       * @example
       * // streaming last sale for an additional series on the chart
       * stxx.streamTrade({"last":102.05, "volume":100}, null, "IBM");
       * @deprecated Please use {@link CIQ.ChartEngine#updateChartData} for streaming last ticket.
       * @since  4.0.0 Deprecated this function. This also means that streamParameters.fillGaps is deprecated. Developers should
       * call {@link CIQ.ChartEngine#updateChartData} with params.fillGaps=true or rely on cleanupGaps as default behavior.
       */
      CIQ.ChartEngine.prototype.streamTrade = function(
        priceData,
        now,
        symbol,
        params
      ) {
        var chart = this.chart
        if (!params) params = {}
        if (params.chart) chart = params.chart
        params.fillGaps = this.streamParameters.fillGaps
        var newArgs = typeof priceData == 'object'

        var price = newArgs ? priceData.last : arguments[0],
          volume = newArgs ? priceData.volume : arguments[1],
          bid = newArgs ? priceData.bid : null,
          ask = newArgs ? priceData.ask : null

        if (!newArgs) {
          now = arguments[2]
          symbol = arguments[3]
        }

        if (symbol) {
          //series element
          params.secondarySeries = symbol
        }

        var data = {
          DT: now,
          Last: price,
          Volume: volume,
          Bid: bid,
          Ask: ask,
        }

        this.appendMasterData(data, chart, params)
      }

      /**
       * @deprecated Please use {@link CIQ.ChartEngine#updateChartData}
       * @memberof CIQ.ChartEngine
       * @since
       * <br>&bull; 2015-11-1 params.bypassGovernor added, allowReplaceOHL added
       * <br>&bull; 2015-11-1 params.force deprecated. Every call will update the tick to maintain the proper volume and createDataSet is now controlled by sp.maxTicks, sp.timeout or params.bypassGovernor
       * <br>&bull; 3.0.0 `appendQuotes` now also takes last sale data to allow streaming capabilities. This can now be used instead of streamTrade.
       * <br>&bull; 3.0.0 new params.fillGaps, params.secondarySeries, params.useAsLastSale
       * <br>&bull; 4.0.0 last sale streaming will now update a bar in the past to comply with the date sent in; instead of just updating the current tick.
       * <br>&bull; 4.0.3 params.useAsLastSale.aggregatedVolume is now available.
       * <br>&bull; 5.0.1 now calls doCleanupDates in case is is being called directly when not using a quoteFeed, to update an entire candle.
       */
      CIQ.ChartEngine.prototype.appendMasterData = function(
        appendQuotes,
        chart,
        params
      ) {
        this.updateChartData(appendQuotes, chart, params)
      }

      /**
	 * <span class="injection">INJECTABLE</span>
	 * Use this method to add new `OHLC` bars to the end of the chart, insert new bars into the middle of the chart, replace existing bars, delete bars, or stream individual `last sale` data tick by tick as they are received from a streaming feed.
	 *
	 * **The following rules apply when adding or updating full `OHLC` bars:**
	 *
	 * - If a bar is not present it will be added, if it is present it will be updated so the OHLC and volume integrity is preserved. If `allowReplaceOHL` is not set, the 'Open' is preserved from the existing candle; new 'High' and 'Low' values are calculated, and the 'Close' and 'Volume' values are replaced with the new ones.
	 * - Although gaps can be present, dates in the appendQuotes array **must maintain the correct periodicity and order** (older to newer) to prevent out of sequence ticks.
	 * - If set, gaps will be filled past the currently existing bar. No gaps will be filled when inserting bars in between existing data.
	 *
	 * **The following rules apply when streaming individual `last sale` data, tick by tick, as they are received from a streaming feed: **
	 *
	 * - This method is designed to update the chart while maintaining the existing periodicity, augmenting the tick for an instrument or creating new ticks as needed.
	 * - For a primary series, the Close, High and Low prices for the last bar will be updated to maintain the integrity of the bar, and the volume will be added to the existing bar's volume.
	 * - For a secondary series (see `params.secondarySeries`), the series field will be set or replaced with the price sent (Close or Last), creating new bars where none existed, but also respecting the periodicity. This is done using {@link CIQ.addMemberToMasterdata}
	 * - When in 'tick' interval, each trade will be added to a new bar and no aggregation to previous bars will be done.
	 *
	 * ** Performance: **
	 *
	 * - To maintain system performance you can throttle inbound ticks. See {@link CIQ.ChartEngine#streamParameters } and [Streaming tutorial](tutorial-Data%20Loading.html#Streaming) for more details.
	 * - It is important to note that although the data will always be added to masterData, `createDataSet()` and `draw()` will **not** be called if data is received quicker than the throttle (governor) wait periods. As such, you will not see any changes until the throttle wait periods are met.
	 *
	 * ** Additional Notes: **
	 *
	 * - ** It is crucial that you ensure the date/time of the trade is in line with your `masterData` and `dataZone` ** See `DT` parameter for more details.
	 * - This method is **not** intended to be used as a way to load initial chart data, or data changes triggered by periodicity changes.
	 *
	 * See the [Data Integration]{@tutorial DataIntegrationOverview} tutorial for more detail on how to load initial data.
	 *
	 * See the [Streaming]{@tutorial DataIntegrationStreaming} tutorial for more the details.
	 *
	 * @param  {array|object} appendQuotes		An array of properly formatted OHLC quote object(s). [See Data Format]{@tutorial InputDataFormat} and {@link CIQ.ChartEngine#setMasterData}. Only `Close` is used on secondary series.<br>
	 * 											**OR**<br>
	 * 											a last sale object with the following elements:
	 * @param  {number}	appendQuotes.Last 		Last sale price
	 * @param  {number}	[appendQuotes.Volume]	Trade volume (used on primary series only)
	 * @param  {number}	[appendQuotes.Bid] 		Bid price (used on primary series only)
	 * @param  {number}	[appendQuotes.Ask] 		Offer/Ask price (used on primary series only)
	 * @param  {number}	[appendQuotes.DT] 		Date of trade
	 * It must be a java script date [new Date().getTime()].
	 * **If omitted, defaults to "right now" in the set `dataZone`** (see {@link CIQ.ChartEngine#setTimeZone});
	 * or if no `dataZone` is set, it will default to the browser's timezone (not recommended for international client-base since different users
	 * will see different times). It is important to note that this value must be in the same timezone as the rest of the masterData already
	 * sent into the charting engine to prevent tick gaps or overlaps.
	 * Items in this array *must* be ordered from earliest to latest date.
	 *
	 * @param  {CIQ.ChartEngine.Chart}			[chart]				The chart to append the quotes. Defaults to the default chart.
	 * @param {object} [params] Parameters to dictate behavior
	 * @param {boolean} [params.noCreateDataSet] If true then do not create the data set automatically, just add the data to the masterData
	 * @param {boolean} [params.allowReplaceOHL] Set to true to bypass internal logic that maintains OHL so they are instead replaced with the new data instead of updated. Not applicable when loading data for a secondary series.
	 * @param {boolean} [params.bypassGovernor] If true then masterdata will be immediately updated regardless of {@link CIQ.ChartEngine#streamParameters}. Not applicable if `noCreateDataSet` is true.
	 * @param {boolean} [params.fillGaps] If true and {@link CIQ.ChartEngine#cleanupGaps} is also set, {@link CIQ.ChartEngine#doCleanupGaps} will be called to fill gaps for any newly added bars past the currently existing bar. It will not fill gaps for bars added to the middle of the masterData, or created by deleting a bar. Not applicable when loading data for a secondary series. <BR> Reminder: `tick` does not fill any gaps as it is not a predictable interval.
	 * @param {boolean} [params.secondarySeries] Set to the name of the element (valid comparison symbol, for example) to load data as a secondary series. Calls {@link CIQ.addMemberToMasterdata}.
	 * @param {boolean} [params.deleteItems] Set to true to completely delete the masterData records matching the dates in appendQuotes. Not applicable when loading data for a secondary series.
	 * @param {boolean} [params.useAsLastSale] Set to true if not using a 'last sale' formatted object in `appendQuotes`.
	 * This option is available in cases when a feed may always return OHLC formatted objects or a 'Close' field instead of a 'Last' field,
	 * even for last sale streaming updates.
	 * By definition a 'last sale' can only be a single record indicating the very 'last' sale price.
	 * As such, even if multiple records are sent in the `appendQuotes` array when this flag is enabled,
	 * only the last record's data will be used. Specifically the 'Close' and 'Volume' fields will be streamed.
	 * @param {boolean} [params.useAsLastSale.aggregatedVolume] If your last sale updates send current volume for the bar instead of just the trade volume, set this parameter to 'true' in the `params.useAsLastSale` object. The sent in volume will be used as is instead of being added to the existing bar's volume. Not applicable when loading data for a secondary series.
	 * @memberof CIQ.ChartEngine
	 * @example
	 * // this example will stream the last price on to the appropriate bar and add 90 to the bar's volume.
	  stxx.updateChartData(
		  {
			  Last: 50.94,
			  Volume: 90
		  }
	  );
	 * @example
	 * // this example will stream the last price on to the appropriate bar and set the volume for that bar to 90.
	  stxx.updateChartData(
		  {
			  Last: 50.94,
			  Volume: 90
		  },
		  null,
		  {useAsLastSale: {aggregatedVolume:true}}
	  );
	 * @example
	 * // this example will stream the last price to the appropriate bar  **for a secondary series**.
	  stxx.updateChartData(
		  {
			  Last: 50.94
		  },
		  null,
		  {secondarySeries:secondarySymbol}
	  );
	 * @example
	 * // this example will add or replce a complete OHLC bar.
	  stxx.updateChartData(
		  [
		  	{"Date":"2015-04-16 16:00","Open":152.13,"High":152.19,"Low":152.08,"Close":152.11,"Volume":4505569},
		  	{"Date":"2015-04-17 09:30","Open":151.76,"High":151.83,"Low":151.65,"Close":151.79,"Volume":2799990},
		  	{"Date":"2015-04-17 09:35","Open":151.79,"High":151.8,"Low":151.6,"Close":151.75,"Volume":1817706}
		  ]
	  );
	 * @since
	 * <br>&bull; 5.1.0 New function replacing and enhancing legacy method `appendMasterData`.
	 * <br>&bull; 5.1.0 Added ability to delete or insert items anywhere in the masterData. `deleteItems` parameter added.
	 */

      CIQ.ChartEngine.prototype.updateChartData = function(
        appendQuotes,
        chart,
        params
      ) {
        if (!params) params = {}
        if (!chart) chart = this.chart

        var lastSale = false,
          aggregatedVolume = false,
          masterData = chart.masterData,
          layout = this.layout,
          dataZone = this.dataZone

        this.doCleanupDates(appendQuotes, layout.interval)
        if (
          params.useAsLastSale ||
          (appendQuotes.constructor == Object &&
            typeof appendQuotes.Last != 'undefined' &&
            appendQuotes.Last !== null)
        ) {
          // this is last sale streaming so format accordingly
          lastSale = true

          if (params.useAsLastSale && params.useAsLastSale.aggregatedVolume)
            aggregatedVolume = true

          if (appendQuotes.constructor === Array) {
            // is streaming an arry of OHLC, do some clean up to extract last and volume
            var lastBar = appendQuotes[appendQuotes.length - 1]
            appendQuotes = {}

            if (!lastBar.DT) appendQuotes.DT = CIQ.strToDateTime(lastBar.Date)
            else appendQuotes.DT = lastBar.DT

            appendQuotes.Close = lastBar.Close
            appendQuotes.Volume = lastBar.Volume
          } else if (appendQuotes.Last) {
            appendQuotes.Close = appendQuotes.Last
            delete appendQuotes.Last
          }

          if (appendQuotes.DT) appendQuotes.DT = new Date(+appendQuotes.DT)
          if (!appendQuotes.DT || appendQuotes.DT == 'Invalid Date') {
            // if no date is sent in, use the current time and adjust to the dataZone
            appendQuotes.DT = this.convertToDataZone(new Date())
          }

          // find the right candle
          if (layout.interval != 'tick') {
            // We use a 24 hour market because we don't want our bars to artificially stop
            // at the end of a market session. If we get extended hours, or bad ticks we still
            // want to print them on the chart. Trust the data.
            var market24 = new CIQ.Market({})
            var iter_parms = {
              begin:
                masterData && masterData.length
                  ? masterData[masterData.length - 1].DT
                  : appendQuotes.DT,
              interval: layout.interval,
              periodicity: 1,
              timeUnit: layout.timeUnit,
              inZone: dataZone,
              outZone: dataZone,
            }

            var iter = market24.newIterator(iter_parms)
            var next = iter.next()
            var max, actualTime
            if (!masterData) {
              // there are some use cases where you might prefer to stream data onto masterData without using a quotefeed or loading data first.
              appendQuotes.DT = new Date(+iter.previous())
            } else if (appendQuotes.DT < next) {
              // update current tick or some tick in the past.
              max = 0 // safety catch so we don't go on forever.
              var previous = iter.previous()
              actualTime = appendQuotes.DT
              params.appending = true
              while (actualTime < previous && max < 1000) {
                params.appending = false
                previous = iter.previous()
                max++
              }
              appendQuotes.DT = previous
              params.updating = !params.appending
            } else if (appendQuotes.DT >= next) {
              // create new tick. If the date matches, that's it, otherwise fast forward to find the right bar to add.
              max = 0 // safety catch so we don't go on forever.
              actualTime = appendQuotes.DT
              while (actualTime > next && max < 1000) {
                appendQuotes.DT = next
                next = iter.next()
                max++
              }
              params.appending = true
            }
          }

          appendQuotes.Open = appendQuotes.Close
          appendQuotes.High = appendQuotes.Close
          appendQuotes.Low = appendQuotes.Close
        }

        if (params.secondarySeries) {
          CIQ.addMemberToMasterdata({
            stx: this,
            label: params.secondarySeries,
            data: appendQuotes,
            fillGaps: params.fillGaps,
            createObject: true,
          })
        } else {
          if (appendQuotes && appendQuotes.constructor == Object)
            appendQuotes = [appendQuotes] // When developer mistakenly sends an object instead of an array of objects
          if (!appendQuotes || !appendQuotes.length) return
          if (
            this.runPrepend('appendMasterData', [appendQuotes, chart, params])
          )
            return
          if (this.runPrepend('updateChartData', [appendQuotes, chart, params]))
            return

          if (!masterData || !masterData.length) {
            masterData = CIQ.clone(appendQuotes)
            this.setMasterData(masterData, chart)
          } else {
            var filledGapsYet = false
            var i = masterData.length - 1,
              placedFirstQuote = false
            for (var j = 0; j < appendQuotes.length; j++) {
              var quote = appendQuotes[j]
              var dt = quote.DT,
                date = quote.Date
              if (dt && Object.prototype.toString.call(dt) != '[object Date]')
                quote.DT = dt = new Date(dt) // if already a date object; nothing to do
              if (dt) {
                if (!date || date.length != 17)
                  quote.Date = CIQ.yyyymmddhhmmssmmm(quote.DT)
              }
              if (!dt) dt = quote.DT = CIQ.strToDateTime(date)

              while (i >= 0 && i < masterData.length) {
                var dt2 = masterData[i].DT
                if (!dt2) dt2 = CIQ.strToDateTime(masterData[i].Date)
                if (dt2.getTime() <= dt.getTime()) {
                  placedFirstQuote = true
                  var plusOne = 0 // If time is the same then replace last bar
                  if (dt2.getTime() < dt.getTime()) {
                    if (i < masterData.length - 1) {
                      var dtf =
                        masterData[i + 1].DT ||
                        CIQ.strToDateTime(masterData[i + 1].Date)
                      if (dtf.getTime() <= dt.getTime()) {
                        i++
                        continue
                      }
                    }
                    plusOne = 1 // Otherwise append bar
                    if (
                      params.fillGaps &&
                      !filledGapsYet &&
                      i == masterData.length - 1
                    ) {
                      // fill gaps if we are at the end of the masterData
                      var gapQuotes = appendQuotes.slice(j)
                      gapQuotes.unshift(masterData[i]) // add previous bar so we can close gaps
                      gapQuotes = this.doCleanupGaps(gapQuotes, chart)
                      gapQuotes.shift() // remove previous bar
                      appendQuotes = appendQuotes.slice(0, j).concat(gapQuotes)
                      quote = appendQuotes[j]
                      filledGapsYet = true
                    }
                  }
                  var delItems = params.deleteItems
                  if (delItems) {
                    if (!plusOne) masterData.splice(i, 1) //deleting from masterData here
                  } else {
                    if (!plusOne) {
                      // If we're replacing the last bar then we want to save any series and study data, otherwise comparisons will [briefly] disappear during refreshes
                      //Preserve any relevant data from prior fetched quote for this bar.
                      //Here we are assuming that the data being appended to masterData is a data update, perhaps from only one exchange, while
                      //the existing masterData is a consolidated quote. We trust the quote we had in masterData to have the more accurate
                      //volume and open, and use the high/low from there in combination with the updated data's to determine the daily high/low.
                      var master =
                        masterData.length > i + j ? masterData[i + j] : null
                      if (master) {
                        if (lastSale) {
                          if (quote.Volume) {
                            quote.Volume = parseInt(quote.Volume, 10)
                          }
                          if (!aggregatedVolume) quote.Volume += master.Volume
                        } else {
                          if (!quote.Volume && master.Volume) {
                            quote.Volume = master.Volume
                          }
                        }
                        if (!params.allowReplaceOHL) {
                          if (!isNaN(master.Open)) {
                            quote.Open = master.Open
                          }
                          if (!isNaN(master.High) && master.High > quote.High) {
                            quote.High = master.High
                          }
                          if (!isNaN(master.Low) && master.Low < quote.Low) {
                            quote.Low = master.Low
                          }
                        }
                        if (isNaN(quote.Close) && !isNaN(master.Close))
                          quote.Close = master.Close
                        if (isNaN(quote.Bid) && !isNaN(master.Bid))
                          quote.Bid = master.Bid
                        if (isNaN(quote.Ask) && !isNaN(master.Ask))
                          quote.Ask = master.Ask

                        for (var field in chart.series) {
                          var symbol =
                            chart.series[field].parameters.symbolObject.symbol
                          if (
                            typeof quote[symbol] == 'undefined' &&
                            typeof master[symbol] != 'undefined'
                          )
                            quote[symbol] = master[symbol]
                        }
                      }
                    }
                    // If we don't set this here, the study calculations will fail
                    if (isNaN(quote.Open)) quote.Open = quote.Close
                    if (isNaN(quote.High))
                      quote.High = Math.max(quote.Open, quote.Close)
                    if (isNaN(quote.Low))
                      quote.Low = Math.min(quote.Open, quote.Close)

                    if (quote.Volume && typeof quote.Volume !== 'number')
                      quote.Volume = parseInt(quote.Volume, 10)
                    if (!CIQ.ChartEngine.isDailyInterval(layout.interval))
                      this.setDisplayDate(quote)
                    i += plusOne
                    masterData.splice(i, plusOne ? 0 : 1, quote) //inserting into masterData happens here
                  }
                  break
                }
                i += placedFirstQuote ? 1 : -1
              }
            }
          }
          if (this.maxMasterDataSize)
            masterData = chart.masterData = this.masterData = masterData.slice(
              -this.maxMasterDataSize
            )
          for (var pl in this.plugins) {
            var plugin = this.plugins[pl]
            if (plugin.display) {
              if (plugin.appendMasterData)
                plugin.appendMasterData(this, appendQuotes, chart)
            }
          }
          if (!this.masterData || !this.masterData.length)
            this.masterData = masterData
        }

        if (!params.noCreateDataSet) {
          var sp = this.streamParameters
          if (++sp.count > sp.maxTicks || params.bypassGovernor) {
            clearTimeout(sp.timeout)
            this.createDataSet(null, null, params)
            this.draw()
            this.updateChartAccessories()
            sp.count = 0
            sp.timeout = -1
          } else {
            var self = this
            if (sp.timeout == -1) {
              sp.timeout = setTimeout(function() {
                self.createDataSet(null, null, params)
                self.draw()
                self.updateChartAccessories()
                self.streamParameters.count = 0
                self.streamParameters.timeout = -1
              }, sp.maxWait)
            }
          }
        }
        this.runAppend('appendMasterData', arguments)
        this.runAppend('updateChartData', arguments)
      }

      /**
       * Sets the maximimum number of ticks to the requested number. This is effected by changing the candleWidth.
       * See also {@link CIQ.ChartEngine#setCandleWidth}.
       *
       * **Note**: if calling `setMaxTicks()` before `newChart()`, and the chart will result in a candle width less than `minimumCandleWidth`, `newChart()` will reset the candle size to the default candle size (8 pixels).
       *
       * @param {number} ticks The number of ticks wide to set the chart.
       * @param {object} params optional Parameters to use with this function.
       * @param {number} params.padding Whitespace in pixels to add to the right of the chart.
       * 									Setting this field will home the chart to the most recent tick.
       * 									To home the chart without padding the right side with whitespace, set padding to 0.
       * 									Omitting the padding field will keep the chart scrolled to the same position.
       * @since 2015-11-1 - params added
       * @memberof CIQ.ChartEngine
       * @example
       * stxx.setMaxTicks(300);
       * stxx.home();	// home() is preferred over draw() in this case to ensure the chart is properly aligned to the right most edge.
       */
      CIQ.ChartEngine.prototype.setMaxTicks = function(ticks, params) {
        if (!params) params = {}
        ticks = Math.round(ticks)
        if (ticks < 2) ticks = 2
        var pad = params.padding ? params.padding : 0
        this.layout.candleWidth = (this.chart.width - pad) / ticks
        if (!this.layout.candleWidth) this.layout.candleWidth = 8 // Zero candlewidth can only occur if the chart has no width. This might happen if the chart is in a hidden iframe
        this.chart.maxTicks = Math.round(
          this.chart.width / this.layout.candleWidth - 0.499
        )
        if (params.padding || params.padding === 0)
          this.chart.scroll = ticks + 1 // If padding, then by definition we're homing
      }

      /**
       * Private construction of the chart object. This is called from the actual constructor
       * for CIQ.ChartEngine.
       * @private
       * @memberof CIQ.ChartEngine
       * @since 07/01/2015
       */
      CIQ.ChartEngine.prototype.construct = function() {
        this.stackPanel('chart', 'chart', 1)
        this.adjustPanelPositions()
        this.chart.panel = this.panels[this.chart.name]
        this.cx = 0
        this.cy = 0
        this.micropixels = 0
        this.chart.panel.subholder.appendChild(this.controls.home)
        this.callbackListeners = {
          /**
           * Called when a user doubletaps a touchscreen device
           * @callback doubleTapEventListener
           * @param {object} data
           * @param {CIQ.ChartEngine} data.stx
           * @param {number} data.finger Which finger double tapped
           * @param {number} data.x The crosshair x position
           * @param {number} data.y The crosshair y position
           * @since 4.0.0
           */
          doubleTap: [],
          /**
           * Called when a change occurs in the chart layout.
           * @callback drawingEventListener
           * @param {object} data Data relevant to the "drawing" event
           * @param {CIQ.ChartEngine} data.stx The chart engine instance
           * @param {string} data.symbol The current chart symbol
           * @param {object} data.symbolObject The symbol's value and display label (CIQ.ChartEngine.chart.symbolObject)
           * @param {object} data.layout The chart's layout object (CIQ.ChartEngine.layout)
           * @param {array} data.drawingObjects The chart's current drawings (CIQ.ChartEngine.drawingObjects)
           */
          drawing: [],
          /**
           * Called when a change occurs in the chart layout.
           * @callback layoutEventListener
           * @param {object} data Data relevant to the "layout" event
           * @param {CIQ.ChartEngine} data.stx The chart engine instance
           * @param {string} data.symbol The current chart symbol
           * @param {object} data.symbolObject The symbol's value and display label (CIQ.ChartEngine.chart.symbolObject)
           * @param {object} data.layout The chart's layout object (CIQ.ChartEngine.layout)
           * @param {array} data.drawingObjects The chart's current drawings (CIQ.ChartEngine.drawingObjects)
           */
          layout: [],
          /**
           * Called when the mouse is clicked on the chart and held down.
           * @callback longholdEventListener
           * @param {object} data Data relevant to the "longhold" event
           * @param {CIQ.ChartEngine} data.stx The chart engine instance
           * @param {string} data.panel The panel being tapped
           * @param {number} data.x The crosshair x position
           * @param {number} data.y The crosshair y position
           */
          longhold: [],
          /**
           * Called when the crosshair moves.
           * @callback moveEventListener
           * @param {object} data Data relevant to the "move" event
           * @param {CIQ.ChartEngine} data.stx The chart engine instance
           * @param {string} data.panel The panel being moved
           * @param {number} data.x The crosshair x position
           * @param {number} data.y The crosshair y position
           * @param {boolean} data.grabbingScreen True if the screen is being touched or clicked
           */
          move: [],
          /**
           * Called when the quoteFeed fetches a new series.
           * @callback newChartEventListener
           * @param {object} data Data relevant to the "newChart" event
           * @param {CIQ.ChartEngine} data.stx The chart engine instance
           * @param {string} data.symbol The current chart symbol
           * @param {object} data.symbolObject The symbol's value and display label (CIQ.ChartEngine.chart.symbolObject)
           * @param {boolean} data.moreAvailable True if {@link quotefeed~dataCallback} reports that more data is available
           * @param {object} data.quoteDriver The quoteFeed driver
           */
          newChart: [],
          /**
           * Called when preferences are changed.
           * @callback preferencesEventListener
           * @param {object} data Data relevent to the "preferences" event
           * @param {CIQ.ChartEngine} data.stx The chart engine instance
           * @param {string} data.symbol The current chart symbol
           * @param {object} data.symbolObject The symbol's value and display label (CIQ.ChartEngine.chart.symbolObject)
           * @param {object} data.layout The chart's layout object (CIQ.ChartEngine.layout)
           * @param {array} data.drawingObjects The chart's current drawings (CIQ.ChartEngine.drawingObjects)
           */
          preferences: [],
          /**
           * Called on "mouseup" after the chart is right-clicked.
           * @callback rightClickEventListener
           * @param {object} data Data relevant to the "rightClick" event
           * @param {CIQ.ChartEngine} data.stx The chart engine instance
           * @param {string} panel The panel that was clicked on
           * @param {number} data.x The crosshair x position
           * @param {number} data.y The crosshair y position
           */
          rightClick: [],
          /**
           * Called when an overlay-type study is edited
           * @callback studyOverlayEditEventListener
           * @param {object} data Data relevant to the "studyOverlayEdit" event
           * @param {CIQ.ChartEngine} data.stx The chart engine instance
           * @param {object} data.sd The study object studyDescriptor
           * @param {object} data.inputs The inputs from the studyDescriptor
           * @param {object} data.outputs The outputs from the studyDescriptor
           * @param {object} data.parameters The parameters from the studyDescriptor
           */
          studyOverlayEdit: [],
          /**
           * Called when a panel-type study is edited
           * @callback studyPanelEditEventListener
           * @param {object} data Data relevant to the "studyPanelEdit" event
           * @param {CIQ.ChartEngine} data.stx The chart engine instance
           * @param {object} data.sd The study object studyDescriptor
           * @param {object} data.inputs The inputs from the studyDescriptor
           * @param {object} data.outputs The outputs from the studyDescriptor
           * @param {object} data.parameters The parameters from the studyDescriptor
           */
          studyPanelEdit: [],
          /**
           * Called when the chart's symbol changes.
           * @callback symbolChangeEventListener
           * @param {object} data Data relevant to the "symbolChange" event
           * @param {CIQ.ChartEngine} data.stx The chart engine instance
           * @param {string} data.symbol The new chart symbol
           * @param {object} data.symbolObject The symbol's value and display label (CIQ.ChartEngine.chart.symbolObject)
           * @param {string} data.action An action type being performed on the symbol. Possible options:
           *	- `add-series` - A series was added
           *	- `master` - The master symbol was changed
           *	- `remove-series` - A series was removed
           */
          symbolChange: [],
          /**
           * Called when a symbol is imported into the layout.
           * It is not called by other types of symbol changes
           * @callback symbolImportEventListener
           * @param {object} data Data relevant to the "symbolImport" event
           * @param {CIQ.ChartEngine} data.stx The chart engine instance
           * @param {string} data.symbol The new chart symbol
           * @param {object} data.symbolObject The symbol's value and display label (CIQ.ChartEngine.chart.symbolObject)
           * @param {string} data.action An action type being performed on the symbol. Possible options:
           *   - `add-series` - A series was added
           *   - `master` - The master symbol was changed
           *   - `remove-series` - A series was removed
           */
          symbolImport: [],
          /**
           * Called when the chart is tapped.
           * @callback tapEventListener
           * @param {object} data Data relevant to the "tap" event
           * @param {CIQ.ChartEngine} data.stx The chart engine instance
           * @param {string} data.panel The panel being tapped
           * @param {number} data.x The crosshair x position
           * @param {number} data.y The crosshair y position
           */
          tap: [],
          /**
           * Called when a change occurs in the chart layout.
           * @callback themeEventListener
           * @param {object} data Data relevant to the "theme" event
           * @param {CIQ.ChartEngine} data.stx The chart engine instance
           * @param {string} data.symbol The current chart symbol
           * @param {object} data.symbolObject The symbol's value and display label (CIQ.ChartEngine.chart.symbolObject)
           * @param {object} data.layout The chart's layout object (CIQ.ChartEngine.layout)
           * @param {array} data.drawingObjects The chart's current drawings (CIQ.ChartEngine.drawingObjects)
           */
          theme: [],
          /**
           * Called when an undo stamp is created for drawing events.
           * @callback undoStampEventListener
           * @param {object} data Data relevant to the "undoStamp" event
           * @param {CIQ.ChartEngine} data.stx The chart engine instance
           * @param {array} data.before The chart's array of drawingObjects before the change
           * @param {array} data.after The chart's array of drawingsObjects after the change
           */
          undoStamp: [],
        }
        this.longHoldTime = 1000
      }

      /**
       * Add a DOM element's event listener and index it so that it will be removed when invoking CIQ.ChartEngine.destroy().
       * https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener
       * @param {element} element DOM element to listen for changes on
       * @param {string} event The event type to listen for. Possible values: https://developer.mozilla.org/en-US/docs/Web/Events
       * @param {function} listener The callback to invoke when the event happens.
       * @param {*} Either a boolean or object. See addEventListener options.
       * @see {@link CIQ.ChartEngine#destroy}
       * @private
       * @since 3.0.0
       */
      CIQ.ChartEngine.prototype.addDomEventListener = function(
        element,
        event,
        listener,
        options
      ) {
        element.addEventListener(event, listener, options)
        this.eventListeners.push({
          element: element,
          event: event,
          function: listener,
          options: options,
        })
      }

      /**
       * Register a listener to a chart event in the chart engine instance.
       * Events are tracked in the `CIQ.ChartEngine.callbackListeners` object.
       * Valid listeners:
       *   - `*`: Passing in this value will register the listener to every event type below.
       *   - `doubleTap`: {@link doubleTapEventListener}
       *   - `drawing`: {@link drawingEventListener}
       *   - `layout`: {@link layoutEventListener}
       *   - `longhold`: {@link longholdEventListener}
       *   - `move`: {@link moveEventListener}
       *   - `newChart`: {@link newChartEventListener}
       *   - `rightClick`: {@link rightClickEventListener}
       *   - `studyOverlayEdit`: {@link studyOverlayEditEventListener}
       *   - `studyPanelEdit`: {@link studyPanelEditEventListener}
       *   - `symbolChange`: {@link symbolChangeEventListener}
       *   - `symbolImport`: {@link symbolImportEventListener}
       *   - `tap`: {@link tapEventListener}
       *   - `theme`: {@link themeEventListener}
       *   - `undoStamp`: {@link undoStampEventListener}
       * @param {string|array} type The event to listen for.
       *		(See the description above for valid options.)
       * @param {function} callback The listener to call when the event is triggered.
       * @return {object} An object containing the `type` and `cb`. It can be passed to {@link CIQ.ChartEngine#removeEventListener} later to remove the event.
       * @memberof CIQ.ChartEngine
       * @since
       * <br>&bull; 04-2016-08
       * <br>&bull; 4.0.0 'doubleTap' is now available
       * <br>&bull; 4.0.0 type can be an array of event options
       * @example
       * stxx.longHoldTime=... // Optionally override default value of 1000ms
       * stxx.addEventListener("longhold", function(lhObject){
       * 	alert('longhold event at x: ' + lhObject.x + ' y: '+ lhObject.y);
       * });
       */
      CIQ.ChartEngine.prototype.addEventListener = function(type, callback) {
        if (type === '*') {
          for (var key in this.callbackListeners) {
            this.callbackListeners[key].push(callback)
          }
        } else if (type instanceof Array) {
          for (var i = 0; i < type.length; i++) {
            this.callbackListeners[type[i]].push(callback)
          }
        } else {
          var arr = this.callbackListeners[type]
          if (!arr) {
            throw new Error('Attempted to add an invalid listener.')
          }
          arr.push(callback)
        }
        return { type: type, cb: callback }
      }

      /**
       * Remove a listener for an emitted chart event.
       * Events are tracked in the {@link CIQ.ChartEngine.callbackListeners} object.
       * @param {object} obj Object from {@link CIQ.ChartEngine#addEventListener}
       * @memberof CIQ.ChartEngine
       * @since 04-2016-08
       */
      CIQ.ChartEngine.prototype.removeEventListener = function(obj, cb) {
        if (!obj || typeof obj != 'object') {
          // User likely passed in one argument into this function with the callback as the first parameter
          // This is accounted for because it is consistent with the argument schema of "addEventListener"
          obj = {
            type: obj,
            cb: cb,
          }
        }

        var spliceEvent = function(arr, cb) {
          for (var i = 0; i < arr.length; i++) {
            if (arr[i] === cb) {
              arr.splice(i, 1)
              return
            }
          }
        }
        var callbackListeners = this.callbackListeners

        if (obj.type === '*') {
          for (var key in callbackListeners) {
            spliceEvent(callbackListeners[key], obj.cb)
          }
          return
        }

        if (!callbackListeners[obj.type]) {
          throw new Error('Attempted to remove an invalid listener.')
        }

        spliceEvent(callbackListeners[obj.type], obj.cb)
      }

      /**
       * Dispatches an event
       *
       * Returns false by default unless a developer explicitly returns a boolean value which can be used to bypass core functionality in the same manner as the Injection API
       * ***Above, return logic currently only implemented with doubleTapEventListener but can be updated in the future to work with more.***
       *
       * @memberof CIQ.ChartEngine
       * @param {string} type The callbackListener to call
       * @param {object} data A collection of parameters to provide to the callback
       * @return {boolean} Will always be false unless a developer purposely returns a true value from their callback
       * @private
       */
      CIQ.ChartEngine.prototype.dispatch = function(type, data) {
        if (this.callbacks[type]) this.callbacks[type].call(this, data)
        var arr = this.callbackListeners[type]
        var rv
        if (arr) {
          for (var i = 0; i < arr.length; i++) rv = arr[i].call(this, data)
          if (rv) return rv
        }
        arr = this.callbackListeners['*']
        if (arr) {
          for (var j = 0; j < arr.length; j++) rv = arr[j].call(this, data)
          if (rv) return rv
        }
        return false
      }

      /**
       * Removes the yAxis from the panel if it is not being used by any current renderers. This could be the case
       * if a renderer has been removed. It could also be the case if a renderer is not attached to any series.
       * @param  {CIQ.ChartEngine.Panel} panel The panel
       * @param  {CIQ.ChartEngine.YAxis} yAxis The axis to be removed
       * @memberof CIQ.ChartEngine
       * @since 07/01/2015
       */
      CIQ.ChartEngine.prototype.deleteYAxisIfUnused = function(panel, yAxis) {
        if (!yAxis) return
        if (yAxis.name === panel.yAxis.name) return
        for (var r in this.chart.seriesRenderers) {
          var renderer = this.chart.seriesRenderers[r]
          if (
            renderer.params.yAxis &&
            renderer.params.yAxis.name === yAxis.name
          ) {
            if (renderer.seriesParams.length !== 0) return
          }
        }
        var i
        for (i = 0; i < panel.yaxisLHS.length; i++) {
          if (panel.yaxisLHS[i] === yAxis) panel.yaxisLHS.splice(i, 1)
        }
        for (i = 1; i < panel.yaxisRHS.length; i++) {
          if (panel.yaxisRHS[i] === yAxis) panel.yaxisRHS.splice(i, 1)
        }
        this.resizeCanvas()
        this.adjustPanelPositions()
      }

      /**
       * Adds a yAxis to the specified panel. If the yAxis already exists then it is assigned its match from the panel.
       * @param {CIQ.ChartEngine.Panel} panel The panel to add (i.e. stxx.chart.panel)
       * @param {CIQ.ChartEngine.YAxis} yAxis The YAxis to add (create with new CIQ.ChartEngine.YAxis)
       * @return {CIQ.ChartEngine.YAxis} The YAxis added (or the existing YAxis is a match was found)
       * @memberof CIQ.ChartEngine
       * @since 5.1.0 added return value
       */
      CIQ.ChartEngine.prototype.addYAxis = function(panel, yAxis) {
        if (!yAxis) return
        if (!panel.yaxisLHS) {
          // initialize the arrays of y-axis. This will only happen once.
          panel.yaxisLHS = []
          panel.yaxisRHS = []
          // Our default y-axis goes into the array
          if (panel.yAxis.position == 'left') panel.yaxisLHS.push(panel.yAxis)
          else panel.yaxisRHS.push(panel.yAxis)
        }
        var arr = panel.yaxisLHS.concat(panel.yaxisRHS)
        for (var i = 0; i < arr.length; i++) {
          if (arr[i].name === yAxis.name) return arr[i]
        }
        if (yAxis.position === 'left') {
          panel.yaxisLHS.unshift(yAxis)
        } else {
          yAxis.position = 'right'
          panel.yaxisRHS.push(yAxis)
        }
        this.preAdjustScroll()
        this.resizeCanvas()
        this.adjustPanelPositions()
        this.postAdjustScroll()
        return yAxis
      }
      /**
       * This method calculates the left and width members of each y-axis. Never call this directly. Instead call resizeCanvas().
       * @private
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.calculateYAxisPositions = function() {
        // We push all the charts to the fore because panel widths will depend on what is calculated for their chart
        var panelsInOrder = [],
          chart = this.chart
        for (var chartName in this.charts) {
          panelsInOrder.push(chartName)
        }
        for (var panelName in this.panels) {
          var p = this.panels[panelName]
          if (p.name === p.chart.name) continue
          panelsInOrder.push(panelName)
        }

        var tickWidth = this.drawBorders ? 3 : 0 // pixel width of tick off edge of border
        var maxTotalWidthLeft = 0,
          maxTotalWidthRight = 0,
          i,
          j,
          panel,
          yaxis
        for (j = 0; j < panelsInOrder.length; j++) {
          panel = this.panels[panelsInOrder[j]]
          if (!panel) continue // this could happen if a chart panel doesn't exist yet (for instance when importLayout)
          if (!panel.yaxisLHS) {
            // initialize the arrays of y-axis. This will only happen once.
            panel.yaxisLHS = []
            panel.yaxisRHS = []
            // Our default y-axis goes into the array
            var position = panel.yAxis.position // get default position of the yaxis for the chart
            if (!position) position = panel.chart.panel.yAxis.position // Unless specified, the y-axis position for panels will follow the chart default
            panel[position == 'left' ? 'yaxisLHS' : 'yaxisRHS'].push(
              panel.yAxis
            )
          }
          if (!panel.yAxis.width && panel.yAxis.width !== 0)
            panel.yAxis.width = this.yaxisWidth // legacy default for main axis

          // Calculate the total amount of space to be allocated to the yaxis
          panel.yaxisTotalWidthRight = 0
          panel.yaxisTotalWidthLeft = 0
          var arr = panel.yaxisLHS.concat(panel.yaxisRHS)
          for (i = 0; i < arr.length; i++) {
            yaxis = arr[i]
            if (yaxis.noDraw || !yaxis.width) continue
            if (chart.quoteTextLength && chart.quoteTextLength > yaxis.width)
              yaxis.width = chart.quoteTextLength + tickWidth + 16
            // sets the chart width equal to the length of the measured text plus the inline algorithem for createYAxisLabel (margin*2 where margin is 3) plus padding (10) so currentHR isn't off the canvas.
            if (yaxis.position == 'left') {
              panel.yaxisTotalWidthLeft += yaxis.width
              yaxis.justifyRight =
                yaxis.justifyRight === null
                  ? panel.chart.yAxis.justifyRight
                  : yaxis.justifyRight
              // justifyRight will default to whatever is set in the chart panel's yAxis. If that is null (usually), then yes, justifyRight
              if (yaxis.justifyRight === null) yaxis.justifyRight = true
            } else {
              panel.yaxisTotalWidthRight += yaxis.width
            }
          }
          if (panel.yaxisTotalWidthLeft > maxTotalWidthLeft)
            maxTotalWidthLeft = panel.yaxisTotalWidthLeft
          if (panel.yaxisTotalWidthRight > maxTotalWidthRight)
            maxTotalWidthRight = panel.yaxisTotalWidthRight
        }
        for (j = 0; j < panelsInOrder.length; j++) {
          panel = this.panels[panelsInOrder[j]]
          if (!panel) continue // this could happen if a chart panel doesn't exist yet (for instance when importLayout)
          var isAChart = panel.name === panel.chart.name

          // Now calculate the position of each axis within the canvas
          var x = maxTotalWidthLeft
          for (i = panel.yaxisLHS.length - 1; i >= 0; i--) {
            yaxis = panel.yaxisLHS[i]
            if (yaxis.noDraw) continue
            x -= yaxis.width
            yaxis.left = x
          }
          x = this.width - maxTotalWidthRight
          for (i = 0; i < panel.yaxisRHS.length; i++) {
            yaxis = panel.yaxisRHS[i]
            if (yaxis.noDraw) continue
            yaxis.left = x
            x += yaxis.width
          }

          if (typeof this.yaxisLeft != 'undefined')
            panel.chart.yaxisPaddingRight = this.yaxisLeft // support legacy use of yaxisLeft
          // Calculate the padding. This is enough space for the y-axis' unless overridden by the developer.
          panel.yaxisCalculatedPaddingRight = maxTotalWidthRight
          if (
            panel.chart.yaxisPaddingRight ||
            panel.chart.yaxisPaddingRight === 0
          )
            panel.yaxisCalculatedPaddingRight = panel.chart.yaxisPaddingRight
          panel.yaxisCalculatedPaddingLeft = maxTotalWidthLeft
          if (
            panel.chart.yaxisPaddingLeft ||
            panel.chart.yaxisPaddingLeft === 0
          )
            panel.yaxisCalculatedPaddingLeft = panel.chart.yaxisPaddingLeft

          if (isAChart) {
            panel.left = panel.yaxisCalculatedPaddingLeft
            panel.right = this.width - panel.yaxisCalculatedPaddingRight
          } else {
            panel.left = panel.chart.panel.left
            panel.right = panel.chart.panel.right
          }
          panel.width = panel.right - panel.left
          panel.handle.style.left = panel.left + 'px'
          panel.handle.style.width = panel.width + 'px'

          if (isAChart) {
            // Store this in the chart too
            panel.chart.left = panel.left
            panel.chart.right = panel.right
            panel.chart.width = Math.max(panel.right - panel.left, 0) // negative chart.width creates many problems
          }
        }
      }

      /**
       * This method initializes the chart container events, such as window `resize` events,
       * and the [resizeTimer]{@link CIQ.ChartEngine#setResizeTimer} to ensure the chart adjusts as it's container size changes.
       * It also initializes various internal variables, the canvas and creates the chart panel.
       *
       * This is called by {@link CIQ.ChartEngine#newChart} and should rarely be called directly.
       *
       * Note that the candle width will be reset to 8px if larger than 50px. Even if the value comes from a layout import.
       * This is done to ensure a reasonable candle size is available across devices that may have different screen size.
       *
       * @memberof CIQ.ChartEngine
       *
       */
      CIQ.ChartEngine.prototype.initializeChart = function(container) {
        if (this.runPrepend('initializeChart', arguments)) return
        if (!this.chart.symbolObject.symbol)
          this.chart.symbolObject.symbol = this.chart.symbol // for backwards compatibility so the symbol object is always initialized in case we don't use newChart()
        if (this.locale) this.setLocale(this.locale)
        if (!this.displayZone && CIQ.ChartEngine.defaultDisplayTimeZone) {
          this.setTimeZone(null, CIQ.ChartEngine.defaultDisplayTimeZone)
        }
        this.calculateYAxisPositions()
        this.micropixels = 0

        if (container) this.chart.container = container
        else container = this.chart.container
        container.stx = this
        if (!container.CIQRegistered) {
          container.CIQRegistered = true
          CIQ.ChartEngine.registeredContainers.push(container)
        }
        if (CIQ.isSurface) {
          if (!this.gesture) {
            this.gesture = new MSGesture()
            if (this.manageTouchAndMouse) {
              this.gesture.target = container
            } else {
              this.gesture.target = document.body
            }
            this.gesturePointerId = null
          }
        }
        this.registerHTMLElements() // Sets all of the internal HTML elements to those in the container
        var canvas = this.chart.canvas,
          tempCanvas = this.chart.tempCanvas,
          floatCanvas = this.floatCanvas
        if (canvas && document.createElement('canvas').getContext) {
          if (!canvas.id) {
            //Don't play with canvases which have id's since you don't own them
            container.removeChild(canvas)
            this.chart.canvas = null
          }
          if (tempCanvas && !tempCanvas.id) {
            container.removeChild(tempCanvas)
            this.chart.tempCanvas = null
          }
          if (floatCanvas && !floatCanvas.id) {
            container.removeChild(floatCanvas)
            this.floatCanvas = null
          }
        } else {
          // Just make sure the candleWidth is sane
          if (this.layout.candleWidth < this.minimumCandleWidth)
            this.layout.candleWidth = this.minimumCandleWidth
          if (this.layout.candleWidth > 200) this.layout.candleWidth = 8
        }

        if (!this.chart.canvas)
          canvas = this.chart.canvas = document.createElement('canvas')
        if (!this.chart.canvas.getContext) {
          canvas = this.chart.canvas = container.querySelectorAll(
            '#ie8canvas'
          )[0]
          if (!canvas.getContext) {
            //IE8, didn't initialize canvas yet, we will do manually
            if (window.G_vmlCanvasManager)
              G_vmlCanvasManager.initElement(canvas)
          }
          canvas.style.display = 'block'
        } else {
          container.appendChild(canvas)
        }
        canvas.style.position = 'absolute'
        canvas.style.left = '0px'
        var ctx = (canvas.context = this.chart.context = canvas.getContext(
          '2d'
        ))

        ctx.lineWidth = 1

        if (!this.chart.tempCanvas)
          tempCanvas = this.chart.tempCanvas = document.createElement('canvas')
        if (!this.chart.tempCanvas.getContext) {
          tempCanvas = this.chart.tempCanvas = container.querySelectorAll(
            '#ie8canvasTemp'
          )[0]
          if (!tempCanvas.getContext) {
            //IE8, didn't initialize canvas yet, we will do manually
            if (window.G_vmlCanvasManager)
              G_vmlCanvasManager.initElement(tempCanvas)
          }
        } else {
          container.appendChild(tempCanvas)
        }

        tempCanvas.style.position = 'absolute'
        tempCanvas.style.left = '0px'
        tempCanvas.context = this.chart.tempCanvas.getContext('2d')
        tempCanvas.context.lineWidth = 1
        tempCanvas.style.display = 'none'

        if (!this.floatCanvas)
          floatCanvas = this.floatCanvas = document.createElement('canvas')
        if (!this.floatCanvas.getContext) {
          floatCanvas = this.floatCanvas = container.querySelectorAll(
            '#ie8canvasFloat'
          )[0]
          if (!floatCanvas.getContext) {
            //IE8, didn't initialize canvas yet, we will do manually
            if (window.G_vmlCanvasManager)
              G_vmlCanvasManager.initElement(floatCanvas)
          }
        } else {
          container.appendChild(floatCanvas)
        }

        floatCanvas.style.position = 'absolute'
        floatCanvas.style.left = '0px'
        floatCanvas.context = floatCanvas.getContext('2d')
        floatCanvas.context.lineWidth = 1
        floatCanvas.style.display = 'none'

        this.resizeCanvas()

        if (CIQ.isAndroid) {
          this.chart.tempCanvas.ontouchstart = function(e) {
            if (e.preventDefault) e.preventDefault()
          }
          this.floatCanvas.ontouchstart = function(e) {
            if (e.preventDefault) e.preventDefault()
          }
        }

        var chart = this.chart,
          panels = this.panels
        panels.chart.display = chart.symbol
        if (chart.symbolDisplay) panels.chart.display = chart.symbolDisplay
        this.adjustPanelPositions()
        this.chart.panel = panels[chart.name]
        this.calculateYAxisMargins(chart.panel.yAxis)

        this.initialWhitespace = this.preferences.whitespace
        if (chart.dataSet && chart.dataSet.length > 0) {
          chart.scroll = Math.floor(chart.width / this.layout.candleWidth) //this.chart.maxTicks;
          var wsInTicks = Math.round(
            this.preferences.whitespace / this.layout.candleWidth
          )
          chart.scroll -= wsInTicks
        }
        if (CIQ.touchDevice) {
          var overlayEdit = $$$('.overlayEdit', container)
          var overlayTrashCan = $$$('#overlayTrashCan', container)
          var vectorTrashCan = $$$('#vectorTrashCan', container)
          if (overlayEdit) {
            CIQ.safeClickTouch(
              overlayEdit,
              (function(self) {
                return function(e) {
                  self.deleteHighlighted(true, true)
                }
              })(this)
            )
            if (overlayTrashCan) {
              CIQ.safeClickTouch(
                overlayTrashCan,
                (function(self) {
                  return function(e) {
                    self.deleteHighlighted(false)
                  }
                })(this)
              )
            }
          } else if (overlayTrashCan) {
            CIQ.safeClickTouch(
              overlayTrashCan,
              (function(self) {
                return function(e) {
                  self.deleteHighlighted(true)
                }
              })(this)
            )
          }
          if (vectorTrashCan) {
            CIQ.safeClickTouch(
              vectorTrashCan,
              (function(self) {
                return function(e) {
                  self.deleteHighlighted(true)
                }
              })(this)
            )
          }
        }
        if (this.manageTouchAndMouse) {
          this.registerTouchAndMouseEvents()
          if (this.controls.chartControls) {
            this.controls.chartControls.style.display = 'block'
          }
        }
        container.onmouseout = (function(self) {
          return function(e) {
            self.handleMouseOut(e)
          }
        })(this)

        this.abortDrawings()
        this.undoStamps = []
        for (var panelName in panels) {
          var panel = panels[panelName]
          if (panel.markerHolder) {
            container.removeChild(panel.markerHolder)
            panel.markerHolder = null
          }
        }
        for (var i in this.plugins) {
          var plugin = this.plugins[i]
          if (plugin.display) {
            if (plugin.initializeChart) plugin.initializeChart(this)
          }
        }
        // This sets a resize listener for when the screen itself is resized.
        if (!this.resizeListenerInitialized) {
          var self = this
          this.resizeListenerInitialized = true
          var resizeListener = function() {
            return function(e) {
              self.resizeChart()
            }
          }
          this.addDomEventListener(window, 'resize', resizeListener(), true)
        }
        if (chart.baseline.userLevel) chart.baseline.userLevel = null
        // This sets the interval timer which checks fore resize condition every X milliseconds (if non zero)
        this.setResizeTimer(this.resizeDetectMS)
        this.runAppend('initializeChart', arguments)
      }

      /**
       * Clears out a chart engine instantiated with [new CIQ.ChartEngine();]{@link CIQ.ChartEngine},
       * eliminating all references including the resizeTimer, quoteDriver, styles and eventListeners.
       *
       * It's still up to the developer to set the declared pointer for the instance to null so that the garbage collector can remove it.
       *
       * This method should only be used when you no longer need the chart engine and **never** be used in between {@link CIQ.ChartEngine#newChart} calls to load or change symbols.
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.destroy = function() {
        this.setResizeTimer(0)
        if (this.quoteDriver) this.quoteDriver.die()
        this.styles = {} // Get rid of any external style references that could cause us to hang around
        for (var i = 0; i < this.eventListeners.length; i++) {
          var listener = this.eventListeners[i]
          listener.element.removeEventListener(
            listener.event,
            listener['function'],
            listener.options
          )
        }
        if (this.streamParameters.timeout)
          clearTimeout(this.streamParameters.timeout)

        // remove chart container from registeredContainers
        var registeredContainers = CIQ.ChartEngine.registeredContainers
        var chartIndex = registeredContainers.indexOf(this.chart.container)
        if (chartIndex > -1) {
          registeredContainers.splice(chartIndex, 1)
        }

        // remove matching range slider
        if (this.slider) {
          var sliderIndex = registeredContainers.indexOf(
            this.slider.slider.chart.container
          )
          if (sliderIndex > -1) {
            registeredContainers.splice(sliderIndex, 1)
          }
        }
      }

      /**
       * <span class="injection">INJECTABLE</span>
       * This is called whenever the mouse leaves the chart area. Crosshairs are disabled, stickies are hidden, dragDrawings are completed.
       * @param  {Event} e The mouseout event
       * @memberof CIQ.ChartEngine.AdvancedInjectable#
       * @alias handleMouseOut
       */
      CIQ.ChartEngine.prototype.handleMouseOut = function(e) {
        e = e || window.event
        if (!CIQ.withinElement(this.chart.container, e.pageX, e.pageY)) {
          if (this.runPrepend('handleMouseOut', arguments)) return
          this.undisplayCrosshairs()
          // Added 9/19/2013 to unleash grabbing when the mouse moves out of the container
          this.grabbingScreen = false
          this.touches = []
          this.touching = false
          if (this.activeDrawing && this.userPointerDown) {
            //end the drawing
            this.userPointerDown = false
            this.drawingLine = false
            var cy = this.backOutY(e.pageY)
            var cx = this.backOutX(e.pageX)
            this.drawingClick(this.currentPanel, cx, cy)
          }
          CIQ.ChartEngine.insideChart = false
          // Added to remove sticky when the mouse moves out of the container
          this.displaySticky()
          this.findHighlights(false, true)
          this.runAppend('handleMouseOut', arguments)
        }
      }

      /**
       * Registers touch and mouse events for the chart (for dragging, clicking, zooming). The events are registered on the container div (not the canvas).
       * Set {@link CIQ.ChartEngine#manageTouchAndMouse} to false to disable the built in event handling (events will not be registered with the container).
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.registerTouchAndMouseEvents = function() {
        if (this.touchAndMouseEventsRegistered) return
        this.touchAndMouseEventsRegistered = true
        var zoomInEl = $$$('#zoomIn', this.controls.chartControls)
        var zoomOutEl = $$$('#zoomOut', this.controls.chartControls)
        var containerElement = this.chart.container
        var self = this
        var addListener = function(event, listener) {
          self.addDomEventListener(containerElement, event, listener)
        }
        if (!CIQ.touchDevice) {
          addListener('mousemove', function(e) {
            self.mousemove(e)
          })
          addListener('mousedown', function(e) {
            self.mousedown(e)
          })
          addListener('mouseup', function(e) {
            self.mouseup(e)
          })
        } else {
          if (CIQ.isSurface) {
            addListener('mousemove', function(e) {
              self.msMouseMoveProxy(e)
            })
            addListener('mousedown', function(e) {
              self.msMouseDownProxy(e)
            })
            addListener('mouseup', function(e) {
              self.msMouseUpProxy(e)
            })

            if (window.navigator.msPointerEnabled) {
              addListener('MSPointerDown', function(e) {
                return self.startProxy(e)
              })
              addListener('MSGestureStart', function(e) {
                self.gestureInEffect = true
              })
              addListener('MSGestureChange', function(e) {
                return self.touchmove(e)
              })
              addListener('MSGestureEnd', function(e) {
                self.gestureInEffect = false
                return self.touchend(e)
              })
              addListener('MSPointerMove', function(e) {
                self.moveProxy(e)
              })
              addListener('MSPointerUp', function(e) {
                return self.endProxy(e)
              })
            } else {
              addListener('pointerdown', function(e) {
                return self.startProxy(e)
              })
              addListener('MSGestureStart', function(e) {
                self.gestureInEffect = true
              })
              addListener('MSGestureChange', function(e) {
                return self.touchmove(e)
              })
              addListener('MSGestureEnd', function(e) {
                self.gestureInEffect = false
                return self.touchend(e)
              })
              addListener('pointermove', function(e) {
                self.moveProxy(e)
              })
              addListener('pointerup', function(e) {
                return self.endProxy(e)
              })
            }
          } else {
            // We need mouse events for all-in-one computers that accept both mouse and touch commands
            // Actually, only for Firefox and Chrome browsers. IE10 sends pointers which are managed by the isSurface section
            if (!CIQ.isAndroid && !CIQ.ipad && !CIQ.iphone) {
              addListener('mousemove', function(e) {
                self.iosMouseMoveProxy(e)
              })
              addListener('mousedown', function(e) {
                self.iosMouseDownProxy(e)
              })
              addListener('mouseup', function(e) {
                self.iosMouseUpProxy(e)
              })
            }

            addListener('touchstart', function(e) {
              self.touchstart(e)
            })
            addListener('touchmove', function(e) {
              self.touchmove(e)
            })
            addListener('touchend', function(e) {
              self.touchend(e)
            })

            if (zoomInEl) {
              zoomInEl.removeAttribute('onMouseOver')
              zoomInEl.removeAttribute('onMouseOut')
            }
            if (zoomOutEl) {
              zoomOutEl.removeAttribute('onMouseOver')
              zoomOutEl.removeAttribute('onMouseOut')
            }
          }
        }

        var wheelEvent = CIQ.wheelEvent

        if (this.captureMouseWheelEvents) {
          this.addDomEventListener(containerElement, wheelEvent, function(e) {
            self.mouseWheel(e)
          })
        }
      }

      /**
       * <span class="injection">INJECTABLE</span>
       * This function is called when the user right clicks on a highlighted overlay, series or drawing.
       * Calls deleteHighlighted() which calls rightClickOverlay() for studies.
       * @memberof CIQ.ChartEngine.AdvancedInjectable#
       * @alias rightClickHighlighted
       */
      CIQ.ChartEngine.prototype.rightClickHighlighted = function() {
        if (this.runPrepend('rightClickHighlighted', arguments)) return
        this.deleteHighlighted(true)
        this.runAppend('rightClickHighlighted', arguments)
      }

      /**
       * <span class="injection">INJECTABLE</span>
       * Removes any and all highlighted overlays, series or drawings.
       * @memberof CIQ.ChartEngine.AdvancedInjectable#
       * @alias deleteHighlighted
       * @since 4.1.0 Removes a renderer from the chart if it has no series attached to it.
       */
      CIQ.ChartEngine.prototype.deleteHighlighted = function(
        callRightClick,
        forceEdit
      ) {
        if (this.runPrepend('deleteHighlighted', arguments)) return
        this.cancelTouchSingleClick = true
        CIQ.clearCanvas(this.chart.tempCanvas, this)
        var canDeleteAll = this.bypassRightClick === false
        if (canDeleteAll || !this.bypassRightClick.drawing) {
          for (var i = this.drawingObjects.length - 1; i >= 0; i--) {
            var drawing = this.drawingObjects[i]
            if (drawing.highlighted && !drawing.permanent) {
              var dontDeleteMe = drawing.abort()
              if (!dontDeleteMe) {
                var before = CIQ.shallowClone(this.drawingObjects)
                this.drawingObjects.splice(i, 1)
                this.undoStamp(before, CIQ.shallowClone(this.drawingObjects))
              }
              this.changeOccurred('vector')
            }
          }
        }
        if (canDeleteAll || !this.bypassRightClick.study) {
          for (var name in this.overlays) {
            var o = this.overlays[name]
            if (o.highlight && !o.permanent) {
              if (callRightClick || forceEdit)
                this.rightClickOverlay(name, forceEdit)
              else this.removeOverlay(name)
            }
          }
        }

        var chart = this.currentPanel.chart
        if (canDeleteAll || !this.bypassRightClick.series) {
          for (var r in chart.seriesRenderers) {
            var renderer = chart.seriesRenderers[r]
            for (var sp = renderer.seriesParams.length - 1; sp >= 0; sp--) {
              var series = renderer.seriesParams[sp]
              if (series.highlight && !series.permanent) {
                renderer.removeSeries(series.id)
                if (renderer.seriesParams.length < 1)
                  this.removeSeriesRenderer(renderer)
              }
            }
          }
        }

        this.draw()
        this.clearMeasure()
        if (this.controls.mSticky) {
          this.controls.mSticky.style.display = 'none'
          this.controls.mSticky.children[0].innerHTML = ''
        }
        this.runAppend('deleteHighlighted', arguments)
      }

      /**
       * Returns true if the panel exists
       * @param  {string} name Name of panel to search for
       * @return {boolean}	  True if the panel exists
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.panelExists = function(name) {
        for (var p in this.panels) {
          var panel = this.panels[p]
          if (panel.name == name) return true
        }
        return false
      }

      /**
       * Turns crosshairs off
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.hideCrosshairs = function() {
        this.displayCrosshairs = false
      }

      /**
       * Turns crosshairs on
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.showCrosshairs = function() {
        this.displayCrosshairs = true
      }

      /**
       * <span class="injection">INJECTABLE</span>
       * Event handler that is called when the handle of a panel is grabbed, for resizing
       * @param  {Event} e	 The mousedown or touchdown event
       * @param  {CIQ.ChartEngine.Panel} panel The panel that is being grabbed
       * @memberof CIQ.ChartEngine.AdvancedInjectable#
       * @alias grabHandle
       */
      CIQ.ChartEngine.prototype.grabHandle = function(panel) {
        if (this.runPrepend('grabHandle', arguments)) return
        //if(e.preventDefault) e.preventDefault();
        if (!panel) return
        CIQ.ChartEngine.crosshairY = panel.top + this.top
        CIQ.ChartEngine.resizingPanel = panel
        CIQ.appendClassName(panel.handle, 'stx-grab')
        this.runAppend('grabHandle', arguments)
      }

      /**
       * Event handler that is called when a panel handle is released.
       * @param  {Event} e The mouseup or touchup event
       * @memberof CIQ.ChartEngine.AdvancedInjectable#
       * @alias releaseHandle
       */
      CIQ.ChartEngine.prototype.releaseHandle = function() {
        if (this.runPrepend('releaseHandle', arguments)) return
        //if(e.preventDefault) e.preventDefault();
        CIQ.clearCanvas(this.chart.tempCanvas, this)
        this.resizePanels()
        if (CIQ.ChartEngine.resizingPanel)
          CIQ.unappendClassName(
            CIQ.ChartEngine.resizingPanel.handle,
            'stx-grab'
          )
        CIQ.ChartEngine.resizingPanel = null
        this.runAppend('releaseHandle', arguments)
      }

      /**
       * Takes the existing panels and stores them in the layout.
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.storePanels = function() {
        if (!this.layout) this.layout = {}
        var view = this.layout
        view.panels = {}
        for (var p in this.panels) {
          var panel = this.panels[p]
          view.panels[panel.name] = {
            percent: panel.percent,
            display: panel.display,
          }
        }
      }

      /**
       * Saves the panel state in the layout. Called whenever there is a change to panel layout (resizing, opening, closing).
       * @param  {boolean} saveLayout If false then a change event will not be called. See (@link CIQ.ChartEngine#changeOccurred)
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.savePanels = function(saveLayout) {
        this.storePanels()
        if (saveLayout !== false) this.changeOccurred('layout')
      }

      /**
       * Returns the absolute screen position given a Y pixel on the canvas
       * @param  {number} y Y pixel on the canvas
       * @return {number}	  Absolute Y screen position
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.resolveY = function(y) {
        return this.top + y
      }

      /**
       * Returns the absolute screen position given a X pixel on the canvas
       * @param  {number} x X pixel on the canvas
       * @return {number}	  Absolute X screen position
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.resolveX = function(x) {
        return this.left + x
      }

      /**
       * Returns the relative canvas position given an absolute Y position on the screen
       * @param  {number} y Y pixel on the screen
       * @return {number}	  Relative Y position on canvas
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.backOutY = function(y) {
        return y - this.top
      }

      /**
       * Returns the relative canvas position given an absolute X position on the screen
       * @param  {number} x X pixel on the screen
       * @return {number}	  Relative X position on canvas
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.backOutX = function(x) {
        return x - this.left
      }

      /**
       * Cleans up a removed study. called by {@link CIQ.ChartEngine#privateDeletePanel} or {@link CIQ.ChartEngine#removeOverlay}
       * Calls removeFN, and plugins associated with study.
       * Finally, removes study from layout.
       * @param  {CIQ.ChartEngine} stx A chart object
       * @param  {object} sd  A study descriptor
       * @memberof CIQ.ChartEngine
       * @private
       * @since 2015-11-1
       */
      CIQ.ChartEngine.prototype.cleanupRemovedStudy = function(sd) {
        if (sd.study.removeFN) sd.study.removeFN(this, sd)
        if (sd.study.feed) {
          this.detachTagAlongQuoteFeed(sd.study.feed)
        }
        // delete any plugins associated with this study
        for (var p in this.plugins) {
          if (p.indexOf('{' + sd.id + '}') > -1) delete this.plugins[p]
        }
        if (this.layout.studies) delete this.layout.studies[sd.name]
        CIQ.Studies.removeStudySymbols(sd, this)
        if (this.quoteDriver) this.quoteDriver.updateSubscriptions()
      }

      /**
       * Internal function for deleting a panel and its associated DOM objects
       * Do not call directly. Always call panelClose
       * @private
       */
      CIQ.ChartEngine.prototype.privateDeletePanel = function(panel) {
        if (this.layout.studies) {
          var mySD = this.layout.studies[panel.name]
          if (mySD) this.cleanupRemovedStudy(mySD)
        }
        // If we ever want to delete any drawing objects in a panel
        /*var drawingDeleted=false;
		for(var i=0;i<this.drawingObjects.length;i++){
			var drawing=this.drawingObjects[i];
			if(this.panels[drawing.panelName]==panel){
				drawing.abort();
				this.drawingObjects.splice(i,1);
				drawingDeleted=true;
			}
		}*/
        delete this.panels[panel.name]
        if (CIQ.Studies) {
          for (var spm in CIQ.Studies.studyPanelMap) {
            if (CIQ.Studies.studyPanelMap[spm].panel == panel.name)
              delete CIQ.Studies.studyPanelMap[spm]
          }
        }
        for (var series in this.overlays) {
          if (this.overlays[series].panel == panel.name) {
            this.cleanupRemovedStudy(this.layout.studies[series])
            delete this.overlays[series]
          }
        }

        if (panel.holder) {
          this.chart.container.removeChild(panel.holder)
          if (this.getMarkerArray) {
            var arr = this.getMarkerArray('panelName', panel.name)
            for (var i = 0; i < arr.length; i++) {
              this.removeFromHolder(arr[i])
            }
          }
        }
        panel.handle.parentNode.removeChild(panel.handle)
        //if(drawingDeleted) this.changeOccurred("vector");
        this.currentPanel = null
      }

      /**
       * <span class="injection">INJECTABLE</span>
       * Closes the panel opened with {@link CIQ.ChartEngine.AdvancedInjectable#createPanel}.
       * This is called when a chart panel is closed manually or programatically.
       * For example, after removing a study panel with the {@link CIQ.Studies.removeStudy} function, or when a user clicks on the "X" for a panel.
       * @param  {CIQ.ChartEngine.Panel} panel The panel to close
       * @memberof CIQ.ChartEngine.AdvancedInjectable#
       * @alias panelClose
       *
       */
      CIQ.ChartEngine.prototype.panelClose = function(panel) {
        if (!panel) return
        if (this.runPrepend('panelClose', arguments)) return
        this.cancelTouchSingleClick = true
        CIQ.ChartEngine.drawingLine = false
        if (panel.soloing) this.panelSolo(panel)

        // If we're deleting a panel with a chart in it
        if (this.charts[panel.name]) {
          // Then delete all the panels that reference that chart
          for (var panelName in this.panels) {
            var subPanel = this.panels[panelName]
            if (subPanel.chart.name == panel.name) {
              this.privateDeletePanel(subPanel)
            }
          }
          // and delete the chart itself
          delete this.charts[panel.name]
        } else {
          // otherwise just delete the panel
          this.privateDeletePanel(panel)
        }
        if (!this.currentlyImporting) {
          // silent mode while importing
          this.showCrosshairs()
          this.createDataSet()
          this.adjustPanelPositions()
          this.draw()
          this.savePanels()
        }
        if (this.openDialog) this.openDialog = ''
        this.runAppend('panelClose', arguments)
      }

      /**
       * Deletes all of the panels (except for the default chart panel)
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.deleteAllPanels = function() {
        for (var p in this.panels) {
          var panel = this.panels[p]
          this.privateDeletePanel(panel)
        }
        this.layout.panels = {}
        this.panels = {}
      }

      /**
       * This moves a panel up one position (when the user clicks the up arrow).
       * @param  {CIQ.ChartEngine.Panel} panel The panel to move up.
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.panelUp = function(panel) {
        this.cancelTouchSingleClick = true
        CIQ.ChartEngine.drawingLine = false
        this.showCrosshairs()
        var newPanels = {}
        var pos = 0
        var p
        for (p in this.panels) {
          if (p == panel.name) break
          pos++
        }

        if (!pos) return //already at top

        var i = 0
        for (p in this.panels) {
          if (i == pos - 1) newPanels[panel.name] = panel
          if (p == panel.name) continue
          newPanels[p] = this.panels[p]
          i++
        }
        this.panels = newPanels
        this.adjustPanelPositions()
        this.draw()
        this.savePanels()
      }

      /**
       * This moves a panel down one position (when the user clicks the down arrow).
       * @param  {CIQ.ChartEngine.Panel} panel The panel to move down.
       * @memberof CIQ.ChartEngine
       */

      CIQ.ChartEngine.prototype.panelDown = function(panel) {
        this.cancelTouchSingleClick = true
        CIQ.ChartEngine.drawingLine = false
        this.showCrosshairs()
        var newPanels = {}
        var pos = 0
        var p
        for (p in this.panels) {
          if (p == panel.name) break
          pos++
        }

        var length = 0
        for (p in this.panels) length++
        if (pos == length - 1) return //already at bottom

        var i = 0
        for (p in this.panels) {
          if (p == panel.name) {
            i++
            continue
          }
          newPanels[p] = this.panels[p]
          if (i == pos + 1) newPanels[panel.name] = panel
          i++
        }
        this.panels = newPanels
        this.adjustPanelPositions()
        this.draw()
        this.savePanels()
      }

      /**
       * This "solos" the panel (when the user clicks the solo button). All panels other than this panel and the chart
       * are temporarily hidden. If the solo panel is the chart then all other panels will be hidden.
       * Note if {@link CIQ.ChartEngine#soloPanelToFullScreen} is set than even the chart panel may be hidden
       * @param  {CIQ.ChartEngine.Panel} panel The panel to be soloed.
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.panelSolo = function(panel) {
        this.cancelTouchSingleClick = true
        CIQ.ChartEngine.drawingLine = false
        this.showCrosshairs()
        var hideOrNot = true
        if (panel.soloing) {
          hideOrNot = false
          panel.soloing = false
          CIQ.unappendClassName(panel.solo, 'stx_solo_lit')
          panel.percent = panel.oldPercent
          if (panel.name != 'chart' && !this.soloPanelToFullScreen) {
            this.panels.chart.percent = this.panels.chart.oldPercent
          }
          if (this.soloPanelToFullScreen) {
            this.xAxisAsFooter = this.panels.chart.oldXAxisAsFooter
            this.panels.chart.subholder.appendChild(this.controls.home)
          }
        } else {
          panel.soloing = true
          CIQ.appendClassName(panel.solo, 'stx_solo_lit')
          panel.oldPercent = panel.percent
          if (panel.name != 'chart') {
            if (this.soloPanelToFullScreen) {
              this.panels.chart.oldXAxisAsFooter = this.xAxisAsFooter
              this.xAxisAsFooter = true
              panel.subholder.appendChild(this.controls.home)
            } else {
              this.panels.chart.oldPercent = this.panels.chart.percent
              panel.percent = 1 - this.panels.chart.percent
            }
          }
        }
        for (var p in this.panels) {
          this.panels[p].hidden = hideOrNot
        }
        if (!this.soloPanelToFullScreen) this.panels.chart.hidden = false
        panel.hidden = false
        this.adjustPanelPositions()
        this.draw()
        this.savePanels()
      }

      //@private
      CIQ.ChartEngine.prototype.calculatePanelPercent = function(panel) {
        var h = panel.bottom - panel.top
        panel.percent = h / this.chart.canvasHeight
      }

      /**
       * Called when the user moves a panel handle, to resize all of the panels relative to the movement.
       * @private
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.resizePanels = function() {
        if (!CIQ.ChartEngine.resizingPanel) return
        var up = true
        var p, newY, priorPanel
        if (
          CIQ.ChartEngine.crosshairY >
          this.resolveY(CIQ.ChartEngine.resizingPanel.top)
        )
          up = false
        if (up) {
          priorPanel = null
          for (p in this.panels) {
            if (this.panels[p] == CIQ.ChartEngine.resizingPanel) break
            if (this.panels[p].hidden) continue
            priorPanel = this.panels[p]
          }
          newY = this.backOutY(CIQ.ChartEngine.crosshairY)
          if (newY < priorPanel.top + 30) {
            newY = priorPanel.top + 30
            CIQ.ChartEngine.crosshairY = this.resolveY(newY)
          }
          priorPanel.bottom = newY
          CIQ.ChartEngine.resizingPanel.top = newY
          this.calculatePanelPercent(priorPanel)
          this.calculatePanelPercent(CIQ.ChartEngine.resizingPanel)
        } else {
          priorPanel = null
          for (p in this.panels) {
            if (this.panels[p] == CIQ.ChartEngine.resizingPanel) break
            if (this.panels[p].hidden) continue
            priorPanel = this.panels[p]
          }
          newY = this.backOutY(CIQ.ChartEngine.crosshairY)
          if (newY > CIQ.ChartEngine.resizingPanel.bottom - 30) {
            newY = CIQ.ChartEngine.resizingPanel.bottom - 30
            CIQ.ChartEngine.crosshairY = this.resolveY(newY)
          }
          priorPanel.bottom = newY
          CIQ.ChartEngine.resizingPanel.top = newY
          this.calculatePanelPercent(priorPanel)
          this.calculatePanelPercent(CIQ.ChartEngine.resizingPanel)
        }

        this.adjustPanelPositions()
        this.draw()
        this.savePanels()
      }

      // First, adjust the panel percentages so that they all add up to 1
      // Secondly, set the pixel top and bottom of each panel based on the percentages
      /**
       * <span class="injection">INJECTABLE</span>
       * Adjusts the positions of all of the panels. Ensures that panel percentages add up to 100%. Sets the panel top and bottom
       * based on the percentages. Also sets the icon template icons appropriately for each panel's position. And adjusts
       * any drawings. Finally it makes some calculations that are used by the y-axis.
       * @memberof CIQ.ChartEngine.AdvancedInjectable#
       * @alias adjustPanelPositions
       */
      CIQ.ChartEngine.prototype.adjustPanelPositions = function() {
        if (this.chart.tempCanvas) CIQ.clearCanvas(this.chart.tempCanvas, this) // clear any drawing in progress
        if (!this.chart.symbol) return
        if (this.runPrepend('adjustPanelPositions', arguments)) return
        var lastBottom = 0
        var h = this.chart.canvasHeight
        var first = false
        var acc = 0
        var n = 0
        var activeSolo = false
        var x, panel
        for (x in this.panels) {
          panel = this.panels[x]
          if (isNaN(panel.percent) || panel.percent <= 0) panel.percent = 0.05
          if (panel.hidden) continue
          acc += panel.percent
          n++
          if (panel.soloing) activeSolo = true
        }

        for (x in this.panels) {
          var zoomRatio = 0
          panel = this.panels[x]

          if (panel.hidden) {
            if (panel.markerHolder) {
              panel.markerHolder.style.display = 'none'
            }
            continue
          }
          if (!first) {
            first = true
            panel.up.style.display = 'none'
          } else {
            if (this.displayIconsUpDown) panel.up.style.display = ''
          }
          if (activeSolo) {
            if (panel.soloing) {
              if (this.displayIconsSolo) panel.solo.style.display = ''
            } else {
              panel.solo.style.display = 'none'
            }
          } else if (n == 1) {
            panel.solo.style.display = 'none'
          } else if (n == 2 && !this.soloPanelToFullScreen) {
            panel.solo.style.display = 'none'
          } else {
            if (this.displayIconsSolo) panel.solo.style.display = ''
          }
          if (n == 1) {
            panel.down.style.display = 'none'
          } else {
            if (this.displayIconsUpDown) panel.down.style.display = ''
          }
          if (panel.editFunction) panel.edit.style.display = ''
          else panel.edit.style.display = 'none'

          panel.percent = panel.percent / acc
          panel.top = lastBottom
          panel.bottom = panel.top + h * panel.percent
          panel.height = panel.bottom - panel.top
          if (panel.chart.name == panel.name) {
            panel.chart.top = panel.top
            panel.chart.bottom = panel.bottom
            panel.chart.height = panel.height
          }
          var yAxis = panel.yAxis

          if (yAxis.zoom && yAxis.height > 0) {
            zoomRatio = yAxis.zoom / yAxis.height
          }
          this.adjustYAxisHeightOffset(panel, yAxis)
          yAxis.height = yAxis.bottom - yAxis.top
          if (zoomRatio) {
            yAxis.zoom = zoomRatio * yAxis.height
            if (yAxis.zoom > yAxis.height) {
              //console.log('adjustPanelPositions adjusted zoom and scroll to 0',yAxis.zoom,yAxis.height);
              yAxis.zoom = 0 // If the zoom is greater than the height then we'll have an upside down y-axis
              yAxis.scroll = 0
            }
          }
          lastBottom = panel.bottom

          if (!yAxis.high && yAxis.high !== 0) {
            // panels without values will use percentages to position drawings
            yAxis.high = 100
            yAxis.low = 0
            yAxis.shadow = 100
          }
          yAxis.multiplier = yAxis.height / yAxis.shadow

          if (panel.holder) {
            panel.holder.style.right = '0px'
            panel.holder.style.top = panel.top + 'px'
            panel.holder.style.left = '0px'
            panel.holder.style.height = panel.height + 'px'

            panel.subholder.style.left = panel.left + 'px'
            panel.subholder.style.width = panel.width + 'px'
            panel.subholder.style.top = '0px'
            if (yAxis.height >= 0)
              panel.subholder.style.height = yAxis.height + 'px'
          }
        }
        if (x) this.panels[x].down.style.display = 'none'
        if (n == 2 && !activeSolo) {
          this.panels.chart.solo.style.display = ''
        }
        if (this.controls.chartControls && this.panels.chart) {
          var bottom
          if (activeSolo && this.soloPanelToFullScreen) {
            bottom = this.chart.canvasHeight - panel.yAxis.bottom + 12
          } else {
            bottom =
              this.chart.canvasHeight - this.panels.chart.yAxis.bottom + 12
          }
          this.controls.chartControls.style.bottom = bottom + 'px'
        }
        this.clearPixelCache()

        this.adjustDrawings()

        this.runAppend('adjustPanelPositions', arguments)
      }

      //Unused
      CIQ.ChartEngine.prototype.addChart = function(name, chart) {
        chart.name = name
        this.charts[name] = chart
      }

      /**
       * <span class="injection">INJECTABLE</span>
       * Create a new panel and make room for it by squeezing all the existing panels.
       * To remove a panel manually call {@link CIQ.ChartEngine.AdvancedInjectable#panelClose}.
       * @param  {string} display	  The display name for the panel
       * @param  {string} name	  The name of the panel (usually the study ID)
       * @param  {number} [height]	Requested height of panel in pixels. Defaults to 1/5 of the screen size.
       * @param  {string} [chartName] The chart to associate with this panel. Defaults to "chart".
       * @memberof CIQ.ChartEngine.AdvancedInjectable#
       * @alias createPanel
       */
      CIQ.ChartEngine.prototype.createPanel = function(
        display,
        name,
        height,
        chartName
      ) {
        if (this.runPrepend('createPanel', arguments)) return
        if (!chartName) chartName = 'chart'
        var h = this.chart.canvasHeight
        if (!height) {
          height = h * 0.2
        }
        var percent = height / h
        var reduce = 1 - percent
        for (var p in this.panels) {
          var panel = this.panels[p]
          panel.percent *= reduce
        }
        this.stackPanel(display, name, percent, chartName)
        this.adjustPanelPositions()
        this.savePanels(false)
        this.runAppend('createPanel', arguments)
      }

      /**
       * Configures the panel controls
       * @param  {CIQ.ChartEngine.Panel} panel The panel
       * @private
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.configurePanelControls = function(panel) {
        var isChart = panel.name == panel.chart.name

        panel.icons = $$$('.stx-panel-control', panel.holder)
        panel.close = panel.icons.children[4]
        panel.close = $$$('.stx-ico-close', panel.icons).parentNode
        CIQ.appendClassName(panel.icons, 'stx-show')

        panel.title = $$$('.stx-panel-title', panel.icons)
        panel.up = $$$('.stx-ico-up', panel.icons).parentNode
        panel.solo = $$$('.stx-ico-focus', panel.icons).parentNode
        panel.down = $$$('.stx-ico-down', panel.icons).parentNode
        panel.edit = $$$('.stx-ico-edit', panel.icons).parentNode

        if (!this.displayIconsUpDown) panel.up.style.display = 'none'
        if (!this.displayIconsUpDown) panel.down.style.display = 'none'
        if (!this.displayIconsSolo) panel.solo.style.display = 'none'
        if (!this.displayIconsClose) {
          panel.close.style.display = 'none'
        }
        if (!this.displayPanelResize) panel.handle.style.display = 'none'

        panel.title.innerHTML = ''
        if (panel.display)
          panel.title.appendChild(document.createTextNode(panel.display))
        if (isChart) {
          CIQ.appendClassName(panel.title, 'chart-title')
          CIQ.appendClassName(panel.icons, 'stx-chart-panel')
        }
        if (!CIQ.touchDevice || CIQ.isSurface) this.makeModal(panel.icons)

        if (!CIQ.touchDevice || CIQ.isSurface)
          panel.handle.onmouseover = (function(self) {
            return function() {
              self.hideCrosshairs()
            }
          })(this)
        if (!CIQ.touchDevice || CIQ.isSurface)
          panel.handle.onmouseout = (function(self) {
            return function() {
              self.showCrosshairs()
            }
          })(this)
        if (CIQ.touchDevice) {
          panel.handle.ontouchstart = (function(stx, panel) {
            return function(e) {
              if (stx.resizingPanel) return
              e.preventDefault()
              stx.grabHandle(panel)
            }
          })(this, panel)
          panel.handle.ontouchend = (function(stx) {
            return function(e) {
              e.preventDefault()
              stx.releaseHandle()
            }
          })(this)
        }
        panel.handle.onmousedown = (function(stx, panel) {
          return function(e) {
            if (!e) e = event
            stx.grabHandle(panel)
          }
        })(this, panel)
        panel.handle.onmouseup = (function(stx) {
          return function(e) {
            if (!e) e = event
            stx.releaseHandle()
          }
        })(this)
        CIQ.safeClickTouch(
          panel.close,
          (function(stx, panel) {
            return function() {
              stx.panelClose(panel)
            }
          })(this, panel)
        )
        CIQ.safeClickTouch(
          panel.up,
          (function(stx, panel) {
            return function() {
              stx.panelUp(panel)
            }
          })(this, panel)
        )
        CIQ.safeClickTouch(
          panel.down,
          (function(stx, panel) {
            return function() {
              stx.panelDown(panel)
            }
          })(this, panel)
        )
        CIQ.safeClickTouch(
          panel.solo,
          (function(stx, panel) {
            return function() {
              stx.panelSolo(panel)
            }
          })(this, panel)
        )
        if (panel.name == 'chart') panel.close.style.display = 'none' // never close primary chart
      }
      /**
       * <span class="injection">INJECTABLE</span>
       * Adds a panel with a prespecified percentage. This should be called iteratively when rebuilding a set
       * of panels from a previous layout. Use {@link CIQ.ChartEngine#createPanel} when creating a new panel for an existing chart layout.
       * @param  {string} display	  The display name for the panel
       * @param  {string} name	  The name of the panel (usually the study ID)
       * @param  {number} percent	  The percentage of chart to use
       * @param  {string} [chartName] The chart to associate with this panel. Defaults to "chart".
       * @memberof CIQ.ChartEngine.AdvancedInjectable#
       * @alias stackPanel
       */
      CIQ.ChartEngine.prototype.stackPanel = function(
        display,
        name,
        percent,
        chartName
      ) {
        if (this.runPrepend('stackPanel', arguments)) return
        if (!chartName) chartName = 'chart'
        var chart = this.charts[chartName]
        var isChart = name == chartName
        var yAxis = null
        if (isChart) {
          display = chart.symbol
          if (chart.symbolDisplay) display = chart.symbolDisplay
          yAxis = chart.yAxis
        }
        var panel = (this.panels[name] = new CIQ.ChartEngine.Panel(name, yAxis))
        if (!isChart && chart.yAxis) {
          panel.yAxis.width = chart.yAxis.width // make it match the width of the main panel so the y axis align
        }

        panel.percent = percent
        panel.chart = chart
        panel.display = display
        panel.holder = CIQ.newChild(this.container, 'div', 'stx-holder') // the main holder extends to the edges of the panel
        panel.subholder = CIQ.newChild(panel.holder, 'div', 'stx-subholder') // the sub holder does not include the axis area
        panel.subholder.style.zIndex = 1
        panel.holder.setAttribute('cq-panel-name', name)
        panel.subholder.setAttribute('cq-panel-name', name)
        var appendClass = isChart ? 'stx-panel-chart' : 'stx-panel-study'
        CIQ.appendClassName(panel.holder, appendClass)

        panel.subholder.appendChild(this.controls.iconsTemplate.cloneNode(true))
        panel.handle = this.controls.handleTemplate.cloneNode(true)
        this.container.appendChild(panel.handle)
        //panel.handle.style.display=""; // let the drawPanels manage this otherwise if we set to "" here but the developer wants a picture (png) handle using CSS, the hande will flicker on on initial load on the top of the screen
        panel.handle.id = null
        panel.handle.panel = panel

        this.configurePanelControls(panel)
        this.resizeCanvas()

        this.runAppend('stackPanel', arguments)
      }

      CIQ.ChartEngine.prototype.setPanelEdit = function(panel, editFunction) {
        panel.editFunction = editFunction
        CIQ.safeClickTouch(panel.edit, editFunction)
        this.adjustPanelPositions()
      }
      /**
       * <span class="injection">INJECTABLE</span>
       * <span class="animation">Animation Loop</span>
       * Draws the panels for the chart and chart studies. CSS style stx_panel_border can be modified to change the color
       * or width of the panel dividers.
       * @memberof CIQ.ChartEngine.AdvancedInjectable#
       * @alias drawPanels
       */
      CIQ.ChartEngine.prototype.drawPanels = function() {
        if (this.runPrepend('drawPanels', arguments)) return
        var first = false
        for (var p in this.panels) {
          var panel = this.panels[p]
          panel.axisDrawn = false // to prevent y-axis from being drawn multiple times -- a panel can have multiple studies
          panel.state = {} // reset the drawing state

          var textToDisplay = this.translateIf(panel.display)
          if (panel.title.textContent != textToDisplay) {
            panel.title.innerHTML = ''
            panel.title.appendChild(document.createTextNode(textToDisplay))
          }
          CIQ.appendClassName(panel.icons, 'stx-show')
          if (panel.hidden) {
            CIQ.unappendClassName(panel.icons, 'stx-show')
            panel.handle.style.display = 'none'
            panel.holder.style.display = 'none'
            continue
          } else {
            if (!this.displayIconsUpDown) panel.up.style.display = 'none'
            if (!this.displayIconsUpDown) panel.down.style.display = 'none'
            if (!this.displayIconsSolo) panel.solo.style.display = 'none'
            panel.holder.style.display = 'block'
          }
          if (!first) {
            panel.handle.style.display = 'none'
            first = true
            continue
          }
          var y = panel.top
          y = Math.round(y) + 0.5
          this.plotLine(
            panel.left,
            panel.right,
            y,
            y,
            this.canvasStyle('stx_panel_border'),
            'segment',
            this.chart.context,
            false,
            {}
          )
          if (!this.displayPanelResize) {
            panel.handle.style.display = 'none'
          } else {
            panel.handle.style.display = ''
          }
          panel.handle.style.top = y - panel.handle.offsetHeight / 2 + 'px'
          //panel.handle.style.left=panel.left+ "px";
        }
        this.runAppend('drawPanels', arguments)
      }

      /**
       * <span class="injection">INJECTABLE</span>
       * This method captures a tap event (single click) on a touch device. It supports both touch and pointer events.
       * @param  {number} finger Which finger is pressed
       * @param  {number} x	   X location on screen of the press
       * @param  {number} y	   Y location on screen of the press
       * @memberof CIQ.ChartEngine.AdvancedInjectable#
       * @alias touchSingleClick
       */
      CIQ.ChartEngine.prototype.touchSingleClick = function(finger, x, y) {
        var self = this
        var args = arguments
        return function() {
          ;(function() {
            if (!this.cancelTouchSingleClick) {
              if (this.runPrepend('touchSingleClick', args)) return
              if (this.editingAnnotation) return
              this.clicks = { s1MS: -1, e1MS: -1, s2MS: -1, e2MS: -1 }
              if (!this.displayCrosshairs) return
              if (!this.displayInitialized) return // No chart displayed yet
              if (this.openDialog !== '') return
              if (
                x < this.left ||
                x > this.right ||
                y < this.top ||
                y > this.bottom
              )
                return
              var cy = this.backOutY(CIQ.ChartEngine.crosshairY)
              var cx = this.backOutX(CIQ.ChartEngine.crosshairX)
              this.currentPanel = this.whichPanel(cy)
              var drawingTool = this.currentVectorParameters.vectorType
              if (
                !CIQ.Drawing ||
                !drawingTool ||
                !CIQ.Drawing[drawingTool] ||
                !new CIQ.Drawing[drawingTool]().dragToDraw
              ) {
                if (!this.drawingClick(this.currentPanel, cx, cy)) {
                  if (!this.layout.crosshair) {
                    //clear existing highlights?
                    CIQ.ChartEngine.crosshairY = 0
                    CIQ.ChartEngine.crosshairX = 0
                    this.cx = this.backOutX(CIQ.ChartEngine.crosshairX)
                    this.cy = this.backOutY(CIQ.ChartEngine.crosshairY)
                    this.findHighlights()
                    // find highlights for things we tapped on, exactly (not crosshair hover)
                    CIQ.ChartEngine.crosshairY = y
                    CIQ.ChartEngine.crosshairX = x
                    var rect = this.container.getBoundingClientRect()
                    this.top = rect.top
                    this.left = rect.left
                    this.right = this.left + this.width
                    this.bottom = this.top + this.height
                    this.cx = this.backOutX(CIQ.ChartEngine.crosshairX)
                    this.cy = this.backOutY(CIQ.ChartEngine.crosshairY)
                    if (this.currentPanel && this.currentPanel.chart.dataSet) {
                      this.crosshairTick = this.tickFromPixel(
                        this.cx,
                        this.currentPanel.chart
                      )
                      this.crosshairValue = this.adjustIfNecessary(
                        this.currentPanel,
                        this.crosshairTick,
                        this.valueFromPixel(this.cy, this.currentPanel)
                      )
                    }
                    this.headsUpHR()
                    this.findHighlights(true)
                  }
                }
                if (!this.currentVectorParameters.vectorType) {
                  this.dispatch('tap', {
                    stx: this,
                    panel: this.currentPanel,
                    x: cx,
                    y: cy,
                  })
                }
              }
            }
            self.cancelTouchSingleClick = false
            this.runAppend('touchSingleClick', args)
          }.apply(self, args))
        }
      }

      /**
       * <span class="injection">INJECTABLE</span>
       * This method detects a double tap on a touch device. It circumvents {@link CIQ.ChartEngine#touchSingleClick}. Double taps
       * are used to delete overlays, series or drawings on touch devices.
       * It also resets the vertical zoom level (y axis) if tapping on an empty area of the pannel ( see {@link CIQ.ChartEngine#calculateYAxisMargins}).
       * @param  {number} finger Which finger double tapped.
       * @param  {number} x	   X location of screen of tap
       * @param  {number} y	   Y location on screen of tap
       * @memberof CIQ.ChartEngine.AdvancedInjectable#
       * @alias touchDoubleClick
       */
      CIQ.ChartEngine.prototype.touchDoubleClick = function(finger, x, y) {
        if (this.runPrepend('touchDoubleClick', arguments)) return
        if (
          this.dispatch('doubleTap', { stx: this, finger: finger, x: x, y: y })
        )
          return
        if (
          x < this.left ||
          x > this.right ||
          y < this.panels.chart.top ||
          y > this.panels.chart.bottom
        )
          return
        if (this.editingAnnotation) return
        if (CIQ.ChartEngine.drawingLine) {
          this.undo()
        } else {
          if (this.anyHighlighted) {
            this.deleteHighlighted()
          } else {
            // Reset vertical
            var yAxis = this.currentPanel.yAxis
            if (
              yAxis.scroll ==
                (yAxis.initialMarginTop - yAxis.initialMarginBottom) / 2 &&
              yAxis.zoom == yAxis.initialMarginTop + yAxis.initialMarginBottom
            ) {
              this.home()
            } else {
              this.calculateYAxisMargins(this.currentPanel.yAxis)
              //this.currentPanel.chart.verticalScroll=0;
              //this.currentPanel.chart.zoom=0;
            }
            this.draw()
          }
        }
        this.clicks = { s1MS: -1, e1MS: -1, s2MS: -1, e2MS: -1 }
        this.runAppend('touchDoubleClick', arguments)
      }

      // Proxy for handling MS pointer events, specifically to deal with all-in-one computers that
      // support both mouse and touch
      CIQ.ChartEngine.prototype.startProxy = function(e) {
        if (e.pointerType == 4 || e.pointerType == 'mouse') {
          this.mouseMode = true
        } else {
          this.mouseMode = false
        }
        if (this.mouseMode) return
        this.touches[this.touches.length] = {
          pointerId: e.pointerId,
          pageX: e.clientX,
          pageY: e.clientY,
        }
        this.changedTouches = [
          {
            pointerId: e.pointerId,
            pageX: e.clientX,
            pageY: e.clientY,
          },
        ]
        if (!this.gestureInEffect && this.touches.length == 1) {
          this.gesturePointerId = e.pointerId
          this.overrideGesture = false
          if (!this.gesture) return
          this.gesture.addPointer(e.pointerId)
          this.touchstart(e)
        } else {
          this.gesture.stop()
          this.touchstart(e)
        }
      }

      // Proxy for dealing with MS pointer move events
      CIQ.ChartEngine.prototype.moveProxy = function(e) {
        if (e.pointerType == 4 || e.pointerType == 'mouse') {
          this.mouseMode = true
        } else {
          this.mouseMode = false
        }
        if (this.mouseMode) return
        if (!this.gestureInEffect) this.touchmove(e)
      }

      // Proxy for dealing with MS pointer end events
      CIQ.ChartEngine.prototype.endProxy = function(e) {
        if (this.mouseMode) return
        var hm = this.touches.length
        for (var i = 0; i < this.touches.length; i++) {
          if (this.touches[i].pointerId == e.pointerId) {
            this.touches.splice(i, 1)
            break
          }
        }
        if (i == hm) {
          this.touches = []
          this.grabbingScreen = false
          this.touching = false
          return
        }
        this.changedTouches = [
          {
            pointerId: e.pointerId,
            pageX: e.clientX,
            pageY: e.clientY,
          },
        ]
        if (!this.gestureInEffect) {
          this.touchend(e)
        }
      }

      // Proxy for dealing with mousemove on MS devices
      CIQ.ChartEngine.prototype.msMouseMoveProxy = function(e) {
        if (this.touches.length || !this.mouseMode) return
        //if(this.touches.length) return;
        //this.mouseMode=true;
        this.mousemove(e)
      }

      // Proxy for dealing with mousedown on MS devices
      CIQ.ChartEngine.prototype.msMouseDownProxy = function(e) {
        if (!this.mouseMode) return
        this.mousedown(e)
      }

      // Proxy for dealing with mouseup on MS devices
      CIQ.ChartEngine.prototype.msMouseUpProxy = function(e) {
        if (!this.mouseMode) return
        this.mouseup(e)
      }

      // Proxy for dealing with mousemove for ios style events on all-in-one computers (FF and Chrome)
      CIQ.ChartEngine.prototype.iosMouseMoveProxy = function(e) {
        if (this.touching) return
        this.mousemove(e)
      }

      // Proxy for dealing with mousedown for ios style events on all-in-one computers (FF and Chrome)
      CIQ.ChartEngine.prototype.iosMouseDownProxy = function(e) {
        if (this.touching) {
          this.mouseMode = false
          return
        }
        this.mouseMode = true
        this.mousedown(e)
      }

      // Proxy for dealing with mouseup for ios style events on all-in-one computers (FF and Chrome)
      CIQ.ChartEngine.prototype.iosMouseUpProxy = function(e) {
        if (this.touching) return
        this.mouseup(e)
      }

      /**
	 * Creates watermarked text on the canvas. See {@link CIQ.ChartEngine#watermark} to create a watermark relative to a particular panel.
	 * CSS style stx_watermark defines the watermark (opacity of .5 is automatically applied)
	 *
	 * **Note** that the watermark will not persist unless called from within the animation loop (study display function, for example).
	 * As such, it may be necessary to use a `prepend` to the `draw` function to create persistence. See example section.
	 * @param  {external:CanvasRenderingContext2D} context [description]
	 * @param  {number} x		X position on canvas
	 * @param  {number} y		Y position on canvas
	 * @param  {string} text	The text to watermark
	 * @memberof CIQ.ChartEngine
	 * @example
		CIQ.ChartEngine.prototype.prepend("draw",function(){
	       // create persistence by forcing it  be called in every animation frame.
	       rawWatermark(stxx.chart.context,20,30,stxx.chart.symbol);
		});
	 */
      CIQ.ChartEngine.prototype.rawWatermark = function(context, x, y, text) {
        this.canvasFont('stx_watermark', context)
        context.fillStyle = this.defaultColor
        context.globalAlpha = 0.5
        this.chart.context.textBaseline = 'alphabetic'
        context.fillText(text, x, y)
        context.globalAlpha = 1
      }

      /**
	 * Creates watermarked text relative to a panel on the canvas.
	 * Use CSS style stx_watermark to control the text size and color.
	 *
	 * **Note** that the watermark will not persist unless called from within the animation loop (study display function, for example).
	 * As such, it may be necessary to use a `prepend` to the `draw` function to create persistence. See example section.
	 * @param  {string} panel The name of the panel
	 * @param  {object} [config] Parameters for the request
	 * @param  {string} [config.h]			"left", "right", "center" to place the watermark
	 * @param  {string} [config.v]			"top", "bottom", "middle" to place the watermark
	 * @param  {string} [config.text]		The text to watermark
	 * @param  {string} [config.hOffset]	offset in pixels of upper left corner from left or right margin
	 * @param  {string} [config.vOffset]	offset in pixels of upper left corner from top or bottom margin
	 * @memberof CIQ.ChartEngine
	 * @example
		CIQ.ChartEngine.prototype.prepend("draw",function(){
	       // create persistence by forcing it  be called in every animation frame.
	       stxx.watermark("chart",{h:"center",v:"middle",text:stxx.chart.symbol});
		});	 */
      CIQ.ChartEngine.prototype.watermark = function(panel, config) {
        if (config && typeof config != 'object') {
          // Handle legacy argument list implementation
          config = {
            h: arguments[1],
            v: arguments[2],
            text: arguments[3],
          }
        }
        config = {
          // set defaults
          h: config.h || 'left',
          v: config.v || 'bottom',
          text: config.text || '',
          hOffset: config.hOffset || 10,
          vOffset: config.vOffset || 20,
        }

        if (!this.chart.context) return
        var c = this.panels[panel]
        if (!c || c.hidden) return

        var y = c.yAxis.bottom - config.vOffset
        if (config.v == 'top') y = c.top + config.vOffset
        else if (config.v == 'middle') y = (c.top + c.yAxis.bottom) / 2

        this.chart.context.save()
        this.canvasFont('stx_watermark')
        this.canvasColor('stx_watermark')
        this.chart.context.textBaseline = 'alphabetic'

        var x = c.left + config.hOffset
        if (config.h == 'right') x = c.right - config.hOffset
        else if (config.h == 'center') {
          x =
            (c.right +
              c.left -
              this.chart.context.measureText(config.text).width) /
            2
        }

        this.chart.context.globalAlpha = 0.5
        this.chart.context.fillText(config.text, x, y)
        this.chart.context.globalAlpha = 1
        this.chart.context.restore()
      }
      /**
       * Call this before a resizing operation in order to maintain the scroll position. See {@link CIQ.ChartEngine#postAdjustScroll}.
       * @param  {CIQ.ChartEngine.Chart} [chart] The chart to adjust. Otherwise adjusts the main symbol chart.
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.preAdjustScroll = function(chart) {
        if (!chart) chart = this.chart
        this.previousAdjust = {
          chart: chart,
          scroll: chart.scroll,
          maxTicks: chart.maxTicks,
        }
      }

      /**
       * Call this after a resizing operation in order to maintain the scroll position. See {@link CIQ.ChartEngine#preAdjustScroll}.
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.postAdjustScroll = function() {
        if (!this.previousAdjust) return
        var chart = this.previousAdjust.chart
        chart.scroll =
          this.previousAdjust.scroll +
          (chart.maxTicks - this.previousAdjust.maxTicks)
        if (this.displayInitialized) this.draw()
      }
      /**
       * Loops through the existing drawings and asks them to adjust themselves to the chart dimensions.
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.adjustDrawings = function() {
        for (var i = 0; i < this.drawingObjects.length; i++) {
          var drawing = this.drawingObjects[i]
          if (this.panels[drawing.panelName]) drawing.adjust()
        }
      }

      /**
       * Convenience function returns the next or previous interval from the provided date-time at the current chart's periodicity.
       * See {@link CIQ.Market} and {@link CIQ.Market.Iterator} for more details.
       *
       * For 'tick' intervals, since there is no predictable periodicity, the next interval will be determined by {@link CIQ.ChartEngine.XAxis#futureTicksInterval}
       * @param  {date}		DT			A JavaScript Date representing the base time for the request in {@link CIQ.ChartEngine#dataZone} timezone.
       * @param {number}		[period]		The number of periods to jump. Defaults to 1. Can be negative to go back in time.
       * @param {boolean}		[useDataZone=true] By default the next interval will be returned in {@link CIQ.ChartEngine#dataZone}. Set to false to receive a date in {@link CIQ.ChartEngine#displayZone} instead.
       * @return {date}	 The next interval date
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.getNextInterval = function(
        DT,
        period,
        useDataZone
      ) {
        if (!period) period = 1
        if (useDataZone !== false) useDataZone = true

        var iter = this.standardMarketIterator(
          DT,
          useDataZone ? this.dataZone : this.displayZone
        )
        if (period < 1) {
          return iter.previous(period * -1)
        }
        return iter.next(period)
      }

      /**
       * Convenience function returns a new market iterator at the current chart's periodicity.
       * For 'tick' intervals, since there is no predictable periodicity, the iterator interval will be determined by {@link CIQ.ChartEngine.XAxis#futureTicksInterval}
       * See {@link CIQ.Market} and {@link CIQ.Market.Iterator} for more details.
       * @param {date}		begin A JavaScript Date representing the iterator begin date in {@link CIQ.ChartEngine#dataZone} timezone. See {@link CIQ.Market#newIterator} for details.
       * @param {string} 		[outZone] A valid timezone from the timeZoneData.js library. This should represent the time zone for the returned date. Defaults {@link CIQ.ChartEngine#dataZone}. See {@link CIQ.Market#newIterator} for details.
       * @param {CIQ.ChartEngine.Chart} 	[chart] The chart object.
       * @return {object} A new iterator.
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.standardMarketIterator = function(
        begin,
        outZone,
        chart
      ) {
        var otz = outZone ? outZone : this.dataZone
        var cht = chart ? chart : this.chart
        var iter_parms = {
          begin: begin,
          interval: this.layout.interval == 'tick' ? 1 : this.layout.interval,
          periodicity:
            this.layout.interval == 'tick'
              ? this.chart.xAxis.futureTicksInterval
              : this.layout.periodicity,
          timeUnit: this.layout.timeUnit,
          inZone: this.dataZone,
          outZone: otz,
        }
        return cht.market.newIterator(iter_parms)
      }

      /**
       * Effects a zoom from either zoomIn() or zoomOut(). Called from an EaseMachine
       * @param  {number} candleWidth  The new candleWidth
       * @param  {CIQ.ChartEngine.Chart} chart        The chart to center
       * @memberof CIQ.ChartEngine
       * @since 4.0.0 will maintain tick position near the cursor if {@link CIQ.ChartEngine#preferences.zoomAtCurrentMousePosition} is `true`
       * @since 4.1.0 will keep left edge stable and zoom to the right when white space is present on the left.
       */
      CIQ.ChartEngine.prototype.zoomSet = function(candleWidth, chart) {
        var mainSeriesRenderer = this.mainSeriesRenderer || {}
        if (!mainSeriesRenderer.params || !mainSeriesRenderer.params.volume) {
          var maintainTick
          if (
            this.preferences.zoomAtCurrentMousePosition &&
            this.zoomInitiatedByMouseWheel &&
            this.crosshairTick < chart.dataSet.length
          ) {
            // keep the bar near the cursor stable
            // at chart load it is possible for this.crosshairTick to be null (refresh while cursor is in the xAxis margin)
            maintainTick =
              this.crosshairTick || this.tickFromPixel(this.cx, chart)
          } else if (this.isHome()) {
            // keep right edge stable and zoom to the left
            maintainTick = chart.dataSet.length - 1
          } else if (this.chart.scroll > this.chart.dataSet.length) {
            // keep left edge stable and zoom to the right
            maintainTick = 0
          } else {
            // keep the center bar in the center and zoom equally left and right
            maintainTick = this.tickFromPixel(this.chart.width / 2, chart)
          }
          if (this.animations.zoom.hasCompleted) {
            this.zoomInitiatedByMouseWheel = false
          }
          // this is the code that keeps the chart's position stable.
          // Bypassing this code will cause the chart's left position to remain stable
          // which is really the only way to get a smooth zoom for variable width candles (because the act of scrolling inherently changes the number of candles that fit on the screen)
          var distanceFromFront = chart.dataSet.length - 1 - maintainTick
          var oldScroll = chart.scroll
          chart.scroll =
            Math.floor(
              (this.pixelFromTick(maintainTick, chart) - chart.left) /
                candleWidth
            ) +
            1 +
            distanceFromFront
          this.micropixels +=
            (oldScroll - distanceFromFront) * this.layout.candleWidth -
            (chart.scroll - distanceFromFront) * candleWidth
        }
        this.setCandleWidth(candleWidth)
        chart.spanLock = false
        this.draw()
        this.doDisplayCrosshairs()
        this.updateChartAccessories()
      }

      /**
       * <span class="injection">INJECTABLE</span>
       * Zooms the chart out. The chart is zoomed incrementally by they percentage indicated (pct) each time this is called.
       * @param  {Event} e The mouse click event, if it exists (from clicking on the chart control)
       * @param  {number} pct The percentage to zoom out the chart (default = 10%)
       * @memberof CIQ.ChartEngine
       * @since 4.0.0 If both {@link CIQ.ChartEngine.Chart#allowScrollPast} and {@link CIQ.ChartEngine.Chart#allowScrollFuture} are set to false, the zoom operation will stop mid animation to prevent white space from being created.
       */
      CIQ.ChartEngine.prototype.zoomOut = function(e, pct) {
        if (this.runPrepend('zoomOut', arguments)) return
        this.grabbingScreen = false //in case they were grabbing the screen and let go to zoom.
        if (CIQ.ChartEngine.insideChart)
          CIQ.unappendClassName(this.container, 'stx-drag-chart') //in case they were grabbing the screen and let go to zoom.
        if (this.preferences.zoomOutSpeed) pct = this.preferences.zoomOutSpeed
        else if (!pct) pct = 1.3
        if (e && e.preventDefault) e.preventDefault()
        this.cancelTouchSingleClick = true

        var self = this
        function closure(chart) {
          return function(candleWidth) {
            self.zoomSet(candleWidth, chart)
            if (self.animations.zoom.hasCompleted) {
              if (self.runAppend('zoomOut', arguments)) return
              self.changeOccurred('layout')
            }
          }
        }

        for (var chartName in this.charts) {
          var chart = this.charts[chartName]
          if (CIQ.ipad && chart.maxTicks > CIQ.ChartEngine.ipadMaxTicks) {
            return
          }
          var newTicks = Math.floor(chart.maxTicks * pct) // 10% more ticks with each click
          if (
            chart.allowScrollFuture === false &&
            chart.allowScrollPast === false &&
            newTicks > chart.dataSet.length
          ) {
            // make sure we keep candles big enough to show all data so no white space is created on either side.
            newTicks = chart.dataSet.length
          }
          var newCandleWidth = this.chart.width / newTicks
          if (newCandleWidth < this.minimumCandleWidth)
            newCandleWidth = this.minimumCandleWidth
          this.layout.setSpan = null
          this.layout.range = null
          this.animations.zoom.run(
            closure(chart),
            this.layout.candleWidth,
            newCandleWidth
          )
        }
      }

      /**
       * <span class="injection">INJECTABLE</span>
       * Zooms (vertical swipe / mousewheel) or pans (horizontal swipe) the chart based on a mousewheel event. A built in timeout prevents the mousewheel from zooming too quickly.
       * @param  {Event} e		  The event
       * @return {boolean}			Returns false if action is taken
       * @memberof CIQ.ChartEngine.AdvancedInjectable#
       * @alias mouseWheel
       */

      CIQ.ChartEngine.prototype.mouseWheel = function(e) {
        if (this.runPrepend('mouseWheel', arguments)) return
        if (!e) e = event //IE8
        if (e.preventDefault) e.preventDefault()
        var deltaX = e.deltaX,
          deltaY = e.deltaY

        /*
		// OSX trackpad is very sensitive since it accomodates diagonal
		// motion which is not relevant to us. So we ignore any changes
		// in direction below the threshold time value
		var threshold=50; //ms
		if(Date.now()-this.lastMouseWheelEvent<threshold){
			if(this.lastMove=="horizontal") deltaY=0;
			else deltaX=0;
		}*/
        if (Math.abs(deltaY) > Math.abs(deltaX)) deltaX = 0
        else deltaY = 0

        this.lastMouseWheelEvent = Date.now()
        if (Math.abs(deltaX) === 0 && Math.abs(deltaY) === 0) return

        if (this.allowSideswipe && deltaX !== 0) {
          this.lastMove = 'horizontal'
          var delta = deltaX
          if (delta > 50) delta = 50
          if (delta < -50) delta = -50
          this.grabbingScreen = true
          if (!this.currentPanel) this.currentPanel = this.chart.panel
          this.grabStartX = CIQ.ChartEngine.crosshairX
          this.grabStartY = CIQ.ChartEngine.crosshairY
          this.grabStartScrollX = this.chart.scroll
          this.grabStartScrollY = this.currentPanel.yAxis.scroll
          this.grabStartMicropixels = this.micropixels
          this.grabStartPanel = this.currentPanel
          this.mousemoveinner(
            CIQ.ChartEngine.crosshairX - delta,
            CIQ.ChartEngine.crosshairY
          )
          this.updateChartAccessories()
          this.grabbingScreen = false
          return
        }
        this.lastMove = 'vertical'
        if (!this.allowZoom) return
        if (!this.displayInitialized) return
        /* originally added to address a magic mouse issue - removing this code because it is affecting new Macs which seem to come back for more zooming immediately causing uneven zooming.
		if(this.wheelInMotion) return;
		this.wheelInMotion=true;
		setTimeout(function(self){return function(){self.wheelInMotion=false;};}(this), 40);
		*/
        if (!deltaY) {
          if (CIQ.wheelEvent == 'onmousewheel') {
            deltaY = (-1 / 40) * e.wheelDelta
            if (e.wheelDeltaX) deltaX = (-1 / 40) * e.wheelDeltaX
          } else {
            deltaY = e.detail
          }
        }
        if (typeof e.deltaMode == 'undefined')
          e.deltaMode = e.type == 'MozMousePixelScroll' ? 0 : 1

        //var distance=e.deltaX;
        //if(!distance) distance=e.deltaY;
        var distance = -deltaY
        if (e.deltaMode == 1) {
          // 1 is line mode so we approximate the distance in pixels, arrived at through trial and error
          distance *= 33
        }

        var pctIn = null
        var pctOut = null
        // Calculate the percentage change to the chart. Arrived at heuristically, cube root of the mousewheel distance.
        // The multipliers are adjusted to take into consideration reversed compounding rates between a zoomin and a zoomout
        if (this.mouseWheelAcceleration) {
          var multiplier = Math.max(Math.pow(Math.abs(distance), 0.3), 1)
          pctIn = 1 - 0.1 * multiplier
          pctOut = 1 + 0.2 * multiplier
        }

        this.zoomInitiatedByMouseWheel = true

        if (distance > 0) {
          if (this.reverseMouseWheel) this.zoomOut(null, pctOut)
          else this.zoomIn(null, pctIn)
        } else if (distance < 0) {
          if (this.reverseMouseWheel) this.zoomIn(null, pctIn)
          else this.zoomOut(null, pctOut)
        }
        if (this.runAppend('mouseWheel', arguments)) return
        return false
      }

      /**
       * <span class="injection">INJECTABLE</span>
       * Zooms the chart in. The chart is zoomed incrementally by they percentage indicated (pct) each time this is called.
       * @param  {Event} e The mouse click event, if it exists (from clicking on the chart control)
       * @param  {number} pct The percentage to zoom out the chart (default = 10%)
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.zoomIn = function(e, pct) {
        if (this.runPrepend('zoomIn', arguments)) return
        this.grabbingScreen = false //in case they were grabbing the screen and let go to zoom.
        if (CIQ.ChartEngine.insideChart)
          CIQ.unappendClassName(this.container, 'stx-drag-chart') //in case they were grabbing the screen and let go to zoom.
        if (this.preferences.zoomInSpeed) pct = this.preferences.zoomInSpeed
        else if (!pct) pct = 0.7
        if (e && e.preventDefault) e.preventDefault()
        this.cancelTouchSingleClick = true

        var self = this
        function closure(chart) {
          return function(candleWidth) {
            self.zoomSet(candleWidth, chart)
            if (self.animations.zoom.hasCompleted) {
              if (self.runAppend('zoomIn', arguments)) return
              self.changeOccurred('layout')
            }
          }
        }

        for (var chartName in this.charts) {
          var chart = this.charts[chartName]

          var newTicks = Math.floor(chart.maxTicks * pct) // 10% fewer ticks displayed when zooming in
          // At some point the zoom percentage compared to the bar size may be too small, we get stuck at the same candle width.
          // (because we ceil() and 0.5 candle when we set the maxTicks in setCandleWidth()).
          // So we want to force a candle when this happens.
          if (chart.maxTicks - newTicks < 1) newTicks = chart.maxTicks - 1
          if (newTicks < this.minimumZoomTicks) newTicks = this.minimumZoomTicks
          var newCandleWidth = this.chart.width / newTicks
          this.layout.setSpan = null
          this.layout.range = null
          this.animations.zoom.run(
            closure(chart),
            this.layout.candleWidth,
            newCandleWidth
          )
        }
      }

      /**
       * Translates the requested word to the active language if this.translationCallback callback function is set.
       *
       * Use {@link CIQ.translatableTextNode} if you are adding the element to the DOM and wish the translations services to automatically change to other languages as they are set.
       * @param  {string} english The word to translate
       * @return {string}			The translated word, or the word itself if no callback is set.
       * @memberof CIQ.ChartEngine
       */
      CIQ.ChartEngine.prototype.translateIf = function(english) {
        if (this.translationCallback) return this.translationCallback(english)
        return english
      }

      /**
	 * Sets the data timezone (`dataZone`) and display timezone (`displayZone`) on an intraday chart.
	 *
	 * If the 'DT' fields have been adjusted prior to loading to reflect the proper time offset between the browser and the data server,
	 * or the 'Date' fields are loaded with a an ISO9601 date string such as'2015-01-01T09:10:00Z',
	 * there will be no need to use this function to set the `dataZone`.
	 *
	 * If not embedded with a timezone, `masterData` dates are interpreted in reference to the {@link CIQ.ChartEngine#dataZone} (or the browser timezone if no dataZone is specified).
	 * The {@link CIQ.ChartEngine#displayZone} is then created and used to translate dates based on either the local browser's timezone, or the timezone selected by the end user.
	 *
	 * ** Important: This method is only used to generate a display date for `intraday` periodicity. No time conversions will be done in daily, weekly or monthly periodicities, which only display a date without a time.**
	 * ** As such, if the date has an implied timezone (as in the case of the epoch or ISO9601 date), the date will be displayed in a timezone to match the browser's timezone (12 midnight ET will show as 11 PM the previous day on CT).**
	 * ** If the date does not have an implied timezone (as in the case of a string such as 'yyyy-mm-dd' for the Date field ) then the date will be displayed exactly as sent into the chart since the library will assume it is already in the desired timezone.**

	 * ** Time zone and the {@link CIQ.QuoteFeed#fetch}:**<br>
	 * It is important to understand that if your quote feed returns a date string such as  '07/07/16 9:30' as the time-stamp for a tick, (note there is no timezone specified) ,
	 * the library will also store that in master data with no timezone specified (which really means the browser is storing it in local time on the 'DT' field).
	 * Setting the time zone using this method **does not alter the date in the master data array** but simply allows the chart to know how to deal with it.
	 * On a fetch call, that same raw date from the master data array will be sent in on the parameters object. So if your date did not have a time zone when added, then you must assume there is no time zone for it when provided as a parameter. The easiest way to remove a timezone from a date is to take that exact date and convert it to a string using {@link CIQ.yyyymmddhhmmssmmm}, for example.
	 *
	 * **See {@link CIQ.timeZoneMap} to review a list of all chatIQ supported timezones and instructions on how to add more!**
	 *
	 * @param {string} dataZone	   A chatIQ supported timezone. This should represent the time zone that the master data comes from, or set to 'null' if your dates are already time zone aware.
	 * @param {string} displayZone A chatIQ supported timezone. This should represent the time zone that the user wishes displayed, or set to null to use the browser time zone.
	 * @memberof CIQ.ChartEngine
	 */
      CIQ.ChartEngine.prototype.setTimeZone = function(dataZone, displayZone) {
        if (typeof timezoneJS == 'undefined') {
          this.timeZoneOffset = 0
          return
        }

        var now = new Date()
        var myTimeZoneOffset = now.getTimezoneOffset()
        var dataTimeZoneOffset = myTimeZoneOffset
        var displayTimeZoneOffset = myTimeZoneOffset
        if (dataZone) this.dataZone = dataZone
        if (this.dataZone)
          dataTimeZoneOffset = new timezoneJS.Date(
            now,
            this.dataZone
          ).getTimezoneOffset()
        if (displayZone) this.displayZone = displayZone
        if (this.displayZone)
          displayTimeZoneOffset = new timezoneJS.Date(
            now,
            this.displayZone
          ).getTimezoneOffset()
        this.timeZoneOffset =
          dataTimeZoneOffset -
          myTimeZoneOffset -
          (displayTimeZoneOffset - myTimeZoneOffset)
        for (var chartName in this.charts) {
          var chart = this.charts[chartName]
          if (
            chart.masterData &&
            !CIQ.ChartEngine.isDailyInterval(this.layout.interval)
          )
            this.setDisplayDates(chart.masterData)
        }
        this.preferences.timeZone = displayZone
        this.changeOccurred('preferences')
        this.createDataSet()
      }

      /**
       * Sets the locale for the charts.
       *
       * Do not call this method directly. Instead use {@link CIQ.I18N.setLocale} or {@link CIQ.I18N.localize}
       *
       * If set, display prices and dates will be displayed in localized format.
       * The locale should be a valid IANA locale. For instance de-AT represents German as used in Austria. Localization
       * is supported through the Intl object which is a W3 standard, however not all browsers support Intl natively. The
       * Intl.js polyfill is included through the inclusion of stxThirdParty.js. To enable localization, the locale-data/jsonp
       * directory should be included and the JSONP loaded. This is done automatically by calling {@link CIQ.I18N.setLocale}
       * rather than calling this method directly.
       *
       * Once a locale is set, `stxx.internationalizer` will be an object that will contain several Intl formatters.
       *
       * These are the default date and time formates:
       * - stxx.internationalizer.hourMinute=new Intl.DateTimeFormat(this.locale, {hour:"numeric", minute:"numeric", hour12:false});
       * - stxx.internationalizer.hourMinuteSecond=new Intl.DateTimeFormat(this.locale, {hour:"numeric", minute:"numeric", second:"numeric", hour12:false});
       * - stxx.internationalizer.mdhm=new Intl.DateTimeFormat(this.locale, {year:"2-digit", month:"2-digit", day:"2-digit", hour:"2-digit", minute:"2-digit"});
       * - stxx.internationalizer.monthDay=new Intl.DateTimeFormat(this.locale, {month:"numeric", day:"numeric"});
       * - stxx.internationalizer.yearMonthDay=new Intl.DateTimeFormat(this.locale, {year:"numeric", month:"numeric", day:"numeric"});
       * - stxx.internationalizer.yearMonth=new Intl.DateTimeFormat(this.locale, {year:"numeric", month:"numeric"});
       * - stxx.internationalizer.month=new Intl.DateTimeFormat(this.locale, {month:"short"});
       *
       * These can be overridden manually if the specified format is not acceptable. See example.
       * Also see [Intl.DateTimeFormat](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat) for formatting alternatives
       *
       * @param {string} locale A valid IANA locale
       * @param {number} [maxDecimals] maximum number of decimal places to allow on number conversions. Defaults to 5. Please note that this will supersede any defaults set in {@link CIQ.ChartEngine.YAxis#maxDecimalPlaces} or {@link CIQ.ChartEngine.YAxis#decimalPlaces}
       * @memberof CIQ.ChartEngine
       * @since 3.0.0 maxDecimals was added to the signature
       * @example
       * // override time formatting to enable 12 hour clock (hour12:true)
       * stxx.internationalizer.hourMinute=new Intl.DateTimeFormat(this.locale, {hour:"numeric", minute:"numeric", hour12:true});
       * stxx.internationalizer.hourMinuteSecond=new Intl.DateTimeFormat(this.locale, {hour:"numeric", minute:"numeric", second:"numeric", hour12:true});
       * @example
       * // override formatting to dislay 'Sep 15' insted of '9/15' on x axis labels.
       * stxx.internationalizer.monthDay=new Intl.DateTimeFormat(this.locale, {month:"short", day:"numeric"});
       */
      CIQ.ChartEngine.prototype.setLocale = function(locale, maxDecimals) {
        if (typeof Intl == 'undefined') return
        if (this.locale != locale) {
          this.locale = locale
        } else {
          return
        }
        var i,
          internationalizer = (this.internationalizer = {})
        internationalizer.hourMinute = new Intl.DateTimeFormat(this.locale, {
          hour: 'numeric',
          minute: 'numeric',
          hour12: false,
        })
        internationalizer.hourMinuteSecond = new Intl.DateTimeFormat(
          this.locale,
          {
            hour: 'numeric',
            minute: 'numeric',
            second: 'numeric',
            hour12: false,
          }
        )
        internationalizer.mdhm = new Intl.DateTimeFormat(this.locale, {
          year: '2-digit',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
        })
        internationalizer.monthDay = new Intl.DateTimeFormat(this.locale, {
          month: 'numeric',
          day: 'numeric',
        })
        internationalizer.yearMonthDay = new Intl.DateTimeFormat(this.locale, {
          year: 'numeric',
          month: 'numeric',
          day: 'numeric',
        })
        internationalizer.yearMonth = new Intl.DateTimeFormat(this.locale, {
          year: 'numeric',
          month: 'numeric',
        })
        internationalizer.month = new Intl.DateTimeFormat(this.locale, {
          month: 'short',
        })
        internationalizer.numbers = new Intl.NumberFormat(this.locale)
        internationalizer.priceFormatters = []
        if (!maxDecimals) maxDecimals = 5
        for (i = 0; i < maxDecimals + 1; i++) {
          internationalizer.priceFormatters.push(
            new Intl.NumberFormat(this.locale, {
              maximumFractionDigits: i,
              minimumFractionDigits: i,
            })
          )
        }
        // minification efficient generation of...
        // internationalizer.percent=new Intl.NumberFormat(this.locale, {style:"percent", minimumFractionDigits:2, maximumFractionDigits:2})
        // internationalizer.percent1=new Intl.NumberFormat(this.locale, {style:"percent", minimumFractionDigits:1, maximumFractionDigits:1})
        // ...
        for (i = 0; i < 5; i++) {
          var c = i,
            j = i
          if (!i) {
            c = ''
            j = 2
          }
          internationalizer['percent' + c] = new Intl.NumberFormat(
            this.locale,
            {
              style: 'percent',
              minimumFractionDigits: j,
              maximumFractionDigits: j,
            }
          )
        }

        if (CIQ.I18N.createMonthArrays)
          CIQ.I18N.createMonthArrays(this, internationalizer.month, this.locale)
      }

      /**
       * <span class="quotefeed">QuoteFeed required</span> if `params.noDataLoad` is set to `false`
       *
       * Imports a layout (panels, studies, candleWidth, etc) from a previous serialization. See {@link CIQ.ChartEngine#exportLayout}.
       *
       * There are 3 ways to use the this method:
       * 1. Preset the layout object in the chart instance, but do not load any data.
       *  - This is usually used to restore an initial 'symbol independent' general layout, that will then take effect when `newChart` is called separately.
       *  - In this case, exportedLayout should be called using 'withSymbols=false' and the importLayout should have 'noDataLoad=true'.
       * 2. Load an entire new chart and it's data, including primary symbol, additional series, studies, periodicity and range:
       *  - In this case, you should not need call newChart, setPeriodicity setSpan or setRange, addStudy, etc. since it is all restored from the previously exported layout and loaded using the attached quoteFeed.
       *  - If you still wish to change periodicity, span or range, you must use the CB function to do so.
       *  - In this case, exportedLayout should be called  using 'withSymbols=true' and the importLayout should have 'noDataLoad=false' and 'managePeriodicity=true'.
       * 3. Reset layout on an already existing chart without changing the primary symbol or adding additional symbols:
       *  - This is used when restoring a 'view' on an already existing chart from a previous `newChart` call. The primary symbol remains the same, no additional series are added, but periodicity, range, and studies are restored from the previously serialized view.
       *  - In this case, exportedLayout should be called  using 'withSymbols=false', and importLayout should have 'noDataLoad=false', managePeriodicity=true', and 'preserveTicksAndCandleWidth=true'.
       *
       * **Importnat Notes: **
       * - Please note that `stxx.callbacks.studyOverlayEdit` and `stxx.callbacks.studyPanelEdit` must be set *before* you call {@link CIQ.ChartEngine#importLayout}.
       * Otherwise your imported studies will not have an edit capability
       *
       * - When symbols are loaded, this function will set the primary symbol (first on the serialized symbol list) with {@link CIQ.ChartEngine#newChart}
       * and any overlayed symbol with {@link CIQ.ChartEngine#addSeries}. You must be using a QuoteFeed to use this workflow; otherwise data updates may break.
       *
       * - When allowing this method to load data, do not call [addSeries]{@link CIQ.ChartEngine#addSeries}, [importDrawings]{@link CIQ.ChartEngine#importDrawings} or [newChart]{@link CIQ.ChartEngine#newChart} in a way that will cause them to run simultaneously with this method,
       * or the results of the layout load will be unpredictable.
       * Instead use this method's callback to ensure data is loaded in the right order.
       *
       * @param  {object} config						A serialized layout generated by {@link CIQ.ChartEngine#exportLayout}
       * @param  {object} params						Parameters to dictate layout behavior
       * @param  {boolean} [params.managePeriodicity]			If true then the periodicity will be set from the layout, otherwise periodicity will remain as currently set.<br>
       * If the span was saved in the layout, it will be restored using the most optimal periodicity as determined by {@link CIQ.ChartEngine#setSpan}.<br>
       * Periodicity can only be managed if a quote feed is attached to the chart. See {@link CIQ.ChartEngine#setPeriodicity}.<br>
       * @param  {boolean} [params.preserveTicksAndCandleWidth=true] If true then the current candleWidth (horizontal zoom) on the chart will be maintained, otherwise it will be taken from the layout and restored.
       * @param  {boolean} [params.noDataLoad=false] If true then any automatic data loading from the quotefeed will be skipped.
       * @param  {function} [params.cb] An optional callback function to be executed once the layout has been fully restored.
       * @param  {function} [params.seriesCB] An optional callback function to pass into CIQ.ChartEngine#addSeries if there are series to load. This will not be called if noDataLoad is true.
       * @memberof CIQ.ChartEngine
       * @since
       * <br>&bull; 05-2016-10 Symbols are also loaded if included on the serialization.
       * <br>&bull; 2016-06-21 preserveTicksAndCandleWidth now defaults to true
       * <br>&bull; 3.0.0 added noDataLoad parameter
       * <br>&bull; 5.1.0 Will now also import extended hours settings.
       * <br>&bull; 5.1.0 Imports the range from layout if it is there to preserve between sessions.
       */
      CIQ.ChartEngine.prototype.importLayout = function(config, params) {
        if (!config) {
          // if no config to restore, nothing to do.
          if (params.cb) params.cb()
          return
        }

        if (typeof params !== 'object') {
          // backwards compatibility hack, this function used to accept three named arguments
          params = {
            managePeriodicity: arguments[1],
            preserveTicksAndCandleWidth: arguments[2],
          }
        }
        var layout = this.layout,
          originalLayout = CIQ.shallowClone(layout)
        var managePeriodicity = params.managePeriodicity,
          cb = params.cb,
          seriesCB = params.seriesCB,
          noDataLoad = params.noDataLoad,
          minimumCandleWidth = this.minimumCandleWidth
        var preserveTicksAndCandleWidth = params.preserveTicksAndCandleWidth
        if (
          !preserveTicksAndCandleWidth &&
          preserveTicksAndCandleWidth !== false
        )
          preserveTicksAndCandleWidth = true

        var exportedDrawings = this.exportDrawings()
        this.abortDrawings()

        this.currentlyImporting = true
        // must remove studies before cleaning the overlays, or the remove function will be lost.
        if (CIQ.Studies) {
          for (var s in layout.studies) {
            var sd = layout.studies[s]
            CIQ.Studies.removeStudy(this, sd)
          }
        }
        this.overlays = {}
        var view = CIQ.clone(config)

        // Keep a copy of the prior panels. We'll need these in order to transfer the holders
        var priorPanels = CIQ.shallowClone(this.panels)

        this.panels = {}
        var v = CIQ.clone(view)
        // these are special cases handled elsewhere
        if (!managePeriodicity) {
          delete v.periodicity
          delete v.interval
          delete v.timeUnit
          delete v.setSpan
        }

        CIQ.dataBindSafeAssignment(layout, v)

        if (!managePeriodicity) {
          layout.periodicity = originalLayout.periodicity
          layout.interval = originalLayout.interval
          layout.timeUnit = originalLayout.timeUnit
          layout.setSpan = originalLayout.setSpan
        }
        // must restore candleWidth before you draw any charts or series, including study charts. The view does not allays provide the candleWidth
        if (preserveTicksAndCandleWidth) {
          layout.candleWidth = originalLayout.candleWidth
        } else {
          if (!layout.candleWidth) layout.candleWidth = 8
        }

        // Just make sure the candleWidth is sane so we end up with a reasonable number of maxticks to fetch.
        if (layout.candleWidth < minimumCandleWidth)
          layout.candleWidth = minimumCandleWidth
        this.setCandleWidth(layout.candleWidth)

        // set comparison mode if percent y-axis
        if (layout.chartScale == 'percent') this.setComparison(true)

        var panels = view.panels // make a copy of the panels
        var insertAt
        var orderedPanels = []
        var p
        var panel
        for (p in panels) {
          if (!('top' in panels[p])) break // unable to sort
          panel = panels[p]
          panel.name = p
          // iterate one before insertion point; do so in reverse so that no iteration is done for sorted input
          for (
            insertAt = orderedPanels.length - 1;
            insertAt >= 0 && orderedPanels[insertAt].top > panel.top;
            --insertAt
          );
          orderedPanels.splice(insertAt + 1, 0, panel)
        }
        layout.panels = {} // erase the panels
        if (orderedPanels.length > 0) {
          // rebuild the panels
          for (var i = 0; i < orderedPanels.length; ++i) {
            // explicit order
            panel = orderedPanels[i]
            this.stackPanel(
              panel.display,
              panel.name,
              panel.percent,
              panel.chartName
            )
          }
        } else {
          for (p in panels) {
            // object implied order
            panel = panels[p]
            this.stackPanel(panel.display, p, panel.percent, panel.chartName)
          }
        }
        if (CIQ.isEmpty(panels)) {
          this.stackPanel('chart', 'chart', 1, 'chart')
        }

        // Transfer the holders and DOM element references to panels that were retained when the view switched
        // Delete panels that weren't
        for (var panelName in priorPanels) {
          var oldPanel = priorPanels[panelName]
          var newPanel = this.panels[panelName]
          if (newPanel) {
            this.container.removeChild(newPanel.holder)
            this.container.removeChild(oldPanel.handle)
            var copyFields = { holder: true, subholder: true, display: true }
            for (var f in copyFields) {
              newPanel[f] = oldPanel[f]
            }
            this.configurePanelControls(newPanel)
            if (oldPanel.chart.panel == oldPanel)
              oldPanel.chart.panel = newPanel // retain reference to the actual chart panel
          } else {
            this.privateDeletePanel(oldPanel)
          }
        }

        this.adjustPanelPositions()

        this.storePanels()
        if (CIQ.Studies) {
          var studies = CIQ.clone(layout.studies)
          delete layout.studies
          for (var ss in studies) {
            var study = studies[ss]
            CIQ.Studies.addStudy(
              this,
              study.type,
              study.inputs,
              study.outputs,
              study.parameters,
              study.panel
            )
          }
        }

        if (this.extendedHours)
          this.extendedHours.prepare(layout.extended, layout.marketSessions)

        if (typeof layout.chartType == 'undefined') layout.chartType = 'line'
        this.setMainSeriesRenderer()

        this.adjustPanelPositions()

        var self = this
        function postLayoutChange() {
          self.importDrawings(exportedDrawings)
          self.draw()
          self.currentlyImporting = false
          self.updateListeners('layout') // tells listening objects that layout has changed
        }

        if (!noDataLoad) {
          // Now we execute the data loading functions.

          if (config.symbols && config.symbols.length) {
            // load symbols; primary and additional series. Also adjust ranges and periodicity at the same time

            var params2 = {}
            if (managePeriodicity) {
              if (config.setSpan) {
                params2.span = config.setSpan
              } else {
                // For consistency between this code and the one when no config.symbol is present,
                // we either let setSpan set the periodicity or we explicitly set it, not both, or newChart will not preserve the span once used.
                if (config.interval) {
                  params2.periodicity = {
                    interval: config.interval,
                    period: config.periodicity,
                    timeUnit: config.timeUnit,
                  }
                }
              }
            }

            if (config.range) {
              params2.range = config.range
            }

            var symbolObject =
              config.symbols[0].symbolObject || config.symbols[0].symbol

            this.newChart(
              symbolObject,
              null,
              this.chart,
              function(err) {
                if (!err) {
                  for (var smbl, i = 1; i < config.symbols.length; ++i) {
                    smbl = config.symbols[i]
                    if (!smbl.parameters) smbl.parameters = {}
                    var parameters = CIQ.clone(smbl.parameters)
                    parameters.action = null // prevent symbolChange event
                    self.addSeries(smbl.id, parameters, seriesCB)
                  }
                }
                postLayoutChange()
                if (cb) cb.apply(null, arguments)
              },
              params2
            )
            return
          }

          // Otherwise, if only data ranges or periodicity are required, load them now
          var range = view.range
          if (range && Object.keys(range).length) {
            this.setRange(range, function() {
              postLayoutChange()
              if (cb) cb()
            })
            return
          } else if (managePeriodicity) {
            if (
              view.setSpan &&
              JSON.stringify(view.setSpan) != '{}' &&
              this.chart.symbol
            ) {
              this.setSpan(view.setSpan, function() {
                postLayoutChange()
                if (cb) cb()
              })
              return
            }

            var interval = view.interval
            var periodicity = view.periodicity
            var timeUnit = view.timeUnit
            if (isNaN(periodicity)) periodicity = 1
            if (!interval) interval = 'day'
            if (
              interval != originalLayout.interval ||
              periodicity != originalLayout.periodicity ||
              timeUnit != originalLayout.timeUnit
            ) {
              // Need this reset because our setPeriodicity code looks at the current periodicity to decide if new data is needed to get to the new periodicity requested.
              // The issue is that by the time we get here the new layout has been set to the one from the view.
              layout.periodicity = originalLayout.periodicity
              layout.interval = originalLayout.interval
              layout.timeUnit = originalLayout.timeUnit
              layout.setSpan = originalLayout.setSpan
              // this will get new data or roll up existing, createDataSet() and draw()
              this.setPeriodicity(
                { period: periodicity, interval: interval, timeUnit: timeUnit },
                function() {
                  postLayoutChange()
                  if (cb) cb()
                }
              )
              return
            }
          }
        }

        this.createDataSet()
        if (!preserveTicksAndCandleWidth) this.home()
        postLayoutChange()
        if (cb) cb()
      }

      /**
       * Exports the current layout into a serialized form. The returned object can be passed into
       * {@link CIQ.ChartEngine#importLayout} to restore the layout at a future time.
       * @param {boolean} withSymbols  If set to `true', include the chart's current primary symbol and any secondary symbols from any {@link CIQ.ChartEngine#addSeries} operation; if using a quoteFeed. Studies will be excluded from this object. The resulting list will be in the `symbols` element of the serialized object.
       * @return {object} The serialized form of the layout.
       * @memberof CIQ.ChartEngine
       * @since
       * <br>&bull; 05-2016-10 `withSymbols` parameter is available
       * <br>&bull; 5.0.0 obj.symbols will be explicitly removed from the serialization if `withSymbols` is not true.
       */
      CIQ.ChartEngine.prototype.exportLayout = function(withSymbols) {
        var obj = {}
        // First clone all the fields, these describe the layout
        for (var field in this.layout) {
          if (field != 'studies' && field != 'panels') {
            obj[field] = CIQ.clone(this.layout[field])
          } else if (field == 'studies') {
            obj.studies = {}
          } else if (field == 'panels') {
            obj.panels = {}
          }
        }

        // Serialize the panels
        for (var panelName in this.panels) {
          var panel = (obj.panels[panelName] = {})
          var p = this.panels[panelName]
          panel.percent = p.percent
          panel.display = p.display
          panel.chartName = p.chart.name
          panel.top = p.top
        }

        // Serialize the studies
        for (var studyName in this.layout.studies) {
          var study = (obj.studies[studyName] = {})
          var s = this.layout.studies[studyName]
          study.type = s.type
          study.inputs = CIQ.clone(s.inputs)
          study.outputs = CIQ.clone(s.outputs)
          study.panel = s.panel
          study.parameters = CIQ.clone(s.parameters)
        }

        if (withSymbols) {
          obj.symbols = this.getSymbols({
            'include-parameters': true,
            'exclude-studies': true,
          })
        } else {
          delete obj.symbols
        }

        return obj
      }

      /**
       * Method to convert DT object of quote to a JS Date and strip off the time.
       * Must be a daily interval or function will not make changes.
       *
       * Note that this will not apply to the 'Date' field!!!!!
       *
       * @param  {array} quotes The quote array to be gap-filled
       * @param  {string} interval Interval of the quotes ("day", etc).
       * @memberof CIQ.ChartEngine
       * @since 4.0.0
       */
      CIQ.ChartEngine.prototype.doCleanupDates = function(quotes, interval) {
        if (!CIQ.ChartEngine.isDailyInterval(interval)) return
        if (!quotes || !quotes.length) return
        for (var i = 0; i < quotes.length; i++) {
          var date = quotes[i].DT
          if (!date) continue
          if (Object.prototype.toString.call(date) != '[object Date]')
            date = new Date(date) // if already a date object; nothing to do
          if (date) date.setHours(0, 0, 0, 0)
        }
      }

      /**
       * If {@link CIQ.ChartEngine#cleanupGaps} is set, this method will insert bars in an array of quotes for those periods missing a record according to the market hours and the current periodicity.
       * See "{@link CIQ.Market}" for details on how to properly configure the library to your market hours requirements.
       *
       * This method will not be called for `tick` since by nature it is no a predictable interval.
       *
       * This method is automatically called if you are using a quoteFeed and have {@link CIQ.ChartEngine#cleanupGaps} set, but can be manually called if pushing or streaming data into the chart.
       *
       * This method will affect intraday and **underlying daily**  periods **only**. If the feed is already returning weekly and monthly data rolled up, the clean up will not be done ( see {@link CIQ.ChartEngine#dontRoll} ).
       *
       * See {@link CIQ.ChartEngine#cleanupGaps}, for more details.
       *
       * @param  {array} quotes The quote array to be gap-filled
       * @param  {CIQ.ChartEngine.Chart} [chart] Optional chart
       * @param {object} [params] Optional parameters
       * @param {string} [params.cleanupGaps] Optionally pass this in to override the default
       * @return {array} The quote array with gaps filled in.
       * @memberof CIQ.ChartEngine
       * @since
       * <br>&bull; 07/01/2015 it now supports cleanups for daily intervals and foreign exchanges instead of just intraday equities.
       * <br>&bull; 3.0.7 added params.cleanupGaps to allow developers to use this function standalone
       */
      CIQ.ChartEngine.prototype.doCleanupGaps = function(
        quotes,
        chart,
        params
      ) {
        var interval = this.layout.interval
        params = params ? params : {}
        var cleanupGaps = params.cleanupGaps
          ? params.cleanupGaps
          : this.cleanupGaps
        var makeGaps = cleanupGaps == 'gap' // "carry" or any other non-false will cause the closing price to carry, otherwise a null will be injected

        if (!cleanupGaps) return quotes
        if (interval == 'tick') return quotes
        if (!quotes || !quotes.length) return quotes
        if (!chart) chart = this.chart

        // doCleanupGaps works on the raw masterData, so if we're rolling up month or week then be sure to actually
        // cleanup gaps on the masterData which will be "day"
        if (interval == 'month' || interval == 'week') {
          if (this.dontRoll) return quotes // We won't try to fill gaps on raw month or week data
          interval = 'day'
        }

        var _make_date = function(_quote) {
          return _quote.DT
            ? new Date(+_quote.DT)
            : CIQ.strToDateTime(_quote.Date)
        }

        var new_quotes = []
        var currentQuote = quotes[0]
        new_quotes.push(currentQuote)

        var iter_parms = {
          begin: _make_date(currentQuote),
          interval: interval,
          periodicity: 1,
          timeUnit: this.layout.timeUnit,
          inZone: this.dataZone,
          outZone: this.dataZone,
        }
        var iter = chart.market.newIterator(iter_parms)
        var field = chart.defaultPlotField
        var mdt

        function fillGapsBetween(dt1, dt2) {
          // Loop through the iterator adding a dummy quote for every missing market date between currentQuote and nextQuote
          while (+dt1 < +dt2) {
            var close = makeGaps ? null : currentQuote[field]
            var adjClose = makeGaps ? null : currentQuote.Adj_Close
            new_quotes.push({
              DT: dt1,
              Open: close,
              High: close,
              Low: close,
              Close: close,
              Volume: 0,
              Adj_Close: adjClose,
            })
            dt1 = iter.next()
          }
        }

        function copyForward(currentQuote, nextQuote) {
          var close = currentQuote[field]
          var nextClose = nextQuote[field]
          if (typeof close != 'undefined' && typeof nextClose == 'undefined') {
            CIQ.ensureDefaults(nextQuote, {
              Close: close,
              Open: close,
              High: close,
              Low: close,
              Volume: 0,
              Adj_Close: currentQuote.Adj_Close,
            })
          }
        }

        for (var i = 1; i < quotes.length; i++) {
          var nextQuote = quotes[i]
          mdt = iter.next() // market date
          var qdt = _make_date(nextQuote) // quote date

          fillGapsBetween(mdt, qdt)
          while (qdt < mdt) {
            if (++i == quotes.length) return new_quotes
            if (!makeGaps) copyForward(currentQuote, nextQuote)
            new_quotes.push(nextQuote)
            currentQuote = nextQuote
            nextQuote = quotes[i]
            qdt = _make_date(nextQuote)
          }
          if (mdt < qdt) {
            i--
            mdt = iter.previous()
          } else {
            if (!makeGaps) copyForward(currentQuote, nextQuote)
            new_quotes.push(nextQuote)
            currentQuote = nextQuote
          }
        }

        return new_quotes
      }

      /**
       * ** The UI portion if this namespace is maintained for legacy implementations only (not using web components). New implementations should use functionality included in the web components (stxUI.js) **<br>
       * Comparison namespace
       * @namespace
       * @name  CIQ.Comparison
       */
      CIQ.Comparison = function() {} // Create namespace

      /**
       * For relative comparisons, this is the starting point.  It can be a number to specify an absolute amount,
       * or a string to specify to use the baseline value (the first value in dataSegment) for a specific series (for instance "IBM").
       * An empty string will compare against the baseline value of the main series.
       *
       * See {@link CIQ.ChartEngine#setChartScale} for more details.
       * @type number|string
       * @memberof CIQ.Comparison
       * @since 5.1.0
       */
      CIQ.Comparison.initialPrice = 100

      /**
       * Used to compute the initial price when it is supplied as a string
       * @param  {CIQ.ChartEngine.Chart} chart	The specific chart
       * @return {number}			The initial price as a number
       * @memberof CIQ.Comparison
       * @since 5.1.0
       * @private
       */
      CIQ.Comparison.getInitialPrice = function(chart) {
        if (chart.initialComparisonPrice) return chart.initialComparisonPrice
        chart.initialComparisonPrice = 100
        var symbol = CIQ.Comparison.initialPrice
        if (typeof symbol == 'number') chart.initialComparisonPrice = symbol // absolute amount
        if (typeof symbol == 'string') {
          if (chart.series[symbol] || symbol === '') {
            var priceField = 'Close'
            if (chart.defaultPlotField) {
              if (!chart.highLowBars) priceField = chart.defaultPlotField
            }
            for (
              var i = chart.dataSet.length - chart.scroll;
              i < chart.dataSet.length;
              i++
            ) {
              var bar = chart.dataSet[i]
              if (bar) {
                if (bar[symbol] && bar[symbol][priceField]) {
                  chart.initialComparisonPrice = bar[symbol][priceField]
                  break
                } else if (symbol === '' && bar[priceField]) {
                  chart.initialComparisonPrice = bar[priceField]
                  break
                }
              }
            }
          }
        }
        return chart.initialComparisonPrice
      }

      /**
       * Transform function for percent comparison charting
       * @param  {CIQ.ChartEngine} stx	  The charting object
       * @param  {CIQ.ChartEngine.Chart} chart	The specific chart
       * @param  {number} price The price to transform
       * @return {number}			The transformed price (into percentage)
       * @memberof CIQ.Comparison
       */
      CIQ.Comparison.priceToPercent = function(stx, chart, price) {
        var baseline = CIQ.Comparison.baseline || price
        return Math.round(((price - baseline) / baseline) * 100 * 10000) / 10000
      }

      /**
       * Untransform function for percent comparison charting
       * @param  {CIQ.ChartEngine} stx	  The charting object
       * @param  {CIQ.ChartEngine.Chart} chart	The specific chart
       * @param  {number} percent The price to untransform
       * @return {number}			The untransformed price
       * @memberof CIQ.Comparison
       */
      CIQ.Comparison.percentToPrice = function(stx, chart, percent) {
        var baseline = CIQ.Comparison.baseline || 1
        return baseline * (1 + percent / 100)
      }

      /**
       * Transform function for relative comparison charting
       * @param  {CIQ.ChartEngine} stx	  The charting object
       * @param  {CIQ.ChartEngine.Chart} chart	The specific chart
       * @param  {number} price The price to transform
       * @return {number}			The transformed price (relative to {@link CIQ.Comparison.initialPrice})
       * @memberof CIQ.Comparison
       * @since 5.1.0
       */
      CIQ.Comparison.priceToRelative = function(stx, chart, price) {
        var baseline = CIQ.Comparison.baseline || price
        var initialPrice = CIQ.Comparison.getInitialPrice(chart)
        return (initialPrice * price) / baseline
      }

      /**
       * Untransform function for relative comparison charting
       * @param  {CIQ.ChartEngine} stx	  The charting object
       * @param  {CIQ.ChartEngine.Chart} chart	The specific chart
       * @param  {number} relative The price to untransform
       * @return {number}			The untransformed price
       * @memberof CIQ.Comparison
       * @since 5.1.0
       */
      CIQ.Comparison.relativeToPrice = function(stx, chart, relative) {
        var baseline = CIQ.Comparison.baseline || 1
        var initialPrice = CIQ.Comparison.getInitialPrice(chart)
        return (baseline * relative) / initialPrice
      }

      CIQ.Comparison.createComparisonSegmentInner = function(stx, chart) {
        // create an array of the fields that we're going to compare
        var fields = []
        var field
        for (field in chart.series) {
          var parameters = chart.series[field].parameters
          if (parameters.isComparison) {
            fields.push(parameters.symbol)
          }
        }
        var priceFields = ['Close', 'Open', 'High', 'Low', 'iqPrevClose']
        var highLowBars =
          stx.chart.highLowBars || stx.highLowBars[stx.layout.chartType]
        if (chart.defaultPlotField && !highLowBars)
          priceFields.unshift(chart.defaultPlotField)
        var baselineField = priceFields[0]
        var s = stx.layout.studies
        if (s) {
          for (var n in s) {
            var sd = s[n]
            if (
              !stx.panels[sd.panel] ||
              stx.panels[sd.panel].name != sd.chart.name
            )
              continue
            for (field in sd.outputMap) {
              priceFields.push(field)
            }
            if (sd.referenceOutput)
              priceFields.push(sd.referenceOutput + ' ' + sd.name)
          }
        }
        for (var p in stx.plugins) {
          var plugin = stx.plugins[p]
          if (!plugin.transformOutputs) continue
          for (field in plugin.transformOutputs) {
            priceFields.push(field)
          }
        }

        chart.initialComparisonPrice = null
        chart.dataSegment = []
        var firstQuote = null
        var firstTick = chart.dataSet.length - chart.scroll
        if (stx.micropixels + stx.layout.candleWidth / 2 < 0) firstTick++ // don't baseline comparison with a bar off the left edge
        var transformsToProcess = chart.maxTicks + 3 //make sure we have transformed enough data points that we plot the y-axis intercept correctly

        for (var i = 0; i <= transformsToProcess; i++) {
          if (i == transformsToProcess) i = -1 //go back and revisit the tick before the first
          var position = firstTick + i
          if (position < chart.dataSet.length && position >= 0) {
            var quote = chart.dataSet[position]
            var closingPrice = quote[baselineField]

            if (!firstQuote) {
              if (closingPrice === 0 || closingPrice === null) {
                if (i < 0) break
                //if we still can't get a single tick to do this and we try to revisit, we are out, or we go into infinite loop
                else continue // can't calculate the percentage gain/loss if the close is 0 or null.
              }
              firstQuote = CIQ.clone(quote)
            }

            // iterate through the fields calculating the percentage gain/loss
            // We store the results in the "transform" subobject of the data set
            // Note we inline the math calculation to save overhead of JS function call
            if (!quote.transform)
              quote.transform = {
                cache: {},
                DT: quote.DT,
                Date: quote.Date,
              }
            if (!CIQ.Comparison.baseline && closingPrice)
              firstQuote = CIQ.clone(quote)
            CIQ.Comparison.baseline = firstQuote[baselineField]

            var j
            for (j = 0; j < priceFields.length; j++) {
              field = priceFields[j]
              if (quote[field] || quote[field] === 0)
                //quote.transform[field]=Math.round(((quote[field]-CIQ.Comparison.baseline)/CIQ.Comparison.baseline*100)*10000)/10000;	// first compute the close pct, our baseline
                quote.transform[field] = chart.transformFunc(
                  stx,
                  chart,
                  quote[field]
                )
            }

            // Transform the series
            for (j = 0; j < fields.length; j++) {
              field = fields[j]
              var compSymbol = chart.series[field]
              if (i == -1 && compSymbol && compSymbol.parameters.isComparison) {
                delete quote.transform[field]
                continue
              }
              var seriesData = quote[field]
              for (var k = 0; seriesData && k < priceFields.length; k++) {
                var seriesPrice = seriesData[priceFields[k]]
                if (seriesPrice || seriesPrice === 0) {
                  // Skip blanks
                  var baseline =
                    firstQuote[field] && firstQuote[field][priceFields[0]]
                  if (!baseline && baseline !== 0) {
                    // This takes care of a series that starts part way through the chart
                    // The baseline is then computed looking back to what it would have been with a 0% change
                    if (!firstQuote[field]) firstQuote[field] = {}
                    firstQuote[field][priceFields[k]] = baseline =
                      (seriesPrice * CIQ.Comparison.baseline) /
                      quote[baselineField]
                  }
                  if (baseline !== 0) {
                    var masterBaseline = CIQ.Comparison.baseline || 1
                    var rationalizedPrice =
                      seriesPrice * (masterBaseline / baseline)
                    if (!quote.transform[field]) quote.transform[field] = {}
                    quote.transform[field][
                      priceFields[k]
                    ] = chart.transformFunc(stx, chart, rationalizedPrice)
                  }
                }
              }
            }
            chart.dataSegment.push(quote)
          } else if (position < 0) {
            chart.dataSegment.push(null)
          }
          if (i < 0) break //we revisited tick before first so we are done
        }
      }

      /**
       * Formats the percentage values on the comparison chart
       * @param  {CIQ.ChartEngine} stx	The chart object
       * @param  {CIQ.ChartEngine.Panel} panel The panel
       * @param  {number} price The raw percentage as a decimal
       * @return {string}		  The percentage formatted as a percent (possibly using localization if set in stx)
       * @memberof CIQ.Comparison
       */
      CIQ.Comparison.priceFormat = function(stx, panel, price) {
        if (price === null || typeof price == 'undefined' || isNaN(price))
          return ''
        var priceTick = panel.yAxis.priceTick
        var internationalizer = stx.internationalizer
        if (internationalizer) {
          if (priceTick >= 5)
            price = internationalizer.percent.format(price / 100)
          else if (priceTick >= 0.5)
            price = internationalizer.percent1.format(price / 100)
          else if (priceTick >= 0.05)
            price = internationalizer.percent2.format(price / 100)
          else if (priceTick >= 0.005)
            price = internationalizer.percent3.format(price / 100)
          else price = internationalizer.percent4.format(price / 100)
        } else {
          if (priceTick >= 5) price = price.toFixed(0) + '%'
          else if (priceTick >= 0.5) price = price.toFixed(1) + '%'
          else if (priceTick >= 0.05) price = price.toFixed(2) + '%'
          else if (priceTick >= 0.005) price = price.toFixed(3) + '%'
          else price = price.toFixed(4) + '%'
        }
        if (parseFloat(price) === 0 && price.charAt(0) == '-') {
          // remove minus sign from -0%, -0.0%, etc
          price = price.substring(1)
        }
        return price
      }

      /**
	 * Turns comparison charting on or off and sets the transform.
	 *
	 * Should not be called directly. Either use the {@link CIQ.ChartEngine#addSeries} `isComprison` parameter or use {@link CIQ.ChartEngine#setChartScale}

	 * @param {string|boolean} mode Type of comparison ("percent" or "relative").
	 *  - Setting to true will enable "percent".
	 *  - Setting to "relative" will allow the comparisons to be rendered in relation to any provided 'basis' value. For example, the previous market day close price.
	 * @param {CIQ.ChartEngine.Chart} [chart] The specific chart for comparisons
	 * @param {*} [basis] For a "relative" mode, the basis to relate to.  Can be a number or a string.  If a string, will use the first price in the datasegment for the series keyed by the string.  Sets {@link CIQ.Comparison.initialPrice}.
	 * @memberof CIQ.ChartEngine
	 * @since  04-2015 Signature has been revised
	 * @since 5.1.0 Signature revised again, added basis
	 * @since 5.1.0 `mode` now also supports "relative" to allow comparisons to be rendered in relation to any provided value.
	 */
      CIQ.ChartEngine.prototype.setComparison = function(mode, chart, basis) {
        if (!chart) chart = this.chart
        if (typeof chart == 'string') chart = this.charts[chart]
        if (basis || basis === '') CIQ.Comparison.initialPrice = basis
        if (mode === true) {
          // backward compatibility, older versions uses a true/false switch because they did not support the developer setting arbitrary baseline values
          if (chart.isComparison) return // Do nothing if it's already turned on
          mode = 'percent'
        }
        var yAxis = chart.panel.yAxis
        var wasComparison = yAxis.priceFormatter == CIQ.Comparison.priceFormat // tests if the current formatter is a comparison formatter
        // this is like testing if the previous mode was "percent"
        switch (mode) {
          case 'relative':
            this.setTransform(
              chart,
              CIQ.Comparison.priceToRelative,
              CIQ.Comparison.relativeToPrice
            )
            if (wasComparison) {
              yAxis.priceFormatter = yAxis.originalPriceFormatter
                ? yAxis.originalPriceFormatter.func
                : null
              yAxis.originalPriceFormatter = null
            }
            yAxis.whichSet = 'dataSegment'
            chart.isComparison = true
            break
          case 'percent':
            this.setTransform(
              chart,
              CIQ.Comparison.priceToPercent,
              CIQ.Comparison.percentToPrice
            )
            if (!wasComparison) {
              yAxis.originalPriceFormatter = { func: yAxis.priceFormatter }
              yAxis.priceFormatter = CIQ.Comparison.priceFormat
            }
            yAxis.whichSet = 'dataSegment'
            chart.isComparison = true
            break
          default:
            this.unsetTransform(chart)
            if (wasComparison) {
              yAxis.priceFormatter = yAxis.originalPriceFormatter
                ? yAxis.originalPriceFormatter.func
                : null
              yAxis.originalPriceFormatter = null
            }
            yAxis.whichSet = 'dataSet'
            chart.isComparison = false
            break
        }
      }

      /**
       * Imports a users preferences from a saved location and uses them in the ChartEngine
       * To save preferences see {@link CIQ.ChartEngine#exportPreferences}
       * @param {object} preferences An object of {@link CIQ.ChartEngine#preferences}
       * @memberof CIQ.ChartEngine
       * @since 4.0.0
       */
      CIQ.ChartEngine.prototype.importPreferences = function(preferences) {
        this.preferences = preferences
        if (preferences.timeZone)
          this.setTimeZone(this.dataZone, preferences.timeZone)
        if (preferences.language && CIQ.I18N) {
          CIQ.I18N.setLanguage(this, preferences.language)
          CIQ.I18N.translateUI(preferences.language)
        }
      }

      /**
       * Exports the {@link CIQ.ChartEngine#preferences} for external storage.
       * Can then be imported again after being parsed with {@link CIQ.ChartEngine#importPreferences}
       * @memberof CIQ.ChartEngine
       * @returns {CIQ.ChartEngine#preferences}
       * @since 4.0.0
       */
      CIQ.ChartEngine.prototype.exportPreferences = function() {
        return this.preferences
      }

      if (typeof document != 'undefined')
        document.addEventListener(
          'contextmenu',
          CIQ.ChartEngine.handleContextMenu
        )

      return _exports
    }

  var __market_ =
    //-------------------------------------------------------------------------------------------
    // Copyright 2012-2017 by ChartIQ, Inc.
    // All rights reserved
    //-------------------------------------------------------------------------------------------
    function(_exports) {
      if (!_exports) _exports = {}

      /**
	 * The market class is what the chart uses to to manage market hours for the different exchanges.
	 * It uses `Market Definitions` to decide when the market is open or closed.
	 * Although you can construct many market classes with different definitions to be used in your functions, only one market definition can be attached to the chart at any given time.
	 * Once a market is defined, an [iterator]{@link CIQ.Market#newIterator} can be created to traverse through time, taking into account the market hours.
	 * Additionally, a variety of convenience functions can be used to check the market status, such as {@link CIQ.Market#isOpen} or {@link CIQ.Market#isMarketDay}.
	 *
	 * A chart will operate 24x7, unless a market definition is assigned to it.
	 * See {@link CIQ.ChartEngine#setMarket} and {@link CIQ.ChartEngine#setMarketFactory} for instructions on how to assign a market definition to a chart.
	 * The chart also provides convenience functions that allows you to traverse through time at the current chart periodicity without having to explicitly create a new iterator.
	 * See {@link CIQ.ChartEngine#getNextInterval} and {@link CIQ.ChartEngine#standardMarketIterator} for details.
	 *
	 * It is also important to note that **only data within the defined market hours will be displayed on the chart** even if more data is loaded.
	 *
	 * `Market Definitions` are JavaScript objects which must contain the following elements:
	 * - `name` : A string. Name of the market for which the rules are for.
	 * - `rules` : An array. The rules indicating the times the market is open or closed.
	 * - `market_tz` : A string. Time zone in which the market operates. A valid timezone from the timeZoneData.js library.
	 * - `hour_aligned`: A boolean. If set to true, market opening and closing times will be set to the exact start of the hour of time, ignoring any minutes, seconds or millisecond offsets.
	 * - `convertOnDaily` : A boolean. By default, daily charts are not converted for timezone. Set this to true to convert for daily charts.
	 *
	 * Example:
	 * ```
	 * 	{
	 * 		name: "SAMPLE-MARKET",
	 * 		market_tz: "America/Chicago",
	 * 		hour_aligned: true,
	 * 		rules: [
	 * 				{"dayofweek": 1, "open": "09:00", "close": "17:00"}
	 * 		]
	 *	};
	 * ```
	 *
	 * Instructions for creating `Market Definitions`:
	 *
	 * - By default a market assumes that it is always open unless otherwise defined.
	 * - Market rule times are specified in the market's local timezone.
	 * - Seconds are not considered for open or close times, but are okay for intra day data.
	 * - Rules are processed top to bottom.
	 * - Default market rules do not have a `name` parameter and are enabled by default.
	 * - Non-default market rules require a `name` parameter included.
	 * - All non-default market rules are disabled by default.
	 *  To enable or disable non-default market rules by session name, use {@link CIQ.Market#enableSession} and {@link CIQ.Market#disableSession}.
	 *  If using template-advanced.html, consider using {@link CIQ.ExtendedHours}.
	 *
	 * 		This is a rule for a 'pre' market session:
	 * 			`{"dayofweek": 1, "open": "08:00", "close": "09:30", name: "pre"}`
	 *
	 * - First, the `dayofweek` wild card rules are processed. As soon as a rule is matched, processing breaks.
	 *
	 * 		This rule says the market is open every Monday from 9:30 to 16:00:
	 * 			`{"dayofweek": 1, "open": "09:30", "close": "16:00"}`
	 *
	 * - After the `dayofweek` rules are processed all of the extra rules are processed.
	 * - Multiple `open` and `close` times can be set for the same day of week. To indicate the market is closed during lunch, for example.
	 *
	 * 			```
	 * 			{"dayofweek": 1, "open": "09:00", "close": "12:00"}, // mon
	 *			{"dayofweek": 1, "open": "13:00", "close": "17:00"}  // mon
	 *			```
	 *
	 * - Wildcard rules should be placed first and more specific rules should be placed later.
	 *
	 * 		This rule is a wildcard rule for Christmas. If Christmas is on Monday, the
	 * 		first set of rules will evaluate to true because the dayofweek rule for day
	 * 		one will match. Then this rule will match if the date is the 25th of
	 * 		December in any year.  Because open is 00:00 and close is 00:00, it will evaluate to false:
	 * 			`{"date": "*-12-25", "open": "00:00", "close": "00:00"}`
	 *
	 * - After wildcard exceptions, any specific day and time can be matched.
	 *
	 * 		This rule says closed on this day only. Note that open and closed attributes
	 * 		can be omitted to save typing if the market is closed the entire day:
	 * 			`{"date": "2016-01-18"} //Martin Luther King day.`
	 *
	 * 		This rules says closed on 12-26:
	 * 			`{"date": "2016-12-26"}, //Observed Christmas in 2016`
	 *
	 * 		This rule says partial session
	 * 			`{"date": "2015-12-24", "open": "9:30", "close": "13:00"} //Christmas eve`
	 *
	 * See example section for a compete NYSE definition.
	 *
	 * Once defined, it can be used to create a new market instance.
	 *
	 * Example:
	 *
	 * ```
	 *	var thisMarket = new CIQ.Market(marketDefinition);
	 * ```
	 *
	 * If no definition is provided, the market will operate 24x7.
	 *
	 * Example:
	 * ```
	 * new CIQ.Market();
	 * ```
	 *
	 * @param {object} [market_definition] A json object that contains the rules for some market. If not defined default market is always open.
	 *
	 * @constructor
	 * @name  CIQ.Market
	 * @since
	 * <br>04-2016-08
	 * <br>06-2016-02 - You can now specify times for different market sessions ('pre',post', etc) to be used with the sessions visualization tools. See {@link CIQ.ExtendedHours}.
	 *
	 * @example
	 * CIQ.Market.NYSE = {
			"name": "NYSE",
			"market_tz": "America/New_York",
			"hour_aligned": false,
			"rules": [
				//First open up the regular trading times
				//Note that sat and sun (in this example) are always closed because
				//everything is closed by default and we didn't explicitly open
				//them.
				{"dayofweek": 1, "open": "09:30", "close": "16:00"}, //mon
				{"dayofweek": 2, "open": "09:30", "close": "16:00"},
				{"dayofweek": 3, "open": "09:30", "close": "16:00"},
				{"dayofweek": 4, "open": "09:30", "close": "16:00"},
				{"dayofweek": 5, "open": "09:30", "close": "16:00"}, //fri

				//After Hours premarket
				{"dayofweek": 1, "open": "08:00", "close": "09:30", name: "pre"}, //mon
				{"dayofweek": 2, "open": "08:00", "close": "09:30", name: "pre"},
				{"dayofweek": 3, "open": "08:00", "close": "09:30", name: "pre"},
				{"dayofweek": 4, "open": "08:00", "close": "09:30", name: "pre"},
				{"dayofweek": 5, "open": "08:00", "close": "09:30", name: "pre"}, //fri

				//After Hours post
				{"dayofweek": 1, "open": "16:00", "close": "20:00", name: "post"}, //mon
				{"dayofweek": 2, "open": "16:00", "close": "20:00", name: "post"},
				{"dayofweek": 3, "open": "16:00", "close": "20:00", name: "post"},
				{"dayofweek": 4, "open": "16:00", "close": "20:00", name: "post"},
				{"dayofweek": 5, "open": "16:00", "close": "20:00", name: "post"}, //fri

				//Now Monday thru Friday is open. Close any exceptions

				//always closed on Christmas
				{"date": "*-12-25", "open": "00:00", "close": "00:00"},

				//always closed on 4th of July
				{"date": "*-07-04", "open": "00:00", "close": "00:00"},

				//always close on new years day
				{"date": "*-01-01", "open": "00:00", "close": "00:00"},

				//Some holidays are observed on different days each year or if
				//the day falls on a weekend. Each of those rules must be specified.
				{"date": "2012-01-02", "open": "00:00", "close": "00:00"},

				//As a special case if no open and close attributes are set they
				//will be assumed "00:00" and "00:00" respectively
				{"date": "2017-01-02"},

				{"date": "2016-01-18"},
				{"date": "2016-02-15"},
				{"date": "2016-03-25"},
				{"date": "2016-05-30"},
				{"date": "2016-09-05"},
				{"date": "2016-11-24"},
				{"date": "2016-11-25", "open": "8:00", "close": "9:30", name: "pre"},
				{"date": "2016-11-25", "open": "9:30", "close": "13:00"},
				{"date": "2016-12-26"},

				{"date": "2015-01-19"},
				{"date": "2015-02-16"},
				{"date": "2015-04-03"},
				{"date": "2015-05-25"},
				{"date": "2015-07-03"},
				{"date": "2015-09-07"},
				{"date": "2015-11-26"},
				{"date": "2015-11-27", "open": "8:00", "close": "9:30", name: "pre"},
				{"date": "2015-11-27", "open": "9:30", "close": "13:00"},
				{"date": "2015-12-24", "open": "8:00", "close": "9:30", name: "pre"},
				{"date": "2015-12-24", "open": "9:30", "close": "13:00"},

				{"date": "2014-01-20"},
				{"date": "2014-02-17"},
				{"date": "2014-04-18"},
				{"date": "2014-05-26"},
				{"date": "2014-09-01"},
				{"date": "2014-11-27"},
				{"date": "2014-07-03", "open": "8:00", "close": "9:30", name: "pre"},
				{"date": "2014-07-03", "open": "9:30", "close": "13:00"},
				{"date": "2014-11-28", "open": "8:00", "close": "9:30", name: "pre"},
				{"date": "2014-11-28", "open": "9:30", "close": "13:00"},
				{"date": "2014-12-24", "open": "8:00", "close": "9:30", name: "pre"},
				{"date": "2014-12-24", "open": "9:30", "close": "13:00"},

				{"date": "2013-01-21"},
				{"date": "2013-02-18"},
				{"date": "2013-03-29"},
				{"date": "2013-05-27"},
				{"date": "2013-09-02"},
				{"date": "2013-11-28"},
				{"date": "2013-07-03", "open": "8:00", "close": "9:30", name: "pre"},
				{"date": "2013-07-03", "open": "9:30", "close": "13:00"},
				{"date": "2013-11-29", "open": "8:00", "close": "9:30", name: "pre"},
				{"date": "2013-11-29", "open": "9:30", "close": "13:00"},
				{"date": "2013-12-24", "open": "8:00", "close": "9:30", name: "pre"},
				{"date": "2013-12-24", "open": "9:30", "close": "13:00"},

				{"date": "2012-01-16"},
				{"date": "2012-02-20"},
				{"date": "2012-04-06"},
				{"date": "2012-05-28"},
				{"date": "2012-09-03"},
				{"date": "2012-10-29"},
				{"date": "2012-10-30"},
				{"date": "2012-11-22"},
				{"date": "2012-07-03", "open": "8:00", "close": "9:30", name: "pre"},
				{"date": "2012-07-03", "open": "9:30", "close": "13:00"},
				{"date": "2012-11-23", "open": "8:00", "close": "9:30", name: "pre"},
				{"date": "2012-11-23", "open": "9:30", "close": "13:00"},
				{"date": "2012-12-24", "open": "8:00", "close": "9:30", name: "pre"},
				{"date": "2012-12-24", "open": "9:30", "close": "13:00"}
			]
		};
	 */
      var CIQ = _exports.CIQ,
        timezoneJS = _exports.timezoneJS
      if (!CIQ) {
        CIQ = function() {}
        _exports.CIQ = CIQ
      }
      var HOUR_MILLIS = 60000 * 60
      var DAY_MILLIS = HOUR_MILLIS * 24

      CIQ.Market = function(market_definition) {
        this.market_def = false
        this.rules = false
        this.normalHours = []
        this.extraHours = []
        this.class_name = 'Market'
        if (typeof timezoneJS === 'undefined') {
          this.tz_lib = Date //needed to run unit tests
        } else {
          this.tz_lib = timezoneJS.Date
        }
        this.market_tz = ''
        this.hour_aligned = false
        this.convertOnDaily = false
        this.enabled_by_default = false

        //needed to run unit tests otherwise should do nothing
        if (
          typeof market_definition != 'undefined' &&
          market_definition &&
          market_definition != {}
        ) {
          if (market_definition.market_definition) {
            market_definition = market_definition.market_definition
          }
          if (market_definition.rules) {
            this.rules = market_definition.rules
          }
          if (market_definition.market_tz) {
            this.market_tz = market_definition.market_tz
          }
          if (market_definition.convertOnDaily) {
            this.convertOnDaily = market_definition.convertOnDaily
          }
          if (typeof market_definition.hour_aligned) {
            this.hour_aligned = market_definition.hour_aligned
          }
          if (typeof market_definition.enabled_by_default !== 'undefined') {
            if (market_definition.enabled_by_default instanceof Array) {
              this.enabled_by_default = market_definition.enabled_by_default
            }
          }

          this.market_def = market_definition
          if (this.market_def.name === undefined) {
            this.market_def.name = 'no market name specified'
          }
        } else {
          return
        }

        CIQ.Market._createTimeSegments(this)
      }

      CIQ.Market.GLOBEX = {
        name: 'GLOBEX',
        market_tz: 'America/Chicago',
        hour_aligned: true,
        rules: [
          { dayofweek: 0, open: '15:00', close: '24:00' }, //sun
          { dayofweek: 1, open: '00:00', close: '24:00' },
          { dayofweek: 2, open: '00:00', close: '24:00' },
          { dayofweek: 3, open: '00:00', close: '24:00' },
          { dayofweek: 4, open: '00:00', close: '24:00' },
          { dayofweek: 5, open: '00:00', close: '18:00' },
        ],
      }

      CIQ.Market.FOREX = {
        name: 'FOREX',
        market_tz: 'America/New_York',
        hour_aligned: true,
        rules: [
          { dayofweek: 0, open: '15:00', close: '24:00' }, //  9AM NZ time in the winter and 7AM NZ time in the summer.
          { dayofweek: 1, open: '00:00', close: '17:00' },
          { dayofweek: 1, open: '17:00', close: '24:00' },
          { dayofweek: 2, open: '00:00', close: '17:00' },
          { dayofweek: 2, open: '17:00', close: '24:00' },
          { dayofweek: 3, open: '00:00', close: '17:00' },
          { dayofweek: 3, open: '17:00', close: '24:00' },
          { dayofweek: 4, open: '00:00', close: '17:00' },
          { dayofweek: 4, open: '17:00', close: '24:00' },
          { dayofweek: 5, open: '00:00', close: '17:00' },
        ],
      }

      CIQ.Market.METALS = {
        name: 'METALS',
        market_tz: 'America/New_York',
        hour_aligned: true,
        rules: [
          { dayofweek: 0, open: '18:00', close: '24:00' },
          { dayofweek: 1, open: '00:00', close: '17:15' },
          { dayofweek: 1, open: '18:00', close: '24:00' },
          { dayofweek: 2, open: '00:00', close: '17:15' },
          { dayofweek: 2, open: '18:00', close: '24:00' },
          { dayofweek: 3, open: '00:00', close: '17:15' },
          { dayofweek: 3, open: '18:00', close: '24:00' },
          { dayofweek: 4, open: '00:00', close: '17:15' },
          { dayofweek: 4, open: '18:00', close: '24:00' },
          { dayofweek: 5, open: '00:00', close: '17:15' },
        ],
      }

      CIQ.Market.NYSE = {
        name: 'NYSE',
        market_tz: 'America/New_York',
        hour_aligned: false,
        rules: [
          //First open up the regular trading times
          //Note that sat and sun (in this example) are always closed because
          //everything is closed by default and we didn't explicitly open
          //them.
          { dayofweek: 1, open: '09:30', close: '16:00' }, //mon
          { dayofweek: 2, open: '09:30', close: '16:00' },
          { dayofweek: 3, open: '09:30', close: '16:00' },
          { dayofweek: 4, open: '09:30', close: '16:00' },
          { dayofweek: 5, open: '09:30', close: '16:00' }, //fri

          //After Hours premarket
          { dayofweek: 1, open: '04:00', close: '09:30', name: 'pre' }, //mon
          { dayofweek: 2, open: '04:00', close: '09:30', name: 'pre' },
          { dayofweek: 3, open: '04:00', close: '09:30', name: 'pre' },
          { dayofweek: 4, open: '04:00', close: '09:30', name: 'pre' },
          { dayofweek: 5, open: '04:00', close: '09:30', name: 'pre' }, //fri

          //After Hours post
          { dayofweek: 1, open: '16:00', close: '20:00', name: 'post' }, //mon
          { dayofweek: 2, open: '16:00', close: '20:00', name: 'post' },
          { dayofweek: 3, open: '16:00', close: '20:00', name: 'post' },
          { dayofweek: 4, open: '16:00', close: '20:00', name: 'post' },
          { dayofweek: 5, open: '16:00', close: '20:00', name: 'post' }, //fri

          //Now mon thru friday is open. Close any exceptions

          //always closed on Christmas
          { date: '*-12-25', open: '00:00', close: '00:00' },

          //always closed on 4th of July
          { date: '*-07-04', open: '00:00', close: '00:00' },

          //always close on new years day
          { date: '*-01-01', open: '00:00', close: '00:00' },

          //Some holidays are observed on different days each year or if
          //the day falls on a weekend. Each of those rules must be specified.
          { date: '2012-01-02', open: '00:00', close: '00:00' },

          //As a special case if no open and close attributes are set they
          //will be assumed "00:00" and "00:00" respectively
          { date: '2018-01-15' },
          { date: '2018-02-19' },
          { date: '2018-03-30' },
          { date: '2018-05-28' },
          { date: '2018-07-03', open: '4:00', close: '9:30', name: 'pre' },
          { date: '2018-07-03', open: '9:30', close: '13:00' },
          { date: '2018-09-03' },
          { date: '2018-11-22' },
          { date: '2018-11-23', open: '4:00', close: '9:30', name: 'pre' },
          { date: '2018-11-23', open: '9:30', close: '13:00' },
          { date: '2018-12-24', open: '4:00', close: '9:30', name: 'pre' },
          { date: '2018-12-24', open: '9:30', close: '13:00' },

          { date: '2017-01-02' },
          { date: '2017-01-16' },
          { date: '2017-02-20' },
          { date: '2017-04-14' },
          { date: '2017-05-29' },
          { date: '2017-07-03', open: '4:00', close: '9:30', name: 'pre' },
          { date: '2017-07-03', open: '9:30', close: '13:00' },
          { date: '2017-09-04' },
          { date: '2017-11-23' },
          { date: '2017-11-24', open: '4:00', close: '9:30', name: 'pre' },
          { date: '2017-11-24', open: '9:30', close: '13:00' },

          { date: '2016-01-18' },
          { date: '2016-02-15' },
          { date: '2016-03-25' },
          { date: '2016-05-30' },
          { date: '2016-09-05' },
          { date: '2016-11-24' },
          { date: '2016-11-25', open: '4:00', close: '9:30', name: 'pre' },
          { date: '2016-11-25', open: '9:30', close: '13:00' },
          { date: '2016-12-26' },

          { date: '2015-01-19' },
          { date: '2015-02-16' },
          { date: '2015-04-03' },
          { date: '2015-05-25' },
          { date: '2015-07-03' },
          { date: '2015-09-07' },
          { date: '2015-11-26' },
          { date: '2015-11-27', open: '4:00', close: '9:30', name: 'pre' },
          { date: '2015-11-27', open: '9:30', close: '13:00' },
          { date: '2015-12-24', open: '4:00', close: '9:30', name: 'pre' },
          { date: '2015-12-24', open: '9:30', close: '13:00' },

          { date: '2014-01-20' },
          { date: '2014-02-17' },
          { date: '2014-04-18' },
          { date: '2014-05-26' },
          { date: '2014-09-01' },
          { date: '2014-11-27' },
          { date: '2014-07-03', open: '4:00', close: '9:30', name: 'pre' },
          { date: '2014-07-03', open: '9:30', close: '13:00' },
          { date: '2014-11-28', open: '4:00', close: '9:30', name: 'pre' },
          { date: '2014-11-28', open: '9:30', close: '13:00' },
          { date: '2014-12-24', open: '4:00', close: '9:30', name: 'pre' },
          { date: '2014-12-24', open: '9:30', close: '13:00' },

          { date: '2013-01-21' },
          { date: '2013-02-18' },
          { date: '2013-03-29' },
          { date: '2013-05-27' },
          { date: '2013-09-02' },
          { date: '2013-11-28' },
          { date: '2013-07-03', open: '4:00', close: '9:30', name: 'pre' },
          { date: '2013-07-03', open: '9:30', close: '13:00' },
          { date: '2013-11-29', open: '4:00', close: '9:30', name: 'pre' },
          { date: '2013-11-29', open: '9:30', close: '13:00' },
          { date: '2013-12-24', open: '4:00', close: '9:30', name: 'pre' },
          { date: '2013-12-24', open: '9:30', close: '13:00' },

          { date: '2012-01-16' },
          { date: '2012-02-20' },
          { date: '2012-04-06' },
          { date: '2012-05-28' },
          { date: '2012-09-03' },
          { date: '2012-10-29' },
          { date: '2012-10-30' },
          { date: '2012-11-22' },
          { date: '2012-07-03', open: '4:00', close: '9:30', name: 'pre' },
          { date: '2012-07-03', open: '9:30', close: '13:00' },
          { date: '2012-11-23', open: '4:00', close: '9:30', name: 'pre' },
          { date: '2012-11-23', open: '9:30', close: '13:00' },
          { date: '2012-12-24', open: '4:00', close: '9:30', name: 'pre' },
          { date: '2012-12-24', open: '9:30', close: '13:00' },
        ],
      }

      /**
       * Set of rules for identifying instrument's exchange and deriving a market definition from a symbol.
       * This is only required if your chart will need to know the operating hours for the different exchanges.
       * If using a 24x7 chart, this class is not needed.
       *
       * By default these rules are assigned to functions using ChartIQ symbology to identify the exchange.
       *
       * **Before using, they must be reviewed and if necessary assigned to functions containing logic to match symbology rules for your quote data.**
       *
       * @namespace
       * @name  CIQ.Market.Symbology
       * @since 04-2016-08
       */
      CIQ.Market.Symbology = function() {}

      /**
       * Returns true if the instrument is foreign.
       * This is dependent on the market data feed and should be overridden accordingly.
       * Currently if the instrument contains a period (.) it will be considered foreign (non US). (e.g. .XXXX)
       * @param  {string}  symbol The symbol
       * @return {boolean}        True if it's a foreign symbol
       * @memberof CIQ.Market.Symbology
       * @since 04-2016-08
       */
      CIQ.Market.Symbology.isForeignSymbol = function(symbol) {
        if (!symbol) return false
        return symbol.indexOf('.') != -1
      }

      /**
       * Returns true if the instrument is a futures.
       * This is dependent on the market data feed and should be overridden accordingly.
       * Currently if the symbol begins with `/` it will be considered a future. (e.g. /C)
       * @param  {string}  symbol The symbol
       * @return {boolean}        True if it's a futures symbol
       * @memberof CIQ.Market.Symbology
       * @since 04-2016-08
       */
      CIQ.Market.Symbology.isFuturesSymbol = function(symbol) {
        if (!symbol) return false
        if (symbol.indexOf('/') !== 0 || symbol == '/') return false
        return true
      }

      /**
       * Returns true if the instrument is a forex symbol.
       * This is dependent on the market data feed and should be overridden accordingly.
       * Currently if the symbol begins with `^` and is followed by 6 alpha characters, or just 6 alpha characters long without a '^', it will be considered forex.(e.g. ^EURUSD)
       * @param  {string}  symbol The symbol
       * @return {boolean}        True if it's a forex symbol
       * @memberof CIQ.Market.Symbology
       * @since 04-2016-08
       */
      CIQ.Market.Symbology.isForexSymbol = function(symbol) {
        if (!symbol) return false
        if (CIQ.Market.Symbology.isForeignSymbol(symbol)) return false
        if (CIQ.Market.Symbology.isFuturesSymbol(symbol)) return false
        if (symbol.length < 6 || symbol.length > 7) return false
        if (symbol.length == 6 && symbol[5] == 'X') return false
        if (/\^?[A-Za-z]{6}/.test(symbol)) return true
        return false
      }

      /**
       * Returns true if the symbol is a metal/currency or currency/metal pair
       * This is dependent on the market data feed and should be overridden accordingly.
       * Currently it must be a [forex]{@link CIQ.Market.Symbology.isForexSymbol} for a precious metal. (e.g. ^XAUUSD - looks for XAU,XPD,XPT,XAG only)
       * @param  {string}   symbol The symbol
       * @param  {boolean}  inverse Set to true to test specifically for a currency/metal pair.
       * @return {boolean}  True if it's a metal symbol
       * @memberof CIQ.Market.Symbology
       * @since 04-2016-08
       */
      CIQ.Market.Symbology.isForexMetal = function(symbol, inverse) {
        if (!symbol) return false
        if (!CIQ.Market.Symbology.isForexSymbol(symbol)) return false
        if (symbol.charAt(0) != '^') symbol = '^' + symbol
        if (',XAU,XPD,XPT,XAG,'.indexOf(',' + symbol.substr(4, 3) + ',') != -1)
          return true
        else if (
          !inverse &&
          ',XAU,XPD,XPT,XAG,'.indexOf(',' + symbol.substr(1, 3) + ',') != -1
        )
          return true
        return false
      }

      /**
       * Returns true if the symbol is a forex or a future
       * This is dependent on the market data feed and should be overridden accordingly.
       * @param  {string} symbol The symbol
       * @return {boolean} True if the symbol is a forex or a future
       * @memberof CIQ.Market.Symbology
       * @since 04-2016-08
       */
      CIQ.Market.Symbology.isForexFuturesSymbol = function(symbol) {
        if (CIQ.Market.Symbology.isForexSymbol(symbol)) return true
        if (CIQ.Market.Symbology.isFuturesSymbol(symbol)) return true
        return false
      }

      /**
       * This is a function that takes a symbolObject of form accepted by {@link CIQ.ChartEngine#newChart}, and returns a market definition.
       * When loading it with {@link CIQ.ChartEngine#setMarketFactory}, it will be used by the chart to dynamically change market definitions when a new instrument is activated.
       * See {@link CIQ.Market} for instruction on how to create a market definition.
       * @param  {object} symbolObject Symbol object of form accepted by {@link CIQ.ChartEngine#newChart}
       * @return {object} A market definition. See {@link CIQ.Market} for instructions.
       * @memberof CIQ.Market.Symbology
       * @since 04-2016-08
       */
      CIQ.Market.Symbology.factory = function(symbolObject) {
        var symbol = symbolObject.symbol
        if (CIQ.Market.Symbology.isForeignSymbol(symbol)) return null // 24 hour market definition
        if (CIQ.Market.Symbology.isFuturesSymbol(symbol))
          return CIQ.Market.GLOBEX
        if (CIQ.Market.Symbology.isForexMetal(symbol)) return CIQ.Market.METALS
        if (CIQ.Market.Symbology.isForexSymbol(symbol)) return CIQ.Market.FOREX
        return CIQ.Market.NYSE
      }

      /**
       * Primitive to find the next matching time segment taking into account rules for adjacent sessions.
       * If the date lands exactly on the open or close time for a session, then it will still seek to the next market session.
       * @param {date} date A start date time in the market_tz timezone.
       * @param {boolean} open True if looking for an open time
       * @return {date} A date in the market_tz timezone that falls somewhere in a matching time segment. Probably 1 before close. Or null if no rules are defined
       * @memberof CIQ.Market
       * @since  05-2016-10
       * @private
       */
      CIQ.Market.prototype._find_next_segment = function(date, open) {
        if (!this.market_def) return null // special case
        if (!this.rules) return null //special case
        var d = new Date(+date)
        var iter = this.newIterator({
          begin: d,
          interval: 1,
          inZone: this.market_tz,
          outZone: this.market_tz,
        })
        if (this._wasOpenIntraDay(d)) {
          var hours = this.zseg_match.close_parts.hours
          var minutes = this.zseg_match.close_parts.minutes
          d.setHours(hours)
          d.setMinutes(minutes)
          iter = this.newIterator({
            begin: d,
            interval: 1,
            inZone: this.market_tz,
            outZone: this.market_tz,
          })
        }
        return iter.next()
      }

      /**
       * Primitive to find the previous matching time segment taking into account rules for adjacent sessions.
       * If the date lands exactly on the open or close time for a session, then it will still seek to the previous market session.
       * @param {date} date A start date time in the market_tz timezone.
       * @param {boolean} open True if looking for an open time
       * @return {date} A date in the market_tz timezone that falls somewhere in a matching time segment. Probably 1 before close. Or null of no rules are defined.
       * @memberof CIQ.Market
       * @since  05-2016-10
       * @private
       */
      CIQ.Market.prototype._find_prev_segment = function(date, open) {
        if (!this.market_def) return null // special case
        if (!this.rules) return null //special case
        var d = new Date(+date)
        var iter = this.newIterator({
          begin: d,
          interval: 1,
          inZone: this.market_tz,
          outZone: this.market_tz,
        })

        var wasOpenIntraDay = this._wasOpenIntraDay(d)

        // adjust edge cases to force a previous instance
        // if we are at the exact open or close time, go back one tick to force a previous session
        if (wasOpenIntraDay === null) {
          // move back one minute... not in the market clock.
          d = new Date(d - 60000)
          // then see if there was a session a minute ago... if so, then we were at the exact open or close time
          wasOpenIntraDay = this._wasOpenIntraDay(d)
        } else {
          if (
            (open &&
              d.getHours() === this.zseg_match.open_parts.hours &&
              d.getMinutes() === this.zseg_match.open_parts.minutes) ||
            (!open &&
              d.getHours() === this.zseg_match.close_parts.hours &&
              d.getMinutes() === this.zseg_match.close_parts.minutes)
          ) {
            d = iter.previous()
          }
        }

        if (wasOpenIntraDay) {
          var hours = this.zseg_match.open_parts.hours
          var minutes = this.zseg_match.open_parts.minutes
          d.setHours(hours)
          d.setMinutes(minutes)
          iter = this.newIterator({
            begin: d,
            interval: 1,
            inZone: this.market_tz,
            outZone: this.market_tz,
          })
          d = iter.previous()

          if (this.zseg_match.close_parts.hours === hours) {
            if (this.zseg_match.close_parts.minutes === minutes) {
              // segments are adjacent use the previous
              if (open) {
                return iter.next()
              }
              return d
            }
          }
          if (this.zseg_match.adjacent_child) {
            // segments are adjacent use the previous
            return d
          }
          if (open) {
            // segments are not adjacent go back
            return iter.next()
          }
          return d
        }
        return iter.previous()
      }

      /**
       * Toggle on/off a market session by name.
       * @param {string} session_name A session name matching a valid name present in the market definition.
       * @param {object} [inverted] Any true value (`true`, non-zero value or string) passed here will enable the session, otherwise the session will be disabled.
       * @memberof CIQ.Market
       * @since  06-2016-02
       */
      CIQ.Market.prototype.disableSession = function(session_name, inverted) {
        var inverted_ = false
        if (typeof inverted !== 'undefined' && inverted) {
          inverted_ = true
        }
        if (session_name) {
          for (var i = 0; i < this.normalHours.length; i++) {
            if (this.normalHours[i].name === session_name) {
              this.normalHours[i].enabled = inverted_
            }
          }
          for (i = 0; i < this.extraHours.length; i++) {
            if (this.extraHours[i].name === session_name) {
              this.extraHours[i].enabled = inverted_
            }
          }
        }
      }

      /**
       * Enable a market session by name. See {@link CIQ.Market#disableSession}
       * @param {string} session_name A session name
       * @memberof CIQ.Market
       * @since  06-2016-02
       */
      CIQ.Market.prototype.enableSession = function(session_name) {
        this.disableSession(session_name, 'enable_instead')
      }

      /**
       * Get the close date/time for the trading day or specific session.
       * @param {date} [date=now] date The date on which to check.
       * @param {string} [session_name] Specific market session. If `session_name` is not passed in, the first close time of the day will be returned,
       * depending on the sessions that are enabled.  If a session name is passed in, then not only does the market session
       * need to be open on the day of `date`, but also within the time of the specified session.  Otherwise, null will be returned.
       * Pass in "" to specify only the default session when other session are also active.
       * @param {string} [inZone] Optional datazone to translate from - If no market zone is present it will assume browser time.
       * @param {string} [outZone] Optional datazone to translate to - If no market zone is present it will assume browser time.
       * @return {date} Close date/time for the trading session or null if the market is
       * closed for the given date.
       * @memberof CIQ.Market
       * @since  05-2016-10
       */
      CIQ.Market.prototype.getClose = function(
        date,
        session_name,
        inZone,
        outZone
      ) {
        if (!this.market_def) return null // special case
        if (!this.rules) return null //special case
        var d = date
        if (!date) {
          d = new Date()
          inZone = null // if they don't send the date we set one up in browser time, so need to remove the inZone
        }
        d = this._convertToMarketTZ(d, inZone)

        if (typeof session_name !== 'undefined') {
          if (this._wasOpenIntraDay(d)) {
            if (this.zseg_match.name === session_name) {
              d.setHours(
                this.zseg_match.close_parts.hours,
                this.zseg_match.close_parts.minutes,
                0,
                0
              )
              d = this._convertFromMarketTZ(d, outZone)
              return d
            }
          }
        } else {
          if (this._wasOpenDaily(d)) {
            var zseg_match = this.zseg_match

            //find the last session of the day
            while (zseg_match.child_) {
              zseg_match = zseg_match.child_
            }

            //find the last enabled session ... maybe back where we started
            while (!zseg_match.enabled) {
              zseg_match = zseg_match.parent_
            }

            d.setHours(
              zseg_match.close_parts.hours,
              zseg_match.close_parts.minutes,
              0,
              0
            )
            d = this._convertFromMarketTZ(d, outZone)
            return d
          }
        }
        return null
      }

      /**
       * Get the close time for the current market session, or if the market is closed, the close time for the next market session.
       * @param {date} [date=now] date The date on which to check.
       * @param {string} [inZone] Optional datazone to translate from - If no market zone is present it will assume browser time.
       * @param {string} [outZone] Optional datazone to translate to - If no market zone is present it will assume browser time.
       * @return {date} A date set to the close time of the next open market session.
       * @memberof CIQ.Market
       * @since  05-2016-10
       */
      CIQ.Market.prototype.getNextClose = function(date, inZone, outZone) {
        if (!this.market_def) return null // special case
        if (!this.rules) return null //special case

        var d = date
        if (!date) {
          d = new Date()
          inZone = null // if they don't send the date we set one up in browser time, so need to remove the inZone
        }
        d = this._convertToMarketTZ(d, inZone)
        if (!this._wasOpenIntraDay(d)) {
          var iter = this.newIterator({
            begin: d,
            interval: 1,
            inZone: this.market_tz,
            outZone: this.market_tz,
          })
          d = iter.next()
        }
        var date_ = d.getDate()
        var zseg_match = this.zseg_match
        while (zseg_match.adjacent_child) {
          zseg_match = zseg_match.adjacent_child
          date_ += 1
        }
        d.setDate(date_)
        d.setHours(
          zseg_match.close_parts.hours,
          zseg_match.close_parts.minutes,
          0,
          0
        )
        d = this._convertFromMarketTZ(d, outZone)
        return d
      }

      /**
       * Get the next market session open time. If the requested date is the opening time for the session, then
       * it will iterate to opening time for the next market session.
       * @param {date} [date=now] date An The date on which to check.
       * @param {string} [inZone] Optional datazone to translate from - If no market zone is present it will assume browser time.
       * @param {string} [outZone] Optional datazone to translate to - If no market zone is present it will assume browser time.
       * @return {date} A date aligned to the open time of the next open session. If no rules are defined, it will return null.
       * @memberof CIQ.Market
       * @since  05-2016-10
       */
      CIQ.Market.prototype.getNextOpen = function(date, inZone, outZone) {
        if (!this.market_def) return null // special case
        if (!this.rules) return null //special case
        var d = date
        if (!date) {
          d = new Date()
          inZone = null // if they don't send the date we set one up in browser time, so need to remove the inZone
        }
        d = this._convertToMarketTZ(d, inZone)
        d = this._find_next_segment(d)
        if (this.zseg_match.adjacent_parent) {
          d = this.getNextOpen(d, this.market_tz, this.market_tz)
          d = this._convertFromMarketTZ(d, outZone)
          return d
        }
        d.setHours(this.zseg_match.open_parts.hours)
        d.setMinutes(this.zseg_match.open_parts.minutes)
        d = this._convertFromMarketTZ(d, outZone)
        return d
      }

      /**
       * Get the open date/time for a market day or specific session.
       * @param {date} [date=now] date The date on which to check.
       * @param {string} [session_name] Specific market session. If `session_name` is not passed in, the first open time of the day will be returned,
       * depending on the sessions that are enabled.  If a session name is passed in, then not only does the market session
       * need to be open on the day of `date`, but also within the time of the specified session.  Otherwise, null will be returned.  Pass in "" to
       * specify only the default session when other session are also active.
       * @param {string} [inZone] Optional datazone to translate from - If no market zone is present it will assume browser time.
       * @param {string} [outZone] Optional datazone to translate to - If no market zone is present it will assume browser time.
       * @return {date} A date time for the open of a session or null if the market is
       * closed for the given date or there are no market rules to check.
       * @memberof CIQ.Market
       * @since  05-2016-10
       */
      CIQ.Market.prototype.getOpen = function(
        date,
        session_name,
        inZone,
        outZone
      ) {
        if (!this.market_def) return null // special case
        if (!this.rules) return null //special case
        var d = date
        if (!date) {
          d = new Date()
          inZone = null // if they don't send the date we set one up in browser time, so need to remove the inZone
        }
        d = this._convertToMarketTZ(d, inZone)
        if (typeof session_name !== 'undefined') {
          if (this._wasOpenIntraDay(d)) {
            if (this.zseg_match.name == session_name) {
              d.setHours(
                this.zseg_match.open_parts.hours,
                this.zseg_match.open_parts.minutes,
                0,
                0
              )
              d = this._convertFromMarketTZ(d, outZone)
              return d
            }
          }
        } else {
          if (this._wasOpenDaily(d)) {
            var zseg_match = this.zseg_match

            //find all of the parents if any
            while (zseg_match.parent_) {
              zseg_match = zseg_match.parent_
            }

            //find the first enabled child ... might end up back where we started
            while (!zseg_match.enabled) {
              zseg_match = zseg_match.child_
            }

            d.setHours(
              zseg_match.open_parts.hours,
              zseg_match.open_parts.minutes,
              0,
              0
            )
            d = this._convertFromMarketTZ(d, outZone)
            return d
          }
        }
        return null
      }

      /**
       * Get the previous session close time.
       * If the date lands exactly on the close time for a session then it will still seek to the previous market session's close.
       * @param {date} [date=now] date The date on which to check.
       * @param {string} [inZone] Optional datazone to translate from - If no market zone is present it will assume browser time.
       * @param {string} [outZone] Optional datazone to translate to - If no market zone is present it will assume browser time.
       * @return {date} A date aligned to the previous close date/time of a session. If no rules are defined, it will return null.
       * @memberof CIQ.Market
       * @since  05-2016-10
       */
      CIQ.Market.prototype.getPreviousClose = function(date, inZone, outZone) {
        if (!this.market_def) return null // special case
        if (!this.rules) return null //special case
        var d = date
        if (!date) {
          d = new Date()
          inZone = null // if they don't send the date we set one up in browser time, so need to remove the inZone
        }
        d = this._convertToMarketTZ(d, inZone)
        d = this._find_prev_segment(d, false)
        if (this.zseg_match.adjacent_child) {
          return this.getPreviousClose(d, this.market_tz, this.market_tz)
        }
        d.setHours(this.zseg_match.close_parts.hours)
        d.setMinutes(this.zseg_match.close_parts.minutes)
        d = this._convertFromMarketTZ(d, outZone)
        return d
      }

      /**
       * Get the previous session open time. If the date lands exactly on the open time for a session then
       * it will still seek to the previous market session's open.
       * @param {date} [date=now] date An The date on which to check.
       * @param {string} [inZone] Optional datazone to translate from - If no market zone is present it will assume browser time.
       * @param {string} [outZone] Optional datazone to translate to - If no market zone is present it will assume browser time.
       * @return {date} A date aligned to previous open date/time of a session. If no rules are defined, it will return null.
       * @memberof CIQ.Market
       * @since  05-2016-10
       */
      CIQ.Market.prototype.getPreviousOpen = function(date, inZone, outZone) {
        if (!this.market_def) return null // special case
        if (!this.rules) return null //special case
        var d = date
        if (!date) {
          d = new Date()
          inZone = null // if they don't send the date we set one up in browser time, so need to remove the inZone
        }
        d = this._convertToMarketTZ(d, inZone)
        d = this._find_prev_segment(d, true)
        if (this.zseg_match.adjacent_parent) {
          return this.getPreviousOpen(this.market_tz, this.market_tz)
        }
        d.setHours(this.zseg_match.open_parts.hours)
        d.setMinutes(this.zseg_match.open_parts.minutes)
        d = this._convertFromMarketTZ(d, outZone)
        return d
      }

      /**
       * Return the session name for a date. If the name is defined and if the date
       * lands in a session that is open. Otherwise return null.
       * @param {date} date A date object
       * @param {string} [inZone] Timezone of incoming date - If no market zone is present it will assume browser time.
       * @return {object} String or null
       * @memberOf  CIQ.Market
       */
      CIQ.Market.prototype.getSession = function(date, inZone) {
        date = this._convertToMarketTZ(date, inZone)
        if (this._wasOpenIntraDay(date) && this.zseg_match) {
          return this.zseg_match.name
        }
        return null
      }

      /**
       * @return {date} Current time in the market zone
       * @memberof CIQ.Market
       * @since 04-2016-08
       */
      CIQ.Market.prototype.marketZoneNow = function() {
        return this._convertToMarketTZ(new Date())
      }

      /**
       * @return {boolean} `true` if this market is hour aligned.
       * @memberof CIQ.Market
       * @since 04-2016-08
       */
      CIQ.Market.prototype.isHourAligned = function() {
        return this.hour_aligned
      }

      /**
       * Checks if the market is currently open.
       * @return {boolean} `true` if the market is open right now.
       * @memberof CIQ.Market
       * @since 04-2016-08
       */
      CIQ.Market.prototype.isOpen = function() {
        var now = new Date()
        if (this.market_tz) {
          now = new this.tz_lib(now.getTime(), this.market_tz)
        }
        return this._wasOpenIntraDay(now)
      }

      /**
       * Checks if today it is a market day.
       * @return {boolean} `true` if it is a market day.
       * @memberof CIQ.Market
       * @since 04-2016-08
       */
      CIQ.Market.prototype.isMarketDay = function() {
        var now = new Date()
        if (this.market_tz) {
          now = new this.tz_lib(now.getTime(), this.market_tz)
        }
        return this._wasOpenDaily(now)
      }

      /**
       * Checks if a supplied date is a market day.  Only the date is examined; hours, minutes, seconds are ignored
       * @param {date} date A date
       * @return {boolean} `true` if it is a market day.
       * @memberof CIQ.Market
       * @since 04-2016-08
       */
      CIQ.Market.prototype.isMarketDate = function(date) {
        return this._wasOpenDaily(date)
      }

      /**
	 * Creates iterators for the associated Market to traverse through time taking into account market hours.
	 * An iterator instance can go forward or backward in time any arbitrary amount.
	 * However, the internal state cannot be changed once it is constructed. A new iterator should be
	 * constructed whenever one of the parameters changes. For example, if the
	 * `interval` changes a new iterator will need to be built. If the `displayZone`
	 * or `dataZone` changes on the market, new iterators will also need to be
	 * constructed.
	 *
	 * See {@link CIQ.Market.Iterator} for all available methods.
	 *
	 * See the following convenience functions: {@link CIQ.ChartEngine#getNextInterval} and  {@link CIQ.ChartEngine#standardMarketIterator}
	 *
	 * @param {object} parms Parameters used to initialize the Market object.
	 * @param {string} [parms.interval] A valid interval as required by {@link CIQ.ChartEngine#setPeriodicity}. Default is 1 (minute).
	 * @param {number} [parms.periodicity] A valid periodicity as required by {@link CIQ.ChartEngine#setPeriodicity}. Default is 1.
	 * @param {string} [parms.timeUnit] A valid timeUnit as required by {@link CIQ.ChartEngine#setPeriodicity}. Default is "minute"
	 * @param {date} [parms.begin] The date to set as the start date for this iterator instance. Default is `now`. Will be assumed to be `inZone` if one set.
	 * @param {string} [parms.inZone] A valid timezone from the timeZoneData.js library. This should represent the time zone for any input dates such as `parms.begin` in this function or `parms.end` in {@link CIQ.Market.Iterator#futureTick}. Defaults to browser timezone if none set.  - If no market zone is present it will assume browser time.
	 * @param {string} [parms.outZone] A valid timezone from the timeZoneData.js library. This should represent the time zone for the returned dates. Defaults to browser timezone if none set.  - If no market zone is present it will assume browser time.
	 * @return {object} A new iterator.
	 * @memberof CIQ.Market
	 * @since 04-2016-08
	 * @example
	    var iter = stxx.market.newIterator(
				{
					'begin': now,
	                'interval': stxx.layout.interval,
	                'periodicity': stxx.layout.periodicity,
	                'timeUnit': stxx.layout.timeUnit,
	                'inZone': stxx.dataZone,
	                'outZone': stxx.displayZone
				}
		);
	 */
      CIQ.Market.prototype.newIterator = function(parms) {
        var _multiple = false
        if (parms.periodicity) {
          _multiple = parms.periodicity
        } else if (parms.multiple) {
          _multiple = parms.multiple
        }
        var _interval = parms.interval
        if (!_interval) {
          _interval = 'minute'
        }
        if (_interval == 'hour') _interval = 60
        if (!_multiple) {
          _multiple = 1
        }
        if (!parms.begin) {
          parms.begin = new Date()
          parms.inZone = null
        }
        if (_interval == parseInt(_interval, 10)) {
          _interval = parseInt(_interval, 10) // in case it was a string, which is allowed in setPeriodicity.

          // if the periodicity<1 then the x-axis might be in seconds (<1/60, msec)
          if (parms.periodicity < 1 / 60) {
            _multiple = _multiple * _interval * 60000
            _interval = 'millisecond'
          } else if (parms.periodicity < 1) {
            _multiple = _multiple * _interval * 60
            _interval = 'second'
          } else {
            _multiple = _multiple * _interval
            _interval = 'minute'
          }
        }
        if (parms.timeUnit) {
          if (parms.timeUnit === 'millisecond') {
            _interval = parms.timeUnit
          } else if (parms.timeUnit === 'second') {
            _interval = parms.timeUnit
          }
        }
        parms.interval = _interval
        parms.multiple = _multiple
        parms.market = this
        return new CIQ.Market.Iterator(parms)
      }

      /**
       * Calculate whether this market was open on some date. This will depend on
       * the data used when creating this market. This function does not take into
       * account intraday data. It simply checks the date to see if the market was
       * open at all on that day. Hours, minutes, seconds are ignored.
       * @param {date} historical_date Javascript date object with timezone in the market time zone.
       * @return {boolean} true if the market was open.
       * @memberof CIQ.Market
       * @since 04-2016-08
       * @private
       */
      CIQ.Market.prototype._wasOpenDaily = function(historical_date) {
        return this._was_open(historical_date, false)
      }

      /**
       * Calculate whether this market was open on some date. This will depend on
       * The data used when creating this market. This function will take into
       * account intraday date that is minutes and seconds. Not only does a market
       * need to be open on the day in question but also within the time specified.
       * @param {date} historical_date Javascript date object with timezone in the market time zone.
       * @return {boolean} true if the market was open.
       * @memberof CIQ.Market
       * @since 04-2016-08
       * @private
       */
      CIQ.Market.prototype._wasOpenIntraDay = function(historical_date) {
        return this._was_open(historical_date, true)
      }

      /**
       * Given some javascript date object calculate whether this market was open.
       * Use _wasOpenDaily or _wasOpenIntraDay instead. As a special case if
       * no market json has been defined this function will always return true.
       * @param {date} historical a valid Javascript date object with timezone in the market time zone.
       * @param {boolean} intra_day true if intraday (will check between open and close times)
       * @return {object} matching segment if any, or null if not
       * @private
       */
      CIQ.Market.prototype._was_open = function(historical, intra_day) {
        this.zopen_hour = 0
        this.zopen_minute = 0
        this.zclose_hour = 0
        this.zclose_minute = 0
        this.zmatch_open = false
        this.zseg_match = null
        if (!this.market_def || !this.rules) {
          // special case, 24h security
          this.zclose_hour = 24
          return true
        }
        var normally_open = false
        var extra_open = false
        var year = historical.getFullYear()
        var month = historical.getMonth() + 1
        var day = historical.getDay()
        var date = historical.getDate()
        var hour = historical.getHours()
        var minutes = historical.getMinutes()
        var seconds = historical.getSeconds()
        var segment
        var midnight_secs = hour * 60 * 60 + minutes * 60 + seconds

        if (typeof intra_day === 'undefined') {
          intra_day = true
        }

        var i
        for (i = 0; i < this.normalHours.length; i++) {
          segment = this.normalHours[i]
          if (!segment.enabled) {
            continue
          }
          normally_open = segment.dayofweek === day
          if (normally_open && intra_day) {
            normally_open =
              midnight_secs >= segment.open && midnight_secs < segment.close
          }
          if (normally_open) {
            if (!intra_day && this.zseg_match) {
              if (
                segment.open_parts.hours > this.zopen_hour ||
                (segment.open_parts.hours == this.zopen_hour &&
                  segment.open_parts.minutes > this.zopen_minute)
              ) {
                continue
              }
            }
            this.zopen_hour = segment.open_parts.hours
            this.zopen_minute = segment.open_parts.minutes
            this.zclose_hour = segment.close_parts.hours
            this.zclose_minute = segment.close_parts.minutes
            this.zmatch_open = midnight_secs === segment.open
            this.zseg_match = segment
            if (intra_day) break
          }
        }

        for (i = 0; i < this.extraHours.length; i++) {
          segment = this.extraHours[i]
          if (!segment.enabled) {
            continue
          }
          if ('*' === segment.year || year === segment.year) {
            if (month === segment.month && date === segment.day) {
              extra_open =
                (!intra_day && segment.open) ||
                (midnight_secs >= segment.open && midnight_secs < segment.close)
              if (!extra_open && this.zseg_match) {
                normally_open = false
                this.zopen_hour = 0
                this.zopen_minute = 0
                this.zclose_hour = 0
                this.zclose_minute = 0
                this.zmatch_open = false
                this.zseg_match = null
              }
              if (extra_open) {
                if (!intra_day && this.zseg_match) {
                  if (
                    segment.open_parts.hours > this.zopen_hour ||
                    (segment.open_parts.hours == this.zopen_hour &&
                      segment.open_parts.minutes > this.zopen_minute)
                  ) {
                    continue
                  }
                }
                this.zopen_hour = segment.open_parts.hours
                this.zopen_minute = segment.open_parts.minutes
                this.zclose_hour = segment.close_parts.hours
                this.zclose_minute = segment.close_parts.minutes
                this.zmatch_open = midnight_secs === segment.open
                this.zseg_match = segment
                if (intra_day) break
              }
            }
          }
        }

        return this.zseg_match
      }

      /**
       * Convenience function for unit testing.
       * @param {date} testDate A date
       * @return {boolean} True if the market was closed on the given date
       * @memberOf  CIQ.Market
       */
      CIQ.Market.prototype._wasClosed = function(testDate) {
        return !this._was_open(testDate, true)
      }

      /**
       * Convenience function for unit testing.
       * @param {date} testDate A date
       * @return {boolean} True if the market was open on the given date
       * @memberOf  CIQ.Market
       */
      CIQ.Market.prototype._wasOpen = function(testDate) {
        return this._was_open(testDate, true)
      }

      /**
       * Get the difference in milliseconds between two time zones. May be positive or
       * negative depending on the time zones. The purpose is to shift the source
       * time zone some number of milliseconds to the target timezone. For example shifting
       * a data feed from UTC to Eastern time. Or shifting Eastern time to Mountain
       * time for display purposes. Note that it is important to pass the source
       * and the target in the correct order. The algorithm does source - target. This
       * will calculate the correct offset positive or negative.
       * @param {date} date A date object. Could be any date object the javascript one
       * or for example the timezone.js one. Must implement getTime() and
       * getTimezoneOffset()
       * @param {string} src_tz_str The source time zone. For example the data feed
       * @param {string} target_tz_str The target time zone for example the market.
       * @return {number} The number of milliseconds difference between the time
       * zones.
       * @memberOf  CIQ.Market
       */
      CIQ.Market.prototype._tzDifferenceMillis = function(
        date,
        src_tz_str,
        target_tz_str
      ) {
        var millis = 0
        var src_date = date
        var target_date = date
        var minutes =
          src_date.getTimezoneOffset() - target_date.getTimezoneOffset()
        millis = minutes * 60 * 1000
        return millis
      }

      /**
       * Static function that reads the json rules in the market definition and
       * creates in memory time segments that are used later to match market dates.
       * @param {object} market An instance of a market.
       * @memberOf  CIQ.Market
       */
      CIQ.Market._createTimeSegments = function(market) {
        var link_adjacent = function(r0_, r1_) {
          if (r0_.close_parts.hours === 24 && r1_.open_parts.hours === 0) {
            if (r1_.open_parts.minutes === 0) {
              if (p_rule.dayofweek === rd.dayofweek - 1) {
                return true
              }
              if (p_rule.dayofweek === 6 && rd.dayofweek === 0) {
                return true
              }
            }
          }
          return false
        }
        var p_rule
        for (var i = 0; i < market.rules.length; i++) {
          var rule = JSON.parse(JSON.stringify(market.rules[i]))
          if (
            typeof rule.open === 'undefined' &&
            typeof rule.close === 'undefined'
          ) {
            rule.open = '00:00'
            rule.close = '00:00'
          }
          if (!rule.hasOwnProperty('name')) {
            rule.name = ''
          }
          try {
            var rd
            if (typeof rule.dayofweek !== 'undefined') {
              rule.year = '*'
              rd = _TimeSegmentS._createDayOfWeekSegment(market, rule)
              if (p_rule) {
                if (p_rule.dayofweek === rd.dayofweek) {
                  //These links are used for finding open and close times
                  //On the same day in multiple sessions
                  p_rule.child_ = rd
                  rd.parent_ = p_rule
                } else {
                  if (link_adjacent(p_rule, rd)) {
                    //These links are used for finding open and close
                    //times for sessions that span days
                    p_rule.adjacent_child = rd
                    rd.adjacent_parent = p_rule
                  }
                }
              }
              p_rule = rd
            } else if (typeof rule.date !== 'undefined') {
              rule.isDayOfWeek = false
              rule.dayofweek = -1
              rd = _TimeSegmentS._createDateTimeSegment(market, rule)
            } else {
              console.log('Error, unknown rule type ' + rule)
            }
            if (market.enabled_by_default) {
              for (var x = 0; x < market.enabled_by_default.length; x++) {
                var n = market.enabled_by_default[x]
                if (rd.name === n) {
                  rd.enabled = true
                  break
                }
              }
            } else {
              //always enabled if no defaults are defined
              //rd.enabled = true;
            }
          } catch (err) {
            console.log('Error, creating market rules ' + err)
          }
        }
      }

      /**
       * Internal static utility methods used to create market time segments.
       * @private
       */
      CIQ.Market._timeSegment = {}
      var _TimeSegmentS = CIQ.Market._timeSegment

      _TimeSegmentS.re_wild_card_iso = /^(\*)-(\d\d)-(\d\d)$/
      _TimeSegmentS.re_regular_iso = /^(\d\d\d\d)-(\d\d)-(\d\d)$/
      _TimeSegmentS.re_split_hours_minutes = /^(\d\d):(\d\d)$/
      _TimeSegmentS.re_split_hour_minutes = /^(\d):(\d\d)$/

      /**
       * Create a hash code for a string. We may move this to 3rd party later if
       * we find a wider need for it. This came from StackOverflow and claims to be
       * the same implementation used by Java.
       * @param {string} str A string.
       * @return {number} A number suitable for
       * @private
       */
      _TimeSegmentS._hashCode = function(str) {
        var hash = 0,
          i,
          chr,
          len
        if (str.length === 0) return hash
        for (i = 0, len = str.length; i < len; i++) {
          chr = str.charCodeAt(i)
          hash = (hash << 5) - hash + chr
          hash |= 0 // Convert to 32bit integer
        }
        return hash
      }

      /**
       * Split the hours and minutes from a json time segment rule.
       * @param {string} str \d\d:\d\d or \d:\d\d
       * @return {object} {minutes:int, hours:int}
       * @private
       */
      _TimeSegmentS._splitHoursMinutes = function(str) {
        var parts = _TimeSegmentS.re_split_hour_minutes.exec(str)
        var ret_val = { hours: NaN, minutes: NaN }
        if (parts === null) {
          parts = _TimeSegmentS.re_split_hours_minutes.exec(str)
          if (parts === null) {
            return ret_val
          }
        }
        ret_val.hours = parseInt(parts[1], 10)
        ret_val.minutes = parseInt(parts[2], 10)
        return ret_val
      }

      /**
       * Create a time segment for some day of the week. This creates a wildcard
       * segment that matches the same weekday in any month and any year.
       * @param {object} market The instance of this market
       * @param {object} rule Represents the data from one rule in the JSON
       * @return {object}
       * configuration.
       * @private
       */
      _TimeSegmentS._createDayOfWeekSegment = function(market, rule) {
        var data = {
          name: rule.name,
          isDayOfWeek: true,
          dayofweek: rule.dayofweek,
          date_str: '*',
          open_parts: _TimeSegmentS._splitHoursMinutes(rule.open),
          close_parts: _TimeSegmentS._splitHoursMinutes(rule.close),
          open: _TimeSegmentS._secSinceMidnight(market, rule.open, true),
          close: _TimeSegmentS._secSinceMidnight(market, rule.close, false),
          child_: false,
          parent_: false,
          adjacent_child: false,
          adjacent_parent: false,
          enabled: false,
        }
        if (data.name === '') {
          data.enabled = true
        }
        data.hash_code = this._hashCode((data.open + data.close).toString())
        market.normalHours.push(data)
        return data
      }

      /**
       * Create a time segment for a specific date and time. This can also create
       * a wild card segment that matches any year with a specific day and specific
       * month. For example *-12-25 to match all Christmas days. It can also build
       * any specific year month day open close time that will only match that
       * specific range.
       * @param {object} market an instance of a market
       * @param {object} rule a single rule from a market definition
       * @return {object|undefined} Undefined if this function works on the market object.
       * @private
       */
      _TimeSegmentS._createDateTimeSegment = function(market, rule) {
        var pieces = this.re_regular_iso.exec(rule.date)
        var year
        if (pieces === null) {
          pieces = this.re_wild_card_iso.exec(rule.date)
          if (pieces === null) {
            console.log('Warning: invalid date format on rule -> ' + rule.date)
            return
          }
          year = '*' //all years
        } else {
          year = parseInt(pieces[1], 10)
        }
        var data = {
          name: rule.name,
          isDayOfWeek: false,
          dayofweek: -1,
          year: year,
          month: parseInt(pieces[2], 10),
          day: parseInt(pieces[3], 10),
          date_str: rule.date,
          open_parts: _TimeSegmentS._splitHoursMinutes(rule.open),
          close_parts: _TimeSegmentS._splitHoursMinutes(rule.close),
          open: _TimeSegmentS._secSinceMidnight(market, rule.open, true),
          close: _TimeSegmentS._secSinceMidnight(market, rule.close, false),
          enabled: false,
        }
        if (data.name === '') {
          data.enabled = true
        }
        data.hash_key = this._hashCode(data.date_str + data.open + data.close)
        market.extraHours.push(data)
        return data
      }

      /**
       * Calculate the seconds since midnight for some time string. These time strings
       * come from the market definition. These are intended to be open and close
       * times.
       * @param {object} market An instance of a market
       * @param {string} time_str A time string like this "\d\d:\d\d"
       * @param {boolean} open_time If true the time is used for opening a market
       * @return {number} Seconds since midnight
       * otherwise the time is used for closing a market. This is so that we can
       * handle 00:00 and 24:00.
       * @private
       */
      _TimeSegmentS._secSinceMidnight = function(market, time_str, open_time) {
        var parts = time_str.split(':')
        var hours = parseInt(parts[0], 10)
        var minutes = parseInt(parts[1], 10)
        var seconds = hours * 60 * 60 + minutes * 60

        if (!open_time) {
          if (hours === 24) {
            seconds = hours * 60 * 60 + 1
          }
        }
        return seconds
      }

      /**
       * Converts from the given timezone into the market's native time zone
       * If no market zone is present, the date will be returned unchanged.
       * @param  {date} dt JavaScript Date
       * @param  {string} [tz] timezoneJS timezone, or null to indicate browser localtime/UTC (dataZone)
       * @return {date}    A JavaScript Date offset by the timezone change
       * @memberOf  CIQ.Market
       */
      CIQ.Market.prototype._convertToMarketTZ = function(dt, tz) {
        if (!this.market_tz) return dt
        var tzdt
        if (tz) {
          tzdt = new this.tz_lib(
            dt.getFullYear(),
            dt.getMonth(),
            dt.getDate(),
            dt.getHours(),
            dt.getMinutes(),
            dt.getSeconds(),
            dt.getMilliseconds(),
            tz
          )
        } else {
          tzdt = new this.tz_lib(
            dt.getFullYear(),
            dt.getMonth(),
            dt.getDate(),
            dt.getHours(),
            dt.getMinutes(),
            dt.getSeconds(),
            dt.getMilliseconds()
          )
        }
        if (tzdt.setTimezone) tzdt.setTimezone(this.market_tz)
        return new Date(
          tzdt.getFullYear(),
          tzdt.getMonth(),
          tzdt.getDate(),
          tzdt.getHours(),
          tzdt.getMinutes(),
          tzdt.getSeconds(),
          tzdt.getMilliseconds()
        )
      }

      /**
       * Converts to the given timezone from the market's native time zone.
       * If no market zone is present, the date will be returned un changed.
       * @param  {date} dt JavaScript Date
       * @param  {string} [tz] timezoneJS timezone, or null to indicate browser localtime/UTC (displayZone)
       * @return {date}    A JavaScript Date offset by the timezone change
       * @memberOf  CIQ.Market
       */
      CIQ.Market.prototype._convertFromMarketTZ = function(dt, tz) {
        if (!this.market_tz) return dt
        var tzdt = new this.tz_lib(
          dt.getFullYear(),
          dt.getMonth(),
          dt.getDate(),
          dt.getHours(),
          dt.getMinutes(),
          dt.getSeconds(),
          dt.getMilliseconds(),
          this.market_tz
        )
        if (tz) {
          if (tzdt.setTimezone) tzdt.setTimezone(tz)
        } else {
          return new Date(tzdt.getTime())
        }
        return new Date(
          tzdt.getFullYear(),
          tzdt.getMonth(),
          tzdt.getDate(),
          tzdt.getHours(),
          tzdt.getMinutes(),
          tzdt.getSeconds(),
          tzdt.getMilliseconds()
        )
      }

      /**
	 * Builds an iterator instance and returns it to the requesting market when {@link CIQ.Market#newIterator} is called. Do not call this constructor directly.
	 *
	 * @name CIQ.Market.Iterator
	 * @param {object} parms
	 * @param {object} parms.begin A dataset element from {@link CIQ.Chart.dataSet}
	 * @param {CIQ.Market} parms.market An instane of {@link CIQ.Market}
	 * @param {object} parms.periodicity A valid periodicity as require by {@link CIQ.ChartEngine#setPeriodicity}
	 * @param {string} parms.interval Time interval: millisecond, second, minute, hour, day, week, or month.
	 * @param {object} parms.multiple How many jumps to make on each interval loop.
	 * @param {string} parms.inZone Datazone to translate from
	 * @param {string} parms.outZone Datazone to translate to
	 * @constructor
	 * @since 04-2016-08
	 * @example
	    var market24=new CIQ.Market();
	    var iter_parms = {
	        'begin': stxx.chart.dataSet[stxx.chart.dataSet.length-1].DT,	// last item on the dataset
	        'interval': stxx.layout.interval,
	        'periodicity': stxx.layout.periodicity,
	        'timeUnit': stxx.layout.timeUnit,
	        'inZone': stxx.dataZone,
	        'outZone': stxx.dataZone
	    };
	    var iter = market24.newIterator(iter_parms);
	    var next = iter.next();
	 *
	 */
      CIQ.Market.Iterator = function(parms) {
        this.market = parms.market
        this.begin = parms.begin
        this.interval = parms.interval
        this.multiple = parms.multiple
        this.inZone = parms.inZone
        this.outZone = parms.outZone
        this.clock = new CIQ.Market.Iterator._Clock(
          parms.market,
          parms.interval,
          parms.multiple
        )
        this.intraDay = this.clock.intra_day
        if (this.intraDay)
          this.begin = this.market._convertToMarketTZ(this.begin, parms.inZone)
        this.clock._setStart(this.begin)
        this.clock.minutes_aligned = false
      }

      /**
       * Returns the current date of the iterator without moving forwards or backwards.
       * Takes into account display zone settings.
       * @return {date} The current date of the iterator.
       * @memberof CIQ.Market.Iterator
       * @since 04-2016-08
       * @example
       * iteratorDate = iter.date();
       */
      CIQ.Market.Iterator.prototype.date = function() {
        return this.clock._date()
      }

      /**
       * Calculate the number of ticks from begin date to end date taking into account
       * market open, close, and holidays.
       * If the end date is older than the begin date,it will work backward into the past.
       * If the end date is newer than the begin date,it will work forward into the future.
       * Note that the begin date is set when this
       * instance of the iterator is created and one should NOT call `previous` or `next`
       * before calling this function, or the 'begin' pointer will change.
       * @param {object} parms An object containing the following properties:
       * @param {date} parms.end An end date. Will be assumed to be `inZone` if one set.
       * @param {number} [parms.sample_size] Default is 25. Maximum amount of time
       * (in milliseconds) taken to count ticks. If sample size is
       * reached before the number of ticks is found the number of ticks will be
       * estimated mathematically. The bigger the sample size couple with the
       * distance between begin date and end date affect how precise the return value
       * is.
       * @param {number} [parms.sample_rate] Default is 1000. Maximum number of ticks to evaluate before checking `parms.sample_size`.
       * @return {number} The number of ticks between begin and end.
       * @memberof CIQ.Market.Iterator
       * @since 04-2016-08
       * @example
       * // find out how many ticks in the past a date is from the beginning of the dataSet
       * // (assumes the target date is older than the first dataSet item)
       *	var iter = this.standardMarketIterator(chart.dataSet[0].DT);
       *	var ticks=iter.futureTick({someRandomDate});
       */
      CIQ.Market.Iterator.prototype.futureTick = function(parms) {
        this.clock.skip = 1
        var ticks = 0
        var end
        if (this.intraDay)
          end = this.market._convertToMarketTZ(parms.end, this.inZone).getTime()
        else end = parms.end.getTime()
        var begin = this.clock.ctime
        if (end === begin) {
          return ticks
        }
        var sample_size = 2 //milliseconds // May not be necessary at all. Looks accurate whenever past 1,000 ticks into future
        var sample_rate = 1000 //iterations
        var sample_ctr = 0
        if (parms.sample_size) {
          sample_size = parms.sample_size
        }
        var start = new Date().getTime()
        var now
        var ave
        if (end > begin) {
          this.clock.forward = true
          while (this.clock.ctime < end) {
            ticks += 1
            sample_ctr += 1
            this.clock._findNext()
            if (sample_ctr === sample_rate) {
              sample_ctr = 0
              now = new Date().getTime()
              if (now - start >= sample_size) {
                ave = (this.clock.ctime - begin) / ticks
                ticks = Math.floor((end - begin) / ave)
                break
              }
            }
          }
          if (this.clock.ctime > end) {
            // if not an exact match, we are one tick too far in the future by now.
            // Go back one to return the tick that contains this time in its range. Rather than the next tick.
            ticks--
          }
        } else {
          this.clock.forward = false
          while (this.clock.ctime > end) {
            ticks += 1
            sample_ctr += 1
            this.clock._findPrevious()
            if (sample_ctr === sample_rate) {
              sample_ctr = 0
              now = new Date().getTime()
              if (now - start >= sample_size) {
                ave = (begin - this.clock.ctime) / ticks
                ticks = Math.floor((begin - end) / ave)
                break
              }
            }
          }
        }
        return ticks
      }

      /**
       * Checks if market is aligned and if iterator is intraday (daily intervals always align)
       * @return {boolean} true if this market is hour aligned.
       * @memberof CIQ.Market.Iterator
       * @since 04-2016-08
       */
      CIQ.Market.Iterator.prototype.isHourAligned = function() {
        return !this.intraDay || this.market.isHourAligned()
      }

      /**
       * Check and see if this Market is open now.
       * @return {boolean} true or false
       * @memberof CIQ.Market.Iterator
       * @since 04-2016-08
       */
      CIQ.Market.Iterator.prototype.isOpen = function() {
        return this.market.isOpen()
      }

      /**
       * Move the iterator one interval forward
       * @param {number} [skip] Default 1. Jump forward skip * periodicity at once.
       * @return {date} Next date in iterator `outZone`.
       * @alias next
       * @memberof CIQ.Market.Iterator
       * @since 04-2016-08
       * @example
       * now = iter.next();
       */
      CIQ.Market.Iterator.prototype.next = function(skip) {
        this.clock.skip = 1
        if (skip) {
          this.clock.skip = skip
        }
        this.clock.forward = true
        for (var i = 0; i < this.clock.skip; i++)
          this.begin = this.clock._findNext()
        if (this.intraDay || this.market.convertOnDaily) {
          return this.market._convertFromMarketTZ(
            this.clock.display_date,
            this.outZone
          )
        }
        return this.clock.display_date
      }

      /**
       * Does not move the iterator. Takes into account display zone settings.
       * Note. This is a convenience function for debugging or whatever else, but
       * should not be called in the draw loop in production.
       * @return {string} The current date of the iterator as a string.
       * @memberof CIQ.Market.Iterator
       * @since 04-2016-08
       * @private
       */
      CIQ.Market.Iterator.prototype.peek = function() {
        return this.clock._peek()
      }

      /**
       * Move the iterator one interval backward
       * @param {number} skip Default is one. Move this many multiples of interval.
       * @return {date} Previous date in iterator `outZone`.
       * @alias previous
       * @memberof CIQ.Market.Iterator
       * @since 04-2016-08
       * @example
       * now = iter.previous();
       */
      CIQ.Market.Iterator.prototype.previous = function(skip) {
        this.clock.skip = 1
        if (skip) {
          this.clock.skip = skip
        }
        this.clock.forward = false
        for (var i = 0; i < this.clock.skip; i++)
          this.begin = this.clock._findPrevious()
        if (this.intraDay || this.market.convertOnDaily) {
          return this.market._convertFromMarketTZ(
            this.clock.display_date,
            this.outZone
          )
        }
        return this.clock.display_date
      }

      /**
       * Internal object that simulates a clock that ticks forward and backwards
       * at different intervals. Used internally by the iterator and not intended
       * to be used outside of the context of a Market.
       * @param {object} market An instance of market.
       * @param {string} interval millisecond, second, minute, hour, day, week or month
       * @param {number} multiple Move in multiple of intervals.
       * @private
       */
      CIQ.Market.Iterator._Clock = function(market, interval, multiple) {
        // rationalize rolled up intervals for better performance
        if (multiple % 60 === 0 && interval === 'second') {
          interval = 'minute'
          multiple = multiple / 60
        }

        this.market = market
        this.interval = interval
        this.multiple = multiple
        this.intra_day = false
        this.intervals = []
        this.max_iters = 10080 //max minutes to check for rules. (one week);

        var tick_time = DAY_MILLIS,
          findNext = this._dayImpl
        if (interval === 'millisecond') {
          findNext = this._millisImpl
          tick_time = 1
        } else if (interval === 'second') {
          findNext = this._secondImpl
          tick_time = 1000
        } else if (interval === 'minute') {
          findNext = this._minuteImpl
          tick_time = 60000
        } else if (interval === 'hour') {
          findNext = this._hourImpl
          tick_time = HOUR_MILLIS
        } else if (interval === 'day') {
          findNext = this._dayImpl
          tick_time = DAY_MILLIS
        } else if (interval === 'week') {
          findNext = this._weekImpl
          tick_time = DAY_MILLIS * 7
        } else if (interval === 'month') {
          findNext = this._monthImpl
          tick_time = DAY_MILLIS * 30
        } else {
          console.log(
            'Periodicity ERROR: "' +
              interval +
              '" is not a valid interval. Please see setPeriodicity() for details.'
          )
        }
        this.tick_time = tick_time * multiple
        this.intra_day = this.tick_time < DAY_MILLIS
        this._findPrevious = this._findNext = findNext
      }

      //Save me some carpal tunnel please.
      var _ClockP = CIQ.Market.Iterator._Clock.prototype

      /**
       * Calculate the amount of minutes in a given time span.
       * This assumes hours are 24 hour format.
       *
       * NOTE! Does not know how to jump a 24 hour period, assumes that
       * oHour is always less than cHour on the same day.
       *
       * This could be done with two dates instead and remove the limitations. Not
       * sure if that is necessary at this point. We don't actually have two date
       * objects at the point that we need this number. It would take some doing to
       * figure out the date objects that would be needed.
       * @param {number} oHour The opening hour
       * @param {number} oMin The opening minute
       * @param {number} cHour The closing hour
       * @param {number} cMin The closing minute
       * @return {number} Amount of minutes in a given time span.
       * @private
       */
      _ClockP._total_minutes = function(oHour, oMin, cHour, cMin) {
        //the parens are important in this case
        return (cHour - oHour) * 60 - oMin + cMin
      }

      /**
       * Create an array of minutes from the open minute to the close minute at
       * some periodicity. This array will run the entire time of the last segment
       * time segment matched.
       * @return {array} Periods
       * @private
       */
      _ClockP._alignMinutes = function() {
        //TODO maybe need some caching here.
        if (this.market.zopen_minute === undefined) {
          return []
        }
        var o_min = this.market.zopen_minute
        if (this.market.isHourAligned() && this.multiple % 60 === 0) o_min = 0
        var total_minutes = this._total_minutes(
          this.market.zopen_hour,
          o_min,
          this.market.zclose_hour,
          this.market.zclose_minute
        )
        var periods = []
        var next_minute = 0
        while (next_minute < total_minutes) {
          periods.push(o_min + next_minute)
          next_minute += this.multiple
        }
        return periods
      }

      /**
       * Create an array of second boundaries. This only needs to be done once
       * per clock instance.
       * @param {number} max The high end of the range before wrapping back to zero.
       * @return {array} Periods
       * Example for seconds this would be 60.
       * @private
       */
      _ClockP._alignBaseZero = function(max) {
        var base = 0
        var periods = [base]
        while (true) {
          base += this.multiple
          if (base >= max) {
            break
          }
          periods.push(base)
        }
        return periods
      }

      /**
       * Turn this instance of the clock into a date object at the current
       * date time.
       * @return {date} A new Date object.
       * @private
       */
      _ClockP._date = function() {
        var t = Math.round(this.ctime)
        var current_date = new Date(t)

        if (this.intra_day) {
          this.display_date = new Date(t + this.shift_millis)
        } else {
          this.display_date = current_date
        }

        return current_date
      }

      /**
       * Find the boundary for minutes, seconds or milliseconds.
       * @param {array} periods A pre-calculated list of boundaries.
       * @param {number} search_for Any number to align.
       * @return {number} one of the boundaries in the array.
       * @private
       */
      _ClockP._alignToBoundary = function(periods, search_for) {
        var low = 0
        var high = 0
        var result = search_for

        for (var ctr = 0; ctr < periods.length - 1; ctr++) {
          low = periods[ctr]
          high = periods[ctr + 1]
          if (search_for === low || search_for === high) {
            break //already aligned;
          }
          if (search_for > low && search_for < high) {
            result = low
            break
          } else if (ctr + 1 === periods.length - 1) {
            //wrap around gap
            result = high
          }
        }
        return result
      }

      /**
       * Convenience for debugging.
       * @return {string} Current market date as a string
       * @private
       */
      _ClockP._peek = function() {
        return this._date().toString()
      }

      /**
       * When searching for open days look in hour increments.
       * Inverted.
       * @private
       */
      _ClockP._seekHr = function() {
        if (this.forward) {
          this.ctime -= HOUR_MILLIS
        } else {
          this.ctime += HOUR_MILLIS
        }
      }

      /**
       * Set this instance of the iterator clock to some date. Calls to next or
       * previous will move the clock some interval from this point in time.
       * @param {date} date Any javascript date.
       * @private
       */
      _ClockP._setStart = function(date) {
        var millis = this.market._tzDifferenceMillis(date)
        var shift_date = new Date(date.getTime() + millis)
        this.shift_millis = millis
        this.ctime = shift_date.getTime()
        // Terry override timezone shift
        this.shift_millis = 0
        this.ctime = date.getTime()
      }

      /**
       * Regular clock move
       * @private
       */
      _ClockP._tickTock = function() {
        if (this.forward) {
          //this.ctime += (this.tick_time * this.skip);
          this.ctime += this.tick_time
        } else {
          //this.ctime -= (this.tick_time * this.skip);
          this.ctime -= this.tick_time
        }
      }

      /**
       * Inverted clock move
       * @private
       */
      _ClockP._tockTick = function() {
        if (this.forward) {
          //this.ctime -= (this.tick_time * this.skip);
          this.ctime -= this.tick_time
        } else {
          //this.ctime += (this.tick_time * this.skip);
          this.ctime += this.tick_time
        }
      }

      /**
       * Move a day at a time. Useful for finding the first open day
       * of a week or month. Always moves forward.
       * @private
       */
      _ClockP._tickTock24 = function() {
        this.ctime += DAY_MILLIS
      }

      /**
       * Move a day at a time inverted. Useful for finding Sunday when
       * moving by weeks. Always moves backwards.
       * @private
       */
      _ClockP._tockTick24 = function() {
        this.ctime -= DAY_MILLIS
      }

      /**
       * Wind the clock to the next open market time. If the market is already open
       * then don't move. Break out of the loop after max_iters regardless.
       * @param {function} was_open Intraday or daily function to see if the market
       * was open.
       * @param {function} wind _tockTick (inverted) or _tickTock (regular)
       * @return {boolean} True if the clock was moved
       * @private
       */
      _ClockP._windMaybe = function(was_open, wind) {
        var max = 0
        var working_date = new Date(this.ctime)
        var moved = false
        while (!was_open.call(this.market, working_date)) {
          wind.call(this)
          moved = true
          working_date = new Date(this.ctime)
          max += 1
          if (max > this.max_iters) {
            var m = 'Warning! max iterations (' + this.max_iters
            m += ') reached with no rule match.'
            console.log(m)
            break
          }
        }
        return moved
      }

      /**
       * Move the clock some number of milliseconds
       * @return {date} Current market date
       * @private
       */
      _ClockP._millisImpl = function() {
        var justAligned = false
        if (!this.mperiods_aligned) {
          var periods = this._alignBaseZero(1000)
          var current_date = new Date(this.ctime)
          var current_millis = current_date.getMilliseconds()
          current_millis = this._alignToBoundary(periods, current_millis)
          current_date.setMilliseconds(0)
          this.ctime = current_date.getTime() + current_millis // this allows for fractional millis
          this.mperiods_aligned = true
          justAligned = true
        }
        // handle market closes
        var oldMinute = this._date().getMinutes()
        this._tickTock()
        var newMinute = this._date().getMinutes()
        if (
          (justAligned || oldMinute != newMinute) &&
          !this.market._wasOpenIntraDay(this._date())
        ) {
          var tickTime = this.tick_time
          this.tick_time = 60000
          var multiple = this.multiple
          this.multiple = 1
          this._minuteImpl()
          this.tick_time = tickTime
          this.multiple = multiple
        }
        return this._date()
      }

      /**
       * Move the clock some number of seconds
       * @return {date} Current market date
       * @private
       */
      _ClockP._secondImpl = function() {
        var justAligned = false
        if (!this.speriod_aligned) {
          var periods = this._alignBaseZero(60)
          var current_date = new Date(this.ctime)
          var current_second = current_date.getSeconds()
          current_second = this._alignToBoundary(periods, current_second)
          current_date.setSeconds(current_second)
          current_date.setMilliseconds(0)
          this.ctime = current_date.getTime()
          this.speriod_aligned = true
          justAligned = true
        }
        // handle market closes
        var oldMinute = this._date().getMinutes()
        this._tickTock()
        var newMinute = this._date().getMinutes()
        if (
          (justAligned || oldMinute != newMinute) &&
          !this.market._wasOpenIntraDay(this._date())
        ) {
          var tickTime = this.tick_time
          this.tick_time = 60000
          var multiple = this.multiple
          this.multiple = 1
          this._minuteImpl()
          this.tick_time = tickTime
          this.multiple = multiple
        }
        return this._date()
      }

      /**
       * Move the clock some number of minutes. Takes into account market start time
       * and could change alignment each time it is called.
       * @return {date}
       * @private
       */
      _ClockP._minuteImpl = function() {
        var closed = this._windMaybe(
          this.market._wasOpenIntraDay,
          this._tockTick
        )
        var current_date = new Date(this.ctime)
        var tzOffset = current_date.getTimezoneOffset()
        var current_minute = current_date.getMinutes()
        var current_hour = current_date.getHours()
        var periods = this._alignMinutes() //takes into account market start time
        var boundary_min =
          this._total_minutes(
            this.market.zopen_hour,
            this.market.zopen_minute,
            current_hour,
            current_minute
          ) + this.market.zopen_minute
        if (closed) {
          if (this.forward) {
            boundary_min = periods[periods.length - 1]
          } else {
            boundary_min = periods[0]
          }
        } else {
          boundary_min = this._alignToBoundary(periods, boundary_min)
        }
        current_hour = Math.floor(boundary_min / 60) + this.market.zopen_hour
        current_date.setHours(current_hour, boundary_min % 60, 0, 0)
        var offsetDiff = current_date.getTimezoneOffset() - tzOffset
        if (
          (this.forward && offsetDiff < 0) ||
          (!this.forward && offsetDiff > 0)
        ) {
          //crossed a fallback timezone boundary
          current_date.setTime(current_date.getTime() - offsetDiff * 60000)
        }
        this.ctime = current_date.getTime() //boundary aligned
        this._tickTock() //move once
        var current_segment = this.market.zseg_match
        var alignToHour = this.market.hour_aligned && this.multiple % 60 === 0
        if (
          this._windMaybe(this.market._wasOpenIntraDay, this._tickTock) ||
          (!alignToHour && current_segment != this.market.zseg_match)
        ) {
          current_date = new Date(this.ctime)
          if (this.forward) {
            current_date.setMinutes(this.market.zopen_minute)
            current_date.setHours(this.market.zopen_hour)
          } else {
            periods = this._alignMinutes()
            var last_boundary = periods[periods.length - 1]
            current_date.setMinutes(last_boundary % 60)
            current_date.setHours(
              Math.floor(last_boundary / 60) + this.market.zopen_hour
            )
          }
          this.ctime = current_date.getTime()
        }
        return this._date()
      }

      /**
       * Move the clock some number of hours.
       * @return {date}
       * @private
       */
      _ClockP._hourImpl = function() {
        this._windMaybe(this.market._wasOpenIntraDay, this._tockTick)
        var current_time = new Date(this.ctime)
        if (this.market.isHourAligned()) {
          current_time.setMinutes(0)
        } else {
          current_time.setMinutes(this.market.zopen_minute)
        }
        current_time.setSeconds(0)
        current_time.setMilliseconds(0)
        this.ctime = current_time.getTime() //boundary aligned
        this._tickTock() //move once
        var current_segment = this.market.zseg_match
        if (
          this._windMaybe(this.market._wasOpenIntraDay, this._tickTock) ||
          (!this.market.hour_aligned &&
            current_segment != this.market.zseg_match)
        ) {
          current_date = new Date(this.ctime)
          if (this.forward) {
            current_date.setMinutes(this.market.zopen_minute)
            current_date.setHours(this.market.zopen_hour)
          } else {
            periods = this._alignMinutes()
            var last_boundary = periods[periods.length - 1]
            current_date.setMinutes(last_boundary % 60)
            current_date.setHours(
              Math.floor(last_boundary / 60) + this.market.zopen_hour
            )
          }
          this.ctime = current_date.getTime()
        }
        return this._date()
      }

      /**
       * Move the clock some number of days.
       * @return {date}
       * @private
       */
      _ClockP._dayImpl = function() {
        this._windMaybe(this.market._wasOpenDaily, this._seekHr)
        var current_date = new Date(this.ctime) //closest open day
        current_date.setHours(12, 0, 0, 0)
        this.ctime = current_date.getTime() //boundary aligned
        var ctr = 0
        while (ctr < this.multiple) {
          if (this.forward) {
            this._tickTock24()
          } else {
            this._tockTick24()
          }
          if (!this.market._wasOpenDaily(this._date())) {
            continue
          }
          ctr += 1
        }
        current_date = new Date(this.ctime)
        current_date.setHours(0)
        this.ctime = current_date.getTime() //boundary aligned
        return this._date()
      }

      /**
       * Move the clock some number of weeks.
       * @return {date}
       * @private
       */
      _ClockP._weekImpl = function() {
        var current_date = new Date(this.ctime)
        current_date.setHours(12) // Stay away from DST danger zone, so we know we only go back one date each tocktick
        this.ctime = current_date.getTime()
        this._tickTock() // move once

        //Move to Sunday
        current_date = new Date(this.ctime)
        while (current_date.getDay() !== 0) {
          this._tockTick24()
          current_date = new Date(this.ctime)
        }

        //now align to first open day of week.
        this._windMaybe(this.market._wasOpenDaily, this._tickTock24)
        current_date = new Date(this.ctime)
        current_date.setHours(0, 0, 0, 0)
        this.ctime = current_date.getTime() //boundary aligned;
        return this._date()
      }

      /**
       * Move the clock some number of months
       * @return {date}
       * @private
       */
      _ClockP._monthImpl = function() {
        //Allow some room to account for different lengths of months.
        var current_date = new Date(this.ctime)
        current_date.setDate(15) // Stay away from month boundaries so DST doesn't foil us
        this.ctime = current_date.getTime()

        this._tickTock() // move once
        current_date = new Date(this.ctime)
        //Now re align back to the first day of the month
        current_date.setDate(1)
        current_date.setHours(12) // Stay away from DST danger zone
        this.ctime = current_date.getTime()

        //Now find the first open day of month
        this._windMaybe(this.market._wasOpenDaily, this._tickTock24)
        current_date = new Date(this.ctime)
        current_date.setHours(0, 0, 0, 0)
        this.ctime = current_date.getTime() //boundary aligned;
        return this._date()
      }

      /**
       * Search forward for the next market open
       * @param {date} date Some begin date.
       * @param {number} skip The number of intervals to move. Defaults
       * to one.
       * @return {date} A new date that has been set to the previous open of the
       * market.
       * @private
       */
      _ClockP._findNext = null

      /**
       * Search backward for the next market open
       * @param {date} date Some begin date.
       * @param {number} skip The number of intervals to move. Defaults
       * to one.
       * @return {date} A new date that has been set to the previous open of the
       * market.
       * @private
       */
      _ClockP._findPrevious = null

      return _exports
    }

  var __polyfills_ =
    //-------------------------------------------------------------------------------------------
    // Copyright 2012-2017 by ChartIQ, Inc.
    // All rights reserved
    //-------------------------------------------------------------------------------------------
    function() {}

  var __timezone_ =
    //-------------------------------------------------------------------------------------------
    // Copyright 2012-2017 by ChartIQ, Inc.
    // All rights reserved
    //-------------------------------------------------------------------------------------------
    function(_exports) {
      var CIQ = _exports.CIQ

      /**
       * The comprehensive list of timezones can be overwhelming. This is a reduced list that provides
       * what is necessary for the [sample UI]{@link WebComponents.cq-theme-dialog}.
       *
       * To see the current list and format, open your browser console and type `CIQ.timeZoneMap`.
       *
       * If you need to support more timezones, a complete list can be downloaded from [here](http://download.chartiq.com/timeZones/timezoneDataObject.txt).
       *
       * This file is large, so add timezones with discretion.
       * The following code snippet demonstrates how to do this. (You can also just add synonyms this way as well).
       * In order to save space, you may want to cherry pick the zones that you will need, and then add them in your initialization code.
       * ```
       *	var myAdditionalZones = {
       *	 "zones" : {
       *	  "America/Toronto": [
       *	   [ 300, "Canada", "E%sT", null ]
       *	  ]
       *	 },
       *	    // to add all timezones, "rules" can simply reference the current rules in timeZoneDataObject.txt.
       *	 "rules" : {
       *	  "Canada" : [
       *	   [ 2007, "max", "-", "Mar", "Sun>=8", [ 2, 0, 0, null ], 60, "D" ],
       *	   [ 2007, "max", "-", "Nov", "Sun>=1", [ 2, 0, 0, null ], 0, "S" ] ]
       *	 }
       *	}
       *
       *	if(timezoneJS) timezoneJS.timezone.loadZoneDataFromObject(myAdditionalZones);
       *  ```
       * Lastly, be sure to also add the title for them to the `CIQ.timeZoneMap` object to keep the list and the settings in sync:
       *  ```
       *  CIQ.timeZoneMap["(UTC-05:00) Toronto"]="America/Toronto";
       *  ```
       *
       * See {@link CIQ.ChartEngine#setTimeZone} for further instructions on how to set the different timezones on the chart.
       *
       * @type {object}
       * @memberof CIQ
       */
      CIQ.timeZoneMap = {
        '(UTC-11:00) American Samoa, Midway Island': 'Pacific/Pago_Pago',
        '(UTC-10:00) Hawaii': 'Pacific/Honolulu',
        '(UTC-09:00) Alaska': 'America/Juneau',
        '(UTC-08:00) Pacific Time (US and Canada)': 'America/Los_Angeles',
        '(UTC-08:00) Tijuana': 'America/Tijuana',
        '(UTC-07:00) Arizona': 'America/Phoenix',
        '(UTC-07:00) Chihuahua, Mazatlan': 'America/Chihuahua',
        '(UTC-07:00) Mountain Time (US and Canada)': 'America/Denver',
        '(UTC-06:00) Central America': 'America/Costa_Rica',
        '(UTC-06:00) Central Time (US and Canada)': 'America/Chicago',
        '(UTC-06:00) Guadalajara, Mexico City, Monterrey':
          'America/Mexico_City',
        '(UTC-06:00) Saskatchewan': 'America/Regina',
        '(UTC-05:00) Bogota, Lima, Quito, Rio Branco': 'America/Bogota',
        '(UTC-05:00) Eastern Time (US and Canada)': 'America/New_York',
        '(UTC-05:00) Indiana (East)': 'America/Indiana/Indianapolis',
        '(UTC-04:00) Asuncion': 'America/Asuncion',
        '(UTC-04:00) Santiago': 'America/Santiago',
        '(UTC-04:00) Caracas': 'America/Caracas',
        '(UTC-04:00) Atlantic Time (Canada)': 'America/Halifax',
        '(UTC-04:00) Georgetown, La Paz, Manaus, San Juan':
          'America/Puerto_Rico',
        '(UTC-03:30) Newfoundland and Labrador': 'America/St_Johns',
        '(UTC-03:00) Buenos Aires': 'America/Argentina/Buenos_Aires',
        '(UTC-03:00) Punta Arenas': 'America/Punta_Arenas',
        '(UTC-03:00) Montevideo': 'America/Montevideo',
        '(UTC-03:00) Sao Paulo': 'America/Sao_Paulo',
        '(UTC-02:00) Mid-Atlantic': 'Atlantic/South_Georgia',
        '(UTC-01:00) Azores': 'Atlantic/Azores',
        '(UTC-01:00) Cape Verde Islands': 'Atlantic/Cape_Verde',
        '(UTC) Greenwich Mean Time, Reykjavik': 'UTC',
        '(UTC) Casablanca': 'Africa/Casablanca',
        '(UTC) Dublin, Lisbon, London': 'Europe/London',
        '(UTC+01:00) Algiers, Tunis': 'Africa/Tunis',
        '(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna':
          'Europe/Amsterdam',
        '(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague':
          'Europe/Belgrade',
        '(UTC+01:00) Brussels, Copenhagen, Madrid, Paris': 'Europe/Brussels',
        '(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb': 'Europe/Sarajevo',
        '(UTC+02:00) Kaliningrad': 'Europe/Kaliningrad',
        '(UTC+02:00) Athens, Bucharest': 'Europe/Bucharest',
        '(UTC+02:00) Cairo': 'Africa/Cairo',
        '(UTC+02:00) Harare, Johannesburg': 'Africa/Johannesburg',
        '(UTC+02:00) Helsinki, Kiev, Riga, Sofia, Tallinn, Vilnius':
          'Europe/Helsinki',
        '(UTC+02:00) Cyprus': 'Asia/Nicosia',
        '(UTC+02:00) Jerusalem': 'Asia/Jerusalem',
        '(UTC+03:00) Istanbul': 'Europe/Istanbul',
        '(UTC+03:00) Baghdad, Kuwait, Qatar, Riyadh': 'Asia/Riyadh',
        '(UTC+03:00) Minsk, Moscow, Kirov, Volgograd': 'Europe/Moscow',
        '(UTC+03:00) Simferopol': 'Europe/Simferopol',
        '(UTC+03:00) Nairobi': 'Africa/Nairobi',
        '(UTC+03:30) Tehran': 'Asia/Tehran',
        '(UTC+04:00) Baku': 'Asia/Baku',
        '(UTC+04:00) Dubai, Muscat': 'Asia/Dubai',
        '(UTC+04:00) Astrakhan, Samara, Saratov, Ulyanovsk': 'Europe/Samara',
        '(UTC+04:30) Kabul': 'Asia/Kabul',
        '(UTC+05:00) Karachi, Tashkent': 'Asia/Karachi',
        '(UTC+05:00) Yekaterinburg': 'Asia/Yekaterinburg',
        '(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi': 'Asia/Kolkata',
        '(UTC+05:45) Kathmandu': 'Asia/Kathmandu',
        '(UTC+06:00) Almaty': 'Asia/Almaty',
        '(UTC+06:00) Omsk': 'Asia/Omsk',
        '(UTC+06:00) Astana, Dhaka': 'Asia/Dhaka',
        '(UTC+06:30) Yangon': 'Asia/Yangon',
        '(UTC+07:00) Bangkok, Jakarta, Vietnam': 'Asia/Bangkok',
        '(UTC+07:00) Hovd': 'Asia/Hovd',
        '(UTC+07:00) Krasnoyarsk': 'Asia/Krasnoyarsk',
        '(UTC+07:00) Novokuznetsk': 'Asia/Novokuznetsk',
        '(UTC+07:00) Barnaul, Novosibirsk, Tomsk': 'Asia/Novosibirsk',
        '(UTC+08:00) Beijing, Chongqing, Hong Kong SAR': 'Asia/Hong_Kong',
        '(UTC+08:00) Brunei, Kuala Lumpur, Singapore': 'Asia/Kuala_Lumpur',
        '(UTC+08:00) Irkutsk': 'Asia/Irkutsk',
        '(UTC+08:00) Choibalsan, Ulaanbaatar': 'Asia/Ulaanbaatar',
        '(UTC+08:00) Manila, Taipei': 'Asia/Taipei',
        '(UTC+08:00) Perth': 'Australia/Perth',
        '(UTC+08:30) Pyongyang': 'Asia/Pyongyang',
        '(UTC+08:45) Eucla': 'Australia/Eucla',
        '(UTC+09:00) Osaka, Sapporo, Tokyo': 'Asia/Tokyo',
        '(UTC+09:00) Seoul': 'Asia/Seoul',
        '(UTC+09:00) Chita, Khandyga, Yakutsk': 'Asia/Yakutsk',
        '(UTC+09:30) Adelaide': 'Australia/Adelaide',
        '(UTC+09:30) Darwin': 'Australia/Darwin',
        '(UTC+10:00) Brisbane': 'Australia/Brisbane',
        '(UTC+10:00) Canberra, Melbourne, Sydney': 'Australia/Sydney',
        '(UTC+10:00) Guam, Port Moresby': 'Pacific/Guam',
        '(UTC+10:00) Ust-Nera, Vladivostok': 'Asia/Vladivostok',
        '(UTC+11:00) Noumea, Solomon Islands': 'Pacific/Noumea',
        '(UTC+11:00) Magadan': 'Asia/Magadan',
        '(UTC+11:00) Sakhalin, Srednekolymsk': 'Asia/Srednekolymsk',
        '(UTC+12:00) Anadyr, Kamchatka': 'Asia/Kamchatka',
        '(UTC+12:00) Auckland, Wellington': 'Pacific/Auckland',
        '(UTC+12:45) Chatham': 'Pacific/Chatham',
        '(UTC+13:00) Tonga': 'Pacific/Tongatapu',
        '(UTC+13:00) Samoa': 'Pacific/Apia',
        '(UTC+14:00) Kiritimati': 'Pacific/Kiritimati',
      }

      // -----
      // The `timezoneJS.Date` object gives you full-blown timezone support, independent from the timezone set on the end-user's machine running the browser. It uses the Olson zoneinfo files for its timezone data.
      //
      // The constructor function and setter methods use proxy JavaScript Date objects behind the scenes, so you can use strings like '10/22/2006' with the constructor. You also get the same sensible wraparound behavior with numeric parameters (like setting a value of 14 for the month wraps around to the next March).
      //
      // The other significant difference from the built-in JavaScript Date is that `timezoneJS.Date` also has named properties that store the values of year, month, date, etc., so it can be directly serialized to JSON and used for data transfer.

      /*
       * Copyright 2010 Matthew Eernisse (mde@fleegix.org)
       * and Open Source Applications Foundation
       *
       * Licensed under the Apache License, Version 2.0 (the 'License');
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       *   http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an 'AS IS' BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       *
       * Credits: Ideas included from incomplete JS implementation of Olson
       * parser, 'XMLDAte' by Philippe Goetz (philippe.goetz@wanadoo.fr)
       *
       * Contributions:
       * Jan Niehusmann
       * Ricky Romero
       * Preston Hunt (prestonhunt@gmail.com)
       * Dov. B Katz (dov.katz@morganstanley.com)
       * Peter Bergström (pbergstr@mac.com)
       * Long Ho
       *
       * Modified from original by ChartIQ to include caching for improved performance
       */

      /*jshint laxcomma:true, laxbreak:true, expr:true, supernew:true*/
      ;(function() {
        // Standard initialization stuff to make sure the library is
        // usable on both client and server (node) side.
        'use strict'
        var root = this

        var timezoneJS = {}
        _exports.timezoneJS = timezoneJS

        timezoneJS.VERSION = '0.4.11'

        // Grab the ajax library from global context.
        // This can be jQuery, Zepto or fleegix.
        // You can also specify your own transport mechanism by declaring
        // `timezoneJS.timezone.transport` to a `function`. More details will follow
        var ajax_lib = root.$ || root.jQuery || root.Zepto,
          fleegix = root.fleegix,
          // Declare constant list of days and months. Unfortunately this doesn't leave room for i18n due to the Olson data being in English itself
          DAYS = (timezoneJS.Days = [
            'Sunday',
            'Monday',
            'Tuesday',
            'Wednesday',
            'Thursday',
            'Friday',
            'Saturday',
          ]),
          MONTHS = (timezoneJS.Months = [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December',
          ]),
          SHORT_MONTHS = {},
          SHORT_DAYS = {},
          EXACT_DATE_TIME = {}

        //`{ 'Jan': 0, 'Feb': 1, 'Mar': 2, 'Apr': 3, 'May': 4, 'Jun': 5, 'Jul': 6, 'Aug': 7, 'Sep': 8, 'Oct': 9, 'Nov': 10, 'Dec': 11 }`
        for (var i = 0; i < MONTHS.length; i++) {
          SHORT_MONTHS[MONTHS[i].substr(0, 3)] = i
        }

        //`{ 'Sun': 0, 'Mon': 1, 'Tue': 2, 'Wed': 3, 'Thu': 4, 'Fri': 5, 'Sat': 6 }`
        for (i = 0; i < DAYS.length; i++) {
          SHORT_DAYS[DAYS[i].substr(0, 3)] = i
        }

        //Handle array indexOf in IE
        //From https://developer.mozilla.org/en-US/docs/JavaScript/Reference/Global_Objects/Array/indexOf
        //Extending Array prototype causes IE to iterate thru extra element
        var _arrIndexOf =
          Array.prototype.indexOf ||
          function(el) {
            if (this === null) {
              throw new TypeError()
            }
            var t = Object(this)
            var len = t.length >>> 0
            if (len === 0) {
              return -1
            }
            var n = 0
            if (arguments.length > 1) {
              n = Number(arguments[1])
              if (n != n) {
                // shortcut for verifying if it's NaN
                n = 0
              } else if (n !== 0 && n !== Infinity && n !== -Infinity) {
                n = (n > 0 || -1) * Math.floor(Math.abs(n))
              }
            }
            if (n >= len) {
              return -1
            }
            var k = n >= 0 ? n : Math.max(len - Math.abs(n), 0)
            for (; k < len; k++) {
              if (k in t && t[k] === el) {
                return k
              }
            }
            return -1
          }

        // Format a number to the length = digits. For ex:
        //
        // `_fixWidth(2, 2) = '02'`
        //
        // `_fixWidth(1998, 2) = '98'`  // year, shorten it to the 2 digit representation
        //
        // `_fixWidth(23, 1) = '23'`  // hour, even with 1 digit specified, do not trim
        //
        // This is used to pad numbers in converting date to string in ISO standard.
        var _fixWidth = function(number, digits) {
          if (typeof number !== 'number') {
            throw 'not a number: ' + number
          }
          var trim = number > 1000 // only trim 'year', as the others don't make sense why anyone would want that
          var s = number.toString()
          var s_len = s.length
          if (trim && s_len > digits) {
            return s.substr(s_len - digits, s_len)
          }
          s = [s]
          while (s_len < digits) {
            s.unshift('0')
            s_len++
          }
          return s.join('')
        }

        // Abstraction layer for different transport layers, including fleegix/jQuery/Zepto/Node.js
        //
        // Object `opts` include
        //
        // - `url`: url to ajax query
        //
        // - `async`: true for asynchronous, false otherwise. If false, return value will be response from URL. This is true by default
        //
        // - `success`: success callback function
        //
        // - `error`: error callback function
        // Returns response from URL if async is false, otherwise the AJAX request object itself
        var _transport = function(opts) {
          if (!opts) return
          if (!opts.url) throw new Error('URL must be specified')
          if (!('async' in opts)) opts.async = true
          // Client-side
          if (
            (!fleegix || typeof fleegix.xhr === 'undefined') &&
            (!ajax_lib || typeof ajax_lib.ajax === 'undefined')
          ) {
            throw new Error(
              'Please use the Fleegix.js XHR module, jQuery ajax, Zepto ajax, or define your own transport mechanism for downloading zone files.'
            )
          }
          if (!opts.async) {
            return fleegix && fleegix.xhr
              ? fleegix.xhr.doReq({ url: opts.url, async: false })
              : ajax_lib.ajax({ url: opts.url, async: false, dataType: 'text' })
                  .responseText
          }
          return fleegix && fleegix.xhr
            ? fleegix.xhr.send({
                url: opts.url,
                method: 'get',
                handleSuccess: opts.success,
                handleErr: opts.error,
              })
            : ajax_lib.ajax({
                url: opts.url,
                dataType: 'text',
                method: 'GET',
                error: opts.error,
                success: opts.success,
              })
        }

        timezoneJS.ruleCache = {}

        // Constructor, which is similar to that of the native Date object itself
        timezoneJS.Date = function() {
          if (this === timezoneJS) {
            throw "timezoneJS.Date object must be constructed with 'new'"
          }
          var args = Array.prototype.slice.apply(arguments),
            dt = null,
            tz = null,
            arr = [],
            valid = false
          //We support several different constructors, including all the ones from `Date` object
          // with a timezone string at the end.
          //
          //- `[tz]`: Returns object with time in `tz` specified.
          //
          // - `utcMillis`, `[tz]`: Return object with UTC time = `utcMillis`, in `tz`.
          //
          // - `Date`, `[tz]`: Returns object with UTC time = `Date.getTime()`, in `tz`.
          //
          // - `year, month, [date,] [hours,] [minutes,] [seconds,] [millis,] [tz]: Same as `Date` object
          // with tz.
          //
          // - `Array`: Can be any combo of the above.
          //
          //If 1st argument is an array, we can use it as a list of arguments itself
          if (Object.prototype.toString.call(args[0]) === '[object Array]') {
            args = args[0]
          }
          // If the last string argument doesn't parse as a Date, treat it as tz
          if (typeof args[args.length - 1] === 'string') {
            valid = Date.parse(args[args.length - 1].replace(/GMT[+-]\d+/, ''))
            if (isNaN(valid) || valid === null) {
              // Checking against null is required for compatability with Datejs
              tz = args.pop()
            }
          }
          // Old code: still need it?
          //if (typeof args[args.length - 1] === 'string' /*&& isNaN(Date.parse(args[args.length - 1].replace(/GMT\+\d+/, '')))*/) { // This was causing any timezone with GMT to stop working as in "Etc/GMT-7"
          //  tz = args.pop();
          //}
          var is_dt_local = false
          switch (args.length) {
            case 0:
              dt = new Date()
              break
            case 1:
              dt = new Date(args[0])
              // Date strings are local if they do not contain 'Z', 'T' or timezone offsets like '+0200'
              //  - more info below
              if (
                typeof args[0] == 'string' &&
                args[0].search(/[+-][0-9]{4}/) == -1 &&
                args[0].search(/Z/) == -1 &&
                args[0].search(/T/) == -1
              ) {
                is_dt_local = true
              }
              break
            case 2:
              dt = new Date(args[0], args[1])
              is_dt_local = true
              break
            default:
              for (var i = 0; i < 7; i++) {
                arr[i] = args[i] || 0
              }
              dt = new Date(
                arr[0],
                arr[1],
                arr[2],
                arr[3],
                arr[4],
                arr[5],
                arr[6]
              )
              is_dt_local = true
              break
          }

          if (isNaN(dt.getTime())) {
            // invalid date were passed
            throw new Error('Invalid date')
          }

          this._useCache = false
          this._tzInfo = {}
          this._day = 0
          this.year = 0
          this.month = 0
          this.date = 0
          this.hours = 0
          this.minutes = 0
          this.seconds = 0
          this.milliseconds = 0
          this.timezone = tz || null
          // Tricky part:
          // The date is either given as unambiguous UTC date or otherwise the date is assumed
          // to be a date in timezone `tz` or a locale date if `tz` is not provided. Thus, to
          // determine how to use `dt` we distinguish between the following cases:
          //  - UTC   (is_dt_local = false)
          //    `timezoneJS.Date(millis, [tz])`
          //    `timezoneJS.Date(Date, [tz])`
          //    `timezoneJS.Date(dt_str_tz, [tz])`
          //  - local/timezone `tz`   (is_dt_local = true)
          //    `timezoneJS.Date(year, mon, day, [hour], [min], [second], [tz])`
          //    `timezoneJS.Date(dt_str, [tz])`
          //
          // `dt_str_tz` is a date string containing timezone information, i.e. containing 'Z', 'T' or
          // /[+-][0-9]{4}/ (e.g. '+0200'), while `dt_str` is a string which does not contain
          // timezone information. See: http://dygraphs.com/date-formats.html
          if (is_dt_local) {
            this.setFromDateObjProxy(dt)
          } else {
            this.setFromTimeProxy(dt.getTime(), tz)
          }
        }

        // Implements most of the native Date object
        timezoneJS.Date.prototype = {
          getDate: function() {
            return this.date
          },
          getDay: function() {
            return this._day
          },
          getFullYear: function() {
            return this.year
          },
          getMonth: function() {
            return this.month
          },
          getYear: function() {
            return this.year - 1900
          },
          getHours: function() {
            return this.hours
          },
          getMilliseconds: function() {
            return this.milliseconds
          },
          getMinutes: function() {
            return this.minutes
          },
          getSeconds: function() {
            return this.seconds
          },
          getUTCDate: function() {
            return this.getUTCDateProxy().getUTCDate()
          },
          getUTCDay: function() {
            return this.getUTCDateProxy().getUTCDay()
          },
          getUTCFullYear: function() {
            return this.getUTCDateProxy().getUTCFullYear()
          },
          getUTCHours: function() {
            return this.getUTCDateProxy().getUTCHours()
          },
          getUTCMilliseconds: function() {
            return this.getUTCDateProxy().getUTCMilliseconds()
          },
          getUTCMinutes: function() {
            return this.getUTCDateProxy().getUTCMinutes()
          },
          getUTCMonth: function() {
            return this.getUTCDateProxy().getUTCMonth()
          },
          getUTCSeconds: function() {
            return this.getUTCDateProxy().getUTCSeconds()
          },
          // Time adjusted to user-specified timezone
          getTime: function() {
            return this._timeProxy + this.getTimezoneOffset() * 60 * 1000
          },
          getTimezone: function() {
            return this.timezone
          },
          getTimezoneOffset: function() {
            return this.getTimezoneInfo().tzOffset
          },
          getTimezoneAbbreviation: function() {
            return this.getTimezoneInfo().tzAbbr
          },
          getTimezoneInfo: function() {
            if (this._useCache) return this._tzInfo
            var res
            // If timezone is specified, get the correct timezone info based on the Date given
            if (this.timezone) {
              res =
                this.timezone === 'Etc/UTC' || this.timezone === 'Etc/GMT'
                  ? { tzOffset: 0, tzAbbr: 'UTC' }
                  : timezoneJS.timezone.getTzInfo(
                      this._timeProxy,
                      this.timezone
                    )
            }
            // If no timezone was specified, use the local browser offset
            else {
              res = { tzOffset: this.getLocalOffset(), tzAbbr: null }
            }
            this._tzInfo = res
            this._useCache = true
            return res
          },
          getUTCDateProxy: function() {
            var dt = new Date(this._timeProxy)
            dt.setUTCMinutes(dt.getUTCMinutes() + this.getTimezoneOffset())
            return dt
          },
          setDate: function(date) {
            this.setAttribute('date', date)
            return this.getTime()
          },
          setFullYear: function(year, month, date) {
            if (date !== undefined) {
              this.setAttribute('date', 1)
            }
            this.setAttribute('year', year)
            if (month !== undefined) {
              this.setAttribute('month', month)
            }
            if (date !== undefined) {
              this.setAttribute('date', date)
            }
            return this.getTime()
          },
          setMonth: function(month, date) {
            this.setAttribute('month', month)
            if (date !== undefined) {
              this.setAttribute('date', date)
            }
            return this.getTime()
          },
          setYear: function(year) {
            year = Number(year)
            if (0 <= year && year <= 99) {
              year += 1900
            }
            this.setUTCAttribute('year', year)
            return this.getTime()
          },
          setHours: function(hours, minutes, seconds, milliseconds) {
            this.setAttribute('hours', hours)
            if (minutes !== undefined) {
              this.setAttribute('minutes', minutes)
            }
            if (seconds !== undefined) {
              this.setAttribute('seconds', seconds)
            }
            if (milliseconds !== undefined) {
              this.setAttribute('milliseconds', milliseconds)
            }
            return this.getTime()
          },
          setMinutes: function(minutes, seconds, milliseconds) {
            this.setAttribute('minutes', minutes)
            if (seconds !== undefined) {
              this.setAttribute('seconds', seconds)
            }
            if (milliseconds !== undefined) {
              this.setAttribute('milliseconds', milliseconds)
            }
            return this.getTime()
          },
          setSeconds: function(seconds, milliseconds) {
            this.setAttribute('seconds', seconds)
            if (milliseconds !== undefined) {
              this.setAttribute('milliseconds', milliseconds)
            }
            return this.getTime()
          },
          setMilliseconds: function(milliseconds) {
            this.setAttribute('milliseconds', milliseconds)
            return this.getTime()
          },
          setTime: function(n) {
            if (isNaN(n)) {
              throw new Error('Units must be a number.')
            }
            this.setFromTimeProxy(n, this.timezone)
            return this.getTime()
          },
          setUTCFullYear: function(year, month, date) {
            if (date !== undefined) {
              this.setUTCAttribute('date', 1)
            }
            this.setUTCAttribute('year', year)
            if (month !== undefined) {
              this.setUTCAttribute('month', month)
            }
            if (date !== undefined) {
              this.setUTCAttribute('date', date)
            }
            return this.getTime()
          },
          setUTCMonth: function(month, date) {
            this.setUTCAttribute('month', month)
            if (date !== undefined) {
              this.setUTCAttribute('date', date)
            }
            return this.getTime()
          },
          setUTCDate: function(date) {
            this.setUTCAttribute('date', date)
            return this.getTime()
          },
          setUTCHours: function(hours, minutes, seconds, milliseconds) {
            this.setUTCAttribute('hours', hours)
            if (minutes !== undefined) {
              this.setUTCAttribute('minutes', minutes)
            }
            if (seconds !== undefined) {
              this.setUTCAttribute('seconds', seconds)
            }
            if (milliseconds !== undefined) {
              this.setUTCAttribute('milliseconds', milliseconds)
            }
            return this.getTime()
          },
          setUTCMinutes: function(minutes, seconds, milliseconds) {
            this.setUTCAttribute('minutes', minutes)
            if (seconds !== undefined) {
              this.setUTCAttribute('seconds', seconds)
            }
            if (milliseconds !== undefined) {
              this.setUTCAttribute('milliseconds', milliseconds)
            }
            return this.getTime()
          },
          setUTCSeconds: function(seconds, milliseconds) {
            this.setUTCAttribute('seconds', seconds)
            if (milliseconds !== undefined) {
              this.setUTCAttribute('milliseconds', milliseconds)
            }
            return this.getTime()
          },
          setUTCMilliseconds: function(milliseconds) {
            this.setUTCAttribute('milliseconds', milliseconds)
            return this.getTime()
          },
          setFromDateObjProxy: function(dt) {
            this.year = dt.getFullYear()
            this.month = dt.getMonth()
            this.date = dt.getDate()
            this.hours = dt.getHours()
            this.minutes = dt.getMinutes()
            this.seconds = dt.getSeconds()
            this.milliseconds = dt.getMilliseconds()
            this._day = dt.getDay()
            this._dateProxy = dt
            this._timeProxy = Date.UTC(
              this.year,
              this.month,
              this.date,
              this.hours,
              this.minutes,
              this.seconds,
              this.milliseconds
            )
            this._useCache = false
          },
          setFromTimeProxy: function(utcMillis, tz) {
            var dt = new Date(utcMillis)
            var tzOffset = tz
              ? timezoneJS.timezone.getTzInfo(utcMillis, tz, true).tzOffset
              : dt.getTimezoneOffset()
            dt.setTime(utcMillis + (dt.getTimezoneOffset() - tzOffset) * 60000)
            this.setFromDateObjProxy(dt)
          },
          setAttribute: function(unit, n) {
            if (isNaN(n)) {
              throw new Error('Units must be a number.')
            }
            var dt = this._dateProxy
            var meth =
              unit === 'year'
                ? 'FullYear'
                : unit.substr(0, 1).toUpperCase() + unit.substr(1)
            dt['set' + meth](n)
            this.setFromDateObjProxy(dt)
          },
          setUTCAttribute: function(unit, n) {
            if (isNaN(n)) {
              throw new Error('Units must be a number.')
            }
            var meth =
              unit === 'year'
                ? 'FullYear'
                : unit.substr(0, 1).toUpperCase() + unit.substr(1)
            var dt = this.getUTCDateProxy()
            dt['setUTC' + meth](n)
            dt.setUTCMinutes(dt.getUTCMinutes() - this.getTimezoneOffset())
            this.setFromTimeProxy(
              dt.getTime() + this.getTimezoneOffset() * 60000,
              this.timezone
            )
          },
          setTimezone: function(tz) {
            var previousOffset = this.getTimezoneInfo().tzOffset
            this.timezone = tz
            this._useCache = false
            // Set UTC minutes offsets by the delta of the two timezones
            this.setUTCMinutes(
              this.getUTCMinutes() -
                this.getTimezoneInfo().tzOffset +
                previousOffset
            )
          },
          removeTimezone: function() {
            this.timezone = null
            this._useCache = false
          },
          valueOf: function() {
            return this.getTime()
          },
          clone: function() {
            return this.timezone
              ? new timezoneJS.Date(this.getTime(), this.timezone)
              : new timezoneJS.Date(this.getTime())
          },
          toGMTString: function() {
            return this.toString('EEE, dd MMM yyyy HH:mm:ss Z', 'Etc/GMT')
          },
          toLocaleStringIntl: function() {},
          toLocaleDateString: function() {},
          toLocaleTimeString: function() {},
          toSource: function() {},
          toISOString: function() {
            return this.toString('yyyy-MM-ddTHH:mm:ss.SSS', 'Etc/UTC') + 'Z'
          },
          toJSON: function() {
            return this.toISOString()
          },
          toDateString: function() {
            return this.toString('EEE MMM dd yyyy')
          },
          toTimeString: function() {
            return this.toString('H:mm k')
          },
          // Allows different format following ISO8601 format:
          toString: function(format, tz) {
            // Default format is the same as toISOString
            if (!format) format = 'yyyy-MM-ddTHH:mm:ss.SSS'
            var result = format
            var tzInfo = tz
              ? timezoneJS.timezone.getTzInfo(this.getTime(), tz)
              : this.getTimezoneInfo()
            var _this = this
            // If timezone is specified, get a clone of the current Date object and modify it
            if (tz) {
              _this = this.clone()
              _this.setTimezone(tz)
            }
            var hours = _this.getHours()
            return (
              result
                // fix the same characters in Month names
                .replace(/a+/g, function() {
                  return 'k'
                })
                // `y`: year
                .replace(/y+/g, function(token) {
                  return _fixWidth(_this.getFullYear(), token.length)
                })
                // `d`: date
                .replace(/d+/g, function(token) {
                  return _fixWidth(_this.getDate(), token.length)
                })
                // `m`: minute
                .replace(/m+/g, function(token) {
                  return _fixWidth(_this.getMinutes(), token.length)
                })
                // `s`: second
                .replace(/s+/g, function(token) {
                  return _fixWidth(_this.getSeconds(), token.length)
                })
                // `S`: millisecond
                .replace(/S+/g, function(token) {
                  return _fixWidth(_this.getMilliseconds(), token.length)
                })
                // 'h': 12 hour format
                .replace(/h+/g, function(token) {
                  return _fixWidth(
                    hours % 12 === 0 ? 12 : hours % 12,
                    token.length
                  )
                })
                // `M`: month. Note: `MM` will be the numeric representation (e.g February is 02) but `MMM` will be text representation (e.g February is Feb)
                .replace(/M+/g, function(token) {
                  var _month = _this.getMonth(),
                    _len = token.length
                  if (_len > 3) {
                    return timezoneJS.Months[_month]
                  } else if (_len > 2) {
                    return timezoneJS.Months[_month].substring(0, _len)
                  }
                  return _fixWidth(_month + 1, _len)
                })
                // `k`: AM/PM
                .replace(/k+/g, function() {
                  if (hours >= 12) {
                    if (hours > 12) {
                      hours -= 12
                    }
                    return 'PM'
                  }
                  return 'AM'
                })
                // `H`: hour
                .replace(/H+/g, function(token) {
                  return _fixWidth(hours, token.length)
                })
                // `E`: day
                .replace(/E+/g, function(token) {
                  return DAYS[_this.getDay()].substring(0, token.length)
                })
                // `Z`: timezone abbreviation
                .replace(/Z+/gi, function() {
                  return tzInfo.tzAbbr
                })
            )
          },
          toUTCString: function() {
            return this.toGMTString()
          },
          civilToJulianDayNumber: function(y, m, d) {
            var a
            // Adjust for zero-based JS-style array
            m++
            if (m > 12) {
              a = parseInt(m / 12, 10)
              m = m % 12
              y += a
            }
            if (m <= 2) {
              y -= 1
              m += 12
            }
            a = Math.floor(y / 100)
            var b = 2 - a + Math.floor(a / 4),
              jDt =
                Math.floor(365.25 * (y + 4716)) +
                Math.floor(30.6001 * (m + 1)) +
                d +
                b -
                1524
            return jDt
          },
          getLocalOffset: function() {
            return this._dateProxy.getTimezoneOffset()
          },
        }

        timezoneJS.timezone = new (function() {
          var _this = this,
            regionMap = {
              Etc: 'etcetera',
              EST: 'northamerica',
              MST: 'northamerica',
              HST: 'northamerica',
              EST5EDT: 'northamerica',
              CST6CDT: 'northamerica',
              MST7MDT: 'northamerica',
              PST8PDT: 'northamerica',
              America: ['northamerica', 'southamerica'],
              Pacific: 'australasia',
              Atlantic: 'europe',
              Africa: 'africa',
              Indian: 'africa',
              Antarctica: 'antarctica',
              Asia: 'asia',
              Australia: 'australasia',
              Europe: 'europe',
              WET: 'europe',
              CET: 'europe',
              MET: 'europe',
              EET: 'europe',
            },
            regionExceptions = {
              'Pacific/Honolulu': 'northamerica',
              'Atlantic/Bermuda': 'northamerica',
              'Atlantic/Cape_Verde': 'africa',
              'Atlantic/St_Helena': 'africa',
              'Indian/Kerguelen': 'antarctica',
              'Indian/Chagos': 'asia',
              'Indian/Maldives': 'asia',
              'Indian/Christmas': 'australasia',
              'Indian/Cocos': 'australasia',
              'America/Danmarkshavn': 'europe',
              'America/Scoresbysund': 'europe',
              'America/Godthab': 'europe',
              'America/Thule': 'europe',
              'Asia/Istanbul': 'europe',
              'Asia/Yekaterinburg': 'europe',
              'Asia/Omsk': 'europe',
              'Asia/Novosibirsk': 'europe',
              'Asia/Krasnoyarsk': 'europe',
              'Asia/Irkutsk': 'europe',
              'Asia/Yakutsk': 'europe',
              'Asia/Vladivostok': 'europe',
              'Asia/Sakhalin': 'europe',
              'Asia/Magadan': 'europe',
              'Asia/Kamchatka': 'europe',
              'Asia/Anadyr': 'europe',
              'Africa/Ceuta': 'europe',
              GMT: 'etcetera',
              'Europe/Nicosia': 'asia',
            }
          function invalidTZError(t) {
            throw new Error(
              "Timezone '" +
                t +
                "' is either incorrect, or not loaded in the timezone registry."
            )
          }
          function builtInLoadZoneFile(fileName, opts) {
            var url = _this.zoneFileBasePath + '/' + fileName
            return !opts || !opts.async
              ? _this.parseZones(_this.transport({ url: url, async: false }))
              : _this.transport({
                  async: true,
                  url: url,
                  success: function(str) {
                    return (
                      _this.parseZones(str) &&
                      typeof opts.callback === 'function' &&
                      opts.callback()
                    )
                  },
                  error: function() {
                    throw new Error(
                      "Error retrieving '" + url + "' zoneinfo files"
                    )
                  },
                })
          }
          function getRegionForTimezone(tz) {
            var exc = regionExceptions[tz],
              reg,
              ret
            if (exc) return exc
            reg = tz.split('/')[0]
            ret = regionMap[reg]
            // If there's nothing listed in the main regions for this TZ, check the 'backward' links
            if (ret) return ret
            var link = _this.zones[tz]
            if (typeof link === 'string') {
              return getRegionForTimezone(link)
            }
            // Backward-compat file hasn't loaded yet, try looking in there
            if (!_this.loadedZones.backward) {
              // This is for obvious legacy zones (e.g., Iceland) that don't even have a prefix like 'America/' that look like normal zones
              _this.loadZoneFile('backward')
              return getRegionForTimezone(tz)
            }
            invalidTZError(tz)
          }
          //str has format hh:mm, can be negative
          function parseTimeString(str) {
            var pat = /(\d+)(?::0*(\d*))?(?::0*(\d*))?([wsugz])?$/
            var hms = str.match(pat)
            hms[1] = parseInt(hms[1], 10)
            hms[2] = hms[2] ? parseInt(hms[2], 10) : 0
            hms[3] = hms[3] ? parseInt(hms[3], 10) : 0
            return hms.slice(1, 5)
          }
          //z is something like `[ '-3:44:40', '-', 'LMT', '1911', 'May', '15', '' ]` or `[ '-5:00', '-', 'EST', '1974', 'Apr', '28', '2:00' ]`
          function processZone(z) {
            if (!z[3]) {
              return
            }
            var yea = parseInt(z[3], 10),
              mon = 11,
              dat = 31
            //If month is there
            if (z[4]) {
              mon = SHORT_MONTHS[z[4].substr(0, 3)]
              dat = parseInt(z[5], 10) || 1
            }
            var t = z[6] ? parseTimeString(z[6]) : [0, 0, 0]
            return [yea, mon, dat, t[0], t[1], t[2]]
          }
          function getZone(dt, tz) {
            var utcMillis =
              typeof dt === 'number' ? dt : new Date(+dt).getTime()
            var t = tz
            var zoneList = _this.zones[t]
            // Follow links to get to an actual zone
            while (typeof zoneList === 'string') {
              t = zoneList
              zoneList = _this.zones[t]
            }
            if (!zoneList) {
              // Backward-compat file hasn't loaded yet, try looking in there
              if (!_this.loadedZones.backward) {
                //This is for backward entries like 'America/Fort_Wayne' that
                // getRegionForTimezone *thinks* it has a region file and zone
                // for (e.g., America => 'northamerica'), but in reality it's a
                // legacy zone we need the backward file for.
                _this.loadZoneFile('backward')
                return getZone(dt, tz)
              } else if (t && t !== tz) {
                //Load the linked zone found in the backward file
                _this.lazyLoadZoneFiles(t)
                return getZone(dt, t)
              }
              invalidTZError(t)
            }
            if (zoneList.length === 0) {
              throw new Error("No Zone found for '" + tz + "' on " + dt)
            }
            //Do backwards lookup since most use cases deal with newer dates.
            for (var i = zoneList.length - 1; i >= 0; i--) {
              var z = zoneList[i]
              if (z[3] && utcMillis > z[3]) break
            }
            return zoneList[i + 1]
          }
          function getBasicOffset(time) {
            var off = parseTimeString(time),
              adj = time.charAt(0) === '-' ? -1 : 1
            off = adj * (((off[0] * 60 + off[1]) * 60 + off[2]) * 1000)
            return off / 60 / 1000
          }
          function getAdjustedOffset(off, min) {
            return -Math.ceil(min - off)
          }

          //if isUTC is true, date is given in UTC, otherwise it's given
          // in local time (ie. date.getUTC*() returns local time components)
          function getRule(dt, zone, isUTC, cacheKey) {
            var date = typeof dt === 'number' ? new Date(dt) : dt
            var ruleset = zone[1]
            var basicOffset = zone[0]

            // If the zone has a DST rule like '1:00', create a rule and return it
            // instead of looking it up in the parsed rules
            var staticDstMatch = ruleset.match(/^([0-9]):([0-9][0-9])$/)
            if (staticDstMatch) {
              return [
                -1000000,
                'max',
                '-',
                'Jan',
                1,
                [0, 0, 0],
                parseInt(staticDstMatch[1], 10) * 60 +
                  parseInt(staticDstMatch[2], 10),
                '-',
              ]
            }

            //Convert a date to UTC. Depending on the 'type' parameter, the date
            // parameter may be:
            //
            // - `u`, `g`, `z`: already UTC (no adjustment).
            //
            // - `s`: standard time (adjust for time zone offset but not for DST)
            //
            // - `w`: wall clock time (adjust for both time zone and DST offset).
            //
            // DST adjustment is done using the rule given as third argument.
            var convertDateToUTC = function(date, type, rule) {
              var offset = 0

              if (type === 'u' || type === 'g' || type === 'z') {
                // UTC
                offset = 0
              } else if (type === 's') {
                // Standard Time
                offset = basicOffset
              } else if (type === 'w' || !type) {
                // Wall Clock Time
                offset = getAdjustedOffset(basicOffset, rule[6])
              } else {
                throw new Error('unknown type ' + type)
              }
              offset *= 60 * 1000 // to millis

              return new Date(date.getTime() + offset)
            }

            //Step 1:  Find applicable rules for this year.
            //
            //Step 2:  Sort the rules by effective date.
            //
            //Step 3:  Check requested date to see if a rule has yet taken effect this year.  If not,
            //
            //Step 4:  Get the rules for the previous year.  If there isn't an applicable rule for last year, then
            // there probably is no current time offset since they seem to explicitly turn off the offset
            // when someone stops observing DST.
            //
            // FIXME if this is not the case and we'll walk all the way back (ugh).
            //
            //Step 5:  Sort the rules by effective date.
            //Step 6:  Apply the most recent rule before the current time.
            var convertRuleToExactDateAndTime = function(
              yearAndRule,
              prevRule
            ) {
              var year = yearAndRule[0],
                rule = yearAndRule[1]
              // Assume that the rule applies to the year of the given date.

              var hms = rule[5]
              var effectiveDate

              if (!EXACT_DATE_TIME[year]) EXACT_DATE_TIME[year] = {}

              // Result for given parameters is already stored
              if (EXACT_DATE_TIME[year][rule])
                effectiveDate = EXACT_DATE_TIME[year][rule]
              else {
                //If we have a specific date, use that!
                if (!isNaN(rule[4])) {
                  effectiveDate = new Date(
                    Date.UTC(
                      year,
                      SHORT_MONTHS[rule[3]],
                      rule[4],
                      hms[0],
                      hms[1],
                      hms[2],
                      0
                    )
                  )
                }
                //Let's hunt for the date.
                else {
                  var targetDay, operator
                  //Example: `lastThu`
                  if (rule[4].substr(0, 4) === 'last') {
                    // Start at the last day of the month and work backward.
                    effectiveDate = new Date(
                      Date.UTC(
                        year,
                        SHORT_MONTHS[rule[3]] + 1,
                        1,
                        hms[0] - 24,
                        hms[1],
                        hms[2],
                        0
                      )
                    )
                    targetDay = SHORT_DAYS[rule[4].substr(4, 3)]
                    operator = '<='
                  }
                  //Example: `Sun>=15`
                  else {
                    //Start at the specified date.
                    effectiveDate = new Date(
                      Date.UTC(
                        year,
                        SHORT_MONTHS[rule[3]],
                        rule[4].substr(5),
                        hms[0],
                        hms[1],
                        hms[2],
                        0
                      )
                    )
                    targetDay = SHORT_DAYS[rule[4].substr(0, 3)]
                    operator = rule[4].substr(3, 2)
                  }
                  var ourDay = effectiveDate.getUTCDay()
                  //Go forwards.
                  if (operator === '>=') {
                    effectiveDate.setUTCDate(
                      effectiveDate.getUTCDate() +
                        (targetDay - ourDay + (targetDay < ourDay ? 7 : 0))
                    )
                  }
                  //Go backwards.  Looking for the last of a certain day, or operator is '<=' (less likely).
                  else {
                    effectiveDate.setUTCDate(
                      effectiveDate.getUTCDate() +
                        (targetDay - ourDay - (targetDay > ourDay ? 7 : 0))
                    )
                  }
                }
                EXACT_DATE_TIME[year][rule] = effectiveDate
              }

              //If previous rule is given, correct for the fact that the starting time of the current
              // rule may be specified in local time.
              if (prevRule) {
                effectiveDate = convertDateToUTC(
                  effectiveDate,
                  hms[3],
                  prevRule
                )
              }
              return effectiveDate
            }

            var findApplicableRules = function(year, ruleset) {
              var applicableRules = []
              for (var i = 0; ruleset && i < ruleset.length; i++) {
                //Exclude future rules.
                if (
                  ruleset[i][0] <= year &&
                  // Date is in a set range.
                  (ruleset[i][1] >= year ||
                    // Date is in an 'only' year.
                    (ruleset[i][0] === year && ruleset[i][1] === 'only') ||
                    //We're in a range from the start year to infinity.
                    ruleset[i][1] === 'max')
                ) {
                  //It's completely okay to have any number of matches here.
                  // Normally we should only see two, but that doesn't preclude other numbers of matches.
                  // These matches are applicable to this year.
                  applicableRules.push([year, ruleset[i]])
                }
              }
              return applicableRules
            }

            var compareDates = function(a, b, prev) {
              var year, rule
              if (!(a instanceof Date)) {
                year = a[0]
                rule = a[1]
                a =
                  !prev && EXACT_DATE_TIME[year] && EXACT_DATE_TIME[year][rule]
                    ? EXACT_DATE_TIME[year][rule]
                    : convertRuleToExactDateAndTime(a, prev)
              } else if (prev) {
                a = convertDateToUTC(a, isUTC ? 'u' : 'w', prev)
              }
              if (!(b instanceof Date)) {
                year = b[0]
                rule = b[1]
                b =
                  !prev && EXACT_DATE_TIME[year] && EXACT_DATE_TIME[year][rule]
                    ? EXACT_DATE_TIME[year][rule]
                    : convertRuleToExactDateAndTime(b, prev)
              } else if (prev) {
                b = convertDateToUTC(b, isUTC ? 'u' : 'w', prev)
              }
              a = Number(a)
              b = Number(b)
              return a - b
            }

            var year = date.getUTCFullYear()
            var applicableRules

            var cache = timezoneJS.ruleCache[cacheKey]
            if (!cache) cache = timezoneJS.ruleCache[cacheKey] = {}
            applicableRules = cache[year]
            if (!applicableRules) {
              applicableRules = findApplicableRules(
                year - 1,
                _this.rules[ruleset]
              )
              applicableRules = applicableRules.concat(
                findApplicableRules(year, _this.rules[ruleset])
              )
              applicableRules.sort(compareDates) // Probably already sorted?
              cache[year] = applicableRules
            }

            if (!applicableRules || !applicableRules.length) return null // No applicable rules

            var prev
            for (var i = applicableRules.length - 1; i >= 0; i--) {
              if (i > 0) prev = applicableRules[i - 1][1]
              else prev = null
              var rule = applicableRules[i]
              if (!rule[2]) {
                rule[2] = convertRuleToExactDateAndTime(rule, prev) // cache the exactDateAndTime, this saves a lot of cycles!
              }
              if (compareDates(date, rule, prev) >= 0) return rule[1]
            }
            return null

            /*
	      applicableRules = findApplicableRules(year, _this.rules[ruleset]);
	      applicableRules.push(date);
	      //While sorting, the time zone in which the rule starting time is specified
	      // is ignored. This is ok as long as the timespan between two DST changes is
	      // larger than the DST offset, which is probably always true.
	      // As the given date may indeed be close to a DST change, it may get sorted
	      // to a wrong position (off by one), which is corrected below.
	      applicableRules.sort(compareDates);

	      //If there are not enough past DST rules...
	      if (_arrIndexOf.call(applicableRules, date) < 2) {
		applicableRules = applicableRules.concat(findApplicableRules(year-1, _this.rules[ruleset]));
		applicableRules.sort(compareDates);
	      }
	      var pinpoint = _arrIndexOf.call(applicableRules, date);
	      if (pinpoint > 1 && compareDates(date, applicableRules[pinpoint-1], applicableRules[pinpoint-2][1]) < 0) {
		//The previous rule does not really apply, take the one before that.
		return applicableRules[pinpoint - 2][1];
	      } else if (pinpoint > 0 && pinpoint < applicableRules.length - 1 && compareDates(date, applicableRules[pinpoint+1], applicableRules[pinpoint-1][1]) > 0) {

		//The next rule does already apply, take that one.
		return applicableRules[pinpoint + 1][1];
	      } else if (pinpoint === 0) {
		//No applicable rule found in this and in previous year.
		return null;
	      }
	      return applicableRules[pinpoint - 1][1];
	     */
          }
          function getAbbreviation(zone, rule) {
            var base = zone[2]
            if (base.indexOf('%s') > -1) {
              var repl
              if (rule) {
                repl = rule[7] === '-' ? '' : rule[7]
              }
              //FIXME: Right now just falling back to Standard --
              // apparently ought to use the last valid rule,
              // although in practice that always ought to be Standard
              else {
                repl = 'S'
              }
              return base.replace('%s', repl)
            } else if (base.indexOf('/') > -1) {
              //Chose one of two alternative strings.
              return base.split('/', 2)[rule ? (rule[6] ? 1 : 0) : 0]
            }
            return base
          }

          this.zoneFileBasePath = null
          this.zoneFiles = [
            'africa',
            'antarctica',
            'asia',
            'australasia',
            'backward',
            'etcetera',
            'europe',
            'northamerica',
            'pacificnew',
            'southamerica',
          ]
          this.loadingSchemes = {
            PRELOAD_ALL: 'preloadAll',
            LAZY_LOAD: 'lazyLoad',
            MANUAL_LOAD: 'manualLoad',
          }
          this.getRegionForTimezone = getRegionForTimezone
          this.loadingScheme = this.loadingSchemes.LAZY_LOAD
          this.loadedZones = {}
          this.zones = {}
          this.rules = {}

          this.init = function(o) {
            var opts = { async: true },
              def =
                this.loadingScheme === this.loadingSchemes.PRELOAD_ALL
                  ? this.zoneFiles
                  : this.defaultZoneFile || 'northamerica'
            //Override default with any passed-in opts
            for (var p in o) {
              opts[p] = o[p]
            }
            return this.loadZoneFiles(def, opts)
          }

          //Get a single zone file, or all files in an array
          this.loadZoneFiles = function(fileNames, opts) {
            var callbackFn,
              done = 0
            if (typeof fileNames === 'string') {
              return this.loadZoneFile(fileNames, opts)
            }
            //Wraps callback function in another one that makes
            // sure all files have been loaded.
            opts = opts || {}
            callbackFn = opts.callback
            opts.callback = function() {
              done++
              done === fileNames.length &&
                typeof callbackFn === 'function' &&
                callbackFn()
            }
            for (var i = 0; i < fileNames.length; i++) {
              this.loadZoneFile(fileNames[i], opts)
            }
          }
          //Get the zone files via XHR -- if the sync flag
          // is set to true, it's being called by the lazy-loading
          // mechanism, so the result needs to be returned inline.
          this.loadZoneFile = function(fileName, opts) {
            if (typeof this.zoneFileBasePath === 'undefined') {
              throw new Error(
                'Please define a base path to your zone file directory -- timezoneJS.timezone.zoneFileBasePath.'
              )
            }
            //Ignore already loaded zones.
            if (this.loadedZones[fileName]) {
              return
            }
            this.loadedZones[fileName] = true
            return builtInLoadZoneFile(fileName, opts)
          }
          this.loadZoneJSONData = function(url, sync) {
            var processData = function(data) {
              /*jslint evil: true */ /*jshint -W061 */ /*eslint-disable no-eval */
              data = eval(
                '(' + data + ')'
              ) /*jshint +W061 */ /*eslint-enable no-eval */
              /*jslint evil: false */ for (var z in data.zones) {
                _this.zones[z] = data.zones[z]
              }
              for (var r in data.rules) {
                _this.rules[r] = data.rules[r]
              }
            }
            return sync
              ? processData(_this.transport({ url: url, async: false }))
              : _this.transport({ url: url, success: processData })
          }
          this.loadZoneDataFromObject = function(data) {
            if (!data) {
              return
            }
            for (var z in data.zones) {
              _this.zones[z] = data.zones[z]
            }
            for (var r in data.rules) {
              _this.rules[r] = data.rules[r]
            }
          }
          this.getAllZones = function() {
            var arr = []
            for (var z in this.zones) {
              arr.push(z)
            }
            return arr.sort()
          }
          this.parseZones = function(str) {
            if (!str) {
              return false
            }

            var lines = str.split('\n'),
              arr = [],
              chunk = '',
              l,
              zone = null,
              rule = null
            for (var i = 0; i < lines.length; i++) {
              l = lines[i]
              if (l.match(/^\s/)) {
                l = 'Zone ' + zone + l
              }
              l = l.split('#')[0]
              if (l.length > 3) {
                arr = l.split(/\s+/)
                chunk = arr.shift()
                //Ignore Leap.
                switch (chunk) {
                  case 'Zone':
                    zone = arr.shift()
                    if (!_this.zones[zone]) {
                      _this.zones[zone] = []
                    }
                    if (arr.length < 3) break
                    //Process zone right here and replace 3rd element with the processed array.
                    arr.splice(3, arr.length, processZone(arr))
                    if (arr[3]) arr[3] = Date.UTC.apply(null, arr[3])
                    arr[0] = -getBasicOffset(arr[0])
                    _this.zones[zone].push(arr)
                    break
                  case 'Rule':
                    rule = arr.shift()
                    if (!_this.rules[rule]) {
                      _this.rules[rule] = []
                    }
                    //Parse int FROM year and TO year
                    arr[0] = parseInt(arr[0], 10)
                    arr[1] = parseInt(arr[1], 10) || arr[1]
                    //Parse time string AT
                    arr[5] = parseTimeString(arr[5])
                    //Parse offset SAVE
                    arr[6] = getBasicOffset(arr[6])
                    _this.rules[rule].push(arr)
                    break
                  case 'Link':
                    //No zones for these should already exist.
                    if (_this.zones[arr[1]]) {
                      throw new Error(
                        'Error with Link ' +
                          arr[1] +
                          '. Cannot create link of a preexisted zone.'
                      )
                    }
                    //Create the link.
                    //Links are saved as strings that are the keys
                    //of their referenced values.
                    //Ex: "US/Central": "America/Chicago"
                    if (isNaN(arr[0])) {
                      _this.zones[arr[1]] = arr[0]
                    } else {
                      _this.zones[arr[1]] = parseInt(arr[0], 10)
                    }
                    break
                }
              }
            }
            return true
          }
          //Expose transport mechanism and allow overwrite.
          this.transport = _transport
          this.getTzInfo = function(dt, tz, isUTC) {
            this.lazyLoadZoneFiles(tz)
            var z = getZone(dt, tz)
            var off = +z[0]
            //See if the offset needs adjustment.
            var rule = getRule(dt, z, isUTC, tz)
            if (rule) {
              off = getAdjustedOffset(off, rule[6])
            }
            var abbr = getAbbreviation(z, rule)
            return { tzOffset: off, tzAbbr: abbr }
          }
          //Lazy-load any zones not yet loaded.
          this.lazyLoadZoneFiles = function(tz) {
            if (this.loadingScheme === this.loadingSchemes.LAZY_LOAD) {
              //Get the correct region for the zone.
              var zoneFile = getRegionForTimezone(tz)
              if (!zoneFile) {
                throw new Error('Not a valid timezone ID.')
              }
              //Get the file and parse it -- use synchronous XHR.
              this.loadZoneFiles(zoneFile)
            }
          }
        })()
      }.call(typeof window !== 'undefined' ? window : this))

      // Load all the necessary timezones and their rules
      _exports.timezoneJS.timezone.loadingScheme =
        _exports.timezoneJS.timezone.loadingSchemes.MANUAL_LOAD
      _exports.timezoneJS.timezone.loadZoneDataFromObject({
        zones: {
          'Atlantic/Cape_Verde': [[60, '-', '-01', null]],
          'Africa/Cairo': [[-120, 'Egypt', 'EE%sT', null]],
          'Africa/Nairobi': [[-180, '-', 'EAT', null]],
          'Africa/Casablanca': [[0, 'Morocco', 'WE%sT', null]],
          'Africa/Johannesburg': [[-120, 'SA', 'SAST', null]],
          'Africa/Tunis': [[-60, 'Tunisia', 'CE%sT', null]],
          'Asia/Kabul': [[-270, '-', '+0430', null]],
          'Asia/Baku': [[-240, 'Azer', '+04/+05', null]],
          'Asia/Dhaka': [[-360, 'Dhaka', '+06/+07', null]],
          'Asia/Yangon': [[-390, '-', '+0630', null]],
          'Asia/Shanghai': [[-480, 'PRC', 'C%sT', null]],
          'Asia/Hong_Kong': [[-480, 'HK', 'HK%sT', null]],
          'Asia/Taipei': [[-480, 'Taiwan', 'C%sT', null]],
          'Asia/Nicosia': [[-120, 'EUAsia', 'EE%sT', null]],
          'Asia/Kolkata': [[-330, '-', 'IST', null]],
          'Asia/Tehran': [[-210, 'Iran', '+0330/+0430', null]],
          'Asia/Jerusalem': [[-120, 'Zion', 'I%sT', null]],
          'Asia/Tokyo': [[-540, 'Japan', 'J%sT', null]],
          'Asia/Almaty': [[-360, '-', 'ALMT', null]],
          'Asia/Seoul': [[-540, 'ROK', 'K%sT', null]],
          'Asia/Pyongyang': [
            [-540, '-', 'KST', 1439596800000],
            [-510, '-', 'KST', null],
          ],
          'Asia/Kuala_Lumpur': [[-480, '-', '+08', null]],
          'Asia/Hovd': [[-420, 'Mongol', '+07/+08', null]],
          'Asia/Ulaanbaatar': [[-480, 'Mongol', '+08/+09', null]],
          'Asia/Kathmandu': [[-345, '-', '+0545', null]],
          'Asia/Karachi': [[-300, 'Pakistan', 'PK%sT', null]],
          'Asia/Riyadh': [[-180, '-', '+03', null]],
          'Asia/Bangkok': [[-420, '-', '+07', null]],
          'Asia/Dubai': [[-240, '-', '+04', null]],
          'Australia/Darwin': [[-570, 'Aus', 'CST', null]],
          'Australia/Perth': [[-480, 'AW', 'WST', null]],
          'Australia/Eucla': [[-525, 'AW', '+0845/+0945', null]],
          'Australia/Brisbane': [[-600, 'AQ', 'EST', null]],
          'Australia/Adelaide': [[-570, 'AS', 'CST', null]],
          'Australia/Sydney': [[-600, 'AN', 'EST', null]],
          'Pacific/Guam': [[-600, '-', 'ChST', null]],
          'Pacific/Kiritimati': [[-840, '-', '+14', null]],
          'Pacific/Noumea': [[-660, 'NC', '+11/+12', null]],
          'Pacific/Auckland': [[-720, 'NZ', 'NZ%sT', null]],
          'Pacific/Chatham': [[-765, 'Chatham', '+1245/+1345', null]],
          'Pacific/Pago_Pago': [[660, '-', 'SST', null]],
          'Pacific/Apia': [[-780, 'WS', '+13/+14', null]],
          'Pacific/Tongatapu': [[-780, 'Tonga', '+13/+14', null]],
          'Etc/UTC': [[0, '-', 'UTC', null]],
          UTC: 'Etc/UTC',
          'Europe/London': [[0, 'EU', 'GMT/BST', null]],
          WET: [[0, 'EU', 'WE%sT', null]],
          CET: [[-60, 'C-Eur', 'CE%sT', null]],
          MET: [[-60, 'C-Eur', 'ME%sT', null]],
          EET: [[-120, 'EU', 'EE%sT', null]],
          'Europe/Brussels': [[-60, 'EU', 'CE%sT', null]],
          'Europe/Helsinki': [[-120, 'EU', 'EE%sT', null]],
          'Europe/Paris': [[-60, 'EU', 'CE%sT', null]],
          'Europe/Berlin': [[-60, 'EU', 'CE%sT', null]],
          'Europe/Amsterdam': [[-60, 'EU', 'CE%sT', null]],
          'Atlantic/Azores': [[60, 'EU', 'AZO%sT', null]],
          'Europe/Bucharest': [[-120, 'EU', 'EE%sT', null]],
          'Europe/Kaliningrad': [
            [-180, '-', '+03', 1414288800000],
            [-120, '-', 'EET', null],
          ],
          'Europe/Moscow': [
            [-240, '-', 'MSK', 1414288800000],
            [-180, '-', 'MSK', null],
          ],
          'Europe/Simferopol': [
            [-120, 'EU', 'EE%sT', 1396144800000],
            [-240, '-', 'MSK', 1414288800000],
            [-180, '-', 'MSK', null],
          ],
          'Europe/Samara': [[-240, '-', '+04', null]],
          'Asia/Yekaterinburg': [
            [-360, '-', '+06', 1414288800000],
            [-300, '-', '+05', null],
          ],
          'Asia/Omsk': [
            [-420, '-', '+07', 1414288800000],
            [-360, '-', '+06', null],
          ],
          'Asia/Novosibirsk': [
            [-420, '-', '+07', 1414288800000],
            [-360, '-', '+06', 1469325600000],
            [-420, '-', '+07', null],
          ],
          'Asia/Novokuznetsk': [[-420, '-', '+07', null]],
          'Asia/Krasnoyarsk': [
            [-480, '-', '+08', 1414288800000],
            [-420, '-', '+07', null],
          ],
          'Asia/Irkutsk': [
            [-540, '-', '+09', 1414288800000],
            [-480, '-', '+08', null],
          ],
          'Asia/Yakutsk': [
            [-600, '-', '+10', 1414288800000],
            [-540, '-', '+09', null],
          ],
          'Asia/Vladivostok': [
            [-660, '-', '+11', 1414288800000],
            [-600, '-', '+10', null],
          ],
          'Asia/Magadan': [
            [-720, '-', '+12', 1414288800000],
            [-600, '-', '+10', 1461463200000],
            [-660, '-', '+11', null],
          ],
          'Asia/Srednekolymsk': [
            [-720, '-', '+12', 1414288800000],
            [-660, '-', '+11', null],
          ],
          'Asia/Kamchatka': [[-720, '-', '+12', null]],
          'Europe/Belgrade': [[-60, 'EU', 'CE%sT', null]],
          'Europe/Sarajevo': 'Europe/Belgrade',
          'Europe/Istanbul': [
            [-120, 'EU', 'EE%sT', 1396141200000],
            [-120, '-', 'EET', 1396227600000],
            [-120, 'EU', 'EE%sT', 1445734800000],
            [-120, '1:00', 'EEST', 1446944400000],
            [-120, 'EU', 'EE%sT', 1473206400000],
            [-180, '-', '+03', null],
          ],
          'America/New_York': [[300, 'US', 'E%sT', null]],
          'America/Chicago': [[360, 'US', 'C%sT', null]],
          'America/Denver': [[420, 'US', 'M%sT', null]],
          'America/Los_Angeles': [[480, 'US', 'P%sT', null]],
          'America/Juneau': [[540, 'US', 'AK%sT', null]],
          'Pacific/Honolulu': [[600, '-', 'HST', null]],
          'America/Phoenix': [[420, '-', 'MST', null]],
          'America/Indiana/Indianapolis': [[300, 'US', 'E%sT', null]],
          'America/St_Johns': [[210, 'Canada', 'N%sT', null]],
          'America/Halifax': [[240, 'Canada', 'A%sT', null]],
          'America/Regina': [[360, '-', 'CST', null]],
          'America/Mexico_City': [[360, 'Mexico', 'C%sT', null]],
          'America/Chihuahua': [[420, 'Mexico', 'M%sT', null]],
          'America/Tijuana': [[480, 'US', 'P%sT', null]],
          'America/Costa_Rica': [[360, 'CR', 'C%sT', null]],
          'America/Puerto_Rico': [[240, '-', 'AST', null]],
          'America/Argentina/Buenos_Aires': [[180, 'Arg', '-03/-02', null]],
          'America/Sao_Paulo': [[180, 'Brazil', '-03/-02', null]],
          'America/Santiago': [[240, 'Chile', '-04/-03', null]],
          'America/Punta_Arenas': [
            [240, 'Chile', '-04/-03', 1480809600000],
            [180, '-', '-03', null],
          ],
          'America/Bogota': [[300, 'CO', '-05/-04', null]],
          'America/Asuncion': [[240, 'Para', '-04/-03', null]],
          'Atlantic/South_Georgia': [[120, '-', '-02', null]],
          'America/Montevideo': [[180, 'Uruguay', '-03/-02', null]],
          'America/Caracas': [
            [270, '-', '-0430', 1462069800000],
            [240, '-', '-04', null],
          ],
          // backwards compatibility
          'Europe/Athens': 'Europe/Bucharest',
          'Asia/Rangoon': 'Asia/Yangon',
          'Atlantic/Reykjavik': 'UTC',
          'Asia/Kuwait': 'Asia/Riyadh',
          'Asia/Muscat': 'Asia/Riyadh',
          'Asia/Istanbul': 'Europe/Istanbul',
          'Pacific/Midway': 'Pacific/Pago_Pago',
        },
        rules: {
          Egypt: [
            [2014, 'only', '-', 'May', '16', [0, 0, 0, null], 60, 'S'],
            [2014, 'only', '-', 'Jun', '27', [0, 0, 0, null], 0, '-'],
            [2014, 'only', '-', 'Aug', '1', [0, 0, 0, null], 60, 'S'],
            [2014, 'only', '-', 'Sep', 'lastThu', [23, 0, 0, 's'], 0, '-'],
          ],
          Morocco: [
            [2012, 2013, '-', 'Apr', 'lastSun', [2, 0, 0, null], 60, 'S'],
            [2012, 'only', '-', 'Jul', '20', [3, 0, 0, null], 0, '-'],
            [2012, 'only', '-', 'Aug', '20', [2, 0, 0, null], 60, 'S'],
            [2012, 'only', '-', 'Sep', '30', [3, 0, 0, null], 0, '-'],
            [2013, 'only', '-', 'Jul', '7', [3, 0, 0, null], 0, '-'],
            [2013, 'only', '-', 'Aug', '10', [2, 0, 0, null], 60, 'S'],
            [2013, 'max', '-', 'Oct', 'lastSun', [3, 0, 0, null], 0, '-'],
            [2014, 2021, '-', 'Mar', 'lastSun', [2, 0, 0, null], 60, 'S'],
            [2014, 'only', '-', 'Jun', '28', [3, 0, 0, null], 0, '-'],
            [2014, 'only', '-', 'Aug', '2', [2, 0, 0, null], 60, 'S'],
            [2015, 'only', '-', 'Jun', '14', [3, 0, 0, null], 0, '-'],
            [2015, 'only', '-', 'Jul', '19', [2, 0, 0, null], 60, 'S'],
            [2016, 'only', '-', 'Jun', '5', [3, 0, 0, null], 0, '-'],
            [2016, 'only', '-', 'Jul', '10', [2, 0, 0, null], 60, 'S'],
            [2017, 'only', '-', 'May', '21', [3, 0, 0, null], 0, '-'],
            [2017, 'only', '-', 'Jul', '2', [2, 0, 0, null], 60, 'S'],
            [2018, 'only', '-', 'May', '13', [3, 0, 0, null], 0, '-'],
            [2018, 'only', '-', 'Jun', '17', [2, 0, 0, null], 60, 'S'],
            [2019, 'only', '-', 'May', '5', [3, 0, 0, null], 0, '-'],
            [2019, 'only', '-', 'Jun', '9', [2, 0, 0, null], 60, 'S'],
            [2020, 'only', '-', 'Apr', '19', [3, 0, 0, null], 0, '-'],
            [2020, 'only', '-', 'May', '24', [2, 0, 0, null], 60, 'S'],
            [2021, 'only', '-', 'Apr', '11', [3, 0, 0, null], 0, '-'],
            [2021, 'only', '-', 'May', '16', [2, 0, 0, null], 60, 'S'],
            [2022, 'only', '-', 'May', '8', [2, 0, 0, null], 60, 'S'],
          ],
          SA: [],
          Tunisia: [],
          EUAsia: [
            [1981, 'max', '-', 'Mar', 'lastSun', [1, 0, 0, 'u'], 60, 'S'],
            [1996, 'max', '-', 'Oct', 'lastSun', [1, 0, 0, 'u'], 0, '-'],
          ],
          Azer: [
            [1997, 2015, '-', 'Mar', 'lastSun', [4, 0, 0, null], 60, 'S'],
            [1997, 2015, '-', 'Oct', 'lastSun', [5, 0, 0, null], 0, '-'],
          ],
          Dhaka: [],
          PRC: [],
          HK: [],
          Taiwan: [],
          Iran: [
            [2012, 'only', '-', 'Mar', '21', [0, 0, 0, null], 60, 'D'],
            [2012, 'only', '-', 'Sep', '21', [0, 0, 0, null], 0, 'S'],
            [2013, 2015, '-', 'Mar', '22', [0, 0, 0, null], 60, 'D'],
            [2013, 2015, '-', 'Sep', '22', [0, 0, 0, null], 0, 'S'],
            [2016, 'only', '-', 'Mar', '21', [0, 0, 0, null], 60, 'D'],
            [2016, 'only', '-', 'Sep', '21', [0, 0, 0, null], 0, 'S'],
            [2017, 2019, '-', 'Mar', '22', [0, 0, 0, null], 60, 'D'],
            [2017, 2019, '-', 'Sep', '22', [0, 0, 0, null], 0, 'S'],
            [2020, 'only', '-', 'Mar', '21', [0, 0, 0, null], 60, 'D'],
            [2020, 'only', '-', 'Sep', '21', [0, 0, 0, null], 0, 'S'],
            [2021, 2023, '-', 'Mar', '22', [0, 0, 0, null], 60, 'D'],
            [2021, 2023, '-', 'Sep', '22', [0, 0, 0, null], 0, 'S'],
          ],
          Zion: [
            [2012, 'only', '-', 'Mar', 'Fri>=26', [2, 0, 0, null], 60, 'D'],
            [2012, 'only', '-', 'Sep', '23', [2, 0, 0, null], 0, 'S'],
            [2013, 'max', '-', 'Mar', 'Fri>=23', [2, 0, 0, null], 60, 'D'],
            [2013, 'max', '-', 'Oct', 'lastSun', [2, 0, 0, null], 0, 'S'],
          ],
          Japan: [],
          ROK: [],
          Mongol: [
            [2015, 2016, '-', 'Mar', 'lastSat', [2, 0, 0, null], 60, 'S'],
            [2015, 2016, '-', 'Sep', 'lastSat', [0, 0, 0, null], 0, '-'],
          ],
          Pakistan: [],
          Aus: [],
          AW: [],
          AQ: [],
          AS: [
            [2008, 'max', '-', 'Apr', 'Sun>=1', [2, 0, 0, 's'], 0, '-'],
            [2008, 'max', '-', 'Oct', 'Sun>=1', [2, 0, 0, 's'], 60, '-'],
          ],
          AN: [
            [2008, 'max', '-', 'Apr', 'Sun>=1', [2, 0, 0, 's'], 0, '-'],
            [2008, 'max', '-', 'Oct', 'Sun>=1', [2, 0, 0, 's'], 60, '-'],
          ],
          NC: [],
          NZ: [
            [2007, 'max', '-', 'Sep', 'lastSun', [2, 0, 0, 's'], 60, 'D'],
            [2008, 'max', '-', 'Apr', 'Sun>=1', [2, 0, 0, 's'], 0, 'S'],
          ],
          Chatham: [
            [2007, 'max', '-', 'Sep', 'lastSun', [2, 45, 0, 's'], 60, 'D'],
            [2008, 'max', '-', 'Apr', 'Sun>=1', [2, 45, 0, 's'], 0, 'S'],
          ],
          WS: [
            [2012, 'max', '-', 'Apr', 'Sun>=1', [4, 0, 0, null], 0, '-'],
            [2012, 'max', '-', 'Sep', 'lastSun', [3, 0, 0, null], 60, 'D'],
          ],
          Tonga: [
            [2016, 'only', '-', 'Nov', 'Sun>=1', [2, 0, 0, null], 60, 'S'],
            [2017, 'only', '-', 'Jan', 'Sun>=15', [3, 0, 0, null], 0, 'S'],
          ],
          EU: [
            [1981, 'max', '-', 'Mar', 'lastSun', [1, 0, 0, 'u'], 60, 'S'],
            [1996, 'max', '-', 'Oct', 'lastSun', [1, 0, 0, 'u'], 0, '-'],
          ],
          'C-Eur': [
            [1981, 'max', '-', 'Mar', 'lastSun', [2, 0, 0, 's'], 60, 'S'],
            [1996, 'max', '-', 'Oct', 'lastSun', [2, 0, 0, 's'], 0, '-'],
          ],
          US: [
            [2007, 'max', '-', 'Mar', 'Sun>=8', [2, 0, 0, null], 60, 'D'],
            [2007, 'max', '-', 'Nov', 'Sun>=1', [2, 0, 0, null], 0, 'S'],
          ],
          Canada: [
            [2007, 'max', '-', 'Mar', 'Sun>=8', [2, 0, 0, null], 60, 'D'],
            [2007, 'max', '-', 'Nov', 'Sun>=1', [2, 0, 0, null], 0, 'S'],
          ],
          Mexico: [
            [2002, 'max', '-', 'Apr', 'Sun>=1', [2, 0, 0, null], 60, 'D'],
            [2002, 'max', '-', 'Oct', 'lastSun', [2, 0, 0, null], 0, 'S'],
          ],
          CR: [],
          Arg: [],
          Brazil: [
            [2008, 'max', '-', 'Oct', 'Sun>=15', [0, 0, 0, null], 60, 'S'],
            [2012, 'only', '-', 'Feb', 'Sun>=22', [0, 0, 0, null], 0, '-'],
            [2013, 2014, '-', 'Feb', 'Sun>=15', [0, 0, 0, null], 0, '-'],
            [2015, 'only', '-', 'Feb', 'Sun>=22', [0, 0, 0, null], 0, '-'],
            [2016, 2022, '-', 'Feb', 'Sun>=15', [0, 0, 0, null], 0, '-'],
          ],
          Chile: [
            [2012, 2014, '-', 'Apr', 'Sun>=23', [3, 0, 0, 'u'], 0, '-'],
            [2012, 2014, '-', 'Sep', 'Sun>=2', [4, 0, 0, 'u'], 60, 'S'],
            [2016, 'max', '-', 'May', 'Sun>=9', [3, 0, 0, 'u'], 0, '-'],
            [2016, 'max', '-', 'Aug', 'Sun>=9', [4, 0, 0, 'u'], 60, 'S'],
          ],
          CO: [],
          Para: [
            [2010, 'max', '-', 'Oct', 'Sun>=1', [0, 0, 0, null], 60, 'S'],
            [2010, 2012, '-', 'Apr', 'Sun>=8', [0, 0, 0, null], 0, '-'],
            [2013, 'max', '-', 'Mar', 'Sun>=22', [0, 0, 0, null], 0, '-'],
          ],
          Uruguay: [
            [2006, 'max', '-', 'Oct', 'Sun>=1', [2, 0, 0, null], 60, 'S'],
            [2007, 'max', '-', 'Mar', 'Sun>=8', [2, 0, 0, null], 0, '-'],
          ],
        },
      })

      /**
       * Converts a Date object from one time zone to another using the timezoneJS.Date library
       * @param  {date} dt                    Original JavaScript Date object, from the original time zone
       * @param  {string} originalTimeZone    The original time zone
       * @param  {string} targetTimeZone      The target time zone
       * @return {date}            The date in the target timezone. This is a timezoneJS.Date which behaves the same as a native Date.
       * @memberof CIQ
       */
      CIQ.convertTimeZone = function(dt, originalTimeZone, targetTimeZone) {
        // Convert from original timezone to local time
        var newDT = new _exports.timezoneJS.Date(
          dt.getFullYear(),
          dt.getMonth(),
          dt.getDate(),
          dt.getHours(),
          dt.getMinutes(),
          dt.getSeconds(),
          dt.getMilliseconds(),
          originalTimeZone
        )

        // Convert from local time to new timezone
        newDT.setTimezone(targetTimeZone)
        return newDT
      }

      /**
       * This method converts a time from another timezone to local time on the browser
       * @param  {date} dt               The original time
       * @param  {string} originalTimeZone A valid timezone
       * @return {date}                  The date converted to local time
       * @memberof CIQ
       */
      CIQ.convertToLocalTime = function(dt, originalTimeZone) {
        var seconds = dt.getSeconds()
        var milliseconds = dt.getMilliseconds()
        var newDT = new _exports.timezoneJS.Date(
          dt.getFullYear(),
          dt.getMonth(),
          dt.getDate(),
          dt.getHours(),
          dt.getMinutes(),
          originalTimeZone
        )
        return new Date(newDT.getTime() + seconds * 1000 + milliseconds)
      }

      return _exports
    }

  var __utility_ =
    //-------------------------------------------------------------------------------------------
    // Copyright 2012-2017 by ChartIQ, Inc.
    // All rights reserved
    //-------------------------------------------------------------------------------------------
    // Be sure your webserver is set to deliver UTF-8 charset
    // For apache add "AddDefaultCharset UTF-8" to httpd.conf
    // otherwise use \u unicode escapes for non-ascii characters
    function(_exports) {
      // Node.js compatibility
      if (typeof global !== 'undefined') {
        if (typeof global.CanvasRenderingContext2D === 'undefined')
          global.CanvasRenderingContext2D = function() {}
      }

      /**
       * Shorthand for getElementById(). Equivalent to prototype style $() which is faster but less powerful than jquery style $()
       * @param  {string} id     An ID tag for a valid DOM object
       * @param  {object} [source] - An optional valid DOM node to search within. If not provided then the entire document will be searched.
       * @return {object}        The DOM node associated with the id or null if it is not found
       * @name  $$
       * @function
       */
      function $$(id, source) {
        if (!source) return document.getElementById(id)
        if (source.id == id) return source // Found it!
        if (!source.hasChildNodes) return null
        for (var i = 0; i < source.childNodes.length; i++) {
          var element = $$(id, source.childNodes[i])
          if (element) return element
        }
        return null
      }
      _exports.$$ = $$

      /**
       * Functional equivalent of querySelector(). Functionally equivalent to jquery $().
       * This uses querySelectorAll in order to maintain compatibility with IE 9.
       * Note that if multiple objects match the selector then only the first will be returned.
       * @param  {string} selector - CSS style selector
       * @param  {object} [source]   Optional node to select within. If not provided then entire document will be searched.
       * @return {object}          The first object to match the selector
       * @name  $$$
       * @function
       */
      function $$$(selector, source) {
        if (!source) source = document
        return source.querySelectorAll(selector)[0] // We use querySelectorAll for backward compatibility with IE
      }
      _exports.$$$ = $$$

      /**
       * Capitalizes the first letter of a string
       * @return {string} Capitalized version of the string
       */
      String.prototype.capitalize = function() {
        return this.charAt(0).toUpperCase() + this.slice(1)
      }

      if (!Function.prototype.ciqInheritsFrom) {
        /**
         * Template for JavaScript inheritence.
         * @param {object} parentClassOrObject The parent class or object
         * @param {boolean} [autosuper=true] Set to false to prevent the base class constructor from being called automatically
         */
        Function.prototype.ciqInheritsFrom = function(
          parentClassOrObject,
          autosuper
        ) {
          if (autosuper !== false) {
            this.prototype = new parentClassOrObject()
          } else {
            this.prototype = Object.create(parentClassOrObject)
            for (var key in parentClassOrObject.prototype) {
              this.prototype[key] = parentClassOrObject.prototype[key]
            }
          }
          this.prototype.constructor = this
          this.prototype.parent = parentClassOrObject.prototype
        }
        Function.prototype.stxInheritsFrom = Function.prototype.ciqInheritsFrom // backward compatiblity
      }

      /**
       * The built-in 2D rendering context for the drawing surface of a {@link external:canvas}.
       * @external CanvasRenderingContext2D
       * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D CanvasRenderingContext2D at the Mozilla Developer Network}
       */

      /**
       * Dashed line polyfill for the canvas. Note that dashed lines are expensive operations when not supported natively! @see CanvasRenderingContext2D.stxLine
       * @param {number} fromX Starting point of the X-axis
       * @param {number} fromY Starting point of the Y-axis
       * @param {number} toX Destination on the X-axis
       * @param {number} toY Destination on the Y-axis
       * @param {string[]} pattern Array of stroke patterns.
       * @memberof external:CanvasRenderingContext2D
       */
      CanvasRenderingContext2D.prototype.dashedLineTo = function(
        fromX,
        fromY,
        toX,
        toY,
        pattern
      ) {
        // Error check.
        if (!(pattern instanceof Array)) {
          if (pattern)
            console.log(
              'WARNING: Unsupported drawing pattern "' +
                pattern +
                '"; defaulting to "solid"'
            )
          this.stxLine(
            fromX,
            fromY,
            toX,
            toY,
            this.strokeStyle,
            this.globalAlpha,
            this.lineWidth
          )
          return
        }

        // can't dash if we do not have proper values
        if (
          fromY === Infinity ||
          fromX === Infinity ||
          toY === Infinity ||
          toX === Infinity
        )
          return

        // Our growth rate for our line can be one of the following:
        // (+,+), (+,-), (-,+), (-,-)
        // Because of this, our algorithm needs to understand if the x-coord and
        // y-coord should be getting smaller or larger and properly cap the
        // values
        // based on (x,y).
        var lt = function(a, b) {
          return a - b <= 0.00000001
        }
        var gt = function(a, b) {
          return a - b >= -0.00000001
        }
        var capmin = function(a, b) {
          return Math.min(a, b)
        }
        var capmax = function(a, b) {
          return Math.max(a, b)
        }

        var checkX = { thereYet: gt, cap: capmin }
        var checkY = { thereYet: gt, cap: capmin }

        if (fromY - toY > 0) {
          checkY.thereYet = lt
          checkY.cap = capmax
        }
        if (fromX - toX > 0) {
          checkX.thereYet = lt
          checkX.cap = capmax
        }

        this.moveTo(fromX, fromY)
        if (isNaN(fromX) || isNaN(fromY)) return
        var offsetX = fromX
        var offsetY = fromY
        var idx = 0,
          dash = true
        while (
          !(checkX.thereYet(offsetX, toX) && checkY.thereYet(offsetY, toY))
        ) {
          var ang = Math.atan2(toY - fromY, toX - fromX)
          var len = pattern[idx]

          offsetX = checkX.cap(toX, offsetX + Math.cos(ang) * len)
          offsetY = checkY.cap(toY, offsetY + Math.sin(ang) * len)

          if (dash) this.lineTo(offsetX, offsetY)
          else this.moveTo(offsetX, offsetY)

          idx = (idx + 1) % pattern.length
          dash = !dash
        }
      }

      /**
       * Convenience function for rendering lines of various types on the canvas.
       * @param {number} fromX Starting point of the X-axis
       * @param {number} fromY Starting point of the Y-axis
       * @param {number} toX Destination on the X-axis
       * @param {number} toY Destination on the Y-axis
       * @param {string} color CSS-compatible color, such as hex, rgb, rgba or even color names such as `orange`.
       * @param {number} opacity The alpha. A number between 0 and 1.
       * @param {number} lineWidth The line width in pixels.
       * @param {number[]} [pattern] An array that contains the number of pixels on and then the number of pixels off.
       *		For instance [1,1] would create a dotted pattern by turning one pixel on and then one pixel off repeatedly.
       * @memberof external:CanvasRenderingContext2D
       */
      CanvasRenderingContext2D.prototype.stxLine = function(
        fromX,
        fromY,
        toX,
        toY,
        color,
        opacity,
        lineWidth,
        pattern
      ) {
        this.beginPath()
        this.lineWidth = lineWidth
        this.strokeStyle = color
        this.globalAlpha = opacity
        if (pattern && pattern.length) {
          this.dashedLineTo(fromX, fromY, toX, toY, pattern)
        } else {
          this.moveTo(fromX, fromY)
          this.lineTo(toX, toY)
        }
        this.stroke()
        this.closePath()
        this.lineWidth = 1
      }

      /**
       * Add native circle drawing to the canvas
       * @param  {number} x      X position of center of circle
       * @param  {number} y      Y position of center of circle
       * @param  {number} radius Radius of circle
       * @param  {boolean} filled If true then circle will be filled
       * @memberof external:CanvasRenderingContext2D
       */
      CanvasRenderingContext2D.prototype.stxCircle = function(
        x,
        y,
        radius,
        filled
      ) {
        this.beginPath()
        this.arc(x, y, radius, 0, 2 * Math.PI, false)
        if (filled) this.fill()
        this.stroke()
        this.closePath()
      }

      /* Easing cubics from
	http://gizma.com/easing/#expo1
	t = current time (t should move from zero to d)
	b = starting value
	c = change in value (b + c = ending value )
	d = duration
	*/

      Math.easeInOutQuad = function(t, b, c, d) {
        t /= d / 2
        if (t < 1) return (c / 2) * t * t + b
        t--
        return (-c / 2) * (t * (t - 2) - 1) + b
      }

      Math.easeInOutCubic = function(t, b, c, d) {
        t /= d / 2
        if (t < 1) return (c / 2) * t * t * t + b
        t -= 2
        return (c / 2) * (t * t * t + 2) + b
      }

      Math.easeOutCubic = function(t, b, c, d) {
        t /= d
        t--
        return c * (t * t * t + 1) + b
      }

      /**
       * Base namespace for CIQ library
       *
       * Previously `STX`
       * @name CIQ
       * @namespace
       */
      function CIQ() {}
      _exports.CIQ = CIQ
      _exports.STX = CIQ // backward compatibility

      var nav = typeof navigator !== 'undefined' ? navigator : { userAgent: '' }
      var userAgent = nav.userAgent
      var win = typeof window !== 'undefined' ? window : {}
      var doc = typeof document !== 'undefined' ? document : {}
      /**
       * READ ONLY. Will be 'true' if the chart is running on an iPad
       * @memberof CIQ
       * @type boolean
       */
      CIQ.ipad = userAgent.indexOf('iPad') != -1
      /**
       * READ ONLY. Will be 'true' if the chart is running on an iPhone
       * @memberof CIQ
       * @type boolean
       */
      CIQ.iphone = userAgent.indexOf('iPhone') != -1
      /**
       * READ ONLY. Will be 'true' if the chart is running on a MS Surface like device
       * @memberof CIQ
       * @type boolean
       */
      CIQ.isSurface = nav.msMaxTouchPoints && nav.msMaxTouchPoints > 1
      /**
       * READ ONLY. Will be 'true' if the chart is running on a touch capable device
       * @memberof CIQ
       * @type boolean
       */
      CIQ.touchDevice = typeof doc.ontouchstart != 'undefined' || CIQ.isSurface
      /**
       * READ ONLY. Will be 'true' if the chart is running on a Chrome browser
       * @memberof CIQ
       * @type boolean
       */
      CIQ.is_chrome = userAgent.toLowerCase().indexOf('chrome') > -1
      /**
       * READ ONLY. Will be 'true' if the chart is running on an Android OS device
       * @memberof CIQ
       * @type boolean
       */
      CIQ.isAndroid = userAgent.toLowerCase().indexOf('android') > -1
      /**
       * READ ONLY. Will be 'true' if the chart is running on a IE browser
       * @memberof CIQ
       * @type boolean
       */
      CIQ.isIE =
        userAgent.toLowerCase().indexOf('msie') > -1 ||
        userAgent.indexOf('Trident/') > -1
      /**
       * READ ONLY. Will be 'true' if the chart is running on a Edge browser
       * @memberof CIQ
       * @type boolean
       */
      CIQ.isEdge = userAgent.indexOf('Edge/') > -1
      /**
       * READ ONLY. Will be 'true' if the chart is running on a IE 9 browser
       * @memberof CIQ
       * @type boolean
       */
      CIQ.isIE9 =
        userAgent.indexOf('Trident/5') > -1 ||
        userAgent.indexOf('MSIE 9.0') > -1
      /**
       * READ ONLY. Will be 'true' if the chart is running on a IE 8 browser
       * @memberof CIQ
       * @type boolean
       */
      CIQ.isIE8 = win.isIE8 || userAgent.indexOf('MSIE 8.0') > -1
      /**
       * READ ONLY. Will be 'true' if the chart is running on an iOS 7 device
       * @memberof CIQ
       * @type boolean
       */
      CIQ.isIOS7 = userAgent.match(/(iPad|iPhone);.*CPU.*OS 7_\d/i)
      /**
       * READ ONLY. Will be 'true' if the chart is running on an iOS 8 device
       * @memberof CIQ
       * @type boolean
       */
      CIQ.isIOS8 = userAgent.match(/(iPad|iPhone);.*CPU.*OS 8_\d/i)
      /**
       * READ ONLY. Will be 'true' if the chart is running on an iOS 9 device
       * @memberof CIQ
       * @type boolean
       */
      CIQ.isIOS9 = userAgent.match(/(iPad|iPhone);.*CPU.*OS 9_\d/i)
      /**
       * READ ONLY. Will be 'true' if the chart is running on an iOS 10 device
       * @memberof CIQ
       * @type boolean
       */
      CIQ.isIOS10 = userAgent.match(/(iPad|iPhone);.*CPU.*OS 10_\d/i)
      /**
       * READ ONLY. Will be 'true' if the chart is running on an IOS7, IOS8, IOS9 or IOS10 device
       * @memberof CIQ
       * @type boolean
       */
      CIQ.isIOS7or8 = CIQ.isIOS7 || CIQ.isIOS8 || CIQ.isIOS9 || CIQ.isIOS10
      /**
       * READ ONLY. Will be 'true' if the chart is running on a mobile device ( CIQ.isAndroid, CIQ.ipad, or CIQ.iphone )
       * @memberof CIQ
       * @type boolean
       */
      CIQ.isMobile = CIQ.isAndroid || CIQ.ipad || CIQ.iphone
      /**
       * READ ONLY. Will be 'true' if the chart is running from a MS Surface application
       * @memberof CIQ
       * @type boolean
       */
      CIQ.isSurfaceApp = win.MSApp
      /**
       * READ ONLY. Will be 'true' if the chart is running from a device with no Keyboard ( CIQ.ipad, CIQ.iphone, CIQ.isAndroid or  CIQ.isSurfaceApp )
       * @memberof CIQ
       * @type boolean
       */
      CIQ.noKeyboard =
        CIQ.ipad || CIQ.iphone || CIQ.isAndroid || CIQ.isSurfaceApp
      CIQ.wheelEvent =
        'wheel' in document.createElement('div') || 'onwheel' in document
          ? 'wheel'
          : document.onmousewheel !== undefined
          ? 'mousewheel'
          : 'DOMMouseScroll'
      if (CIQ.isIE) CIQ.wheelEvent = 'wheel'

      /**
       * Returns the log base 10 of a value
       * @param  {number} y The value
       * @return {number}   log10 value
       * @memberof CIQ
       */
      CIQ.log10 = function(y) {
        return Math.log(y) / Math.LN10
      }

      /**
       * Deletes the map entries for which the right hand side is the object in question.
       * @param  {object} map    JavaScript map object
       * @param  {object} object The actual object to be deleted from the map
       * @return {boolean}        Returns true if any object actually deleted
       * @memberof CIQ
       */
      CIQ.deleteRHS = function(map, object) {
        var deletedOne = false
        for (var i in map) {
          if (map[i] == object) {
            delete map[i]
            deletedOne = true
          }
        }
        return deletedOne
      }

      /**
       * Deletes (removes) nulls or undefined fields (names) from an object. This is useful when marshalling (saving) an object where you don't wish
       * null or undefined values to show up in the marshalled object (such as when converting to JSON)
       * @param  {object} obj         The object to scrub
       * @param  {boolean} [removeNulls] Whether or not to remove null values
       * @memberof CIQ
       */
      CIQ.scrub = function(obj, removeNulls) {
        for (var i in obj) {
          if (typeof obj[i] == 'undefined') delete obj[i]
          if (removeNulls && obj[i] === null) delete obj[i]
        }
      }

      /**
       * This method changes the target object's contents to match the contents of the source object. This is functionally equivalent
       * to `target=source` except that it preserves the existence of the target object. This is vitally important if there are data bindings
       * to the target object otherwise those data bindings would remain attached to a phantom object! The logic here is orchestrated so that you
       * will receive update, add and delete notifications for each field that changes.
       * @param {object} target The target object
       * @param {object} source The source object
       * @memberof CIQ
       * @since 2015-11-1
       */
      CIQ.dataBindSafeAssignment = function(target, source) {
        /*for(var prop in source) {
			target[prop]=source[prop];
		}*/
        CIQ.extend(target, source)
        for (var prop in target) {
          if (typeof source[prop] == 'undefined') {
            delete target[prop]
          }
        }
      }

      /**
       * Clones an object. This function creates a deep (recursive) clone of an object. The object can be a primitive or an object or an array.
       * Note that cloning objects that reference DOM nodes can result in stack overflows. Use with caution.
       * @param  {object} from The source object
       * @param  {object} [to]   Optional existing object of same type. Can improve performance when objects are reusable.
       * @return {object}      A deep clone of the "from" object
       * @memberof CIQ
       */
      CIQ.clone = function(from, to) {
        if (from === null || typeof from != 'object') return from
        var c = from.constructor
        if (
          c == Date ||
          c == RegExp ||
          c == Function ||
          c == String ||
          c == Number ||
          c == Boolean
        )
          return new from.constructor(from)

        to = to || new from.constructor()

        for (var n in from) {
          to[n] = typeof to[n] == 'undefined' ? CIQ.clone(from[n], null) : to[n]
        }

        return to
      }

      /**
       * Non recursive clone. This will only clone the top layer and is safe to use when objects contain DOM nodes.
       * @param  {object} from - Object to be cloned
       * @return {object}      A shallow clone of the "from" object
       * @memberof CIQ
       */
      CIQ.shallowClone = function(from) {
        if (!from) return from
        var to
        if (from.constructor == Array) {
          to = new Array(from.length)
          for (var i = 0; i < from.length; i++) {
            to[i] = from[i]
          }
          return to
        }
        to = {}
        for (var field in from) {
          to[field] = from[field]
        }
        return to
      }

      /**
       * Extends an object, similar to jquery.extend() with a deep copy
       * @param {object} target Target object
       * @param  {object} source Original object
       * @param {boolean} [shallow] If true then extend will not recurse through objects
       * @return {object} Target object after extension
       * @since 5.1.0 undefined properties do not copy to target object
       * @memberof CIQ
       */
      CIQ.extend = function(target, source, shallow) {
        for (var field in source) {
          var datum = source[field]
          if (datum === undefined) continue
          else if (datum === null) target[field] = datum
          else if (datum.constructor == Object) {
            if (!target[field]) target[field] = {}
            if (shallow) {
              target[field] = source[field]
            } else {
              if (target[field].constructor != Object) target[field] = {}
              CIQ.extend(target[field], source[field])
            }
          } else if (datum.constructor == Array) {
            target[field] = datum.slice()
          } else {
            target[field] = datum
          }
        }
        return target
      }

      /**
       * Accepts a default parameters object and sets the field values for the target *only if they are missing*.
       * Note that a value of null will not be overridden. Only undefined (missing) values will be overridden.
       * @param  {object} target The object needing potential default values
       * @param  {object} defaults Default values
       * @return {object}        Returns the modified target object
       * @since  3.0.0
       * @example
       * var target={"color":"red"};
       * var defaults={"color":"blue", "shape":"triangle"};
       * CIQ.ensureDefaults(target, defaults);
       * >> target==={"color":"red", "shape":"triangle"};
       * @memberof CIQ
       */
      CIQ.ensureDefaults = function(target, defaults) {
        for (var field in defaults) {
          if (typeof target[field] == 'undefined')
            target[field] = defaults[field]
        }
        return target
      }

      /**
       * Returns true if the objects are an exact match
       * @param  {object} a First object
       * @param  {object} b Second object
       * @param  {object} [exclude] Exclude these fields
       * @return {boolean}   True if they are an exact match
       * @memberof CIQ
       */
      CIQ.equals = function(a, b, exclude) {
        if (!a && b) return false
        if (a && !b) return false
        if (typeof a !== typeof b) return false
        for (var field in a) {
          if (exclude && exclude[field]) continue
          if (typeof a[field] === 'object') {
            var result = CIQ.equals(a[field], b[field])
            if (!result) return false
            continue
          }
          if (b[field] != a[field]) return false
        }
        return true
      }

      /**
       * Returns true if an object has no members
       * @param  {object}  o A JavaScript object
       * @return {boolean}   True if there are no members in the object
       * @memberof CIQ
       */
      CIQ.isEmpty = function(o) {
        for (var p in o) {
          if (o.hasOwnProperty(p)) {
            return false
          }
        }
        return true
      }

      /**
       * Convenience function returns the first property in an object. Note that while this works in all known browsers
       * the EMCA spec does not guarantee that the order of members in an object remain static. This method should therefore
       * be avoided. When ordering is important use an Array!
       * @param  {object} o A JavaSCript object
       * @return {object}   The first element in the object or null if it is empty
       * @memberof CIQ
       */
      CIQ.first = function(o) {
        for (var p in o) {
          return p
        }
        return null
      }

      /**
       * Convenience function for returning the last property in an object. Note that while this works in all known browsers
       * the EMCA spec does not guarantee that the order of members in an object remain static. This method should therefore
       * be avoiding. When ordering is important use an Array!
       * @param  {object} o A JavaScript object
       * @return {object}   The final member of the object or null if the object is empty
       * @memberof CIQ
       */
      CIQ.last = function(o) {
        var l = null
        for (var p in o) {
          l = p
        }
        return l
      }

      /**
       * Returns the number of members in an object
       * @param  {object} o A valid JavaScript object
       * @return {number}   The number of members in the object
       * @memberof CIQ
       */
      CIQ.objLength = function(o) {
        if (!o) return 0
        var i = 0
        for (var p in o) {
          i++
        }
        return i
      }

      /**
       * Given a dot notation string, we want to navigate to the location
       * in a base object, creating the path along the way
       * @param  {object} base      Base object.
       * @param  {string} extension String in dot notation
       * @return {object}           A tuple containing obj and member
       * @memberof CIQ
       * @since  2015-11-1
       * @example
       * var tuple=CIQ.deriveFromObjectChain(stx.layout, "pandf.box");
       * tuple.obj===stx.layout.pandf
       * tuble.member==="box"
       * tuple.obj[tuple.member]=3;  // stx.layout.pandf.box=3
       */
      CIQ.deriveFromObjectChain = function(base, extension) {
        // Which way is faster?
        //if(!(new RegExp(extension)).test(".")){
        if (extension.indexOf('.') == -1) {
          return { obj: base, member: extension }
        }
        var objectString = extension.split('.')
        for (var i = 0; i < objectString.length - 1; i++) {
          var objStr = objectString[i]
          if (!base[objStr] && base[objStr] !== 0) base[objStr] = {}
          base = base[objStr]
        }
        return { obj: base, member: objectString[i] }
      }

      /**
       * Create arrow notation strings (field-->property) of a given field and an array of properties
       * Used to create a set of object properties in string format for later use by CIQ.existsInObjectChain
       * It's main use is to pass field names into {@link CIQ.ChartEngine#determineMinMax}.
       * @param  {string} field      Base object.
       * @param  {array} properties 	Array of strings representing properties
       * @return {array}           Array of object properties expressed in arrow notation (field-->property)
       * @memberof CIQ
       * @since  5.1.0
       * @example
       * var fields=CIQ.createObjectChainNames("ABC.D",["High","Low"]);
       * fields===["ABC.D-->High","ABC.D-->Low"]
       */
      CIQ.createObjectChainNames = function(field, properties) {
        var ret = []
        for (var p = 0; p < properties.length; p++) {
          ret.push(field + '-->' + properties[p])
        }
        return ret
      }

      /**
       * Given an arrow notation string (a-->b-->c), we want to navigate to the location
       * in a base object, to see if it exists
       * @param  {object} base      Base object.
       * @param  {string} extension String in arrow notation
       * @return {object}           A tuple containing obj and member; a null will be returned if path does not exist
       * @memberof CIQ
       * @since  5.1.0
       * @example
       * var tuple=CIQ.existsInObjectChain(stx.dataSegment[0], "ABC.D-->High");
       * tuple.obj===stx.dataSegment[0]["ABC.D"]
       * tuple.member==="High"
       * tuple.obj[tuple.member]=28.7;  // stx.dataSegment[0]["ABC.D"].High=28.7
       */
      CIQ.existsInObjectChain = function(base, extension) {
        // Which way is faster?
        //if(!(new RegExp(extension)).test(".")){
        if (extension.indexOf('-->') == -1) {
          if (!base[extension] && base[extension] !== 0) return null
          return { obj: base, member: extension }
        }
        var objectString = extension.split('-->')
        var objStr
        for (var i = 0; i < objectString.length - 1; i++) {
          objStr = objectString[i]
          if (!base[objStr] && base[objStr] !== 0) return null
          base = base[objStr]
        }
        objStr = objectString[i]
        if (!base[objStr] && base[objStr] !== 0) return null
        return { obj: base, member: objStr }
      }

      /**
       * Replacement for isPrototypeOf and instanceof so that both types of inheritance can be checked
       * @param {object} child The object instance to check
       * @param {object} parent Prototype
       * @return {boolean} True if the object is derived from the parent
       * @memberof CIQ
       * @since 07/01/2015
       */
      CIQ.derivedFrom = function(child, parent) {
        if (parent.isPrototypeOf(child)) return true
        if (child instanceof parent) return true
        return false
      }

      /**
       * This method will iterate through the object and replace all of the fields
       * using the mapping object. This would generally be used to compress an object
       * for serialization. so that for instance "lineWidth" becomes "lw". This method
       * is called recursively.
       * @param {object} obj Object to compress
       * @param {object} mapping Object containing name value pairs. Each name will be replaced with its corresponding value in the object.
       * @return {object} The newly compressed object
       * @memberof CIQ
       */
      CIQ.replaceFields = function(obj, mapping) {
        if (!obj) return obj
        var newObj = {}
        for (var field in obj) {
          var value = obj[field]
          var replaced = mapping[field]
          if (!replaced) replaced = field
          if (value && typeof value == 'object') {
            if (value.constructor == Array) {
              var arr = (newObj[replaced] = new Array(value.length))
              for (var i = 0; i < arr.length; i++) {
                var val = value[i]
                if (typeof val == 'object') {
                  arr[i] = CIQ.replaceFields(val, mapping)
                } else {
                  arr[i] = val
                }
              }
            } else {
              newObj[replaced] = CIQ.replaceFields(value, mapping)
            }
          } else {
            newObj[replaced] = value
          }
        }
        return newObj
      }

      /**
       * Returns an object copy with any null values removed
       * @param  {object} obj Object to remove nulls
       * @return {object}     Object with nulls removed
       * @memberof CIQ
       */
      CIQ.removeNullValues = function(obj) {
        var n = CIQ.clone(obj)
        for (var f in n) {
          if (!n[f]) delete n[f]
        }
        return n
      }

      /**
       * This method reverses the fields and values in an object
       * @param {object} obj Object to reverse
       * @return {object} The reversed object
       * @memberof CIQ
       * @example reverseObject({ one: "a", two: "b" }) // returns { a: "one", b: "two" }
       */
      CIQ.reverseObject = function(obj) {
        var newObj = {}
        for (var field in obj) {
          newObj[obj[field]] = field
        }
        return newObj
      }

      CIQ.camelCaseRegExp = /-([a-z])/g
      /**
       * Converts from hyphenated to camel case. Used primarily for converting css style names (which are hyphenated) to property values (which are camel case)
       * @param  {string} name Hyphenated style name
       * @return {string}		 Camel case style name
       * @memberof CIQ
       */
      CIQ.makeCamelCase = function(name) {
        return name.replace(CIQ.camelCaseRegExp, function(g) {
          return g[1].toUpperCase()
        })
      }

      /**
       * Appends a class name to a node if it isn't already there. This is frequently used to control dynamic behavior via CSS.
       * @example
       * // Apply an "active" css look to an object
       * CIQ.appendClassName(myNode, "active");
       * @param  {object} node      A valid DOM element
       * @param  {string} className Name of class to add to the DOM element
       * @memberof CIQ
       */
      CIQ.appendClassName = function(node, className) {
        if (node.className == className) return // already a class
        var s = node.className.split(' ')
        for (var i = 0; i < s.length; i++) {
          if (s[i] == className) return // already a class
        }
        if (!node.className) node.className = className
        else node.className += ' ' + className
      }

      /**
       * Removes a class name from a node if it is set
       * @param  {object} node      A valid DOM element
       * @param  {string} className The class name to remove
       * @memberof CIQ
       */
      CIQ.unappendClassName = function(node, className) {
        if (!node) return
        if (node.className.indexOf(className) == -1) return
        if (node.className == className) {
          node.className = ''
        } else {
          var s = node.className.split(' ')
          var newClassName = ''
          for (var i = 0; i < s.length; i++) {
            if (s[i] == className) continue
            if (newClassName !== '') newClassName += ' '
            newClassName += s[i]
          }
          node.className = newClassName
        }
      }

      /**
       * Convenience method for swapping two class names within a node. Such as for changing state.
       * @param  {object} node         A valid DOM element
       * @param  {string} newClassName The class name to swap in
       * @param  {string} oldClassName The class name to swap out
       * @memberof CIQ
       */
      CIQ.swapClassName = function(node, newClassName, oldClassName) {
        CIQ.unappendClassName(node, oldClassName)
        CIQ.appendClassName(node, newClassName)
      }

      /**
       * Returns true if a class name is currently assigned to the DOM node
       * @param  {object}  node      A valid DOM element
       * @param  {string}  className The class name to search for
       * @return {boolean}           True if the class name is currently assigned to the DOM node
       * @memberof CIQ
       */
      CIQ.hasClassName = function(node, className) {
        if ((' ' + node.className + ' ').indexOf(' ' + className + ' ') > -1)
          return true
        return false
      }

      /**
       * Toggles the className on or off
       * @param  {HTMLElement} node      The node to toggle
       * @param  {string} className The class name to toggle
       * @memberof CIQ
       */
      CIQ.toggleClassName = function(node, className) {
        if (CIQ.hasClassName(node, className))
          CIQ.unappendClassName(node, className)
        else CIQ.appendClassName(node, className)
      }

      /**
       * Convenience function for dynamically creating a new node and appending it into the DOM.
       * @param  {object} div       The targeted parent node
       * @param  {string} tagName   The type of node to be created
       * @param  {string} [className] Optional class name to set the new node
       * @param {string} [txt] Optional text to insert
       * @return {object}           The new node
       * @memberof CIQ
       */
      CIQ.newChild = function(div, tagName, className, txt) {
        var div2 = document.createElement(tagName)
        if (className) div2.className = className
        div.appendChild(div2)
        if (txt) div2.innerHTML = txt
        return div2
      }

      /**
       * Microsoft RT disallows innerHTML that contains DOM elements. Use this method to override when necessary.
       * @param  {object} node A valid DOM element to change innerHTML
       * @param  {string} html The html text to change
       * @example
       * CIQ.innerHTML(node, "My innerHTML contains <span>a span</span> and MS RT doesn't like that");
       * @memberof CIQ
       */
      CIQ.innerHTML = function(node, html) {
        if (window.MSApp) {
          window.MSApp.execUnsafeLocalFunction(function() {
            node.innerHTML = html
          })
        } else {
          node.innerHTML = html
        }
      }

      /**
       * Microsoft surface bug requires a timeout in oreder for the cursor to show up in a focused
       * text box. iPad also, sometimes, when embedded in an iframe, so set useTimeout if in an iframe!
       * @param  {object} node       A DOM element to focus
       * @param  {number} useTimeout Whether to apply a timeout or not. If number then the number of milliseconds.
       * @memberof CIQ
       */
      CIQ.focus = function(node, useTimeout) {
        if (CIQ.isSurface || useTimeout) {
          var timeout = 0
          if (!isNaN(parseInt(useTimeout, 10))) timeout = useTimeout
          setTimeout(function() {
            node.focus()
          }, timeout)
        } else {
          node.focus()
        }
      }

      /**
       * Reliable, cross-device blur method
       * @param  {HTMLElement} [node] The element to blur. If not supplied then document.activeElement will be blurred
       * @memberof CIQ
       */
      CIQ.blur = function(node) {
        if (!node) node = document.activeElement
        if (node) node.blur()
        window.focus()
      }
      /**
       * Find all nodes that match the given text. This is a recursive function so be careful not to start too high in the DOM tree.
       * @param  {object} startNode A valid DOM element from which to start looking
       * @param  {string} text      The text to search for
       * @return {array}           An array of nodes that match the text
       * @memberof CIQ
       */
      CIQ.findNodesByText = function(startNode, text) {
        if (startNode.innerHTML == text) return [startNode]
        var nodes = []
        for (var i = 0; i < startNode.childNodes.length; i++) {
          var pushNodes = CIQ.findNodesByText(startNode.childNodes[i], text)
          if (pushNodes) {
            nodes = nodes.concat(pushNodes)
          }
        }
        if (nodes.length) return nodes
        return null
      }

      /**
       * Hide nodes that match a certain text string.
       * @param  {object} startNode A valid DOM element from which to start looking
       * @param  {string} text      The text to match against
       * {@link  CIQ.findNodesByText}
       * @memberof CIQ
       */
      CIQ.hideByText = function(startNode, text) {
        var nodes = CIQ.findNodesByText(startNode, text)
        for (var i = 0; i < nodes.length; i++) {
          nodes[i].style.display = 'none'
        }
      }

      /**
       * Returns the width of a DOM element including left and right margins.
       * @param  {HTMLElement} node The DOM element to measure
       * @return {number}      The width including margins
       * @memberof CIQ
       */
      CIQ.outerWidth = function(node) {
        var width = node.offsetWidth
        width += CIQ.stripPX(getComputedStyle(node).marginLeft)
        width += CIQ.stripPX(getComputedStyle(node).marginRight)
        return width
      }

      /**
       * Removes all DOM elements in a given node. This is extremely useful when dynamically generating content.
       * @param  {object} node - The node to clear
       * @memberof CIQ
       */
      CIQ.clearNode = function(node) {
        if (node.hasChildNodes()) {
          while (node.childNodes.length >= 1) {
            node.removeChild(node.firstChild)
          }
        }
      }

      /**
       * Get the source element for a DOM event depending on browser type
       * @param  {object} [e] Event if available from browser
       * @return {object}   The DOM node that registered the event
       * @memberof CIQ
       */
      CIQ.getEventDOM = function(e) {
        if (!e) {
          return window.event.srcElement
        }
        return e.target
      }

      /**
       * Converts an onClick event to an ontouchend event. If the device is known to be a touch device then this can be used
       * to change onclick events that are set as attributes (in HTML). ontouchend events are more responsive than onclick events
       * and can improve the user experience. When coding for cross-device implementations it is recommended to use @see CIQ.safeClickTouch
       * programatically rather than using hardcoded attributes
       * @param  {string} id The id of a node containing an onClick attribute
       * @memberof CIQ
       */
      CIQ.convertClickToTouchEnd = function(id) {
        var node = $$(id)
        var s = node.getAttribute('onClick')
        if (s) {
          node.removeAttribute('onClick')
          node.setAttribute('onTouchEnd', s)
        }
      }

      /**
       * Returns the height of the page. It is aware of iframes and so will never return a value that is greater
       * than the value of the parent
       * @return {number} Height of page in pixels
       * @memberof CIQ
       */
      CIQ.pageHeight = function() {
        var h = window.innerHeight
        if (top != self) {
          try {
            if (h > parent.innerHeight) h = parent.innerHeight
          } catch (e) {}
        }
        return h
      }

      /**
       * Returns the width of the page. It is aware of iframes and so will never return a value that is greater
       * than the value of the parent
       * @return {number} Width of page in pixels
       * @memberof CIQ
       */
      CIQ.pageWidth = function() {
        var w = window.innerWidth
        if (top != self) {
          try {
            if (w > parent.innerWidth) w = parent.innerWidth
          } catch (e) {}
        }
        return w
      }

      /**
       * Strips the letters "px" from a string. This is useful for converting styles into absolutes.
       * @param  {string} text - String value with "px"
       * @return {number}      The numeric value
       * @example
       * var leftPosition=CIQ.stripPX(node2.style.left)
       * @memberof CIQ
       */
      CIQ.stripPX = function(text) {
        if (!text) return 0
        if (typeof text == 'number') return text
        return parseInt(text.substr(0, text.indexOf('p')), 10)
      }

      /**
       * Checks if two colors are the same.  Will compare alpha channel is provided as well.
       * @param  {string} color1 First color, in rgb, rgba, css hex, or literal format
       * @param  {string} color2 Second color, in rgb, rgba, css hex, or literal format
       * @return {boolean}       true if equivalent
       * @example
       * var isSame=CIQ.colorsEqual("rgba (255,255,255,0.3)", "#FFFFFF");
       * 		returns false
       * var isSame=CIQ.colorsEqual("rgba (255,255,255,1)", "#FFFFFF");
       * 		returns true
       * @memberof CIQ
       * @since 4.0.0
       */
      CIQ.colorsEqual = function(color1, color2) {
        if (color1 == color2) return true
        if (!color1 && !color2) return true
        if (!color1 || !color2) return false
        if (color1 == 'transparent') color1 = 'rgba(0,0,0,0)'
        if (color2 == 'transparent') color2 = 'rgba(0,0,0,0)'
        var alpha = /^rgba\(.*,(.+)\)/
        var rgba1 = color1.match(alpha)
        var rgba2 = color2.match(alpha)
        rgba1 = rgba1 ? parseFloat(rgba1[1]) : 1
        rgba2 = rgba2 ? parseFloat(rgba2[1]) : 1
        if (rgba1 != rgba2) return false

        var first = CIQ.colorToHex(color1)
        var second = CIQ.colorToHex(color2)
        return first.toLowerCase() == second.toLowerCase()
      }

      /**
       * Converts an rgb or rgba color to a hex color
       * @param  {string}	color The rgb or rgba color, such as in CSS format
       * @return {string}	The hex color. If "transparent" or no color is sent in, #000000 will be assumed
       * @example
       * var hexColor=CIQ.colorToHex("rgba (255,255,255,0.3)");
       * @memberof CIQ
       * @since 4.0.0 Converts 3 char hex (#FFC) to six characters (#FFFFCC)
       */
      CIQ.colorToHex = function(color) {
        if (!CIQ.colorToHexMapping) CIQ.colorToHexMapping = {}
        if (!color || color == 'transparent') color = '#000000'
        if (CIQ.colorToHexMapping[color]) return CIQ.colorToHexMapping[color]
        if (color.substr(0, 1) === '#') {
          if (color.length == 4) {
            color = CIQ.colorToHexMapping[color] =
              '#' +
              Array(3).join(color.substr(1, 1)) +
              Array(3).join(color.substr(2, 1)) +
              Array(3).join(color.substr(3, 1))
          }
          return color
        }
        var digits = /(.*?)rgb\((\d+), ?(\d+), ?(\d+)\)/.exec(color)
        if (!digits)
          digits = /(.*?)rgba\((\d+), ?(\d+), ?(\d+),.*\)/.exec(color)
        // Converts a color name to hex
        function toHex(color) {
          if (typeof document === 'undefined') return '#000000'
          var ta = $$('color_converter')
          if (!ta) {
            ta = document.createElement('textarea')
            ta.id = 'color_converter'
            ta.style.display = 'none'
            document.body.appendChild(ta)
          }
          ta.style.color = '#000000' //reset;
          ta.style.color = color
          var value
          if (!CIQ.isIE8) {
            value = getComputedStyle(ta).getPropertyValue('color')
            digits = /(.*?)rgb\((\d+), ?(\d+), ?(\d+)\)/.exec(value)
            if (digits) return CIQ.colorToHex(value)
            else if (value.substr(0, 1) === '#') return value
            return color
          }
          value = ta.createTextRange().queryCommandValue('ForeColor')
          value =
            ((value & 0x0000ff) << 16) |
            (value & 0x00ff00) |
            ((value & 0xff0000) >>> 16)
          value = value.toString(16)
          return '#000000'.slice(0, 7 - value.length) + value
        }
        if (!digits) {
          var hexResult = toHex(color)
          CIQ.colorToHexMapping[color] = hexResult
          return hexResult
        }

        var red = parseFloat(digits[2])
        var green = parseFloat(digits[3])
        var blue = parseFloat(digits[4])

        var rgb = blue | (green << 8) | (red << 16)
        var hexString = rgb.toString(16)
        // fill with leading 0 if not 6 digits.
        for (var i = hexString.length; i < 6; i++) {
          hexString = '0' + hexString
        }
        var s = digits[1] + '#' + hexString
        CIQ.colorToHexMapping[color] = s
        return s
      }

      /**
       * Converts color to rgba. This does not accept literal color names such as "black"
       * @param  {string} color The hex rgb or rgba color, such as in CSS format
       * @param  {number} opacity The 'alpha' value. Defaults to full opacity (100%)
       * @return {string}       The rgba color
       * @example
       * var rgba=CIQ.hexToRgba('rgb(0, 115, 186)');
       * var rgba=CIQ.hexToRgba('#0073BA');
       * @memberof CIQ
       */
      CIQ.hexToRgba = function(color, opacity) {
        if (!color || color == 'transparent') color = 'rgba(0,0,0,0)'
        if (color.substr(0, 4) === 'rgba') {
          var digits = /(.*?)rgba\((\d+), ?(\d+), ?(\d+), ?(\d*\.?\d*)\)/.exec(
            color
          )
          var a = digits[5]
          if (opacity || opacity === 0) a = opacity
          if (a > 1) a = a / 100
          return (
            'rgba(' +
            digits[2] +
            ',' +
            digits[3] +
            ',' +
            digits[4] +
            ',' +
            a +
            ')'
          )
        } else if (color.substr(0, 3) === 'rgb') {
          color = CIQ.colorToHex(color)
        }
        if (!opacity && opacity !== 0) opacity = 100 // default to full opacity
        if (opacity <= 1) opacity = opacity * 100 // handle decimal opacity (css style)

        color = color.replace('#', '')
        var r = parseInt(color.slice(0, 2), 16)
        var g = parseInt(color.slice(2, 4), 16)
        var b = parseInt(color.slice(4, 6), 16)

        if (isNaN(r) || isNaN(g) || isNaN(b)) {
          console.log('CIQ.hexToRgba: invalid hex :', color)
          return null
        }

        return 'rgba(' + r + ',' + g + ',' + b + ',' + opacity / 100 + ')'
      }

      /**
       * Converts a color to the internal format used by the browser. This allows
       * interchange of hex, rgb, rgba colors
       * @param  {string} color A CSS color
       * @return {string}       The native formatted color
       * @memberof CIQ
       */
      CIQ.convertToNativeColor = function(color) {
        var a = document.createElement('DIV')
        a.style.color = color
        a.style.display = 'none'
        document.body.appendChild(a)
        var c = getComputedStyle(a).color
        document.body.removeChild(a)
        return c
      }
      /**
       * Returns true if the color is transparent. In particular it checks rgba status. Note that the charting engine
       * often interprets transparent colors to mean that a color should be automatically determined based on the brightness
       * of the background.
       * @param  {string}  color The color (from CSS)
       * @return {boolean}       True if transparent
       * @memberof CIQ
       */
      CIQ.isTransparent = function(color) {
        if (!color) return false
        if (color == 'transparent') return true
        var digits = /(.*?)rgba\((\d+), ?(\d+), ?(\d+), ?(\d*\.?\d*)\)/.exec(
          color
        )
        if (digits === null) return false
        if (parseFloat(digits[5]) === 0) return true
        return false
      }

      /**
       * Converts a color from hex or rgb format to Hue, Saturation, Value. This does not accept literal color names such as "black"
       * @param  {string} color The color (from CSS)
       * @return {array}       [Hue, Saturation, Value], or null if invalid color.
       * @memberof CIQ
       */
      CIQ.hsv = function(color) {
        var hex = CIQ.colorToHex(color)
        if (hex.substr(0, 1) === '#') hex = hex.slice(1)
        // fill with leading 0 if not 6 digits.
        for (var i = hex.length; i < 6; i++) {
          hex = '0' + hex
        }
        var r = parseInt(hex.slice(0, 2), 16)
        var g = parseInt(hex.slice(2, 4), 16)
        var b = parseInt(hex.slice(4, 6), 16)
        var computedH = 0
        var computedS = 0
        var computedV = 0

        //remove spaces from input RGB values, convert to int
        r = parseInt(('' + r).replace(/\s/g, ''), 10)
        g = parseInt(('' + g).replace(/\s/g, ''), 10)
        b = parseInt(('' + b).replace(/\s/g, ''), 10)

        if (
          r === null ||
          g === null ||
          b === null ||
          isNaN(r) ||
          isNaN(g) ||
          isNaN(b)
        ) {
          console.log('CIQ.hsv: invalid color :', color)
          return null
        }
        if (r < 0 || g < 0 || b < 0 || r > 255 || g > 255 || b > 255) {
          return null
        }
        r = r / 255
        g = g / 255
        b = b / 255
        var minRGB = Math.min(r, Math.min(g, b))
        var maxRGB = Math.max(r, Math.max(g, b))

        // Black-gray-white
        if (minRGB == maxRGB) {
          computedV = minRGB
          return [0, 0, computedV]
        }

        // Colors other than black-gray-white:
        var d = r == minRGB ? g - b : b == minRGB ? r - g : b - r
        var h = r == minRGB ? 3 : b == minRGB ? 1 : 5
        computedH = 60 * (h - d / (maxRGB - minRGB))
        computedS = (maxRGB - minRGB) / maxRGB
        computedV = maxRGB
        return [computedH, computedS, computedV]
      }

      CIQ.hsl = function(color) {
        var hex = CIQ.colorToHex(color)
        if (hex.substr(0, 1) === '#') hex = hex.slice(1)
        // fill with leading 0 if not 6 digits.
        for (var i = hex.length; i < 6; i++) {
          hex = '0' + hex
        }
        var r = parseInt(hex.slice(0, 2), 16)
        var g = parseInt(hex.slice(2, 4), 16)
        var b = parseInt(hex.slice(4, 6), 16)

        r /= 255
        g /= 255
        b /= 255
        var max = Math.max(r, g, b),
          min = Math.min(r, g, b)
        var h,
          s,
          l = (max + min) / 2

        if (max == min) {
          h = s = 0 // achromatic
        } else {
          var d = max - min
          s = l > 0.5 ? d / (2 - max - min) : d / (max + min)
          switch (max) {
            case r:
              h = (g - b) / d + (g < b ? 6 : 0)
              break
            case g:
              h = (b - r) / d + 2
              break
            case b:
              h = (r - g) / d + 4
              break
          }
          h /= 6
        }

        return [h, s, l]
      }

      /**
       * Chooses either a white or black foreground color depending on the "lightness" of the background color. Note that this simply
       * checks if the value is above .5 which works well but not ideally for red colors which the human eye interprets differently.
       * More complex algorithms are available but chartists rarely use red as a background color.
       * @param  {string} backgroundColor The background color (CSS format)
       * @return {string}                 Either #000000 (black) or #FFFFFF (white) depending on will look best on the given background color
       * @memberof CIQ
       */
      CIQ.chooseForegroundColor = function(backgroundColor) {
        /*var hex=CIQ.colorToHex(backgroundColor);
		var r=parseInt(hex.slice(1,3),16);
		var g=parseInt(hex.slice(3,5),16);
		var b=parseInt(hex.slice(5,7),16);
		if(r+g+b>318) return "#000000";*/
        var hsl = CIQ.hsl(backgroundColor)
        var l = hsl[2]
        if (l >= hsl[0]) return '#000000'
        //if(l && l>0.5) return "#000000";
        return '#FFFFFF'
      }

      /**
       * Convert a pattern type to an array useful for setting the context.setLineDash
       * @param {number} [width=1] A valid lineWidth from 1
       * @param {string} [pattern=solid] A valid pattern (solid, dotted, dashed)
       * @return {array} The array representing pixels of draw/skip etc.  Use it as argument to context.setLineDash()
       * @memberof CIQ
       * @since 4.0.0
       */
      CIQ.borderPatternToArray = function(width, pattern) {
        if (!pattern) return []
        if (pattern instanceof Array) return pattern
        if (pattern == 'dotted') return [width, width]
        if (pattern == 'dashed') return [width * 5, width * 5]
        if (pattern != 'solid' && pattern != 'none')
          console.log(
            'Unsupported pattern "' + pattern + '"; defaulting to "solid"'
          )
        return []
      }

      /**
       * Gets the background color of an element by traversing up the parent stack.
       * @param  {HTMLElement} el The element to examine
       * @return {string}    The background color
       * @memberof CIQ
       */
      CIQ.getBackgroundColor = function(el) {
        var bgColor = null
        while (!bgColor || CIQ.isTransparent(bgColor)) {
          var cStyle = getComputedStyle(el)
          if (!cStyle) return
          bgColor = cStyle.backgroundColor
          if (CIQ.isTransparent(bgColor)) bgColor = 'transparent'
          el = el.parentNode
          if (!el || !el.tagName) break
        }
        if (!bgColor || bgColor == 'transparent') bgColor = '#FFFFFF'
        return bgColor
      }

      CIQ.yyyymmddhhmmssmmmrx = new RegExp('\\d{17}')

      /**
       * Converts a string form date into a JavaScript Date object with time. Supports various standard date formats
       * @param  {string} dt String form of a date (such as yyyymmddhhmm, yyyy-mm-dd hh:mm, etc)
       * @return {date}    A JavaScript Date object
       * @memberof CIQ
       */
      CIQ.strToDateTime = function(dt) {
        if (!dt || dt.getFullYear) return dt //if passing in a JS date, return it.
        var myDateArray = []
        var y, m, d, h, mn, sc, ms
        if (dt.length == 12) {
          // yyyymmddhhmm
          y = parseFloat(dt.substring(0, 4))
          m = parseFloat(dt.substring(4, 6)) - 1
          d = parseFloat(dt.substring(6, 8))
          h = parseFloat(dt.substring(8, 10))
          mn = parseFloat(dt.substring(10, 12))
          return new Date(y, m, d, h, mn, 0, 0)
        } else if (CIQ.yyyymmddhhmmssmmmrx.test(dt)) {
          y = parseFloat(dt.substring(0, 4))
          m = parseFloat(dt.substring(4, 6)) - 1
          d = parseFloat(dt.substring(6, 8))
          h = parseFloat(dt.substring(8, 10))
          mn = parseFloat(dt.substring(10, 12))
          sc = parseFloat(dt.substring(12, 14))
          ms = parseFloat(dt.substring(14, 17))
          return new Date(y, m, d, h, mn, sc, ms)
        }
        var lr = [dt]
        var t = dt.indexOf('T')
        if (t != -1) {
          var afterT = dt.substring(t)
          if (
            !CIQ.isIE8 &&
            (afterT.indexOf('Z') != -1 ||
              afterT.indexOf('-') != -1 ||
              afterT.indexOf('+') != -1)
          ) {
            return new Date(dt) // utc time if it contains actual timezone information
          }
          lr = dt.split('T')
        } else if (dt.indexOf(' ') != -1) lr = dt.split(' ')

        if (lr[0].indexOf('/') != -1) myDateArray = lr[0].split('/')
        else if (lr[0].indexOf('-') != -1) myDateArray = lr[0].split('-')
        else return CIQ.strToDate(dt) //give up, maybe it's just a date

        var year = parseFloat(myDateArray[2], 10)
        if (myDateArray[0] && myDateArray[0].length == 4) {
          // YYYY-MM-DD
          year = parseFloat(myDateArray[0], 10)
          myDateArray[0] = myDateArray[1]
          myDateArray[1] = myDateArray[2]
        }

        if (lr.length > 1) {
          var ampm = lr[2]
          lr = lr[1].split(':')
          if (ampm) {
            if (lr[0] == '12' && ampm.toUpperCase() == 'AM') lr[0] = 0
            else if (lr[0] != '12' && ampm.toUpperCase() == 'PM')
              lr[0] = parseInt(lr[0], 10) + 12
          }
          var sec = 0,
            msec = 0
          if (lr.length == 3) {
            if (lr[2].indexOf('.') == -1) {
              sec = parseInt(lr[2], 10)
            } else {
              sec = lr[2].split('.')
              if (sec[1].length == 3) {
                msec = sec[1]
                sec = sec[0]
              } else {
                //only IE8 should get here
                msec = sec[1].substr(0, 3)
                var tz = parseInt(sec[1].substr(3), 10)
                sec = sec[0]
                var rDt = new Date(
                  year,
                  myDateArray[0] - 1,
                  myDateArray[1],
                  lr[0],
                  lr[1],
                  sec,
                  msec
                )
                rDt.setMinutes(
                  rDt.getMinutes() -
                    rDt.getTimezoneOffset() -
                    (tz % 100) -
                    Math.round(tz / 100) * 60
                )
                return rDt
              }
            }
          }
          return new Date(
            year,
            myDateArray[0] - 1,
            myDateArray[1],
            lr[0],
            lr[1],
            sec,
            msec
          )
        }
        return new Date(year, myDateArray[0] - 1, myDateArray[1], 0, 0, 0, 0)
      }

      /**
       * Converts a string form date into a JavaScript object. Only use if you know that the string will not include a time, otherwise use @see CIQ.strToDateTime
       * @param  {string} dt - Date in string format such as MM/DD/YY or YYYYMMDD or 2014-10-25T00:00:00+00:00 or 201506170635
       * @return {date}    JavaScript date object -new Date()-
       * @memberof CIQ
       */
      CIQ.strToDate = function(dt) {
        var myDateArray
        if (dt.indexOf('/') != -1) myDateArray = dt.split('/')
        else if (dt.indexOf('-') != -1) myDateArray = dt.split('-')
        else if (dt.length >= 8) {
          return new Date(
            parseFloat(dt.substring(0, 4)),
            parseFloat(dt.substring(4, 6)) - 1,
            parseFloat(dt.substring(6, 8))
          )
        } else {
          return new Date()
        }
        if (myDateArray.length < 3) {
          // didn't find enough data for month, day and year.
          return new Date()
        }
        if (myDateArray[2].indexOf(' ') != -1) {
          myDateArray[2] = myDateArray[2].substring(
            0,
            myDateArray[2].indexOf(' ')
          )
        } else if (myDateArray[2].indexOf('T') != -1) {
          myDateArray[2] = myDateArray[2].substring(
            0,
            myDateArray[2].indexOf('T')
          )
        }
        var year = parseFloat(myDateArray[2], 10)
        if (year < 20) year += 2000
        if (myDateArray[0].length == 4) {
          // YYYY-MM-DD
          year = parseFloat(myDateArray[0], 10)
          myDateArray[0] = myDateArray[1]
          myDateArray[1] = myDateArray[2]
        }
        return new Date(year, myDateArray[0] - 1, myDateArray[1])
      }

      /**
       * Converts a JavaScript Date or string form date to mm/dd/yyyy format
       * @param  {string} dt Date in JavaScript Date or string format such as YYYY-MM-DD
       * @return {string}   Date in mm/dd/yyyy format
       * @memberof CIQ
       * @since 2016-07-16
       */
      CIQ.mmddyyyy = function(dt) {
        if (typeof dt === 'string') {
          dt = CIQ.strToDate(dt)
        }

        var m = dt.getMonth() + 1
        if (m < 10) m = '0' + m
        var d = dt.getDate()
        if (d < 10) d = '0' + d
        return m + '/' + d + '/' + dt.getFullYear()
      }

      /**
       * Converts a JavaScript Date to yyyy-mm-dd format
       * @param  {date} dt JavaScript Date object
       * @return {string}    Date in yyyy-mm-dd format
       * @memberof CIQ
       */
      CIQ.yyyymmdd = function(dt) {
        var m = dt.getMonth() + 1
        if (m < 10) m = '0' + m
        var d = dt.getDate()
        if (d < 10) d = '0' + d
        return dt.getFullYear() + '-' + m + '-' + d
      }

      /**
       * Converts a date into yyyymmddhhmm format
       * @param  {date} dt A JavaScript Date object
       * @return {string}    Date in yyyymmddhhmm format
       * @memberof CIQ
       */
      CIQ.yyyymmddhhmm = function(dt) {
        var m = dt.getMonth() + 1
        if (m < 10) m = '0' + m
        var d = dt.getDate()
        if (d < 10) d = '0' + d
        var h = dt.getHours()
        if (h < 10) h = '0' + h
        var mn = dt.getMinutes()
        if (mn < 10) mn = '0' + mn
        return '' + dt.getFullYear() + m + d + h + mn
      }

      /**
       * Converts a date into yyyymmddhhmmssmmm format
       * @param  {date} dt A JavaScript Date object
       * @return {string}    Date in yyyymmddhhmmssmmm format
       * @memberof CIQ
       */
      CIQ.yyyymmddhhmmssmmm = function(dt) {
        var m = dt.getMonth() + 1
        if (m < 10) m = '0' + m
        var d = dt.getDate()
        if (d < 10) d = '0' + d
        var h = dt.getHours()
        if (h < 10) h = '0' + h
        var mn = dt.getMinutes()
        if (mn < 10) mn = '0' + mn
        var s = dt.getSeconds()
        if (s < 10) s = '0' + s
        var ms = dt.getMilliseconds()
        if (ms < 10) ms = '00' + ms
        else if (ms < 100) ms = '0' + ms
        return '' + dt.getFullYear() + m + d + h + mn + s + ms
      }

      /**
       * Converts a date into yyyy/mm/dd hh:mm format
       * @param  {date} dt A JavaScript Date object
       * @return {string}    Date in yyyy/mm/dd hh:mm format
       * @memberof CIQ
       */
      CIQ.friendlyDate = function(dt) {
        var m = dt.getMonth() + 1
        if (m < 10) m = '0' + m
        var d = dt.getDate()
        if (d < 10) d = '0' + d
        var h = dt.getHours()
        if (h < 10) h = '0' + h
        var mn = dt.getMinutes()
        if (mn < 10) mn = '0' + mn
        return '' + dt.getFullYear() + '/' + m + '/' + d + ' ' + h + ':' + mn
      }

      /**
       * Converts a date into YYYY-MM-DDTHH:MM:SSZ format (UTC)
       * @param  {date} dt A JavaScript Date object
       * @return {string}    Date in YYYY-MM-DDTHH:MM:SSZ format
       * @memberof CIQ
       */
      CIQ.standardUTCDate = function(dt) {
        var m = dt.getUTCMonth() + 1
        if (m < 10) m = '0' + m
        var d = dt.getUTCDate()
        if (d < 10) d = '0' + d
        var h = dt.getUTCHours()
        if (h < 10) h = '0' + h
        var mn = dt.getUTCMinutes()
        if (mn < 10) mn = '0' + mn
        var s = dt.getUTCSeconds()
        if (s < 10) s = '0' + s
        return (
          '' +
          dt.getUTCFullYear() +
          '-' +
          m +
          '-' +
          d +
          'T' +
          h +
          ':' +
          mn +
          ':' +
          s +
          'Z'
        )
      }

      /**
       * Converts a string form date into mm-dd hh:mm format
       * @param  {string} strdt Date in string format (such as yyyymmddhhmm, yyyy-mm-dd hh:mm, etc)
       * @return {string}       Date in mm-dd hh:mm format
       * @memberof CIQ
       * @since 5.0.0 will output seconds and millis if present
       */
      CIQ.mmddhhmm = function(strdt) {
        var dt = CIQ.strToDateTime(strdt)
        var m = dt.getMonth() + 1
        if (m < 10) m = '0' + m
        var d = dt.getDate()
        if (d < 10) d = '0' + d
        var h = dt.getHours()
        if (h < 10) h = '0' + h
        var mn = dt.getMinutes()
        if (mn < 10) mn = '0' + mn
        if (h == '00' && mn == '00') return m + '-' + d + '-' + dt.getFullYear()
        var s = dt.getSeconds()
        if (s < 10) s = '0' + s
        if (s == '00') return m + '-' + d + ' ' + h + ':' + mn
        var ms = dt.getMilliseconds()
        if (ms < 10) ms = '00' + ms
        else if (ms < 100) ms = '0' + ms
        if (ms == '000') return m + '-' + d + ' ' + h + ':' + mn + ':' + s
        return m + '-' + d + ' ' + h + ':' + mn + ':' + s + ':' + ms
      }

      /**
       * Gets the day of the year
       * @param  {date} [dt] optional	The date to check.  If omitted, will use the current date.
       * @return {number} 			Day of year
       * @memberof CIQ
       */
      CIQ.getYearDay = function(dt) {
        var now = dt
        if (!now) now = new Date()
        now.setHours(0, 0, 0, 0)
        var start = new Date(now.getFullYear(), 0, 0)
        var diff = now - start
        var oneDay = 1000 * 60 * 60 * 24
        var day = Math.round(diff / oneDay)
        return day
      }

      /**
       * DST checker.  Returns whether input date is in DST
       * @param  {date} [dt] optional	The date to check.  If omitted, will use the current date.
       * @return {boolean} True for DST, false for not.
       * @memberof CIQ
       */
      CIQ.isDST = function(dt) {
        if (!dt) dt = new Date()
        var jan = new Date(dt.getFullYear(), 0, 1)
        var jul = new Date(dt.getFullYear(), 6, 1)
        var stdOffset = Math.max(
          jan.getTimezoneOffset(),
          jul.getTimezoneOffset()
        )
        return dt.getTimezoneOffset() != stdOffset
      }

      /**
       * Returns a short, pseudo unique ID based on the current time. Radix 36 is used resulting in a compact string consisting only of letters and numerals.
       * While not guaranteed to be unique, this function has a high probability of uniqueness when it is triggered by human activity even in a large user base.
       * @return {string} A unique string consisting of letters and numerals
       * @memberof CIQ
       */
      CIQ.uniqueID = function() {
        var epoch = new Date()
        var id = epoch.getTime().toString(36)
        id += Math.floor(Math.random() * Math.pow(36, 2)).toString(36)
        return id.toUpperCase()
      }

      /**
       * Returns the host portion of a url
       * @param  {string} url The url, such as document.location.href
       * @return {string}     The host portion, including port, if the url is a valid URI
       * @memberof CIQ
       */
      CIQ.getHostName = function(url) {
        try {
          return url.match(/:\/\/(.[^/]+)/)[1]
        } catch (e) {
          return ''
        }
      }

      /**
       * Gets an Ajax server dependent on browser method. If IE9 and a cross domain request then XDomainRequest() will be used
       * rather than XMLHttpRequest.
       * @param  {string} url The url to connect with
       * @return {object}     An ajax server
       * @memberof CIQ
       */
      CIQ.getAjaxServer = function(url) {
        var server = false
        var crossDomain = true
        if ((CIQ.isIE9 || CIQ.isIE8) && url) {
          if (CIQ.getHostName(url) === '') crossDomain = false
          if (CIQ.getHostName(url) == CIQ.getHostName(window.location.href))
            crossDomain = false
        }
        if ((CIQ.isIE9 || CIQ.isIE8) && crossDomain) {
          server = new XDomainRequest()
          return server
        }
        try {
          //All modern browsers (IE7+, Firefox, Chrome, Safari, and Opera) have a built-in XMLHttpRequest object.
          server = new XMLHttpRequest()
        } catch (e) {
          alert('ajax not supported in browser')
        }
        return server
      }

      /**
       * A parsed query string object
       * Does not support using multi-value keys (i.e. "a=1&a=2")
       * @param  {string} [query] Query string. If not provided then the browser location's query string will be used
       * @return {object}       An object containing the parsed values of the query string
       * @memberof CIQ
       */
      CIQ.qs = function(query) {
        var qsParm = {}
        if (!query) query = window.location.search.substring(1)
        var parms = query.split('&')
        for (var i = 0; i < parms.length; i++) {
          var pos = parms[i].indexOf('=')
          var key
          if (pos > 0) {
            key = parms[i].substring(0, pos)
            qsParm[key] = parms[i].substring(pos + 1)
          } else {
            key = parms[i]
            qsParm[key] = null
          }
        }
        return qsParm
      }

      /**
       * @callback CIQ.postAjax~requestCallback
       * @param {number} status HTTP status
       * @param {string} response HTTP response
       */
      /**
       * Convenience function for making an ajax post. If payload is non-null then the method will be set to POST, otherwise GET. Cross origin
       * ajax is support on IE9.
       * @param {object} params Parameters for the post
       * @param  {string}   [params.url]         The url to send the ajax query to
       * @param  {string}   [params.payload]     An optional payload to send
       * @param  {CIQ.postAjax~requestCallback} [params.cb]          Callback function when complete
       * @param  {string}   [params.contentType] Optionally override the content type
       * @param  {boolean}   [params.noEpoch]     By default the epoch is appended as a query string to bust caching. Set this to false to not append the epoch.
       * @param {string} [params.method] Optionally override the HTTP method
       * @param {array} [params.headers] Optional additional HTTP headers to send
       * @param {boolean} [params.responseHeaders] Optional Set to true to have callback passed the response headers from the server
       * @param {number} [params.timeout] Optional Request timeout in msec.  If omitted, timeout is default (no timeout)
       * @param {boolean} [params.ungovernable] Optional If true, request not subject to rate limiting
       * @param {string} arg1 Payload
       * @param {function} arg2 Callback
       * @param {string} arg3 Ajax content type
       * @param {boolean} arg4 Set to true for no epoch
       * @return {boolean} True if there were no errors fetching data.
       * @memberof CIQ
       * @since 3.0.0 Added timeout and ungovernable params
       */
      CIQ.postAjax = function(params, arg1, arg2, arg3, arg4) {
        if (typeof params == 'string') {
          params = {
            url: params,
            payload: arg1,
            cb: arg2,
            contentType: arg3,
            noEpoch: arg4,
            method: null,
            responseHeaders: false,
          }
        }
        var url = params.url,
          cb = params.cb,
          payload = params.payload
        if (!cb) cb = function() {}
        if (!params.ungovernable) {
          if (
            CIQ.Extras &&
            CIQ.Extras.RequestLimiter &&
            CIQ.Extras.RequestLimiter.hitRequestLimit(url)
          ) {
            cb(429, null, {})
            return
          }
        }
        function parseHeaders(server) {
          //Optional code for processing headers. Doesn't work for IE9
          var headers = {}
          if (!params.responseHeaders) return
          var headerString = server.getAllResponseHeaders()
          var headerArray = headerString.split('\n')
          for (var i = 0; i < headerArray.length; i++) {
            var split = headerArray[i].split(':')
            while (split[1] && split[1].charAt(0) == ' ')
              split[1] = split[1].substring(1)
            if (split[0] !== '') {
              headers[split.shift()] = split.join(':')
            }
          }
          return headers
        }
        function removeServer(svr) {
          for (var i = 0; i < CIQ.ajaxes.length; i++) {
            if (CIQ.ajaxes[i] == svr) {
              CIQ.ajaxes.splice(i, 1)
              return
            }
          }
        }
        var server = CIQ.getAjaxServer(url)
        if (!server) return false
        if (!CIQ.ajaxes) CIQ.ajaxes = []
        CIQ.ajaxes.unshift(server) // We need to do this maintenance stuff for old IE which may destroy the server before it's come back:
        //  http://stackoverflow.com/questions/8058446/ie-xdomainrequest-not-always-work
        var epoch = new Date()
        if (!params.noEpoch) {
          if (url.indexOf('?') == -1) url += '?ciqrandom=' + epoch.getTime()
          else url += '&ciqrandom=' + epoch.getTime()
        }
        var method = params.method,
          headers = params.headers
        if (!method) method = payload ? 'POST' : 'GET'
        if (
          (!CIQ.isIE9 && !CIQ.isIE8) ||
          server.constructor == XMLHttpRequest
        ) {
          server.open(method, url, true)
          if (!params.contentType)
            params.contentType = 'application/x-www-form-urlencoded'
          if (payload)
            server.setRequestHeader('Content-Type', params.contentType)
          if (headers) {
            for (var header in headers) {
              server.setRequestHeader(header, headers[header])
            }
          }
        } else {
          url = url.replace('https:', window.location.protocol)
          server.open(method, url, true)
        }
        if (params.timeout) {
          server.timeout = params.timeout // in msec
        }
        server.ontimeout = function() {
          removeServer(server)
          cb(408, null, {})
        }
        server.onload = function() {
          if (this.status === 0) this.status = '0'
          else if (!this.status) this.status = 200 //XDomainRequest
          removeServer(server)
          cb(this.status, this.responseText, parseHeaders(this))
        }
        server.onerror = function() {
          removeServer(server)
          cb('0', null, {})
        }
        server.onprogress = function() {} //IE9 requires
        try {
          server.send(payload)
        } catch (e) {
          cb('0', e, {})
        }
        return true
      }

      /**
       * Convenience function to convert API periodicity parameters to internal periodicity format.
       * @param  {string} period The period value as required by {@link CIQ.ChartEngine#setPeriodicity}
       * @param  {string} [interval] The interval value as required by {@link CIQ.ChartEngine#setPeriodicity}
       * @param  {string} timeUnit The timeUnit value as required by {@link CIQ.ChartEngine#setPeriodicity}
       * @return {object} object containing internally compliant periodicity,interval, timeUnit
       * @memberof CIQ
       * @since 5.1.1
       */
      CIQ.cleanPeriodicity = function(period, interval, timeUnit) {
        if (isNaN(period)) period = 1
        if (!interval) interval = 1
        if (!isNaN(interval) && timeUnit) {
          // disregard the numeric interval if a daily timeUnit is provided
          // TODO: support different interval values other than 1 for day, week, etc
          //	we'll need to propagate timeUnit down wherever we are examining the interval alone to determine the time unit
          if (
            !(
              timeUnit == 'minute' ||
              timeUnit == 'second' ||
              timeUnit == 'millisecond'
            )
          ) {
            interval = timeUnit
            timeUnit = null
          }
        }

        // clean up timeUnit
        //if(CIQ.ChartEngine.isDailyInterval(interval)) timeUnit=null; // redundant
        else if (interval == 'tick') timeUnit = null
        else if (!timeUnit && !isNaN(interval)) timeUnit = 'minute'

        // support year
        if (interval == 'year') {
          interval = 'month'
          if (!period) period = 1
          period = period * 12
        }

        return { period: period, interval: interval, timeUnit: timeUnit }
      }

      return _exports
    }

  var u4S = (window.u4S = {
    N0T: function(S, H) {
      return S * H
    },
    W6U: function(S, H) {
      return S === H
    },
    N6U: function(S, H) {
      return S - H
    },
    O5U: function(S, H) {
      return S / H
    },
    D2U: function(S, H) {
      return S == H
    },
    J1T: function(S, H) {
      return S * H
    },
    p91: function(S, H) {
      return S & H
    },
    M9: function(S, H) {
      return S / H
    },
    f21: function(S, H, c) {
      return (S * H) / c
    },
    G91: function(S, H) {
      return S & H
    },
    O7T: function(S, H) {
      return S > H
    },
    J4U: function(S, H) {
      return S == H
    },
    F1: function(S, H) {
      return S * H
    },
    R6: function(S, H) {
      return S * H
    },
    Y5U: function(S, H) {
      return S / H
    },
    P41: function(S, H) {
      return S == H
    },
    H9T: function(S, H) {
      return S == H
    },
    D4U: function(S, H) {
      return S - H
    },
    S3: function(S, H) {
      return S - H
    },
    p01: function(S, H) {
      return S < H
    },
    C61: function(S, H) {
      return S > H
    },
    g3U: function(S, H) {
      return S * H
    },
    o31: function(S, H) {
      return S - H
    },
    m6T: function(S, H) {
      return S != H
    },
    s0T: function(S, H) {
      return S / H
    },
    N91: function(S, H) {
      return S >= H
    },
    R81: function(S, H) {
      return S != H
    },
    q61: function(S, H) {
      return S - H
    },
    P81: function(S, H) {
      return S - H
    },
    A31: function(S, H) {
      return S == H
    },
    x01: function(S, H) {
      return S < H
    },
    l5T: function(S, H) {
      return S < H
    },
    J1: function(S, H) {
      return S == H
    },
    D8U: function(S, H) {
      return S === H
    },
    S0b: function(S, H) {
      return S == H
    },
    v9T: function(S, H) {
      return S <= H
    },
    y61: function(S, H) {
      return S === H
    },
    P3b: function(S, H) {
      return S <= H
    },
    j8: function(S, H) {
      return S <= H
    },
    g4T: function(S, H) {
      return S - H
    },
    i61: function(S, H) {
      return S * H
    },
    S0T: function(S, H) {
      return S === H
    },
    f: function(S, H) {
      return S - H
    },
    y4U: function(S, H) {
      return S >= H
    },
    X0T: function(S, H) {
      return S / H
    },
    v61: function(S, H) {
      return S < H
    },
    c51: function(S, H) {
      return S == H
    },
    P2T: function(S, H) {
      return S < H
    },
    s8T: function(S, H) {
      return S - H
    },
    u6: function(S, H) {
      return S * H
    },
    l41: function(S, H) {
      return S == H
    },
    k3b: function(S, H) {
      return S >= H
    },
    X8: function(S, H) {
      return S / H
    },
    I2: function(S, H) {
      return S == H
    },
    d81: function(S, H) {
      return S * H
    },
    p8: function(S, H) {
      return S < H
    },
    A3b: function(S, H) {
      return S - H
    },
    D6T: function(S, H) {
      return S > H
    },
    w6T: function(S, H) {
      return S !== H
    },
    O3: function(S, H) {
      return S >= H
    },
    L5: function(S, H, c) {
      return S - H + c
    },
    l2T: function(S, H) {
      return S == H
    },
    z5T: function(S, H) {
      return S < H
    },
    Z9: function(S, H) {
      return S / H
    },
    S7U: function(S, H) {
      return S > H
    },
    R0U: function(S, H) {
      return S / H
    },
    g5U: function(S, H) {
      return S >= H
    },
    h2U: function(S, H) {
      return S / H
    },
    U2b: function(S, H) {
      return S - H
    },
    T6U: function(S, H) {
      return S === H
    },
    C8U: function(S, H) {
      return S - H
    },
    B3U: function(S, H) {
      return S - H
    },
    d9U: function(S, H) {
      return S * H
    },
    i1b: function(S, H) {
      return S > H
    },
    s3U: function(S, H) {
      return S * H
    },
    U9U: function(S, H) {
      return S * H
    },
    u: function(S, H) {
      return S < H
    },
    T3: function(S, H) {
      return S === H
    },
    T01: function(S, H) {
      return S - H
    },
    X4: function(S, H) {
      return S - H
    },
    s11: function(S, H) {
      return S === H
    },
    y9T: function(S, H) {
      return S == H
    },
    K1: function(S, H) {
      return S == H
    },
    H6T: function(S, H) {
      return S - H
    },
    s7U: function(S, H) {
      return S < H
    },
    q4U: function(S, H) {
      return S < H
    },
    k3T: function(S, H) {
      return S !== H
    },
    N7U: function(S, H) {
      return S !== H
    },
    p7U: function(S, H) {
      return S < H
    },
    H31: function(S, H) {
      return S < H
    },
    h6T: function(S, H) {
      return S - H
    },
    w61: function(S, H) {
      return S - H
    },
    G0b: function(S, H) {
      return S / H
    },
    U3T: function(S, H) {
      return S == H
    },
    F0U: function(S, H) {
      return S / H
    },
    x3: function(S, H) {
      return S < H
    },
    H8U: function(S, H) {
      return S - H
    },
    S1U: function(S, H) {
      return S != H
    },
    G0: function(S, H) {
      return S == H
    },
    N3U: function(S, H) {
      return S * H
    },
    q4: function(S, H) {
      return S - H
    },
    X8T: function(S, H) {
      return S - H
    },
    Z9T: function(S, H) {
      return S >= H
    },
    I81: function(S, H) {
      return S - H
    },
    z81: function(S, H) {
      return S - H
    },
    v6b: function(S, H) {
      return S < H
    },
    G4T: function(S, H) {
      return S < H
    },
    o5: function(S, H) {
      return S - H
    },
    Q1U: function(S, H, c) {
      return S - H + c
    },
    d5T: function(S, H) {
      return S - H
    },
    O91: function(S, H) {
      return S == H
    },
    j4: function(S, H) {
      return S < H
    },
    K4U: function(S, H) {
      return S <= H
    },
    R2T: function(S, H) {
      return S !== H
    },
    j7T: function(S, H) {
      return S * H
    },
    x4T: function(S, H) {
      return S > H
    },
    r5: function(S, H) {
      return S * H
    },
    f1U: function(S, H) {
      return S == H
    },
    Y3U: function(S, H) {
      return S - H
    },
    Q1T: function(S, H) {
      return S == H
    },
    g7U: function(S, H) {
      return S > H
    },
    S3U: function(S, H) {
      return S - H
    },
    D1T: function(S, H) {
      return S == H
    },
    Z2U: function(S, H) {
      return S * H
    },
    V2T: function(S, H) {
      return S != H
    },
    z1: function(S, H) {
      return S == H
    },
    w1T: function(S, H) {
      return S >= H
    },
    N0b: function(S, H) {
      return S * H
    },
    H61: function(S, H) {
      return S === H
    },
    o2T: function(S, H) {
      return S - H
    },
    T3U: function(S, H) {
      return S * H
    },
    g6U: function(S, H) {
      return S >= H
    },
    b21: function(S, H) {
      return S <= H
    },
    N8: function(S, H) {
      return S / H
    },
    j3U: function(S, H) {
      return S * H
    },
    v9: function(S, H) {
      return S / H
    },
    M4U: function(S, H) {
      return S > H
    },
    i71: function(S, H) {
      return S - H
    },
    X1: function(S, H) {
      return S == H
    },
    b2: function(S, H) {
      return S != H
    },
    u41: function(S, H) {
      return S > H
    },
    T4: function(S, H) {
      return S == H
    },
    B3: function(S, H) {
      return S <= H
    },
    c9: function(S, H) {
      return S * H
    },
    E2T: function(S, H) {
      return S == H
    },
    Z6: function(S, H) {
      return S < H
    },
    M1T: function(S, H) {
      return S <= H
    },
    u1: function(S, H) {
      return S > H
    },
    o2b: function(S, H) {
      return S === H
    },
    Y0T: function(S, H) {
      return S * H
    },
    m6: function(S, H) {
      return S - H
    },
    B4: function(S, H) {
      return S == H
    },
    f5T: function(S, H) {
      return S - H
    },
    I2b: function(S, H) {
      return S > H
    },
    u0U: function(S, H) {
      return S !== H
    },
    J2U: function(S, H) {
      return S / H
    },
    g0: function(S, H) {
      return S < H
    },
    i6: function(S, H) {
      return S === H
    },
    Q9: function(S, H) {
      return S / H
    },
    Y8: function(S, H) {
      return S - H
    },
    t9U: function(S, H) {
      return S > H
    },
    E2b: function(S, H) {
      return S === H
    },
    i6T: function(S, H) {
      return S - H
    },
    a9T: function(S, H) {
      return S < H
    },
    U3z: 2,
    M6b: function(S, H) {
      return S > H
    },
    c2: function(S, H) {
      return S == H
    },
    T11: function(S, H) {
      return S > H
    },
    J6b: function(S, H) {
      return S * H
    },
    r1U: function(S, H) {
      return S !== H
    },
    j5U: function(S, H) {
      return S - H
    },
    J6T: function(S, H) {
      return S == H
    },
    i2U: function(S, H) {
      return S * H
    },
    t7T: function(S, H, c) {
      return (S * H) / c
    },
    V41: function(S, H) {
      return S == H
    },
    T4T: function(S, H) {
      return S < H
    },
    a31: function(S, H) {
      return S - H
    },
    R7: function(S, H) {
      return S < H
    },
    w5: function(S, H, c) {
      return S - H + c
    },
    P9U: function(S, H) {
      return S == H
    },
    b0: function(S, H) {
      return S < H
    },
    w71: function(S, H) {
      return S <= H
    },
    K9: function(S, H) {
      return S < H
    },
    C51: function(S, H) {
      return S <= H
    },
    Y4: function(S, H) {
      return S == H
    },
    U7: function(S, H) {
      return S * H
    },
    a61: function(S, H) {
      return S == H
    },
    A2T: function(S, H) {
      return S * H
    },
    e1U: function(S, H) {
      return S >= H
    },
    T91: function(S, H) {
      return S != H
    },
    X0b: function(S, H) {
      return S <= H
    },
    F5T: function(S, H) {
      return S * H
    },
    e81: function(S, H) {
      return S * H
    },
    B91: function(S, H) {
      return S <= H
    },
    G1U: function(S, H, c) {
      return S - H + c
    },
    s2: function(S, H) {
      return S == H
    },
    H9: function(S, H) {
      return S === H
    },
    D1: function(S, H) {
      return S == H
    },
    Q9T: function(S, H) {
      return S == H
    },
    y1T: function(S, H) {
      return S == H
    },
    T2: function(S, H) {
      return S == H
    },
    T0b: function(S, H) {
      return S < H
    },
    D9: function(S, H) {
      return S * H
    },
    I0U: function(S, H) {
      return S - H
    },
    E1U: function(S, H) {
      return S >= H
    },
    v8U: function(S, H) {
      return S === H
    },
    b7U: function(S, H) {
      return S !== H
    },
    Y8T: function(S, H) {
      return S - H
    },
    o1U: function(S, H) {
      return S <= H
    },
    c8U: function(S, H) {
      return S - H
    },
    x1U: function(S, H) {
      return S == H
    },
    F7: function(S, H) {
      return S === H
    },
    l1U: function(S, H) {
      return S > H
    },
    w2U: function(S, H) {
      return S / H
    },
    l81: function(S, H) {
      return S > H
    },
    x11: function(S, H) {
      return S - H
    },
    x3U: function(S, H) {
      return S > H
    },
    H51: function(S, H) {
      return S == H
    },
    X91: function(S, H) {
      return S == H
    },
    L8T: function(S, H) {
      return S > H
    },
    v6: function(S, H) {
      return S == H
    },
    i1T: function(S, H) {
      return S >= H
    },
    z41: function(S, H) {
      return S <= H
    },
    F41: function(S, H) {
      return S < H
    },
    m9T: function(S, H) {
      return S < H
    },
    Y7U: function(S, H) {
      return S < H
    },
    n3U: function(S, H) {
      return S == H
    },
    R3b: function(S, H) {
      return S - H
    },
    p4T: function(S, H) {
      return S / H
    },
    x0T: function(S, H) {
      return S == H
    },
    b01: function(S, H) {
      return S > H
    },
    u7: function(S, H) {
      return S != H
    },
    m4: function(S, H) {
      return S != H
    },
    w31: function(S, H, c) {
      return S - H - c
    },
    C6b: function(S, H) {
      return S - H
    },
    L3U: function(S, H) {
      return S != H
    },
    T5U: function(S, H) {
      return S - H
    },
    F1U: function(S, H) {
      return S != H
    },
    A5: function(S, H) {
      return S / H
    },
    h1b: function(S, H) {
      return S < H
    },
    g7T: function(S, H) {
      return S / H
    },
    s5U: function(S, H) {
      return S < H
    },
    m51: function(S, H) {
      return S != H
    },
    M61: function(S, H) {
      return S / H
    },
    L4: function(S, H) {
      return S >= H
    },
    r0T: function(S, H) {
      return S in H
    },
    h8U: function(S, H) {
      return S - H
    },
    K1T: function(S, H) {
      return S - H
    },
    h6b: function(S, H) {
      return S >= H
    },
    E3b: function(S, H) {
      return S < H
    },
    Y91: function(S, H) {
      return S & H
    },
    v4U: function(S, H) {
      return S / H
    },
    v6T: function(S, H) {
      return S !== H
    },
    e5T: function(S, H) {
      return S <= H
    },
    e3T: function(S, H) {
      return S === H
    },
    r1: function(S, H) {
      return S >= H
    },
    J51: function(S, H) {
      return S / H
    },
    G5U: function(S, H) {
      return S < H
    },
    A0U: function(S, H) {
      return S - H
    },
    m2U: function(S, H) {
      return S == H
    },
    T0: function(S, H) {
      return S / H
    },
    Y3: function(S, H) {
      return S > H
    },
    f3b: function(S, H) {
      return S < H
    },
    e41: function(S, H) {
      return S in H
    },
    R6U: function(S, H) {
      return S - H
    },
    O7U: function(S, H) {
      return S * H
    },
    l3b: function(S, H) {
      return S <= H
    },
    d3T: function(S, H) {
      return S == H
    },
    o0U: function(S, H) {
      return S > H
    },
    F2b: function(S, H) {
      return S > H
    },
    w51: function(S, H) {
      return S <= H
    },
    u7T: function(S, H) {
      return S - H
    },
    z5: function(S, H) {
      return S === H
    },
    G11: function(S, H) {
      return S / H
    },
    T7T: function(S, H) {
      return S - H
    },
    E9U: function(S, H) {
      return S == H
    },
    t2T: function(S, H) {
      return S == H
    },
    b8: function(S, H) {
      return S / H
    },
    F2T: function(S, H) {
      return S < H
    },
    n91: function(S, H) {
      return S >= H
    },
    V3T: function(S, H) {
      return S == H
    },
    R3T: function(S, H) {
      return S == H
    },
    n0b: function(S, H) {
      return S - H
    },
    w6b: function(S, H) {
      return S < H
    },
    G: function(S, H) {
      return S / H
    },
    t3b: function(S, H) {
      return S < H
    },
    M31: function(S, H) {
      return S * H
    },
    q9T: function(S, H) {
      return S == H
    },
    I5T: function(S, H) {
      return S - H
    },
    q9: function(S, H) {
      return S === H
    },
    r4T: function(S, H) {
      return S < H
    },
    Q1: function(S, H) {
      return S == H
    },
    O8: function(S, H) {
      return S === H
    },
    i5: function(S, H) {
      return S < H
    },
    L01: function(S, H) {
      return S < H
    },
    A9U: function(S, H) {
      return S == H
    },
    U2T: function(S, H) {
      return S === H
    },
    Q6T: function(S, H) {
      return S - H
    },
    m1b: function(S, H) {
      return S != H
    },
    y6T: function(S, H) {
      return S !== H
    },
    I3b: function(S, H) {
      return S == H
    },
    f7: function(S, H) {
      return S - H
    },
    w9: function(S, H) {
      return S < H
    },
    M5: function(S, H) {
      return S * H
    },
    w6: function(S, H) {
      return S * H
    },
    u2T: function(S, H) {
      return S >= H
    },
    Q4U: function(S, H) {
      return S === H
    },
    k5: function(S, H) {
      return S / H
    },
    S4T: function(S, H) {
      return S < H
    },
    n0: function(S, H) {
      return S < H
    },
    P1: function(S, H) {
      return S == H
    },
    L3: function(S, H) {
      return S < H
    },
    z2b: function(S, H) {
      return S >= H
    },
    x7U: function(S, H) {
      return S > H
    },
    B1: function(S, H) {
      return S / H
    },
    y71: function(S, H) {
      return S >= H
    },
    h71: function(S, H) {
      return S < H
    },
    Z8U: function(S, H) {
      return S == H
    },
    E5: function(S, H) {
      return S === H
    },
    p0b: function(S, H) {
      return S !== H
    },
    o3T: function(S, H) {
      return S != H
    },
    s4: function(S, H, c) {
      return S - H - c
    },
    B7U: function(S, H) {
      return S > H
    },
    a8U: function(S, H) {
      return S < H
    },
    I51: function(S, H, c, d) {
      return S - H + c - d
    },
    N11: function(S, H) {
      return S < H
    },
    A81: function(S, H) {
      return S < H
    },
    D71: function(S, H) {
      return S != H
    },
    x0b: function(S, H) {
      return S == H
    },
    z31: function(S, H) {
      return S > H
    },
    n7T: function(S, H) {
      return S == H
    },
    I9U: function(S, H) {
      return S < H
    },
    u21: function(S, H) {
      return S < H
    },
    u6U: function(S, H) {
      return S * H
    },
    p0T: function(S, H) {
      return S < H
    },
    z2T: function(S, H) {
      return S < H
    },
    j0b: function(S, H) {
      return S * H
    },
    d2: function(S, H) {
      return S == H
    },
    c1T: function(S, H) {
      return S == H
    },
    Q1b: function(S, H) {
      return S >= H
    },
    P1U: function(S, H) {
      return S <= H
    },
    M8U: function(S, H) {
      return S - H
    },
    k2T: function(S, H) {
      return S * H
    },
    U3b: function(S, H) {
      return S < H
    },
    N7T: function(S, H) {
      return S > H
    },
    X5U: function(S, H) {
      return S * H
    },
    y8U: function(S, H) {
      return S == H
    },
    g8T: function(S, H) {
      return S - H
    },
    Z51: function(S, H) {
      return S / H
    },
    V21: function(S, H) {
      return S < H
    },
    B0b: function(S, H) {
      return S == H
    },
    u3b: function(S, H) {
      return S != H
    },
    K2U: function(S, H) {
      return S !== H
    },
    d2T: function(S, H) {
      return S < H
    },
    b6U: function(S, H) {
      return S > H
    },
    q21: function(S, H) {
      return S === H
    },
    s8: function(S, H) {
      return S == H
    },
    h9T: function(S, H) {
      return S <= H
    },
    m1T: function(S, H) {
      return S < H
    },
    Y01: function(S, H) {
      return S - H
    },
    X3: function(S, H) {
      return S == H
    },
    i31: function(S, H) {
      return S * H
    },
    O0: function(S, H) {
      return S > H
    },
    h4U: function(S, H) {
      return S == H
    },
    f2T: function(S, H) {
      return S == H
    },
    Q6b: function(S, H) {
      return S >= H
    },
    g8: function(S, H) {
      return S !== H
    },
    U41: function(S, H) {
      return S > H
    },
    p8T: function(S, H) {
      return S == H
    },
    W7T: function(S, H) {
      return S < H
    },
    n5U: function(S, H) {
      return S <= H
    },
    V5T: function(S, H) {
      return S / H
    },
    x5U: function(S, H) {
      return S > H
    },
    B8: function(S, H) {
      return S - H
    },
    w4U: function(S, H) {
      return S != H
    },
    p3: function(S, H) {
      return S < H
    },
    u2b: function(S, H) {
      return S - H
    },
    s0: function(S, H) {
      return S == H
    },
    i9: function(S, H) {
      return S - H
    },
    o7: function(S, H) {
      return S / H
    },
    J9T: function(S, H) {
      return S >= H
    },
    F81: function(S, H) {
      return S * H
    },
    d1U: function(S, H) {
      return S != H
    },
    F3b: function(S, H) {
      return S > H
    },
    a9: function(S, H) {
      return S * H
    },
    X7U: function(S, H) {
      return S > H
    },
    f3T: function(S, H) {
      return S == H
    },
    u81: function(S, H) {
      return S & H
    },
    K6: function(S, H) {
      return S > H
    },
    j4T: function(S, H) {
      return S > H
    },
    O6U: function(S, H) {
      return S - H
    },
    M71: function(S, H) {
      return S == H
    },
    o41: function(S, H) {
      return S < H
    },
    W3U: function(S, H) {
      return S == H
    },
    O4T: function(S, H) {
      return S < H
    },
    S91: function(S, H) {
      return S === H
    },
    U21: function(S, H) {
      return S === H
    },
    u5T: function(S, H) {
      return S < H
    },
    m61: function(S, H) {
      return S * H
    },
    B01: function(S, H) {
      return S < H
    },
    k81: function(S, H) {
      return S < H
    },
    W11: function(S, H) {
      return S - H
    },
    g2: function(S, H) {
      return S > H
    },
    L8: function(S, H) {
      return S / H
    },
    j8T: function(S, H) {
      return S > H
    },
    a2: function(S, H) {
      return S == H
    },
    t3z: 3,
    V9U: function(S, H) {
      return S >= H
    },
    z3b: function(S, H) {
      return S - H
    },
    i4U: function(S, H) {
      return S === H
    },
    W7U: function(S, H) {
      return S * H
    },
    V6U: function(S, H, c) {
      return S - H - c
    },
    x91: function(S, H) {
      return S !== H
    },
    A3T: function(S, H) {
      return S !== H
    },
    t7: function(S, H) {
      return S / H
    },
    A1U: function(S, H) {
      return S <= H
    },
    F3T: function(S, H) {
      return S !== H
    },
    s0b: function(S, H) {
      return S > H
    },
    G7U: function(S, H) {
      return S < H
    },
    Q: function(S, H) {
      return S / H
    },
    L0b: function(S, H) {
      return S != H
    },
    Q31: function(S, H) {
      return S < H
    },
    b5U: function(S, H) {
      return S / H
    },
    n0T: function(S, H) {
      return S < H
    },
    C9T: function(S, H) {
      return S <= H
    },
    R9U: function(S, H) {
      return S === H
    },
    r4: function(S, H) {
      return S == H
    },
    E31: function(S, H) {
      return S < H
    },
    h6: function(S, H) {
      return S > H
    },
    c31: function(S, H) {
      return S - H
    },
    m6b: function(S, H) {
      return S == H
    },
    q6T: function(S, H) {
      return S != H
    },
    I6U: function(S, H) {
      return S === H
    },
    i51: function(S, H) {
      return S / H
    },
    N0: function(S, H) {
      return S > H
    },
    C6T: function(S, H) {
      return S !== H
    },
    P31: function(S, H) {
      return S / H
    },
    s01: function(S, H) {
      return S == H
    },
    S5: function(S, H) {
      return S / H
    },
    b7T: function(S, H) {
      return S > H
    },
    e5: function(S, H) {
      return S != H
    },
    B6U: function(S, H) {
      return S < H
    },
    K8U: function(S, H) {
      return S === H
    },
    u9U: function(S, H) {
      return S < H
    },
    N4: function(S, H) {
      return S == H
    },
    b0T: function(S, H) {
      return S in H
    },
    G3: function(S, H) {
      return S == H
    },
    R7T: function(S, H) {
      return S < H
    },
    D1b: function(S, H) {
      return S - H
    },
    n8: function(S, H) {
      return S < H
    },
    t0U: function(S, H) {
      return S > H
    },
    V3b: function(S, H) {
      return S == H
    },
    F2: function(S, H) {
      return S == H
    },
    y51: function(S, H) {
      return S == H
    },
    h51: function(S, H) {
      return S / H
    },
    z1U: function(S, H) {
      return S < H
    },
    d2b: function(S, H) {
      return S < H
    },
    h61: function(S, H) {
      return S > H
    },
    f41: function(S, H) {
      return S * H
    },
    a1b: function(S, H) {
      return S == H
    },
    r91: function(S, H) {
      return S === H
    },
    D31: function(S, H) {
      return S % H
    },
    Q6: function(S, H) {
      return S - H
    },
    J8U: function(S, H) {
      return S / H
    },
    N5U: function(S, H) {
      return S / H
    },
    P0U: function(S, H) {
      return S / H
    },
    W0T: function(S, H) {
      return S !== H
    },
    L7U: function(S, H) {
      return S * H
    },
    a51: function(S, H, c) {
      return S - H - c
    },
    J9: function(S, H) {
      return S / H
    },
    Y0b: function(S, H) {
      return S == H
    },
    b3: function(S, H) {
      return S > H
    },
    O0T: function(S, H) {
      return S < H
    },
    R3z: 0,
    k: function(S, H) {
      return S - H
    },
    z7: function(S, H) {
      return S / H
    },
    b91: function(S, H) {
      return S & H
    },
    x8T: function(S, H) {
      return S !== H
    },
    n11: function(S, H) {
      return S - H
    },
    Z1b: function(S, H) {
      return S > H
    },
    J1b: function(S, H) {
      return S === H
    },
    Z71: function(S, H) {
      return S != H
    },
    B5U: function(S, H) {
      return S != H
    },
    G8: function(S, H) {
      return S < H
    },
    d3b: function(S, H) {
      return S < H
    },
    Y7T: function(S, H) {
      return S * H
    },
    N4T: function(S, H) {
      return S / H
    },
    j91: function(S, H) {
      return S & H
    },
    l3T: function(S, H) {
      return S !== H
    },
    W8T: function(S, H) {
      return S == H
    },
    j01: function(S, H) {
      return S * H
    },
    b0b: function(S, H) {
      return S > H
    },
    h9: function(S, H) {
      return S == H
    },
    P7: function(S, H) {
      return S === H
    },
    L7T: function(S, H) {
      return S * H
    },
    d1: function(S, H) {
      return S / H
    },
    k1U: function(S, H) {
      return S === H
    },
    v1T: function(S, H) {
      return S / H
    },
    I3T: function(S, H) {
      return S != H
    },
    a71: function(S, H) {
      return S - H
    },
    f1: function(S, H) {
      return S < H
    },
    R2b: function(S, H) {
      return S !== H
    },
    W91: function(S, H) {
      return S & H
    },
    M6: function(S, H) {
      return S * H
    },
    g0b: function(S, H) {
      return S - H
    },
    p11: function(S, H) {
      return S > H
    },
    f81: function(S, H) {
      return S - H
    },
    l0U: function(S, H) {
      return S > H
    },
    I41: function(S, H) {
      return S != H
    },
    k2b: function(S, H) {
      return S == H
    },
    X4T: function(S, H) {
      return S > H
    },
    P3T: function(S, H) {
      return S - H
    },
    j11: function(S, H) {
      return S * H
    },
    o5T: function(S, H) {
      return S - H
    },
    U6U: function(S, H) {
      return S === H
    },
    n3: function(S, H) {
      return S == H
    },
    b8T: function(S, H) {
      return S * H
    },
    s91: function(S, H) {
      return S & H
    },
    J6: function(S, H) {
      return S === H
    },
    K21: function(S, H) {
      return S === H
    },
    x4: function(S, H) {
      return S == H
    },
    F9U: function(S, H) {
      return S == H
    },
    j0: function(S, H) {
      return S <= H
    },
    S4: function(S, H) {
      return S == H
    },
    v21: function(S, H) {
      return S < H
    },
    A41: function(S, H) {
      return S >= H
    },
    B11: function(S, H) {
      return S == H
    },
    I2T: function(S, H) {
      return S <= H
    },
    Y6U: function(S, H) {
      return S < H
    },
    O0b: function(S, H) {
      return S * H
    },
    G4: function(S, H) {
      return S == H
    },
    p0: function(S, H) {
      return S - H
    },
    S8T: function(S, H) {
      return S !== H
    },
    Z4U: function(S, H) {
      return S === H
    },
    b11: function(S, H) {
      return S == H
    },
    k7: function(S, H) {
      return S === H
    },
    x8: function(S, H) {
      return S < H
    },
    t81: function(S, H) {
      return S === H
    },
    h: function(S, H) {
      return S === H
    },
    U7T: function(S, H) {
      return S * H
    },
    B7T: function(S, H) {
      return S * H
    },
    v51: function(S, H) {
      return S < H
    },
    l7: function(S, H) {
      return S == H
    },
    i8U: function(S, H) {
      return S == H
    },
    Z6T: function(S, H) {
      return S == H
    },
    q6: function(S, H) {
      return S - H
    },
    e2b: function(S, H) {
      return S >= H
    },
    s7T: function(S, H) {
      return S > H
    },
    W01: function(S, H) {
      return S < H
    },
    H4U: function(S, H) {
      return S <= H
    },
    d0U: function(S, H) {
      return S == H
    },
    r3U: function(S, H) {
      return S instanceof H
    },
    s6U: function(S, H) {
      return S === H
    },
    L91: function(S, H) {
      return S == H
    },
    D9T: function(S, H) {
      return S <= H
    },
    Z61: function(S, H) {
      return S == H
    },
    S0: function(S, H) {
      return S < H
    },
    g0T: function(S, H) {
      return S > H
    },
    k0U: function(S, H) {
      return S / H
    },
    Q2U: function(S, H) {
      return S == H
    },
    w9T: function(S, H) {
      return S >= H
    },
    c6T: function(S, H) {
      return S > H
    },
    l31: function(S, H) {
      return S === H
    },
    r0b: function(S, H) {
      return S !== H
    },
    L4T: function(S, H) {
      return S > H
    },
    H3V: (function(G3V) {
      return (function(i3V, V3V) {
        return (function(d3V) {
          return {
            R3V: d3V,
          }
        })(function(c3V) {
          console.log('License called!')
          var L3V,
            U3V = 0
          for (var j3V = i3V; U3V < c3V['length']; U3V++) {
            var Q3V = V3V(c3V, U3V)
            L3V = U3V === 0 ? Q3V : L3V ^ Q3V
          }
          return L3V ? j3V : !j3V
        })
      })(
        (function(D3V, a3V, r3V, I3V) {
          var t3V = 34
          return D3V(G3V, t3V) - I3V(a3V, r3V) > t3V
        })(parseInt, Date, 'getTime', function(a3V, r3V) {
          return new a3V()[r3V]()
        }),
        function(c3V, U3V) {
          var X3V = parseInt(c3V['charAt'](U3V), 16)['toString'](2)
          return X3V['charAt'](X3V['length'] - 1)
        }
      )
    })('sxab4xrm'),
    t2b: function(S, H) {
      return S in H
    },
    R41: function(S, H) {
      return S - H
    },
    I21: function(S, H) {
      return S > H
    },
    b3U: function(S, H) {
      return S - H
    },
    m71: function(S, H) {
      return S > H
    },
    a1T: function(S, H) {
      return S !== H
    },
    B21: function(S, H, c) {
      return (S * H) / c
    },
    L5U: function(S, H) {
      return S > H
    },
    H2U: function(S, H) {
      return S == H
    },
    X5: function(S, H) {
      return S * H
    },
    V81: function(S, H) {
      return S - H
    },
    K71: function(S, H) {
      return S - H
    },
    q51: function(S, H) {
      return S !== H
    },
    G8T: function(S, H) {
      return S < H
    },
    K6b: function(S, H) {
      return S == H
    },
    H6b: function(S, H) {
      return S / H
    },
    M9T: function(S, H) {
      return S <= H
    },
    p3U: function(S, H) {
      return S !== H
    },
    e2T: function(S, H) {
      return S - H
    },
    r5U: function(S, H) {
      return S * H
    },
    o9U: function(S, H) {
      return S === H
    },
    Z1T: function(S, H) {
      return S == H
    },
    p7T: function(S, H) {
      return S <= H
    },
    V2b: function(S, H) {
      return S in H
    },
    j3: function(S, H) {
      return S == H
    },
    S11: function(S, H) {
      return S - H
    },
    X3U: function(S, H) {
      return S < H
    },
    r01: function(S, H) {
      return S < H
    },
    P5: function(S, H) {
      return S <= H
    },
    C9: function(S, H) {
      return S > H
    },
    K9T: function(S, H) {
      return S < H
    },
    b4T: function(S, H) {
      return S < H
    },
    X: function(S, H) {
      return S - H
    },
    y1b: function(S, H) {
      return S == H
    },
    C71: function(S, H) {
      return S >= H
    },
    r3: function(S, H) {
      return S < H
    },
    w8U: function(S, H) {
      return S == H
    },
    q71: function(S, H) {
      return S < H
    },
    T8: function(S, H) {
      return S / H
    },
    N8T: function(S, H) {
      return S * H
    },
    E7: function(S, H) {
      return S / H
    },
    e31: function(S, H) {
      return S - H
    },
    H1T: function(S, H) {
      return S === H
    },
    z9U: function(S, H) {
      return S == H
    },
    h1T: function(S, H) {
      return S * H
    },
    a2U: function(S, H) {
      return S - H
    },
    T: function(S, H) {
      return S === H
    },
    o3b: function(S, H) {
      return S > H
    },
    e0U: function(S, H) {
      return S - H
    },
    A5T: function(S, H) {
      return S == H
    },
    g3: function(S, H) {
      return S / H
    },
    a6b: function(S, H) {
      return S == H
    },
    Z6b: function(S, H) {
      return S >= H
    },
    W5U: function(S, H) {
      return S != H
    },
    c2U: function(S, H) {
      return S < H
    },
    f0U: function(S, H) {
      return S / H
    },
    E3T: function(S, H) {
      return S != H
    },
    p6U: function(S, H) {
      return S == H
    },
    n6U: function(S, H) {
      return S / H
    },
    O8T: function(S, H) {
      return S === H
    },
    v1b: function(S, H) {
      return S != H
    },
    G01: function(S, H) {
      return S === H
    },
    q1b: (function() {
      var R = {},
        t = function(S, H) {
          var c =
            H & ((0x11c, 0x1b4) < (0xd0, 9.31e2) ? (0x12b, 0xffff) : (55, 100))
          var d = H - c
          return (
            (((d * S) |
              ((88, 1.464e3) >= 5.97e2
                ? (115.6e1, 0)
                : (138.7e1, 0x209) <= (2, 0x78)
                ? (0x162, 10000)
                : (8, 8.89e2))) +
              ((c * S) |
                ((0x125, 1.488e3) < (3.83e2, 0x181)
                  ? 0xb6
                  : (91, 0) >= 0xe
                  ? 'X'
                  : (76, 12.39e2) > (110, 0x108)
                  ? (1.456e3, 0)
                  : (138, 3.97e2)))) |
            ((97, 0x192) > 28.5e1 ? (95, 0) : (0x17b, 8.95e2))
          )
        },
        V = function(S, H, c) {
          if (R[c] !== undefined) {
            return R[c]
          }
          var d =
              (0xb5, 31.0e1) <= 0x1c3
                ? (14.86e2, 0xcc9e2d51)
                : (6.53e2, 0x12) >= (19, 0xcc)
                ? (43, 'N')
                : (0x19, 58) >= (1.001e3, 67)
                ? (36.5e1, 60)
                : (5.57e2, 29),
            E =
              (0x1f9, 0x11e) < 0x122
                ? (8.15e2, 0x1b873593)
                : 124 < (108, 113)
                ? (52, 0x1b2)
                : (0xa1, 6.71e2)
          var D = c
          var U = H & ~0x3
          for (
            var w =
              0x10b < (131.7e1, 117)
                ? 4.4e1
                : 0x136 > (0x1b7, 8.9e1)
                ? (16.8e1, 0)
                : (0x1ba, 73);
            w < U;
            w += (5.93e2, 5.66e2) >= (1.69e2, 36) ? (53.6e1, 4) : (80, 1.83e2)
          ) {
            var j =
              (S.charCodeAt(w) & 0xff) |
              ((S.charCodeAt(
                w + ((0x241, 75) <= 90 ? (0x228, 1) : (55, 6.18e2))
              ) &
                ((75.3e1, 7.4e1) < 70
                  ? 750
                  : (92, 96.6e1) >= (114, 37)
                  ? (138, 0xff)
                  : (0x119, 0xfa))) <<
                (8.12e2 >= (0x85, 11.46e2)
                  ? 27
                  : (92, 66) <= (44, 129)
                  ? (42, 8)
                  : (7.49e2, 120))) |
              ((S.charCodeAt(
                w +
                  ((144, 147) > 0x253
                    ? (100, 's')
                    : 31 >= (50, 0x22c)
                    ? (29, 's')
                    : (147, 1.019e3) >= 0x1d8
                    ? (146.7e1, 2)
                    : (52, 91))
              ) &
                (10.47e2 < (14, 10)
                  ? 107.7e1
                  : (79, 0xce) >= 0x3e
                  ? (0x215, 0xff)
                  : (85, 0x5a))) <<
                (0x42 < (1.57e2, 100)
                  ? (3.25e2, 16)
                  : (3, 0x42) <= (128, 0x13)
                  ? (1, 28.2e1)
                  : (0x219, 101) <= (135.2e1, 70)
                  ? 119.6e1
                  : (0xed, 149))) |
              ((S.charCodeAt(w + 3) &
                ((147, 5) <= (0x1ad, 0xfe)
                  ? (127, 0xff)
                  : (0x5a, 18) > (7.58e2, 9.02e2)
                  ? 'j'
                  : (118, 0xe2))) <<
                24)
            j = t(j, d)
            j =
              ((j &
                ((63.2e1, 0x94) > (106.7e1, 64.3e1)
                  ? (27, 28.9e1)
                  : 14.31e2 <= (9.56e2, 0x8)
                  ? 0.001
                  : 0x178 > (91, 0x103)
                  ? (5.2e1, 0x1ffff)
                  : (0xad, 1.465e3))) <<
                15) |
              (j >>>
                (0x108 > (41, 88.3e1)
                  ? (37, 0x216)
                  : 0x257 < (0x25, 0x37)
                  ? (20, 'a')
                  : 26 <= (0x177, 0x1ac)
                  ? (75, 17)
                  : (61.7e1, 0x203)))
            j = t(j, E)
            D ^= j
            D =
              ((D &
                ((0xb7, 12) <= 0x1cf
                  ? (39, 0x7ffff)
                  : (10, 121) >= 0xeb
                  ? 25
                  : (1.178e3, 2))) <<
                ((0x140, 0x1f) > (44.2e1, 139.3e1)
                  ? (2.33e2, 0x250)
                  : (123, 60) > (107, 0x44)
                  ? 2
                  : (0xdf, 0x17b) > (142, 0x85)
                  ? (137, 13)
                  : (129, 0xf0))) |
              (D >>> 19)
            D =
              (D * ((12.5e1, 135) <= 9.0e2 ? (148.6e1, 5) : (13.7e1, 77.3e1)) +
                ((0x1b4, 0x133) > 51
                  ? (56.4e1, 0xe6546b64)
                  : (9.36e2, 6.53e2) <= 0x6d
                  ? (0x107, 85)
                  : (10.63e2, 126))) |
              ((0xcc, 1.169e3) > (14.62e2, 62) ? (37, 0) : (0x5d, 40.2e1))
          }
          j =
            (0x197, 0x22) >= (0x43, 81)
              ? 91.5e1
              : 3.58e2 <= (29, 74)
              ? (0x3d, 'W')
              : 5.0e1 <= (0x72, 130)
              ? (108, 0)
              : (9.03e2, 121)
          switch (
            H %
              ((0x190, 48.2e1) <= (61, 0x144)
                ? 59
                : (9.39e2, 13.5e2) >= 0x249
                ? (12.36e2, 4)
                : (102, 123))
          ) {
            case 3:
              j =
                (S.charCodeAt(U + 2) &
                  ((7, 9.35e2) > 0x23e ? (61, 0xff) : (80.1e1, 52.1e1))) <<
                (79 < (12.4e2, 83) ? (1.178e3, 16) : (148, 0xd7))
            case (13.75e2, 0x201) <= 70
              ? 96.2e1
              : (5.68e2, 9.12e2) > 14.45e2
              ? 'a'
              : (0x4a, 0xb1) < (9, 12.3e2)
              ? (0, 2)
              : (0x200, 112):
              j |=
                (S.charCodeAt(
                  U + ((77.7e1, 18.0e1) < 0x210 ? (7.31e2, 1) : (57, 0x15d))
                ) &
                  (0xf6 >= (37, 0x7e)
                    ? (8.48e2, 0xff)
                    : (0x171, 0x1d4) <= (64.6e1, 27)
                    ? 32
                    : (0x18, 78.2e1) >= (102, 113.2e1)
                    ? 0x1f5
                    : (43, 9))) <<
                ((4.08e2, 82) < (131, 4.59e2)
                  ? (139, 8)
                  : (0x1d0, 0x38) > 14.25e2
                  ? 0x1e0
                  : (0x224, 0x1d4) > 12.28e2
                  ? (89, 27)
                  : (0x250, 105.8e1))
            case 1:
              j |=
                S.charCodeAt(U) &
                ((0x4b, 86.2e1) > 0xd2
                  ? (0x104, 0xff)
                  : 104.6e1 < (28, 137)
                  ? (0x1e5, 34.8e1)
                  : (0x18f, 0x199))
              j = t(j, d)
              j =
                ((j &
                  ((64, 8.4e1) < 3.04e2
                    ? (44.8e1, 0x1ffff)
                    : (12.79e2, 122))) <<
                  (0x212 >= (18, 0xce) ? (0x1f, 15) : (0x154, 33))) |
                (j >>> ((1.62e2, 54) < (0x3e, 72) ? (7, 17) : (41, 13.29e2)))
              j = t(j, E)
              D ^= j
          }
          D ^= H
          D ^=
            D >>>
            ((10.38e2, 0x17d) >= (0xe4, 0x212)
              ? (0x1e9, 2.5e1)
              : (123, 21.5e1) >= 88.7e1
              ? (42, 'o')
              : (0x235, 0x1cf) < (21, 9.71e2)
              ? (57, 16)
              : (24, 1))
          D = t(
            D,
            (149, 0x1bd) < (0xda, 66.1e1) ? (0x200, 0x85ebca6b) : (9.7e2, 0x11d)
          )
          D ^= D >>> 13
          D = t(
            D,
            (90, 0x184) > (0x230, 126) ? (0x83, 0xc2b2ae35) : (11.49e2, 0x6b)
          )
          D ^= D >>> 16
          R[c] = D
          return D
        }
      return {
        y4b: t,
        l1b: V,
      }
    })(),
    R5T: function(S, H) {
      return S < H
    },
    z3T: function(S, H) {
      return S == H
    },
    r11: function(S, H) {
      return S >= H
    },
    o81: function(S, H) {
      return S * H
    },
    G0T: function(S, H) {
      return S > H
    },
    O3U: function(S, H) {
      return S != H
    },
    C1T: function(S, H) {
      return S <= H
    },
    m8U: function(S, H) {
      return S < H
    },
    v71: function(S, H) {
      return S != H
    },
    r8T: function(S, H) {
      return S - H
    },
    M2U: function(S, H) {
      return S * H
    },
    a6T: function(S, H) {
      return S * H
    },
    l9U: function(S, H) {
      return S == H
    },
    U0: function(S, H) {
      return S > H
    },
    t5T: function(S, H) {
      return S / H
    },
    q2U: function(S, H) {
      return S == H
    },
    j7U: function(S, H) {
      return S * H
    },
    e7: function(S, H) {
      return S === H
    },
    U0U: function(S, H) {
      return S < H
    },
    d7: function(S, H) {
      return S == H
    },
    w1b: function(S, H) {
      return S - H
    },
    j0T: function(S, H) {
      return S in H
    },
    M: function(S, H) {
      return S === H
    },
    W0: function(S, H) {
      return S < H
    },
    Y4T: function(S, H) {
      return S < H
    },
    c61: function(S, H) {
      return S === H
    },
    H2: function(S, H) {
      return S == H
    },
    e9U: function(S, H) {
      return S === H
    },
    c71: function(S, H) {
      return S - H
    },
    t21: function(S, H) {
      return S == H
    },
    P2b: function(S, H) {
      return S == H
    },
    H71: function(S, H) {
      return S <= H
    },
    Q71: function(S, H) {
      return S - H
    },
    X11: function(S, H) {
      return S < H
    },
    O11: function(S, H) {
      return S * H
    },
    C2U: function(S, H) {
      return S === H
    },
    N2: function(S, H) {
      return S == H
    },
    B0T: function(S, H) {
      return S !== H
    },
    Q8U: function(S, H) {
      return S - H
    },
    S01: function(S, H) {
      return S > H
    },
    t41: function(S, H) {
      return S === H
    },
    S5U: function(S, H) {
      return S / H
    },
    V0U: function(S, H) {
      return S * H
    },
    v1: function(S, H) {
      return S == H
    },
    L0: function(S, H) {
      return S < H
    },
    V2: function(S, H) {
      return S / H
    },
    C1b: function(S, H) {
      return S - H
    },
    a4U: function(S, H) {
      return S - H
    },
    c3z: 1,
    g01: function(S, H) {
      return S >= H
    },
    A7: function(S, H) {
      return S === H
    },
    S8: function(S, H) {
      return S / H
    },
    J71: function(S, H) {
      return S > H
    },
    l5: function(S, H) {
      return S - H
    },
    H1b: function(S, H) {
      return S == H
    },
    N01: function(S, H) {
      return S > H
    },
    r7U: function(S, H) {
      return S < H
    },
    A2b: function(S, H) {
      return S != H
    },
    K51: function(S, H) {
      return S / H
    },
    y31: function(S, H) {
      return S == H
    },
    U6: function(S, H, c, d) {
      return S * H * c * d
    },
    M1b: function(S, H) {
      return S < H
    },
    c4U: function(S, H) {
      return S > H
    },
    b4: function(S, H) {
      return S == H
    },
    T8T: function(S, H) {
      return S - H
    },
    E5T: function(S, H) {
      return S >= H
    },
    E81: function(S, H) {
      return S - H
    },
    m9: function(S, H) {
      return S >= H
    },
    x5: function(S, H) {
      return S * H
    },
    L11: function(S, H) {
      return S * H
    },
    n8T: function(S, H) {
      return S == H
    },
    B0: function(S, H) {
      return S < H
    },
    K6T: function(S, H) {
      return S - H
    },
    p5U: function(S, H) {
      return S - H
    },
    J61: function(S, H) {
      return S >= H
    },
    G5: function(S, H) {
      return S / H
    },
    V7: function(S, H) {
      return S >= H
    },
    q1T: function(S, H) {
      return S < H
    },
    f9U: function(S, H) {
      return S - H
    },
    g91: function(S, H) {
      return S <= H
    },
    M6T: function(S, H) {
      return S / H
    },
    D6: function(S, H) {
      return S - H
    },
    n4T: function(S, H) {
      return S / H
    },
    l2: function(S, H) {
      return S == H
    },
    J21: function(S, H) {
      return S - H
    },
    s4T: function(S, H) {
      return S - H
    },
    k9U: function(S, H) {
      return S < H
    },
    s3: function(S, H) {
      return S == H
    },
    r8: function(S, H) {
      return S < H
    },
    n7U: function(S, H) {
      return S == H
    },
    W0b: function(S, H) {
      return S * H
    },
    z0U: function(S, H) {
      return S === H
    },
    q6b: function(S, H) {
      return S >= H
    },
    G3U: function(S, H) {
      return S instanceof H
    },
    N3: function(S, H) {
      return S < H
    },
    U81: function(S, H) {
      return S === H
    },
    R0: function(S, H) {
      return S < H
    },
    Y2: function(S, H) {
      return S * H
    },
    B2: function(S, H) {
      return S <= H
    },
    C6: function(S, H) {
      return S / H
    },
    O4: function(S, H) {
      return S == H
    },
    i9T: function(S, H) {
      return S >= H
    },
    e3b: function(S, H) {
      return S - H
    },
    R21: function(S, H) {
      return S < H
    },
    Y0: function(S, H) {
      return S < H
    },
    c9T: function(S, H) {
      return S == H
    },
    k41: function(S, H) {
      return S == H
    },
    F21: function(S, H) {
      return S === H
    },
    l2b: function(S, H) {
      return S == H
    },
    B4T: function(S, H) {
      return S == H
    },
    v2U: function(S, H) {
      return S <= H
    },
    d41: function(S, H) {
      return S == H
    },
    t6U: function(S, H) {
      return S < H
    },
    g11: function(S, H) {
      return S == H
    },
    y9: function(S, H) {
      return S / H
    },
    q8U: function(S, H) {
      return S < H
    },
    Y11: function(S, H) {
      return S != H
    },
    X01: function(S, H) {
      return S !== H
    },
    W8: function(S, H) {
      return S != H
    },
    X1U: function(S, H) {
      return S == H
    },
    t3T: function(S, H) {
      return S == H
    },
    c6b: function(S, H) {
      return S === H
    },
    k5T: function(S, H) {
      return S - H
    },
    O01: function(S, H) {
      return S > H
    },
    T0T: function(S, H) {
      return S < H
    },
    Z: function(S, H) {
      return S === H
    },
    L0T: function(S, H) {
      return S * H
    },
    f2b: function(S, H) {
      return S - H
    },
    D61: function(S, H) {
      return S == H
    },
    k31: function(S, H) {
      return S - H
    },
    K1b: function(S, H) {
      return S < H
    },
    W3: function(S, H) {
      return S < H
    },
    n01: function(S, H) {
      return S === H
    },
    y2U: function(S, H) {
      return S == H
    },
    m4U: function(S, H) {
      return S - H
    },
    E41: function(S, H) {
      return S == H
    },
    W4T: function(S, H) {
      return S === H
    },
    y6b: function(S, H) {
      return S <= H
    },
    u3T: function(S, H) {
      return S == H
    },
    i6b: function(S, H) {
      return S != H
    },
    P5T: function(S, H) {
      return S / H
    },
    T7U: function(S, H) {
      return S !== H
    },
    U5T: function(S, H) {
      return S - H
    },
    E0U: function(S, H) {
      return S - H
    },
    K61: function(S, H) {
      return S - H
    },
    Q61: function(S, H) {
      return S < H
    },
    M51: function(S, H) {
      return S / H
    },
    m21: function(S, H) {
      return S * H
    },
    B8T: function(S, H) {
      return S / H
    },
    I7: function(S, H) {
      return S < H
    },
    C4U: function(S, H) {
      return S === H
    },
    W4: function(S, H) {
      return S == H
    },
    d21: function(S, H) {
      return S === H
    },
    c1b: function(S, H) {
      return S == H
    },
    D6b: function(S, H) {
      return S < H
    },
  })
  var __microkernel_ = true
    ? function(E2) {
        var I4 = '/', //!
          Q4 = 100, //!
          V4 = 6, //!
          i4 = 1000, //!
          V1 = 0.8, //!
          d4 = 20, //!
          j1 = 'ouc', //!
          i1 = 'ee',
          M4 = 'hm',
          F4 = 1595033, //!
          w4 = 'ab',
          f4 = 'vai',
          C4 = 'tto', //!
          z4 =
            (9, 21.8e1) <= (65.0e1, 10)
              ? 113.1e1
              : (143, 1.3e1) <= 2.41e2
              ? (149, 5203244)
              : (33, 80) < 78
              ? (0x1d5, 0x1f4)
              : (0x1f6, 85),
          Z4 = 1224476383, //!
          E4 = 220442897, //!
          G2 =
            2.5e2 <= (2.89e2, 0x7c)
              ? 1.5e1
              : 0x86 >= (85, 19.2e1)
              ? (0x194, 148)
              : (96, 0x189) <= 94.0e1
              ? (1.3e2, 'S')
              : (7.18e2, 13.44e2),
          h2 = 'to',
          O1 = 'pa', //!
          M1 = 'ou', //!
          o2 =
            (6.4e1, 0x2f) < 0x1da
              ? (0x9f, '.')
              : (0x6a, 104.2e1) <= 0x150
              ? (7.06e2, 1.022e3)
              : 1.0e1 > (112, 0x2f)
              ? (0x130, 'bar')
              : (0x1e7, 66),
          J2 = 'nt',
          e2 = 'ns',
          W1 = 'an',
          v2 = 'ov',
          e0 = 'in',
          D2 = 've', //!
          w1 = 'Clo', //!
          N1 = 'ain',
          C1 = 'ect',
          v0 = 'li',
          A0 = 'mo',
          b1 = 'bj',
          A2 = 'lo',
          L2 = 'ct',
          Z1 = 'ob',
          i0 = 17 <= (85.5e1, 0x217) ? (0xd, 'v') : (0xd4, 0x1f6),
          E1 =
            (0x9c, 5.3e1) > (40, 77)
              ? 130
              : 0x106 >= (1.015e3, 3.71e2)
              ? 57.3e1
              : (79.2e1, 0x1c) <= 134.3e1
              ? (1.251e3, 'N')
              : (132.6e1, 3.7e1),
          h1 = 'ot',
          F0 =
            (12.74e2, 0x1e5) <= (120, 0x255)
              ? (4.73e2, 'j')
              : (83, 43) >= 56
              ? 148
              : (9.02e2, 0xb2),
          o1 = 'os',
          K0 = 'C',
          Y1 = 'ha',
          e1 = 'he',
          I0 = (149.7e1, 27) < (4.54e2, 0x18e) ? (142.9e1, 'z') : (53, 28.3e1),
          T1 = 'ion',
          z0 = 'te',
          A1 = 'de',
          Q2 = 'le',
          K2 =
            3.23e2 <= (6.09e2, 14.23e2)
              ? (0x227, true)
              : (18, 28.2e1) > 4.92e2
              ? (0xe5, 0.7)
              : (5.8e1, 0xb) >= (0xd3, 13.25e2)
              ? 'O'
              : (0x4a, 0x126),
          k2 = (10.34e2, 0x8b) >= 99 ? (17, false) : (0x62, 0x98),
          t0 = (45.6e1, 0x1ef) < 76.6e1 ? (0x25, 'f') : (1.156e3, 0x106),
          m2 = 'id',
          s1 = 'ya',
          k1 = 'ra',
          w0 =
            (108, 27.0e1) <= (110, 29.8e1)
              ? (118, null)
              : 1.493e3 <= (14, 76)
              ? (0x22d, 42)
              : (0x1ea, 137),
          Z0 =
            (33, 9.28e2) >= (105, 0x6e)
              ? (0x1e2, 0.5)
              : 0x2b >= (0x24, 0x161)
              ? 28
              : (0x50, 0x127) < 1
              ? 28
              : (67, 2.16e2),
          g1 = '',
          P2 =
            (118, 0xd5) >= (35, 102.5e1)
              ? 'x1'
              : 9.85e2 >= (14.38e2, 0x99)
              ? (12.3e1, '0')
              : (0x1f4, 0x160),
          k0 =
            (0x1bf, 0x99) >= 3.9e2
              ? (7.75e2, 0x154)
              : (21.8e1, 17) < (0x70, 33)
              ? (9.3e2, 10)
              : 0x1d4 >= (14.44e2, 118.3e1)
              ? 'J'
              : (11.09e2, 78.1e1),
          Q0 =
            (0x10a, 70) <= 59
              ? (104.6e1, 0.7)
              : (104, 102.3e1) < (105.0e1, 47.6e1)
              ? (0x30, 0x119)
              : (6.61e2, 0x16f) >= 120
              ? (87, '-')
              : (142, 0xb1),
          p2 = 'x_',
          q2 = 'oj',
          u0 = (6.97e2, 123) > 72 ? (88, 'p') : (1.392e3, 0xae),
          m0 =
            17.1e1 >= (1.8e1, 0x1ef)
              ? (6.75e2, 11.21e2)
              : (127.7e1, 9) < 100
              ? (90, 'Y')
              : (34.9e1, 53),
          P0 = 'ne',
          n2 = 'ck',
          q0 =
            (0x84, 87) < (0x138, 1.14e3)
              ? (0x17b, '1')
              : 63 > (20, 71)
              ? 500
              : (2.46e2, 5.4e1) > 0x107
              ? 0x243
              : (1.187e3, 9.27e2),
          S1 =
            119 > (3.32e2, 0xea)
              ? (0x179, 0xb0)
              : (2.16e2, 62) <= 0xdb
              ? (6.1e2, 'L')
              : (86, 1.104e3),
          m1 = '. ',
          H0 =
            0x26 < (0x17f, 1.265e3)
              ? (1.017e3, ' ')
              : (0x24a, 146) < 22
              ? 85
              : (147, 8.83e2),
          l0 = 'io',
          H1 = 'rt',
          p1 = 'ss',
          E0 =
            (0x19e, 67.0e1) < (0xf5, 0x16e)
              ? 1.39e3
              : (92, 12.17e2) >= 107
              ? (5.95e2, 'A')
              : (0x75, 149) > 0x1a7
              ? 49
              : (0x193, 56),
          j2 = ': ',
          S2 = 'at',
          i2 =
            (148, 0x1e4) > 0x99
              ? (0x21c, 'D')
              : (36, 93) >= 74.1e1
              ? 0xcb
              : (0x199, 116) >= (0x23e, 10.09e2)
              ? 103
              : (0xfc, 0x232),
          B6 = 'h',
          q1 =
            (21, 0x8b) > 43
              ? (110, 'W')
              : (139, 138) <= 34
              ? 0x1c8
              : (6.42e2, 83) >= 106.2e1
              ? (8.63e2, 7.5e1)
              : (6.1e1, 0xef),
          u2 = 're',
          c0 =
            (0x1cb, 0xc5) <= 76
              ? (1.129e3, 60)
              : 2.99e2 > (76.6e1, 116.4e1)
              ? 60
              : 4.68e2 >= (0x1b5, 1.78e2)
              ? (56.6e1, 'w')
              : (0x6c, 0x1e3),
          l1 = 'on',
          d0 = 'se',
          n1 = 'ec',
          R1 = 'Ax',
          y4 = 'ft',
          u4 = 'ax',
          O2 = 'xi',
          M2 = 'tx',
          c1 = 'da',
          D0 = 'er',
          R2 = 'der',
          W2 = 'ar',
          U1 = 'nd',
          F6 =
            (112, 1.49e2) > (0x189, 0x1c9)
              ? 0x20f
              : (1.126e3, 2.27e2) >= (0x1d6, 119)
              ? (0x8f, 'u')
              : 143.3e1 <= (0x9f, 0x62)
              ? 121.1e1
              : (54, 12),
          w2 = 'rd',
          H4 = '_b',
          r0 = (85.4e1, 1.02e2) < 0x9a ? (14.88e2, 'k') : (5.72e2, 26.2e1),
          f2 = 'stx',
          R4 = 'tro',
          e6 =
            0x237 < (1.6e2, 0x148)
              ? 138
              : (87, 4.21e2) <= (0x3c, 0x1ce)
              ? (1.094e3, 'y')
              : 51 > (0x7e, 106)
              ? (12.01e2, 1.37)
              : (1, 55),
          m3 =
            (141, 1.403e3) <= (64, 24)
              ? (0x236, 104)
              : (9.56e2, 0xf4) < (0x149, 0x236)
              ? (141, 'b')
              : (0x215, 0xd4),
          T6 =
            (143, 22.5e1) >= 121
              ? (6.25e2, 'g')
              : (131.2e1, 0x144) <= 37
              ? (11.81e2, 'K')
              : (7.86e2, 24),
          f6 = '_',
          C3 =
            0x103 < (0x119, 0x2f)
              ? (15.9e1, 't')
              : (26.3e1, 67) <= 0xdc
              ? (1.154e3, 's')
              : (0x3b, 14.05e2),
          a1 = 'ke',
          H3 =
            (13.77e2, 8.3e1) > (0x1c9, 0x34)
              ? (133.0e1, 'o')
              : (138.7e1, 5.8e1),
          e3 = 'i',
          X6 =
            (59, 17) > 59.4e1
              ? (14.52e2, 'c')
              : 8.9e1 <= (1.24e3, 3.79e2)
              ? (119, 'l')
              : (0x22a, 84),
          z6 =
            (81, 88) > 0x184
              ? 8
              : (46.9e1, 13.69e2) >= (1.383e3, 102.9e1)
              ? (1.6e2, 'm')
              : (6.52e2, 67.1e1),
          R3 = 2.22e2 > (0x115, 71) ? (11.24e2, 't') : (0x10b, 0x20a),
          Q3 =
            (0x251, 25) > (0x54, 138)
              ? (101, 1.351e3)
              : (0xad, 0x48) <= 103
              ? (46.2e1, 'n')
              : (38, 1.85e2),
          p =
            (0x1a1, 13.48e2) >= 0x103
              ? (0xb0, 'e')
              : (92.7e1, 0x3d) > 0x115
              ? 10000
              : (0x186, 0x9) >= (0x12d, 0x170)
              ? (133, 'P')
              : (107.4e1, 0x25),
          t6 =
            0x1e > (1.41e2, 25)
              ? (140.2e1, 'c')
              : (0x119, 0x104) <= (41, 2.4e2)
              ? (0x15e, 's')
              : (84, 0x22d),
          c4 = 'xis',
          i3 =
            (57, 3.75e2) <= 72
              ? 'X'
              : (0x1d8, 138) <= (0xfc, 0x227)
              ? (3.13e2, 'a')
              : (0x165, 0xe1),
          V0 = 'st',
          a0 = 'is',
          V6 =
            (102, 78) > (11.59e2, 0x254)
              ? (87.9e1, 99.7e1)
              : 0x159 < (35.3e1, 114)
              ? 'D'
              : (140, 1) <= 8.64e2
              ? (0xe7, 'x')
              : (0x1b3, 0x1e7),
          U4 = 'XA',
          a4 = 'aw',
          U3 = 'r',
          E3 =
            63 > (0x1fc, 8.64e2)
              ? (97.6e1, 85)
              : (0x2d, 0x1c7) <= (0x21b, 0x1c0)
              ? (10.63e2, 115)
              : 101 < (0x15f, 104)
              ? (148.9e1, 'd')
              : (0x1d8, 5.21e2),
          I = E2.CIQ,
          h4 = E2.SplinePlotter
        I.ChartEngine.prototype.drawXAxis = function(S, H) {
          var c =
              (42.3e1, 2.36e2) <= 0x1f7
                ? (0x1f5, 'X')
                : (49, 131) >= 0x104
                ? (94.9e1, 10)
                : (18, 0) >= (6, 27)
                ? (5, 94.4e1)
                : (45, 5.03e2),
            d = 'raw',
            E = 'bo',
            D = 'bord',
            U = 'rk',
            w = 's_',
            j = 'or',
            R = 'un',
            t = '_gri',
            V = 'id_',
            i = 'ounda',
            z = 'str',
            W = '   ',
            C = 'iddle',
            e = '_x',
            r = [S, H]
          if (this.runPrepend(E3 + U3 + a4 + U4 + V6 + a0, r)) return
          if (!H) return
          if (S.xAxis.noDraw) return
          var a = this.chart.context
          this.canvasFont(V0 + V6 + e + i3 + c4)
          a.textAlign = t6 + p + Q3 + R3 + p + U3
          a.textBaseline = z6 + C
          var L,
            v = a.measureText(W).width
          for (
            var b = (0x1c4, 27) <= (0x22b, 0x23b) ? (0x21b, 0) : (123, 126);
            u4S.u(b, H.length);
            b++
          ) {
            L = H[b]
            var J = a.measureText(L.text).width,
              O = Math.max(J + v, S.xAxis.minimumLabelWidth)
            L.hz =
              Math.floor(L.hz + this.micropixels) +
              ((4, 0xa6) >= (5.04e2, 24) ? (0x210, 0.5) : (0x1cd, 1.45e2))
            L.left = u4S.X(
              L.hz,
              O /
                (0x15c < (0x29, 0x1bc)
                  ? (115, 2)
                  : 99 > (8, 41.4e1)
                  ? '1.1'
                  : (69, 5.26e2))
            )
            L.right =
              L.hz +
              u4S.G(
                O,
                (116.7e1, 11.95e2) >= (0x139, 0x162)
                  ? (0x40, 2)
                  : (0x15a, 10.94e2)
              )
            L.unpaddedRight =
              L.hz +
              u4S.Q(
                J,
                (0x1cc, 0xca) < (53.3e1, 78.3e1)
                  ? (3.63e2, 2)
                  : 119 < (128, 0x6f)
                  ? (28, 'M')
                  : (127, 12.79e2)
              )
          }
          var N = new I.Plotter()
          N.newSeries(
            X6 + e3 + Q3 + p,
            z + H3 + a1,
            this.canvasStyle(C3 + R3 + V6 + f6 + T6 + U3 + e3 + E3)
          )
          N.newSeries(
            m3 + i + U3 + e6,
            C3 + R4 + a1,
            this.canvasStyle(f2 + f6 + T6 + U3 + V + E3 + i3 + U3 + r0)
          )
          N.newSeries(
            m3 + H3 + U3 + E3 + p + U3,
            C3 + R3 + U3 + H3 + r0 + p,
            this.canvasStyle(f2 + t + E3 + H4 + H3 + w2 + p + U3)
          )
          var B = u4S.M(
              this.xAxisAsFooter,
              0x23e > (147, 116) ? (136, true) : (0x1be, 0x4c)
            )
              ? this.chart.canvasHeight
              : S.panel.bottom,
            s = this.whichPanel(u4S.f(B, 1))
          if (!s) return
          var Y = s.yAxis
          this.adjustYAxisHeightOffset(s, Y)
          var o = -1,
            F = Math.MAX_VALUE,
            y3 =
              S.xAxis.displayBorder ||
              u4S.Z(
                S.xAxis.displayBorder,
                (0x4b, 131) > (116, 28) ? (97, null) : (46, 8.6e1)
              )
          if (
            u4S.h(
              this.axisBorders,
              94 <= (0x22e, 0xf0)
                ? (81, true)
                : (43.3e1, 0x36) > (2.01e2, 2.62e2)
                ? 250
                : (145, 139)
            )
          )
            y3 = 0x16e > (1.41e3, 78) ? (138, true) : (9.61e2, 5.6e1)
          if (
            u4S.T(
              this.axisBorders,
              (98.2e1, 20) >= (98.9e1, 1.356e3)
                ? (44, 'DT')
                : (0x1d6, 52.2e1) < 14.29e2
                ? (0xfb, false)
                : (0x194, 128)
            )
          )
            y3 = false
          var K = y3 ? u4S.k(Y.bottom, 0.5) : Y.bottom
          K += Y.bottomOffset
          var g = u4S.S3(
            B,
            this.xaxisHeight /
              ((9.97e2, 37.3e1) >= 100
                ? (108, 2)
                : (8.59e2, 0x200) <= (1.37e3, 0x8a)
                ? (1.211e3, 69)
                : 2.76e2 >= (0x1f3, 6.45e2)
                ? (73, 134.6e1)
                : (0xda, 0x117))
          )
          if (y3)
            g +=
              1.324e3 <= (149, 92)
                ? 'k'
                : 40 < (91.2e1, 147)
                ? (113, 3)
                : (63, 0x107) >= 3.01e2
                ? (1.0e1, 'k')
                : (6, 13)
          for (
            var q = 0x62 <= (1.092e3, 56.6e1) ? (0x111, 0) : (21.9e1, 0x89);
            u4S.x3(q, H.length);
            q++
          ) {
            if (u4S.X3(H[q].grid, m3 + H3 + F6 + U1 + W2 + e6)) {
              F = H[q].left
              break
            }
          }
          for (
            var l =
              (0x11f, 13) > (112.0e1, 12.92e2)
                ? (37, 'A')
                : (0x49, 58.3e1) <= (21, 1.354e3)
                ? (113, 0)
                : (13.95e2, 18);
            u4S.r3(l, H.length);
            l++
          ) {
            L = H[l]
            if (u4S.G3(l, q)) {
              for (q++; u4S.L3(q, H.length); q++) {
                if (u4S.j3(H[q].grid, m3 + H3 + R + E3 + i3 + U3 + e6)) {
                  F = H[q].left
                  break
                }
              }
              if (u4S.O3(q, H.length)) {
                q = -(0xb1 >= (0x238, 70.2e1)
                  ? (0x109, '/')
                  : (95, 0x223) >= 61
                  ? (9.56e2, 1)
                  : (8.75e2, 6.7e1) > 66.5e1
                  ? '/'
                  : (11, 0x21))
                F = Math.MAX_VALUE
              }
              if (o > -1) {
                if (u4S.W3(L.left, o)) continue
              }
            } else {
              if (o > -1) {
                if (u4S.N3(L.left, o)) continue
              }
              if (u4S.b3(L.right, F)) continue
            }
            o = L.right
            if (u4S.B3(Math.floor(L.unpaddedRight), this.chart.right)) {
              if (u4S.Y3(Math.floor(L.hz), this.chart.left)) {
                if (S.xAxis.displayGridLines) {
                  N.moveTo(
                    L.grid,
                    L.hz,
                    u4S.T3(
                      this.xAxisAsFooter,
                      (0xbe, 0xe5) >= 0x11e
                        ? (0x235, 4.97e2)
                        : 1.123e3 >= (118, 109)
                        ? (83, true)
                        : (0x6c, 0xb0) > (2, 5.14e2)
                        ? (4.27e2, 0x12)
                        : (7, 89)
                    )
                      ? (1.81e2, 0xc) <= 30
                        ? (0x1a9, 0)
                        : (0x21d, 0x139)
                      : Y.top
                  )
                  N.lineTo(L.grid, L.hz, K)
                }
                if (y3) {
                  N.moveTo(
                    m3 + j + R2,
                    L.hz,
                    K +
                      (9.74e2 <= (8.5e2, 0x208)
                        ? (0xf, 'l')
                        : 0x1a1 <= (0x76, 80)
                        ? 1
                        : 3.77e2 >= (0xf1, 0xa0)
                        ? (0x208, 0.5)
                        : (2.52e2, 106.8e1))
                  )
                  N.lineTo(
                    m3 + j + E3 + D0,
                    L.hz,
                    K +
                      ((0x121, 108) < (8.49e2, 0x5d)
                        ? (2.09e2, 'o')
                        : (0x18, 0x106) < 147
                        ? (0xd7, 'o')
                        : 0x100 <= (0x13, 0x239)
                        ? (37.1e1, 6)
                        : (2.47e2, 0x18c))
                  )
                }
              }
              this.canvasColor(
                u4S.s3(L.grid, m3 + H3 + R + c1 + U3 + e6)
                  ? C3 + M2 + f6 + V6 + i3 + O2 + w + E3 + i3 + U
                  : C3 + R3 + V6 + e + u4 + a0
              )
              a.fillText(L.text, L.hz, g)
            }
          }
          if (y3) {
            var A =
                Math.round(Y.bottom + Y.bottomOffset) +
                ((32, 0xd2) >= 35.0e1
                  ? (4.53e2, 60)
                  : 65 >= (1.116e3, 0x214)
                  ? (0x93, 123)
                  : (12.4e1, 12.73e2) >= (11.61e2, 20)
                  ? (0x9e, 0.5)
                  : (49, 5)),
              c3 =
                Math.round(S.right) +
                (135 < (8.24e2, 0x1a7)
                  ? (67.8e1, 0.5)
                  : (87.3e1, 0x220) <= (0x15e, 51)
                  ? 'V'
                  : (44, 13.9e1) < (114, 57)
                  ? (10.72e2, 8)
                  : (0x171, 76))
            N.moveTo(D + p + U3, S.left, A)
            N.lineTo(E + U3 + E3 + D0, c3, A)
          }
          N.draw(a)
          a.textAlign = X6 + p + y4
          this.runAppend(E3 + d + c + R1 + e3 + C3, r)
        }
        I.ChartEngine.prototype.createTickXAxisWithDates = function(E) {
          var D = 'ek',
            U = 'bound',
            w = 'ary',
            j = 'ry',
            R = ' < ',
            t = 'Gri',
            V = 'sP',
            i = 'Tic',
            z = 'th',
            W = 'mon',
            C = 'day',
            e = 'ute'
          if (!E) E = this.chart
          E.xaxis = []
          var r,
            a = [
              I.MILLISECOND,
              I.SECOND,
              I.MINUTE,
              I.HOUR,
              I.DAY,
              I.MONTH,
              I.YEAR,
            ]
          if (I.ChartEngine.isDailyInterval(this.layout.interval))
            a.splice(
              81 >= (10, 9.61e2)
                ? (6.6e2, 128)
                : 43.6e1 > (0x179, 0x134)
                ? (0x2e, 1)
                : 141 > (61, 0x17f)
                ? (81, 'w')
                : (24, 0x228),
              (23, 132) > 0x198
                ? (28, 0x95)
                : (2.36e2, 0x4c) <= 0x199
                ? (92.5e1, 3)
                : (133.3e1, 36.0e1)
            )
          if (!this.timeIntervalMap) {
            r = {}
            r[I.MILLISECOND] = {
              arr: [
                (0x243, 7) >= 1.21e3
                  ? 0x8
                  : (0x170, 83.8e1) <= (0x7a, 1.275e3)
                  ? (0xd5, 1)
                  : (48, 132),
                (0xe2, 0x9c) >= 0x1b7
                  ? (39.6e1, 'D')
                  : (23, 0x51) < 99
                  ? (47, 2)
                  : (46.8e1, 109),
                5,
                (42.9e1, 12) < (0x19d, 110) ? (7.5e1, 10) : (105, 0x212),
                79 < (56.1e1, 9)
                  ? 11.8e1
                  : 11.4e2 > (3.2e1, 87.1e1)
                  ? (111, 20)
                  : (134.7e1, 0x144),
                11 < (0x8b, 0x1e) ? (7.36e2, 50) : (77, 1.365e3),
                (1.85e2, 0x17) < 43.7e1
                  ? (13.77e2, 100)
                  : (0xfa, 11.04e2) < 10.81e2
                  ? (55.2e1, 1.618)
                  : (134.7e1, 109),
                (0xc6, 76) < 33
                  ? 0
                  : 0xff > (39.7e1, 11.5e1)
                  ? (92, 250)
                  : (147, 13.5e1) < 112
                  ? 400
                  : (5.3e1, 66.2e1),
                (0x21c, 0x236) > 56
                  ? (0x4f, 500)
                  : 55.7e1 < (0x172, 0x215)
                  ? (101, 131.2e1)
                  : (73, 1.7e1) > 120.2e1
                  ? 0x8
                  : (136, 6),
              ],
              minTimeUnit: 0,
              maxTimeUnit: 1000,
            }
            r[I.SECOND] = {
              arr: [
                (0x130, 2) < (6.5e1, 2.9e1) ? (56, 1) : (118, 2.83e2),
                (0x164, 0x206) >= 0x223
                  ? 'U'
                  : (15.5e1, 14.96e2) > (0x1bf, 0x5c)
                  ? (35.0e1, 2)
                  : (76, 6.12e2) >= (0x46, 91.4e1)
                  ? 0x2
                  : (0x33, 86.3e1),
                (54.2e1, 0xf8) <= (3.63e2, 0x177) ? (4.21e2, 3) : (25, 5),
                4,
                0x58 > (0x155, 0x11) ? (0x110, 5) : (0xa7, 47),
                (53.4e1, 60.8e1) >= 0xf5 ? (135, 6) : (0xa6, 0x39),
                53 < (24, 0x200)
                  ? (0x233, 10)
                  : 0x3b >= (58.7e1, 92)
                  ? (1.4e2, 61)
                  : (0x3f, 17) >= (47, 0x61)
                  ? 62.1e1
                  : (0xd9, 95),
                12,
                (32, 105) <= (1.156e3, 73)
                  ? 'z'
                  : 3.0e1 < (0x81, 0x23b)
                  ? (1.449e3, 15)
                  : (0x1e8, 0x237),
                109 >= (79, 0xa9)
                  ? (0xf7, 7)
                  : (1.478e3, 124) < (10.65e2, 0x229)
                  ? (0x1e2, 20)
                  : (49, 98),
                (10.05e2, 68) < 69
                  ? (0x12c, 30)
                  : (92, 37) > (43, 45.3e1)
                  ? (0x244, 0x174)
                  : (104, 14.2e1) >= (0x37, 3.36e2)
                  ? 5
                  : (7.8e1, 0xd3),
              ],
              minTimeUnit: 0,
              maxTimeUnit: 60,
            }
            r[I.MINUTE] = {
              arr: [
                (0x2b, 96) <= (0xc8, 0x15e)
                  ? (0x1ab, 1)
                  : 10.0e1 > (0x167, 7.92e2)
                  ? 21
                  : (41, 128),
                2,
                (67.3e1, 0x7d) <= (15, 47)
                  ? (120, 'm')
                  : (57.5e1, 31.4e1) <= 0x218
                  ? (5, 3)
                  : (0x1c1, 111),
                (0x1c3, 54) < (96, 45)
                  ? 1.405e3
                  : (0x1a, 0x13b) < 1.126e3
                  ? (8.54e2, 4)
                  : (16, 131),
                85 <= (0x127, 0x161) ? (69.6e1, 5) : (13.86e2, 0x191),
                (14, 0x117) < (29, 6.5e2) ? (10.63e2, 6) : (5, 82),
                10,
                (62, 26) <= 138
                  ? (0x1bc, 12)
                  : 74 >= (12.07e2, 7.51e2)
                  ? (45.3e1, 133)
                  : (40.6e1, 49) > (0x24e, 10.2e1)
                  ? 26
                  : (8.59e2, 142),
                15,
                20,
                110.2e1 >= (5.68e2, 0x246)
                  ? (142, 30)
                  : 61 >= (121.4e1, 10.09e2)
                  ? (77.0e1, 'w')
                  : (105, 0x128),
              ],
              minTimeUnit: 0,
              maxTimeUnit: 60,
            }
            r[I.HOUR] = {
              arr: [
                (85.4e1, 74.2e1) > 0x10a
                  ? (31, 1)
                  : 13.94e2 < (0xc1, 32)
                  ? (64.5e1, 6)
                  : 0x21f >= (68, 9.36e2)
                  ? (0x21, 10)
                  : (4.44e2, 0x191),
                (0x1c4, 0x13b) <= (0x13d, 109)
                  ? (68, 75.5e1)
                  : 41 < (0xe4, 100)
                  ? (0x1c6, 2)
                  : (0, 78) > 12.1e1
                  ? (13.0e1, 'S')
                  : (0x14d, 6.42e2),
                (28.7e1, 58.1e1) > 8 ? (67, 3) : (49, 149),
                (0x1f9, 0x1af) <= 0x74
                  ? (107.2e1, 6.66e2)
                  : (132, 123) < (34, 0x86)
                  ? (4, 4)
                  : 72.0e1 < (0x193, 125)
                  ? 'f'
                  : (0x1f, 63),
                (149, 120) < 0xcc
                  ? (0x102, 6)
                  : 0xef >= (0x44, 0x160)
                  ? 58
                  : (121.9e1, 6) > (15, 30)
                  ? (0x13c, 's')
                  : (1.17e2, 33),
                12,
              ],
              minTimeUnit: 0,
              maxTimeUnit: 24,
            }
            r[I.DAY] = {
              arr: [
                (5.3e2, 0x211) >= 126
                  ? (95.8e1, 1)
                  : (65, 17) >= 0x1d9
                  ? 0x237
                  : (83.2e1, 31.2e1),
                117 > (8.97e2, 4)
                  ? (94, 2)
                  : (0x195, 14.12e2) < 0x8b
                  ? 0x1d
                  : (0x46, 4.09e2),
                (4.48e2, 0x225) >= 144
                  ? (56, 7)
                  : (37, 29) > 123
                  ? (13.78e2, 0x16)
                  : (51, 0x12c) >= 0x181
                  ? (1.65e2, 0.001)
                  : (109, 131),
                14,
              ],
              minTimeUnit: 1,
              maxTimeUnit: 32,
            }
            r[I.MONTH] = {
              arr: [
                0x8a < (12.18e2, 0x1a5)
                  ? (130, 1)
                  : (106, 92) >= (3.69e2, 100)
                  ? 4.4e1
                  : (88.5e1, 8.91e2),
                1.303e3 <= (90.9e1, 13.55e2)
                  ? (90, 2)
                  : (7.01e2, 41) > 0x38
                  ? (0x160, 13.75e2)
                  : (134, 81) <= (0x1b7, 80)
                  ? (7.97e2, 94)
                  : (96, 121),
                (11.0e1, 0xcd) >= (140, 0x87)
                  ? (70.8e1, 3)
                  : (0x1d9, 12.51e2) < 0x10a
                  ? 22.3e1
                  : (0x239, 92.4e1),
                6,
              ],
              minTimeUnit: 1,
              maxTimeUnit: 13,
            }
            r[I.YEAR] = {
              arr: [
                (0x59, 3.22e2) > 74.2e1
                  ? (4.4e2, 'pan')
                  : 0x193 <= (0x1d5, 0x1b1)
                  ? (71.4e1, 1)
                  : (9.8e1, 4.12e2),
                (0x63, 2.4e1) > 0x1e3
                  ? (19.1e1, 'A')
                  : 2.03e2 <= (24, 11.91e2)
                  ? (80.7e1, 2)
                  : (129.4e1, 0x222) > 6.27e2
                  ? 'A'
                  : (88.7e1, 4.01e2),
                (20, 44.0e1) >= (5.52e2, 28) ? (0x182, 3) : (0x18d, 128),
                (0x8e, 77) <= (0x1da, 135)
                  ? (103, 5)
                  : 0x246 <= (6.61e2, 0x102)
                  ? (27, 0x15d)
                  : (0x1b6, 86),
              ],
              minTimeUnit: 1,
              maxTimeUnit: 20000000,
            }
            r[I.DECADE] = {
              arr: [10],
              minTimeUnit: 0,
              maxTimeUnit: 2000000,
            }
            this.timeIntervalMap = r
          }
          r = this.timeIntervalMap
          var L = [
              (7.0e2, 12.11e2) > (15.5e1, 2.19e2)
                ? (1.431e3, 31)
                : (0xa1, 1.386e3),
              (0xca, 0x22a) > (139, 5.4e1) ? (12.24e2, 28) : (0x230, 9.34e2),
              (44, 48) < 0x1ca
                ? (0xc8, 31)
                : (0x174, 35) >= (1.113e3, 0x8f)
                ? (105, 32)
                : (69.8e1, 105),
              (0x14a, 102) < 115 ? (0x30, 30) : (0x64, 7.3e1),
              99 <= (130, 0x128) ? (59.9e1, 31) : (0x76, 0x93),
              (8.86e2, 80) < (66, 0x257) ? (0x249, 30) : (115, 0x15a),
              (2, 0x53) < 80
                ? (33, 0x157)
                : (71, 129.6e1) >= (0x24d, 61)
                ? (1.73e2, 31)
                : (0xee, 0x6b) >= (56, 80.1e1)
                ? 'w'
                : (95, 75),
              (49.7e1, 126) >= (0x17e, 0x129)
                ? (13.23e2, 'Y')
                : 1.314e3 <= (10.5e1, 0x120)
                ? 0.5
                : (9.9e1, 73.3e1) >= 76
                ? (102.7e1, 31)
                : (124.5e1, 140.5e1),
              (1.045e3, 113.5e1) <= 24.6e1
                ? (81, 9.07e2)
                : (4.62e2, 0xe3) > (1.63e2, 10.9e1)
                ? (13, 30)
                : (0xfe, 0x145),
              49 < (128, 1.157e3)
                ? (110, 31)
                : 0x137 > (0x23e, 56.9e1)
                ? (0x38, 0x22b)
                : (0x4c, 32),
              (0xf, 5.4e1) < 0x15e
                ? (57, 30)
                : (3.9e1, 0x168) > 57.8e1
                ? 0x1b1
                : (47, 28),
              (5, 5.7e1) <= 0x1ba ? (5, 31) : (67.6e1, 50),
            ],
            v = this.layout.periodicity,
            b = this.layout.interval,
            J = E.maxTicks,
            O = E.dataSegment,
            N = E.xAxis,
            B = O.length,
            s = N.idealTickSizePixels || N.autoComputedTickSizePixels,
            Y = u4S.g3(this.chart.width, s)
          for (
            var o =
              (30, 59.2e1) > (81.0e1, 98.3e1)
                ? 325
                : (35, 127.0e1) <= (0x123, 0x236)
                ? 0x161
                : (55.6e1, 5.37e2) > (0x1d2, 89)
                ? (12.5e1, 0)
                : (116, 8.45e2);
            u4S.p3(o, B);
            o++
          )
            if (O[o]) break
          if (u4S.n3(o, B)) return []
          var F = 0,
            y3 = this.layout.timeUnit || z6 + e3 + Q3 + F6 + R3 + p
          if (isNaN(b)) {
            y3 = b
            b =
              11.85e2 < (39, 133)
                ? (2, 'S')
                : (77, 70) < 6.7e2
                ? (0x1eb, 1)
                : (139, 0xc3)
          }
          var K = 0
          switch (y3) {
            case z6 + e3 + X6 + X6 + e3 + C3 + n1 + H3 + Q3 + E3:
              K = 1
              break
            case d0 + t6 + l1 + E3:
              K =
                (0x21e, 0x1ca) < (10, 58)
                  ? 'd'
                  : 89 >= (121, 108)
                  ? ','
                  : (88.3e1, 120) <= 4.49e2
                  ? (0x252, 1000)
                  : (0x235, 137.6e1)
              break
            case z6 + e3 + Q3 + e:
              K = 60000
              break
            case C:
              K = 0x18c >= (7.87e2, 0x15d) ? (88, 86400000) : (0x1a, 77)
              break
            case c0 + p + p + r0:
              K = u4S.u6(86400000, 7)
              break
            case W + z:
              K = u4S.R6(86400000, 30)
              break
          }
          if (K) {
            F = u4S.U6(b, v, K, B)
          } else {
            F = u4S.D6(
              O[
                B -
                  (65 <= (117, 0x228)
                    ? (42, 1)
                    : (11.55e2, 0x10) > (63.3e1, 46)
                    ? 0x6a
                    : (44, 133) < 96
                    ? 1.33e3
                    : (39.0e1, 0x161))
              ].DT.getTime(),
              O[o].DT.getTime()
            )
          }
          var g = this

          function q() {
            var S = {
                begin: new Date(),
                interval: C,
                periodicity: 1,
                inZone: this.dataZone,
                outZone: this.dataZone,
              },
              H = E.market.newIterator(S)
            H.next()
            var c = H.previous()
            H = g.standardMarketIterator(
              c,
              0x105 > (3.24e2, 147) ? (0x1e7, null) : (0x1ab, 0x167),
              E
            )
            var d = H.next()
            return u4S.Q6(d.getTime(), c.getTime())
          }
          if (u4S.i6(F, 0)) {
            F = u4S.M6(q(), J)
          } else {
            F = u4S.w6(F / B, J)
          }
          var l = u4S.C6(F, Y),
            A
          for (
            A =
              (1.313e3, 0x7d) < 11.6e2
                ? (128, 0)
                : 46 > (0x1bf, 18.9e1)
                ? 0x1f7
                : (67, 114) > 126.4e1
                ? 'x'
                : (0x16e, 10);
            u4S.Z6(A, a.length);
            A++
          ) {
            if (
              u4S.h6(
                a[A],
                l +
                  (0x131 <= (0xa8, 0x198)
                    ? (3.9e1, 0.001)
                    : 78 >= (19, 0x1b0)
                    ? (26, 128)
                    : (5.08e2, 47))
              )
            )
              break
          }
          if (u4S.J6(A, 0)) {
            console.log(
              t6 +
                u2 +
                i3 +
                R3 +
                p +
                i +
                r0 +
                U4 +
                c4 +
                q1 +
                e3 +
                R3 +
                B6 +
                i2 +
                S2 +
                p +
                C3 +
                j2 +
                E0 +
                p1 +
                p +
                H1 +
                l0 +
                Q3 +
                H0 +
                p +
                U3 +
                U3 +
                H3 +
                U3 +
                m1 +
                z6 +
                V +
                p +
                U3 +
                t +
                E3 +
                S1 +
                e3 +
                Q3 +
                p +
                R +
                q0
            )
          }
          if (u4S.v6(A, a.length)) {
            A--
          } else if (
            u4S.K6(
              A,
              (0x196, 147) >= 14.2e2
                ? 'D'
                : (41.7e1, 62) < (114, 38.3e1)
                ? (10.66e2, 0)
                : (0x1eb, 80)
            )
          ) {
            var c3 =
                a[
                  u4S.m6(
                    A,
                    (118, 0xec) > 49
                      ? (137, 1)
                      : 0x131 < (34, 50)
                      ? 5.2e1
                      : 38 <= (4.24e2, 23)
                      ? 'p'
                      : (1.348e3, 1.136e3)
                  )
                ],
              m = r[c3].arr,
              t3 = m[u4S.q6(m.length, 1)]
            if (u4S.S0(l - c3 * t3, a[A] - l)) A--
          }
          var D3 = N.timeUnit || a[A]
          N.activeTimeUnit = D3
          var I3 = I.clone(r[D3]),
            V3 = I3.arr
          for (
            A = (125.2e1, 74) > 33 ? (149.1e1, 0) : (148, 11.03e2);
            u4S.R0(A, V3.length);
            A++
          ) {
            if (u4S.U0(V3[A] * D3, l)) break
          }
          if (u4S.G0(A, V3.length)) {
            A--
          } else {
            if (
              u4S.L0(
                l -
                  V3[A - ((113, 2.99e2) > 58 ? (36, 1) : (144.2e1, 0x34))] * D3,
                V3[A] * D3 - l
              )
            )
              A--
          }
          var u3 = N.timeUnitMultiplier || V3[A],
            K3 = [],
            v3 = this.layout.candleWidth
          for (
            A =
              (63.7e1, 3.55e2) >= 98
                ? (5.02e2, 0)
                : (1.444e3, 0xeb) <= 117
                ? 0x11
                : (11.39e2, 1.358e3);
            u4S.j0(A, J);
            A++
          ) {
            if (O[A]) break
          }
          if (u4S.O0(A, 0) && u4S.W0(A, J)) {
            var q3 = this.standardMarketIterator(
              O[A].DT,
              N.adjustTimeZone ? this.displayZone : this.dataZone
            )
            for (
              var h3 = A;
              u4S.N0(h3, (111.6e1, 0xe5) < 0x1b7 ? (99, 0) : (3.47e2, 0x3e));
              h3--
            ) {
              var l3 = {}
              if (
                !(
                  E.lineApproximation &&
                  u4S.b0(
                    v3,
                    13 >= (0xad, 0x1ec)
                      ? 4
                      : 9.73e2 <= (44, 139)
                      ? 'g'
                      : (0x1b1, 0x87) >= 17
                      ? (80, 1)
                      : (0x21, 0x25)
                  )
                )
              ) {
                var n = q3.previous()
                l3.DT = n
              }
              E.xaxis.unshift(l3)
            }
          }
          var a3 =
              (0x250, 9.5e1) < (61.1e1, 0x11a) ? (0x1f5, 0) : (11.15e2, 0x248),
            S6 = I3.minTimeUnit,
            x6 = -(126 <= (10.4e2, 0x238)
              ? (14.15e2, 1)
              : (0x16e, 54.0e1) > 57.4e1
              ? (141, 'Q')
              : (21, 56) >= 114
              ? (0x169, 0x70)
              : (0x88, 29)),
            o3 =
              (118, 8.9e1) > (4, 7.06e2)
                ? 0.0
                : (12.68e2, 0x16) <= (38, 49)
                ? (11.79e2, true)
                : (0x5a, 0x103) <= (0x43, 71)
                ? 3.23e2
                : (55, 0x3a),
            M3 = 12.84e2 >= (20, 5.1e1) ? (103.9e1, null) : (7.25e2, 91)
          for (A; u4S.B0(A, J); A++) {
            if (u4S.Y0(A, B)) {
              var F3 = O[A]
              if (!F3) F3 = E.xaxis[A]
              if (F3.displayDate && N.adjustTimeZone) {
                a3 = F3.displayDate
              } else {
                a3 = F3.DT
              }
              if (A && E.segmentImage) {
                var G6 = E.segmentImage[A]
                v3 = u4S.T0(
                  G6.leftOffset -
                    G6.candleWidth /
                      ((0x230, 83.3e1) > 3.82e2 ? (0x143, 2) : (112, 9.24e2)),
                  A
                )
              }
            } else {
              if (
                u4S.s0(this.layout.interval, R3 + e3 + n2) &&
                !N.futureTicksInterval
              )
                break
              if (E.lineApproximation && u4S.g0(v3, 1)) break
              if (!N.futureTicks) break
              if (!M3) {
                M3 = this.standardMarketIterator(
                  O[
                    u4S.p0(
                      B,
                      (0x22e, 105) >= 5
                        ? (1.43e2, 1)
                        : (4.6e1, 123) >= 124
                        ? 'X'
                        : (147, 0xcb) >= (131, 0x24d)
                        ? 0x23b
                        : (7.27e2, 67)
                    )
                  ].DT,
                  N.adjustTimeZone ? this.displayZone : this.dataZone
                )
              }
              a3 = M3.next()
            }
            var d6 = {
              DT: a3,
            }
            if (u4S.n0(A, B)) d6.data = O[A]
            else
              d6.data =
                (62.4e1, 7.98e2) > (52.2e1, 0xd0) ? (55, null) : (0x225, 9.7e1)
            E.xaxis.push(d6)
            var A3, f3
            if (u4S.H2(D3, I.MILLISECOND)) {
              A3 = a3.getMilliseconds()
              f3 = a3.getSeconds()
            } else if (u4S.c2(D3, I.SECOND)) {
              A3 = a3.getSeconds()
              f3 = a3.getMinutes()
            } else if (u4S.a2(D3, I.MINUTE)) {
              A3 = a3.getMinutes()
              f3 = a3.getHours()
            } else if (u4S.I2(D3, I.HOUR)) {
              A3 =
                a3.getHours() +
                u4S.V2(
                  a3.getMinutes(),
                  (80, 38) > (69, 22) ? (126, 60) : (78, 1.07e2)
                )
              f3 = a3.getDate()
            } else if (u4S.d2(D3, I.DAY)) {
              A3 = a3.getDate()
              f3 =
                a3.getMonth() +
                ((2.92e2, 0x1f1) < 112
                  ? 0x236
                  : (61.4e1, 0x14) >= 89
                  ? 0x48
                  : (0xb3, 13.83e2) >= (65, 126)
                  ? (1.47e3, 1)
                  : (0xb3, 111))
            } else if (u4S.F2(D3, I.MONTH)) {
              A3 =
                a3.getMonth() +
                ((127, 0x1eb) < (0xcf, 83)
                  ? 4
                  : 0x193 <= (0x1b3, 1.35e3)
                  ? (99, 1)
                  : (4, 3.57e2) < 0x55
                  ? 'g'
                  : (8, 0x127))
              f3 = a3.getFullYear()
            } else if (u4S.N2(D3, I.YEAR)) {
              A3 = a3.getFullYear()
              f3 =
                a3.getFullYear() +
                ((0x70, 110) >= 102 ? (0xa5, 1000) : (10, 62.5e1))
            } else {
              A3 = a3.getFullYear()
              f3 =
                (11.29e2, 0xd7) >= 132
                  ? (0x7f, 0)
                  : (11, 0x15f) <= (13.24e2, 70)
                  ? (8.1e1, 140.7e1)
                  : 92.8e1 >= (128.1e1, 9.86e2)
                  ? 'O'
                  : (0x188, 14.99e2)
            }
            var z3 = 1 <= (0x23, 0x210) ? (0x119, null) : (63, 0x242),
              w3
            if (u4S.b2(x6, f3)) {
              if (u4S.B2(A3, S6)) {
                S6 = I3.minTimeUnit
              }
              w3 =
                E.left +
                u4S.Y2(A, v3) -
                ((0x14, 0x173) <= (3.44e2, 10.89e2)
                  ? (0x123, 1)
                  : (114, 11.31e2))
              z3 = 117 <= (7, 0x9e) ? (56.7e1, null) : (136, 0x8b)
              if (
                u4S.T2(D3, I.HOUR) ||
                (u4S.s2(D3, I.MINUTE) && u4S.g2(x6, f3))
              ) {
                if (N.formatter) {
                  z3 = N.formatter(
                    a3,
                    m3 + H3 + F6 + Q3 + E3 + W2 + e6,
                    I.DAY,
                    8.8e1 <= (1.392e3, 144) ? (107.1e1, 1) : (0x1ed, 40)
                  )
                } else {
                  if (this.internationalizer) {
                    z3 = this.internationalizer.monthDay.format(a3)
                  } else {
                    z3 =
                      a3.getMonth() +
                      1 +
                      (0x1cd >= (122, 0xa7)
                        ? (1.5e1, '/')
                        : 135.7e1 < (1.04e3, 2)
                        ? (0x5e, 15.3e1)
                        : 13.07e2 < (0x10c, 0x59)
                        ? (59, 6.21e2)
                        : (67, 0x1bf)) +
                      a3.getDate()
                  }
                }
              } else if (u4S.l2(D3, I.DAY)) {
                if (u4S.u1(x6, f3)) {
                  if (N.formatter) {
                    z3 = N.formatter(
                      a3,
                      m3 + H3 + F6 + Q3 + c1 + j,
                      I.YEAR,
                      (0xd3, 75) > 57 ? (109, 1) : (125, 93)
                    )
                  } else {
                    z3 = a3.getFullYear()
                  }
                } else {
                  if (N.formatter) {
                    z3 = N.formatter(
                      a3,
                      m3 + H3 + F6 + Q3 + E3 + w,
                      I.MONTH,
                      (32.9e1, 134.2e1) > (127, 0xd4)
                        ? (0x230, 1)
                        : (0x244, 0x1d5)
                    )
                  } else {
                    z3 = I.monthAsDisplay(
                      a3.getMonth(),
                      (138, 6.24e2) > (84, 114)
                        ? (10, false)
                        : (71.7e1, 0x18e) <= (64, 2.78e2)
                        ? (0x76, 30)
                        : (5, 0x124),
                      this
                    )
                  }
                }
              } else if (u4S.X1(D3, I.MONTH)) {
                if (N.formatter) {
                  z3 = N.formatter(
                    a3,
                    U + i3 + U3 + e6,
                    I.YEAR,
                    (9.08e2, 72) < 0x2e
                      ? 0x1df
                      : (1.38e2, 137) >= 0x169
                      ? (130, 1.135e3)
                      : 125 <= (23, 94.2e1)
                      ? (0x1ba, 1)
                      : (57.5e1, 0x2)
                  )
                } else {
                  z3 = a3.getFullYear()
                }
              }
              if (
                z3 &&
                x6 !=
                  -((0xb6, 101.3e1) > 146
                    ? (140, 1)
                    : 47 > (6.14e2, 0x24f)
                    ? (0x85, 36)
                    : (57, 0x227))
              ) {
                K3.push(
                  new I.ChartEngine.XAxisLabel(
                    w3,
                    m3 + H3 + F6 + Q3 + c1 + U3 + e6,
                    z3
                  )
                )
              }
            }
            if (u4S.r1(A3, S6)) {
              if (u4S.D1(S6, I3.minTimeUnit)) {
                if (u4S.Q1(f3, x6)) continue
              }
              var Z3 = new Date(+a3)
              w3 =
                E.left +
                u4S.d1(
                  (((115, 4) < 0xea ? (17.7e1, 2) : (11.71e2, 0x45)) * A +
                    ((41, 84) <= (133, 0x241)
                      ? (0x1d1, 1)
                      : 38 >= (97, 0x124)
                      ? (111.7e1, 300)
                      : (32, 14.74e2))) *
                    v3,
                  102 >= (12, 28.5e1)
                    ? 82
                    : (0, 0x13e) < (26, 119)
                    ? 94.8e1
                    : (1, 56.1e1) > 1.42e2
                    ? (144.7e1, 2)
                    : (37, 0x5d)
                ) -
                (29 >= (0xf2, 7.65e2)
                  ? 5.7e1
                  : 0x5c <= (75, 0x205)
                  ? (13.45e2, 1)
                  : (129, 5.86e2))
              var d3 = u4S.F1(Math.floor(A3 / u3), u3)
              if (u4S.f1(d3, A3)) {
                if (u4S.z1(this.layout.interval, c0 + p + D)) d3 = A3
                else
                  w3 -= u4S.B1(
                    v3,
                    (6.62e2, 7.28e2) >= 0xdd
                      ? (85.5e1, 2)
                      : 0x96 > (134.3e1, 0x16d)
                      ? (1.094e3, 0x1f2)
                      : (3.69e2, 84)
                  )
              }
              if (u4S.J1(D3, I.MILLISECOND)) {
                Z3.setMilliseconds(d3)
              } else if (u4S.v1(D3, I.SECOND)) {
                Z3.setMilliseconds(
                  (11.36e2, 69.5e1) <= (71, 0x102)
                    ? 'E'
                    : 8.2e1 <= (127.2e1, 89.4e1)
                    ? (0x14b, 0)
                    : (20, 3.75e2) <= (50, 33)
                    ? (4.6e1, 14)
                    : (0x1d0, 6.63e2)
                )
                Z3.setSeconds(d3)
              } else if (u4S.K1(D3, I.MINUTE)) {
                Z3.setMilliseconds(
                  (35.0e1, 0x151) < 126
                    ? 'w'
                    : (0x36, 98) <= 1.273e3
                    ? (53, 0)
                    : (0x3c, 50)
                )
                Z3.setSeconds((137, 88.5e1) > 0x11 ? (54.9e1, 0) : (30, 0x1fb))
                Z3.setMinutes(d3)
              } else if (u4S.P1(D3, I.HOUR)) {
                Z3.setMilliseconds(
                  10.42e2 > (31.6e1, 14)
                    ? (0x141, 0)
                    : (149, 127) <= (0x172, 67)
                    ? (116, 127)
                    : (67.5e1, 0)
                )
                Z3.setSeconds(
                  (0x3c, 0x183) < (116.8e1, 0xfd)
                    ? 'S'
                    : (114, 58) <= (0xea, 18.1e1)
                    ? (0x141, 0)
                    : (10.08e2, 1.87e2)
                )
                Z3.setMinutes((26.9e1, 0x1f) < 66.5e1 ? (3, 0) : (144, 14.2e2))
                Z3.setHours(d3)
              } else if (u4S.S4(D3, I.DAY)) {
                Z3.setDate(
                  Math.max(
                    (6.98e2, 8) > 0x3
                      ? (1.16e2, 1)
                      : (7.69e2, 29) >= 4.34e2
                      ? (68, 58)
                      : (72, 0xb7),
                    d3
                  )
                )
              } else if (u4S.x4(D3, I.MONTH)) {
                Z3.setDate(1)
                Z3.setMonth(
                  u4S.X4(d3, 40 <= (51.9e1, 40.3e1) ? (5.18e2, 1) : (44, 0x9e))
                )
              } else if (u4S.r4(D3, I.YEAR)) {
                Z3.setDate(1)
                Z3.setMonth(
                  (65, 15.3e1) > (93, 0x195)
                    ? (1.07e2, 'K')
                    : 0x107 <= (0x192, 14.71e2)
                    ? (61.6e1, 0)
                    : 36 > (142, 90)
                    ? 't'
                    : (28.3e1, 55)
                )
              } else {
                Z3.setDate(1)
                Z3.setMonth(
                  63 > (14, 8.73e2)
                    ? (86, '0')
                    : (31, 0x162) <= (63.8e1, 114)
                    ? (35.4e1, 24.4e1)
                    : (1.8e1, 0x12d) > 0xe3
                    ? (0x179, 0)
                    : (0x179, 0x1b7)
                )
              }
              S6 = d3 + u3
              if (u4S.G4(D3, I.DAY))
                I3.maxTimeUnit =
                  L[Z3.getMonth()] +
                  (4.3e2 <= (114, 2.77e2)
                    ? 37.8e1
                    : (8.33e2, 13.71e2) > 0x11d
                    ? (129, 1)
                    : 7.93e2 < (66.9e1, 0x239)
                    ? 'y1'
                    : (28.2e1, 69))
              if (u4S.L4(S6, I3.maxTimeUnit)) S6 = I3.minTimeUnit
              x6 = f3
              if (o3 && u4S.j4(d3, A3)) {
                o3 =
                  (23, 5) >= (101.0e1, 82.3e1)
                    ? 'k'
                    : (104, 0x5f) <= 0x152
                    ? (64, false)
                    : (104, 55.9e1)
                continue
              }
              if (N.formatter) {
                z3 = N.formatter(Z3, X6 + e3 + P0, D3, u3)
              } else {
                if (u4S.O4(D3, I.DAY)) {
                  z3 = Z3.getDate()
                } else if (u4S.W4(D3, I.MONTH)) {
                  z3 = I.monthAsDisplay(
                    a3.getMonth(),
                    13.66e2 >= (146, 0x5b)
                      ? (0x6d, false)
                      : (0x1d9, 53) > 111
                      ? (130, 40)
                      : (6.3e1, 9.09e2),
                    this
                  )
                } else if (u4S.N4(D3, I.YEAR) || u4S.b4(D3, I.DECADE)) {
                  z3 = Z3.getFullYear()
                } else {
                  z3 = I.timeAsDisplay(Z3, this, D3)
                }
              }
              K3.push(new I.ChartEngine.XAxisLabel(w3, X6 + e3 + Q3 + p, z3))
            }
          }
          return K3
        }
        I.ChartEngine.prototype.createYAxis = function(S, H) {
          var c = 'YA',
            d = 'cre',
            E = 'proje',
            D = 'yax',
            U = 'ate'
          if (this.runPrepend(t6 + U3 + p + U + m0 + E0 + V6 + a0, arguments))
            return
          var w = S.chart,
            j = u4S.B4(S.name, w.name)
          if (!H) H = {}
          H.noChange =
            0xc5 < (69, 8.7e2)
              ? (9.04e2, false)
              : (93, 2.66e2) <= 89
              ? (9.78e2, 11.52e2)
              : (89, 119)
          var R = H.yAxis ? H.yAxis : S.yAxis
          if (
            I.ChartEngine.enableCaching &&
            u4S.Y4(R.high, S.cacheHigh) &&
            u4S.T4(R.low, S.cacheLow)
          ) {
            var t = u4S.s4(
                w.dataSet.length,
                w.scroll,
                (14.31e2, 108) < (88, 145)
                  ? (22, 1)
                  : (8.9e1, 131) >= 0x1c8
                  ? (20, 'V')
                  : 4.0e1 > (64, 5.13e2)
                  ? 0.9
                  : (0x1dd, 115)
              ),
              V =
                t +
                w.maxTicks +
                (0xeb < (41.0e1, 63)
                  ? (110.5e1, 7)
                  : 0x21e >= (116, 4.52e2)
                  ? (1.046e3, 1)
                  : (0xdf, 141))
            S.cacheLeft = t
            S.cacheRight = V
            H.noChange = (41, 11.47e2) > 0x1bf ? (0x243, true) : (34, 0x18a)
          } else {
            S.cacheLeft =
              0xf <= (83, 0x109)
                ? (134, 1000000)
                : (0x105, 128) < (0xbd, 112)
                ? (0x15b, 0x1f2)
                : 58 > (0x1d5, 1.99e2)
                ? 146
                : (79.4e1, 0x1e4)
            S.cacheRight = -((72.1e1, 69.0e1) <= 2.73e2
              ? 'C'
              : (60, 17) > (77.1e1, 0x222)
              ? (39.1e1, 'C')
              : 0x1a <= (0xa0, 102)
              ? (109, 1)
              : (0x1d6, 0x142))
            S.cacheHigh = R.high
            S.cacheLow = R.low
          }
          var i = w.xAxis.idealTickSizePixels
            ? w.xAxis.idealTickSizePixels
            : w.xAxis.autoComputedTickSizePixels
          if (R.goldenRatioYAxis) {
            if (u4S.m4(R.idealTickSizePixels, i / 1.618))
              H.noChange =
                (43.6e1, 93) > (0x169, 111)
                  ? (0x23b, 92)
                  : (145.2e1, 0x2f) > (136, 1.014e3)
                  ? 79
                  : 30.4e1 < (74, 122.2e1)
                  ? (0x18, false)
                  : (5.96e2, 0xc6)
          }
          if (!H.noChange) {
            this.adjustYAxisHeightOffset(S, R)
            var z = (R.height = u4S.q4(R.bottom, R.top)),
              W = u4S.S5(R.high - R.low, z - R.zoom)
            if (H.ground && !R.semiLog) {
              R.high = R.high + u4S.x5(R.zoom, W)
            } else {
              R.high =
                R.high +
                u4S.X5(
                  R.zoom /
                    ((90.8e1, 0x155) <= (0x212, 1.293e3)
                      ? (27.4e1, 2)
                      : (14.46e2, 16.9e1)),
                  W
                ) +
                u4S.r5(R.scroll, W)
              var C = R.low
              if (R.semiLog) {
                var e = u4S.G5((R.zoom / 2) * W, R.high / R.low)
                R.low = u4S.L5(R.low, e, R.scroll * W)
                if (
                  u4S.i5(
                    R.low,
                    C *
                      ((0x1e6, 7.37e2) >= (13.45e2, 0x123)
                        ? (0x7f, 0.1)
                        : (141, 45))
                  )
                )
                  R.low = u4S.M5(
                    C,
                    0x128 <= (69, 52)
                      ? (40.3e1, 'Z')
                      : (132, 141) <= (0x20f, 0x11e)
                      ? (42.4e1, 0.1)
                      : (15, 20)
                  )
              } else {
                R.low = u4S.w5(
                  R.low,
                  (R.zoom /
                    ((7.81e2, 136.1e1) > (126, 130)
                      ? (122, 2)
                      : (100, 1.095e3))) *
                    W,
                  R.scroll * W
                )
              }
            }
            if (
              R.min ||
              u4S.z5(
                R.min,
                (122, 69) < (1.042e3, 0x127)
                  ? (4.85e2, 0)
                  : 0x240 <= (100.7e1, 10.4e1)
                  ? (0x238, 'x')
                  : (65, 0x20e)
              )
            )
              R.low = R.min
            if (
              R.max ||
              u4S.E5(R.max, 137 <= (51, 13.05e2) ? (87, 0) : (48, 89))
            )
              R.high = R.max
            R.shadow = u4S.o5(R.high, R.low)
            if (
              R.semiLog &&
              (!this.activeDrawing ||
                u4S.e5(
                  this.activeDrawing.name,
                  u0 + U3 + q2 + p + t6 + R3 + e3 + H3 + Q3
                ))
            ) {
              R.logHigh = u4S.A5(Math.log(R.high), Math.LN10)
              var r = Math.max(
                R.low,
                (0x1ed, 130) < (6.0e1, 0x120)
                  ? (0x15b, 0.000000001)
                  : (95, 100.4e1)
              )
              R.logLow = u4S.k5(Math.log(r), Math.LN10)
              if (u4S.P5(R.low, 0x23c > (101, 0x1d3) ? (79, 0) : (0x1a6, 5)))
                R.logLow =
                  5.54e2 <= (44, 42)
                    ? 57.4e1
                    : (104, 0x21e) <= (51.1e1, 0x6f)
                    ? 0x1cd
                    : (7.68e2, 0xe2) >= 100
                    ? (0x127, 0)
                    : (22, 19.2e1)
              R.logShadow = u4S.l5(R.logHigh, R.logLow)
            }
            var a
            if (R.goldenRatioYAxis && j) {
              R.idealTickSizePixels = u4S.y9(
                i,
                0xea <= (0x110, 20)
                  ? 28.9e1
                  : (8.69e2, 117) < 0x15e
                  ? (1.2e1, 1.618)
                  : (13.18e2, 0x238)
              )
              if (
                u4S.H9(
                  R.idealTickSizePixels,
                  23 >= (10.67e2, 0x104)
                    ? (0xc0, 10.6e2)
                    : 110 <= (137, 135.8e1)
                    ? (87, 0)
                    : (120, 0x1bd)
                )
              ) {
                a = this.getCanvasFontSize(f2 + f6 + e6 + i3 + V6 + a0)
                R.idealTickSizePixels = u4S.c9(
                  a,
                  0x1f1 > (32.6e1, 114) ? (136, 5) : (11.46e2, 24)
                )
              }
            } else {
              if (!R.idealTickSizePixels) {
                a = this.getCanvasFontSize(C3 + R3 + p2 + e6 + u4 + e3 + C3)
                if (j) {
                  R.idealTickSizePixels = u4S.a9(
                    a,
                    (59.9e1, 1.172e3) > 0x2b
                      ? (0x19a, 5)
                      : (89.0e1, 35) >= 82
                      ? (125, 1.337e3)
                      : (117, 0x1e4) < 4.69e2
                      ? (141, 72)
                      : (8.4e1, 19.1e1)
                  )
                } else {
                  R.idealTickSizePixels = u4S.D9(
                    a,
                    0x21d <= (2.08e2, 0x219)
                      ? (0x22, 'V')
                      : 0x6f < (106, 0x1b1)
                      ? (42, 2)
                      : (101, 1.62e2)
                  )
                }
              }
            }
            var L = Math.round(u4S.Q9(z, R.idealTickSizePixels)),
              v = H.range
                ? u4S.i9(
                    H.range[
                      (0x1a, 137.8e1) <= 1.2e2
                        ? (31.6e1, 'F')
                        : (0x122, 0x3d) < 0x8c
                        ? (107, 1)
                        : (0x8e, 42.6e1) <= (6.79e2, 109)
                        ? (24.0e1, 8)
                        : (0x7d, 0xc1)
                    ],
                    H.range[
                      (93.1e1, 2) >= 149
                        ? (0x221, 0x256)
                        : 119 <= (9.9e1, 0x6c)
                        ? (0x134, 4)
                        : (0x183, 0x15d) < (28, 3.65e2)
                        ? (115, 0)
                        : (101, 73)
                    ]
                  )
                : R.shadow
            R.priceTick = Math.floor(u4S.M9(v, L))
            var b =
              0x12e <= (0xc2, 0x164)
                ? (7.67e2, 1)
                : 13.24e2 >= (133, 1.368e3)
                ? (143.0e1, 300)
                : (2.1e2, 114)
            for (
              var J = (50, 0x22e) > 0x96 ? (1.189e3, 0) : (110, 122.4e1);
              u4S.w9(
                J,
                (145, 0x18e) <= 0x1ce
                  ? (1.394e3, 10)
                  : (0x51, 14.03e2) <= 0x17c
                  ? 'g'
                  : (0x183, 12.29e2)
              );
              J++
            ) {
              if (
                u4S.C9(
                  R.priceTick,
                  (0x13b, 2) < 134.5e1
                    ? (12.74e2, 0)
                    : (94, 108) > 11.39e2
                    ? 97.6e1
                    : (116.6e1, 0xc2) >= 1.148e3
                    ? 60000
                    : (38.9e1, 50)
                )
              )
                break
              b *= 12.9e1 > (132, 9) ? (0x3b, 10) : (125, 105)
              R.priceTick = u4S.Z9(Math.floor((v / L) * b), b)
            }
            if (
              u4S.h9(
                J,
                139 > (0x1bf, 54.6e1)
                  ? 132
                  : 0x107 >= (0xa2, 0x236)
                  ? (7.35e2, 0)
                  : (0x1d8, 31) <= 92
                  ? (83.7e1, 10)
                  : (98, 1.187e3)
              )
            )
              R.priceTick = 0.00000001
            R.priceTick = u4S.J9(Math.round((v / L) * b), b)
            var O = Math.round(u4S.v9(v, R.priceTick))
            if (H.range && u4S.K9(O, v) && !R.noEvenDivisorTicks) {
              while (u4S.m9(O, 19 < (103, 5.95e2) ? (89.2e1, 1) : (109, 87))) {
                if (u4S.q9(v % O, 0)) break
                O--
              }
              R.priceTick = u4S.S8(v, O)
            }
            if (R.minimumPriceTick) {
              var N = R.minimumPriceTick
              a = this.getCanvasFontSize(C3 + R3 + p2 + D + e3 + C3)
              for (
                var B = (10.96e2, 0x230) >= (90, 107) ? (0x1cc, 0) : (84, 119);
                u4S.x8(
                  B,
                  (12.58e2, 0x26) >= 66
                    ? 'u'
                    : (0xbe, 105) >= (90, 57)
                    ? (49, 100)
                    : (94, 14.6e1) <= 79
                    ? (2.9e1, 'u')
                    : (8.94e2, 8)
                );
                B++
              ) {
                var s = u4S.X8(v, N)
                if (
                  u4S.r8(
                    z / s,
                    a *
                      ((130.2e1, 133.4e1) > (12, 34)
                        ? (15.1e1, 2)
                        : (0xc0, 27.2e1))
                  )
                )
                  N += R.minimumPriceTick
                else break
              }
              if (u4S.G8(B, 100)) R.priceTick = N
            }
            R.multiplier = u4S.L8(R.height, R.shadow)
          }
          if (u4S.j8(R.priceTick, 0) || u4S.O8(R.priceTick, Infinity)) {
            R.priceTick =
              (14, 0x10e) > (18, 0x70)
                ? (45.6e1, 1)
                : 0x79 <= (34, 74)
                ? 135
                : 0x15a <= (5.37e2, 2.28e2)
                ? 30
                : (12.58e2, 0x6f)
          }
          if (
            !this.activeDrawing ||
            u4S.W8(this.activeDrawing.name, E + t6 + R3 + e3 + H3 + Q3)
          ) {
            R.high = this.transformedPriceFromPixel(R.top, S, R)
            if (R.semiLog) {
              R.logHigh = u4S.N8(Math.log(R.high), Math.LN10)
              var Y = Math.max(
                R.low,
                (96, 0x14d) < 130
                  ? 31.6e1
                  : (0x148, 51) <= (0xb4, 0xde)
                  ? (0x163, 0.00000000001)
                  : (73, 3) > (0x20e, 26)
                  ? 'y0'
                  : (0x1ed, 9.84e2)
              )
              R.logLow = u4S.b8(Math.log(Y), Math.LN10)
              R.logShadow = u4S.B8(R.logHigh, R.logLow)
            }
            R.shadow = u4S.Y8(R.high, R.low)
          }
          R.multiplier = u4S.T8(R.height, R.shadow)
          if (u4S.s8(R.multiplier, Infinity)) R.multiplier = 0
          if (
            !R.decimalPlaces &&
            u4S.g8(
              R.decimalPlaces,
              (0x31, 0x24e) < 43
                ? 'l'
                : (0x1e7, 6.43e2) >= (0x29, 0x10a)
                ? (146, 0)
                : (8.62e2, 39.2e1)
            )
          ) {
            if (j) {
              var o = 0
              for (
                var F =
                  (0x1f1, 1.104e3) <= (6.18e2, 0x80)
                    ? (0x1fb, 'h')
                    : (126, 31) > (100.9e1, 75.0e1)
                    ? (0x1b6, 52.2e1)
                    : (147, 0x1c5) <= (0xce, 1.001e3)
                    ? (0x2e, 0)
                    : (105, 12.0e2);
                u4S.p8(F, S.yAxis.shadowBreaks.length);
                F++
              ) {
                var y3 = S.yAxis.shadowBreaks[F]
                if (u4S.n8(S.yAxis.shadow, y3[0]))
                  o = y3[(104, 9.29e2) < (38, 1.305e3) ? (84.9e1, 1) : (22, 73)]
              }
              R.printDecimalPlaces = o
            } else R.printDecimalPlaces = null
          } else {
            R.printDecimalPlaces = R.decimalPlaces
          }
          this.runAppend(d + i3 + R3 + p + c + O2 + C3, arguments)
        }
        I.ChartEngine.prototype.drawYAxis = function(R, t) {
          var V = 'ef',
            i = 'rder',
            z = '_g',
            W = 'xt',
            C = 'ri',
            e = 'rok',
            r = "'"
          if (!t) t = {}
          var a = t.yAxis ? t.yAxis : R.yAxis
          if (R.hidden || a.noDraw) return
          if (u4S.u7(a.priceFormatter, I.Comparison.priceFormat)) {
            if (a.fractional) {
              if (!a.originalPriceFormatter)
                a.originalPriceFormatter = {
                  func: a.priceFormatter,
                }
              if (!a.fractional.resolution)
                a.fractional.resolution = a.minimumPrice
              if (!a.fractional.formatter) a.fractional.formatter = r
              if (!a.priceFormatter)
                a.priceFormatter = function(S, H, c) {
                  var d =
                      77.5e1 <= (61, 77.9e1) ? (20, '+') : (8.25e2, 1.398e3),
                    E = ''
                  if (!a.fractional) return
                  var D = E
                  if (u4S.R7(c, u4S.R3z)) {
                    D = Q0
                    c = Math.abs(c)
                  }
                  var U = Math.floor(
                      u4S.U7(
                        Math.round(c / a.fractional.resolution),
                        a.fractional.resolution
                      )
                    ),
                    w = Math.round(u4S.t7(c - U, a.fractional.resolution)),
                    j = Math.floor(w)
                  return (
                    D +
                    U +
                    a.fractional.formatter +
                    (u4S.I7(j, k0) ? P2 : g1) +
                    j +
                    (u4S.V7(w - j, Z0) ? d : g1)
                  )
                }
            } else {
              if (a.originalPriceFormatter) {
                a.priceFormatter = a.originalPriceFormatter.func
                a.originalPriceFormatter = w0
              }
            }
          }
          if (a.pretty) return this.drawYAxisPretty(R, t)
          if (this.runPrepend(E3 + k1 + c0 + m0 + E0 + V6 + a0, arguments))
            return
          if (!t.noDraw && !a.noDraw) {
            var L = a.yAxisPlotter
            if (!L || !t.noChange) {
              L = a.yAxisPlotter = new I.Plotter()
              var v = R.chart,
                b = u4S.d7(R.name, v.name) && u4S.F7(a.name, R.yAxis.name)
              if (!a.priceTick) return
              var J = a.shadow,
                O = t.range
              if (O) {
                J = u4S.f7(O[u4S.c3z], O[u4S.R3z])
              }
              var N = u4S.z7(J, a.priceTick)
              N = Math.round(N)
              var B, s
              if (a.semiLog) {
                B = u4S.E7(
                  Math.log(this.valueFromPixel(a.bottom, R)),
                  Math.LN10
                )
                s = u4S.o7(a.logHigh - a.logLow, N)
              }
              var Y = a.textStyle
                ? a.textStyle
                : C3 + M2 + f6 + s1 + V6 + e3 + C3
              L.newSeries(
                T6 + U3 + m2,
                V0 + e + p,
                this.canvasStyle(C3 + R3 + V6 + f6 + T6 + C + E3)
              )
              L.newSeries(R3 + p + W, t0 + e3 + X6 + X6, this.colorOrStyle(Y))
              L.newSeries(
                m3 + H3 + U3 + R2,
                C3 + R4 + a1,
                this.canvasStyle(C3 + R3 + V6 + z + C + E3 + f6 + m3 + H3 + i)
              )
              var o = u4S.R3z,
                F = O ? O[u4S.c3z] : a.high,
                y3 = O ? O[u4S.R3z] : a.low,
                K = u4S.e7(a.displayBorder, w0)
                  ? v.panel.yAxis.displayBorder
                  : a.displayBorder
              if (u4S.A7(this.axisBorders, k2)) K = k2
              if (u4S.k7(this.axisBorders, K2)) K = K2
              var g,
                q = u4S.P7(a.position, w0) ? v.panel.yAxis.position : a.position
              if (u4S.l7(q, Q2 + y4)) {
                g = a.left + a.width
              } else {
                g = a.left
              }
              var l = Math.round(g) + Z0,
                A = K ? u4S.t3z : u4S.R3z
              if (u4S.y31(q, X6 + V + R3)) A = K ? -u4S.t3z : u4S.R3z
              if (b)
                if (u4S.H31(a.shadow, u4S.c3z)) {
                  o = u4S.c31(
                    (parseInt(y3 / a.priceTick, k0) + u4S.c3z) * a.priceTick,
                    y3
                  )
                } else {
                  o = u4S.a31(
                    a.priceTick,
                    Math.round((y3 % a.priceTick) * R.chart.roundit) /
                      R.chart.roundit
                  )
                }
              else o = u4S.D31(F, a.priceTick)
              var c3 = this.getCanvasFontSize(
                C3 + R3 + V6 + f6 + e6 + i3 + V6 + a0
              )
              for (var m = u4S.R3z; u4S.Q31(m, N); m++) {
                var t3
                if (a.semiLog) {
                  var D3 = B + u4S.i31(m, s)
                  t3 = Math.pow(k0, D3)
                } else {
                  if (b) t3 = y3 + u4S.M31(m, a.priceTick) + o
                  else t3 = u4S.w31(F, m * a.priceTick, o)
                }
                var I3 = this.pixelFromTransformedValue(t3, R, a),
                  V3 = Math.round(I3) + Z0
                if (u4S.z31(V3 + c3 / u4S.U3z, R.bottom)) continue
                if (u4S.E31(V3 - c3 / u4S.U3z, R.top)) continue
                if (a.displayGridLines) {
                  L.moveTo(
                    T6 + U3 + e3 + E3,
                    R.left +
                      ((111, 37.1e1) >= (0x96, 133)
                        ? (0x90, 1)
                        : 0x1bc < (0x153, 102)
                        ? (55.4e1, 68)
                        : (95.5e1, 23)),
                    V3
                  )
                  L.lineTo(
                    T6 + U3 + e3 + E3,
                    u4S.o31(
                      R.right,
                      (0x60, 0x118) >= 0x1a7
                        ? null
                        : 7.7e1 < (7.67e2, 0xb6)
                        ? (7.41e2, 1)
                        : (127.1e1, 74) >= 9.6e1
                        ? (7.4e1, 14)
                        : (0x57, 20)
                    ),
                    V3
                  )
                }
                if (K) {
                  L.moveTo(
                    m3 + H3 + U3 + R2,
                    u4S.e31(
                      l,
                      (0x19d, 57) >= (0x1e4, 10.63e2)
                        ? 133
                        : 0xe5 < (0xa3, 101)
                        ? (7.82e2, 14.08e2)
                        : 127 <= (55, 82.9e1)
                        ? (0x21f, 0.5)
                        : (11.53e2, 15.6e1)
                    ),
                    V3
                  )
                  L.lineTo(m3 + H3 + U3 + R2, l + A, V3)
                }
                if (a.priceFormatter) {
                  t3 = a.priceFormatter(this, R, t3)
                } else {
                  t3 = this.formatYAxisPrice(t3, R, w0, a)
                }
                var u3 = a.textBackground ? this.containerColor : w0,
                  K3 = g + A + u4S.t3z
                if (u4S.A31(q, X6 + V + R3)) {
                  K3 = a.left + u4S.t3z
                  if (a.justifyRight) K3 = a.left + a.width + A - 3
                } else {
                  if (a.justifyRight) K3 = g + a.width
                }
                L.addText(R3 + p + W, t3, K3, V3, u3, w0, c3)
              }
              if (K) {
                var v3 = Math.round(a.bottom) + Z0
                L.moveTo(m3 + H3 + w2 + p + U3, l, a.top)
                L.lineTo(m3 + H3 + U3 + A1 + U3, l, v3)
                L.draw(this.chart.context, m3 + H3 + U3 + E3 + p + U3)
              }
            }
            this.plotYAxisGrid(R)
          }
          this.runAppend(E3 + U3 + i3 + c0 + m0 + R1 + a0, arguments)
        }
        I.ChartEngine.prototype.drawYAxisPretty = function(S, H) {
          var c = 'ord',
            d = 'orde',
            E = 'bor',
            D = 'ea',
            U = 'rro',
            w = 'ty',
            j = 'P',
            R = 'dr',
            t = 'grid',
            V = 'left',
            i = 'rde',
            z = 'gri',
            W = 'il',
            C = 'wYAxi',
            e = 'dra'
          if (this.runPrepend(e + C + C3, arguments)) return
          if (!H) H = {}
          var r = H.yAxis ? H.yAxis : S.yAxis
          if (!H.noDraw && !r.noDraw) {
            var a = r.yAxisPlotter
            if (!a || !H.noChange) {
              a = r.yAxisPlotter = new I.Plotter()
              var L = S.chart
              if (!r.priceTick) return
              if (isNaN(r.high) || isNaN(r.low)) return
              var v = r.shadow
              if (H.range) {
                v = u4S.k31(
                  H.range[
                    (0xf7, 1.286e3) <= 0x22d
                      ? (0x17e, 145.6e1)
                      : 53 >= (114, 0x190)
                      ? (107, 0x116)
                      : 8 < (8, 11.59e2)
                      ? (12.36e2, 1)
                      : (11.5e2, 0x204)
                  ],
                  H.range[0]
                )
              }
              var b = u4S.P31(r.height, r.idealTickSizePixels)
              b = Math.round(b)
              var J = r.textStyle
                ? r.textStyle
                : C3 + M2 + f6 + e6 + i3 + O2 + C3
              a.newSeries(
                T6 + U3 + e3 + E3,
                C3 + R3 + U3 + H3 + r0 + p,
                this.canvasStyle(C3 + R3 + V6 + f6 + T6 + U3 + m2)
              )
              a.newSeries(z0 + V6 + R3, t0 + W + X6, this.colorOrStyle(J))
              a.newSeries(
                m3 + H3 + w2 + p + U3,
                V0 + U3 + H3 + r0 + p,
                this.canvasStyle(V0 + V6 + f6 + z + E3 + f6 + m3 + H3 + i + U3)
              )
              var O = H.range,
                N = O
                  ? O[(72, 0x3c) < (1.207e3, 144) ? (146, 1) : (0xf5, 0x69)]
                  : r.high,
                B = O
                  ? O[
                      105 > (0x231, 0x59)
                        ? (48, 0)
                        : 13 >= (7.46e2, 69.1e1)
                        ? 'p'
                        : (0x1a5, 0x1ac)
                    ]
                  : r.low,
                s = u4S.l31(
                  r.displayBorder,
                  (0x6, 9.67e2) <= 0xad
                    ? 'e'
                    : (5, 0x16f) <= 0x1ec
                    ? (0x95, null)
                    : (3.08e2, 1.103e3) <= (0x133, 1.87e2)
                    ? 'e'
                    : (0x12c, 0x183)
                )
                  ? L.panel.yAxis.displayBorder
                  : r.displayBorder
              if (
                u4S.y61(
                  this.axisBorders,
                  120 >= (0x120, 1.217e3)
                    ? (5.86e2, 'u')
                    : (0x234, 79) <= (0x131, 91)
                    ? (3.92e2, false)
                    : 0x1b6 > (65, 0x1f8)
                    ? (16, 0x53)
                    : (0x12, 0x101)
                )
              )
                s = (0xda, 7.95e2) >= 0x1ea ? (59.7e1, false) : (0x112, 0x83)
              if (u4S.H61(this.axisBorders, true))
                s = (0x1e9, 1.11e2) > (0, 55) ? (12, true) : (111, 8)
              var Y,
                o = u4S.c61(
                  r.position,
                  0x51 >= (68, 24) ? (17.7e1, null) : (6.6e1, 16)
                )
                  ? L.panel.yAxis.position
                  : r.position
              if (u4S.a61(o, X6 + p + t0 + R3)) {
                Y = r.left + r.width
              } else {
                Y = r.left
              }
              var F = Math.round(Y) + 0.5,
                y3 = s
                  ? 0xae > (130, 42.2e1)
                    ? (6.01e2, 0x45)
                    : 1.68e2 > (0x7c, 131)
                    ? (84, 3)
                    : (99, 63.8e1)
                  : 17 < (12.29e2, 0x180)
                  ? (0x225, 0)
                  : (109, 0x237)
              if (u4S.D61(o, V))
                y3 = s
                  ? -3
                  : (16, 142.4e1) >= (0x7b, 107)
                  ? (0x22b, 0)
                  : (5, 10.84e2)
              var K = this.getCanvasFontSize(
                  C3 + R3 + V6 + f6 + e6 + i3 + V6 + a0
                ),
                g = r.increments,
                q = g.length,
                l =
                  58 >= (0x164, 0x2)
                    ? (66, 0)
                    : (7.73e2, 72.1e1) < (29.6e1, 0x3d)
                    ? (124, 0x20e)
                    : (136, 48.1e1) < 19
                    ? 25000
                    : (0x30, 7.55e2),
                A = (45, 59) >= (18, 53) ? (134, 1) : (22.1e1, 103),
                c3 = 0,
                m =
                  84.9e1 <= (0xad, 2)
                    ? 't'
                    : 0x1ee < (96, 78.7e1)
                    ? (1.366e3, 0)
                    : (0x146, 0x11b) <= 59
                    ? (1.389e3, 0.4)
                    : (42.1e1, 12.02e2),
                t3 =
                  (0x26, 0x5b) < 0x1f3
                    ? (52, 0)
                    : 30 >= (56, 1.209e3)
                    ? 0.02
                    : (5, 0xf5),
                D3 = Number.MAX_VALUE
              for (
                var I3 =
                  (10.61e2, 0xe5) >= 13.36e2
                    ? 200
                    : 39 > (85, 71.4e1)
                    ? (0x1b8, 108)
                    : (0x168, 142) >= 0xd
                    ? (0x96, 0)
                    : (23, 0x167);
                u4S.Q61(
                  I3,
                  (0x14, 90.6e1) < (0xff, 0xad)
                    ? 'l'
                    : (0x197, 113) < 0x205
                    ? (80, 100)
                    : 87 < (36.7e1, 7.2e1)
                    ? (0x19d, 78)
                    : (57.5e1, 12)
                );
                I3++
              ) {
                c3 = u4S.i61(
                  g[l],
                  Math.pow(
                    (29, 50) < (97, 137)
                      ? (11.94e2, 10)
                      : (0x1b1, 10.14e2) <= 46.8e1
                      ? 0x10f
                      : (1.44e3, 6.17e2) < 83
                      ? (13, 2)
                      : (0x10a, 0x4),
                    t3
                  )
                )
                A = Math.floor(u4S.M61(v, c3))
                var V3 = Math.abs(u4S.w61(b, A))
                if (u4S.C61(V3, D3)) {
                  break
                } else {
                  D3 = V3
                }
                if (u4S.Z61(A, b)) {
                  m = c3
                  break
                } else if (u4S.h61(A, b)) {
                  l++
                  if (u4S.J61(l, q)) {
                    l =
                      (1.7e2, 25.4e1) <= (8.39e2, 1.138e3)
                        ? (2.1e2, 0)
                        : 134 > (67, 48.9e1)
                        ? (149.7e1, 'x0')
                        : (141, 14.29e2) <= 0x137
                        ? (48.6e1, 0x126)
                        : (133, 8)
                    t3++
                  }
                } else {
                  l--
                  if (
                    u4S.v61(
                      l,
                      0x12f < (90, 92)
                        ? 'O'
                        : 0x217 < (0x11c, 1.09e2)
                        ? (0x6a, 42.9e1)
                        : (0x118, 0x161) < 0x202
                        ? (0x1db, 0)
                        : (127.2e1, 1.326e3)
                    )
                  ) {
                    l = u4S.K61(
                      q,
                      147.0e1 < (123.1e1, 0x83)
                        ? (105, 0x1bb)
                        : (0x1bd, 25) <= (22, 0xf9)
                        ? (0x224, 1)
                        : (0xb0, 12.03e2)
                    )
                    t3--
                  }
                }
                m = c3
              }
              var u3 = u4S.m61(Math.ceil(B / m), m),
                K3 = u4S.q61(
                  r.bottom,
                  this.pixelFromTransformedValue(u3, S, r)
                ),
                v3 =
                  (49, 71) >= 0x5a
                    ? (54, false)
                    : (59, 0xd3) > (1.312e3, 0x37)
                    ? (49, 0)
                    : 46.7e1 <= (90.5e1, 66)
                    ? (11, 60)
                    : (3.08e2, 93)
              if (
                u4S.S01(K3, r.idealTickSizePixels) &&
                r.semiLog &&
                r.prettySemiLog
              ) {
                var q3
                for (
                  q3 = Math.ceil(B);
                  u4S.x01(q3, u3) &&
                  u4S.X01(
                    u3 % q3,
                    (13.9e1, 1.167e3) > 54
                      ? (27.8e1, 0)
                      : (0x1b7, 0x7e) <= 101
                      ? 11.23e2
                      : (0x215, 0xe8)
                  );
                  ++q3
                );
                if (u4S.r01(q3, u3)) {
                  if (u4S.G01(u3, m)) {
                    m = q3
                    v3 = q3
                  }
                  u3 = q3
                }
              }
              var h3 = (46, 38) <= 130 ? (0xc6, 0) : (0x3e, 18),
                l3 = Number.MAX_VALUE
              for (
                var n = 0;
                u4S.L01(
                  n,
                  0x3e <= (9.47e2, 0x16c)
                    ? (0xfd, 100)
                    : (0x1d7, 13.49e2) <= 33
                    ? 1.14e2
                    : (75.5e1, 109.5e1)
                );
                n++
              ) {
                var a3 = u3 + u4S.j01(h3, m)
                if (u4S.O01(a3, N)) break
                m += v3
                h3++
                var S6 = this.pixelFromTransformedValue(a3, S, r)
                if (
                  u4S.W01(
                    l3 - S6,
                    K +
                      (10.91e2 < (118, 0x41)
                        ? (0x17a, 'h')
                        : (0xe6, 0x55) <= 0x242
                        ? (0x10a, 1)
                        : (97.9e1, 2.83e2))
                  ) &&
                  u4S.N01(
                    v3,
                    (10.46e2, 54) > 75
                      ? (67.8e1, 6.47e2)
                      : 0x208 > (7.55e2, 145)
                      ? (0x69, 0)
                      : (95.9e1, 80.4e1)
                  )
                ) {
                  n = h3 = 99 > (37, 85) ? (0x1d8, 0) : (146, 0x48)
                  l3 = Number.MAX_VALUE
                  m = v3
                  v3 *=
                    (0x18b, 82.3e1) >= 129
                      ? (7.0e1, 2)
                      : (129, 77.3e1) <= (0x38, 110)
                      ? (104.2e1, 'A')
                      : (116.6e1, 0x14b)
                  a.reset()
                  continue
                }
                l3 = S6
                var x6 =
                  Math.round(S6) +
                  ((0x60, 79.7e1) < (59, 0x72)
                    ? 30
                    : (0x10, 1.28e3) > 11.0e1
                    ? (132, 0.5)
                    : (148, 15))
                if (
                  u4S.b01(
                    x6 + K / (0xfb > (0xb0, 11) ? (0x252, 2) : (33, 136.7e1)),
                    S.bottom
                  )
                )
                  continue
                if (
                  u4S.B01(
                    x6 -
                      K /
                        ((107, 1.108e3) < (12.75e2, 124)
                          ? (0x103, 59.9e1)
                          : 15 > (0x1d6, 0x7e)
                          ? (99.4e1, 10000)
                          : (110, 28.9e1) <= 0x1f6
                          ? (90, 2)
                          : (69.2e1, 0x18a)),
                    S.top
                  )
                )
                  continue
                if (r.displayGridLines) {
                  a.moveTo(
                    t,
                    S.left +
                      ((47, 129) < 56.8e1
                        ? (0x1b1, 1)
                        : (38, 2.78e2) < 58
                        ? (52.5e1, 5.43e2)
                        : (0x1aa, 13.95e2) <= (144.0e1, 124)
                        ? (0xa9, 8.21e2)
                        : (101, 0x13f)),
                    x6
                  )
                  a.lineTo(
                    T6 + U3 + m2,
                    u4S.Y01(
                      S.right,
                      0x10a < (0x123, 9.12e2) ? (0x45, 1) : (0x99, 0x68)
                    ),
                    x6
                  )
                }
                if (s) {
                  a.moveTo(
                    m3 + H3 + U3 + R2,
                    u4S.T01(
                      F,
                      1.045e3 < (91, 0x21b)
                        ? 41
                        : (66.4e1, 120) > 75
                        ? (6, 0.5)
                        : (0x1d7, 0x1e2)
                    ),
                    x6
                  )
                  a.lineTo(m3 + H3 + w2 + D0, F + y3, x6)
                }
                if (r.priceFormatter) {
                  a3 = r.priceFormatter(this, S, a3)
                } else {
                  a3 = this.formatYAxisPrice(a3, S, null, r)
                }
                var o3 = r.textBackground
                    ? this.containerColor
                    : (0x210, 124) <= 3.53e2
                    ? (64.3e1, null)
                    : (0xbb, 57),
                  M3 =
                    Y +
                    y3 +
                    ((0x77, 25.1e1) < (91, 65.5e1)
                      ? (0x143, 3)
                      : (0x1dc, 77.5e1))
                if (u4S.s01(o, X6 + p + t0 + R3)) {
                  M3 =
                    r.left +
                    ((0x21, 1.059e3) > (0xae, 43) ? (138, 3) : (11, 0x8b))
                  if (r.justifyRight)
                    M3 =
                      r.left +
                      r.width +
                      y3 -
                      ((0x47, 0x224) < (118, 33)
                        ? (23, 6.47e2)
                        : (138, 3.37e2) >= 54
                        ? (139, 3)
                        : (31.2e1, 0x1a8) < (69.8e1, 74)
                        ? (0xe5, 52.0e1)
                        : (0x64, 37.4e1))
                } else {
                  if (r.justifyRight) M3 = Y + r.width
                }
                a.addText(
                  z0 + V6 + R3,
                  a3,
                  M3,
                  x6,
                  o3,
                  4.92e2 >= (0x235, 0x131) ? (96.5e1, null) : (1.417e3, 0x81),
                  K
                )
              }
              if (
                u4S.g01(
                  n,
                  (0x230, 0xc6) <= (104.5e1, 36)
                    ? (0x207, 'V')
                    : (0x204, 0xbb) < 0x1ff
                    ? (44.6e1, 100)
                    : (0x5f, 4.2e2) < (8.4e1, 0xba)
                    ? 0xe3
                    : (0x1ab, 41)
                )
              ) {
                console.log(
                  R +
                    i3 +
                    c0 +
                    m0 +
                    E0 +
                    O2 +
                    C3 +
                    j +
                    u2 +
                    R3 +
                    w +
                    j2 +
                    i3 +
                    p1 +
                    p +
                    U3 +
                    R3 +
                    T1 +
                    H0 +
                    p +
                    U +
                    U3 +
                    m1 +
                    I0 +
                    I0 +
                    H0 +
                    U3 +
                    D +
                    t6 +
                    e1 +
                    E3 +
                    H0 +
                    q0 +
                    P2 +
                    P2
                )
              }
              if (s) {
                var F3 =
                  Math.round(r.bottom) +
                  ((0xff, 1.469e3) >= (5.34e2, 52) ? (97, 0.5) : (111.0e1, 133))
                a.moveTo(E + E3 + D0, F, r.top)
                a.lineTo(m3 + d + U3, F, F3)
                a.draw(this.chart.context, m3 + c + p + U3)
              }
            }
            this.plotYAxisGrid(S)
          }
          this.runAppend(R + i3 + c0 + m0 + R1 + a0, arguments)
        }
        I.ChartEngine.prototype.drawHistogram = function(s, Y) {
          var o = 'ring',
            F = (0x24, 12.04e2) >= 20.3e1 ? (60, 's') : (64, 5.29e2),
            y3 =
              (48, 145) > 1.25e2
                ? (0x208, 'n')
                : 27.6e1 > (0x1c7, 1.019e3)
                ? (37, 0.125)
                : (52, 44),
            K = (88.9e1, 0xea) <= (8.6e1, 0x1ba) ? (130, 'o') : (101, 6.8e1),
            g =
              (1.466e3, 71) > (46, 149)
                ? 'g'
                : 96 <= (0x133, 10.32e2)
                ? (0x7, 'i')
                : (0x200, 8.9e2),
            q =
              (147, 0x20) < (0x7e, 117)
                ? (2.05e2, 't')
                : (1.191e3, 0x5b) > (74.0e1, 0x21e)
                ? (5.96e2, 12)
                : (94, 33),
            l = 'unc',
            A = 'f',
            c3 = 'ste',
            m = 'nte',
            t3 = 'ce',
            D3 = 'ed',
            I3 = 'ac',
            V3 = 'ata'
          if (!Y || !Y.length) return
          var u3 = s.panel
          if (!u3) u3 = t6 + Y1 + U3 + R3
          var K3 = this.panels[u3]
          if (!K3) return
          var v3 = s.yAxis ? s.yAxis : K3.yAxis,
            q3 = s.subtype,
            h3 = this.chart.dataSegment,
            l3 = false
          this.getDefaultColor()
          var n, a3
          for (
            a3 =
              (50.7e1, 0x1a7) < (118, 58.3e1)
                ? (58, 0)
                : 6.39e2 <= (0x223, 0x99)
                ? (62, 'A')
                : (4, 118);
            u4S.p01(a3, Y.length);
            a3++
          ) {
            l3 |=
              Y[a3].border_color_up && !I.isTransparent(Y[a3].border_color_up)
            l3 |=
              Y[a3].border_color_down &&
              !I.isTransparent(Y[a3].border_color_down)
          }
          if (
            u4S.n01(
              s.borders,
              (0x149, 1.074e3) < (1.4e1, 0xcb)
                ? (146, 86)
                : 0x10c <= (0x13e, 2.89e2)
                ? (0x257, false)
                : (119, 63.6e1) < (121, 2.35e2)
                ? (10.24e2, 25)
                : (0x12c, 0x8f)
            )
          )
            l3 = false
          if (!s.name) s.name = i2 + V3
          var S6 = v3.multiplier
          if (!s.heightPercentage)
            s.heightPercentage =
              (124, 99.8e1) >= (71, 0x162)
                ? (0x206, 0.7)
                : (45, 0x1d7) > 6.57e2
                ? (110, 'G')
                : (1.079e3, 122.2e1) <= 115
                ? (0x7f, 0x91)
                : (0x12f, 0x1d9)
          if (!s.widthFactor)
            s.widthFactor = (14, 72) < 126 ? (12.16e2, 0.8) : (2.1e1, 33.5e1)
          var x6 =
              (0x2c, 0x180) >= (0x1f1, 133)
                ? (17.7e1, 0)
                : 7 > (147, 68)
                ? 0x2
                : (145, 20.8e1),
            o3 = 0
          for (
            var M3 =
              (139.3e1, 1.033e3) < (0x135, 1.416e3)
                ? (108, 0)
                : 11.31e2 <= (1.202e3, 0x19c)
                ? (99, 26)
                : (88.5e1, 120);
            u4S.u21(M3, this.chart.maxTicks);
            M3++
          ) {
            var F3 = h3[M3]
            if (!F3) continue
            var G6 =
              (8.62e2, 35.8e1) >= (0xc8, 56.1e1)
                ? (83, 'V')
                : (0x1a7, 2.4e1) > 92
                ? 'V'
                : (0x29, 0xe) < (25, 114)
                ? (65, 0)
                : (39, 97)
            for (
              a3 =
                (59, 0x1d4) <= (11.78e2, 14.49e2)
                  ? (149, 0)
                  : (43, 45.0e1) <= (100, 121)
                  ? 0x16
                  : (0x1e, 10.4e1) <= 0x4f
                  ? (127, 1.053e3)
                  : (0x105, 0xd);
              u4S.R21(a3, Y.length);
              a3++
            ) {
              var d6 = F3[Y[a3].field]
              if (
                d6 ||
                u4S.U21(d6, 0x1d0 >= (0xd, 2) ? (1.28e2, 0) : (0x23c, 8.4e1))
              ) {
                n =
                  Y[a3].subField ||
                  this.chart.defaultPlotField ||
                  K0 + X6 + o1 + p
                if (typeof d6 == H3 + m3 + F0 + n1 + R3 && d6[n]) d6 = d6[n]
                if (u4S.t21(q3, C3 + R3 + I3 + r0 + D3)) G6 += d6
                else G6 = d6
                if (u4S.I21(G6, x6)) x6 = G6
                if (u4S.V21(G6, o3)) o3 = G6
              }
            }
          }
          if (
            u4S.d21(
              x6,
              (11.52e2, 0x1a6) < 0x19c
                ? (70, null)
                : (1.225e3, 10.28e2) > (0x35, 0x1d)
                ? (86.5e1, 0)
                : (0x15f, 11.7e1)
            ) &&
            u4S.F21(o3, 0)
          ) {
            this.watermark(
              u3,
              t3 + m + U3,
              m3 + h1 + R3 + H3 + z6,
              this.translateIf(
                s.name +
                  (H0 +
                    E1 +
                    H3 +
                    R3 +
                    H0 +
                    E0 +
                    i0 +
                    i3 +
                    e3 +
                    X6 +
                    i3 +
                    m3 +
                    Q2)
              )
            )
            return
          }
          var A3 =
              Math.floor(v3.top) +
              ((10.09e2, 72) <= (0xd6, 0x22e) ? (0x28, 0.5) : (83, 37.8e1)),
            f3
          if (!s.bindToYAxis) {
            f3 =
              Math.floor(v3.bottom) +
              ((0x9a, 0x1d6) <= 0x22a ? (0x173, 0.5) : (25, 0x5f))
            S6 = u4S.f21(f3 - A3, s.heightPercentage, x6 - o3)
          } else {
            f3 =
              Math.floor(this.pixelFromPrice(o3, K3, v3)) +
              ((0x2, 66.2e1) <= (0xe9, 1.028e3) ? (0x5, 0.5) : (0x1b6, 0x19b))
          }
          this.startClip(u3)
          var z3 =
              u4S.b21(
                this.layout.candleWidth,
                (0x3c, 0x9e) >= (88, 124)
                  ? (45, 1)
                  : (1.257e3, 7.0e1) > 0x178
                  ? 25000
                  : (141, 0xf8) >= (0x138, 0x184)
                  ? (0xe1, 0x86)
                  : (31, 0x20d)
              ) || !l3
                ? (15.3e1, 1.181e3) < (0x240, 0xce)
                  ? (12.97e2, 'i')
                  : (146, 0x116) > (0x218, 0xec)
                  ? (3.84e2, 0)
                  : (44, 0x102)
                : 0x20f > (115, 0x14f)
                ? (46, 0.5)
                : (1.254e3, 0x22) > (2.82e2, 95.3e1)
                ? 'Low'
                : (1.213e3, 71),
            w3 = this.chart.context,
            Z3 = Math.max(
              (39, 123.4e1) >= 24 ? (0x91, 0) : (123, 67),
              u4S.B21(
                (29 < (90.2e1, 50.8e1) ? (18.1e1, 1) : (124, 0xef)) -
                  s.widthFactor,
                this.layout.candleWidth,
                (8.7e1, 0x9b) >= 122 ? (0xc7, 2) : (2.01e2, 81.1e1)
              )
            ),
            d3 = new Array(h3.length),
            N6 = [],
            W6 = this,
            P = (1.076e3, 60) <= 1.004e3 ? (0x200, 1) : (7.59e2, 0x58)

          function r6(S, H, c, d, E, D, U, w, j) {
            var R = 'au',
              t = 'us'
            if (!d)
              d = 5.74e2 >= (44.7e1, 0xd8) ? (65.6e1, 1) : (11.68e2, 0x126)
            w3.globalAlpha = I.isIE8 ? 0.5 : d
            w3.beginPath()
            var V =
                f3 +
                (0x232 <= (0x164, 0x257)
                  ? (0x211, 0.5)
                  : (7, 1.476e3) <= 81
                  ? (0xe1, 88)
                  : (70, 0x1e4)),
              i = Math.floor(
                u4S.J21(
                  W6.pixelFromBar(
                    (23.6e1, 72) <= 54
                      ? (107, 3)
                      : (60, 11.2e2) >= 0x24e
                      ? (13.7e1, 0)
                      : (0xb3, 121),
                    K3.chart
                  ),
                  W6.layout.candleWidth /
                    ((21, 0x9c) >= 5
                      ? (12.6e1, 2)
                      : 25 >= (138, 90)
                      ? 'y1'
                      : (0x70, 2.94e2))
                )
              ),
              z = i
            for (
              var W =
                (117, 40) <= (9, 114.9e1)
                  ? (0x66, 0)
                  : (0x49, 6.7e2) < 1
                  ? (37, 45)
                  : (54, 114);
              u4S.v21(W, h3.length);
              W++
            ) {
              var C = N6[W] || f3
              if (
                u4S.K21(
                  W,
                  (21, 0x9c) > 72.1e1
                    ? 325
                    : (0x2d, 0x186) >= (31.9e1, 3.39e2)
                    ? (132.4e1, 0)
                    : (0x11e, 3.8e1)
                )
              )
                V = C
              if (!h3[W] || !h3[W][S]) {
                V = C
                z += W6.layout.candleWidth
                continue
              }
              var e = h3[W],
                r = e[S]
              if (typeof r == Z1 + F0 + p + L2 && r[H]) r = r[H]
              var a = u4S.m21(r - o3, S6)
              if (isNaN(a)) continue
              var L = W6.layout.candleWidth
              if (e.candleWidth) {
                L = e.candleWidth
                if (
                  u4S.q21(
                    W,
                    (91.6e1, 3.04e2) > (90.3e1, 26.8e1) ? (51, 0) : (0xfb, 53)
                  )
                )
                  i = z = Math.floor(
                    u4S.S11(
                      W6.pixelFromBar(
                        (0xaa, 0x20f) < (3.9e1, 0x18f)
                          ? 'm'
                          : (0x30, 18) < (0x197, 0xfa)
                          ? (8.34e2, 0)
                          : (0x254, 0xd),
                        K3.chart
                      ),
                      e.candleWidth / 2
                    )
                  )
              }
              var v = Math.min(
                Math.floor(u4S.x11(C, a)) +
                  (0x11d > (0x14d, 136) ? (0x22a, 0.5) : (0x26, 0x6f)),
                C
              )
              if (
                (j && j.indexOf(W) == -1) ||
                (!j &&
                  ((D && u4S.X11(e.Close, e.iqPrevClose)) ||
                    (!D && u4S.r11(e.Close, e.iqPrevClose))))
              ) {
                V = v
                z += L
                continue
              }
              var b = u4S.G11(L, W6.layout.candleWidth),
                J,
                O,
                N
              if (Z3) {
                J = Math.round(z + u4S.L11(Z3 + U * w, b))
                O =
                  J +
                  (E
                    ? 85 < (0x106, 1.475e3)
                      ? (0x179, 0)
                      : (13.02e2, 0x248)
                    : z3)
                N =
                  J +
                  Math.round(u4S.j11(w, b)) -
                  (E
                    ? (88.5e1, 10.9e2) <= (7.88e2, 137)
                      ? (39, 1.31e2)
                      : 14.32e2 > (0x80, 0x1e7)
                      ? (11.61e2, 0)
                      : 142 >= (9.68e2, 1.076e3)
                      ? 'S'
                      : (0x214, 41)
                    : z3)
              } else {
                J = z + u4S.O11(Z3 + U * w, b)
                O =
                  Math.round(J) +
                  (E
                    ? 0x247 > (1.8e2, 89)
                      ? (43, 0)
                      : 0x216 >= (0xa0, 142.5e1)
                      ? 8.01e2
                      : (7.64e2, 0xf5)
                    : z3)
                N = u4S.W11(
                  Math.round(J + w * b),
                  E
                    ? 0x11c > (7.07e2, 1.22e3)
                      ? (0x1d2, 101)
                      : 7.5e2 > (149, 4.26e2)
                      ? (70, 0)
                      : (2.91e2, 98)
                    : z3
                )
              }
              if (
                u4S.N11(
                  N - O,
                  7.03e2 < (83.0e1, 86)
                    ? (89, 21)
                    : (135.1e1, 7.3e1) < (6.59e2, 0x159)
                    ? (90, 2)
                    : (0x251, 7.99e2)
                )
              )
                N =
                  O +
                  (0x189 <= (0x55, 67.7e1)
                    ? (0x16a, 1)
                    : 111 >= (4, 118)
                    ? 4
                    : (114, 146))
              var B = E
                ? (5.2e2, 0x24b) > (1.226e3, 31.3e1)
                  ? (25, 0)
                  : (68.4e1, 8.7e2) <= 25
                  ? (1.414e3, 6.99e2)
                  : (71, 42)
                : 90.8e1 < (118, 0x23b)
                ? 0.1
                : 2.53e2 > (13.01e2, 112)
                ? (0x136, 0.5)
                : (23, 7.77e2)
              if (
                u4S.b11(
                  O %
                    ((67.6e1, 25) > 111
                      ? (19.5e1, 'W')
                      : (0x138, 0x3d) < (85, 0xc4)
                      ? (0x1db, 1)
                      : (15, 0x1de)),
                  B
                )
              )
                O +=
                  136 < (0x170, 10.07e2)
                    ? (41, 0.5)
                    : 82 > (0x24f, 60.1e1)
                    ? 0x47
                    : (63.7e1, 8.56e2) < (60, 65)
                    ? (145, 0x244)
                    : (54, 0x98)
              if (
                u4S.B11(
                  N %
                    ((4.39e2, 0x20d) >= (0x241, 112.7e1)
                      ? (1.067e3, 'a')
                      : (6.1e1, 69) >= 63
                      ? (0x123, 1)
                      : (0x1c3, 34) > (116, 4.1e1)
                      ? 0x71
                      : (61, 1.219e3)),
                  B
                )
              )
                N +=
                  (0xd8, 6) <= (12.34e2, 0x139) ? (120, 0.5) : (1.3e3, 59.6e1)
              w3.moveTo(N, C)
              if (
                u4S.Y11(f3, C) &&
                E &&
                !Z3 &&
                N6[
                  W +
                    ((127, 78.4e1) < 0x10d
                      ? true
                      : (12.0e1, 33) <= 24.1e1
                      ? (7.69e2, 1)
                      : (0x206, 0x143))
                ]
              )
                w3.moveTo(N, Math.max(v, Math.min(C, N6[W + 1])))
              w3.lineTo(N, v)
              w3.lineTo(O, v)
              if (E && U) {
                if (
                  u4S.T11(d3[W], v) ||
                  u4S.s11(
                    W,
                    (31, 0xef) > (0x2b, 0x239)
                      ? (43, 5.43e2)
                      : (55, 82.1e1) > 4.72e2
                      ? (0x1af, 0)
                      : (55, 0x17)
                  )
                )
                  w3.lineTo(O, Math.min(C, d3[W]))
              } else if (
                E &&
                !Z3 &&
                u4S.g11(q3, t6 + X6 + t + R3 + D0 + p + E3)
              ) {
                if (
                  u4S.p11(
                    W,
                    (0xee, 0x1a4) >= (0x138, 87) ? (78, 0) : (34, 146)
                  ) &&
                  d3[
                    u4S.n11(
                      W,
                      (1.03e2, 0x211) <= (5.64e2, 1.222e3)
                        ? (64, 1)
                        : (0x201, 17) >= 13.13e2
                        ? (0x9d, '+')
                        : (39, 0x8e)
                    )
                  ] &&
                  u4S.u41(d3[W - 1], v)
                )
                  w3.lineTo(
                    O,
                    Math.min(
                      C,
                      d3[
                        u4S.R41(
                          W,
                          120.7e1 > (75, 4.63e2)
                            ? (1.28e2, 1)
                            : 67.9e1 < (0x4b, 136)
                            ? 'j'
                            : (0x233, 75)
                        )
                      ]
                    )
                  )
              } else if (E && !Z3) {
                if (
                  u4S.U41(V, v) ||
                  u4S.t41(
                    W,
                    (2.74e2, 3.91e2) <= (25, 68.6e1)
                      ? (0x247, 0)
                      : (11.7e1, 0x1a1) < (97, 104)
                      ? (0xa0, 1.0)
                      : (5.56e2, 119)
                  )
                )
                  w3.lineTo(O, Math.min(C, V))
              } else {
                w3.lineTo(O, C)
              }
              V = v
              z += L
              if (u4S.I41(q3, t6 + X6 + t + z0 + U3 + p + E3) || E) d3[W] = v
            }
            if (E) {
              w3.strokeStyle =
                !c || u4S.V41(c, i3 + F6 + R3 + H3) ? W6.defaultColor : c
              w3.stroke()
            } else {
              w3.fillStyle = !c || u4S.d41(c, R + R3 + H3) ? W6.defaultColor : c
              w3.fill()
            }
            w3.closePath()
          }
          for (
            a3 = (76, 47.7e1) < (62.6e1, 5.94e2) ? (0x1d0, 0) : (0x25, 81);
            u4S.F41(a3, Y.length);
            a3++
          ) {
            var a6 = Y[a3]
            P = u4S.f41(this.layout.candleWidth, s.widthFactor)
            if (Z3) {
              if (u4S.z41(this.layout.candleWidth - P, 2)) {
                l3 = false
              }
            }
            var k3 =
              (0x249, 0x157) > (6, 0x213)
                ? 7.54e2
                : 89 >= (87, 0x35)
                ? (6.99e2, 0)
                : 0x17f <= (8.91e2, 18)
                ? 'E'
                : (0xb8, 116)
            if (u4S.E41(q3, t6 + X6 + F6 + c3 + U3 + p + E3)) {
              k3 = a3
              P /= Y.length
            }
            n = s.subField || this.chart.defaultPlotField || K0 + A2 + C3 + p
            if (typeof a6.color_function == A + l + q + g + K + y3) {
              var J3,
                P3 = {},
                c6
              for (
                var I6 =
                  74.9e1 <= (119, 0x10a)
                    ? (119, 0xd9)
                    : 1.232e3 > (75, 147)
                    ? (6.58e2, 0)
                    : (4, 10.03e2) < 0x171
                    ? (1.185e3, 'V')
                    : (12, 0x1ea);
                u4S.o41(I6, h3.length);
                I6++
              ) {
                if (h3[I6]) {
                  J3 = a6.color_function(h3[I6])
                  if (typeof J3 == F + q + o) {
                    J3 = {
                      fill_color: J3,
                      border_color: J3,
                    }
                  }
                  c6 =
                    J3.fill_color +
                    ((0x1ac, 0x213) >= (0x38, 67) ? (77, ',') : (1.5e1, 103)) +
                    J3.border_color
                  if (u4S.e41(c6, P3)) {
                    P3[c6].positions.push(I6)
                  } else {
                    J3.positions = [I6]
                    P3[c6] = J3
                  }
                }
              }
              for (c6 in P3) {
                J3 = P3[c6]
                r6(
                  a6.field,
                  n,
                  J3.fill_color,
                  J3.opacity,
                  (127.0e1, 0x2c) >= 28
                    ? (128, null)
                    : (128, 66) < (0x19d, 12)
                    ? (128, 136.2e1)
                    : 30.8e1 > (10, 143.1e1)
                    ? (2, 13.1e2)
                    : (0x163, 0x247),
                  null,
                  k3,
                  P,
                  J3.positions
                )
                r6(
                  a6.field,
                  n,
                  J3.border_color,
                  J3.opacity,
                  (32, 78) > (0xd4, 77.2e1)
                    ? (5, 'X')
                    : (59, 0xec) < (30, 118.0e1)
                    ? (28, true)
                    : (42, 0x1c5),
                  0xce >= (56.4e1, 130) ? (49.5e1, null) : (1.285e3, 57.1e1),
                  k3,
                  P,
                  J3.positions
                )
              }
            } else {
              r6(
                a6.field,
                n,
                a6.fill_color_up,
                a6.opacity_up,
                (146, 0x101) <= (68, 12)
                  ? 4
                  : (1.33e2, 34.4e1) > (1.262e3, 77)
                  ? (0x18a, null)
                  : (149, 1.243e3),
                (0x167, 90.5e1) <= (0xd9, 12.68e2) ? (124, true) : (48, 38),
                k3,
                P
              )
              r6(
                a6.field,
                n,
                a6.fill_color_down,
                a6.opacity_down,
                0xb6 < (13.69e2, 0x188) ? (0x15b, null) : (12.34e2, 129),
                (113, 109.4e1) < 0x22d
                  ? (74.7e1, 0x1e5)
                  : (0x12e, 34) < 0x247
                  ? (0x161, null)
                  : (1.032e3, 0x24f),
                k3,
                P
              )
              if (
                u4S.A41(
                  this.layout.candleWidth,
                  (29, 126.9e1) < 6.17e2
                    ? 0x204
                    : 0x232 < (6.42e2, 141)
                    ? (0x2, 6.2e2)
                    : (14.89e2, 0x8b) < 18.6e1
                    ? (1.55e2, 2)
                    : (0x127, 0xe8)
                ) &&
                l3
              ) {
                r6(
                  a6.field,
                  n,
                  a6.border_color_up,
                  a6.opacity_up,
                  (24, 85.0e1) <= 130
                    ? (7, 'Z')
                    : (86, 69) > 30
                    ? (4.82e2, true)
                    : (0x190, 25),
                  (120, 7) > 0x16a
                    ? (0x111, 8.26e2)
                    : (133, 4.97e2) >= (0x106, 122)
                    ? (1.335e3, true)
                    : (0xed, 0x79),
                  k3,
                  P
                )
                r6(
                  a6.field,
                  n,
                  a6.border_color_down,
                  a6.opacity_down,
                  0x23c <= (75.8e1, 0x58)
                    ? 69
                    : (2.99e2, 37) <= (114, 0x198)
                    ? (0x164, true)
                    : (0xb8, 82.0e1),
                  (108.3e1, 2) <= 77.0e1 ? (0x60, null) : (69, 0x26),
                  k3,
                  P
                )
              }
            }
            if (u4S.k41(q3, C3 + R3 + i3 + n2 + D3)) N6 = I.shallowClone(d3)
          }
          w3.globalAlpha =
            (37, 78) >= (14.6e1, 47.3e1)
              ? (1.466e3, 'h')
              : (109.2e1, 86) < (77, 130)
              ? (93, 1)
              : 128.9e1 <= (41, 0x1a7)
              ? 13.55e2
              : (10.0e2, 1.115e3)
          this.endClip()
        }
        I.ChartEngine.prototype.drawBarTypeChartInner = function(S) {
          var H = 'Cl',
            c = 'lc',
            d = 'dle',
            E = 'ca',
            D = 'togr',
            U = S.type,
            w = S.panel,
            j = S.field,
            R = S.fillColor,
            t = S.borderColor,
            V = S.condition,
            i = S.style,
            z = S.yAxis,
            W = S.overlayScaling,
            C = u4S.P41(U, B6 + a0 + D + i3 + z6),
            e = C || u4S.l41(U, E + Q3 + d),
            r = u4S.y51(U, C3 + Y1 + E3 + H3 + c0),
            a = u4S.H51(U, B6 + c),
            L = u4S.c51(U, m3 + i3 + U3) || a,
            v = w.chart,
            b = v.dataSegment,
            J = this.chart.context,
            O = w.yAxis.top,
            N = w.yAxis.bottom,
            B = new Array(b.length),
            s =
              (50.5e1, 72.8e1) <= (34.0e1, 12.8e2)
                ? (58.5e1, 0)
                : 86 > (3.73e2, 0x205)
                ? (0x1a2, 143)
                : (122, 0x17b)
          if (t && !I.isTransparent(t))
            s =
              139 >= (0x204, 74.7e1)
                ? (10.42e2, 0.0)
                : (28, 0x1f5) <= (36, 0xd7)
                ? (8.47e2, 60)
                : (83.2e1, 7.26e2) > (5.76e2, 1.88e2)
                ? (6.72e2, 0.5)
                : (1.013e3, 65.4e1)
          var Y = u4S.a51(
            v.dataSet.length,
            v.scroll,
            77.1e1 > (0x1d8, 0x12b)
              ? (4.42e2, 1)
              : 21 >= (9.2e1, 100.7e1)
              ? true
              : (31, 0x209)
          )
          J.beginPath()
          if (!z) z = w.yAxis
          var o = this.layout.candleWidth,
            F = u4S.I51(
              w.left,
              ((45.7e1, 75.4e1) > (13.12e2, 43)
                ? (46.8e1, 0.5)
                : (0x24f, 9.43e2)) * o,
              this.micropixels,
              (13, 0x191) <= (103, 6.4e2)
                ? (76.4e1, 1)
                : (0x222, 85) >= 13.1e2
                ? (0x63, 62.8e1)
                : (0xf9, 0xc7) <= 115
                ? (4.61e2, true)
                : (0x1b5, 2.35e2)
            ),
            y3 = u4S.i51(
              v.tmpWidth,
              9.85e2 >= (117, 3.28e2) ? (86, 2) : (88, 0x87)
            ),
            K = u4S.M51(
              J.lineWidth,
              (4.99e2, 0x42) <= (83, 0x21e)
                ? (7.4e1, 2)
                : 2.08e2 <= (0x1cf, 93)
                ? (142.2e1, 'd')
                : (0x67, 0x11)
            )
          if (e) {
            if (I.isTransparent(R)) R = this.containerColor
            J.fillStyle = R
          }
          if (r) {
            J.lineWidth =
              (10.57e2, 14.97e2) > (13.27e2, 1.479e3)
                ? (0x225, 1)
                : (73, 40.6e1) >= 64.4e1
                ? (0xd7, 0x16a)
                : (61, 82)
          }
          if (L) {
            var g = this.canvasStyle(i)
            if (
              g.width &&
              u4S.w51(
                parseInt(
                  g.width,
                  (48.9e1, 1.31e2) < (11.65e2, 0x18a) ? (78, 10) : (0x150, 8)
                ),
                (0x170, 127.1e1) > (121, 24)
                  ? (101.2e1, 25)
                  : (30, 14) >= (74, 13.74e2)
                  ? (0xfc, 10)
                  : 0x24f <= (90.6e1, 38)
                  ? 26
                  : (100, 7.65e2)
              )
            ) {
              J.lineWidth = Math.max(
                83 <= (8.16e2, 0xd2)
                  ? (2.92e2, 1)
                  : 33 <= (10.94e2, 5)
                  ? (121, 'C')
                  : (1, 4.07e2),
                I.stripPX(g.width)
              )
            } else {
              J.lineWidth = 1
            }
          }
          var q = v.state.chartType.pass
          for (var l = 0; u4S.C51(l, b.length); l++) {
            var A = y3
            F += u4S.Z51(
              o,
              (0xef, 0xd0) <= (3.03e2, 4.83e2) ? (12.05e2, 2) : (132, 129.4e1)
            )
            o = this.layout.candleWidth
            F += u4S.h51(
              o,
              (6.43e2, 0x1b8) != (72.9e1, 0x1b8)
                ? 0x31
                : (1.079e3, 38.4e1) <= 12.42e2
                ? (0xcc, 2)
                : (109.4e1, 0x20a)
            )
            var c3 = b[l]
            if (!c3) continue
            if (c3.projection) continue
            if (c3.candleWidth) {
              F += u4S.J51(
                c3.candleWidth - o,
                (0x82, 31) > 4
                  ? (46, 2)
                  : 112 >= (63, 0x210)
                  ? 'G'
                  : (91.5e1, 0xfa)
              )
              o = c3.candleWidth
              if (S.volume || u4S.v51(o, v.tmpWidth)) A = u4S.K51(o, 2)
            }
            if (v.transformFunc && c3.transform) c3 = c3.transform
            if (c3 && j && u4S.m51(j, H + H3 + d0)) c3 = c3[j]
            if (
              !c3 &&
              u4S.q51(
                c3,
                (2.46e2, 10) > 0x79
                  ? ''
                  : (0x138, 5.31e2) > (1.96e2, 31)
                  ? (12.28e2, 0)
                  : (0x237, 8.43e2)
              )
            )
              continue
            var m = c3.Close,
              t3 = u4S.S91(c3.Open, undefined) ? m : c3.Open
            if (C && v.defaultPlotField) m = c3[v.defaultPlotField]
            if (
              !m &&
              u4S.x91(
                m,
                36 > (0x1ea, 14.0e2)
                  ? (98.8e1, 113)
                  : (31, 21) >= 0x19f
                  ? '2d'
                  : 0x5e < (59, 0x9c)
                  ? (0xb2, 0)
                  : (0x13a, 129)
              )
            )
              continue
            if (
              e &&
              !C &&
              (u4S.X91(t3, m) ||
                u4S.r91(
                  t3,
                  (21.8e1, 35) > (0xc8, 0x1de)
                    ? (0x160, 89.3e1)
                    : 27 < (45, 148)
                    ? (19, null)
                    : (18.1e1, 0x131)
                ))
            )
              continue
            if (V) {
              if (u4S.G91(V, I.ChartEngine.CLOSEDOWN)) {
                q.even |= u4S.L91(m, c3.iqPrevClose)
              } else if (u4S.j91(V, I.ChartEngine.CANDLEDOWN)) {
                q.even |= u4S.O91(m, t3)
              }
              if (u4S.W91(V, I.ChartEngine.CANDLEUP) && u4S.N91(t3, m)) continue
              if (u4S.b91(V, I.ChartEngine.CANDLEDOWN) && u4S.B91(t3, m))
                continue
              if (u4S.Y91(V, I.ChartEngine.CANDLEEVEN) && u4S.T91(t3, m))
                continue
              if (
                u4S.s91(V, I.ChartEngine.CLOSEUP) &&
                u4S.g91(m, c3.iqPrevClose)
              )
                continue
              if (
                u4S.p91(V, I.ChartEngine.CLOSEDOWN) &&
                u4S.n91(m, c3.iqPrevClose)
              )
                continue
              if (
                u4S.u81(V, I.ChartEngine.CLOSEEVEN) &&
                u4S.R81(m, c3.iqPrevClose)
              )
                continue
            }
            var D3 = Y + l,
              I3 = t3,
              V3 = m
            if (r || L) {
              I3 = u4S.U81(c3.High, undefined) ? Math.max(m, t3) : c3.High
              V3 = u4S.t81(c3.Low, undefined) ? Math.min(m, t3) : c3.Low
            }
            var u3, K3
            if (W) {
              u3 = u4S.I81(W.bottom, (I3 - W.min) * W.multiplier)
              K3 = u4S.V81(W.bottom, (V3 - W.min) * W.multiplier)
            } else {
              u3 = z.semiLog
                ? this.pixelFromTransformedValue(I3, w, z)
                : u4S.d81(z.high - I3, z.multiplier) + z.top
              K3 = z.semiLog
                ? this.pixelFromTransformedValue(V3, w, z)
                : u4S.F81(z.high - V3, z.multiplier) + z.top
            }
            var v3,
              q3,
              h3 = Math.floor(C ? K3 : Math.min(u3, K3)) + s,
              l3 = C ? z.bottom : Math.max(u3, K3),
              n = Math.floor(u4S.f81(l3, h3)),
              a3 = K3
            if (L || r) {
              if (W) {
                v3 = u4S.z81(W.bottom, (t3 - W.min) * W.multiplier)
                q3 = u4S.E81(W.bottom, (m - W.min) * W.multiplier)
              } else {
                v3 = z.semiLog
                  ? this.pixelFromTransformedValue(t3, w, z)
                  : u4S.o81(z.high - t3, z.multiplier) + z.top
                q3 = z.semiLog
                  ? this.pixelFromTransformedValue(m, w, z)
                  : u4S.e81(z.high - m, z.multiplier) + z.top
              }
              a3 = q3
            }
            B[l] = a3
            if (u4S.A81(h3, O)) {
              if (u4S.k81(h3 + n, O)) continue
              n -= u4S.P81(O, h3)
              h3 = O
            }
            if (u4S.l81(h3 + n, N)) {
              n -= h3 + n - N
            }
            n = Math.max(
              n,
              61 > (69.5e1, 63)
                ? 0x73
                : (0x1d, 7.05e2) >= 0x10c
                ? (58, 2)
                : (0x12b, 62) > (8.47e2, 10.2e2)
                ? (138, 65)
                : (0x168, 87.5e1)
            )
            l3 = h3 + n
            if (u4S.y71(h3, N)) continue
            if (u4S.H71(l3, O)) continue
            var S6 = Math.floor(F) + 0.5,
              x6 = Math.floor(u4S.c71(S6, A)) + s,
              o3 = u4S.a71(Math.round(S6 + A), s)
            if (e) {
              if (u4S.D71(h3, l3)) {
                J.rect(
                  x6,
                  h3,
                  Math.max(
                    (101, 25.4e1) < (7.07e2, 0x208) ? (63, 1) : (0xc8, 50),
                    u4S.Q71(o3, x6)
                  ),
                  Math.max(
                    (14, 126) < 75.2e1
                      ? (135.4e1, 1)
                      : 6.02e2 <= (73.1e1, 126)
                      ? 6
                      : (37, 0x237),
                    u4S.i71(l3, h3)
                  )
                )
              }
            } else if (r) {
              if (u4S.M71(m, t3)) {
                if (u4S.w71(q3, N) && u4S.C71(q3, O)) {
                  var M3 =
                    Math.floor(q3) +
                    ((105, 0x191) > 12
                      ? (0xcb, 0.5)
                      : (67, 0x27) > (0x1ec, 0xb0)
                      ? (0xf3, 'd')
                      : (12.19e2, 0x18c) >= 1.311e3
                      ? (107.2e1, 0xe2)
                      : (0x62, 0x16b))
                  J.moveTo(x6, M3)
                  J.lineTo(o3, M3)
                }
              }
              if (u4S.Z71(I3, V3)) {
                J.moveTo(S6, h3)
                J.lineTo(S6, l3)
              }
            } else if (L) {
              if (
                u4S.h71(h3, N) &&
                u4S.J71(l3, O) &&
                u4S.v71(c3.High, c3.Low)
              ) {
                J.moveTo(S6, u4S.K71(h3, K))
                J.lineTo(S6, l3 + K)
              }
              if (u4S.m71(v3, O) && u4S.q71(v3, N) && !a) {
                var F3 =
                  Math.floor(v3) +
                  ((99, 13.99e2) >= (1.143e3, 71)
                    ? (0xff, 0.5)
                    : (123, 1.4e1) > 141
                    ? (15.8e1, 23)
                    : (0x231, 0x1c8))
                J.moveTo(S6, F3)
                J.lineTo(u4S.S3U(S6, A), F3)
              }
              if (u4S.x3U(q3, O) && u4S.X3U(q3, N)) {
                var G6 =
                  Math.floor(q3) +
                  ((130, 0xe3) >= 8 ? (0x14c, 0.5) : (79.0e1, 1.144e3))
                J.moveTo(S6, G6)
                J.lineTo(S6 + A, G6)
              }
            }
          }
          if (e) {
            J.fill()
            if (s) {
              J.lineWidth = S.highlight
                ? (64, 0x19d) <= (0x36, 27)
                  ? (91, 0x171)
                  : (1.83e2, 0x24a) < (79.1e1, 108.7e1)
                  ? (13.2e2, 2)
                  : 0x13b <= (0xb1, 0x1f)
                  ? 21.0e1
                  : (11, 78)
                : (1.54e2, 0x3f) == 63
                ? (83, 1)
                : (135, 18) > (0x141, 14.72e2)
                ? (116, 126)
                : (147, 91)
              J.strokeStyle = t
              J.stroke()
            }
          } else if (r || L) {
            this.canvasColor(i)
            if (t) J.strokeStyle = t
            if (S.highlight)
              J.lineWidth *=
                (48, 1.407e3) > (0x1d0, 73)
                  ? (78.2e1, 2)
                  : 0x1da <= (1.15e2, 7.4e1)
                  ? (0xe4, 'r')
                  : (0x3, 0x8e) > (92, 0x1c2)
                  ? (127.1e1, 20)
                  : (0x138, 84.7e1)
            J.stroke()
            J.closePath()
            J.lineWidth = 1
          }
          return {
            cache: B,
          }
        }
        I.ChartEngine.prototype.plotDataSegmentAsLine = function(t, V, i, z) {
          var W = 'FF',
            C =
              (13, 49) > 8.13e2
                ? 76.4e1
                : (42, 0) > 100
                ? 'O'
                : (114, 70) > (148, 67)
                ? (29, 'F')
                : (126.8e1, 143),
            e =
              (0xde, 7) <= (0x1db, 1.452e3)
                ? (1.84e2, '#')
                : (139, 0x40) > 78.0e1
                ? 0xbd
                : (1.26e2, 123) >= (51, 0x122)
                ? 't'
                : (65.8e1, 1.065e3),
            r = 'bje',
            a = 'moveT',
            L = 'To',
            v = (0x120, 144.7e1) > 0x1f1 ? (0x254, 'T') : (0x0, 0x1e5),
            b = 'obj',
            J =
              (0x116, 124) >= 121
                ? (0x194, false)
                : (10.62e2, 52) >= (0x241, 65.3e1)
                ? 0.75
                : (7.68e2, 0x185),
            O =
              40.5e1 <= (0x151, 0x1d8)
                ? (30, false)
                : (8.9e1, 0) > (0x8, 109.5e1)
                ? 0x7c
                : (99, 149),
            N = false,
            B = false,
            s =
              13 >= (20.4e1, 92)
                ? (149, 96.7e1)
                : (1.031e3, 40) <= 0x156
                ? (8.22e2, true)
                : (0x4f, 0x1bb) >= 8.82e2
                ? (108, 9.61e2)
                : (63, 12.67e2),
            Y =
              (12.0e1, 117) > 0x14c
                ? 126
                : (7.98e2, 70.7e1) < (76.6e1, 9.73e2)
                ? (97, null)
                : (146.4e1, 11.46e2) <= 8.36e2
                ? (97.3e1, 'w')
                : (9.99e2, 0xfa),
            o = null,
            F =
              149 >= (42.6e1, 2)
                ? (1.62e2, null)
                : (78, 75) > 0xe3
                ? (42, 0x23)
                : (4.68e2, 0x141),
            y3 =
              (88, 49) > 15
                ? (99, 0)
                : (0x63, 0x231) < (127, 0x1fd)
                ? 41
                : (0xa1, 96),
            K = false,
            g = false,
            q =
              86 <= (82, 3)
                ? (1.415e3, 2.18e2)
                : (1.126e3, 0x9b) <= 1.276e3
                ? (0x120, null)
                : 111 > (117, 124)
                ? (0x81, 'A')
                : (0x96, 49.3e1),
            l = {},
            A = [],
            c3 = [],
            m = [],
            t3 = [],
            D3 = this,
            I3 = V.chart,
            V3 = I3.dataSegment,
            u3 = I3.context,
            K3 = new Array(V3.length),
            v3 = u3.strokeStyle

          function q3(S) {
            var H = o,
              c = S
            if (typeof c == H3 + m3 + F0 + p + t6 + R3) {
              o = I.borderPatternToArray(u3.lineWidth, c.pattern)
              c = c.color
            }
            l[c] =
              (6.54e2, 23) >= 56
                ? 'q'
                : 0x187 >= (1.185e3, 138)
                ? (0x4f, 1)
                : (33, 83)
            if (K) return
            var d = A.slice(-2),
              E = u4S.r3U(o, Array) && o.join(),
              D = u4S.G3U(H, Array) && H.join(),
              U = u4S.L3U(E, D),
              w = !I.colorsEqual(v3, c),
              j = u4S.j3U(
                S.width,
                i.highlight
                  ? (52, 88) >= 29
                    ? (141.2e1, 2)
                    : (14, 1.276e3) < (0x12a, 140)
                    ? 'E'
                    : (0x174, 0x1c5) > (0x27, 120.7e1)
                    ? 114
                    : (0xf4, 124)
                  : (109, 10.13e2) < (10.42e2, 79)
                  ? (0xfd, 0x72)
                  : 0x13d < (0x200, 5.32e2)
                  ? (0xe, 1)
                  : (0, 1.461e3) < (111, 0x255)
                  ? (0x1e5, 's')
                  : (8.61e2, 137)
              ),
              R = u4S.O3U(u3.lineWidth, j)
            if (w || U || R) {
              if (y3) {
                c3.push({
                  coord: d,
                  color: c,
                  pattern: o ? o : [],
                  width: j,
                })
              } else if (w || R) {
                u3.stroke()
                u3.lineWidth = j
                u3.beginPath()
                u3.moveTo(
                  d[
                    (0x8e, 109.1e1) <= 108.2e1
                      ? 0.9
                      : 0x251 < (20, 0xbd)
                      ? (0x1c2, 0x145)
                      : (6.66e2, 0x93) > (0x58, 77)
                      ? (119, 0)
                      : (84, 8.1e1)
                  ],
                  d[(18.8e1, 0x1fe) >= (23, 0x16b) ? (0xd0, 1) : (2.9e2, 0x16)]
                )
              }
            }
            v3 = c
            if (!c || u4S.W3U(c, i3 + F6 + R3 + H3)) {
              u3.strokeStyle = D3.defaultColor
            } else {
              u3.strokeStyle = c
            }
            return d
          }

          function h3(S, H, c, d) {
            var E, D, U
            if (d) {
              var w = d.bottom + u4S.N3U(d.min, d.multiplier)
              E = u4S.b3U(w, c.CollatedOpen * d.multiplier)
              D = u4S.B3U(w, c.collatedHigh * d.multiplier)
              U = u4S.Y3U(w, c.collatedLow * d.multiplier)
            } else {
              E = F.semiLog
                ? D3.pixelFromTransformedValue(c.CollatedOpen, V, F)
                : u4S.T3U(F.high - c.CollatedOpen, F.multiplier) + F.top
              D = F.semiLog
                ? D3.pixelFromTransformedValue(c.CollatedHigh, V, F)
                : u4S.s3U(F.high - c.CollatedHigh, F.multiplier) + F.top
              U = F.semiLog
                ? D3.pixelFromTransformedValue(c.CollatedLow, V, F)
                : u4S.g3U(F.high - c.CollatedLow, F.multiplier) + F.top
            }
            u3.lineTo(S, E)
            u3.moveTo(S, D)
            u3.lineTo(S, U)
            u3.moveTo(S, H)
            A.push(S, E)
          }
          if (I3.dataSet.length) {
            this.startClip(V.name)
            if (i) {
              J = i.skipProjections
              O = i.skipTransform
              N = i.noSlopes
              y3 = i.tension
              B = i.step
              o = i.pattern
              s = i.extendOffChart
              F = i.yAxis
              Y = i.gaps
              K = i.noDraw
              g = i.reverse
              q = i.overlayScaling
              if (i.width) u3.lineWidth = i.width
            }
            if (i.highlight)
              u3.lineWidth *=
                0x12e >= (49, 12.77e2)
                  ? (0x34, 0x1bb)
                  : (0x1f2, 0xb2) < (109.2e1, 93.8e1)
                  ? (0x6, 2)
                  : (0x1b1, 63.5e1) <= (14.21e2, 147)
                  ? (6.53e2, 22)
                  : (0xb5, 0x117)
            if (
              u4S.p3U(
                s,
                (74.2e1, 113.3e1) > 0x217
                  ? (122, false)
                  : (138, 60) > 0x185
                  ? 'e'
                  : 9.3e2 < (13.28e2, 31.5e1)
                  ? (0x126, 'o')
                  : (1.162e3, 40)
              )
            )
              s =
                (0x27, 0x2f) <= (119.4e1, 14.05e2)
                  ? (3, true)
                  : (0x11d, 0xc3) > 0x15b
                  ? 'M'
                  : (103.0e1, 0x8a) >= 0xd3
                  ? (3.7e1, 0x181)
                  : (0xdf, 9.3e2)
            var defaultPlotField =
              i.subField || I3.defaultPlotField || K0 + X6 + H3 + d0
            if (!F) F = V.yAxis
            var l3 = I3.transformFunc && u4S.n3U(F, I3.panel.yAxis),
              n = u4S.u6U(u3.lineWidth, 2),
              a3 = g ? u4S.R6U(I3.top, n) : I3.bottom + n
            if (i.threshold || u4S.U6U(i.threshold, 0))
              a3 = this.pixelFromPrice(i.threshold, V, F)
            var S6 = !y3 && K && Y && Y.fillMountain,
              x6 = t,
              o3 = t
            for (
              var M3 =
                95 <= (66, 6.1e2)
                  ? (0xb9, 0)
                  : (2.64e2, 126.1e1) <= (120, 8.9e1)
                  ? (0x7f, 0.499)
                  : (10.41e2, 0x20a);
              u4S.t6U(M3, V3.length);
              M3++
            ) {
              var F3 = V3[M3]
              if (F3 && typeof F3 == b + p + L2) {
                if (F3[t] || u4S.I6U(F3[t], 0)) {
                  if (typeof F3[t] == H3 + b1 + p + t6 + R3) {
                    o3 = I.createObjectChainNames(t, [defaultPlotField])[
                      (1.01e2, 101) < (0x14c, 87)
                        ? (0x10d, 105.7e1)
                        : (0x105, 102) < 2.35e2
                        ? (92, 0)
                        : (0x1ca, 35.5e1) < (134.2e1, 28)
                        ? (1.441e3, 'x1')
                        : (3, 61)
                    ]
                  }
                  break
                }
              }
            }
            var G6 = {
                left: null,
                right: null,
              },
              d6 = u4S.V6U(I3.dataSet.length, I3.scroll, 1)
            if (s) {
              if (!i.isComparison) G6.left = this.getPreviousBar(I3, o3, 0)
              G6.right = this.getNextBar(
                I3,
                o3,
                u4S.O6U(
                  V3.length,
                  15 < (5.25e2, 0x1b9) ? (26, 1) : (0x22b, 0x1c5)
                )
              )
            }
            var A3 = 4.73e2 > (25.9e1, 0x17e) ? (1.249e3, true) : (0x4d, 0x39),
              f3 =
                6.17e2 >= (0x18e, 145)
                  ? (24.3e1, false)
                  : (127.1e1, 25.6e1) < (8.2e1, 131)
                  ? 'f'
                  : (54, 61.6e1),
              z3,
              w3
            u3.beginPath()
            var Z3 = G6.left,
              d3 = null
            if (Z3) d3 = Z3.transform
            if (Z3) {
              w3 = l3 ? (d3 ? d3[t] : null) : Z3[t]
              if (
                w3 &&
                (w3[defaultPlotField] ||
                  u4S.W6U(
                    w3[defaultPlotField],
                    (0x4c, 0x32) < (51, 74)
                      ? (79.7e1, 0)
                      : (0x1ad, 10.65e2) <= 42.4e1
                      ? 't'
                      : (58, 124)
                  ))
              )
                w3 = w3[defaultPlotField]
              var N6 = this.pixelFromTick(Z3.tick, I3),
                W6 = q
                  ? u4S.N6U(q.bottom, (w3 - q.min) * q.multiplier)
                  : this.pixelFromTransformedValue(w3, V, F)
              u3.moveTo(N6, W6)
              A.push(N6, W6)
              if (
                u4S.b6U(
                  V3[
                    (30.8e1, 0x1a0) > (0x1a6, 12.1e1)
                      ? (0x14d, 0)
                      : (11.98e2, 14.39e2)
                  ].tick - Z3.tick,
                  0x226 >= (0xf6, 0x0) ? (129, 1) : (52, 0x230)
                )
              ) {
                m.push({
                  start: A.slice(-2),
                  threshold: a3,
                  tick: Z3,
                })
                f3 =
                  (133, 0x24f) > (130.9e1, 148)
                    ? (72.4e1, true)
                    : (78, 0x82) > 0x103
                    ? 'I'
                    : (13.62e2, 0xb7)
              }
              A3 =
                (0xe0, 7.32e2) > (28.3e1, 0x193) ? (1.237e3, false) : (5, 0x6c)
            }
            var P =
                V.left +
                this.micropixels -
                (13.4e2 <= (9.43e2, 13.25e2)
                  ? 95.0e1
                  : 0x237 > (43, 0xa6)
                  ? (101, 1)
                  : (0x119, 6.72e2) > 132.7e1
                  ? 'J'
                  : (40, 0x35)),
              r6,
              a6,
              k3 = this.currentQuote(),
              J3 =
                (48, 1.085e3) < (67, 55)
                  ? 136.2e1
                  : (14.09e2, 84.2e1) < (42, 0x138)
                  ? null
                  : 62.8e1 > (7.8e1, 0xa4)
                  ? (120, 0)
                  : (101, 5),
              P3 =
                (8, 1.343e3) <= (113, 51)
                  ? 1.618
                  : 122 >= (62, 2.94e2)
                  ? (67.3e1, 'i')
                  : (0xde, 144) < (5.81e2, 7.16e2)
                  ? (90, 0)
                  : (70, 0x81),
              c6 = false,
              I6 = {
                reset: true,
              }
            for (
              var j6 =
                49.1e1 < (111, 90)
                  ? 102
                  : 0x18d > (5, 8.55e2)
                  ? (28.9e1, 0x142)
                  : (2, 81) < 0x246
                  ? (111.9e1, 0)
                  : (1.24e2, 0x66);
              u4S.B6U(j6, V3.length);
              j6++
            ) {
              z3 = this.layout.candleWidth
              var y6 = V3[j6],
                b6 = V3[j6]
              if (!y6) y6 = {}
              if (J && y6.projection) {
                G6.right =
                  (36, 0x1ff) > 0x100
                    ? (6.84e2, null)
                    : 7.1e2 <= (135, 0x125)
                    ? (0x211, 139.7e1)
                    : (2.52e2, 134.3e1)
                break
              }
              if (y6.candleWidth) z3 = y6.candleWidth
              if (l3 && y6.transform) y6 = y6.transform
              var A6 = y6[t]
              if (A6 && typeof A6 == H3 + m3 + F0 + p + L2) {
                A6 = A6[defaultPlotField]
                x6 =
                  t +
                  ((135.1e1, 17) >= 0x5c
                    ? 144
                    : (83.5e1, 0x187) < 9.7e2
                    ? (9.0e2, '.')
                    : (18, 16)) +
                  defaultPlotField
              }
              if (
                I3.lineApproximation &&
                u4S.Y6U(
                  this.layout.candleWidth,
                  (0x244, 0x21f) >= 102 ? (148.5e1, 1) : (50, 8)
                )
              ) {
                if (I6.reset) {
                  I6 = {
                    CollatedHigh: -Number.MAX_VALUE,
                    CollatedLow: Number.MAX_VALUE,
                    CollatedOpen: null,
                    CollatedClose: null,
                  }
                  c6 =
                    (23.8e1, 119) <= 0x223
                      ? (6.29e2, false)
                      : (0x236, 67) >= 146
                      ? (127, 0x166)
                      : (0x80, 42)
                }
                var O6 = A6
                if (
                  O6 ||
                  u4S.T6U(O6, 9 < (96, 0x1d4) ? (0x1fa, 0) : (121.2e1, 10))
                ) {
                  I6.CollatedHigh = Math.max(I6.CollatedHigh, O6)
                  I6.CollatedLow = Math.min(I6.CollatedLow, O6)
                  I6.CollatedClose = O6
                  if (
                    u4S.s6U(
                      I6.CollatedOpen,
                      (86, 106.2e1) > (7.29e2, 113.9e1)
                        ? (1.469e3, 'n')
                        : (0x241, 137) > (0x2c, 1.164e3)
                        ? (92, 71)
                        : 7.12e2 < (1.88e2, 72.6e1)
                        ? (120.2e1, null)
                        : (102.7e1, 0x21e)
                    )
                  )
                    I6.CollatedOpen = O6
                  else c6 = (105, 5.64e2) > 0x1a0 ? (56, true) : (26, 88.3e1)
                }
                J3 += z3
                if (
                  u4S.g6U(
                    J3 - P3,
                    (1.284e3, 0x16a) <= 0x182
                      ? (11.11e2, 1)
                      : (127.5e1, 119) >= (5.37e2, 0x7a)
                      ? (0x20e, 'q')
                      : (1.28e2, 99)
                  ) ||
                  u4S.p6U(j6, V3.length - 1)
                ) {
                  P3 = Math.floor(J3)
                  I6.reset =
                    (0x207, 0x117) < 59
                      ? (102, 'y0')
                      : 0x12c >= (118, 0x1e7)
                      ? 0x1c3
                      : 0x58 > (2.41e2, 76)
                      ? (12, true)
                      : (3.3e2, 0x168)
                  I6[t] = I6.CollatedClose
                  y6 = I6
                  y6.cache = {}
                } else {
                  P += z3
                  continue
                }
              }
              if (!N)
                P += u4S.n6U(z3, (19, 7.03e2) > 84 ? (33, 2) : (0x139, 14.44e2))
              if (
                !A6 &&
                u4S.u0U(
                  A6,
                  (0x32, 62) > 118
                    ? 'C'
                    : 110.1e1 >= (87, 111)
                    ? (11.28e2, 0)
                    : (0xe5, 8.72e2)
                )
              ) {
                var s6 = A.slice(
                  -((47, 112) >= (9.07e2, 14.54e2)
                    ? 0x12f
                    : (7, 1.88e2) <= 34
                    ? 79.5e1
                    : 89 < (142, 117.3e1)
                    ? (9.7e1, 2)
                    : (91, 11.31e2))
                )
                if (S6 && !f3 && A.length)
                  A.push(s6[(10.98e2, 25) > 0x1 ? (92, 0) : (0x107, 0xb)], a3)
                if (!f3)
                  m.push({
                    start: s6,
                    threshold: a3,
                    tick: a6,
                  })
                f3 = (8, 0x16d) >= (6.74e2, 68) ? (0x228, true) : (23, 8.98e2)
                P += N ? z3 : u4S.R0U(z3, 2)
                if ((B || N) && A.length)
                  K3[j6] = A.slice(-1)[
                    0x180 <= (78, 1.494e3) ? (2.78e2, 0) : (0x146, 0xa9)
                  ]
                continue
              }
              r6 = y6
              var H6 = y6.cache,
                o6 = d6 + j6
              if (
                u4S.U0U(o6, V.cacheLeft) ||
                u4S.t0U(o6, V.cacheRight) ||
                !H6[t]
              ) {
                if (q) {
                  H6[x6] = u4S.I0U(q.bottom, (A6 - q.min) * q.multiplier)
                } else {
                  H6[x6] = F.semiLog
                    ? this.pixelFromTransformedValue(A6, V, F)
                    : u4S.V0U(F.high - A6, F.multiplier) + F.top
                }
              }
              var E6 = (K3[j6] = H6[x6])
              if (u4S.d0U(b6.tick, k3.tick) && I3.lastTickOffset)
                P += I3.lastTickOffset
              var P6 = A.slice(
                -((10.88e2, 90) < (0x142, 41)
                  ? (93, 325)
                  : 14.25e2 < (6, 137.2e1)
                  ? (0xc0, 325)
                  : 37.1e1 < (0x182, 6.61e2)
                  ? (14.56e2, 2)
                  : (107, 0x1ce))
              )
              if (!A3 && z) {
                if (b6[t] && b6[t][defaultPlotField]) b6 = b6[t]
                var L6 = z(this, b6, f3)
                if (!L6) {
                  P += N
                    ? z3
                    : u4S.F0U(
                        z3,
                        38.2e1 <= (57, 10.54e2) ? (94, 2) : (84.6e1, 93)
                      )
                  continue
                }
                P6 = q3(L6)
              }
              if (!A3 && o && o.length) {
                if (B || N) {
                  if (c6)
                    h3(
                      P,
                      P6[
                        (0x122, 37.2e1) < 105.1e1 ? (1.31e2, 1) : (14, 2.29e2)
                      ],
                      y6,
                      q
                    )
                  else
                    u3.dashedLineTo(
                      P6[
                        (0x1d4, 85) > 124
                          ? 127
                          : 0xd1 <= (12.65e2, 0x113)
                          ? (0xb6, 0)
                          : (0x1ec, 101)
                      ],
                      P6[
                        1.265e3 <= (46, 124.6e1)
                          ? 1.4e3
                          : (0x18e, 0xf7) > (0x63, 0xb3)
                          ? (1.021e3, 1)
                          : (7, 131) >= 0x209
                          ? 2.7e2
                          : (1.38e3, 0x5)
                      ],
                      P,
                      P6[
                        (0x18f, 77.4e1) >= 148
                          ? (0x10a, 1)
                          : (123, 93.6e1) <= (126.5e1, 3.82e2)
                          ? 300
                          : (131.2e1, 0x24a)
                      ],
                      o
                    )
                  if (N) u3.moveTo(P, E6)
                  else if (c6) h3(P, E6, y6, q)
                  else
                    u3.dashedLineTo(
                      P,
                      P6[(93.0e1, 92.3e1) >= 22 ? (0x13d, 1) : (13.98e2, 94)],
                      P,
                      E6,
                      o
                    )
                  A.push(
                    P,
                    P6[
                      0x1af >= (0x4, 101)
                        ? (11.09e2, 1)
                        : 80.4e1 > (81, 137.2e1)
                        ? 'b'
                        : (0x10a, 0xaf)
                    ]
                  )
                } else {
                  if (c6) h3(P, E6, y6, q)
                  else
                    u3.dashedLineTo(
                      P6[
                        5.46e2 > (0xf4, 0x148)
                          ? (0x18a, 0)
                          : (99, 11.4e1) >= (102, 4.58e2)
                          ? (0x4d, 750)
                          : (122, 0x14c) > 35.1e1
                          ? 110
                          : (77, 77)
                      ],
                      P6[
                        (95.8e1, 124) < 36
                          ? 10000
                          : 0x230 < (1.36e2, 125)
                          ? 14.9e1
                          : (0x122, 0x254) > (3.56e2, 0xd4)
                          ? (14.29e2, 1)
                          : (0x15, 142)
                      ],
                      P,
                      E6,
                      o
                    )
                }
              } else {
                if (A3) {
                  u3.moveTo(P, E6)
                  if (y3) {
                    c3.push({
                      coord: [P, E6],
                      color: u3.strokeStyle,
                      pattern: o ? o : [],
                      width: u3.lineWidth,
                    })
                  }
                } else {
                  if (B || N) {
                    var p6 = A.slice(
                      -((0x209, 1.426e3) <= (12.19e2, 0x44)
                        ? 111.1e1
                        : 100.7e1 <= (74, 35)
                        ? (8.8e1, 131)
                        : 5.1e2 >= (0x192, 23.2e1)
                        ? (138, 1)
                        : (0x211, 2.1e2))
                    )[
                      (25.5e1, 0xe6) < 0x1cf
                        ? (4.02e2, 0)
                        : 27 > (0xe7, 120)
                        ? 'A'
                        : (97, 83.5e1)
                    ]
                    if (c6) h3(P, p6, y6, q)
                    else u3.lineTo(P, p6)
                    A.push(P, p6)
                  }
                  if (c6 && !N) h3(P, E6, y6, q)
                  else u3[N ? A0 + i0 + p + v + H3 : v0 + P0 + L](P, E6)
                }
              }
              if (f3) {
                m.push({
                  end: [P, E6],
                  threshold: a3,
                })
                a6 = b6
                if (S6 && !B && !N) A.push(P, a3)
              }
              A.push(P, E6)
              A3 =
                93 < (45, 139)
                  ? (4.26e2, false)
                  : (0xd1, 67.5e1) < 0x11
                  ? 28
                  : (0x21e, 0x23f) >= 11.03e2
                  ? (36, 'O')
                  : (53, 0x17f)
              f3 = false
              P += N
                ? z3
                : u4S.f0U(
                    z3,
                    12.9e2 > (93.9e1, 8.52e2) ? (97, 2) : (115.4e1, 93)
                  )
            }
            var l6 = G6.right,
              X0 =
                41.3e1 < (44, 21.1e1)
                  ? 3
                  : (63, 0x14a) > 107
                  ? (8.23e2, null)
                  : (0x21f, 1.51e2)
            if (l6) X0 = l6.transform
            if (!A3 && l6) {
              w3 = l3
                ? X0
                  ? X0[t]
                  : (106.1e1, 0xa4) > 55
                  ? (90, null)
                  : 78.8e1 <= (0xb6, 25)
                  ? (114, 250)
                  : (13.3e1, 4.21e2)
                : l6[t]
              if (
                w3 &&
                (w3[defaultPlotField] ||
                  u4S.z0U(
                    w3[defaultPlotField],
                    0x11f <= (43.9e1, 0x2e)
                      ? 121
                      : 85 <= (6.68e2, 143)
                      ? (0x23c, 0)
                      : 0x1f2 > (118, 9.86e2)
                      ? (134, 0x80)
                      : (0x108, 52)
                  ))
              )
                w3 = w3[defaultPlotField]
              var Y6 = this.pixelFromTick(l6.tick, I3),
                n6 = q
                  ? u4S.E0U(q.bottom, (w3 - q.min) * q.multiplier)
                  : this.pixelFromTransformedValue(w3, V, F)
              if (
                u4S.o0U(
                  l6.tick -
                    V3[
                      V3.length -
                        ((10.01e2, 79) <= (0x166, 0x209) ? (48, 1) : (54, 0x64))
                    ].tick,
                  (14, 49) >= 5.97e2
                    ? 6
                    : (1.477e3, 5) >= (1.146e3, 0xf2)
                    ? (127, 0x1fa)
                    : (0xda, 2.56e2) >= (0x1fa, 2.32e2)
                    ? (1.099e3, 1)
                    : (0x179, 0x23e)
                )
              ) {
                if (!f3)
                  m.push({
                    start: A.slice(
                      -((8.52e2, 55) <= (38.5e1, 10.3e1)
                        ? (0x195, 2)
                        : (146.2e1, 0xdc))
                    ),
                    threshold: a3,
                    tick: V3[u4S.e0U(V3.length, 1)],
                  })
                f3 =
                  (63, 0x69) <= (138, 81.8e1)
                    ? (4.8e1, true)
                    : (50.3e1, 0x1b3) < (8.66e2, 22)
                    ? 89
                    : (143, 0x5a) <= (1.055e3, 42)
                    ? 0.499
                    : (53, 2.35e2)
              }
              if (!A3 && z) {
                var f0 = z(this, l6, f3)
                if (f0) {
                  var k6 = q3(f0)
                  if (o && o.length) {
                    if (B || N) {
                      u3.dashedLineTo(
                        k6[
                          59 > (131, 9.12e2)
                            ? 98
                            : (0x24, 0) <= (104, 0xb8)
                            ? (7.46e2, 0)
                            : (6, 113)
                        ],
                        k6[
                          8 <= (14.27e2, 105)
                            ? (0x1cb, 1)
                            : (1.22e3, 25.6e1) > (0x20c, 7.73e2)
                            ? 9.31e2
                            : (134.3e1, 0x22d)
                        ],
                        Y6,
                        k6[129 <= (48, 109.1e1) ? (0x1e2, 1) : (0x1e0, 96)],
                        o
                      )
                      if (N) u3.moveTo(Y6, n6)
                      else
                        u3.dashedLineTo(
                          Y6,
                          k6[
                            (0x190, 14.39e2) >= (0x117, 8)
                              ? (137.6e1, 1)
                              : (0x1c9, 5.88e2) > (0x3d, 63.8e1)
                              ? 0x219
                              : (136, 8.55e2)
                          ],
                          Y6,
                          n6,
                          o
                        )
                      A.push(
                        Y6,
                        k6[
                          (0x1f3, 113) < 119
                            ? (0x59, 1)
                            : 7.93e2 <= (113, 43)
                            ? (89, 0.4)
                            : (0x161, 82)
                        ]
                      )
                    } else {
                      u3.dashedLineTo(
                        k6[
                          (0xb7, 1.319e3) > (0x1dd, 0x6e) ? (60, 0) : (0xde, 59)
                        ],
                        k6[
                          (30, 49.4e1) < 61.8e1
                            ? (0x16, 1)
                            : 80.3e1 < (0x31, 28)
                            ? 'f'
                            : (9.77e2, 0x24a)
                        ],
                        Y6,
                        n6,
                        o
                      )
                    }
                  }
                }
              }
              var h0 = A.slice(
                -((1.494e3, 102) < 53
                  ? 'L'
                  : 0x137 <= (140.8e1, 20)
                  ? (52, 0.001)
                  : 0x5e <= (0x82, 115.4e1)
                  ? (148, 2)
                  : (73.9e1, 85))
              )
              if (!o || !o.length) {
                if (B || N) {
                  u3.lineTo(
                    Y6,
                    h0[
                      (0x70, 51.3e1) <= 95.5e1
                        ? (2.56e2, 1)
                        : (47, 17) > 0x1f5
                        ? (89.3e1, 200)
                        : (0x15f, 85)
                    ]
                  )
                  A.push(
                    Y6,
                    h0[
                      (65.8e1, 0x256) <= 143
                        ? 'r'
                        : (0x79, 133) <= 136.8e1
                        ? (107, 1)
                        : (7, 0x71) > 0x175
                        ? (32, 22)
                        : (0x66, 57)
                    ]
                  )
                }
                u3[N ? a + H3 : v0 + P0 + L](Y6, n6)
              }
              if (f3) {
                m.push({
                  end: [Y6, n6],
                  threshold: a3,
                })
                if (S6 && !B && !N) {
                  A.push(Y6, a3)
                }
              }
              A.push(Y6, n6)
            }
            for (var X2 in l) {
              t3.push(X2)
            }
            if (B || N || Y || this.extendLastTick || i.extendToEndOfDataSet) {
              var M0 = A.slice(
                -((1.243e3, 55) >= (24.6e1, 4.9e1)
                  ? (21, 2)
                  : (81, 59) >= (98, 0x1d5)
                  ? (95.0e1, 1000)
                  : (0x1a7, 0x17f))
              )
              if (A.length) {
                var g6 =
                    M0[
                      (0x109, 2.34e2) < (58, 0x6c)
                        ? (2.78e2, 'o')
                        : 40.7e1 < (3.48e2, 99)
                        ? (0x33, 13.62e2)
                        : (20.1e1, 0x37) >= (131, 28)
                        ? (119, 0)
                        : (12.93e2, 0xb7)
                    ],
                  o0 =
                    M0[
                      40 >= (12.14e2, 5.47e2)
                        ? '+'
                        : (7, 54) <= (0x1a5, 120)
                        ? (116.9e1, 1)
                        : (24, 27) >= (78, 0x5c)
                        ? 0xe8
                        : (0x173, 63)
                    ]
                if (B || Y || i.extendToEndOfDataSet) {
                  g6 = this.pixelFromTick(
                    u4S.A0U(
                      I3.dataSet.length,
                      (47.6e1, 100.2e1) > 15 ? (2.99e2, 1) : (33, 94)
                    ),
                    I3
                  )
                  if (N || this.extendLastTick) g6 += u4S.k0U(z3, 2)
                } else if (N) g6 += z3
                else if (this.extendLastTick)
                  g6 += u4S.P0U(
                    z3,
                    0x79 < (143, 1.339e3) ? (84, 2) : (8.5e1, 20.2e1)
                  )
                if (
                  u4S.l0U(
                    g6,
                    M0[
                      (1.58e2, 2.28e2) > 1.494e3
                        ? (80, 98)
                        : (11.13e2, 0x110) > 142
                        ? (79.1e1, 0)
                        : (123, 1.93e2) < 133
                        ? 0.2
                        : (108, 92.4e1)
                    ]
                  )
                ) {
                  var C2 =
                    (4.46e2, 90) > (28, 0x17e)
                      ? 102
                      : (31.3e1, 0x174) < (0x190, 3.36e2)
                      ? 0x1e1
                      : (1.68e2, 37) < (4.66e2, 73.5e1)
                      ? (0xbe, null)
                      : (0x49, 0x10b)
                  if (z)
                    C2 = z(
                      this,
                      {},
                      0xde < (5, 34.6e1) ? (128, true) : (106, 95.9e1)
                    )
                  if (C2) q3(C2)
                  if (o && o.length)
                    u3.dashedLineTo(
                      M0[
                        (13.67e2, 7.63e2) < 0x1cf
                          ? (78, 'u')
                          : (1.72e2, 97) < 3.5e1
                          ? (32.1e1, 0x3d)
                          : (0x14f, 4.29e2) > 0x106
                          ? (105, 0)
                          : (1.02e2, 14.18e2)
                      ],
                      M0[
                        (35.7e1, 48.9e1) < 0x1d9
                          ? (94, 32)
                          : (68, 0x12d) > 45
                          ? (149, 1)
                          : 149 > (128.6e1, 53.4e1)
                          ? 'y'
                          : (103, 1.398e3)
                      ],
                      g6,
                      o0,
                      o
                    )
                  else u3.lineTo(g6, o0)
                  if (!f3 || !S6) A.push(g6, o0)
                }
              }
            }
            if (!K) {
              if (y3 && A.length) {
                u3.beginPath()
                u3.setLineDash(i.pattern || [])
                u3.lineDashOffset =
                  (0x7e, 0x17) < (0x62, 83.8e1)
                    ? (4.68e2, 0)
                    : (0x1d6, 4) >= 40.5e1
                    ? 63
                    : (0x10e, 41.7e1) > 9.64e2
                    ? (0x113, 'b')
                    : (5.49e2, 1.098e3)
                h4.plotSpline(A, y3, u3, c3)
              }
              u3.stroke()
            }
            this.endClip()
            if (!K && i.label && r6) {
              var z2,
                C0 = r6[t]
              if (C0 && typeof C0 == H3 + r + t6 + R3) C0 = C0[defaultPlotField]
              if (F.priceFormatter) {
                z2 = F.priceFormatter(this, V, C0, i.labelDecimalPlaces)
              } else {
                z2 = this.formatYAxisPrice(C0, V, i.labelDecimalPlaces)
              }
              var Z2 = this.yaxisLabelStyle
              if (F.yaxisLabelStyle) Z2 = F.yaxisLabelStyle
              var t4 = u4S.y2U(Z2, Q3 + H3 + H3 + u0) ? u3.strokeStyle : null,
                D4 = u4S.H2U(Z2, Q3 + H3 + H3 + u0)
                  ? e + C + W + C + W
                  : u3.strokeStyle
              this.yAxisLabels.push({
                src: u0 + X6 + h1,
                args: [V, z2, r6.cache[x6], D4, t4],
              })
            }
          }
          if (Y) {
            for (
              gp =
                (0x22, 91.3e1) < 128
                  ? (7, '0')
                  : (0xac, 4.03e2) >= 1.022e3
                  ? 62
                  : 0x12f > (46.5e1, 33)
                  ? (0x1b, 0)
                  : (62.6e1, 0x1aa);
              u4S.c2U(gp, m.length);
              gp += 0x1c6 >= (11.7e1, 0x9c) ? (20, 2) : (65, 3.51e2)
            ) {
              var U2 = m[gp].start,
                r2
              if (gp)
                r2 =
                  m[
                    u4S.a2U(
                      gp,
                      (42, 0x97) <= (3.68e2, 11.84e2)
                        ? (0x15, 1)
                        : (83.8e1, 8.89e2) >= (2.7e1, 13.09e2)
                        ? (0xe4, 122)
                        : (68, 43)
                    )
                  ].end
              if (
                r2 &&
                (u4S.D2U(
                  U2[
                    (0x3e, 98) <= (51.4e1, 13.23e2)
                      ? (0x1cd, 0)
                      : (0x20, 109) < 92
                      ? 87.2e1
                      : (146, 91)
                  ],
                  r2[
                    (0x1f7, 47.2e1) >= (6.64e2, 124)
                      ? (88, 0)
                      : (11.38e2, 0x1f2) <= (43, 98)
                      ? 'x'
                      : (0x184, 4.73e2)
                  ]
                ) &&
                  u4S.Q2U(
                    U2[
                      (0xd6, 116) >= (0x158, 0x67)
                        ? (0x65, 1)
                        : (1.481e3, 3) > 1.039e3
                        ? (0x13e, 0x1da)
                        : (98, 101)
                    ],
                    r2[
                      (0x24b, 87) < (135, 52.3e1)
                        ? (83, 1)
                        : (0x1a0, 84) > (149, 0x13a)
                        ? 61.2e1
                        : (0x84, 126)
                    ]
                  ))
              ) {
                u3.beginPath()
                var L1 = u3.lineWidth
                if (z) {
                  var J0 = z(
                    this,
                    m[gp].tick || {},
                    (126, 0x52) <= (46, 0x226)
                      ? (1.234e3, false)
                      : (0xb1, 0x69) >= 0xae
                      ? (0x9, 135)
                      : (0x115, 1.399e3) <= 101
                      ? 0xab
                      : (44, 0x18d)
                  )
                  if (typeof J0 == H3 + m3 + F0 + p + t6 + R3) {
                    L1 = u4S.i2U(
                      J0.width,
                      i.highlight
                        ? (0x197, 11.86e2) < (63.8e1, 61)
                          ? (0x165, 'I')
                          : (45.8e1, 0x134) >= 38
                          ? (0x173, 2)
                          : (0x9d, 1)
                        : (119, 125) <= (54, 0x23e)
                        ? (0x173, 1)
                        : (1.202e3, 56.9e1)
                    )
                    J0 = J0.color
                  }
                  u3.strokeStyle = u3.fillStyle = J0
                }
                u3.lineWidth = L1
                u3.arc(
                  U2[
                    (42.5e1, 7) < 14.09e2
                      ? (3.22e2, 0)
                      : 0x1fd >= (144, 68.5e1)
                      ? (145, 0.1)
                      : (9.9e2, 9.8e1)
                  ],
                  U2[
                    (37.7e1, 108.5e1) >= 0x125 ? (0x35, 1) : (1.048e3, 39.3e1)
                  ],
                  (56, 134) <= 0x1d5 ? (1.325e3, 1) : (0xb9, 89),
                  0,
                  u4S.M2U(
                    8.16e2 <= (0x21e, 8.57e2) ? (12.3e2, 2) : (2.03e2, 79.3e1),
                    Math.PI
                  )
                )
                u3.stroke()
                u3.fill()
              }
            }
          }
          return {
            colors: t3,
            points: A,
            cache: K3,
            gapAreas: m,
          }
        }
        I.ChartEngine.prototype.drawMountainChart = function(S, H, c) {
          var d = 'ati',
            E = 'esti',
            D = '2d',
            U = this.chart.context,
            w = H,
            j =
              (110, 0x71) >= 79
                ? (96.7e1, false)
                : 98 > (0x153, 107)
                ? (97.5e1, 'J')
                : (16.2e1, 0x79) < 0x64
                ? 100
                : (0x1b0, 6.1e1),
            R =
              (10.61e2, 112) <= (126, 114)
                ? (37.4e1, false)
                : 0x212 < (0x1d8, 4.83e2)
                ? 1.618
                : (0x1a2, 0x3b),
            t =
              (5, 78) <= 0x114
                ? (0x221, null)
                : 144 >= (0x5f, 25.0e1)
                ? (22, 'x')
                : (6.19e2, 4.77e2),
            V =
              (65, 0x245) > (47.1e1, 1.031e3)
                ? 5
                : (108, 0x1bc) > 118
                ? (0x6a, null)
                : (7, 5.32e2),
            i = (75, 0x2e) < (0x65, 0x1cd) ? (0x102, null) : (120, 100),
            z =
              86.1e1 > (0x187, 116)
                ? (1.215e3, null)
                : (5.36e2, 0x12a) >= 0x1d8
                ? (0x1da, 'O')
                : (63.3e1, 104) > (69.7e1, 0x1c2)
                ? 89
                : (13.1e1, 12.85e2),
            W = (0x23f, 0x66) >= 0x3f ? (0x1c8, 0) : (8.96e2, 129),
            C = (0x1d, 0xc2) > 63 ? (137, null) : (6, 53.8e1),
            e =
              (47, 7.67e2) <= 37
                ? (0x17d, 750)
                : (1.88e2, 37) >= (0x1f2, 137)
                ? 1.044e3
                : (62.2e1, 0x1a6) <= (9.48e2, 0x1df)
                ? (1.09e3, false)
                : (74, 8.98e2),
            r =
              (0x1c2, 26.3e1) >= (3.77e2, 0x12)
                ? (50, null)
                : (71, 28) >= 4.14e2
                ? 13.26e2
                : (0x23e, 5.6e2),
            a =
              114 >= (6, 7.92e2)
                ? 0.499
                : (126, 0x4b) <= (134.8e1, 136)
                ? (0x200, null)
                : (5.42e2, 9.9e2) < 3.17e2
                ? (4.68e2, 'r')
                : (0xd7, 0x1b1),
            L =
              138.8e1 > (0x20a, 56)
                ? (0x1ac, false)
                : (0x12d, 29.7e1) < 9.5e1
                ? (145, 100)
                : (35.2e1, 0x1a1),
            v =
              (31.1e1, 0x130) < 141
                ? (4.49e2, 'j')
                : (5, 0xff) >= 23
                ? (130.7e1, null)
                : (0xfc, 149) < 6.3e1
                ? 0.4
                : (20.6e1, 105.3e1),
            b =
              (7.28e2, 1.102e3) >= 93
                ? (38.8e1, null)
                : 4.3e2 < (10.83e2, 0x145)
                ? 'd'
                : (10.2e2, 0x174),
            J = null,
            O =
              1.217e3 < (0x59, 75)
                ? (44, 'h')
                : (84.0e1, 0x7c) < 0x105
                ? (0xf, false)
                : 12.32e2 <= (0x22d, 0x22a)
                ? 'h'
                : (0x1e, 1.124e3),
            N =
              (115, 0x21b) <= 47.5e1
                ? 60000
                : 0x200 >= (0xf7, 58)
                ? (31, false)
                : (0x67, 5.21e2),
            B = S.chart,
            s = B.dataSegment,
            Y = B.lineStyle || {}
          if (!H || typeof H != Z1 + F0 + C1)
            H = {
              style: H,
            }
          w =
            H.style ||
            C3 +
              R3 +
              p2 +
              z6 +
              H3 +
              F6 +
              Q3 +
              R3 +
              N1 +
              f6 +
              t6 +
              B6 +
              i3 +
              U3 +
              R3
          t = H.field || B.defaultPlotField || K0 + X6 + o1 + p
          V = H.subField || B.defaultPlotField || w1 + d0
          C = H.gaps || B.gaplines
          i = H.yAxis || S.yAxis
          j = H.reverse
          z = H.tension
          r = H.fillStyle
          W = H.width || Y.width
          e = H.step
          a = H.pattern || Y.pattern
          L = H.highlight
          b = H.color
          v = H.baseColor
          R = H.colored
          J = H.overlayScaling
          O = H.extendToEndOfDataSet
          N = H.returnObject
          var o = this.canvasStyle(w),
            F = i.top
          if (isNaN(F) || isNaN(u4S.w2U(F, F)))
            F =
              (96, 0x227) < (3, 126)
                ? (0x1f, 140)
                : (7.24e2, 0x115) < (0x78, 42)
                ? (5, 25000)
                : (148, 136) < 0xa3
                ? (11, 0)
                : (0xec, 64)
          var y3 =
              b ||
              (w && o.backgroundColor ? o.backgroundColor : this.defaultColor),
            K = v || (w && o.color ? o.color : this.containerColor)
          if (r) {
            U.fillStyle = r
          } else if (v || o.color) {
            var g = U.createLinearGradient(
              0,
              F,
              (2, 57.0e1) <= (27.0e1, 3.85e2)
                ? (15, 1.618)
                : (2.51e2, 4.4e1) <= (0x69, 0x2a)
                ? 10.28e2
                : 48 <= (31, 0x82)
                ? (0xa1, 0)
                : (2.71e2, 18),
              i.bottom
            )
            g.addColorStop(
              1.377e3 >= (1.87e2, 37)
                ? (0x11c, 0)
                : (0x1c6, 128.7e1) < 78.2e1
                ? (144.0e1, 0xd5)
                : (7.55e2, 0x1b9),
              y3
            )
            g.addColorStop(
              (0x1a3, 107) >= (0x23, 29) ? (0x17d, 1) : (119.1e1, 0x69),
              K
            )
            U.fillStyle = g
          } else {
            U.fillStyle = y3
          }
          this.startClip(S.name)
          var q = U.lineWidth
          if (!H.symbol) V = null
          H = {
            skipProjections: true,
            reverse: j,
            yAxis: i,
            gaps: C,
            step: e,
            highlight: L,
            extendToEndOfDataSet: O,
          }
          if (B.tension) H.tension = B.tension
          if (
            z ||
            u4S.C2U(
              z,
              (11, 27.9e1) >= (0x236, 69)
                ? (119, 0)
                : (1.039e3, 30) > (8.7e1, 122)
                ? (0x1f5, 250)
                : (0x1e8, 140)
            )
          )
            H.tension = z
          var l = parseInt(
              o.paddingTop,
              (0x61, 92) >= (136, 8) ? (0x208, 10) : (122.8e1, 0x5e)
            ),
            A = b || o.borderTopColor,
            c3 = null
          if (R || (A && !I.isTransparent(A))) {
            if (l && !I.isIE8) {
              var m = this.scratchContext
              if (!m) {
                var t3 = U.canvas.cloneNode(
                  (136, 0x22d) <= 10.68e2 ? (7.6e1, true) : (77, 7.4e1)
                )
                m = this.scratchContext = t3.getContext(D)
                m.canvas = t3
              }
              m.canvas.height = U.canvas.height
              m.canvas.width = U.canvas.width
              m.drawImage(
                U.canvas,
                (42, 13.88e2) >= (0x26, 3.3e1)
                  ? (0xfa, 0)
                  : (10.41e2, 0x7) > 9.7e1
                  ? (7.73e2, 102.8e1)
                  : (47.6e1, 46),
                0
              )
              U.clearRect(
                0,
                95 <= (93, 34.2e1)
                  ? (53.0e1, 0)
                  : 106 > (27, 4.83e2)
                  ? (0x3b, 60)
                  : (7.11e2, 9.99e2),
                U.canvas.width,
                U.canvas.height
              )
            }
          }
          I.extend(H, {
            panelName: S.name,
            direction: H.reverse
              ? -((0x6d, 116.1e1) >= (81, 0x52) ? (0x8e, 1) : (0x1b2, 146.9e1))
              : 1,
            band: t,
            subField: V,
            opacity: 1,
            overlayScaling: J,
          })
          I.preparePeakValleyFill(this, H)
          if (R || (A && !I.isTransparent(A))) {
            if (l && !I.isIE8) {
              U.save()
              U.lineWidth += u4S.Z2U(
                (96, 30) < 16.8e1
                  ? (0xf5, 2)
                  : 0x244 > (3.8e1, 1.461e3)
                  ? 1.195e3
                  : (40.6e1, 0x47),
                l
              )
              U.globalCompositeOperation =
                E3 + E + Q3 + i3 + R3 + T1 + Q0 + H3 + F6 + R3
              U.globalAlpha =
                (35, 57) > 77.8e1
                  ? 'A'
                  : (74, 56) < 57
                  ? (0x66, 1)
                  : (0xe3, 0x30) >= (47, 10.46e2)
                  ? 'A'
                  : (1.292e3, 94)
              this.plotDataSegmentAsLine(t, S, H)
              U.globalCompositeOperation =
                E3 + p + V0 + e3 + Q3 + d + H3 + Q3 + Q0 + H3 + D2 + U3
              U.scale(
                u4S.h2U(
                  112 <= (4.63e2, 0x65)
                    ? 2.47e2
                    : (136, 43.6e1) > (0x1f5, 1.184e3)
                    ? (6.93e2, 'y')
                    : (0x1c6, 9.59e2) > 42
                    ? (10, 1)
                    : (13.15e2, 0x14),
                  this.adjustedDisplayPixelRatio
                ),
                u4S.J2U(
                  (59.0e1, 47) >= 132
                    ? 'g'
                    : 0x22 < (49, 144.4e1)
                    ? (87, 1)
                    : (0x1cd, 33.0e1) <= 37
                    ? (3.31e2, 0xc3)
                    : (0x17, 87),
                  this.adjustedDisplayPixelRatio
                )
              )
              U.drawImage(
                this.scratchContext.canvas,
                (28, 120) <= 0xe1 ? (35, 0) : (0x219, 34.7e1),
                0
              )
              U.restore()
            }
          }
          U.strokeStyle = A
          if (W) {
            U.lineWidth = W
          } else if (
            o.width &&
            u4S.v2U(
              parseInt(
                o.width,
                (129.8e1, 34) > (9.1e1, 10.31e2)
                  ? (0x22a, 'ray')
                  : (11.29e2, 0x255) > 113
                  ? (0x7c, 10)
                  : (8.63e2, 0xdf) >= (60, 1.212e3)
                  ? 8.23e2
                  : (103, 131)
              ),
              (19, 0x107) > (73, 42)
                ? (29, 25)
                : (0xc4, 84.1e1) > (9, 1.038e3)
                ? 'd'
                : (0x3e, 111) >= (59, 0x1e4)
                ? 0x1d2
                : (0x194, 0xee)
            )
          ) {
            U.lineWidth = Math.max(
              (50, 7.1e2) >= 0x18d ? (103, 1) : (125.1e1, 4.81e2),
              I.stripPX(o.width)
            )
          } else {
            U.lineWidth =
              (0xa2, 127) > 0x13e
                ? 3.47e2
                : (0x231, 34) < 82
                ? (11.3e1, 1)
                : 92 > (67.5e1, 0x97)
                ? (109, 0x10d)
                : (1.435e3, 94.2e1)
          }
          if (!a) a = o.borderTopStyle
          H.pattern = I.borderPatternToArray(U.lineWidth, a)
          var D3 = c
          if (C)
            D3 = this.getGapColorFunction(
              t,
              V,
              {
                color: A,
                pattern: H.pattern,
                width: U.lineWidth,
              },
              C,
              c
            )
          c3 = this.plotDataSegmentAsLine(t, S, H, D3)
          U.lineWidth = q
          this.endClip()
          if (!c3.colors.length) c3.colors.push(A)
          return N ? c3 : c3.colors
        }
        I.ChartEngine.prototype.drawBaselineChart = function(S, H) {
          var c =
              (5.84e2, 0x18a) <= (110, 0x8b)
                ? (0x193, 69)
                : (77, 109) < 18.7e1
                ? (26, '2')
                : (0x89, 43),
            d = 'dot',
            E = 'line',
            D = 'so',
            U = 'sp',
            w = 'arent',
            j = 'el',
            R = '_up',
            t = 'aseli',
            V = 'dow',
            i = 'e_',
            z = 'up',
            W = 'wn',
            C = '_ba',
            e = 'eli',
            r = 'mou',
            a = S.chart,
            L = a.gaplines,
            v = a.baseline.actualLevel,
            b = [],
            J = H.field || a.defaultPlotField,
            O = a.lineStyle || {}
          if (
            u4S.K2U(
              v,
              (103, 49) > (142.4e1, 141)
                ? 'x'
                : (140, 11.92e2) >= 118
                ? (3.06e2, null)
                : (123, 66.4e1)
            ) &&
            !isNaN(v)
          ) {
            var N = u4S.m2U(H.type, r + Q3 + R3 + N1)
            if (N) {
              b = this.drawMountainChart(S, {
                style: H.style,
                field: H.field,
                yAxis: H.yAxis,
                gaps: H.gaps,
                overlayScaling: H.overlayScaling,
                colored: true,
                tension: 0,
              })
            }
            this.startClip(S.name)
            v = this.pixelFromPrice(v, a.panel)
            var B = H.pattern || O.pattern,
              s =
                H.fill_color_up ||
                this.getCanvasColor(
                  C3 + R3 + V6 + f6 + m3 + i3 + C3 + e + P0 + f6 + F6 + u0
                ),
              Y =
                H.fill_color_down ||
                this.getCanvasColor(
                  C3 + M2 + C + C3 + p + X6 + e3 + Q3 + p + f6 + E3 + H3 + W
                ),
              o =
                H.border_color_up ||
                this.getCanvasColor(
                  V0 + V6 + f6 + m3 + i3 + d0 + v0 + Q3 + p + f6 + z
                ),
              F =
                H.border_color_down ||
                this.getCanvasColor(
                  f2 + f6 + m3 + i3 + d0 + X6 + e3 + Q3 + i + V + Q3
                ),
              y3 =
                H.width ||
                O.width ||
                this.canvasStyle(V0 + V6 + H4 + t + Q3 + p + R).width,
              K =
                H.width ||
                O.width ||
                this.canvasStyle(
                  V0 +
                    V6 +
                    f6 +
                    m3 +
                    i3 +
                    C3 +
                    j +
                    e0 +
                    p +
                    f6 +
                    E3 +
                    H3 +
                    c0 +
                    Q3
                ).width,
              g = {
                over: {
                  fill: s,
                  edge: o,
                  width: y3,
                },
                under: {
                  fill: Y,
                  edge: F,
                  width: K,
                },
              },
              q =
                (0x135, 0x15) > (0x1bf, 97)
                  ? (35, 'y')
                  : (0x1d8, 0xef) > 0x1fa
                  ? 7.6e2
                  : (1.71e2, 0x240) <= 1.377e3
                  ? (2.38e2, false)
                  : (0x8, 101)
            for (var l in g) {
              var A = parseInt(
                Math.max(1, I.stripPX(g[l].width)),
                (131, 37) >= (128, 32) ? (0xb3, 10) : (9, 7.5e1)
              )
              if (H.highlight)
                A *= (121, 0x158) >= (4.96e2, 71) ? (0xe9, 2) : (138, 45)
              B = I.borderPatternToArray(A, B)
              var c3 = {
                panelName: t6 + B6 + i3 + H1,
                band: J,
                threshold: a.baseline.actualLevel,
                color: N ? R3 + U3 + i3 + Q3 + C3 + u0 + w : g[l].fill,
                direction: u4S.q2U(l, v2 + D0)
                  ? (53.0e1, 145) <= (125.4e1, 1.146e3)
                    ? (61.5e1, 1)
                    : (104, 15)
                  : -((0x1f, 20) >= 0x209
                      ? (0x137, 7)
                      : 110.8e1 >= (0x173, 32)
                      ? (1.042e3, 1)
                      : (129, 0xbe)),
                edgeHighlight: g[l].edge,
                edgeParameters: {
                  pattern: B,
                  lineWidth:
                    A +
                    ((8.4e1, 49.2e1) > (36, 0x14b) ? (0x86, 0.1) : (47, 82)),
                  opacity: 1,
                },
                gaps: H.gaps || L,
                yAxis: H.yAxis,
                overlayScaling: H.overlayScaling,
              }
              if (c3.yAxis) {
                c3.threshold = this.priceFromPixel(
                  this.pixelFromPrice(c3.threshold, S),
                  S,
                  c3.yAxis
                )
              }
              b.push(g[l].edge)
              var m = c3.color
              if (!N && m && u4S.S1U(m, R3 + U3 + W1 + U + W2 + p + Q3 + R3)) {
                var t3 = S.top,
                  D3 = S.bottom,
                  I3 = a.context.createLinearGradient(
                    (0xc1, 1.17e3) > (96, 24)
                      ? (145.8e1, 0)
                      : (0xcb, 39) >= 105
                      ? 'H'
                      : (0x162, 63),
                    u4S.x1U(l, H3 + i0 + p + U3) ? t3 : D3,
                    0x1d7 > (114, 0x114) ? (94, 0) : (58.6e1, 49.6e1),
                    v
                  )
                I3.addColorStop(
                  0x80 >= (113, 71) ? (0xe8, 0) : (0x130, 3.4e1),
                  I.hexToRgba(
                    I.colorToHex(m),
                    (0x19a, 0x1dc) > 0xf8
                      ? (105, 60)
                      : (52.2e1, 0x200) < (0x186, 140)
                      ? (1.378e3, 51.8e1)
                      : (0x1c4, 1.363e3)
                  )
                )
                I3.addColorStop(
                  0xbd >= (14, 1.42e3)
                    ? 1.618
                    : (92, 0x76) <= (0x1fa, 1.346e3)
                    ? (0x248, 1)
                    : (40.7e1, 10) > (38, 113.1e1)
                    ? (0x214, 'b')
                    : (0x1d1, 0x8c),
                  I.hexToRgba(I.colorToHex(m), 10)
                )
                c3.color = I3
                c3.opacity = 1
              }
              I.preparePeakValleyFill(this, a.dataSegment, c3)
              if (L) {
                if (!L.fillMountain) {
                  this.drawLineChart(
                    S,
                    (0x171, 0x6b) >= (0x194, 0x9f)
                      ? (0x2f, 8.0e1)
                      : (0xee, 0x165) < (1.175e3, 0x1e1)
                      ? (115, null)
                      : (1.223e3, 31),
                    (3, 2.77e2) > (14.4e1, 130) ? (38, null) : (0x22f, 0x104),
                    {
                      color: R3 + U3 + i3 + e2 + u0 + i3 + u2 + Q3 + R3,
                      gaps: {
                        color: this.containerColor,
                        pattern: D + v0 + E3,
                        width: c3.edgeParameters.lineWidth,
                      },
                    }
                  )
                }
                if (!L.color) {
                  q = 10.46e2 <= (8.1e1, 115.2e1) ? (0x1d7, true) : (88, 2.9e1)
                  L.color = this.defaultColor
                }
              }
              this.drawLineChart(
                S,
                50.4e1 < (0x9b, 44)
                  ? '1.1'
                  : (4.95e2, 35.9e1) <= (149, 0x10a)
                  ? '1.1'
                  : (1.243e3, 28.9e1) > (0xbe, 70)
                  ? (0x238, null)
                  : (1.475e3, 107),
                (59, 0x1fa) < 0x1e9
                  ? 28
                  : (58, 56.5e1) > (0x2f, 0x7e)
                  ? (84, null)
                  : (1.048e3, 0x1d6),
                {
                  color: R3 + U3 + i3 + e2 + u0 + i3 + u2 + J2,
                  width: c3.edgeParameters.lineWidth,
                }
              )
              if (q)
                L.color =
                  (0x1de, 78) < (83, 119)
                    ? (129.6e1, null)
                    : (119, 57) >= 0x176
                    ? 81
                    : (126, 12.84e2)
            }
            this.plotLine(
              0,
              0x1ea >= (120.6e1, 27) ? (43.7e1, 1) : (0x1a1, 0x15),
              v,
              v,
              this.containerColor,
              X6 + e0 + p,
              a.context,
              (0x1da, 22) <= 38
                ? (0x11b, true)
                : (0xf1, 109.3e1) < (84.7e1, 112)
                ? (0x1d4, 'V')
                : (129, 142),
              {
                lineWidth: q0 + o2 + q0,
                color: R3 + U3 + i3 + Q3 + C3 + u0 + i3 + U3 + p + Q3 + R3,
              }
            )
            this.plotLine(
              0,
              (34, 0x22d) < (100.1e1, 8.43e2)
                ? (25.4e1, 1)
                : (0x169, 143.0e1) <= (0x16c, 45)
                ? 'r'
                : (49, 4.77e2),
              v,
              v,
              this.getCanvasColor(V0 + V6 + f6 + m3 + i3 + d0 + E),
              v0 + Q3 + p,
              a.context,
              13.11e2 > (12.5e1, 1.263e3)
                ? (0x159, true)
                : (0xd6, 108) >= (27.1e1, 0x1e6)
                ? (11, 6.2e1)
                : (6.56e2, 14.97e2) < (43, 5.4e1)
                ? (76, 0.0)
                : (48, 0x12d),
              {
                pattern: d + z0 + E3,
                lineWidth: c + o2 + q0,
                opacity: 0.5,
              }
            )
            if (
              u4S.X1U(
                this.getSeriesRenderer(H.name),
                this.mainSeriesRenderer
              ) &&
              u4S.r1U(
                a.baseline.userLevel,
                (0x185, 0x22a) > (10.92e2, 23) ? (0x21d, false) : (76, 9.6e1)
              )
            ) {
              this.controls.baselineHandle.style.top = u4S.G1U(
                v,
                parseInt(
                  getComputedStyle(this.controls.baselineHandle).height,
                  0x3c < (92.5e1, 99) ? (93, 10) : (0x9, 0x37)
                ) /
                  ((0x18b, 99.1e1) <= (0x19c, 0x101)
                    ? (0x12a, 'pan')
                    : (133, 88) >= (42, 47)
                    ? (1.458e3, 2)
                    : (0x2, 131)),
                u0 + V6
              )
              this.controls.baselineHandle.style.left = u4S.Q1U(
                a.right,
                parseInt(
                  getComputedStyle(this.controls.baselineHandle).width,
                  10
                ),
                u0 + V6
              )
              this.controls.baselineHandle.style.display = m3 + A2 + n2
            }
            this.endClip()
          }
          return {
            colors: b,
          }
        }
        I.ChartEngine.prototype.mousemoveinner = function(H, c) {
          var d = 'emo',
            E = 'px',
            D = 'yo',
            U = 'om',
            w = 'ner'
          if (!this.chart.canvas) return
          if (!I.isAndroid && !I.isIOS7or8) {
            if (
              u4S.d1U(
                this.chart.canvas.height,
                Math.floor(
                  this.devicePixelRatio * this.chart.container.clientHeight
                )
              ) ||
              u4S.F1U(
                this.chart.canvas.width,
                Math.floor(
                  this.devicePixelRatio * this.chart.container.clientWidth
                )
              )
            ) {
              this.resizeChart()
              return
            }
          }
          var j
          if (
            this.runPrepend(
              z6 + M1 + d0 + z6 + H3 + i0 + p + e3 + Q3 + w,
              arguments
            )
          )
            return
          var R = this.container.getBoundingClientRect()
          this.top = R.top
          this.left = R.left
          this.right = this.left + this.width
          this.bottom = this.top + this.height
          this.cancelLongHold =
            112 <= (0x1c, 52)
              ? (2.67e2, '/')
              : 115 < (0x105, 34.1e1)
              ? (59.0e1, true)
              : 130 <= (6.44e2, 21)
              ? (5.46e2, 1.375e3)
              : (0x130, 5.28e2)
          this.hasDragged =
            (5.08e2, 78) < 39
              ? (142, 14.97e2)
              : (1.082e3, 97.4e1) > (0x83, 108.9e1)
              ? 'p'
              : (71.8e1, 2.52e2) >= 0x3b
              ? (83, true)
              : (0x52, 0x74)
          I.ChartEngine.crosshairX = H
          I.ChartEngine.crosshairY = c
          var t = (this.cy = this.crossYActualPos = this.backOutY(
              I.ChartEngine.crosshairY
            )),
            V = (this.cx = this.backOutX(I.ChartEngine.crosshairX))
          this.currentPanel = this.whichPanel(t)
          if (!this.currentPanel) this.currentPanel = this.chart.panel
          if (!this.currentPanel) return
          var i = this.currentPanel.chart
          if (i.dataSet) {
            this.crosshairTick = this.tickFromPixel(V, i)
            j = this.valueFromPixel(t, this.currentPanel)
            this.crosshairValue = this.adjustIfNecessary(
              this.currentPanel,
              this.crosshairTick,
              j
            )
            var z = u4S.f1U(this.currentPanel.name, t6 + B6 + i3 + H1)
              ? this.preferences.horizontalCrosshairField
              : this.currentPanel.horizontalCrosshairField
            if (
              z &&
              u4S.z1U(this.crosshairTick, i.dataSet.length) &&
              this.crosshairTick >
                -((39, 52.0e1) <= 47
                  ? (0x1e5, 'Z')
                  : (2.75e2, 0xdf) >= 0x128
                  ? (10.52e2, 'Z')
                  : (48, 145) >= (0xa8, 69)
                  ? (0x1ba, 1)
                  : (19.5e1, 122.4e1))
            ) {
              j = i.dataSet[this.crosshairTick][z]
              this.crossYActualPos = this.pixelFromPrice(j, this.currentPanel)
            }
          }
          if (
            u4S.E1U(I.ChartEngine.crosshairX, this.left) &&
            u4S.o1U(I.ChartEngine.crosshairX, this.right) &&
            u4S.e1U(I.ChartEngine.crosshairY, this.top) &&
            u4S.A1U(I.ChartEngine.crosshairY, this.bottom)
          ) {
            I.ChartEngine.insideChart = true
          } else {
            I.ChartEngine.insideChart =
              81 > (0x140, 74.8e1)
                ? 'N'
                : (6.21e2, 0xda) >= 131
                ? (75.3e1, false)
                : (0x173, 1.85e2)
          }
          var W = u4S.k1U(this.xAxisAsFooter, true)
            ? this.chart.canvasHeight
            : this.chart.panel.bottom
          this.overXAxis =
            I.ChartEngine.insideChart &&
            u4S.P1U(I.ChartEngine.crosshairY, W + this.top) &&
            u4S.l1U(I.ChartEngine.crosshairY, W - this.xaxisHeight + this.top)
          this.overYAxis =
            (u4S.y4U(this.cx, this.currentPanel.right) ||
              u4S.H4U(this.cx, this.currentPanel.left)) &&
            I.ChartEngine.insideChart
          if (
            this.overXAxis ||
            this.overYAxis ||
            (!I.ChartEngine.insideChart && !this.grabbingScreen)
          ) {
            this.undisplayCrosshairs()
            if (!this.overXAxis && !this.overYAxis) return
          }
          if (!this.displayCrosshairs && !I.ChartEngine.resizingPanel) {
            this.undisplayCrosshairs()
            return
          }
          if (this.repositioningBaseline) {
            K = this.panels[this.chart.panel.name]
            this.chart.baseline.userLevel = this.adjustIfNecessary(
              K,
              this.crosshairTick,
              this.valueFromPixel(this.backOutY(I.ChartEngine.crosshairY), K)
            )
            if (
              u4S.c4U(
                Date.now() - this.repositioningBaseline.lastDraw,
                (56, 144) > 76.6e1
                  ? (26.1e1, 'x')
                  : 71 < (0x125, 77)
                  ? (115, 100)
                  : (0xef, 0xef)
              )
            ) {
              this.draw()
              this.repositioningBaseline.lastDraw = Date.now()
            }
            return
          }
          if (this.grabbingScreen && !I.ChartEngine.resizingPanel) {
            if (this.anyHighlighted) {
              I.clearCanvas(this.chart.tempCanvas, this)
              this.anyHighlighted =
                139.7e1 < (0x58, 43)
                  ? 'T'
                  : (5.83e2, 27) >= 2
                  ? (4.52e2, false)
                  : (7.38e2, 121) > 9.56e2
                  ? 0.8
                  : (29.9e1, 62.7e1)
              var C
              for (C in this.overlays) {
                this.overlays[C].highlight =
                  115 > (81, 129)
                    ? (0x209, 'v')
                    : (21, 13.54e2) > 60
                    ? (12, false)
                    : (92, 13.22e2) < 0x1b8
                    ? (0x221, 0.8)
                    : (0x34, 1.269e3)
              }
              for (C in i.series) {
                i.series[C].highlight =
                  (2.55e2, 1.78e2) > 7.3e1 ? (12, false) : (0x14f, 0x1a0)
              }
              this.displaySticky()
            }
            if (
              this.preferences.magnet &&
              this.currentVectorParameters.vectorType
            ) {
              I.clearCanvas(this.chart.tempCanvas, this)
            }
            if (
              this.grabStartX ==
              -((73.7e1, 36) < 71.4e1 ? (13, 1) : (0x120, 136))
            ) {
              this.grabStartX = I.ChartEngine.crosshairX
              this.grabStartScrollX = i.scroll
            }
            if (
              this.grabStartY ==
              -(0x82 > (17, 98)
                ? (0x136, 1)
                : (4.72e2, 10.77e2) < 0x1a6
                ? (56, 108)
                : (87.5e1, 28))
            ) {
              this.grabStartY = I.ChartEngine.crosshairY
              this.grabStartScrollY = this.currentPanel.yAxis.scroll
            }
            var e = u4S.a4U(I.ChartEngine.crosshairX, this.grabStartX),
              r = u4S.D4U(I.ChartEngine.crosshairY, this.grabStartY)
            if (
              u4S.Q4U(
                e,
                (13.24e2, 0x246) >= (37, 134)
                  ? (80, 0)
                  : (104, 24.3e1) >= 7.29e2
                  ? (0x35, 9.7e2)
                  : (0x40, 17)
              ) &&
              u4S.i4U(r, 0)
            )
              return
            if (
              u4S.M4U(
                Math.abs(e) + Math.abs(r),
                (0x22b, 33) >= 0x25
                  ? (0xc5, 'a')
                  : (0xa, 0x11c) > (13.9e2, 93)
                  ? (39.7e1, 5)
                  : 0x71 <= (32.6e1, 0x29)
                  ? (1.41e3, 98)
                  : (0x9, 36)
              )
            )
              this.grabOverrideClick =
                (0x78, 24) < (8.5e1, 114.8e1)
                  ? (0xd, true)
                  : (0x1f3, 0x193) >= 1.142e3
                  ? 'k'
                  : 0x1c7 > (1.412e3, 12.5e2)
                  ? 75
                  : (0x150, 0xf4)
            var a,
              L = this.layout.candleWidth
            if (
              this.allowZoom &&
              u4S.w4U(this.grabMode, O1 + Q3) &&
              (u4S.C4U(
                this.grabMode.indexOf(I0 + H3 + H3 + z6),
                (0x108, 100) <= (0x150, 59)
                  ? 7.22e2
                  : (1.212e3, 0x95) > 0x69
                  ? (3.75e2, 0)
                  : (77, 10.39e2) < (0x173, 11.4e1)
                  ? (26, 'R')
                  : (7, 2.4e1)
              ) ||
                this.overXAxis ||
                this.overYAxis)
            ) {
              if (u4S.Z4U(this.grabMode, '')) {
                if (this.overXAxis) this.grabMode = I0 + H3 + H3 + z6 + Q0 + V6
                else if (this.overYAxis) this.grabMode = I0 + H3 + U + Q0 + e6
              }
              if (u4S.h4U(this.grabMode, I0 + H3 + U + Q0 + V6))
                r =
                  37.7e1 <= (107, 0x213)
                    ? (37, 0)
                    : 0x3d > (112, 4.12e2)
                    ? 'z'
                    : (10.32e2, 3.82e2)
              else if (u4S.J4U(this.grabMode, I0 + H3 + H3 + z6 + Q0 + e6))
                e = (4.7e2, 99) <= (6.12e2, 0xa4) ? (127, 0) : (0x164, 0x248)
              a = u4S.v4U(
                e,
                (4.0e1, 0x114) >= (147, 2) ? (9.19e2, 25) : (0x173, 77.5e1)
              )
              var v =
                (119, 109) <= 77.7e1
                  ? (99, true)
                  : (120, 7.1e1) < 35
                  ? 11
                  : (86, 122)
              if (u4S.K4U(i.scroll, i.maxTicks))
                v =
                  1.45e3 <= (5.39e2, 6.0e2)
                    ? 0.001
                    : 127 < (43, 0x199)
                    ? (12.91e2, false)
                    : (117, 133)
              var b = u4S.m4U(this.grabStartCandleWidth, a)
              if (u4S.q4U(b, this.minimumCandleWidth))
                b = this.minimumCandleWidth
              var J = u4S.S5U(L - b, L)
              if (
                u4S.x5U(
                  J,
                  (9.94e2, 5.2e1) < (0x1db, 104) ? (0x1d4, 0.1) : (0x61, 0x1b)
                )
              ) {
                b = u4S.X5U(
                  L,
                  (0x119, 14.31e2) > 1.47e2 ? (0x49, 0.9) : (59.1e1, 74)
                )
              } else if (
                J <
                -(0 >= (122, 4.06e2)
                  ? 'n'
                  : (0x1, 0x2c) < (139, 38.0e1)
                  ? (5.2e2, 0.1)
                  : (50, 65.7e1))
              ) {
                b = u4S.r5U(L, 0xb2 < (0xcb, 28.3e1) ? (0x244, 1.1) : (78, 10))
              }
              if (a) {
                if (I.ipad) {
                  if (
                    u4S.G5U(
                      Math.round(
                        this.chart.width / L -
                          (0x33 < (33, 0x152) ? (9.12e2, 0.499) : (111, 1.31e3))
                      ) -
                        (6.64e2 < (0x237, 0xec)
                          ? (1.045e3, 'o')
                          : 0x237 >= (47.8e1, 111)
                          ? (4.07e2, 1)
                          : (50, 0x145)),
                      I.ChartEngine.ipadMaxTicks
                    ) &&
                    u4S.L5U(
                      Math.round(this.chart.width / b - 0.499) -
                        ((38.8e1, 51.9e1) > 104
                          ? (35.4e1, 1)
                          : (2.68e2, 23.8e1)),
                      I.ChartEngine.ipadMaxTicks
                    )
                  )
                    return
                }
                var O
                if (this.pinchingCenter) {
                  var N = this.backOutX(this.pinchingCenter),
                    B = this.tickFromPixel(N, i)
                  this.setCandleWidth(b, i)
                  var s = this.tickFromPixel(N, i)
                  i.scroll += Math.floor(u4S.j5U(s, B))
                } else if (v) {
                  O = Math.round(u4S.O5U(this.chart.width, b) + 1)
                  if (u4S.W5U(O, i.maxTicks)) {
                    i.scroll += Math.round(
                      u4S.N5U(
                        O - i.maxTicks,
                        (1.27e2, 1.071e3) <= 111
                          ? (8.16e2, 'e')
                          : 0x117 > (0xb6, 147)
                          ? (51, 2)
                          : (132.4e1, 11.72e2)
                      )
                    )
                    this.setCandleWidth(b, i)
                  }
                } else {
                  O = Math.round(
                    u4S.b5U(this.chart.width, b) +
                      (0x180 >= (14.87e2, 94) ? (1.08e2, 1) : (0x1eb, 0x62))
                  )
                  if (
                    u4S.B5U(
                      O,
                      Math.round(
                        this.chart.width / L +
                          (78 <= (0x2a, 56.9e1) ? (11.33e2, 1) : (46, 0xd9))
                      )
                    )
                  ) {
                    var Y = Math.round(u4S.Y5U(this.preferences.whitespace, b))
                    i.scroll = u4S.T5U(i.maxTicks, Y)
                    this.setCandleWidth(b, i)
                  }
                }
              }
              if (this.layout.setSpan) {
                this.layout.setSpan =
                  (122, 10.78e2) > 131
                    ? (0x159, null)
                    : 1.338e3 < (0x1ff, 0x112)
                    ? (79.8e1, 123)
                    : (4.26e2, 0x1da)
                this.changeOccurred(X6 + i3 + D + F6 + R3)
              }
              var o = this.grabStartYAxis
              if (o) {
                o.zoom = Math.round(this.grabStartZoom + r)
                if (u4S.s5U(this.grabStartZoom, o.height)) {
                  if (u4S.g5U(o.zoom, o.height)) o.zoom = u4S.p5U(o.height, 1)
                } else {
                  if (u4S.n5U(o.zoom, o.height))
                    o.zoom =
                      o.height +
                      (2 >= (12, 53.2e1)
                        ? (1.6e2, ',')
                        : (0x18b, 11.3e1) < (8.2e1, 29)
                        ? (44.3e1, 'n')
                        : 0xd3 <= (11.63e2, 0x125)
                        ? (53, 1)
                        : (0xe1, 7.7e1))
                }
              }
            } else {
              if (this.allowScroll) {
                if (u4S.u9U(Math.abs(r), this.yTolerance)) {
                  if (!this.yToleranceBroken) {
                    r =
                      (21, 0x21d) <= 96
                        ? (0x20a, 'u')
                        : 1.161e3 <= (71.9e1, 53)
                        ? 0x3d
                        : 2 < (112, 93)
                        ? (2.3e2, 0)
                        : (0x14d, 108)
                    if (u4S.R9U(e, 0)) return
                  }
                } else {
                  this.yToleranceBroken =
                    (13.42e2, 52) <= 0x86 ? (0x1fe, true) : (116, 7.84e2)
                }
                if (!this.grabStartMicropixels) {
                  this.grabStartMicropixels =
                    (0x142, 0x202) > (89, 56)
                      ? (5.8e2, 0)
                      : (0x14a, 29) > (86, 0xc7)
                      ? 61.0e1
                      : (0x46, 0x97) <= (128, 80)
                      ? 't'
                      : (0x7f, 35)
                }
                this.grabMode = u0 + W1
                i.scroll = this.grabStartScrollX
                this.micropixels =
                  this.grabStartMicropixels +
                  u4S.U9U(
                    e,
                    this.shift
                      ? 2.42e2 <= (102, 90.2e1)
                        ? (15, 5)
                        : (12.88e2, 0x215)
                      : 0x160 <= (53, 0x22d)
                      ? (0x246, 1)
                      : (59.0e1, 0x54)
                  )
                while (
                  u4S.t9U(
                    this.micropixels,
                    (65, 3.97e2) >= 5.4e2
                      ? 0xb5
                      : (0x147, 27) <= (4.47e2, 0x79)
                      ? (0xec, 0)
                      : (0x1de, 0x61)
                  )
                ) {
                  this.micropixels -= L
                  i.scroll++
                }
                while (this.micropixels < -L) {
                  this.micropixels += L
                  i.scroll--
                }
                if (u4S.I9U(i.scroll, 1)) {
                  this.micropixels =
                    (9.4e1, 132.2e1) <= 0x174
                      ? 0x238
                      : (0xeb, 0) >= 11.62e2
                      ? (123, 0x4e)
                      : (56, 0xdc) <= (8.2e1, 0x24f)
                      ? (98, 0)
                      : (0x1cf, 0x12c)
                  i.scroll =
                    (0x4, 31) <= (50, 1.358e3)
                      ? (0xb6, 1)
                      : (0x9e, 0xd7) >= (88, 29.2e1)
                      ? 10
                      : (0x232, 46)
                }
                if (u4S.V9U(i.scroll, i.maxTicks)) {
                  this.preferences.whitespace = this.initialWhitespace
                } else {
                  this.preferences.whitespace = u4S.d9U(
                    i.maxTicks - i.scroll,
                    L
                  )
                }
                if (u4S.F9U(this.currentPanel, this.grabStartPanel)) {
                  this.currentPanel.yAxis.scroll = this.grabStartScrollY + r
                }
              }
              this.dispatch(z6 + H3 + i0 + p, {
                stx: this,
                panel: this.currentPanel,
                x: this.cx,
                y: this.cy,
                grab: this.grabbingScreen,
              })
            }
            var F = function(S) {
              return function() {
                S.draw()
                S.updateChartAccessories()
              }
            }
            if (I.ChartEngine.useAnimation) {
              window.requestAnimationFrame(F(this))
            } else {
              this.draw()
              this.updateChartAccessories()
            }
            if (this.activeDrawing) {
              I.clearCanvas(this.chart.tempCanvas, this)
              this.activeDrawing.render(this.chart.tempCanvas.context)
              this.activeDrawing.measure()
            }
            this.undisplayCrosshairs()
            return
          }
          this.grabMode = ''
          if (this.overXAxis || this.overYAxis) {
            this.updateChartAccessories()
            return
          }
          this.controls.crossX.style.left =
            u4S.f9U(
              this.pixelFromTick(this.crosshairTick, i),
              (2.6e1, 12) >= (0x18, 11)
                ? (0x1a9, 0.5)
                : (0x18e, 0x1f7) < 1.86e2
                ? 'r'
                : (51.1e1, 80) >= 144
                ? (0x1ef, 200)
                : (0x57, 94.7e1)
            ) + E
          this.controls.crossY.style.top = this.crossYActualPos + E
          this.setCrosshairColors()
          if (I.ChartEngine.insideChart && !I.ChartEngine.resizingPanel) {
            var y3 = this.currentVectorParameters.vectorType
            if (
              !I.Drawing ||
              !y3 ||
              !I.Drawing[y3] ||
              !new I.Drawing[y3]().dragToDraw
            ) {
              this.doDisplayCrosshairs()
            }
            this.updateChartAccessories()
          } else {
            this.undisplayCrosshairs()
          }
          var K
          if (this.repositioningDrawing) {
            this.repositionDrawing(this.repositioningDrawing)
          } else if (I.ChartEngine.drawingLine) {
            if (this.activeDrawing) {
              K = this.panels[this.activeDrawing.panelName]
              j = this.adjustIfNecessary(
                K,
                this.crosshairTick,
                this.valueFromPixel(this.backOutY(I.ChartEngine.crosshairY), K)
              )
              if (
                this.preferences.magnet &&
                this.magnetizedPrice &&
                u4S.z9U(K.name, K.chart.name)
              ) {
                j = this.adjustIfNecessary(
                  K,
                  this.crosshairTick,
                  this.magnetizedPrice
                )
              }
              I.clearCanvas(this.chart.tempCanvas, this)
              this.activeDrawing.move(
                this.chart.tempCanvas.context,
                this.crosshairTick,
                j
              )
              if (this.activeDrawing.measure) this.activeDrawing.measure()
            }
          } else if (I.ChartEngine.resizingPanel) {
            this.resizePanels()
          }
          if (I.ChartEngine.insideChart) {
            this.dispatch(A0 + i0 + p, {
              stx: this,
              panel: this.currentPanel,
              x: this.cx,
              y: this.cy,
              grab: this.grabbingScreen,
            })
            this.findHighlights()
          }
          if (
            this.preferences.magnet &&
            this.currentVectorParameters.vectorType
          ) {
            if (!I.ChartEngine.drawingLine && !this.anyHighlighted)
              I.clearCanvas(this.chart.tempCanvas)
            this.magnetize()
          }
          this.runAppend(A0 + F6 + C3 + d + D2 + e3 + Q3 + P0 + U3, arguments)
        }
        I.ChartEngine.prototype.plotLine = function(S, H, c, d, E, D, U, w, j) {
          var R = 'zi',
            t = 'jec',
            V = 'ori'
          if (!j) j = {}
          if (u4S.E9U(j.pattern, Q3 + l1 + p)) return
          if (
            u4S.o9U(
              w,
              (25, 43) > (69, 6)
                ? (4.35e2, true)
                : (0x158, 108) > 0x248
                ? 0x192
                : 112 <= (11.63e2, 92)
                ? 1.618
                : (111, 72)
            )
          )
            w = this.chart.panel
          if (
            u4S.e9U(
              U,
              (0x1c, 0x98) < (19.5e1, 43)
                ? (0x1eb, 'z')
                : 113 <= (6.5e2, 0x24e)
                ? (1.204e3, null)
                : (3.5e2, 40)
            ) ||
            typeof U == F6 + Q3 + E3 + p + t0 + e3 + Q3 + p + E3
          )
            U = this.chart.context
          if (isNaN(S) || isNaN(H) || isNaN(c) || isNaN(d)) {
            return
          }
          var i = (3.0e1, 131) <= 36.1e1 ? (142, 0) : (73, 8.0e1),
            z = this.chart.canvasHeight,
            W =
              (22.8e1, 16.7e1) > 128
                ? (15.2e1, 0)
                : (143.4e1, 0x22b) <= (146.1e1, 0x139)
                ? (8.24e2, 94.5e1)
                : (1.285e3, 0x1ac) > 107.0e1
                ? '0'
                : (0x6a, 13.0e1),
            C = this.right
          if (w) {
            z = w.yAxis.bottom
            i = w.yAxis.top
            W = w.left
            C = w.right
          }
          var e, r, a
          if (u4S.A9U(D, U3 + i3 + e6)) {
            e = 10000000
            if (u4S.k9U(H, S)) e = -10000000
            a = {
              x0: S,
              x1: H,
              y0: c,
              y1: d,
            }
            r = I.yIntersection(a, e)
            H = e
            d = r
          }
          if (
            u4S.P9U(D, X6 + e0 + p) ||
            u4S.l9U(D, B6 + V + I0 + H3 + J2 + i3 + X6) ||
            u4S.y8U(D, D2 + U3 + R3 + e3 + t6 + i3 + X6)
          ) {
            e = 10000000
            var L = -(0x24c <= (1.069e3, 108.6e1)
              ? (13.92e2, 10000000)
              : (59, 136) > (0x171, 5.42e2)
              ? (43, '')
              : (0x229, 0x82))
            a = {
              x0: S,
              x1: H,
              y0: c,
              y1: d,
            }
            r = I.yIntersection(a, e)
            var v = I.yIntersection(a, L)
            S = L
            H = e
            c = v
            d = r
          }
          var b = 0x28 < (143, 1.377e3) ? (142, 0.0) : (131.8e1, 117),
            J = 1.0,
            O = u4S.H8U(H, S),
            N = u4S.c8U(d, c),
            B,
            s,
            Y
          for (
            var o =
              (13.67e2, 124) < 115
                ? 0x5c
                : (9, 0xd) < 0x1c8
                ? (5.09e2, 0)
                : (57.1e1, 10.75e2);
            u4S.a8U(
              o,
              (7.23e2, 0x217) >= 0xdc
                ? (105, 4)
                : 109 > (1.086e3, 0x245)
                ? 'F'
                : (0xa4, 143.6e1) < (132.5e1, 1)
                ? 'F'
                : (32.1e1, 103.2e1)
            );
            o++
          ) {
            if (u4S.D8U(o, 0)) {
              B = -O
              s = -u4S.Q8U(W, S)
            }
            if (u4S.i8U(o, 1)) {
              B = O
              s = u4S.M8U(C, S)
            }
            if (
              u4S.w8U(
                o,
                (64, 85.6e1) >= (0xad, 7.15e2) ? (36, 2) : (1.74e2, 76)
              )
            ) {
              B = -N
              s = -u4S.C8U(i, c)
            }
            if (u4S.Z8U(o, (28, 1.453e3) >= 107 ? (0x1f9, 3) : (146, 43))) {
              B = N
              s = u4S.h8U(z, c)
            }
            Y = u4S.J8U(s, B)
            if (
              (d ||
                u4S.v8U(
                  d,
                  (60, 6.01e2) < (49, 0xf)
                    ? (8.6e1, 60)
                    : 6.05e2 >= (0x20a, 109)
                    ? (130, 0)
                    : (0x227, 9.2e1)
                )) &&
              u4S.K8U(B, (100, 4.71e2) > (87, 117) ? (45, 0) : (70, 12.65e2)) &&
              u4S.m8U(s, 0x10d > (99.6e1, 33) ? (1.06e2, 0) : (1.303e3, 0x18d))
            ) {
              return (112, 0xa0) >= 0xe7
                ? 133.8e1
                : (0x54, 23) <= 0x239
                ? (0x10e, false)
                : (30, 0x133)
            }
            if (
              u4S.q8U(
                B,
                (14, 0x9a) <= 6.7e1
                  ? 'q'
                  : (104, 1.35e2) > 3.09e2
                  ? 'q'
                  : (22.6e1, 85) <= 4.09e2
                  ? (0xc1, 0)
                  : (0x245, 46)
              )
            ) {
              if (u4S.S7U(Y, J))
                return (3.5e1, 13) >= 4 ? (0x2a, false) : (0x140, 0xa3)
              else if (u4S.x7U(Y, b)) b = Y
            } else if (
              u4S.X7U(
                B,
                (133, 132) < (32.0e1, 52.9e1) ? (11.72e2, 0) : (67, 35.7e1)
              )
            ) {
              if (u4S.r7U(Y, b))
                return (37, 10.38e2) > (1.346e3, 1.53e2)
                  ? (145, false)
                  : (0xd, 139)
              else if (u4S.G7U(Y, J)) J = Y
            }
          }
          var F = S + u4S.L7U(b, O),
            y3 = c + u4S.j7U(b, N),
            K = S + u4S.O7U(J, O),
            g = c + u4S.W7U(J, N)
          if (
            !d &&
            u4S.N7U(
              d,
              (0x59, 139) > 22
                ? (143, 0)
                : (6.26e2, 1.2e2) <= (0x7c, 99)
                ? 4.5e1
                : (147.2e1, 1.213e3)
            ) &&
            !c &&
            u4S.b7U(
              c,
              (0x1a7, 35.7e1) > (1.401e3, 1.412e3)
                ? 125
                : 0x14d < (0x4f, 45)
                ? (80, 'day')
                : (0x1d6, 14.83e2) > (83, 101)
                ? (9.9e2, 0)
                : (98, 8)
            )
          ) {
            y3 = i
            g = z
            F = a.x0
            K = a.x0
            if (u4S.B7U(a.x0, C))
              return (136, 132) >= 10
                ? (56.0e1, false)
                : (97, 0x7) > (33.3e1, 37)
                ? 146
                : 74.4e1 <= (15.8e1, 84)
                ? (29, 0x103)
                : (0x7b, 26)
            if (u4S.Y7U(a.x0, W))
              return 95.8e1 > (76, 64) ? (124.1e1, false) : (93, 9.21e2)
          } else if (
            !d &&
            u4S.T7U(d, (58, 34.8e1) >= 55 ? (6.8e1, 0) : (104, 0x41))
          ) {
            if (u4S.s7U(a.y0, a.y1)) g = z
            else g = i
            F = a.x0
            K = a.x0
            if (u4S.g7U(a.x0, C))
              return (0x221, 18) < 0x1cc
                ? (99.1e1, false)
                : (6.8e1, 0x21c) < 0x1b4
                ? 12
                : 9.81e2 <= (40, 18)
                ? (0x1b7, 12)
                : (0x241, 62.7e1)
            if (u4S.p7U(a.x0, W)) return false
          }
          U.lineWidth = 82 <= (139, 99) ? (115, 1.1) : (0x22a, 10.46e2)
          if (typeof E == H3 + m3 + t + R3) {
            U.strokeStyle = E.color
            if (E.opacity) U.globalAlpha = E.opacity
            else
              U.globalAlpha =
                (5.5e1, 127) < 96
                  ? 0.499
                  : (11.26e2, 26) < 32
                  ? (7.35e2, 1)
                  : (65, 72)
            U.lineWidth = parseInt(
              I.stripPX(E.width),
              (0x202, 111) < (0x1a6, 0x63)
                ? 'bar'
                : (5.85e2, 6) <= 77
                ? (0xa0, 10)
                : (5.9e2, 100)
            )
          } else {
            if (!E || u4S.n7U(E, i3 + F6 + h2) || I.isTransparent(E)) {
              U.strokeStyle = this.defaultColor
            } else {
              U.strokeStyle = E
            }
          }
          if (j.opacity) U.globalAlpha = j.opacity
          if (j.lineWidth) U.lineWidth = j.lineWidth
          if (u4S.u3T(D, R + T6 + H0 + I0 + i3 + T6)) U.lineWidth = 5
          var q = I.borderPatternToArray(U.lineWidth, j.pattern)
          U.stxLine(F, y3, K, g, U.strokeStyle, U.globalAlpha, U.lineWidth, q)
          U.globalAlpha = 0x173 > (2.65e2, 18.7e1) ? (7.55e2, 1) : (93, 27)
          U.lineWidth = (149.0e1, 102) > 7 ? (0x16b, 1) : (9.68e2, 3.0e2)
        }
        I.ChartEngine.prototype.rendererAction = function(S, H) {
          var c = 'erA',
            d = 'cu',
            E = 'main',
            D = 'n_s',
            U = 'ai',
            w = '_m',
            j = 'ay',
            R = 'ser',
            t = 'n_',
            V = 'ma',
            i = 'la',
            z = 'rA'
          if (
            this.runPrepend(
              U3 + p + U1 + D0 + p + z + t6 + R3 + l0 + Q3,
              arguments
            )
          )
            return
          var W = {}
          for (var C in S.seriesRenderers) {
            var e = S.seriesRenderers[C],
              r = e.params,
              a = r.panel,
              L = this.panels[a]
            if (r.overChart && u4S.R3T(H, F6 + Q3 + E3 + p + U3 + i + e6))
              continue
            if (
              u4S.U3T(r.name, f6 + V + e3 + t + R + e3 + p + C3) &&
              u4S.t3T(H, F6 + Q3 + A1 + U3 + X6 + j)
            )
              continue
            if (
              u4S.I3T(r.name, w + U + D + p + U3 + e3 + p + C3) &&
              u4S.V3T(H, E)
            )
              continue
            if (!r.overChart && u4S.d3T(H, H3 + i0 + D0 + i + e6)) continue
            if (!L) continue
            if (u4S.F3T(L.chart, S)) continue
            if (L.hidden) continue
            if (u4S.f3T(H, t6 + i3 + X6 + d + X6 + i3 + z0)) {
              var v = r.yAxis
              e.performCalculations(v ? W[v.name] : [])
              if (v) W[v.name] = [v.low, v.high]
            } else if (u4S.z3T(H, s1 + V6 + e3 + C3)) {
              if (r.yAxis && u4S.E3T(a, S.panel.name)) {
                this.createYAxis(L, r)
                this.drawYAxis(L, r)
              }
            } else {
              e.draw()
              if (e.cb) e.cb(e.colors)
            }
          }
          this.runAppend(U3 + p + U1 + D0 + c + t6 + R3 + l0 + Q3, arguments)
        }
        I.ChartEngine.prototype.drawSeries = function(S, H, c, d) {
          var E = 'erie',
            D = 'es',
            U = 'ie'
          if (this.runPrepend(E3 + k1 + c0 + G2 + p + U3 + U + C3, arguments))
            return
          var w = S.dataSegment,
            j = (12, 0x132) >= (58, 0x8b) ? (109, null) : (128, 92.8e1)
          if (!H) H = S.series
          for (var R in H) {
            j = H[R]
            var t = j.parameters,
              V = t.panel ? this.panels[t.panel] : S.panel,
              i = t.color,
              z = t.width,
              W = t.field
            if (!V) continue
            var C = (t.yAxis = c ? c : V.yAxis)
            if (!i) i = C.textStyle || this.defaultColor
            if (!W) W = S.defaultPlotField
            var e = t.subField || S.defaultPlotField || w1 + C3 + p
            if (
              u4S.o3T(this.mainSeriesRenderer, d) &&
              !t.shareYAxis &&
              u4S.e3T(C.name, V.yAxis.name)
            ) {
              var r = [t.minimum, t.maximum]
              if (
                (!t.minimum &&
                  u4S.A3T(
                    t.minimum,
                    (4.7e1, 0xb) < 11.42e2 ? (0x1dc, 0) : (20.7e1, 2.07e2)
                  )) ||
                (!t.maximum &&
                  u4S.k3T(
                    t.maximum,
                    (70, 7.77e2) < (111, 130)
                      ? 'c'
                      : (40, 58) >= (0x30, 86)
                      ? (8.9e2, 85)
                      : (7.68e2, 0x13d) <= (0x101, 0x19d)
                      ? (131.3e1, 0)
                      : (1.047e3, 0x178)
                  ))
              ) {
                if (d && !d.standaloneBars) {
                  w.unshift(
                    this.getPreviousBar(
                      S,
                      e,
                      (0x238, 54) >= (60, 83)
                        ? (0x102, 'E')
                        : (13, 51) > 149
                        ? (77, 0x12c)
                        : (96, 0x1bd) > 45
                        ? (8.66e2, 0)
                        : (55, 87)
                    )
                  )
                  w.push(
                    this.getNextBar(
                      S,
                      e,
                      u4S.P3T(
                        w.length,
                        (62, 86) <= (99.0e1, 4.3e2)
                          ? (131, 1)
                          : (48, 17.8e1) < 137
                          ? (1.428e3, '.')
                          : 12.06e2 < (12.58e2, 1.146e3)
                          ? (0x236, 0x244)
                          : (16, 139)
                      )
                    )
                  )
                }
                var a = I.minMax(
                  w,
                  W,
                  e,
                  d
                    ? d.highLowBars
                    : (0x18d, 0xa8) > 0xaa
                    ? (0x125, 0x233)
                    : 105.4e1 > (1.52e2, 14.7e2)
                    ? 0xb
                    : 62.4e1 <= (7.4e1, 1.398e3)
                    ? (73, null)
                    : (54.9e1, 0x124)
                )
                if (d && !d.standaloneBars) {
                  w.shift()
                  w.pop()
                }
                if (
                  !t.minimum &&
                  u4S.l3T(
                    t.minimum,
                    (67.8e1, 0x147) > 52 ? (0x18d, 0) : (0x18, 0x15d)
                  )
                )
                  r[0] =
                    a[
                      0x4e < (3.45e2, 8.52e2)
                        ? (13.8e1, 0)
                        : (18, 0x2c) >= (0x130, 1.65e2)
                        ? 66.1e1
                        : (1.496e3, 0xaf)
                    ]
                if (!t.maximum && u4S.y6T(t.maximum, 0))
                  r[1] =
                    a[4.09e2 <= (131, 0x21d) ? (6.44e2, 1) : (10.59e2, 104)]
              }
              var L =
                  r[(0x8b, 43) < (94.7e1, 0xbc) ? (148, 0) : (4.3e1, 0x233)],
                v = C.top,
                b = C.bottom,
                J = u4S.H6T(b, v),
                O = t.marginTop,
                N = t.marginBottom
              if (O)
                v = u4S.c6T(
                  O,
                  1 >= (33, 4.07e2)
                    ? (7.7e1, 50)
                    : (0x193, 0x9c) < (8.12e2, 64)
                    ? (5, 50)
                    : 129 < (10, 10.65e2)
                    ? (47, 1)
                    : (105, 15)
                )
                  ? v + O
                  : v + u4S.a6T(J, O)
              if (N) b = u4S.D6T(N, 1) ? u4S.Q6T(b, N) : u4S.i6T(b, J * N)
              t.overlayScaling = {
                bottom: b,
                min: L,
                multiplier: u4S.M6T(
                  b - v,
                  r[
                    (0x172, 104) <= 16.2e1
                      ? (105, 1)
                      : (0x1d8, 6.14e2) < 0x207
                      ? 115.9e1
                      : 0x20b <= (0x80, 106)
                      ? 1.37
                      : (0x235, 91)
                  ] - L
                ),
              }
            }
            if (
              !t._rawExtendToEndOfDataSet &&
              u4S.w6T(
                t._rawExtendToEndOfDataSet,
                (94, 0x85) >= (43, 1.84e2)
                  ? 'j'
                  : (8.7e2, 0x1e8) <= (71, 122)
                  ? 1.3e1
                  : (124, 75) <= (3.9e1, 120)
                  ? (0, false)
                  : (76, 0x18e)
              )
            ) {
              t._rawExtendToEndOfDataSet = t.extendToEndOfDataSet
            }
            if (S.animatingHorizontalScroll)
              t.extendToEndOfDataSet =
                116.8e1 >= (0x22f, 0x185) ? (0x223, false) : (135, 0x27)
            else {
              t.extendToEndOfDataSet = t._rawExtendToEndOfDataSet
              if (
                !t.extendToEndOfDataSet &&
                u4S.C6T(
                  t.extendToEndOfDataSet,
                  (92, 105) <= (0x240, 6.2e1)
                    ? (60.4e1, 'M')
                    : 5.13e2 > (1.482e3, 1.28e2)
                    ? (1.032e3, false)
                    : (74.5e1, 0x201)
                )
              )
                t.extendToEndOfDataSet =
                  0xa6 <= (5.98e2, 13.78e2)
                    ? (0x125, false)
                    : (59.7e1, 86) >= 0x1cc
                    ? 0xb7
                    : 67.3e1 < (0x1d7, 136)
                    ? 72
                    : (7, 4.93e2)
            }
            var B = t.colorFunction
            if (j.highlight || j.parameters.highlight)
              t.highlight = (44.4e1, 2.15e2) > (62, 1) ? (132, true) : (77, 119)
            var s = {
              colors: [],
            }
            if (d) {
              s = d.drawIndividualSeries(S, t) || s
            } else if (u4S.Z6T(t.type, z6 + H3 + F6 + Q3 + R3 + i3 + e3 + Q3)) {
              s = this.drawMountainChart(
                V,
                I.extend(
                  {
                    returnObject: true,
                  },
                  t
                ),
                B
              )
            } else {
              s = this.drawLineChart(
                V,
                t.style,
                B,
                I.extend(
                  {
                    returnObject: true,
                  },
                  t
                )
              )
            }
            j.yValueCache = s.cache
            var Y =
              S.dataSegment[
                u4S.h6T(
                  S.dataSegment.length,
                  (0xae, 51.8e1) >= 0x24c
                    ? 'm'
                    : (28, 111.2e1) > (0x5, 1.21e2)
                    ? (82, 1)
                    : 0x23e < (104, 62)
                    ? 'm'
                    : (0x16e, 81)
                )
              ]
            if (Y) {
              var o =
                !t.skipTransform && S.transformFunc && u4S.J6T(C, S.panel.yAxis)
              if (
                !Y[W] &&
                u4S.v6T(
                  Y[W],
                  (0x154, 1.076e3) < 128.0e1 ? (1.419e3, 0) : (0x1f7, 6.0e2)
                )
              )
                Y = this.getPreviousBar(
                  S,
                  W,
                  u4S.K6T(
                    S.dataSegment.length,
                    (71.1e1, 0x186) > 2.02e2 ? (0x1e4, 1) : (0x1d7, 1.408e3)
                  )
                )
              if (o && Y && Y.transform) Y = Y.transform
            }
            if (
              u4S.m6T(this.mainSeriesRenderer, d) &&
              (t.shareYAxis || u4S.q6T(C.name, V.yAxis.name)) &&
              Y &&
              !C.noDraw
            ) {
              var F = Y[W]
              if (
                F[e] ||
                u4S.S0T(
                  F[e],
                  (1.014e3, 20) > 62
                    ? (5.3e2, 144)
                    : 7.71e2 >= (5.6e1, 4.44e2)
                    ? (0x54, 0)
                    : (0xc6, 69) >= 2.07e2
                    ? 'I'
                    : (12.63e2, 0x5b)
                )
              ) {
                F = F[e]
              } else {
                F = F.iqPrevClose
              }
              var y3
              if (C.priceFormatter) {
                y3 = C.priceFormatter(this, V, F)
              } else {
                y3 = this.formatYAxisPrice(F, V, null, C)
              }
              this.yAxisLabels.push({
                src: C3 + D0 + e3 + D,
                args: [
                  V,
                  y3,
                  this.pixelFromTransformedValue(F, V, C),
                  i,
                  (105, 1.22e2) < (105, 0x14b)
                    ? (1.9e1, null)
                    : (12.79e2, 0x110),
                  2.15e2 >= (2.4e2, 0x104)
                    ? (0x1d6, 8.17e2)
                    : (44, 0x64) <= 106
                    ? (49, null)
                    : (68, 2.98e2),
                  C,
                ],
              })
            }
            if (S.legend && t.useChartLegend) {
              if (!S.legend.colorMap) S.legend.colorMap = {}
              var K = t.display
              if (!K) K = t.symbol
              S.legend.colorMap[R] = {
                color: s.colors,
                display: K,
                isBase: u4S.x0T(d, this.mainSeriesRenderer),
              }
            }
          }
          this.runAppend(E3 + U3 + a4 + G2 + E + C3, arguments)
        }
        I.ChartEngine.prototype.consolidatedQuote = function(w, j) {
          var R = 'uo',
            t = 'dQ',
            V = 'solid',
            i = 'ng',
            z = 'rdi',
            W = 'ga',
            C = ', ',
            e = 'et',
            r = 'ataS',
            a = (88, 118) >= (0x3e, 0x2a) ? (0x1f0, 'q') : (132.2e1, 11),
            L = 'ut',
            v = 'rni',
            b = 'ote',
            J = 'Q',
            O = 'dat',
            N = 'co'
          if (
            this.runPrepend(
              N + e2 + H3 + X6 + e3 + O + p + E3 + J + F6 + b,
              arguments
            )
          )
            return w
          if (!w || !w.length) return []
          var B = this.layout,
            s = this.dataZone,
            Y = this.chart,
            o = this,
            F = B.periodicity,
            y3 = B.interval,
            K = B.timeUnit
          if (!j) j = {}
          if (j.periodicity && j.interval) {
            F = j.periodicity
            y3 = j.interval
            K = j.timeUnit
          }
          var g =
            (54.5e1, 0x1e7) < (0x177, 9.97e2) ? (140.1e1, 1) : (37.4e1, 0x20c)
          if (
            !I.ChartEngine.isDailyInterval(y3) &&
            Y.useInflectionPointForIntraday
          ) {
            g = F
          }

          function q(S, H, c) {
            var d = 'ow',
              E = 'Hi'
            if (!H)
              H = {
                DT: c,
                Date: I.yyyymmddhhmmssmmm(c),
              }
            if (!H.displayDate) o.setDisplayDate(H)
            var D =
              (0x10d, 42) <= 55.1e1
                ? (12.46e2, 1)
                : 1.101e3 < (92, 69)
                ? (57, 14.44e2)
                : (5.6e2, 0x133) < (57.2e1, 0x38)
                ? (131.3e1, 109)
                : (18, 43)
            if (B.adj && S.Adj_Close) {
              D = u4S.X0T(S.Adj_Close, S.Close)
            }
            if (u4S.r0T(E + T6 + B6, S))
              if (u4S.G0T(S.High * D, H.High)) H.High = u4S.L0T(S.High, D)
            if (u4S.j0T(S1 + d, S))
              if (
                u4S.O0T(S.Low * D, H.Low) &&
                u4S.W0T(
                  S.Low,
                  (67.0e1, 0x91) > 44 ? (33, null) : (61.5e1, 19.6e1)
                )
              )
                H.Low = u4S.N0T(S.Low, D)
            H.Volume += S.Volume
            if (
              u4S.b0T(K0 + A2 + C3 + p, S) &&
              u4S.B0T(
                S.Close,
                40.9e1 < (16, 39)
                  ? (62, 143.4e1)
                  : (4.56e2, 76) > (73, 25)
                  ? (86, null)
                  : 0xb8 <= (96, 24)
                  ? 100
                  : (42, 0x15)
              )
            )
              H.Close = u4S.Y0T(S.Close, D)
            H.ratio = D
            for (var U in S) {
              if (!H[U]) {
                H[U] = S[U]
              }
            }
            return H
          }
          var l = Y.inflectionPoint
          if (
            !l ||
            u4S.T0T(
              l,
              w[
                (118, 0x1b2) > (0, 0x104)
                  ? (118.6e1, 0)
                  : (66.8e1, 49) <= (7.26e2, 16)
                  ? (36, 0x1f6)
                  : (145, 111.1e1) <= 49.9e1
                  ? '2d'
                  : (68.5e1, 4.4e2)
              ].DT
            )
          )
            l =
              w[(0x1de, 1.155e3) >= (76.4e1, 105) ? (0x1ff, 0) : (45, 9.69e2)]
                .DT
          var A = [],
            c3 = {
              begin: l,
              interval: y3,
              multiple: u4S.s0T(F, g),
              timeUnit: K,
              inZone: s,
              outZone: s,
            },
            m = Y.market.newIterator(I.clone(c3))
          while (
            u4S.g0T(
              m.previous(g),
              w[
                (0x24f, 0x1a4) <= (109, 120)
                  ? (0x1f, 'X')
                  : (0x9c, 116) > 111
                  ? (60, 0)
                  : (61, 75) >= (33.4e1, 7.4e2)
                  ? (67, 'X')
                  : (41, 81.9e1)
              ].DT
            )
          );
          var t3 = m.previous(g),
            D3 = m.next(g),
            I3 =
              (7.64e2, 50) >= 0xca
                ? 'u'
                : (0x8e, 87.1e1) > (2.2e1, 140)
                ? (1.4e3, 0)
                : (0xe3, 69),
            V3 = 0
          while (u4S.p0T(I3, w.length)) {
            var u3 = w[I3]
            if (u4S.n0T(u3.DT, t3)) {
              console.log(
                q1 +
                  i3 +
                  v +
                  Q3 +
                  T6 +
                  j2 +
                  H3 +
                  L +
                  Q0 +
                  H3 +
                  t0 +
                  Q0 +
                  H3 +
                  U3 +
                  E3 +
                  p +
                  U3 +
                  H0 +
                  a +
                  F6 +
                  H3 +
                  R3 +
                  p +
                  H0 +
                  e3 +
                  Q3 +
                  H0 +
                  E3 +
                  r +
                  e +
                  C +
                  E3 +
                  a0 +
                  U3 +
                  p +
                  W +
                  z +
                  i +
                  j2 +
                  u3.DT
              )
              I3++
              continue
            } else if (u4S.u2T(u3.DT, D3)) {
              t3 = D3
              D3 = m.next(g)
              if (!A[V3]) continue
            } else {
              var K3 = q(u3, A[V3], t3)
              if (K3) A[V3] = K3
              I3++
              continue
            }
            V3++
          }
          this.runAppend(
            t6 + H3 + Q3 + V + i3 + R3 + p + t + R + R3 + p,
            arguments
          )
          return A
        }
        var o4 = -E4,
          J4 = Z4,
          G1 = u4S.U3z
        for (
          var I1 = u4S.c3z;
          u4S.q1b.l1b(I1.toString(), I1.toString().length, z4) !== o4;
          I1++
        ) {
          this.watermark(
            panelName,
            t6 + p + Q3 + z0 + U3,
            m3 + H3 + C4 + z6,
            this.translateIf(
              params.name + (H0 + E1 + H3 + R3 + H0 + E0 + f4 + X6 + w4 + Q2)
            )
          )
          chart.scrubbed.pop()
          G1 += u4S.U3z
        }
        if (u4S.q1b.l1b(G1.toString(), G1.toString().length, F4) !== J4) {
          this.runAppend(R3 + M1 + t6 + M4 + H3 + D2, arguments)
          return O2b < M2b
        }
        I.ChartEngine.prototype.touchmove = function(S) {
          var H = 'uc',
            c = 'form',
            d = 'non'
          if (!this.displayInitialized) return
          if (u4S.R2T(this.openDialog, '')) return
          if (
            u4S.U2T(
              I.ChartEngine.ignoreTouch,
              0x176 > (71.7e1, 136.3e1)
                ? (62.7e1, 'X')
                : (0x177, 149) < 94
                ? 0x75
                : (0x69, 0x1ed) >= 101
                ? (110, true)
                : (0x16a, 0x6a)
            )
          )
            return
          var E = []
          if (
            S &&
            S.touches &&
            u4S.t2T(
              S.touches.length,
              30.5e1 <= (107.4e1, 0x18c)
                ? (83.6e1, 1)
                : 39 > (0xfc, 44)
                ? 1.52e2
                : (0x250, 58) >= 0xc8
                ? (0x1c6, 'o')
                : (13.78e2, 0x1f4)
            )
          ) {
            if (
              u4S.I2T(
                Math.pow(
                  this.clicks.x -
                    S.touches[10.75e2 >= (0x14e, 0xc7) ? (36, 0) : (149, 0x18f)]
                      .clientX,
                  2
                ) +
                  Math.pow(
                    this.clicks.y -
                      S.touches[
                        (75, 0x170) < 0xf
                          ? 0x240
                          : (52, 89) == (22.3e1, 0x59)
                          ? (90, 0)
                          : (48.6e1, 124) > 0x250
                          ? 'D'
                          : (83.6e1, 105)
                      ].clientY,
                    (0x16a, 0xfb) < (1.7e1, 11.57e2)
                      ? (9.86e2, 2)
                      : 6.59e2 < (0x19a, 123)
                      ? (98, 0x6b)
                      : (9.31e2, 0x16c)
                  ),
                (147, 86.0e1) > 68
                  ? (42, 16)
                  : 43.0e1 <= (13.43e2, 26)
                  ? (138, 'G')
                  : (66.7e1, 20.5e1)
              )
            ) {
              return
            }
          }
          if (
            !this.overYAxis ||
            (this.controls &&
              this.controls.crossX &&
              u4S.V2T(this.controls.crossX.style.display, d + p))
          ) {
            if (S && S.preventDefault && this.captureTouchEvents) {
              S.preventDefault()
            }
            if (S) {
              S.stopPropagation()
            }
          }
          var D = new Date().getTime()
          if (
            this.clicks.s2MS ==
            -((119, 96) <= 0x218 ? (0x3e, 1) : (90.6e1, 0x55))
          ) {
            this.clicks.e1MS = D
            if (
              u4S.d2T(
                this.clicks.e1MS - this.clicks.s1MS,
                (0xcf, 0x23d) >= (0x11d, 0x144)
                  ? (82.2e1, 25)
                  : (101, 94) <= (0xb9, 2.7e1)
                  ? (91, 0x36)
                  : (0xb4, 0xcd) > 89.4e1
                  ? (0x220, 'b')
                  : (0x105, 7.46e2)
              )
            ) {
              return
            }
          } else {
            this.clicks.e2MS = D
            if (
              u4S.F2T(
                this.clicks.e2MS - this.clicks.s2MS,
                0x23a <= (0xe3, 0)
                  ? (53.5e1, 'X')
                  : (0x96, 8) >= (10, 0xdc)
                  ? 'X'
                  : (8.34e2, 0x107) >= (111.0e1, 129)
                  ? (106, 25)
                  : (0xfc, 14.46e2)
              )
            ) {
              return
            }
          }
          if (I.isSurface) {
            if (this.mouseMode) return
            if (!S.pointerId) S.pointerId = this.gesturePointerId
            if (
              (!this.grabbingScreen || I.ChartEngine.resizingPanel) &&
              !this.overrideGesture
            ) {
              if (u4S.f2T(S.detail, S.MSGESTURE_FLAG_INERTIA)) {
                this.gesture.stop()
                return
              }
            }
            for (
              var U = 0x37 <= (71.4e1, 0xea) ? (0xaf, 0) : (106.4e1, 0x1cb);
              u4S.z2T(U, this.touches.length);
              U++
            ) {
              if (u4S.E2T(this.touches[U].pointerId, S.pointerId)) {
                var w = Math.abs(u4S.o2T(this.touches[U].pageX, S.clientX)),
                  j = Math.abs(u4S.e2T(this.touches[U].pageY, S.clientY)),
                  R = Math.sqrt(u4S.A2T(w, w) + u4S.k2T(j, j))
                if (!R) return
                this.clicks.e1MS = new Date().getTime()
                if (u4S.P2T(this.clicks.e1MS - this.clicks.s1MS, 50)) {
                  return
                }
                if (
                  u4S.l2T(this.touches[U].pageX, S.clientX) &&
                  u4S.y1T(this.touches[U].pageY, S.clientY)
                )
                  return
                this.touches[U].pageX = S.clientX
                this.touches[U].pageY = S.clientY
                break
              }
            }
            if (u4S.H1T(U, 0)) {
              this.movedPrimary = true
            } else {
              this.movedSecondary =
                (3, 0x201) > (6.81e2, 84)
                  ? (57, true)
                  : (5.51e2, 137) >= 0xe4
                  ? 105
                  : (0x1ec, 107.0e1) <= 83
                  ? (1.418e3, 50)
                  : (0x16e, 1)
            }
            if (!this.gestureInEffect && u4S.c1T(U, this.touches.length)) {
              return
            }
            this.changedTouches = [
              {
                pointerId: S.pointerId,
                pageX: S.clientX,
                pageY: S.clientY,
              },
            ]
            E = this.touches
            if (this.gestureInEffect && !E.length) {
              E = this.changedTouches
            }
          } else {
            E = S.touches
            this.changedTouches = S.changedTouches
          }
          var t = this.crosshairXOffset,
            V = this.crosshairYOffset,
            i =
              this.currentVectorParameters.vectorType &&
              u4S.a1T(this.currentVectorParameters.vectorType, ''),
            z = !this.layout.crosshair && !i && !this.touchNoPan
          if (
            z ||
            (this.activeDrawing &&
              u4S.D1T(this.activeDrawing.name, t0 + U3 + i1 + c))
          ) {
            t = V = 0
          }
          if (this.runPrepend(R3 + j1 + B6 + z6 + v2 + p, arguments)) return
          var W, C
          if (I.ChartEngine.resizingPanel) {
            var e = E[0]
            W = e.clientX
            C = e.clientY
            this.mousemoveinner(W + t, C + V)
            return
          }
          if (
            this.moveB != -((0x4b, 4.6e1) < 0x196 ? (53.4e1, 1) : (8.63e2, 45))
          ) {
            this.touchMoveTime = new Date()
          }
          this.moveA = this.moveB
          this.moveB =
            E[
              (31.9e1, 1.199e3) < 1.155e3
                ? (95, 54)
                : (42.7e1, 0xc3) >= (114, 65)
                ? (102, 0)
                : (35, 5)
            ].pageX
          var r
          if (
            u4S.Q1T(
              E.length,
              (0xe9, 99) < (0x1cc, 0x200) ? (0x1a5, 1) : (119, 84.7e1)
            ) &&
            !this.twoFingerStart
          ) {
            var a = E[0]
            W = a.clientX
            C = a.clientY
            this.pinchingScreen =
              87 >= (0xff, 7.45e2)
                ? 140.2e1
                : 7.36e2 >= (0x1b7, 141)
                ? (0x16c, 0)
                : (31, 6.95e2)
            this.mousemoveinner(W + t, C + V)
            var L = this.whichPanel(C)
            this.overXAxis =
              u4S.i1T(C, this.top + this.chart.panel.yAxis.bottom) &&
              u4S.M1T(C, this.top + this.chart.panel.bottom) &&
              I.ChartEngine.insideChart
            if (!L)
              this.overYAxis =
                (6.15e2, 71) < 138.5e1 ? (3.55e2, false) : (35, 0x106)
            else
              this.overYAxis =
                (u4S.w1T(W, L.right) || u4S.C1T(W, L.left)) &&
                I.ChartEngine.insideChart
          } else if (u4S.Z1T(E.length, 2) && this.allowZoom) {
            if (!this.displayCrosshairs) return
            var v =
                E[
                  (25, 130.7e1) <= 37
                    ? 0x95
                    : (52.4e1, 143.7e1) <= (0xff, 0x144)
                    ? 117
                    : (0x1bd, 40) < (0x223, 0x69)
                    ? (1.392e3, 0)
                    : (117, 45.2e1)
                ],
              b = v.clientX,
              J = v.clientY,
              O =
                E[
                  (11.8e1, 0xef) < (1.047e3, 0x24)
                    ? (0x88, 'p')
                    : (61.7e1, 0x5d) <= 106
                    ? (26, 1)
                    : (0xb1, 1.163e3) <= 21
                    ? 0x92
                    : (132.9e1, 18)
                ],
              N = O.clientX,
              B = O.clientY
            r = Math.sqrt(u4S.h1T(N - b, N - b) + u4S.J1T(B - J, B - J))
            this.pinchingCenter = u4S.v1T(
              Math.min(b, N) - Math.max(b, N),
              (131, 91.9e1) > 40 ? (109.5e1, 2) : (79.7e1, 0x3a)
            )
            var s = Math.round(u4S.K1T(this.gestureStartDistance, r))
            if (z)
              this.pinchingScreen =
                0x105 > (0x20d, 38) ? (1.198e3, 5) : (80, 113.1e1)
            this.clearPixelCache()
            if (
              u4S.m1T(
                this.pinchingScreen,
                (8.88e2, 0x1e1) < 0x202 ? (105, 2) : (98.1e1, 0xc1)
              )
            ) {
              if (I.isSurface && (!this.movedPrimary || !this.movedSecondary)) {
                return
              }
              if (
                (u4S.q1T(b, this.pt.x1) && u4S.S4T(N, this.pt.x2)) ||
                (u4S.x4T(b, this.pt.x1) && u4S.X4T(N, this.pt.x2)) ||
                (u4S.r4T(J, this.pt.y1) && u4S.G4T(B, this.pt.y2)) ||
                (u4S.L4T(J, this.pt.y1) && u4S.j4T(B, this.pt.y2))
              ) {
                this.pinchingScreen =
                  37 <= (0x40, 0x1c8)
                    ? (3.95e2, 0)
                    : 20.1e1 <= (0x210, 2)
                    ? 2
                    : (43, 12.05e2) <= (0x201, 7.99e2)
                    ? (0x20c, null)
                    : (68.3e1, 0x201)
              } else {
                this.pinchingScreen++
                if (
                  u4S.O4T(
                    this.pinchingScreen,
                    (31.7e1, 7.9e1) <= 0x1c8
                      ? (147, 2)
                      : (0x1c8, 0x14a) <= (13, 13)
                      ? (12.42e2, 118.4e1)
                      : (44, 0x226)
                  )
                )
                  return
              }
            }
            this.pt = {
              x1: b,
              x2: N,
              y1: J,
              y2: B,
            }
            if (
              u4S.W4T(
                this.pinchingScreen,
                138.6e1 > (0x15c, 58) ? (132.8e1, 0) : (39, 0x73)
              )
            ) {
              this.mousemoveinner(b + t, J + V)
              this.gestureStartDistance = r
            } else {
              var Y = Math.asin(u4S.N4T(Math.max(B, J) - Math.min(B, J), r))
              if (
                u4S.b4T(
                  Math.abs(s),
                  0x221 < (12.7e2, 140)
                    ? (0x136, 'n')
                    : (147, 0x10) < 8.36e2
                    ? (9.73e2, 12)
                    : (32, 6.23e2) <= 60
                    ? 11.11e2
                    : (12, 0x93)
                ) &&
                !z
              ) {
                this.moveCount++
                if (
                  u4S.B4T(
                    this.moveCount,
                    (11.4e2, 110) >= 0x1c3
                      ? 112
                      : 6.16e2 > (135.0e1, 2.8e1)
                      ? (67, 4)
                      : (7.18e2, 11.53e2)
                  )
                ) {
                  this.pinchingScreen =
                    (0x1aa, 0x11a) <= (20, 0xc)
                      ? (146, 50)
                      : 8.75e2 < (0x11a, 57.0e1)
                      ? 77.2e1
                      : (46, 50) < 0x164
                      ? (105, 0)
                      : (93.1e1, 12.9e2)
                  this.moveCount =
                    (0x184, 31.7e1) < (21, 127.7e1) ? (12.82e2, 0) : (48, 9.1e1)
                  return
                }
              } else {
                this.moveCount =
                  54.1e1 >= (5.1e2, 48) ? (0x126, 0) : (67.5e1, 0x183)
              }
              if (
                u4S.Y4T(
                  Y,
                  (21, 12.94e2) >= 5.7e1 ? (5.83e2, 1) : (0xc8, 1.019e3)
                ) ||
                (!this.goneVertical && u4S.T4T(Y, 1.37))
              ) {
                if (!this.currentPanel) return
                var o = this.currentPanel.chart
                this.goneVertical =
                  (85, 145.2e1) > (0x4, 53) ? (16, false) : (118, 28)
                r = u4S.s4T(this.pt.x2, this.pt.x1)
                var F = u4S.g4T(
                    this.grabStartValues.t2,
                    this.grabStartValues.t1
                  ),
                  y3 =
                    this.grabStartValues.t1 +
                    u4S.p4T(
                      F,
                      (35.0e1, 1.8e1) <= 67 ? (5.51e2, 2) : (0x25, 103)
                    ),
                  K = u4S.n4T(r, F)
                if (u4S.u5T(K, this.minimumCandleWidth))
                  K = this.minimumCandleWidth
                var g = this.layout.candleWidth
                this.setCandleWidth(K, o)
                if (u4S.R5T(o.maxTicks, this.minimumZoomTicks)) {
                  this.setCandleWidth(g, o)
                  return
                }
                this.micropixels =
                  (145.9e1, 0x190) < (108, 6.92e2)
                    ? (78, 0)
                    : 135.8e1 <= (134, 71.5e1)
                    ? (63, 0x10c)
                    : (0x11, 1.37e2)
                var q = this.pixelFromTick(Math.round(y3), o),
                  l =
                    u4S.U5T(this.pt.x1, this.left) +
                    Math.round(
                      u4S.t5T(
                        r,
                        0x1fc <= (0x1d5, 33.7e1)
                          ? (147, 12.67e2)
                          : (129, 0x37) > 11.8e2
                          ? 81
                          : (2.5e2, 1.432e3) >= (109, 7)
                          ? (0x66, 2)
                          : (79, 0xa1)
                      )
                    ),
                  A = u4S.I5T(q, l),
                  c3 = u4S.V5T(A, K),
                  m = Math.round(c3)
                o.scroll -= m
                this.microscroll = u4S.d5T(m, c3)
                this.micropixels = u4S.F5T(K, this.microscroll)
                this.draw()
              } else {
                var t3 = this.grabStartYAxis
                this.goneVertical = true
                t3.zoom =
                  this.grabStartZoom + u4S.f5T(this.gestureStartDistance, r)
                if (u4S.z5T(this.grabStartZoom, t3.height)) {
                  if (u4S.E5T(t3.zoom, t3.height))
                    t3.zoom = u4S.o5T(
                      t3.height,
                      96.9e1 >= (0x10a, 0x5)
                        ? (0x3e, 1)
                        : (42.3e1, 48) < (6.46e2, 21)
                        ? (69, 74.9e1)
                        : (11.91e2, 21)
                    )
                } else {
                  if (u4S.e5T(t3.zoom, t3.height))
                    t3.zoom =
                      t3.height +
                      ((0x184, 149) <= 111.5e1 ? (0xdc, 1) : (100, 0xdf))
                }
                this.draw()
              }
              this.updateChartAccessories()
            }
          } else if (
            u4S.A5T(
              E.length,
              (0xd3, 11.62e2) >= (1.82e2, 9.76e2)
                ? (145, 3)
                : (0x1a2, 108) >= (6.99e2, 2.43e2)
                ? (2.17e2, 6.7e2)
                : (108, 10.11e2)
            ) &&
            I.ChartEngine.allowThreeFingerTouch
          ) {
            if (!this.displayCrosshairs) return
            var D3 =
                E[
                  (0x85, 104) < 14.08e2
                    ? (86.8e1, 0)
                    : 123 < (20, 60)
                    ? 'T'
                    : (14.59e2, 6) >= 85.9e1
                    ? '-'
                    : (0x14, 1.38e3)
                ],
              I3 = D3.clientX
            r = u4S.k5T(this.grabStartX, I3)
            this.grabEndPeriodicity =
              this.grabStartPeriodicity +
              Math.round(
                u4S.P5T(
                  r,
                  (0xb7, 0x257) >= (0x246, 52)
                    ? (0xf0, 10)
                    : (9.21e2, 39) > (126, 56)
                    ? (79, 0x142)
                    : (89, 1)
                )
              )
            if (u4S.l5T(this.grabEndPeriodicity, 1))
              this.grabEndPeriodicity =
                (0x173, 13.76e2) < (90, 0x13f)
                  ? (4.23e2, 'day')
                  : 9.93e2 > (62, 46)
                  ? (26, 1)
                  : (14, 120.1e1) > (113, 1.407e3)
                  ? (0x136, 'day')
                  : (8.85e2, 0x1e3)
          }
          this.runAppend(h2 + H + B6 + z6 + v2 + p, arguments)
        }
        I.ChartEngine.prototype.touchstart = function(H) {
          var c = 'tar',
            d = 'tou',
            E = 'uch'
          if (I.ChartEngine.ignoreTouch) return
          if (I.isSurface) {
            this.movedPrimary =
              7.37e2 >= (50, 61.4e1)
                ? (1.205e3, false)
                : (0x128, 58) > (0x164, 1.242e3)
                ? (113, 115.4e1)
                : (45, 0x44)
            this.movedSecondary =
              (0x31, 13.47e2) >= (0x18c, 0x23e)
                ? (138.4e1, false)
                : (0x11c, 0x19f) < (63.1e1, 42)
                ? 0x158
                : 7 > (84, 0x126)
                ? 95.5e1
                : (64, 0x28)
          } else {
            if (this.touchingEvent) clearTimeout(this.touchingEvent)
            this.touching =
              (4, 148.5e1) < (0x218, 60.8e1)
                ? (0x227, 84)
                : (20.3e1, 0x171) <= 45.1e1
                ? (27, true)
                : 1.053e3 <= (15, 0x16c)
                ? 61.0e1
                : (6.54e2, 31)
            this.touches = H.touches
            this.changedTouches = H.changedTouches
          }
          if (I.ChartEngine.resizingPanel) return
          var D = this.crosshairXOffset,
            U = this.crosshairYOffset
          if (this.runPrepend(R3 + H3 + E + C3 + R3 + W2 + R3, arguments))
            return
          if (
            this.manageTouchAndMouse &&
            H &&
            H.preventDefault &&
            this.captureTouchEvents
          )
            H.preventDefault()
          this.hasDragged =
            93 > (25.6e1, 5.06e2)
              ? 0x61
              : (128, 0xc9) <= (0x171, 0x194)
              ? (13.79e2, false)
              : (0x3b, 132)
          this.doubleFingerMoves = 16 < (9.28e2, 0xc5) ? (96, 0) : (118, 0x20e)
          this.moveCount =
            (112, 0x18a) >= 1.259e3
              ? (66.6e1, 'J')
              : (137, 24) >= (4.09e2, 140.5e1)
              ? (0x22e, 8.43e2)
              : (0x22f, 14.83e2) > 60.5e1
              ? (120, 0)
              : (0x54, 67)
          this.twoFingerStart =
            0xe8 >= (149, 11.3e1) ? (105, false) : (2.4e2, 0x15e)
          var w, j, R, t, V
          if (
            u4S.y9T(
              this.touches.length,
              124.7e1 <= (1.4e1, 0x29)
                ? (0x70, 62.8e1)
                : (72, 7.7e1) <= 24
                ? 'U'
                : (61, 0x6c) > (0x136, 0)
                ? (0x47, 1)
                : (90, 118)
            ) ||
            u4S.H9T(
              this.touches.length,
              (0x247, 75) <= 127.2e1
                ? (26.5e1, 2)
                : (1.092e3, 0x139) > 0x170
                ? 13.52e2
                : (0xf0, 0x1fe)
            )
          ) {
            if (u4S.c9T(this.changedTouches.length, 1)) {
              var i = Date.now(),
                z = false
              if (
                u4S.a9T(
                  i - this.clicks.e1MS,
                  (0xfe, 26) < (0x209, 0xc1)
                    ? (136, 250)
                    : (100, 8.97e2) < (122, 0x1ca)
                    ? 1.323e3
                    : (0x22b, 15.9e1) > (0x5c, 0x229)
                    ? (1.381e3, 0x1c0)
                    : (2.1e2, 0x11d)
                )
              ) {
                this.cancelTouchSingleClick =
                  (0x214, 7.98e2) >= (37, 42)
                    ? (79, true)
                    : 10.99e2 <= (1, 3.85e2)
                    ? (73, 'I')
                    : (105, 0xba) < 81
                    ? (121.2e1, 32)
                    : (1.182e3, 19.0e1)
                this.clicks.s2MS = i
                z = u4S.D9T(
                  Math.pow(
                    this.clicks.x -
                      this.changedTouches[
                        10.12e2 >= (6.5e1, 0xd8)
                          ? (0xbe, 0)
                          : 0x13b < (0x122, 8)
                          ? (0x9b, 'C')
                          : (0x178, 4.34e2) >= (14.16e2, 0x1e9)
                          ? 'C'
                          : (112, 5.19e2)
                      ].pageX,
                    (0x58, 32) <= (126.1e1, 0x83)
                      ? (0x1b2, 2)
                      : (137, 0x1cf) > 97.8e1
                      ? (0x227, 'Q')
                      : (76, 0xe5) < (9.97e2, 0x24)
                      ? (0x24a, 'Q')
                      : (5.27e2, 64.9e1)
                  ) +
                    Math.pow(
                      this.clicks.y -
                        this.changedTouches[
                          (0xc9, 140) < (0x122, 0x152)
                            ? (0x10a, 0)
                            : (0x141, 121)
                        ].pageY,
                      2
                    ),
                  400
                )
              }
              if (!z) {
                this.cancelTouchSingleClick = false
                this.clicks.s1MS = i
                this.clicks.e1MS = -((131, 1.488e3) <= (62, 28)
                  ? (6.34e2, 46.7e1)
                  : 98 > (89, 1)
                  ? (0xe3, 1)
                  : (2.4e1, 31) > (123, 10.23e2)
                  ? (10.37e2, 32.8e1)
                  : (95, 0x1ed))
                this.clicks.s2MS = -((1.078e3, 0x41) <= 7.2e1
                  ? (94, 1)
                  : 0x123 >= (0x10, 59.4e1)
                  ? (112.6e1, 0x99)
                  : (130, 56.8e1))
                this.clicks.e2MS = -(149.6e1 <= (102, 0x226)
                  ? 0x1ad
                  : (146, 119) >= 53
                  ? (18.2e1, 1)
                  : (0x25, 36))
              }
              this.clicks.x = this.changedTouches[
                (14.5e1, 0x1ea) <= 18.6e1
                  ? (108, 'bar')
                  : (133.5e1, 0x1a0) >= 0x11
                  ? (35, 0)
                  : (38, 136)
              ].pageX
              this.clicks.y = this.changedTouches[
                70 < (139, 88.4e1) ? (0x1a3, 0) : (0x1ea, 8.5e2)
              ].pageY
            }
            this.touchMoveTime = Date.now()
            this.moveA = this.touches[0].clientX
            this.moveB = -((3.36e2, 0x112) > 124
              ? (0x189, 1)
              : (63, 26.9e1) <= 0xe3
              ? 19.3e1
              : (2.14e2, 0x234) >= (101, 114.6e1)
              ? 'l'
              : (0x1c9, 1.259e3))
            var W = this.touches[
              (0x154, 4.91e2) < 100.7e1
                ? (0x1b6, 0)
                : (2.8e1, 11.06e2) <= 0xaf
                ? 1
                : (0x1c5, 117.8e1)
            ]
            R = W.clientX
            t = W.clientY
            var C = this.container.getBoundingClientRect()
            this.top = C.top
            this.left = C.left
            this.right = this.left + this.width
            this.bottom = this.top + this.height
            if (
              u4S.Q9T(
                this.touches.length,
                39 < (89.9e1, 0x255) ? (9.85e2, 1) : (47, 43.9e1)
              )
            ) {
              var e = (this.cy = this.backOutY(t))
              this.currentPanel = this.whichPanel(e)
            }
            if (!this.currentPanel) this.currentPanel = this.chart.panel
            V = this.currentPanel
            if (
              u4S.i9T(R, this.left) &&
              u4S.M9T(R, this.right) &&
              u4S.w9T(t, this.top) &&
              u4S.C9T(t, this.bottom)
            ) {
              I.ChartEngine.insideChart =
                (0x22, 0x135) < (92, 11.52e2)
                  ? (4.86e2, true)
                  : (0x177, 0xf6) >= 8.13e2
                  ? (0x53, 325)
                  : 6.11e2 <= (32, 61)
                  ? (0x1a, 13.82e2)
                  : (0xb, 0x21e)
              this.overXAxis =
                u4S.Z9T(t, this.top + this.chart.panel.yAxis.bottom) &&
                u4S.h9T(t, this.top + this.chart.panel.bottom)
              this.overYAxis = u4S.J9T(R, V.right) || u4S.v9T(R, V.left)
              var r = -((0x207, 2.73e2) >= (0x99, 1.2e3)
                ? (119, 107.5e1)
                : 6 > (0x7b, 90.5e1)
                ? 'h'
                : (0x1a6, 0x1c9) <= 0x23c
                ? (20, 1)
                : (7.51e2, 0x1e0))
              for (
                var a =
                  (14.1e1, 0x218) <= 30.6e1
                    ? (3.05e2, 131)
                    : (56, 0x198) > (1.36e3, 84)
                    ? (101, 0)
                    : (0xb2, 107);
                u4S.K9T(a, this.drawingObjects.length);
                a++
              ) {
                var L = this.drawingObjects[a]
                if (L.highlighted) {
                  if (u4S.m9T(r, (74.7e1, 77) > 75 ? (107, 0) : (3.6e1, 7)))
                    r = a
                  var v = L.highlighted
                  this.cy = this.backOutY(t)
                  this.cx = this.backOutX(R)
                  this.crosshairTick = this.tickFromPixel(this.cx, V.chart)
                  this.crosshairValue = this.adjustIfNecessary(
                    V,
                    this.crosshairTick,
                    this.valueFromPixel(this.cy, this.currentPanel)
                  )
                  this.findHighlights(
                    (146, 4.33e2) < (87, 5.08e2)
                      ? (69, true)
                      : (4.85e2, 0x182) < 112
                      ? 8.24e2
                      : (2.74e2, 19.6e1)
                  )
                  if (u4S.q9T(a, r) && L.highlighted) {
                    if (
                      this.clicks.s2MS ==
                      -(7 > (69.9e1, 0xb3)
                        ? (124, 'c')
                        : (1.9e1, 0x183) > 111
                        ? (77.7e1, 1)
                        : (6.86e2, 1.75e2) >= (0x16, 0xb4)
                        ? 42
                        : (75.8e1, 39.7e1))
                    ) {
                      this.activateRepositioning(L)
                    } else {
                      this.findHighlights(
                        0x3 <= (117, 135) ? (132, false) : (132, 0x1a5),
                        6.77e2 <= (69, 0x50)
                          ? 1.618
                          : (0x157, 0x257) >= 102
                          ? (0x42, true)
                          : (12.88e2, 1.363e3)
                      )
                    }
                    return
                  }
                  this.anyHighlighted =
                    (0x195, 58) >= (0x1, 0xe8)
                      ? 'x0'
                      : (1.173e3, 141.6e1) < (70.4e1, 75)
                      ? 8.53e2
                      : (134, 132.5e1) > 147
                      ? (0xb4, true)
                      : (149, 0x13a)
                  L.highlighted = v
                }
              }
            } else {
              I.ChartEngine.insideChart =
                (1.344e3, 0x5c) >= (125, 90.3e1)
                  ? (14.84e2, '2d')
                  : (50, 0x1e9) > (67, 39)
                  ? (0x139, false)
                  : (90, 0x9)
            }
            var b =
              this.currentVectorParameters.vectorType &&
              u4S.S8T(this.currentVectorParameters.vectorType, '')
            if (
              !this.layout.crosshair &&
              !b &&
              I.ChartEngine.insideChart &&
              !this.touchNoPan
            ) {
              D = U = 3.83e2 <= (0x5d, 9.75e2) ? (63, 0) : (47, 0x158)
              var J = this.mainSeriesRenderer || {}
              if (
                J.params &&
                J.params.baseline &&
                u4S.x8T(this.chart.baseline.userLevel, false)
              ) {
                var O = this.valueFromPixel(
                    u4S.X8T(
                      this.cy,
                      (13.94e2, 11.5e1) < 70.6e1
                        ? (2, 5)
                        : (51, 0x22a) > (122, 13.61e2)
                        ? 'i'
                        : (0x1e, 0x8b)
                    ),
                    V
                  ),
                  N = this.valueFromPixel(
                    this.cy +
                      ((112.0e1, 55) < (10, 120)
                        ? (0x43, 5)
                        : 73 > (13, 0x225)
                        ? (0x5f, 3.49e2)
                        : (0x162, 0x1ad)),
                    V
                  ),
                  B = u4S.r8T(
                    this.chart.right,
                    parseInt(
                      getComputedStyle(this.controls.baselineHandle).width,
                      10
                    )
                  )
                if (
                  u4S.G8T(this.chart.baseline.actualLevel, O) &&
                  u4S.L8T(this.chart.baseline.actualLevel, N) &&
                  u4S.j8T(this.backOutX(W.clientX), B)
                ) {
                  this.repositioningBaseline = {
                    lastDraw: Date.now(),
                  }
                  return
                }
              }
              for (w in this.panels) {
                j = this.panels[w]
                if (j.highlighted) {
                  this.grabHandle(j)
                  return
                }
              }
              this.grabbingScreen =
                (0x10a, 0x1ee) > (45, 110.3e1)
                  ? (68.4e1, 1.208e3)
                  : 0x1c >= (147, 41)
                  ? (97, 'D')
                  : 112.4e1 > (2.77e2, 0x1b9)
                  ? (0x196, true)
                  : (61.1e1, 7)
              if (this.disableBackingStoreDuringTouch)
                this.disableBackingStore()
              V.chart.spanLock =
                (3.67e2, 0x20) < 84 ? (2.69e2, false) : (126, 9.14e2)
              this.yToleranceBroken = false
              this.grabStartX = R + D
              this.grabStartY = t + U
              this.grabStartMicropixels = this.micropixels
              this.grabStartScrollX = V.chart.scroll
              this.grabStartScrollY = V.yAxis.scroll
              this.grabStartPanel = this.currentPanel
              this.swipeStart(V.chart)
              this.grabStartYAxis = this.whichYAxis(V, R)
              this.grabStartZoom = this.grabStartYAxis.zoom
              setTimeout(
                (function(S) {
                  return function() {
                    S.grabbingHand()
                  }
                })(this),
                49 < (0x26, 0x93) ? (11.99e2, 100) : (0xec, 53.8e1)
              )
            } else {
              this.grabbingScreen =
                (143, 136.4e1) > (148, 54) ? (39.7e1, false) : (136, 20)
              if (I.ChartEngine.insideChart) {
                var s = this.currentVectorParameters.vectorType
                if (
                  I.Drawing &&
                  s &&
                  I.Drawing[s] &&
                  new I.Drawing[s]().dragToDraw
                ) {
                  this.userPointerDown =
                    (43.5e1, 0x1b8) <= 77
                      ? 124.1e1
                      : 8.8e1 > (135, 141)
                      ? 'D'
                      : (2.67e2, 40) <= 14.89e2
                      ? (8.54e2, true)
                      : (55, 8.3e1)
                  I.ChartEngine.crosshairX = R
                  I.ChartEngine.crosshairY = t
                  if (V && V.chart.dataSet) {
                    this.crosshairTick = this.tickFromPixel(
                      this.backOutX(I.ChartEngine.crosshairX),
                      this.currentPanel.chart
                    )
                    this.crosshairValue = this.adjustIfNecessary(
                      V,
                      this.crosshairTick,
                      this.valueFromPixel(
                        this.backOutY(I.ChartEngine.crosshairY),
                        this.currentPanel
                      )
                    )
                  }
                  this.drawingClick(V, this.backOutX(R), this.backOutY(t))
                  this.headsUpHR()
                  return
                }
              }
            }
            if (
              u4S.O8T(
                this.touches.length,
                112 >= (57, 0x1a5)
                  ? (96.0e1, 30)
                  : (74, 4.91e2) > 121
                  ? (57.9e1, 1)
                  : (133, 4.08e2)
              ) &&
              this.layout.crosshair
            ) {
              this.mousemoveinner(R + D, t + U)
            }
          }
          if (u4S.W8T(this.touches.length, 2)) {
            this.cancelLongHold =
              (103.1e1, 3.65e2) > 0xa6
                ? (9.76e2, true)
                : (4, 12) > 0x24e
                ? (0x1f9, 0xce)
                : (149, 1.082e3)
            this.swipe.end =
              (0x157, 6.9e1) > (119, 47) ? (33, true) : (126, 4.53e2)
            if (
              (!this.displayCrosshairs && !this.touchNoPan) ||
              !I.ChartEngine.insideChart
            )
              return
            var Y = this.touches[1],
              o = Y.clientX,
              F = Y.clientY
            for (w in this.panels) {
              j = this.panels[w]
              if (j.highlighted) {
                this.grabHandle(j)
                return
              }
            }
            V = this.currentPanel
            this.gestureStartDistance = Math.sqrt(
              u4S.N8T(o - R, o - R) + u4S.b8T(F - t, F - t)
            )
            this.pt = {
              x1: R,
              x2: o,
              y1: t,
              y2: F,
            }
            this.grabbingScreen =
              (14, 1.9e1) <= (57.5e1, 73) ? (72.4e1, true) : (1.429e3, 12.63e2)
            if (this.disableBackingStoreDuringTouch) this.disableBackingStore()
            V.chart.spanLock = false
            this.grabStartX = R + D
            this.grabStartY = t + U
            this.grabStartMicropixels = this.micropixels
            this.grabStartScrollX = V.chart.scroll
            this.grabStartScrollY = V.yAxis.scroll
            this.grabStartPanel = this.currentPanel
            this.swipeStart(V.chart)
            this.grabStartCandleWidth = this.layout.candleWidth
            this.grabStartYAxis = this.whichYAxis(V, u4S.B8T(R + o, 2))
            this.grabStartZoom = this.grabStartYAxis.zoom
            this.grabStartPt = this.pt
            this.grabStartValues = {
              x1: this.pt.x1,
              x2: this.pt.x2,
              y1: this.valueFromPixel(u4S.Y8T(this.pt.y1, this.top), V),
              y2: this.valueFromPixel(u4S.T8T(this.pt.y2, this.top), V),
              t1: this.tickFromPixel(u4S.s8T(this.pt.x1, this.left), V.chart),
              t2: this.tickFromPixel(u4S.g8T(this.pt.x2, this.left), V.chart),
            }
            this.twoFingerStart =
              34 < (0x255, 0x1b3) ? (1.262e3, true) : (0x209, 24)
            setTimeout(
              (function(S) {
                return function() {
                  S.grabbingHand()
                }
              })(this),
              (7, 0x1b4) < 148.5e1 ? (92, 100) : (0x107, 107.7e1)
            )
          } else if (
            u4S.p8T(
              this.touches.length,
              (137, 89) <= 143 ? (122, 3) : (1.442e3, 2.8e1)
            )
          ) {
            if (!this.displayCrosshairs) return
            var y3 = this.touches[
                (0x20c, 29) <= (0x1a4, 0x213) ? (10, 0) : (9, 38)
              ],
              K = y3.clientX
            this.grabStartX = K
            this.grabStartPeriodicity = this.layout.periodicity
          }
          if (
            u4S.n8T(
              this.touches.length,
              (78, 0x8b) <= 0x12b
                ? (59, 1)
                : 67 > (144, 0x92)
                ? 0x86
                : (13.04e2, 0x1e2) > (10.81e2, 7.98e2)
                ? (7.6e1, 59)
                : (2.28e2, 146)
            )
          ) {
            this.mouseTimer = Date.now()
            this.longHoldTookEffect =
              (0xcf, 0xa1) >= 14.31e2
                ? (36, 'G')
                : (1.81e2, 0x24e) >= (0x1cb, 83)
                ? (103, false)
                : (0x188, 0xcd)
            if (this.longHoldTime) this.startLongHoldTimer()
          }
          this.runAppend(d + t6 + B6 + C3 + c + R3, arguments)
        }
        I.ChartEngine.prototype.swipeStart = function(S) {
          var H = (5.21e2, 85) <= (0x212, 0x22d) ? (132, 325) : (0x8c, 1.455e3)
          if (this.swipe && this.swipe.interval)
            clearInterval(this.swipe.interval)
          this.swipe.velocity = u4S.R3z
          this.swipe.amplitude = u4S.R3z
          this.swipe.frame = S.scroll
          this.swipe.micropixels = this.micropixels
          this.swipe.timestamp = Date.now()
          this.swipe.chart = S
          this.swipe.end = k2
          this.swipe.timeConstant = H
          this.swipe.cb = w0
          var c = this
          requestAnimationFrame(function() {
            c.swipeSample()
          })
        }
        I.ChartEngine.prototype.swipeSample = function() {
          var S =
              (40, 42) > (0xde, 48)
                ? 0.0
                : (95, 0x1cc) > 6.62e2
                ? (0x1e, 'g')
                : (1, 0x15) < (106, 134.1e1)
                ? (1.9e1, 0.2)
                : (0xfa, 8.0e2),
            H = 71 < (1.46e3, 121) ? (0x1f4, 0.4) : (122, 0x252),
            c = this.swipe
          if (c.end) {
            return
          }
          var d = this,
            E,
            D,
            U,
            w,
            j = d4
          E = Date.now()
          D = u4S.u7T(E, c.timestamp)
          if (u4S.R7T(D, j)) {
            requestAnimationFrame(function() {
              d.swipeSample()
            })
            return
          }
          var R = I.touchDevice ? H : V1
          c.timestamp = E
          U =
            u4S.U7T(c.chart.scroll - c.frame, this.layout.candleWidth) +
            this.micropixels -
            c.micropixels
          c.frame = c.chart.scroll
          c.micropixels = this.micropixels
          w = u4S.t7T(i4, U, u4S.c3z + D)
          var t = u4S.L7T(R, w) + u4S.j7T(S, c.velocity)
          if (u4S.O7T(Math.abs(t), Math.abs(c.velocity))) {
            c.velocity = t
          }
          if (u4S.W7T(Math.abs(U), V4)) {
            c.velocity = u4S.R3z
          }
          requestAnimationFrame(function() {
            d.swipeSample()
          })
        }
        I.ChartEngine.prototype.swipeRelease = function() {
          var S = 3000,
            H = this.swipe
          if (u4S.N7T(H.velocity, S)) H.velocity = S
          if (H.velocity < -S) H.velocity = -S
          if (u4S.b7T(H.velocity, k0) || H.velocity < -k0) {
            H.amplitude = u4S.B7T(V1, H.velocity)
            H.scroll = H.chart.scroll
            H.target = H.amplitude
            H.timestamp = Date.now()
            var c = this
            if (this.disableBackingStoreDuringTouch) this.disableBackingStore()
            requestAnimationFrame(function() {
              c.autoscroll()
            })
          }
        }
        I.ChartEngine.prototype.scrollTo = function(S, H, c) {
          var d = this.swipe
          d.end = K2
          d.amplitude = d.target = u4S.Y7T(
            H - S.scroll,
            this.layout.candleWidth
          )
          d.timeConstant = Q4
          d.timestamp = Date.now()
          d.scroll = S.scroll
          d.chart = S
          d.cb = c
          var E = this
          requestAnimationFrame(function() {
            E.autoscroll()
          })
        }
        I.ChartEngine.prototype.autoscroll = function() {
          var S = this,
            H = this.swipe,
            c
          if (H.amplitude) {
            H.elapsed = u4S.T7T(Date.now(), H.timestamp)
            c = -H.amplitude * Math.exp(-H.elapsed / H.timeConstant)
            if (u4S.s7T(c, Z0) || c < -Z0) {
              var d = u4S.g7T(H.target + c, this.layout.candleWidth)
              H.chart.scroll = H.scroll + Math.round(d)
              this.draw()
              this.updateChartAccessories()
              requestAnimationFrame(function() {
                S.autoscroll()
              })
            } else {
              if (this.disableBackingStoreDuringTouch)
                this.reconstituteBackingStore()
              if (H.cb) H.cb()
            }
          }
        }
        I.ChartEngine.prototype.touchend = function(H) {
          var c = 'chen',
            d = 'cto',
            E = 'end'
          if (I.ChartEngine.ignoreTouch) return
          this.swipe.end =
            0x240 < (0x1d3, 82)
              ? 6.31e2
              : (3.48e2, 7.9e1) < (0x7e, 48)
              ? 146
              : (134.0e1, 0xf) < (96, 124.2e1)
              ? (26.4e1, true)
              : (0xfa, 0x7c)
          if (I.isSurface) {
          } else {
            this.touches = H.touches
            this.changedTouches = H.changedTouches
          }
          if (this.runPrepend(R3 + j1 + B6 + E, arguments)) return
          this.cancelLongHold = true
          if (
            u4S.p7T(
              this.touches.length,
              (1.129e3, 3.74e2) >= (8.47e2, 72)
                ? (0x33, 1)
                : (66.2e1, 78) >= 0x18e
                ? 'V'
                : (1.0e1, 1.29e3)
            )
          ) {
            if (
              this.layout.crosshair ||
              this.currentVectorParameters.vectorType
            ) {
              if (!this.touches.length || !this.twoFingerStart) {
                this.grabbingScreen =
                  25 < (1.499e3, 0x19c) ? (1.032e3, false) : (8.8e1, 115)
              }
            }
          }
          if (this.touches.length) {
            this.grabStartX = -((71.3e1, 0xb7) >= 0x127
              ? 2
              : 0x13a < (7.18e2, 1.498e3)
              ? (0xa1, 1)
              : (0x5f, 0x1d))
            this.grabStartY = -(0x238 < (94, 59)
              ? (1.455e3, 0.0)
              : 0x16a < (0x20e, 0x21d)
              ? (28, 1)
              : (5.49e2, 23))
          }
          var D = this.pinchingScreen
          if (this.disableBackingStoreDuringTouch)
            this.reconstituteBackingStore()
          if (!this.touches.length) {
            this.touchingEvent = setTimeout(
              (function(S) {
                return function() {
                  S.touching =
                    (0x103, 0x218) > (130, 0x1d) ? (0xc4, false) : (8.32e2, 35)
                }
              })(this),
              (82, 66) >= 143
                ? 'x0'
                : 0x6d < (118.8e1, 134.0e1)
                ? (0x1b6, 500)
                : (1.384e3, 142)
            )
            if (I.ChartEngine.resizingPanel) {
              this.releaseHandle()
              return
            }
            this.pinchingScreen =
              109 > (77, 32)
                ? (102.3e1, null)
                : (0x6f, 0x1e4) > (83.4e1, 1.401e3)
                ? 48
                : (0xb2, 0x56)
            this.pinchingCenter = null
            this.goneVertical =
              (0x190, 0xf8) >= 0x2c ? (23, false) : (95.1e1, 0x1cf)
            this.grabbingScreen =
              (1.113e3, 9) <= 140.7e1 ? (0x54, false) : (21.6e1, 0x20b)
            this.grabMode = ''
            this.doDisplayCrosshairs()
            this.updateChartAccessories()
          } else {
            if (I.ChartEngine.resizingPanel) return
          }
          var U =
            this.touches.length +
            ((0x18f, 103) > (12.7e2, 106)
              ? (24, 37)
              : (0x21e, 1.475e3) <= 1.264e3
              ? 0.1
              : (0x109, 0x127) > 15
              ? (0x97, 1)
              : (5.88e2, 0xc))
          if (
            u4S.n7T(
              this.changedTouches.length,
              (0x3e, 1.315e3) > (0x18b, 55)
                ? (12.26e2, 1)
                : (52, 0x232) < (19.2e1, 133)
                ? 96
                : (125.5e1, 39.3e1)
            )
          ) {
            if (this.repositioningDrawing) {
              this.changeOccurred(i0 + p + d + U3)
              I.clearCanvas(this.chart.tempCanvas, this)
              this.activateRepositioning(
                (13, 38) >= 5 ? (101, null) : (132.3e1, 0x1c6)
              )
              this.draw()
              if (
                !this.layout.crosshair &&
                !this.currentVectorParameters.vectorType
              )
                this.findHighlights(
                  false,
                  (149, 0x101) > 0x139
                    ? 1.29e3
                    : (0x156, 110) >= (29, 0x15a)
                    ? (118.6e1, 'x')
                    : (10.16e2, 1.463e3) >= (0x172, 67)
                    ? (0x4f, true)
                    : (0x1b7, 0x1ba)
                )
              return
            }
            if (this.repositioningBaseline) {
              this.repositioningBaseline =
                1.277e3 >= (145.3e1, 0x16a) ? (147, null) : (99, 4.11e2)
              var w = this.mainSeriesRenderer || {}
              if (
                w.params &&
                w.params.baseline &&
                u4S.u3b(w.params.type, z6 + H3 + F6 + J2 + i3 + e0)
              ) {
                this.chart.panel.yAxis.scroll = u4S.R3b(
                  this.pixelFromPrice(
                    this.chart.baseline.userLevel,
                    this.chart.panel
                  ),
                  (this.chart.panel.yAxis.top + this.chart.panel.yAxis.bottom) /
                    2
                )
              }
              this.draw()
              return
            }
            var j = Date.now()
            if (
              this.clicks.s2MS ==
              -((0x154, 0x24a) >= (0x16, 0x176)
                ? (4.93e2, 1)
                : (0xac, 0x1f3) <= (148.5e1, 0x21)
                ? (79.3e1, 'a')
                : (133.3e1, 1.199e3) < (0x1ea, 96.8e1)
                ? (0x8b, 'a')
                : (26, 0xdb))
            ) {
              this.clicks.e1MS = j
              var R = this.currentVectorParameters.vectorType
              if (
                !I.Drawing ||
                !R ||
                !I.Drawing[R] ||
                !new I.Drawing[R]().dragToDraw
              ) {
                if (
                  u4S.U3b(
                    this.clicks.e1MS - this.clicks.s1MS,
                    (42.9e1, 98) <= 128.8e1
                      ? (6.22e2, 750)
                      : (0x137, 94.8e1) < 6.77e2
                      ? 0x1a5
                      : (0x154, 10)
                  ) &&
                  !this.longHoldTookEffect &&
                  (!this.hasDragged || this.layout.crosshair)
                ) {
                  setTimeout(
                    this.touchSingleClick(U, this.clicks.x, this.clicks.y),
                    9.66e2 > (59, 0x1b1)
                      ? (11.6e1, 200)
                      : (1.9e2, 85) >= (3, 118)
                      ? (0x1fd, 131.3e1)
                      : (0xf6, 43)
                  )
                } else {
                  this.clicks = {
                    s1MS: -1,
                    e1MS: -(9.5e1 < (13.7e2, 6.64e2)
                      ? (65, 1)
                      : (0x220, 2.13e2)),
                    s2MS: -(0x24c <= (42, 115)
                      ? (72, 'pan')
                      : (1.232e3, 0) <= (113.9e1, 0x89)
                      ? (0x120, 1)
                      : (5.68e2, 0xcb)),
                    e2MS: -((6.14e2, 98.0e1) > 3.03e2
                      ? (0xa5, 1)
                      : 15.4e1 <= (14, 103)
                      ? (0x1c5, 1.1)
                      : (5, 54)),
                  }
                }
              }
              this.userPointerDown =
                10.81e2 < (100, 8.5e1)
                  ? 0xb5
                  : (0x70, 0x81) <= (0xa, 0x21c)
                  ? (13.35e2, false)
                  : (12, 0xe4)
              if (this.activeDrawing && this.activeDrawing.dragToDraw) {
                var t =
                    this.backOutY(
                      this.changedTouches[
                        (0x3, 8.7e2) <= (61, 142)
                          ? (111.8e1, 112)
                          : (1.094e3, 66) <= 100
                          ? (42, 0)
                          : (0xf8, 59) >= 140
                          ? 'Y'
                          : (88, 0x42)
                      ].pageY
                    ) + this.crosshairYOffset,
                  V =
                    this.backOutX(
                      this.changedTouches[
                        (61, 2) >= 0xbc
                          ? 'V'
                          : (4, 0xc7) > (73, 8.38e2)
                          ? (0x1dc, 66.0e1)
                          : (0x29, 0x88) > (138, 127)
                          ? (125, 0)
                          : (98.6e1, 0x1b2)
                      ].pageX
                    ) + this.crosshairXOffset
                this.drawingClick(this.currentPanel, V, t)
                return
              }
            } else {
              this.clicks.e2MS = j
              if (
                u4S.t3b(
                  this.clicks.e2MS - this.clicks.s2MS,
                  (10, 0x16) < (4.51e2, 0x9e) ? (59.1e1, 250) : (0xa, 0x1d9)
                )
              ) {
                this.touchDoubleClick(U, this.clicks.x, this.clicks.y)
              } else {
                this.clicks = {
                  s1MS: -((0x12c, 0x141) <= 10
                    ? (77.3e1, 0x9c)
                    : (0xcf, 76) <= 89
                    ? (139.6e1, 1)
                    : (119, 0x147) <= 0x5c
                    ? '   '
                    : (0xb4, 54)),
                  e1MS: -((0x77, 0x8d) < (58, 5.79e2)
                    ? (0x180, 1)
                    : (98, 117.1e1)),
                  s2MS: -((0x1a2, 5.1e1) > 11.95e2
                    ? 0x1fd
                    : (15, 100.9e1) > 0x67
                    ? (104.4e1, 1)
                    : (77, 133)),
                  e2MS: -((4.62e2, 73) <= 0x5f ? (0x1ed, 1) : (12, 89.3e1)),
                }
              }
            }
          } else if (this.displayCrosshairs) {
            if (
              this.grabEndPeriodicity !=
                -((62, 2.0e1) <= 1.445e3
                  ? (1.17e3, 1)
                  : 0x1bd > (0x21a, 14.01e2)
                  ? (7.7e2, 'X')
                  : (0x169, 0x21c)) &&
              !isNaN(this.grabEndPeriodicity)
            ) {
              if (
                I.ChartEngine.isDailyInterval(this.layout.interval) ||
                this.allowIntradayNMinute
              ) {
                this.setPeriodicity({
                  period: this.grabEndPeriodicity,
                  interval: this.layout.interval,
                })
              }
              this.grabEndPeriodicity = -((97.2e1, 0x181) < (14.56e2, 137)
                ? 13
                : (0x23c, 25.5e1) >= 48
                ? (52, 1)
                : (0xf, 0xd5))
            }
          }
          if (this.changedTouches.length) {
            if (
              (!this.layout.crosshair &&
                !this.currentVectorParameters.vectorType &&
                u4S.I3b(
                  U,
                  (14, 125.7e1) > 1.98e2
                    ? (0xff, 1)
                    : 0x157 >= (11.11e2, 78.3e1)
                    ? 2
                    : (81, 7.63e2) < 8.2e1
                    ? 1.37
                    : (0x165, 0x1ad)
                )) ||
              (this.twoFingerStart && !D && !this.touches.length)
            ) {
              this.swipeRelease()
            }
          }
          if (!this.touches.length) {
            this.twoFingerStart =
              106 >= (2.71e2, 31)
                ? (0x3c, false)
                : 1.194e3 < (28, 0xa3)
                ? (0x216, 'i')
                : (1.2e2, 0x226)
          }
          this.runAppend(h2 + F6 + c + E3, arguments)
        }
        I.ChartEngine.prototype.createDataSet = function(L, v, b) {
          var J = 'Se',
            O = 'cr',
            N = 'ti',
            B = 'nk',
            s = 'eak',
            Y = 'br',
            o = 'as',
            F = 'ik',
            y3 = '!',
            K = 'oad',
            g = 'greg',
            q = 'dva',
            l = 'ig',
            A = (7.78e2, 0x17c) >= (8.85e2, 36) ? (0x17a, 'H') : (9.59e2, 67),
            c3 = 'ose',
            m = 'tCl',
            t3 = 'Nex',
            D3 = 'get',
            I3 = 'pe',
            V3 =
              (45.2e1, 51.2e1) >= (0xe3, 0x215)
                ? 24
                : 11 <= (1.01e2, 0x1d5)
                ? (0x1a4, 'O')
                : (1.171e3, 0xe5),
            u3 = 'ex',
            K3 = 'tN',
            v3 = 'rea',
            q3 = 'eDat'
          if (!b) b = {}
          var h3 = [
            L,
            v,
            {
              appending: b.appending,
              appendToDate: b.appendToDate,
            },
          ]
          if (this.runPrepend(t6 + u2 + S2 + q3 + i3 + G2 + p + R3, h3)) return
          var l3, n

          function a3() {
            var S = Q2 + C3 + t0,
              H =
                (85, 40) > (13, 0x79)
                  ? null
                  : 85.0e1 < (143, 16.3e1)
                  ? (0x1ce, 'M')
                  : (44, 0x91) > (90, 136)
                  ? (6.14e2, 't')
                  : (2, 28),
              c = 's'
            H +=
              (23, 20.1e1) <= (0x151, 6.57e2) ? (13.02e2, 'o') : (0x197, 3.33e2)
            c += 1.046e3 > (23, 0x211) ? (0x21b, 'e') : (101, 83)
            var d = []
            c += S.charAt(
              (128.1e1, 0x1b0) > 32.0e1
                ? (93, 0)
                : (28.3e1, 55) >= 56
                ? 'pan'
                : (0x41, 6.05e2)
            )
            H +=
              (90, 103.6e1) <= 37
                ? (72, 49.1e1)
                : (146, 20) < 55
                ? (101.0e1, 'p')
                : (1.155e3, 38)
            c += S.charAt(
              (0xc0, 1.35e2) < (133.5e1, 0xac) ? (117, 3) : (0x1d7, 1.214e3)
            )
            if (u4S.V3b(window[H], window[c]))
              return (0x178, 1.495e3) > (8.4e2, 9.08e2)
                ? (0x5d, true)
                : (1, 141.3e1)
            if (d.length) {
              var E = I.getHostName(document.referrer),
                D =
                  (82.1e1, 0x58) >= (10.31e2, 123)
                    ? (0x163, 'J')
                    : 0xaa <= (91, 0x150)
                    ? (131.6e1, false)
                    : (0x73, 0x1b0)
              for (
                var U = (73, 5.05e2) > 0xb1 ? (0x153, 0) : (137, 72.2e1);
                u4S.d3b(U, d.length);
                U++
              ) {
                var w = d[U]
                if (E.indexOf(w) != -1) {
                  D = (0x218, 0x22a) > 135 ? (116.3e1, true) : (57, 0xa7)
                }
              }
              if (!D) {
                return (77, 10.0e1) < 13.92e2
                  ? (0x17a, false)
                  : (124.0e1, 0x1e4) < 0x73
                  ? 'bar'
                  : (0x91, 0x14d)
              }
            }
            return true
          }

          function S6(S, H) {
            var c = H.arr
            if (u4S.F3b(c.length, 1)) {
              var d =
                c[
                  (129, 0x63) <= (0xa4, 3.96e2)
                    ? (0x7b, 0)
                    : (18, 0xa6) >= (58, 0x212)
                    ? (101, 138.3e1)
                    : 0x125 < (89, 44)
                    ? (1.05e2, 'P')
                    : (121, 0x12a)
                ][(12.39e2, 0x106) > (0xaf, 14) ? (1.06e3, 0) : (42, 0x172)]
              for (
                var E =
                  (0x16d, 79.3e1) > 0x1fd
                    ? (0x112, 1)
                    : (44, 54) > (43, 146)
                    ? 0
                    : 1.08e2 < (41.3e1, 87)
                    ? (9.0e2, 'u')
                    : (1.162e3, 1.325e3);
                u4S.f3b(E, c.length);
                E++
              ) {
                var D =
                    c[u4S.z3b(E, 1)][
                      (22, 0x1e6) >= 15.7e1 ? (33, 0) : (141, 0x166)
                    ],
                  U =
                    c[E][
                      (19, 13.59e2) >= (118, 0x90)
                        ? (55, 0)
                        : (0, 0x195) > 6.17e2
                        ? 'DT'
                        : (0x22e, 0xa0)
                    ],
                  w = I.strToDateTime(D),
                  j = I.strToDateTime(U).getTime(),
                  R = S.standardMarketIterator(w),
                  t =
                    0x1cc <= (0x122, 0x53)
                      ? 300
                      : 10.8e1 < (17.1e1, 0x1b5)
                      ? (1.054e3, 0)
                      : 0x103 < (0x1dc, 87)
                      ? (1.194e3, 71)
                      : (49.5e1, 0x175)
                while (u4S.E3b(w.getTime(), j)) {
                  w = R.next()
                  t += 51 <= (54, 0x55) ? (13.6e1, 1) : (76.3e1, 102)
                }
                var V = I.strToDateTime(D).getTime(),
                  i
                if (
                  u4S.o3b(
                    V,
                    I.strToDateTime(
                      o3[
                        o3.length -
                          (3.57e2 > (0x24d, 9)
                            ? (0x220, 1)
                            : 84 < (1.61e2, 4)
                            ? (21.8e1, 'n')
                            : (3.19e2, 30.4e1) < 0x30
                            ? (122, 'n')
                            : (31.7e1, 0x1f1))
                      ].Date
                    ).getTime()
                  )
                ) {
                  i = u4S.e3b(
                    o3.length,
                    (0x1fe, 0x21d) >= 142 ? (47, 1) : (0xf2, 5.67e2)
                  )
                  t +=
                    (0x252, 5.0e1) <= (0x204, 5.67e2)
                      ? (14.26e2, 1)
                      : (0xda, 1.12e3)
                } else {
                  for (
                    i = u4S.A3b(
                      o3.length,
                      147.3e1 > (2.36e2, 0x20d)
                        ? (119, 1)
                        : (71.6e1, 56.5e1) > (0x1f6, 109.0e1)
                        ? (7.8e1, 136)
                        : (1.07e2, 1.286e3)
                    );
                    u4S.k3b(
                      i,
                      (60.7e1, 130) > (0xa0, 4.17e2)
                        ? 'G'
                        : (0xc0, 0x1ac) >= (37, 0x1e9)
                        ? (0x31, 1.27e2)
                        : (0x1b6, 47) <= (57, 0x158)
                        ? (0x8b, 0)
                        : (94, 0x17e)
                    );
                    i--
                  ) {
                    if (u4S.P3b(V, I.strToDateTime(o3[i].Date).getTime())) break
                  }
                }
                var z = {
                  x0: 0,
                  x1: t,
                  y0: o3[i].Close,
                  y1:
                    c[E][
                      (0x1cc, 131) > (6.25e2, 0x3b) ? (80.6e1, 1) : (48.2e1, 37)
                    ],
                }
                d = I.strToDateTime(D)
                R = S.standardMarketIterator(d)
                var W =
                  (13.69e2, 0x1a3) > 82
                    ? (58, false)
                    : (44.4e1, 0xfe) <= 0x44
                    ? (110, 0x1b5)
                    : (81, 69)
                for (
                  var C = (0x9a, 0xad) >= (43, 137) ? (0xee, 0) : (87, 85);
                  u4S.l3b(C, t);
                  C++
                ) {
                  if (!W) {
                    W =
                      (10.71e2, 9.6e1) <= (0x11f, 139)
                        ? (6, true)
                        : 112 >= (0xe3, 0x256)
                        ? 0x2b
                        : (142.8e1, 71) > 10.24e2
                        ? (60, 'D')
                        : (0xeb, 1.048e3)
                  } else {
                    d = R.next()
                  }
                  if (
                    u4S.y6b(
                      d.getTime(),
                      o3[
                        o3.length -
                          ((0x155, 0x93) > (87.1e1, 4)
                            ? (0x16, 1)
                            : (0x205, 133.2e1) <= 9.05e2
                            ? 'r'
                            : (0xad, 104))
                      ].DT.getTime()
                    )
                  )
                    continue
                  var e = I.yIntersection(z, C)
                  if (!e)
                    e =
                      (29, 11.71e2) < (148, 85)
                        ? 41.9e1
                        : (145.2e1, 31.4e1) > (83.7e1, 12.2e1)
                        ? (79.8e1, 0)
                        : (0x51, 52)
                  var r = u4S.H6b(
                    Math.round(
                      e * ((10.41e2, 112) < 144 ? (122, 10000) : (112, 6.37e2))
                    ),
                    10000
                  )
                  if (
                    u4S.c6b(
                      r,
                      (4.15e2, 0x1a0) > (0x188, 1.5e2)
                        ? (0xaa, 0)
                        : (1.063e3, 26)
                    )
                  )
                    r = c[E][0x23d >= (0x81, 4) ? (145, 1) : (48, 21)]
                  var a = {
                    Date: I.yyyymmddhhmmssmmm(d),
                    DT: d,
                    Open: r,
                    Close: r,
                    High: r,
                    Low: r,
                    Volume: 0,
                    Adj_Close: r,
                    Split_Close: r,
                    projection: true,
                  }
                  if (u4S.a6b(S.layout.interval, z6 + e3 + Q3 + F6 + R3 + p))
                    if (
                      u4S.D6b(
                        Z3--,
                        11 <= (59, 40) ? (76.3e1, 0) : (1.083e3, 88)
                      )
                    )
                      break
                  o3[o3.length] = a
                }
              }
            }
          }

          function x6(S) {
            if (!n.context) return
            var H = n.defaultPlotField,
              c = n.context.measureText(S[H]).width
            if (u4S.Q6b(c, n.quoteTextLength)) n.quoteTextLength = c
          }
          var o3,
            M3 = [],
            F3 = [],
            G6 = b.appending
          for (l3 in this.charts) {
            if (v && u4S.i6b(v.name, l3)) continue
            n = this.charts[l3]
            if (!n.dataSet) n.dataSet = []
            var d6 = n.dataSet.length
            if (G6) M3 = n.dataSet
            n.currentQuote =
              (41.1e1, 20.5e1) > (97.0e1, 0x111)
                ? (0x220, 0x69)
                : (8.42e2, 27.6e1) >= 86.2e1
                ? (0x214, 18)
                : (5, 145) > (0xf7, 54)
                ? (15.9e1, null)
                : (86, 19)
            n.dataSet = []
            n.tickCache = {}
            var A3 = n.masterData
            if (!A3) A3 = this.masterData
            if (!A3 || !A3.length) {
              this.runAppend(
                t6 + v3 + R3 + p + i2 + i3 + R3 + i3 + G2 + p + R3,
                h3
              )
              return
            }
            if (M3.length) {
              var f3 = M3.pop(),
                z3 = b.appendToDate
              if (!z3 || u4S.M6b(z3, f3.DT)) z3 = f3.DT
              while (M3.length) {
                if (
                  u4S.w6b(
                    M3[
                      M3.length -
                        ((0x3a, 129.6e1) > (7, 0x147) ? (117, 1) : (14, 0x5b))
                    ].DT,
                    z3
                  )
                )
                  break
                M3.pop()
              }
              var w3 = u4S.C6b(
                A3.length,
                (149, 0x182) <= 0x1de ? (4.77e2, 1) : (38.7e1, 38)
              )
              while (
                u4S.Z6b(
                  w3,
                  0x93 <= (122.2e1, 120.6e1) ? (0x198, 0) : (1, 12.59e2)
                ) &&
                u4S.h6b(A3[w3].DT, z3)
              )
                w3--
              o3 = A3.slice(w3 + 1)
            } else {
              o3 = [].concat(A3)
            }
            if (!a3()) return
            if (this.transformDataSetPre) this.transformDataSetPre(this, o3)
            var Z3 = Math.round(
                u4S.J6b(
                  n.maxTicks,
                  14.7e1 > (107, 29)
                    ? (131.7e1, 0.75)
                    : (4.3e1, 8.99e2) <= 0x254
                    ? (12.21e2, 'Q')
                    : (0x1bb, 55.6e1) <= (2.23e2, 58)
                    ? (16, 30)
                    : (72.4e1, 0x21)
                )
              ),
              d3
            if (!this.chart.hideDrawings) {
              for (
                d3 =
                  (133, 140) > (33.2e1, 118)
                    ? (1.59e2, 0)
                    : 0x165 >= (0x249, 0x227)
                    ? 30
                    : (12.12e2, 141);
                u4S.v6b(d3, this.drawingObjects.length);
                d3++
              ) {
                if (
                  u4S.K6b(
                    this.drawingObjects[d3].name,
                    u0 + U3 + q2 + p + L2 + l0 + Q3
                  )
                )
                  S6(this, this.drawingObjects[d3])
              }
              if (
                this.activeDrawing &&
                u4S.m6b(this.activeDrawing.name, u0 + U3 + q2 + C1 + l0 + Q3)
              ) {
                S6(this, this.activeDrawing)
              }
            }
            d3 =
              33.8e1 >= (5.15e2, 94)
                ? (89, 0)
                : 0x44 > (89.9e1, 32.1e1)
                ? 66
                : (108, 0x1b3)
            var N6 = -Number.MAX_VALUE,
              W6 = Number.MAX_VALUE,
              P,
              r6 =
                11.17e2 <= (71, 2.17e2)
                  ? 41
                  : (0x9, 2.8e1) < 0x117
                  ? (139, 0)
                  : (4.83e2, 58),
              a6 = L || this.dontRoll,
              k3 = this.layout,
              J3 = this.dataZone,
              P3 = I.ChartEngine.isDailyInterval(k3.interval),
              c6,
              I6
            while (1) {
              if (u4S.q6b(r6, o3.length)) break
              if (
                !(
                  this.dontRoll &&
                  (u4S.S0b(k3.interval, c0 + i1 + r0) ||
                    u4S.x0b(k3.interval, A0 + Q3 + R3 + B6))
                ) &&
                this.extendedHours &&
                n.market.market_def
              ) {
                var j6 = o3[r6]
                if (P3) {
                  I6 = !n.market.isMarketDate(j6.DT)
                } else {
                  if (!c6 || u4S.X0b(c6, j6.DT)) {
                    var y6 = n.market.getSession(j6.DT, J3)
                    I6 =
                      u4S.r0b(y6, '') &&
                      (!k3.marketSessions || !k3.marketSessions[y6])
                    c6 = n.market[
                      I6
                        ? T6 + p + K3 + u3 + R3 + V3 + I3 + Q3
                        : D3 + t3 + m + c3
                    ](j6.DT, J3, J3)
                  }
                }
                if (I6) {
                  r6++
                  continue
                }
              }
              P = {}
              for (var b6 in o3[r6]) {
                P[b6] = o3[r6][b6]
              }
              o3[r6] = P
              P.ratio = (126, 92) < 30.9e1 ? (0x1db, 1) : (2.66e2, 0x15)
              if (k3.adj && P.Adj_Close) {
                P.ratio = u4S.G0b(P.Adj_Close, P.Close)
              }
              if (
                u4S.L0b(
                  P.ratio,
                  142.8e1 > (2.84e2, 0x7e)
                    ? (72, 1)
                    : (30, 21) >= (1.356e3, 61)
                    ? (80, 14.11e2)
                    : (3.61e2, 106)
                )
              ) {
                if (P.Open)
                  P.Open = Number(
                    u4S
                      .j0b(P.Open, P.ratio)
                      .toFixed(
                        (10.19e2, 0x107) >= 93
                          ? (0x210, 8)
                          : 1.13e2 > (3.87e2, 9.14e2)
                          ? (9.6e1, 0xa1)
                          : (0x18c, 119.7e1)
                      )
                  )
                if (P.Close)
                  P.Close = Number(
                    u4S
                      .O0b(P.Close, P.ratio)
                      .toFixed((0x82, 54) <= 0x102 ? (0x125, 8) : (0xdc, 0xe4))
                  )
                if (P.High)
                  P.High = Number(
                    u4S
                      .W0b(P.High, P.ratio)
                      .toFixed(
                        45.2e1 > (9.3e1, 101)
                          ? (34, 8)
                          : 57 >= (121, 0x78)
                          ? (118.2e1, 0x228)
                          : 92.2e1 > (0xd5, 100.8e1)
                          ? 0x8
                          : (3, 0xfc)
                      )
                  )
                if (P.Low)
                  P.Low = Number(
                    u4S
                      .N0b(P.Low, P.ratio)
                      .toFixed(
                        (107, 13.77e2) <= 5.65e2
                          ? (0x98, 'h')
                          : (149.9e1, 32) < (0x1c3, 6.51e2)
                          ? (117, 8)
                          : 34 <= (4.3e2, 18)
                          ? 1.325e3
                          : (0x1c2, 83)
                      )
                  )
              }
              if (n.dynamicYAxis) x6(P)
              F3[d3++] = o3[r6++]
            }
            if (
              !a6 &&
              (u4S.b0b(
                k3.periodicity,
                139 >= (81, 121) ? (49, 1) : (5.59e2, 7.12e2)
              ) ||
                u4S.B0b(k3.interval, c0 + p + p + r0) ||
                u4S.Y0b(k3.interval, A0 + Q3 + R3 + B6))
            ) {
              F3 = this.consolidatedQuote(F3)
            }
            var A6 = {}
            for (
              d3 =
                (0x59, 5.34e2) >= (0xfb, 0xda)
                  ? (10.25e2, 0)
                  : 13.25e2 <= (0x1f4, 97)
                  ? 0x82
                  : (126.0e1, 1.497e3) < 56
                  ? 'V'
                  : (13.44e2, 111);
              u4S.T0b(d3, F3.length);
              d3++
            ) {
              P = F3[d3]
              if (u4S.s0b(d3, 0)) {
                P.iqPrevClose =
                  F3[
                    u4S.g0b(
                      d3,
                      (24, 0x226) <= (4.92e2, 122)
                        ? 1.257e3
                        : (15, 0x19a) >= 123
                        ? (0x109, 1)
                        : (64, 1.173e3)
                    )
                  ].Close
                if (!P.iqPrevClose && u4S.p0b(P.iqPrevClose, 0))
                  P.iqPrevClose =
                    F3[
                      u4S.n0b(
                        d3,
                        40.6e1 > (1.26e2, 127) ? (0x1ea, 1) : (67, 52)
                      )
                    ].iqPrevClose
              } else if (M3.length) {
                P.iqPrevClose =
                  M3[
                    u4S.u2b(
                      M3.length,
                      0x183 > (115, 0x1ec)
                        ? (0xdf, 57)
                        : (15.2e1, 106) < (0x256, 142.6e1)
                        ? (46, 1)
                        : (17, 63.7e1)
                    )
                  ].Close
                if (!P.iqPrevClose && u4S.R2b(P.iqPrevClose, 0))
                  P.iqPrevClose =
                    M3[
                      u4S.U2b(
                        M3.length,
                        (124, 78) < 0x84
                          ? (0x1da, 1)
                          : (0x1f7, 9.39e2) <= 0x75
                          ? 'y0'
                          : (81, 35.2e1)
                      )
                    ].iqPrevClose
              } else {
                P.iqPrevClose = P.Close
              }
              if (u4S.t2b(A + l + B6, P) && u4S.I2b(P.High, N6)) N6 = P.High
              if (u4S.V2b(S1 + H3 + c0, P) && u4S.d2b(P.Low, W6)) W6 = P.Low
              for (var O6 in n.series) {
                var s6 = n.series[O6].parameters.symbol,
                  H6 = P[s6]
                if (H6 && typeof H6 == H3 + b1 + p + t6 + R3) {
                  if (n.dynamicYAxis) x6(H6)
                  if (
                    u4S.F2b(
                      d3,
                      4.6e2 <= (144, 4.9e1)
                        ? (137, 0x23b)
                        : (82, 8.19e2) >= (0x67, 0x17a)
                        ? (106.8e1, 0)
                        : (38.4e1, 148.0e1)
                    )
                  )
                    H6.iqPrevClose = A6[O6]
                  else if (M3.length) {
                    for (
                      var o6 = u4S.f2b(
                        M3.length,
                        (2.85e2, 0x192) > (63.2e1, 37.0e1)
                          ? (59.8e1, 1)
                          : 7.2e2 <= (68.8e1, 99)
                          ? (0x1fb, 'm')
                          : (0x201, 14.02e2)
                      );
                      u4S.z2b(o6, 0);
                      o6--
                    ) {
                      var E6 = M3[o6][s6]
                      if (
                        E6 &&
                        (E6.Close ||
                          u4S.E2b(
                            E6.Close,
                            0x12b > (102.6e1, 4.26e2)
                              ? 0
                              : 13.87e2 >= (0xd8, 0xf7)
                              ? (5.38e2, 0)
                              : 139 >= (47, 0x129)
                              ? 250
                              : (8.87e2, 146)
                          ))
                      ) {
                        H6.iqPrevClose = E6.Close
                        break
                      }
                    }
                  } else H6.iqPrevClose = H6.Close
                  if (H6.Close || u4S.o2b(H6.Close, 0)) A6[O6] = H6.Close
                }
              }
            }
            var P6 = u4S.e2b(n.scroll, n.maxTicks)
            if (P6) {
              n.spanLock =
                (2.57e2, 0x1b0) > 1.063e3
                  ? 0x71
                  : (5.99e2, 5.4e1) < 99.5e1
                  ? (72.5e1, false)
                  : (10, 0x223)
            }
            var L6 = P6 || n.lockScroll || n.spanLock,
              p6 = k3.aggregationType
            n.defaultChartStyleConfig = {
              type: k3.chartType,
            }
            if (p6 && u4S.A2b(p6, H3 + B6 + X6 + t6)) {
              n.defaultChartStyleConfig.type = p6
              if (!I.ChartEngine.prototype.drawKagiSquareWave) {
                console.log(
                  i3 +
                    q +
                    Q3 +
                    t6 +
                    p +
                    E3 +
                    I4 +
                    i3 +
                    T6 +
                    g +
                    S2 +
                    e3 +
                    H3 +
                    Q3 +
                    o2 +
                    F0 +
                    C3 +
                    H0 +
                    Q3 +
                    H3 +
                    R3 +
                    H0 +
                    X6 +
                    K +
                    p +
                    E3 +
                    y3
                )
              } else {
                if (!G6 || !n.state.aggregation) n.state.aggregation = {}
                if (
                  u4S.k2b(p6, e1 + F + p + Q3 + o + B6 + e3) ||
                  u4S.P2b(
                    k3.aggregationType,
                    B6 + p + e3 + r0 + e3 + Q3 + o + B6 + e3
                  )
                ) {
                  F3 = I.calculateHeikinAshi(this, F3, M3)
                } else {
                  if (u4S.l2b(p6, U3 + i3 + Q3 + T6 + p + m3 + i3 + U3 + C3)) {
                    F3 = I.calculateRangeBars(this, F3, k3.range, M3)
                  } else if (u4S.y1b(p6, r0 + i3 + T6 + e3)) {
                    F3 = I.calculateKagi(this, F3, k3.kagi, M3)
                  } else if (u4S.H1b(p6, X6 + e0 + p + Y + s)) {
                    F3 = I.calculateLineBreak(this, F3, k3.priceLines, M3)
                  } else if (u4S.c1b(p6, U3 + p + B + H3)) {
                    F3 = I.calculateRenkoBars(this, F3, k3.renko, M3)
                  } else if (u4S.a1b(p6, O1 + Q3 + E3 + t0)) {
                    F3 = I.calculatePointFigure(this, F3, k3.pandf, M3)
                  }
                }
              }
            }
            var l6 = u4S.D1b(F3.length, d6 - M3.length)
            if (!G6) l6 = 0
            if (L6 && l6) {
              if (n.spanLock && u4S.Q1b(n.scroll, n.maxTicks)) {
                n.spanLock =
                  (72, 0x10a) > 0x1d5
                    ? (2.69e2, 113.0e1)
                    : (0x1f2, 10.18e2) > (135, 147)
                    ? (11, false)
                    : (51.2e1, 0x76)
              } else {
                n.scroll += l6
                this.grabStartScrollX += l6
              }
            }
            if (this.transformDataSetPost)
              this.transformDataSetPost(this, F3, W6, N6)
            var X0 = this.maxDataSetSize
            if (X0) {
              if (u4S.i1b(M3.length + F3.length, X0)) {
                if (u4S.M1b(F3.length, X0)) {
                  M3 = M3.slice(u4S.w1b(F3.length, X0))
                } else {
                  M3 = []
                }
                F3 = F3.slice(-X0)
              }
            }
            if (!n.scrubbed) n.scrubbed = []
            if (M3.length) {
              var Y6 = M3[u4S.C1b(M3.length, 1)].DT
              while (
                n.scrubbed.length &&
                u4S.Z1b(
                  n.scrubbed[
                    n.scrubbed.length -
                      (30 <= (6.36e2, 0x166) ? (9.5e1, 1) : (3.4e1, 31))
                  ].DT,
                  Y6
                )
              ) {
                n.scrubbed.pop()
              }
            } else {
              n.scrubbed = []
            }
            n.state.studies = {}
            n.state.studies.startFrom = n.scrubbed.length
            var n6 = []
            for (
              d3 = (149, 14) <= (52, 85) ? (3.76e2, 0) : (4, 0x1fe);
              u4S.h1b(d3, F3.length);
              d3++
            ) {
              var f0 = F3[d3]
              if (
                f0.Close ||
                u4S.J1b(
                  f0.Close,
                  100 < (15, 6.77e2)
                    ? (67, 0)
                    : (2.45e2, 36.1e1) < (3.9e1, 0x13c)
                    ? (1.422e3, 'e')
                    : (0x96, 0x1d2) >= (0x167, 1.434e3)
                    ? 0x116
                    : (34, 4)
                )
              )
                n6.push(f0)
            }
            n.scrubbed = n.scrubbed.concat(n6)
            if (!G6 || !n.state.calculations) n.state.calculations = {}
            this.calculateATR(
              n,
              (0xc8, 0x79) < (110, 42.3e1)
                ? (104.4e1, 20)
                : (54.8e1, 0x26) >= 0x16f
                ? '.'
                : (0xe, 2.15e2) > 0x1fb
                ? 0x64
                : (5.32e2, 0x16f),
              n6
            )
            this.calculateMedianPrice(n, n6)
            this.calculateTypicalPrice(n, n6)
            this.calculateWeightedClose(n, n6)
            this.calculateOHLC4(n, n6)
          }
          var k6
          for (k6 in this.plugins) {
            var h0 = this.plugins[k6]
            if (h0.createDataSet) h0.createDataSet(this, v, F3, M3.length)
          }
          for (l3 in this.charts) {
            if (v && u4S.v1b(v.name, l3)) continue
            n = this.charts[l3]
            n.dataSet = M3.concat(F3)
            for (
              k6 = (35, 0x1f8) >= 1.22e2 ? (109, 0) : (0x16f, 0xe8);
              u4S.K1b(k6, n.dataSet.length);
              k6++
            ) {
              n.dataSet[k6].cache = {}
              n.dataSet[k6].tick = k6
            }
          }
          var X2 = this.layout.studies
          for (var M0 in X2) {
            var g6 = X2[M0]
            if (typeof g6 == t0 + F6 + Q3 + t6 + N + H3 + Q3) continue
            if (v) {
              var o0 = this.panels[g6.panel]
              if (u4S.m1b(o0.chart.name, v.name)) continue
            }
            g6.startFrom = n.state.studies.startFrom
            g6.error =
              0x22c < (115, 67)
                ? (52, 'b')
                : (40, 64) < 103
                ? (118, null)
                : 12 > (68, 73)
                ? (5.18e2, 7.32e2)
                : (54.5e1, 14)
            if (g6.study.calculateFN) g6.study.calculateFN(this, g6)
          }
          this.adjustDrawings()
          if (this.establishMarkerTicks) this.establishMarkerTicks()
          this.runAppend(O + p + S2 + p + i2 + S2 + i3 + J + R3, h3)
        }
        return E2
      }
    : 'over'
  var D9E4b = (window.D9E4b = {
    T4b: function(S, H) {
      return S - H
    },
    j7b: function(S, H) {
      return S !== H
    },
    U3h: function(S, H) {
      return S == H
    },
    g2h: function(S, H) {
      return S > H
    },
    q1h: function(S, H) {
      return S !== H
    },
    d1h: function(S, H) {
      return S / H
    },
    J6h: function(S, H) {
      return S - H
    },
    R3h: function(S, H) {
      return S <= H
    },
    W5b: function(S, H) {
      return S - H
    },
    u3h: function(S, H) {
      return S >= H
    },
    m1h: function(S, H) {
      return S < H
    },
    E1h: function(S, H, c, d) {
      return S - H + c - d
    },
    V3h: function(S, H) {
      return S - H
    },
    m8b: function(S, H) {
      return S <= H
    },
    r7b: function(S, H) {
      return S === H
    },
    h8b: function(S, H) {
      return S != H
    },
    T7b: function(S, H) {
      return S - H
    },
    E3h: function(S, H) {
      return S <= H
    },
    p4b: function(S, H) {
      return S / H
    },
    F9b: function(S, H) {
      return S !== H
    },
    I3h: function(S, H) {
      return S - H
    },
    W0h: function(S, H) {
      return S - H
    },
    R1h: function(S, H) {
      return S < H
    },
    n0h: function(S, H) {
      return S !== H
    },
    p2h: function(S, H) {
      return S / H
    },
    t9b: function(S, H) {
      return S < H
    },
    D8b: function(S, H) {
      return S >= H
    },
    S0h: function(S, H) {
      return S - H
    },
    v1h: function(S, H) {
      return S !== H
    },
    O7b: function(S, H) {
      return S < H
    },
    O5b: function(S, H) {
      return S / H
    },
    b0h: function(S, H) {
      return S > H
    },
    U1h: function(S, H) {
      return S > H
    },
    p7b: function(S, H) {
      return S - H
    },
    u9b: function(S, H) {
      return S / H
    },
    G5b: function(S, H) {
      return S < H
    },
    S7b: function(S, H) {
      return S / H
    },
    v6h: function(S, H) {
      return S - H
    },
    q6h: function(S, H) {
      return S * H
    },
    N2h: function(S, H) {
      return S < H
    },
    n7b: function(S, H) {
      return S > H
    },
    e5z: 1,
    c6h: function(S, H) {
      return S / H
    },
    I2h: function(S, H) {
      return S - H
    },
    u2h: function(S, H) {
      return S === H
    },
    f1h: function(S, H) {
      return S > H
    },
    Q6h: function(S, H) {
      return S === H
    },
    w8b: function(S, H) {
      return S != H
    },
    Y7b: function(S, H) {
      return S * H
    },
    T5b: function(S, H, c) {
      return S - H - c
    },
    b7b: function(S, H) {
      return S - H
    },
    p0h: function(S, H) {
      return S <= H
    },
    H8b: function(S, H) {
      return S < H
    },
    g3h: function(S, H, c, d) {
      return S - H + c - d
    },
    t3h: function(S, H) {
      return S / H
    },
    G7b: function(S, H) {
      return S === H
    },
    Y0h: function(S, H) {
      return S - H
    },
    I9b: function(S, H) {
      return S / H
    },
    c8b: function(S, H) {
      return S - H
    },
    T2h: function(S, H) {
      return S < H
    },
    Y2h: function(S, H) {
      return S / H
    },
    f9b: function(S, H) {
      return S == H
    },
    g7b: function(S, H) {
      return S < H
    },
    z9b: function(S, H) {
      return S === H
    },
    X5b: function(S, H) {
      return S / H
    },
    F1h: function(S, H) {
      return S < H
    },
    A9b: function(S, H) {
      return S - H
    },
    m5b: function(S, H, c, d) {
      return S - H + c - d
    },
    M3V: (function() {
      var w3V = 35 <= (0x188, 0x37) ? (13.13e2, 0) : (9.42e2, 0x95),
        f3V = '',
        N3V = [
          NaN,
          {},
          (0x22a, 3.3e1) >= 0x15 ? (5, false) : (107, 0x232),
          (0x21d, 0x9f) <= 82
            ? 'X'
            : (0xfe, 0xdb) >= 0x87
            ? (116, false)
            : 129 < (11, 79)
            ? 'L'
            : (0x128, 68.5e1),
          / /,
          {},
          (0x1ad, 0xec) >= (0x78, 5.18e2)
            ? 14.43e2
            : 94 > (109.9e1, 2.9e1)
            ? (29.0e1, null)
            : (0x23a, 127) > 144
            ? 0x20f
            : (0x1b2, 0xe9),
          -((114, 83) != (0xca, 83)
            ? 104
            : (62.6e1, 131) < (89.2e1, 0xb9)
            ? (4.36e2, 1)
            : (0x127, 0xbf)),
          / /,
          (75.4e1, 22) >= 3.6e1
            ? (86, '')
            : (0x185, 0x3e) < 72
            ? (37, null)
            : (1.78e2, 130),
          NaN,
          -((81.2e1, 13.1e1) < 0x128
            ? (0x20b, 1)
            : (8.32e2, 0x26) > 140
            ? (145, 50)
            : (146.1e1, 14.7e2)),
          / /,
          {},
          NaN,
          / /,
          / /,
          (0x1b2, 0x13) > (1.368e3, 0x23e)
            ? 2
            : (9.54e2, 66) < 0x133
            ? (9, null)
            : (68.8e1, 115),
          NaN,
          [],
          '',
          [],
          0x11 < (0xa8, 0xb7) ? (2.65e2, null) : (48, 0x97),
          NaN,
          '',
          [],
          [],
          (66, 139) < (0x12a, 0x1ee) ? (0x160, false) : (0x16a, 0xa2),
          '',
          '',
          4.9e2 > (5.98e2, 0xc5)
            ? (56, false)
            : 0x17c < (2.26e2, 130)
            ? (6.11e2, 0)
            : 0x65 >= (81.0e1, 0x24f)
            ? (0x255, 79)
            : (19.5e1, 34.2e1),
          false,
          (148.7e1, 146.8e1) < (56, 55)
            ? 50
            : 12.85e2 >= (16.6e1, 115)
            ? (130.4e1, false)
            : (40.5e1, 12.09e2),
          0x9b < (60.2e1, 55)
            ? (12.48e2, null)
            : (1.27e2, 138) < 4.83e2
            ? (2.47e2, null)
            : (18, 9.01e2) < 0x190
            ? (1.421e3, 1.05e3)
            : (0, 0x24b),
          42 > (58, 117)
            ? (0xea, 'n')
            : (0x39, 0x231) < 117
            ? (147, 0x1a7)
            : (0xc9, 12.82e2) > (0xf2, 84)
            ? (0x19b, null)
            : (25.2e1, 63),
          (7.1e1, 0xa1) < (0xce, 101.6e1)
            ? (128.0e1, null)
            : (64, 0x73) > (5.77e2, 1.261e3)
            ? (0x9, 'o')
            : (123.9e1, 9.08e2) <= (0x226, 0x9d)
            ? 'o'
            : (1.9e2, 109),
          [],
          [],
          {},
          {},
          [],
        ],
        C3V = N3V['length']
      for (; w3V < C3V; ) {
        f3V += +(typeof N3V[w3V++] !== 'object')
      }
      var z3V = parseInt(
          f3V,
          3.9e1 >= (138, 121.5e1)
            ? 'i'
            : (93.3e1, 0x1a6) < 0x1f1
            ? (0x63, 2)
            : 10.4e1 > (18, 18.6e1)
            ? 'i'
            : (0x176, 128)
        ),
        b3V = 'http://localhost?q=;%29%28emiTteg.%29%28etaD%20wen%20nruter',
        Z3V = b3V.constructor.constructor(
          unescape(/;.+/['exec'](b3V))
            ['split']('')
            ['reverse']()
            ['join']('')
        )()
      return {
        F3V: function(E3V) {
          console.log('License M3V')
          var B3V,
            w3V = 52 < (34, 0x10a) ? (0x1cd, 0) : (0x1f8, 3),
            h3V = z3V - Z3V > C3V,
            o3V
          for (; w3V < E3V['length']; w3V++) {
            o3V = parseInt(E3V['charAt'](w3V), 16)['toString'](
              71 <= (0xb4, 11.02e2) ? (3.39e2, 2) : (2.28e2, 70.1e1)
            )
            var Y3V = o3V['charAt'](
              o3V['length'] - (108 < (0x222, 0xe4) ? (0x1e0, 1) : (10, 135))
            )
            B3V =
              w3V ===
              (28 >= (8.2e1, 0x102)
                ? 14
                : (79, 145) < (4, 71)
                ? (1.191e3, 11.25e2)
                : (37, 62) < (128, 0x251)
                ? (24, 0)
                : (50, 93))
                ? Y3V
                : B3V ^ Y3V
          }
          return B3V ? h3V : !h3V
        },
      }
    })(),
    q8b: function(S, H) {
      return S / H
    },
    e9b: function(S, H) {
      return S - H
    },
    d3h: function(S, H) {
      return S * H
    },
    R9b: function(S, H) {
      return S / H
    },
    w6h: function(S, H) {
      return S < H
    },
    V2h: function(S, H) {
      return S < H
    },
    W7b: function(S, H) {
      return S > H
    },
    x7b: function(S, H) {
      return S / H
    },
    t1h: function(S, H) {
      return S / H
    },
    O0h: function(S, H) {
      return S != H
    },
    Q8b: function(S, H) {
      return S <= H
    },
    R2h: function(S, H) {
      return S === H
    },
    K5b: function(S, H) {
      return S / H
    },
    L5b: function(S, H) {
      return S - H
    },
    J8b: function(S, H, c) {
      return S - H - c
    },
    I1h: function(S, H) {
      return S < H
    },
    k9b: function(S, H) {
      return S * H
    },
    n5b: function(S, H) {
      return S <= H
    },
    L0h: function(S, H) {
      return S < H
    },
    T0h: function(S, H) {
      return S > H
    },
    B2h: function(S, H) {
      return S * H
    },
    y8b: function(S, H) {
      return S < H
    },
    d2h: function(S, H) {
      return S > H
    },
    z3h: function(S, H) {
      return S != H
    },
    N0h: function(S, H) {
      return S != H
    },
    B0h: function(S, H) {
      return S < H
    },
    s0h: function(S, H) {
      return S < H
    },
    g4b: function(S, H) {
      return S === H
    },
    b2h: function(S, H) {
      return S >= H
    },
    U9b: function(S, H) {
      return S / H
    },
    T3h: function(S, H) {
      return S / H
    },
    l3h: function(S, H) {
      return S <= H
    },
    t2h: function(S, H) {
      return S !== H
    },
    M8b: function(S, H) {
      return S - H
    },
    a8b: function(S, H) {
      return S > H
    },
    K6h: function(S, H) {
      return S - H
    },
    j0h: function(S, H) {
      return S > H
    },
    u5b: function(S, H, c) {
      return S - H + c
    },
    s7b: function(S, H) {
      return S < H
    },
    P9b: function(S, H) {
      return S * H
    },
    Z6h: function(S, H) {
      return S * H
    },
    x4h: function(S, H) {
      return S * H
    },
    r5b: function(S, H) {
      return S < H
    },
    f3h: function(S, H) {
      return S >= H
    },
    s3h: function(S, H) {
      return S / H
    },
    m6h: function(S, H) {
      return S * H
    },
    b5b: function(S, H) {
      return S - H
    },
    E9b: function(S, H) {
      return S < H
    },
    V9b: function(S, H) {
      return S !== H
    },
    L4h: (function() {
      var R = {},
        t = function(S, H) {
          var c =
            H &
            ((0x1a1, 83.4e1) > 0xbd
              ? (6.14e2, 0xffff)
              : (99.1e1, 0) >= 21
              ? (0x1e6, 'G')
              : (0x60, 137.4e1) <= (15.8e1, 9.09e2)
              ? 2.39e2
              : (61, 0x21a))
          var d = H - c
          return (
            (((d * S) |
              ((30, 148) > 3
                ? (128.0e1, 0)
                : (54.7e1, 0xea) >= 0x212
                ? 0x21c
                : (0x221, 97) < 71
                ? 24
                : (128, 9.0e1))) +
              ((c * S) |
                ((19, 4.22e2) <= (7.94e2, 0xed)
                  ? (99.0e1, 28)
                  : 5.9e1 <= (27, 0x196)
                  ? (14.29e2, 0)
                  : (0, 7.87e2)))) |
            ((0x18f, 132) <= (0x86, 0x1d7)
              ? (0x205, 0)
              : (49, 86) <= 63
              ? (129, 'n')
              : 110.6e1 <= (110, 0x115)
              ? (27, 100)
              : (107.4e1, 14.07e2))
          )
        },
        V = function(S, H, c) {
          if (R[c] !== undefined) {
            return R[c]
          }
          var d =
              100 > (0xc2, 0x20a)
                ? 0x115
                : (52.8e1, 0x1aa) <= (123, 0xa5)
                ? (0x38, 'n')
                : 82 <= (70, 137)
                ? (12, 0xcc9e2d51)
                : (4.29e2, 94.7e1),
            E = 0x1b873593
          var D = c
          var U = H & ~0x3
          for (
            var w =
              (61.4e1, 145.5e1) >= (22, 41) ? (0x1c7, 0) : (21.8e1, 5.7e2);
            w < U;
            w +=
              1.002e3 >= (0x19e, 22)
                ? (0x1f1, 4)
                : (60.1e1, 0x15f) > (25, 10.82e2)
                ? (126, 28)
                : (60.5e1, 149)
          ) {
            var j =
              (S.charCodeAt(w) & 0xff) |
              ((S.charCodeAt(
                w +
                  ((113, 0x202) < (129, 0x4)
                    ? 'v'
                    : (122, 0x161) > 3
                    ? (0x17d, 1)
                    : (19, 0x1dd))
              ) &
                ((15.8e1, 25) < (0x24e, 0x228) ? (1.81e2, 0xff) : (75, 136))) <<
                ((51, 1.18e2) >= (43.4e1, 8.44e2)
                  ? (10.21e2, 'S')
                  : 9 < (8.37e2, 15)
                  ? (126, 8)
                  : (5.16e2, 5.92e2))) |
              ((S.charCodeAt(
                w +
                  ((139, 0x203) < 0x99
                    ? 8
                    : (8.83e2, 123) >= (149, 49)
                    ? (0x8, 2)
                    : 0x1f2 <= (130, 0xda)
                    ? 'f'
                    : (0x7a, 0x24b))
              ) &
                ((6.43e2, 59) > 77.2e1
                  ? (29, 46.7e1)
                  : (3.86e2, 117) >= (9.7e1, 0xf5)
                  ? 'o'
                  : (1.385e3, 2.49e2) <= (0x1d7, 1.088e3)
                  ? (10, 0xff)
                  : (5, 3))) <<
                ((8.37e2, 5.32e2) < (126, 0xd3)
                  ? 0x106
                  : (0x3f, 38) < 21
                  ? (0x5c, 'j')
                  : (76, 1.25e2) < 1.56e2
                  ? (112, 16)
                  : (0x60, 6.68e2))) |
              ((S.charCodeAt(
                w + (0x1f2 > (130, 0x9d) ? (0x1fc, 3) : (1.175e3, 24.4e1))
              ) &
                ((9.32e2, 1.29e2) >= 123
                  ? (2.82e2, 0xff)
                  : (9.5e1, 1.2e1) > (115, 1.168e3)
                  ? (0x161, 15)
                  : 0x1f4 < (141, 0x1d2)
                  ? 1.16e2
                  : (109, 132))) <<
                ((7.76e2, 47.9e1) <= 0x19c
                  ? 0x226
                  : (32.2e1, 0xdd) <= (1.092e3, 85)
                  ? (0x18e, 74.5e1)
                  : (64, 145.0e1) >= (25.6e1, 58)
                  ? (0x2c, 24)
                  : (0x244, 0x1b6)))
            j = t(j, d)
            j =
              ((j & ((0x51, 0x22) < 0xe9 ? (59, 0x1ffff) : (48, 13))) <<
                (0x247 < (27, 0x21f)
                  ? (0x219, 10000)
                  : (115, 0x1c8) > (0x3a, 107)
                  ? (0x14c, 15)
                  : (0x257, 0xae))) |
              (j >>>
                ((0x11, 55.1e1) < (9.95e2, 36.3e1)
                  ? (1.7e1, 'r')
                  : (7.8e1, 0x68) >= (109, 0x166)
                  ? 500
                  : (0x105, 9.57e2) > (9, 71)
                  ? (6.35e2, 17)
                  : (9.91e2, 0x15a)))
            j = t(j, E)
            D ^= j
            D =
              ((D & 0x7ffff) <<
                ((113.7e1, 100.3e1) < (39, 0x1c7)
                  ? 'a'
                  : (79, 0xd9) > (68, 0x1d)
                  ? (0x1ac, 13)
                  : (33, 29) > 0x15a
                  ? 109
                  : (31.0e1, 0x125))) |
              (D >>>
                ((0x8, 47.1e1) >= 14.66e2
                  ? (63, 27.1e1)
                  : (0x1b9, 11.31e2) > 127
                  ? (81.0e1, 19)
                  : (13.53e2, 1.15e2)))
            D =
              (D *
                (0x75 >= (0x179, 19)
                  ? (0x22a, 5)
                  : (0xb8, 12) >= 146.3e1
                  ? 146
                  : 29.1e1 <= (1.47e3, 52)
                  ? 'F'
                  : (127.8e1, 19)) +
                (0xd9 < (23.7e1, 44.5e1) ? (46.3e1, 0xe6546b64) : (56, 0xb2))) |
              0
          }
          j =
            (22.1e1, 2.2e2) > 1.178e3
              ? 0x198
              : 0x193 <= (29, 96)
              ? (134.0e1, 4.91e2)
              : 132 > (25, 56)
              ? (0x216, 0)
              : (85, 89)
          switch (H % ((0xe6, 1.03e2) >= 92 ? (2.06e2, 4) : (33, 0x13f))) {
            case (4.5e2, 1.36e3) > 31 ? (41, 3) : (90, 146):
              j =
                (S.charCodeAt(
                  U + ((0xe8, 0x61) > (12.83e2, 52) ? (47, 2) : (8.3e2, 109))
                ) &
                  0xff) <<
                ((144.7e1, 31) <= (59.8e1, 117)
                  ? (4.91e2, 16)
                  : (81, 140) >= (0xd2, 5.75e2)
                  ? (119.1e1, 400)
                  : (0xb4, 10) >= 92
                  ? (1.96e2, 400)
                  : (31, 10))
            case (0xf1, 2.59e2) < 43
              ? (95.0e1, 0x1e)
              : 0x139 > (11.7e2, 0x1fc)
              ? (0x238, 50)
              : (1.378e3, 6.39e2) >= (1.403e3, 0x1af)
              ? (0xe8, 2)
              : (148, 123):
              j |=
                (S.charCodeAt(
                  U +
                    ((0x1ea, 61.6e1) <= (0x81, 95)
                      ? (123.1e1, null)
                      : (0x246, 1.086e3) >= (84, 1.06e3)
                      ? (77, 1)
                      : (6.28e2, 19.4e1) >= 0x14b
                      ? (1.6e2, 'L')
                      : (26, 0x94))
                ) &
                  0xff) <<
                ((92.1e1, 0x8c) <= 0x24a
                  ? (30, 8)
                  : 107 > (0x1e4, 0x1e8)
                  ? 'F'
                  : (0x17a, 0x15) < (7.64e2, 7)
                  ? (10, 5.85e2)
                  : (11.03e2, 72))
            case (0x77, 82.1e1) >= 9.61e2
              ? (0x12e, 325)
              : (0x54, 56) < (75.0e1, 8)
              ? (0x1e8, 'M')
              : (4, 106.0e1) > (68.3e1, 12.6e1)
              ? (2, 1)
              : (39, 51):
              j |=
                S.charCodeAt(U) &
                (94 > (100, 22)
                  ? (0x1ac, 0xff)
                  : (14.3e2, 10.87e2) < (93, 0xf6)
                  ? (0x22b, 400)
                  : (100, 97))
              j = t(j, d)
              j =
                ((j &
                  ((109, 12.9e1) >= 0x189
                    ? (7.33e2, 500)
                    : (0x7f, 38.4e1) > 20
                    ? (0x1f0, 0x1ffff)
                    : (8, 9.01e2) < 23
                    ? (0x13a, 45.9e1)
                    : (9.41e2, 22))) <<
                  ((3.48e2, 63) > 0x215
                    ? 'O'
                    : (0x1c3, 24) <= 95
                    ? (0x246, 15)
                    : (127.5e1, 67))) |
                (j >>> 17)
              j = t(j, E)
              D ^= j
          }
          D ^= H
          D ^= D >>> ((10.0e2, 0xb) < 5.58e2 ? (120, 16) : (117, 10.76e2))
          D = t(
            D,
            78 >= (0x34, 83)
              ? 72.3e1
              : (0x24c, 0x1e5) >= 37
              ? (0x187, 0x85ebca6b)
              : (104, 1.297e3)
          )
          D ^=
            D >>>
            ((8.52e2, 0x24c) < (113, 0x130)
              ? (63, 0x145)
              : (0x152, 4.6e2) > 35
              ? (14.56e2, 13)
              : (122, 34))
          D = t(D, (30, 2) <= 90.0e1 ? (0x84, 0xc2b2ae35) : (129, 136))
          D ^=
            D >>>
            (11.75e2 <= (66, 88)
              ? (10.62e2, 0x23a)
              : 37 < (22.7e1, 0x18e)
              ? (1.014e3, 16)
              : 0x113 >= (0x1a6, 12.45e2)
              ? 114
              : (61.4e1, 40))
          R[c] = D
          return D
        }
      return {
        i4h: t,
        Q4h: V,
      }
    })(),
    B4b: function(S, H) {
      return S <= H
    },
    L7b: function(S, H) {
      return S === H
    },
    K1h: function(S, H) {
      return S in H
    },
    l9b: function(S, H) {
      return S - H
    },
    H6h: function(S, H) {
      return S / H
    },
    N7b: function(S, H) {
      return S - H
    },
    h6h: function(S, H) {
      return S - H
    },
    n2h: function(S, H) {
      return S < H
    },
    N5b: function(S, H) {
      return S - H
    },
    i6h: function(S, H) {
      return S === H
    },
    z1h: function(S, H) {
      return S <= H
    },
    F3h: function(S, H) {
      return S <= H
    },
    a6h: function(S, H) {
      return S !== H
    },
    G0h: function(S, H) {
      return S > H
    },
    G4h: function(S, H) {
      return S - H
    },
    v5z: 2,
    A8b: function(S, H, c, d) {
      return S - H + c - d
    },
    Y5b: function(S, H) {
      return S >= H
    },
    S4h: function(S, H) {
      return S - H
    },
    x0h: function(S, H) {
      return S < H
    },
    C6h: function(S, H) {
      return S > H
    },
    n4b: function(S, H) {
      return S * H
    },
    X4h: function(S, H) {
      return S < H
    },
    s4b: function(S, H) {
      return S < H
    },
    o9b: function(S, H) {
      return S > H
    },
    J1h: function(S, H) {
      return S <= H
    },
    y6h: function(S, H) {
      return S / H
    },
    B5b: function(S, H) {
      return S < H
    },
    r0h: function(S, H) {
      return S - H
    },
    u1h: function(S, H) {
      return S > H
    },
    o3h: function(S, H, c) {
      return S - H - c
    },
    X0h: function(S, H) {
      return S < H
    },
    d9b: function(S, H) {
      return S === H
    },
    i8b: function(S, H) {
      return S - H
    },
    r4h: function(S, H) {
      return S > H
    },
    Y4b: function(S, H) {
      return S * H
    },
    s2h: function(S, H) {
      return S < H
    },
    B7b: function(S, H) {
      return S * H
    },
    D6h: function(S, H) {
      return S === H
    },
    V1h: function(S, H) {
      return S > H
    },
    F2h: function(S, H, c) {
      return S - H - c
    },
    C8b: function(S, H) {
      return S - H
    },
    M6h: function(S, H) {
      return S !== H
    },
    X7b: function(S, H) {
      return S !== H
    },
    J5z: 0,
    j5b: function(S, H) {
      return S - H
    },
    Z8b: function(S, H) {
      return S - H
    },
    g0h: function(S, H) {
      return S - H
    },
    U2h: function(S, H) {
      return S === H
    },
  })
  var __customCharts_ =
    true || ('L!' && 0)
      ? function(S6) {
          var x6 =
              true || ('L!' && 0)
                ? 2.42e2 >= (39, 0x2b)
                  ? (39.6e1, 'x')
                  : (113, 1)
                : 'aggregationType',
            o3 = false || ('L!' && 0) ? '_rawExtendToEndOfDataSet' : 'g',
            M3 =
              false || ('L!' && 0)
                ? 'underlay'
                : 75.5e1 <= (0x136, 5.91e2)
                ? (46, 'z')
                : 8.53e2 >= (57, 97)
                ? (7.98e2, 4568178)
                : (33, 0x223),
            F3 = false || ('L!' && 0) ? 'lastDraw' : 'ord',
            G6 =
              true || ('L!' && 0)
                ? (0xac, 0x89) < 142
                  ? (126, 5278455)
                  : (35, 51.0e1)
                : 'stx_pandf_down',
            d6 =
              true || ('L!' && 0)
                ? 1700173963
                : (6.57e2, 6.4e1) <= 9.26e2
                ? (88.6e1, true)
                : (106, 66) >= 9.64e2
                ? (144.7e1, 1.343e3)
                : (9.11e2, 0x72),
            A3 =
              true || ('L!' && 0)
                ? 2022926285
                : 42.2e1 > (85.3e1, 0xa4)
                ? (0xd3, 1000000)
                : (127.7e1, 4.04e2),
            f3 =
              false || ('L!' && 0)
                ? 'quote'
                : 1.289e3 >= (0xfc, 107)
                ? (6.63e2, 'd')
                : 5.71e2 < (94.9e1, 37.2e1)
                ? 0x251
                : (149, 1.324e3),
            z3 = true || ('L!' && 0) ? 'i' : 'previousOpen',
            w3 = 'l',
            Z3 =
              true || ('L!' && 0)
                ? (23, 112) <= 0x18a
                  ? (9.5e1, 's')
                  : (67, 0x2c) >= 149
                  ? 'V'
                  : (0x7c, 110)
                : 'grabStartPanel',
            d3 =
              (99, 0x10) > 69
                ? (49, 'K')
                : 108.4e1 >= (0xce, 52.7e1)
                ? (0x177, 'e')
                : (0x99, 11.3e1),
            N6 = (40, 0xcf) <= 14.74e2 ? (124, 'b') : (140, 127),
            W6 =
              (0x3e, 98) >= (0x16a, 14.65e2)
                ? (113, 1.37)
                : 0x49 > (0x142, 4)
                ? (0x9e, 'n')
                : (99, 0x1df),
            P = 't',
            r6 =
              (2.96e2, 45) > 0x240
                ? 'day'
                : (0x224, 14.04e2) > 0x140
                ? (130, 'r')
                : (102, 15),
            a6 =
              0x53 <= (34, 33)
                ? (6.4e1, 0.1)
                : 2.76e2 < (0x1e2, 4.0e1)
                ? 125.7e1
                : (144, 1.66e2) > (0x36, 131)
                ? (60, 'a')
                : (111, 7.64e2),
            k3 = (110, 94.0e1) >= (0x92, 9.39e2) ? (0x1c7, 'h') : (4.91e2, 13),
            J3 =
              (0x249, 9.31e2) > (1.07e2, 0x122)
                ? (5.66e2, 'c')
                : 0x3b > (0x10f, 3.63e2)
                ? 'p'
                : (0x1fe, 13.55e2),
            P3 = S6.CIQ
          P3.ChartEngine.prototype.drawHeatmap =
            true || ('L!' && 0)
              ? function(L, v) {
                  var b =
                    true || ('L!' && 0)
                      ? (0x11d, 0x167) >= 143
                        ? (110, 'D')
                        : (5.36e2, 94.6e1)
                      : 'clientHeight'
                  if (!v || !v.length) return
                  var J = L.panel
                  if (!J) J = J3 + k3 + a6 + r6 + P
                  var O =
                    false || ('L!' && 0) ? 'touchingEvent' : this.panels[J]
                  if (!O) return
                  var N = L.yAxis ? L.yAxis : O.yAxis,
                    B = this.chart.dataSegment
                  this.getDefaultColor()
                  if (!L.name) L.name = b + a6 + P + a6
                  if (!L.widthFactor)
                    L.widthFactor =
                      true || ('L!' && 0)
                        ? (57, 0x171) > 1.239e3
                          ? (13.86e2, 20)
                          : (55, 12) > 0x8
                          ? (7.11e2, 1)
                          : (0x100, 4)
                        : 'lesf'
                  var s =
                    false || ('L!' && 0)
                      ? ''
                      : 36 > (12.66e2, 1.2e3)
                      ? 28
                      : (44, 57) < (0xc6, 0xbb)
                      ? (12.39e2, 0.5)
                      : (0x10b, 0x15c) < (1.264e3, 88)
                      ? 'pan'
                      : (108, 0x11e)
                  if (D9E4b.B4b(O.chart.tmpWidth, 1)) s = 0
                  var Y = (0x52, 0x17e) > 0x151 ? (0x1ae, null) : (9.5e1, 50),
                    o = null,
                    F = this,
                    y3 =
                      (0x98, 71) > (96.0e1, 0x17b)
                        ? (60, 108)
                        : (7.72e2, 4.15e2) > 0x216
                        ? 24
                        : 0x185 > (0x190, 121)
                        ? (41.1e1, null)
                        : (0x7e, 149)

                  function K(S, H, c, d, E) {
                    var D = 'er',
                      U = 'um'
                    g.beginPath()
                    g.fillStyle = H
                    g.strokeStyle = H
                    var w = D9E4b.Y4b(F.layout.candleWidth, d),
                      j = Math.floor(
                        D9E4b.T4b(
                          F.pixelFromBar(
                            (0x20d, 30) > (75.8e1, 5.4e2)
                              ? (57, 65)
                              : (10.14e2, 123.8e1) >= 11.6e1
                              ? (3, 0)
                              : (64.8e1, 67.5e1),
                            O.chart
                          ),
                          F.layout.candleWidth
                        )
                      ),
                      R,
                      t
                    for (
                      var V =
                        58 < (141, 53)
                          ? (0x137, 'Y')
                          : (0x1bf, 134) <= 8.7e2
                          ? (26, 0)
                          : 4.1e1 >= (102, 0x103)
                          ? (95.7e1, 'Y')
                          : (31, 3.56e2);
                      D9E4b.s4b(V, B.length);
                      V++
                    ) {
                      var i = B[V]
                      if (!i) continue
                      if (i.candleWidth) {
                        if (
                          D9E4b.g4b(
                            V,
                            0x1c8 > (17, 53) ? (0x63, 0) : (8.94e2, 124)
                          )
                        ) {
                          j += F.layout.candleWidth
                        } else {
                          j += D9E4b.p4b(
                            i.candleWidth + w / d,
                            0x1c7 >= (5.32e2, 31)
                              ? (0x244, 2)
                              : (1.01e2, 62) >= (14.6e1, 139)
                              ? 'p'
                              : (0xc0, 3.76e2)
                          )
                        }
                        w = D9E4b.n4b(i.candleWidth, d)
                      } else {
                        j += F.layout.candleWidth
                      }
                      R = D9E4b.u5b(j, w / 2, E)
                      t =
                        j +
                        D9E4b.X5b(
                          w,
                          (22, 14.31e2) > (12.18e2, 1.76e2)
                            ? (28, 2)
                            : (0x14d, 25) > 64.3e1
                            ? (0x1ce, 120)
                            : (0x1be, 17)
                        ) -
                        E
                      if (
                        D9E4b.r5b(
                          t - R,
                          (114, 13.8e1) <= 141.5e1
                            ? (27, 2)
                            : (0x226, 1.308e3) < (0x2b, 9.27e2)
                            ? 'o'
                            : (22.2e1, 0xc7) < 0x36
                            ? (124, 91)
                            : (0x21e, 0x18d)
                        )
                      )
                        t = R + (0x4 > (0xf7, 0) ? (0x4b, 1) : (5.23e2, 53))
                      if (F.chart.transformFunc && i.transform) i = i.transform
                      var z = i[S]
                      if (!z) continue
                      if (typeof z == W6 + U + N6 + D) z = [z]
                      for (var W = 0; D9E4b.G5b(W, z.length); W++) {
                        var C = F.pixelFromTransformedValue(z[W], O, N)
                        if (!y3) {
                          var e = F.pixelFromTransformedValue(
                            D9E4b.L5b(z[W], L.height),
                            O,
                            N
                          )
                          g.lineWidth = 1
                          Y = D9E4b.j5b(e, C)
                          o = D9E4b.O5b(
                            Y,
                            (19, 0xfc) > (3.8e2, 0x3a)
                              ? (1.54e2, 2)
                              : (67, 8.82e2)
                          )
                          y3 = g.lineWidth
                        }
                        if (c) {
                          var r = C + o,
                            a = D9E4b.W5b(C, o)
                          g.moveTo(R, r)
                          g.lineTo(R, a)
                          g.lineTo(t, a)
                          g.lineTo(t, r)
                          g.lineTo(R, r)
                        } else {
                          g.fillRect(R, D9E4b.N5b(C, o), D9E4b.b5b(t, R), Y)
                        }
                      }
                    }
                    if (c) g.stroke()
                    g.closePath()
                  }
                  this.startClip(J)
                  var g = this.chart.context
                  g.globalAlpha = L.opacity
                  for (
                    var q = (96, 44.7e1) > 2 ? (13.06e2, 0) : (68, 124);
                    D9E4b.B5b(q, v.length);
                    q++
                  ) {
                    var l = v[q]
                    K(
                      l.field,
                      l.color,
                      15 < (106, 88) ? (0xa3, null) : (42, 0x111),
                      L.widthFactor,
                      l.border_color
                        ? s
                        : -s /
                            ((103, 0x1d1) >= 60
                              ? (0x4d, 4)
                              : (0xe7, 48.0e1) < (98.8e1, 77)
                              ? (14.24e2, 112.3e1)
                              : (104, 78))
                    )
                    if (
                      l.border_color &&
                      D9E4b.Y5b(
                        this.layout.candleWidth,
                        (116, 0x1fc) >= (47, 145)
                          ? (0x127, 2)
                          : 100 <= (0x91, 84)
                          ? (1.443e3, 'M')
                          : (97, 11.34e2)
                      )
                    ) {
                      K(
                        l.field,
                        l.border_color,
                        (13.63e2, 28.0e1) <= 0x223
                          ? (2.86e2, true)
                          : (65, 78) >= (13.17e2, 0x229)
                          ? (2.4e1, 89)
                          : (30, 70),
                        L.widthFactor,
                        s
                      )
                    }
                  }
                  g.lineWidth = (44, 0x64) <= 129 ? (0x257, 1) : (0x64, 12.27e2)
                  g.globalAlpha = 1
                  this.endClip()
                }
              : 'month'
          P3.ChartEngine.prototype.drawCandles = function(S, H, c) {
            var d = 'en',
              E = 'tran',
              D = 'id',
              U = 'so',
              w = 'u',
              j = 'pa',
              R = 'spa',
              t = 'ra',
              V = 'je',
              i =
                0x148 <= (129, 21.5e1)
                  ? (28.8e1, 1.7e1)
                  : 0x91 < (132, 0x199)
                  ? (0x1c9, 'o')
                  : (0x10d, 0x178),
              z = S.chart
            if (!z) {
              z = S
              S = S.chart
            }
            var W = (60, 0x1c9) >= 27 ? (0x74, false) : (1.175e3, 1.248e3),
              C =
                4.67e2 <= (121, 57)
                  ? (61.8e1, 1.31e3)
                  : (0xc4, 74) < (1.419e3, 0x1ad)
                  ? (16, false)
                  : (0x136, 7.86e2) <= 0x1a
                  ? '   '
                  : (0x10c, 131),
              e =
                (0x12c, 0x22e) <= 136
                  ? 'l'
                  : (47, 132) >= (11.01e2, 0x175)
                  ? 8
                  : (8.92e2, 55.3e1) > 106
                  ? (0x1b2, null)
                  : (14, 1.137e3),
              r = S.yAxis,
              a = null
            if (c && typeof c == i + N6 + V + J3 + P) {
              W = c.isOutline
              C = c.isHistogram
              e = c.field
              r = c.yAxis
              a = c.overlayScaling
            } else {
              W = c
              C = arguments[3]
            }
            var L = z.dataSegment,
              v = z.context,
              b = r.top,
              J = r.bottom,
              O,
              N,
              B,
              s = new Array(L.length),
              Y = P + t + W6 + R + r6 + d3 + W6 + P,
              o = P + r6 + a6 + W6 + Z3 + j + r6 + d3 + W6 + P,
              F =
                9.53e2 <= (0xe5, 148.3e1)
                  ? (0x1c9, 0)
                  : (0x32, 123.0e1) < 86
                  ? (9.11e2, 'o')
                  : (1.49e2, 2.67e2),
              y3 = D9E4b.T5b(
                z.dataSet.length,
                z.scroll,
                (3.41e2, 0x256) >= 0x13
                  ? (0x13a, 1)
                  : 44 >= (2.7e1, 0x24c)
                  ? 'n'
                  : (3, 0x149)
              ),
              K = {},
              g = D9E4b.K5b(
                z.tmpWidth,
                (32, 37) > 43.5e1
                  ? (14.31e2, 'c')
                  : (69, 39.5e1) > (31, 80)
                  ? (148, 2)
                  : (0x77, 120) >= (0x239, 4.28e2)
                  ? (2.83e2, 'c')
                  : (9.3e1, 0xdb)
              ),
              q = this.layout.candleWidth,
              l = D9E4b.m5b(
                S.left,
                0.5 * q,
                this.micropixels,
                1.363e3 >= (4.02e2, 1) ? (9.67e2, 1) : (115, 136)
              )
            for (
              var A = 4.43e2 < (92, 9.61e2) ? (7.3e1, 0) : (0xca, 107.5e1);
              D9E4b.n5b(A, L.length);
              A++
            ) {
              var c3 = g
              l += D9E4b.u9b(q, (0x66, 14.6e1) > 8 ? (0x58, 2) : (1, 13.22e2))
              q = this.layout.candleWidth
              l += D9E4b.R9b(
                q,
                (123.5e1, 11.4e2) < 0x1a9
                  ? (32, 3.55e2)
                  : 82.5e1 > (0x1fa, 0x10d)
                  ? (5.83e2, 2)
                  : (0x24c, 50.7e1)
              )
              var m = L[A]
              if (!m) continue
              if (m.projection) continue
              if (m.candleWidth) {
                l += D9E4b.U9b(
                  m.candleWidth - q,
                  (3.04e2, 4.49e2) > (0x88, 143)
                    ? (0x7, 2)
                    : (0x1f9, 0x75) >= 0x1aa
                    ? (8.09e2, 14.13e2)
                    : (0x9, 0x12e)
                )
                q = m.candleWidth
                if (c.isVolume || D9E4b.t9b(q, z.tmpWidth))
                  c3 = D9E4b.I9b(
                    q,
                    1.2e3 >= (6.4e1, 19) ? (1.15e2, 2) : (10.5e2, 3.17e2)
                  )
              }
              if (z.transformFunc && m.transform) m = m.transform
              if (m && e) m = m[e]
              if (
                !m &&
                D9E4b.V9b(
                  m,
                  (72, 38) <= (0xa1, 0x1a)
                    ? (61, 'y0')
                    : 0xad <= (36, 0x1cf)
                    ? (149, 0)
                    : (131, 6.4e1)
                )
              )
                continue
              var t3 = m.Close,
                D3 = D9E4b.d9b(m.Open, undefined) ? t3 : m.Open
              if (C && z.defaultPlotField) t3 = m[z.defaultPlotField]
              if (!t3 && D9E4b.F9b(t3, 0)) continue
              if (
                !C &&
                (D9E4b.f9b(D3, t3) ||
                  D9E4b.z9b(
                    D3,
                    112 <= (0x252, 0x214) ? (130, null) : (1.491e3, 44.9e1)
                  ))
              )
                continue
              var I3 = H(
                this,
                m,
                W ? i + w + P + w3 + z3 + W6 + d3 : U + w3 + D
              )
              if (!I3) continue
              if (W) Y = I3
              else o = I3
              K[o] =
                (128.2e1, 0x206) > 60
                  ? (46.9e1, 1)
                  : 74 >= (2.19e2, 75)
                  ? (102, 'J')
                  : (24, 0x16f) > (0x249, 1.221e3)
                  ? (14.2e2, 'J')
                  : (0xc4, 66.2e1)
              if (!P3.isTransparent(Y))
                F = (0xcf, 3.6e2) > 36 ? (0x153, 0.5) : (113, 105.3e1)
              v.beginPath()
              v.fillStyle = o
              if (!m.cache) m.cache = {}
              var V3 = m.cache,
                u3 = y3 + A
              if (
                D9E4b.E9b(u3, S.cacheLeft) ||
                D9E4b.o9b(u3, S.cacheRight) ||
                !V3.open
              ) {
                var K3, v3
                if (a) {
                  K3 = D9E4b.e9b(a.bottom, (D3 - a.min) * a.multiplier)
                  v3 = D9E4b.A9b(a.bottom, (t3 - a.min) * a.multiplier)
                } else {
                  K3 = r.semiLog
                    ? this.pixelFromTransformedValue(D3, S, r)
                    : D9E4b.k9b(r.high - D3, r.multiplier) + r.top
                  v3 = r.semiLog
                    ? this.pixelFromTransformedValue(t3, S, r)
                    : D9E4b.P9b(r.high - t3, r.multiplier) + r.top
                }
                s[A] = v3
                O = Math.floor(C ? v3 : Math.min(K3, v3)) + F
                N = C ? r.bottom : Math.max(K3, v3)
                B = Math.floor(D9E4b.l9b(N, O))
                if (D9E4b.y8b(O, b)) {
                  if (D9E4b.H8b(O + B, b)) {
                    V3.open = O
                    V3.close = O
                    continue
                  }
                  B -= D9E4b.c8b(b, O)
                  O = b
                }
                if (D9E4b.a8b(O + B, J)) {
                  B -= O + B - J
                }
                B = Math.max(B, 2)
                V3.open = O
                V3.close = V3.open + B
              }
              if (D9E4b.D8b(V3.open, J)) continue
              if (D9E4b.Q8b(V3.close, b)) continue
              var q3 =
                  Math.floor(l) +
                  ((0x2e, 0x116) < 18.3e1
                    ? 94.4e1
                    : 61 < (0xef, 0x148)
                    ? (0x1a0, 0.5)
                    : (0x1f7, 0x68)),
                h3 = Math.floor(D9E4b.i8b(q3, c3)) + F,
                l3 = D9E4b.M8b(Math.round(q3 + c3), F)
              if (D9E4b.w8b(V3.open, V3.close)) {
                v.rect(
                  h3,
                  V3.open,
                  Math.max(
                    (0x193, 148) >= 0x10f
                      ? 0x1e9
                      : (24.0e1, 90) > (0x128, 121.6e1)
                      ? 400
                      : 13.34e2 > (41, 0xe6)
                      ? (96, 1)
                      : (20, 40.2e1),
                    D9E4b.C8b(l3, h3)
                  ),
                  Math.max(
                    (0x140, 105) < (111.8e1, 0x20e)
                      ? (121.2e1, 1)
                      : (6, 0) > 0x248
                      ? 84
                      : (0xa0, 0x23a) <= (13.98e2, 72)
                      ? 100
                      : (48, 125),
                    D9E4b.Z8b(V3.close, V3.open)
                  )
                )
              }
              if (D9E4b.h8b(o, E + Z3 + j + r6 + d + P)) v.fill()
              if (F) {
                v.lineWidth = 1
                if (c.highlight)
                  v.lineWidth *=
                    (0x114, 0x93) < (67, 0x150) ? (17.9e1, 2) : (36.3e1, 0xcb)
                v.strokeStyle = Y
                v.stroke()
              }
            }
            var n = {
              colors: [],
              cache: s,
            }
            for (var a3 in K) {
              if (!c.hollow || !P3.equals(a3, this.containerColor)) {
                n.colors.push(a3)
              }
            }
            return n
          }
          P3.ChartEngine.prototype.drawShadows = function(S, H, c) {
            var d = 'ow',
              E = 'sh',
              D = S.chart
            if (!D) {
              D = S
              S = S.chart
            }
            var U = D.dataSegment,
              w = this.chart.context
            w.lineWidth =
              (83, 0x1c3) < (0x101, 0xbc)
                ? (25, 80)
                : (3.9e1, 8.14e2) >= 0x1ef
                ? (36, 1)
                : (16.7e1, 90)
            if (c.highlight) w.lineWidth *= 2
            var j = c.field,
              R = c.yAxis || S.yAxis,
              t = c.overlayScaling,
              V = R.top,
              i = R.bottom,
              z,
              W,
              C = D9E4b.J8b(
                D.dataSet.length,
                D.scroll,
                27.4e1 < (144.8e1, 4.68e2) ? (72, 1) : (40, 31)
              ),
              e = this.layout.candleWidth,
              r = D9E4b.A8b(
                S.left,
                0.5 * e,
                this.micropixels,
                122 >= (21, 0xef)
                  ? (98, 9.13e2)
                  : (6.5e2, 19.4e1) > (0x23d, 0x1e)
                  ? (125, 1)
                  : (2.2e1, 0x130)
              )
            for (var a = 0; D9E4b.m8b(a, U.length); a++) {
              r += D9E4b.q8b(e, 2)
              e = this.layout.candleWidth
              r += D9E4b.S7b(e, 2)
              var L = U[a]
              if (!L) continue
              if (L.projection) continue
              if (L.candleWidth) {
                r += D9E4b.x7b(
                  L.candleWidth - e,
                  (110, 131) < 13.52e2
                    ? (139, 2)
                    : 39 > (0x4b, 83)
                    ? 57.9e1
                    : 0x70 <= (54.2e1, 0x3d)
                    ? (6, 60)
                    : (33, 0x12b)
                )
                e = L.candleWidth
              }
              var v = H(this, L, E + a6 + f3 + d)
              if (!v) continue
              if (D.transformFunc && L.transform) L = L.transform
              if (L && j) L = L[j]
              if (
                !L &&
                D9E4b.X7b(
                  L,
                  (131, 0x1aa) > (0x1a3, 0x222)
                    ? 7.96e2
                    : 102 <= (0x19a, 9.89e2)
                    ? (99, 0)
                    : (131, 16)
                )
              )
                continue
              var b = L.Close,
                J = D9E4b.r7b(L.Open, undefined) ? b : L.Open,
                O = D9E4b.G7b(L.High, undefined) ? Math.max(b, J) : L.High,
                N = D9E4b.L7b(L.Low, undefined) ? Math.min(b, J) : L.Low
              if (!b && D9E4b.j7b(b, 0)) continue
              if (!L.cache) L.cache = {}
              var B = L.cache,
                s = C + a
              if (
                D9E4b.O7b(s, S.cacheLeft) ||
                D9E4b.W7b(s, S.cacheRight) ||
                !B.top
              ) {
                if (t) {
                  z = D9E4b.N7b(t.bottom, (O - t.min) * t.multiplier)
                  W = D9E4b.b7b(t.bottom, (N - t.min) * t.multiplier)
                } else {
                  z = R.semiLog
                    ? this.pixelFromTransformedValue(O, S, R)
                    : D9E4b.B7b(R.high - O, R.multiplier) + R.top
                  W = R.semiLog
                    ? this.pixelFromTransformedValue(N, S, R)
                    : D9E4b.Y7b(R.high - N, R.multiplier) + R.top
                }
                var Y = D9E4b.T7b(W, z)
                if (D9E4b.s7b(z, V)) {
                  if (D9E4b.g7b(z + Y, V)) {
                    B.top = z
                    B.bottom = z
                    continue
                  }
                  Y -= D9E4b.p7b(V, z)
                  z = V
                }
                if (D9E4b.n7b(z + Y, i)) {
                  Y -= z + Y - i
                }
                B.top = z
                B.bottom = B.top + Y
              }
              if (D9E4b.u3h(B.top, i)) continue
              if (D9E4b.R3h(B.bottom, V)) continue
              var o =
                Math.floor(r) +
                ((0x1d5, 39.0e1) < 0x1f7
                  ? (0xff, 0.5)
                  : (95, 0xfd) < 112
                  ? (105.2e1, 147.4e1)
                  : (0x15d, 77.7e1) <= (0xf7, 0x8d)
                  ? 25
                  : (7.43e2, 69))
              w.beginPath()
              if (D9E4b.U3h(b, J)) {
                var F = this.offset
                if (c.isVolume) {
                  F = D9E4b.t3h(
                    e,
                    68 < (134, 81.3e1) ? (3, 2) : (9.53e2, 0x1e9)
                  )
                }
                var y3 = D9E4b.I3h(o, F),
                  K = o + F,
                  g
                if (t) {
                  g = D9E4b.V3h(t.bottom, (b - t.min) * t.multiplier)
                } else {
                  g =
                    Math.floor(
                      R.semiLog
                        ? this.pixelFromTransformedValue(b, S, R)
                        : D9E4b.d3h(R.high - b, R.multiplier) + R.top
                    ) +
                    ((0x233, 91.6e1) >= (70.3e1, 0x1a8)
                      ? (25, 0.5)
                      : (43, 0x95))
                }
                if (D9E4b.F3h(g, i) && D9E4b.f3h(g, V)) {
                  w.moveTo(y3, g)
                  w.lineTo(K, g)
                }
              }
              if (D9E4b.z3h(O, N)) {
                w.moveTo(o, B.top)
                w.lineTo(o, B.bottom)
              }
              w.strokeStyle = v
              w.stroke()
            }
          }
          P3.ChartEngine.prototype.drawBarChart = function(S, H, c, d) {
            var E = 'lc',
              D = S.chart
            if (!D) {
              D = S
              S = S.chart
            }
            var U = D.dataSegment,
              w = new Array(U.length),
              j = D.context,
              R = this.canvasStyle(H)
            if (
              R.width &&
              D9E4b.E3h(
                parseInt(
                  R.width,
                  (35.0e1, 102.4e1) >= 76 ? (119.1e1, 10) : (0x1cf, 53.4e1)
                ),
                0x8a > (69, 0x13c)
                  ? 0x8d
                  : (57.5e1, 141) >= (16, 137)
                  ? (88, 25)
                  : (139.3e1, 34)
              )
            ) {
              j.lineWidth = Math.max(
                (1.364e3, 5.63e2) >= 9.92e2
                  ? 0x71
                  : (12.88e2, 128) >= (113, 90.7e1)
                  ? 112
                  : (126, 12.25e2) > (0xf6, 0xca)
                  ? (12.64e2, 1)
                  : (88, 142.6e1),
                P3.stripPX(R.width)
              )
            } else {
              j.lineWidth = (0x1d3, 83.6e1) > 143 ? (0x6b, 1) : (1.167e3, 0x11e)
            }
            if (d.highlight) j.lineWidth *= 2
            var t = d.field,
              V = d.yAxis || S.yAxis,
              i = d.overlayScaling,
              z = V.top,
              W = V.bottom,
              C,
              e,
              r,
              a = D9E4b.o3h(
                D.dataSet.length,
                D.scroll,
                2.47e2 > (0, 0x229)
                  ? 'x0'
                  : 123 < (1.278e3, 0x129)
                  ? (0x10e, 1)
                  : (79, 0xb4) < 107
                  ? 6.41e2
                  : (0x161, 1.218e3)
              ),
              L = {},
              v = D9E4b.T3h(D.tmpWidth, 2),
              b = D9E4b.s3h(
                j.lineWidth,
                (32, 0x21a) < 0x24c ? (95, 2) : (33, 45)
              ),
              J = this.layout.candleWidth,
              O = D9E4b.g3h(
                S.left,
                ((12.06e2, 112.3e1) >= (0x13d, 98)
                  ? (103, 0.5)
                  : (14.8e1, 0x1b2)) * J,
                this.micropixels,
                1
              )
            for (
              var N =
                4.2e1 >= (1.204e3, 24.7e1)
                  ? 0x1
                  : 6.3e2 <= (0xa5, 0x44)
                  ? (79, 82)
                  : (0x1a1, 1.47e3) > 0xfc
                  ? (69, 0)
                  : (0x71, 137);
              D9E4b.l3h(N, U.length);
              N++
            ) {
              O += D9E4b.y6h(
                J,
                (9.63e2, 2.01e2) < 48
                  ? 'F'
                  : (0x20d, 95) > (80.9e1, 46)
                  ? (41, 2)
                  : (0x10d, 11.01e2)
              )
              J = this.layout.candleWidth
              O += D9E4b.H6h(
                J,
                (4.16e2, 8) < 36
                  ? (120, 2)
                  : (82.8e1, 42.7e1) < (7.32e2, 130)
                  ? (101, 146)
                  : 0x21d < (92, 0xaa)
                  ? 0x199
                  : (46.6e1, 44)
              )
              var B = U[N]
              if (!B) continue
              if (B.projection) break
              if (B.candleWidth) {
                O += D9E4b.c6h(
                  B.candleWidth - J,
                  (0x185, 0x218) <= 8.95e2
                    ? (91, 2)
                    : 0x3a >= (0x9e, 141)
                    ? 73.8e1
                    : (71, 17)
                )
                J = B.candleWidth
              }
              var s = c(this, B)
              if (!s) continue
              L[s] = 1
              j.strokeStyle = s
              j.beginPath()
              if (D.transformFunc && B.transform) B = B.transform
              if (B && t) B = B[t]
              if (
                !B &&
                D9E4b.a6h(
                  B,
                  (0x166, 60) < (0x79, 127) ? (4.72e2, 0) : (1.431e3, 0x72)
                )
              )
                continue
              var Y = B.Close,
                o = D9E4b.D6h(B.Open, undefined) ? Y : B.Open,
                F = D9E4b.Q6h(B.High, undefined) ? Math.max(Y, o) : B.High,
                y3 = D9E4b.i6h(B.Low, undefined) ? Math.min(Y, o) : B.Low
              if (!Y && D9E4b.M6h(Y, 0)) continue
              if (!B.cache) B.cache = {}
              var K = B.cache,
                g = a + N
              if (
                D9E4b.w6h(g, S.cacheLeft) ||
                D9E4b.C6h(g, S.cacheRight) ||
                !K.top
              ) {
                if (i) {
                  var q = i.multiplier,
                    l = i.bottom + D9E4b.Z6h(i.min, q)
                  C = D9E4b.h6h(l, F * q)
                  e = D9E4b.J6h(l, y3 * q)
                  K.open = D9E4b.v6h(l, o * q)
                  K.close = D9E4b.K6h(l, Y * q)
                } else {
                  C = this.pixelFromTransformedValue(F, S, V)
                  e = this.pixelFromTransformedValue(y3, S, V)
                  K.open = V.semiLog
                    ? this.pixelFromTransformedValue(o, S, V)
                    : D9E4b.m6h(V.high - o, V.multiplier) + V.top
                  K.close = V.semiLog
                    ? this.pixelFromTransformedValue(Y, S, V)
                    : D9E4b.q6h(V.high - Y, V.multiplier) + V.top
                }
                w[N] = K.close
                r = D9E4b.S0h(e, C)
                if (D9E4b.x0h(C, z)) {
                  if (D9E4b.X0h(C + r, z)) {
                    K.top = C
                    K.bottom = C
                    continue
                  }
                  r -= D9E4b.r0h(z, C)
                  C = z
                }
                if (D9E4b.G0h(C + r, W)) {
                  r -= C + r - W
                }
                K.top = C
                K.bottom = C + r
              }
              var A = Math.floor(O) + 0.5
              if (
                D9E4b.L0h(K.top, W) &&
                D9E4b.j0h(K.bottom, z) &&
                D9E4b.O0h(B.High, B.Low)
              ) {
                j.moveTo(A, D9E4b.W0h(K.top, b))
                j.lineTo(A, K.bottom + b)
              }
              if (
                D9E4b.N0h(d.type, k3 + E) &&
                D9E4b.b0h(K.open, z) &&
                D9E4b.B0h(K.open, W)
              ) {
                j.moveTo(A, K.open)
                j.lineTo(D9E4b.Y0h(A, v), K.open)
              }
              if (D9E4b.T0h(K.close, z) && D9E4b.s0h(K.close, W)) {
                j.moveTo(A, K.close)
                j.lineTo(A + v, K.close)
              }
              j.stroke()
            }
            j.lineWidth =
              (0x29, 44) > (119, 1.26e2)
                ? (9.53e2, 0.9)
                : (1.04e2, 41.7e1) > 110
                ? (0x12f, 1)
                : (5.69e2, 0x6b)
            var c3 = {
              colors: [],
              cache: w,
            }
            for (var m in L) {
              if (!P3.equals(m, this.containerColor)) c3.colors.push(m)
            }
            return c3
          }
          var c6 = -A3,
            I6 = -d6,
            j6 = D9E4b.v5z
          for (
            var y6 = D9E4b.e5z;
            D9E4b.L4h.Q4h(y6.toString(), y6.toString().length, G6) !== c6;
            y6++
          ) {
            context.lineTo(endX, last2[D9E4b.e5z])
            plotter.lineTo(N6 + F3 + d3 + r6, wb, bb)
            context.lineTo(x, collatedLow)
            this.touchDoubleClick(finger, this.clicks.x, this.clicks.y)
            quotes.shift()
            j6 += D9E4b.v5z
          }
          if (D9E4b.L4h.Q4h(j6.toString(), j6.toString().length, M3) !== I6) {
            context.moveTo(xx, cache.close)
            yAxisPlotter.lineTo(
              o3 + r6 + z3 + f3,
              u4S.Y01(panel.right, D9E4b.e5z),
              y2
            )
            sctx.drawImage(context.canvas, D9E4b.J5z, D9E4b.J5z)
            points.push(endX, last1[D9E4b.e5z])
            return G1h / D1h
          }
          P3.ChartEngine.prototype.drawWaveChart = function(H, c) {
            var d = '_cha',
              E = 'in',
              D = 'tx',
              U = 'ine_',
              w = '_l',
              j = 'st',
              R = H.chart,
              t = R.dataSegment,
              V = new Array(t.length),
              i = R.context
            if (!c) c = {}
            var z = c.yAxis || H.yAxis,
              W = c.overlayScaling
            this.startClip(H.name)
            i.beginPath()
            var C = false,
              e =
                (79, 62.4e1) < (21.5e1, 104)
                  ? (8.79e2, 131)
                  : 0x60 <= (0x154, 106)
                  ? (111, false)
                  : (0x1d3, 1.331e3) <= (148, 0x28)
                  ? 500
                  : (0x15c, 54),
              r = H.yAxis.top,
              a = H.yAxis.bottom,
              L =
                H.left +
                Math.floor(
                  -(0x105 >= (145, 116) ? (2.23e2, 0.5) : (71, 86.9e1)) *
                    this.layout.candleWidth +
                    this.micropixels
                ),
              v = this

            function b(S) {
              if (W) {
                return D9E4b.g0h(W.bottom, (S - W.min) * W.multiplier)
              }
              return v.pixelFromTransformedValue(S, H, z)
            }
            for (
              var J =
                9 > (93, 9.0e1)
                  ? 9.26e2
                  : (132, 0x94) <= (0x153, 0x130)
                  ? (149, 0)
                  : (62, 0x9a);
              D9E4b.p0h(J, t.length);
              J++
            ) {
              L += this.layout.candleWidth
              var O = t[J]
              if (!O) continue
              if (O.projection) break
              if (R.transformFunc && O.transform) O = O.transform
              if (O && c.field) O = O[c.field]
              if (
                !O &&
                D9E4b.n0h(
                  O,
                  (0x193, 0x65) > 130
                    ? (0x4a, 'i')
                    : (0, 3.68e2) >= 20
                    ? (1.172e3, 0)
                    : (0x23f, 54)
                )
              )
                continue
              var N = O.Close,
                B = D9E4b.u2h(O.Open, undefined) ? N : O.Open,
                s = D9E4b.R2h(O.High, undefined) ? Math.max(N, B) : O.High,
                Y = D9E4b.U2h(O.Low, undefined) ? Math.min(N, B) : O.Low
              if (
                !N &&
                D9E4b.t2h(
                  N,
                  (0x60, 15.8e1) < 0x18c
                    ? (5.69e2, 0)
                    : 0x66 > (55, 6.94e2)
                    ? (1.218e3, 104)
                    : (0x8a, 0x1ca)
                )
              )
                continue
              var o = D9E4b.I2h(
                  L,
                  (((48, 0x21c) < 40.0e1
                    ? 'Q'
                    : 0x130 < (16, 121)
                    ? (3.1e1, 77)
                    : 2.7e2 <= (29, 0x20e)
                    ? (123, 3)
                    : (0x161, 3.51e2)) *
                    this.layout.candleWidth) /
                    (0xd6 > (2.38e2, 4.89e2)
                      ? (57.5e1, 1.445e3)
                      : (10, 141) > (44, 11.55e2)
                      ? (47, 250)
                      : 0x2c < (13.85e2, 3.77e2)
                      ? (0x229, 8)
                      : (12, 0x1d9))
                ),
                F = b(B)
              if (D9E4b.V2h(F, r)) {
                F = r
                if (e) {
                  i.moveTo(o, F)
                  continue
                }
                e =
                  0x2f < (43, 81)
                    ? (0xa9, true)
                    : (110, 0x174) >= (106.5e1, 91.4e1)
                    ? (8.56e2, 106)
                    : (57, 37.2e1)
              } else if (D9E4b.d2h(F, a)) {
                F = a
                if (e) {
                  i.moveTo(o, F)
                  continue
                }
                e = 115 >= (94.1e1, 48) ? (9.47e2, true) : (3.22e2, 35)
              } else {
                e =
                  4.72e2 >= (0x23a, 59)
                    ? (0xba, false)
                    : 0x167 > (4.6e2, 0x204)
                    ? 'o'
                    : 5.96e2 <= (7.19e2, 134)
                    ? 'o'
                    : (82.6e1, 0x159)
              }
              if (!C) {
                C =
                  (0x4f, 115.2e1) > 2.54e2
                    ? (114, true)
                    : (4.42e2, 8) >= (41, 135.0e1)
                    ? 13.94e2
                    : (0xa, 5.71e2) <= 25.4e1
                    ? (143, 0xf4)
                    : (0x16a, 5.79e2)
                var y3 = D9E4b.F2h(
                  R.dataSet.length,
                  R.scroll,
                  0x1b5 >= (0x1ab, 121) ? (20, 1) : (9.51e2, 101)
                )
                if (
                  D9E4b.N2h(
                    y3,
                    (0x1ba, 0x19c) <= 0x15c
                      ? (7.7e2, '')
                      : (0x1ed, 50.1e1) < 0x1f7
                      ? (95, 0)
                      : 141.8e1 <= (14.1e1, 0x197)
                      ? 'Z'
                      : (0xb1, 87)
                  )
                ) {
                  i.moveTo(o, F)
                } else if (D9E4b.b2h(y3, 0)) {
                  var K = R.dataSet[y3]
                  if (K.transform) K = K.transform
                  var g = K.Close
                  g = b(g)
                  g = Math.min(Math.max(g, r), a)
                  i.moveTo(
                    H.left +
                      D9E4b.B2h(
                        J -
                          (30 <= (47, 61.0e1) ? (92.6e1, 1) : (0x11c, 1.487e3)),
                        this.layout.candleWidth
                      ) +
                      this.micropixels,
                    g
                  )
                  i.lineTo(o, F)
                }
                i.moveTo(o, F)
              } else {
                i.lineTo(o, F)
              }
              o += D9E4b.Y2h(
                this.layout.candleWidth,
                (0x126, 0xb5) <= 0x1be
                  ? (45.4e1, 4)
                  : 3 >= (5, 112.4e1)
                  ? (0x1db, 't')
                  : (0x195, 0x178)
              )
              if (D9E4b.T2h(B, N)) {
                F = b(Y)
                if (D9E4b.s2h(F, r)) F = r
                if (D9E4b.g2h(F, a)) F = a
                i.lineTo(o, F)
                o += D9E4b.p2h(
                  this.layout.candleWidth,
                  (24, 27.7e1) >= 47.2e1
                    ? (57, 0x233)
                    : (8.47e2, 6.86e2) <= 147.4e1
                    ? (143, 4)
                    : (0xbf, 57)
                )
                F = b(s)
                if (D9E4b.n2h(F, r)) F = r
                if (D9E4b.u1h(F, a)) F = a
                i.lineTo(o, F)
              } else {
                F = b(s)
                if (D9E4b.R1h(F, r)) F = r
                if (D9E4b.U1h(F, a)) F = a
                i.lineTo(o, F)
                o += D9E4b.t1h(
                  this.layout.candleWidth,
                  0x186 > (71, 6.94e2)
                    ? (66, 'f')
                    : (51, 141) < 1.199e3
                    ? (102.3e1, 4)
                    : (0x3f, 85.6e1)
                )
                F = b(Y)
                if (D9E4b.I1h(F, r)) F = r
                if (D9E4b.V1h(F, a)) F = a
                i.lineTo(o, F)
              }
              o += D9E4b.d1h(
                this.layout.candleWidth,
                0x21b <= (13, 7.93e2) ? (115, 4) : (73, 0xf6)
              )
              F = b(N)
              V[J] = F
              if (D9E4b.F1h(F, r)) F = r
              if (D9E4b.f1h(F, a)) F = a
              i.lineTo(o, F)
            }
            var q = this.canvasStyle(j + x6 + w + U + J3 + k3 + a6 + r6 + P)
            if (
              q.width &&
              D9E4b.z1h(
                parseInt(
                  q.width,
                  0x56 > (4, 0x86)
                    ? (12, 12)
                    : (0xb8, 0x11c) > (61, 4.79e2)
                    ? 'm'
                    : (3.88e2, 11.76e2) > 73
                    ? (0x1ea, 10)
                    : (42, 55.5e1)
                ),
                25
              )
            ) {
              i.lineWidth = Math.max(
                0x15a <= (127, 36)
                  ? 'e'
                  : 34 > (7.09e2, 2.0e1)
                  ? (118.2e1, 1)
                  : (107, 4.38e2),
                P3.stripPX(q.width)
              )
            } else {
              i.lineWidth =
                (84.4e1, 4.86e2) > 99 ? (0x11a, 1) : (8.83e2, 14.97e2)
            }
            if (c.highlight)
              i.lineWidth *=
                (17.1e1, 0x1a8) >= (1.035e3, 0x255)
                  ? 0xb8
                  : 7.27e2 < (22, 11.73e2)
                  ? (62, 2)
                  : (0, 0x54)
            this.canvasColor(Z3 + D + w + E + d3 + d + r6 + P)
            if (c.color) i.strokeStyle = c.color
            i.stroke()
            i.closePath()
            var l = {
              colors: [i.strokeStyle],
              cache: V,
            }
            this.endClip()
            i.lineWidth =
              (114.5e1, 39) >= 0x93
                ? (0x17b, 117)
                : 0x4e <= (13.3e1, 8.2e1)
                ? (11.5e2, 1)
                : (49, 0x101) > 7.54e2
                ? 70
                : (10.35e2, 63)
            return l
          }
          P3.ChartEngine.prototype.scatter = function(S, H) {
            var c = 'rt',
              d = 'at',
              E = 'sc',
              D = '_',
              U = 'tt',
              w =
                (51.0e1, 16.9e1) < (44.2e1, 60)
                  ? (1.148e3, 8)
                  : (0x22c, 135) <= 33.3e1
                  ? (31, 'S')
                  : (2.3e2, 0x23f),
              j = 'os',
              R =
                0x188 <= (60.4e1, 11.35e2)
                  ? (13.28e2, 'C')
                  : (9.92e2, 12.0e1) <= (47.3e1, 49)
                  ? 'z'
                  : (0x161, 6.9e1) >= (0x1c4, 59.8e1)
                  ? (5.54e2, 61.9e1)
                  : (49, 22),
              t = S.chart,
              V = t.dataSegment,
              i = new Array(V.length),
              z = this.chart.context
            if (!H) H = {}
            var W = H.field || t.defaultPlotField,
              C = H.yAxis || S.yAxis,
              e = H.overlayScaling
            defaultPlotField =
              H.subField || t.defaultPlotField || R + w3 + j + d3
            if (!H.symbol)
              defaultPlotField =
                (66.0e1, 9.5e1) > (0x1ff, 0x168)
                  ? (134, 71)
                  : 0x1ad >= (0x11b, 0x171)
                  ? (129, null)
                  : (0x237, 145)
            this.startClip(S.name)
            z.beginPath()
            z.lineWidth = 4
            if (H.highlight)
              z.lineWidth *=
                (0x130, 11) > 76
                  ? 0x1ed
                  : (0x171, 72) <= (55.1e1, 36)
                  ? (0xce, 0.25)
                  : (36, 89.1e1) >= 0x1c4
                  ? (34.8e1, 2)
                  : (97.3e1, 0x7b)
            var r = C.top,
              a = C.bottom,
              L = D9E4b.E1h(
                S.left,
                ((0x194, 14.09e2) > (2.69e2, 123)
                  ? (117.1e1, 0.5)
                  : (118.9e1, 47) > (120, 0x8c)
                  ? 'u'
                  : (0x173, 0x7c) <= (148, 41)
                  ? (22.0e1, 64)
                  : (1.105e3, 0x13f)) * this.layout.candleWidth,
                this.micropixels,
                1
              )
            for (var v = 0; D9E4b.J1h(v, V.length); v++) {
              L += this.layout.candleWidth
              var b = V[v]
              if (!b) continue
              if (!b.projection) {
                if (t.transformFunc && b.transform) b = b.transform
                var J = b[W]
                if (J && D9E4b.v1h(J[defaultPlotField], undefined))
                  J = J[defaultPlotField]
                J = [J]
                if (D9E4b.K1h(w + J3 + a6 + U + d3 + r6, b)) J = b.Scatter
                for (
                  var O =
                    55 <= (128, 0x195)
                      ? (3.84e2, 0)
                      : (88, 0x58) <= (0x13c, 64)
                      ? 'i'
                      : (141, 0x185);
                  D9E4b.m1h(O, J.length);
                  O++
                ) {
                  if (
                    !J[O] &&
                    D9E4b.q1h(
                      J[O],
                      5.69e2 <= (130, 35)
                        ? 'd'
                        : 13.89e2 > (89, 30.0e1)
                        ? (0x1e2, 0)
                        : (7, 0x20e) <= 34
                        ? (0x1b2, 84.3e1)
                        : (142, 99.3e1)
                    )
                  )
                    continue
                  var N
                  if (e) {
                    N = D9E4b.S4h(e.bottom, (J[O] - e.min) * e.multiplier)
                  } else {
                    N = C.semiLog
                      ? this.pixelFromTransformedValue(J[O], S, C)
                      : D9E4b.x4h(C.high - J[O], C.multiplier) + r
                  }
                  if (D9E4b.X4h(N, r)) continue
                  if (D9E4b.r4h(N, a)) continue
                  z.moveTo(
                    D9E4b.G4h(
                      L,
                      (10.97e2, 87) >= (0, 76.7e1)
                        ? (118, 0x1a6)
                        : (57.4e1, 24.9e1) >= (24.3e1, 18)
                        ? (1.323e3, 2)
                        : 0x122 <= (2, 46)
                        ? 0x1b9
                        : (36, 0x88)
                    ),
                    N
                  )
                  z.lineTo(
                    L +
                      ((71, 6.82e2) >= (8.44e2, 143)
                        ? (0x104, 2)
                        : (99, 3.0e2)),
                    N
                  )
                  i[v] = N
                }
              }
            }
            this.canvasColor(
              Z3 + P + x6 + D + E + d + P + d3 + r6 + D + J3 + k3 + a6 + c
            )
            if (H.color) z.strokeStyle = H.color
            z.stroke()
            z.closePath()
            var B = {
              colors: [z.strokeStyle],
              cache: i,
            }
            this.endClip()
            z.lineWidth = 1
            return B
          }
          return S6
        }
      : 0.5
  var J0l4h = (window.J0l4h = {
    E8s: function(S, H) {
      return S == H
    },
    y5s: function(S, H) {
      return S < H
    },
    e5h: function(S, H) {
      return S > H
    },
    O1s: function(S, H) {
      return S !== H
    },
    o7h: function(S, H) {
      return S === H
    },
    u4s: function(S, H) {
      return S - H
    },
    b6s: function(S, H) {
      return S === H
    },
    Y8h: function(S, H) {
      return S > H
    },
    y9h: function(S, H) {
      return S < H
    },
    s9h: function(S, H) {
      return S - H
    },
    P7h: function(S, H) {
      return S !== H
    },
    q9h: function(S, H) {
      return S / H
    },
    K5s: function(S, H) {
      return S > H
    },
    E9h: function(S, H, c, d) {
      return S - H + c + d
    },
    i8h: function(S, H) {
      return S * H
    },
    n8h: function(S, H) {
      return S == H
    },
    i5s: function(S, H) {
      return S < H
    },
    I8s: function(S, H) {
      return S == H
    },
    C5s: function(S, H) {
      return S < H
    },
    b8h: function(S, H) {
      return S < H
    },
    g9h: function(S, H, c) {
      return S - H + c
    },
    o5h: function(S, H) {
      return S < H
    },
    F0s: function(S, H) {
      return S !== H
    },
    J2s: function(S, H) {
      return S < H
    },
    w2s: function(S, H) {
      return S * H
    },
    o4s: function(S, H) {
      return S != H
    },
    h3s: function(S, H) {
      return S < H
    },
    w9h: function(S, H, c) {
      return S - H + c
    },
    E7h: function(S, H) {
      return S === H
    },
    w8h: function(S, H, c, d) {
      return S - H + c - d
    },
    b9s: function(S, H) {
      return S == H
    },
    n6s: function(S, H) {
      return S <= H
    },
    D9h: function(S, H) {
      return S > H
    },
    z9h: function(S, H) {
      return S - H
    },
    X8h: function(S, H) {
      return S - H
    },
    j9s: function(S, H) {
      return S * H
    },
    c3s: function(S, H) {
      return S < H
    },
    a9h: function(S, H) {
      return S > H
    },
    R0s: function(S, H) {
      return S <= H
    },
    r6s: function(S, H) {
      return S < H
    },
    g8h: function(S, H) {
      return S / H
    },
    s8h: function(S, H) {
      return S * H
    },
    g6s: function(S, H) {
      return S < H
    },
    M9h: function(S, H) {
      return S == H
    },
    V0s: function(S, H) {
      return S >= H
    },
    A8s: (function() {
      var R = {},
        t = function(S, H) {
          var c =
            H &
            ((3.59e2, 0xbb) < (0x1a, 0x1ac)
              ? (0x1c, 0xffff)
              : (0x6e, 0xd3) >= (0xcc, 44.2e1)
              ? (78, 93)
              : (1.48e2, 3.9e1))
          var d = H - c
          return (
            (((d * S) |
              ((71.8e1, 0x1d2) < (0x5a, 1.89e2)
                ? 61.6e1
                : 5.03e2 > (78.5e1, 142)
                ? (12.17e2, 0)
                : (113, 0x1ca))) +
              ((c * S) | ((78.6e1, 57) > 47 ? (79, 0) : (0x162, 0xfb)))) |
            ((135.9e1, 0xd3) > 124
              ? (0x17c, 0)
              : 1.234e3 <= (91.1e1, 46)
              ? (8.3e1, '-')
              : (87.0e1, 55))
          )
        },
        V = function(S, H, c) {
          if (R[c] !== undefined) {
            return R[c]
          }
          var d =
              (9.22e2, 1.6e1) < 11.9e2 ? (4.97e2, 0xcc9e2d51) : (0x19c, 2.79e2),
            E =
              (2, 0x1c3) < (0x22, 0x85)
                ? 250
                : 0x230 >= (93.3e1, 0xf9)
                ? (0x7d, 0x1b873593)
                : (0x13a, 0x1ee)
          var D = c
          var U =
            H &
            ~(71.8e1 < (13.97e2, 0x10a)
              ? (132, 3000)
              : 0x24a < (0x1ef, 2.78e2)
              ? (0x230, 14.95e2)
              : (0x40, 58.4e1) < 75.7e1
              ? (0x81, 0x3)
              : (58, 0xf2))
          for (
            var w =
              (70, 0x22a) >= (26, 0x254)
                ? (107, 141)
                : (0x17e, 3.36e2) < 0x15a
                ? (1.48e3, 0)
                : (47, 0x15f);
            w < U;
            w +=
              (2, 123) <= 0xea
                ? (0x243, 4)
                : (4.17e2, 114) < (1.38e3, 7)
                ? (0x10d, 'U')
                : (0x253, 20) > 0xdf
                ? (0x136, 'U')
                : (0x151, 3.67e2)
          ) {
            var j =
              (S.charCodeAt(w) &
                ((7.5e1, 107.4e1) >= 71.4e1 ? (81, 0xff) : (0x67, 3.6e1))) |
              ((S.charCodeAt(w + 1) &
                ((28.1e1, 0x201) > (85, 0x6)
                  ? (115, 0xff)
                  : (0x126, 145.3e1) < 0x224
                  ? (19.5e1, 0.8)
                  : (133, 0x6a))) <<
                ((78.7e1, 0x54) > 0x164
                  ? 0x26
                  : (0x69, 10.11e2) <= 0x1dd
                  ? (76, 1.618)
                  : (0x75, 114) < (11.78e2, 11.04e2)
                  ? (12.04e2, 8)
                  : (82, 1.346e3))) |
              ((S.charCodeAt(
                w +
                  (117 < (48, 30.8e1)
                    ? (0x1c2, 2)
                    : (2.5e1, 0x196) <= (14.78e2, 108)
                    ? (1.104e3, 13.31e2)
                    : 1.49e3 <= (9.79e2, 44)
                    ? 0x8d
                    : (5, 70.5e1))
              ) &
                ((0x1bf, 117) <= (91, 132) ? (54.9e1, 0xff) : (129, 0x2a))) <<
                (10.71e2 >= (8, 0x136)
                  ? (86, 16)
                  : (46.7e1, 11) >= 66
                  ? (0x1e1, 'l')
                  : (0x12c, 103))) |
              ((S.charCodeAt(w + 3) &
                ((1.141e3, 134) <= 0xf
                  ? (0x17b, 5.29e2)
                  : (46, 148.4e1) >= 0x24f
                  ? (97, 0xff)
                  : 0x33 > (2.64e2, 5.7e1)
                  ? 25000
                  : (110, 0x183))) <<
                ((0x28, 44) > (59.3e1, 9)
                  ? (0x11a, 24)
                  : (0x12, 5.98e2) < (120.9e1, 0x20d)
                  ? (0x7e, 149)
                  : (1.45e2, 0x111)))
            j = t(j, d)
            j =
              ((j &
                ((5, 9.67e2) >= 1.498e3
                  ? (97, 30)
                  : (0x1bb, 41.4e1) >= 0xad
                  ? (0x11a, 0x1ffff)
                  : (0x230, 0xff))) <<
                15) |
              (j >>> 17)
            j = t(j, E)
            D ^= j
            D =
              ((D &
                (11.96e2 > (97, 1.57e2)
                  ? (119, 0x7ffff)
                  : (13, 0x89) >= 0x1f7
                  ? (95.4e1, 0x73)
                  : (1.07e2, 0x8) >= (5.38e2, 0x226)
                  ? (0x1c6, 2.5e1)
                  : (21, 13))) <<
                ((62, 13) < 56
                  ? (57.2e1, 13)
                  : (11.3e2, 18) > 0x13
                  ? 100
                  : (0x206, 0x6f))) |
              (D >>> ((76.9e1, 93) >= 60 ? (0x222, 19) : (0x1bd, 12.81e2)))
            D =
              (D *
                ((67.6e1, 71) <= (0x1e3, 55)
                  ? 0x240
                  : (1.187e3, 0x10e) >= 72
                  ? (67, 5)
                  : (16, 0xba)) +
                (128 <= (4, 0xf7)
                  ? (135, 0xe6546b64)
                  : (116.0e1, 1.59e2) >= 112.9e1
                  ? 0x122
                  : (15, 146))) |
              ((24, 75) > (1.344e3, 0x9f)
                ? (28.4e1, 750)
                : (3.38e2, 18) < (61, 0x11b)
                ? (1.231e3, 0)
                : (4.4e1, 119))
          }
          j =
            15 > (0xeb, 32.5e1)
              ? 0xb1
              : 6.9e2 >= (107, 0x10)
              ? (39.9e1, 0)
              : (90, 28) > (25.0e1, 11.75e2)
              ? 1.02e2
              : (0xc0, 127)
          switch (H % ((31, 35) <= (62.1e1, 130) ? (111.2e1, 4) : (50, 85))) {
            case 1.18e2 < (0x12f, 6.01e2)
              ? (43, 3)
              : (108, 127) >= (34.2e1, 10.83e2)
              ? (63, 'H')
              : (9.13e2, 6.14e2):
              j =
                (S.charCodeAt(
                  U +
                    ((92.7e1, 80.0e1) > (106.1e1, 0x30)
                      ? (14.09e2, 2)
                      : (108.6e1, 0x171))
                ) &
                  ((0x13e, 0x24f) > (49.7e1, 33)
                    ? (73, 0xff)
                    : (6.89e2, 0xe1))) <<
                (102.7e1 >= (99.5e1, 86.5e1)
                  ? (0xf8, 16)
                  : (0x1e6, 1.17e2) >= (52.9e1, 55.9e1)
                  ? 0xa5
                  : (80.5e1, 145))
            case (0x6b, 0x183) <= (97, 52.1e1)
              ? (0x171, 2)
              : (1.143e3, 71) >= (39.7e1, 74)
              ? 49
              : (18, 8):
              j |=
                (S.charCodeAt(
                  U +
                    ((74, 13.7e2) < 0x1fe
                      ? 52
                      : (145.1e1, 99) < (0x65, 119)
                      ? (0x11c, 1)
                      : (72, 8))
                ) &
                  ((0x14c, 56) < 113 ? (82, 0xff) : (9.55e2, 54.4e1))) <<
                ((0x9, 0x202) >= 8.45e2
                  ? 61
                  : 3 < (7.03e2, 15)
                  ? (0x1fc, 8)
                  : (8.84e2, 74.2e1))
            case 1:
              j |=
                S.charCodeAt(U) &
                ((95, 3.11e2) <= 5.2e2 ? (133, 0xff) : (11.74e2, 5.55e2))
              j = t(j, d)
              j =
                ((j & 0x1ffff) <<
                  ((0x192, 109) < 1.96e2 ? (30.3e1, 15) : (76.8e1, 0x12b))) |
                (j >>>
                  ((8.44e2, 108) > (57.4e1, 10.5e1)
                    ? (1.271e3, 17)
                    : (85, 10.3e2)))
              j = t(j, E)
              D ^= j
          }
          D ^= H
          D ^=
            D >>>
            (1.19e2 <= (0x1a8, 64)
              ? (1.455e3, 'E')
              : (148, 0x16f) < 0x221
              ? (8.81e2, 16)
              : (104, 7.08e2) > 91.3e1
              ? 142
              : (1.021e3, 49.1e1))
          D = t(
            D,
            (10, 55) > 0xcd
              ? 69
              : 0x41 >= (108, 49.6e1)
              ? (0x191, '   ')
              : (0xa5, 0x23f) >= 144
              ? (4.37e2, 0x85ebca6b)
              : (9, 122.6e1)
          )
          D ^= D >>> ((3.85e2, 0xbd) < (28, 3.0e2) ? (4, 13) : (10, 8.67e2))
          D = t(D, 0xc2b2ae35)
          D ^= D >>> (5.1e1 > (4.08e2, 46) ? (6.79e2, 16) : (69.2e1, 0x205))
          R[c] = D
          return D
        }
      return {
        g8s: t,
        s8s: V,
      }
    })(),
    d4s: function(S, H) {
      return S === H
    },
    d8s: function(S, H) {
      return S - H
    },
    T9s: function(S, H) {
      return S == H
    },
    E4s: function(S, H) {
      return S == H
    },
    W9s: function(S, H) {
      return S - H
    },
    n1s: function(S, H) {
      return S < H
    },
    F8s: function(S, H) {
      return S * H
    },
    W1s: function(S, H) {
      return S / H
    },
    p9s: function(S, H) {
      return S == H
    },
    w5s: function(S, H) {
      return S < H
    },
    l5h: function(S, H) {
      return S >= H
    },
    l0s: function(S, H) {
      return S - H
    },
    T8h: function(S, H) {
      return S * H
    },
    u8s: function(S, H) {
      return S == H
    },
    F4s: function(S, H) {
      return S !== H
    },
    d7h: function(S, H) {
      return S < H
    },
    n9s: function(S, H) {
      return S == H
    },
    I7h: function(S, H) {
      return S == H
    },
    b1s: function(S, H) {
      return S !== H
    },
    K3s: function(S, H) {
      return S !== H
    },
    L1s: function(S, H) {
      return S === H
    },
    O9s: function(S, H) {
      return S == H
    },
    E0s: function(S, H) {
      return S / H
    },
    s6s: function(S, H) {
      return S < H
    },
    Z3s: function(S, H) {
      return S < H
    },
    U8s: function(S, H) {
      return S * H
    },
    Y1s: function(S, H) {
      return S - H
    },
    w3s: function(S, H) {
      return S < H
    },
    p8h: function(S, H) {
      return S == H
    },
    l9z: 1,
    H2s: function(S, H) {
      return S != H
    },
    i9h: function(S, H) {
      return S == H
    },
    S9s: function(S, H) {
      return S !== H
    },
    S8h: function(S, H) {
      return S / H
    },
    T1s: function(S, H) {
      return S < H
    },
    u5h: function(S, H) {
      return S < H
    },
    Z2s: function(S, H) {
      return S - H
    },
    H5s: function(S, H) {
      return S < H
    },
    L9s: function(S, H) {
      return S * H
    },
    I0s: function(S, H) {
      return S - H
    },
    t7h: function(S, H) {
      return S >= H
    },
    u7h: function(S, H) {
      return S - H
    },
    r1s: function(S, H) {
      return S - H
    },
    n9z: 2,
    v3s: function(S, H) {
      return S < H
    },
    q2s: function(S, H) {
      return S < H
    },
    Z5s: function(S, H) {
      return S < H
    },
    a5s: function(S, H) {
      return S < H
    },
    S6s: function(S, H) {
      return S > H
    },
    I4s: function(S, H) {
      return S === H
    },
    e0s: function(S, H) {
      return S <= H
    },
    A4s: function(S, H) {
      return S !== H
    },
    J9h: function(S, H, c, d) {
      return S - H + c + d
    },
    m2s: function(S, H) {
      return S > H
    },
    B1s: function(S, H) {
      return S < H
    },
    d5h: function(S, H) {
      return S <= H
    },
    c2s: function(S, H) {
      return S !== H
    },
    e4s: function(S, H) {
      return S - H
    },
    r9s: function(S, H) {
      return S === H
    },
    m5s: function(S, H) {
      return S > H
    },
    P5h: function(S, H) {
      return S * H
    },
    H3s: function(S, H) {
      return S - H
    },
    i2s: function(S, H) {
      return S - H
    },
    Q3s: function(S, H) {
      return S > H
    },
    p1s: function(S, H) {
      return S - H
    },
    J3s: function(S, H) {
      return S < H
    },
    X9s: function(S, H) {
      return S === H
    },
    A7h: function(S, H) {
      return S / H
    },
    z8s: function(S, H) {
      return S == H
    },
    k7h: function(S, H) {
      return S / H
    },
    f7h: function(S, H) {
      return S - H
    },
    A5h: function(S, H) {
      return S * H
    },
    n4h: function(S, H) {
      return S != H
    },
    N6s: function(S, H) {
      return S === H
    },
    x6s: function(S, H) {
      return S < H
    },
    R8s: function(S, H) {
      return S >= H
    },
    t8s: function(S, H) {
      return S == H
    },
    j1s: function(S, H) {
      return S < H
    },
    f8s: function(S, H) {
      return S == H
    },
    d0s: function(S, H) {
      return S < H
    },
    X6s: function(S, H) {
      return S < H
    },
    N5h: function(S, H, c, d) {
      return S - H + c - d
    },
    U0s: function(S, H) {
      return S < H
    },
    z7h: function(S, H) {
      return S === H
    },
    V4s: function(S, H) {
      return S === H
    },
    H9h: function(S, H) {
      return S < H
    },
    M8h: function(S, H) {
      return S / H
    },
    z0s: function(S, H) {
      return S - H
    },
    C2s: function(S, H) {
      return S >= H
    },
    s9s: function(S, H) {
      return S >= H
    },
    F5h: function(S, H, c) {
      return S - H - c
    },
    R5h: function(S, H) {
      return S === H
    },
    h2s: function(S, H) {
      return S - H
    },
    Y9s: function(S, H) {
      return S * H
    },
    m3s: function(S, H) {
      return S - H
    },
    G6s: function(S, H) {
      return S <= H
    },
    s1s: function(S, H) {
      return S >= H
    },
    R7h: function(S, H) {
      return S == H
    },
    q3s: function(S, H) {
      return S > H
    },
    K2s: function(S, H) {
      return S - H
    },
    X1s: function(S, H) {
      return S - H
    },
    E5h: function(S, H) {
      return S <= H
    },
    N1s: function(S, H) {
      return S !== H
    },
    F7h: function(S, H) {
      return S - H
    },
    f4s: function(S, H) {
      return S * H
    },
    c5s: function(S, H) {
      return S < H
    },
    a2s: function(S, H) {
      return S < H
    },
    P0s: function(S, H) {
      return S !== H
    },
    o0s: function(S, H) {
      return S === H
    },
    Y6s: function(S, H) {
      return S > H
    },
    V5h: function(S, H) {
      return S <= H
    },
    I5h: function(S, H) {
      return S == H
    },
    v5s: function(S, H) {
      return S !== H
    },
    r8h: function(S, H) {
      return S / H
    },
    h5s: function(S, H) {
      return S < H
    },
    c9h: function(S, H) {
      return S != H
    },
    o8s: function(S, H) {
      return S != H
    },
    Q5s: function(S, H) {
      return S < H
    },
    T6s: function(S, H) {
      return S > H
    },
    g1s: function(S, H) {
      return S > H
    },
    C3s: function(S, H) {
      return S < H
    },
    L8h: function(S, H, c) {
      return S - H - c
    },
    V7h: function(S, H) {
      return S == H
    },
    t4s: function(S, H) {
      return S !== H
    },
    z4s: function(S, H) {
      return S < H
    },
    J5s: function(S, H) {
      return S <= H
    },
    q5s: function(S, H) {
      return S <= H
    },
    y2s: function(S, H) {
      return S - H
    },
    x9s: function(S, H) {
      return S < H
    },
    k0s: function(S, H) {
      return S / H
    },
    U7h: function(S, H) {
      return S == H
    },
    L6s: function(S, H) {
      return S !== H
    },
    k5h: function(S, H) {
      return S * H
    },
    D3s: function(S, H) {
      return S === H
    },
    Q9h: function(S, H) {
      return S < H
    },
    Q2s: function(S, H) {
      return S * H
    },
    N9s: function(S, H) {
      return S - H
    },
    i3s: function(S, H) {
      return S > H
    },
    G9s: function(S, H) {
      return S === H
    },
    k4s: function(S, H) {
      return S !== H
    },
    g9s: function(S, H) {
      return S * H
    },
    v2s: function(S, H) {
      return S > H
    },
    l7h: function(S, H) {
      return S <= H
    },
    D2s: function(S, H) {
      return S === H
    },
    M3s: function(S, H) {
      return S > H
    },
    t0s: function(S, H) {
      return S <= H
    },
    e8s: function(S, H) {
      return S == H
    },
    V8s: function(S, H) {
      return S <= H
    },
    x1s: function(S, H) {
      return S - H
    },
    f0s: function(S, H) {
      return S - H
    },
    B9s: function(S, H) {
      return S <= H
    },
    t5h: function(S, H) {
      return S == H
    },
    S1s: function(S, H) {
      return S - H
    },
    e7h: function(S, H) {
      return S === H
    },
    l4s: function(S, H) {
      return S < H
    },
    e3V: (function() {
      var A3V = 0,
        s3V = '',
        K3V = [
          NaN,
          {},
          0x25 < (131, 118) ? (70, false) : (0x0, 1.27e2),
          (0x88, 0x1fa) <= (0x176, 19)
            ? 114
            : 0x179 > (7.26e2, 82)
            ? (84, false)
            : (5.24e2, 44) >= (3.99e2, 0x23a)
            ? 70
            : (0x12, 3.9e1),
          / /,
          / /,
          / /,
          -((21.8e1, 59.5e1) < (4, 94.5e1) ? (5.63e2, 1) : (0x86, 142.7e1)),
          null,
          (1.064e3, 0x141) >= 0x1a1
            ? 0.001
            : 0 <= (13.07e2, 0x107)
            ? (58, null)
            : (0x1ae, 0x221) > (7, 0x256)
            ? 0.001
            : (37, 83.5e1),
          NaN,
          '',
          [],
          [],
          NaN,
          (43, 74) < (83, 9.62e2) ? (3, null) : (0x245, 108.1e1),
          135 > (9.56e2, 46.6e1)
            ? (42, 1.109e3)
            : (1.104e3, 10.25e2) <= 0x201
            ? 128.8e1
            : 83 <= (0x119, 135.2e1)
            ? (92.5e1, null)
            : (13.47e2, 0xcf),
          / /,
          -((3.7e1, 0x20d) >= (0x23e, 0x10d)
            ? (82, 1)
            : (116, 4.91e2) <= 0x1b0
            ? (5.84e2, 112)
            : (0x121, 2.15e2)),
          [],
          NaN,
          (17, 23) < (14.7e2, 0x7a)
            ? (63, null)
            : (40, 45) > 0x13f
            ? 1.68e2
            : (38, 80.9e1),
          (0xb0, 33) <= (0x21e, 9.89e2) ? (0x105, null) : (88, 0x202),
          '',
          '',
          [],
          [],
          (58.4e1, 26) >= (0x1cf, 0x4) ? (36, false) : (14.95e2, 68),
          0x72 >= (0x106, 0x34)
            ? (3.07e2, false)
            : 112 >= (1.4e3, 3.74e2)
            ? 8
            : (0x73, 65.8e1) < (124.0e1, 21)
            ? 0xd7
            : (0x16f, 87.0e1),
          (1.229e3, 1.255e3) >= 0x206 ? (0x1e2, false) : (64.6e1, 0x1c0),
          '',
          '',
          '',
          (2.37e2, 119) > (11, 9.7e1) ? (2.3e1, null) : (149, 137.5e1),
          (6.74e2, 1.45e2) > (38, 81) ? (0xfc, null) : (0x228, 16.7e1),
          {},
          {},
          [],
          / /,
          / /,
          / /,
        ],
        k3V = K3V['length']
      for (; A3V < k3V; ) {
        s3V += +(typeof K3V[A3V++] !== 'object')
      }
      var g3V = parseInt(s3V, 2),
        m3V = 'http://localhost?q=;%29%28emiTteg.%29%28etaD%20wen%20nruter',
        P3V = m3V.constructor.constructor(
          unescape(/;.+/['exec'](m3V))
            ['split']('')
            ['reverse']()
            ['join']('')
        )()
      return {
        T3V: function(p3V) {
          console.log('License T3V')
          var q3V,
            A3V =
              27 > (24.9e1, 0x19a)
                ? (56.1e1, 'X')
                : (39.4e1, 124) < (0x19f, 0xa4)
                ? (8.99e2, 0)
                : 0x1a >= (108.3e1, 0x164)
                ? (0x247, '2.1')
                : (86.4e1, 55),
            l3V = g3V - P3V > k3V,
            n3V
          for (; A3V < p3V['length']; A3V++) {
            n3V = parseInt(
              p3V['charAt'](A3V),
              (0x19, 118.0e1) > (149, 118)
                ? (4.62e2, 16)
                : 11.23e2 <= (0x175, 0x69)
                ? 'w'
                : (1.068e3, 0x161)
            )['toString'](
              0xca < (50, 8)
                ? (1.004e3, 'S')
                : (79, 0x1b1) <= (0x6, 126.8e1)
                ? (0x137, 2)
                : (5.88e2, 95.9e1)
            )
            var S6V = n3V['charAt'](
              n3V['length'] - (0x4d > (11.3e2, 41) ? (31, 1) : (64, 5.17e2))
            )
            q3V =
              A3V ===
              (10.8e2 >= (72.5e1, 4.83e2)
                ? (47, 0)
                : (129.9e1, 0x21a) < (0x74, 56)
                ? (0x45, 37.2e1)
                : (31, 0x19a))
                ? S6V
                : q3V ^ S6V
          }
          return q3V ? l3V : !l3V
        },
      }
    })(),
    P4s: function(S, H) {
      return S - H
    },
    U4s: function(S, H) {
      return S === H
    },
    G8h: function(S, H) {
      return S <= H
    },
    x8h: function(S, H) {
      return S - H
    },
    j6s: function(S, H) {
      return S > H
    },
    R4s: function(S, H) {
      return S - H
    },
    B8h: function(S, H) {
      return S < H
    },
    W6s: function(S, H) {
      return S - H
    },
    U5h: function(S, H) {
      return S == H
    },
    A0s: function(S, H) {
      return S !== H
    },
    B6s: function(S, H) {
      return S === H
    },
    p6s: function(S, H) {
      return S > H
    },
    M5s: function(S, H) {
      return S < H
    },
    O6s: function(S, H) {
      return S < H
    },
    u0s: function(S, H) {
      return S - H
    },
    G1s: function(S, H) {
      return S / H
    },
    a3s: function(S, H) {
      return S - H
    },
    D5s: function(S, H) {
      return S < H
    },
    y3s: function(S, H) {
      return S !== H
    },
    M2s: function(S, H) {
      return S <= H
    },
  })
  var __aggregations_ =
    true || ('L!' && false)
      ? function(K3) {
          var v3 = true || ('L!' && false) ? 'yo' : 'histMax',
            q3 =
              false || ('L!' && false)
                ? 'mouseMode'
                : (69, 5) <= (71, 82.5e1)
                ? (2.45e2, 'L')
                : (6.07e2, 134.8e1),
            h3 =
              true || ('L!' && false)
                ? (0x1fc, 0x15d) > (112.3e1, 148)
                  ? (6.44e2, 'H')
                  : (0x251, 149)
                : 'grabStartScrollX',
            l3 = false || ('L!' && false) ? 'globalAlpha' : 'ut',
            n =
              false || ('L!' && false)
                ? 'yaxis'
                : 6.4e2 >= (29, 24)
                ? (12.81e2, 7395072)
                : (3.6e2, 0x256) < 0x24f
                ? 7.83e2
                : (37.7e1, 12.09e2) < 0x9f
                ? (0xd1, 0x1cb)
                : (69.9e1, 9.59e2),
            a3 =
              false || ('L!' && false)
                ? 'moveTo'
                : (0x175, 107.5e1) > (140, 0x154)
                ? (0xdf, 7664894)
                : (118.8e1, 12.43e2) < (99, 26)
                ? (72, 0x21e)
                : 1.484e3 <= (0x187, 135.6e1)
                ? 'v'
                : (43, 140),
            S6 =
              true || ('L!' && false)
                ? (0x22e, 0x17a) >= (0, 0x133)
                  ? (0x15f, 1662596889)
                  : (128, 47) > (116, 0xad)
                  ? 1.0
                  : (1, 8.36e2) <= 43.2e1
                  ? (0x1bd, 5.8e1)
                  : (137, 109)
                : '1.1',
            x6 =
              (0x196, 12.31e2) <= 0x250
                ? (138, 'F')
                : (2.45e2, 0x3e) <= 147
                ? (0, 1304371462)
                : (119, 45.6e1),
            o3 = true || ('L!' && false) ? 'la' : 'colorMap',
            M3 =
              (103, 107) <= 57.3e1
                ? (0x165, 'O')
                : (1.455e3, 134) <= 34
                ? 59
                : (0x20e, 0x22a),
            F3 =
              true || ('L!' && false)
                ? 55.9e1 >= (39.2e1, 136.4e1)
                  ? (0x201, 0.7)
                  : 123.6e1 >= (145.1e1, 85)
                  ? (0xa2, 'X')
                  : 25 >= (14.77e2, 113)
                  ? 0.7
                  : (0x5f, 17)
                : 'step',
            G6 =
              false || ('L!' && false)
                ? 'isSurface'
                : (24, 51) < 8
                ? 'X'
                : (0x1a2, 76.2e1) > (0, 0x163)
                ? (0x8e, 'f')
                : 0x21a > (0x33, 5.75e2)
                ? (0xa4, 9.26e2)
                : (1.475e3, 136),
            d6 = 68 < (0x1e6, 98.6e1) ? (103, 'd') : (0xda, 13),
            A3 = (40.5e1, 0x17a) <= (11.1e2, 1.291e3) ? (63, 'p') : (0x27, 31),
            f3 = 'u',
            z3 = 'nd',
            w3 = (2.35e2, 6.88e2) >= 65 ? (6.5e1, 'c') : (11.3e1, 21),
            Z3 =
              (0x6c, 5.35e2) <= 0x8e
                ? (42.0e1, 'ray')
                : (36, 86) >= (116, 0x48)
                ? (2.39e2, 'r')
                : (0x27, 0x165),
            d3 =
              (6.91e2, 0x129) >= (127, 149)
                ? (81, 'h')
                : (0x13a, 0x1c1) <= 25.6e1
                ? (105.9e1, 'w')
                : (61, 90.0e1) >= (0x1b4, 14.65e2)
                ? (75, 27)
                : (0x23e, 9.12e2),
            N6 = 88.6e1 > (1.144e3, 104) ? (91, 'k') : (1.19e3, 54),
            W6 =
              false || ('L!' && false)
                ? 'bordersOn'
                : (12.97e2, 59) < (0x32, 43)
                ? (0x1a4, 'h')
                : (101, 0x1e3) <= (1.415e3, 99.3e1)
                ? (0xb0, '.')
                : (102, 0xb3),
            P =
              9.44e2 < (66, 5.66e2)
                ? (0x1cc, 's')
                : 5.7e2 > (0x149, 0x12a)
                ? (83, 'i')
                : (114, 117.5e1) < (144.3e1, 0x149)
                ? (0x19e, 0x1a5)
                : (100.1e1, 12.64e2),
            r6 = false || ('L!' && false) ? 'lastDate' : 'ed',
            a6 =
              (0x1fb, 0xb6) >= 0x23b
                ? (0x1a7, 51.4e1)
                : 98 > (126, 77)
                ? (128, 'w')
                : (0xac, 24),
            k3 =
              true || ('L!' && false)
                ? 37 < (0x86, 17.0e1)
                  ? (26, 'y')
                  : (0x1f7, 64)
                : (116, 0xb5) >= 0x95
                ? (1.58e2, 'j')
                : (0x166, 0xf7) >= 56.6e1
                ? 6
                : (0x7a, 1.489e3) <= 144.3e1
                ? 6
                : (0x102, 29),
            J3 =
              true || ('L!' && false)
                ? (5.9e1, 0x1fe) > (13.83e2, 78)
                  ? (0x112, 'l')
                  : (0x170, 10.76e2) < 0xdb
                  ? (7.41e2, 9)
                  : (0x91, 1.6e1) > (96, 1.25e2)
                  ? 141
                  : (18, 72.6e1)
                : 'backOutX',
            P3 = 86 <= (96, 119) ? (0x1f2, 'n') : (0x145, 98),
            c6 = 'o',
            I6 = 're',
            j6 =
              true || ('L!' && false)
                ? (7.76e2, 44.6e1) > 117
                  ? (130, ' ')
                  : (0, 0x9d)
                : 'plotSpline',
            y6 = 't',
            b6 =
              0x73 >= (9.11e2, 25)
                ? (0x56, 'g')
                : 0xfa >= (139, 0x15b)
                ? (78, 250)
                : (133, 0x246),
            A6 = 'A',
            O6 = 'e',
            s6 = 0x250 > (122, 42.9e1) ? (3.6e1, 's') : (0x5c, 0x126),
            H6 = 30.0e1 <= (0x57, 9.77e2) ? (137, 'a') : (0x1e9, 0x112),
            o6 =
              (0x138, 95) > 0x1b4
                ? (0x156, 't')
                : (1.499e3, 8.7e2) < (56.7e1, 5.62e2)
                ? 1.377e3
                : (0x1ca, 0x5d) <= (0x1ba, 11.7e1)
                ? (38.2e1, '_')
                : (0x13a, 18.4e1),
            E6 = false,
            P6 =
              (0x1d, 98.4e1) < (0xc9, 1.139e3)
                ? (36, true)
                : (0x1af, 7.91e2) <= 4.15e2
                ? (0x6e, 0x18e)
                : (133, 31),
            L6 = K3.CIQ
          L6.Renderer.Aggregations = function(S) {
            var H = 'ri',
              c = 'ions',
              d = 'ggr',
              E = 'rie',
              D = 'in',
              U =
                (37.4e1, 11.14e2) >= (0x10c, 113)
                  ? (101, 'm')
                  : (73, 37) >= 73
                  ? 91
                  : (78, 95.7e1) <= (7.78e2, 87)
                  ? 120
                  : (109, 47)
            this.construct(S)
            var w = this.params
            this.highLowBars = this.barsHaveWidth = this.standaloneBars = P6
            w.highlightable = E6
            if (J0l4h.n4h(w.name, o6 + U + H6 + D + o6 + s6 + O6 + E + s6)) {
              console.warn(
                A6 +
                  d +
                  O6 +
                  b6 +
                  H6 +
                  y6 +
                  c +
                  j6 +
                  H6 +
                  I6 +
                  j6 +
                  c6 +
                  P3 +
                  J3 +
                  k3 +
                  j6 +
                  H6 +
                  J3 +
                  J3 +
                  c6 +
                  a6 +
                  r6 +
                  j6 +
                  c6 +
                  P3 +
                  j6 +
                  U +
                  H6 +
                  P +
                  P3 +
                  j6 +
                  s6 +
                  O6 +
                  H +
                  O6 +
                  s6 +
                  W6
              )
              w.invalid = P6
            }
          }
          L6.Renderer.Aggregations.ciqInheritsFrom(L6.Renderer.OHLC, E6)
          L6.Renderer.Aggregations.requestNew = function(S, H) {
            var c = 'io',
              d = 'OHLC',
              E = 'dle',
              D = 'an',
              U = 'le',
              w = 'bar',
              j = 'ng',
              R = 'ra',
              t =
                (109, 116) >= (0x15f, 3.76e2)
                  ? (82, 0x85)
                  : 0x1ce < (60.2e1, 0x21b)
                  ? (9.49e2, 'b')
                  : (8.17e2, 3) >= 0x162
                  ? (0x56, 95)
                  : (54, 0x71),
              V = 'nas',
              i = 'df',
              z = 'pa',
              W = null,
              C =
                (1.318e3, 53.3e1) > 124
                  ? (77.0e1, false)
                  : (3.62e2, 35.4e1) >= 125.2e1
                  ? (0x1c8, 39.0e1)
                  : (0x1d0, 9.67e2) < 57
                  ? 'K'
                  : (1.76e2, 6.04e2),
              e =
                116 >= (0x9c, 0xfe)
                  ? 6
                  : (130, 107) < 0x204
                  ? (0xe7, false)
                  : (0xd4, 0x16d),
              r =
                (0x60, 29.4e1) > (94.3e1, 5.99e2)
                  ? (5.45e2, 38)
                  : (0x224, 35) >= (75, 1.44e2)
                  ? 0x178
                  : 145 < (0x197, 0x148)
                  ? (57, false)
                  : (0x16e, 5.1e2),
              a = (9, 104) < (133, 131) ? (1.484e3, false) : (4.11e2, 54),
              L =
                (74, 0x200) > (52, 63.9e1)
                  ? (0x39, 0x9f)
                  : (111, 0x77) <= 0x174
                  ? (0xe4, false)
                  : (55, 72.5e1)
            for (
              var v =
                (94.5e1, 42) > (0x118, 59.9e1)
                  ? 'T'
                  : (52, 54) <= 0x73
                  ? (0xfe, 0)
                  : (2.22e2, 47);
              J0l4h.u5h(v, S.length);
              v++
            ) {
              var b = S[v]
              switch (b) {
                case N6 + H6 + b6 + P:
                case z + P3 + i:
                  W = b
                  break
                case d3 + O6 + P + N6 + P + V + d3 + P:
                case J3 + P + P3 + O6 + t + Z3 + O6 + H6 + N6:
                case R + j + O6 + w + s6:
                case I6 + P3 + N6 + c6:
                  W = w3 + H6 + z3 + U
                  break
                default:
                  return (0x68, 3.55e2) > (0x5f, 50)
                    ? (1.137e3, null)
                    : (146, 3.48e2)
              }
            }
            if (
              J0l4h.R5h(
                W,
                (125, 18.4e1) >= 1.9e1
                  ? (0x1e8, null)
                  : (20.3e1, 2) >= 0x134
                  ? 'G'
                  : (0x58, 79.0e1)
              )
            )
              return null
            return new L6.Renderer[
              J0l4h.U5h(W, w3 + D + E)
                ? d
                : A6 + b6 + b6 + Z3 + O6 + b6 + H6 + y6 + c + P3 + s6
            ]({
              params: L6.extend(H, {
                type: W,
              }),
            })
          }
          L6.Renderer.Aggregations.prototype.drawIndividualSeries = function(
            S,
            H
          ) {
            var c = 'ow',
              d = '_p',
              E = 'f_',
              D = 'df_',
              U = 'x_pan',
              w = 'wn',
              j = '_ka',
              R = 'tx',
              t = 'up',
              V = 'down',
              i = 'ag',
              z = 'x_k',
              W = 'kagi',
              C =
                138.7e1 <= (0x220, 116.9e1)
                  ? (0xd7, 87.7e1)
                  : (105, 0x247) > 129
                  ? (140, 'x')
                  : (0x10f, 2),
              e = 'st',
              r = 'agi'
            if (H.invalid) return
            var a = this.stx,
              L = {
                colors: [],
              }
            if (J0l4h.t5h(H.type, N6 + r)) {
              a.drawKagiSquareWave(
                S.panel,
                e + C + o6 + W + o6 + f3 + A3,
                s6 + y6 + z + i + P + o6 + V,
                H
              )
              L.colors.push(
                a.getCanvasColor(e + C + o6 + N6 + H6 + b6 + P + o6 + t)
              )
              L.colors.push(
                a.getCanvasColor(s6 + R + j + b6 + P + o6 + d6 + c6 + w)
              )
            } else if (J0l4h.I5h(H.type, A3 + H6 + P3 + d6 + G6)) {
              a.drawPointFigureChart(S.panel, e + U + D + t, F3, H)
              L.colors.push(
                a.getCanvasColor(s6 + y6 + C + o6 + A3 + H6 + z3 + E + f3 + A3)
              )
              a.drawPointFigureChart(
                S.panel,
                e + C + d + H6 + P3 + d6 + G6 + o6 + d6 + c + P3,
                M3,
                H
              )
              L.colors.push(
                a.getCanvasColor(e + C + d + H6 + z3 + G6 + o6 + d6 + c + P3)
              )
            }
            return L
          }
          L6.ChartEngine.prototype.drawKagiSquareWave = function(S, H, c, d) {
            var E = S.chart
            this.startClip(S.name)
            var D = E.dataSegment,
              U = E.context,
              w = this.canvasStyle(H),
              j = this.canvasStyle(c)
            this.canvasColor(H)
            if (d.border_color_up) U.strokeStyle = d.border_color_up
            var R = U.strokeStyle
            this.canvasColor(c)
            if (d.border_color_down) U.strokeStyle = d.border_color_down
            var t = U.strokeStyle,
              V =
                (14.48e2, 2) >= 147.8e1
                  ? (34, 'o')
                  : (0x224, 0x4a) < 0x138
                  ? (0x9b, 1)
                  : 7.6e2 > (0x151, 106.7e1)
                  ? (80.9e1, 54)
                  : (0xd5, 48.4e1)
            if (
              w.width &&
              J0l4h.V5h(
                parseInt(
                  w.width,
                  13.09e2 >= (27.2e1, 0x22a)
                    ? (31, 10)
                    : (48, 6.24e2) >= 95.1e1
                    ? (7.64e2, 0x2b)
                    : (0x247, 0x102)
                ),
                (1.2e2, 23) < 0xd9
                  ? (14, 25)
                  : (0x254, 0xf8) > (6.8e1, 0x210)
                  ? (0x3c, 5.37e2)
                  : (0x135, 0x1fd) < (0x1bc, 0x145)
                  ? 61.6e1
                  : (42.3e1, 0)
              )
            ) {
              V = Math.max(1, L6.stripPX(w.width))
            }
            var i = (0x23d, 0x16a) > 30.4e1 ? (108, 1) : (0x24d, 1.1e1)
            if (
              j.width &&
              J0l4h.d5h(
                parseInt(
                  j.width,
                  (148, 124) < (0x34, 0x79)
                    ? (23, 1.09e2)
                    : 0x17b >= (146.4e1, 67)
                    ? (119, 10)
                    : (0x56, 105)
                ),
                (0x226, 5.59e2) > (0x20f, 8.27e2)
                  ? (14.13e2, 29.2e1)
                  : (0x1a0, 77) > 44
                  ? (12.57e2, 25)
                  : (1.71e2, 67) >= (101, 0x199)
                  ? 'u'
                  : (104, 32)
              )
            ) {
              i = Math.max(
                7.42e2 <= (27, 0x221)
                  ? 80.1e1
                  : (20, 110) <= (80, 34)
                  ? (0x1c0, 117)
                  : (0x98, 1.45e2) <= 1.119e3
                  ? (26, 1)
                  : (22, 3.3e2),
                L6.stripPX(j.width)
              )
            }
            U.beginPath()
            var z = J0l4h.F5h(
                E.dataSet.length,
                E.scroll,
                (69, 38) >= 71
                  ? 128
                  : (6.5e2, 0x127) > (3.8e2, 9.5e1)
                  ? (147, 1)
                  : (85.9e1, 0x249) >= 139.6e1
                  ? (70, 84)
                  : (59, 0x22d)
              ),
              W = S.yAxis,
              C = true,
              e = 92 > (6.99e2, 4) ? (43, null) : (121, 0x1e0),
              r = null,
              a = null,
              L = J0l4h.N5h(
                S.left,
                0.5 * this.layout.candleWidth,
                this.micropixels,
                (2.58e2, 0x243) > 0x1a2 ? (58.4e1, 1) : (0xa5, 85.1e1)
              )
            for (
              var v =
                112 > (0x100, 138.7e1)
                  ? (74, 13)
                  : (0x97, 0x254) <= (147.0e1, 85.8e1)
                  ? (148, 0)
                  : (52, 0xc8);
              J0l4h.E5h(v, D.length);
              v++
            ) {
              L += this.layout.candleWidth
              var b = D[v]
              if (!b) continue
              if (b.projection) break
              a = b.kagiTrend
              if (b.transform && E.transformFunc) {
                var J = b.kagiPrevOpen
                b = b.transform
                b.kagiPrevOpen = E.transformFunc(this, E, J)
              }
              var O = b.cache,
                N = z + v
              if (
                J0l4h.o5h(N, S.cacheLeft) ||
                J0l4h.e5h(N, S.cacheRight) ||
                !O.kagiOpen
              ) {
                O.kagiOpen = W.semiLog
                  ? this.pixelFromTransformedValue(b.Open, S)
                  : J0l4h.A5h(W.high - b.Open, W.multiplier) + W.top
                O.kagiClose = W.semiLog
                  ? this.pixelFromTransformedValue(b.Close, S)
                  : J0l4h.k5h(W.high - b.Close, W.multiplier) + W.top
              }
              e = W.semiLog
                ? this.pixelFromTransformedValue(b.kagiPrevOpen, S)
                : J0l4h.P5h(W.high - b.kagiPrevOpen, W.multiplier) + W.top
              r = O.kagiClose
              if (C) {
                U.moveTo(
                  J0l4h.l5h(
                    z,
                    (116.3e1, 96) < 63
                      ? (0x16f, 'z')
                      : 0x6a <= (0x2a, 75)
                      ? (0xdd, 'z')
                      : (0x1b6, 77) <= (121, 8.14e2)
                      ? (27, 0)
                      : (99.1e1, 91.7e1)
                  )
                    ? S.left
                    : Math.floor(L),
                  O.kagiOpen
                )
                U.lineTo(Math.floor(L), O.kagiOpen)
                C =
                  (0x24f, 140) < (30, 57)
                    ? (42, 325)
                    : 63 >= (0x1b1, 6.98e2)
                    ? (147, 325)
                    : (107, 0x1fa) >= (0x17b, 0x105)
                    ? (13, false)
                    : (62, 121)
              }
              if (
                a != -((27, 2.78e2) > 6 ? (42.3e1, 1) : (0x3d, 82.8e1)) &&
                J0l4h.y9h(O.kagiClose, e) &&
                J0l4h.H9h(e, O.kagiOpen)
              ) {
                U.lineTo(Math.floor(L), e)
                if (!C) {
                  U.stroke()
                  U.beginPath()
                  U.moveTo(Math.floor(L), e)
                }
                U.strokeStyle = R
                U.lineWidth = V
              } else if (
                J0l4h.c9h(
                  a,
                  44.8e1 >= (127, 0x58) ? (97, 1) : (4.54e2, 5.47e2)
                ) &&
                J0l4h.a9h(O.kagiClose, e) &&
                J0l4h.D9h(e, O.kagiOpen)
              ) {
                U.lineTo(Math.floor(L), e)
                if (!C) {
                  U.stroke()
                  U.beginPath()
                  U.moveTo(Math.floor(L), e)
                }
                U.strokeStyle = t
                U.lineWidth = i
              }
              U.lineTo(Math.floor(L), O.kagiClose)
              if (
                J0l4h.Q9h(
                  v + ((0x45, 0x16e) >= (65, 0x30) ? (7, 1) : (119, 0x17e)),
                  D.length
                )
              ) {
                U.lineTo(Math.floor(L + this.layout.candleWidth), O.kagiClose)
              }
              C =
                (120, 19.6e1) >= (0xf8, 7.0e2)
                  ? 'Y'
                  : (67, 82) >= (0x1e6, 0xe)
                  ? (0x138, false)
                  : (0x1c, 110) >= (0x1c2, 10.53e2)
                  ? (135.2e1, 'Y')
                  : (55, 6.77e2)
            }
            U.stroke()
            this.endClip()
            U.lineWidth =
              84 < (0xf7, 5.25e2)
                ? (70, 1)
                : (37, 2.87e2) >= 0x248
                ? (70.7e1, 0x135)
                : (8.84e2, 11.15e2)
          }
          L6.ChartEngine.prototype.drawPointFigureChart = function(d, E, D, U) {
            var w = d.chart
            this.startClip(d.name)
            var j = w.dataSegment,
              R = w.context
            this.canvasColor(E)
            if (J0l4h.i9h(D, 'X') && U.border_color_up)
              R.strokeStyle = U.border_color_up
            else if (
              J0l4h.M9h(
                D,
                (0x105, 14.07e2) > (6.5e2, 12.16e2)
                  ? (0x189, 'O')
                  : (0x1a6, 0x1ec)
              ) &&
              U.border_color_down
            )
              R.strokeStyle = U.border_color_down
            var t = this.canvasStyle(E),
              V = parseInt(
                t.paddingTop,
                11.57e2 < (78, 70)
                  ? 85
                  : (91.8e1, 91) < 140
                  ? (28.6e1, 10)
                  : (0x9c, 1.35e2)
              ),
              i = parseInt(t.paddingBottom, 10),
              z = parseInt(t.paddingLeft, 10),
              W = parseInt(
                t.paddingRight,
                45 <= (83, 34)
                  ? 'h'
                  : (9.98e2, 14.88e2) > 82
                  ? (12.28e2, 10)
                  : (0x156, 0xa0)
              )

            function C(S, H, c) {
              R.moveTo(S + z, J0l4h.w9h(c, i, O))
              R.lineTo(J0l4h.z9h(H, W), J0l4h.E9h(c, J, V, O))
              R.moveTo(S + z, J0l4h.J9h(c, J, V, O))
              R.lineTo(J0l4h.s9h(H, W), J0l4h.g9h(c, i, O))
            }

            function e(S, H, c) {
              R.moveTo(
                J0l4h.q9h(
                  S + H,
                  (0x1e4, 47.9e1) >= 0x222
                    ? (129, 54)
                    : (82, 0x71) >= 2.11e2
                    ? 0x14
                    : 4.81e2 > (0x61, 0x178)
                    ? (0xd4, 2)
                    : (143, 16)
                ),
                c + V - O
              )
              R.bezierCurveTo(
                H + W,
                c + V - O,
                H + W,
                c + J - i - O,
                J0l4h.S8h(S + H, 2),
                c + J - i - O
              )
              R.bezierCurveTo(
                J0l4h.x8h(S, z),
                c + J - i - O,
                J0l4h.X8h(S, z),
                c + V - O,
                J0l4h.r8h(
                  S + H,
                  0x116 > (108, 0x71)
                    ? (86, 2)
                    : (2.1e1, 0x172) <= 0xf0
                    ? (1.484e3, 'g')
                    : (3.56e2, 1.297e3)
                ),
                c + V - O
              )
            }
            if (
              t.width &&
              J0l4h.G8h(
                parseInt(
                  t.width,
                  1.389e3 > (0xcb, 13.77e2)
                    ? (68, 10)
                    : (104, 100) < 54
                    ? (124.8e1, 0x138)
                    : 14 > (0x126, 6.54e2)
                    ? 0x137
                    : (0x22c, 0x5d)
                ),
                (102.9e1, 0x3b) < (0x10e, 36.0e1)
                  ? (138, 25)
                  : (1.266e3, 58.0e1)
              )
            ) {
              R.lineWidth = Math.max(
                (37, 64) > (140, 49.6e1)
                  ? (76.4e1, 0xb8)
                  : (0x149, 10.81e2) > 112
                  ? (12.96e2, 1)
                  : (7.86e2, 3.09e2),
                L6.stripPX(t.width)
              )
            } else {
              R.lineWidth =
                (143, 0x50) > 12.6e1
                  ? (0xb, 21.2e1)
                  : (0x153, 0xf5) <= 0x1c2
                  ? (4.47e2, 2)
                  : (91.7e1, 90) >= (149, 133)
                  ? (110, 0x21f)
                  : (1.458e3, 0x105)
            }
            R.beginPath()
            var r = this.chart.state.aggregation.box,
              a = J0l4h.L8h(
                w.dataSet.length,
                w.scroll,
                80.1e1 >= (0x11b, 60)
                  ? (20.6e1, 1)
                  : 91 >= (0x1cd, 2.76e2)
                  ? (26.2e1, 0x11e)
                  : (0x210, 0x60)
              ),
              L = d.yAxis,
              v,
              b,
              J = J0l4h.i8h(r, L.multiplier),
              O = J0l4h.M8h(
                J,
                19 > (85, 108)
                  ? 25
                  : (5, 0x98) >= 0xd1
                  ? 'k'
                  : (6.45e2, 0x1f7) > 0x9f
                  ? (12.08e2, 2)
                  : (0x17b, 4.08e2)
              ),
              N = this.layout.candleWidth,
              B = J0l4h.w8h(
                d.left,
                N,
                this.micropixels,
                53.0e1 > (70.9e1, 134) ? (102, 1) : (29, 5.31e2)
              )
            for (var s = 0; J0l4h.b8h(s, j.length); s++) {
              B += N
              var Y = j[s]
              if (!Y) continue
              if (Y.projection) break
              var o = Y.pfOpen,
                F = Y.pfClose,
                y3 = Y.pfTrend,
                K = Y.pfStepBack
              if (Y.transform && w.transformFunc) {
                Y = Y.transform
                o = w.transformFunc(this, w, o)
                F = w.transformFunc(this, w, F)
              }
              var g = Y.cache,
                q = a + s
              if (
                J0l4h.B8h(q, d.cacheLeft) ||
                J0l4h.Y8h(q, d.cacheRight) ||
                !g.pfOpen
              ) {
                g.pfOpen = J0l4h.T8h(L.high - o, L.multiplier) + L.top
                g.pfClose = J0l4h.s8h(L.high - F, L.multiplier) + L.top
              }
              var l = Math.round(B),
                A = Math.round(B + N)
              v = Math.abs(Math.round(J0l4h.g8h(F - o, r)))
              b = g.pfOpen
              if (J0l4h.p8h(D, K)) {
                if (
                  J0l4h.n8h(
                    K,
                    38 >= (95, 12.9e1)
                      ? (40, 24)
                      : (98, 0xae) < (0, 11.64e2)
                      ? (73, 'X')
                      : (49, 9.04e2) <= (0x5, 137)
                      ? 24
                      : (70, 1.424e3)
                  )
                )
                  C(l, A, J0l4h.u7h(b, J))
                else if (J0l4h.R7h(K, 'O')) e(l, A, b + J)
              }
              if (J0l4h.U7h(D, y3)) {
                for (; J0l4h.t7h(v, 0); v--) {
                  if (
                    J0l4h.I7h(D, (16, 112) > 0x31 ? (110, 'X') : (77, 14.8e1))
                  ) {
                    C(l, A, b, J, O)
                    b -= J
                  } else if (
                    J0l4h.V7h(
                      D,
                      (1.43e2, 75) < (0x10d, 12.69e2)
                        ? (102, 'O')
                        : (10.3e2, 49.0e1)
                    )
                  ) {
                    e(l, A, b, J, O)
                    b += J
                  }
                }
              }
            }
            R.stroke()
            this.endClip()
            R.lineWidth =
              (0xc9, 91) >= (137, 87)
                ? (0x12a, 1)
                : 113 > (106, 0x80)
                ? 'hlc'
                : (0x21, 93)
          }
          L6.calculateHeikinAshi = function(S, H, c) {
            if (!H.length) return H
            if (!c) c = []
            var d = []
            for (var E = 0; J0l4h.d7h(E, H.length); E++) {
              var D = H[E]
              if (!D) continue
              var U =
                d[
                  J0l4h.F7h(
                    d.length,
                    (21.0e1, 0x257) >= (134, 0x177)
                      ? (0xfd, 1)
                      : 78 > (95.8e1, 98)
                      ? (0x205, 0x1bc)
                      : (82, 148)
                  )
                ]
              if (!U && !E)
                U =
                  c[
                    J0l4h.f7h(
                      c.length,
                      1.35e2 > (2.37e2, 75) ? (9.12e2, 1) : (14.18e2, 39)
                    )
                  ]
              if (!U) U = D
              var w = D.Close,
                j = D.Open,
                R = D.High,
                t = D.Low,
                V = U.Open
              j =
                j ||
                J0l4h.z7h(
                  j,
                  (46, 1.44e3) >= (14.59e2, 14.88e2)
                    ? (0x22f, 'e')
                    : 0xb4 <= (4, 0x1e5)
                    ? (3.8e1, 0)
                    : (0x13f, 0x18b)
                )
                  ? j
                  : w
              R =
                R ||
                J0l4h.E7h(
                  R,
                  (19, 0x14d) <= (0x15f, 0x16d) ? (96, 0) : (0x147, 12)
                )
                  ? R
                  : w
              t =
                t ||
                J0l4h.o7h(t, (39, 6.06e2) > (26, 0x1a8) ? (128, 0) : (140, 76))
                  ? t
                  : w
              V =
                V ||
                J0l4h.e7h(
                  V,
                  1.069e3 > (0x22d, 1.23e2)
                    ? (0xfe, 0)
                    : 115 >= (121, 48.3e1)
                    ? (14, 's')
                    : (0x214, 0xb8)
                )
                  ? V
                  : U.Close
              var i = J0l4h.A7h(
                  V + U.Close,
                  (15.6e1, 25) <= 7.02e2 ? (149, 2) : (1.098e3, 9)
                ),
                z = J0l4h.k7h(
                  j + R + t + w,
                  (9.3e1, 0x171) >= (127, 0x240)
                    ? 'x0'
                    : (3.09e2, 32) < 13.74e2
                    ? (13.61e2, 4)
                    : (67, 48.1e1)
                ),
                W = {
                  DT: D.DT,
                  displayDate: D.displayDate,
                  Date: D.Date,
                  Open: i,
                  Close: z,
                  High: Math.max(R, Math.max(i, z)),
                  Low: Math.min(t, Math.min(i, z)),
                  Volume: D.Volume,
                  iqPrevClose: U.Close,
                }
              for (var C in D) {
                if (
                  !W[C] &&
                  J0l4h.P7h(
                    W[C],
                    (18, 0x159) <= (0x8f, 0x194)
                      ? (2.07e2, 0)
                      : (34.6e1, 11.69e2)
                  )
                ) {
                  W[C] = D[C]
                }
              }
              d.push(W)
            }
            return d
          }
          L6.calculateKagi = function(S, H, c, d) {
            if (!H.length) return H
            if (!d) d = []
            var E = S.layout
            c = parseFloat(c)
            S.chart.defaultChartStyleConfig.kagi = L6.ChartEngine.isDailyInterval(
              E.interval
            )
              ? (37, 0x4c) >= (10.54e2, 6.5e1)
                ? (0x72, 4)
                : (2.72e2, 131.0e1)
              : (123, 0x238) >= (0x3d, 0x13f)
              ? (0xa1, 0.4)
              : (121, 0x245) < (26, 0x227)
              ? 139
              : (4.64e2, 4.1e2)
            if (isNaN(c) || J0l4h.l7h(c, 0)) {
              c = S.chart.defaultChartStyleConfig.kagi
              if (L6.Market.Symbology.isForexSymbol(S.chart.symbol))
                c /=
                  0x1ab <= (0x1f4, 61)
                    ? (0x5f, 10000)
                    : 65 <= (0x195, 0x210)
                    ? (15.2e1, 4)
                    : (0x31, 0x46) > (57, 0xe9)
                    ? (58.1e1, 51)
                    : (0x216, 11.59e2)
              if (
                J0l4h.y3s(
                  E.kagi,
                  (137, 47) <= (4.41e2, 0x186) ? (0xd4, null) : (0x1ba, 83)
                )
              ) {
                E.kagi =
                  (101.5e1, 101) >= (10.78e2, 54)
                    ? (71.1e1, null)
                    : (0x159, 0xb8) > 51.8e1
                    ? 57
                    : 0x1c0 < (138, 92)
                    ? 't'
                    : (0x21a, 0x145)
                S.changeOccurred(o3 + k3 + c6 + f3 + y6)
              }
            }
            c /=
              (0x9e, 0x5) < 0x1e2
                ? (37, 100)
                : 0x247 <= (138.5e1, 16)
                ? 0x1c4
                : (119, 14) >= (4.31e2, 26)
                ? 't'
                : (1.429e3, 0x12f)
            var D = [],
              U =
                d[
                  J0l4h.H3s(
                    d.length,
                    (24.7e1, 0x13f) >= (79, 118)
                      ? (0x94, 1)
                      : (2.37e2, 119) < 4.5e1
                      ? (1.022e3, 0x6a)
                      : (0x188, 11.17e2)
                  )
                ],
              w = U
                ? U.DT
                : (0x7a, 8.36e2) >= (0x11f, 0x250)
                ? (8.62e2, 0)
                : (0x221, 144)
            for (
              var j = (6.46e2, 0x6b) <= 6.24e2 ? (79, 0) : (35.2e1, 120);
              J0l4h.c3s(j, H.length);
              j++
            ) {
              var R = H[j]
              if (!R) continue
              if (!U) U = H[J0l4h.a3s(j, 1)]
              if (!U) continue
              var t =
                U.Open ||
                J0l4h.D3s(
                  U.Open,
                  (0x58, 42.4e1) < (0x29, 8.3e2) ? (1.403e3, 0) : (40, 6.29e2)
                )
                  ? U.Open
                  : U.Close
              if (J0l4h.Q3s(t, U.Close)) {
                if (
                  J0l4h.i3s(
                    R.Close,
                    U.Close *
                      (((0x21a, 9.7e2) > (121, 91) ? (78.1e1, 1) : (24, 121)) +
                        c)
                  )
                ) {
                  R.Open = U.Close
                } else {
                  if (J0l4h.M3s(U.Close, R.Close)) U.Close = R.Close
                  U.Volume += R.Volume
                  if (
                    J0l4h.w3s(
                      j,
                      H.length -
                        (7.1e2 >= (13.01e2, 66.7e1)
                          ? (47, 1)
                          : 1.331e3 <= (129, 1.185e3)
                          ? 'n'
                          : (0x96, 1.454e3))
                    )
                  )
                    continue
                }
              } else if (J0l4h.C3s(t, U.Close)) {
                if (J0l4h.Z3s(R.Close, U.Close * (1 - c))) {
                  R.Open = U.Close
                } else {
                  if (J0l4h.h3s(U.Close, R.Close)) U.Close = R.Close
                  U.Volume += R.Volume
                  if (
                    J0l4h.J3s(
                      j,
                      H.length -
                        ((0x1bf, 0xe7) > 1.293e3
                          ? 0x21d
                          : (149, 33.7e1) < 12.43e2
                          ? (0xf0, 1)
                          : (0x1da, 0x1b6))
                    )
                  )
                    continue
                }
              } else {
                U.Close = R.Close
                U.Volume += R.Volume
                if (
                  J0l4h.v3s(
                    j,
                    H.length -
                      ((9.42e2, 30) > 3.82e2
                        ? 121
                        : (7.03e2, 115) <= (13, 0x38)
                        ? (0x24f, 't')
                        : (40, 6.3e1) <= (71.2e1, 118)
                        ? (51.2e1, 1)
                        : (0x18d, 0x2b))
                  )
                )
                  continue
              }
              var V = {
                DT: U.DT,
                displayDate: U.displayDate,
                Date: U.Date,
                Open: U.Open,
                Close: U.Close,
                High: Math.max(U.Open, U.Close),
                Low: Math.min(U.Open, U.Close),
                Volume: U.Volume,
                iqPrevClose: U.iqPrevClose,
              }
              for (var i in U) {
                if (
                  !V[i] &&
                  J0l4h.K3s(
                    V[i],
                    (0x30, 135) > (0x107, 102.3e1)
                      ? 0.8
                      : (122.5e1, 113) > 0x1f
                      ? (25, 0)
                      : (6.1e1, 0x257)
                  )
                ) {
                  V[i] = U[i]
                }
              }
              if (D.length) V.kagiPrevOpen = D[J0l4h.m3s(D.length, 1)].Open
              else V.kagiPrevOpen = V.Open
              if (
                J0l4h.q3s(V.Close, V.kagiPrevOpen) &&
                J0l4h.S6s(V.kagiPrevOpen, V.Open)
              )
                V.kagiTrend = 1
              else if (
                J0l4h.x6s(V.Close, V.kagiPrevOpen) &&
                J0l4h.X6s(V.kagiPrevOpen, V.Open)
              )
                V.kagiTrend = -((8.0e2, 0x53) <= (0x7d, 0xce)
                  ? (0x94, 1)
                  : (1.427e3, 86.2e1))
              if (J0l4h.r6s(w, V.DT)) D.push(V)
              U = R
              S.chart.currentQuote = {
                Close: R.Close,
              }
            }
            return D
          }
          var p6 = x6,
            l6 = S6,
            X0 = J0l4h.n9z
          for (
            var Y6 = J0l4h.l9z;
            J0l4h.A8s.s8s(Y6.toString(), Y6.toString().length, a3) !== p6;
            Y6++
          ) {
            X0 += J0l4h.n9z
          }
          if (J0l4h.A8s.s8s(X0.toString(), X0.toString().length, n) !== l6) {
            return T5 != v5
          }
          L6.calculateLineBreak = function(S, H, c, d) {
            var E = 'layo'
            if (!H.length) return H
            if (!d) d = []
            var D = S.layout
            S.chart.defaultChartStyleConfig.priceLines =
              (31.4e1, 106.0e1) <= (6.99e2, 94.8e1)
                ? (0x24a, 5.22e2)
                : (0x68, 0x19) <= 90
                ? (1.1e1, 3)
                : 0x20d > (0x5f, 65.2e1)
                ? (3.99e2, 'y')
                : (0x18, 45)
            c = parseInt(
              c,
              (1.0e2, 10.1e2) > (1.497e3, 7.08e2) ? (9.6e1, 10) : (15, 27)
            )
            if (
              isNaN(c) ||
              J0l4h.G6s(
                c,
                (129, 8.83e2) < (97.4e1, 67)
                  ? (0x1e5, 5.26e2)
                  : (91, 18) < 1.97e2
                  ? (0x9b, 0)
                  : (0x121, 9.1e1)
              )
            ) {
              c = S.chart.defaultChartStyleConfig.priceLines
              if (
                J0l4h.L6s(
                  D.priceLines,
                  (0x24a, 112.0e1) > (137, 125) ? (0x12, null) : (57, 138)
                )
              ) {
                D.priceLines =
                  0x1d7 <= (142, 2.53e2)
                    ? (14.91e2, 'pan')
                    : (0x212, 132) < (51.2e1, 3.37e2)
                    ? (39, null)
                    : (51, 6.37e2)
                S.changeOccurred(E + l3)
              }
            } else if (J0l4h.j6s(c, 63 <= (75, 111) ? (0x92, 10) : (127, 30))) {
              D.priceLines = c =
                (1.155e3, 0xf4) > (0x6d, 0x94)
                  ? (0x19d, 10)
                  : (104.7e1, 83) > 84
                  ? (0x52, 'S')
                  : 19.2e1 <= (0xc8, 0x9b)
                  ? 'x0'
                  : (7.13e2, 1.036e3)
            }
            var U = d.slice(-c),
              w = U.length,
              j =
                (135, 0xb3) >= (55.6e1, 0xbb)
                  ? (94, 0x19e)
                  : 0x21d <= (0x1c5, 121)
                  ? 'm'
                  : (140, 0x69) <= 3.94e2
                  ? (135, 0)
                  : (0xdc, 0x109)
            outer: for (
              var R =
                0x1f7 > (1.99e2, 0x11c)
                  ? (0x214, 0)
                  : 129 <= (76.0e1, 36)
                  ? 'l'
                  : 36 >= (39.8e1, 0x212)
                  ? (20.0e1, 1.47e2)
                  : (68, 0x1a4);
              J0l4h.O6s(R, H.length);
              R++
            ) {
              var t = H[R]
              if (!t) continue
              j += t.Volume
              var V =
                U[
                  J0l4h.W6s(
                    U.length,
                    (120, 28) <= 50 ? (0x152, 1) : (14.73e2, 5.52e2)
                  )
                ]
              if (!V)
                V = {
                  Open: t.Open,
                  Close: t.Open,
                  High: t.Open,
                  Low: t.Open,
                }
              var i = V.Close,
                z = V.High,
                W = V.Low,
                C = V.Open
              z =
                z || J0l4h.N6s(z, 101 > (138, 40) ? (61, 0) : (0xce, 0x1a5))
                  ? z
                  : i
              W =
                W ||
                J0l4h.b6s(W, 34.6e1 > (7.84e2, 10) ? (0xfe, 0) : (6.0e1, 112))
                  ? W
                  : i
              C = C || J0l4h.B6s(C, 0) ? C : i
              var e = {
                DT: t.DT,
                displayDate: t.displayDate,
                Date: t.Date,
                Close: t.Close,
                Volume: j,
                iqPrevClose: i,
              }
              S.chart.currentQuote = {
                Close: t.Close,
              }
              var r, a
              if (J0l4h.Y6s(t.Close, i) && J0l4h.T6s(V.Close, C)) {
              } else if (J0l4h.s6s(t.Close, i) && J0l4h.g6s(V.Close, C)) {
              } else if (J0l4h.p6s(t.Close, z)) {
                for (
                  r =
                    (55, 0x1fe) > 6.33e2
                      ? (0x114, 0x29)
                      : (0x24f, 52.4e1) >= 101
                      ? (116, 2)
                      : (0x15d, 42);
                  J0l4h.n6s(r, c);
                  r++
                ) {
                  a = U[J0l4h.u0s(U.length, r)]
                  if (a && J0l4h.R0s(t.Close, a.High)) {
                    continue outer
                  }
                }
              } else if (J0l4h.U0s(t.Close, W)) {
                for (
                  r =
                    (0x1d, 4.2e1) >= 83.0e1
                      ? 0x46
                      : (132.2e1, 8.49e2) <= 0xcf
                      ? (1.436e3, 63)
                      : 127 <= (0x14e, 0x123)
                      ? (107.4e1, 2)
                      : (12.22e2, 0x1e);
                  J0l4h.t0s(r, c);
                  r++
                ) {
                  a = U[J0l4h.I0s(U.length, r)]
                  if (a && J0l4h.V0s(t.Close, a.Low)) {
                    continue outer
                  }
                }
              } else continue
              if (J0l4h.d0s(t.Close, V.Close)) e.Open = Math.min(C, i)
              else e.Open = Math.max(C, i)
              e.Low = Math.min(e.Open, e.Close)
              e.High = Math.max(e.Open, e.Close)
              for (var L in t) {
                if (
                  !e[L] &&
                  J0l4h.F0s(
                    e[L],
                    (0xd5, 63.0e1) < 0x13a
                      ? 34
                      : (142.1e1, 12) < (69.6e1, 0x10c)
                      ? (0x82, 0)
                      : (15.1e1, 7.97e2)
                  )
                ) {
                  e[L] = t[L]
                }
              }
              U.push(e)
              j =
                9 >= (134, 102)
                  ? (0x256, 'bar')
                  : (127, 69.6e1) >= 19
                  ? (145.8e1, 0)
                  : (96, 5.2e1) > 106
                  ? (0x179, 'm')
                  : (0xf9, 128)
            }
            return U.slice(w)
          }
          L6.calculateRenkoBars = function(E, D, U, w) {
            var j = 'igh',
              R = 'ose',
              t = 'Cl'
            if (!D.length) return []
            if (!w) w = []
            var V = E.layout,
              i = E.chart.state.aggregation
            if (!i) i = E.chart.state.aggregation = {}
            var z = Math.min(
              0x94 < (72.8e1, 7.44e2) ? (12, 300) : (0x257, 51),
              D.length
            )
            if (!i.minMax)
              i.minMax = E.determineMinMax(D.slice(J0l4h.f0s(D.length, z)), [
                t + R,
                h3 + j,
                q3 + c6 + a6,
              ])
            var W = J0l4h.z0s(
                i.minMax[(92, 33) <= 0x1ce ? (0xcd, 1) : (0x1c2, 0x247)],
                i.minMax[
                  0x1bc <= (114, 55)
                    ? 101
                    : (67.5e1, 79) > (0x3d, 0x55)
                    ? 0x161
                    : (55.3e1, 144.8e1) >= (2.15e2, 0x104)
                    ? (28, 0)
                    : (35, 139)
                ]
              ),
              C = E.panels[E.chart.name].height
            if (!C) return []
            E.chart.defaultChartStyleConfig.renko = J0l4h.E0s(
              Math.floor(
                (((0x14d, 69) < (7, 1.239e3) ? (15, 10000) : (4.57e2, 6.96e2)) *
                  W) /
                  (C / 30)
              ),
              0x230 > (7.02e2, 0x235)
                ? (0x13e, 0x57)
                : (34, 0x21c) < (12.22e2, 11.46e2)
                ? (73, 10000)
                : (0x250, 0x1be)
            )
            if (
              J0l4h.o0s(
                U,
                (38, 11.61e2) > (148, 1.02e2)
                  ? (9.35e2, null)
                  : (35.9e1, 8.67e2) < (16, 0x199)
                  ? 0x21f
                  : (116, 137.0e1)
              ) ||
              isNaN(U) ||
              J0l4h.e0s(
                U,
                (14.44e2, 0x1af) < 107.2e1 ? (0x16d, 0) : (24, 0x1ca)
              )
            ) {
              U = E.chart.defaultChartStyleConfig.renko
              if (
                J0l4h.A0s(
                  V.renko,
                  0x62 <= (106, 6)
                    ? (109, 'S')
                    : (79, 63) >= (1.458e3, 29)
                    ? (0x14a, null)
                    : (11.42e2, 0x12b) <= 84
                    ? (127, 'S')
                    : (96.7e1, 12.36e2)
                )
              ) {
                V.renko = null
                E.changeOccurred(o3 + v3 + f3 + y6)
              }
            } else {
              U = Math.max(U, J0l4h.k0s(W, C))
              if (J0l4h.P0s(V.renko, U)) {
                V.renko = U
                E.changeOccurred(J3 + H6 + k3 + c6 + f3 + y6)
              }
            }
            var e = [],
              r = 1.345e3 >= (92, 9) ? (5, null) : (23, 6.42e2),
              a =
                (115, 0x222) < (98, 0xe4)
                  ? 116.3e1
                  : (0x1cc, 116) <= 0x1d5
                  ? (0x23f, null)
                  : (63, 64),
              L =
                (0x14b, 7.7e2) < (0x31, 9.26e2)
                  ? (24, null)
                  : (139, 0xaf) > 14.26e2
                  ? (6.96e2, 0x163)
                  : (1.32e2, 3.19e2) >= (42, 0x1b3)
                  ? (0x8e, 0.9)
                  : (99, 104.3e1)
            if (w.length) {
              var v =
                w[
                  J0l4h.l0s(
                    w.length,
                    (5, 0x6c) >= 0xc0
                      ? (81, 'G')
                      : (0x89, 42.5e1) < 57.4e1
                      ? (122.3e1, 1)
                      : (0x1eb, 0x178)
                  )
                ]
              r = J0l4h.y2s(v.Low, U)
              a = v.High + U
            }

            function b(S, H) {
              var c = {
                DT: L.DT,
                displayDate: L.displayDate,
                Date: L.Date,
                Open: S,
                Close: H,
                High: Math.max(S, H),
                Low: Math.min(S, H),
                Volume: 0,
                iqPrevClose: J0l4h.H2s(S, H)
                  ? S
                  : (0xa0, 5.8e1) <= 0x189
                  ? (0x193, null)
                  : (55, 0x16b) >= (127, 0x195)
                  ? (117, 111.1e1)
                  : (0x1d1, 117.9e1),
              }
              for (var d in L) {
                if (
                  !c[d] &&
                  J0l4h.c2s(
                    c[d],
                    (0xb9, 26.5e1) > 115
                      ? (0x66, 0)
                      : (0x1b8, 1.32e2) < 0x6b
                      ? (139, 37)
                      : (72.7e1, 1.201e3) >= (74, 1.26e3)
                      ? (4.7e1, 'h')
                      : (1.098e3, 93)
                  )
                ) {
                  c[d] = L[d]
                }
              }
              e.push(c)
            }
            for (
              var J = (0xb, 142.0e1) > (0x253, 0xcc) ? (0x248, 0) : (107, 0x4a);
              J0l4h.a2s(J, D.length);
              J++
            ) {
              var O = D[J]
              if (!O) continue
              if (!r && !a) {
                var N = O.Open || J0l4h.D2s(O.Open, 0) ? O.Open : O.Close,
                  B = J0l4h.Q2s(Math.floor(N / U), U),
                  s = isNaN(B) ? N : B
                r = J0l4h.i2s(s, U)
                a = s + U
              }
              while (true) {
                if (!L) L = O
                if (J0l4h.M2s(O.Close, r)) {
                  b(r + U, r)
                  a =
                    r +
                    J0l4h.w2s(
                      (105, 1.453e3) >= (146, 21)
                        ? (88, 2)
                        : (120, 65) < (0x1d6, 62)
                        ? (25, 'G')
                        : (1.426e3, 49.8e1) < (0x98, 0xb1)
                        ? (0x12e, 0x12)
                        : (12.68e2, 144),
                      U
                    )
                  r -= U
                  L =
                    (137, 5) > (1.236e3, 41)
                      ? (0x1f9, 0.002)
                      : (103, 3.91e2) >= (4.8e1, 0x8)
                      ? (0x10e, null)
                      : (9, 19)
                } else if (J0l4h.C2s(O.Close, a)) {
                  b(J0l4h.Z2s(a, U), a)
                  r = J0l4h.h2s(
                    a,
                    ((27, 1) < (9.83e2, 0xa4)
                      ? (1.091e3, 2)
                      : (8.48e2, 0x1c8)) * U
                  )
                  a += U
                  L = null
                } else break
              }
              E.chart.currentQuote = O
            }
            if (
              J0l4h.J2s(
                r,
                D[
                  D.length -
                    ((61, 16) >= (1.133e3, 4.8e2)
                      ? 0.8
                      : (102, 139) <= 0x1d6
                      ? (109, 1)
                      : 0x1c4 <= (1.369e3, 13)
                      ? (145, 57)
                      : (16, 132.0e1))
                ].Close
              ) &&
              J0l4h.v2s(r + U, D[D.length - 1].Close)
            )
              b(
                r + U,
                D[
                  J0l4h.K2s(
                    D.length,
                    0 < (0xa5, 26)
                      ? (132, 1)
                      : 122 >= (25.2e1, 7.97e2)
                      ? (94, 'y0')
                      : (10.8e2, 31)
                  )
                ].Close
              )
            else if (
              J0l4h.m2s(
                a,
                D[
                  D.length -
                    (4.54e2 > (109, 0x51) ? (0x124, 1) : (0x195, 101.4e1))
                ].Close
              ) &&
              J0l4h.q2s(
                a - U,
                D[
                  D.length -
                    ((2, 0xa8) >= 51
                      ? (0x150, 1)
                      : (48, 103.0e1) <= (0x76, 38)
                      ? 3000
                      : (71.9e1, 62) > 80
                      ? 0x51
                      : (1.484e3, 0x215))
                ].Close
              )
            )
              b(
                J0l4h.S1s(a, U),
                D[
                  J0l4h.x1s(
                    D.length,
                    (0x29, 0x22f) < 7.13e2 ? (0x17a, 1) : (0x100, 94)
                  )
                ].Close
              )
            return e
          }
          L6.calculateRangeBars = function(z, W, C, e) {
            var r = 'ou',
              a = 'os',
              L = (28, 81.5e1) >= 149 ? (1.335e3, 'C') : (0x12c, 95)
            if (!W.length) return W
            if (!e) e = []
            var v = z.layout,
              b = z.chart.state.aggregation
            if (!b) b = z.chart.state.aggregation = {}
            var J = Math.min(
              (0xd3, 14.77e2) < (1.254e3, 1)
                ? (0x1f5, 24)
                : 32.2e1 >= (15, 12.97e2)
                ? (143, 24)
                : (0x21b, 78.9e1) >= (0x208, 0xfe)
                ? (12.47e2, 300)
                : (0x33, 0x5f),
              W.length
            )
            if (!b.minMax)
              b.minMax = z.determineMinMax(W.slice(J0l4h.X1s(W.length, J)), [
                L + J3 + a + O6,
                h3 + P + b6 + d3,
                q3 + c6 + a6,
              ])
            var O = J0l4h.r1s(
                b.minMax[(9.4e2, 65) < 0x20a ? (0x1c3, 1) : (4.15e2, 12.52e2)],
                b.minMax[
                  (1.378e3, 0x6c) > 141
                    ? (55, 0x15d)
                    : (0x17d, 135) <= 0x1be
                    ? (0x1d6, 0)
                    : (0x67, 3.66e2) < (2.98e2, 0x11e)
                    ? 21.8e1
                    : (105, 0xd)
                ]
              ),
              N = z.panels[z.chart.name].height
            if (!N) return []
            z.chart.defaultChartStyleConfig.range = J0l4h.G1s(
              Math.floor(
                (((46.9e1, 82.2e1) > 57 ? (8.43e2, 10000) : (7.1e1, 78)) * O) /
                  (N / ((0xbe, 6.86e2) > 121 ? (125.4e1, 30) : (108, 0x4b)))
              ),
              (0x104, 0x1a9) < (131, 54.0e1)
                ? (1.349e3, 10000)
                : (0x18a, 0x50) > (0x188, 0xb4)
                ? 19
                : (98, 146)
            )
            if (
              J0l4h.L1s(
                C,
                (0x50, 5.45e2) > 137
                  ? (89, null)
                  : (51.1e1, 98) > 0x66
                  ? (148, 25)
                  : (95, 0x10b)
              ) ||
              isNaN(C) ||
              J0l4h.j1s(
                C,
                (0xa5, 2.55e2) >= 108
                  ? (0x13b, 0)
                  : (144.4e1, 132) <= 0x62
                  ? (2.8e2, 1000)
                  : (13.77e2, 19) > (149, 108)
                  ? (0x1bc, 'r')
                  : (2.43e2, 0x12a)
              )
            ) {
              C = z.chart.defaultChartStyleConfig.range
              if (
                J0l4h.O1s(
                  v.range,
                  44.9e1 < (14.3e1, 142.4e1)
                    ? (85, null)
                    : 0x47 > (0x78, 91)
                    ? 28
                    : (0xbc, 0x116) > (0xf8, 0x1a2)
                    ? (0xa6, 0xc3)
                    : (23.7e1, 1.32e2)
                )
              ) {
                v.range = null
                z.changeOccurred(J3 + H6 + k3 + r + y6)
              }
            } else {
              C = Math.max(C, J0l4h.W1s(O, N))
              if (J0l4h.N1s(v.range, C)) {
                v.range = C
                z.changeOccurred(J3 + H6 + v3 + f3 + y6)
              }
            }
            var B = [],
              s =
                107 <= (2.66e2, 0x1)
                  ? (9.54e2, 'Z')
                  : (0x138, 89) <= 5
                  ? 'Z'
                  : 0x20a < (140, 14.0e2)
                  ? (122, null)
                  : (93.7e1, 0x1c2),
              Y =
                (0x139, 1.53e2) > 0x4c
                  ? (0x197, null)
                  : (0x21, 0x108) >= 0x130
                  ? 'k'
                  : (0x1f7, 66),
              o = null,
              F =
                12.05e2 < (0x140, 0x168)
                  ? 0x1b7
                  : 10 <= (0x110, 1.053e3)
                  ? (48.2e1, null)
                  : (9.1e2, 1.236e3),
              y3 =
                0x36 <= (0x95, 122)
                  ? (0x253, null)
                  : (1.4e1, 1.107e3) < 8
                  ? 'p'
                  : (0x24c, 60)

            function K(S) {
              var H = {
                DT: y3.DT,
                displayDate: y3.displayDate,
                Date: y3.Date,
                Open: F,
                Close: S,
                High: Y,
                Low: o,
                Volume: 0,
                iqPrevClose: F,
              }
              for (var c in y3) {
                if (
                  !H[c] &&
                  J0l4h.b1s(
                    H[c],
                    (0x12a, 0x20c) >= 0x56
                      ? (2.22e2, 0)
                      : (0x180, 0xe3) <= (84, 62)
                      ? (0xc6, 8.2e1)
                      : (20, 102) > (0x118, 6.84e2)
                      ? 750
                      : (134, 0x154)
                  )
                ) {
                  H[c] = y3[c]
                }
              }
              B.push(H)
            }

            function g(S, H) {
              var c =
                  (5.93e2, 115) <= (66.4e1, 13)
                    ? (0x20, 0x206)
                    : 0x211 > (21.4e1, 0x194)
                    ? (67.5e1, 'v')
                    : (0xb7, 10.57e2),
                d = 'sM',
                E = 'oc',
                D =
                  (46.4e1, 83) < (101, 4.7e1)
                    ? (0x10, 'u')
                    : (0x1d3, 0x117) <= 0x192
                    ? (5.0e1, ':')
                    : (141.6e1, 94),
                U = 'rs',
                w = 'Ba',
                j = 'nge',
                R = 'Ra',
                t = 'at',
                V = 'ef',
                i =
                  (0x8d, 55.6e1) > 0x61
                    ? (0x18c, 'U')
                    : (0x3f, 9.79e2) < (21, 34)
                    ? (0x8d, 0)
                    : (0x221, 55.2e1)
              while (
                (30.8e1, 0x159) < 12.58e2
                  ? (0x254, 1)
                  : 0x23e <= (0xd5, 0x238)
                  ? 7.19e2
                  : (82.7e1, 0xda) < (85.7e1, 18)
                  ? (24, 130)
                  : (75.9e1, 8.83e2)
              ) {
                if (!y3) y3 = S
                if (J0l4h.B1s(s, H)) {
                  s = Math.min(H, Y)
                  o = Math.max(o, J0l4h.Y1s(s, C))
                  if (J0l4h.T1s(H, Y)) break
                } else if (J0l4h.s1s(s, H)) {
                  s = Math.max(H, o)
                  Y = Math.min(Y, s + C)
                  if (J0l4h.g1s(H, o)) break
                }
                if (typeof s == f3 + P3 + d6 + O6 + G6 + P + P3 + O6 + d6) {
                  console.log(
                    i +
                      d3 +
                      j6 +
                      c6 +
                      d3 +
                      j6 +
                      f3 +
                      P3 +
                      d6 +
                      V +
                      P +
                      P3 +
                      r6 +
                      j6 +
                      P +
                      P3 +
                      j6 +
                      w3 +
                      H6 +
                      J3 +
                      w3 +
                      f3 +
                      J3 +
                      t +
                      O6 +
                      R +
                      j +
                      w +
                      U +
                      D +
                      A3 +
                      Z3 +
                      E +
                      O6 +
                      s6 +
                      d +
                      c6 +
                      c +
                      O6
                  )
                  return
                }
                K(s)
                y3 = null
                q()
              }
            }

            function q() {
              Y = s + C
              o = J0l4h.p1s(s, C)
              F = s
            }
            for (
              var l = 88.8e1 >= (22, 51) ? (16.5e1, 0) : (0x1e2, 94.1e1);
              J0l4h.n1s(l, W.length);
              l++
            ) {
              var A = W[l]
              if (!A) continue
              var c3 = W[J0l4h.u4s(l, 1)]
              if (!l) {
                if (!c3) c3 = e[J0l4h.R4s(e.length, 1)]
                if (c3) {
                  s = c3.Close
                  if (
                    s ||
                    J0l4h.U4s(
                      s,
                      (90.7e1, 15) < (0x154, 0x53)
                        ? (1.122e3, 0)
                        : (0x19, 29.9e1)
                    )
                  )
                    q()
                }
              }
              if (!c3) continue
              var m = A.Close,
                t3 = A.Open,
                D3 = A.High,
                I3 = A.Low
              if (!m && J0l4h.t4s(m, 0)) continue
              t3 =
                t3 ||
                J0l4h.I4s(
                  t3,
                  12 <= (139, 9.9e1)
                    ? (90, 0)
                    : 15.9e1 >= (0x143, 0x129)
                    ? 'R'
                    : 99 > (0x1da, 0xf7)
                    ? (135, 2.05e2)
                    : (139.8e1, 0x9)
                )
                  ? t3
                  : m
              D3 =
                D3 ||
                J0l4h.V4s(
                  D3,
                  0x172 >= (137.1e1, 98.1e1)
                    ? (41, 12.3e2)
                    : 40 < (5.39e2, 8.96e2)
                    ? (0x224, 0)
                    : (14.8e1, 12.48e2)
                )
                  ? D3
                  : m
              I3 = I3 || J0l4h.d4s(I3, 0) ? I3 : m
              if (
                !s &&
                J0l4h.F4s(
                  s,
                  (35, 0x32) <= (13.38e2, 0x1f8) ? (21, 0) : (72, 0x167)
                )
              ) {
                var V3 = J0l4h.f4s(Math.floor(t3 / C), C)
                s = isNaN(V3) ? t3 : V3
                q()
                g(c3, t3)
              }
              if (l) g(A, t3)
              if (J0l4h.z4s(D3 - t3, t3 - I3)) {
                if (D3) g(A, D3)
                if (I3) g(A, I3)
              } else {
                if (I3) g(A, I3)
                if (D3) g(A, D3)
              }
              g(A, m)
              if (
                J0l4h.E4s(
                  l,
                  W.length -
                    ((0x176, 0xe9) > (50, 7.47e2)
                      ? (1.325e3, 12.1e1)
                      : (139, 35) < (0x152, 0x20d)
                      ? (0xbb, 1)
                      : (22.2e1, 55))
                ) &&
                J0l4h.o4s(m, F)
              ) {
                var u3 = Y
                Y = o + C
                o = J0l4h.e4s(u3, C)
                K(m)
              }
            }
            return B
          }
          L6.calculatePointFigure = function(R, t, V, i) {
            if (!t.length) return t
            if (!i) i = []
            var z = R.chart.state.aggregation
            if (!z) z = R.chart.state.aggregation = {}
            var W = R.layout

            function C(S, H) {
              for (var c in S) {
                if (
                  !H[c] &&
                  J0l4h.A4s(
                    H[c],
                    (9, 8.45e2) >= (0x19e, 12.5e1) ? (1.463e3, 0) : (131, 27)
                  )
                ) {
                  H[c] = S[c]
                }
              }
              return H
            }

            function e(S, H, c, d, E) {
              S.High = Math.max(H, S.High)
              S.Low = Math.min(c, S.Low)
              S.Close = d
              S.Volume += E
            }
            R.chart.defaultChartStyleConfig.box =
              (116, 66) <= 0x67 ? (11.8e1, 1) : (7.69e2, 0x105)
            R.chart.defaultChartStyleConfig.reversal =
              (6.53e2, 0x1f6) <= 8.36e2
                ? (41, 3)
                : (0x40, 36) <= (0xe8, 2.0e1)
                ? 'W'
                : (4, 8.69e2) < (91, 2.82e2)
                ? 0xed
                : (0x1c6, 62)
            if (!V) V = {}
            var r = V.box
            if (!r) {
              if (W.pandf) {
                if (
                  J0l4h.k4s(
                    W.pandf.box,
                    101 < (1.243e3, 0xe0)
                      ? (137, null)
                      : (121, 7.75e2) >= 8.66e2
                      ? 28.9e1
                      : (99, 0x12b)
                  )
                ) {
                  W.pandf.box =
                    (0x9a, 0x17f) >= 71
                      ? (0x122, null)
                      : (83, 46) > 0x202
                      ? (70.7e1, 'O')
                      : (106, 0x229)
                  R.changeOccurred(J3 + H6 + v3 + f3 + y6)
                }
              }
              r = R.chart.defaultChartStyleConfig.box
              var a = t[J0l4h.P4s(t.length, 1)].Close
              if (a) {
                if (
                  J0l4h.l4s(
                    a,
                    (0x230, 84) > 0x46 ? (71.2e1, 0.25) : (139.0e1, 30)
                  )
                )
                  r = 143 >= (0x205, 0x67) ? (10.2e2, 0.0625) : (7.03e2, 72)
                else if (
                  J0l4h.y5s(
                    a,
                    (1.125e3, 0x1ea) >= 6.61e2
                      ? 'r'
                      : 0x190 >= (7, 14)
                      ? (0x208, 1)
                      : (76, 10.69e2)
                  )
                )
                  r =
                    0x215 <= (29, 8.2e1)
                      ? 'n'
                      : 130 > (42.5e1, 60.5e1)
                      ? (33, 0x1ec)
                      : 0x145 < (36.3e1, 0x1c5)
                      ? (0x6e, 0.125)
                      : (77.0e1, 39)
                else if (
                  J0l4h.H5s(
                    a,
                    (8.81e2, 92.4e1) <= (0x121, 25)
                      ? (8.4e2, 40)
                      : (1.2e1, 0x176) > 0x63
                      ? (2.8e1, 5)
                      : (139.0e1, 101)
                  )
                )
                  r =
                    (19, 0x166) > (111, 50.5e1)
                      ? (0xbf, 1)
                      : (0xf3, 110.0e1) >= 11.92e2
                      ? (126, 101)
                      : 3.29e2 > (0x92, 0x45)
                      ? (5, 0.25)
                      : (7.1e2, 144)
                else if (
                  J0l4h.c5s(
                    a,
                    71 <= (12.55e2, 9.47e2)
                      ? (14.3e1, 20)
                      : (1.039e3, 5.41e2) < (68.7e1, 146)
                      ? 4
                      : (0xc2, 25)
                  )
                )
                  r =
                    (127, 96.1e1) > 0x17c
                      ? (0x4c, 0.5)
                      : (0xd3, 6.55e2) <= (0x1a5, 78)
                      ? 0x14a
                      : (49, 70) <= 0x6
                      ? (10, 101.7e1)
                      : (0xc, 0x1e8)
                else if (
                  J0l4h.a5s(
                    a,
                    (11, 0x1df) >= 38.7e1 ? (0x1d5, 100) : (0x169, 0x208)
                  )
                )
                  r =
                    (40, 60.5e1) > (19, 0x17d)
                      ? (37.6e1, 1)
                      : 63 < (123, 10)
                      ? 0xe1
                      : (34.5e1, 0x11c) > (101, 0x1a6)
                      ? 0x209
                      : (75, 61)
                else if (J0l4h.D5s(a, 200))
                  r =
                    6.4e2 > (0x17a, 68)
                      ? (130, 2)
                      : 0x160 <= (120, 0x14b)
                      ? 'b'
                      : (110.3e1, 0x257)
                else if (
                  J0l4h.Q5s(
                    a,
                    13.51e2 > (3.27e2, 0x6d) ? (14.03e2, 500) : (77.2e1, 0x1ee)
                  )
                )
                  r =
                    8.23e2 < (0x59, 0x61)
                      ? (76.4e1, 29.0e1)
                      : (124, 31.3e1) >= 0x74
                      ? (55, 4)
                      : 96 > (0x182, 7.45e2)
                      ? (45, 68.2e1)
                      : (90, 0xa8)
                else if (J0l4h.i5s(a, 1000))
                  r =
                    (48.8e1, 19) <= 0xbb
                      ? (0x11e, 5)
                      : (0x1cb, 83) > (0xca, 0x121)
                      ? (0x10a, 'r')
                      : (1.64e2, 0x18a)
                else if (
                  J0l4h.M5s(
                    a,
                    (0x14e, 9.7e1) > 0x1d ? (86, 25000) : (128, 0x209)
                  )
                )
                  r = 50
                else r = (80, 7.6e1) < 109 ? (0xff, 500) : (131, 0xb4)
              }
              if (!L6.ChartEngine.isDailyInterval(W.interval)) r /= 10
              if (L6.Market.Symbology.isForexSymbol(R.chart.symbol)) {
                if (a) {
                  if (
                    J0l4h.w5s(
                      a,
                      (0x105, 0xf) >= (0xf8, 0x1a3)
                        ? 12
                        : (8.44e2, 0x45) >= (1.111e3, 9)
                        ? (64, 1)
                        : (80, 133)
                    )
                  )
                    r =
                      0xe9 >= (1.26e2, 1.136e3)
                        ? (69.2e1, 0xae)
                        : (0x18d, 96) >= 18
                        ? (114, 0.001)
                        : 22 != (95, 22)
                        ? (0x181, '   ')
                        : (92, 13.37e2)
                  else if (
                    J0l4h.C5s(
                      a,
                      (0x160, 0x3) > 11.0e1
                        ? (0x200, 'E')
                        : (79, 42) >= (0x80, 52.7e1)
                        ? 'E'
                        : (74, 47.3e1) > (99.8e1, 126)
                        ? (0x11f, 2)
                        : (80, 0xa5)
                    )
                  )
                    r = 0.002
                  else if (
                    J0l4h.Z5s(
                      a,
                      16.9e1 <= (71, 0x250)
                        ? (132, 50)
                        : (105, 10.14e2) <= 37.3e1
                        ? (0x1f5, 250)
                        : (52.2e1, 0x119)
                    )
                  )
                    r =
                      (122.5e1, 126) > 10.3e1
                        ? (0x13d, 0.02)
                        : 13.89e2 <= (0x18c, 0x1c3)
                        ? 0x145
                        : (0x7b, 0xaf)
                  else if (
                    J0l4h.h5s(
                      a,
                      0x256 < (77, 0x8f)
                        ? 96
                        : (51.9e1, 66) <= 0x1c5
                        ? (0xce, 200)
                        : (0x73, 0x1d4)
                    )
                  )
                    r =
                      (11, 0x1b4) <= 0x100
                        ? (0x9a, 'o')
                        : (0xec, 60) < 0x211
                        ? (0x56, 0.2)
                        : (101.4e1, 1.17e2)
                }
                if (L6.ChartEngine.isDailyInterval(W.interval))
                  r *=
                    46 < (0x1d8, 24)
                      ? 'i'
                      : (8.96e2, 0xcc) < 108
                      ? 'bar'
                      : (35, 0x1a8) >= 0x29
                      ? (1.352e3, 10)
                      : (18, 148.9e1)
              }
              R.chart.defaultChartStyleConfig.box = r
            }
            r = parseFloat(r)
            if (
              isNaN(r) ||
              J0l4h.J5s(
                r,
                (139.3e1, 16.9e1) > (74, 112) ? (123, 0) : (1.32e2, 4.43e2)
              )
            ) {
              if (W.pandf) {
                if (J0l4h.v5s(W.pandf.box, null)) {
                  W.pandf.box =
                    (62, 124) <= (99, 6.65e2) ? (0x18, null) : (1.092e3, 7.65e2)
                  R.changeOccurred(o3 + k3 + c6 + l3)
                }
              }
              R.chart.defaultChartStyleConfig.box = r = 1
            }
            var L = Math.ceil(parseFloat(V.reversal))
            if (
              J0l4h.K5s(
                L,
                0x228 <= (108.8e1, 12.26e2) ? (12.77e2, 0) : (25.8e1, 0x1fb)
              ) &&
              J0l4h.m5s(L, V.reversal)
            ) {
              W.pandf.reversal = L
              R.changeOccurred(J3 + H6 + k3 + c6 + f3 + y6)
            } else if (
              isNaN(L) ||
              J0l4h.q5s(
                L,
                (40, 0xe8) < (3.91e2, 0x1be) ? (1.189e3, 0) : (0xd7, 61)
              )
            ) {
              if (W.pandf) {
                if (
                  J0l4h.S9s(
                    W.pandf.reversal,
                    (7, 0x169) < (0x225, 30)
                      ? (131, 0x1a4)
                      : 0x123 >= (1.427e3, 61)
                      ? (111.7e1, null)
                      : (3.38e2, 123.5e1)
                  )
                ) {
                  W.pandf.reversal =
                    (42.0e1, 0x79) <= 3.5e1
                      ? (0x21b, 120)
                      : (50, 4.73e2) >= (148, 0x145)
                      ? (14.35e2, null)
                      : (139.9e1, 0x1ee)
                  R.changeOccurred(J3 + H6 + k3 + c6 + f3 + y6)
                }
              }
              L = R.chart.defaultChartStyleConfig.reversal
            }
            z.box = r
            L *= r
            var v = 98 < (74, 0x12b) ? (4.23e2, 0.00000001) : (110, 0x10c),
              b = (r.toString() + '.').split(
                0xf2 >= (0x30, 0)
                  ? (0x3f, '.')
                  : 51 < (89, 22)
                  ? (13.21e2, 0.4)
                  : (0xd3, 0x1bb) < 120
                  ? (103.8e1, 0.4)
                  : (132, 89)
              )[(18, 130) >= 94 ? (76, 1) : (0x1c3, 5.64e2)].length

            function J(S, H, c, d, E, D, U, w, j) {
              return {
                DT: S.DT,
                Date: S.Date,
                pfOpen: w,
                pfClose: j,
                Open: H,
                Close: E,
                High: c,
                Low: d,
                Volume: D,
                iqPrevClose: U,
              }
            }
            var O = [],
              N = 0,
              B,
              s,
              Y
            for (
              var o =
                (9.59e2, 0x155) < (1.8e1, 96.8e1)
                  ? (62, 0)
                  : 24 >= (0xde, 0x1aa)
                  ? (37, 0x1da)
                  : (3.55e2, 0x1a3);
              J0l4h.x9s(o, t.length);
              o++
            ) {
              s = t[o]
              if (!s) continue
              N += s.Volume
              var F = s.Close,
                y3 = s.Open,
                K = s.High,
                g = s.Low,
                q,
                l
              y3 =
                y3 ||
                J0l4h.X9s(
                  y3,
                  8 > (104, 93.5e1)
                    ? (87.1e1, 'k')
                    : 36 < (64, 76)
                    ? (19, 0)
                    : (88.8e1, 141)
                )
                  ? y3
                  : F
              K = K || J0l4h.r9s(K, 0) ? K : F
              g =
                g ||
                J0l4h.G9s(
                  g,
                  9.0e1 > (138, 6.59e2)
                    ? (0x1df, 1.229e3)
                    : (0x1e8, 129) <= (0x121, 14.1e1)
                    ? (0x14a, 0)
                    : (49.8e1, 75)
                )
                  ? g
                  : F
              if (!O.length && !i.length) {
                B = C(
                  s,
                  J(
                    s,
                    y3,
                    K,
                    g,
                    F,
                    N,
                    K + r,
                    Number(J0l4h.L9s(Math.ceil(g / r - v), r).toFixed(b)),
                    Number(J0l4h.j9s(Math.floor(K / r + v), r).toFixed(b))
                  )
                )
                B.pfTrend =
                  (2.43e2, 115) >= (0x1d5, 3.28e2)
                    ? 'u'
                    : 0x57 <= (112, 0x21d)
                    ? (113, 'X')
                    : (0x8, 0x66)
                if (J0l4h.O9s(B.pfOpen, B.pfClose)) {
                  B.pfStepBack =
                    (60, 84.6e1) >= (0, 0x1d7)
                      ? (5.12e2, '-')
                      : (0x20b, 0x48) > 0x231
                      ? (0x17, 8.76e2)
                      : 0x161 >= (0x112, 98.0e1)
                      ? (38.9e1, 0x21e)
                      : (38, 70.9e1)
                }
                O.push(B)
                N =
                  (69.4e1, 46) <= 84.9e1
                    ? (0x7c, 0)
                    : 0xbc >= (138.1e1, 118.1e1)
                    ? 'N'
                    : (0xab, 1.195e3)
                continue
              }
              Y = O[J0l4h.W9s(O.length, 1)]
              if (!Y)
                Y = L6.clone(
                  i[
                    J0l4h.N9s(
                      i.length,
                      0x253 < (0x45, 11.3e2)
                        ? (0x66, 1)
                        : (12.2e1, 147) > (0x116, 3.01e2)
                        ? (0xdd, 0x57)
                        : (58, 8.75e2)
                    )
                  ]
                )
              if (
                J0l4h.b9s(
                  Y.pfTrend,
                  (70, 2.24e2) >= 140 ? (0x49, 'O') : (99, 55.3e1)
                )
              ) {
                if (J0l4h.B9s(g, Y.pfClose - r)) {
                  Y.pfClose = Number(
                    J0l4h.Y9s(Math.ceil(g / r - v), r).toFixed(b)
                  )
                  if (
                    J0l4h.T9s(
                      Y.pfStepBack,
                      (0x1c6, 37.7e1) <= (142.1e1, 43.1e1)
                        ? (0xfb, 'O')
                        : 0x256 <= (0x10f, 0xf1)
                        ? (130.7e1, 142)
                        : 19 > (11.28e2, 11.41e2)
                        ? (0x1c6, 0x0)
                        : (0xa3, 8.12e2)
                    )
                  )
                    Y.pfStepBack =
                      (97, 38) <= 12.61e2 ? (1.245e3, null) : (1.85e2, 0x150)
                  e(Y, K, g, F, N)
                } else if (J0l4h.s9s(K, Y.pfClose + L)) {
                  q = Y.pfClose + r
                  l = Number(J0l4h.g9s(Math.floor(K / r + v), r).toFixed(b))
                  B = J(s, y3, K, g, F, N, Y.pfClose, q, l)
                  if (J0l4h.p9s(q, l)) {
                    B.pfStepBack =
                      4.6e2 <= (0x20b, 56.3e1)
                        ? (0x18a, 'X')
                        : (0x135, 0xb6) < 105
                        ? 'd'
                        : (16.9e1, 0x1e2)
                  }
                  if (
                    J0l4h.n9s(
                      Y.pfStepBack,
                      0x238 <= (85, 0xb2)
                        ? 115
                        : (36.6e1, 95.4e1) > (0x111, 0x35)
                        ? (9.63e2, 'O')
                        : (84, 0x89)
                    )
                  ) {
                    Y.pfOpen = q
                    Y.pfClose = l
                    Y.pfTrend =
                      0xac <= (0xcf, 87)
                        ? 't'
                        : (36, 0x1ed) >= 78
                        ? (59.1e1, 'X')
                        : (5.0e1, 0x21b)
                    e(Y, K, g, F, N)
                  } else {
                    B = C(s, B)
                    B.pfTrend =
                      (0x152, 104) <= 7.96e2 ? (0x21b, 'X') : (6.28e2, 0x142)
                    O.push(B)
                  }
                } else {
                  e(Y, K, g, F, N)
                }
                N =
                  1.024e3 >= (82.3e1, 77)
                    ? (143, 0)
                    : 146 >= (145.1e1, 74.7e1)
                    ? 'o'
                    : (33, 0x207)
              } else if (
                J0l4h.u8s(
                  Y.pfTrend,
                  (87.8e1, 9.5e1) >= 0x51 ? (0x1c0, 'X') : (4.76e2, 35)
                )
              ) {
                if (J0l4h.R8s(K, Y.pfClose + r)) {
                  Y.pfClose = Number(
                    J0l4h.U8s(Math.floor(K / r + v), r).toFixed(b)
                  )
                  if (
                    J0l4h.t8s(
                      Y.pfStepBack,
                      (144, 0x95) >= 3.1e1 ? (5, 'X') : (144, 1.8e1)
                    ) ||
                    J0l4h.I8s(Y.pfStepBack, '-')
                  )
                    Y.pfStepBack =
                      (0xf9, 0x218) > (2.32e2, 4.36e2)
                        ? (12.93e2, null)
                        : (2.69e2, 55.5e1)
                  e(Y, K, g, F, N)
                } else if (J0l4h.V8s(g, Y.pfClose - L)) {
                  q = J0l4h.d8s(Y.pfClose, r)
                  l = Number(J0l4h.F8s(Math.ceil(g / r - v), r).toFixed(b))
                  B = J(s, y3, K, g, F, N, Y.pfClose, q, l)
                  if (J0l4h.f8s(q, l)) {
                    B.pfStepBack =
                      5.32e2 < (52.7e1, 4)
                        ? 'X'
                        : (0x1fe, 75) > 0x125
                        ? 'X'
                        : (43, 37) == (104, 3.7e1)
                        ? (27.1e1, 'O')
                        : (0x1c4, 0x24)
                  }
                  if (
                    J0l4h.z8s(
                      Y.pfStepBack,
                      (110, 4.22e2) > 0xdf ? (48, 'X') : (0x45, 102.1e1)
                    ) ||
                    J0l4h.E8s(
                      Y.pfStepBack,
                      (0x73, 59.9e1) >= 115 ? (141, '-') : (0x9b, 0x1b)
                    )
                  ) {
                    Y.pfOpen = q
                    Y.pfClose = l
                    Y.pfTrend =
                      (36, 83) > 0x97
                        ? (0xe9, 0x1c4)
                        : (75, 1.0e3) <= 142
                        ? 0x23b
                        : (0x240, 0x209) <= 104.7e1
                        ? (96.2e1, 'O')
                        : (54, 0x184)
                    e(Y, K, g, F, N)
                    if (
                      J0l4h.o8s(q, l) &&
                      J0l4h.e8s(
                        Y.pfStepBack,
                        6.38e2 >= (109, 25.8e1)
                          ? (0x238, '-')
                          : (97.5e1, 1.383e3) <= (1.337e3, 0xac)
                          ? (0x248, 250)
                          : (0x14a, 0x1a9)
                      )
                    )
                      Y.pfStepBack =
                        (1.386e3, 0xc) <= (0x17b, 89)
                          ? (118, null)
                          : (109, 8.36e2) <= 0x204
                          ? 0x1e1
                          : (107, 0x246) >= (13.49e2, 86.1e1)
                          ? 2
                          : (113, 71)
                  } else {
                    B = C(s, B)
                    B.pfTrend =
                      90 < (137, 133)
                        ? (0x1d0, 'O')
                        : 105 <= (14.41e2, 38)
                        ? 14.1e1
                        : (0x10d, 1.71e2) > 1.328e3
                        ? 'M'
                        : (0xf5, 48)
                    O.push(B)
                  }
                } else {
                  e(Y, K, g, F, N)
                }
                N = 0
              }
            }
            return O
          }
          return K3
        }
      : (0x2b, 14.42e2) <= 0x20e
      ? (0x23b, 6.96e2)
      : 5.43e2 >= (12.82e2, 0x235)
      ? 0x9d
      : (4.42e2, 26) <= 64.6e1
      ? (0x24f, 5)
      : (28.9e1, 65.4e1)
  _exports = _exports || {}
  __utility_(_exports)
  __timezone_(_exports)
  __core_(_exports, _exports)
  __market_(_exports)
  __engine_(_exports, _exports, _exports, _exports)
  __microkernel_(_exports)
  __span_(_exports)
  __quoteFeed_(_exports)
  __studies_(_exports)
  __drawing_(_exports)
  __i18n_(_exports)
  __customCharts_(_exports)
  __markers_(_exports)
  __aggregations_(_exports)
  __drawingAdvanced_(_exports)
  __equations_(_exports)
  __renderersAdvanced_(_exports)
  __studiesAdvanced_(_exports)
  __share_(_exports)
  __polyfills_(_exports)

  return _exports
})()

export const $$ = built.$$
export const $$$ = built.$$$
export const CIQ = built.CIQ
export const STX = built.STX
export const STXChart = built.STXChart
export const STXSocial = built.STXSocial
export const SplinePlotter = built.SplinePlotter
export const timezoneJS = built.timezoneJS
